/*! For license information please see web-player.component.js.LICENSE.txt */ !function(e, t) {
    "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["webplayer.component"] = t() : e["webplayer.component"] = t();
}(self, ()=>(()=>{
        var e = {
            443: (e, t, n)=>{
                "use strict";
                n.r(t), n.d(t, {
                    default: ()=>a1
                });
                var r = n(365), i = n(357);
                const a1 = function(e) {
                    function t(t) {
                        var n;
                        return (n = e.call(this, t) || this).mediaPlayer = (0, i.MediaPlayer)().create(), n.mediaPlayer.initialize(), n.mediaPlayer.attachView(n.video), n;
                    }
                    (0, r._)(t, e);
                    var n = t.prototype;
                    return n.load = function(t) {
                        var n = this;
                        return e.prototype.setDefaultState.call(this), new Promise(function(e, r) {
                            n.mediaPlayer.attachSource(t), n.mediaPlayer.on(i.MediaPlayer.events.MANIFEST_LOADED, function() {
                                e();
                            }), n.mediaPlayer.on(i.MediaPlayer.events.ERROR, function(e) {
                                r("Failed to load Mss Player");
                            });
                        });
                    }, n.destroy = function() {
                        this.mediaPlayer && (this.mediaPlayer.reset(), this.mediaPlayer = null), e.prototype.destroy.call(this);
                    }, (0, r.b)(t, [
                        {
                            key: "isLive",
                            get: function() {
                                return this.mediaPlayer.isDynamic();
                            }
                        }
                    ]), t;
                }(r.B);
            },
            249: (e, t, n)=>{
                "use strict";
                n.r(t), n.d(t, {
                    default: ()=>s1
                });
                var r = n(365), i = n(793), a1 = n.n(i), o = {
                    capLevelOnFPSDrop: !0,
                    capLevelToPlayerSize: !0
                };
                const s1 = function(e) {
                    function t(t) {
                        var n;
                        (n = e.call(this, t) || this).name = "HlsJsTech", n.playlistDuration = 0;
                        var i = Object.assign({}, o, {
                            capLevelToPlayerSize: !t.disablePlayerSizeLevelCap
                        });
                        return n.hls = new (a1())(i), n.hls.attachMedia(n.video), n.hls.on(a1().Events.AUDIO_TRACK_SWITCHED, n.onAudioTrackChange.bind((0, r.d)(n))), n.hls.on(a1().Events.SUBTITLE_TRACK_SWITCH, n.onTextTrackChange.bind((0, r.d)(n))), n.hls.on(a1().Events.LEVEL_LOADED, n.onLevelLoaded.bind((0, r.d)(n))), n.hls.on(a1().Events.LEVEL_SWITCHED, n.onBitrateChange.bind((0, r.d)(n))), n.hls.on(a1().Events.ERROR, n.onErrorEvent.bind((0, r.d)(n))), n;
                    }
                    (0, r._)(t, e), t.isSupported = function() {
                        return a1().isSupported();
                    };
                    var n = t.prototype;
                    return n.load = function(t) {
                        var n = this;
                        return this.state.playbackState !== r.P.IDLE && this.stop(), e.prototype.setDefaultState.call(this), new Promise(function(e) {
                            n.hls.loadSource(t), n.hls.once(a1().Events.MANIFEST_PARSED, function() {
                                n.removeUnsupportedLevels(), e();
                            });
                        });
                    }, n.removeUnsupportedLevels = function() {
                        var e = this.hls.levels.findIndex(function(e) {
                            return !MediaSource.isTypeSupported('video/mp4; codecs="' + e.attrs.CODECS + '"');
                        });
                        -1 !== e && (this.hls.removeLevel(e), this.removeUnsupportedLevels());
                    }, n.onTimeUpdate = function() {
                        this.updateState({
                            currentTime: this.currentTime,
                            duration: this.duration,
                            isAtLiveEdge: this.currentTime >= this.hls.liveSyncPosition - 5,
                            isSeekable: !this.isLive || this.playlistDuration >= 300
                        }), this.emit(r.a.TIME_UPDATE, {
                            currentTime: this.currentTime,
                            duration: this.duration
                        });
                    }, n.onLevelLoaded = function(e, t) {
                        var n, i, a1 = null == t || null == (n = t.details) ? void 0 : n.live;
                        this.isLiveFlag !== a1 && (this.isLiveFlag = a1, this.updateState({
                            isLive: a1
                        })), this.playlistDuration = null == t || null == (i = t.details) ? void 0 : i.totalduration, this.emit(r.a.LOADED_METADATA, this.state);
                    }, n.getVideoLevels = function() {
                        if (this.hls) return this.hls.levels.map(function(e, t) {
                            return {
                                id: t,
                                width: e.width,
                                height: e.height,
                                bitrate: e.bitrate
                            };
                        });
                    }, n.onBitrateChange = function() {
                        this.emit(r.a.BITRATE_CHANGE, this.currentLevel);
                    }, n.onErrorEvent = function(e, t) {
                        var n = null == t ? void 0 : t.fatal, i = this.errorFormat(t);
                        this.emit(r.a.ERROR, {
                            errorData: i,
                            fatal: n
                        });
                    }, n.seekToLive = function() {
                        this.currentTime = this.hls.liveSyncPosition;
                    }, n.errorFormat = function(e) {
                        var t = {
                            category: null == e ? void 0 : e.type,
                            code: "-1",
                            message: "",
                            data: e
                        };
                        switch(null == e ? void 0 : e.details){
                            case a1().ErrorDetails.MANIFEST_LOAD_ERROR:
                            case a1().ErrorDetails.LEVEL_LOAD_ERROR:
                            case a1().ErrorDetails.FRAG_LOAD_ERROR:
                                t.code = "" + e.response.code, t.message = e.response.text;
                                break;
                            case a1().ErrorDetails.MANIFEST_PARSING_ERROR:
                                t.message = e.reason;
                                break;
                            case a1().ErrorDetails.MANIFEST_LOAD_TIMEOUT:
                            case a1().ErrorDetails.FRAG_LOAD_TIMEOUT:
                            case a1().ErrorDetails.KEY_LOAD_TIMEOUT:
                                break;
                            case a1().ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
                            case a1().ErrorDetails.KEY_LOAD_ERROR:
                                t.code = "" + e.response.code, t.message = e.response.text;
                        }
                        return t;
                    }, n.destroy = function() {
                        this.hls && (this.hls.destroy(), this.hls = null), e.prototype.destroy.call(this);
                    }, (0, r.b)(t, [
                        {
                            key: "currentLevel",
                            get: function() {
                                var e = this;
                                if (this.hls) return this.getVideoLevels().find(function(t) {
                                    return t.id === e.hls.currentLevel;
                                });
                            },
                            set: function(e) {
                                this.hls && (e ? this.hls.currentLevel = e.id : this.hls.nextLevel = -1);
                            }
                        },
                        {
                            key: "currentTime",
                            get: function() {
                                return this.video.currentTime;
                            },
                            set: function(e) {
                                var t;
                                this.state.isSeekable && (this.video.currentTime = this.isLive ? Math.min(e, null != (t = this.hls.liveSyncPosition) ? t : e) : e);
                            }
                        },
                        {
                            key: "isLive",
                            get: function() {
                                return this.hls ? this.isLiveFlag : isNaN(this.video.duration);
                            }
                        },
                        {
                            key: "audioTrack",
                            get: function() {
                                var e, t;
                                return null == (e = this.hls) || null == (t = e.audioTrack) ? void 0 : t.toString();
                            },
                            set: function(e) {
                                this.hls && (this.hls.audioTrack = parseInt(e));
                            }
                        },
                        {
                            key: "audioTracks",
                            get: function() {
                                var e, t = this;
                                return (null == (e = this.hls) ? void 0 : e.audioTracks.map(function(e) {
                                    return {
                                        id: e.id.toString(),
                                        label: e.name,
                                        language: e.lang,
                                        enabled: t.audioTrack === e.id.toString()
                                    };
                                })) || [];
                            }
                        },
                        {
                            key: "textTrack",
                            get: function() {
                                var e, t;
                                return null == (e = this.hls) || null == (t = e.subtitleTrack) ? void 0 : t.toString();
                            },
                            set: function(e) {
                                this.hls && (this.hls.subtitleTrack = e ? parseInt(e) : -1);
                            }
                        },
                        {
                            key: "textTracks",
                            get: function() {
                                var e, t = this;
                                return (null == (e = this.hls) ? void 0 : e.subtitleTracks.map(function(e) {
                                    return {
                                        id: e.id.toString(),
                                        label: e.name,
                                        language: e.lang,
                                        enabled: t.textTrack === e.id.toString()
                                    };
                                })) || [];
                            }
                        }
                    ]), t;
                }(r.B);
            },
            809: (e, t, n)=>{
                "use strict";
                n.r(t), n.d(t, {
                    default: ()=>a1
                });
                var r = n(365), i = n(686);
                const a1 = function(e) {
                    function t(t) {
                        var n;
                        return (n = e.call(this, t) || this).name = "ShakaTech", n.shakaPlayer = new i.Player(n.video), n.shakaPlayer.configure({
                            abr: {
                                restrictToElementSize: !t.disablePlayerSizeLevelCap
                            }
                        }), n.shakaPlayer.addEventListener("variantchanged", n.onAudioTrackChange = n.onAudioTrackChange.bind((0, r.d)(n))), n.shakaPlayer.addEventListener("adaptation", function() {
                            n.onBitrateChange();
                        }), n.shakaPlayer.addEventListener("error", n.onError = n.onError.bind((0, r.d)(n))), n;
                    }
                    (0, r._)(t, e);
                    var n = t.prototype;
                    return n.load = function(t) {
                        return e.prototype.setDefaultState.call(this), this.shakaPlayer.load(t).catch(function() {});
                    }, n.onBitrateChange = function() {
                        var e = this.shakaPlayer.getVariantTracks().filter(function(e) {
                            return e.active;
                        }), t = e.reduce(function(e, t) {
                            return e + t.bandwidth;
                        }, 0), n = e.find(function(e) {
                            return "variant" === e.type;
                        });
                        this.emit(r.a.BITRATE_CHANGE, {
                            bitrate: t,
                            width: n.width,
                            height: n.height
                        });
                    }, n.onError = function(e) {
                        var t = null == e ? void 0 : e.detail;
                        console.log(t);
                        var n = t.severity > 1, i = {
                            category: t.category.toString(),
                            code: t.code.toString(),
                            message: t.data[1].toString(),
                            data: t.data
                        };
                        this.emit(r.a.ERROR, {
                            errorData: i,
                            fatal: n
                        });
                    }, n.getVideoLevels = function() {
                        if (this.shakaPlayer) return this.shakaPlayer.getVariantTracks().map(function(e) {
                            return {
                                id: e.id,
                                width: e.width,
                                height: e.height,
                                bitrate: e.bandwidth
                            };
                        });
                    }, n.destroy = function() {
                        this.shakaPlayer && this.shakaPlayer.destroy(), e.prototype.destroy.call(this);
                    }, (0, r.b)(t, [
                        {
                            key: "isLive",
                            get: function() {
                                return this.shakaPlayer.isLive();
                            }
                        },
                        {
                            key: "duration",
                            get: function() {
                                var e = this.shakaPlayer.seekRange();
                                return e.end - e.start || 0;
                            }
                        },
                        {
                            key: "audioTrack",
                            get: function() {
                                var e, t, n;
                                return null == (e = this.shakaPlayer) || null == (t = e.getVariantTracks()) || null == (n = t.find(function(e) {
                                    return e.active;
                                })) ? void 0 : n.language;
                            },
                            set: function(e) {
                                this.shakaPlayer && this.shakaPlayer.selectAudioLanguage(e);
                            }
                        },
                        {
                            key: "audioTracks",
                            get: function() {
                                var e, t = this;
                                return null == (e = this.shakaPlayer) ? void 0 : e.getAudioLanguages().map(function(e) {
                                    return {
                                        id: e,
                                        language: e,
                                        label: e,
                                        enabled: t.audioTrack === e
                                    };
                                });
                            }
                        },
                        {
                            key: "textTrack",
                            get: function() {
                                var e = this.shakaPlayer.getTextTracks().find(function(e) {
                                    return e.active;
                                });
                                return e && this.shakaPlayer.isTextTrackVisible() ? (0, r.e)(e) : null;
                            },
                            set: function(e) {
                                if (e) {
                                    this.shakaPlayer.setTextTrackVisibility(!0);
                                    var t = this.shakaPlayer.getTextTracks().find(function(t) {
                                        return (0, r.e)(t) === e;
                                    });
                                    this.shakaPlayer.selectTextTrack(t);
                                } else this.shakaPlayer.setTextTrackVisibility(!1);
                            }
                        },
                        {
                            key: "textTracks",
                            get: function() {
                                var e = this;
                                return this.shakaPlayer.getTextTracks().map(function(t) {
                                    return {
                                        id: t.id,
                                        label: t.label,
                                        language: t.language,
                                        enabled: e.textTrack === (0, r.e)(t)
                                    };
                                }).filter(function(e, t, n) {
                                    return n.findIndex(function(t) {
                                        return e.language === t.language && e.label === t.label;
                                    }) === t;
                                });
                            }
                        },
                        {
                            key: "currentLevel",
                            set: function(e) {
                                if (this.shakaPlayer) {
                                    if (e) {
                                        this.shakaPlayer.configure({
                                            abr: {
                                                enabled: !1
                                            }
                                        });
                                        var t = this.shakaPlayer.getVariantTracks().find(function(t) {
                                            return t.id == e.id;
                                        });
                                        this.shakaPlayer.selectVariantTrack(t, !0);
                                    } else this.shakaPlayer.configure({
                                        abr: {
                                            enabled: !0
                                        }
                                    });
                                }
                            },
                            get: function() {
                                if (this.shakaPlayer) {
                                    var e = this.shakaPlayer.getVariantTracks().find(function(e) {
                                        return 1 == e.active;
                                    });
                                    return {
                                        id: e.id,
                                        width: e.width,
                                        height: e.height,
                                        bitrate: e.bandwidth
                                    };
                                }
                            }
                        }
                    ]), t;
                }(r.B);
            },
            851: (e, t, n)=>{
                "use strict";
                n.r(t), n.d(t, {
                    default: ()=>a1
                });
                var r = n(365), i = n(40);
                const a1 = function(e) {
                    function t(t) {
                        var n;
                        return (n = e.call(this, t) || this).player = new i.WebRTCPlayer({
                            video: n.video,
                            type: "whep",
                            iceServers: t.iceServers
                        }), n;
                    }
                    (0, r._)(t, e);
                    var n = t.prototype;
                    return n.load = function(t) {
                        return e.prototype.setDefaultState.call(this, {
                            isSeekable: !1
                        }), this.player.load(new URL(t));
                    }, n.onTimeUpdate = function() {}, n.destroy = function() {
                        this.player.destroy(), e.prototype.destroy.call(this);
                    }, (0, r.b)(t, [
                        {
                            key: "isLive",
                            get: function() {
                                return !0;
                            }
                        }
                    ]), t;
                }(r.B);
            },
            945: (e, t, n)=>{
                "use strict";
                n.r(t), n.d(t, {
                    default: ()=>a1
                });
                var r = n(365), i = n(40);
                const a1 = function(e) {
                    function t(t) {
                        var n;
                        return (n = e.call(this, t) || this).player = new i.WebRTCPlayer({
                            video: n.video,
                            type: "se.eyevinn.whpp",
                            iceServers: t.iceServers
                        }), n;
                    }
                    (0, r._)(t, e);
                    var n = t.prototype;
                    return n.load = function(t) {
                        return e.prototype.setDefaultState.call(this, {
                            isSeekable: !1
                        }), this.player.load(new URL(t));
                    }, n.onTimeUpdate = function() {}, n.destroy = function() {
                        this.player.destroy(), e.prototype.destroy.call(this);
                    }, (0, r.b)(t, [
                        {
                            key: "isLive",
                            get: function() {
                                return !0;
                            }
                        }
                    ]), t;
                }(r.B);
            },
            365: (e, t, n)=>{
                "use strict";
                function r(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                    }
                }
                function i(e, t, n) {
                    return t && r(e.prototype, t), n && r(e, n), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function a1() {
                    return (a1 = Object.assign || function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var n = arguments[t];
                            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                        }
                        return e;
                    }).apply(this, arguments);
                }
                function o(e, t) {
                    e.prototype = Object.create(t.prototype), e.prototype.constructor = e, (Object.setPrototypeOf || function(e, t) {
                        return e.__proto__ = t, e;
                    })(e, t);
                }
                function s1(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }
                function u(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                    return r;
                }
                function l(e, t) {
                    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (n) return (n = n.call(e)).next.bind(n);
                    if (Array.isArray(e) || (n = function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return u(e, void 0);
                            var n = Object.prototype.toString.call(e).slice(8, -1);
                            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? u(e, void 0) : void 0;
                        }
                    }(e)) || t && e && "number" == typeof e.length) {
                        n && (e = n);
                        var r = 0;
                        return function() {
                            return r >= e.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: e[r++]
                            };
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                var c, d, f, h;
                n.d(t, {
                    B: ()=>y,
                    M: ()=>c,
                    P: ()=>g,
                    W: ()=>_,
                    _: ()=>o,
                    a: ()=>f,
                    b: ()=>i,
                    d: ()=>s1,
                    e: ()=>m
                }), (h = c || (c = {})).UNKNOWN = "UNKNOWN", h.HLS = "HLS", h.DASH = "DASH", h.MSS = "MSS", h.EYEVINN_WEBRTC_CHANNEL = "EYEVINN_WEBRTC_CHANNEL", h.EYEVINN_WHPP_CHANNEL = "EYEVINN_WHPP_CHANNEL", h.WHEP = "WHEP", function(e) {
                    e[e.UNKNOWN_MANIFEST_TYPE = 0] = "UNKNOWN_MANIFEST_TYPE";
                }(d || (d = {})), function(e) {
                    e.PLAY = "play", e.PAUSE = "pause", e.PLAYING = "playing", e.TIME_UPDATE = "timeupdate", e.SEEKING = "seeking", e.SEEKED = "seeked", e.WAITING = "waiting", e.STALLED = "stalled", e.VOLUME_CHANGE = "volumechange", e.ENDED = "ended", e.UNREADY = "unready", e.READYING = "readying", e.READY = "ready", e.LOADED_METADATA = "loadedmetadata", e.STATE_CHANGE = "state_change", e.AUDIO_TRACK_CHANGE = "audio_track_change", e.TEXT_TRACK_CHANGE = "text_track_change", e.BUFFERING = "buffering", e.LIVE_ENDED = "live_ended", e.BITRATE_CHANGE = "bitrate_change", e.PLAYER_STOPPED = "player_stopped", e.ERROR = "error";
                }(f || (f = {}));
                var g, p = function() {
                    function e() {
                        this.emitter = function(e) {
                            return {
                                all: e = e || new Map,
                                on: function(t, n) {
                                    var r = e.get(t);
                                    r ? r.push(n) : e.set(t, [
                                        n
                                    ]);
                                },
                                off: function(t, n) {
                                    var r = e.get(t);
                                    r && (n ? r.splice(r.indexOf(n) >>> 0, 1) : e.set(t, []));
                                },
                                emit: function(t, n) {
                                    var r = e.get(t);
                                    r && r.slice().map(function(e) {
                                        e(n);
                                    }), (r = e.get("*")) && r.slice().map(function(e) {
                                        e(t, n);
                                    });
                                }
                            };
                        }();
                    }
                    var t = e.prototype;
                    return t.on = function(e, t) {
                        this.emitter.on.apply(this, arguments);
                    }, t.off = function(e, t) {
                        this.emitter.on.apply(this, arguments);
                    }, t.emit = function(e, t) {
                        this.emitter.emit.apply(this, arguments);
                    }, t.destroy = function() {
                        this.emitter.all.clear();
                    }, e;
                }();
                function m(e) {
                    return e ? e.id + "|" + e.label + "|" + e.language : null;
                }
                !function(e) {
                    e[e.IDLE = 0] = "IDLE", e[e.LOADING = 1] = "LOADING", e[e.READY = 2] = "READY", e[e.PLAYING = 3] = "PLAYING", e[e.PAUSED = 4] = "PAUSED", e[e.SEEKING = 5] = "SEEKING", e[e.BUFFERING = 6] = "BUFFERING", e[e.BITRATE_CHANGE = 7] = "BITRATE_CHANGE", e[e.PLAYER_STOPPED = 8] = "PLAYER_STOPPED";
                }(g || (g = {}));
                var v, y = function(e) {
                    function t(t) {
                        var n, r = t.video;
                        return (n = e.call(this) || this).name = "BaseTech", n.state = {
                            playbackState: g.IDLE,
                            currentTime: 0,
                            duration: 0,
                            isLive: !1,
                            isAtLiveEdge: !1,
                            isSeekable: !0,
                            isMuted: r.muted,
                            audioTracks: [],
                            textTracks: [],
                            volume: r.volume
                        }, n.video = r, n.video.addEventListener("play", n.onPlay = n.onPlay.bind(s1(n))), n.video.addEventListener("playing", n.onPlaying = n.onPlaying.bind(s1(n))), n.video.addEventListener("pause", n.onPause = n.onPause.bind(s1(n))), n.video.addEventListener("timeupdate", n.onTimeUpdate = n.onTimeUpdate.bind(s1(n))), n.video.addEventListener("waiting", n.onWaiting = n.onWaiting.bind(s1(n))), n.video.addEventListener("seeking", n.onSeeking = n.onSeeking.bind(s1(n))), n.video.addEventListener("seeked", n.onSeeked = n.onSeeked.bind(s1(n))), n.video.addEventListener("canplay", n.onLoadedData = n.onLoadedData.bind(s1(n))), n.video.addEventListener("volumechange", n.onVolumeChange = n.onVolumeChange.bind(s1(n))), n.video.addEventListener("ended", n.onEnded = n.onEnded.bind(s1(n))), n.video.audioTracks && n.video.audioTracks.addEventListener("change", n.onAudioTrackChange = n.onAudioTrackChange.bind(s1(n))), n;
                    }
                    o(t, e);
                    var n = t.prototype;
                    return n.updateState = function(e) {
                        var t = this;
                        Object.keys(e).forEach(function(n) {
                            void 0 !== t.state[n] && (t.state[n] = e[n]);
                        }), this.emit(f.STATE_CHANGE, {
                            state: this.state
                        });
                    }, n.onLoadedData = function() {
                        this.updateState({
                            playbackState: this.video.paused ? g.PAUSED : g.PLAYING,
                            duration: this.duration,
                            isLive: this.isLive,
                            audioTracks: this.audioTracks,
                            textTracks: this.textTracks
                        }), this.emit(f.LOADED_METADATA, this.state);
                    }, n.onPlay = function() {
                        this.updateState({
                            playbackState: g.PLAYING
                        }), this.emit(f.PLAY);
                    }, n.onPause = function() {
                        this.updateState({
                            playbackState: g.PAUSED
                        }), this.emit(f.PAUSE);
                    }, n.onPlaying = function() {
                        this.state.playbackState !== g.PLAYING && this.updateState({
                            playbackState: g.PLAYING
                        }), this.emit(f.PLAYING);
                    }, n.onTimeUpdate = function() {
                        this.updateState({
                            currentTime: this.currentTime,
                            duration: this.duration,
                            isAtLiveEdge: this.currentTime >= this.duration - 10,
                            isSeekable: !this.isLive || this.duration >= 300
                        }), this.emit(f.TIME_UPDATE, {
                            currentTime: this.currentTime,
                            duration: this.duration
                        });
                    }, n.onWaiting = function() {
                        this.state.playbackState !== g.SEEKING && (this.updateState({
                            playbackState: g.BUFFERING
                        }), this.emit(f.BUFFERING)), this.emit(f.WAITING);
                    }, n.onSeeking = function() {
                        this.updateState({
                            playbackState: g.SEEKING
                        }), this.emit(f.SEEKING);
                    }, n.onSeeked = function() {
                        this.updateState({
                            playbackState: this.video.paused ? g.PAUSED : g.PLAYING
                        }), this.emit(f.SEEKED);
                    }, n.onVolumeChange = function() {
                        var e = {
                            volume: this.video.volume
                        };
                        this.state.isMuted !== this.isMuted && (e.isMuted = this.isMuted), this.updateState(e), this.emit(f.VOLUME_CHANGE, {
                            volume: this.video.volume
                        });
                    }, n.onAudioTrackChange = function() {
                        this.updateState({
                            audioTracks: this.audioTracks
                        }), this.emit(f.AUDIO_TRACK_CHANGE);
                    }, n.onTextTrackChange = function() {
                        this.updateState({
                            textTracks: this.textTracks
                        }), this.emit(f.TEXT_TRACK_CHANGE);
                    }, n.onEnded = function() {
                        this.emit(f.ENDED), this.updateState({
                            playbackState: g.IDLE
                        });
                    }, n.onBitrateChange = function() {}, n.play = function() {
                        var e = this.video.play();
                        return e ? e.then(function() {
                            return !0;
                        }, function() {
                            return !1;
                        }) : Promise.resolve(!0);
                    }, n.pause = function() {
                        this.video.pause();
                    }, n.mute = function() {
                        this.video.muted = !0;
                    }, n.unmute = function() {
                        this.video.muted = !1;
                    }, n.load = function(e) {
                        var t = this;
                        return this.setDefaultState(), new Promise(function(n, r) {
                            t.video.src = e, t.video.load(), n();
                        });
                    }, n.setDefaultState = function(e) {
                        this.updateState(a1({
                            playbackState: g.LOADING,
                            currentTime: 0,
                            duration: 0,
                            isLive: !1,
                            isAtLiveEdge: !1,
                            isSeekable: !0,
                            isMuted: this.video.muted,
                            audioTracks: [],
                            textTracks: [],
                            volume: this.video.volume
                        }, e));
                    }, n.stop = function() {
                        this.video.src = "", this.video.load(), this.updateState({
                            playbackState: g.IDLE,
                            isLive: !1,
                            currentTime: this.currentTime,
                            duration: this.duration
                        }), this.emit(f.PLAYER_STOPPED);
                    }, n.seekToLive = function() {
                        this.currentTime = this.duration - 10;
                    }, n.getVideoLevels = function() {
                        return [];
                    }, n.destroy = function() {
                        this.stop(), this.video.removeEventListener("timeupdate", this.onTimeUpdate);
                    }, i(t, [
                        {
                            key: "currentLevel",
                            set: function(e) {},
                            get: function() {}
                        },
                        {
                            key: "isPlaying",
                            get: function() {
                                return !this.video.paused;
                            }
                        },
                        {
                            key: "isMuted",
                            get: function() {
                                return this.video.muted;
                            }
                        },
                        {
                            key: "isLive",
                            get: function() {
                                return 1 / 0 === this.video.duration;
                            }
                        },
                        {
                            key: "duration",
                            get: function() {
                                return this.isLive && this.video.seekable.length ? this.video.seekable.end(0) : this.video.duration || 0;
                            }
                        },
                        {
                            key: "currentTime",
                            get: function() {
                                return this.video.currentTime;
                            },
                            set: function(e) {
                                this.state.isSeekable && (this.video.currentTime = this.isLive ? Math.min(e, this.duration - 10) : e);
                            }
                        },
                        {
                            key: "audioTrack",
                            get: function() {
                                var e = this.audioTracks.find(function(e) {
                                    return e.enabled;
                                });
                                return null == e ? void 0 : e.id;
                            },
                            set: function(e) {
                                if (this.video.audioTracks) for(var t, n = l(this.video.audioTracks || []); !(t = n()).done;){
                                    var r = t.value;
                                    r.enabled = r.id === e;
                                }
                            }
                        },
                        {
                            key: "audioTracks",
                            get: function() {
                                var e;
                                return Array.from(null != (e = this.video.audioTracks) ? e : []).map(function(e) {
                                    return {
                                        id: e.id,
                                        label: e.label,
                                        language: e.language,
                                        enabled: e.enabled
                                    };
                                });
                            }
                        },
                        {
                            key: "textTrack",
                            get: function() {
                                return m(this.textTracks.find(function(e) {
                                    return e.enabled;
                                }));
                            },
                            set: function(e) {
                                if (this.video.textTracks) for(var t, n = l(this.video.textTracks || []); !(t = n()).done;){
                                    var r = t.value;
                                    r.enabled = m(r) === e;
                                }
                            }
                        },
                        {
                            key: "textTracks",
                            get: function() {
                                var e;
                                return Array.from(null != (e = this.video.textTracks) ? e : []).filter(function(e) {
                                    return "metadata" !== e.kind;
                                }).map(function(e) {
                                    return {
                                        id: m(e),
                                        label: e.label,
                                        language: e.language,
                                        enabled: e.enabled
                                    };
                                });
                            }
                        },
                        {
                            key: "volume",
                            get: function() {
                                return this.video.volume;
                            },
                            set: function(e) {
                                this.video.volume = Number(e.toFixed(2));
                            }
                        }
                    ]), t;
                }(p), E = {
                    "application/x-mpegURL": c.HLS,
                    "application/octet-stream": c.UNKNOWN,
                    "binary/octet-stream": c.UNKNOWN,
                    "application/vnd.apple.mpegurl": c.HLS,
                    "application/dash+xml": c.DASH,
                    "application/vnd.apple.mpegurl;charset=UTF-8": c.HLS,
                    "application/vnd.ms-sstr+xml": c.MSS,
                    "application/json": c.EYEVINN_WHPP_CHANNEL,
                    "application/whpp+json": c.EYEVINN_WHPP_CHANNEL,
                    "application/sdp": c.WHEP
                }, T = ((v = {})[c.HLS] = "application/vnd.apple.mpegurl", v[c.DASH] = "application/dash+xml", v[c.MSS] = "application/vnd.ms-sstr+xml", v);
                function b(e, t, n) {
                    if (!e.s) {
                        if (n instanceof A) {
                            if (!n.s) return void (n.o = b.bind(null, e, t));
                            1 & t && (t = n.s), n = n.v;
                        }
                        if (n && n.then) return void n.then(b.bind(null, e, t), b.bind(null, e, 2));
                        e.s = t, e.v = n;
                        var r = e.o;
                        r && r(e);
                    }
                }
                var A = function() {
                    function e() {}
                    return e.prototype.then = function(t, n) {
                        var r = new e, i = this.s;
                        if (i) {
                            var a1 = 1 & i ? t : n;
                            if (a1) {
                                try {
                                    b(r, 1, a1(this.v));
                                } catch (e) {
                                    b(r, 2, e);
                                }
                                return r;
                            }
                            return this;
                        }
                        return this.o = function(e) {
                            try {
                                var i = e.v;
                                1 & e.s ? b(r, 1, t ? t(i) : i) : n ? b(r, 1, n(i)) : b(r, 2, i);
                            } catch (e) {
                                b(r, 2, e);
                            }
                        }, r;
                    }, e;
                }(), _ = function(e) {
                    function t(t) {
                        var n;
                        return (n = e.call(this) || this).manifestType = c.UNKNOWN, n.opts = t, n.video = t.video, n;
                    }
                    o(t, e);
                    var r = t.prototype;
                    return r.load = function(e, t) {
                        void 0 === t && (t = !1);
                        try {
                            var r = this;
                            return r.video.muted = t, r.video.autoplay = t, r.video.setAttribute("playsinline", ""), r.emit(f.READYING), r.reset(), r.currentSrc = e, Promise.resolve(function(e) {
                                try {
                                    return Promise.resolve(function(t, n) {
                                        try {
                                            var r = Promise.resolve(function(e) {
                                                try {
                                                    return Promise.resolve(fetch(e)).then(function(t) {
                                                        var n;
                                                        return t.ok ? null == (n = t.headers.get("content-type")) ? void 0 : n.split(";")[0] : Promise.resolve(fetch(e, {
                                                            method: "OPTIONS"
                                                        })).then(function(e) {
                                                            var n = (t = e).headers.get("accept").split(",");
                                                            return n[n.length - 1].trim();
                                                        });
                                                    });
                                                } catch (e) {
                                                    return Promise.reject(e);
                                                }
                                            }(e)).then(function(t) {
                                                return E[t] || (e.match(/\.m3u8/) ? c.HLS : e.match(/\.mpd/) ? c.DASH : e.toLowerCase().match(/\/manifest/) ? c.MSS : c.UNKNOWN);
                                            });
                                        } catch (e) {
                                            return n();
                                        }
                                        return r && r.then ? r.then(void 0, n) : r;
                                    }(0, function() {
                                        return c.UNKNOWN;
                                    }));
                                } catch (e) {
                                    return Promise.reject(e);
                                }
                            }(e)).then(function(t) {
                                function i() {
                                    return r.tech = new a1(r.opts), r.tech.on("*", r.onEvent.bind(r)), r.emit(f.READY), r.tech.load(e);
                                }
                                if (r.manifestType = t, r.opts.enableCloudflareWhepBeta && e.match(/cloudflarestream\.com\/.*\/webRTC\/play$/) && (r.manifestType = c.WHEP), r.manifestType === c.UNKNOWN) throw {
                                    errorCode: d.UNKNOWN_MANIFEST_TYPE
                                };
                                var a1, o = function(e, t) {
                                    var n, r = -1;
                                    e: {
                                        for(var i = 0; i < t.length; i++){
                                            var a1 = t[i][0];
                                            if (a1) {
                                                var o = a1();
                                                if (o && o.then) break e;
                                                if (o === e) {
                                                    r = i;
                                                    break;
                                                }
                                            } else r = i;
                                        }
                                        if (-1 !== r) {
                                            do {
                                                for(var s1 = t[r][1]; !s1;)r++, s1 = t[r][1];
                                                var u = s1();
                                                if (u && u.then) {
                                                    n = !0;
                                                    break e;
                                                }
                                                var l = t[r][2];
                                                r++;
                                            }while (l && !l());
                                            return u;
                                        }
                                    }
                                    var c = new A, d = b.bind(null, c, 2);
                                    return (n ? u.then(f) : o.then(function n(o) {
                                        for(;;){
                                            if (o === e) {
                                                r = i;
                                                break;
                                            }
                                            if (++i === t.length) {
                                                if (-1 !== r) break;
                                                return void b(c, 1, u);
                                            }
                                            if (a1 = t[i][0]) {
                                                if ((o = a1()) && o.then) return void o.then(n).then(void 0, d);
                                            } else r = i;
                                        }
                                        do {
                                            for(var s1 = t[r][1]; !s1;)r++, s1 = t[r][1];
                                            var u = s1();
                                            if (u && u.then) return void u.then(f).then(void 0, d);
                                            var l = t[r][2];
                                            r++;
                                        }while (l && !l());
                                        b(c, 1, u);
                                    })).then(void 0, d), c;
                                    function f(e) {
                                        for(;;){
                                            var n = t[r][2];
                                            if (!n || n()) break;
                                            r++;
                                            for(var i = t[r][1]; !i;)r++, i = t[r][1];
                                            if ((e = i()) && e.then) return void e.then(f).then(void 0, d);
                                        }
                                        b(c, 1, e);
                                    }
                                }(r.manifestType, [
                                    [
                                        function() {
                                            return c.HLS;
                                        },
                                        function() {
                                            var e = function() {
                                                if (!function(e) {
                                                    return e === c.EYEVINN_WEBRTC_CHANNEL || e === c.EYEVINN_WHPP_CHANNEL || e === c.WHEP ? !!window.RTCPeerConnection : !!document.createElement("video").canPlayType(T[e]);
                                                }(c.HLS) || (e = window.navigator.userAgent.toLowerCase(), !/safari/.test(e) && !/iphone|ipad|ipod/.test(e) || !/apple computer/.test(window.navigator.vendor.toLowerCase()))) return Promise.resolve(Promise.resolve().then(n.bind(n, 249))).then(function(e) {
                                                    a1 = e.default;
                                                });
                                                var e;
                                                a1 = y;
                                            }();
                                            if (e && e.then) return e.then(function() {});
                                        }
                                    ],
                                    [
                                        function() {
                                            return c.DASH;
                                        },
                                        function() {
                                            return Promise.resolve(Promise.resolve().then(n.bind(n, 809))).then(function(e) {
                                                a1 = e.default;
                                            });
                                        }
                                    ],
                                    [
                                        function() {
                                            return c.MSS;
                                        },
                                        function() {
                                            return Promise.resolve(Promise.resolve().then(n.bind(n, 443))).then(function(e) {
                                                a1 = e.default;
                                            });
                                        }
                                    ],
                                    [
                                        function() {
                                            return c.EYEVINN_WEBRTC_CHANNEL;
                                        },
                                        function() {
                                            return Promise.resolve(Promise.resolve().then(n.bind(n, 520))).then(function(e) {
                                                a1 = e.default;
                                            });
                                        }
                                    ],
                                    [
                                        function() {
                                            return c.EYEVINN_WHPP_CHANNEL;
                                        },
                                        function() {
                                            return Promise.resolve(Promise.resolve().then(n.bind(n, 945))).then(function(e) {
                                                a1 = e.default;
                                            });
                                        }
                                    ],
                                    [
                                        function() {
                                            return c.WHEP;
                                        },
                                        function() {
                                            return Promise.resolve(Promise.resolve().then(n.bind(n, 851))).then(function(e) {
                                                a1 = e.default;
                                            });
                                        }
                                    ]
                                ]);
                                return o && o.then ? o.then(i) : i();
                            });
                        } catch (e) {
                            return Promise.reject(e);
                        }
                    }, r.onEvent = function(e, t) {
                        this.emit(e, t);
                    }, r.getVideoLevels = function() {
                        if (this.tech) return this.tech.getVideoLevels();
                    }, r.play = function() {
                        var e;
                        return null == (e = this.tech) ? void 0 : e.play();
                    }, r.pause = function() {
                        var e;
                        return null == (e = this.tech) ? void 0 : e.pause();
                    }, r.stop = function() {
                        return this.destroy();
                    }, r.seekTo = function(e) {
                        var t = e.position, n = e.change, r = e.percentage;
                        this.tech && (r ? t = r / 100 * this.tech.duration : n && (t = this.tech.currentTime + n), this.tech.currentTime = t);
                    }, r.seekToLive = function() {
                        var e;
                        return null == (e = this.tech) ? void 0 : e.seekToLive();
                    }, r.setAudioTrack = function(e) {
                        this.tech && (this.tech.audioTrack = e);
                    }, r.setTextTrack = function(e) {
                        this.tech && (this.tech.textTrack = e);
                    }, r.setVolume = function(e) {
                        var t = e.change;
                        if (this.tech) {
                            var n = t ? this.tech.volume + t : e.percentage / 100;
                            n > 1 && (n = 1), n < 0 && (n = 0), this.tech.volume = n;
                        }
                    }, r.getVolume = function() {
                        var e;
                        return null == (e = this.tech) ? void 0 : e.volume;
                    }, r.mute = function() {
                        var e;
                        null == (e = this.tech) || e.mute();
                    }, r.unmute = function() {
                        var e;
                        null == (e = this.tech) || e.unmute();
                    }, r.reset = function() {
                        this.tech && (this.tech.destroy(), this.tech = null, this.emit(f.UNREADY));
                    }, i(t, [
                        {
                            key: "isPlaying",
                            get: function() {
                                var e, t;
                                return null != (e = null == (t = this.tech) ? void 0 : t.isPlaying) && e;
                            }
                        },
                        {
                            key: "isMuted",
                            get: function() {
                                var e, t;
                                return null != (e = null == (t = this.tech) ? void 0 : t.isMuted) && e;
                            }
                        },
                        {
                            key: "isLive",
                            get: function() {
                                var e, t;
                                return null != (e = null == (t = this.tech) ? void 0 : t.isLive) && e;
                            }
                        },
                        {
                            key: "currentTime",
                            get: function() {
                                var e;
                                return null == (e = this.tech) ? void 0 : e.currentTime;
                            }
                        },
                        {
                            key: "currentLevel",
                            get: function() {
                                if (this.tech) return this.tech.currentLevel;
                            },
                            set: function(e) {
                                this.tech && (this.tech.currentLevel = e);
                            }
                        }
                    ]), t;
                }(p);
            },
            520: (e, t, n)=>{
                "use strict";
                n.r(t), n.d(t, {
                    default: ()=>a1
                });
                var r = n(365), i = n(40);
                const a1 = function(e) {
                    function t(t) {
                        var n;
                        return (n = e.call(this, t) || this).player = new i.WebRTCPlayer({
                            video: n.video,
                            type: "se.eyevinn.webrtc"
                        }), n;
                    }
                    (0, r._)(t, e);
                    var n = t.prototype;
                    return n.load = function(t) {
                        return e.prototype.setDefaultState.call(this, {
                            isSeekable: !1
                        }), this.player.load(new URL(t));
                    }, n.onTimeUpdate = function() {}, n.destroy = function() {
                        this.player.destroy(), e.prototype.destroy.call(this);
                    }, (0, r.b)(t, [
                        {
                            key: "isLive",
                            get: function() {
                                return !0;
                            }
                        }
                    ]), t;
                }(r.B);
            },
            575: function(e, t) {
                !function(e) {
                    "use strict";
                    function t(e, t) {
                        var n = Object.keys(e);
                        if (Object.getOwnPropertySymbols) {
                            var r = Object.getOwnPropertySymbols(e);
                            t && (r = r.filter(function(t) {
                                return Object.getOwnPropertyDescriptor(e, t).enumerable;
                            })), n.push.apply(n, r);
                        }
                        return n;
                    }
                    function n(e) {
                        for(var n = 1; n < arguments.length; n++){
                            var r = null != arguments[n] ? arguments[n] : {};
                            n % 2 ? t(Object(r), !0).forEach(function(t) {
                                s1(e, t, r[t]);
                            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : t(Object(r)).forEach(function(t) {
                                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                            });
                        }
                        return e;
                    }
                    function r(e) {
                        return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                            return typeof e;
                        } : function(e) {
                            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                        }, r(e);
                    }
                    function i(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }
                    function a1(e, t) {
                        for(var n = 0; n < t.length; n++){
                            var r = t[n];
                            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                        }
                    }
                    function o(e, t, n) {
                        return t && a1(e.prototype, t), n && a1(e, n), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }
                    function s1(e, t, n) {
                        return t in e ? Object.defineProperty(e, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : e[t] = n, e;
                    }
                    function u(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && c(e, t);
                    }
                    function l(e) {
                        return l = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                            return e.__proto__ || Object.getPrototypeOf(e);
                        }, l(e);
                    }
                    function c(e, t) {
                        return c = Object.setPrototypeOf || function(e, t) {
                            return e.__proto__ = t, e;
                        }, c(e, t);
                    }
                    function d(e, t) {
                        if (t && ("object" == typeof t || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e;
                        }(e);
                    }
                    function f(e) {
                        var t = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e) {
                                return !1;
                            }
                        }();
                        return function() {
                            var n, r = l(e);
                            if (t) {
                                var i = l(this).constructor;
                                n = Reflect.construct(r, arguments, i);
                            } else n = r.apply(this, arguments);
                            return d(this, n);
                        };
                    }
                    function h(e) {
                        return function(e) {
                            if (Array.isArray(e)) return g(e);
                        }(e) || function(e) {
                            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                        }(e) || function(e, t) {
                            if (e) {
                                if ("string" == typeof e) return g(e, t);
                                var n = Object.prototype.toString.call(e).slice(8, -1);
                                return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? g(e, t) : void 0;
                            }
                        }(e) || function() {
                            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }();
                    }
                    function g(e, t) {
                        (null == t || t > e.length) && (t = e.length);
                        for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                        return r;
                    }
                    function p() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        return {
                            id: e.id || null,
                            adId: e.adId || null,
                            sequence: e.sequence || null,
                            apiFramework: e.apiFramework || null,
                            universalAdIds: [],
                            creativeExtensions: []
                        };
                    }
                    var m = [
                        "ADCATEGORIES",
                        "ADCOUNT",
                        "ADPLAYHEAD",
                        "ADSERVINGID",
                        "ADTYPE",
                        "APIFRAMEWORKS",
                        "APPBUNDLE",
                        "ASSETURI",
                        "BLOCKEDADCATEGORIES",
                        "BREAKMAXADLENGTH",
                        "BREAKMAXADS",
                        "BREAKMAXDURATION",
                        "BREAKMINADLENGTH",
                        "BREAKMINDURATION",
                        "BREAKPOSITION",
                        "CLICKPOS",
                        "CLICKTYPE",
                        "CLIENTUA",
                        "CONTENTID",
                        "CONTENTPLAYHEAD",
                        "CONTENTURI",
                        "DEVICEIP",
                        "DEVICEUA",
                        "DOMAIN",
                        "EXTENSIONS",
                        "GDPRCONSENT",
                        "IFA",
                        "IFATYPE",
                        "INVENTORYSTATE",
                        "LATLONG",
                        "LIMITADTRACKING",
                        "MEDIAMIME",
                        "MEDIAPLAYHEAD",
                        "OMIDPARTNER",
                        "PAGEURL",
                        "PLACEMENTTYPE",
                        "PLAYERCAPABILITIES",
                        "PLAYERSIZE",
                        "PLAYERSTATE",
                        "PODSEQUENCE",
                        "REGULATIONS",
                        "SERVERSIDE",
                        "SERVERUA",
                        "TRANSACTIONID",
                        "UNIVERSALADID",
                        "VASTVERSIONS",
                        "VERIFICATIONVENDORS"
                    ];
                    function v(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = [], i = T(e);
                        for(var a1 in !t.ERRORCODE || n.isCustomCode || /^[0-9]{3}$/.test(t.ERRORCODE) || (t.ERRORCODE = 900), t.CACHEBUSTING = S(Math.round(1e8 * Math.random()).toString()), t.TIMESTAMP = (new Date).toISOString(), t.RANDOM = t.random = t.CACHEBUSTING, t)t[a1] = _(t[a1]);
                        for(var o in i){
                            var s1 = i[o];
                            "string" == typeof s1 && r.push(y(s1, t));
                        }
                        return r;
                    }
                    function y(e, t) {
                        var n = (e = E(e, t)).match(/[^[\]]+(?=])/g);
                        if (!n) return e;
                        var r = n.filter(function(e) {
                            return m.indexOf(e) > -1;
                        });
                        return 0 === r.length ? e : E(e, r = r.reduce(function(e, t) {
                            return e[t] = -1, e;
                        }, {}));
                    }
                    function E(e, t) {
                        var n = e;
                        for(var r in t){
                            var i = t[r];
                            n = n.replace(new RegExp("(?:\\[|%%)(".concat(r, ")(?:\\]|%%)"), "g"), i);
                        }
                        return n;
                    }
                    function T(e) {
                        return Array.isArray(e) ? e.map(function(e) {
                            return e && e.hasOwnProperty("url") ? e.url : e;
                        }) : e;
                    }
                    function b(e, t) {
                        for(var n = 0; n < t.length; n++)if (A(t[n], e)) return !0;
                        return !1;
                    }
                    function A(e, t) {
                        if (e && t) {
                            var n = Object.getOwnPropertyNames(e), r = Object.getOwnPropertyNames(t);
                            return n.length === r.length && e.id === t.id && e.url === t.url;
                        }
                        return !1;
                    }
                    function _(e) {
                        return encodeURIComponent(e).replace(/[!'()*]/g, function(e) {
                            return "%".concat(e.charCodeAt(0).toString(16));
                        });
                    }
                    function S(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 8, n = String(e);
                        return n.length < t ? w(0, t - n.length, !1).map(function() {
                            return "0";
                        }).join("") + n : n;
                    }
                    function w(e, t, n) {
                        for(var r = [], i = e < t, a1 = n ? i ? t + 1 : t - 1 : t, o = e; i ? o < a1 : o > a1; i ? o++ : o--)r.push(o);
                        return r;
                    }
                    var I = {
                        track: function(e, t, n) {
                            v(e, t, n).forEach(function(e) {
                                "undefined" != typeof window && null !== window && ((new Image).src = e);
                            });
                        },
                        resolveURLTemplates: v,
                        extractURLsFromTemplates: T,
                        containsTemplateObject: b,
                        isTemplateObjectEqual: A,
                        encodeURIComponentRFC3986: _,
                        replaceUrlMacros: y,
                        leftpad: S,
                        range: w,
                        isNumeric: function(e) {
                            return !isNaN(parseFloat(e)) && isFinite(e);
                        },
                        flatten: function e(t) {
                            return t.reduce(function(t, n) {
                                return t.concat(Array.isArray(n) ? e(n) : n);
                            }, []);
                        },
                        joinArrayOfUniqueTemplateObjs: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], n = Array.isArray(e) ? e : [], r = Array.isArray(t) ? t : [];
                            return n.concat(r).reduce(function(e, t) {
                                return b(t, e) || e.push(t), e;
                            }, []);
                        }
                    };
                    function R(e) {
                        return -1 !== [
                            "true",
                            "TRUE",
                            "True",
                            "1"
                        ].indexOf(e);
                    }
                    var C = {
                        childByName: function(e, t) {
                            var n = e.childNodes;
                            for(var r in n){
                                var i = n[r];
                                if (i.nodeName === t) return i;
                            }
                        },
                        childrenByName: function(e, t) {
                            var n = [], r = e.childNodes;
                            for(var i in r){
                                var a1 = r[i];
                                a1.nodeName === t && n.push(a1);
                            }
                            return n;
                        },
                        resolveVastAdTagURI: function(e, t) {
                            if (!t) return e;
                            if (0 === e.indexOf("//")) {
                                var n = location.protocol;
                                return "".concat(n).concat(e);
                            }
                            if (-1 === e.indexOf("://")) {
                                var r = t.slice(0, t.lastIndexOf("/"));
                                return "".concat(r, "/").concat(e);
                            }
                            return e;
                        },
                        parseBoolean: R,
                        parseNodeText: function(e) {
                            return e && (e.textContent || e.text || "").trim();
                        },
                        copyNodeAttribute: function(e, t, n) {
                            var r = t.getAttribute(e);
                            r && n.setAttribute(e, r);
                        },
                        parseAttributes: function(e) {
                            for(var t = e.attributes, n = {}, r = 0; r < t.length; r++)n[t[r].nodeName] = t[r].nodeValue;
                            return n;
                        },
                        parseDuration: function(e) {
                            if (null == e) return -1;
                            if (I.isNumeric(e)) return parseInt(e);
                            var t = e.split(":");
                            if (3 !== t.length) return -1;
                            var n = t[2].split("."), r = parseInt(n[0]);
                            2 === n.length && (r += parseFloat("0.".concat(n[1])));
                            var i = parseInt(60 * t[1]), a1 = parseInt(60 * t[0] * 60);
                            return isNaN(a1) || isNaN(i) || isNaN(r) || i > 3600 || r > 60 ? -1 : a1 + i + r;
                        },
                        splitVAST: function(e) {
                            var t = [], n = null;
                            return e.forEach(function(r, i) {
                                if (r.sequence && (r.sequence = parseInt(r.sequence, 10)), r.sequence > 1) {
                                    var a1 = e[i - 1];
                                    if (a1 && a1.sequence === r.sequence - 1) return void (n && n.push(r));
                                    delete r.sequence;
                                }
                                n = [
                                    r
                                ], t.push(n);
                            }), t;
                        },
                        assignAttributes: function(e, t) {
                            if (e) for(var n in e){
                                var r = e[n];
                                if (r.nodeName && r.nodeValue && t.hasOwnProperty(r.nodeName)) {
                                    var i = r.nodeValue;
                                    "boolean" == typeof t[r.nodeName] && (i = R(i)), t[r.nodeName] = i;
                                }
                            }
                        },
                        mergeWrapperAdData: function(e, t) {
                            e.errorURLTemplates = t.errorURLTemplates.concat(e.errorURLTemplates), e.impressionURLTemplates = t.impressionURLTemplates.concat(e.impressionURLTemplates), e.extensions = t.extensions.concat(e.extensions), t.viewableImpression.length > 0 && (e.viewableImpression = [].concat(h(e.viewableImpression), h(t.viewableImpression))), e.followAdditionalWrappers = t.followAdditionalWrappers, e.allowMultipleAds = t.allowMultipleAds, e.fallbackOnNoAd = t.fallbackOnNoAd;
                            var n = (t.creatives || []).filter(function(e) {
                                return e && "companion" === e.type;
                            }), r = n.reduce(function(e, t) {
                                return (t.variations || []).forEach(function(t) {
                                    (t.companionClickTrackingURLTemplates || []).forEach(function(t) {
                                        I.containsTemplateObject(t, e) || e.push(t);
                                    });
                                }), e;
                            }, []);
                            e.creatives = n.concat(e.creatives);
                            var i = t.videoClickTrackingURLTemplates && t.videoClickTrackingURLTemplates.length, a1 = t.videoCustomClickURLTemplates && t.videoCustomClickURLTemplates.length;
                            e.creatives.forEach(function(e) {
                                if (t.trackingEvents && t.trackingEvents[e.type]) for(var n in t.trackingEvents[e.type]){
                                    var o = t.trackingEvents[e.type][n];
                                    Array.isArray(e.trackingEvents[n]) || (e.trackingEvents[n] = []), e.trackingEvents[n] = e.trackingEvents[n].concat(o);
                                }
                                "linear" === e.type && (i && (e.videoClickTrackingURLTemplates = e.videoClickTrackingURLTemplates.concat(t.videoClickTrackingURLTemplates)), a1 && (e.videoCustomClickURLTemplates = e.videoCustomClickURLTemplates.concat(t.videoCustomClickURLTemplates)), !t.videoClickThroughURLTemplate || null !== e.videoClickThroughURLTemplate && void 0 !== e.videoClickThroughURLTemplate || (e.videoClickThroughURLTemplate = t.videoClickThroughURLTemplate)), "companion" === e.type && r.length && (e.variations || []).forEach(function(e) {
                                    e.companionClickTrackingURLTemplates = I.joinArrayOfUniqueTemplateObjs(e.companionClickTrackingURLTemplates, r);
                                });
                            }), t.adVerifications && (e.adVerifications = e.adVerifications.concat(t.adVerifications)), t.blockedAdCategories && (e.blockedAdCategories = e.blockedAdCategories.concat(t.blockedAdCategories));
                        }
                    };
                    function D(e, t) {
                        var n = function() {
                            var e = p(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {});
                            return {
                                id: e.id,
                                adId: e.adId,
                                sequence: e.sequence,
                                apiFramework: e.apiFramework,
                                type: "companion",
                                required: null,
                                variations: []
                            };
                        }(t);
                        return n.required = e.getAttribute("required") || null, n.variations = C.childrenByName(e, "Companion").map(function(e) {
                            var t = function() {
                                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                return {
                                    id: e.id || null,
                                    adType: "companionAd",
                                    width: e.width || 0,
                                    height: e.height || 0,
                                    assetWidth: e.assetWidth || null,
                                    assetHeight: e.assetHeight || null,
                                    expandedWidth: e.expandedWidth || null,
                                    expandedHeight: e.expandedHeight || null,
                                    apiFramework: e.apiFramework || null,
                                    adSlotID: e.adSlotID || null,
                                    pxratio: e.pxratio || "1",
                                    renderingMode: e.renderingMode || "default",
                                    staticResources: [],
                                    htmlResources: [],
                                    iframeResources: [],
                                    adParameters: null,
                                    xmlEncoded: null,
                                    altText: null,
                                    companionClickThroughURLTemplate: null,
                                    companionClickTrackingURLTemplates: [],
                                    trackingEvents: {}
                                };
                            }(C.parseAttributes(e));
                            t.htmlResources = C.childrenByName(e, "HTMLResource").reduce(function(e, t) {
                                var n = C.parseNodeText(t);
                                return n ? e.concat(n) : e;
                            }, []), t.iframeResources = C.childrenByName(e, "IFrameResource").reduce(function(e, t) {
                                var n = C.parseNodeText(t);
                                return n ? e.concat(n) : e;
                            }, []), t.staticResources = C.childrenByName(e, "StaticResource").reduce(function(e, t) {
                                var n = C.parseNodeText(t);
                                return n ? e.concat({
                                    url: n,
                                    creativeType: t.getAttribute("creativeType") || null
                                }) : e;
                            }, []), t.altText = C.parseNodeText(C.childByName(e, "AltText")) || null;
                            var n = C.childByName(e, "TrackingEvents");
                            n && C.childrenByName(n, "Tracking").forEach(function(e) {
                                var n = e.getAttribute("event"), r = C.parseNodeText(e);
                                n && r && (Array.isArray(t.trackingEvents[n]) || (t.trackingEvents[n] = []), t.trackingEvents[n].push(r));
                            }), t.companionClickTrackingURLTemplates = C.childrenByName(e, "CompanionClickTracking").map(function(e) {
                                return {
                                    id: e.getAttribute("id") || null,
                                    url: C.parseNodeText(e)
                                };
                            }), t.companionClickThroughURLTemplate = C.parseNodeText(C.childByName(e, "CompanionClickThrough")) || null;
                            var r = C.childByName(e, "AdParameters");
                            return r && (t.adParameters = C.parseNodeText(r), t.xmlEncoded = r.getAttribute("xmlEncoded") || null), t;
                        }), n;
                    }
                    function k(e) {
                        return "linear" === e.type;
                    }
                    function N(e, t) {
                        var n, r = function() {
                            var e = p(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {});
                            return {
                                id: e.id,
                                adId: e.adId,
                                sequence: e.sequence,
                                apiFramework: e.apiFramework,
                                type: "linear",
                                duration: 0,
                                skipDelay: null,
                                mediaFiles: [],
                                mezzanine: null,
                                interactiveCreativeFile: null,
                                closedCaptionFiles: [],
                                videoClickThroughURLTemplate: null,
                                videoClickTrackingURLTemplates: [],
                                videoCustomClickURLTemplates: [],
                                adParameters: null,
                                icons: [],
                                trackingEvents: {}
                            };
                        }(t);
                        r.duration = C.parseDuration(C.parseNodeText(C.childByName(e, "Duration")));
                        var i = e.getAttribute("skipoffset");
                        if (null == i) r.skipDelay = null;
                        else if ("%" === i.charAt(i.length - 1) && -1 !== r.duration) {
                            var a1 = parseInt(i, 10);
                            r.skipDelay = r.duration * (a1 / 100);
                        } else r.skipDelay = C.parseDuration(i);
                        var o = C.childByName(e, "VideoClicks");
                        if (o) {
                            var s1 = C.childByName(o, "ClickThrough");
                            r.videoClickThroughURLTemplate = s1 ? {
                                id: s1.getAttribute("id") || null,
                                url: C.parseNodeText(s1)
                            } : null, C.childrenByName(o, "ClickTracking").forEach(function(e) {
                                r.videoClickTrackingURLTemplates.push({
                                    id: e.getAttribute("id") || null,
                                    url: C.parseNodeText(e)
                                });
                            }), C.childrenByName(o, "CustomClick").forEach(function(e) {
                                r.videoCustomClickURLTemplates.push({
                                    id: e.getAttribute("id") || null,
                                    url: C.parseNodeText(e)
                                });
                            });
                        }
                        var u = C.childByName(e, "AdParameters");
                        u && (r.adParameters = C.parseNodeText(u)), C.childrenByName(e, "TrackingEvents").forEach(function(e) {
                            C.childrenByName(e, "Tracking").forEach(function(e) {
                                var t = e.getAttribute("event"), i = C.parseNodeText(e);
                                if (t && i) {
                                    if ("progress" === t) {
                                        if (!(n = e.getAttribute("offset"))) return;
                                        t = "%" === n.charAt(n.length - 1) ? "progress-".concat(n) : "progress-".concat(Math.round(C.parseDuration(n)));
                                    }
                                    Array.isArray(r.trackingEvents[t]) || (r.trackingEvents[t] = []), r.trackingEvents[t].push(i);
                                }
                            });
                        }), C.childrenByName(e, "MediaFiles").forEach(function(e) {
                            C.childrenByName(e, "MediaFile").forEach(function(e) {
                                r.mediaFiles.push(function(e) {
                                    var t = {
                                        id: null,
                                        fileURL: null,
                                        fileSize: 0,
                                        deliveryType: "progressive",
                                        mimeType: null,
                                        mediaType: null,
                                        codec: null,
                                        bitrate: 0,
                                        minBitrate: 0,
                                        maxBitrate: 0,
                                        width: 0,
                                        height: 0,
                                        apiFramework: null,
                                        scalable: null,
                                        maintainAspectRatio: null
                                    };
                                    t.id = e.getAttribute("id"), t.fileURL = C.parseNodeText(e), t.deliveryType = e.getAttribute("delivery"), t.codec = e.getAttribute("codec"), t.mimeType = e.getAttribute("type"), t.mediaType = e.getAttribute("mediaType") || "2D", t.apiFramework = e.getAttribute("apiFramework"), t.fileSize = parseInt(e.getAttribute("fileSize") || 0), t.bitrate = parseInt(e.getAttribute("bitrate") || 0), t.minBitrate = parseInt(e.getAttribute("minBitrate") || 0), t.maxBitrate = parseInt(e.getAttribute("maxBitrate") || 0), t.width = parseInt(e.getAttribute("width") || 0), t.height = parseInt(e.getAttribute("height") || 0);
                                    var n = e.getAttribute("scalable");
                                    n && "string" == typeof n && (t.scalable = C.parseBoolean(n));
                                    var r = e.getAttribute("maintainAspectRatio");
                                    return r && "string" == typeof r && (t.maintainAspectRatio = C.parseBoolean(r)), t;
                                }(e));
                            });
                            var t = C.childByName(e, "InteractiveCreativeFile");
                            t && (r.interactiveCreativeFile = function(e) {
                                var t = function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    return {
                                        type: e.type || null,
                                        apiFramework: e.apiFramework || null,
                                        variableDuration: C.parseBoolean(e.variableDuration),
                                        fileURL: null
                                    };
                                }(C.parseAttributes(e));
                                return t.fileURL = C.parseNodeText(e), t;
                            }(t));
                            var n = C.childByName(e, "ClosedCaptionFiles");
                            n && C.childrenByName(n, "ClosedCaptionFile").forEach(function(e) {
                                var t = function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    return {
                                        type: e.type || null,
                                        language: e.language || null,
                                        fileURL: null
                                    };
                                }(C.parseAttributes(e));
                                t.fileURL = C.parseNodeText(e), r.closedCaptionFiles.push(t);
                            });
                            var i, a1, o, s1 = C.childByName(e, "Mezzanine"), u = (i = s1, a1 = {}, o = !1, [
                                "delivery",
                                "type",
                                "width",
                                "height"
                            ].forEach(function(e) {
                                i && i.getAttribute(e) ? a1[e] = i.getAttribute(e) : o = !0;
                            }), o ? null : a1);
                            if (u) {
                                var l = {
                                    id: null,
                                    fileURL: null,
                                    delivery: null,
                                    codec: null,
                                    type: null,
                                    width: 0,
                                    height: 0,
                                    fileSize: 0,
                                    mediaType: "2D"
                                };
                                l.id = s1.getAttribute("id"), l.fileURL = C.parseNodeText(s1), l.delivery = u.delivery, l.codec = s1.getAttribute("codec"), l.type = u.type, l.width = parseInt(u.width, 10), l.height = parseInt(u.height, 10), l.fileSize = parseInt(s1.getAttribute("fileSize"), 10), l.mediaType = s1.getAttribute("mediaType") || "2D", r.mezzanine = l;
                            }
                        });
                        var l = C.childByName(e, "Icons");
                        return l && C.childrenByName(l, "Icon").forEach(function(e) {
                            r.icons.push(function(e) {
                                var t = {
                                    program: null,
                                    height: 0,
                                    width: 0,
                                    xPosition: 0,
                                    yPosition: 0,
                                    apiFramework: null,
                                    offset: null,
                                    duration: 0,
                                    type: null,
                                    staticResource: null,
                                    htmlResource: null,
                                    iframeResource: null,
                                    pxratio: "1",
                                    iconClickThroughURLTemplate: null,
                                    iconClickTrackingURLTemplates: [],
                                    iconViewTrackingURLTemplate: null
                                };
                                t.program = e.getAttribute("program"), t.height = parseInt(e.getAttribute("height") || 0), t.width = parseInt(e.getAttribute("width") || 0), t.xPosition = function(e) {
                                    return -1 !== [
                                        "left",
                                        "right"
                                    ].indexOf(e) ? e : parseInt(e || 0);
                                }(e.getAttribute("xPosition")), t.yPosition = function(e) {
                                    return -1 !== [
                                        "top",
                                        "bottom"
                                    ].indexOf(e) ? e : parseInt(e || 0);
                                }(e.getAttribute("yPosition")), t.apiFramework = e.getAttribute("apiFramework"), t.pxratio = e.getAttribute("pxratio") || "1", t.offset = C.parseDuration(e.getAttribute("offset")), t.duration = C.parseDuration(e.getAttribute("duration")), C.childrenByName(e, "HTMLResource").forEach(function(e) {
                                    t.type = e.getAttribute("creativeType") || "text/html", t.htmlResource = C.parseNodeText(e);
                                }), C.childrenByName(e, "IFrameResource").forEach(function(e) {
                                    t.type = e.getAttribute("creativeType") || 0, t.iframeResource = C.parseNodeText(e);
                                }), C.childrenByName(e, "StaticResource").forEach(function(e) {
                                    t.type = e.getAttribute("creativeType") || 0, t.staticResource = C.parseNodeText(e);
                                });
                                var n = C.childByName(e, "IconClicks");
                                return n && (t.iconClickThroughURLTemplate = C.parseNodeText(C.childByName(n, "IconClickThrough")), C.childrenByName(n, "IconClickTracking").forEach(function(e) {
                                    t.iconClickTrackingURLTemplates.push({
                                        id: e.getAttribute("id") || null,
                                        url: C.parseNodeText(e)
                                    });
                                })), t.iconViewTrackingURLTemplate = C.parseNodeText(C.childByName(e, "IconViewTracking")), t;
                            }(e));
                        }), r;
                    }
                    function L(e, t) {
                        var n = function() {
                            var e = p(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {});
                            return {
                                id: e.id,
                                adId: e.adId,
                                sequence: e.sequence,
                                apiFramework: e.apiFramework,
                                type: "nonlinear",
                                variations: [],
                                trackingEvents: {}
                            };
                        }(t);
                        return C.childrenByName(e, "TrackingEvents").forEach(function(e) {
                            var t, r;
                            C.childrenByName(e, "Tracking").forEach(function(e) {
                                t = e.getAttribute("event"), r = C.parseNodeText(e), t && r && (Array.isArray(n.trackingEvents[t]) || (n.trackingEvents[t] = []), n.trackingEvents[t].push(r));
                            });
                        }), C.childrenByName(e, "NonLinear").forEach(function(e) {
                            var t = {
                                id: null,
                                width: 0,
                                height: 0,
                                expandedWidth: 0,
                                expandedHeight: 0,
                                scalable: !0,
                                maintainAspectRatio: !0,
                                minSuggestedDuration: 0,
                                apiFramework: "static",
                                adType: "nonLinearAd",
                                type: null,
                                staticResource: null,
                                htmlResource: null,
                                iframeResource: null,
                                nonlinearClickThroughURLTemplate: null,
                                nonlinearClickTrackingURLTemplates: [],
                                adParameters: null
                            };
                            t.id = e.getAttribute("id") || null, t.width = e.getAttribute("width"), t.height = e.getAttribute("height"), t.expandedWidth = e.getAttribute("expandedWidth"), t.expandedHeight = e.getAttribute("expandedHeight"), t.scalable = C.parseBoolean(e.getAttribute("scalable")), t.maintainAspectRatio = C.parseBoolean(e.getAttribute("maintainAspectRatio")), t.minSuggestedDuration = C.parseDuration(e.getAttribute("minSuggestedDuration")), t.apiFramework = e.getAttribute("apiFramework"), C.childrenByName(e, "HTMLResource").forEach(function(e) {
                                t.type = e.getAttribute("creativeType") || "text/html", t.htmlResource = C.parseNodeText(e);
                            }), C.childrenByName(e, "IFrameResource").forEach(function(e) {
                                t.type = e.getAttribute("creativeType") || 0, t.iframeResource = C.parseNodeText(e);
                            }), C.childrenByName(e, "StaticResource").forEach(function(e) {
                                t.type = e.getAttribute("creativeType") || 0, t.staticResource = C.parseNodeText(e);
                            });
                            var r = C.childByName(e, "AdParameters");
                            r && (t.adParameters = C.parseNodeText(r)), t.nonlinearClickThroughURLTemplate = C.parseNodeText(C.childByName(e, "NonLinearClickThrough")), C.childrenByName(e, "NonLinearClickTracking").forEach(function(e) {
                                t.nonlinearClickTrackingURLTemplates.push({
                                    id: e.getAttribute("id") || null,
                                    url: C.parseNodeText(e)
                                });
                            }), n.variations.push(t);
                        }), n;
                    }
                    function x(e) {
                        var t = [];
                        return e.forEach(function(e) {
                            var n = M(e);
                            n && t.push(n);
                        }), t;
                    }
                    function M(e) {
                        if ("#comment" === e.nodeName) return null;
                        var t, n = {
                            name: null,
                            value: null,
                            attributes: {},
                            children: []
                        }, r = e.attributes, i = e.childNodes;
                        if (n.name = e.nodeName, e.attributes) {
                            for(var a1 in r)if (r.hasOwnProperty(a1)) {
                                var o = r[a1];
                                o.nodeName && o.nodeValue && (n.attributes[o.nodeName] = o.nodeValue);
                            }
                        }
                        for(var s1 in i)if (i.hasOwnProperty(s1)) {
                            var u = M(i[s1]);
                            u && n.children.push(u);
                        }
                        if (0 === n.children.length || 1 === n.children.length && [
                            "#cdata-section",
                            "#text"
                        ].indexOf(n.children[0].name) >= 0) {
                            var l = C.parseNodeText(e);
                            "" !== l && (n.value = l), n.children = [];
                        }
                        return null === (t = n).value && 0 === Object.keys(t.attributes).length && 0 === t.children.length ? null : n;
                    }
                    function O(e) {
                        var t = [];
                        return e.forEach(function(e) {
                            var n, r = {
                                id: e.getAttribute("id") || null,
                                adId: P(e),
                                sequence: e.getAttribute("sequence") || null,
                                apiFramework: e.getAttribute("apiFramework") || null
                            }, i = [];
                            C.childrenByName(e, "UniversalAdId").forEach(function(e) {
                                var t = {
                                    idRegistry: e.getAttribute("idRegistry") || "unknown",
                                    value: C.parseNodeText(e)
                                };
                                i.push(t);
                            });
                            var a1 = C.childByName(e, "CreativeExtensions");
                            for(var o in a1 && (n = x(C.childrenByName(a1, "CreativeExtension"))), e.childNodes){
                                var s1 = e.childNodes[o], u = void 0;
                                switch(s1.nodeName){
                                    case "Linear":
                                        u = N(s1, r);
                                        break;
                                    case "NonLinearAds":
                                        u = L(s1, r);
                                        break;
                                    case "CompanionAds":
                                        u = D(s1, r);
                                }
                                u && (i && (u.universalAdIds = i), n && (u.creativeExtensions = n), t.push(u));
                            }
                        }), t;
                    }
                    function P(e) {
                        return e.getAttribute("AdID") || e.getAttribute("adID") || e.getAttribute("adId") || null;
                    }
                    var F = {
                        Wrapper: {
                            subElements: [
                                "VASTAdTagURI",
                                "Impression"
                            ]
                        },
                        BlockedAdCategories: {
                            attributes: [
                                "authority"
                            ]
                        },
                        InLine: {
                            subElements: [
                                "AdSystem",
                                "AdTitle",
                                "Impression",
                                "AdServingId",
                                "Creatives"
                            ]
                        },
                        Category: {
                            attributes: [
                                "authority"
                            ]
                        },
                        Pricing: {
                            attributes: [
                                "model",
                                "currency"
                            ]
                        },
                        Verification: {
                            oneOfinLineResources: [
                                "JavaScriptResource",
                                "ExecutableResource"
                            ],
                            attributes: [
                                "vendor"
                            ]
                        },
                        UniversalAdId: {
                            attributes: [
                                "idRegistry"
                            ]
                        },
                        JavaScriptResource: {
                            attributes: [
                                "apiFramework",
                                "browserOptional"
                            ]
                        },
                        ExecutableResource: {
                            attributes: [
                                "apiFramework",
                                "type"
                            ]
                        },
                        Tracking: {
                            attributes: [
                                "event"
                            ]
                        },
                        Creatives: {
                            subElements: [
                                "Creative"
                            ]
                        },
                        Creative: {
                            subElements: [
                                "UniversalAdId"
                            ]
                        },
                        Linear: {
                            subElements: [
                                "MediaFiles",
                                "Duration"
                            ]
                        },
                        MediaFiles: {
                            subElements: [
                                "MediaFile"
                            ]
                        },
                        MediaFile: {
                            attributes: [
                                "delivery",
                                "type",
                                "width",
                                "height"
                            ]
                        },
                        Mezzanine: {
                            attributes: [
                                "delivery",
                                "type",
                                "width",
                                "height"
                            ]
                        },
                        NonLinear: {
                            oneOfinLineResources: [
                                "StaticResource",
                                "IFrameResource",
                                "HTMLResource"
                            ],
                            attributes: [
                                "width",
                                "height"
                            ]
                        },
                        Companion: {
                            oneOfinLineResources: [
                                "StaticResource",
                                "IFrameResource",
                                "HTMLResource"
                            ],
                            attributes: [
                                "width",
                                "height"
                            ]
                        },
                        StaticResource: {
                            attributes: [
                                "creativeType"
                            ]
                        },
                        Icons: {
                            subElements: [
                                "Icon"
                            ]
                        },
                        Icon: {
                            oneOfinLineResources: [
                                "StaticResource",
                                "IFrameResource",
                                "HTMLResource"
                            ]
                        }
                    };
                    function U(e, t) {
                        if (F[e.nodeName] && F[e.nodeName].attributes) {
                            var n = F[e.nodeName].attributes.filter(function(t) {
                                return !e.getAttribute(t);
                            });
                            n.length > 0 && G({
                                name: e.nodeName,
                                parentName: e.parentNode.nodeName,
                                attributes: n
                            }, t);
                        }
                    }
                    function j(e, t, n) {
                        var r = F[e.nodeName], i = !n && "Wrapper" !== e.nodeName;
                        if (r && !i) {
                            if (r.subElements) {
                                var a1 = r.subElements.filter(function(t) {
                                    return !C.childByName(e, t);
                                });
                                a1.length > 0 && G({
                                    name: e.nodeName,
                                    parentName: e.parentNode.nodeName,
                                    subElements: a1
                                }, t);
                            }
                            n && r.oneOfinLineResources && (r.oneOfinLineResources.some(function(t) {
                                return C.childByName(e, t);
                            }) || G({
                                name: e.nodeName,
                                parentName: e.parentNode.nodeName,
                                oneOfResources: r.oneOfinLineResources
                            }, t));
                        }
                    }
                    function B(e) {
                        return e.children && 0 !== e.children.length;
                    }
                    function G(e, t) {
                        var n = e.name, r = e.parentName, i = e.attributes, a1 = e.subElements, o = e.oneOfResources, s1 = "Element '".concat(n, "'");
                        t("VAST-warning", {
                            message: s1 += i ? " missing required attribute(s) '".concat(i.join(", "), "' ") : a1 ? " missing required sub element(s) '".concat(a1.join(", "), "' ") : o ? " must provide one of the following '".concat(o.join(", "), "' ") : " is empty",
                            parentElement: r,
                            specVersion: 4.1
                        });
                    }
                    var H = function e(t, n, r) {
                        if (t && t.nodeName) {
                            if ("InLine" === t.nodeName && (r = !0), U(t, n), B(t)) {
                                j(t, n, r);
                                for(var i = 0; i < t.children.length; i++)e(t.children[i], n, r);
                            } else 0 === C.parseNodeText(t).length && G({
                                name: t.nodeName,
                                parentName: t.parentNode.nodeName
                            }, n);
                        }
                    };
                    function V(e, t) {
                        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = n.allowMultipleAds, i = n.followAdditionalWrappers, a1 = e.childNodes;
                        for(var o in a1){
                            var s1 = a1[o];
                            if (-1 !== [
                                "Wrapper",
                                "InLine"
                            ].indexOf(s1.nodeName) && ("Wrapper" !== s1.nodeName || !1 !== i)) {
                                if (C.copyNodeAttribute("id", e, s1), C.copyNodeAttribute("sequence", e, s1), C.copyNodeAttribute("adType", e, s1), "Wrapper" === s1.nodeName) return {
                                    ad: Y(s1, t),
                                    type: "WRAPPER"
                                };
                                if ("InLine" === s1.nodeName) return {
                                    ad: K(s1, t, {
                                        allowMultipleAds: r
                                    }),
                                    type: "INLINE"
                                };
                            }
                        }
                    }
                    function K(e, t) {
                        return !1 === (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).allowMultipleAds && e.getAttribute("sequence") ? null : q(e, t);
                    }
                    function q(e, t) {
                        var n = [];
                        t && H(e, t);
                        var r = e.childNodes, i = function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            return {
                                id: e.id || null,
                                sequence: e.sequence || null,
                                adType: e.adType || null,
                                adServingId: null,
                                categories: [],
                                expires: null,
                                viewableImpression: [],
                                system: null,
                                title: null,
                                description: null,
                                advertiser: null,
                                pricing: null,
                                survey: null,
                                errorURLTemplates: [],
                                impressionURLTemplates: [],
                                creatives: [],
                                extensions: [],
                                adVerifications: [],
                                blockedAdCategories: [],
                                followAdditionalWrappers: !0,
                                allowMultipleAds: !1,
                                fallbackOnNoAd: null
                            };
                        }(C.parseAttributes(e));
                        for(var a1 in r){
                            var o = r[a1];
                            switch(o.nodeName){
                                case "Error":
                                    i.errorURLTemplates.push(C.parseNodeText(o));
                                    break;
                                case "Impression":
                                    i.impressionURLTemplates.push({
                                        id: o.getAttribute("id") || null,
                                        url: C.parseNodeText(o)
                                    });
                                    break;
                                case "Creatives":
                                    i.creatives = O(C.childrenByName(o, "Creative"));
                                    break;
                                case "Extensions":
                                    var s1 = C.childrenByName(o, "Extension");
                                    i.extensions = x(s1), i.adVerifications.length || (n = z(s1));
                                    break;
                                case "AdVerifications":
                                    i.adVerifications = W(C.childrenByName(o, "Verification"));
                                    break;
                                case "AdSystem":
                                    i.system = {
                                        value: C.parseNodeText(o),
                                        version: o.getAttribute("version") || null
                                    };
                                    break;
                                case "AdTitle":
                                    i.title = C.parseNodeText(o);
                                    break;
                                case "AdServingId":
                                    i.adServingId = C.parseNodeText(o);
                                    break;
                                case "Category":
                                    i.categories.push({
                                        authority: o.getAttribute("authority") || null,
                                        value: C.parseNodeText(o)
                                    });
                                    break;
                                case "Expires":
                                    i.expires = parseInt(C.parseNodeText(o), 10);
                                    break;
                                case "ViewableImpression":
                                    i.viewableImpression.push(X(o));
                                    break;
                                case "Description":
                                    i.description = C.parseNodeText(o);
                                    break;
                                case "Advertiser":
                                    i.advertiser = {
                                        id: o.getAttribute("id") || null,
                                        value: C.parseNodeText(o)
                                    };
                                    break;
                                case "Pricing":
                                    i.pricing = {
                                        value: C.parseNodeText(o),
                                        model: o.getAttribute("model") || null,
                                        currency: o.getAttribute("currency") || null
                                    };
                                    break;
                                case "Survey":
                                    i.survey = C.parseNodeText(o);
                                    break;
                                case "BlockedAdCategories":
                                    i.blockedAdCategories.push({
                                        authority: o.getAttribute("authority") || null,
                                        value: C.parseNodeText(o)
                                    });
                            }
                        }
                        return n.length && (i.adVerifications = i.adVerifications.concat(n)), i;
                    }
                    function Y(e, t) {
                        var n = q(e, t), r = e.getAttribute("followAdditionalWrappers"), i = e.getAttribute("allowMultipleAds"), a1 = e.getAttribute("fallbackOnNoAd");
                        n.followAdditionalWrappers = !r || C.parseBoolean(r), n.allowMultipleAds = !!i && C.parseBoolean(i), n.fallbackOnNoAd = a1 ? C.parseBoolean(a1) : null;
                        var o = C.childByName(e, "VASTAdTagURI");
                        if (o ? n.nextWrapperURL = C.parseNodeText(o) : (o = C.childByName(e, "VASTAdTagURL")) && (n.nextWrapperURL = C.parseNodeText(C.childByName(o, "URL"))), n.creatives.forEach(function(e) {
                            if (-1 !== [
                                "linear",
                                "nonlinear"
                            ].indexOf(e.type)) {
                                if (e.trackingEvents) {
                                    n.trackingEvents || (n.trackingEvents = {}), n.trackingEvents[e.type] || (n.trackingEvents[e.type] = {});
                                    var t = function(t) {
                                        var r = e.trackingEvents[t];
                                        Array.isArray(n.trackingEvents[e.type][t]) || (n.trackingEvents[e.type][t] = []), r.forEach(function(r) {
                                            n.trackingEvents[e.type][t].push(r);
                                        });
                                    };
                                    for(var r in e.trackingEvents)t(r);
                                }
                                e.videoClickTrackingURLTemplates && (Array.isArray(n.videoClickTrackingURLTemplates) || (n.videoClickTrackingURLTemplates = []), e.videoClickTrackingURLTemplates.forEach(function(e) {
                                    n.videoClickTrackingURLTemplates.push(e);
                                })), e.videoClickThroughURLTemplate && (n.videoClickThroughURLTemplate = e.videoClickThroughURLTemplate), e.videoCustomClickURLTemplates && (Array.isArray(n.videoCustomClickURLTemplates) || (n.videoCustomClickURLTemplates = []), e.videoCustomClickURLTemplates.forEach(function(e) {
                                    n.videoCustomClickURLTemplates.push(e);
                                }));
                            }
                        }), n.nextWrapperURL) return n;
                    }
                    function W(e) {
                        var t = [];
                        return e.forEach(function(e) {
                            var n = {
                                resource: null,
                                vendor: null,
                                browserOptional: !1,
                                apiFramework: null,
                                type: null,
                                parameters: null,
                                trackingEvents: {}
                            }, r = e.childNodes;
                            for(var i in C.assignAttributes(e.attributes, n), r){
                                var a1 = r[i];
                                switch(a1.nodeName){
                                    case "JavaScriptResource":
                                    case "ExecutableResource":
                                        n.resource = C.parseNodeText(a1), C.assignAttributes(a1.attributes, n);
                                        break;
                                    case "VerificationParameters":
                                        n.parameters = C.parseNodeText(a1);
                                }
                            }
                            var o = C.childByName(e, "TrackingEvents");
                            o && C.childrenByName(o, "Tracking").forEach(function(e) {
                                var t = e.getAttribute("event"), r = C.parseNodeText(e);
                                t && r && (Array.isArray(n.trackingEvents[t]) || (n.trackingEvents[t] = []), n.trackingEvents[t].push(r));
                            }), t.push(n);
                        }), t;
                    }
                    function z(e) {
                        var t = null, n = [];
                        return e.some(function(e) {
                            return t = C.childByName(e, "AdVerifications");
                        }), t && (n = W(C.childrenByName(t, "Verification"))), n;
                    }
                    function X(e) {
                        var t = {};
                        t.id = e.getAttribute("id") || null;
                        var n = e.childNodes;
                        for(var r in n){
                            var i = n[r], a1 = i.nodeName, o = C.parseNodeText(i);
                            if (("Viewable" === a1 || "NotViewable" === a1 || "ViewUndetermined" === a1) && o) {
                                var s1 = a1.toLowerCase();
                                Array.isArray(t[s1]) || (t[s1] = []), t[s1].push(o);
                            }
                        }
                        return t;
                    }
                    var Q = function() {
                        function e() {
                            i(this, e), this._handlers = [];
                        }
                        return o(e, [
                            {
                                key: "on",
                                value: function(e, t) {
                                    if ("function" != typeof t) throw new TypeError("The handler argument must be of type Function. Received type ".concat(r(t)));
                                    if (!e) throw new TypeError("The event argument must be of type String. Received type ".concat(r(e)));
                                    return this._handlers.push({
                                        event: e,
                                        handler: t
                                    }), this;
                                }
                            },
                            {
                                key: "once",
                                value: function(e, t) {
                                    return this.on(e, function(e, t, n) {
                                        var r = {
                                            fired: !1,
                                            wrapFn: void 0
                                        };
                                        function i() {
                                            r.fired || (e.off(t, r.wrapFn), r.fired = !0, n.bind(e).apply(void 0, arguments));
                                        }
                                        return r.wrapFn = i, i;
                                    }(this, e, t));
                                }
                            },
                            {
                                key: "off",
                                value: function(e, t) {
                                    return this._handlers = this._handlers.filter(function(n) {
                                        return n.event !== e || n.handler !== t;
                                    }), this;
                                }
                            },
                            {
                                key: "emit",
                                value: function(e) {
                                    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
                                    var i = !1;
                                    return this._handlers.forEach(function(t) {
                                        "*" === t.event && (i = !0, t.handler.apply(t, [
                                            e
                                        ].concat(n))), t.event === e && (i = !0, t.handler.apply(t, n));
                                    }), i;
                                }
                            },
                            {
                                key: "removeAllListeners",
                                value: function(e) {
                                    return e ? (this._handlers = this._handlers.filter(function(t) {
                                        return t.event !== e;
                                    }), this) : (this._handlers = [], this);
                                }
                            },
                            {
                                key: "listenerCount",
                                value: function(e) {
                                    return this._handlers.filter(function(t) {
                                        return t.event === e;
                                    }).length;
                                }
                            },
                            {
                                key: "listeners",
                                value: function(e) {
                                    return this._handlers.reduce(function(t, n) {
                                        return n.event === e && t.push(n.handler), t;
                                    }, []);
                                }
                            },
                            {
                                key: "eventNames",
                                value: function() {
                                    return this._handlers.map(function(e) {
                                        return e.event;
                                    });
                                }
                            }
                        ]), e;
                    }(), J = function(e, t, n) {
                        n(new Error("Please bundle the library for node to use the node urlHandler"));
                    }, Z = 12e4;
                    function $() {
                        try {
                            var e = new window.XMLHttpRequest;
                            return "withCredentials" in e ? e : null;
                        } catch (e) {
                            return null;
                        }
                    }
                    function ee(e, t, n) {
                        var r = n ? 408 : e.status, i = n ? "XHRURLHandler: Request timed out after ".concat(e.timeout, " ms (").concat(r, ")") : "XHRURLHandler: ".concat(e.statusText, " (").concat(r, ")");
                        t(new Error(i), null, {
                            statusCode: r
                        });
                    }
                    var te = function(e, t, n) {
                        if ("https:" === window.location.protocol && 0 === e.indexOf("http://")) return n(new Error("XHRURLHandler: Cannot go from HTTPS to HTTP."));
                        try {
                            var r = $();
                            r.open("GET", e), r.timeout = t.timeout || Z, r.withCredentials = t.withCredentials || !1, r.overrideMimeType && r.overrideMimeType("text/xml"), r.onload = function() {
                                return function(e, t) {
                                    200 === e.status ? t(null, e.responseXML, {
                                        byteLength: e.response.length,
                                        statusCode: e.status
                                    }) : ee(e, t, !1);
                                }(r, n);
                            }, r.onerror = function() {
                                return ee(r, n, !1);
                            }, r.onabort = function() {
                                return ee(r, n, !1);
                            }, r.ontimeout = function() {
                                return ee(r, n, !0);
                            }, r.send();
                        } catch (e) {
                            n(new Error("XHRURLHandler: Unexpected error"));
                        }
                    }, ne = function() {
                        return !!$();
                    }, re = {
                        get: function(e, t, n) {
                            return n || ("function" == typeof t && (n = t), t = {}), "undefined" == typeof window || null === window ? J(e, t, n) : ne() ? te(e, t, n) : n(new Error("Current context is not supported by any of the default URLHandlers. Please provide a custom URLHandler"));
                        }
                    }, ie = 0, ae = 0, oe = function(e, t) {
                        !e || !t || e <= 0 || t <= 0 || (ae = (ae * ie + 8 * e / t) / ++ie);
                    }, se = {
                        ERRORCODE: 900,
                        extensions: []
                    }, ue = function(e) {
                        u(n, e);
                        var t = f(n);
                        function n() {
                            var e;
                            return i(this, n), (e = t.call(this)).remainingAds = [], e.parentURLs = [], e.errorURLTemplates = [], e.rootErrorURLTemplates = [], e.maxWrapperDepth = null, e.URLTemplateFilters = [], e.fetchingOptions = {}, e.parsingOptions = {}, e;
                        }
                        return o(n, [
                            {
                                key: "addURLTemplateFilter",
                                value: function(e) {
                                    "function" == typeof e && this.URLTemplateFilters.push(e);
                                }
                            },
                            {
                                key: "removeURLTemplateFilter",
                                value: function() {
                                    this.URLTemplateFilters.pop();
                                }
                            },
                            {
                                key: "countURLTemplateFilters",
                                value: function() {
                                    return this.URLTemplateFilters.length;
                                }
                            },
                            {
                                key: "clearURLTemplateFilters",
                                value: function() {
                                    this.URLTemplateFilters = [];
                                }
                            },
                            {
                                key: "trackVastError",
                                value: function(e, t) {
                                    for(var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)r[i - 2] = arguments[i];
                                    this.emit("VAST-error", Object.assign.apply(Object, [
                                        {},
                                        se,
                                        t
                                    ].concat(r))), I.track(e, t);
                                }
                            },
                            {
                                key: "getErrorURLTemplates",
                                value: function() {
                                    return this.rootErrorURLTemplates.concat(this.errorURLTemplates);
                                }
                            },
                            {
                                key: "getEstimatedBitrate",
                                value: function() {
                                    return ae;
                                }
                            },
                            {
                                key: "fetchVAST",
                                value: function(e) {
                                    var t = this, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
                                    return new Promise(function(a1, o) {
                                        t.URLTemplateFilters.forEach(function(t) {
                                            e = t(e);
                                        }), t.parentURLs.push(e);
                                        var s1 = Date.now();
                                        t.emit("VAST-resolving", {
                                            url: e,
                                            previousUrl: r,
                                            wrapperDepth: n,
                                            maxWrapperDepth: t.maxWrapperDepth,
                                            timeout: t.fetchingOptions.timeout,
                                            wrapperAd: i
                                        }), t.urlHandler.get(e, t.fetchingOptions, function(i, u) {
                                            var l = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, c = Math.round(Date.now() - s1), d = Object.assign({
                                                url: e,
                                                previousUrl: r,
                                                wrapperDepth: n,
                                                error: i,
                                                duration: c
                                            }, l);
                                            t.emit("VAST-resolved", d), oe(l.byteLength, c), i ? o(i) : a1(u);
                                        });
                                    });
                                }
                            },
                            {
                                key: "initParsingStatus",
                                value: function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    this.errorURLTemplates = [], this.fetchingOptions = {
                                        timeout: e.timeout || Z,
                                        withCredentials: e.withCredentials
                                    }, this.maxWrapperDepth = e.wrapperLimit || 10, this.parentURLs = [], this.parsingOptions = {
                                        allowMultipleAds: e.allowMultipleAds
                                    }, this.remainingAds = [], this.rootErrorURLTemplates = [], this.rootURL = "", this.urlHandler = e.urlHandler || e.urlhandler || re, this.vastVersion = null, oe(e.byteLength, e.requestDuration);
                                }
                            },
                            {
                                key: "getRemainingAds",
                                value: function(e) {
                                    var t = this;
                                    if (0 === this.remainingAds.length) return Promise.reject(new Error("No more ads are available for the given VAST"));
                                    var n = e ? I.flatten(this.remainingAds) : this.remainingAds.shift();
                                    return this.errorURLTemplates = [], this.parentURLs = [], this.resolveAds(n, {
                                        wrapperDepth: 0,
                                        url: this.rootURL
                                    }).then(function(e) {
                                        return t.buildVASTResponse(e);
                                    });
                                }
                            },
                            {
                                key: "getAndParseVAST",
                                value: function(e) {
                                    var t = this, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                    return this.initParsingStatus(n), this.URLTemplateFilters.forEach(function(t) {
                                        e = t(e);
                                    }), this.rootURL = e, this.fetchVAST(e).then(function(r) {
                                        return n.previousUrl = e, n.isRootVAST = !0, n.url = e, t.parse(r, n).then(function(e) {
                                            return t.buildVASTResponse(e);
                                        });
                                    });
                                }
                            },
                            {
                                key: "parseVAST",
                                value: function(e) {
                                    var t = this, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                    return this.initParsingStatus(n), n.isRootVAST = !0, this.parse(e, n).then(function(e) {
                                        return t.buildVASTResponse(e);
                                    });
                                }
                            },
                            {
                                key: "buildVASTResponse",
                                value: function(e) {
                                    var t, n = {
                                        ads: (t = {
                                            ads: e,
                                            errorURLTemplates: this.getErrorURLTemplates(),
                                            version: this.vastVersion
                                        }).ads || [],
                                        errorURLTemplates: t.errorURLTemplates || [],
                                        version: t.version || null
                                    };
                                    return this.completeWrapperResolving(n), n;
                                }
                            },
                            {
                                key: "parseVastXml",
                                value: function(e, t) {
                                    var n = t.isRootVAST, r = void 0 !== n && n, i = t.url, a1 = void 0 === i ? null : i, o = t.wrapperDepth, s1 = void 0 === o ? 0 : o, u = t.allowMultipleAds, l = t.followAdditionalWrappers;
                                    if (!e || !e.documentElement || "VAST" !== e.documentElement.nodeName) throw this.emit("VAST-ad-parsed", {
                                        type: "ERROR",
                                        url: a1,
                                        wrapperDepth: s1
                                    }), new Error("Invalid VAST XMLDocument");
                                    var c = [], d = e.documentElement.childNodes, f = e.documentElement.getAttribute("version");
                                    for(var h in r && f && (this.vastVersion = f), d){
                                        var g = d[h];
                                        if ("Error" === g.nodeName) {
                                            var p = C.parseNodeText(g);
                                            r ? this.rootErrorURLTemplates.push(p) : this.errorURLTemplates.push(p);
                                        } else if ("Ad" === g.nodeName) {
                                            if (this.vastVersion && parseFloat(this.vastVersion) < 3) u = !0;
                                            else if (!1 === u && c.length > 1) break;
                                            var m = V(g, this.emit.bind(this), {
                                                allowMultipleAds: u,
                                                followAdditionalWrappers: l
                                            });
                                            m.ad ? (c.push(m.ad), this.emit("VAST-ad-parsed", {
                                                type: m.type,
                                                url: a1,
                                                wrapperDepth: s1,
                                                adIndex: c.length - 1,
                                                vastVersion: f
                                            })) : this.trackVastError(this.getErrorURLTemplates(), {
                                                ERRORCODE: 101
                                            });
                                        }
                                    }
                                    return c;
                                }
                            },
                            {
                                key: "parse",
                                value: function(e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = t.url, r = void 0 === n ? null : n, i = t.resolveAll, a1 = void 0 === i || i, o = t.wrapperSequence, s1 = void 0 === o ? null : o, u = t.previousUrl, l = void 0 === u ? null : u, c = t.wrapperDepth, d = void 0 === c ? 0 : c, f = t.isRootVAST, h = void 0 !== f && f, g = t.followAdditionalWrappers, p = t.allowMultipleAds, m = [];
                                    this.vastVersion && parseFloat(this.vastVersion) < 3 && h && (p = !0);
                                    try {
                                        m = this.parseVastXml(e, {
                                            isRootVAST: h,
                                            url: r,
                                            wrapperDepth: d,
                                            allowMultipleAds: p,
                                            followAdditionalWrappers: g
                                        });
                                    } catch (e) {
                                        return Promise.reject(e);
                                    }
                                    return 1 === m.length && null != s1 && (m[0].sequence = s1), !1 === a1 && (this.remainingAds = C.splitVAST(m), m = this.remainingAds.shift()), this.resolveAds(m, {
                                        wrapperDepth: d,
                                        previousUrl: l,
                                        url: r
                                    });
                                }
                            },
                            {
                                key: "resolveAds",
                                value: function() {
                                    var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], n = arguments.length > 1 ? arguments[1] : void 0, r = n.wrapperDepth, i = n.previousUrl, a1 = n.url, o = [];
                                    return i = a1, t.forEach(function(t) {
                                        var n = e.resolveWrappers(t, r, i);
                                        o.push(n);
                                    }), Promise.all(o).then(function(t) {
                                        var n = I.flatten(t);
                                        if (!n && e.remainingAds.length > 0) {
                                            var o = e.remainingAds.shift();
                                            return e.resolveAds(o, {
                                                wrapperDepth: r,
                                                previousUrl: i,
                                                url: a1
                                            });
                                        }
                                        return n;
                                    });
                                }
                            },
                            {
                                key: "resolveWrappers",
                                value: function(e, t, n) {
                                    var r = this;
                                    return new Promise(function(i) {
                                        var a1;
                                        if (t++, !e.nextWrapperURL) return delete e.nextWrapperURL, i(e);
                                        if (t >= r.maxWrapperDepth || -1 !== r.parentURLs.indexOf(e.nextWrapperURL)) return e.errorCode = 302, delete e.nextWrapperURL, i(e);
                                        e.nextWrapperURL = C.resolveVastAdTagURI(e.nextWrapperURL, n), r.URLTemplateFilters.forEach(function(t) {
                                            e.nextWrapperURL = t(e.nextWrapperURL);
                                        });
                                        var o = null !== (a1 = r.parsingOptions.allowMultipleAds) && void 0 !== a1 ? a1 : e.allowMultipleAds, s1 = e.sequence;
                                        r.fetchVAST(e.nextWrapperURL, t, n, e).then(function(a1) {
                                            return r.parse(a1, {
                                                url: e.nextWrapperURL,
                                                previousUrl: n,
                                                wrapperSequence: s1,
                                                wrapperDepth: t,
                                                followAdditionalWrappers: e.followAdditionalWrappers,
                                                allowMultipleAds: o
                                            }).then(function(t) {
                                                if (delete e.nextWrapperURL, 0 === t.length) return e.creatives = [], i(e);
                                                t.forEach(function(t) {
                                                    t && C.mergeWrapperAdData(t, e);
                                                }), i(t);
                                            });
                                        }).catch(function(t) {
                                            e.errorCode = 301, e.errorMessage = t.message, i(e);
                                        });
                                    });
                                }
                            },
                            {
                                key: "completeWrapperResolving",
                                value: function(e) {
                                    if (0 === e.ads.length) this.trackVastError(e.errorURLTemplates, {
                                        ERRORCODE: 303
                                    });
                                    else for(var t = e.ads.length - 1; t >= 0; t--){
                                        var n = e.ads[t];
                                        (n.errorCode || 0 === n.creatives.length) && (this.trackVastError(n.errorURLTemplates.concat(e.errorURLTemplates), {
                                            ERRORCODE: n.errorCode || 303
                                        }, {
                                            ERRORMESSAGE: n.errorMessage || ""
                                        }, {
                                            extensions: n.extensions
                                        }, {
                                            system: n.system
                                        }), e.ads.splice(t, 1));
                                    }
                                }
                            }
                        ]), n;
                    }(Q), le = null, ce = {
                        data: {},
                        length: 0,
                        getItem: function(e) {
                            return this.data[e];
                        },
                        setItem: function(e, t) {
                            this.data[e] = t, this.length = Object.keys(this.data).length;
                        },
                        removeItem: function(e) {
                            delete this.data[e], this.length = Object.keys(this.data).length;
                        },
                        clear: function() {
                            this.data = {}, this.length = 0;
                        }
                    }, de = function() {
                        function e() {
                            i(this, e), this.storage = this.initStorage();
                        }
                        return o(e, [
                            {
                                key: "initStorage",
                                value: function() {
                                    if (le) return le;
                                    try {
                                        le = "undefined" != typeof window && null !== window ? window.localStorage || window.sessionStorage : null;
                                    } catch (e) {
                                        le = null;
                                    }
                                    return le && !this.isStorageDisabled(le) || (le = ce).clear(), le;
                                }
                            },
                            {
                                key: "isStorageDisabled",
                                value: function(e) {
                                    var t = "__VASTStorage__";
                                    try {
                                        if (e.setItem(t, t), e.getItem(t) !== t) return e.removeItem(t), !0;
                                    } catch (e) {
                                        return !0;
                                    }
                                    return e.removeItem(t), !1;
                                }
                            },
                            {
                                key: "getItem",
                                value: function(e) {
                                    return this.storage.getItem(e);
                                }
                            },
                            {
                                key: "setItem",
                                value: function(e, t) {
                                    return this.storage.setItem(e, t);
                                }
                            },
                            {
                                key: "removeItem",
                                value: function(e) {
                                    return this.storage.removeItem(e);
                                }
                            },
                            {
                                key: "clear",
                                value: function() {
                                    return this.storage.clear();
                                }
                            }
                        ]), e;
                    }(), fe = function() {
                        function e(t, n, r) {
                            i(this, e), this.cappingFreeLunch = t || 0, this.cappingMinimumTimeInterval = n || 0, this.defaultOptions = {
                                withCredentials: !1,
                                timeout: 0
                            }, this.vastParser = new ue, this.storage = r || new de, void 0 === this.lastSuccessfulAd && (this.lastSuccessfulAd = 0), void 0 === this.totalCalls && (this.totalCalls = 0), void 0 === this.totalCallsTimeout && (this.totalCallsTimeout = 0);
                        }
                        return o(e, [
                            {
                                key: "getParser",
                                value: function() {
                                    return this.vastParser;
                                }
                            },
                            {
                                key: "lastSuccessfulAd",
                                get: function() {
                                    return this.storage.getItem("vast-client-last-successful-ad");
                                },
                                set: function(e) {
                                    this.storage.setItem("vast-client-last-successful-ad", e);
                                }
                            },
                            {
                                key: "totalCalls",
                                get: function() {
                                    return this.storage.getItem("vast-client-total-calls");
                                },
                                set: function(e) {
                                    this.storage.setItem("vast-client-total-calls", e);
                                }
                            },
                            {
                                key: "totalCallsTimeout",
                                get: function() {
                                    return this.storage.getItem("vast-client-total-calls-timeout");
                                },
                                set: function(e) {
                                    this.storage.setItem("vast-client-total-calls-timeout", e);
                                }
                            },
                            {
                                key: "hasRemainingAds",
                                value: function() {
                                    return this.vastParser.remainingAds.length > 0;
                                }
                            },
                            {
                                key: "getNextAds",
                                value: function(e) {
                                    return this.vastParser.getRemainingAds(e);
                                }
                            },
                            {
                                key: "get",
                                value: function(e) {
                                    var t = this, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = Date.now();
                                    return (n = Object.assign({}, this.defaultOptions, n)).hasOwnProperty("resolveAll") || (n.resolveAll = !1), this.totalCallsTimeout < r ? (this.totalCalls = 1, this.totalCallsTimeout = r + 36e5) : this.totalCalls++, new Promise(function(i, a1) {
                                        if (t.cappingFreeLunch >= t.totalCalls) return a1(new Error("VAST call canceled \u2013 FreeLunch capping not reached yet ".concat(t.totalCalls, "/").concat(t.cappingFreeLunch)));
                                        var o = r - t.lastSuccessfulAd;
                                        if (o < 0) t.lastSuccessfulAd = 0;
                                        else if (o < t.cappingMinimumTimeInterval) return a1(new Error("VAST call canceled \u2013 (".concat(t.cappingMinimumTimeInterval, ")ms minimum interval reached")));
                                        t.vastParser.getAndParseVAST(e, n).then(function(e) {
                                            return i(e);
                                        }).catch(function(e) {
                                            return a1(e);
                                        });
                                    });
                                }
                            }
                        ]), e;
                    }(), he = function(e) {
                        u(r, e);
                        var t = f(r);
                        function r(e, n, a1) {
                            var o, s1 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
                            for(var u in i(this, r), (o = t.call(this)).ad = n, o.creative = a1, o.variation = s1, o.muted = !1, o.impressed = !1, o.skippable = !1, o.trackingEvents = {}, o.lastPercentage = 0, o._alreadyTriggeredQuartiles = {}, o.emitAlwaysEvents = [
                                "creativeView",
                                "start",
                                "firstQuartile",
                                "midpoint",
                                "thirdQuartile",
                                "complete",
                                "resume",
                                "pause",
                                "rewind",
                                "skip",
                                "closeLinear",
                                "close"
                            ], o.creative.trackingEvents){
                                var l = o.creative.trackingEvents[u];
                                o.trackingEvents[u] = l.slice(0);
                            }
                            return k(o.creative) ? o._initLinearTracking() : o._initVariationTracking(), e && o.on("start", function() {
                                e.lastSuccessfulAd = Date.now();
                            }), o;
                        }
                        return o(r, [
                            {
                                key: "_initLinearTracking",
                                value: function() {
                                    this.linear = !0, this.skipDelay = this.creative.skipDelay, this.setDuration(this.creative.duration), this.clickThroughURLTemplate = this.creative.videoClickThroughURLTemplate, this.clickTrackingURLTemplates = this.creative.videoClickTrackingURLTemplates;
                                }
                            },
                            {
                                key: "_initVariationTracking",
                                value: function() {
                                    if (this.linear = !1, this.skipDelay = -1, this.variation) {
                                        for(var e in this.variation.trackingEvents){
                                            var t = this.variation.trackingEvents[e];
                                            this.trackingEvents[e] ? this.trackingEvents[e] = this.trackingEvents[e].concat(t.slice(0)) : this.trackingEvents[e] = t.slice(0);
                                        }
                                        "nonLinearAd" === this.variation.adType ? (this.clickThroughURLTemplate = this.variation.nonlinearClickThroughURLTemplate, this.clickTrackingURLTemplates = this.variation.nonlinearClickTrackingURLTemplates, this.setDuration(this.variation.minSuggestedDuration)) : function(e) {
                                            return "companionAd" === e.adType;
                                        }(this.variation) && (this.clickThroughURLTemplate = this.variation.companionClickThroughURLTemplate, this.clickTrackingURLTemplates = this.variation.companionClickTrackingURLTemplates);
                                    }
                                }
                            },
                            {
                                key: "setDuration",
                                value: function(e) {
                                    this.assetDuration = e, this.quartiles = {
                                        firstQuartile: Math.round(25 * this.assetDuration) / 100,
                                        midpoint: Math.round(50 * this.assetDuration) / 100,
                                        thirdQuartile: Math.round(75 * this.assetDuration) / 100
                                    };
                                }
                            },
                            {
                                key: "setProgress",
                                value: function(e) {
                                    var t = this, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = this.skipDelay || -1;
                                    if (-1 === r || this.skippable || (r > e ? this.emit("skip-countdown", r - e) : (this.skippable = !0, this.emit("skip-countdown", 0))), this.assetDuration > 0) {
                                        var i = Math.round(e / this.assetDuration * 100), a1 = [];
                                        if (e > 0) {
                                            a1.push("start");
                                            for(var o = this.lastPercentage; o < i; o++)a1.push("progress-".concat(o + 1, "%"));
                                            for(var s1 in a1.push("progress-".concat(Math.round(e))), this.quartiles)this.isQuartileReached(s1, this.quartiles[s1], e) && (a1.push(s1), this._alreadyTriggeredQuartiles[s1] = !0);
                                            this.lastPercentage = i;
                                        }
                                        a1.forEach(function(e) {
                                            t.track(e, {
                                                macros: n,
                                                once: !0
                                            });
                                        }), e < this.progress && this.track("rewind", {
                                            macros: n
                                        });
                                    }
                                    this.progress = e;
                                }
                            },
                            {
                                key: "isQuartileReached",
                                value: function(e, t, n) {
                                    var r = !1;
                                    return t <= n && !this._alreadyTriggeredQuartiles[e] && (r = !0), r;
                                }
                            },
                            {
                                key: "setMuted",
                                value: function(e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                    this.muted !== e && this.track(e ? "mute" : "unmute", {
                                        macros: t
                                    }), this.muted = e;
                                }
                            },
                            {
                                key: "setPaused",
                                value: function(e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                    this.paused !== e && this.track(e ? "pause" : "resume", {
                                        macros: t
                                    }), this.paused = e;
                                }
                            },
                            {
                                key: "setFullscreen",
                                value: function(e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                    this.fullscreen !== e && this.track(e ? "fullscreen" : "exitFullscreen", {
                                        macros: t
                                    }), this.fullscreen = e;
                                }
                            },
                            {
                                key: "setExpand",
                                value: function(e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                    this.expanded !== e && (this.track(e ? "expand" : "collapse", {
                                        macros: t
                                    }), this.track(e ? "playerExpand" : "playerCollapse", {
                                        macros: t
                                    })), this.expanded = e;
                                }
                            },
                            {
                                key: "setSkipDelay",
                                value: function(e) {
                                    "number" == typeof e && (this.skipDelay = e);
                                }
                            },
                            {
                                key: "trackImpression",
                                value: function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    this.impressed || (this.impressed = !0, this.trackURLs(this.ad.impressionURLTemplates, e), this.track("creativeView", {
                                        macros: e
                                    }));
                                }
                            },
                            {
                                key: "error",
                                value: function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                                    this.trackURLs(this.ad.errorURLTemplates, e, {
                                        isCustomCode: t
                                    });
                                }
                            },
                            {
                                key: "errorWithCode",
                                value: function(e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                                    this.error({
                                        ERRORCODE: e
                                    }, t), console.log("The method errorWithCode is deprecated, please use vast tracker error method instead");
                                }
                            },
                            {
                                key: "complete",
                                value: function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    this.track("complete", {
                                        macros: e
                                    });
                                }
                            },
                            {
                                key: "notUsed",
                                value: function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    this.track("notUsed", {
                                        macros: e
                                    }), this.trackingEvents = [];
                                }
                            },
                            {
                                key: "otherAdInteraction",
                                value: function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    this.track("otherAdInteraction", {
                                        macros: e
                                    });
                                }
                            },
                            {
                                key: "acceptInvitation",
                                value: function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    this.track("acceptInvitation", {
                                        macros: e
                                    });
                                }
                            },
                            {
                                key: "adExpand",
                                value: function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    this.track("adExpand", {
                                        macros: e
                                    });
                                }
                            },
                            {
                                key: "adCollapse",
                                value: function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    this.track("adCollapse", {
                                        macros: e
                                    });
                                }
                            },
                            {
                                key: "minimize",
                                value: function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    this.track("minimize", {
                                        macros: e
                                    });
                                }
                            },
                            {
                                key: "verificationNotExecuted",
                                value: function(e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                    if (!this.ad || !this.ad.adVerifications || !this.ad.adVerifications.length) throw new Error("No adVerifications provided");
                                    if (!e) throw new Error("No vendor provided, unable to find associated verificationNotExecuted");
                                    var n = this.ad.adVerifications.find(function(t) {
                                        return t.vendor === e;
                                    });
                                    if (!n) throw new Error("No associated verification element found for vendor: ".concat(e));
                                    var r = n.trackingEvents;
                                    if (r && r.verificationNotExecuted) {
                                        var i = r.verificationNotExecuted;
                                        this.trackURLs(i, t), this.emit("verificationNotExecuted", {
                                            trackingURLTemplates: i
                                        });
                                    }
                                }
                            },
                            {
                                key: "overlayViewDuration",
                                value: function(e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                    t.ADPLAYHEAD = e, this.track("overlayViewDuration", {
                                        macros: t
                                    });
                                }
                            },
                            {
                                key: "close",
                                value: function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    this.track(this.linear ? "closeLinear" : "close", {
                                        macros: e
                                    });
                                }
                            },
                            {
                                key: "skip",
                                value: function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    this.track("skip", {
                                        macros: e
                                    });
                                }
                            },
                            {
                                key: "load",
                                value: function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    this.track("loaded", {
                                        macros: e
                                    });
                                }
                            },
                            {
                                key: "click",
                                value: function() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                    this.clickTrackingURLTemplates && this.clickTrackingURLTemplates.length && this.trackURLs(this.clickTrackingURLTemplates, t);
                                    var r = this.clickThroughURLTemplate || e, i = n({}, t);
                                    if (r) {
                                        this.progress && (i.ADPLAYHEAD = this.progressFormatted());
                                        var a1 = I.resolveURLTemplates([
                                            r
                                        ], i)[0];
                                        this.emit("clickthrough", a1);
                                    }
                                }
                            },
                            {
                                key: "track",
                                value: function(e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = t.macros, r = void 0 === n ? {} : n, i = t.once, a1 = void 0 !== i && i;
                                    "closeLinear" === e && !this.trackingEvents[e] && this.trackingEvents.close && (e = "close");
                                    var o = this.trackingEvents[e], s1 = this.emitAlwaysEvents.indexOf(e) > -1;
                                    o ? (this.emit(e, {
                                        trackingURLTemplates: o
                                    }), this.trackURLs(o, r)) : s1 && this.emit(e, null), a1 && (delete this.trackingEvents[e], s1 && this.emitAlwaysEvents.splice(this.emitAlwaysEvents.indexOf(e), 1));
                                }
                            },
                            {
                                key: "trackURLs",
                                value: function(e) {
                                    var t, r, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, a1 = n({}, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {});
                                    this.linear && (this.creative && this.creative.mediaFiles && this.creative.mediaFiles[0] && this.creative.mediaFiles[0].fileURL && (a1.ASSETURI = this.creative.mediaFiles[0].fileURL), this.progress && (a1.ADPLAYHEAD = this.progressFormatted())), null !== (t = this.creative) && void 0 !== t && null !== (r = t.universalAdIds) && void 0 !== r && r.length && (a1.UNIVERSALADID = this.creative.universalAdIds.map(function(e) {
                                        return e.idRegistry.concat(" ", e.value);
                                    }).join(",")), this.ad && (this.ad.sequence && (a1.PODSEQUENCE = this.ad.sequence), this.ad.adType && (a1.ADTYPE = this.ad.adType), this.ad.adServingId && (a1.ADSERVINGID = this.ad.adServingId), this.ad.categories && this.ad.categories.length && (a1.ADCATEGORIES = this.ad.categories.map(function(e) {
                                        return e.value;
                                    }).join(",")), this.ad.blockedAdCategories && this.ad.blockedAdCategories.length && (a1.BLOCKEDADCATEGORIES = this.ad.blockedAdCategories)), I.track(e, a1, i);
                                }
                            },
                            {
                                key: "convertToTimecode",
                                value: function(e) {
                                    var t = 1e3 * e, n = Math.floor(t / 36e5), r = Math.floor(t / 6e4 % 60), i = Math.floor(t / 1e3 % 60), a1 = Math.floor(t % 1e3);
                                    return "".concat(I.leftpad(n, 2), ":").concat(I.leftpad(r, 2), ":").concat(I.leftpad(i, 2), ".").concat(I.leftpad(a1, 3));
                                }
                            },
                            {
                                key: "progressFormatted",
                                value: function() {
                                    return this.convertToTimecode(this.progress);
                                }
                            }
                        ]), r;
                    }(Q);
                    e.VASTClient = fe, e.VASTParser = ue, e.VASTTracker = he, Object.defineProperty(e, "__esModule", {
                        value: !0
                    });
                }(t);
            },
            749: (e, t, n)=>{
                "use strict";
                n.r(t), n.d(t, {
                    default: ()=>s1
                });
                const r = class {
                    constructor(e){
                        this.id = e.getAttribute("id"), this.allowMultipleAds = e.getAttribute("allowMultipleAds"), this.followRedirects = e.getAttribute("followRedirects"), this.vastAdData = null, this.adTagURI = null, this.customData = null;
                        for(const t in e.childNodes){
                            const n = e.childNodes[t];
                            switch(n.localName){
                                case "AdTagURI":
                                    this.adTagURI = {
                                        templateType: n.getAttribute("templateType"),
                                        uri: (n.textContent || n.text || "").trim()
                                    };
                                    break;
                                case "VASTAdData":
                                    for(this.vastAdData = n.firstChild; this.vastAdData && 1 !== this.vastAdData.nodeType;)this.vastAdData = this.vastAdData.nextSibling;
                                    break;
                                case "CustomAdData":
                                    this.customData = n;
                            }
                        }
                    }
                };
                function i(e, t) {
                    const n = [];
                    for(const r in e.childNodes){
                        const i = e.childNodes[r];
                        i.nodeName !== t && t !== `vmap:${i.nodeName}` && i.nodeName !== `vmap:${t}` || n.push(i);
                    }
                    return n;
                }
                function a1(e) {
                    const t = {
                        attributes: {},
                        children: {},
                        value: {}
                    };
                    t.value = function(e) {
                        if (!e || !e.childNodes) return {};
                        const t = e.childNodes, n = [];
                        for(const e in t){
                            const r = t[e];
                            "#cdata-section" === r.nodeName && n.push(r);
                        }
                        if (n && n.length > 0) try {
                            return JSON.parse(n[0].data);
                        } catch (e) {}
                        let r = "";
                        for(const e in t){
                            const n = t[e];
                            switch(n.nodeName){
                                case "#text":
                                    r += n.textContent.trim();
                                    break;
                                case "#cdata-section":
                                    r += n.data;
                            }
                        }
                        return r;
                    }(e);
                    const n = e.attributes;
                    if (n) for(const e in n){
                        const r = n[e];
                        r.nodeName && void 0 !== r.nodeValue && null !== r.nodeValue && (t.attributes[r.nodeName] = r.nodeValue);
                    }
                    const r = e.childNodes;
                    if (r) for(const e in r){
                        const n = r[e];
                        n.nodeName && "#" !== n.nodeName.substring(0, 1) && (t.children[n.nodeName] = a1(n));
                    }
                    return t;
                }
                const o = class {
                    constructor(e){
                        this.timeOffset = e.getAttribute("timeOffset"), this.breakType = e.getAttribute("breakType"), this.breakId = e.getAttribute("breakId"), this.repeatAfter = e.getAttribute("repeatAfter"), this.adSource = null, this.trackingEvents = [], this.extensions = [];
                        for(const t in e.childNodes){
                            const n = e.childNodes[t];
                            switch(n.localName){
                                case "AdSource":
                                    this.adSource = new r(n);
                                    break;
                                case "TrackingEvents":
                                    for(const e in n.childNodes){
                                        const t = n.childNodes[e];
                                        "Tracking" === t.localName && this.trackingEvents.push({
                                            event: t.getAttribute("event"),
                                            uri: (t.textContent || t.text || "").trim()
                                        });
                                    }
                                    break;
                                case "Extensions":
                                    this.extensions = i(n, "Extension").map((e)=>a1(e));
                            }
                        }
                    }
                    track(e, t) {
                        for(const n in this.trackingEvents){
                            const r = this.trackingEvents[n];
                            if (r.event === e) {
                                let { uri: e } = r;
                                "error" === r.event && (e = e.replace("[ERRORCODE]", t)), this.tracker(e);
                            }
                        }
                    }
                    tracker(e) {
                        "undefined" != typeof window && null !== window && ((new Image).src = e);
                    }
                }, s1 = class {
                    constructor(e){
                        if (!e || !e.documentElement || "VMAP" !== e.documentElement.localName) throw new Error("Not a VMAP document");
                        this.version = e.documentElement.getAttribute("version"), this.adBreaks = [], this.extensions = [];
                        for(const t in e.documentElement.childNodes){
                            const n = e.documentElement.childNodes[t];
                            switch(n.localName){
                                case "AdBreak":
                                    this.adBreaks.push(new o(n));
                                    break;
                                case "Extensions":
                                    this.extensions = i(n, "Extension").map((e)=>a1(e));
                            }
                        }
                    }
                };
            },
            974: (e, t, n)=>{
                var r = n(171), i = n(575), a1 = n(749), o = n(118);
                function s1(e, t, n, r) {
                    Object.defineProperty(e, t, {
                        get: n,
                        set: r,
                        enumerable: !0,
                        configurable: !0
                    });
                }
                function u(e) {
                    return e && e.__esModule ? e.default : e;
                }
                s1(e.exports, "AdBreakTrackingEvent", ()=>d), s1(e.exports, "AdTrackingEvent", ()=>c);
                var l = {};
                s1(l, "CSAIManager", ()=>D, (e)=>D = e);
                var c, d, f, h, g, p = {};
                function m(e) {
                    for(var t = e.split(":"), n = 0, r = 1; t.length > 0;)n += r * parseInt(t.pop(), 10), r *= 60;
                    return n;
                }
                s1(p, "AdServerService", ()=>S, (e)=>S = e), function(e) {
                    e.START = "start", e.IMPRESSION = "impression", e.EXPAND = "expand", e.MUTE = "mute", e.UNMUTE = "unmute", e.PAUSE = "pause", e.RESUME = "resume", e.REWIND = "rewind", e.CLOSE = "close", e.COMPLETE = "complete", e.FIRST_QUARTILE = "firstQuartile", e.MIDPOINT = "midpoint", e.THIRD_QUARTILE = "thirdQuartile", e.CLICK_THROUGH = "clickThrough", e.ERROR = "error";
                }(c || (c = {})), function(e) {
                    e.BREAK_START = "breakStart", e.BREAK_END = "breakEnd";
                }(d || (d = {})), function(e) {
                    e.ClientSide = "csai", e.ServerSide = "ssai";
                }(f || (f = {})), function(e) {
                    e.Preroll = "preroll", e.Midroll = "midroll", e.Postroll = "postroll";
                }(h || (h = {})), function(e) {
                    e.NORMAL = "NORMAL", e.SPONSOR = "BUMPER", e.VIGNETTE = "VIGNETTE", e.TRAILER = "TRAILER";
                }(g || (g = {}));
                var v, y, E, T = function() {
                    return T = Object.assign || function(e) {
                        for(var t, n = 1, r = arguments.length; n < r; n++)for(var i in t = arguments[n])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                        return e;
                    }, T.apply(this, arguments);
                }, b = function(e, t, n, r) {
                    return new (n || (n = Promise))(function(i, a1) {
                        function o(e) {
                            try {
                                u(r.next(e));
                            } catch (e) {
                                a1(e);
                            }
                        }
                        function s1(e) {
                            try {
                                u(r.throw(e));
                            } catch (e) {
                                a1(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(o, s1);
                        }
                        u((r = r.apply(e, t || [])).next());
                    });
                }, A = function(e, t) {
                    var n, r, i, a1, o = {
                        label: 0,
                        sent: function() {
                            if (1 & i[0]) throw i[1];
                            return i[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return a1 = {
                        next: s1(0),
                        throw: s1(1),
                        return: s1(2)
                    }, "function" == typeof Symbol && (a1[Symbol.iterator] = function() {
                        return this;
                    }), a1;
                    function s1(a1) {
                        return function(s1) {
                            return function(a1) {
                                if (n) throw new TypeError("Generator is already executing.");
                                for(; o;)try {
                                    if (n = 1, r && (i = 2 & a1[0] ? r.return : a1[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, a1[1])).done) return i;
                                    switch(r = 0, i && (a1 = [
                                        2 & a1[0],
                                        i.value
                                    ]), a1[0]){
                                        case 0:
                                        case 1:
                                            i = a1;
                                            break;
                                        case 4:
                                            return o.label++, {
                                                value: a1[1],
                                                done: !1
                                            };
                                        case 5:
                                            o.label++, r = a1[1], a1 = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            a1 = o.ops.pop(), o.trys.pop();
                                            continue;
                                        default:
                                            if (!((i = (i = o.trys).length > 0 && i[i.length - 1]) || 6 !== a1[0] && 2 !== a1[0])) {
                                                o = 0;
                                                continue;
                                            }
                                            if (3 === a1[0] && (!i || a1[1] > i[0] && a1[1] < i[3])) {
                                                o.label = a1[1];
                                                break;
                                            }
                                            if (6 === a1[0] && o.label < i[1]) {
                                                o.label = i[1], i = a1;
                                                break;
                                            }
                                            if (i && o.label < i[2]) {
                                                o.label = i[2], o.ops.push(a1);
                                                break;
                                            }
                                            i[2] && o.ops.pop(), o.trys.pop();
                                            continue;
                                    }
                                    a1 = t.call(e, o);
                                } catch (e) {
                                    a1 = [
                                        6,
                                        e
                                    ], r = 0;
                                } finally{
                                    n = i = 0;
                                }
                                if (5 & a1[0]) throw a1[1];
                                return {
                                    value: a1[0] ? a1[1] : void 0,
                                    done: !0
                                };
                            }([
                                a1,
                                s1
                            ]);
                        };
                    }
                }, _ = function(e, t, n) {
                    if (n || 2 === arguments.length) for(var r, i = 0, a1 = t.length; i < a1; i++)!r && i in t || (r || (r = Array.prototype.slice.call(t, 0, i)), r[i] = t[i]);
                    return e.concat(r || Array.prototype.slice.call(t));
                }, S = function() {
                    function e(e) {
                        void 0 === e && (e = !1), this.debug = !1, this.estimatedBandwidth = 500, this.debug = !!e, this.vastParser = new i.VASTParser;
                    }
                    return e.prototype.getVMAP = function(e) {
                        return b(this, void 0, Promise, function() {
                            var t, n;
                            return A(this, function(r) {
                                switch(r.label){
                                    case 0:
                                        return this.debug && console.debug("[CSAIManager] getVMAP", e), [
                                            4,
                                            this.fetchAdsVMAP(e)
                                        ];
                                    case 1:
                                        return t = r.sent(), [
                                            4,
                                            this.resolveAds(t)
                                        ];
                                    case 2:
                                        return n = r.sent(), this.debug && console.debug("[CSAIManager] resolved VMAP to ad breaks", n), [
                                            2,
                                            n
                                        ];
                                }
                            });
                        });
                    }, e.prototype.getVASTs = function(e) {
                        return b(this, void 0, Promise, function() {
                            var t, n, r, i, a1, o;
                            return A(this, function(s1) {
                                switch(s1.label){
                                    case 0:
                                        this.debug && console.debug("[CSAIManager] getVASTs", e), t = [], n = 0, r = e, s1.label = 1;
                                    case 1:
                                        return n < r.length ? (i = r[n], [
                                            4,
                                            this.vastParser.getAndParseVAST(i.vastUrl)
                                        ]) : [
                                            3,
                                            4
                                        ];
                                    case 2:
                                        if (!(a1 = s1.sent())) return [
                                            2
                                        ];
                                        o = a1.ads, t.push(this.mapAdBreakObject({
                                            timeOffset: i.timeOffset.toString()
                                        }, o)), s1.label = 3;
                                    case 3:
                                        return n++, [
                                            3,
                                            1
                                        ];
                                    case 4:
                                        return this.debug && console.debug("[CSAIManager] resolved VAST to ad break", t), [
                                            2,
                                            t
                                        ];
                                }
                            });
                        });
                    }, e.prototype.getVast = function(e) {
                        return b(this, void 0, Promise, function() {
                            var t, n, r;
                            return A(this, function(i) {
                                switch(i.label){
                                    case 0:
                                        return this.debug && console.debug("[CSAIManager] get vast", e), [
                                            4,
                                            this.vastParser.getAndParseVAST(e)
                                        ];
                                    case 1:
                                        return (t = i.sent()) ? (n = t.ads, r = this.mapAdBreakObject({
                                            timeOffset: "100"
                                        }, n), this.debug && console.debug("[CSAIManager] resolved vast to ad break", r), [
                                            2,
                                            r
                                        ]) : [
                                            2
                                        ];
                                }
                            });
                        });
                    }, e.prototype.fetchAdsVMAP = function(e) {
                        return b(this, void 0, Promise, function() {
                            var t, n, r;
                            return A(this, function(i) {
                                switch(i.label){
                                    case 0:
                                        return [
                                            4,
                                            fetch(e)
                                        ];
                                    case 1:
                                        return [
                                            4,
                                            i.sent().text()
                                        ];
                                    case 2:
                                        return t = i.sent(), n = new DOMParser, r = n.parseFromString(t, "text/xml"), [
                                            2,
                                            new (u(a1))(r)
                                        ];
                                }
                            });
                        });
                    }, e.prototype.resolveAds = function(e) {
                        var t;
                        return b(this, void 0, Promise, function() {
                            var n, r, i, a1, o, s1, u;
                            return A(this, function(l) {
                                switch(l.label){
                                    case 0:
                                        n = [], r = 0, i = e.adBreaks, l.label = 1;
                                    case 1:
                                        return r < i.length ? "linear" !== (a1 = i[r]).breakType ? [
                                            2,
                                            n
                                        ] : (o = null === (t = a1.adSource) || void 0 === t ? void 0 : t.vastAdData, s1 = [], o ? (u = {
                                            isRootVAST: !0,
                                            timeout: 1e4,
                                            withCredentials: !0,
                                            wrapperLimit: 10,
                                            followAdditionalWrappers: !0
                                        }, this.vastParser.initParsingStatus(u), [
                                            4,
                                            this.vastParser.parseVAST({
                                                documentElement: o
                                            }, u)
                                        ]) : [
                                            3,
                                            3
                                        ]) : [
                                            3,
                                            5
                                        ];
                                    case 2:
                                        s1 = l.sent().ads, this.estimatedBandwidth = this.vastParser.getEstimatedBitrate(), l.label = 3;
                                    case 3:
                                        n.push(this.mapAdBreakObject(a1, s1)), l.label = 4;
                                    case 4:
                                        return r++, [
                                            3,
                                            1
                                        ];
                                    case 5:
                                        return [
                                            2,
                                            n
                                        ];
                                }
                            });
                        });
                    }, e.prototype.mapAdBreakObject = function(e, t) {
                        var n, r, i, a1, o = this;
                        return {
                            insertionType: f.ClientSide,
                            breakType: "start" === e.timeOffset || "0" === e.timeOffset ? h.Preroll : h.Midroll,
                            timeOffset: "start" === e.timeOffset || "0" === e.timeOffset ? 0 : m(e.timeOffset),
                            ads: null == t ? void 0 : t.map(function(e) {
                                return o.mapAdsObject(e);
                            }).filter(function(e) {
                                return null !== e;
                            }),
                            trackingEvents: {
                                breakStart: (null === (r = null === (n = e.trackingEvents) || void 0 === n ? void 0 : n.filter(function(e) {
                                    return e.event === d.BREAK_START;
                                })) || void 0 === r ? void 0 : r.map(function(e) {
                                    return e.uri;
                                })) || [],
                                breakEnd: (null === (a1 = null === (i = e.trackingEvents) || void 0 === i ? void 0 : i.filter(function(e) {
                                    return e.event === d.BREAK_END;
                                })) || void 0 === a1 ? void 0 : a1.map(function(e) {
                                    return e.uri;
                                })) || []
                            }
                        };
                    }, e.prototype.mapAdsObject = function(e) {
                        var t, n, r, i, a1, o = this, s1 = e.extensions.find(function(e) {
                            return "AdServer" === e.attributes.type;
                        }), u = (null === (n = null === (t = null == s1 ? void 0 : s1.children.find(function(e) {
                            return "AdInfo" === e.name;
                        })) || void 0 === t ? void 0 : t.attributes) || void 0 === n ? void 0 : n.customaid) || void 0, l = (null === (i = null === (r = null == s1 ? void 0 : s1.children.find(function(e) {
                            return "AdInfo" === e.name;
                        })) || void 0 === r ? void 0 : r.attributes) || void 0 === i ? void 0 : i.variant) || g.NORMAL, c = this.findCreative(e.creatives.map(function(e) {
                            return o.mapCreativeObject(e);
                        }));
                        return c ? {
                            id: e.id,
                            customAdId: u,
                            programmatic: "PROGRAMMATIC" === u,
                            system: null === (a1 = e.system) || void 0 === a1 ? void 0 : a1.value,
                            sequence: e.sequence,
                            title: e.title,
                            variant: l,
                            creative: c,
                            errorUrlTemplates: e.errorURLTemplates,
                            impressionUrlTemplates: e.impressionURLTemplates.map(function(e) {
                                return e.url;
                            })
                        } : null;
                    }, e.prototype.findCreative = function(e) {
                        return e.find(function(e) {
                            return "linear" === e.type && e.mediafiles.length > 0;
                        });
                    }, e.prototype.mapCreativeObject = function(e) {
                        var t, n = this;
                        return {
                            id: e.id,
                            adId: e.adId,
                            type: e.type,
                            duration: e.duration,
                            mediafiles: this.filterMediaFiles(e.mediaFiles.map(function(e) {
                                return n.mapMediaFileObject(e);
                            })),
                            trackingEvents: T((t = {}, t[c.CLICK_THROUGH] = _([], e.videoClickTrackingURLTemplates, !0), t), e.trackingEvents),
                            clickThroughUrlTemplate: e.videoClickThroughURLTemplate
                        };
                    }, e.prototype.filterMediaFiles = function(e) {
                        var t = this, n = e.filter(function(e) {
                            return "video/mp4" === e.mimeType;
                        }), r = n.filter(function(e) {
                            return "video/mp4" === e.mimeType && e.fileUrl.length > 0 && (!e.bitrate || e.bitrate < t.estimatedBandwidth);
                        });
                        return 0 === r.length && (r = n), r.sort(function(e, t) {
                            return e.bitrate && t.bitrate ? e.bitrate - t.bitrate : 0;
                        });
                    }, e.prototype.mapMediaFileObject = function(e) {
                        return {
                            id: e.id,
                            mimeType: e.mimeType,
                            fileUrl: e.fileURL,
                            bitrate: e.bitrate,
                            height: e.height,
                            width: e.width
                        };
                    }, e;
                }(), w = function() {
                    function e() {
                        this.emitter = u(o)();
                    }
                    return e.prototype.on = function(e, t) {
                        this.emitter.on.apply(this, [
                            e,
                            t
                        ]);
                    }, e.prototype.off = function(e, t) {
                        this.emitter && this.emitter.off.apply(this, [
                            e,
                            t
                        ]);
                    }, e.prototype.clear = function() {
                        this.emitter.all.clear();
                    }, e.prototype.emit = function(e, t) {
                        this.emitter && this.emitter.emit.apply(this, [
                            e,
                            t
                        ]);
                    }, e;
                }(), I = (v = function(e, t) {
                    return (v = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(e, t) {
                        e.__proto__ = t;
                    } || function(e, t) {
                        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
                    })(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function n() {
                        this.constructor = e;
                    }
                    v(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
                }), R = function(e, t, n, r) {
                    return new (n || (n = Promise))(function(i, a1) {
                        function o(e) {
                            try {
                                u(r.next(e));
                            } catch (e) {
                                a1(e);
                            }
                        }
                        function s1(e) {
                            try {
                                u(r.throw(e));
                            } catch (e) {
                                a1(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(o, s1);
                        }
                        u((r = r.apply(e, t || [])).next());
                    });
                }, C = function(e, t) {
                    var n, r, i, a1, o = {
                        label: 0,
                        sent: function() {
                            if (1 & i[0]) throw i[1];
                            return i[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return a1 = {
                        next: s1(0),
                        throw: s1(1),
                        return: s1(2)
                    }, "function" == typeof Symbol && (a1[Symbol.iterator] = function() {
                        return this;
                    }), a1;
                    function s1(a1) {
                        return function(s1) {
                            return function(a1) {
                                if (n) throw new TypeError("Generator is already executing.");
                                for(; o;)try {
                                    if (n = 1, r && (i = 2 & a1[0] ? r.return : a1[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, a1[1])).done) return i;
                                    switch(r = 0, i && (a1 = [
                                        2 & a1[0],
                                        i.value
                                    ]), a1[0]){
                                        case 0:
                                        case 1:
                                            i = a1;
                                            break;
                                        case 4:
                                            return o.label++, {
                                                value: a1[1],
                                                done: !1
                                            };
                                        case 5:
                                            o.label++, r = a1[1], a1 = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            a1 = o.ops.pop(), o.trys.pop();
                                            continue;
                                        default:
                                            if (!((i = (i = o.trys).length > 0 && i[i.length - 1]) || 6 !== a1[0] && 2 !== a1[0])) {
                                                o = 0;
                                                continue;
                                            }
                                            if (3 === a1[0] && (!i || a1[1] > i[0] && a1[1] < i[3])) {
                                                o.label = a1[1];
                                                break;
                                            }
                                            if (6 === a1[0] && o.label < i[1]) {
                                                o.label = i[1], i = a1;
                                                break;
                                            }
                                            if (i && o.label < i[2]) {
                                                o.label = i[2], o.ops.push(a1);
                                                break;
                                            }
                                            i[2] && o.ops.pop(), o.trys.pop();
                                            continue;
                                    }
                                    a1 = t.call(e, o);
                                } catch (e) {
                                    a1 = [
                                        6,
                                        e
                                    ], r = 0;
                                } finally{
                                    n = i = 0;
                                }
                                if (5 & a1[0]) throw a1[1];
                                return {
                                    value: a1[0] ? a1[1] : void 0,
                                    done: !0
                                };
                            }([
                                a1,
                                s1
                            ]);
                        };
                    }
                }, D = function(e) {
                    function t(t) {
                        var n = e.call(this) || this;
                        return n.debug = !1, n.autoManagePlayback = !0, n.adBreaks = [], n.adMarkers = [], n.currentAdBreakVideos = [], n.validCurrentTime = 0, n.trackedAdBreaks = {}, n.trackedAds = {}, n.debug = !!t.debug, n.initOptions = t, n.state = "idle", n.adServerService = new p.AdServerService(n.debug), t = function(e) {
                            var t;
                            return e.container || e.adVideoElement || (console.warn("[CSAIManager] container or adVideoElement is expected, choosing the parent of contentVideoElement as container"), e.container = e.contentVideoElement.parentElement), e.container && e.adVideoElement && (console.warn("[CSAIManager] either container or adVideoElement is expected, not both, choosing the adVideoElement"), delete e.container), e.isLive || e.vmapUrl || e.adBreakVASTList || console.error("[CSAIManager] vmapUrl or adBreakVASTList is required"), e.vmapUrl && e.adBreakVASTList && (console.warn("[CSAIManager] either vmapUrl or adBreakVASTList is expected, not both, choosing the adBreakVASTList"), delete e.vmapUrl), e.isLive && (e.vmapUrl || (null === (t = e.adBreakVASTList) || void 0 === t ? void 0 : t.length) > 1) && console.warn("[CSAIManager] isLive is true, vmapUrl and adBreakVASTList are not expected, ignoring them"), e;
                        }(t), n.autoManagePlayback && t.contentVideoElement.pause(), n.contentVideoElement = t.contentVideoElement, n.adVideoElement = n.setupAdVideoElement(t), n.videoEventFilter = new r.VideoEventFilter(n.adVideoElement), n.autoManagePlayback = !t.autoManagePlayback || t.autoManagePlayback, n.fetchAds(t), n;
                    }
                    return I(t, e), t.prototype.setupAdVideoElement = function(e) {
                        if (e.adVideoElement) return e.adVideoElement;
                        if (e.container) {
                            var t = function(e) {
                                var t = document.createElement("video");
                                return t.style.position = "absolute", t.style.top = "0", t.style.left = "0", t.style.width = "100%", t.style.height = "100%", t.style.backgroundColor = "black", t.style.display = "none", e && (t.playsInline = e.playsInline, t.muted = e.muted, t.volume = e.volume), t;
                            }(this.contentVideoElement);
                            return e.container.appendChild(t), t;
                        }
                    }, t.prototype.fetchAds = function(e) {
                        var t;
                        return R(this, void 0, Promise, function() {
                            var n, r;
                            return C(this, function(i) {
                                switch(i.label){
                                    case 0:
                                        return e.isLive && (null === (t = e.adBreakVASTList) || void 0 === t ? void 0 : t.length) > 1 ? [
                                            2
                                        ] : e.vmapUrl ? (n = this, [
                                            4,
                                            this.adServerService.getVMAP(e.vmapUrl)
                                        ]) : [
                                            3,
                                            2
                                        ];
                                    case 1:
                                        n.adBreaks = i.sent(), i.label = 2;
                                    case 2:
                                        return e.adBreakVASTList ? (r = this, [
                                            4,
                                            this.adServerService.getVASTs(e.adBreakVASTList)
                                        ]) : [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        r.adBreaks = i.sent(), i.label = 4;
                                    case 4:
                                        return this.adBreaks = this.adBreaks.sort(function(e, t) {
                                            return e.timeOffset - t.timeOffset;
                                        }), this.adMarkers = this.adBreaks.map(function(e) {
                                            return e.timeOffset;
                                        }), this.start(), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, t.prototype.play = function() {
                        "idle" === this.state && (this.state = "playing", this.playNextVideo());
                    }, t.prototype.fetchAdBreak = function(e) {
                        return R(this, void 0, Promise, function() {
                            var t;
                            return C(this, function(n) {
                                switch(n.label){
                                    case 0:
                                        return [
                                            4,
                                            this.adServerService.getVast(e)
                                        ];
                                    case 1:
                                        return (t = n.sent()) && this.adBreaks.push(t), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, t.prototype.triggerAdBreak = function() {
                        return R(this, void 0, Promise, function() {
                            return C(this, function(e) {
                                return this.adBreaks && 0 !== this.adBreaks.length ? (this.playAdBreak(this.adBreaks.shift()), [
                                    2
                                ]) : [
                                    2
                                ];
                            });
                        });
                    }, t.prototype.start = function() {
                        var e = this;
                        if (0 === this.adMarkers[0]) this.adMarkers.shift(), this.playAdBreak(this.adBreaks.shift());
                        else {
                            if (!this.adMarkers.find(function(t) {
                                return t > e.contentVideoElement.currentTime;
                            })) return;
                            this.contentVideoElement.addEventListener("timeupdate", this.onContentTimeUpdateRef = this.onContentTimeUpdate.bind(this));
                        }
                    }, t.prototype.playAdBreak = function(e) {
                        this.autoManagePlayback && this.contentVideoElement.pause(), this.currentAdBreak = e, this.trackAdBreakEvent(this.currentAdBreak, d.BREAK_START);
                        for(var t = 0, n = e.ads; t < n.length; t++){
                            var r = n[t];
                            this.currentAdBreakVideos.push(r);
                        }
                        this.playNextVideo();
                    }, t.prototype.playNextVideo = function() {
                        this.videoEventFilter.clear(), this.adVideoElement.removeEventListener("seeking", this.onAdSeekingRef);
                        var e = this.currentAdBreakVideos.shift();
                        e ? this.playAd(e) : this.playContent();
                    }, t.prototype.playAd = function(e) {
                        var t = this, n = e.creative.mediafiles[0].fileUrl;
                        if (this.debug && console.debug("[CSAIManager] play ad", e), !n) return this.playNextVideo();
                        this.currentAd = e, this.adVideoElement.style.display = "block", this.adVideoElement.src = n, ("idle" !== this.state || this.initOptions.autoplay) && this.adVideoElement.play(), this.adVideoElement.addEventListener("playing", function() {
                            t.trackEvent(c.START, t.currentAd), t.trackEvent(c.IMPRESSION, t.currentAd), t.state = "playing";
                        }, {
                            once: !0
                        }), this.adVideoElement.addEventListener("ended", function() {
                            t.trackEvent(c.COMPLETE, t.currentAd), t.state = "ended", t.validCurrentTime = 0, t.playNextVideo();
                        }, {
                            once: !0
                        }), this.videoEventFilter.addEventListener(r.PlayerEvents.TimeUpdate, function() {
                            t.adVideoElement.seeking || (t.validCurrentTime = t.adVideoElement.currentTime), t.monitorProgress();
                        }), this.videoEventFilter.addEventListener(r.PlayerEvents.Pause, function() {
                            t.trackEvent(c.PAUSE, t.currentAd);
                        }), this.videoEventFilter.addEventListener(r.PlayerEvents.Resume, function() {
                            t.trackEvent(c.RESUME, t.currentAd);
                        }), this.videoEventFilter.addEventListener(r.PlayerEvents.Error, function() {
                            t.trackEvent(c.ERROR, t.currentAd);
                        }), this.adVideoElement.addEventListener("seeking", this.onAdSeekingRef = function() {
                            var e = t.adVideoElement.currentTime - t.validCurrentTime;
                            Math.abs(e) > .01 && (t.adVideoElement.currentTime = t.validCurrentTime);
                        });
                    }, t.prototype.playContent = function() {
                        var e = this;
                        this.debug && console.debug("[CSAIManager] play content"), this.adVideoElement.style.display = "none", this.adVideoElement.src = "", this.currentAdBreak && (this.trackAdBreakEvent(this.currentAdBreak, d.BREAK_END), this.currentAdBreak = null), this.autoManagePlayback && this.contentVideoElement.play();
                        var t = this.adMarkers.find(function(t) {
                            return t > e.contentVideoElement.currentTime;
                        });
                        t && (this.debug && console.debug("[CSAIManager] waiting for next break", t), this.contentVideoElement.addEventListener("timeupdate", this.onContentTimeUpdateRef = this.onContentTimeUpdate.bind(this)));
                    }, t.prototype.onContentTimeUpdate = function() {
                        this.contentVideoElement.currentTime > this.adMarkers[0] && (this.contentVideoElement.removeEventListener("timeupdate", this.onContentTimeUpdateRef), this.adMarkers.shift(), this.playAdBreak(this.adBreaks.shift()));
                    }, t.prototype.monitorProgress = function() {
                        var e = this, t = this.adVideoElement.currentTime, n = this.adVideoElement.duration;
                        if (this.currentAd) {
                            var r = n - t, i = Math.round(100 - 100 * r / n), a1 = {
                                25: c.FIRST_QUARTILE,
                                50: c.MIDPOINT,
                                75: c.THIRD_QUARTILE
                            };
                            Object.keys(a1).map(function(t) {
                                var n = a1[t];
                                i > parseInt(t, 10) && e.currentAd && e.trackEvent(n, e.currentAd);
                            });
                        }
                    }, t.prototype.trackAdBreakEvent = function(e, t) {
                        var n = this;
                        e && e.trackingEvents && t && (!this.trackedAdBreaks[e.timeOffset] || !0 !== this.trackedAdBreaks[e.timeOffset][t]) && (this.trackedAdBreaks[e.timeOffset] || (this.trackedAdBreaks[e.timeOffset] = {}), this.emit(t, e), (e.trackingEvents[t] || []).forEach(function(e) {
                            return R(n, void 0, void 0, function() {
                                return C(this, function(n) {
                                    return this.debug && console.debug("[CSAIManager] ad break tracking event -> ".concat(t), e), (new Image).src = e, [
                                        2
                                    ];
                                });
                            });
                        }), this.trackedAdBreaks[e.timeOffset][t] = !0);
                    }, t.prototype.trackEvent = function(e, t) {
                        var n = this;
                        if (t && e && (!this.trackedAds[t.id] || !0 !== this.trackedAds[t.id][e])) {
                            this.trackedAds[t.id] || (this.trackedAds[t.id] = {});
                            var r = [];
                            switch(e){
                                case c.IMPRESSION:
                                    r = t.impressionUrlTemplates || [];
                                    break;
                                case c.ERROR:
                                    r = t.errorUrlTemplates || [];
                                    break;
                                default:
                                    r = t.creative.trackingEvents[e] || [];
                            }
                            this.emit(e, t), null == r || r.forEach(function(t) {
                                return R(n, void 0, void 0, function() {
                                    return C(this, function(n) {
                                        return this.debug && console.debug("[CSAIManager] ad tracking event -> ".concat(e), t), (new Image).src = t, [
                                            2
                                        ];
                                    });
                                });
                            }), this.trackedAds[t.id][e] = !0;
                        }
                    }, t.prototype.destroy = function() {
                        this.adBreaks = [], this.adMarkers = [], this.currentAd = null, this.currentAdBreak = null, this.currentAdBreakVideos = [], this.onContentTimeUpdateRef = null, this.onAdSeekingRef = null, this.trackedAdBreaks = {}, this.trackedAds = {}, this.videoEventFilter.clear(), this.videoEventFilter.destroy(), this.initOptions.adVideoElement || this.adVideoElement.remove();
                    }, t;
                }(w);
                y = e.exports, E = l, Object.keys(E).forEach(function(e) {
                    "default" === e || "__esModule" === e || y.hasOwnProperty(e) || Object.defineProperty(y, e, {
                        enumerable: !0,
                        get: function() {
                            return E[e];
                        }
                    });
                });
            },
            171: (e, t, n)=>{
                var r = n(527);
                function i(e, t, n, r) {
                    Object.defineProperty(e, t, {
                        get: n,
                        set: r,
                        enumerable: !0,
                        configurable: !0
                    });
                }
                i(e.exports, "VideoEventFilter", ()=>a1.VideoEventFilter), i(e.exports, "PlayerEvents", ()=>a1.PlayerEvents), i(e.exports, "PlayerState", ()=>a1.PlayerState);
                var a1 = {};
                i(a1, "PlayerState", ()=>s1, (e)=>s1 = e), i(a1, "PlayerEvents", ()=>u, (e)=>u = e), i(a1, "VideoEventFilter", ()=>p, (e)=>p = e);
                var o, s1, u, l, c, d, f, h = function() {
                    function e() {
                        this.emitter = (function(e) {
                            return e && e.__esModule ? e.default : e;
                        })(r)();
                    }
                    return e.prototype.addEventListener = function(e, t) {
                        this.emitter.on.apply(this, [
                            e,
                            t
                        ]);
                    }, e.prototype.removeEventListener = function(e, t) {
                        this.emitter && this.emitter.off.apply(this, [
                            e,
                            t
                        ]);
                    }, e.prototype.clear = function() {
                        this.emitter.all.clear();
                    }, e.prototype.emit = function(e, t) {
                        this.emitter && this.emitter.emit.apply(this, [
                            e,
                            t
                        ]);
                    }, e.prototype.destroy = function() {
                        this.emitter.all.clear(), this.emitter = null;
                    }, e;
                }(), g = (o = function(e, t) {
                    return (o = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(e, t) {
                        e.__proto__ = t;
                    } || function(e, t) {
                        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
                    })(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function n() {
                        this.constructor = e;
                    }
                    o(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
                });
                !function(e) {
                    e.Idle = "idle", e.Loading = "loading", e.Playing = "playing", e.Paused = "paused", e.Buffering = "buffering", e.Seeking = "seeking", e.Ended = "ended";
                }(s1 || (s1 = {})), function(e) {
                    e.Loading = "loading", e.Loaded = "loaded", e.Play = "play", e.Resume = "resume", e.Pause = "pause", e.Seeking = "seeking", e.Seeked = "seeked", e.Buffering = "buffering", e.Buffered = "buffered", e.TimeUpdate = "timeupdate", e.Ended = "ended", e.Error = "error";
                }(u || (u = {})), (c = l || (l = {}))[c.NETWORK_EMPTY = 0] = "NETWORK_EMPTY", c[c.NETWORK_IDLE = 1] = "NETWORK_IDLE", c[c.NETWORK_LOADING = 2] = "NETWORK_LOADING", c[c.NETWORK_NO_SOURCE = 3] = "NETWORK_NO_SOURCE", (f = d || (d = {}))[f.HAVE_NOTHING = 0] = "HAVE_NOTHING", f[f.HAVE_METADATA = 1] = "HAVE_METADATA", f[f.HAVE_CURRENT_DATA = 2] = "HAVE_CURRENT_DATA", f[f.HAVE_FUTURE_DATA = 3] = "HAVE_FUTURE_DATA", f[f.HAVE_ENOUGH_DATA = 4] = "HAVE_ENOUGH_DATA";
                var p = function(e) {
                    function t(t) {
                        var n = e.call(this) || this;
                        return n.listeners = [], n.videoElement = t, "string" == typeof t && (n.videoElement = document.querySelector(t)), n.state = function(e) {
                            return e.readyState === d.HAVE_NOTHING && e.networkState === l.NETWORK_EMPTY ? s1.Idle : e.networkState === l.NETWORK_LOADING ? s1.Loading : e.ended ? s1.Ended : e.paused ? s1.Paused : s1.Playing;
                        }(t), n.setupEventListeners(), n;
                    }
                    return g(t, e), t.prototype.setupEventListeners = function() {
                        this.addListener("loadstart", this.onLoading), this.addListener("loadeddata", this.onLoaded), this.addListener("playing", this.onPlaying), this.addListener("pause", this.onPause), this.addListener("seeking", this.onSeeking), this.addListener("seeked", this.onSeeked), this.addListener("waiting", this.onBuffering), this.addListener("timeupdate", this.onTimeUpdate), this.addListener("error", this.onError), this.addListener("ended", this.onEnded);
                    }, t.prototype.addListener = function(e, t) {
                        var n = t.bind(this);
                        this.videoElement.addEventListener(e, n), this.listeners.push({
                            type: e,
                            handler: n
                        });
                    }, t.prototype.onLoading = function() {
                        this.state !== s1.Loading && (this.setState(s1.Loading), this.emit(u.Loading));
                    }, t.prototype.onLoaded = function() {
                        this.state === s1.Loading && this.emit(u.Loaded);
                    }, t.prototype.onPlaying = function() {
                        this.state === s1.Ended && this.setState(s1.Loading), [
                            s1.Loading,
                            s1.Paused
                        ].includes(this.state) && (this.state === s1.Loading && this.emit(u.Play), this.state === s1.Paused && (this.lastState = s1.Paused, this.emit(u.Resume)), this.setState(s1.Playing, !0)), this.state === s1.Buffering && this.onBuffered();
                    }, t.prototype.onPause = function() {
                        var e = this;
                        this.state === s1.Playing && (clearTimeout(this.pauseDebounce), this.pauseDebounce = window.setTimeout(function() {
                            e.emit(u.Pause), e.setState(s1.Paused, !0);
                        }, 200));
                    }, t.prototype.onSeeking = function() {
                        [
                            s1.Loading,
                            s1.Seeking,
                            s1.Ended
                        ].includes(this.state) || (clearTimeout(this.pauseDebounce), this.setState(s1.Seeking, !0), this.emit(u.Seeking));
                    }, t.prototype.onSeeked = function() {
                        this.state === s1.Seeking && (this.setState(this.lastState, !0), this.emit(u.Seeked));
                    }, t.prototype.onBuffering = function() {
                        [
                            s1.Loading,
                            s1.Buffering,
                            s1.Seeking,
                            s1.Ended
                        ].includes(this.state) || (this.setState(s1.Buffering, !0), this.emit(u.Buffering));
                    }, t.prototype.onBuffered = function() {
                        this.state === s1.Buffering && (this.setState(this.lastState, !0), this.emit(u.Buffered));
                    }, t.prototype.onTimeUpdate = function() {
                        this.videoElement.seeking || [
                            s1.Loading,
                            s1.Paused,
                            s1.Seeking,
                            s1.Buffering,
                            s1.Ended
                        ].includes(this.state) || this.emit(u.TimeUpdate);
                    }, t.prototype.onEnded = function() {
                        clearTimeout(this.pauseDebounce), this.state !== s1.Ended && (this.setState(s1.Ended), this.emit(u.Ended));
                    }, t.prototype.onError = function() {
                        this.state !== s1.Ended && (this.emit(u.Error, this.videoElement.error), this.onEnded());
                    }, t.prototype.getState = function() {
                        return this.state;
                    }, t.prototype.setState = function(e, t) {
                        t && this.updateLastState(this.state), this.state = e;
                    }, t.prototype.updateLastState = function(e) {
                        this.lastState = e || this.state;
                    }, t.prototype.destroy = function() {
                        var t = this;
                        this.listeners.forEach(function(e) {
                            var n = e.type, r = e.handler;
                            t.videoElement.removeEventListener(n, r);
                        }), e.prototype.destroy.call(this);
                    }, t;
                }(h);
            },
            527: (e, t, n)=>{
                "use strict";
                function r(e) {
                    return {
                        all: e = e || new Map,
                        on: function(t, n) {
                            var r = e.get(t);
                            r && r.push(n) || e.set(t, [
                                n
                            ]);
                        },
                        off: function(t, n) {
                            var r = e.get(t);
                            r && r.splice(r.indexOf(n) >>> 0, 1);
                        },
                        emit: function(t, n) {
                            (e.get(t) || []).slice().map(function(e) {
                                e(n);
                            }), (e.get("*") || []).slice().map(function(e) {
                                e(t, n);
                            });
                        }
                    };
                }
                n.r(t), n.d(t, {
                    default: ()=>r
                });
            },
            40: (e, t, n)=>{
                var r = n(758), i = n(974), a1 = n(672);
                function o(e, t, n, r) {
                    Object.defineProperty(e, t, {
                        get: n,
                        set: r,
                        enumerable: !0,
                        configurable: !0
                    });
                }
                o(e.exports, "WebRTCPlayer", ()=>h), o(e.exports, "ListAvailableAdapters", ()=>f);
                class s1 {
                    constructor(e, t, n){
                        this.channelUrl = t, this.resetPeer(e);
                    }
                    enableDebug() {
                        this.debug = !0;
                    }
                    resetPeer(e) {
                        this.localPeer = e;
                    }
                    getPeer() {
                        return this.localPeer;
                    }
                    async connect(e) {
                        this.client = new a1.WHPPClient(this.localPeer, this.channelUrl, {
                            debug: this.debug
                        }), await this.client.connect();
                    }
                    log(...e) {
                        this.debug && console.log("WebRTC-player", ...e);
                    }
                    error(...e) {
                        console.error("WebRTC-player", ...e);
                    }
                }
                class u {
                    waitingForCandidates = !1;
                    resourceUrl = void 0;
                    constructor(e, t, n){
                        this.channelUrl = t, this.debug = !0, this.resetPeer(e);
                    }
                    enableDebug() {
                        this.debug = !0;
                    }
                    resetPeer(e) {
                        this.localPeer = e, this.localPeer.onicegatheringstatechange = this.onIceGatheringStateChange.bind(this), this.localPeer.oniceconnectionstatechange = this.onIceConnectionStateChange.bind(this), this.localPeer.onicecandidateerror = this.onIceCandidateError.bind(this), this.localPeer.onicecandidate = this.onIceCandidate.bind(this);
                    }
                    getPeer() {
                        return this.localPeer;
                    }
                    async connect(e) {
                        this.localPeer.addTransceiver("video", {
                            direction: "recvonly"
                        }), this.localPeer.addTransceiver("audio", {
                            direction: "recvonly"
                        });
                        const t = await this.localPeer.createOffer({
                            offerToReceiveAudio: !0,
                            offerToReceiveVideo: !0
                        });
                        this.localPeer.setLocalDescription(t), this.waitingForCandidates = !0, this.iceGatheringTimeout = setTimeout(this.onIceGatheringTimeout.bind(this), e && e.timeout || 2e3);
                    }
                    log(...e) {
                        this.debug && console.log("WebRTC-player", ...e);
                    }
                    error(...e) {
                        console.error("WebRTC-player", ...e);
                    }
                    onIceGatheringStateChange(e) {
                        this.log("IceGatheringState", this.localPeer.iceGatheringState), "complete" === this.localPeer.iceGatheringState && this.waitingForCandidates && this.onDoneWaitingForCandidates();
                    }
                    onIceConnectionStateChange(e) {
                        this.log("IceConnectionState", this.localPeer.iceConnectionState), "failed" === this.localPeer.iceConnectionState && this.localPeer.close();
                    }
                    async onIceCandidate(e) {
                        if ("icecandidate" !== e.type) return;
                        const t = e.candidate;
                        t && this.log("IceCandidate", t.candidate);
                    }
                    onIceCandidateError(e) {
                        this.log("IceCandidateError", e);
                    }
                    onIceGatheringTimeout() {
                        this.log("IceGatheringTimeout"), this.waitingForCandidates && this.onDoneWaitingForCandidates();
                    }
                    async onDoneWaitingForCandidates() {
                        this.waitingForCandidates = !1, clearTimeout(this.iceGatheringTimeout);
                        const e = await fetch(this.channelUrl.href, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                sdp: this.localPeer.localDescription.sdp
                            })
                        });
                        if (e.ok) {
                            const { sdp: t } = await e.json();
                            this.localPeer.setRemoteDescription({
                                type: "answer",
                                sdp: t
                            });
                        }
                    }
                }
                let l;
                !function(e) {
                    e[e.Client = 0] = "Client", e[e.Server = 1] = "Server";
                }(l || (l = {}));
                class c {
                    constructor(e, t, n){
                        this.channelUrl = t, this.whepType = l.Client, this.onErrorHandler = n, this.resetPeer(e);
                    }
                    enableDebug() {
                        this.debug = !0;
                    }
                    resetPeer(e) {
                        this.localPeer = e, this.localPeer.onicegatheringstatechange = this.onIceGatheringStateChange.bind(this), this.localPeer.onicecandidate = this.onIceCandidate.bind(this);
                    }
                    getPeer() {
                        return this.localPeer;
                    }
                    async connect(e) {
                        await this.initSdpExchange();
                    }
                    async initSdpExchange() {
                        if (clearTimeout(this.iceGatheringTimeout), this.whepType === l.Client) {
                            this.localPeer.addTransceiver("video", {
                                direction: "recvonly"
                            }), this.localPeer.addTransceiver("audio", {
                                direction: "recvonly"
                            });
                            const e = await this.localPeer.createOffer();
                            await this.localPeer.setLocalDescription(e), this.waitingForCandidates = !0, this.iceGatheringTimeout = setTimeout(this.onIceGatheringTimeout.bind(this), 2e3);
                        } else {
                            const e = await this.requestOffer();
                            await this.localPeer.setRemoteDescription({
                                type: "offer",
                                sdp: e
                            });
                            const t = await this.localPeer.createAnswer();
                            await this.localPeer.setLocalDescription(t), this.waitingForCandidates = !0, this.iceGatheringTimeout = setTimeout(this.onIceGatheringTimeout.bind(this), 2e3);
                        }
                    }
                    async onIceCandidate(e) {
                        if ("icecandidate" !== e.type) return;
                        const t = e.candidate;
                        t && this.log(t.candidate);
                    }
                    onIceGatheringStateChange(e) {
                        this.log("IceGatheringState", this.localPeer.iceGatheringState), "complete" === this.localPeer.iceGatheringState && this.waitingForCandidates && this.onDoneWaitingForCandidates();
                    }
                    onIceGatheringTimeout() {
                        this.log("IceGatheringTimeout"), this.waitingForCandidates && this.onDoneWaitingForCandidates();
                    }
                    async onDoneWaitingForCandidates() {
                        this.waitingForCandidates = !1, clearTimeout(this.iceGatheringTimeout), this.whepType === l.Client ? await this.sendOffer() : await this.sendAnswer();
                    }
                    async requestOffer() {
                        if (this.whepType === l.Server) {
                            const e = await fetch(this.channelUrl.href, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/sdp"
                                },
                                body: ""
                            });
                            if (e.ok) return this.resource = e.headers.get("Location"), this.log("WHEP Resource", this.resource), await e.text();
                        }
                    }
                    async sendAnswer() {
                        if (this.whepType === l.Server) {
                            const e = this.localPeer.localDescription, t = await fetch(this.resource, {
                                method: "PATCH",
                                headers: {
                                    "Content-Type": "application/sdp"
                                },
                                body: e.sdp
                            });
                            t.ok || this.error(`sendAnswer response: ${t.status}`);
                        }
                    }
                    async sendOffer() {
                        const e = this.localPeer.localDescription;
                        if (this.whepType === l.Client) {
                            const t = await fetch(this.channelUrl.href, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/sdp"
                                },
                                body: e.sdp
                            });
                            if (t.ok) {
                                this.resource = t.headers.get("Location"), this.log("WHEP Resource", this.resource);
                                const e = await t.text();
                                await this.localPeer.setRemoteDescription({
                                    type: "answer",
                                    sdp: e
                                });
                            } else 400 === t.status ? (this.log("server does not support client-offer, need to reconnect"), this.whepType = l.Server, this.onErrorHandler("reconnectneeded")) : this.error(`sendAnswer response: ${t.status}`);
                        }
                    }
                    log(...e) {
                        this.debug && console.log("WebRTC-player", ...e);
                    }
                    error(...e) {
                        console.error("WebRTC-player", ...e);
                    }
                }
                const d = {
                    "se.eyevinn.whpp": (e, t, n)=>new s1(e, t, n),
                    "se.eyevinn.webrtc": (e, t, n)=>new u(e, t, n),
                    whep: (e, t, n)=>new c(e, t, n)
                };
                function f() {
                    return Object.keys(d);
                }
                class h extends r.EventEmitter {
                    reconnectAttemptsLeft = 2;
                    constructor(e){
                        super(), this.videoElement = e.video, this.adapterType = e.type, this.adapterFactory = e.adapterFactory, this.iceServers = [
                            {
                                urls: "stun:stun.l.google.com:19302"
                            }
                        ], e.iceServers && (this.iceServers = e.iceServers), this.debug = !!e.debug, e.vmapUrl && (this.csaiManager = new i.CSAIManager({
                            contentVideoElement: this.videoElement,
                            vmapUrl: e.vmapUrl,
                            isLive: !0,
                            autoplay: !0
                        }), this.videoElement.addEventListener("ended", ()=>{
                            this.csaiManager.destroy();
                        }));
                    }
                    async load(e) {
                        this.channelUrl = e, this.connect();
                    }
                    log(...e) {
                        this.debug && console.log("WebRTC-player", ...e);
                    }
                    error(...e) {
                        console.error("WebRTC-player", ...e);
                    }
                    onConnectionStateChange(e) {
                        if ("failed" === this.peer.connectionState) {
                            if (this.peer && this.peer.close(), this.reconnectAttemptsLeft <= 0) return void this.error("Connection failed, reconnecting failed");
                            this.log(`Connection failed, recreating peer connection, attempts left ${this.reconnectAttemptsLeft}`), this.connect(), this.reconnectAttemptsLeft--;
                        } else "connected" === this.peer.connectionState && (this.log("Connected"), this.reconnectAttemptsLeft = 2, this.videoElement.srcObject || (this.log("Updating video element srcobject"), this.videoElement.srcObject = this.stream));
                    }
                    onErrorHandler(e) {
                        this.log(`onError=${e}`), "reconnectneeded" === e && (this.peer && this.peer.close(), this.videoElement.srcObject = void 0, this.setupPeer(), this.adapter.resetPeer(this.peer), this.adapter.connect());
                    }
                    setupPeer() {
                        this.stream = new MediaStream, this.peer = new RTCPeerConnection({
                            iceServers: this.iceServers
                        }), this.peer.onconnectionstatechange = this.onConnectionStateChange.bind(this), this.peer.ontrack = this.onTrack.bind(this);
                    }
                    onTrack(e) {
                        const t = e.track;
                        switch(t.kind){
                            case "video":
                                if ("feedbackvideolabel" !== t.label) {
                                    const e = t.clone();
                                    this.log("Adding video track", e), this.stream.addTrack(e);
                                }
                                break;
                            case "audio":
                                const e1 = t.clone();
                                this.log("Adding audio track", e1), this.stream.addTrack(e1);
                                break;
                            default:
                                this.log("unknown track", t);
                        }
                    }
                    async connect() {
                        var e, t, n, r;
                        if (this.setupPeer(), "custom" !== this.adapterType ? this.adapter = (e = this.adapterType, t = this.peer, n = this.channelUrl, r = this.onErrorHandler.bind(this), d[e](t, n, r)) : this.adapterFactory && (this.adapter = this.adapterFactory(this.peer, this.channelUrl, this.onErrorHandler.bind(this))), !this.adapter) throw new Error(`Failed to create adapter (${this.adapterType})`);
                        this.debug && this.adapter.enableDebug(), await this.adapter.connect();
                    }
                    mute() {
                        this.videoElement.muted = !0;
                    }
                    unmute() {
                        this.videoElement.muted = !1;
                    }
                    stop() {
                        this.peer.close(), this.videoElement.src = null, this.videoElement.load();
                    }
                    destroy() {
                        this.stop(), this.removeAllListeners();
                    }
                }
            },
            672: (e, t, n)=>{
                "use strict";
                n.r(t), n.d(t, {
                    WHPPClient: ()=>r
                });
                var r = function() {
                    function e(e, t, n) {
                        this.localPeer = void 0, this.whppUrl = void 0, this.iceGatheringTimeout = void 0, this.waitingForCandidates = !1, this.resourceUrl = void 0, this.opts = void 0, this.localPeer = e, this.whppUrl = t, this.opts = n, this.localPeer.onicegatheringstatechange = this.onIceGatheringStateChange.bind(this), this.localPeer.oniceconnectionstatechange = this.onIceConnectionStateChange.bind(this), this.localPeer.onicecandidateerror = this.onIceCandidateError.bind(this), this.localPeer.onicecandidate = this.onIceCandidate.bind(this);
                    }
                    var t = e.prototype;
                    return t.getPeer = function() {
                        return this.localPeer;
                    }, t.connect = function() {
                        try {
                            var e, t = this;
                            return Promise.resolve(fetch(t.whppUrl.href, {
                                method: "POST",
                                headers: {
                                    "Content-Type": null != (e = t.opts) && e.useLegacyContentType ? "application/json" : "application/whpp+json"
                                },
                                body: "{}"
                            })).then(function(e) {
                                var n;
                                function r(r) {
                                    return n ? r : Promise.resolve(e.json()).then(function(n) {
                                        var r = e.headers.get("location");
                                        return t.resourceUrl = new URL(r), t.log(n.offer), Promise.resolve(function(e) {
                                            try {
                                                return Promise.resolve(fetch(e.href, {
                                                    method: "OPTIONS"
                                                })).then(function(e) {
                                                    return !(!e.ok || !e.headers.get("Allow") || !e.headers.get("Allow").split(",").find(function(e) {
                                                        return "PATCH" === e.trimStart();
                                                    }));
                                                });
                                            } catch (e) {
                                                return Promise.reject(e);
                                            }
                                        }(t.resourceUrl)).then(function(e) {
                                            return t.log("ICE trickle supported by endpoint: " + e), t.opts || (t.opts = {}), t.opts.noIceTrickle = !e, t.supportsTrickleIce() || (t.waitingForCandidates = !0), Promise.resolve(t.localPeer.setRemoteDescription({
                                                type: "offer",
                                                sdp: n.offer
                                            })).then(function() {
                                                return Promise.resolve(t.localPeer.createAnswer()).then(function(e) {
                                                    return Promise.resolve(t.localPeer.setLocalDescription(e)).then(function() {
                                                        var e = function() {
                                                            if (t.supportsTrickleIce()) return t.log("ICE trickle supported, sending answer"), Promise.resolve(t.sendAnswer()).then(function() {});
                                                            var e;
                                                            t.iceGatheringTimeout = setTimeout(t.onIceGatheringTimeout.bind(t), (null == (e = t.opts) ? void 0 : e.timeout) || 2e3);
                                                        }();
                                                        if (e && e.then) return e.then(function() {});
                                                    });
                                                });
                                            });
                                        });
                                    });
                                }
                                var i = function() {
                                    if (!e.ok) return function() {
                                        if (415 === e.status) return t.opts.useLegacyContentType = !0, Promise.resolve(fetch(t.whppUrl.href, {
                                            method: "POST",
                                            headers: {
                                                "Content-Type": "application/json"
                                            },
                                            body: "{}"
                                        })).then(function(t) {
                                            e = t;
                                        });
                                        n = 1;
                                    }();
                                }();
                                return i && i.then ? i.then(r) : r(i);
                            });
                        } catch (e) {
                            return Promise.reject(e);
                        }
                    }, t.log = function() {
                        var e, t;
                        null != (e = this.opts) && e.debug && (t = console).log.apply(t, [
                            "whpp-client"
                        ].concat([].slice.call(arguments)));
                    }, t.error = function() {
                        var e;
                        (e = console).error.apply(e, [
                            "whpp-client"
                        ].concat([].slice.call(arguments)));
                    }, t.onIceGatheringStateChange = function(e) {
                        this.log("IceGatheringState", this.localPeer.iceGatheringState), "complete" === this.localPeer.iceGatheringState && !this.supportsTrickleIce() && this.waitingForCandidates && this.onDoneWaitingForCandidates();
                    }, t.onIceConnectionStateChange = function(e) {
                        this.log("IceConnectionState", this.localPeer.iceConnectionState), "failed" === this.localPeer.iceConnectionState && this.localPeer.close();
                    }, t.onIceCandidate = function(e) {
                        try {
                            var t = this;
                            if ("icecandidate" !== e.type) return Promise.resolve();
                            var n = e.candidate;
                            return n ? (t.log("IceCandidate", n.candidate), t.supportsTrickleIce() ? (t.sendCandidate(n), Promise.resolve()) : Promise.resolve()) : Promise.resolve();
                        } catch (e) {
                            return Promise.reject(e);
                        }
                    }, t.onIceCandidateError = function(e) {
                        this.log("IceCandidateError", e);
                    }, t.onIceGatheringTimeout = function() {
                        this.log("IceGatheringTimeout"), !this.supportsTrickleIce() && this.waitingForCandidates && this.onDoneWaitingForCandidates();
                    }, t.supportsTrickleIce = function() {
                        return this.opts && !this.opts.noIceTrickle;
                    }, t.onDoneWaitingForCandidates = function() {
                        try {
                            var e = this;
                            return e.waitingForCandidates = !1, clearTimeout(e.iceGatheringTimeout), Promise.resolve(e.sendAnswer()).then(function() {});
                        } catch (e) {
                            return Promise.reject(e);
                        }
                    }, t.sendCandidate = function(e) {
                        try {
                            var t, n = this;
                            return Promise.resolve(fetch(n.resourceUrl.href, {
                                method: "PATCH",
                                headers: {
                                    "Content-Type": null != (t = n.opts) && t.useLegacyContentType ? "application/json" : "application/whpp+json"
                                },
                                body: JSON.stringify({
                                    candidate: e.candidate
                                })
                            })).then(function(e) {
                                e.ok || (n.error("sendCandidate response: " + e.status), 405 === e.status && n.log("ICE trickle not supported by endpoint"));
                            });
                        } catch (e) {
                            return Promise.reject(e);
                        }
                    }, t.sendAnswer = function() {
                        try {
                            var e, t = this, n = {
                                answer: t.localPeer.localDescription.sdp
                            };
                            return t.log(n.answer), Promise.resolve(fetch(t.resourceUrl.href, {
                                method: "PUT",
                                headers: {
                                    "Content-Type": null != (e = t.opts) && e.useLegacyContentType ? "application/json" : "application/whpp+json"
                                },
                                body: JSON.stringify(n)
                            })).then(function(e) {
                                e.ok || t.error("sendAnswer response: " + e.status);
                            });
                        } catch (e) {
                            return Promise.reject(e);
                        }
                    }, e;
                }();
            },
            357: (e)=>{
                var t;
                window, t = function() {
                    return function(e) {
                        var t = {};
                        function n(r) {
                            if (t[r]) return t[r].exports;
                            var i = t[r] = {
                                i: r,
                                l: !1,
                                exports: {}
                            };
                            return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
                        }
                        return n.m = e, n.c = t, n.d = function(e, t, r) {
                            n.o(e, t) || Object.defineProperty(e, t, {
                                enumerable: !0,
                                get: r
                            });
                        }, n.r = function(e) {
                            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                                value: "Module"
                            }), Object.defineProperty(e, "__esModule", {
                                value: !0
                            });
                        }, n.t = function(e, t) {
                            if (1 & t && (e = n(e)), 8 & t) return e;
                            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
                            var r = Object.create(null);
                            if (n.r(r), Object.defineProperty(r, "default", {
                                enumerable: !0,
                                value: e
                            }), 2 & t && "string" != typeof e) for(var i in e)n.d(r, i, (function(t) {
                                return e[t];
                            }).bind(null, i));
                            return r;
                        }, n.n = function(e) {
                            var t = e && e.__esModule ? function() {
                                return e.default;
                            } : function() {
                                return e;
                            };
                            return n.d(t, "a", t), t;
                        }, n.o = function(e, t) {
                            return Object.prototype.hasOwnProperty.call(e, t);
                        }, n.p = "/dist/", n(n.s = "./index.js");
                    }({
                        "./externals/base64.js": function(e, t, n) {
                            var r, i, o, u, l, c = function(e) {
                                for(var t = [], n = 0; n < e.length; ++n){
                                    var r = e.charCodeAt(n);
                                    r < 128 ? t.push(r) : r < 2048 ? (t.push(192 | r >> 6), t.push(128 | 63 & r)) : r < 65536 ? (t.push(224 | r >> 12), t.push(128 | 63 & r >> 6), t.push(128 | 63 & r)) : (t.push(240 | r >> 18), t.push(128 | 63 & r >> 12), t.push(128 | 63 & r >> 6), t.push(128 | 63 & r));
                                }
                                return t;
                            }, d = function(e) {
                                for(var t = [], n = 0; n < e.length;){
                                    var r = e[n++];
                                    r < 128 || (r < 224 ? (r = (31 & r) << 6, r |= 63 & e[n++]) : r < 240 ? (r = (15 & r) << 12, r |= (63 & e[n++]) << 6, r |= 63 & e[n++]) : (r = (7 & r) << 18, r |= (63 & e[n++]) << 12, r |= (63 & e[n++]) << 6, r |= 63 & e[n++])), t.push(String.fromCharCode(r));
                                }
                                return t.join("");
                            }, f = {};
                            r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = function(e) {
                                for(var t = 0, n = [], i = 0 | e.length / 3; 0 < i--;){
                                    var a1 = (e[t] << 16) + (e[t + 1] << 8) + e[t + 2];
                                    t += 3, n.push(r.charAt(63 & a1 >> 18)), n.push(r.charAt(63 & a1 >> 12)), n.push(r.charAt(63 & a1 >> 6)), n.push(r.charAt(63 & a1));
                                }
                                return 2 == e.length - t ? (a1 = (e[t] << 16) + (e[t + 1] << 8), n.push(r.charAt(63 & a1 >> 18)), n.push(r.charAt(63 & a1 >> 12)), n.push(r.charAt(63 & a1 >> 6)), n.push("=")) : 1 == e.length - t && (a1 = e[t] << 16, n.push(r.charAt(63 & a1 >> 18)), n.push(r.charAt(63 & a1 >> 12)), n.push("==")), n.join("");
                            }, o = function() {
                                for(var e = [], t = 0; t < r.length; ++t)e[r.charCodeAt(t)] = t;
                                return e["=".charCodeAt(0)] = 0, e;
                            }(), u = function(e) {
                                for(var t = 0, n = [], r = 0 | e.length / 4; 0 < r--;){
                                    var i = (o[e.charCodeAt(t)] << 18) + (o[e.charCodeAt(t + 1)] << 12) + (o[e.charCodeAt(t + 2)] << 6) + o[e.charCodeAt(t + 3)];
                                    n.push(255 & i >> 16), n.push(255 & i >> 8), n.push(255 & i), t += 4;
                                }
                                return n && ("=" == e.charAt(t - 2) ? (n.pop(), n.pop()) : "=" == e.charAt(t - 1) && n.pop()), n;
                            }, l = {
                                encode: function(e) {
                                    for(var t = [], n = 0; n < e.length; ++n)t.push(e.charCodeAt(n));
                                    return t;
                                },
                                decode: function(e) {
                                    for(var t = 0; t < s.length; ++t)a[t] = String.fromCharCode(a[t]);
                                    return a.join("");
                                }
                            }, f.decodeArray = function(e) {
                                var t = u(e);
                                return new Uint8Array(t);
                            }, f.encodeASCII = function(e) {
                                var t = l.encode(e);
                                return i(t);
                            }, f.decodeASCII = function(e) {
                                var t = u(e);
                                return l.decode(t);
                            }, f.encode = function(e) {
                                var t = c(e);
                                return i(t);
                            }, f.decode = function(e) {
                                var t = u(e);
                                return d(t);
                            }, t.decode = f.decode, t.decodeArray = f.decodeArray, t.encode = f.encode, t.encodeASCII = f.encodeASCII;
                        },
                        "./externals/cea608-parser.js": function(e, t, n) {
                            !function(e) {
                                "use strict";
                                var t = {
                                    42: 225,
                                    92: 233,
                                    94: 237,
                                    95: 243,
                                    96: 250,
                                    123: 231,
                                    124: 247,
                                    125: 209,
                                    126: 241,
                                    127: 9608,
                                    128: 174,
                                    129: 176,
                                    130: 189,
                                    131: 191,
                                    132: 8482,
                                    133: 162,
                                    134: 163,
                                    135: 9834,
                                    136: 224,
                                    137: 32,
                                    138: 232,
                                    139: 226,
                                    140: 234,
                                    141: 238,
                                    142: 244,
                                    143: 251,
                                    144: 193,
                                    145: 201,
                                    146: 211,
                                    147: 218,
                                    148: 220,
                                    149: 252,
                                    150: 8216,
                                    151: 161,
                                    152: 42,
                                    153: 8217,
                                    154: 9473,
                                    155: 169,
                                    156: 8480,
                                    157: 8226,
                                    158: 8220,
                                    159: 8221,
                                    160: 192,
                                    161: 194,
                                    162: 199,
                                    163: 200,
                                    164: 202,
                                    165: 203,
                                    166: 235,
                                    167: 206,
                                    168: 207,
                                    169: 239,
                                    170: 212,
                                    171: 217,
                                    172: 249,
                                    173: 219,
                                    174: 171,
                                    175: 187,
                                    176: 195,
                                    177: 227,
                                    178: 205,
                                    179: 204,
                                    180: 236,
                                    181: 210,
                                    182: 242,
                                    183: 213,
                                    184: 245,
                                    185: 123,
                                    186: 125,
                                    187: 92,
                                    188: 94,
                                    189: 95,
                                    190: 124,
                                    191: 8764,
                                    192: 196,
                                    193: 228,
                                    194: 214,
                                    195: 246,
                                    196: 223,
                                    197: 165,
                                    198: 164,
                                    199: 9475,
                                    200: 197,
                                    201: 229,
                                    202: 216,
                                    203: 248,
                                    204: 9487,
                                    205: 9491,
                                    206: 9495,
                                    207: 9499
                                }, n = function(e) {
                                    var n = e;
                                    return t.hasOwnProperty(e) && (n = t[e]), String.fromCharCode(n);
                                }, r = 15, i = 32, a1 = {
                                    17: 1,
                                    18: 3,
                                    21: 5,
                                    22: 7,
                                    23: 9,
                                    16: 11,
                                    19: 12,
                                    20: 14
                                }, o = {
                                    17: 2,
                                    18: 4,
                                    21: 6,
                                    22: 8,
                                    23: 10,
                                    19: 13,
                                    20: 15
                                }, s1 = {
                                    25: 1,
                                    26: 3,
                                    29: 5,
                                    30: 7,
                                    31: 9,
                                    24: 11,
                                    27: 12,
                                    28: 14
                                }, u = {
                                    25: 2,
                                    26: 4,
                                    29: 6,
                                    30: 8,
                                    31: 10,
                                    27: 13,
                                    28: 15
                                }, l = [
                                    "white",
                                    "green",
                                    "blue",
                                    "cyan",
                                    "red",
                                    "yellow",
                                    "magenta",
                                    "black",
                                    "transparent"
                                ], c = {
                                    verboseFilter: {
                                        DATA: 3,
                                        DEBUG: 3,
                                        INFO: 2,
                                        WARNING: 2,
                                        TEXT: 1,
                                        ERROR: 0
                                    },
                                    time: null,
                                    verboseLevel: 0,
                                    setTime: function(e) {
                                        this.time = e;
                                    },
                                    log: function(e, t) {
                                        var n = this.verboseFilter[e];
                                        this.verboseLevel >= n && console.log(this.time + " [" + e + "] " + t);
                                    }
                                }, d = function(e) {
                                    for(var t = [], n = 0; n < e.length; n++)t.push(e[n].toString(16));
                                    return t;
                                }, f = function(e, t, n, r, i) {
                                    this.foreground = e || "white", this.underline = t || !1, this.italics = n || !1, this.background = r || "black", this.flash = i || !1;
                                };
                                f.prototype = {
                                    reset: function() {
                                        this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
                                    },
                                    setStyles: function(e) {
                                        for(var t = [
                                            "foreground",
                                            "underline",
                                            "italics",
                                            "background",
                                            "flash"
                                        ], n = 0; n < t.length; n++){
                                            var r = t[n];
                                            e.hasOwnProperty(r) && (this[r] = e[r]);
                                        }
                                    },
                                    isDefault: function() {
                                        return "white" === this.foreground && !this.underline && !this.italics && "black" === this.background && !this.flash;
                                    },
                                    equals: function(e) {
                                        return this.foreground === e.foreground && this.underline === e.underline && this.italics === e.italics && this.background === e.background && this.flash === e.flash;
                                    },
                                    copy: function(e) {
                                        this.foreground = e.foreground, this.underline = e.underline, this.italics = e.italics, this.background = e.background, this.flash = e.flash;
                                    },
                                    toString: function() {
                                        return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
                                    }
                                };
                                var h = function(e, t, n, r, i, a1) {
                                    this.uchar = e || " ", this.penState = new f(t, n, r, i, a1);
                                };
                                h.prototype = {
                                    reset: function() {
                                        this.uchar = " ", this.penState.reset();
                                    },
                                    setChar: function(e, t) {
                                        this.uchar = e, this.penState.copy(t);
                                    },
                                    setPenState: function(e) {
                                        this.penState.copy(e);
                                    },
                                    equals: function(e) {
                                        return this.uchar === e.uchar && this.penState.equals(e.penState);
                                    },
                                    copy: function(e) {
                                        this.uchar = e.uchar, this.penState.copy(e.penState);
                                    },
                                    isEmpty: function() {
                                        return " " === this.uchar && this.penState.isDefault();
                                    }
                                };
                                var g = function() {
                                    this.chars = [];
                                    for(var e = 0; e < i; e++)this.chars.push(new h);
                                    this.pos = 0, this.currPenState = new f;
                                };
                                g.prototype = {
                                    equals: function(e) {
                                        for(var t = !0, n = 0; n < i; n++)if (!this.chars[n].equals(e.chars[n])) {
                                            t = !1;
                                            break;
                                        }
                                        return t;
                                    },
                                    copy: function(e) {
                                        for(var t = 0; t < i; t++)this.chars[t].copy(e.chars[t]);
                                    },
                                    isEmpty: function() {
                                        for(var e = !0, t = 0; t < i; t++)if (!this.chars[t].isEmpty()) {
                                            e = !1;
                                            break;
                                        }
                                        return e;
                                    },
                                    setCursor: function(e) {
                                        this.pos !== e && (this.pos = e), this.pos < 0 ? (c.log("ERROR", "Negative cursor position " + this.pos), this.pos = 0) : this.pos > i && (c.log("ERROR", "Too large cursor position " + this.pos), this.pos = i);
                                    },
                                    moveCursor: function(e) {
                                        var t = this.pos + e;
                                        if (e > 1) for(var n = this.pos + 1; n < t + 1; n++)this.chars[n].setPenState(this.currPenState);
                                        this.setCursor(t);
                                    },
                                    backSpace: function() {
                                        this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
                                    },
                                    insertChar: function(e) {
                                        e >= 144 && this.backSpace();
                                        var t = n(e);
                                        this.pos >= i ? c.log("ERROR", "Cannot insert " + e.toString(16) + " (" + t + ") at position " + this.pos + ". Skipping it!") : (this.chars[this.pos].setChar(t, this.currPenState), this.moveCursor(1));
                                    },
                                    clearFromPos: function(e) {
                                        var t;
                                        for(t = e; t < i; t++)this.chars[t].reset();
                                    },
                                    clear: function() {
                                        this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
                                    },
                                    clearToEndOfRow: function() {
                                        this.clearFromPos(this.pos);
                                    },
                                    getTextString: function() {
                                        for(var e = [], t = !0, n = 0; n < i; n++){
                                            var r = this.chars[n].uchar;
                                            " " !== r && (t = !1), e.push(r);
                                        }
                                        return t ? "" : e.join("");
                                    },
                                    setPenStyles: function(e) {
                                        this.currPenState.setStyles(e), this.chars[this.pos].setPenState(this.currPenState);
                                    }
                                };
                                var p = function() {
                                    this.rows = [];
                                    for(var e = 0; e < r; e++)this.rows.push(new g);
                                    this.currRow = 14, this.nrRollUpRows = null, this.reset();
                                };
                                p.prototype = {
                                    reset: function() {
                                        for(var e = 0; e < r; e++)this.rows[e].clear();
                                        this.currRow = 14;
                                    },
                                    equals: function(e) {
                                        for(var t = !0, n = 0; n < r; n++)if (!this.rows[n].equals(e.rows[n])) {
                                            t = !1;
                                            break;
                                        }
                                        return t;
                                    },
                                    copy: function(e) {
                                        for(var t = 0; t < r; t++)this.rows[t].copy(e.rows[t]);
                                    },
                                    isEmpty: function() {
                                        for(var e = !0, t = 0; t < r; t++)if (!this.rows[t].isEmpty()) {
                                            e = !1;
                                            break;
                                        }
                                        return e;
                                    },
                                    backSpace: function() {
                                        this.rows[this.currRow].backSpace();
                                    },
                                    clearToEndOfRow: function() {
                                        this.rows[this.currRow].clearToEndOfRow();
                                    },
                                    insertChar: function(e) {
                                        this.rows[this.currRow].insertChar(e);
                                    },
                                    setPen: function(e) {
                                        this.rows[this.currRow].setPenStyles(e);
                                    },
                                    moveCursor: function(e) {
                                        this.rows[this.currRow].moveCursor(e);
                                    },
                                    setCursor: function(e) {
                                        c.log("INFO", "setCursor: " + e), this.rows[this.currRow].setCursor(e);
                                    },
                                    setPAC: function(e) {
                                        c.log("INFO", "pacData = " + JSON.stringify(e));
                                        var t = e.row - 1;
                                        this.nrRollUpRows && t < this.nrRollUpRows - 1 && (t = this.nrRollUpRows - 1), this.currRow = t;
                                        var n = this.rows[this.currRow];
                                        if (null !== e.indent) {
                                            var r = e.indent, i = Math.max(r - 1, 0);
                                            n.setCursor(e.indent), e.color = n.chars[i].penState.foreground;
                                        }
                                        var a1 = {
                                            foreground: e.color,
                                            underline: e.underline,
                                            italics: e.italics,
                                            background: "black",
                                            flash: !1
                                        };
                                        this.setPen(a1);
                                    },
                                    setBkgData: function(e) {
                                        c.log("INFO", "bkgData = " + JSON.stringify(e)), this.backSpace(), this.setPen(e), this.insertChar(32);
                                    },
                                    setRollUpRows: function(e) {
                                        this.nrRollUpRows = e;
                                    },
                                    rollUp: function() {
                                        if (null !== this.nrRollUpRows) {
                                            c.log("TEXT", this.getDisplayText());
                                            var e = this.currRow + 1 - this.nrRollUpRows, t = this.rows.splice(e, 1)[0];
                                            t.clear(), this.rows.splice(this.currRow, 0, t), c.log("INFO", "Rolling up");
                                        } else c.log("DEBUG", "roll_up but nrRollUpRows not set yet");
                                    },
                                    getDisplayText: function(e) {
                                        e = e || !1;
                                        for(var t = [], n = "", i = -1, a1 = 0; a1 < r; a1++){
                                            var o = this.rows[a1].getTextString();
                                            o && (i = a1 + 1, e ? t.push("Row " + i + ': "' + o + '"') : t.push(o.trim()));
                                        }
                                        return t.length > 0 && (n = e ? "[" + t.join(" | ") + "]" : t.join("\n")), n;
                                    },
                                    getTextAndFormat: function() {
                                        return this.rows;
                                    }
                                };
                                var m = function(e, t) {
                                    this.chNr = e, this.outputFilter = t, this.mode = null, this.verbose = 0, this.displayedMemory = new p, this.nonDisplayedMemory = new p, this.lastOutputScreen = new p, this.currRollUpRow = this.displayedMemory.rows[14], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
                                };
                                m.prototype = {
                                    modes: [
                                        "MODE_ROLL-UP",
                                        "MODE_POP-ON",
                                        "MODE_PAINT-ON",
                                        "MODE_TEXT"
                                    ],
                                    reset: function() {
                                        this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.currRollUpRow = this.displayedMemory.rows[14], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.lastCueEndTime = null;
                                    },
                                    getHandler: function() {
                                        return this.outputFilter;
                                    },
                                    setHandler: function(e) {
                                        this.outputFilter = e;
                                    },
                                    setPAC: function(e) {
                                        this.writeScreen.setPAC(e);
                                    },
                                    setBkgData: function(e) {
                                        this.writeScreen.setBkgData(e);
                                    },
                                    setMode: function(e) {
                                        e !== this.mode && (this.mode = e, c.log("INFO", "MODE=" + e), "MODE_POP-ON" == this.mode ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), "MODE_ROLL-UP" !== this.mode && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = e);
                                    },
                                    insertChars: function(e) {
                                        for(var t = 0; t < e.length; t++)this.writeScreen.insertChar(e[t]);
                                        var n = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
                                        c.log("INFO", n + ": " + this.writeScreen.getDisplayText(!0)), "MODE_PAINT-ON" !== this.mode && "MODE_ROLL-UP" !== this.mode || (c.log("TEXT", "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
                                    },
                                    cc_RCL: function() {
                                        c.log("INFO", "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
                                    },
                                    cc_BS: function() {
                                        c.log("INFO", "BS - BackSpace"), "MODE_TEXT" !== this.mode && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
                                    },
                                    cc_AOF: function() {},
                                    cc_AON: function() {},
                                    cc_DER: function() {
                                        c.log("INFO", "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
                                    },
                                    cc_RU: function(e) {
                                        c.log("INFO", "RU(" + e + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(e);
                                    },
                                    cc_FON: function() {
                                        c.log("INFO", "FON - Flash On"), this.writeScreen.setPen({
                                            flash: !0
                                        });
                                    },
                                    cc_RDC: function() {
                                        c.log("INFO", "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
                                    },
                                    cc_TR: function() {
                                        c.log("INFO", "TR"), this.setMode("MODE_TEXT");
                                    },
                                    cc_RTD: function() {
                                        c.log("INFO", "RTD"), this.setMode("MODE_TEXT");
                                    },
                                    cc_EDM: function() {
                                        c.log("INFO", "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate();
                                    },
                                    cc_CR: function() {
                                        c.log("CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate();
                                    },
                                    cc_ENM: function() {
                                        c.log("INFO", "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
                                    },
                                    cc_EOC: function() {
                                        if (c.log("INFO", "EOC - End Of Caption"), "MODE_POP-ON" === this.mode) {
                                            var e = this.displayedMemory;
                                            this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = e, this.writeScreen = this.nonDisplayedMemory, c.log("TEXT", "DISP: " + this.displayedMemory.getDisplayText());
                                        }
                                        this.outputDataUpdate();
                                    },
                                    cc_TO: function(e) {
                                        c.log("INFO", "TO(" + e + ") - Tab Offset"), this.writeScreen.moveCursor(e);
                                    },
                                    cc_MIDROW: function(e) {
                                        var t = {
                                            flash: !1
                                        };
                                        if (t.underline = e % 2 == 1, t.italics = e >= 46, t.italics) t.foreground = "white";
                                        else {
                                            var n = Math.floor(e / 2) - 16;
                                            t.foreground = [
                                                "white",
                                                "green",
                                                "blue",
                                                "cyan",
                                                "red",
                                                "yellow",
                                                "magenta"
                                            ][n];
                                        }
                                        c.log("INFO", "MIDROW: " + JSON.stringify(t)), this.writeScreen.setPen(t);
                                    },
                                    outputDataUpdate: function() {
                                        var e = c.time;
                                        null !== e && this.outputFilter && (this.outputFilter.updateData && this.outputFilter.updateData(e, this.displayedMemory), null !== this.cueStartTime || this.displayedMemory.isEmpty() ? this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, e, this.lastOutputScreen), this.cueStartTime = this.displayedMemory.isEmpty() ? null : e) : this.cueStartTime = e, this.lastOutputScreen.copy(this.displayedMemory));
                                    },
                                    cueSplitAtTime: function(e) {
                                        this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, e, this.displayedMemory), this.cueStartTime = e));
                                    }
                                };
                                var v = function(e, t, n) {
                                    this.field = e || 1, this.outputs = [
                                        t,
                                        n
                                    ], this.channels = [
                                        new m(1, t),
                                        new m(2, n)
                                    ], this.currChNr = -1, this.lastCmdA = null, this.lastCmdB = null, this.bufferedData = [], this.startTime = null, this.lastTime = null, this.dataCounters = {
                                        padding: 0,
                                        char: 0,
                                        cmd: 0,
                                        other: 0
                                    };
                                };
                                v.prototype = {
                                    getHandler: function(e) {
                                        return this.channels[e].getHandler();
                                    },
                                    setHandler: function(e, t) {
                                        this.channels[e].setHandler(t);
                                    },
                                    addData: function(e, t) {
                                        var n, r, i, a1 = !1;
                                        this.lastTime = e, c.setTime(e);
                                        for(var o = 0; o < t.length; o += 2)r = 127 & t[o], i = 127 & t[o + 1], r >= 16 && r <= 31 && r === this.lastCmdA && i === this.lastCmdB ? (this.lastCmdA = null, this.lastCmdB = null, c.log("DEBUG", "Repeated command (" + d([
                                            r,
                                            i
                                        ]) + ") is dropped")) : 0 !== r || 0 !== i ? (c.log("DATA", "[" + d([
                                            t[o],
                                            t[o + 1]
                                        ]) + "] -> (" + d([
                                            r,
                                            i
                                        ]) + ")"), (n = this.parseCmd(r, i)) || (n = this.parseMidrow(r, i)), n || (n = this.parsePAC(r, i)), n || (n = this.parseBackgroundAttributes(r, i)), n || (a1 = this.parseChars(r, i)) && (this.currChNr && this.currChNr >= 0 ? this.channels[this.currChNr - 1].insertChars(a1) : c.log("WARNING", "No channel found yet. TEXT-MODE?")), n ? this.dataCounters.cmd += 2 : a1 ? this.dataCounters.char += 2 : (this.dataCounters.other += 2, c.log("WARNING", "Couldn't parse cleaned data " + d([
                                            r,
                                            i
                                        ]) + " orig: " + d([
                                            t[o],
                                            t[o + 1]
                                        ])))) : this.dataCounters.padding += 2;
                                    },
                                    parseCmd: function(e, t) {
                                        var n;
                                        if (!((20 === e || 21 === e || 28 === e || 29 === e) && 32 <= t && t <= 47 || (23 === e || 31 === e) && 33 <= t && t <= 35)) return !1;
                                        n = 20 === e || 21 === e || 23 === e ? 1 : 2;
                                        var r = this.channels[n - 1];
                                        return 20 === e || 21 === e || 28 === e || 29 === e ? 32 === t ? r.cc_RCL() : 33 === t ? r.cc_BS() : 34 === t ? r.cc_AOF() : 35 === t ? r.cc_AON() : 36 === t ? r.cc_DER() : 37 === t ? r.cc_RU(2) : 38 === t ? r.cc_RU(3) : 39 === t ? r.cc_RU(4) : 40 === t ? r.cc_FON() : 41 === t ? r.cc_RDC() : 42 === t ? r.cc_TR() : 43 === t ? r.cc_RTD() : 44 === t ? r.cc_EDM() : 45 === t ? r.cc_CR() : 46 === t ? r.cc_ENM() : 47 === t && r.cc_EOC() : r.cc_TO(t - 32), this.lastCmdA = e, this.lastCmdB = t, this.currChNr = n, !0;
                                    },
                                    parseMidrow: function(e, t) {
                                        var n = null;
                                        if ((17 === e || 25 === e) && 32 <= t && t <= 47) {
                                            if ((n = 17 === e ? 1 : 2) !== this.currChNr) return c.log("ERROR", "Mismatch channel in midrow parsing"), !1;
                                            var r = this.channels[n - 1];
                                            return r.insertChars([
                                                32
                                            ]), r.cc_MIDROW(t), c.log("DEBUG", "MIDROW (" + d([
                                                e,
                                                t
                                            ]) + ")"), this.lastCmdA = e, this.lastCmdB = t, !0;
                                        }
                                        return !1;
                                    },
                                    parsePAC: function(e, t) {
                                        var n, r;
                                        if (!((17 <= e && e <= 23 || 25 <= e && e <= 31) && 64 <= t && t <= 127 || (16 === e || 24 === e) && 64 <= t && t <= 95)) return !1;
                                        n = e <= 23 ? 1 : 2, r = 64 <= t && t <= 95 ? 1 === n ? a1[e] : s1[e] : 1 === n ? o[e] : u[e];
                                        var i = this.interpretPAC(r, t);
                                        return this.channels[n - 1].setPAC(i), this.lastCmdA = e, this.lastCmdB = t, this.currChNr = n, !0;
                                    },
                                    interpretPAC: function(e, t) {
                                        var n, r = {
                                            color: null,
                                            italics: !1,
                                            indent: null,
                                            underline: !1,
                                            row: e
                                        };
                                        return n = t > 95 ? t - 96 : t - 64, r.underline = 1 == (1 & n), n <= 13 ? r.color = [
                                            "white",
                                            "green",
                                            "blue",
                                            "cyan",
                                            "red",
                                            "yellow",
                                            "magenta",
                                            "white"
                                        ][Math.floor(n / 2)] : n <= 15 ? (r.italics = !0, r.color = "white") : r.indent = 4 * Math.floor((n - 16) / 2), r;
                                    },
                                    parseChars: function(e, t) {
                                        var r = null, i = null, a1 = null;
                                        if (e >= 25 ? (r = 2, a1 = e - 8) : (r = 1, a1 = e), 17 <= a1 && a1 <= 19) {
                                            var o;
                                            o = 17 === a1 ? t + 80 : 18 === a1 ? t + 112 : t + 144, c.log("INFO", "Special char '" + n(o) + "' in channel " + r), i = [
                                                o
                                            ], this.lastCmdA = e, this.lastCmdB = t;
                                        } else 32 <= e && e <= 127 && (i = 0 === t ? [
                                            e
                                        ] : [
                                            e,
                                            t
                                        ], this.lastCmdA = null, this.lastCmdB = null);
                                        if (i) {
                                            var s1 = d(i);
                                            c.log("DEBUG", "Char codes =  " + s1.join(","));
                                        }
                                        return i;
                                    },
                                    parseBackgroundAttributes: function(e, t) {
                                        var n, r, i;
                                        return ((16 === e || 24 === e) && 32 <= t && t <= 47 || (23 === e || 31 === e) && 45 <= t && t <= 47) && (n = {}, 16 === e || 24 === e ? (r = Math.floor((t - 32) / 2), n.background = l[r], t % 2 == 1 && (n.background = n.background + "_semi")) : 45 === t ? n.background = "transparent" : (n.foreground = "black", 47 === t && (n.underline = !0)), i = e < 24 ? 1 : 2, this.channels[i - 1].setBkgData(n), this.lastCmdA = e, this.lastCmdB = t, !0);
                                    },
                                    reset: function() {
                                        for(var e = 0; e < this.channels.length; e++)this.channels[e] && this.channels[e].reset();
                                        this.lastCmdA = null, this.lastCmdB = null;
                                    },
                                    cueSplitAtTime: function(e) {
                                        for(var t = 0; t < this.channels.length; t++)this.channels[t] && this.channels[t].cueSplitAtTime(e);
                                    }
                                }, e.logger = c, e.PenState = f, e.CaptionScreen = p, e.Cea608Parser = v, e.findCea608Nalus = function(e, t, n) {
                                    for(var r = 0, i = t, a1 = [], o = function(e, t, n, r) {
                                        if (4 !== e || t < 8) return null;
                                        var i = n.getUint8(r), a1 = n.getUint16(r + 1), o = n.getUint32(r + 3), s1 = n.getUint8(r + 7);
                                        return 181 == i && 49 == a1 && 1195456820 == o && 3 == s1;
                                    }; i < t + n;){
                                        if (r = e.getUint32(i), 6 == (31 & e.getUint8(i + 4))) for(var s1 = i + 5, u = -1; s1 < i + 4 + r - 1;){
                                            u = 0;
                                            for(var l = 255; 255 === l;)u += l = e.getUint8(s1), s1++;
                                            var c = 0;
                                            for(l = 255; 255 === l;)c += l = e.getUint8(s1), s1++;
                                            o(u, c, e, s1) && a1.push([
                                                s1,
                                                c
                                            ]), s1 += c;
                                        }
                                        i += r + 4;
                                    }
                                    return a1;
                                }, e.extractCea608DataFromRange = function(e, t) {
                                    var n = t[0], r = [
                                        [],
                                        []
                                    ];
                                    n += 8;
                                    var i = 31 & e.getUint8(n);
                                    n += 2;
                                    for(var a1 = 0; a1 < i; a1++){
                                        var o = e.getUint8(n), s1 = 4 & o, u = 3 & o;
                                        n++;
                                        var l = e.getUint8(n);
                                        n++;
                                        var c = e.getUint8(n);
                                        n++, s1 && (127 & l) + (127 & c) != 0 && (0 === u ? (r[0].push(l), r[0].push(c)) : 1 === u && (r[1].push(l), r[1].push(c)));
                                    }
                                    return r;
                                };
                            }(t);
                        },
                        "./externals/xml2json.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function(e) {
                                void 0 === (e = e || {}).escapeMode && (e.escapeMode = !0), void 0 === e.attributePrefix && (e.attributePrefix = "_"), e.arrayAccessForm = e.arrayAccessForm || "none", e.emptyNodeForm = e.emptyNodeForm || "text", void 0 === e.enableToStringFunc && (e.enableToStringFunc = !0), e.arrayAccessFormPaths = e.arrayAccessFormPaths || [], void 0 === e.skipEmptyTextNodesForObj && (e.skipEmptyTextNodesForObj = !0), void 0 === e.stripWhitespaces && (e.stripWhitespaces = !0), e.datetimeAccessFormPaths = e.datetimeAccessFormPaths || [], void 0 === e.useDoubleQuotes && (e.useDoubleQuotes = !1), e.xmlElementsFilter = e.xmlElementsFilter || [], e.jsonPropertiesFilter = e.jsonPropertiesFilter || [], void 0 === e.keepCData && (e.keepCData = !1), void 0 === e.ignoreRoot && (e.ignoreRoot = !1);
                                function t(e) {
                                    var t = e.localName;
                                    return null == t && (t = e.baseName), null != t && "" != t || (t = e.nodeName), t;
                                }
                                function n(e) {
                                    return "string" == typeof e ? e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;") : e;
                                }
                                function r(e, t, n, r) {
                                    for(var i = 0; i < e.length; i++){
                                        var a1 = e[i];
                                        if ("string" == typeof a1) {
                                            if (a1 == r) break;
                                        } else if (a1 instanceof RegExp) {
                                            if (a1.test(r)) break;
                                        } else if ("function" == typeof a1 && a1(t, n, r)) break;
                                    }
                                    return i != e.length;
                                }
                                function i(t, n, i) {
                                    "property" === e.arrayAccessForm && (t[n] instanceof Array ? t[n + "_asArray"] = t[n] : t[n + "_asArray"] = [
                                        t[n]
                                    ]), !(t[n] instanceof Array) && e.arrayAccessFormPaths.length > 0 && r(e.arrayAccessFormPaths, t, n, i) && (t[n] = [
                                        t[n]
                                    ]);
                                }
                                function a1(e) {
                                    var t = e.split(/[-T:+Z]/g), n = new Date(t[0], t[1] - 1, t[2]), r = t[5].split(".");
                                    if (n.setHours(t[3], t[4], r[0]), r.length > 1 && n.setMilliseconds(r[1]), t[6] && t[7]) {
                                        var i = 60 * t[6] + Number(t[7]);
                                        i = 0 + ("-" == (/\d\d-\d\d:\d\d$/.test(e) ? "-" : "+") ? -1 * i : i), n.setMinutes(n.getMinutes() - i - n.getTimezoneOffset());
                                    } else -1 !== e.indexOf("Z", e.length - 1) && (n = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds())));
                                    return n;
                                }
                                function o(t, n, i, a1) {
                                    return !(1 == n && e.xmlElementsFilter.length > 0) || r(e.xmlElementsFilter, t, i, a1);
                                }
                                function s1(n, u) {
                                    if (9 == n.nodeType) {
                                        for(var l = new Object, c = n.childNodes, d = 0; d < c.length; d++)1 == (h = c[d]).nodeType && (e.ignoreRoot ? l = s1(h) : (l = {})[g = t(h)] = s1(h));
                                        return l;
                                    }
                                    if (1 == n.nodeType) {
                                        (l = new Object).__cnt = 0;
                                        var f = [];
                                        for(c = n.childNodes, d = 0; d < c.length; d++){
                                            var h, g = t(h = c[d]);
                                            if (8 != h.nodeType) {
                                                var p = u + "." + g;
                                                if (o(l, h.nodeType, g, p)) {
                                                    if (l.__cnt++, null == l[g]) {
                                                        var m = s1(h, p);
                                                        ("#text" != g || /[^\s]/.test(m)) && ((v = {})[g] = m, f.push(v)), l[g] = m, i(l, g, p);
                                                    } else {
                                                        var v;
                                                        null != l[g] && (l[g] instanceof Array || (l[g] = [
                                                            l[g]
                                                        ], i(l, g, p))), m = s1(h, p), ("#text" != g || /[^\s]/.test(m)) && ((v = {})[g] = m, f.push(v)), l[g][l[g].length] = m;
                                                    }
                                                }
                                            }
                                        }
                                        l.__children = f;
                                        for(var y = t(n), E = 0; E < n.attributes.length; E++){
                                            var T = n.attributes[E];
                                            l.__cnt++;
                                            for(var b = T.value, A = 0, _ = e.matchers.length; A < _; A++){
                                                var S = e.matchers[A];
                                                S.test(T, y) && (b = S.converter(T.value));
                                            }
                                            l[e.attributePrefix + T.name] = b;
                                        }
                                        var w = function(e) {
                                            return e.prefix;
                                        }(n);
                                        return null != w && "" != w && (l.__cnt++, l.__prefix = w), null != l["#text"] && (l.__text = l["#text"], l.__text instanceof Array && (l.__text = l.__text.join("\n")), e.stripWhitespaces && (l.__text = l.__text.trim()), delete l["#text"], "property" == e.arrayAccessForm && delete l["#text_asArray"], l.__text = function(t, n, i) {
                                            if (e.datetimeAccessFormPaths.length > 0) {
                                                var o = i.split(".#")[0];
                                                return r(e.datetimeAccessFormPaths, t, n, o) ? a1(t) : t;
                                            }
                                            return t;
                                        }(l.__text, g, u + "." + g)), null != l["#cdata-section"] && (l.__cdata = l["#cdata-section"], delete l["#cdata-section"], "property" == e.arrayAccessForm && delete l["#cdata-section_asArray"]), 0 == l.__cnt && "text" == e.emptyNodeForm ? l = "" : 1 == l.__cnt && null != l.__text ? l = l.__text : 1 != l.__cnt || null == l.__cdata || e.keepCData ? l.__cnt > 1 && null != l.__text && e.skipEmptyTextNodesForObj && (e.stripWhitespaces && "" == l.__text || "" == l.__text.trim()) && delete l.__text : l = l.__cdata, delete l.__cnt, !e.enableToStringFunc || null == l.__text && null == l.__cdata || (l.toString = function() {
                                            return (null != this.__text ? this.__text : "") + (null != this.__cdata ? this.__cdata : "");
                                        }), l;
                                    }
                                    if (3 == n.nodeType || 4 == n.nodeType) return n.nodeValue;
                                }
                                function u(t, r, i, a1) {
                                    var o = "<" + (null != t && null != t.__prefix ? t.__prefix + ":" : "") + r;
                                    if (null != i) for(var s1 = 0; s1 < i.length; s1++){
                                        var u = i[s1], l = t[u];
                                        e.escapeMode && (l = n(l)), o += " " + u.substr(e.attributePrefix.length) + "=", e.useDoubleQuotes ? o += '"' + l + '"' : o += "'" + l + "'";
                                    }
                                    return o + (a1 ? "/>" : ">");
                                }
                                function l(e, t) {
                                    return "</" + (null != e.__prefix ? e.__prefix + ":" : "") + t + ">";
                                }
                                function c(t, n) {
                                    var r, i;
                                    return "property" == e.arrayAccessForm && (i = "_asArray", -1 !== (r = n.toString()).indexOf(i, r.length - i.length)) || 0 == n.toString().indexOf(e.attributePrefix) || 0 == n.toString().indexOf("__") || t[n] instanceof Function;
                                }
                                function d(e) {
                                    var t = 0;
                                    if (e instanceof Object) for(var n in e)c(e, n) || t++;
                                    return t;
                                }
                                function f(t, n, i) {
                                    return 0 == e.jsonPropertiesFilter.length || "" == i || r(e.jsonPropertiesFilter, t, n, i);
                                }
                                function h(t) {
                                    var n = [];
                                    if (t instanceof Object) for(var r in t)-1 == r.toString().indexOf("__") && 0 == r.toString().indexOf(e.attributePrefix) && n.push(r);
                                    return n;
                                }
                                function g(t) {
                                    var r = "";
                                    return t instanceof Object ? r += function(t) {
                                        var r = "";
                                        return null != t.__cdata && (r += "<![CDATA[" + t.__cdata + "]]>"), null != t.__text && (e.escapeMode ? r += n(t.__text) : r += t.__text), r;
                                    }(t) : null != t && (e.escapeMode ? r += n(t) : r += t), r;
                                }
                                function p(e, t) {
                                    return "" === e ? t : e + "." + t;
                                }
                                function m(e, t, n, r) {
                                    var i = "";
                                    if (0 == e.length) i += u(e, t, n, !0);
                                    else for(var a1 = 0; a1 < e.length; a1++)i += u(e[a1], t, h(e[a1]), !1), i += v(e[a1], p(r, t)), i += l(e[a1], t);
                                    return i;
                                }
                                function v(e, t) {
                                    var n = "";
                                    if (d(e) > 0) {
                                        for(var r in e)if (!c(e, r) && ("" == t || f(e, r, p(t, r)))) {
                                            var i = e[r], a1 = h(i);
                                            null == i || null == i ? n += u(i, r, a1, !0) : i instanceof Object ? i instanceof Array ? n += m(i, r, a1, t) : i instanceof Date ? (n += u(i, r, a1, !1), n += i.toISOString(), n += l(i, r)) : d(i) > 0 || null != i.__text || null != i.__cdata ? (n += u(i, r, a1, !1), n += v(i, p(t, r)), n += l(i, r)) : n += u(i, r, a1, !0) : (n += u(i, r, a1, !1), n += g(i), n += l(i, r));
                                        }
                                    }
                                    return n + g(e);
                                }
                                this.parseXmlString = function(e) {
                                    var t;
                                    if (window.ActiveXObject || window, void 0 === e) return null;
                                    if (window.DOMParser) {
                                        var n = new window.DOMParser;
                                        try {
                                            (t = n.parseFromString(e, "text/xml")).getElementsByTagNameNS("*", "parsererror").length > 0 && (t = null);
                                        } catch (e) {
                                            t = null;
                                        }
                                    } else 0 == e.indexOf("<?") && (e = e.substr(e.indexOf("?>") + 2)), (t = new ActiveXObject("Microsoft.XMLDOM")).async = "false", t.loadXML(e);
                                    return t;
                                }, this.asArray = function(e) {
                                    return void 0 === e || null == e ? [] : e instanceof Array ? e : [
                                        e
                                    ];
                                }, this.toXmlDateTime = function(e) {
                                    return e instanceof Date ? e.toISOString() : "number" == typeof e ? new Date(e).toISOString() : null;
                                }, this.asDateTime = function(e) {
                                    return "string" == typeof e ? a1(e) : e;
                                }, this.xml2json = function(e) {
                                    return s1(e);
                                }, this.xml_str2json = function(e) {
                                    var t = this.parseXmlString(e);
                                    return null != t ? this.xml2json(t) : null;
                                }, this.json2xml_str = function(e) {
                                    return v(e, "");
                                }, this.json2xml = function(e) {
                                    var t = this.json2xml_str(e);
                                    return this.parseXmlString(t);
                                }, this.getVersion = function() {
                                    return "1.2.0";
                                };
                            };
                        },
                        "./index.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./index_mediaplayerOnly.js");
                            n.d(t, "MediaPlayer", function() {
                                return r.MediaPlayer;
                            });
                            var i = n("./src/streaming/utils/Capabilities.js");
                            n.d(t, "supportsMediaSource", function() {
                                return i.supportsMediaSource;
                            });
                            var a1 = n("./src/streaming/metrics/MetricsReporting.js");
                            n.d(t, "MetricsReporting", function() {
                                return a1.default;
                            });
                            var o = n("./src/streaming/protection/Protection.js");
                            n.d(t, "Protection", function() {
                                return o.default;
                            });
                            var s1 = n("./src/streaming/MediaPlayerFactory.js");
                            n.d(t, "MediaPlayerFactory", function() {
                                return s1.default;
                            });
                            var u = n("./src/core/Debug.js");
                            n.d(t, "Debug", function() {
                                return u.default;
                            }), dashjs.Protection = o.default, dashjs.MetricsReporting = a1.default, dashjs.MediaPlayerFactory = s1.default, dashjs.Debug = u.default, dashjs.supportsMediaSource = i.supportsMediaSource, t.default = dashjs;
                        },
                        "./index_mediaplayerOnly.js": function(e, t, n) {
                            "use strict";
                            n.r(t), (function(e) {
                                var r = n("./src/streaming/MediaPlayer.js");
                                n.d(t, "MediaPlayer", function() {
                                    return r.default;
                                });
                                var i = n("./src/core/FactoryMaker.js");
                                n.d(t, "FactoryMaker", function() {
                                    return i.default;
                                });
                                var a1 = n("./src/core/Debug.js");
                                n.d(t, "Debug", function() {
                                    return a1.default;
                                });
                                var o = n("./src/core/Version.js"), s1 = (n("./node_modules/es6-promise/auto.js"), "undefined" != typeof window && window || e), u = s1.dashjs;
                                u || (u = s1.dashjs = {}), u.MediaPlayer = r.default, u.FactoryMaker = i.default, u.Debug = a1.default, u.Version = Object(o.getVersionString)(), t.default = u;
                            }).call(this, n("./node_modules/webpack/buildin/global.js"));
                        },
                        "./node_modules/base64-js/index.js": function(e, t, n) {
                            "use strict";
                            t.byteLength = function(e) {
                                var t = l(e), n = t[0], r = t[1];
                                return 3 * (n + r) / 4 - r;
                            }, t.toByteArray = function(e) {
                                for(var t, n = l(e), r = n[0], o = n[1], s1 = new a1(function(e, t, n) {
                                    return 3 * (t + n) / 4 - n;
                                }(0, r, o)), u = 0, c = o > 0 ? r - 4 : r, d = 0; d < c; d += 4)t = i[e.charCodeAt(d)] << 18 | i[e.charCodeAt(d + 1)] << 12 | i[e.charCodeAt(d + 2)] << 6 | i[e.charCodeAt(d + 3)], s1[u++] = t >> 16 & 255, s1[u++] = t >> 8 & 255, s1[u++] = 255 & t;
                                return 2 === o && (t = i[e.charCodeAt(d)] << 2 | i[e.charCodeAt(d + 1)] >> 4, s1[u++] = 255 & t), 1 === o && (t = i[e.charCodeAt(d)] << 10 | i[e.charCodeAt(d + 1)] << 4 | i[e.charCodeAt(d + 2)] >> 2, s1[u++] = t >> 8 & 255, s1[u++] = 255 & t), s1;
                            }, t.fromByteArray = function(e) {
                                for(var t, n = e.length, i = n % 3, a1 = [], o = 16383, s1 = 0, u = n - i; s1 < u; s1 += o)a1.push(c(e, s1, s1 + o > u ? u : s1 + o));
                                return 1 === i ? (t = e[n - 1], a1.push(r[t >> 2] + r[t << 4 & 63] + "==")) : 2 === i && (t = (e[n - 2] << 8) + e[n - 1], a1.push(r[t >> 10] + r[t >> 4 & 63] + r[t << 2 & 63] + "=")), a1.join("");
                            };
                            for(var r = [], i = [], a1 = "undefined" != typeof Uint8Array ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s1 = 0, u = o.length; s1 < u; ++s1)r[s1] = o[s1], i[o.charCodeAt(s1)] = s1;
                            function l(e) {
                                var t = e.length;
                                if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                                var n = e.indexOf("=");
                                return -1 === n && (n = t), [
                                    n,
                                    n === t ? 0 : 4 - n % 4
                                ];
                            }
                            function c(e, t, n) {
                                for(var i, a1, o = [], s1 = t; s1 < n; s1 += 3)i = (e[s1] << 16 & 16711680) + (e[s1 + 1] << 8 & 65280) + (255 & e[s1 + 2]), o.push(r[(a1 = i) >> 18 & 63] + r[a1 >> 12 & 63] + r[a1 >> 6 & 63] + r[63 & a1]);
                                return o.join("");
                            }
                            i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
                        },
                        "./node_modules/bcp-47-match/index.js": function(e, t, n) {
                            "use strict";
                            function r(e, t) {
                                return function(n, r) {
                                    for(var a1, o, s1, u = i(n, "tag"), l = i(null == r ? "*" : r, "range"), c = [], d = -1; ++d < l.length;)if (a1 = l[d].toLowerCase(), t || "*" !== a1) {
                                        for(o = -1, s1 = []; ++o < u.length;)if (e(u[o].toLowerCase(), a1)) {
                                            if (!t) return u[o];
                                            c.push(u[o]);
                                        } else s1.push(u[o]);
                                        u = s1;
                                    }
                                    return t ? c : void 0;
                                };
                            }
                            function i(e, t) {
                                var n = e && "string" == typeof e ? [
                                    e
                                ] : e;
                                if (!n || "object" != typeof n || !("length" in n)) throw new Error("Invalid " + t + " `" + n + "`, expected non-empty string");
                                return n;
                            }
                            t.basicFilter = r(function(e, t) {
                                return "*" === t || e === t || e.indexOf(t + "-") > -1;
                            }, !0), t.extendedFilter = r(function(e, t) {
                                var n = e.split("-"), r = t.split("-"), i = 0, a1 = 0;
                                if ("*" !== r[a1] && n[i] !== r[a1]) return !1;
                                for(i++, a1++; a1 < r.length;)if ("*" !== r[a1]) {
                                    if (!n[i]) return !1;
                                    if (n[i] !== r[a1]) {
                                        if (1 === n[i].length) return !1;
                                        i++;
                                    } else i++, a1++;
                                } else a1++;
                                return !0;
                            }, !0), t.lookup = r(function(e, t) {
                                for(var n, r = t;;){
                                    if ("*" === r || e === r) return !0;
                                    if ((n = r.lastIndexOf("-")) < 0) return !1;
                                    "-" === r.charAt(n - 2) && (n -= 2), r = r.slice(0, n);
                                }
                            });
                        },
                        "./node_modules/bcp-47-normalize/index.js": function(e, t, n) {
                            "use strict";
                            e.exports = n("./node_modules/bcp-47-normalize/lib/index.js");
                        },
                        "./node_modules/bcp-47-normalize/lib/defaults.json": function(e) {
                            e.exports = JSON.parse('["mni-beng-in","mni-mtei-in","sat-deva-in","sat-olck-in","shi-latn-ma","shi-tfng-ma","vai-latn-lr","vai-vaii-lr","yue-hans-cn","yue-hant-hk","az-arab-ir","az-cyrl-az","az-latn-az","bm-nkoo-ml","bs-cyrl-ba","bs-latn-ba","en-dsrt-us","ff-adlm-gn","ff-latn-sn","ha-arab-ng","hi-latn-in","iu-latn-ca","ks-arab-in","ks-deva-in","mn-mong-cn","ms-arab-my","pa-arab-pk","pa-guru-in","sd-arab-pk","sd-deva-in","sr-cyrl-rs","sr-latn-rs","su-latn-id","uz-arab-af","uz-cyrl-uz","uz-latn-uz","zh-hans-cn","zh-hant-tw","mni-beng","sat-olck","shi-tfng","vai-vaii","yue-hant","az-latn","bs-latn","ff-latn","jbo-001","ks-arab","pa-guru","prg-001","sd-arab","sr-cyrl","su-latn","uz-latn","zh-hans","agq-cm","ar-001","arn-cl","asa-tz","ast-es","bas-cm","bem-zm","bez-tz","bgn-pk","blt-vn","brx-in","bss-cm","byn-er","cad-us","cch-ng","ccp-bd","ceb-ph","cgg-ug","chr-us","cic-us","ckb-iq","dav-ke","dje-ne","doi-in","dsb-de","dua-cm","dyo-sn","ebu-ke","eo-001","ewo-cm","fil-ph","fur-it","gaa-gh","gez-et","gsw-ch","guz-ke","haw-us","hsb-de","ia-001","ife-tg","io-001","jgo-cm","jmc-tz","kab-dz","kaj-ng","kam-ke","kcg-ng","kde-tz","kea-cv","ken-cm","khq-ml","kkj-cm","kln-ke","kok-in","kpe-lr","ksb-tz","ksf-cm","ksh-de","lag-tz","lkt-us","lrc-ir","luo-ke","luy-ke","mai-in","mas-ke","mer-ke","mfe-mu","mgh-mz","mgo-cm","moh-ca","mua-cm","mus-us","myv-ru","mzn-ir","naq-na","nds-de","nmg-cm","nnh-cm","nqo-gn","nso-za","nus-ss","nyn-ug","osa-us","pcm-ng","quc-gt","rof-tz","rwk-tz","sah-ru","saq-ke","sbp-tz","scn-it","sdh-ir","seh-mz","ses-ml","sid-et","sma-se","smj-se","smn-fi","sms-fi","ssy-er","syr-iq","szl-pl","teo-ug","tig-er","trv-tw","trw-pk","twq-ne","tzm-ma","vo-001","vun-tz","wae-ch","wal-et","wbp-au","xog-ug","yav-cm","yi-001","zgh-ma","aa-et","af-za","ak-gh","am-et","an-es","as-in","ba-ru","be-by","bg-bg","bm-ml","bn-bd","bo-cn","br-fr","ca-es","ce-ru","co-fr","cs-cz","cu-ru","cv-ru","cy-gb","da-dk","de-de","dv-mv","dz-bt","ee-gh","el-gr","en-us","es-es","et-ee","eu-es","fa-ir","fi-fi","fo-fo","fr-fr","fy-nl","ga-ie","gd-gb","gl-es","gn-py","gu-in","gv-im","ha-ng","he-il","hi-in","hr-hr","hu-hu","hy-am","id-id","ig-ng","ii-cn","is-is","it-it","iu-ca","ja-jp","jv-id","ka-ge","ki-ke","kk-kz","kl-gl","km-kh","kn-in","ko-kr","ku-tr","kw-gb","ky-kg","lb-lu","lg-ug","ln-cd","lo-la","lt-lt","lu-cd","lv-lv","mg-mg","mi-nz","mk-mk","ml-in","mn-mn","mr-in","ms-my","mt-mt","my-mm","nb-no","nd-zw","ne-np","nl-nl","nn-no","nr-za","nv-us","ny-mw","oc-fr","om-et","or-in","os-ge","pl-pl","ps-af","pt-br","qu-pe","rm-ch","rn-bi","ro-ro","ru-ru","rw-rw","sa-in","sc-it","se-no","sg-cf","si-lk","sk-sk","sl-si","sn-zw","so-so","sq-al","ss-za","st-za","sv-se","sw-tz","ta-in","te-in","tg-tj","th-th","ti-et","tk-tm","tn-za","to-to","tr-tr","ts-za","tt-ru","ug-cn","uk-ua","ur-pk","ve-za","vi-vn","wa-be","wo-sn","xh-za","yo-ng","zu-za"]');
                        },
                        "./node_modules/bcp-47-normalize/lib/fields.json": function(e) {
                            e.exports = JSON.parse('[{"from":{"field":"script","value":"qaai"},"to":{"field":"script","value":"zinh"}},{"from":{"field":"region","value":"bu"},"to":{"field":"region","value":"mm"}},{"from":{"field":"region","value":"ct"},"to":{"field":"region","value":"ki"}},{"from":{"field":"region","value":"dd"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"dy"},"to":{"field":"region","value":"bj"}},{"from":{"field":"region","value":"fx"},"to":{"field":"region","value":"fr"}},{"from":{"field":"region","value":"hv"},"to":{"field":"region","value":"bf"}},{"from":{"field":"region","value":"jt"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"mi"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"nh"},"to":{"field":"region","value":"vu"}},{"from":{"field":"region","value":"nq"},"to":{"field":"region","value":"aq"}},{"from":{"field":"region","value":"pu"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"pz"},"to":{"field":"region","value":"pa"}},{"from":{"field":"region","value":"qu"},"to":{"field":"region","value":"eu"}},{"from":{"field":"region","value":"rh"},"to":{"field":"region","value":"zw"}},{"from":{"field":"region","value":"tp"},"to":{"field":"region","value":"tl"}},{"from":{"field":"region","value":"uk"},"to":{"field":"region","value":"gb"}},{"from":{"field":"region","value":"vd"},"to":{"field":"region","value":"vn"}},{"from":{"field":"region","value":"wk"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"yd"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"zr"},"to":{"field":"region","value":"cd"}},{"from":{"field":"region","value":"230"},"to":{"field":"region","value":"et"}},{"from":{"field":"region","value":"280"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"736"},"to":{"field":"region","value":"sd"}},{"from":{"field":"region","value":"886"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"958"},"to":{"field":"region","value":"aa"}},{"from":{"field":"region","value":"020"},"to":{"field":"region","value":"ad"}},{"from":{"field":"region","value":"784"},"to":{"field":"region","value":"ae"}},{"from":{"field":"region","value":"004"},"to":{"field":"region","value":"af"}},{"from":{"field":"region","value":"028"},"to":{"field":"region","value":"ag"}},{"from":{"field":"region","value":"660"},"to":{"field":"region","value":"ai"}},{"from":{"field":"region","value":"008"},"to":{"field":"region","value":"al"}},{"from":{"field":"region","value":"051"},"to":{"field":"region","value":"am"}},{"from":{"field":"region","value":"024"},"to":{"field":"region","value":"ao"}},{"from":{"field":"region","value":"010"},"to":{"field":"region","value":"aq"}},{"from":{"field":"region","value":"032"},"to":{"field":"region","value":"ar"}},{"from":{"field":"region","value":"016"},"to":{"field":"region","value":"as"}},{"from":{"field":"region","value":"040"},"to":{"field":"region","value":"at"}},{"from":{"field":"region","value":"036"},"to":{"field":"region","value":"au"}},{"from":{"field":"region","value":"533"},"to":{"field":"region","value":"aw"}},{"from":{"field":"region","value":"248"},"to":{"field":"region","value":"ax"}},{"from":{"field":"region","value":"031"},"to":{"field":"region","value":"az"}},{"from":{"field":"region","value":"070"},"to":{"field":"region","value":"ba"}},{"from":{"field":"region","value":"052"},"to":{"field":"region","value":"bb"}},{"from":{"field":"region","value":"050"},"to":{"field":"region","value":"bd"}},{"from":{"field":"region","value":"056"},"to":{"field":"region","value":"be"}},{"from":{"field":"region","value":"854"},"to":{"field":"region","value":"bf"}},{"from":{"field":"region","value":"100"},"to":{"field":"region","value":"bg"}},{"from":{"field":"region","value":"048"},"to":{"field":"region","value":"bh"}},{"from":{"field":"region","value":"108"},"to":{"field":"region","value":"bi"}},{"from":{"field":"region","value":"204"},"to":{"field":"region","value":"bj"}},{"from":{"field":"region","value":"652"},"to":{"field":"region","value":"bl"}},{"from":{"field":"region","value":"060"},"to":{"field":"region","value":"bm"}},{"from":{"field":"region","value":"096"},"to":{"field":"region","value":"bn"}},{"from":{"field":"region","value":"068"},"to":{"field":"region","value":"bo"}},{"from":{"field":"region","value":"535"},"to":{"field":"region","value":"bq"}},{"from":{"field":"region","value":"076"},"to":{"field":"region","value":"br"}},{"from":{"field":"region","value":"044"},"to":{"field":"region","value":"bs"}},{"from":{"field":"region","value":"064"},"to":{"field":"region","value":"bt"}},{"from":{"field":"region","value":"104"},"to":{"field":"region","value":"mm"}},{"from":{"field":"region","value":"074"},"to":{"field":"region","value":"bv"}},{"from":{"field":"region","value":"072"},"to":{"field":"region","value":"bw"}},{"from":{"field":"region","value":"112"},"to":{"field":"region","value":"by"}},{"from":{"field":"region","value":"084"},"to":{"field":"region","value":"bz"}},{"from":{"field":"region","value":"124"},"to":{"field":"region","value":"ca"}},{"from":{"field":"region","value":"166"},"to":{"field":"region","value":"cc"}},{"from":{"field":"region","value":"180"},"to":{"field":"region","value":"cd"}},{"from":{"field":"region","value":"140"},"to":{"field":"region","value":"cf"}},{"from":{"field":"region","value":"178"},"to":{"field":"region","value":"cg"}},{"from":{"field":"region","value":"756"},"to":{"field":"region","value":"ch"}},{"from":{"field":"region","value":"384"},"to":{"field":"region","value":"ci"}},{"from":{"field":"region","value":"184"},"to":{"field":"region","value":"ck"}},{"from":{"field":"region","value":"152"},"to":{"field":"region","value":"cl"}},{"from":{"field":"region","value":"120"},"to":{"field":"region","value":"cm"}},{"from":{"field":"region","value":"156"},"to":{"field":"region","value":"cn"}},{"from":{"field":"region","value":"170"},"to":{"field":"region","value":"co"}},{"from":{"field":"region","value":"188"},"to":{"field":"region","value":"cr"}},{"from":{"field":"region","value":"192"},"to":{"field":"region","value":"cu"}},{"from":{"field":"region","value":"132"},"to":{"field":"region","value":"cv"}},{"from":{"field":"region","value":"531"},"to":{"field":"region","value":"cw"}},{"from":{"field":"region","value":"162"},"to":{"field":"region","value":"cx"}},{"from":{"field":"region","value":"196"},"to":{"field":"region","value":"cy"}},{"from":{"field":"region","value":"203"},"to":{"field":"region","value":"cz"}},{"from":{"field":"region","value":"278"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"276"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"262"},"to":{"field":"region","value":"dj"}},{"from":{"field":"region","value":"208"},"to":{"field":"region","value":"dk"}},{"from":{"field":"region","value":"212"},"to":{"field":"region","value":"dm"}},{"from":{"field":"region","value":"214"},"to":{"field":"region","value":"do"}},{"from":{"field":"region","value":"012"},"to":{"field":"region","value":"dz"}},{"from":{"field":"region","value":"218"},"to":{"field":"region","value":"ec"}},{"from":{"field":"region","value":"233"},"to":{"field":"region","value":"ee"}},{"from":{"field":"region","value":"818"},"to":{"field":"region","value":"eg"}},{"from":{"field":"region","value":"732"},"to":{"field":"region","value":"eh"}},{"from":{"field":"region","value":"232"},"to":{"field":"region","value":"er"}},{"from":{"field":"region","value":"724"},"to":{"field":"region","value":"es"}},{"from":{"field":"region","value":"231"},"to":{"field":"region","value":"et"}},{"from":{"field":"region","value":"246"},"to":{"field":"region","value":"fi"}},{"from":{"field":"region","value":"242"},"to":{"field":"region","value":"fj"}},{"from":{"field":"region","value":"238"},"to":{"field":"region","value":"fk"}},{"from":{"field":"region","value":"583"},"to":{"field":"region","value":"fm"}},{"from":{"field":"region","value":"234"},"to":{"field":"region","value":"fo"}},{"from":{"field":"region","value":"250"},"to":{"field":"region","value":"fr"}},{"from":{"field":"region","value":"249"},"to":{"field":"region","value":"fr"}},{"from":{"field":"region","value":"266"},"to":{"field":"region","value":"ga"}},{"from":{"field":"region","value":"826"},"to":{"field":"region","value":"gb"}},{"from":{"field":"region","value":"308"},"to":{"field":"region","value":"gd"}},{"from":{"field":"region","value":"268"},"to":{"field":"region","value":"ge"}},{"from":{"field":"region","value":"254"},"to":{"field":"region","value":"gf"}},{"from":{"field":"region","value":"831"},"to":{"field":"region","value":"gg"}},{"from":{"field":"region","value":"288"},"to":{"field":"region","value":"gh"}},{"from":{"field":"region","value":"292"},"to":{"field":"region","value":"gi"}},{"from":{"field":"region","value":"304"},"to":{"field":"region","value":"gl"}},{"from":{"field":"region","value":"270"},"to":{"field":"region","value":"gm"}},{"from":{"field":"region","value":"324"},"to":{"field":"region","value":"gn"}},{"from":{"field":"region","value":"312"},"to":{"field":"region","value":"gp"}},{"from":{"field":"region","value":"226"},"to":{"field":"region","value":"gq"}},{"from":{"field":"region","value":"300"},"to":{"field":"region","value":"gr"}},{"from":{"field":"region","value":"239"},"to":{"field":"region","value":"gs"}},{"from":{"field":"region","value":"320"},"to":{"field":"region","value":"gt"}},{"from":{"field":"region","value":"316"},"to":{"field":"region","value":"gu"}},{"from":{"field":"region","value":"624"},"to":{"field":"region","value":"gw"}},{"from":{"field":"region","value":"328"},"to":{"field":"region","value":"gy"}},{"from":{"field":"region","value":"344"},"to":{"field":"region","value":"hk"}},{"from":{"field":"region","value":"334"},"to":{"field":"region","value":"hm"}},{"from":{"field":"region","value":"340"},"to":{"field":"region","value":"hn"}},{"from":{"field":"region","value":"191"},"to":{"field":"region","value":"hr"}},{"from":{"field":"region","value":"332"},"to":{"field":"region","value":"ht"}},{"from":{"field":"region","value":"348"},"to":{"field":"region","value":"hu"}},{"from":{"field":"region","value":"360"},"to":{"field":"region","value":"id"}},{"from":{"field":"region","value":"372"},"to":{"field":"region","value":"ie"}},{"from":{"field":"region","value":"376"},"to":{"field":"region","value":"il"}},{"from":{"field":"region","value":"833"},"to":{"field":"region","value":"im"}},{"from":{"field":"region","value":"356"},"to":{"field":"region","value":"in"}},{"from":{"field":"region","value":"086"},"to":{"field":"region","value":"io"}},{"from":{"field":"region","value":"368"},"to":{"field":"region","value":"iq"}},{"from":{"field":"region","value":"364"},"to":{"field":"region","value":"ir"}},{"from":{"field":"region","value":"352"},"to":{"field":"region","value":"is"}},{"from":{"field":"region","value":"380"},"to":{"field":"region","value":"it"}},{"from":{"field":"region","value":"832"},"to":{"field":"region","value":"je"}},{"from":{"field":"region","value":"388"},"to":{"field":"region","value":"jm"}},{"from":{"field":"region","value":"400"},"to":{"field":"region","value":"jo"}},{"from":{"field":"region","value":"392"},"to":{"field":"region","value":"jp"}},{"from":{"field":"region","value":"404"},"to":{"field":"region","value":"ke"}},{"from":{"field":"region","value":"417"},"to":{"field":"region","value":"kg"}},{"from":{"field":"region","value":"116"},"to":{"field":"region","value":"kh"}},{"from":{"field":"region","value":"296"},"to":{"field":"region","value":"ki"}},{"from":{"field":"region","value":"174"},"to":{"field":"region","value":"km"}},{"from":{"field":"region","value":"659"},"to":{"field":"region","value":"kn"}},{"from":{"field":"region","value":"408"},"to":{"field":"region","value":"kp"}},{"from":{"field":"region","value":"410"},"to":{"field":"region","value":"kr"}},{"from":{"field":"region","value":"414"},"to":{"field":"region","value":"kw"}},{"from":{"field":"region","value":"136"},"to":{"field":"region","value":"ky"}},{"from":{"field":"region","value":"398"},"to":{"field":"region","value":"kz"}},{"from":{"field":"region","value":"418"},"to":{"field":"region","value":"la"}},{"from":{"field":"region","value":"422"},"to":{"field":"region","value":"lb"}},{"from":{"field":"region","value":"662"},"to":{"field":"region","value":"lc"}},{"from":{"field":"region","value":"438"},"to":{"field":"region","value":"li"}},{"from":{"field":"region","value":"144"},"to":{"field":"region","value":"lk"}},{"from":{"field":"region","value":"430"},"to":{"field":"region","value":"lr"}},{"from":{"field":"region","value":"426"},"to":{"field":"region","value":"ls"}},{"from":{"field":"region","value":"440"},"to":{"field":"region","value":"lt"}},{"from":{"field":"region","value":"442"},"to":{"field":"region","value":"lu"}},{"from":{"field":"region","value":"428"},"to":{"field":"region","value":"lv"}},{"from":{"field":"region","value":"434"},"to":{"field":"region","value":"ly"}},{"from":{"field":"region","value":"504"},"to":{"field":"region","value":"ma"}},{"from":{"field":"region","value":"492"},"to":{"field":"region","value":"mc"}},{"from":{"field":"region","value":"498"},"to":{"field":"region","value":"md"}},{"from":{"field":"region","value":"499"},"to":{"field":"region","value":"me"}},{"from":{"field":"region","value":"663"},"to":{"field":"region","value":"mf"}},{"from":{"field":"region","value":"450"},"to":{"field":"region","value":"mg"}},{"from":{"field":"region","value":"584"},"to":{"field":"region","value":"mh"}},{"from":{"field":"region","value":"807"},"to":{"field":"region","value":"mk"}},{"from":{"field":"region","value":"466"},"to":{"field":"region","value":"ml"}},{"from":{"field":"region","value":"496"},"to":{"field":"region","value":"mn"}},{"from":{"field":"region","value":"446"},"to":{"field":"region","value":"mo"}},{"from":{"field":"region","value":"580"},"to":{"field":"region","value":"mp"}},{"from":{"field":"region","value":"474"},"to":{"field":"region","value":"mq"}},{"from":{"field":"region","value":"478"},"to":{"field":"region","value":"mr"}},{"from":{"field":"region","value":"500"},"to":{"field":"region","value":"ms"}},{"from":{"field":"region","value":"470"},"to":{"field":"region","value":"mt"}},{"from":{"field":"region","value":"480"},"to":{"field":"region","value":"mu"}},{"from":{"field":"region","value":"462"},"to":{"field":"region","value":"mv"}},{"from":{"field":"region","value":"454"},"to":{"field":"region","value":"mw"}},{"from":{"field":"region","value":"484"},"to":{"field":"region","value":"mx"}},{"from":{"field":"region","value":"458"},"to":{"field":"region","value":"my"}},{"from":{"field":"region","value":"508"},"to":{"field":"region","value":"mz"}},{"from":{"field":"region","value":"516"},"to":{"field":"region","value":"na"}},{"from":{"field":"region","value":"540"},"to":{"field":"region","value":"nc"}},{"from":{"field":"region","value":"562"},"to":{"field":"region","value":"ne"}},{"from":{"field":"region","value":"574"},"to":{"field":"region","value":"nf"}},{"from":{"field":"region","value":"566"},"to":{"field":"region","value":"ng"}},{"from":{"field":"region","value":"558"},"to":{"field":"region","value":"ni"}},{"from":{"field":"region","value":"528"},"to":{"field":"region","value":"nl"}},{"from":{"field":"region","value":"578"},"to":{"field":"region","value":"no"}},{"from":{"field":"region","value":"524"},"to":{"field":"region","value":"np"}},{"from":{"field":"region","value":"520"},"to":{"field":"region","value":"nr"}},{"from":{"field":"region","value":"570"},"to":{"field":"region","value":"nu"}},{"from":{"field":"region","value":"554"},"to":{"field":"region","value":"nz"}},{"from":{"field":"region","value":"512"},"to":{"field":"region","value":"om"}},{"from":{"field":"region","value":"591"},"to":{"field":"region","value":"pa"}},{"from":{"field":"region","value":"604"},"to":{"field":"region","value":"pe"}},{"from":{"field":"region","value":"258"},"to":{"field":"region","value":"pf"}},{"from":{"field":"region","value":"598"},"to":{"field":"region","value":"pg"}},{"from":{"field":"region","value":"608"},"to":{"field":"region","value":"ph"}},{"from":{"field":"region","value":"586"},"to":{"field":"region","value":"pk"}},{"from":{"field":"region","value":"616"},"to":{"field":"region","value":"pl"}},{"from":{"field":"region","value":"666"},"to":{"field":"region","value":"pm"}},{"from":{"field":"region","value":"612"},"to":{"field":"region","value":"pn"}},{"from":{"field":"region","value":"630"},"to":{"field":"region","value":"pr"}},{"from":{"field":"region","value":"275"},"to":{"field":"region","value":"ps"}},{"from":{"field":"region","value":"620"},"to":{"field":"region","value":"pt"}},{"from":{"field":"region","value":"585"},"to":{"field":"region","value":"pw"}},{"from":{"field":"region","value":"600"},"to":{"field":"region","value":"py"}},{"from":{"field":"region","value":"634"},"to":{"field":"region","value":"qa"}},{"from":{"field":"region","value":"959"},"to":{"field":"region","value":"qm"}},{"from":{"field":"region","value":"960"},"to":{"field":"region","value":"qn"}},{"from":{"field":"region","value":"962"},"to":{"field":"region","value":"qp"}},{"from":{"field":"region","value":"963"},"to":{"field":"region","value":"qq"}},{"from":{"field":"region","value":"964"},"to":{"field":"region","value":"qr"}},{"from":{"field":"region","value":"965"},"to":{"field":"region","value":"qs"}},{"from":{"field":"region","value":"966"},"to":{"field":"region","value":"qt"}},{"from":{"field":"region","value":"967"},"to":{"field":"region","value":"eu"}},{"from":{"field":"region","value":"968"},"to":{"field":"region","value":"qv"}},{"from":{"field":"region","value":"969"},"to":{"field":"region","value":"qw"}},{"from":{"field":"region","value":"970"},"to":{"field":"region","value":"qx"}},{"from":{"field":"region","value":"971"},"to":{"field":"region","value":"qy"}},{"from":{"field":"region","value":"972"},"to":{"field":"region","value":"qz"}},{"from":{"field":"region","value":"638"},"to":{"field":"region","value":"re"}},{"from":{"field":"region","value":"642"},"to":{"field":"region","value":"ro"}},{"from":{"field":"region","value":"688"},"to":{"field":"region","value":"rs"}},{"from":{"field":"region","value":"643"},"to":{"field":"region","value":"ru"}},{"from":{"field":"region","value":"646"},"to":{"field":"region","value":"rw"}},{"from":{"field":"region","value":"682"},"to":{"field":"region","value":"sa"}},{"from":{"field":"region","value":"090"},"to":{"field":"region","value":"sb"}},{"from":{"field":"region","value":"690"},"to":{"field":"region","value":"sc"}},{"from":{"field":"region","value":"729"},"to":{"field":"region","value":"sd"}},{"from":{"field":"region","value":"752"},"to":{"field":"region","value":"se"}},{"from":{"field":"region","value":"702"},"to":{"field":"region","value":"sg"}},{"from":{"field":"region","value":"654"},"to":{"field":"region","value":"sh"}},{"from":{"field":"region","value":"705"},"to":{"field":"region","value":"si"}},{"from":{"field":"region","value":"744"},"to":{"field":"region","value":"sj"}},{"from":{"field":"region","value":"703"},"to":{"field":"region","value":"sk"}},{"from":{"field":"region","value":"694"},"to":{"field":"region","value":"sl"}},{"from":{"field":"region","value":"674"},"to":{"field":"region","value":"sm"}},{"from":{"field":"region","value":"686"},"to":{"field":"region","value":"sn"}},{"from":{"field":"region","value":"706"},"to":{"field":"region","value":"so"}},{"from":{"field":"region","value":"740"},"to":{"field":"region","value":"sr"}},{"from":{"field":"region","value":"728"},"to":{"field":"region","value":"ss"}},{"from":{"field":"region","value":"678"},"to":{"field":"region","value":"st"}},{"from":{"field":"region","value":"222"},"to":{"field":"region","value":"sv"}},{"from":{"field":"region","value":"534"},"to":{"field":"region","value":"sx"}},{"from":{"field":"region","value":"760"},"to":{"field":"region","value":"sy"}},{"from":{"field":"region","value":"748"},"to":{"field":"region","value":"sz"}},{"from":{"field":"region","value":"796"},"to":{"field":"region","value":"tc"}},{"from":{"field":"region","value":"148"},"to":{"field":"region","value":"td"}},{"from":{"field":"region","value":"260"},"to":{"field":"region","value":"tf"}},{"from":{"field":"region","value":"768"},"to":{"field":"region","value":"tg"}},{"from":{"field":"region","value":"764"},"to":{"field":"region","value":"th"}},{"from":{"field":"region","value":"762"},"to":{"field":"region","value":"tj"}},{"from":{"field":"region","value":"772"},"to":{"field":"region","value":"tk"}},{"from":{"field":"region","value":"626"},"to":{"field":"region","value":"tl"}},{"from":{"field":"region","value":"795"},"to":{"field":"region","value":"tm"}},{"from":{"field":"region","value":"788"},"to":{"field":"region","value":"tn"}},{"from":{"field":"region","value":"776"},"to":{"field":"region","value":"to"}},{"from":{"field":"region","value":"792"},"to":{"field":"region","value":"tr"}},{"from":{"field":"region","value":"780"},"to":{"field":"region","value":"tt"}},{"from":{"field":"region","value":"798"},"to":{"field":"region","value":"tv"}},{"from":{"field":"region","value":"158"},"to":{"field":"region","value":"tw"}},{"from":{"field":"region","value":"834"},"to":{"field":"region","value":"tz"}},{"from":{"field":"region","value":"804"},"to":{"field":"region","value":"ua"}},{"from":{"field":"region","value":"800"},"to":{"field":"region","value":"ug"}},{"from":{"field":"region","value":"581"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"840"},"to":{"field":"region","value":"us"}},{"from":{"field":"region","value":"858"},"to":{"field":"region","value":"uy"}},{"from":{"field":"region","value":"860"},"to":{"field":"region","value":"uz"}},{"from":{"field":"region","value":"336"},"to":{"field":"region","value":"va"}},{"from":{"field":"region","value":"670"},"to":{"field":"region","value":"vc"}},{"from":{"field":"region","value":"862"},"to":{"field":"region","value":"ve"}},{"from":{"field":"region","value":"092"},"to":{"field":"region","value":"vg"}},{"from":{"field":"region","value":"850"},"to":{"field":"region","value":"vi"}},{"from":{"field":"region","value":"704"},"to":{"field":"region","value":"vn"}},{"from":{"field":"region","value":"548"},"to":{"field":"region","value":"vu"}},{"from":{"field":"region","value":"876"},"to":{"field":"region","value":"wf"}},{"from":{"field":"region","value":"882"},"to":{"field":"region","value":"ws"}},{"from":{"field":"region","value":"973"},"to":{"field":"region","value":"xa"}},{"from":{"field":"region","value":"974"},"to":{"field":"region","value":"xb"}},{"from":{"field":"region","value":"975"},"to":{"field":"region","value":"xc"}},{"from":{"field":"region","value":"976"},"to":{"field":"region","value":"xd"}},{"from":{"field":"region","value":"977"},"to":{"field":"region","value":"xe"}},{"from":{"field":"region","value":"978"},"to":{"field":"region","value":"xf"}},{"from":{"field":"region","value":"979"},"to":{"field":"region","value":"xg"}},{"from":{"field":"region","value":"980"},"to":{"field":"region","value":"xh"}},{"from":{"field":"region","value":"981"},"to":{"field":"region","value":"xi"}},{"from":{"field":"region","value":"982"},"to":{"field":"region","value":"xj"}},{"from":{"field":"region","value":"983"},"to":{"field":"region","value":"xk"}},{"from":{"field":"region","value":"984"},"to":{"field":"region","value":"xl"}},{"from":{"field":"region","value":"985"},"to":{"field":"region","value":"xm"}},{"from":{"field":"region","value":"986"},"to":{"field":"region","value":"xn"}},{"from":{"field":"region","value":"987"},"to":{"field":"region","value":"xo"}},{"from":{"field":"region","value":"988"},"to":{"field":"region","value":"xp"}},{"from":{"field":"region","value":"989"},"to":{"field":"region","value":"xq"}},{"from":{"field":"region","value":"990"},"to":{"field":"region","value":"xr"}},{"from":{"field":"region","value":"991"},"to":{"field":"region","value":"xs"}},{"from":{"field":"region","value":"992"},"to":{"field":"region","value":"xt"}},{"from":{"field":"region","value":"993"},"to":{"field":"region","value":"xu"}},{"from":{"field":"region","value":"994"},"to":{"field":"region","value":"xv"}},{"from":{"field":"region","value":"995"},"to":{"field":"region","value":"xw"}},{"from":{"field":"region","value":"996"},"to":{"field":"region","value":"xx"}},{"from":{"field":"region","value":"997"},"to":{"field":"region","value":"xy"}},{"from":{"field":"region","value":"998"},"to":{"field":"region","value":"xz"}},{"from":{"field":"region","value":"720"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"887"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"175"},"to":{"field":"region","value":"yt"}},{"from":{"field":"region","value":"710"},"to":{"field":"region","value":"za"}},{"from":{"field":"region","value":"894"},"to":{"field":"region","value":"zm"}},{"from":{"field":"region","value":"716"},"to":{"field":"region","value":"zw"}},{"from":{"field":"region","value":"999"},"to":{"field":"region","value":"zz"}},{"from":{"field":"variants","value":"aaland"},"to":{"field":"region","value":"ax"}},{"from":{"field":"variants","value":"polytoni"},"to":{"field":"variants","value":"polyton"}},{"from":{"field":"variants","value":"heploc"},"to":{"field":"variants","value":"alalc97"}},{"from":{"field":"variants","value":"arevela"},"to":{"field":"language","value":"hy"}},{"from":{"field":"variants","value":"arevmda"},"to":{"field":"language","value":"hyw"}}]');
                        },
                        "./node_modules/bcp-47-normalize/lib/index.js": function(e, t, n) {
                            "use strict";
                            var r = n("./node_modules/bcp-47/index.js"), i = n("./node_modules/bcp-47-match/index.js"), a1 = n("./node_modules/bcp-47-normalize/lib/matches.json"), o = n("./node_modules/bcp-47-normalize/lib/fields.json"), s1 = n("./node_modules/bcp-47-normalize/lib/defaults.json"), u = n("./node_modules/bcp-47-normalize/lib/many.json");
                            e.exports = function(e, t) {
                                var n, c = t || {}, m = r.parse(String(e || "").toLowerCase(), c), v = r.stringify(m), y = -1;
                                if (!v) return v;
                                for(; ++y < a1.length;)i.extendedFilter(v, a1[y].from).length && (f(m, a1[y].from, a1[y].to), v = r.stringify(m));
                                for(y = -1; ++y < o.length;)h(m, o[y].from.field, o[y].from.value) && g(m, o[y].to.field, o[y].to.value);
                                for(v = r.stringify(Object.assign({}, m, d)), y = -1; ++y < s1.length;)v === s1[y] && (f(m, s1[y], s1[y].split("-").slice(0, -1).join("-")), v = r.stringify(Object.assign({}, m, d)));
                                if (m.extensions.sort(p), c.warning) for(n in u)l.call(u[n], m[n]) && c.warning("Deprecated " + n + " `" + m[n] + "`, expected one of `" + u[n][m[n]].join("`, `") + "`", null, 7);
                                return m.script && (m.script = m.script.charAt(0).toUpperCase() + m.script.slice(1)), m.region && (m.region = m.region.toUpperCase()), r.stringify(m);
                            };
                            var l = {}.hasOwnProperty, c = new Intl.Collator, d = {
                                variants: [],
                                extensions: [],
                                privateuse: [],
                                irregular: null,
                                regular: null
                            };
                            function f(e, t, n) {
                                var i, a1 = r.parse(t), o = r.parse(n), s1 = [];
                                for(i in a1)a1[i] && a1[i].length && h(e, i, a1[i]) && s1.push(i);
                                for(i in o)o[i] && o[i].length && (s1.indexOf(i) > -1 || !e[i] || !e[i].length) && g(e, i, o[i]);
                            }
                            function h(e, t, n) {
                                var r, i, a1, o, s1 = !1;
                                if (n) {
                                    if (i = r = e[t], r && "object" == typeof r) for(i = [], a1 = -1; ++a1 < r.length;)o = r[a1], n.indexOf(o) < 0 ? i.push(o) : s1 = !0;
                                    else r === n && (i = null, s1 = !0);
                                    e[t] = i;
                                }
                                return s1;
                            }
                            function g(e, t, n) {
                                var r, i, a1, o = e[t];
                                if (o && "object" == typeof o) for(r = [].concat(n), i = -1; ++i < r.length;)a1 = r[i], o.indexOf(a1) < 0 && o.push(a1);
                                else e[t] = n;
                            }
                            function p(e, t) {
                                return c.compare(e.singleton, t.singleton);
                            }
                        },
                        "./node_modules/bcp-47-normalize/lib/many.json": function(e) {
                            e.exports = JSON.parse('{"region":{"172":["ru","am","az","by","ge","kg","kz","md","tj","tm","ua","uz"],"200":["cz","sk"],"530":["cw","sx","bq"],"532":["cw","sx","bq"],"536":["sa","iq"],"582":["fm","mh","mp","pw"],"810":["ru","am","az","by","ee","ge","kz","kg","lv","lt","md","tj","tm","ua","uz"],"830":["je","gg"],"890":["rs","me","si","hr","mk","ba"],"891":["rs","me"],"an":["cw","sx","bq"],"cs":["rs","me"],"fq":["aq","tf"],"nt":["sa","iq"],"pc":["fm","mh","mp","pw"],"su":["ru","am","az","by","ee","ge","kz","kg","lv","lt","md","tj","tm","ua","uz"],"yu":["rs","me"],"062":["034","143"],"ant":["cw","sx","bq"],"scg":["rs","me"],"ntz":["sa","iq"],"sun":["ru","am","az","by","ee","ge","kz","kg","lv","lt","md","tj","tm","ua","uz"],"yug":["rs","me"]}}');
                        },
                        "./node_modules/bcp-47-normalize/lib/matches.json": function(e) {
                            e.exports = JSON.parse('[{"from":"in","to":"id"},{"from":"iw","to":"he"},{"from":"ji","to":"yi"},{"from":"jw","to":"jv"},{"from":"mo","to":"ro"},{"from":"scc","to":"sr"},{"from":"scr","to":"hr"},{"from":"aam","to":"aas"},{"from":"adp","to":"dz"},{"from":"aue","to":"ktz"},{"from":"ayx","to":"nun"},{"from":"bgm","to":"bcg"},{"from":"bjd","to":"drl"},{"from":"ccq","to":"rki"},{"from":"cjr","to":"mom"},{"from":"cka","to":"cmr"},{"from":"cmk","to":"xch"},{"from":"coy","to":"pij"},{"from":"cqu","to":"quh"},{"from":"drh","to":"mn"},{"from":"drw","to":"fa-af"},{"from":"gav","to":"dev"},{"from":"gfx","to":"vaj"},{"from":"ggn","to":"gvr"},{"from":"gti","to":"nyc"},{"from":"guv","to":"duz"},{"from":"hrr","to":"jal"},{"from":"ibi","to":"opa"},{"from":"ilw","to":"gal"},{"from":"jeg","to":"oyb"},{"from":"kgc","to":"tdf"},{"from":"kgh","to":"kml"},{"from":"koj","to":"kwv"},{"from":"krm","to":"bmf"},{"from":"ktr","to":"dtp"},{"from":"kvs","to":"gdj"},{"from":"kwq","to":"yam"},{"from":"kxe","to":"tvd"},{"from":"kzj","to":"dtp"},{"from":"kzt","to":"dtp"},{"from":"lii","to":"raq"},{"from":"lmm","to":"rmx"},{"from":"meg","to":"cir"},{"from":"mst","to":"mry"},{"from":"mwj","to":"vaj"},{"from":"myt","to":"mry"},{"from":"nad","to":"xny"},{"from":"ncp","to":"kdz"},{"from":"nnx","to":"ngv"},{"from":"nts","to":"pij"},{"from":"oun","to":"vaj"},{"from":"pcr","to":"adx"},{"from":"pmc","to":"huw"},{"from":"pmu","to":"phr"},{"from":"ppa","to":"bfy"},{"from":"ppr","to":"lcq"},{"from":"pry","to":"prt"},{"from":"puz","to":"pub"},{"from":"sca","to":"hle"},{"from":"skk","to":"oyb"},{"from":"tdu","to":"dtp"},{"from":"thc","to":"tpo"},{"from":"thx","to":"oyb"},{"from":"tie","to":"ras"},{"from":"tkk","to":"twm"},{"from":"tlw","to":"weo"},{"from":"tmp","to":"tyj"},{"from":"tne","to":"kak"},{"from":"tnf","to":"fa-af"},{"from":"tsf","to":"taj"},{"from":"uok","to":"ema"},{"from":"xba","to":"cax"},{"from":"xia","to":"acn"},{"from":"xkh","to":"waw"},{"from":"xsj","to":"suj"},{"from":"ybd","to":"rki"},{"from":"yma","to":"lrr"},{"from":"ymt","to":"mtm"},{"from":"yos","to":"zom"},{"from":"yuu","to":"yug"},{"from":"asd","to":"snz"},{"from":"dit","to":"dif"},{"from":"llo","to":"ngt"},{"from":"myd","to":"aog"},{"from":"nns","to":"nbr"},{"from":"sgn-br","to":"bzs"},{"from":"sgn-co","to":"csn"},{"from":"sgn-de","to":"gsg"},{"from":"sgn-dk","to":"dsl"},{"from":"sgn-fr","to":"fsl"},{"from":"sgn-gb","to":"bfi"},{"from":"sgn-gr","to":"gss"},{"from":"sgn-ie","to":"isg"},{"from":"sgn-it","to":"ise"},{"from":"sgn-jp","to":"jsl"},{"from":"sgn-mx","to":"mfs"},{"from":"sgn-ni","to":"ncs"},{"from":"sgn-nl","to":"dse"},{"from":"sgn-no","to":"nsi"},{"from":"sgn-pt","to":"psr"},{"from":"sgn-se","to":"swl"},{"from":"sgn-us","to":"ase"},{"from":"sgn-za","to":"sfs"},{"from":"no-bokmal","to":"nb"},{"from":"no-nynorsk","to":"nn"},{"from":"aa-saaho","to":"ssy"},{"from":"sh","to":"sr-latn"},{"from":"cnr","to":"sr-me"},{"from":"no","to":"nb"},{"from":"tl","to":"fil"},{"from":"az-az","to":"az-latn-az"},{"from":"bs-ba","to":"bs-latn-ba"},{"from":"ha-latn-gh","to":"ha-gh"},{"from":"ha-latn-ne","to":"ha-ne"},{"from":"ha-latn-ng","to":"ha-ng"},{"from":"kk-cyrl-kz","to":"kk-kz"},{"from":"ky-cyrl-kg","to":"ky-kg"},{"from":"ks-arab-in","to":"ks-in"},{"from":"mn-cyrl-mn","to":"mn-mn"},{"from":"ms-latn-bn","to":"ms-bn"},{"from":"ms-latn-my","to":"ms-my"},{"from":"ms-latn-sg","to":"ms-sg"},{"from":"pa-in","to":"pa-guru-in"},{"from":"pa-pk","to":"pa-arab-pk"},{"from":"shi-ma","to":"shi-tfng-ma"},{"from":"sr-ba","to":"sr-cyrl-ba"},{"from":"sr-me","to":"sr-latn-me"},{"from":"sr-rs","to":"sr-cyrl-rs"},{"from":"sr-xk","to":"sr-cyrl-xk"},{"from":"tzm-latn-ma","to":"tzm-ma"},{"from":"ug-arab-cn","to":"ug-cn"},{"from":"uz-af","to":"uz-arab-af"},{"from":"uz-uz","to":"uz-latn-uz"},{"from":"vai-lr","to":"vai-vaii-lr"},{"from":"yue-cn","to":"yue-hans-cn"},{"from":"yue-hk","to":"yue-hant-hk"},{"from":"zh-cn","to":"zh-hans-cn"},{"from":"zh-hk","to":"zh-hant-hk"},{"from":"zh-mo","to":"zh-hant-mo"},{"from":"zh-sg","to":"zh-hans-sg"},{"from":"zh-tw","to":"zh-hant-tw"},{"from":"aju","to":"jrb"},{"from":"als","to":"sq"},{"from":"arb","to":"ar"},{"from":"ayr","to":"ay"},{"from":"azj","to":"az"},{"from":"bcc","to":"bal"},{"from":"bcl","to":"bik"},{"from":"bxk","to":"luy"},{"from":"bxr","to":"bua"},{"from":"cld","to":"syr"},{"from":"cmn","to":"zh"},{"from":"cwd","to":"cr"},{"from":"dgo","to":"doi"},{"from":"dhd","to":"mwr"},{"from":"dik","to":"din"},{"from":"diq","to":"zza"},{"from":"lbk","to":"bnc"},{"from":"ekk","to":"et"},{"from":"emk","to":"man"},{"from":"esk","to":"ik"},{"from":"fat","to":"ak"},{"from":"fuc","to":"ff"},{"from":"gaz","to":"om"},{"from":"gbo","to":"grb"},{"from":"gno","to":"gon"},{"from":"gug","to":"gn"},{"from":"gya","to":"gba"},{"from":"hdn","to":"hai"},{"from":"hea","to":"hmn"},{"from":"ike","to":"iu"},{"from":"kmr","to":"ku"},{"from":"knc","to":"kr"},{"from":"kng","to":"kg"},{"from":"knn","to":"kok"},{"from":"kpv","to":"kv"},{"from":"lvs","to":"lv"},{"from":"mhr","to":"chm"},{"from":"mup","to":"raj"},{"from":"khk","to":"mn"},{"from":"npi","to":"ne"},{"from":"ojg","to":"oj"},{"from":"ory","to":"or"},{"from":"pbu","to":"ps"},{"from":"pes","to":"fa"},{"from":"plt","to":"mg"},{"from":"pnb","to":"lah"},{"from":"quz","to":"qu"},{"from":"rmy","to":"rom"},{"from":"spy","to":"kln"},{"from":"src","to":"sc"},{"from":"swh","to":"sw"},{"from":"ttq","to":"tmh"},{"from":"tw","to":"ak"},{"from":"umu","to":"del"},{"from":"uzn","to":"uz"},{"from":"xpe","to":"kpe"},{"from":"xsl","to":"den"},{"from":"ydd","to":"yi"},{"from":"zai","to":"zap"},{"from":"zsm","to":"ms"},{"from":"zyb","to":"za"},{"from":"him","to":"srx"},{"from":"mnk","to":"man"},{"from":"bh","to":"bho"},{"from":"prs","to":"fa-af"},{"from":"swc","to":"sw-cd"},{"from":"aar","to":"aa"},{"from":"abk","to":"ab"},{"from":"ave","to":"ae"},{"from":"afr","to":"af"},{"from":"aka","to":"ak"},{"from":"amh","to":"am"},{"from":"arg","to":"an"},{"from":"ara","to":"ar"},{"from":"asm","to":"as"},{"from":"ava","to":"av"},{"from":"aym","to":"ay"},{"from":"aze","to":"az"},{"from":"bak","to":"ba"},{"from":"bel","to":"be"},{"from":"bul","to":"bg"},{"from":"bih","to":"bho"},{"from":"bis","to":"bi"},{"from":"bam","to":"bm"},{"from":"ben","to":"bn"},{"from":"bod","to":"bo"},{"from":"bre","to":"br"},{"from":"bos","to":"bs"},{"from":"cat","to":"ca"},{"from":"che","to":"ce"},{"from":"cha","to":"ch"},{"from":"cos","to":"co"},{"from":"cre","to":"cr"},{"from":"ces","to":"cs"},{"from":"chu","to":"cu"},{"from":"chv","to":"cv"},{"from":"cym","to":"cy"},{"from":"dan","to":"da"},{"from":"deu","to":"de"},{"from":"div","to":"dv"},{"from":"dzo","to":"dz"},{"from":"ewe","to":"ee"},{"from":"ell","to":"el"},{"from":"eng","to":"en"},{"from":"epo","to":"eo"},{"from":"spa","to":"es"},{"from":"est","to":"et"},{"from":"eus","to":"eu"},{"from":"fas","to":"fa"},{"from":"ful","to":"ff"},{"from":"fin","to":"fi"},{"from":"fij","to":"fj"},{"from":"fao","to":"fo"},{"from":"fra","to":"fr"},{"from":"fry","to":"fy"},{"from":"gle","to":"ga"},{"from":"gla","to":"gd"},{"from":"glg","to":"gl"},{"from":"grn","to":"gn"},{"from":"guj","to":"gu"},{"from":"glv","to":"gv"},{"from":"hau","to":"ha"},{"from":"heb","to":"he"},{"from":"hin","to":"hi"},{"from":"hmo","to":"ho"},{"from":"hrv","to":"hr"},{"from":"hat","to":"ht"},{"from":"hun","to":"hu"},{"from":"hye","to":"hy"},{"from":"her","to":"hz"},{"from":"ina","to":"ia"},{"from":"ind","to":"id"},{"from":"ile","to":"ie"},{"from":"ibo","to":"ig"},{"from":"iii","to":"ii"},{"from":"ipk","to":"ik"},{"from":"ido","to":"io"},{"from":"isl","to":"is"},{"from":"ita","to":"it"},{"from":"iku","to":"iu"},{"from":"jpn","to":"ja"},{"from":"jav","to":"jv"},{"from":"kat","to":"ka"},{"from":"kon","to":"kg"},{"from":"kik","to":"ki"},{"from":"kua","to":"kj"},{"from":"kaz","to":"kk"},{"from":"kal","to":"kl"},{"from":"khm","to":"km"},{"from":"kan","to":"kn"},{"from":"kor","to":"ko"},{"from":"kau","to":"kr"},{"from":"kas","to":"ks"},{"from":"kur","to":"ku"},{"from":"kom","to":"kv"},{"from":"cor","to":"kw"},{"from":"kir","to":"ky"},{"from":"lat","to":"la"},{"from":"ltz","to":"lb"},{"from":"lug","to":"lg"},{"from":"lim","to":"li"},{"from":"lin","to":"ln"},{"from":"lao","to":"lo"},{"from":"lit","to":"lt"},{"from":"lub","to":"lu"},{"from":"lav","to":"lv"},{"from":"mlg","to":"mg"},{"from":"mah","to":"mh"},{"from":"mri","to":"mi"},{"from":"mkd","to":"mk"},{"from":"mal","to":"ml"},{"from":"mon","to":"mn"},{"from":"mol","to":"ro"},{"from":"mar","to":"mr"},{"from":"msa","to":"ms"},{"from":"mlt","to":"mt"},{"from":"mya","to":"my"},{"from":"nau","to":"na"},{"from":"nob","to":"nb"},{"from":"nde","to":"nd"},{"from":"nep","to":"ne"},{"from":"ndo","to":"ng"},{"from":"nld","to":"nl"},{"from":"nno","to":"nn"},{"from":"nor","to":"nb"},{"from":"nbl","to":"nr"},{"from":"nav","to":"nv"},{"from":"nya","to":"ny"},{"from":"oci","to":"oc"},{"from":"oji","to":"oj"},{"from":"orm","to":"om"},{"from":"ori","to":"or"},{"from":"oss","to":"os"},{"from":"pan","to":"pa"},{"from":"pli","to":"pi"},{"from":"pol","to":"pl"},{"from":"pus","to":"ps"},{"from":"por","to":"pt"},{"from":"que","to":"qu"},{"from":"roh","to":"rm"},{"from":"run","to":"rn"},{"from":"ron","to":"ro"},{"from":"rus","to":"ru"},{"from":"kin","to":"rw"},{"from":"san","to":"sa"},{"from":"srd","to":"sc"},{"from":"snd","to":"sd"},{"from":"sme","to":"se"},{"from":"sag","to":"sg"},{"from":"hbs","to":"sr-latn"},{"from":"sin","to":"si"},{"from":"slk","to":"sk"},{"from":"slv","to":"sl"},{"from":"smo","to":"sm"},{"from":"sna","to":"sn"},{"from":"som","to":"so"},{"from":"sqi","to":"sq"},{"from":"srp","to":"sr"},{"from":"ssw","to":"ss"},{"from":"sot","to":"st"},{"from":"sun","to":"su"},{"from":"swe","to":"sv"},{"from":"swa","to":"sw"},{"from":"tam","to":"ta"},{"from":"tel","to":"te"},{"from":"tgk","to":"tg"},{"from":"tha","to":"th"},{"from":"tir","to":"ti"},{"from":"tuk","to":"tk"},{"from":"tgl","to":"fil"},{"from":"tsn","to":"tn"},{"from":"ton","to":"to"},{"from":"tur","to":"tr"},{"from":"tso","to":"ts"},{"from":"tat","to":"tt"},{"from":"twi","to":"ak"},{"from":"tah","to":"ty"},{"from":"uig","to":"ug"},{"from":"ukr","to":"uk"},{"from":"urd","to":"ur"},{"from":"uzb","to":"uz"},{"from":"ven","to":"ve"},{"from":"vie","to":"vi"},{"from":"vol","to":"vo"},{"from":"wln","to":"wa"},{"from":"wol","to":"wo"},{"from":"xho","to":"xh"},{"from":"yid","to":"yi"},{"from":"yor","to":"yo"},{"from":"zha","to":"za"},{"from":"zho","to":"zh"},{"from":"zul","to":"zu"},{"from":"alb","to":"sq"},{"from":"arm","to":"hy"},{"from":"baq","to":"eu"},{"from":"bur","to":"my"},{"from":"chi","to":"zh"},{"from":"cze","to":"cs"},{"from":"dut","to":"nl"},{"from":"fre","to":"fr"},{"from":"geo","to":"ka"},{"from":"ger","to":"de"},{"from":"gre","to":"el"},{"from":"ice","to":"is"},{"from":"mac","to":"mk"},{"from":"mao","to":"mi"},{"from":"may","to":"ms"},{"from":"per","to":"fa"},{"from":"rum","to":"ro"},{"from":"slo","to":"sk"},{"from":"tib","to":"bo"},{"from":"wel","to":"cy"}]');
                        },
                        "./node_modules/bcp-47/index.js": function(e, t, n) {
                            "use strict";
                            t.parse = n("./node_modules/bcp-47/lib/parse.js"), t.stringify = n("./node_modules/bcp-47/lib/stringify.js");
                        },
                        "./node_modules/bcp-47/lib/normalize.json": function(e) {
                            e.exports = JSON.parse('{"en-gb-oed":"en-GB-oxendict","i-ami":"ami","i-bnn":"bnn","i-default":null,"i-enochian":null,"i-hak":"hak","i-klingon":"tlh","i-lux":"lb","i-mingo":null,"i-navajo":"nv","i-pwn":"pwn","i-tao":"tao","i-tay":"tay","i-tsu":"tsu","sgn-be-fr":"sfb","sgn-be-nl":"vgt","sgn-ch-de":"sgg","art-lojban":"jbo","cel-gaulish":null,"no-bok":"nb","no-nyn":"nn","zh-guoyu":"cmn","zh-hakka":"hak","zh-min":null,"zh-min-nan":"nan","zh-xiang":"hsn"}');
                        },
                        "./node_modules/bcp-47/lib/parse.js": function(e, t, n) {
                            "use strict";
                            var r = n("./node_modules/is-alphanumerical/index.js"), i = n("./node_modules/is-alphabetical/index.js"), a1 = n("./node_modules/is-decimal/index.js"), o = n("./node_modules/bcp-47/lib/regular.json"), s1 = n("./node_modules/bcp-47/lib/normalize.json");
                            e.exports = function e(t, n) {
                                var l, c, d, f = n || {}, h = {
                                    language: null,
                                    extendedLanguageSubtags: [],
                                    script: null,
                                    region: null,
                                    variants: [],
                                    extensions: [],
                                    privateuse: [],
                                    irregular: null,
                                    regular: null
                                }, g = String(t), p = g.toLowerCase(), m = 0;
                                if (null == t) throw new Error("Expected string, got `" + t + "`");
                                if (u.call(s1, p)) return (null == f.normalize || f.normalize) && s1[p] ? e(s1[p]) : (h[-1 === o.indexOf(p) ? "irregular" : "regular"] = g, h);
                                for(; i(p.charCodeAt(m)) && m < 9;)m++;
                                if (m > 1 && m < 9) {
                                    if (h.language = g.slice(0, m), m < 4) for(c = 0; 45 === p.charCodeAt(m) && i(p.charCodeAt(m + 1)) && i(p.charCodeAt(m + 2)) && i(p.charCodeAt(m + 3)) && !i(p.charCodeAt(m + 4));){
                                        if (c > 2) return v(m, 3, "Too many extended language subtags, expected at most 3 subtags");
                                        h.extendedLanguageSubtags.push(g.slice(m + 1, m + 4)), m += 4, c++;
                                    }
                                    for(45 === p.charCodeAt(m) && i(p.charCodeAt(m + 1)) && i(p.charCodeAt(m + 2)) && i(p.charCodeAt(m + 3)) && i(p.charCodeAt(m + 4)) && !i(p.charCodeAt(m + 5)) && (h.script = g.slice(m + 1, m + 5), m += 5), 45 === p.charCodeAt(m) && (i(p.charCodeAt(m + 1)) && i(p.charCodeAt(m + 2)) && !i(p.charCodeAt(m + 3)) ? (h.region = g.slice(m + 1, m + 3), m += 3) : a1(p.charCodeAt(m + 1)) && a1(p.charCodeAt(m + 2)) && a1(p.charCodeAt(m + 3)) && !a1(p.charCodeAt(m + 4)) && (h.region = g.slice(m + 1, m + 4), m += 4)); 45 === p.charCodeAt(m);){
                                        for(d = l = m + 1; r(p.charCodeAt(d));){
                                            if (d - l > 7) return v(d, 1, "Too long variant, expected at most 8 characters");
                                            d++;
                                        }
                                        if (!(d - l > 4 || d - l > 3 && a1(p.charCodeAt(l)))) break;
                                        h.variants.push(g.slice(l, d)), m = d;
                                    }
                                    for(; 45 === p.charCodeAt(m) && 120 !== p.charCodeAt(m + 1) && r(p.charCodeAt(m + 1)) && 45 === p.charCodeAt(m + 2) && r(p.charCodeAt(m + 3));){
                                        for(d = m + 2, c = 0; 45 === p.charCodeAt(d) && r(p.charCodeAt(d + 1)) && r(p.charCodeAt(d + 2));)for(d = (l = d + 1) + 2, c++; r(p.charCodeAt(d));){
                                            if (d - l > 7) return v(d, 2, "Too long extension, expected at most 8 characters");
                                            d++;
                                        }
                                        if (!c) return v(d, 4, "Empty extension, extensions must have at least 2 characters of content");
                                        h.extensions.push({
                                            singleton: g.charAt(m + 1),
                                            extensions: g.slice(m + 3, d).split("-")
                                        }), m = d;
                                    }
                                } else m = 0;
                                if (0 === m && 120 === p.charCodeAt(m) || 45 === p.charCodeAt(m) && 120 === p.charCodeAt(m + 1)) for(d = m = m ? m + 2 : 1; 45 === p.charCodeAt(d) && r(p.charCodeAt(d + 1));){
                                    for(d = l = m + 1; r(p.charCodeAt(d));){
                                        if (d - l > 7) return v(d, 5, "Too long private-use area, expected at most 8 characters");
                                        d++;
                                    }
                                    h.privateuse.push(g.slice(m + 1, d)), m = d;
                                }
                                return m !== g.length ? v(m, 6, "Found superfluous content after tag") : h;
                                function v(e, t, n) {
                                    return f.warning && f.warning(n, t, e), f.forgiving ? h : {
                                        language: null,
                                        extendedLanguageSubtags: [],
                                        script: null,
                                        region: null,
                                        variants: [],
                                        extensions: [],
                                        privateuse: [],
                                        irregular: null,
                                        regular: null
                                    };
                                }
                            };
                            var u = {}.hasOwnProperty;
                        },
                        "./node_modules/bcp-47/lib/regular.json": function(e) {
                            e.exports = JSON.parse('["art-lojban","cel-gaulish","no-bok","no-nyn","zh-guoyu","zh-hakka","zh-min","zh-min-nan","zh-xiang"]');
                        },
                        "./node_modules/bcp-47/lib/stringify.js": function(e, t, n) {
                            "use strict";
                            e.exports = function(e) {
                                var t, n, r, i = e || {}, a1 = [];
                                if (i.irregular || i.regular) return i.irregular || i.regular;
                                if (i.language) for(a1 = a1.concat(i.language, i.extendedLanguageSubtags || [], i.script || [], i.region || [], i.variants || []), t = i.extensions || [], n = -1; ++n < t.length;)(r = t[n]).singleton && r.extensions && r.extensions.length && (a1 = a1.concat(r.singleton, r.extensions));
                                return i.privateuse && i.privateuse.length && (a1 = a1.concat("x", i.privateuse)), a1.join("-");
                            };
                        },
                        "./node_modules/codem-isoboxer/dist/iso_boxer.js": function(e, t, n) {
                            var r = {
                                parseBuffer: function(e) {
                                    return new i(e).parse();
                                },
                                addBoxProcessor: function(e, t) {
                                    "string" == typeof e && "function" == typeof t && (a1.prototype._boxProcessors[e] = t);
                                },
                                createFile: function() {
                                    return new i;
                                },
                                createBox: function(e, t, n) {
                                    var r = a1.create(e);
                                    return t && t.append(r, n), r;
                                },
                                createFullBox: function(e, t, n) {
                                    var i = r.createBox(e, t, n);
                                    return i.version = 0, i.flags = 0, i;
                                },
                                Utils: {}
                            };
                            r.Utils.dataViewToString = function(e, t) {
                                var n = t || "utf-8";
                                if ("undefined" != typeof TextDecoder) return new TextDecoder(n).decode(e);
                                var r = [], i = 0;
                                if ("utf-8" === n) for(; i < e.byteLength;){
                                    var a1 = e.getUint8(i++);
                                    a1 < 128 || (a1 < 224 ? (a1 = (31 & a1) << 6, a1 |= 63 & e.getUint8(i++)) : a1 < 240 ? (a1 = (15 & a1) << 12, a1 |= (63 & e.getUint8(i++)) << 6, a1 |= 63 & e.getUint8(i++)) : (a1 = (7 & a1) << 18, a1 |= (63 & e.getUint8(i++)) << 12, a1 |= (63 & e.getUint8(i++)) << 6, a1 |= 63 & e.getUint8(i++))), r.push(String.fromCharCode(a1));
                                }
                                else for(; i < e.byteLength;)r.push(String.fromCharCode(e.getUint8(i++)));
                                return r.join("");
                            }, r.Utils.utf8ToByteArray = function(e) {
                                var t, n;
                                if ("undefined" != typeof TextEncoder) t = (new TextEncoder).encode(e);
                                else for(t = [], n = 0; n < e.length; ++n){
                                    var r = e.charCodeAt(n);
                                    r < 128 ? t.push(r) : r < 2048 ? (t.push(192 | r >> 6), t.push(128 | 63 & r)) : r < 65536 ? (t.push(224 | r >> 12), t.push(128 | 63 & r >> 6), t.push(128 | 63 & r)) : (t.push(240 | r >> 18), t.push(128 | 63 & r >> 12), t.push(128 | 63 & r >> 6), t.push(128 | 63 & r));
                                }
                                return t;
                            }, r.Utils.appendBox = function(e, t, n) {
                                if (t._offset = e._cursor.offset, t._root = e._root ? e._root : e, t._raw = e._raw, t._parent = e, -1 !== n) {
                                    if (null != n) {
                                        var r, i = -1;
                                        if ("number" == typeof n) i = n;
                                        else {
                                            if ("string" == typeof n) r = n;
                                            else {
                                                if ("object" != typeof n || !n.type) return void e.boxes.push(t);
                                                r = n.type;
                                            }
                                            for(var a1 = 0; a1 < e.boxes.length; a1++)if (r === e.boxes[a1].type) {
                                                i = a1 + 1;
                                                break;
                                            }
                                        }
                                        e.boxes.splice(i, 0, t);
                                    } else e.boxes.push(t);
                                }
                            }, t.parseBuffer = r.parseBuffer, t.addBoxProcessor = r.addBoxProcessor, t.createFile = r.createFile, t.createBox = r.createBox, t.createFullBox = r.createFullBox, t.Utils = r.Utils, r.Cursor = function(e) {
                                this.offset = void 0 === e ? 0 : e;
                            };
                            var i = function(e) {
                                this._cursor = new r.Cursor, this.boxes = [], e && (this._raw = new DataView(e));
                            };
                            i.prototype.fetch = function(e) {
                                var t = this.fetchAll(e, !0);
                                return t.length ? t[0] : null;
                            }, i.prototype.fetchAll = function(e, t) {
                                var n = [];
                                return i._sweep.call(this, e, n, t), n;
                            }, i.prototype.parse = function() {
                                for(this._cursor.offset = 0, this.boxes = []; this._cursor.offset < this._raw.byteLength;){
                                    var e = a1.parse(this);
                                    if (void 0 === e.type) break;
                                    this.boxes.push(e);
                                }
                                return this;
                            }, i._sweep = function(e, t, n) {
                                for(var r in this.type && this.type == e && t.push(this), this.boxes){
                                    if (t.length && n) return;
                                    i._sweep.call(this.boxes[r], e, t, n);
                                }
                            }, i.prototype.write = function() {
                                var e, t = 0;
                                for(e = 0; e < this.boxes.length; e++)t += this.boxes[e].getLength(!1);
                                var n = new Uint8Array(t);
                                for(this._rawo = new DataView(n.buffer), this.bytes = n, this._cursor.offset = 0, e = 0; e < this.boxes.length; e++)this.boxes[e].write();
                                return n.buffer;
                            }, i.prototype.append = function(e, t) {
                                r.Utils.appendBox(this, e, t);
                            };
                            var a1 = function() {
                                this._cursor = new r.Cursor;
                            };
                            a1.parse = function(e) {
                                var t = new a1;
                                return t._offset = e._cursor.offset, t._root = e._root ? e._root : e, t._raw = e._raw, t._parent = e, t._parseBox(), e._cursor.offset = t._raw.byteOffset + t._raw.byteLength, t;
                            }, a1.create = function(e) {
                                var t = new a1;
                                return t.type = e, t.boxes = [], t;
                            }, a1.prototype._boxContainers = [
                                "dinf",
                                "edts",
                                "mdia",
                                "meco",
                                "mfra",
                                "minf",
                                "moof",
                                "moov",
                                "mvex",
                                "stbl",
                                "strk",
                                "traf",
                                "trak",
                                "tref",
                                "udta",
                                "vttc",
                                "sinf",
                                "schi",
                                "encv",
                                "enca"
                            ], a1.prototype._boxProcessors = {}, a1.prototype._procField = function(e, t, n) {
                                this._parsing ? this[e] = this._readField(t, n) : this._writeField(t, n, this[e]);
                            }, a1.prototype._procFieldArray = function(e, t, n, r) {
                                var i;
                                if (this._parsing) for(this[e] = [], i = 0; i < t; i++)this[e][i] = this._readField(n, r);
                                else for(i = 0; i < this[e].length; i++)this._writeField(n, r, this[e][i]);
                            }, a1.prototype._procFullBox = function() {
                                this._procField("version", "uint", 8), this._procField("flags", "uint", 24);
                            }, a1.prototype._procEntries = function(e, t, n) {
                                var r;
                                if (this._parsing) for(this[e] = [], r = 0; r < t; r++)this[e].push({}), n.call(this, this[e][r]);
                                else for(r = 0; r < t; r++)n.call(this, this[e][r]);
                            }, a1.prototype._procSubEntries = function(e, t, n, r) {
                                var i;
                                if (this._parsing) for(e[t] = [], i = 0; i < n; i++)e[t].push({}), r.call(this, e[t][i]);
                                else for(i = 0; i < n; i++)r.call(this, e[t][i]);
                            }, a1.prototype._procEntryField = function(e, t, n, r) {
                                this._parsing ? e[t] = this._readField(n, r) : this._writeField(n, r, e[t]);
                            }, a1.prototype._procSubBoxes = function(e, t) {
                                var n;
                                if (this._parsing) for(this[e] = [], n = 0; n < t; n++)this[e].push(a1.parse(this));
                                else for(n = 0; n < t; n++)this._rawo ? this[e][n].write() : this.size += this[e][n].getLength();
                            }, a1.prototype._readField = function(e, t) {
                                switch(e){
                                    case "uint":
                                        return this._readUint(t);
                                    case "int":
                                        return this._readInt(t);
                                    case "template":
                                        return this._readTemplate(t);
                                    case "string":
                                        return -1 === t ? this._readTerminatedString() : this._readString(t);
                                    case "data":
                                        return this._readData(t);
                                    case "utf8":
                                        return this._readUTF8String();
                                    default:
                                        return -1;
                                }
                            }, a1.prototype._readInt = function(e) {
                                var t = null, n = this._cursor.offset - this._raw.byteOffset;
                                switch(e){
                                    case 8:
                                        t = this._raw.getInt8(n);
                                        break;
                                    case 16:
                                        t = this._raw.getInt16(n);
                                        break;
                                    case 32:
                                        t = this._raw.getInt32(n);
                                        break;
                                    case 64:
                                        var r = this._raw.getInt32(n), i = this._raw.getInt32(n + 4);
                                        t = r * Math.pow(2, 32) + i;
                                }
                                return this._cursor.offset += e >> 3, t;
                            }, a1.prototype._readUint = function(e) {
                                var t, n, r = null, i = this._cursor.offset - this._raw.byteOffset;
                                switch(e){
                                    case 8:
                                        r = this._raw.getUint8(i);
                                        break;
                                    case 16:
                                        r = this._raw.getUint16(i);
                                        break;
                                    case 24:
                                        r = ((t = this._raw.getUint16(i)) << 8) + (n = this._raw.getUint8(i + 2));
                                        break;
                                    case 32:
                                        r = this._raw.getUint32(i);
                                        break;
                                    case 64:
                                        t = this._raw.getUint32(i), n = this._raw.getUint32(i + 4), r = t * Math.pow(2, 32) + n;
                                }
                                return this._cursor.offset += e >> 3, r;
                            }, a1.prototype._readString = function(e) {
                                for(var t = "", n = 0; n < e; n++){
                                    var r = this._readUint(8);
                                    t += String.fromCharCode(r);
                                }
                                return t;
                            }, a1.prototype._readTemplate = function(e) {
                                return this._readUint(e / 2) + this._readUint(e / 2) / Math.pow(2, e / 2);
                            }, a1.prototype._readTerminatedString = function() {
                                for(var e = ""; this._cursor.offset - this._offset < this._raw.byteLength;){
                                    var t = this._readUint(8);
                                    if (0 === t) break;
                                    e += String.fromCharCode(t);
                                }
                                return e;
                            }, a1.prototype._readData = function(e) {
                                var t = e > 0 ? e : this._raw.byteLength - (this._cursor.offset - this._offset);
                                if (t > 0) {
                                    var n = new Uint8Array(this._raw.buffer, this._cursor.offset, t);
                                    return this._cursor.offset += t, n;
                                }
                                return null;
                            }, a1.prototype._readUTF8String = function() {
                                var e = this._raw.byteLength - (this._cursor.offset - this._offset), t = null;
                                return e > 0 && (t = new DataView(this._raw.buffer, this._cursor.offset, e), this._cursor.offset += e), t ? r.Utils.dataViewToString(t) : t;
                            }, a1.prototype._parseBox = function() {
                                if (this._parsing = !0, this._cursor.offset = this._offset, this._offset + 8 > this._raw.buffer.byteLength) this._root._incomplete = !0;
                                else {
                                    switch(this._procField("size", "uint", 32), this._procField("type", "string", 4), 1 === this.size && this._procField("largesize", "uint", 64), "uuid" === this.type && this._procFieldArray("usertype", 16, "uint", 8), this.size){
                                        case 0:
                                            this._raw = new DataView(this._raw.buffer, this._offset, this._raw.byteLength - this._cursor.offset + 8);
                                            break;
                                        case 1:
                                            this._offset + this.size > this._raw.buffer.byteLength ? (this._incomplete = !0, this._root._incomplete = !0) : this._raw = new DataView(this._raw.buffer, this._offset, this.largesize);
                                            break;
                                        default:
                                            this._offset + this.size > this._raw.buffer.byteLength ? (this._incomplete = !0, this._root._incomplete = !0) : this._raw = new DataView(this._raw.buffer, this._offset, this.size);
                                    }
                                    this._incomplete || (this._boxProcessors[this.type] && this._boxProcessors[this.type].call(this), -1 !== this._boxContainers.indexOf(this.type) ? this._parseContainerBox() : this._data = this._readData());
                                }
                            }, a1.prototype._parseFullBox = function() {
                                this.version = this._readUint(8), this.flags = this._readUint(24);
                            }, a1.prototype._parseContainerBox = function() {
                                for(this.boxes = []; this._cursor.offset - this._raw.byteOffset < this._raw.byteLength;)this.boxes.push(a1.parse(this));
                            }, a1.prototype.append = function(e, t) {
                                r.Utils.appendBox(this, e, t);
                            }, a1.prototype.getLength = function() {
                                if (this._parsing = !1, this._rawo = null, this.size = 0, this._procField("size", "uint", 32), this._procField("type", "string", 4), 1 === this.size && this._procField("largesize", "uint", 64), "uuid" === this.type && this._procFieldArray("usertype", 16, "uint", 8), this._boxProcessors[this.type] && this._boxProcessors[this.type].call(this), -1 !== this._boxContainers.indexOf(this.type)) for(var e = 0; e < this.boxes.length; e++)this.size += this.boxes[e].getLength();
                                return this._data && this._writeData(this._data), this.size;
                            }, a1.prototype.write = function() {
                                switch(this._parsing = !1, this._cursor.offset = this._parent._cursor.offset, this.size){
                                    case 0:
                                        this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.parent._rawo.byteLength - this._cursor.offset);
                                        break;
                                    case 1:
                                        this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.largesize);
                                        break;
                                    default:
                                        this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.size);
                                }
                                if (this._procField("size", "uint", 32), this._procField("type", "string", 4), 1 === this.size && this._procField("largesize", "uint", 64), "uuid" === this.type && this._procFieldArray("usertype", 16, "uint", 8), this._boxProcessors[this.type] && this._boxProcessors[this.type].call(this), -1 !== this._boxContainers.indexOf(this.type)) for(var e = 0; e < this.boxes.length; e++)this.boxes[e].write();
                                return this._data && this._writeData(this._data), this._parent._cursor.offset += this.size, this.size;
                            }, a1.prototype._writeInt = function(e, t) {
                                if (this._rawo) {
                                    var n = this._cursor.offset - this._rawo.byteOffset;
                                    switch(e){
                                        case 8:
                                            this._rawo.setInt8(n, t);
                                            break;
                                        case 16:
                                            this._rawo.setInt16(n, t);
                                            break;
                                        case 32:
                                            this._rawo.setInt32(n, t);
                                            break;
                                        case 64:
                                            var r = Math.floor(t / Math.pow(2, 32)), i = t - r * Math.pow(2, 32);
                                            this._rawo.setUint32(n, r), this._rawo.setUint32(n + 4, i);
                                    }
                                    this._cursor.offset += e >> 3;
                                } else this.size += e >> 3;
                            }, a1.prototype._writeUint = function(e, t) {
                                if (this._rawo) {
                                    var n, r, i = this._cursor.offset - this._rawo.byteOffset;
                                    switch(e){
                                        case 8:
                                            this._rawo.setUint8(i, t);
                                            break;
                                        case 16:
                                            this._rawo.setUint16(i, t);
                                            break;
                                        case 24:
                                            n = (16776960 & t) >> 8, r = 255 & t, this._rawo.setUint16(i, n), this._rawo.setUint8(i + 2, r);
                                            break;
                                        case 32:
                                            this._rawo.setUint32(i, t);
                                            break;
                                        case 64:
                                            r = t - (n = Math.floor(t / Math.pow(2, 32))) * Math.pow(2, 32), this._rawo.setUint32(i, n), this._rawo.setUint32(i + 4, r);
                                    }
                                    this._cursor.offset += e >> 3;
                                } else this.size += e >> 3;
                            }, a1.prototype._writeString = function(e, t) {
                                for(var n = 0; n < e; n++)this._writeUint(8, t.charCodeAt(n));
                            }, a1.prototype._writeTerminatedString = function(e) {
                                if (0 !== e.length) {
                                    for(var t = 0; t < e.length; t++)this._writeUint(8, e.charCodeAt(t));
                                    this._writeUint(8, 0);
                                }
                            }, a1.prototype._writeTemplate = function(e, t) {
                                var n = Math.floor(t), r = (t - n) * Math.pow(2, e / 2);
                                this._writeUint(e / 2, n), this._writeUint(e / 2, r);
                            }, a1.prototype._writeData = function(e) {
                                if (e) {
                                    if (this._rawo) {
                                        if (e instanceof Array) {
                                            for(var t = this._cursor.offset - this._rawo.byteOffset, n = 0; n < e.length; n++)this._rawo.setInt8(t + n, e[n]);
                                            this._cursor.offset += e.length;
                                        }
                                        e instanceof Uint8Array && (this._root.bytes.set(e, this._cursor.offset), this._cursor.offset += e.length);
                                    } else this.size += e.length;
                                }
                            }, a1.prototype._writeUTF8String = function(e) {
                                var t = r.Utils.utf8ToByteArray(e);
                                if (this._rawo) for(var n = new DataView(this._rawo.buffer, this._cursor.offset, t.length), i = 0; i < t.length; i++)n.setUint8(i, t[i]);
                                else this.size += t.length;
                            }, a1.prototype._writeField = function(e, t, n) {
                                switch(e){
                                    case "uint":
                                        this._writeUint(t, n);
                                        break;
                                    case "int":
                                        this._writeInt(t, n);
                                        break;
                                    case "template":
                                        this._writeTemplate(t, n);
                                        break;
                                    case "string":
                                        -1 == t ? this._writeTerminatedString(n) : this._writeString(t, n);
                                        break;
                                    case "data":
                                        this._writeData(n);
                                        break;
                                    case "utf8":
                                        this._writeUTF8String(n);
                                }
                            }, a1.prototype._boxProcessors.avc1 = a1.prototype._boxProcessors.encv = function() {
                                this._procFieldArray("reserved1", 6, "uint", 8), this._procField("data_reference_index", "uint", 16), this._procField("pre_defined1", "uint", 16), this._procField("reserved2", "uint", 16), this._procFieldArray("pre_defined2", 3, "uint", 32), this._procField("width", "uint", 16), this._procField("height", "uint", 16), this._procField("horizresolution", "template", 32), this._procField("vertresolution", "template", 32), this._procField("reserved3", "uint", 32), this._procField("frame_count", "uint", 16), this._procFieldArray("compressorname", 32, "uint", 8), this._procField("depth", "uint", 16), this._procField("pre_defined3", "int", 16), this._procField("config", "data", -1);
                            }, a1.prototype._boxProcessors.dref = function() {
                                this._procFullBox(), this._procField("entry_count", "uint", 32), this._procSubBoxes("entries", this.entry_count);
                            }, a1.prototype._boxProcessors.elst = function() {
                                this._procFullBox(), this._procField("entry_count", "uint", 32), this._procEntries("entries", this.entry_count, function(e) {
                                    this._procEntryField(e, "segment_duration", "uint", 1 === this.version ? 64 : 32), this._procEntryField(e, "media_time", "int", 1 === this.version ? 64 : 32), this._procEntryField(e, "media_rate_integer", "int", 16), this._procEntryField(e, "media_rate_fraction", "int", 16);
                                });
                            }, a1.prototype._boxProcessors.emsg = function() {
                                this._procFullBox(), 1 == this.version ? (this._procField("timescale", "uint", 32), this._procField("presentation_time", "uint", 64), this._procField("event_duration", "uint", 32), this._procField("id", "uint", 32), this._procField("scheme_id_uri", "string", -1), this._procField("value", "string", -1)) : (this._procField("scheme_id_uri", "string", -1), this._procField("value", "string", -1), this._procField("timescale", "uint", 32), this._procField("presentation_time_delta", "uint", 32), this._procField("event_duration", "uint", 32), this._procField("id", "uint", 32)), this._procField("message_data", "data", -1);
                            }, a1.prototype._boxProcessors.free = a1.prototype._boxProcessors.skip = function() {
                                this._procField("data", "data", -1);
                            }, a1.prototype._boxProcessors.frma = function() {
                                this._procField("data_format", "uint", 32);
                            }, a1.prototype._boxProcessors.ftyp = a1.prototype._boxProcessors.styp = function() {
                                this._procField("major_brand", "string", 4), this._procField("minor_version", "uint", 32);
                                var e = -1;
                                this._parsing && (e = (this._raw.byteLength - (this._cursor.offset - this._raw.byteOffset)) / 4), this._procFieldArray("compatible_brands", e, "string", 4);
                            }, a1.prototype._boxProcessors.hdlr = function() {
                                this._procFullBox(), this._procField("pre_defined", "uint", 32), this._procField("handler_type", "string", 4), this._procFieldArray("reserved", 3, "uint", 32), this._procField("name", "string", -1);
                            }, a1.prototype._boxProcessors.mdat = function() {
                                this._procField("data", "data", -1);
                            }, a1.prototype._boxProcessors.mdhd = function() {
                                this._procFullBox(), this._procField("creation_time", "uint", 1 == this.version ? 64 : 32), this._procField("modification_time", "uint", 1 == this.version ? 64 : 32), this._procField("timescale", "uint", 32), this._procField("duration", "uint", 1 == this.version ? 64 : 32), this._parsing || "string" != typeof this.language || (this.language = this.language.charCodeAt(0) - 96 << 10 | this.language.charCodeAt(1) - 96 << 5 | this.language.charCodeAt(2) - 96), this._procField("language", "uint", 16), this._parsing && (this.language = String.fromCharCode(96 + (this.language >> 10 & 31), 96 + (this.language >> 5 & 31), 96 + (31 & this.language))), this._procField("pre_defined", "uint", 16);
                            }, a1.prototype._boxProcessors.mehd = function() {
                                this._procFullBox(), this._procField("fragment_duration", "uint", 1 == this.version ? 64 : 32);
                            }, a1.prototype._boxProcessors.mfhd = function() {
                                this._procFullBox(), this._procField("sequence_number", "uint", 32);
                            }, a1.prototype._boxProcessors.mfro = function() {
                                this._procFullBox(), this._procField("mfra_size", "uint", 32);
                            }, a1.prototype._boxProcessors.mp4a = a1.prototype._boxProcessors.enca = function() {
                                this._procFieldArray("reserved1", 6, "uint", 8), this._procField("data_reference_index", "uint", 16), this._procFieldArray("reserved2", 2, "uint", 32), this._procField("channelcount", "uint", 16), this._procField("samplesize", "uint", 16), this._procField("pre_defined", "uint", 16), this._procField("reserved3", "uint", 16), this._procField("samplerate", "template", 32), this._procField("esds", "data", -1);
                            }, a1.prototype._boxProcessors.mvhd = function() {
                                this._procFullBox(), this._procField("creation_time", "uint", 1 == this.version ? 64 : 32), this._procField("modification_time", "uint", 1 == this.version ? 64 : 32), this._procField("timescale", "uint", 32), this._procField("duration", "uint", 1 == this.version ? 64 : 32), this._procField("rate", "template", 32), this._procField("volume", "template", 16), this._procField("reserved1", "uint", 16), this._procFieldArray("reserved2", 2, "uint", 32), this._procFieldArray("matrix", 9, "template", 32), this._procFieldArray("pre_defined", 6, "uint", 32), this._procField("next_track_ID", "uint", 32);
                            }, a1.prototype._boxProcessors.payl = function() {
                                this._procField("cue_text", "utf8");
                            }, a1.prototype._boxProcessors.pssh = function() {
                                this._procFullBox(), this._procFieldArray("SystemID", 16, "uint", 8), this._procField("DataSize", "uint", 32), this._procFieldArray("Data", this.DataSize, "uint", 8);
                            }, a1.prototype._boxProcessors.schm = function() {
                                this._procFullBox(), this._procField("scheme_type", "uint", 32), this._procField("scheme_version", "uint", 32), 1 & this.flags && this._procField("scheme_uri", "string", -1);
                            }, a1.prototype._boxProcessors.sdtp = function() {
                                this._procFullBox();
                                var e = -1;
                                this._parsing && (e = this._raw.byteLength - (this._cursor.offset - this._raw.byteOffset)), this._procFieldArray("sample_dependency_table", e, "uint", 8);
                            }, a1.prototype._boxProcessors.sidx = function() {
                                this._procFullBox(), this._procField("reference_ID", "uint", 32), this._procField("timescale", "uint", 32), this._procField("earliest_presentation_time", "uint", 1 == this.version ? 64 : 32), this._procField("first_offset", "uint", 1 == this.version ? 64 : 32), this._procField("reserved", "uint", 16), this._procField("reference_count", "uint", 16), this._procEntries("references", this.reference_count, function(e) {
                                    this._parsing || (e.reference = (1 & e.reference_type) << 31, e.reference |= 2147483647 & e.referenced_size, e.sap = (1 & e.starts_with_SAP) << 31, e.sap |= (3 & e.SAP_type) << 28, e.sap |= 268435455 & e.SAP_delta_time), this._procEntryField(e, "reference", "uint", 32), this._procEntryField(e, "subsegment_duration", "uint", 32), this._procEntryField(e, "sap", "uint", 32), this._parsing && (e.reference_type = e.reference >> 31 & 1, e.referenced_size = 2147483647 & e.reference, e.starts_with_SAP = e.sap >> 31 & 1, e.SAP_type = e.sap >> 28 & 7, e.SAP_delta_time = 268435455 & e.sap);
                                });
                            }, a1.prototype._boxProcessors.smhd = function() {
                                this._procFullBox(), this._procField("balance", "uint", 16), this._procField("reserved", "uint", 16);
                            }, a1.prototype._boxProcessors.ssix = function() {
                                this._procFullBox(), this._procField("subsegment_count", "uint", 32), this._procEntries("subsegments", this.subsegment_count, function(e) {
                                    this._procEntryField(e, "ranges_count", "uint", 32), this._procSubEntries(e, "ranges", e.ranges_count, function(e) {
                                        this._procEntryField(e, "level", "uint", 8), this._procEntryField(e, "range_size", "uint", 24);
                                    });
                                });
                            }, a1.prototype._boxProcessors.stsd = function() {
                                this._procFullBox(), this._procField("entry_count", "uint", 32), this._procSubBoxes("entries", this.entry_count);
                            }, a1.prototype._boxProcessors.subs = function() {
                                this._procFullBox(), this._procField("entry_count", "uint", 32), this._procEntries("entries", this.entry_count, function(e) {
                                    this._procEntryField(e, "sample_delta", "uint", 32), this._procEntryField(e, "subsample_count", "uint", 16), this._procSubEntries(e, "subsamples", e.subsample_count, function(e) {
                                        this._procEntryField(e, "subsample_size", "uint", 1 === this.version ? 32 : 16), this._procEntryField(e, "subsample_priority", "uint", 8), this._procEntryField(e, "discardable", "uint", 8), this._procEntryField(e, "codec_specific_parameters", "uint", 32);
                                    });
                                });
                            }, a1.prototype._boxProcessors.tenc = function() {
                                this._procFullBox(), this._procField("default_IsEncrypted", "uint", 24), this._procField("default_IV_size", "uint", 8), this._procFieldArray("default_KID", 16, "uint", 8);
                            }, a1.prototype._boxProcessors.tfdt = function() {
                                this._procFullBox(), this._procField("baseMediaDecodeTime", "uint", 1 == this.version ? 64 : 32);
                            }, a1.prototype._boxProcessors.tfhd = function() {
                                this._procFullBox(), this._procField("track_ID", "uint", 32), 1 & this.flags && this._procField("base_data_offset", "uint", 64), 2 & this.flags && this._procField("sample_description_offset", "uint", 32), 8 & this.flags && this._procField("default_sample_duration", "uint", 32), 16 & this.flags && this._procField("default_sample_size", "uint", 32), 32 & this.flags && this._procField("default_sample_flags", "uint", 32);
                            }, a1.prototype._boxProcessors.tfra = function() {
                                this._procFullBox(), this._procField("track_ID", "uint", 32), this._parsing || (this.reserved = 0, this.reserved |= (48 & this.length_size_of_traf_num) << 4, this.reserved |= (12 & this.length_size_of_trun_num) << 2, this.reserved |= 3 & this.length_size_of_sample_num), this._procField("reserved", "uint", 32), this._parsing && (this.length_size_of_traf_num = (48 & this.reserved) >> 4, this.length_size_of_trun_num = (12 & this.reserved) >> 2, this.length_size_of_sample_num = 3 & this.reserved), this._procField("number_of_entry", "uint", 32), this._procEntries("entries", this.number_of_entry, function(e) {
                                    this._procEntryField(e, "time", "uint", 1 === this.version ? 64 : 32), this._procEntryField(e, "moof_offset", "uint", 1 === this.version ? 64 : 32), this._procEntryField(e, "traf_number", "uint", 8 * (this.length_size_of_traf_num + 1)), this._procEntryField(e, "trun_number", "uint", 8 * (this.length_size_of_trun_num + 1)), this._procEntryField(e, "sample_number", "uint", 8 * (this.length_size_of_sample_num + 1));
                                });
                            }, a1.prototype._boxProcessors.tkhd = function() {
                                this._procFullBox(), this._procField("creation_time", "uint", 1 == this.version ? 64 : 32), this._procField("modification_time", "uint", 1 == this.version ? 64 : 32), this._procField("track_ID", "uint", 32), this._procField("reserved1", "uint", 32), this._procField("duration", "uint", 1 == this.version ? 64 : 32), this._procFieldArray("reserved2", 2, "uint", 32), this._procField("layer", "uint", 16), this._procField("alternate_group", "uint", 16), this._procField("volume", "template", 16), this._procField("reserved3", "uint", 16), this._procFieldArray("matrix", 9, "template", 32), this._procField("width", "template", 32), this._procField("height", "template", 32);
                            }, a1.prototype._boxProcessors.trex = function() {
                                this._procFullBox(), this._procField("track_ID", "uint", 32), this._procField("default_sample_description_index", "uint", 32), this._procField("default_sample_duration", "uint", 32), this._procField("default_sample_size", "uint", 32), this._procField("default_sample_flags", "uint", 32);
                            }, a1.prototype._boxProcessors.trun = function() {
                                this._procFullBox(), this._procField("sample_count", "uint", 32), 1 & this.flags && this._procField("data_offset", "int", 32), 4 & this.flags && this._procField("first_sample_flags", "uint", 32), this._procEntries("samples", this.sample_count, function(e) {
                                    256 & this.flags && this._procEntryField(e, "sample_duration", "uint", 32), 512 & this.flags && this._procEntryField(e, "sample_size", "uint", 32), 1024 & this.flags && this._procEntryField(e, "sample_flags", "uint", 32), 2048 & this.flags && this._procEntryField(e, "sample_composition_time_offset", 1 === this.version ? "int" : "uint", 32);
                                });
                            }, a1.prototype._boxProcessors["url "] = a1.prototype._boxProcessors["urn "] = function() {
                                this._procFullBox(), "urn " === this.type && this._procField("name", "string", -1), this._procField("location", "string", -1);
                            }, a1.prototype._boxProcessors.vlab = function() {
                                this._procField("source_label", "utf8");
                            }, a1.prototype._boxProcessors.vmhd = function() {
                                this._procFullBox(), this._procField("graphicsmode", "uint", 16), this._procFieldArray("opcolor", 3, "uint", 16);
                            }, a1.prototype._boxProcessors.vttC = function() {
                                this._procField("config", "utf8");
                            }, a1.prototype._boxProcessors.vtte = function() {};
                        },
                        "./node_modules/core-util-is/lib/util.js": function(e, t, n) {
                            (function(e) {
                                function n(e) {
                                    return Object.prototype.toString.call(e);
                                }
                                t.isArray = function(e) {
                                    return Array.isArray ? Array.isArray(e) : "[object Array]" === n(e);
                                }, t.isBoolean = function(e) {
                                    return "boolean" == typeof e;
                                }, t.isNull = function(e) {
                                    return null === e;
                                }, t.isNullOrUndefined = function(e) {
                                    return null == e;
                                }, t.isNumber = function(e) {
                                    return "number" == typeof e;
                                }, t.isString = function(e) {
                                    return "string" == typeof e;
                                }, t.isSymbol = function(e) {
                                    return "symbol" == typeof e;
                                }, t.isUndefined = function(e) {
                                    return void 0 === e;
                                }, t.isRegExp = function(e) {
                                    return "[object RegExp]" === n(e);
                                }, t.isObject = function(e) {
                                    return "object" == typeof e && null !== e;
                                }, t.isDate = function(e) {
                                    return "[object Date]" === n(e);
                                }, t.isError = function(e) {
                                    return "[object Error]" === n(e) || e instanceof Error;
                                }, t.isFunction = function(e) {
                                    return "function" == typeof e;
                                }, t.isPrimitive = function(e) {
                                    return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
                                }, t.isBuffer = e.isBuffer;
                            }).call(this, n("./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer);
                        },
                        "./node_modules/es6-promise/auto.js": function(e, t, n) {
                            "use strict";
                            e.exports = n("./node_modules/es6-promise/dist/es6-promise.js").polyfill();
                        },
                        "./node_modules/es6-promise/dist/es6-promise.js": function(e, t, n) {
                            (function(t, n) {
                                var r;
                                r = function() {
                                    "use strict";
                                    function e(e) {
                                        return "function" == typeof e;
                                    }
                                    var r = Array.isArray ? Array.isArray : function(e) {
                                        return "[object Array]" === Object.prototype.toString.call(e);
                                    }, i = 0, a1 = void 0, o = void 0, s1 = function(e, t) {
                                        g[i] = e, g[i + 1] = t, 2 === (i += 2) && (o ? o(p) : T());
                                    }, u = "undefined" != typeof window ? window : void 0, l = u || {}, c = l.MutationObserver || l.WebKitMutationObserver, d = "undefined" == typeof self && void 0 !== t && "[object process]" === ({}).toString.call(t), f = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;
                                    function h() {
                                        var e = setTimeout;
                                        return function() {
                                            return e(p, 1);
                                        };
                                    }
                                    var g = new Array(1e3);
                                    function p() {
                                        for(var e = 0; e < i; e += 2)(0, g[e])(g[e + 1]), g[e] = void 0, g[e + 1] = void 0;
                                        i = 0;
                                    }
                                    var m, v, y, E, T = void 0;
                                    function b(e, t) {
                                        var n = this, r = new this.constructor(S);
                                        void 0 === r[_] && O(r);
                                        var i = n._state;
                                        if (i) {
                                            var a1 = arguments[i - 1];
                                            s1(function() {
                                                return x(i, r, a1, n._result);
                                            });
                                        } else N(n, r, e, t);
                                        return r;
                                    }
                                    function A(e) {
                                        if (e && "object" == typeof e && e.constructor === this) return e;
                                        var t = new this(S);
                                        return R(t, e), t;
                                    }
                                    d ? T = function() {
                                        return t.nextTick(p);
                                    } : c ? (v = 0, y = new c(p), E = document.createTextNode(""), y.observe(E, {
                                        characterData: !0
                                    }), T = function() {
                                        E.data = v = ++v % 2;
                                    }) : f ? ((m = new MessageChannel).port1.onmessage = p, T = function() {
                                        return m.port2.postMessage(0);
                                    }) : T = void 0 === u ? function() {
                                        try {
                                            var e = Function("return this")().require("vertx");
                                            return void 0 !== (a1 = e.runOnLoop || e.runOnContext) ? function() {
                                                a1(p);
                                            } : h();
                                        } catch (e) {
                                            return h();
                                        }
                                    }() : h();
                                    var _ = Math.random().toString(36).substring(2);
                                    function S() {}
                                    var w = void 0;
                                    function I(t, n, r) {
                                        n.constructor === t.constructor && r === b && n.constructor.resolve === A ? function(e, t) {
                                            1 === t._state ? D(e, t._result) : 2 === t._state ? k(e, t._result) : N(t, void 0, function(t) {
                                                return R(e, t);
                                            }, function(t) {
                                                return k(e, t);
                                            });
                                        }(t, n) : void 0 === r ? D(t, n) : e(r) ? function(e, t, n) {
                                            s1(function(e) {
                                                var r = !1, i = function(n, i, a1, o) {
                                                    try {
                                                        n.call(i, function(n) {
                                                            r || (r = !0, t !== n ? R(e, n) : D(e, n));
                                                        }, function(t) {
                                                            r || (r = !0, k(e, t));
                                                        });
                                                    } catch (e) {
                                                        return e;
                                                    }
                                                }(n, t, 0, 0, e._label);
                                                !r && i && (r = !0, k(e, i));
                                            }, e);
                                        }(t, n, r) : D(t, n);
                                    }
                                    function R(e, t) {
                                        if (e === t) k(e, new TypeError("You cannot resolve a promise with itself"));
                                        else if (i = typeof (r = t), null === r || "object" !== i && "function" !== i) D(e, t);
                                        else {
                                            var n = void 0;
                                            try {
                                                n = t.then;
                                            } catch (t) {
                                                return void k(e, t);
                                            }
                                            I(e, t, n);
                                        }
                                        var r, i;
                                    }
                                    function C(e) {
                                        e._onerror && e._onerror(e._result), L(e);
                                    }
                                    function D(e, t) {
                                        e._state === w && (e._result = t, e._state = 1, 0 !== e._subscribers.length && s1(L, e));
                                    }
                                    function k(e, t) {
                                        e._state === w && (e._state = 2, e._result = t, s1(C, e));
                                    }
                                    function N(e, t, n, r) {
                                        var i = e._subscribers, a1 = i.length;
                                        e._onerror = null, i[a1] = t, i[a1 + 1] = n, i[a1 + 2] = r, 0 === a1 && e._state && s1(L, e);
                                    }
                                    function L(e) {
                                        var t = e._subscribers, n = e._state;
                                        if (0 !== t.length) {
                                            for(var r = void 0, i = void 0, a1 = e._result, o = 0; o < t.length; o += 3)r = t[o], i = t[o + n], r ? x(n, r, i, a1) : i(a1);
                                            e._subscribers.length = 0;
                                        }
                                    }
                                    function x(t, n, r, i) {
                                        var a1 = e(r), o = void 0, s1 = void 0, u = !0;
                                        if (a1) {
                                            try {
                                                o = r(i);
                                            } catch (e) {
                                                u = !1, s1 = e;
                                            }
                                            if (n === o) return void k(n, new TypeError("A promises callback cannot return that same promise."));
                                        } else o = i;
                                        n._state !== w || (a1 && u ? R(n, o) : !1 === u ? k(n, s1) : 1 === t ? D(n, o) : 2 === t && k(n, o));
                                    }
                                    var M = 0;
                                    function O(e) {
                                        e[_] = M++, e._state = void 0, e._result = void 0, e._subscribers = [];
                                    }
                                    var P = function() {
                                        function e(e, t) {
                                            this._instanceConstructor = e, this.promise = new e(S), this.promise[_] || O(this.promise), r(t) ? (this.length = t.length, this._remaining = t.length, this._result = new Array(this.length), 0 === this.length ? D(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(t), 0 === this._remaining && D(this.promise, this._result))) : k(this.promise, new Error("Array Methods must be provided an Array"));
                                        }
                                        return e.prototype._enumerate = function(e) {
                                            for(var t = 0; this._state === w && t < e.length; t++)this._eachEntry(e[t], t);
                                        }, e.prototype._eachEntry = function(e, t) {
                                            var n = this._instanceConstructor, r = n.resolve;
                                            if (r === A) {
                                                var i = void 0, a1 = void 0, o = !1;
                                                try {
                                                    i = e.then;
                                                } catch (e) {
                                                    o = !0, a1 = e;
                                                }
                                                if (i === b && e._state !== w) this._settledAt(e._state, t, e._result);
                                                else if ("function" != typeof i) this._remaining--, this._result[t] = e;
                                                else if (n === F) {
                                                    var s1 = new n(S);
                                                    o ? k(s1, a1) : I(s1, e, i), this._willSettleAt(s1, t);
                                                } else this._willSettleAt(new n(function(t) {
                                                    return t(e);
                                                }), t);
                                            } else this._willSettleAt(r(e), t);
                                        }, e.prototype._settledAt = function(e, t, n) {
                                            var r = this.promise;
                                            r._state === w && (this._remaining--, 2 === e ? k(r, n) : this._result[t] = n), 0 === this._remaining && D(r, this._result);
                                        }, e.prototype._willSettleAt = function(e, t) {
                                            var n = this;
                                            N(e, void 0, function(e) {
                                                return n._settledAt(1, t, e);
                                            }, function(e) {
                                                return n._settledAt(2, t, e);
                                            });
                                        }, e;
                                    }(), F = function() {
                                        function t(e) {
                                            this[_] = M++, this._result = this._state = void 0, this._subscribers = [], S !== e && ("function" != typeof e && function() {
                                                throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
                                            }(), this instanceof t ? function(e, t) {
                                                try {
                                                    t(function(t) {
                                                        R(e, t);
                                                    }, function(t) {
                                                        k(e, t);
                                                    });
                                                } catch (t) {
                                                    k(e, t);
                                                }
                                            }(this, e) : function() {
                                                throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                                            }());
                                        }
                                        return t.prototype.catch = function(e) {
                                            return this.then(null, e);
                                        }, t.prototype.finally = function(t) {
                                            var n = this, r = n.constructor;
                                            return e(t) ? n.then(function(e) {
                                                return r.resolve(t()).then(function() {
                                                    return e;
                                                });
                                            }, function(e) {
                                                return r.resolve(t()).then(function() {
                                                    throw e;
                                                });
                                            }) : n.then(t, t);
                                        }, t;
                                    }();
                                    return F.prototype.then = b, F.all = function(e) {
                                        return new P(this, e).promise;
                                    }, F.race = function(e) {
                                        var t = this;
                                        return r(e) ? new t(function(n, r) {
                                            for(var i = e.length, a1 = 0; a1 < i; a1++)t.resolve(e[a1]).then(n, r);
                                        }) : new t(function(e, t) {
                                            return t(new TypeError("You must pass an array to race."));
                                        });
                                    }, F.resolve = A, F.reject = function(e) {
                                        var t = new this(S);
                                        return k(t, e), t;
                                    }, F._setScheduler = function(e) {
                                        o = e;
                                    }, F._setAsap = function(e) {
                                        s1 = e;
                                    }, F._asap = s1, F.polyfill = function() {
                                        var e = void 0;
                                        if (void 0 !== n) e = n;
                                        else if ("undefined" != typeof self) e = self;
                                        else try {
                                            e = Function("return this")();
                                        } catch (e) {
                                            throw new Error("polyfill failed because global object is unavailable in this environment");
                                        }
                                        var t = e.Promise;
                                        if (t) {
                                            var r = null;
                                            try {
                                                r = Object.prototype.toString.call(t.resolve());
                                            } catch (e) {}
                                            if ("[object Promise]" === r && !t.cast) return;
                                        }
                                        e.Promise = F;
                                    }, F.Promise = F, F;
                                }, e.exports = r();
                            }).call(this, n("./node_modules/process/browser.js"), n("./node_modules/webpack/buildin/global.js"));
                        },
                        "./node_modules/fast-deep-equal/index.js": function(e, t, n) {
                            "use strict";
                            var r = Array.isArray, i = Object.keys, a1 = Object.prototype.hasOwnProperty;
                            e.exports = function e(t, n) {
                                if (t === n) return !0;
                                if (t && n && "object" == typeof t && "object" == typeof n) {
                                    var o, s1, u, l = r(t), c = r(n);
                                    if (l && c) {
                                        if ((s1 = t.length) != n.length) return !1;
                                        for(o = s1; 0 != o--;)if (!e(t[o], n[o])) return !1;
                                        return !0;
                                    }
                                    if (l != c) return !1;
                                    var d = t instanceof Date, f = n instanceof Date;
                                    if (d != f) return !1;
                                    if (d && f) return t.getTime() == n.getTime();
                                    var h = t instanceof RegExp, g = n instanceof RegExp;
                                    if (h != g) return !1;
                                    if (h && g) return t.toString() == n.toString();
                                    var p = i(t);
                                    if ((s1 = p.length) !== i(n).length) return !1;
                                    for(o = s1; 0 != o--;)if (!a1.call(n, p[o])) return !1;
                                    for(o = s1; 0 != o--;)if (!e(t[u = p[o]], n[u])) return !1;
                                    return !0;
                                }
                                return t != t && n != n;
                            };
                        },
                        "./node_modules/ieee754/index.js": function(e, t) {
                            t.read = function(e, t, n, r, i) {
                                var a1, o, s1 = 8 * i - r - 1, u = (1 << s1) - 1, l = u >> 1, c = -7, d = n ? i - 1 : 0, f = n ? -1 : 1, h = e[t + d];
                                for(d += f, a1 = h & (1 << -c) - 1, h >>= -c, c += s1; c > 0; a1 = 256 * a1 + e[t + d], d += f, c -= 8);
                                for(o = a1 & (1 << -c) - 1, a1 >>= -c, c += r; c > 0; o = 256 * o + e[t + d], d += f, c -= 8);
                                if (0 === a1) a1 = 1 - l;
                                else {
                                    if (a1 === u) return o ? NaN : 1 / 0 * (h ? -1 : 1);
                                    o += Math.pow(2, r), a1 -= l;
                                }
                                return (h ? -1 : 1) * o * Math.pow(2, a1 - r);
                            }, t.write = function(e, t, n, r, i, a1) {
                                var o, s1, u, l = 8 * a1 - i - 1, c = (1 << l) - 1, d = c >> 1, f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = r ? 0 : a1 - 1, g = r ? 1 : -1, p = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                                for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s1 = isNaN(t) ? 1 : 0, o = c) : (o = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -o)) < 1 && (o--, u *= 2), (t += o + d >= 1 ? f / u : f * Math.pow(2, 1 - d)) * u >= 2 && (o++, u /= 2), o + d >= c ? (s1 = 0, o = c) : o + d >= 1 ? (s1 = (t * u - 1) * Math.pow(2, i), o += d) : (s1 = t * Math.pow(2, d - 1) * Math.pow(2, i), o = 0)); i >= 8; e[n + h] = 255 & s1, h += g, s1 /= 256, i -= 8);
                                for(o = o << i | s1, l += i; l > 0; e[n + h] = 255 & o, h += g, o /= 256, l -= 8);
                                e[n + h - g] |= 128 * p;
                            };
                        },
                        "./node_modules/imsc/src/main/js/doc.js": function(e, t, n) {
                            !function(e, t, n, r, i) {
                                function a1(e, t, n, r) {
                                    var i = r && "seq" === r.timeContainer, o = 0;
                                    r && (o = i && n ? n.end : r.begin), t.begin = t.explicit_begin ? t.explicit_begin + o : o;
                                    var s1 = t.begin, u = null;
                                    for(var l in t.sets)a1(e, t.sets[l], u, t), s1 = "seq" === t.timeContainer ? t.sets[l].end : Math.max(s1, t.sets[l].end), u = t.sets[l];
                                    if ("contents" in t) for(var c in t.contents)a1(e, t.contents[c], u, t), s1 = "seq" === t.timeContainer ? t.contents[c].end : Math.max(s1, t.contents[c].end), u = t.contents[c];
                                    else s1 = i ? t.begin : Number.POSITIVE_INFINITY;
                                    null !== t.explicit_end && null !== t.explicit_dur ? t.end = Math.min(t.begin + t.explicit_dur, o + t.explicit_end) : null === t.explicit_end && null !== t.explicit_dur ? t.end = t.begin + t.explicit_dur : null !== t.explicit_end && null === t.explicit_dur ? t.end = o + t.explicit_end : t.end = s1, delete t.explicit_begin, delete t.explicit_dur, delete t.explicit_end, e._registerEvent(t);
                                }
                                function o(e) {
                                    this.node = e;
                                }
                                function s1() {
                                    this.events = [], this.head = null, this.body = null;
                                }
                                function u() {
                                    this.styling = null, this.layout = null;
                                }
                                function l() {
                                    this.styles = {};
                                }
                                function c() {
                                    this.id = null, this.styleAttrs = null, this.styleRefs = null;
                                }
                                function d() {
                                    this.regions = {};
                                }
                                function f(e) {
                                    this.kind = e;
                                }
                                function h(e) {
                                    this.id = e;
                                }
                                function g(e) {
                                    this.regionID = e;
                                }
                                function p(e) {
                                    this.styleAttrs = e;
                                }
                                function m(e) {
                                    this.sets = e;
                                }
                                function v(e) {
                                    this.contents = e;
                                }
                                function y(e, t, n) {
                                    this.explicit_begin = e, this.explicit_end = t, this.explicit_dur = n;
                                }
                                function E() {
                                    f.call(this, "body");
                                }
                                function T() {
                                    f.call(this, "div");
                                }
                                function b() {
                                    f.call(this, "p");
                                }
                                function A() {
                                    f.call(this, "span");
                                }
                                function _() {
                                    f.call(this, "span");
                                }
                                function S() {
                                    f.call(this, "br");
                                }
                                function w() {}
                                function I() {}
                                function R(e) {
                                    return e && "xml:id" in e.attributes && e.attributes["xml:id"].value || null;
                                }
                                function C(e) {
                                    return e && "style" in e.attributes ? e.attributes.style.value.split(" ") : [];
                                }
                                function D(e, t) {
                                    var n = {};
                                    if (null !== e) for(var i in e.attributes){
                                        var a1 = e.attributes[i].uri + " " + e.attributes[i].local, o = r.byQName[a1];
                                        if (void 0 !== o) {
                                            var s1 = o.parse(e.attributes[i].value);
                                            null !== s1 ? (n[a1] = s1, o === r.byName.zIndex && O(t, "zIndex attribute present but not used by IMSC1 since regions do not overlap")) : P(t, "Cannot parse styling attribute " + a1 + " --\x3e " + e.attributes[i].value);
                                        }
                                    }
                                    return n;
                                }
                                function k(e, t, n) {
                                    for(var r in e.attributes)if (e.attributes[r].uri === t && e.attributes[r].local === n) return e.attributes[r].value;
                                    return null;
                                }
                                function N(e, t, n) {
                                    var r, i = null;
                                    return null !== (r = /^(\d+(?:\.\d+)?)f$/.exec(n)) ? null !== t && (i = parseFloat(r[1]) / t) : null !== (r = /^(\d+(?:\.\d+)?)t$/.exec(n)) ? null !== e && (i = parseFloat(r[1]) / e) : null !== (r = /^(\d+(?:\.\d+)?)ms$/.exec(n)) ? i = parseFloat(r[1]) / 1e3 : null !== (r = /^(\d+(?:\.\d+)?)s$/.exec(n)) ? i = parseFloat(r[1]) : null !== (r = /^(\d+(?:\.\d+)?)h$/.exec(n)) ? i = 3600 * parseFloat(r[1]) : null !== (r = /^(\d+(?:\.\d+)?)m$/.exec(n)) ? i = 60 * parseFloat(r[1]) : null !== (r = /^(\d{2,}):(\d\d):(\d\d(?:\.\d+)?)$/.exec(n)) ? i = 3600 * parseInt(r[1]) + 60 * parseInt(r[2]) + parseFloat(r[3]) : null !== (r = /^(\d{2,}):(\d\d):(\d\d)\:(\d{2,})$/.exec(n)) && null !== t && (i = 3600 * parseInt(r[1]) + 60 * parseInt(r[2]) + parseInt(r[3]) + (null === r[4] ? 0 : parseInt(r[4]) / t)), i;
                                }
                                function L(e, t, n) {
                                    for(; t.styleRefs.length > 0;){
                                        var r = t.styleRefs.pop();
                                        r in e.styles ? (L(e, e.styles[r], n), M(e.styles[r].styleAttrs, t.styleAttrs)) : P(n, "Non-existant style id referenced");
                                    }
                                }
                                function x(e, t, n, r) {
                                    for(var i = t.length - 1; i >= 0; i--){
                                        var a1 = t[i];
                                        a1 in e.styles ? M(e.styles[a1].styleAttrs, n) : P(r, "Non-existant style id referenced");
                                    }
                                }
                                function M(e, t) {
                                    for(var n in e)n in t || (t[n] = e[n]);
                                }
                                function O(e, t) {
                                    if (e && e.warn && e.warn(t)) throw t;
                                }
                                function P(e, t) {
                                    if (e && e.error && e.error(t)) throw t;
                                }
                                function F(e, t) {
                                    throw e && e.fatal && e.fatal(t), t;
                                }
                                function U(e, t) {
                                    for(var n, r = 0, i = e.length - 1; r <= i;){
                                        var a1 = e[n = Math.floor((r + i) / 2)];
                                        if (a1 < t) r = n + 1;
                                        else {
                                            if (!(a1 > t)) return {
                                                found: !0,
                                                index: n
                                            };
                                            i = n - 1;
                                        }
                                    }
                                    return {
                                        found: !1,
                                        index: r
                                    };
                                }
                                e.fromXML = function(e, r, i) {
                                    var f = t.parser(!0, {
                                        xmlns: !0
                                    }), h = [], g = [], p = [], m = 0, v = null;
                                    f.onclosetag = function(e) {
                                        if (h[0] instanceof l) for(var t in h[0].styles)L(h[0], h[0].styles[t], r);
                                        else if (h[0] instanceof b || h[0] instanceof A) {
                                            if (h[0].contents.length > 1) {
                                                var a1, s1 = [
                                                    h[0].contents[0]
                                                ];
                                                for(a1 = 1; a1 < h[0].contents.length; a1++)h[0].contents[a1] instanceof _ && s1[s1.length - 1] instanceof _ ? s1[s1.length - 1].text += h[0].contents[a1].text : s1.push(h[0].contents[a1]);
                                                h[0].contents = s1;
                                            }
                                            h[0] instanceof A && 1 === h[0].contents.length && h[0].contents[0] instanceof _ && (h[0].text = h[0].contents[0].text, delete h[0].contents);
                                        } else h[0] instanceof o && (h[0].node.uri === n.ns_tt && "metadata" === h[0].node.local ? m-- : m > 0 && i && "onCloseTag" in i && i.onCloseTag());
                                        p.shift(), g.shift(), h.shift();
                                    }, f.ontext = function(e) {
                                        if (void 0 === h[0]) ;
                                        else if (h[0] instanceof A || h[0] instanceof b) {
                                            var t = new _;
                                            t.initFromText(v, h[0], e, p[0], r), h[0].contents.push(t);
                                        } else h[0] instanceof o && m > 0 && i && "onText" in i && i.onText(e);
                                    }, f.onopentag = function(e) {
                                        var t = e.attributes["xml:space"];
                                        t ? p.unshift(t.value) : 0 === p.length ? p.unshift("default") : p.unshift(p[0]);
                                        var a1 = e.attributes["xml:lang"];
                                        if (a1 ? g.unshift(a1.value) : 0 === g.length ? g.unshift("") : g.unshift(g[0]), e.uri === n.ns_tt) {
                                            if ("tt" === e.local) null !== v && F(r, "Two <tt> elements at (" + this.line + "," + this.column + ")"), (v = new s1).initFromNode(e, r), h.unshift(v);
                                            else if ("head" === e.local) h[0] instanceof s1 || F(r, "Parent of <head> element is not <tt> at (" + this.line + "," + this.column + ")"), null !== v.head && F("Second <head> element at (" + this.line + "," + this.column + ")"), v.head = new u, h.unshift(v.head);
                                            else if ("styling" === e.local) h[0] instanceof u || F(r, "Parent of <styling> element is not <head> at (" + this.line + "," + this.column + ")"), null !== v.head.styling && F("Second <styling> element at (" + this.line + "," + this.column + ")"), v.head.styling = new l, h.unshift(v.head.styling);
                                            else if ("style" === e.local) {
                                                var f;
                                                h[0] instanceof l ? ((f = new c).initFromNode(e, r), f.id ? v.head.styling.styles[f.id] = f : P(r, "<style> element missing @id attribute"), h.unshift(f)) : h[0] instanceof w ? ((f = new c).initFromNode(e, r), M(f.styleAttrs, h[0].styleAttrs), h.unshift(f)) : F(r, "Parent of <style> element is not <styling> or <region> at (" + this.line + "," + this.column + ")");
                                            } else if ("layout" === e.local) h[0] instanceof u || F(r, "Parent of <layout> element is not <head> at " + this.line + "," + this.column + ")"), null !== v.head.layout && F(r, "Second <layout> element at " + this.line + "," + this.column + ")"), v.head.layout = new d, h.unshift(v.head.layout);
                                            else if ("region" === e.local) {
                                                h[0] instanceof d || F(r, "Parent of <region> element is not <layout> at " + this.line + "," + this.column + ")");
                                                var y = new w;
                                                y.initFromNode(v, e, r), !y.id || y.id in v.head.layout.regions ? P(r, "Ignoring <region> with duplicate or missing @id at " + this.line + "," + this.column + ")") : v.head.layout.regions[y.id] = y, h.unshift(y);
                                            } else if ("body" === e.local) {
                                                h[0] instanceof s1 || F(r, "Parent of <body> element is not <tt> at " + this.line + "," + this.column + ")"), null !== v.body && F(r, "Second <body> element at " + this.line + "," + this.column + ")");
                                                var _ = new E;
                                                _.initFromNode(v, e, r), v.body = _, h.unshift(_);
                                            } else if ("div" === e.local) {
                                                h[0] instanceof T || h[0] instanceof E || F(r, "Parent of <div> element is not <body> or <div> at " + this.line + "," + this.column + ")");
                                                var R = new T;
                                                R.initFromNode(v, h[0], e, r), h[0].contents.push(R), h.unshift(R);
                                            } else if ("p" === e.local) {
                                                h[0] instanceof T || F(r, "Parent of <p> element is not <div> at " + this.line + "," + this.column + ")");
                                                var C = new b;
                                                C.initFromNode(v, h[0], e, r), h[0].contents.push(C), h.unshift(C);
                                            } else if ("span" === e.local) {
                                                h[0] instanceof A || h[0] instanceof b || F(r, "Parent of <span> element is not <span> or <p> at " + this.line + "," + this.column + ")");
                                                var D = new A;
                                                D.initFromNode(v, h[0], e, p[0], r), h[0].contents.push(D), h.unshift(D);
                                            } else if ("br" === e.local) {
                                                h[0] instanceof A || h[0] instanceof b || F(r, "Parent of <br> element is not <span> or <p> at " + this.line + "," + this.column + ")");
                                                var k = new S;
                                                k.initFromNode(v, h[0], e, r), h[0].contents.push(k), h.unshift(k);
                                            } else if ("set" === e.local) {
                                                h[0] instanceof A || h[0] instanceof b || h[0] instanceof T || h[0] instanceof E || h[0] instanceof w || h[0] instanceof S || F(r, "Parent of <set> element is not a content element or a region at " + this.line + "," + this.column + ")");
                                                var N = new I;
                                                N.initFromNode(v, h[0], e, r), h[0].sets.push(N), h.unshift(N);
                                            } else h.unshift(new o(e));
                                        } else h.unshift(new o(e));
                                        if (h[0] instanceof o) {
                                            if (e.uri === n.ns_tt && "metadata" === e.local) m++;
                                            else if (m > 0 && i && "onOpenTag" in i) {
                                                var L = [];
                                                for(var x in e.attributes)L[e.attributes[x].uri + " " + e.attributes[x].local] = {
                                                    uri: e.attributes[x].uri,
                                                    local: e.attributes[x].local,
                                                    value: e.attributes[x].value
                                                };
                                                i.onOpenTag(e.uri, e.local, L);
                                            }
                                        }
                                    }, f.write(e).close(), null !== v.head ? delete v.head.styling : v.head = new u, null === v.head.layout && (v.head.layout = new d);
                                    var y = !1;
                                    for(var R in v.head.layout.regions){
                                        y = !0;
                                        break;
                                    }
                                    if (!y) {
                                        var C = w.prototype.createDefaultRegion();
                                        v.head.layout.regions[C.id] = C;
                                    }
                                    for(var D in v.head.layout.regions)a1(v, v.head.layout.regions[D], null, null);
                                    return v.body && a1(v, v.body, null, null), v;
                                }, s1.prototype.initFromNode = function(e, t) {
                                    this.cellResolution = function(e, t) {
                                        var r = k(e, n.ns_ttp, "cellResolution"), i = 15, a1 = 32;
                                        if (null !== r) {
                                            var o = /(\d+) (\d+)/.exec(r);
                                            null !== o ? (a1 = parseInt(o[1]), i = parseInt(o[2])) : O(t, "Malformed cellResolution value (using initial value instead)");
                                        }
                                        return {
                                            w: a1,
                                            h: i
                                        };
                                    }(e, t);
                                    var r = function(e, t) {
                                        var r, i = k(e, n.ns_ttp, "frameRate"), a1 = 30;
                                        null !== i && (null !== (r = /(\d+)/.exec(i)) ? a1 = parseInt(r[1]) : O(t, "Malformed frame rate attribute (using initial value instead)"));
                                        var o = k(e, n.ns_ttp, "frameRateMultiplier"), s1 = 1;
                                        null !== o && (null !== (r = /(\d+) (\d+)/.exec(o)) ? s1 = parseInt(r[1]) / parseInt(r[2]) : O(t, "Malformed frame rate multiplier attribute (using initial value instead)"));
                                        var u = s1 * a1, l = 1, c = k(e, n.ns_ttp, "tickRate");
                                        return null === c ? null !== i && (l = u) : null !== (r = /(\d+)/.exec(c)) ? l = parseInt(r[1]) : O(t, "Malformed tick rate attribute (using initial value instead)"), {
                                            effectiveFrameRate: u,
                                            tickRate: l
                                        };
                                    }(e, t);
                                    this.effectiveFrameRate = r.effectiveFrameRate, this.tickRate = r.tickRate, this.aspectRatio = function(e, t) {
                                        var r = k(e, n.ns_ittp, "aspectRatio"), i = null;
                                        if (null !== r) {
                                            var a1 = /(\d+) (\d+)/.exec(r);
                                            if (null !== a1) {
                                                var o = parseInt(a1[1]), s1 = parseInt(a1[2]);
                                                0 !== o && 0 !== s1 ? i = o / s1 : P(t, "Illegal aspectRatio values (ignoring)");
                                            } else P(t, "Malformed aspectRatio attribute (ignoring)");
                                        }
                                        return i;
                                    }(e, t);
                                    var a1 = k(e, n.ns_ttp, "timeBase");
                                    null !== a1 && "media" !== a1 && F(t, "Unsupported time base");
                                    var o = function(e, t) {
                                        var r = k(e, n.ns_tts, "extent");
                                        if (null === r) return null;
                                        var a1 = r.split(" ");
                                        if (2 !== a1.length) return O(t, "Malformed extent (ignoring)"), null;
                                        var o = i.parseLength(a1[0]), s1 = i.parseLength(a1[1]);
                                        return s1 && o ? {
                                            h: s1,
                                            w: o
                                        } : (O(t, "Malformed extent values (ignoring)"), null);
                                    }(e, t);
                                    null === o ? this.pxDimensions = {
                                        h: 480,
                                        w: 640
                                    } : ("px" === o.h.unit && "px" === o.w.unit || F(t, "Extent on TT must be in px or absent"), this.pxDimensions = {
                                        h: o.h.value,
                                        w: o.w.value
                                    });
                                }, s1.prototype._registerEvent = function(e) {
                                    if (!(e.end <= e.begin)) {
                                        var t = U(this.events, e.begin);
                                        if (t.found || this.events.splice(t.index, 0, e.begin), e.end !== Number.POSITIVE_INFINITY) {
                                            var n = U(this.events, e.end);
                                            n.found || this.events.splice(n.index, 0, e.end);
                                        }
                                    }
                                }, s1.prototype.getMediaTimeRange = function() {
                                    return [
                                        this.events[0],
                                        this.events[this.events.length - 1]
                                    ];
                                }, s1.prototype.getMediaTimeEvents = function() {
                                    return this.events;
                                }, c.prototype.initFromNode = function(e, t) {
                                    this.id = R(e), this.styleAttrs = D(e, t), this.styleRefs = C(e);
                                }, h.prototype.initFromNode = function(e, t, n, r) {
                                    this.id = R(n);
                                }, g.prototype.initFromNode = function(e, t, n, r) {
                                    this.regionID = function(e) {
                                        return e && "region" in e.attributes ? e.attributes.region.value : "";
                                    }(n);
                                }, p.prototype.initFromNode = function(e, t, n, r) {
                                    this.styleAttrs = D(n, r), null !== e.head && null !== e.head.styling && x(e.head.styling, C(n), this.styleAttrs, r);
                                }, m.prototype.initFromNode = function(e, t, n, r) {
                                    this.sets = [];
                                }, v.prototype.initFromNode = function(e, t, n, r) {
                                    this.contents = [];
                                }, y.prototype.initFromNode = function(e, t, n, r) {
                                    var i = function(e, t, n, r) {
                                        var i = null;
                                        n && "begin" in n.attributes && null === (i = N(e.tickRate, e.effectiveFrameRate, n.attributes.begin.value)) && O(r, "Malformed begin value " + n.attributes.begin.value + " (using 0)");
                                        var a1 = null;
                                        n && "dur" in n.attributes && null === (a1 = N(e.tickRate, e.effectiveFrameRate, n.attributes.dur.value)) && O(r, "Malformed dur value " + n.attributes.dur.value + " (ignoring)");
                                        var o = null;
                                        return n && "end" in n.attributes && null === (o = N(e.tickRate, e.effectiveFrameRate, n.attributes.end.value)) && O(r, "Malformed end value (ignoring)"), {
                                            explicit_begin: i,
                                            explicit_end: o,
                                            explicit_dur: a1
                                        };
                                    }(e, 0, n, r);
                                    this.explicit_begin = i.explicit_begin, this.explicit_end = i.explicit_end, this.explicit_dur = i.explicit_dur, this.timeContainer = function(e, t) {
                                        var n = e && "timeContainer" in e.attributes ? e.attributes.timeContainer.value : null;
                                        return n && "par" !== n ? "seq" === n ? "seq" : (P(t, "Illegal value of timeContainer (assuming 'par')"), "par") : "par";
                                    }(n, r);
                                }, E.prototype.initFromNode = function(e, t, n) {
                                    p.prototype.initFromNode.call(this, e, null, t, n), y.prototype.initFromNode.call(this, e, null, t, n), m.prototype.initFromNode.call(this, e, null, t, n), g.prototype.initFromNode.call(this, e, null, t, n), v.prototype.initFromNode.call(this, e, null, t, n);
                                }, T.prototype.initFromNode = function(e, t, n, r) {
                                    p.prototype.initFromNode.call(this, e, t, n, r), y.prototype.initFromNode.call(this, e, t, n, r), m.prototype.initFromNode.call(this, e, t, n, r), g.prototype.initFromNode.call(this, e, t, n, r), v.prototype.initFromNode.call(this, e, t, n, r);
                                }, b.prototype.initFromNode = function(e, t, n, r) {
                                    p.prototype.initFromNode.call(this, e, t, n, r), y.prototype.initFromNode.call(this, e, t, n, r), m.prototype.initFromNode.call(this, e, t, n, r), g.prototype.initFromNode.call(this, e, t, n, r), v.prototype.initFromNode.call(this, e, t, n, r);
                                }, A.prototype.initFromNode = function(e, t, n, r, i) {
                                    p.prototype.initFromNode.call(this, e, t, n, i), y.prototype.initFromNode.call(this, e, t, n, i), m.prototype.initFromNode.call(this, e, t, n, i), g.prototype.initFromNode.call(this, e, t, n, i), v.prototype.initFromNode.call(this, e, t, n, i), this.space = r;
                                }, _.prototype.initFromText = function(e, t, n, r, i) {
                                    y.prototype.initFromNode.call(this, e, t, null, i), this.text = n, this.space = r;
                                }, S.prototype.initFromNode = function(e, t, n, r) {
                                    g.prototype.initFromNode.call(this, e, t, n, r), y.prototype.initFromNode.call(this, e, t, n, r);
                                }, w.prototype.createDefaultRegion = function() {
                                    var e = new w;
                                    return h.call(e, ""), p.call(e, {}), m.call(e, []), y.call(e, 0, Number.POSITIVE_INFINITY, null), e;
                                }, w.prototype.initFromNode = function(e, t, n) {
                                    h.prototype.initFromNode.call(this, e, null, t, n), p.prototype.initFromNode.call(this, e, null, t, n), y.prototype.initFromNode.call(this, e, null, t, n), m.prototype.initFromNode.call(this, e, null, t, n), null !== e.head && null !== e.head.styling && x(e.head.styling, C(t), this.styleAttrs, n);
                                }, I.prototype.initFromNode = function(e, t, n, r) {
                                    y.prototype.initFromNode.call(this, e, t, n, r);
                                    var i = D(n, r);
                                    for(var a1 in this.qname = null, this.value = null, i){
                                        if (this.qname) {
                                            P(r, "More than one style specified on set");
                                            break;
                                        }
                                        this.qname = a1, this.value = i[a1];
                                    }
                                };
                            }(t, "undefined" == typeof sax ? n("./node_modules/sax/lib/sax.js") : sax, "undefined" == typeof imscNames ? n("./node_modules/imsc/src/main/js/names.js") : imscNames, "undefined" == typeof imscStyles ? n("./node_modules/imsc/src/main/js/styles.js") : imscStyles, "undefined" == typeof imscUtils ? n("./node_modules/imsc/src/main/js/utils.js") : imscUtils);
                        },
                        "./node_modules/imsc/src/main/js/html.js": function(e, t, n) {
                            !function(e, t, n) {
                                function r(e, t, s1) {
                                    var l;
                                    if ("region" === s1.kind ? (l = document.createElement("div")).style.position = "absolute" : "body" === s1.kind || "div" === s1.kind ? l = document.createElement("div") : "p" === s1.kind ? l = document.createElement("p") : "span" === s1.kind ? l = document.createElement("span") : "br" === s1.kind && (l = document.createElement("br")), l) {
                                        for(var c in l.style.margin = "0", u){
                                            var d = u[c], f = s1.styleAttrs[d.qname];
                                            void 0 !== f && null !== d.map && d.map(e, l, s1, f);
                                        }
                                        var h = l;
                                        if ("region" === s1.kind) {
                                            var g = s1.styleAttrs[n.byName.writingMode.qname];
                                            "lrtb" === g || "lr" === g ? (e.ipd = "lr", e.bpd = "tb") : "rltb" === g || "rl" === g ? (e.ipd = "rl", e.bpd = "tb") : "tblr" === g ? (e.ipd = "tb", e.bpd = "lr") : "tbrl" !== g && "tb" !== g || (e.ipd = "tb", e.bpd = "rl");
                                        }
                                        var p = s1.styleAttrs[n.byName.linePadding.qname];
                                        if (p && p > 0) {
                                            var m = Math.ceil(p * e.h) + "px";
                                            "tb" === e.bpd ? (h.style.paddingLeft = m, h.style.paddingRight = m) : (h.style.paddingTop = m, h.style.paddingBottom = m), e.lp = p;
                                        }
                                        var v = s1.styleAttrs[n.byName.multiRowAlign.qname];
                                        if (v && "auto" !== v) {
                                            var y = document.createElement("span");
                                            y.style.display = "inline-block", y.style.textAlign = v, l.appendChild(y), h = y, e.mra = v;
                                        }
                                        if (s1.styleAttrs[n.byName.fillLineGap.qname] && (e.flg = !0), "span" === s1.kind && s1.text) {
                                            if (e.lp || e.mra || e.flg) for(var E = "", T = 0; T < s1.text.length; T++){
                                                E += s1.text.charAt(T);
                                                var b = s1.text.charCodeAt(T);
                                                if (b < 55296 || b > 56319 || T === s1.text.length) {
                                                    var A = document.createElement("span");
                                                    A.textContent = E, l.appendChild(A), E = "";
                                                }
                                            }
                                            else l.textContent = s1.text;
                                        }
                                        for(var _ in t.appendChild(l), s1.contents)r(e, h, s1.contents[_]);
                                        var S = [];
                                        if ((e.lp || e.mra || e.flg) && "p" === s1.kind && (o(e, h, S, null), e.mra && (function(e) {
                                            for(var t = 0; t < e.length - 1; t++){
                                                var n = e[t].elements.length;
                                                if (0 !== n && !1 === e[t].br) {
                                                    var r = document.createElement("br"), i = e[t].elements[n - 1].node;
                                                    i.parentElement.insertBefore(r, i.nextSibling);
                                                }
                                            }
                                        }(S), e.mra = null), e.lp && (function(e, t, n) {
                                            for(var r in e){
                                                var i = e[r].elements.length, a1 = e[r].elements[e[r].start_elem], o = e[r].elements[e[r].end_elem], s1 = Math.ceil(t) + "px", u = "-" + Math.ceil(t) + "px";
                                                0 !== i && ("lr" === n.ipd ? (a1.node.style.borderLeftColor = a1.bgcolor || "#00000000", a1.node.style.borderLeftStyle = "solid", a1.node.style.borderLeftWidth = s1, a1.node.style.marginLeft = u) : "rl" === n.ipd ? (a1.node.style.borderRightColor = a1.bgcolor || "#00000000", a1.node.style.borderRightStyle = "solid", a1.node.style.borderRightWidth = s1, a1.node.style.marginRight = u) : "tb" === n.ipd && (a1.node.style.borderTopColor = a1.bgcolor || "#00000000", a1.node.style.borderTopStyle = "solid", a1.node.style.borderTopWidth = s1, a1.node.style.marginTop = u), "lr" === n.ipd ? (o.node.style.borderRightColor = o.bgcolor || "#00000000", o.node.style.borderRightStyle = "solid", o.node.style.borderRightWidth = s1, o.node.style.marginRight = u) : "rl" === n.ipd ? (o.node.style.borderLeftColor = o.bgcolor || "#00000000", o.node.style.borderLeftStyle = "solid", o.node.style.borderLeftWidth = s1, o.node.style.marginLeft = u) : "tb" === n.ipd && (o.node.style.borderBottomColor = o.bgcolor || "#00000000", o.node.style.borderBottomStyle = "solid", o.node.style.borderBottomWidth = s1, o.node.style.marginBottom = u));
                                            }
                                        }(S, e.lp * e.h, e), e.lp = null), e.flg)) {
                                            var w = a1(h.getBoundingClientRect(), e);
                                            !function(e, t, n, r) {
                                                for(var i = Math.sign(n - t), a1 = 0; a1 <= e.length; a1++){
                                                    var o, s1, u;
                                                    if (o = 0 === a1 ? t : a1 === e.length ? n : (e[a1].before + e[a1 - 1].after) / 2, a1 > 0) for(var l = 0; l < e[a1 - 1].elements.length; l++)null !== e[a1 - 1].elements[l].bgcolor && i * ((u = e[a1 - 1].elements[l]).after - o) < 0 && (s1 = Math.ceil(Math.abs(o - u.after)) + "px", u.node.style.backgroundColor = u.bgcolor, "lr" === r.bpd ? u.node.style.paddingRight = s1 : "rl" === r.bpd ? u.node.style.paddingLeft = s1 : "tb" === r.bpd && (u.node.style.paddingBottom = s1));
                                                    if (a1 < e.length) for(var c = 0; c < e[a1].elements.length; c++)null !== (u = e[a1].elements[c]).bgcolor && i * (u.before - o) > 0 && (s1 = Math.ceil(Math.abs(u.before - o)) + "px", u.node.style.backgroundColor = u.bgcolor, "lr" === r.bpd ? u.node.style.paddingLeft = s1 : "rl" === r.bpd ? u.node.style.paddingRight = s1 : "tb" === r.bpd && (u.node.style.paddingTop = s1));
                                                }
                                            }(S, w.before, w.after, e), e.flg = null;
                                        }
                                        if ("region" === s1.kind && (o(e, h, S), "tb" === e.bpd && e.enableRollUp && s1.contents.length > 0 && "after" === s1.styleAttrs[n.byName.displayAlign.qname])) {
                                            var I = new i("" === s1.id ? "_" : s1.id, S);
                                            if (e.currentISDState[I.id] = I, e.previousISDState && I.id in e.previousISDState && e.previousISDState[I.id].plist.length > 0 && I.plist.length > 1 && I.plist[I.plist.length - 2].text === e.previousISDState[I.id].plist[e.previousISDState[I.id].plist.length - 1].text) {
                                                var R = l.firstElementChild, C = I.plist[I.plist.length - 1].after - I.plist[I.plist.length - 1].before;
                                                R.style.bottom = "-" + C + "px", R.style.transition = "transform 0.4s", R.style.position = "relative", R.style.transform = "translateY(-" + C + "px)";
                                            }
                                        }
                                    } else !function(e, t) {
                                        if (e && e.error && e.error(t)) throw t;
                                    }(e.errorHandler, "Error processing ISD element kind: " + s1.kind);
                                }
                                function i(e, t) {
                                    this.id = e, this.plist = t;
                                }
                                function a1(e, t) {
                                    var n = {
                                        before: null,
                                        after: null,
                                        start: null,
                                        end: null
                                    };
                                    return "tb" === t.bpd ? (n.before = e.top, n.after = e.bottom, "lr" === t.ipd ? (n.start = e.left, n.end = e.right) : (n.start = e.right, n.end = e.left)) : "lr" === t.bpd ? (n.before = e.left, n.after = e.right, n.start = e.top, n.end = e.bottom) : "rl" === t.bpd && (n.before = e.right, n.after = e.left, n.start = e.top, n.end = e.bottom), n;
                                }
                                function o(e, t, n, r) {
                                    var i, s1, u, l, c = t.style.backgroundColor || r;
                                    if (0 === t.childElementCount) {
                                        if ("span" === t.localName) {
                                            var d = t.getBoundingClientRect();
                                            if (0 === d.height || 0 === d.width) return;
                                            var f = a1(d, e);
                                            if (0 !== n.length && (i = f.before, s1 = f.after, u = n[n.length - 1].before, s1 < (l = n[n.length - 1].after) && i > u || l <= s1 && u >= i)) {
                                                var h = Math.sign(f.after - f.before), g = Math.sign(f.end - f.start);
                                                h * (f.before - n[n.length - 1].before) < 0 && (n[n.length - 1].before = f.before), h * (f.after - n[n.length - 1].after) > 0 && (n[n.length - 1].after = f.after), g * (f.start - n[n.length - 1].start) < 0 && (n[n.length - 1].start = f.start, n[n.length - 1].start_elem = n[n.length - 1].elements.length), g * (f.end - n[n.length - 1].end) > 0 && (n[n.length - 1].end = f.end, n[n.length - 1].end_elem = n[n.length - 1].elements.length);
                                            } else n.push({
                                                before: f.before,
                                                after: f.after,
                                                start: f.start,
                                                end: f.end,
                                                start_elem: 0,
                                                end_elem: 0,
                                                elements: [],
                                                text: "",
                                                br: !1
                                            });
                                            n[n.length - 1].text += t.textContent, n[n.length - 1].elements.push({
                                                node: t,
                                                bgcolor: c,
                                                before: f.before,
                                                after: f.after
                                            });
                                        } else "br" === t.localName && 0 !== n.length && (n[n.length - 1].br = !0);
                                    } else for(var p = t.firstChild; p;)p.nodeType === Node.ELEMENT_NODE && o(e, p, n, c), p = p.nextSibling;
                                }
                                function s1(e, t) {
                                    this.qname = e, this.map = t;
                                }
                                e.render = function(e, t, n, i, a1, o, s1, u, l) {
                                    var c = i || t.clientHeight, d = a1 || t.clientWidth;
                                    if (null !== e.aspectRatio) {
                                        var f = c * e.aspectRatio;
                                        f > d ? c = Math.round(d / e.aspectRatio) : d = f;
                                    }
                                    var h = document.createElement("div");
                                    h.style.position = "relative", h.style.width = d + "px", h.style.height = c + "px", h.style.margin = "auto", h.style.top = 0, h.style.bottom = 0, h.style.left = 0, h.style.right = 0, h.style.zIndex = 0;
                                    var g = {
                                        h: c,
                                        w: d,
                                        regionH: null,
                                        regionW: null,
                                        imgResolver: n,
                                        displayForcedOnlyMode: o || !1,
                                        isd: e,
                                        errorHandler: s1,
                                        previousISDState: u,
                                        enableRollUp: l || !1,
                                        currentISDState: {},
                                        flg: null,
                                        lp: null,
                                        mra: null,
                                        ipd: null,
                                        bpd: null
                                    };
                                    for(var p in t.appendChild(h), e.contents)r(g, h, e.contents[p]);
                                    return g.currentISDState;
                                };
                                var u = [
                                    new s1("http://www.w3.org/ns/ttml#styling backgroundColor", function(e, t, n, r) {
                                        0 !== r[3] && (t.style.backgroundColor = "rgba(" + r[0].toString() + "," + r[1].toString() + "," + r[2].toString() + "," + (r[3] / 255).toString() + ")");
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling color", function(e, t, n, r) {
                                        t.style.color = "rgba(" + r[0].toString() + "," + r[1].toString() + "," + r[2].toString() + "," + (r[3] / 255).toString() + ")";
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling direction", function(e, t, n, r) {
                                        t.style.direction = r;
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling display", function(e, t, n, r) {}),
                                    new s1("http://www.w3.org/ns/ttml#styling displayAlign", function(e, t, n, r) {
                                        t.style.display = "flex", t.style.flexDirection = "column", "before" === r ? t.style.justifyContent = "flex-start" : "center" === r ? t.style.justifyContent = "center" : "after" === r && (t.style.justifyContent = "flex-end");
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling extent", function(e, t, n, r) {
                                        e.regionH = r.h * e.h, e.regionW = r.w * e.w;
                                        var i = 0, a1 = 0, o = n.styleAttrs["http://www.w3.org/ns/ttml#styling padding"];
                                        o && (i = (o[0] + o[2]) * e.h, a1 = (o[1] + o[3]) * e.w), t.style.height = e.regionH - i + "px", t.style.width = e.regionW - a1 + "px";
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling fontFamily", function(e, t, n, r) {
                                        var i = [];
                                        for(var a1 in r)"monospaceSerif" === r[a1] ? (i.push("Courier New"), i.push('"Liberation Mono"'), i.push("Courier"), i.push("monospace")) : "proportionalSansSerif" === r[a1] ? (i.push("Arial"), i.push("Helvetica"), i.push('"Liberation Sans"'), i.push("sans-serif")) : "monospace" === r[a1] ? i.push("monospace") : "sansSerif" === r[a1] ? i.push("sans-serif") : "serif" === r[a1] ? i.push("serif") : "monospaceSansSerif" === r[a1] ? (i.push("Consolas"), i.push("monospace")) : "proportionalSerif" === r[a1] ? i.push("serif") : i.push(r[a1]);
                                        t.style.fontFamily = i.join(",");
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling fontSize", function(e, t, n, r) {
                                        t.style.fontSize = r * e.h + "px";
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling fontStyle", function(e, t, n, r) {
                                        t.style.fontStyle = r;
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling fontWeight", function(e, t, n, r) {
                                        t.style.fontWeight = r;
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling lineHeight", function(e, t, n, r) {
                                        t.style.lineHeight = "normal" === r ? "normal" : r * e.h + "px";
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling opacity", function(e, t, n, r) {
                                        t.style.opacity = r;
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling origin", function(e, t, n, r) {
                                        t.style.top = r.h * e.h + "px", t.style.left = r.w * e.w + "px";
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling overflow", function(e, t, n, r) {
                                        t.style.overflow = r;
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling padding", function(e, t, n, r) {
                                        var i = [];
                                        i[0] = r[0] * e.h + "px", i[1] = r[3] * e.w + "px", i[2] = r[2] * e.h + "px", i[3] = r[1] * e.w + "px", t.style.padding = i.join(" ");
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling showBackground", null),
                                    new s1("http://www.w3.org/ns/ttml#styling textAlign", function(e, t, r, i) {
                                        var a1, o = r.styleAttrs[n.byName.direction.qname];
                                        a1 = "start" === i ? "rtl" === o ? "right" : "left" : "end" === i ? "rtl" === o ? "left" : "right" : i, t.style.textAlign = a1;
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling textDecoration", function(e, t, n, r) {
                                        t.style.textDecoration = r.join(" ").replace("lineThrough", "line-through");
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling textOutline", function(e, t, n, r) {
                                        t.style.textShadow = "none" === r ? "" : "rgba(" + r.color[0].toString() + "," + r.color[1].toString() + "," + r.color[2].toString() + "," + (r.color[3] / 255).toString() + ") 0px 0px " + r.thickness * e.h + "px";
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling unicodeBidi", function(e, t, n, r) {
                                        var i;
                                        i = "bidiOverride" === r ? "bidi-override" : r, t.style.unicodeBidi = i;
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling visibility", function(e, t, n, r) {
                                        t.style.visibility = r;
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling wrapOption", function(e, t, n, r) {
                                        "wrap" === r ? "preserve" === n.space ? t.style.whiteSpace = "pre-wrap" : t.style.whiteSpace = "normal" : "preserve" === n.space ? t.style.whiteSpace = "pre" : t.style.whiteSpace = "noWrap";
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling writingMode", function(e, t, n, r) {
                                        "lrtb" === r || "lr" === r || "rltb" === r || "rl" === r ? t.style.writingMode = "horizontal-tb" : "tblr" === r ? t.style.writingMode = "vertical-lr" : "tbrl" !== r && "tb" !== r || (t.style.writingMode = "vertical-rl");
                                    }),
                                    new s1("http://www.w3.org/ns/ttml#styling zIndex", function(e, t, n, r) {
                                        t.style.zIndex = r;
                                    }),
                                    new s1("http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt backgroundImage", function(e, t, n, r) {
                                        if (null !== e.imgResolver && null !== r) {
                                            var i = document.createElement("img"), a1 = e.imgResolver(r, i);
                                            a1 && (i.src = a1), i.height = e.regionH, i.width = e.regionW, t.appendChild(i);
                                        }
                                    }),
                                    new s1("http://www.w3.org/ns/ttml/profile/imsc1#styling forcedDisplay", function(e, t, n, r) {
                                        e.displayForcedOnlyMode && !1 === r && (t.style.visibility = "hidden");
                                    })
                                ], l = {};
                                for(var c in u)l[u[c].qname] = u[c];
                            }(t, "undefined" == typeof imscNames ? n("./node_modules/imsc/src/main/js/names.js") : imscNames, "undefined" == typeof imscStyles ? n("./node_modules/imsc/src/main/js/styles.js") : imscStyles);
                        },
                        "./node_modules/imsc/src/main/js/isd.js": function(e, t, n) {
                            !function(e, t, n) {
                                function r(e, t, o, l, c, d, f, h, g) {
                                    if (t < f.begin || t >= f.end) return null;
                                    var p = "regionID" in f && "" !== f.regionID ? f.regionID : d;
                                    if (null !== c && p !== o.id && (!("contents" in f) || "contents" in f && 0 === f.contents.length || "" !== p)) return null;
                                    var m = new s1(f);
                                    for(var v in f.sets)t < f.sets[v].begin || t >= f.sets[v].end || (m.styleAttrs[f.sets[v].qname] = f.sets[v].value);
                                    var y, E = {};
                                    for(var T in m.styleAttrs)if (E[T] = !0, T === n.byName.writingMode.qname && !(n.byName.direction.qname in m.styleAttrs)) {
                                        var b = m.styleAttrs[T];
                                        "lrtb" === b || "lr" === b ? m.styleAttrs[n.byName.direction.qname] = "ltr" : "rltb" !== b && "rl" !== b || (m.styleAttrs[n.byName.direction.qname] = "rtl");
                                    }
                                    if (null !== c) for(var A in n.all){
                                        var _ = n.all[A];
                                        if (_.qname === n.byName.textDecoration.qname) {
                                            var S = c.styleAttrs[_.qname], w = m.styleAttrs[_.qname], I = [];
                                            void 0 === w ? I = S : -1 === w.indexOf("none") ? ((-1 === w.indexOf("noUnderline") && -1 !== S.indexOf("underline") || -1 !== w.indexOf("underline")) && I.push("underline"), (-1 === w.indexOf("noLineThrough") && -1 !== S.indexOf("lineThrough") || -1 !== w.indexOf("lineThrough")) && I.push("lineThrough"), (-1 === w.indexOf("noOverline") && -1 !== S.indexOf("overline") || -1 !== w.indexOf("overline")) && I.push("overline")) : I.push("none"), m.styleAttrs[_.qname] = I;
                                        } else _.inherit && _.qname in c.styleAttrs && !(_.qname in m.styleAttrs) && (m.styleAttrs[_.qname] = c.styleAttrs[_.qname]);
                                    }
                                    for(var R in n.all){
                                        var C = n.all[R];
                                        C.qname in m.styleAttrs || ("region" === m.kind || !1 === C.inherit && null !== C.initial) && (m.styleAttrs[C.qname] = C.parse(C.initial), E[C.qname] = !0);
                                    }
                                    for(var D in n.all){
                                        var k = n.all[D];
                                        if (k.qname in E && null !== k.compute) {
                                            var N = k.compute(e, c, m, m.styleAttrs[k.qname], g);
                                            null !== N ? m.styleAttrs[k.qname] = N : u(h, "Style '" + k.qname + "' on element '" + m.kind + "' cannot be computed");
                                        }
                                    }
                                    if ("none" === m.styleAttrs[n.byName.display.qname]) return null;
                                    for(var L in null === c ? y = null === l ? [] : [
                                        l
                                    ] : "contents" in f && (y = f.contents), y){
                                        var x = r(e, t, o, l, m, p, y[L], h, g);
                                        null !== x && m.contents.push(x.element);
                                    }
                                    for(var M in m.styleAttrs)-1 === n.byQName[M].applies.indexOf(m.kind) && delete m.styleAttrs[M];
                                    if ("span" === m.kind && m.text && "default" === m.space) {
                                        var O = m.text.replace(/\s+/g, " ");
                                        m.text = O;
                                    }
                                    if ("p" === m.kind) {
                                        var P = [];
                                        i(m, P);
                                        for(var F = 0, U = "after_br", j = 0;;)if ("after_br" === U) F >= P.length || "br" === P[F].kind ? (U = "before_br", j = F, F--) : ("preserve" !== P[F].space && (P[F].text = P[F].text.replace(/^\s+/g, "")), P[F].text.length > 0 ? (U = "looking_br", F++) : P.splice(F, 1));
                                        else if ("before_br" === U) {
                                            if (F < 0 || "br" === P[F].kind) {
                                                if (U = "after_br", (F = j + 1) >= P.length) break;
                                            } else if ("preserve" !== P[F].space && (P[F].text = P[F].text.replace(/\s+$/g, "")), P[F].text.length > 0) {
                                                if (U = "after_br", (F = j + 1) >= P.length) break;
                                            } else P.splice(F, 1), F--;
                                        } else F >= P.length || "br" === P[F].kind ? (U = "before_br", j = F, F--) : F++;
                                        a1(m);
                                    }
                                    return "div" === m.kind && n.byName.backgroundImage.qname in m.styleAttrs || "br" === m.kind || "contents" in m && m.contents.length > 0 || "span" === m.kind && null !== m.text || "region" === m.kind && "always" === m.styleAttrs[n.byName.showBackground.qname] ? {
                                        region_id: p,
                                        element: m
                                    } : null;
                                }
                                function i(e, t) {
                                    if ("contents" in e) for(var n in e.contents)i(e.contents[n], t);
                                    else t.push(e);
                                }
                                function a1(e) {
                                    if ("br" === e.kind) return !1;
                                    if ("text" in e) return 0 === e.text.length;
                                    if ("contents" in e) {
                                        for(var t = e.contents.length; t--;)a1(e.contents[t]) && e.contents.splice(t, 1);
                                        return 0 === e.contents.length;
                                    }
                                }
                                function o(e) {
                                    this.contents = [], this.aspectRatio = e.aspectRatio;
                                }
                                function s1(e) {
                                    for(var t in this.kind = e.kind || "region", e.id && (this.id = e.id), this.styleAttrs = {}, e.styleAttrs)this.styleAttrs[t] = e.styleAttrs[t];
                                    "text" in e ? this.text = e.text : "br" !== e.kind && (this.contents = []), "space" in e && (this.space = e.space);
                                }
                                function u(e, t) {
                                    if (e && e.error && e.error(t)) throw t;
                                }
                                e.generateISD = function(e, t, n) {
                                    var i = new o(e), a1 = {};
                                    for(var s1 in e.head.layout.regions){
                                        var u = r(e, t, e.head.layout.regions[s1], e.body, null, "", e.head.layout.regions[s1], n, a1);
                                        null !== u && i.contents.push(u.element);
                                    }
                                    return i;
                                };
                            }(t, "undefined" == typeof imscNames ? n("./node_modules/imsc/src/main/js/names.js") : imscNames, "undefined" == typeof imscStyles ? n("./node_modules/imsc/src/main/js/styles.js") : imscStyles);
                        },
                        "./node_modules/imsc/src/main/js/main.js": function(e, t, n) {
                            t.generateISD = n("./node_modules/imsc/src/main/js/isd.js").generateISD, t.fromXML = n("./node_modules/imsc/src/main/js/doc.js").fromXML, t.renderHTML = n("./node_modules/imsc/src/main/js/html.js").render;
                        },
                        "./node_modules/imsc/src/main/js/names.js": function(e, t, n) {
                            !function(e) {
                                e.ns_tt = "http://www.w3.org/ns/ttml", e.ns_tts = "http://www.w3.org/ns/ttml#styling", e.ns_ttp = "http://www.w3.org/ns/ttml#parameter", e.ns_xml = "http://www.w3.org/XML/1998/namespace", e.ns_itts = "http://www.w3.org/ns/ttml/profile/imsc1#styling", e.ns_ittp = "http://www.w3.org/ns/ttml/profile/imsc1#parameter", e.ns_smpte = "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt", e.ns_ebutts = "urn:ebu:tt:style";
                            }(t);
                        },
                        "./node_modules/imsc/src/main/js/styles.js": function(e, t, n) {
                            !function(e, t, n) {
                                function r(e, t, n, r, i, a1, o, s1) {
                                    this.name = t, this.ns = e, this.qname = e + " " + t, this.inherit = i, this.animatable = a1, this.initial = n, this.applies = r, this.parse = o, this.compute = s1;
                                }
                                for(var i in e.all = [
                                    new r(t.ns_tts, "backgroundColor", "transparent", [
                                        "body",
                                        "div",
                                        "p",
                                        "region",
                                        "span"
                                    ], !1, !0, n.parseColor, null),
                                    new r(t.ns_tts, "color", "white", [
                                        "span"
                                    ], !0, !0, n.parseColor, null),
                                    new r(t.ns_tts, "direction", "ltr", [
                                        "p",
                                        "span"
                                    ], !0, !0, function(e) {
                                        return e;
                                    }, null),
                                    new r(t.ns_tts, "display", "auto", [
                                        "body",
                                        "div",
                                        "p",
                                        "region",
                                        "span"
                                    ], !1, !0, function(e) {
                                        return e;
                                    }, null),
                                    new r(t.ns_tts, "displayAlign", "before", [
                                        "region"
                                    ], !1, !0, function(e) {
                                        return e;
                                    }, null),
                                    new r(t.ns_tts, "extent", "auto", [
                                        "tt",
                                        "region"
                                    ], !1, !0, function(e) {
                                        if ("auto" === e) return e;
                                        var t = e.split(" ");
                                        if (2 !== t.length) return null;
                                        var r = n.parseLength(t[0]), i = n.parseLength(t[1]);
                                        return i && r ? {
                                            h: i,
                                            w: r
                                        } : null;
                                    }, function(e, t, n, r, i) {
                                        var a1, o;
                                        if ("auto" === r) a1 = 1;
                                        else if ("%" === r.h.unit) a1 = r.h.value / 100;
                                        else {
                                            if ("px" !== r.h.unit) return null;
                                            a1 = r.h.value / e.pxDimensions.h;
                                        }
                                        if ("auto" === r) o = 1;
                                        else if ("%" === r.w.unit) o = r.w.value / 100;
                                        else {
                                            if ("px" !== r.w.unit) return null;
                                            o = r.w.value / e.pxDimensions.w;
                                        }
                                        return {
                                            h: a1,
                                            w: o
                                        };
                                    }),
                                    new r(t.ns_tts, "fontFamily", "default", [
                                        "span"
                                    ], !0, !0, function(e) {
                                        var t = e.split(","), n = [];
                                        for(var r in t)"'" !== t[r].charAt(0) && '"' !== t[r].charAt(0) && "default" === t[r] ? n.push("monospaceSerif") : n.push(t[r]);
                                        return n;
                                    }, null),
                                    new r(t.ns_tts, "fontSize", "1c", [
                                        "span"
                                    ], !0, !0, n.parseLength, function(t, n, r, i, a1) {
                                        var o;
                                        if ("%" === i.unit) o = null !== n ? n.styleAttrs[e.byName.fontSize.qname] * i.value / 100 : i.value / 100 / t.cellResolution.h;
                                        else if ("em" === i.unit) o = null !== n ? n.styleAttrs[e.byName.fontSize.qname] * i.value : i.value / t.cellResolution.h;
                                        else if ("c" === i.unit) o = i.value / t.cellResolution.h;
                                        else {
                                            if ("px" !== i.unit) return null;
                                            o = i.value / t.pxDimensions.h;
                                        }
                                        return o;
                                    }),
                                    new r(t.ns_tts, "fontStyle", "normal", [
                                        "span"
                                    ], !0, !0, function(e) {
                                        return e;
                                    }, null),
                                    new r(t.ns_tts, "fontWeight", "normal", [
                                        "span"
                                    ], !0, !0, function(e) {
                                        return e;
                                    }, null),
                                    new r(t.ns_tts, "lineHeight", "normal", [
                                        "p"
                                    ], !0, !0, function(e) {
                                        return "normal" === e ? e : n.parseLength(e);
                                    }, function(t, n, r, i, a1) {
                                        var o;
                                        if ("normal" === i) o = i;
                                        else if ("%" === i.unit) o = r.styleAttrs[e.byName.fontSize.qname] * i.value / 100;
                                        else if ("em" === i.unit) o = r.styleAttrs[e.byName.fontSize.qname] * i.value;
                                        else if ("c" === i.unit) o = i.value / t.cellResolution.h;
                                        else {
                                            if ("px" !== i.unit) return null;
                                            o = i.value / t.pxDimensions.h;
                                        }
                                        return o;
                                    }),
                                    new r(t.ns_tts, "opacity", 1, [
                                        "region"
                                    ], !1, !0, parseFloat, null),
                                    new r(t.ns_tts, "origin", "auto", [
                                        "region"
                                    ], !1, !0, function(e) {
                                        if ("auto" === e) return e;
                                        var t = e.split(" ");
                                        if (2 !== t.length) return null;
                                        var r = n.parseLength(t[0]), i = n.parseLength(t[1]);
                                        return i && r ? {
                                            h: i,
                                            w: r
                                        } : null;
                                    }, function(e, t, n, r, i) {
                                        var a1, o;
                                        if ("auto" === r) a1 = 0;
                                        else if ("%" === r.h.unit) a1 = r.h.value / 100;
                                        else {
                                            if ("px" !== r.h.unit) return null;
                                            a1 = r.h.value / e.pxDimensions.h;
                                        }
                                        if ("auto" === r) o = 0;
                                        else if ("%" === r.w.unit) o = r.w.value / 100;
                                        else {
                                            if ("px" !== r.w.unit) return null;
                                            o = r.w.value / e.pxDimensions.w;
                                        }
                                        return {
                                            h: a1,
                                            w: o
                                        };
                                    }),
                                    new r(t.ns_tts, "overflow", "hidden", [
                                        "region"
                                    ], !1, !0, function(e) {
                                        return e;
                                    }, null),
                                    new r(t.ns_tts, "padding", "0px", [
                                        "region"
                                    ], !1, !0, function(e) {
                                        var t = e.split(" ");
                                        if (t.length > 4) return null;
                                        var r = [];
                                        for(var i in t){
                                            var a1 = n.parseLength(t[i]);
                                            if (!a1) return null;
                                            r.push(a1);
                                        }
                                        return r;
                                    }, function(t, n, r, i, a1) {
                                        var o;
                                        if (1 === i.length) o = [
                                            i[0],
                                            i[0],
                                            i[0],
                                            i[0]
                                        ];
                                        else if (2 === i.length) o = [
                                            i[0],
                                            i[1],
                                            i[0],
                                            i[1]
                                        ];
                                        else if (3 === i.length) o = [
                                            i[0],
                                            i[1],
                                            i[2],
                                            i[1]
                                        ];
                                        else {
                                            if (4 !== i.length) return null;
                                            o = [
                                                i[0],
                                                i[1],
                                                i[2],
                                                i[3]
                                            ];
                                        }
                                        var s1 = r.styleAttrs[e.byName.writingMode.qname];
                                        if ("lrtb" === s1 || "lr" === s1) o = [
                                            o[0],
                                            o[3],
                                            o[2],
                                            o[1]
                                        ];
                                        else if ("rltb" === s1 || "rl" === s1) o = [
                                            o[0],
                                            o[1],
                                            o[2],
                                            o[3]
                                        ];
                                        else if ("tblr" === s1) o = [
                                            o[3],
                                            o[0],
                                            o[1],
                                            o[2]
                                        ];
                                        else {
                                            if ("tbrl" !== s1 && "tb" !== s1) return null;
                                            o = [
                                                o[3],
                                                o[2],
                                                o[1],
                                                o[0]
                                            ];
                                        }
                                        var u = [];
                                        for(var l in o)if (0 === o[l].value) u[l] = 0;
                                        else if ("%" === o[l].unit) u[l] = "0" === l || "2" === l ? r.styleAttrs[e.byName.extent.qname].h * o[l].value / 100 : r.styleAttrs[e.byName.extent.qname].w * o[l].value / 100;
                                        else if ("em" === o[l].unit) u[l] = r.styleAttrs[e.byName.fontSize.qname] * o[l].value;
                                        else if ("c" === o[l].unit) u[l] = o[l].value / t.cellResolution.h;
                                        else {
                                            if ("px" !== o[l].unit) return null;
                                            u[l] = "0" === l || "2" === l ? o[l].value / t.pxDimensions.h : o[l].value / t.pxDimensions.w;
                                        }
                                        return u;
                                    }),
                                    new r(t.ns_tts, "showBackground", "always", [
                                        "region"
                                    ], !1, !0, function(e) {
                                        return e;
                                    }, null),
                                    new r(t.ns_tts, "textAlign", "start", [
                                        "p"
                                    ], !0, !0, function(e) {
                                        return e;
                                    }, function(e, t, n, r, i) {
                                        return "left" === r ? "start" : "right" === r ? "end" : r;
                                    }),
                                    new r(t.ns_tts, "textDecoration", "none", [
                                        "span"
                                    ], !0, !0, function(e) {
                                        return e.split(" ");
                                    }, null),
                                    new r(t.ns_tts, "textOutline", "none", [
                                        "span"
                                    ], !0, !0, function(e) {
                                        if ("none" === e) return e;
                                        var t = {}, r = e.split(" ");
                                        if (0 === r.length || r.length > 2) return null;
                                        var i = n.parseColor(r[0]);
                                        if (t.color = i, null !== i && r.shift(), 1 !== r.length) return null;
                                        var a1 = n.parseLength(r[0]);
                                        return a1 ? (t.thickness = a1, t) : null;
                                    }, function(t, n, r, i, a1) {
                                        if ("none" === i) return i;
                                        var o = {};
                                        if (null === i.color ? o.color = r.styleAttrs[e.byName.color.qname] : o.color = i.color, "%" === i.thickness.unit) o.thickness = r.styleAttrs[e.byName.fontSize.qname] * i.thickness.value / 100;
                                        else if ("em" === i.thickness.unit) o.thickness = r.styleAttrs[e.byName.fontSize.qname] * i.thickness.value;
                                        else if ("c" === i.thickness.unit) o.thickness = i.thickness.value / t.cellResolution.h;
                                        else {
                                            if ("px" !== i.thickness.unit) return null;
                                            o.thickness = i.thickness.value / t.pxDimensions.h;
                                        }
                                        return o;
                                    }),
                                    new r(t.ns_tts, "unicodeBidi", "normal", [
                                        "span",
                                        "p"
                                    ], !1, !0, function(e) {
                                        return e;
                                    }, null),
                                    new r(t.ns_tts, "visibility", "visible", [
                                        "body",
                                        "div",
                                        "p",
                                        "region",
                                        "span"
                                    ], !0, !0, function(e) {
                                        return e;
                                    }, null),
                                    new r(t.ns_tts, "wrapOption", "wrap", [
                                        "span"
                                    ], !0, !0, function(e) {
                                        return e;
                                    }, null),
                                    new r(t.ns_tts, "writingMode", "lrtb", [
                                        "region"
                                    ], !1, !0, function(e) {
                                        return e;
                                    }, null),
                                    new r(t.ns_tts, "zIndex", "auto", [
                                        "region"
                                    ], !1, !0, function(e) {
                                        var t;
                                        return "auto" === e ? t = e : (t = parseInt(e), isNaN(t) && (t = null)), t;
                                    }, null),
                                    new r(t.ns_ebutts, "linePadding", "0c", [
                                        "p"
                                    ], !0, !1, n.parseLength, function(e, t, n, r, i) {
                                        return "c" === r.unit ? r.value / e.cellResolution.h : null;
                                    }),
                                    new r(t.ns_ebutts, "multiRowAlign", "auto", [
                                        "p"
                                    ], !0, !1, function(e) {
                                        return e;
                                    }, null),
                                    new r(t.ns_smpte, "backgroundImage", null, [
                                        "div"
                                    ], !1, !1, function(e) {
                                        return e;
                                    }, null),
                                    new r(t.ns_itts, "forcedDisplay", "false", [
                                        "body",
                                        "div",
                                        "p",
                                        "region",
                                        "span"
                                    ], !0, !0, function(e) {
                                        return "true" === e;
                                    }, null),
                                    new r(t.ns_itts, "fillLineGap", "false", [
                                        "p"
                                    ], !0, !0, function(e) {
                                        return "true" === e;
                                    }, null)
                                ], e.byQName = {}, e.all)e.byQName[e.all[i].qname] = e.all[i];
                                for(var a1 in e.byName = {}, e.all)e.byName[e.all[a1].name] = e.all[a1];
                            }(t, "undefined" == typeof imscNames ? n("./node_modules/imsc/src/main/js/names.js") : imscNames, "undefined" == typeof imscUtils ? n("./node_modules/imsc/src/main/js/utils.js") : imscUtils);
                        },
                        "./node_modules/imsc/src/main/js/utils.js": function(e, t, n) {
                            !function(e) {
                                var t = /#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})?/, n = /rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/, r = /rgba\(\s*(\d+),\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/, i = {
                                    transparent: [
                                        0,
                                        0,
                                        0,
                                        0
                                    ],
                                    black: [
                                        0,
                                        0,
                                        0,
                                        255
                                    ],
                                    silver: [
                                        192,
                                        192,
                                        192,
                                        255
                                    ],
                                    gray: [
                                        128,
                                        128,
                                        128,
                                        255
                                    ],
                                    white: [
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    maroon: [
                                        128,
                                        0,
                                        0,
                                        255
                                    ],
                                    red: [
                                        255,
                                        0,
                                        0,
                                        255
                                    ],
                                    purple: [
                                        128,
                                        0,
                                        128,
                                        255
                                    ],
                                    fuchsia: [
                                        255,
                                        0,
                                        255,
                                        255
                                    ],
                                    magenta: [
                                        255,
                                        0,
                                        255,
                                        255
                                    ],
                                    green: [
                                        0,
                                        128,
                                        0,
                                        255
                                    ],
                                    lime: [
                                        0,
                                        255,
                                        0,
                                        255
                                    ],
                                    olive: [
                                        128,
                                        128,
                                        0,
                                        255
                                    ],
                                    yellow: [
                                        255,
                                        255,
                                        0,
                                        255
                                    ],
                                    navy: [
                                        0,
                                        0,
                                        128,
                                        255
                                    ],
                                    blue: [
                                        0,
                                        0,
                                        255,
                                        255
                                    ],
                                    teal: [
                                        0,
                                        128,
                                        128,
                                        255
                                    ],
                                    aqua: [
                                        0,
                                        255,
                                        255,
                                        255
                                    ],
                                    cyan: [
                                        0,
                                        255,
                                        255,
                                        255
                                    ]
                                };
                                e.parseColor = function(e) {
                                    var a1, o = null, s1 = i[e.toLowerCase()];
                                    return void 0 !== s1 ? o = s1 : null !== (a1 = t.exec(e)) ? o = [
                                        parseInt(a1[1], 16),
                                        parseInt(a1[2], 16),
                                        parseInt(a1[3], 16),
                                        void 0 !== a1[4] ? parseInt(a1[4], 16) : 255
                                    ] : null !== (a1 = n.exec(e)) ? o = [
                                        parseInt(a1[1]),
                                        parseInt(a1[2]),
                                        parseInt(a1[3]),
                                        255
                                    ] : null !== (a1 = r.exec(e)) && (o = [
                                        parseInt(a1[1]),
                                        parseInt(a1[2]),
                                        parseInt(a1[3]),
                                        parseInt(a1[4])
                                    ]), o;
                                };
                                var a1 = /^((?:\+|\-)?\d*(?:\.\d+)?)(px|em|c|%)$/;
                                e.parseLength = function(e) {
                                    var t, n = null;
                                    return null !== (t = a1.exec(e)) && (n = {
                                        value: parseFloat(t[1]),
                                        unit: t[2]
                                    }), n;
                                };
                            }(t);
                        },
                        "./node_modules/inherits/inherits_browser.js": function(e, t) {
                            "function" == typeof Object.create ? e.exports = function(e, t) {
                                e.super_ = t, e.prototype = Object.create(t.prototype, {
                                    constructor: {
                                        value: e,
                                        enumerable: !1,
                                        writable: !0,
                                        configurable: !0
                                    }
                                });
                            } : e.exports = function(e, t) {
                                e.super_ = t;
                                var n = function() {};
                                n.prototype = t.prototype, e.prototype = new n, e.prototype.constructor = e;
                            };
                        },
                        "./node_modules/is-alphabetical/index.js": function(e, t, n) {
                            "use strict";
                            e.exports = function(e) {
                                var t = "string" == typeof e ? e.charCodeAt(0) : e;
                                return t >= 97 && t <= 122 || t >= 65 && t <= 90;
                            };
                        },
                        "./node_modules/is-alphanumerical/index.js": function(e, t, n) {
                            "use strict";
                            var r = n("./node_modules/is-alphabetical/index.js"), i = n("./node_modules/is-decimal/index.js");
                            e.exports = function(e) {
                                return r(e) || i(e);
                            };
                        },
                        "./node_modules/is-decimal/index.js": function(e, t, n) {
                            "use strict";
                            e.exports = function(e) {
                                var t = "string" == typeof e ? e.charCodeAt(0) : e;
                                return t >= 48 && t <= 57;
                            };
                        },
                        "./node_modules/isarray/index.js": function(e, t) {
                            var n = {}.toString;
                            e.exports = Array.isArray || function(e) {
                                return "[object Array]" == n.call(e);
                            };
                        },
                        "./node_modules/node-libs-browser/node_modules/buffer/index.js": function(e, t, n) {
                            "use strict";
                            (function(e) {
                                var r = n("./node_modules/base64-js/index.js"), i = n("./node_modules/ieee754/index.js"), a1 = n("./node_modules/isarray/index.js");
                                function o() {
                                    return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
                                }
                                function s1(e, t) {
                                    if (o() < t) throw new RangeError("Invalid typed array length");
                                    return u.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = u.prototype : (null === e && (e = new u(t)), e.length = t), e;
                                }
                                function u(e, t, n) {
                                    if (!(u.TYPED_ARRAY_SUPPORT || this instanceof u)) return new u(e, t, n);
                                    if ("number" == typeof e) {
                                        if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");
                                        return d(this, e);
                                    }
                                    return l(this, e, t, n);
                                }
                                function l(e, t, n, r) {
                                    if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');
                                    return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? function(e, t, n, r) {
                                        if (t.byteLength, n < 0 || t.byteLength < n) throw new RangeError("'offset' is out of bounds");
                                        if (t.byteLength < n + (r || 0)) throw new RangeError("'length' is out of bounds");
                                        return t = void 0 === n && void 0 === r ? new Uint8Array(t) : void 0 === r ? new Uint8Array(t, n) : new Uint8Array(t, n, r), u.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = u.prototype : e = f(e, t), e;
                                    }(e, t, n, r) : "string" == typeof t ? function(e, t, n) {
                                        if ("string" == typeof n && "" !== n || (n = "utf8"), !u.isEncoding(n)) throw new TypeError('"encoding" must be a valid string encoding');
                                        var r = 0 | g(t, n), i = (e = s1(e, r)).write(t, n);
                                        return i !== r && (e = e.slice(0, i)), e;
                                    }(e, t, n) : function(e, t) {
                                        if (u.isBuffer(t)) {
                                            var n = 0 | h(t.length);
                                            return 0 === (e = s1(e, n)).length || t.copy(e, 0, 0, n), e;
                                        }
                                        if (t) {
                                            if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || (r = t.length) != r ? s1(e, 0) : f(e, t);
                                            if ("Buffer" === t.type && a1(t.data)) return f(e, t.data);
                                        }
                                        var r;
                                        throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
                                    }(e, t);
                                }
                                function c(e) {
                                    if ("number" != typeof e) throw new TypeError('"size" argument must be a number');
                                    if (e < 0) throw new RangeError('"size" argument must not be negative');
                                }
                                function d(e, t) {
                                    if (c(t), e = s1(e, t < 0 ? 0 : 0 | h(t)), !u.TYPED_ARRAY_SUPPORT) for(var n = 0; n < t; ++n)e[n] = 0;
                                    return e;
                                }
                                function f(e, t) {
                                    var n = t.length < 0 ? 0 : 0 | h(t.length);
                                    e = s1(e, n);
                                    for(var r = 0; r < n; r += 1)e[r] = 255 & t[r];
                                    return e;
                                }
                                function h(e) {
                                    if (e >= o()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + o().toString(16) + " bytes");
                                    return 0 | e;
                                }
                                function g(e, t) {
                                    if (u.isBuffer(e)) return e.length;
                                    if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
                                    "string" != typeof e && (e = "" + e);
                                    var n = e.length;
                                    if (0 === n) return 0;
                                    for(var r = !1;;)switch(t){
                                        case "ascii":
                                        case "latin1":
                                        case "binary":
                                            return n;
                                        case "utf8":
                                        case "utf-8":
                                        case void 0:
                                            return B(e).length;
                                        case "ucs2":
                                        case "ucs-2":
                                        case "utf16le":
                                        case "utf-16le":
                                            return 2 * n;
                                        case "hex":
                                            return n >>> 1;
                                        case "base64":
                                            return G(e).length;
                                        default:
                                            if (r) return B(e).length;
                                            t = ("" + t).toLowerCase(), r = !0;
                                    }
                                }
                                function p(e, t, n) {
                                    var r = !1;
                                    if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
                                    if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return "";
                                    if ((n >>>= 0) <= (t >>>= 0)) return "";
                                    for(e || (e = "utf8");;)switch(e){
                                        case "hex":
                                            return k(this, t, n);
                                        case "utf8":
                                        case "utf-8":
                                            return I(this, t, n);
                                        case "ascii":
                                            return C(this, t, n);
                                        case "latin1":
                                        case "binary":
                                            return D(this, t, n);
                                        case "base64":
                                            return w(this, t, n);
                                        case "ucs2":
                                        case "ucs-2":
                                        case "utf16le":
                                        case "utf-16le":
                                            return N(this, t, n);
                                        default:
                                            if (r) throw new TypeError("Unknown encoding: " + e);
                                            e = (e + "").toLowerCase(), r = !0;
                                    }
                                }
                                function m(e, t, n) {
                                    var r = e[t];
                                    e[t] = e[n], e[n] = r;
                                }
                                function v(e, t, n, r, i) {
                                    if (0 === e.length) return -1;
                                    if ("string" == typeof n ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = i ? 0 : e.length - 1), n < 0 && (n = e.length + n), n >= e.length) {
                                        if (i) return -1;
                                        n = e.length - 1;
                                    } else if (n < 0) {
                                        if (!i) return -1;
                                        n = 0;
                                    }
                                    if ("string" == typeof t && (t = u.from(t, r)), u.isBuffer(t)) return 0 === t.length ? -1 : y(e, t, n, r, i);
                                    if ("number" == typeof t) return t &= 255, u.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, n) : Uint8Array.prototype.lastIndexOf.call(e, t, n) : y(e, [
                                        t
                                    ], n, r, i);
                                    throw new TypeError("val must be string, number or Buffer");
                                }
                                function y(e, t, n, r, i) {
                                    var a1, o = 1, s1 = e.length, u = t.length;
                                    if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
                                        if (e.length < 2 || t.length < 2) return -1;
                                        o = 2, s1 /= 2, u /= 2, n /= 2;
                                    }
                                    function l(e, t) {
                                        return 1 === o ? e[t] : e.readUInt16BE(t * o);
                                    }
                                    if (i) {
                                        var c = -1;
                                        for(a1 = n; a1 < s1; a1++)if (l(e, a1) === l(t, -1 === c ? 0 : a1 - c)) {
                                            if (-1 === c && (c = a1), a1 - c + 1 === u) return c * o;
                                        } else -1 !== c && (a1 -= a1 - c), c = -1;
                                    } else for(n + u > s1 && (n = s1 - u), a1 = n; a1 >= 0; a1--){
                                        for(var d = !0, f = 0; f < u; f++)if (l(e, a1 + f) !== l(t, f)) {
                                            d = !1;
                                            break;
                                        }
                                        if (d) return a1;
                                    }
                                    return -1;
                                }
                                function E(e, t, n, r) {
                                    n = Number(n) || 0;
                                    var i = e.length - n;
                                    r ? (r = Number(r)) > i && (r = i) : r = i;
                                    var a1 = t.length;
                                    if (a1 % 2 != 0) throw new TypeError("Invalid hex string");
                                    r > a1 / 2 && (r = a1 / 2);
                                    for(var o = 0; o < r; ++o){
                                        var s1 = parseInt(t.substr(2 * o, 2), 16);
                                        if (isNaN(s1)) return o;
                                        e[n + o] = s1;
                                    }
                                    return o;
                                }
                                function T(e, t, n, r) {
                                    return H(B(t, e.length - n), e, n, r);
                                }
                                function b(e, t, n, r) {
                                    return H(function(e) {
                                        for(var t = [], n = 0; n < e.length; ++n)t.push(255 & e.charCodeAt(n));
                                        return t;
                                    }(t), e, n, r);
                                }
                                function A(e, t, n, r) {
                                    return b(e, t, n, r);
                                }
                                function _(e, t, n, r) {
                                    return H(G(t), e, n, r);
                                }
                                function S(e, t, n, r) {
                                    return H(function(e, t) {
                                        for(var n, r, i, a1 = [], o = 0; o < e.length && !((t -= 2) < 0); ++o)r = (n = e.charCodeAt(o)) >> 8, i = n % 256, a1.push(i), a1.push(r);
                                        return a1;
                                    }(t, e.length - n), e, n, r);
                                }
                                function w(e, t, n) {
                                    return 0 === t && n === e.length ? r.fromByteArray(e) : r.fromByteArray(e.slice(t, n));
                                }
                                function I(e, t, n) {
                                    n = Math.min(e.length, n);
                                    for(var r = [], i = t; i < n;){
                                        var a1, o, s1, u, l = e[i], c = null, d = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                                        if (i + d <= n) switch(d){
                                            case 1:
                                                l < 128 && (c = l);
                                                break;
                                            case 2:
                                                128 == (192 & (a1 = e[i + 1])) && (u = (31 & l) << 6 | 63 & a1) > 127 && (c = u);
                                                break;
                                            case 3:
                                                a1 = e[i + 1], o = e[i + 2], 128 == (192 & a1) && 128 == (192 & o) && (u = (15 & l) << 12 | (63 & a1) << 6 | 63 & o) > 2047 && (u < 55296 || u > 57343) && (c = u);
                                                break;
                                            case 4:
                                                a1 = e[i + 1], o = e[i + 2], s1 = e[i + 3], 128 == (192 & a1) && 128 == (192 & o) && 128 == (192 & s1) && (u = (15 & l) << 18 | (63 & a1) << 12 | (63 & o) << 6 | 63 & s1) > 65535 && u < 1114112 && (c = u);
                                        }
                                        null === c ? (c = 65533, d = 1) : c > 65535 && (c -= 65536, r.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), r.push(c), i += d;
                                    }
                                    return function(e) {
                                        var t = e.length;
                                        if (t <= R) return String.fromCharCode.apply(String, e);
                                        for(var n = "", r = 0; r < t;)n += String.fromCharCode.apply(String, e.slice(r, r += R));
                                        return n;
                                    }(r);
                                }
                                t.Buffer = u, t.SlowBuffer = function(e) {
                                    return +e != e && (e = 0), u.alloc(+e);
                                }, t.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = void 0 !== e.TYPED_ARRAY_SUPPORT ? e.TYPED_ARRAY_SUPPORT : function() {
                                    try {
                                        var e = new Uint8Array(1);
                                        return e.__proto__ = {
                                            __proto__: Uint8Array.prototype,
                                            foo: function() {
                                                return 42;
                                            }
                                        }, 42 === e.foo() && "function" == typeof e.subarray && 0 === e.subarray(1, 1).byteLength;
                                    } catch (e) {
                                        return !1;
                                    }
                                }(), t.kMaxLength = o(), u.poolSize = 8192, u._augment = function(e) {
                                    return e.__proto__ = u.prototype, e;
                                }, u.from = function(e, t, n) {
                                    return l(null, e, t, n);
                                }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, {
                                    value: null,
                                    configurable: !0
                                })), u.alloc = function(e, t, n) {
                                    return function(e, t, n, r) {
                                        return c(t), t <= 0 ? s1(e, t) : void 0 !== n ? "string" == typeof r ? s1(e, t).fill(n, r) : s1(e, t).fill(n) : s1(e, t);
                                    }(null, e, t, n);
                                }, u.allocUnsafe = function(e) {
                                    return d(null, e);
                                }, u.allocUnsafeSlow = function(e) {
                                    return d(null, e);
                                }, u.isBuffer = function(e) {
                                    return !(null == e || !e._isBuffer);
                                }, u.compare = function(e, t) {
                                    if (!u.isBuffer(e) || !u.isBuffer(t)) throw new TypeError("Arguments must be Buffers");
                                    if (e === t) return 0;
                                    for(var n = e.length, r = t.length, i = 0, a1 = Math.min(n, r); i < a1; ++i)if (e[i] !== t[i]) {
                                        n = e[i], r = t[i];
                                        break;
                                    }
                                    return n < r ? -1 : r < n ? 1 : 0;
                                }, u.isEncoding = function(e) {
                                    switch(String(e).toLowerCase()){
                                        case "hex":
                                        case "utf8":
                                        case "utf-8":
                                        case "ascii":
                                        case "latin1":
                                        case "binary":
                                        case "base64":
                                        case "ucs2":
                                        case "ucs-2":
                                        case "utf16le":
                                        case "utf-16le":
                                            return !0;
                                        default:
                                            return !1;
                                    }
                                }, u.concat = function(e, t) {
                                    if (!a1(e)) throw new TypeError('"list" argument must be an Array of Buffers');
                                    if (0 === e.length) return u.alloc(0);
                                    var n;
                                    if (void 0 === t) for(t = 0, n = 0; n < e.length; ++n)t += e[n].length;
                                    var r = u.allocUnsafe(t), i = 0;
                                    for(n = 0; n < e.length; ++n){
                                        var o = e[n];
                                        if (!u.isBuffer(o)) throw new TypeError('"list" argument must be an Array of Buffers');
                                        o.copy(r, i), i += o.length;
                                    }
                                    return r;
                                }, u.byteLength = g, u.prototype._isBuffer = !0, u.prototype.swap16 = function() {
                                    var e = this.length;
                                    if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                                    for(var t = 0; t < e; t += 2)m(this, t, t + 1);
                                    return this;
                                }, u.prototype.swap32 = function() {
                                    var e = this.length;
                                    if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                                    for(var t = 0; t < e; t += 4)m(this, t, t + 3), m(this, t + 1, t + 2);
                                    return this;
                                }, u.prototype.swap64 = function() {
                                    var e = this.length;
                                    if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                                    for(var t = 0; t < e; t += 8)m(this, t, t + 7), m(this, t + 1, t + 6), m(this, t + 2, t + 5), m(this, t + 3, t + 4);
                                    return this;
                                }, u.prototype.toString = function() {
                                    var e = 0 | this.length;
                                    return 0 === e ? "" : 0 === arguments.length ? I(this, 0, e) : p.apply(this, arguments);
                                }, u.prototype.equals = function(e) {
                                    if (!u.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
                                    return this === e || 0 === u.compare(this, e);
                                }, u.prototype.inspect = function() {
                                    var e = "", n = t.INSPECT_MAX_BYTES;
                                    return this.length > 0 && (e = this.toString("hex", 0, n).match(/.{2}/g).join(" "), this.length > n && (e += " ... ")), "<Buffer " + e + ">";
                                }, u.prototype.compare = function(e, t, n, r, i) {
                                    if (!u.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
                                    if (void 0 === t && (t = 0), void 0 === n && (n = e ? e.length : 0), void 0 === r && (r = 0), void 0 === i && (i = this.length), t < 0 || n > e.length || r < 0 || i > this.length) throw new RangeError("out of range index");
                                    if (r >= i && t >= n) return 0;
                                    if (r >= i) return -1;
                                    if (t >= n) return 1;
                                    if (this === e) return 0;
                                    for(var a1 = (i >>>= 0) - (r >>>= 0), o = (n >>>= 0) - (t >>>= 0), s1 = Math.min(a1, o), l = this.slice(r, i), c = e.slice(t, n), d = 0; d < s1; ++d)if (l[d] !== c[d]) {
                                        a1 = l[d], o = c[d];
                                        break;
                                    }
                                    return a1 < o ? -1 : o < a1 ? 1 : 0;
                                }, u.prototype.includes = function(e, t, n) {
                                    return -1 !== this.indexOf(e, t, n);
                                }, u.prototype.indexOf = function(e, t, n) {
                                    return v(this, e, t, n, !0);
                                }, u.prototype.lastIndexOf = function(e, t, n) {
                                    return v(this, e, t, n, !1);
                                }, u.prototype.write = function(e, t, n, r) {
                                    if (void 0 === t) r = "utf8", n = this.length, t = 0;
                                    else if (void 0 === n && "string" == typeof t) r = t, n = this.length, t = 0;
                                    else {
                                        if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                                        t |= 0, isFinite(n) ? (n |= 0, void 0 === r && (r = "utf8")) : (r = n, n = void 0);
                                    }
                                    var i = this.length - t;
                                    if ((void 0 === n || n > i) && (n = i), e.length > 0 && (n < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                                    r || (r = "utf8");
                                    for(var a1 = !1;;)switch(r){
                                        case "hex":
                                            return E(this, e, t, n);
                                        case "utf8":
                                        case "utf-8":
                                            return T(this, e, t, n);
                                        case "ascii":
                                            return b(this, e, t, n);
                                        case "latin1":
                                        case "binary":
                                            return A(this, e, t, n);
                                        case "base64":
                                            return _(this, e, t, n);
                                        case "ucs2":
                                        case "ucs-2":
                                        case "utf16le":
                                        case "utf-16le":
                                            return S(this, e, t, n);
                                        default:
                                            if (a1) throw new TypeError("Unknown encoding: " + r);
                                            r = ("" + r).toLowerCase(), a1 = !0;
                                    }
                                }, u.prototype.toJSON = function() {
                                    return {
                                        type: "Buffer",
                                        data: Array.prototype.slice.call(this._arr || this, 0)
                                    };
                                };
                                var R = 4096;
                                function C(e, t, n) {
                                    var r = "";
                                    n = Math.min(e.length, n);
                                    for(var i = t; i < n; ++i)r += String.fromCharCode(127 & e[i]);
                                    return r;
                                }
                                function D(e, t, n) {
                                    var r = "";
                                    n = Math.min(e.length, n);
                                    for(var i = t; i < n; ++i)r += String.fromCharCode(e[i]);
                                    return r;
                                }
                                function k(e, t, n) {
                                    var r, i = e.length;
                                    (!t || t < 0) && (t = 0), (!n || n < 0 || n > i) && (n = i);
                                    for(var a1 = "", o = t; o < n; ++o)a1 += (r = e[o]) < 16 ? "0" + r.toString(16) : r.toString(16);
                                    return a1;
                                }
                                function N(e, t, n) {
                                    for(var r = e.slice(t, n), i = "", a1 = 0; a1 < r.length; a1 += 2)i += String.fromCharCode(r[a1] + 256 * r[a1 + 1]);
                                    return i;
                                }
                                function L(e, t, n) {
                                    if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
                                    if (e + t > n) throw new RangeError("Trying to access beyond buffer length");
                                }
                                function x(e, t, n, r, i, a1) {
                                    if (!u.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
                                    if (t > i || t < a1) throw new RangeError('"value" argument is out of bounds');
                                    if (n + r > e.length) throw new RangeError("Index out of range");
                                }
                                function M(e, t, n, r) {
                                    t < 0 && (t = 65535 + t + 1);
                                    for(var i = 0, a1 = Math.min(e.length - n, 2); i < a1; ++i)e[n + i] = (t & 255 << 8 * (r ? i : 1 - i)) >>> 8 * (r ? i : 1 - i);
                                }
                                function O(e, t, n, r) {
                                    t < 0 && (t = 4294967295 + t + 1);
                                    for(var i = 0, a1 = Math.min(e.length - n, 4); i < a1; ++i)e[n + i] = t >>> 8 * (r ? i : 3 - i) & 255;
                                }
                                function P(e, t, n, r, i, a1) {
                                    if (n + r > e.length) throw new RangeError("Index out of range");
                                    if (n < 0) throw new RangeError("Index out of range");
                                }
                                function F(e, t, n, r, a1) {
                                    return a1 || P(e, 0, n, 4), i.write(e, t, n, r, 23, 4), n + 4;
                                }
                                function U(e, t, n, r, a1) {
                                    return a1 || P(e, 0, n, 8), i.write(e, t, n, r, 52, 8), n + 8;
                                }
                                u.prototype.slice = function(e, t) {
                                    var n, r = this.length;
                                    if ((e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e), u.TYPED_ARRAY_SUPPORT) (n = this.subarray(e, t)).__proto__ = u.prototype;
                                    else {
                                        var i = t - e;
                                        n = new u(i, void 0);
                                        for(var a1 = 0; a1 < i; ++a1)n[a1] = this[a1 + e];
                                    }
                                    return n;
                                }, u.prototype.readUIntLE = function(e, t, n) {
                                    e |= 0, t |= 0, n || L(e, t, this.length);
                                    for(var r = this[e], i = 1, a1 = 0; ++a1 < t && (i *= 256);)r += this[e + a1] * i;
                                    return r;
                                }, u.prototype.readUIntBE = function(e, t, n) {
                                    e |= 0, t |= 0, n || L(e, t, this.length);
                                    for(var r = this[e + --t], i = 1; t > 0 && (i *= 256);)r += this[e + --t] * i;
                                    return r;
                                }, u.prototype.readUInt8 = function(e, t) {
                                    return t || L(e, 1, this.length), this[e];
                                }, u.prototype.readUInt16LE = function(e, t) {
                                    return t || L(e, 2, this.length), this[e] | this[e + 1] << 8;
                                }, u.prototype.readUInt16BE = function(e, t) {
                                    return t || L(e, 2, this.length), this[e] << 8 | this[e + 1];
                                }, u.prototype.readUInt32LE = function(e, t) {
                                    return t || L(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
                                }, u.prototype.readUInt32BE = function(e, t) {
                                    return t || L(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
                                }, u.prototype.readIntLE = function(e, t, n) {
                                    e |= 0, t |= 0, n || L(e, t, this.length);
                                    for(var r = this[e], i = 1, a1 = 0; ++a1 < t && (i *= 256);)r += this[e + a1] * i;
                                    return r >= (i *= 128) && (r -= Math.pow(2, 8 * t)), r;
                                }, u.prototype.readIntBE = function(e, t, n) {
                                    e |= 0, t |= 0, n || L(e, t, this.length);
                                    for(var r = t, i = 1, a1 = this[e + --r]; r > 0 && (i *= 256);)a1 += this[e + --r] * i;
                                    return a1 >= (i *= 128) && (a1 -= Math.pow(2, 8 * t)), a1;
                                }, u.prototype.readInt8 = function(e, t) {
                                    return t || L(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                                }, u.prototype.readInt16LE = function(e, t) {
                                    t || L(e, 2, this.length);
                                    var n = this[e] | this[e + 1] << 8;
                                    return 32768 & n ? 4294901760 | n : n;
                                }, u.prototype.readInt16BE = function(e, t) {
                                    t || L(e, 2, this.length);
                                    var n = this[e + 1] | this[e] << 8;
                                    return 32768 & n ? 4294901760 | n : n;
                                }, u.prototype.readInt32LE = function(e, t) {
                                    return t || L(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
                                }, u.prototype.readInt32BE = function(e, t) {
                                    return t || L(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
                                }, u.prototype.readFloatLE = function(e, t) {
                                    return t || L(e, 4, this.length), i.read(this, e, !0, 23, 4);
                                }, u.prototype.readFloatBE = function(e, t) {
                                    return t || L(e, 4, this.length), i.read(this, e, !1, 23, 4);
                                }, u.prototype.readDoubleLE = function(e, t) {
                                    return t || L(e, 8, this.length), i.read(this, e, !0, 52, 8);
                                }, u.prototype.readDoubleBE = function(e, t) {
                                    return t || L(e, 8, this.length), i.read(this, e, !1, 52, 8);
                                }, u.prototype.writeUIntLE = function(e, t, n, r) {
                                    e = +e, t |= 0, n |= 0, r || x(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
                                    var i = 1, a1 = 0;
                                    for(this[t] = 255 & e; ++a1 < n && (i *= 256);)this[t + a1] = e / i & 255;
                                    return t + n;
                                }, u.prototype.writeUIntBE = function(e, t, n, r) {
                                    e = +e, t |= 0, n |= 0, r || x(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
                                    var i = n - 1, a1 = 1;
                                    for(this[t + i] = 255 & e; --i >= 0 && (a1 *= 256);)this[t + i] = e / a1 & 255;
                                    return t + n;
                                }, u.prototype.writeUInt8 = function(e, t, n) {
                                    return e = +e, t |= 0, n || x(this, e, t, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
                                }, u.prototype.writeUInt16LE = function(e, t, n) {
                                    return e = +e, t |= 0, n || x(this, e, t, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : M(this, e, t, !0), t + 2;
                                }, u.prototype.writeUInt16BE = function(e, t, n) {
                                    return e = +e, t |= 0, n || x(this, e, t, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : M(this, e, t, !1), t + 2;
                                }, u.prototype.writeUInt32LE = function(e, t, n) {
                                    return e = +e, t |= 0, n || x(this, e, t, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : O(this, e, t, !0), t + 4;
                                }, u.prototype.writeUInt32BE = function(e, t, n) {
                                    return e = +e, t |= 0, n || x(this, e, t, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : O(this, e, t, !1), t + 4;
                                }, u.prototype.writeIntLE = function(e, t, n, r) {
                                    if (e = +e, t |= 0, !r) {
                                        var i = Math.pow(2, 8 * n - 1);
                                        x(this, e, t, n, i - 1, -i);
                                    }
                                    var a1 = 0, o = 1, s1 = 0;
                                    for(this[t] = 255 & e; ++a1 < n && (o *= 256);)e < 0 && 0 === s1 && 0 !== this[t + a1 - 1] && (s1 = 1), this[t + a1] = (e / o >> 0) - s1 & 255;
                                    return t + n;
                                }, u.prototype.writeIntBE = function(e, t, n, r) {
                                    if (e = +e, t |= 0, !r) {
                                        var i = Math.pow(2, 8 * n - 1);
                                        x(this, e, t, n, i - 1, -i);
                                    }
                                    var a1 = n - 1, o = 1, s1 = 0;
                                    for(this[t + a1] = 255 & e; --a1 >= 0 && (o *= 256);)e < 0 && 0 === s1 && 0 !== this[t + a1 + 1] && (s1 = 1), this[t + a1] = (e / o >> 0) - s1 & 255;
                                    return t + n;
                                }, u.prototype.writeInt8 = function(e, t, n) {
                                    return e = +e, t |= 0, n || x(this, e, t, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
                                }, u.prototype.writeInt16LE = function(e, t, n) {
                                    return e = +e, t |= 0, n || x(this, e, t, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : M(this, e, t, !0), t + 2;
                                }, u.prototype.writeInt16BE = function(e, t, n) {
                                    return e = +e, t |= 0, n || x(this, e, t, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : M(this, e, t, !1), t + 2;
                                }, u.prototype.writeInt32LE = function(e, t, n) {
                                    return e = +e, t |= 0, n || x(this, e, t, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : O(this, e, t, !0), t + 4;
                                }, u.prototype.writeInt32BE = function(e, t, n) {
                                    return e = +e, t |= 0, n || x(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : O(this, e, t, !1), t + 4;
                                }, u.prototype.writeFloatLE = function(e, t, n) {
                                    return F(this, e, t, !0, n);
                                }, u.prototype.writeFloatBE = function(e, t, n) {
                                    return F(this, e, t, !1, n);
                                }, u.prototype.writeDoubleLE = function(e, t, n) {
                                    return U(this, e, t, !0, n);
                                }, u.prototype.writeDoubleBE = function(e, t, n) {
                                    return U(this, e, t, !1, n);
                                }, u.prototype.copy = function(e, t, n, r) {
                                    if (n || (n = 0), r || 0 === r || (r = this.length), t >= e.length && (t = e.length), t || (t = 0), r > 0 && r < n && (r = n), r === n) return 0;
                                    if (0 === e.length || 0 === this.length) return 0;
                                    if (t < 0) throw new RangeError("targetStart out of bounds");
                                    if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
                                    if (r < 0) throw new RangeError("sourceEnd out of bounds");
                                    r > this.length && (r = this.length), e.length - t < r - n && (r = e.length - t + n);
                                    var i, a1 = r - n;
                                    if (this === e && n < t && t < r) for(i = a1 - 1; i >= 0; --i)e[i + t] = this[i + n];
                                    else if (a1 < 1e3 || !u.TYPED_ARRAY_SUPPORT) for(i = 0; i < a1; ++i)e[i + t] = this[i + n];
                                    else Uint8Array.prototype.set.call(e, this.subarray(n, n + a1), t);
                                    return a1;
                                }, u.prototype.fill = function(e, t, n, r) {
                                    if ("string" == typeof e) {
                                        if ("string" == typeof t ? (r = t, t = 0, n = this.length) : "string" == typeof n && (r = n, n = this.length), 1 === e.length) {
                                            var i = e.charCodeAt(0);
                                            i < 256 && (e = i);
                                        }
                                        if (void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");
                                        if ("string" == typeof r && !u.isEncoding(r)) throw new TypeError("Unknown encoding: " + r);
                                    } else "number" == typeof e && (e &= 255);
                                    if (t < 0 || this.length < t || this.length < n) throw new RangeError("Out of range index");
                                    if (n <= t) return this;
                                    var a1;
                                    if (t >>>= 0, n = void 0 === n ? this.length : n >>> 0, e || (e = 0), "number" == typeof e) for(a1 = t; a1 < n; ++a1)this[a1] = e;
                                    else {
                                        var o = u.isBuffer(e) ? e : B(new u(e, r).toString()), s1 = o.length;
                                        for(a1 = 0; a1 < n - t; ++a1)this[a1 + t] = o[a1 % s1];
                                    }
                                    return this;
                                };
                                var j = /[^+\/0-9A-Za-z-_]/g;
                                function B(e, t) {
                                    var n;
                                    t = t || 1 / 0;
                                    for(var r = e.length, i = null, a1 = [], o = 0; o < r; ++o){
                                        if ((n = e.charCodeAt(o)) > 55295 && n < 57344) {
                                            if (!i) {
                                                if (n > 56319) {
                                                    (t -= 3) > -1 && a1.push(239, 191, 189);
                                                    continue;
                                                }
                                                if (o + 1 === r) {
                                                    (t -= 3) > -1 && a1.push(239, 191, 189);
                                                    continue;
                                                }
                                                i = n;
                                                continue;
                                            }
                                            if (n < 56320) {
                                                (t -= 3) > -1 && a1.push(239, 191, 189), i = n;
                                                continue;
                                            }
                                            n = 65536 + (i - 55296 << 10 | n - 56320);
                                        } else i && (t -= 3) > -1 && a1.push(239, 191, 189);
                                        if (i = null, n < 128) {
                                            if ((t -= 1) < 0) break;
                                            a1.push(n);
                                        } else if (n < 2048) {
                                            if ((t -= 2) < 0) break;
                                            a1.push(n >> 6 | 192, 63 & n | 128);
                                        } else if (n < 65536) {
                                            if ((t -= 3) < 0) break;
                                            a1.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128);
                                        } else {
                                            if (!(n < 1114112)) throw new Error("Invalid code point");
                                            if ((t -= 4) < 0) break;
                                            a1.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128);
                                        }
                                    }
                                    return a1;
                                }
                                function G(e) {
                                    return r.toByteArray(function(e) {
                                        if ((e = (function(e) {
                                            return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
                                        })(e).replace(j, "")).length < 2) return "";
                                        for(; e.length % 4 != 0;)e += "=";
                                        return e;
                                    }(e));
                                }
                                function H(e, t, n, r) {
                                    for(var i = 0; i < r && !(i + n >= t.length || i >= e.length); ++i)t[i + n] = e[i];
                                    return i;
                                }
                            }).call(this, n("./node_modules/webpack/buildin/global.js"));
                        },
                        "./node_modules/node-libs-browser/node_modules/events/events.js": function(e, t, n) {
                            "use strict";
                            var r, i = "object" == typeof Reflect ? Reflect : null, a1 = i && "function" == typeof i.apply ? i.apply : function(e, t, n) {
                                return Function.prototype.apply.call(e, t, n);
                            };
                            r = i && "function" == typeof i.ownKeys ? i.ownKeys : Object.getOwnPropertySymbols ? function(e) {
                                return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
                            } : function(e) {
                                return Object.getOwnPropertyNames(e);
                            };
                            var o = Number.isNaN || function(e) {
                                return e != e;
                            };
                            function s1() {
                                s1.init.call(this);
                            }
                            e.exports = s1, e.exports.once = function(e, t) {
                                return new Promise(function(n, r) {
                                    function i(n) {
                                        e.removeListener(t, a1), r(n);
                                    }
                                    function a1() {
                                        "function" == typeof e.removeListener && e.removeListener("error", i), n([].slice.call(arguments));
                                    }
                                    v(e, t, a1, {
                                        once: !0
                                    }), "error" !== t && function(e, t, n) {
                                        "function" == typeof e.on && v(e, "error", t, {
                                            once: !0
                                        });
                                    }(e, i);
                                });
                            }, s1.EventEmitter = s1, s1.prototype._events = void 0, s1.prototype._eventsCount = 0, s1.prototype._maxListeners = void 0;
                            var u = 10;
                            function l(e) {
                                if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
                            }
                            function c(e) {
                                return void 0 === e._maxListeners ? s1.defaultMaxListeners : e._maxListeners;
                            }
                            function d(e, t, n, r) {
                                var i, a1, o, s1;
                                if (l(n), void 0 === (a1 = e._events) ? (a1 = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== a1.newListener && (e.emit("newListener", t, n.listener ? n.listener : n), a1 = e._events), o = a1[t]), void 0 === o) o = a1[t] = n, ++e._eventsCount;
                                else if ("function" == typeof o ? o = a1[t] = r ? [
                                    n,
                                    o
                                ] : [
                                    o,
                                    n
                                ] : r ? o.unshift(n) : o.push(n), (i = c(e)) > 0 && o.length > i && !o.warned) {
                                    o.warned = !0;
                                    var u = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                                    u.name = "MaxListenersExceededWarning", u.emitter = e, u.type = t, u.count = o.length, s1 = u, console && console.warn && console.warn(s1);
                                }
                                return e;
                            }
                            function f() {
                                if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
                            }
                            function h(e, t, n) {
                                var r = {
                                    fired: !1,
                                    wrapFn: void 0,
                                    target: e,
                                    type: t,
                                    listener: n
                                }, i = f.bind(r);
                                return i.listener = n, r.wrapFn = i, i;
                            }
                            function g(e, t, n) {
                                var r = e._events;
                                if (void 0 === r) return [];
                                var i = r[t];
                                return void 0 === i ? [] : "function" == typeof i ? n ? [
                                    i.listener || i
                                ] : [
                                    i
                                ] : n ? function(e) {
                                    for(var t = new Array(e.length), n = 0; n < t.length; ++n)t[n] = e[n].listener || e[n];
                                    return t;
                                }(i) : m(i, i.length);
                            }
                            function p(e) {
                                var t = this._events;
                                if (void 0 !== t) {
                                    var n = t[e];
                                    if ("function" == typeof n) return 1;
                                    if (void 0 !== n) return n.length;
                                }
                                return 0;
                            }
                            function m(e, t) {
                                for(var n = new Array(t), r = 0; r < t; ++r)n[r] = e[r];
                                return n;
                            }
                            function v(e, t, n, r) {
                                if ("function" == typeof e.on) r.once ? e.once(t, n) : e.on(t, n);
                                else {
                                    if ("function" != typeof e.addEventListener) throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
                                    e.addEventListener(t, function i(a1) {
                                        r.once && e.removeEventListener(t, i), n(a1);
                                    });
                                }
                            }
                            Object.defineProperty(s1, "defaultMaxListeners", {
                                enumerable: !0,
                                get: function() {
                                    return u;
                                },
                                set: function(e) {
                                    if ("number" != typeof e || e < 0 || o(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
                                    u = e;
                                }
                            }), s1.init = function() {
                                void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                            }, s1.prototype.setMaxListeners = function(e) {
                                if ("number" != typeof e || e < 0 || o(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
                                return this._maxListeners = e, this;
                            }, s1.prototype.getMaxListeners = function() {
                                return c(this);
                            }, s1.prototype.emit = function(e) {
                                for(var t = [], n = 1; n < arguments.length; n++)t.push(arguments[n]);
                                var r = "error" === e, i = this._events;
                                if (void 0 !== i) r = r && void 0 === i.error;
                                else if (!r) return !1;
                                if (r) {
                                    var o;
                                    if (t.length > 0 && (o = t[0]), o instanceof Error) throw o;
                                    var s1 = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
                                    throw s1.context = o, s1;
                                }
                                var u = i[e];
                                if (void 0 === u) return !1;
                                if ("function" == typeof u) a1(u, this, t);
                                else {
                                    var l = u.length, c = m(u, l);
                                    for(n = 0; n < l; ++n)a1(c[n], this, t);
                                }
                                return !0;
                            }, s1.prototype.addListener = function(e, t) {
                                return d(this, e, t, !1);
                            }, s1.prototype.on = s1.prototype.addListener, s1.prototype.prependListener = function(e, t) {
                                return d(this, e, t, !0);
                            }, s1.prototype.once = function(e, t) {
                                return l(t), this.on(e, h(this, e, t)), this;
                            }, s1.prototype.prependOnceListener = function(e, t) {
                                return l(t), this.prependListener(e, h(this, e, t)), this;
                            }, s1.prototype.removeListener = function(e, t) {
                                var n, r, i, a1, o;
                                if (l(t), void 0 === (r = this._events)) return this;
                                if (void 0 === (n = r[e])) return this;
                                if (n === t || n.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t));
                                else if ("function" != typeof n) {
                                    for(i = -1, a1 = n.length - 1; a1 >= 0; a1--)if (n[a1] === t || n[a1].listener === t) {
                                        o = n[a1].listener, i = a1;
                                        break;
                                    }
                                    if (i < 0) return this;
                                    0 === i ? n.shift() : function(e, t) {
                                        for(; t + 1 < e.length; t++)e[t] = e[t + 1];
                                        e.pop();
                                    }(n, i), 1 === n.length && (r[e] = n[0]), void 0 !== r.removeListener && this.emit("removeListener", e, o || t);
                                }
                                return this;
                            }, s1.prototype.off = s1.prototype.removeListener, s1.prototype.removeAllListeners = function(e) {
                                var t, n, r;
                                if (void 0 === (n = this._events)) return this;
                                if (void 0 === n.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== n[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete n[e]), this;
                                if (0 === arguments.length) {
                                    var i, a1 = Object.keys(n);
                                    for(r = 0; r < a1.length; ++r)"removeListener" !== (i = a1[r]) && this.removeAllListeners(i);
                                    return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
                                }
                                if ("function" == typeof (t = n[e])) this.removeListener(e, t);
                                else if (void 0 !== t) for(r = t.length - 1; r >= 0; r--)this.removeListener(e, t[r]);
                                return this;
                            }, s1.prototype.listeners = function(e) {
                                return g(this, e, !0);
                            }, s1.prototype.rawListeners = function(e) {
                                return g(this, e, !1);
                            }, s1.listenerCount = function(e, t) {
                                return "function" == typeof e.listenerCount ? e.listenerCount(t) : p.call(e, t);
                            }, s1.prototype.listenerCount = p, s1.prototype.eventNames = function() {
                                return this._eventsCount > 0 ? r(this._events) : [];
                            };
                        },
                        "./node_modules/node-libs-browser/node_modules/timers-browserify/main.js": function(e, t, n) {
                            (function(e) {
                                var r = void 0 !== e && e || "undefined" != typeof self && self || window, i = Function.prototype.apply;
                                function a1(e, t) {
                                    this._id = e, this._clearFn = t;
                                }
                                t.setTimeout = function() {
                                    return new a1(i.call(setTimeout, r, arguments), clearTimeout);
                                }, t.setInterval = function() {
                                    return new a1(i.call(setInterval, r, arguments), clearInterval);
                                }, t.clearTimeout = t.clearInterval = function(e) {
                                    e && e.close();
                                }, a1.prototype.unref = a1.prototype.ref = function() {}, a1.prototype.close = function() {
                                    this._clearFn.call(r, this._id);
                                }, t.enroll = function(e, t) {
                                    clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
                                }, t.unenroll = function(e) {
                                    clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
                                }, t._unrefActive = t.active = function(e) {
                                    clearTimeout(e._idleTimeoutId);
                                    var t = e._idleTimeout;
                                    t >= 0 && (e._idleTimeoutId = setTimeout(function() {
                                        e._onTimeout && e._onTimeout();
                                    }, t));
                                }, n("./node_modules/setimmediate/setImmediate.js"), t.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== e && e.setImmediate || this && this.setImmediate, t.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== e && e.clearImmediate || this && this.clearImmediate;
                            }).call(this, n("./node_modules/webpack/buildin/global.js"));
                        },
                        "./node_modules/path-browserify/index.js": function(e, t, n) {
                            (function(e) {
                                function n(e, t) {
                                    for(var n = 0, r = e.length - 1; r >= 0; r--){
                                        var i = e[r];
                                        "." === i ? e.splice(r, 1) : ".." === i ? (e.splice(r, 1), n++) : n && (e.splice(r, 1), n--);
                                    }
                                    if (t) for(; n--; n)e.unshift("..");
                                    return e;
                                }
                                function r(e, t) {
                                    if (e.filter) return e.filter(t);
                                    for(var n = [], r = 0; r < e.length; r++)t(e[r], r, e) && n.push(e[r]);
                                    return n;
                                }
                                t.resolve = function() {
                                    for(var t = "", i = !1, a1 = arguments.length - 1; a1 >= -1 && !i; a1--){
                                        var o = a1 >= 0 ? arguments[a1] : e.cwd();
                                        if ("string" != typeof o) throw new TypeError("Arguments to path.resolve must be strings");
                                        o && (t = o + "/" + t, i = "/" === o.charAt(0));
                                    }
                                    return (i ? "/" : "") + (t = n(r(t.split("/"), function(e) {
                                        return !!e;
                                    }), !i).join("/")) || ".";
                                }, t.normalize = function(e) {
                                    var a1 = t.isAbsolute(e), o = "/" === i(e, -1);
                                    return (e = n(r(e.split("/"), function(e) {
                                        return !!e;
                                    }), !a1).join("/")) || a1 || (e = "."), e && o && (e += "/"), (a1 ? "/" : "") + e;
                                }, t.isAbsolute = function(e) {
                                    return "/" === e.charAt(0);
                                }, t.join = function() {
                                    var e = Array.prototype.slice.call(arguments, 0);
                                    return t.normalize(r(e, function(e, t) {
                                        if ("string" != typeof e) throw new TypeError("Arguments to path.join must be strings");
                                        return e;
                                    }).join("/"));
                                }, t.relative = function(e, n) {
                                    function r(e) {
                                        for(var t = 0; t < e.length && "" === e[t]; t++);
                                        for(var n = e.length - 1; n >= 0 && "" === e[n]; n--);
                                        return t > n ? [] : e.slice(t, n - t + 1);
                                    }
                                    e = t.resolve(e).substr(1), n = t.resolve(n).substr(1);
                                    for(var i = r(e.split("/")), a1 = r(n.split("/")), o = Math.min(i.length, a1.length), s1 = o, u = 0; u < o; u++)if (i[u] !== a1[u]) {
                                        s1 = u;
                                        break;
                                    }
                                    var l = [];
                                    for(u = s1; u < i.length; u++)l.push("..");
                                    return (l = l.concat(a1.slice(s1))).join("/");
                                }, t.sep = "/", t.delimiter = ":", t.dirname = function(e) {
                                    if ("string" != typeof e && (e += ""), 0 === e.length) return ".";
                                    for(var t = e.charCodeAt(0), n = 47 === t, r = -1, i = !0, a1 = e.length - 1; a1 >= 1; --a1)if (47 === (t = e.charCodeAt(a1))) {
                                        if (!i) {
                                            r = a1;
                                            break;
                                        }
                                    } else i = !1;
                                    return -1 === r ? n ? "/" : "." : n && 1 === r ? "/" : e.slice(0, r);
                                }, t.basename = function(e, t) {
                                    var n = function(e) {
                                        "string" != typeof e && (e += "");
                                        var t, n = 0, r = -1, i = !0;
                                        for(t = e.length - 1; t >= 0; --t)if (47 === e.charCodeAt(t)) {
                                            if (!i) {
                                                n = t + 1;
                                                break;
                                            }
                                        } else -1 === r && (i = !1, r = t + 1);
                                        return -1 === r ? "" : e.slice(n, r);
                                    }(e);
                                    return t && n.substr(-1 * t.length) === t && (n = n.substr(0, n.length - t.length)), n;
                                }, t.extname = function(e) {
                                    "string" != typeof e && (e += "");
                                    for(var t = -1, n = 0, r = -1, i = !0, a1 = 0, o = e.length - 1; o >= 0; --o){
                                        var s1 = e.charCodeAt(o);
                                        if (47 !== s1) -1 === r && (i = !1, r = o + 1), 46 === s1 ? -1 === t ? t = o : 1 !== a1 && (a1 = 1) : -1 !== t && (a1 = -1);
                                        else if (!i) {
                                            n = o + 1;
                                            break;
                                        }
                                    }
                                    return -1 === t || -1 === r || 0 === a1 || 1 === a1 && t === r - 1 && t === n + 1 ? "" : e.slice(t, r);
                                };
                                var i = function(e, t, n) {
                                    return e.substr(t, n);
                                };
                            }).call(this, n("./node_modules/process/browser.js"));
                        },
                        "./node_modules/process-nextick-args/index.js": function(e, t, n) {
                            "use strict";
                            (function(t) {
                                !t.version || 0 === t.version.indexOf("v0.") || 0 === t.version.indexOf("v1.") && 0 !== t.version.indexOf("v1.8.") ? e.exports = {
                                    nextTick: function(e, n, r, i) {
                                        if ("function" != typeof e) throw new TypeError('"callback" argument must be a function');
                                        var a1, o, s1 = arguments.length;
                                        switch(s1){
                                            case 0:
                                            case 1:
                                                return t.nextTick(e);
                                            case 2:
                                                return t.nextTick(function() {
                                                    e.call(null, n);
                                                });
                                            case 3:
                                                return t.nextTick(function() {
                                                    e.call(null, n, r);
                                                });
                                            case 4:
                                                return t.nextTick(function() {
                                                    e.call(null, n, r, i);
                                                });
                                            default:
                                                for(a1 = new Array(s1 - 1), o = 0; o < a1.length;)a1[o++] = arguments[o];
                                                return t.nextTick(function() {
                                                    e.apply(null, a1);
                                                });
                                        }
                                    }
                                } : e.exports = t;
                            }).call(this, n("./node_modules/process/browser.js"));
                        },
                        "./node_modules/process/browser.js": function(e, t) {
                            var n, r, i = e.exports = {};
                            function a1() {
                                throw new Error("setTimeout has not been defined");
                            }
                            function o() {
                                throw new Error("clearTimeout has not been defined");
                            }
                            function s1(e) {
                                if (n === setTimeout) return setTimeout(e, 0);
                                if ((n === a1 || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);
                                try {
                                    return n(e, 0);
                                } catch (t) {
                                    try {
                                        return n.call(null, e, 0);
                                    } catch (t) {
                                        return n.call(this, e, 0);
                                    }
                                }
                            }
                            !function() {
                                try {
                                    n = "function" == typeof setTimeout ? setTimeout : a1;
                                } catch (e) {
                                    n = a1;
                                }
                                try {
                                    r = "function" == typeof clearTimeout ? clearTimeout : o;
                                } catch (e) {
                                    r = o;
                                }
                            }();
                            var u, l = [], c = !1, d = -1;
                            function f() {
                                c && u && (c = !1, u.length ? l = u.concat(l) : d = -1, l.length && h());
                            }
                            function h() {
                                if (!c) {
                                    var e = s1(f);
                                    c = !0;
                                    for(var t = l.length; t;){
                                        for(u = l, l = []; ++d < t;)u && u[d].run();
                                        d = -1, t = l.length;
                                    }
                                    u = null, c = !1, function(e) {
                                        if (r === clearTimeout) return clearTimeout(e);
                                        if ((r === o || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);
                                        try {
                                            r(e);
                                        } catch (t) {
                                            try {
                                                return r.call(null, e);
                                            } catch (t) {
                                                return r.call(this, e);
                                            }
                                        }
                                    }(e);
                                }
                            }
                            function g(e, t) {
                                this.fun = e, this.array = t;
                            }
                            function p() {}
                            i.nextTick = function(e) {
                                var t = new Array(arguments.length - 1);
                                if (arguments.length > 1) for(var n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                                l.push(new g(e, t)), 1 !== l.length || c || s1(h);
                            }, g.prototype.run = function() {
                                this.fun.apply(null, this.array);
                            }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = p, i.addListener = p, i.once = p, i.off = p, i.removeListener = p, i.removeAllListeners = p, i.emit = p, i.prependListener = p, i.prependOnceListener = p, i.listeners = function(e) {
                                return [];
                            }, i.binding = function(e) {
                                throw new Error("process.binding is not supported");
                            }, i.cwd = function() {
                                return "/";
                            }, i.chdir = function(e) {
                                throw new Error("process.chdir is not supported");
                            }, i.umask = function() {
                                return 0;
                            };
                        },
                        "./node_modules/readable-stream/duplex-browser.js": function(e, t, n) {
                            e.exports = n("./node_modules/readable-stream/lib/_stream_duplex.js");
                        },
                        "./node_modules/readable-stream/lib/_stream_duplex.js": function(e, t, n) {
                            "use strict";
                            var r = n("./node_modules/process-nextick-args/index.js"), i = Object.keys || function(e) {
                                var t = [];
                                for(var n in e)t.push(n);
                                return t;
                            };
                            e.exports = d;
                            var a1 = n("./node_modules/core-util-is/lib/util.js");
                            a1.inherits = n("./node_modules/inherits/inherits_browser.js");
                            var o = n("./node_modules/readable-stream/lib/_stream_readable.js"), s1 = n("./node_modules/readable-stream/lib/_stream_writable.js");
                            a1.inherits(d, o);
                            for(var u = i(s1.prototype), l = 0; l < u.length; l++){
                                var c = u[l];
                                d.prototype[c] || (d.prototype[c] = s1.prototype[c]);
                            }
                            function d(e) {
                                if (!(this instanceof d)) return new d(e);
                                o.call(this, e), s1.call(this, e), e && !1 === e.readable && (this.readable = !1), e && !1 === e.writable && (this.writable = !1), this.allowHalfOpen = !0, e && !1 === e.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", f);
                            }
                            function f() {
                                this.allowHalfOpen || this._writableState.ended || r.nextTick(h, this);
                            }
                            function h(e) {
                                e.end();
                            }
                            Object.defineProperty(d.prototype, "writableHighWaterMark", {
                                enumerable: !1,
                                get: function() {
                                    return this._writableState.highWaterMark;
                                }
                            }), Object.defineProperty(d.prototype, "destroyed", {
                                get: function() {
                                    return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
                                },
                                set: function(e) {
                                    void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
                                }
                            }), d.prototype._destroy = function(e, t) {
                                this.push(null), this.end(), r.nextTick(t, e);
                            };
                        },
                        "./node_modules/readable-stream/lib/_stream_passthrough.js": function(e, t, n) {
                            "use strict";
                            e.exports = a1;
                            var r = n("./node_modules/readable-stream/lib/_stream_transform.js"), i = n("./node_modules/core-util-is/lib/util.js");
                            function a1(e) {
                                if (!(this instanceof a1)) return new a1(e);
                                r.call(this, e);
                            }
                            i.inherits = n("./node_modules/inherits/inherits_browser.js"), i.inherits(a1, r), a1.prototype._transform = function(e, t, n) {
                                n(null, e);
                            };
                        },
                        "./node_modules/readable-stream/lib/_stream_readable.js": function(e, t, n) {
                            "use strict";
                            (function(t, r) {
                                var i = n("./node_modules/process-nextick-args/index.js");
                                e.exports = E;
                                var a1, o = n("./node_modules/isarray/index.js");
                                E.ReadableState = y, n("./node_modules/node-libs-browser/node_modules/events/events.js").EventEmitter;
                                var s1 = function(e, t) {
                                    return e.listeners(t).length;
                                }, u = n("./node_modules/readable-stream/lib/internal/streams/stream-browser.js"), l = n("./node_modules/safe-buffer/index.js").Buffer, c = t.Uint8Array || function() {}, d = n("./node_modules/core-util-is/lib/util.js");
                                d.inherits = n("./node_modules/inherits/inherits_browser.js");
                                var f = n(0), h = void 0;
                                h = f && f.debuglog ? f.debuglog("stream") : function() {};
                                var g, p = n("./node_modules/readable-stream/lib/internal/streams/BufferList.js"), m = n("./node_modules/readable-stream/lib/internal/streams/destroy.js");
                                d.inherits(E, u);
                                var v = [
                                    "error",
                                    "close",
                                    "destroy",
                                    "pause",
                                    "resume"
                                ];
                                function y(e, t) {
                                    e = e || {};
                                    var r = t instanceof (a1 = a1 || n("./node_modules/readable-stream/lib/_stream_duplex.js"));
                                    this.objectMode = !!e.objectMode, r && (this.objectMode = this.objectMode || !!e.readableObjectMode);
                                    var i = e.highWaterMark, o = e.readableHighWaterMark, s1 = this.objectMode ? 16 : 16384;
                                    this.highWaterMark = i || 0 === i ? i : r && (o || 0 === o) ? o : s1, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new p, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = e.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (g || (g = n("./node_modules/string_decoder/lib/string_decoder.js").StringDecoder), this.decoder = new g(e.encoding), this.encoding = e.encoding);
                                }
                                function E(e) {
                                    if (a1 = a1 || n("./node_modules/readable-stream/lib/_stream_duplex.js"), !(this instanceof E)) return new E(e);
                                    this._readableState = new y(e, this), this.readable = !0, e && ("function" == typeof e.read && (this._read = e.read), "function" == typeof e.destroy && (this._destroy = e.destroy)), u.call(this);
                                }
                                function T(e, t, n, r, i) {
                                    var a1, o = e._readableState;
                                    return null === t ? (o.reading = !1, function(e, t) {
                                        if (!t.ended) {
                                            if (t.decoder) {
                                                var n = t.decoder.end();
                                                n && n.length && (t.buffer.push(n), t.length += t.objectMode ? 1 : n.length);
                                            }
                                            t.ended = !0, S(e);
                                        }
                                    }(e, o)) : (i || (a1 = function(e, t) {
                                        var n, r;
                                        return r = t, l.isBuffer(r) || r instanceof c || "string" == typeof t || void 0 === t || e.objectMode || (n = new TypeError("Invalid non-string/buffer chunk")), n;
                                    }(o, t)), a1 ? e.emit("error", a1) : o.objectMode || t && t.length > 0 ? ("string" == typeof t || o.objectMode || Object.getPrototypeOf(t) === l.prototype || (t = function(e) {
                                        return l.from(e);
                                    }(t)), r ? o.endEmitted ? e.emit("error", new Error("stream.unshift() after end event")) : b(e, o, t, !0) : o.ended ? e.emit("error", new Error("stream.push() after EOF")) : (o.reading = !1, o.decoder && !n ? (t = o.decoder.write(t), o.objectMode || 0 !== t.length ? b(e, o, t, !1) : I(e, o)) : b(e, o, t, !1))) : r || (o.reading = !1)), function(e) {
                                        return !e.ended && (e.needReadable || e.length < e.highWaterMark || 0 === e.length);
                                    }(o);
                                }
                                function b(e, t, n, r) {
                                    t.flowing && 0 === t.length && !t.sync ? (e.emit("data", n), e.read(0)) : (t.length += t.objectMode ? 1 : n.length, r ? t.buffer.unshift(n) : t.buffer.push(n), t.needReadable && S(e)), I(e, t);
                                }
                                Object.defineProperty(E.prototype, "destroyed", {
                                    get: function() {
                                        return void 0 !== this._readableState && this._readableState.destroyed;
                                    },
                                    set: function(e) {
                                        this._readableState && (this._readableState.destroyed = e);
                                    }
                                }), E.prototype.destroy = m.destroy, E.prototype._undestroy = m.undestroy, E.prototype._destroy = function(e, t) {
                                    this.push(null), t(e);
                                }, E.prototype.push = function(e, t) {
                                    var n, r = this._readableState;
                                    return r.objectMode ? n = !0 : "string" == typeof e && ((t = t || r.defaultEncoding) !== r.encoding && (e = l.from(e, t), t = ""), n = !0), T(this, e, t, !1, n);
                                }, E.prototype.unshift = function(e) {
                                    return T(this, e, null, !0, !1);
                                }, E.prototype.isPaused = function() {
                                    return !1 === this._readableState.flowing;
                                }, E.prototype.setEncoding = function(e) {
                                    return g || (g = n("./node_modules/string_decoder/lib/string_decoder.js").StringDecoder), this._readableState.decoder = new g(e), this._readableState.encoding = e, this;
                                };
                                var A = 8388608;
                                function _(e, t) {
                                    return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function(e) {
                                        return e >= A ? e = A : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
                                    }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
                                }
                                function S(e) {
                                    var t = e._readableState;
                                    t.needReadable = !1, t.emittedReadable || (h("emitReadable", t.flowing), t.emittedReadable = !0, t.sync ? i.nextTick(w, e) : w(e));
                                }
                                function w(e) {
                                    h("emit readable"), e.emit("readable"), k(e);
                                }
                                function I(e, t) {
                                    t.readingMore || (t.readingMore = !0, i.nextTick(R, e, t));
                                }
                                function R(e, t) {
                                    for(var n = t.length; !t.reading && !t.flowing && !t.ended && t.length < t.highWaterMark && (h("maybeReadMore read 0"), e.read(0), n !== t.length);)n = t.length;
                                    t.readingMore = !1;
                                }
                                function C(e) {
                                    h("readable nexttick read 0"), e.read(0);
                                }
                                function D(e, t) {
                                    t.reading || (h("resume read 0"), e.read(0)), t.resumeScheduled = !1, t.awaitDrain = 0, e.emit("resume"), k(e), t.flowing && !t.reading && e.read(0);
                                }
                                function k(e) {
                                    var t = e._readableState;
                                    for(h("flow", t.flowing); t.flowing && null !== e.read(););
                                }
                                function N(e, t) {
                                    var n;
                                    return 0 === t.length ? null : (t.objectMode ? n = t.buffer.shift() : !e || e >= t.length ? (n = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.head.data : t.buffer.concat(t.length), t.buffer.clear()) : n = function(e, t, n) {
                                        var r;
                                        return e < t.head.data.length ? (r = t.head.data.slice(0, e), t.head.data = t.head.data.slice(e)) : r = e === t.head.data.length ? t.shift() : n ? function(e, t) {
                                            var n = t.head, r = 1, i = n.data;
                                            for(e -= i.length; n = n.next;){
                                                var a1 = n.data, o = e > a1.length ? a1.length : e;
                                                if (o === a1.length ? i += a1 : i += a1.slice(0, e), 0 == (e -= o)) {
                                                    o === a1.length ? (++r, n.next ? t.head = n.next : t.head = t.tail = null) : (t.head = n, n.data = a1.slice(o));
                                                    break;
                                                }
                                                ++r;
                                            }
                                            return t.length -= r, i;
                                        }(e, t) : function(e, t) {
                                            var n = l.allocUnsafe(e), r = t.head, i = 1;
                                            for(r.data.copy(n), e -= r.data.length; r = r.next;){
                                                var a1 = r.data, o = e > a1.length ? a1.length : e;
                                                if (a1.copy(n, n.length - e, 0, o), 0 == (e -= o)) {
                                                    o === a1.length ? (++i, r.next ? t.head = r.next : t.head = t.tail = null) : (t.head = r, r.data = a1.slice(o));
                                                    break;
                                                }
                                                ++i;
                                            }
                                            return t.length -= i, n;
                                        }(e, t), r;
                                    }(e, t.buffer, t.decoder), n);
                                }
                                function L(e) {
                                    var t = e._readableState;
                                    if (t.length > 0) throw new Error('"endReadable()" called on non-empty stream');
                                    t.endEmitted || (t.ended = !0, i.nextTick(x, t, e));
                                }
                                function x(e, t) {
                                    e.endEmitted || 0 !== e.length || (e.endEmitted = !0, t.readable = !1, t.emit("end"));
                                }
                                function M(e, t) {
                                    for(var n = 0, r = e.length; n < r; n++)if (e[n] === t) return n;
                                    return -1;
                                }
                                E.prototype.read = function(e) {
                                    h("read", e), e = parseInt(e, 10);
                                    var t = this._readableState, n = e;
                                    if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && (t.length >= t.highWaterMark || t.ended)) return h("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? L(this) : S(this), null;
                                    if (0 === (e = _(e, t)) && t.ended) return 0 === t.length && L(this), null;
                                    var r, i = t.needReadable;
                                    return h("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && h("length less than watermark", i = !0), t.ended || t.reading ? h("reading or ended", i = !1) : i && (h("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = _(n, t))), null === (r = e > 0 ? N(e, t) : null) ? (t.needReadable = !0, e = 0) : t.length -= e, 0 === t.length && (t.ended || (t.needReadable = !0), n !== e && t.ended && L(this)), null !== r && this.emit("data", r), r;
                                }, E.prototype._read = function(e) {
                                    this.emit("error", new Error("_read() is not implemented"));
                                }, E.prototype.pipe = function(e, t) {
                                    var n = this, a1 = this._readableState;
                                    switch(a1.pipesCount){
                                        case 0:
                                            a1.pipes = e;
                                            break;
                                        case 1:
                                            a1.pipes = [
                                                a1.pipes,
                                                e
                                            ];
                                            break;
                                        default:
                                            a1.pipes.push(e);
                                    }
                                    a1.pipesCount += 1, h("pipe count=%d opts=%j", a1.pipesCount, t);
                                    var u = t && !1 === t.end || e === r.stdout || e === r.stderr ? y : l;
                                    function l() {
                                        h("onend"), e.end();
                                    }
                                    a1.endEmitted ? i.nextTick(u) : n.once("end", u), e.on("unpipe", function t(r, i) {
                                        h("onunpipe"), r === n && i && !1 === i.hasUnpiped && (i.hasUnpiped = !0, h("cleanup"), e.removeListener("close", m), e.removeListener("finish", v), e.removeListener("drain", c), e.removeListener("error", p), e.removeListener("unpipe", t), n.removeListener("end", l), n.removeListener("end", y), n.removeListener("data", g), d = !0, !a1.awaitDrain || e._writableState && !e._writableState.needDrain || c());
                                    });
                                    var c = function(e) {
                                        return function() {
                                            var t = e._readableState;
                                            h("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && s1(e, "data") && (t.flowing = !0, k(e));
                                        };
                                    }(n);
                                    e.on("drain", c);
                                    var d = !1, f = !1;
                                    function g(t) {
                                        h("ondata"), f = !1, !1 !== e.write(t) || f || ((1 === a1.pipesCount && a1.pipes === e || a1.pipesCount > 1 && -1 !== M(a1.pipes, e)) && !d && (h("false write response, pause", n._readableState.awaitDrain), n._readableState.awaitDrain++, f = !0), n.pause());
                                    }
                                    function p(t) {
                                        h("onerror", t), y(), e.removeListener("error", p), 0 === s1(e, "error") && e.emit("error", t);
                                    }
                                    function m() {
                                        e.removeListener("finish", v), y();
                                    }
                                    function v() {
                                        h("onfinish"), e.removeListener("close", m), y();
                                    }
                                    function y() {
                                        h("unpipe"), n.unpipe(e);
                                    }
                                    return n.on("data", g), function(e, t, n) {
                                        if ("function" == typeof e.prependListener) return e.prependListener(t, n);
                                        e._events && e._events.error ? o(e._events.error) ? e._events.error.unshift(n) : e._events.error = [
                                            n,
                                            e._events.error
                                        ] : e.on(t, n);
                                    }(e, "error", p), e.once("close", m), e.once("finish", v), e.emit("pipe", n), a1.flowing || (h("pipe resume"), n.resume()), e;
                                }, E.prototype.unpipe = function(e) {
                                    var t = this._readableState, n = {
                                        hasUnpiped: !1
                                    };
                                    if (0 === t.pipesCount) return this;
                                    if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, n)), this;
                                    if (!e) {
                                        var r = t.pipes, i = t.pipesCount;
                                        t.pipes = null, t.pipesCount = 0, t.flowing = !1;
                                        for(var a1 = 0; a1 < i; a1++)r[a1].emit("unpipe", this, n);
                                        return this;
                                    }
                                    var o = M(t.pipes, e);
                                    return -1 === o || (t.pipes.splice(o, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, n)), this;
                                }, E.prototype.on = function(e, t) {
                                    var n = u.prototype.on.call(this, e, t);
                                    if ("data" === e) !1 !== this._readableState.flowing && this.resume();
                                    else if ("readable" === e) {
                                        var r = this._readableState;
                                        r.endEmitted || r.readableListening || (r.readableListening = r.needReadable = !0, r.emittedReadable = !1, r.reading ? r.length && S(this) : i.nextTick(C, this));
                                    }
                                    return n;
                                }, E.prototype.addListener = E.prototype.on, E.prototype.resume = function() {
                                    var e = this._readableState;
                                    return e.flowing || (h("resume"), e.flowing = !0, function(e, t) {
                                        t.resumeScheduled || (t.resumeScheduled = !0, i.nextTick(D, e, t));
                                    }(this, e)), this;
                                }, E.prototype.pause = function() {
                                    return h("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (h("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
                                }, E.prototype.wrap = function(e) {
                                    var t = this, n = this._readableState, r = !1;
                                    for(var i in e.on("end", function() {
                                        if (h("wrapped end"), n.decoder && !n.ended) {
                                            var e = n.decoder.end();
                                            e && e.length && t.push(e);
                                        }
                                        t.push(null);
                                    }), e.on("data", function(i) {
                                        h("wrapped data"), n.decoder && (i = n.decoder.write(i)), n.objectMode && null == i || (n.objectMode || i && i.length) && (t.push(i) || (r = !0, e.pause()));
                                    }), e)void 0 === this[i] && "function" == typeof e[i] && (this[i] = function(t) {
                                        return function() {
                                            return e[t].apply(e, arguments);
                                        };
                                    }(i));
                                    for(var a1 = 0; a1 < v.length; a1++)e.on(v[a1], this.emit.bind(this, v[a1]));
                                    return this._read = function(t) {
                                        h("wrapped _read", t), r && (r = !1, e.resume());
                                    }, this;
                                }, Object.defineProperty(E.prototype, "readableHighWaterMark", {
                                    enumerable: !1,
                                    get: function() {
                                        return this._readableState.highWaterMark;
                                    }
                                }), E._fromList = N;
                            }).call(this, n("./node_modules/webpack/buildin/global.js"), n("./node_modules/process/browser.js"));
                        },
                        "./node_modules/readable-stream/lib/_stream_transform.js": function(e, t, n) {
                            "use strict";
                            e.exports = o;
                            var r = n("./node_modules/readable-stream/lib/_stream_duplex.js"), i = n("./node_modules/core-util-is/lib/util.js");
                            function a1(e, t) {
                                var n = this._transformState;
                                n.transforming = !1;
                                var r = n.writecb;
                                if (!r) return this.emit("error", new Error("write callback called multiple times"));
                                n.writechunk = null, n.writecb = null, null != t && this.push(t), r(e);
                                var i = this._readableState;
                                i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                            }
                            function o(e) {
                                if (!(this instanceof o)) return new o(e);
                                r.call(this, e), this._transformState = {
                                    afterTransform: a1.bind(this),
                                    needTransform: !1,
                                    transforming: !1,
                                    writecb: null,
                                    writechunk: null,
                                    writeencoding: null
                                }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", s1);
                            }
                            function s1() {
                                var e = this;
                                "function" == typeof this._flush ? this._flush(function(t, n) {
                                    u(e, t, n);
                                }) : u(this, null, null);
                            }
                            function u(e, t, n) {
                                if (t) return e.emit("error", t);
                                if (null != n && e.push(n), e._writableState.length) throw new Error("Calling transform done when ws.length != 0");
                                if (e._transformState.transforming) throw new Error("Calling transform done when still transforming");
                                return e.push(null);
                            }
                            i.inherits = n("./node_modules/inherits/inherits_browser.js"), i.inherits(o, r), o.prototype.push = function(e, t) {
                                return this._transformState.needTransform = !1, r.prototype.push.call(this, e, t);
                            }, o.prototype._transform = function(e, t, n) {
                                throw new Error("_transform() is not implemented");
                            }, o.prototype._write = function(e, t, n) {
                                var r = this._transformState;
                                if (r.writecb = n, r.writechunk = e, r.writeencoding = t, !r.transforming) {
                                    var i = this._readableState;
                                    (r.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                                }
                            }, o.prototype._read = function(e) {
                                var t = this._transformState;
                                null !== t.writechunk && t.writecb && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
                            }, o.prototype._destroy = function(e, t) {
                                var n = this;
                                r.prototype._destroy.call(this, e, function(e) {
                                    t(e), n.emit("close");
                                });
                            };
                        },
                        "./node_modules/readable-stream/lib/_stream_writable.js": function(e, t, n) {
                            "use strict";
                            (function(t, r, i) {
                                var a1 = n("./node_modules/process-nextick-args/index.js");
                                function o(e) {
                                    var t = this;
                                    this.next = null, this.entry = null, this.finish = function() {
                                        !function(e, t, n) {
                                            var r = e.entry;
                                            for(e.entry = null; r;){
                                                var i = r.callback;
                                                t.pendingcb--, i(undefined), r = r.next;
                                            }
                                            t.corkedRequestsFree ? t.corkedRequestsFree.next = e : t.corkedRequestsFree = e;
                                        }(t, e);
                                    };
                                }
                                e.exports = y;
                                var s1, u = !t.browser && [
                                    "v0.10",
                                    "v0.9."
                                ].indexOf(t.version.slice(0, 5)) > -1 ? r : a1.nextTick;
                                y.WritableState = v;
                                var l = n("./node_modules/core-util-is/lib/util.js");
                                l.inherits = n("./node_modules/inherits/inherits_browser.js");
                                var c, d = {
                                    deprecate: n("./node_modules/util-deprecate/browser.js")
                                }, f = n("./node_modules/readable-stream/lib/internal/streams/stream-browser.js"), h = n("./node_modules/safe-buffer/index.js").Buffer, g = i.Uint8Array || function() {}, p = n("./node_modules/readable-stream/lib/internal/streams/destroy.js");
                                function m() {}
                                function v(e, t) {
                                    s1 = s1 || n("./node_modules/readable-stream/lib/_stream_duplex.js"), e = e || {};
                                    var r = t instanceof s1;
                                    this.objectMode = !!e.objectMode, r && (this.objectMode = this.objectMode || !!e.writableObjectMode);
                                    var i = e.highWaterMark, l = e.writableHighWaterMark, c = this.objectMode ? 16 : 16384;
                                    this.highWaterMark = i || 0 === i ? i : r && (l || 0 === l) ? l : c, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                                    var d = !1 === e.decodeStrings;
                                    this.decodeStrings = !d, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(e) {
                                        !function(e, t) {
                                            var n = e._writableState, r = n.sync, i = n.writecb;
                                            if (function(e) {
                                                e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
                                            }(n), t) !function(e, t, n, r, i) {
                                                --t.pendingcb, n ? (a1.nextTick(i, r), a1.nextTick(S, e, t), e._writableState.errorEmitted = !0, e.emit("error", r)) : (i(r), e._writableState.errorEmitted = !0, e.emit("error", r), S(e, t));
                                            }(e, n, r, t, i);
                                            else {
                                                var o = A(n);
                                                o || n.corked || n.bufferProcessing || !n.bufferedRequest || b(e, n), r ? u(T, e, n, o, i) : T(e, n, o, i);
                                            }
                                        }(t, e);
                                    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new o(this);
                                }
                                function y(e) {
                                    if (s1 = s1 || n("./node_modules/readable-stream/lib/_stream_duplex.js"), !(c.call(y, this) || this instanceof s1)) return new y(e);
                                    this._writableState = new v(e, this), this.writable = !0, e && ("function" == typeof e.write && (this._write = e.write), "function" == typeof e.writev && (this._writev = e.writev), "function" == typeof e.destroy && (this._destroy = e.destroy), "function" == typeof e.final && (this._final = e.final)), f.call(this);
                                }
                                function E(e, t, n, r, i, a1, o) {
                                    t.writelen = r, t.writecb = o, t.writing = !0, t.sync = !0, n ? e._writev(i, t.onwrite) : e._write(i, a1, t.onwrite), t.sync = !1;
                                }
                                function T(e, t, n, r) {
                                    n || function(e, t) {
                                        0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
                                    }(e, t), t.pendingcb--, r(), S(e, t);
                                }
                                function b(e, t) {
                                    t.bufferProcessing = !0;
                                    var n = t.bufferedRequest;
                                    if (e._writev && n && n.next) {
                                        var r = t.bufferedRequestCount, i = new Array(r), a1 = t.corkedRequestsFree;
                                        a1.entry = n;
                                        for(var s1 = 0, u = !0; n;)i[s1] = n, n.isBuf || (u = !1), n = n.next, s1 += 1;
                                        i.allBuffers = u, E(e, t, !0, t.length, i, "", a1.finish), t.pendingcb++, t.lastBufferedRequest = null, a1.next ? (t.corkedRequestsFree = a1.next, a1.next = null) : t.corkedRequestsFree = new o(t), t.bufferedRequestCount = 0;
                                    } else {
                                        for(; n;){
                                            var l = n.chunk, c = n.encoding, d = n.callback;
                                            if (E(e, t, !1, t.objectMode ? 1 : l.length, l, c, d), n = n.next, t.bufferedRequestCount--, t.writing) break;
                                        }
                                        null === n && (t.lastBufferedRequest = null);
                                    }
                                    t.bufferedRequest = n, t.bufferProcessing = !1;
                                }
                                function A(e) {
                                    return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
                                }
                                function _(e, t) {
                                    e._final(function(n) {
                                        t.pendingcb--, n && e.emit("error", n), t.prefinished = !0, e.emit("prefinish"), S(e, t);
                                    });
                                }
                                function S(e, t) {
                                    var n = A(t);
                                    return n && (function(e, t) {
                                        t.prefinished || t.finalCalled || ("function" == typeof e._final ? (t.pendingcb++, t.finalCalled = !0, a1.nextTick(_, e, t)) : (t.prefinished = !0, e.emit("prefinish")));
                                    }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"))), n;
                                }
                                l.inherits(y, f), v.prototype.getBuffer = function() {
                                    for(var e = this.bufferedRequest, t = []; e;)t.push(e), e = e.next;
                                    return t;
                                }, function() {
                                    try {
                                        Object.defineProperty(v.prototype, "buffer", {
                                            get: d.deprecate(function() {
                                                return this.getBuffer();
                                            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                                        });
                                    } catch (e) {}
                                }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (c = Function.prototype[Symbol.hasInstance], Object.defineProperty(y, Symbol.hasInstance, {
                                    value: function(e) {
                                        return !!c.call(this, e) || this === y && e && e._writableState instanceof v;
                                    }
                                })) : c = function(e) {
                                    return e instanceof this;
                                }, y.prototype.pipe = function() {
                                    this.emit("error", new Error("Cannot pipe, not readable"));
                                }, y.prototype.write = function(e, t, n) {
                                    var r, i = this._writableState, o = !1, s1 = !i.objectMode && (r = e, h.isBuffer(r) || r instanceof g);
                                    return s1 && !h.isBuffer(e) && (e = function(e) {
                                        return h.from(e);
                                    }(e)), "function" == typeof t && (n = t, t = null), s1 ? t = "buffer" : t || (t = i.defaultEncoding), "function" != typeof n && (n = m), i.ended ? function(e, t) {
                                        var n = new Error("write after end");
                                        e.emit("error", n), a1.nextTick(t, n);
                                    }(this, n) : (s1 || function(e, t, n, r) {
                                        var i = !0, o = !1;
                                        return null === n ? o = new TypeError("May not write null values to stream") : "string" == typeof n || void 0 === n || t.objectMode || (o = new TypeError("Invalid non-string/buffer chunk")), o && (e.emit("error", o), a1.nextTick(r, o), i = !1), i;
                                    }(this, i, e, n)) && (i.pendingcb++, o = function(e, t, n, r, i, a1) {
                                        if (!n) {
                                            var o = function(e, t, n) {
                                                return e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = h.from(t, n)), t;
                                            }(t, r, i);
                                            r !== o && (n = !0, i = "buffer", r = o);
                                        }
                                        var s1 = t.objectMode ? 1 : r.length;
                                        t.length += s1;
                                        var u = t.length < t.highWaterMark;
                                        if (u || (t.needDrain = !0), t.writing || t.corked) {
                                            var l = t.lastBufferedRequest;
                                            t.lastBufferedRequest = {
                                                chunk: r,
                                                encoding: i,
                                                isBuf: n,
                                                callback: a1,
                                                next: null
                                            }, l ? l.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
                                        } else E(e, t, !1, s1, r, i, a1);
                                        return u;
                                    }(this, i, s1, e, t, n)), o;
                                }, y.prototype.cork = function() {
                                    this._writableState.corked++;
                                }, y.prototype.uncork = function() {
                                    var e = this._writableState;
                                    e.corked && (e.corked--, e.writing || e.corked || e.finished || e.bufferProcessing || !e.bufferedRequest || b(this, e));
                                }, y.prototype.setDefaultEncoding = function(e) {
                                    if ("string" == typeof e && (e = e.toLowerCase()), !([
                                        "hex",
                                        "utf8",
                                        "utf-8",
                                        "ascii",
                                        "binary",
                                        "base64",
                                        "ucs2",
                                        "ucs-2",
                                        "utf16le",
                                        "utf-16le",
                                        "raw"
                                    ].indexOf((e + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + e);
                                    return this._writableState.defaultEncoding = e, this;
                                }, Object.defineProperty(y.prototype, "writableHighWaterMark", {
                                    enumerable: !1,
                                    get: function() {
                                        return this._writableState.highWaterMark;
                                    }
                                }), y.prototype._write = function(e, t, n) {
                                    n(new Error("_write() is not implemented"));
                                }, y.prototype._writev = null, y.prototype.end = function(e, t, n) {
                                    var r = this._writableState;
                                    "function" == typeof e ? (n = e, e = null, t = null) : "function" == typeof t && (n = t, t = null), null != e && this.write(e, t), r.corked && (r.corked = 1, this.uncork()), r.ending || r.finished || function(e, t, n) {
                                        t.ending = !0, S(e, t), n && (t.finished ? a1.nextTick(n) : e.once("finish", n)), t.ended = !0, e.writable = !1;
                                    }(this, r, n);
                                }, Object.defineProperty(y.prototype, "destroyed", {
                                    get: function() {
                                        return void 0 !== this._writableState && this._writableState.destroyed;
                                    },
                                    set: function(e) {
                                        this._writableState && (this._writableState.destroyed = e);
                                    }
                                }), y.prototype.destroy = p.destroy, y.prototype._undestroy = p.undestroy, y.prototype._destroy = function(e, t) {
                                    this.end(), t(e);
                                };
                            }).call(this, n("./node_modules/process/browser.js"), n("./node_modules/node-libs-browser/node_modules/timers-browserify/main.js").setImmediate, n("./node_modules/webpack/buildin/global.js"));
                        },
                        "./node_modules/readable-stream/lib/internal/streams/BufferList.js": function(e, t, n) {
                            "use strict";
                            var r = n("./node_modules/safe-buffer/index.js").Buffer, i = n(1);
                            e.exports = function() {
                                function e() {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), this.head = null, this.tail = null, this.length = 0;
                                }
                                return e.prototype.push = function(e) {
                                    var t = {
                                        data: e,
                                        next: null
                                    };
                                    this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
                                }, e.prototype.unshift = function(e) {
                                    var t = {
                                        data: e,
                                        next: this.head
                                    };
                                    0 === this.length && (this.tail = t), this.head = t, ++this.length;
                                }, e.prototype.shift = function() {
                                    if (0 !== this.length) {
                                        var e = this.head.data;
                                        return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
                                    }
                                }, e.prototype.clear = function() {
                                    this.head = this.tail = null, this.length = 0;
                                }, e.prototype.join = function(e) {
                                    if (0 === this.length) return "";
                                    for(var t = this.head, n = "" + t.data; t = t.next;)n += e + t.data;
                                    return n;
                                }, e.prototype.concat = function(e) {
                                    if (0 === this.length) return r.alloc(0);
                                    if (1 === this.length) return this.head.data;
                                    for(var t, n, i = r.allocUnsafe(e >>> 0), a1 = this.head, o = 0; a1;)t = i, n = o, a1.data.copy(t, n), o += a1.data.length, a1 = a1.next;
                                    return i;
                                }, e;
                            }(), i && i.inspect && i.inspect.custom && (e.exports.prototype[i.inspect.custom] = function() {
                                var e = i.inspect({
                                    length: this.length
                                });
                                return this.constructor.name + " " + e;
                            });
                        },
                        "./node_modules/readable-stream/lib/internal/streams/destroy.js": function(e, t, n) {
                            "use strict";
                            var r = n("./node_modules/process-nextick-args/index.js");
                            function i(e, t) {
                                e.emit("error", t);
                            }
                            e.exports = {
                                destroy: function(e, t) {
                                    var n = this, a1 = this._readableState && this._readableState.destroyed, o = this._writableState && this._writableState.destroyed;
                                    return a1 || o ? (t ? t(e) : !e || this._writableState && this._writableState.errorEmitted || r.nextTick(i, this, e), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function(e) {
                                        !t && e ? (r.nextTick(i, n, e), n._writableState && (n._writableState.errorEmitted = !0)) : t && t(e);
                                    }), this);
                                },
                                undestroy: function() {
                                    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                                }
                            };
                        },
                        "./node_modules/readable-stream/lib/internal/streams/stream-browser.js": function(e, t, n) {
                            e.exports = n("./node_modules/node-libs-browser/node_modules/events/events.js").EventEmitter;
                        },
                        "./node_modules/readable-stream/passthrough.js": function(e, t, n) {
                            e.exports = n("./node_modules/readable-stream/readable-browser.js").PassThrough;
                        },
                        "./node_modules/readable-stream/readable-browser.js": function(e, t, n) {
                            (t = e.exports = n("./node_modules/readable-stream/lib/_stream_readable.js")).Stream = t, t.Readable = t, t.Writable = n("./node_modules/readable-stream/lib/_stream_writable.js"), t.Duplex = n("./node_modules/readable-stream/lib/_stream_duplex.js"), t.Transform = n("./node_modules/readable-stream/lib/_stream_transform.js"), t.PassThrough = n("./node_modules/readable-stream/lib/_stream_passthrough.js");
                        },
                        "./node_modules/readable-stream/transform.js": function(e, t, n) {
                            e.exports = n("./node_modules/readable-stream/readable-browser.js").Transform;
                        },
                        "./node_modules/readable-stream/writable-browser.js": function(e, t, n) {
                            e.exports = n("./node_modules/readable-stream/lib/_stream_writable.js");
                        },
                        "./node_modules/safe-buffer/index.js": function(e, t, n) {
                            var r = n("./node_modules/node-libs-browser/node_modules/buffer/index.js"), i = r.Buffer;
                            function a1(e, t) {
                                for(var n in e)t[n] = e[n];
                            }
                            function o(e, t, n) {
                                return i(e, t, n);
                            }
                            i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? e.exports = r : (a1(r, t), t.Buffer = o), a1(i, o), o.from = function(e, t, n) {
                                if ("number" == typeof e) throw new TypeError("Argument must not be a number");
                                return i(e, t, n);
                            }, o.alloc = function(e, t, n) {
                                if ("number" != typeof e) throw new TypeError("Argument must be a number");
                                var r = i(e);
                                return void 0 !== t ? "string" == typeof n ? r.fill(t, n) : r.fill(t) : r.fill(0), r;
                            }, o.allocUnsafe = function(e) {
                                if ("number" != typeof e) throw new TypeError("Argument must be a number");
                                return i(e);
                            }, o.allocUnsafeSlow = function(e) {
                                if ("number" != typeof e) throw new TypeError("Argument must be a number");
                                return r.SlowBuffer(e);
                            };
                        },
                        "./node_modules/sax/lib/sax.js": function(e, t, n) {
                            (function(e) {
                                !function(t) {
                                    t.parser = function(e, t) {
                                        return new a1(e, t);
                                    }, t.SAXParser = a1, t.SAXStream = s1, t.createStream = function(e, t) {
                                        return new s1(e, t);
                                    }, t.MAX_BUFFER_LENGTH = 65536;
                                    var r, i = [
                                        "comment",
                                        "sgmlDecl",
                                        "textNode",
                                        "tagName",
                                        "doctype",
                                        "procInstName",
                                        "procInstBody",
                                        "entity",
                                        "attribName",
                                        "attribValue",
                                        "cdata",
                                        "script"
                                    ];
                                    function a1(e, n) {
                                        if (!(this instanceof a1)) return new a1(e, n);
                                        var r = this;
                                        !function(e) {
                                            for(var t = 0, n = i.length; t < n; t++)e[i[t]] = "";
                                        }(r), r.q = r.c = "", r.bufferCheckPosition = t.MAX_BUFFER_LENGTH, r.opt = n || {}, r.opt.lowercase = r.opt.lowercase || r.opt.lowercasetags, r.looseCase = r.opt.lowercase ? "toLowerCase" : "toUpperCase", r.tags = [], r.closed = r.closedRoot = r.sawRoot = !1, r.tag = r.error = null, r.strict = !!e, r.noscript = !(!e && !r.opt.noscript), r.state = I.BEGIN, r.strictEntities = r.opt.strictEntities, r.ENTITIES = r.strictEntities ? Object.create(t.XML_ENTITIES) : Object.create(t.ENTITIES), r.attribList = [], r.opt.xmlns && (r.ns = Object.create(p)), r.trackPosition = !1 !== r.opt.position, r.trackPosition && (r.position = r.line = r.column = 0), C(r, "onready");
                                    }
                                    t.EVENTS = [
                                        "text",
                                        "processinginstruction",
                                        "sgmldeclaration",
                                        "doctype",
                                        "comment",
                                        "opentagstart",
                                        "attribute",
                                        "opentag",
                                        "closetag",
                                        "opencdata",
                                        "cdata",
                                        "closecdata",
                                        "error",
                                        "end",
                                        "ready",
                                        "script",
                                        "opennamespace",
                                        "closenamespace"
                                    ], Object.create || (Object.create = function(e) {
                                        function t() {}
                                        return t.prototype = e, new t;
                                    }), Object.keys || (Object.keys = function(e) {
                                        var t = [];
                                        for(var n in e)e.hasOwnProperty(n) && t.push(n);
                                        return t;
                                    }), a1.prototype = {
                                        end: function() {
                                            x(this);
                                        },
                                        write: function(e) {
                                            var n = this;
                                            if (this.error) throw this.error;
                                            if (n.closed) return L(n, "Cannot write after close. Assign an onready handler.");
                                            if (null === e) return x(n);
                                            "object" == typeof e && (e = e.toString());
                                            for(var r = 0, a1 = ""; a1 = H(e, r++), n.c = a1, a1;)switch(n.trackPosition && (n.position++, "\n" === a1 ? (n.line++, n.column = 0) : n.column++), n.state){
                                                case I.BEGIN:
                                                    if (n.state = I.BEGIN_WHITESPACE, "\ufeff" === a1) continue;
                                                    G(n, a1);
                                                    continue;
                                                case I.BEGIN_WHITESPACE:
                                                    G(n, a1);
                                                    continue;
                                                case I.TEXT:
                                                    if (n.sawRoot && !n.closedRoot) {
                                                        for(var o = r - 1; a1 && "<" !== a1 && "&" !== a1;)(a1 = H(e, r++)) && n.trackPosition && (n.position++, "\n" === a1 ? (n.line++, n.column = 0) : n.column++);
                                                        n.textNode += e.substring(o, r - 1);
                                                    }
                                                    "<" !== a1 || n.sawRoot && n.closedRoot && !n.strict ? (!A(u, a1) || n.sawRoot && !n.closedRoot || M(n, "Text data outside of root node."), "&" === a1 ? n.state = I.TEXT_ENTITY : n.textNode += a1) : (n.state = I.OPEN_WAKA, n.startTagPosition = n.position);
                                                    continue;
                                                case I.SCRIPT:
                                                    "<" === a1 ? n.state = I.SCRIPT_ENDING : n.script += a1;
                                                    continue;
                                                case I.SCRIPT_ENDING:
                                                    "/" === a1 ? n.state = I.CLOSE_TAG : (n.script += "<" + a1, n.state = I.SCRIPT);
                                                    continue;
                                                case I.OPEN_WAKA:
                                                    if ("!" === a1) n.state = I.SGML_DECL, n.sgmlDecl = "";
                                                    else if (b(u, a1)) ;
                                                    else if (b(m, a1)) n.state = I.OPEN_TAG, n.tagName = a1;
                                                    else if ("/" === a1) n.state = I.CLOSE_TAG, n.tagName = "";
                                                    else if ("?" === a1) n.state = I.PROC_INST, n.procInstName = n.procInstBody = "";
                                                    else {
                                                        if (M(n, "Unencoded <"), n.startTagPosition + 1 < n.position) {
                                                            var s1 = n.position - n.startTagPosition;
                                                            a1 = new Array(s1).join(" ") + a1;
                                                        }
                                                        n.textNode += "<" + a1, n.state = I.TEXT;
                                                    }
                                                    continue;
                                                case I.SGML_DECL:
                                                    "[CDATA[" === (n.sgmlDecl + a1).toUpperCase() ? (D(n, "onopencdata"), n.state = I.CDATA, n.sgmlDecl = "", n.cdata = "") : n.sgmlDecl + a1 === "--" ? (n.state = I.COMMENT, n.comment = "", n.sgmlDecl = "") : "DOCTYPE" === (n.sgmlDecl + a1).toUpperCase() ? (n.state = I.DOCTYPE, (n.doctype || n.sawRoot) && M(n, "Inappropriately located doctype declaration"), n.doctype = "", n.sgmlDecl = "") : ">" === a1 ? (D(n, "onsgmldeclaration", n.sgmlDecl), n.sgmlDecl = "", n.state = I.TEXT) : b(d, a1) ? (n.state = I.SGML_DECL_QUOTED, n.sgmlDecl += a1) : n.sgmlDecl += a1;
                                                    continue;
                                                case I.SGML_DECL_QUOTED:
                                                    a1 === n.q && (n.state = I.SGML_DECL, n.q = ""), n.sgmlDecl += a1;
                                                    continue;
                                                case I.DOCTYPE:
                                                    ">" === a1 ? (n.state = I.TEXT, D(n, "ondoctype", n.doctype), n.doctype = !0) : (n.doctype += a1, "[" === a1 ? n.state = I.DOCTYPE_DTD : b(d, a1) && (n.state = I.DOCTYPE_QUOTED, n.q = a1));
                                                    continue;
                                                case I.DOCTYPE_QUOTED:
                                                    n.doctype += a1, a1 === n.q && (n.q = "", n.state = I.DOCTYPE);
                                                    continue;
                                                case I.DOCTYPE_DTD:
                                                    n.doctype += a1, "]" === a1 ? n.state = I.DOCTYPE : b(d, a1) && (n.state = I.DOCTYPE_DTD_QUOTED, n.q = a1);
                                                    continue;
                                                case I.DOCTYPE_DTD_QUOTED:
                                                    n.doctype += a1, a1 === n.q && (n.state = I.DOCTYPE_DTD, n.q = "");
                                                    continue;
                                                case I.COMMENT:
                                                    "-" === a1 ? n.state = I.COMMENT_ENDING : n.comment += a1;
                                                    continue;
                                                case I.COMMENT_ENDING:
                                                    "-" === a1 ? (n.state = I.COMMENT_ENDED, n.comment = N(n.opt, n.comment), n.comment && D(n, "oncomment", n.comment), n.comment = "") : (n.comment += "-" + a1, n.state = I.COMMENT);
                                                    continue;
                                                case I.COMMENT_ENDED:
                                                    ">" !== a1 ? (M(n, "Malformed comment"), n.comment += "--" + a1, n.state = I.COMMENT) : n.state = I.TEXT;
                                                    continue;
                                                case I.CDATA:
                                                    "]" === a1 ? n.state = I.CDATA_ENDING : n.cdata += a1;
                                                    continue;
                                                case I.CDATA_ENDING:
                                                    "]" === a1 ? n.state = I.CDATA_ENDING_2 : (n.cdata += "]" + a1, n.state = I.CDATA);
                                                    continue;
                                                case I.CDATA_ENDING_2:
                                                    ">" === a1 ? (n.cdata && D(n, "oncdata", n.cdata), D(n, "onclosecdata"), n.cdata = "", n.state = I.TEXT) : "]" === a1 ? n.cdata += "]" : (n.cdata += "]]" + a1, n.state = I.CDATA);
                                                    continue;
                                                case I.PROC_INST:
                                                    "?" === a1 ? n.state = I.PROC_INST_ENDING : b(u, a1) ? n.state = I.PROC_INST_BODY : n.procInstName += a1;
                                                    continue;
                                                case I.PROC_INST_BODY:
                                                    if (!n.procInstBody && b(u, a1)) continue;
                                                    "?" === a1 ? n.state = I.PROC_INST_ENDING : n.procInstBody += a1;
                                                    continue;
                                                case I.PROC_INST_ENDING:
                                                    ">" === a1 ? (D(n, "onprocessinginstruction", {
                                                        name: n.procInstName,
                                                        body: n.procInstBody
                                                    }), n.procInstName = n.procInstBody = "", n.state = I.TEXT) : (n.procInstBody += "?" + a1, n.state = I.PROC_INST_BODY);
                                                    continue;
                                                case I.OPEN_TAG:
                                                    b(v, a1) ? n.tagName += a1 : (O(n), ">" === a1 ? U(n) : "/" === a1 ? n.state = I.OPEN_TAG_SLASH : (A(u, a1) && M(n, "Invalid character in tag name"), n.state = I.ATTRIB));
                                                    continue;
                                                case I.OPEN_TAG_SLASH:
                                                    ">" === a1 ? (U(n, !0), j(n)) : (M(n, "Forward-slash in opening tag not followed by >"), n.state = I.ATTRIB);
                                                    continue;
                                                case I.ATTRIB:
                                                    if (b(u, a1)) continue;
                                                    ">" === a1 ? U(n) : "/" === a1 ? n.state = I.OPEN_TAG_SLASH : b(m, a1) ? (n.attribName = a1, n.attribValue = "", n.state = I.ATTRIB_NAME) : M(n, "Invalid attribute name");
                                                    continue;
                                                case I.ATTRIB_NAME:
                                                    "=" === a1 ? n.state = I.ATTRIB_VALUE : ">" === a1 ? (M(n, "Attribute without value"), n.attribValue = n.attribName, F(n), U(n)) : b(u, a1) ? n.state = I.ATTRIB_NAME_SAW_WHITE : b(v, a1) ? n.attribName += a1 : M(n, "Invalid attribute name");
                                                    continue;
                                                case I.ATTRIB_NAME_SAW_WHITE:
                                                    if ("=" === a1) n.state = I.ATTRIB_VALUE;
                                                    else {
                                                        if (b(u, a1)) continue;
                                                        M(n, "Attribute without value"), n.tag.attributes[n.attribName] = "", n.attribValue = "", D(n, "onattribute", {
                                                            name: n.attribName,
                                                            value: ""
                                                        }), n.attribName = "", ">" === a1 ? U(n) : b(m, a1) ? (n.attribName = a1, n.state = I.ATTRIB_NAME) : (M(n, "Invalid attribute name"), n.state = I.ATTRIB);
                                                    }
                                                    continue;
                                                case I.ATTRIB_VALUE:
                                                    if (b(u, a1)) continue;
                                                    b(d, a1) ? (n.q = a1, n.state = I.ATTRIB_VALUE_QUOTED) : (M(n, "Unquoted attribute value"), n.state = I.ATTRIB_VALUE_UNQUOTED, n.attribValue = a1);
                                                    continue;
                                                case I.ATTRIB_VALUE_QUOTED:
                                                    if (a1 !== n.q) {
                                                        "&" === a1 ? n.state = I.ATTRIB_VALUE_ENTITY_Q : n.attribValue += a1;
                                                        continue;
                                                    }
                                                    F(n), n.q = "", n.state = I.ATTRIB_VALUE_CLOSED;
                                                    continue;
                                                case I.ATTRIB_VALUE_CLOSED:
                                                    b(u, a1) ? n.state = I.ATTRIB : ">" === a1 ? U(n) : "/" === a1 ? n.state = I.OPEN_TAG_SLASH : b(m, a1) ? (M(n, "No whitespace between attributes"), n.attribName = a1, n.attribValue = "", n.state = I.ATTRIB_NAME) : M(n, "Invalid attribute name");
                                                    continue;
                                                case I.ATTRIB_VALUE_UNQUOTED:
                                                    if (A(f, a1)) {
                                                        "&" === a1 ? n.state = I.ATTRIB_VALUE_ENTITY_U : n.attribValue += a1;
                                                        continue;
                                                    }
                                                    F(n), ">" === a1 ? U(n) : n.state = I.ATTRIB;
                                                    continue;
                                                case I.CLOSE_TAG:
                                                    if (n.tagName) ">" === a1 ? j(n) : b(v, a1) ? n.tagName += a1 : n.script ? (n.script += "</" + n.tagName, n.tagName = "", n.state = I.SCRIPT) : (A(u, a1) && M(n, "Invalid tagname in closing tag"), n.state = I.CLOSE_TAG_SAW_WHITE);
                                                    else {
                                                        if (b(u, a1)) continue;
                                                        A(m, a1) ? n.script ? (n.script += "</" + a1, n.state = I.SCRIPT) : M(n, "Invalid tagname in closing tag.") : n.tagName = a1;
                                                    }
                                                    continue;
                                                case I.CLOSE_TAG_SAW_WHITE:
                                                    if (b(u, a1)) continue;
                                                    ">" === a1 ? j(n) : M(n, "Invalid characters in closing tag");
                                                    continue;
                                                case I.TEXT_ENTITY:
                                                case I.ATTRIB_VALUE_ENTITY_Q:
                                                case I.ATTRIB_VALUE_ENTITY_U:
                                                    var l, c;
                                                    switch(n.state){
                                                        case I.TEXT_ENTITY:
                                                            l = I.TEXT, c = "textNode";
                                                            break;
                                                        case I.ATTRIB_VALUE_ENTITY_Q:
                                                            l = I.ATTRIB_VALUE_QUOTED, c = "attribValue";
                                                            break;
                                                        case I.ATTRIB_VALUE_ENTITY_U:
                                                            l = I.ATTRIB_VALUE_UNQUOTED, c = "attribValue";
                                                    }
                                                    ";" === a1 ? (n[c] += B(n), n.entity = "", n.state = l) : b(n.entity.length ? E : y, a1) ? n.entity += a1 : (M(n, "Invalid character in entity name"), n[c] += "&" + n.entity + a1, n.entity = "", n.state = l);
                                                    continue;
                                                default:
                                                    throw new Error(n, "Unknown state: " + n.state);
                                            }
                                            return n.position >= n.bufferCheckPosition && function(e) {
                                                for(var n = Math.max(t.MAX_BUFFER_LENGTH, 10), r = 0, a1 = 0, o = i.length; a1 < o; a1++){
                                                    var s1 = e[i[a1]].length;
                                                    if (s1 > n) switch(i[a1]){
                                                        case "textNode":
                                                            k(e);
                                                            break;
                                                        case "cdata":
                                                            D(e, "oncdata", e.cdata), e.cdata = "";
                                                            break;
                                                        case "script":
                                                            D(e, "onscript", e.script), e.script = "";
                                                            break;
                                                        default:
                                                            L(e, "Max buffer length exceeded: " + i[a1]);
                                                    }
                                                    r = Math.max(r, s1);
                                                }
                                                var u = t.MAX_BUFFER_LENGTH - r;
                                                e.bufferCheckPosition = u + e.position;
                                            }(n), n;
                                        },
                                        resume: function() {
                                            return this.error = null, this;
                                        },
                                        close: function() {
                                            return this.write(null);
                                        },
                                        flush: function() {
                                            var e;
                                            k(e = this), "" !== e.cdata && (D(e, "oncdata", e.cdata), e.cdata = ""), "" !== e.script && (D(e, "onscript", e.script), e.script = "");
                                        }
                                    };
                                    try {
                                        r = n("./node_modules/stream-browserify/index.js").Stream;
                                    } catch (e) {
                                        r = function() {};
                                    }
                                    var o = t.EVENTS.filter(function(e) {
                                        return "error" !== e && "end" !== e;
                                    });
                                    function s1(e, t) {
                                        if (!(this instanceof s1)) return new s1(e, t);
                                        r.apply(this), this._parser = new a1(e, t), this.writable = !0, this.readable = !0;
                                        var n = this;
                                        this._parser.onend = function() {
                                            n.emit("end");
                                        }, this._parser.onerror = function(e) {
                                            n.emit("error", e), n._parser.error = null;
                                        }, this._decoder = null, o.forEach(function(e) {
                                            Object.defineProperty(n, "on" + e, {
                                                get: function() {
                                                    return n._parser["on" + e];
                                                },
                                                set: function(t) {
                                                    if (!t) return n.removeAllListeners(e), n._parser["on" + e] = t, t;
                                                    n.on(e, t);
                                                },
                                                enumerable: !0,
                                                configurable: !1
                                            });
                                        });
                                    }
                                    s1.prototype = Object.create(r.prototype, {
                                        constructor: {
                                            value: s1
                                        }
                                    }), s1.prototype.write = function(t) {
                                        if ("function" == typeof e && "function" == typeof e.isBuffer && e.isBuffer(t)) {
                                            if (!this._decoder) {
                                                var r = n("./node_modules/string_decoder/lib/string_decoder.js").StringDecoder;
                                                this._decoder = new r("utf8");
                                            }
                                            t = this._decoder.write(t);
                                        }
                                        return this._parser.write(t.toString()), this.emit("data", t), !0;
                                    }, s1.prototype.end = function(e) {
                                        return e && e.length && this.write(e), this._parser.end(), !0;
                                    }, s1.prototype.on = function(e, t) {
                                        var n = this;
                                        return n._parser["on" + e] || -1 === o.indexOf(e) || (n._parser["on" + e] = function() {
                                            var t = 1 === arguments.length ? [
                                                arguments[0]
                                            ] : Array.apply(null, arguments);
                                            t.splice(0, 0, e), n.emit.apply(n, t);
                                        }), r.prototype.on.call(n, e, t);
                                    };
                                    var u = "\r\n\t ", l = "0124356789", c = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ", d = "'\"", f = u + ">", h = "http://www.w3.org/XML/1998/namespace", g = "http://www.w3.org/2000/xmlns/", p = {
                                        xml: h,
                                        xmlns: g
                                    };
                                    u = T(u), l = T(l), c = T(c);
                                    var m = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, v = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/, y = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, E = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/;
                                    function T(e) {
                                        return e.split("").reduce(function(e, t) {
                                            return e[t] = !0, e;
                                        }, {});
                                    }
                                    function b(e, t) {
                                        return function(e) {
                                            return "[object RegExp]" === Object.prototype.toString.call(e);
                                        }(e) ? !!t.match(e) : e[t];
                                    }
                                    function A(e, t) {
                                        return !b(e, t);
                                    }
                                    d = T(d), f = T(f);
                                    var _, S, w, I = 0;
                                    for(var R in t.STATE = {
                                        BEGIN: I++,
                                        BEGIN_WHITESPACE: I++,
                                        TEXT: I++,
                                        TEXT_ENTITY: I++,
                                        OPEN_WAKA: I++,
                                        SGML_DECL: I++,
                                        SGML_DECL_QUOTED: I++,
                                        DOCTYPE: I++,
                                        DOCTYPE_QUOTED: I++,
                                        DOCTYPE_DTD: I++,
                                        DOCTYPE_DTD_QUOTED: I++,
                                        COMMENT_STARTING: I++,
                                        COMMENT: I++,
                                        COMMENT_ENDING: I++,
                                        COMMENT_ENDED: I++,
                                        CDATA: I++,
                                        CDATA_ENDING: I++,
                                        CDATA_ENDING_2: I++,
                                        PROC_INST: I++,
                                        PROC_INST_BODY: I++,
                                        PROC_INST_ENDING: I++,
                                        OPEN_TAG: I++,
                                        OPEN_TAG_SLASH: I++,
                                        ATTRIB: I++,
                                        ATTRIB_NAME: I++,
                                        ATTRIB_NAME_SAW_WHITE: I++,
                                        ATTRIB_VALUE: I++,
                                        ATTRIB_VALUE_QUOTED: I++,
                                        ATTRIB_VALUE_CLOSED: I++,
                                        ATTRIB_VALUE_UNQUOTED: I++,
                                        ATTRIB_VALUE_ENTITY_Q: I++,
                                        ATTRIB_VALUE_ENTITY_U: I++,
                                        CLOSE_TAG: I++,
                                        CLOSE_TAG_SAW_WHITE: I++,
                                        SCRIPT: I++,
                                        SCRIPT_ENDING: I++
                                    }, t.XML_ENTITIES = {
                                        amp: "&",
                                        gt: ">",
                                        lt: "<",
                                        quot: '"',
                                        apos: "'"
                                    }, t.ENTITIES = {
                                        amp: "&",
                                        gt: ">",
                                        lt: "<",
                                        quot: '"',
                                        apos: "'",
                                        AElig: 198,
                                        Aacute: 193,
                                        Acirc: 194,
                                        Agrave: 192,
                                        Aring: 197,
                                        Atilde: 195,
                                        Auml: 196,
                                        Ccedil: 199,
                                        ETH: 208,
                                        Eacute: 201,
                                        Ecirc: 202,
                                        Egrave: 200,
                                        Euml: 203,
                                        Iacute: 205,
                                        Icirc: 206,
                                        Igrave: 204,
                                        Iuml: 207,
                                        Ntilde: 209,
                                        Oacute: 211,
                                        Ocirc: 212,
                                        Ograve: 210,
                                        Oslash: 216,
                                        Otilde: 213,
                                        Ouml: 214,
                                        THORN: 222,
                                        Uacute: 218,
                                        Ucirc: 219,
                                        Ugrave: 217,
                                        Uuml: 220,
                                        Yacute: 221,
                                        aacute: 225,
                                        acirc: 226,
                                        aelig: 230,
                                        agrave: 224,
                                        aring: 229,
                                        atilde: 227,
                                        auml: 228,
                                        ccedil: 231,
                                        eacute: 233,
                                        ecirc: 234,
                                        egrave: 232,
                                        eth: 240,
                                        euml: 235,
                                        iacute: 237,
                                        icirc: 238,
                                        igrave: 236,
                                        iuml: 239,
                                        ntilde: 241,
                                        oacute: 243,
                                        ocirc: 244,
                                        ograve: 242,
                                        oslash: 248,
                                        otilde: 245,
                                        ouml: 246,
                                        szlig: 223,
                                        thorn: 254,
                                        uacute: 250,
                                        ucirc: 251,
                                        ugrave: 249,
                                        uuml: 252,
                                        yacute: 253,
                                        yuml: 255,
                                        copy: 169,
                                        reg: 174,
                                        nbsp: 160,
                                        iexcl: 161,
                                        cent: 162,
                                        pound: 163,
                                        curren: 164,
                                        yen: 165,
                                        brvbar: 166,
                                        sect: 167,
                                        uml: 168,
                                        ordf: 170,
                                        laquo: 171,
                                        not: 172,
                                        shy: 173,
                                        macr: 175,
                                        deg: 176,
                                        plusmn: 177,
                                        sup1: 185,
                                        sup2: 178,
                                        sup3: 179,
                                        acute: 180,
                                        micro: 181,
                                        para: 182,
                                        middot: 183,
                                        cedil: 184,
                                        ordm: 186,
                                        raquo: 187,
                                        frac14: 188,
                                        frac12: 189,
                                        frac34: 190,
                                        iquest: 191,
                                        times: 215,
                                        divide: 247,
                                        OElig: 338,
                                        oelig: 339,
                                        Scaron: 352,
                                        scaron: 353,
                                        Yuml: 376,
                                        fnof: 402,
                                        circ: 710,
                                        tilde: 732,
                                        Alpha: 913,
                                        Beta: 914,
                                        Gamma: 915,
                                        Delta: 916,
                                        Epsilon: 917,
                                        Zeta: 918,
                                        Eta: 919,
                                        Theta: 920,
                                        Iota: 921,
                                        Kappa: 922,
                                        Lambda: 923,
                                        Mu: 924,
                                        Nu: 925,
                                        Xi: 926,
                                        Omicron: 927,
                                        Pi: 928,
                                        Rho: 929,
                                        Sigma: 931,
                                        Tau: 932,
                                        Upsilon: 933,
                                        Phi: 934,
                                        Chi: 935,
                                        Psi: 936,
                                        Omega: 937,
                                        alpha: 945,
                                        beta: 946,
                                        gamma: 947,
                                        delta: 948,
                                        epsilon: 949,
                                        zeta: 950,
                                        eta: 951,
                                        theta: 952,
                                        iota: 953,
                                        kappa: 954,
                                        lambda: 955,
                                        mu: 956,
                                        nu: 957,
                                        xi: 958,
                                        omicron: 959,
                                        pi: 960,
                                        rho: 961,
                                        sigmaf: 962,
                                        sigma: 963,
                                        tau: 964,
                                        upsilon: 965,
                                        phi: 966,
                                        chi: 967,
                                        psi: 968,
                                        omega: 969,
                                        thetasym: 977,
                                        upsih: 978,
                                        piv: 982,
                                        ensp: 8194,
                                        emsp: 8195,
                                        thinsp: 8201,
                                        zwnj: 8204,
                                        zwj: 8205,
                                        lrm: 8206,
                                        rlm: 8207,
                                        ndash: 8211,
                                        mdash: 8212,
                                        lsquo: 8216,
                                        rsquo: 8217,
                                        sbquo: 8218,
                                        ldquo: 8220,
                                        rdquo: 8221,
                                        bdquo: 8222,
                                        dagger: 8224,
                                        Dagger: 8225,
                                        bull: 8226,
                                        hellip: 8230,
                                        permil: 8240,
                                        prime: 8242,
                                        Prime: 8243,
                                        lsaquo: 8249,
                                        rsaquo: 8250,
                                        oline: 8254,
                                        frasl: 8260,
                                        euro: 8364,
                                        image: 8465,
                                        weierp: 8472,
                                        real: 8476,
                                        trade: 8482,
                                        alefsym: 8501,
                                        larr: 8592,
                                        uarr: 8593,
                                        rarr: 8594,
                                        darr: 8595,
                                        harr: 8596,
                                        crarr: 8629,
                                        lArr: 8656,
                                        uArr: 8657,
                                        rArr: 8658,
                                        dArr: 8659,
                                        hArr: 8660,
                                        forall: 8704,
                                        part: 8706,
                                        exist: 8707,
                                        empty: 8709,
                                        nabla: 8711,
                                        isin: 8712,
                                        notin: 8713,
                                        ni: 8715,
                                        prod: 8719,
                                        sum: 8721,
                                        minus: 8722,
                                        lowast: 8727,
                                        radic: 8730,
                                        prop: 8733,
                                        infin: 8734,
                                        ang: 8736,
                                        and: 8743,
                                        or: 8744,
                                        cap: 8745,
                                        cup: 8746,
                                        int: 8747,
                                        there4: 8756,
                                        sim: 8764,
                                        cong: 8773,
                                        asymp: 8776,
                                        ne: 8800,
                                        equiv: 8801,
                                        le: 8804,
                                        ge: 8805,
                                        sub: 8834,
                                        sup: 8835,
                                        nsub: 8836,
                                        sube: 8838,
                                        supe: 8839,
                                        oplus: 8853,
                                        otimes: 8855,
                                        perp: 8869,
                                        sdot: 8901,
                                        lceil: 8968,
                                        rceil: 8969,
                                        lfloor: 8970,
                                        rfloor: 8971,
                                        lang: 9001,
                                        rang: 9002,
                                        loz: 9674,
                                        spades: 9824,
                                        clubs: 9827,
                                        hearts: 9829,
                                        diams: 9830
                                    }, Object.keys(t.ENTITIES).forEach(function(e) {
                                        var n = t.ENTITIES[e], r = "number" == typeof n ? String.fromCharCode(n) : n;
                                        t.ENTITIES[e] = r;
                                    }), t.STATE)t.STATE[t.STATE[R]] = R;
                                    function C(e, t, n) {
                                        e[t] && e[t](n);
                                    }
                                    function D(e, t, n) {
                                        e.textNode && k(e), C(e, t, n);
                                    }
                                    function k(e) {
                                        e.textNode = N(e.opt, e.textNode), e.textNode && C(e, "ontext", e.textNode), e.textNode = "";
                                    }
                                    function N(e, t) {
                                        return e.trim && (t = t.trim()), e.normalize && (t = t.replace(/\s+/g, " ")), t;
                                    }
                                    function L(e, t) {
                                        return k(e), e.trackPosition && (t += "\nLine: " + e.line + "\nColumn: " + e.column + "\nChar: " + e.c), t = new Error(t), e.error = t, C(e, "onerror", t), e;
                                    }
                                    function x(e) {
                                        return e.sawRoot && !e.closedRoot && M(e, "Unclosed root tag"), e.state !== I.BEGIN && e.state !== I.BEGIN_WHITESPACE && e.state !== I.TEXT && L(e, "Unexpected end"), k(e), e.c = "", e.closed = !0, C(e, "onend"), a1.call(e, e.strict, e.opt), e;
                                    }
                                    function M(e, t) {
                                        if ("object" != typeof e || !(e instanceof a1)) throw new Error("bad call to strictFail");
                                        e.strict && L(e, t);
                                    }
                                    function O(e) {
                                        e.strict || (e.tagName = e.tagName[e.looseCase]());
                                        var t = e.tags[e.tags.length - 1] || e, n = e.tag = {
                                            name: e.tagName,
                                            attributes: {}
                                        };
                                        e.opt.xmlns && (n.ns = t.ns), e.attribList.length = 0, D(e, "onopentagstart", n);
                                    }
                                    function P(e, t) {
                                        var n = e.indexOf(":") < 0 ? [
                                            "",
                                            e
                                        ] : e.split(":"), r = n[0], i = n[1];
                                        return t && "xmlns" === e && (r = "xmlns", i = ""), {
                                            prefix: r,
                                            local: i
                                        };
                                    }
                                    function F(e) {
                                        if (e.strict || (e.attribName = e.attribName[e.looseCase]()), -1 !== e.attribList.indexOf(e.attribName) || e.tag.attributes.hasOwnProperty(e.attribName)) e.attribName = e.attribValue = "";
                                        else {
                                            if (e.opt.xmlns) {
                                                var t = P(e.attribName, !0), n = t.prefix, r = t.local;
                                                if ("xmlns" === n) {
                                                    if ("xml" === r && e.attribValue !== h) M(e, "xml: prefix must be bound to " + h + "\nActual: " + e.attribValue);
                                                    else if ("xmlns" === r && e.attribValue !== g) M(e, "xmlns: prefix must be bound to " + g + "\nActual: " + e.attribValue);
                                                    else {
                                                        var i = e.tag, a1 = e.tags[e.tags.length - 1] || e;
                                                        i.ns === a1.ns && (i.ns = Object.create(a1.ns)), i.ns[r] = e.attribValue;
                                                    }
                                                }
                                                e.attribList.push([
                                                    e.attribName,
                                                    e.attribValue
                                                ]);
                                            } else e.tag.attributes[e.attribName] = e.attribValue, D(e, "onattribute", {
                                                name: e.attribName,
                                                value: e.attribValue
                                            });
                                            e.attribName = e.attribValue = "";
                                        }
                                    }
                                    function U(e, t) {
                                        if (e.opt.xmlns) {
                                            var n = e.tag, r = P(e.tagName);
                                            n.prefix = r.prefix, n.local = r.local, n.uri = n.ns[r.prefix] || "", n.prefix && !n.uri && (M(e, "Unbound namespace prefix: " + JSON.stringify(e.tagName)), n.uri = r.prefix);
                                            var i = e.tags[e.tags.length - 1] || e;
                                            n.ns && i.ns !== n.ns && Object.keys(n.ns).forEach(function(t) {
                                                D(e, "onopennamespace", {
                                                    prefix: t,
                                                    uri: n.ns[t]
                                                });
                                            });
                                            for(var a1 = 0, o = e.attribList.length; a1 < o; a1++){
                                                var s1 = e.attribList[a1], u = s1[0], l = s1[1], c = P(u, !0), d = c.prefix, f = c.local, h = "" === d ? "" : n.ns[d] || "", g = {
                                                    name: u,
                                                    value: l,
                                                    prefix: d,
                                                    local: f,
                                                    uri: h
                                                };
                                                d && "xmlns" !== d && !h && (M(e, "Unbound namespace prefix: " + JSON.stringify(d)), g.uri = d), e.tag.attributes[u] = g, D(e, "onattribute", g);
                                            }
                                            e.attribList.length = 0;
                                        }
                                        e.tag.isSelfClosing = !!t, e.sawRoot = !0, e.tags.push(e.tag), D(e, "onopentag", e.tag), t || (e.noscript || "script" !== e.tagName.toLowerCase() ? e.state = I.TEXT : e.state = I.SCRIPT, e.tag = null, e.tagName = ""), e.attribName = e.attribValue = "", e.attribList.length = 0;
                                    }
                                    function j(e) {
                                        if (!e.tagName) return M(e, "Weird empty close tag."), e.textNode += "</>", void (e.state = I.TEXT);
                                        if (e.script) {
                                            if ("script" !== e.tagName) return e.script += "</" + e.tagName + ">", e.tagName = "", void (e.state = I.SCRIPT);
                                            D(e, "onscript", e.script), e.script = "";
                                        }
                                        var t = e.tags.length, n = e.tagName;
                                        e.strict || (n = n[e.looseCase]());
                                        for(var r = n; t-- && e.tags[t].name !== r;)M(e, "Unexpected close tag");
                                        if (t < 0) return M(e, "Unmatched closing tag: " + e.tagName), e.textNode += "</" + e.tagName + ">", void (e.state = I.TEXT);
                                        e.tagName = n;
                                        for(var i = e.tags.length; i-- > t;){
                                            var a1 = e.tag = e.tags.pop();
                                            e.tagName = e.tag.name, D(e, "onclosetag", e.tagName);
                                            var o = {};
                                            for(var s1 in a1.ns)o[s1] = a1.ns[s1];
                                            var u = e.tags[e.tags.length - 1] || e;
                                            e.opt.xmlns && a1.ns !== u.ns && Object.keys(a1.ns).forEach(function(t) {
                                                var n = a1.ns[t];
                                                D(e, "onclosenamespace", {
                                                    prefix: t,
                                                    uri: n
                                                });
                                            });
                                        }
                                        0 === t && (e.closedRoot = !0), e.tagName = e.attribValue = e.attribName = "", e.attribList.length = 0, e.state = I.TEXT;
                                    }
                                    function B(e) {
                                        var t, n = e.entity, r = n.toLowerCase(), i = "";
                                        return e.ENTITIES[n] ? e.ENTITIES[n] : e.ENTITIES[r] ? e.ENTITIES[r] : ("#" === (n = r).charAt(0) && ("x" === n.charAt(1) ? (n = n.slice(2), i = (t = parseInt(n, 16)).toString(16)) : (n = n.slice(1), i = (t = parseInt(n, 10)).toString(10))), n = n.replace(/^0+/, ""), i.toLowerCase() !== n ? (M(e, "Invalid character entity"), "&" + e.entity + ";") : String.fromCodePoint(t));
                                    }
                                    function G(e, t) {
                                        "<" === t ? (e.state = I.OPEN_WAKA, e.startTagPosition = e.position) : A(u, t) && (M(e, "Non-whitespace before first tag."), e.textNode = t, e.state = I.TEXT);
                                    }
                                    function H(e, t) {
                                        var n = "";
                                        return t < e.length && (n = e.charAt(t)), n;
                                    }
                                    I = t.STATE, String.fromCodePoint || (_ = String.fromCharCode, S = Math.floor, w = function() {
                                        var e, t, n = 16384, r = [], i = -1, a1 = arguments.length;
                                        if (!a1) return "";
                                        for(var o = ""; ++i < a1;){
                                            var s1 = Number(arguments[i]);
                                            if (!isFinite(s1) || s1 < 0 || s1 > 1114111 || S(s1) !== s1) throw RangeError("Invalid code point: " + s1);
                                            s1 <= 65535 ? r.push(s1) : (e = 55296 + ((s1 -= 65536) >> 10), t = s1 % 1024 + 56320, r.push(e, t)), (i + 1 === a1 || r.length > n) && (o += _.apply(null, r), r.length = 0);
                                        }
                                        return o;
                                    }, Object.defineProperty ? Object.defineProperty(String, "fromCodePoint", {
                                        value: w,
                                        configurable: !0,
                                        writable: !0
                                    }) : String.fromCodePoint = w);
                                }(t);
                            }).call(this, n("./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer);
                        },
                        "./node_modules/setimmediate/setImmediate.js": function(e, t, n) {
                            (function(e, t) {
                                !function(e, n) {
                                    "use strict";
                                    if (!e.setImmediate) {
                                        var r, i, a1, o, s1, u = 1, l = {}, c = !1, d = e.document, f = Object.getPrototypeOf && Object.getPrototypeOf(e);
                                        f = f && f.setTimeout ? f : e, "[object process]" === ({}).toString.call(e.process) ? r = function(e) {
                                            t.nextTick(function() {
                                                g(e);
                                            });
                                        } : function() {
                                            if (e.postMessage && !e.importScripts) {
                                                var t = !0, n = e.onmessage;
                                                return e.onmessage = function() {
                                                    t = !1;
                                                }, e.postMessage("", "*"), e.onmessage = n, t;
                                            }
                                        }() ? (o = "setImmediate$" + Math.random() + "$", s1 = function(t) {
                                            t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(o) && g(+t.data.slice(o.length));
                                        }, e.addEventListener ? e.addEventListener("message", s1, !1) : e.attachEvent("onmessage", s1), r = function(t) {
                                            e.postMessage(o + t, "*");
                                        }) : e.MessageChannel ? ((a1 = new MessageChannel).port1.onmessage = function(e) {
                                            g(e.data);
                                        }, r = function(e) {
                                            a1.port2.postMessage(e);
                                        }) : d && "onreadystatechange" in d.createElement("script") ? (i = d.documentElement, r = function(e) {
                                            var t = d.createElement("script");
                                            t.onreadystatechange = function() {
                                                g(e), t.onreadystatechange = null, i.removeChild(t), t = null;
                                            }, i.appendChild(t);
                                        }) : r = function(e) {
                                            setTimeout(g, 0, e);
                                        }, f.setImmediate = function(e) {
                                            "function" != typeof e && (e = new Function("" + e));
                                            for(var t = new Array(arguments.length - 1), n = 0; n < t.length; n++)t[n] = arguments[n + 1];
                                            var i = {
                                                callback: e,
                                                args: t
                                            };
                                            return l[u] = i, r(u), u++;
                                        }, f.clearImmediate = h;
                                    }
                                    function h(e) {
                                        delete l[e];
                                    }
                                    function g(e) {
                                        if (c) setTimeout(g, 0, e);
                                        else {
                                            var t = l[e];
                                            if (t) {
                                                c = !0;
                                                try {
                                                    !function(e) {
                                                        var t = e.callback, n = e.args;
                                                        switch(n.length){
                                                            case 0:
                                                                t();
                                                                break;
                                                            case 1:
                                                                t(n[0]);
                                                                break;
                                                            case 2:
                                                                t(n[0], n[1]);
                                                                break;
                                                            case 3:
                                                                t(n[0], n[1], n[2]);
                                                                break;
                                                            default:
                                                                t.apply(void 0, n);
                                                        }
                                                    }(t);
                                                } finally{
                                                    h(e), c = !1;
                                                }
                                            }
                                        }
                                    }
                                }("undefined" == typeof self ? void 0 === e ? this : e : self);
                            }).call(this, n("./node_modules/webpack/buildin/global.js"), n("./node_modules/process/browser.js"));
                        },
                        "./node_modules/stream-browserify/index.js": function(e, t, n) {
                            e.exports = i;
                            var r = n("./node_modules/node-libs-browser/node_modules/events/events.js").EventEmitter;
                            function i() {
                                r.call(this);
                            }
                            n("./node_modules/inherits/inherits_browser.js")(i, r), i.Readable = n("./node_modules/readable-stream/readable-browser.js"), i.Writable = n("./node_modules/readable-stream/writable-browser.js"), i.Duplex = n("./node_modules/readable-stream/duplex-browser.js"), i.Transform = n("./node_modules/readable-stream/transform.js"), i.PassThrough = n("./node_modules/readable-stream/passthrough.js"), i.Stream = i, i.prototype.pipe = function(e, t) {
                                var n = this;
                                function i(t) {
                                    e.writable && !1 === e.write(t) && n.pause && n.pause();
                                }
                                function a1() {
                                    n.readable && n.resume && n.resume();
                                }
                                n.on("data", i), e.on("drain", a1), e._isStdio || t && !1 === t.end || (n.on("end", s1), n.on("close", u));
                                var o = !1;
                                function s1() {
                                    o || (o = !0, e.end());
                                }
                                function u() {
                                    o || (o = !0, "function" == typeof e.destroy && e.destroy());
                                }
                                function l(e) {
                                    if (c(), 0 === r.listenerCount(this, "error")) throw e;
                                }
                                function c() {
                                    n.removeListener("data", i), e.removeListener("drain", a1), n.removeListener("end", s1), n.removeListener("close", u), n.removeListener("error", l), e.removeListener("error", l), n.removeListener("end", c), n.removeListener("close", c), e.removeListener("close", c);
                                }
                                return n.on("error", l), e.on("error", l), n.on("end", c), n.on("close", c), e.on("close", c), e.emit("pipe", n), e;
                            };
                        },
                        "./node_modules/string_decoder/lib/string_decoder.js": function(e, t, n) {
                            "use strict";
                            var r = n("./node_modules/safe-buffer/index.js").Buffer, i = r.isEncoding || function(e) {
                                switch((e = "" + e) && e.toLowerCase()){
                                    case "hex":
                                    case "utf8":
                                    case "utf-8":
                                    case "ascii":
                                    case "binary":
                                    case "base64":
                                    case "ucs2":
                                    case "ucs-2":
                                    case "utf16le":
                                    case "utf-16le":
                                    case "raw":
                                        return !0;
                                    default:
                                        return !1;
                                }
                            };
                            function a1(e) {
                                var t;
                                switch(this.encoding = function(e) {
                                    var t = function(e) {
                                        if (!e) return "utf8";
                                        for(var t;;)switch(e){
                                            case "utf8":
                                            case "utf-8":
                                                return "utf8";
                                            case "ucs2":
                                            case "ucs-2":
                                            case "utf16le":
                                            case "utf-16le":
                                                return "utf16le";
                                            case "latin1":
                                            case "binary":
                                                return "latin1";
                                            case "base64":
                                            case "ascii":
                                            case "hex":
                                                return e;
                                            default:
                                                if (t) return;
                                                e = ("" + e).toLowerCase(), t = !0;
                                        }
                                    }(e);
                                    if ("string" != typeof t && (r.isEncoding === i || !i(e))) throw new Error("Unknown encoding: " + e);
                                    return t || e;
                                }(e), this.encoding){
                                    case "utf16le":
                                        this.text = u, this.end = l, t = 4;
                                        break;
                                    case "utf8":
                                        this.fillLast = s1, t = 4;
                                        break;
                                    case "base64":
                                        this.text = c, this.end = d, t = 3;
                                        break;
                                    default:
                                        return this.write = f, void (this.end = h);
                                }
                                this.lastNeed = 0, this.lastTotal = 0, this.lastChar = r.allocUnsafe(t);
                            }
                            function o(e) {
                                return e <= 127 ? 0 : e >> 5 == 6 ? 2 : e >> 4 == 14 ? 3 : e >> 3 == 30 ? 4 : e >> 6 == 2 ? -1 : -2;
                            }
                            function s1(e) {
                                var t = this.lastTotal - this.lastNeed, n = function(e, t, n) {
                                    if (128 != (192 & t[0])) return e.lastNeed = 0, "\uFFFD";
                                    if (e.lastNeed > 1 && t.length > 1) {
                                        if (128 != (192 & t[1])) return e.lastNeed = 1, "\uFFFD";
                                        if (e.lastNeed > 2 && t.length > 2 && 128 != (192 & t[2])) return e.lastNeed = 2, "\uFFFD";
                                    }
                                }(this, e);
                                return void 0 !== n ? n : this.lastNeed <= e.length ? (e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e.copy(this.lastChar, t, 0, e.length), void (this.lastNeed -= e.length));
                            }
                            function u(e, t) {
                                if ((e.length - t) % 2 == 0) {
                                    var n = e.toString("utf16le", t);
                                    if (n) {
                                        var r = n.charCodeAt(n.length - 1);
                                        if (r >= 55296 && r <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], n.slice(0, -1);
                                    }
                                    return n;
                                }
                                return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
                            }
                            function l(e) {
                                var t = e && e.length ? this.write(e) : "";
                                if (this.lastNeed) {
                                    var n = this.lastTotal - this.lastNeed;
                                    return t + this.lastChar.toString("utf16le", 0, n);
                                }
                                return t;
                            }
                            function c(e, t) {
                                var n = (e.length - t) % 3;
                                return 0 === n ? e.toString("base64", t) : (this.lastNeed = 3 - n, this.lastTotal = 3, 1 === n ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - n));
                            }
                            function d(e) {
                                var t = e && e.length ? this.write(e) : "";
                                return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
                            }
                            function f(e) {
                                return e.toString(this.encoding);
                            }
                            function h(e) {
                                return e && e.length ? this.write(e) : "";
                            }
                            t.StringDecoder = a1, a1.prototype.write = function(e) {
                                if (0 === e.length) return "";
                                var t, n;
                                if (this.lastNeed) {
                                    if (void 0 === (t = this.fillLast(e))) return "";
                                    n = this.lastNeed, this.lastNeed = 0;
                                } else n = 0;
                                return n < e.length ? t ? t + this.text(e, n) : this.text(e, n) : t || "";
                            }, a1.prototype.end = function(e) {
                                var t = e && e.length ? this.write(e) : "";
                                return this.lastNeed ? t + "\uFFFD" : t;
                            }, a1.prototype.text = function(e, t) {
                                var n = function(e, t, n) {
                                    var r = t.length - 1;
                                    if (r < n) return 0;
                                    var i = o(t[r]);
                                    return i >= 0 ? (i > 0 && (e.lastNeed = i - 1), i) : --r < n || -2 === i ? 0 : (i = o(t[r])) >= 0 ? (i > 0 && (e.lastNeed = i - 2), i) : --r < n || -2 === i ? 0 : (i = o(t[r])) >= 0 ? (i > 0 && (2 === i ? i = 0 : e.lastNeed = i - 3), i) : 0;
                                }(this, e, t);
                                if (!this.lastNeed) return e.toString("utf8", t);
                                this.lastTotal = n;
                                var r = e.length - (n - this.lastNeed);
                                return e.copy(this.lastChar, 0, r), e.toString("utf8", t, r);
                            }, a1.prototype.fillLast = function(e) {
                                if (this.lastNeed <= e.length) return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
                                e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
                            };
                        },
                        "./node_modules/ua-parser-js/src/ua-parser.js": function(e, t, n) {
                            var r;
                            !function(i, a1) {
                                "use strict";
                                var o = "function", s1 = "undefined", u = "object", l = "string", c = "model", d = "name", f = "type", h = "vendor", g = "version", p = "architecture", m = "console", v = "mobile", y = "tablet", E = "smarttv", T = "wearable", b = "embedded", A = "Amazon", _ = "Apple", S = "ASUS", w = "BlackBerry", I = "Google", R = "Huawei", C = "LG", D = "Microsoft", k = "Motorola", N = "Samsung", L = "Sony", x = "Xiaomi", M = "Zebra", O = "Facebook", P = function(e) {
                                    for(var t = {}, n = 0; n < e.length; n++)t[e[n].toUpperCase()] = e[n];
                                    return t;
                                }, F = function(e, t) {
                                    return typeof e === l && -1 !== U(t).indexOf(U(e));
                                }, U = function(e) {
                                    return e.toLowerCase();
                                }, j = function(e, t) {
                                    if (typeof e === l) return e = e.replace(/^\s\s*/, "").replace(/\s\s*$/, ""), typeof t === s1 ? e : e.substring(0, 255);
                                }, B = function(e, t) {
                                    for(var n, r, i, s1, l, c, d = 0; d < t.length && !l;){
                                        var f = t[d], h = t[d + 1];
                                        for(n = r = 0; n < f.length && !l;)if (l = f[n++].exec(e)) for(i = 0; i < h.length; i++)c = l[++r], typeof (s1 = h[i]) === u && s1.length > 0 ? 2 === s1.length ? typeof s1[1] == o ? this[s1[0]] = s1[1].call(this, c) : this[s1[0]] = s1[1] : 3 === s1.length ? typeof s1[1] !== o || s1[1].exec && s1[1].test ? this[s1[0]] = c ? c.replace(s1[1], s1[2]) : a1 : this[s1[0]] = c ? s1[1].call(this, c, s1[2]) : a1 : 4 === s1.length && (this[s1[0]] = c ? s1[3].call(this, c.replace(s1[1], s1[2])) : a1) : this[s1] = c || a1;
                                        d += 2;
                                    }
                                }, G = function(e, t) {
                                    for(var n in t)if (typeof t[n] === u && t[n].length > 0) {
                                        for(var r = 0; r < t[n].length; r++)if (F(t[n][r], e)) return "?" === n ? a1 : n;
                                    } else if (F(t[n], e)) return "?" === n ? a1 : n;
                                    return e;
                                }, H = {
                                    ME: "4.90",
                                    "NT 3.11": "NT3.51",
                                    "NT 4.0": "NT4.0",
                                    2e3: "NT 5.0",
                                    XP: [
                                        "NT 5.1",
                                        "NT 5.2"
                                    ],
                                    Vista: "NT 6.0",
                                    7: "NT 6.1",
                                    8: "NT 6.2",
                                    8.1: "NT 6.3",
                                    10: [
                                        "NT 6.4",
                                        "NT 10.0"
                                    ],
                                    RT: "ARM"
                                }, V = {
                                    browser: [
                                        [
                                            /\b(?:crmo|crios)\/([\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Chrome"
                                            ]
                                        ],
                                        [
                                            /edg(?:e|ios|a)?\/([\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Edge"
                                            ]
                                        ],
                                        [
                                            /(opera mini)\/([-\w\.]+)/i,
                                            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                                            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
                                        ],
                                        [
                                            d,
                                            g
                                        ],
                                        [
                                            /opios[\/ ]+([\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Opera Mini"
                                            ]
                                        ],
                                        [
                                            /\bopr\/([\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Opera"
                                            ]
                                        ],
                                        [
                                            /(kindle)\/([\w\.]+)/i,
                                            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                                            /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
                                            /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
                                            /(?:ms|\()(ie) ([\w\.]+)/i,
                                            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
                                            /(weibo)__([\d\.]+)/i
                                        ],
                                        [
                                            d,
                                            g
                                        ],
                                        [
                                            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "UCBrowser"
                                            ]
                                        ],
                                        [
                                            /\bqbcore\/([\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "WeChat(Win) Desktop"
                                            ]
                                        ],
                                        [
                                            /micromessenger\/([\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "WeChat"
                                            ]
                                        ],
                                        [
                                            /konqueror\/([\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Konqueror"
                                            ]
                                        ],
                                        [
                                            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "IE"
                                            ]
                                        ],
                                        [
                                            /yabrowser\/([\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Yandex"
                                            ]
                                        ],
                                        [
                                            /(avast|avg)\/([\w\.]+)/i
                                        ],
                                        [
                                            [
                                                d,
                                                /(.+)/,
                                                "$1 Secure Browser"
                                            ],
                                            g
                                        ],
                                        [
                                            /\bfocus\/([\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Firefox Focus"
                                            ]
                                        ],
                                        [
                                            /\bopt\/([\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Opera Touch"
                                            ]
                                        ],
                                        [
                                            /coc_coc\w+\/([\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Coc Coc"
                                            ]
                                        ],
                                        [
                                            /dolfin\/([\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Dolphin"
                                            ]
                                        ],
                                        [
                                            /coast\/([\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Opera Coast"
                                            ]
                                        ],
                                        [
                                            /miuibrowser\/([\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "MIUI Browser"
                                            ]
                                        ],
                                        [
                                            /fxios\/([-\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Firefox"
                                            ]
                                        ],
                                        [
                                            /\bqihu|(qi?ho?o?|360)browser/i
                                        ],
                                        [
                                            [
                                                d,
                                                "360 Browser"
                                            ]
                                        ],
                                        [
                                            /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
                                        ],
                                        [
                                            [
                                                d,
                                                /(.+)/,
                                                "$1 Browser"
                                            ],
                                            g
                                        ],
                                        [
                                            /(comodo_dragon)\/([\w\.]+)/i
                                        ],
                                        [
                                            [
                                                d,
                                                /_/g,
                                                " "
                                            ],
                                            g
                                        ],
                                        [
                                            /(electron)\/([\w\.]+) safari/i,
                                            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                                            /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
                                        ],
                                        [
                                            d,
                                            g
                                        ],
                                        [
                                            /(metasr)[\/ ]?([\w\.]+)/i,
                                            /(lbbrowser)/i
                                        ],
                                        [
                                            d
                                        ],
                                        [
                                            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
                                        ],
                                        [
                                            [
                                                d,
                                                O
                                            ],
                                            g
                                        ],
                                        [
                                            /safari (line)\/([\w\.]+)/i,
                                            /\b(line)\/([\w\.]+)\/iab/i,
                                            /(chromium|instagram)[\/ ]([-\w\.]+)/i
                                        ],
                                        [
                                            d,
                                            g
                                        ],
                                        [
                                            /\bgsa\/([\w\.]+) .*safari\//i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "GSA"
                                            ]
                                        ],
                                        [
                                            /headlesschrome(?:\/([\w\.]+)| )/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Chrome Headless"
                                            ]
                                        ],
                                        [
                                            / wv\).+(chrome)\/([\w\.]+)/i
                                        ],
                                        [
                                            [
                                                d,
                                                "Chrome WebView"
                                            ],
                                            g
                                        ],
                                        [
                                            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Android Browser"
                                            ]
                                        ],
                                        [
                                            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
                                        ],
                                        [
                                            d,
                                            g
                                        ],
                                        [
                                            /version\/([\w\.]+) .*mobile\/\w+ (safari)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Mobile Safari"
                                            ]
                                        ],
                                        [
                                            /version\/([\w\.]+) .*(mobile ?safari|safari)/i
                                        ],
                                        [
                                            g,
                                            d
                                        ],
                                        [
                                            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
                                        ],
                                        [
                                            d,
                                            [
                                                g,
                                                G,
                                                {
                                                    "1.0": "/8",
                                                    1.2: "/1",
                                                    1.3: "/3",
                                                    "2.0": "/412",
                                                    "2.0.2": "/416",
                                                    "2.0.3": "/417",
                                                    "2.0.4": "/419",
                                                    "?": "/"
                                                }
                                            ]
                                        ],
                                        [
                                            /(webkit|khtml)\/([\w\.]+)/i
                                        ],
                                        [
                                            d,
                                            g
                                        ],
                                        [
                                            /(navigator|netscape\d?)\/([-\w\.]+)/i
                                        ],
                                        [
                                            [
                                                d,
                                                "Netscape"
                                            ],
                                            g
                                        ],
                                        [
                                            /mobile vr; rv:([\w\.]+)\).+firefox/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Firefox Reality"
                                            ]
                                        ],
                                        [
                                            /ekiohf.+(flow)\/([\w\.]+)/i,
                                            /(swiftfox)/i,
                                            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                                            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                                            /(firefox)\/([\w\.]+)/i,
                                            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                                            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                                            /(links) \(([\w\.]+)/i
                                        ],
                                        [
                                            d,
                                            g
                                        ]
                                    ],
                                    cpu: [
                                        [
                                            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
                                        ],
                                        [
                                            [
                                                p,
                                                "amd64"
                                            ]
                                        ],
                                        [
                                            /(ia32(?=;))/i
                                        ],
                                        [
                                            [
                                                p,
                                                U
                                            ]
                                        ],
                                        [
                                            /((?:i[346]|x)86)[;\)]/i
                                        ],
                                        [
                                            [
                                                p,
                                                "ia32"
                                            ]
                                        ],
                                        [
                                            /\b(aarch64|arm(v?8e?l?|_?64))\b/i
                                        ],
                                        [
                                            [
                                                p,
                                                "arm64"
                                            ]
                                        ],
                                        [
                                            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
                                        ],
                                        [
                                            [
                                                p,
                                                "armhf"
                                            ]
                                        ],
                                        [
                                            /windows (ce|mobile); ppc;/i
                                        ],
                                        [
                                            [
                                                p,
                                                "arm"
                                            ]
                                        ],
                                        [
                                            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
                                        ],
                                        [
                                            [
                                                p,
                                                /ower/,
                                                "",
                                                U
                                            ]
                                        ],
                                        [
                                            /(sun4\w)[;\)]/i
                                        ],
                                        [
                                            [
                                                p,
                                                "sparc"
                                            ]
                                        ],
                                        [
                                            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                        ],
                                        [
                                            [
                                                p,
                                                U
                                            ]
                                        ]
                                    ],
                                    device: [
                                        [
                                            /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                N
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
                                            /samsung[- ]([-\w]+)/i,
                                            /sec-(sgh\w+)/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                N
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /\((ip(?:hone|od)[\w ]*);/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                _
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /\((ipad);[-\w\),; ]+apple/i,
                                            /applecoremedia\/[\w\.]+ \((ipad)/i,
                                            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                _
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                R
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /(?:huawei|honor)([-\w ]+)[;\)]/i,
                                            /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                R
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /\b(poco[\w ]+)(?: bui|\))/i,
                                            /\b; (\w+) build\/hm\1/i,
                                            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                                            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                                            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
                                        ],
                                        [
                                            [
                                                c,
                                                /_/g,
                                                " "
                                            ],
                                            [
                                                h,
                                                x
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
                                        ],
                                        [
                                            [
                                                c,
                                                /_/g,
                                                " "
                                            ],
                                            [
                                                h,
                                                x
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /; (\w+) bui.+ oppo/i,
                                            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "OPPO"
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /vivo (\w+)(?: bui|\))/i,
                                            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Vivo"
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /\b(rmx[12]\d{3})(?: bui|;|\))/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Realme"
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                                            /\bmot(?:orola)?[- ](\w*)/i,
                                            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                k
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                k
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                C
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                                            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                                            /\blg-?([\d\w]+) bui/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                C
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /(ideatab[-\w ]+)/i,
                                            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Lenovo"
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /(?:maemo|nokia).*(n900|lumia \d+)/i,
                                            /nokia[-_ ]?([-\w\.]*)/i
                                        ],
                                        [
                                            [
                                                c,
                                                /_/g,
                                                " "
                                            ],
                                            [
                                                h,
                                                "Nokia"
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /(pixel c)\b/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                I
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                I
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                L
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /sony tablet [ps]/i,
                                            /\b(?:sony)?sgp\w+(?: bui|\))/i
                                        ],
                                        [
                                            [
                                                c,
                                                "Xperia Tablet"
                                            ],
                                            [
                                                h,
                                                L
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            / (kb2005|in20[12]5|be20[12][59])\b/i,
                                            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "OnePlus"
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /(alexa)webm/i,
                                            /(kf[a-z]{2}wi)( bui|\))/i,
                                            /(kf[a-z]+)( bui|\)).+silk\//i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                A
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
                                        ],
                                        [
                                            [
                                                c,
                                                /(.+)/g,
                                                "Fire Phone $1"
                                            ],
                                            [
                                                h,
                                                A
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /(playbook);[-\w\),; ]+(rim)/i
                                        ],
                                        [
                                            c,
                                            h,
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /\b((?:bb[a-f]|st[hv])100-\d)/i,
                                            /\(bb10; (\w+)/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                w
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                S
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                S
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /(nexus 9)/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "HTC"
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                                            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                                            /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i
                                        ],
                                        [
                                            h,
                                            [
                                                c,
                                                /_/g,
                                                " "
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Acer"
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /droid.+; (m[1-5] note) bui/i,
                                            /\bmz-([-\w]{2,})/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Meizu"
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Sharp"
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                                            /(hp) ([\w ]+\w)/i,
                                            /(asus)-?(\w+)/i,
                                            /(microsoft); (lumia[\w ]+)/i,
                                            /(lenovo)[-_ ]?([-\w]+)/i,
                                            /(jolla)/i,
                                            /(oppo) ?([\w ]+) bui/i
                                        ],
                                        [
                                            h,
                                            c,
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /(archos) (gamepad2?)/i,
                                            /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                                            /(kindle)\/([\w\.]+)/i,
                                            /(nook)[\w ]+build\/(\w+)/i,
                                            /(dell) (strea[kpr\d ]*[\dko])/i,
                                            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                                            /(trinity)[- ]*(t\d{3}) bui/i,
                                            /(gigaset)[- ]+(q\w{1,9}) bui/i,
                                            /(vodafone) ([\w ]+)(?:\)| bui)/i
                                        ],
                                        [
                                            h,
                                            c,
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /(surface duo)/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                D
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /droid [\d\.]+; (fp\du?)(?: b|\))/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Fairphone"
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /(u304aa)/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "AT&T"
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /\bsie-(\w*)/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Siemens"
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /\b(rct\w+) b/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "RCA"
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /\b(venue[\d ]{2,7}) b/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Dell"
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /\b(q(?:mv|ta)\w+) b/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Verizon"
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Barnes & Noble"
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /\b(tm\d{3}\w+) b/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "NuVision"
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /\b(k88) b/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "ZTE"
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /\b(nx\d{3}j) b/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "ZTE"
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /\b(gen\d{3}) b.+49h/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Swiss"
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /\b(zur\d{3}) b/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Swiss"
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /\b((zeki)?tb.*\b) b/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Zeki"
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /\b([yr]\d{2}) b/i,
                                            /\b(dragon[- ]+touch |dt)(\w{5}) b/i
                                        ],
                                        [
                                            [
                                                h,
                                                "Dragon Touch"
                                            ],
                                            c,
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /\b(ns-?\w{0,9}) b/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Insignia"
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /\b((nxa|next)-?\w{0,9}) b/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "NextBook"
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
                                        ],
                                        [
                                            [
                                                h,
                                                "Voice"
                                            ],
                                            c,
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /\b(lvtel\-)?(v1[12]) b/i
                                        ],
                                        [
                                            [
                                                h,
                                                "LvTel"
                                            ],
                                            c,
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /\b(ph-1) /i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Essential"
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /\b(v(100md|700na|7011|917g).*\b) b/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Envizen"
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /\b(trio[-\w\. ]+) b/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "MachSpeed"
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /\btu_(1491) b/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Rotor"
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /(shield[\w ]+) b/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Nvidia"
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /(sprint) (\w+)/i
                                        ],
                                        [
                                            h,
                                            c,
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /(kin\.[onetw]{3})/i
                                        ],
                                        [
                                            [
                                                c,
                                                /\./g,
                                                " "
                                            ],
                                            [
                                                h,
                                                D
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                M
                                            ],
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                M
                                            ],
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /(ouya)/i,
                                            /(nintendo) ([wids3utch]+)/i
                                        ],
                                        [
                                            h,
                                            c,
                                            [
                                                f,
                                                m
                                            ]
                                        ],
                                        [
                                            /droid.+; (shield) bui/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Nvidia"
                                            ],
                                            [
                                                f,
                                                m
                                            ]
                                        ],
                                        [
                                            /(playstation [345portablevi]+)/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                L
                                            ],
                                            [
                                                f,
                                                m
                                            ]
                                        ],
                                        [
                                            /\b(xbox(?: one)?(?!; xbox))[\); ]/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                D
                                            ],
                                            [
                                                f,
                                                m
                                            ]
                                        ],
                                        [
                                            /smart-tv.+(samsung)/i
                                        ],
                                        [
                                            h,
                                            [
                                                f,
                                                E
                                            ]
                                        ],
                                        [
                                            /hbbtv.+maple;(\d+)/i
                                        ],
                                        [
                                            [
                                                c,
                                                /^/,
                                                "SmartTV"
                                            ],
                                            [
                                                h,
                                                N
                                            ],
                                            [
                                                f,
                                                E
                                            ]
                                        ],
                                        [
                                            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
                                        ],
                                        [
                                            [
                                                h,
                                                C
                                            ],
                                            [
                                                f,
                                                E
                                            ]
                                        ],
                                        [
                                            /(apple) ?tv/i
                                        ],
                                        [
                                            h,
                                            [
                                                c,
                                                "Apple TV"
                                            ],
                                            [
                                                f,
                                                E
                                            ]
                                        ],
                                        [
                                            /crkey/i
                                        ],
                                        [
                                            [
                                                c,
                                                "Chromecast"
                                            ],
                                            [
                                                h,
                                                I
                                            ],
                                            [
                                                f,
                                                E
                                            ]
                                        ],
                                        [
                                            /droid.+aft(\w)( bui|\))/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                A
                                            ],
                                            [
                                                f,
                                                E
                                            ]
                                        ],
                                        [
                                            /\(dtv[\);].+(aquos)/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Sharp"
                                            ],
                                            [
                                                f,
                                                E
                                            ]
                                        ],
                                        [
                                            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                                            /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i
                                        ],
                                        [
                                            [
                                                h,
                                                j
                                            ],
                                            [
                                                c,
                                                j
                                            ],
                                            [
                                                f,
                                                E
                                            ]
                                        ],
                                        [
                                            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
                                        ],
                                        [
                                            [
                                                f,
                                                E
                                            ]
                                        ],
                                        [
                                            /((pebble))app/i
                                        ],
                                        [
                                            h,
                                            c,
                                            [
                                                f,
                                                T
                                            ]
                                        ],
                                        [
                                            /droid.+; (glass) \d/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                I
                                            ],
                                            [
                                                f,
                                                T
                                            ]
                                        ],
                                        [
                                            /droid.+; (wt63?0{2,3})\)/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                M
                                            ],
                                            [
                                                f,
                                                T
                                            ]
                                        ],
                                        [
                                            /(quest( 2)?)/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                O
                                            ],
                                            [
                                                f,
                                                T
                                            ]
                                        ],
                                        [
                                            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
                                        ],
                                        [
                                            h,
                                            [
                                                f,
                                                b
                                            ]
                                        ],
                                        [
                                            /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
                                        ],
                                        [
                                            c,
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
                                        ],
                                        [
                                            c,
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
                                        ],
                                        [
                                            [
                                                f,
                                                y
                                            ]
                                        ],
                                        [
                                            /(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i
                                        ],
                                        [
                                            [
                                                f,
                                                v
                                            ]
                                        ],
                                        [
                                            /(android[-\w\. ]{0,9});.+buil/i
                                        ],
                                        [
                                            c,
                                            [
                                                h,
                                                "Generic"
                                            ]
                                        ]
                                    ],
                                    engine: [
                                        [
                                            /windows.+ edge\/([\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "EdgeHTML"
                                            ]
                                        ],
                                        [
                                            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Blink"
                                            ]
                                        ],
                                        [
                                            /(presto)\/([\w\.]+)/i,
                                            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                                            /ekioh(flow)\/([\w\.]+)/i,
                                            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                                            /(icab)[\/ ]([23]\.[\d\.]+)/i
                                        ],
                                        [
                                            d,
                                            g
                                        ],
                                        [
                                            /rv\:([\w\.]{1,9})\b.+(gecko)/i
                                        ],
                                        [
                                            g,
                                            d
                                        ]
                                    ],
                                    os: [
                                        [
                                            /microsoft (windows) (vista|xp)/i
                                        ],
                                        [
                                            d,
                                            g
                                        ],
                                        [
                                            /(windows) nt 6\.2; (arm)/i,
                                            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
                                            /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
                                        ],
                                        [
                                            d,
                                            [
                                                g,
                                                G,
                                                H
                                            ]
                                        ],
                                        [
                                            /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
                                        ],
                                        [
                                            [
                                                d,
                                                "Windows"
                                            ],
                                            [
                                                g,
                                                G,
                                                H
                                            ]
                                        ],
                                        [
                                            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                                            /cfnetwork\/.+darwin/i
                                        ],
                                        [
                                            [
                                                g,
                                                /_/g,
                                                "."
                                            ],
                                            [
                                                d,
                                                "iOS"
                                            ]
                                        ],
                                        [
                                            /(mac os x) ?([\w\. ]*)/i,
                                            /(macintosh|mac_powerpc\b)(?!.+haiku)/i
                                        ],
                                        [
                                            [
                                                d,
                                                "Mac OS"
                                            ],
                                            [
                                                g,
                                                /_/g,
                                                "."
                                            ]
                                        ],
                                        [
                                            /droid ([\w\.]+)\b.+(android[- ]x86)/i
                                        ],
                                        [
                                            g,
                                            d
                                        ],
                                        [
                                            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                                            /(blackberry)\w*\/([\w\.]*)/i,
                                            /(tizen|kaios)[\/ ]([\w\.]+)/i,
                                            /\((series40);/i
                                        ],
                                        [
                                            d,
                                            g
                                        ],
                                        [
                                            /\(bb(10);/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                w
                                            ]
                                        ],
                                        [
                                            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Symbian"
                                            ]
                                        ],
                                        [
                                            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Firefox OS"
                                            ]
                                        ],
                                        [
                                            /web0s;.+rt(tv)/i,
                                            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "webOS"
                                            ]
                                        ],
                                        [
                                            /crkey\/([\d\.]+)/i
                                        ],
                                        [
                                            g,
                                            [
                                                d,
                                                "Chromecast"
                                            ]
                                        ],
                                        [
                                            /(cros) [\w]+ ([\w\.]+\w)/i
                                        ],
                                        [
                                            [
                                                d,
                                                "Chromium OS"
                                            ],
                                            g
                                        ],
                                        [
                                            /(nintendo|playstation) ([wids345portablevuch]+)/i,
                                            /(xbox); +xbox ([^\);]+)/i,
                                            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                                            /(mint)[\/\(\) ]?(\w*)/i,
                                            /(mageia|vectorlinux)[; ]/i,
                                            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                                            /(hurd|linux) ?([\w\.]*)/i,
                                            /(gnu) ?([\w\.]*)/i,
                                            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                                            /(haiku) (\w+)/i
                                        ],
                                        [
                                            d,
                                            g
                                        ],
                                        [
                                            /(sunos) ?([\w\.\d]*)/i
                                        ],
                                        [
                                            [
                                                d,
                                                "Solaris"
                                            ],
                                            g
                                        ],
                                        [
                                            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                                            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                                            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
                                            /(unix) ?([\w\.]*)/i
                                        ],
                                        [
                                            d,
                                            g
                                        ]
                                    ]
                                }, K = function(e, t) {
                                    if (typeof e === u && (t = e, e = a1), !(this instanceof K)) return new K(e, t).getResult();
                                    var n = e || (typeof i !== s1 && i.navigator && i.navigator.userAgent ? i.navigator.userAgent : ""), r = t ? function(e, t) {
                                        var n = {};
                                        for(var r in e)t[r] && t[r].length % 2 == 0 ? n[r] = t[r].concat(e[r]) : n[r] = e[r];
                                        return n;
                                    }(V, t) : V;
                                    return this.getBrowser = function() {
                                        var e, t = {};
                                        return t.name = a1, t.version = a1, B.call(t, n, r.browser), t.major = typeof (e = t.version) === l ? e.replace(/[^\d\.]/g, "").split(".")[0] : a1, t;
                                    }, this.getCPU = function() {
                                        var e = {};
                                        return e.architecture = a1, B.call(e, n, r.cpu), e;
                                    }, this.getDevice = function() {
                                        var e = {};
                                        return e.vendor = a1, e.model = a1, e.type = a1, B.call(e, n, r.device), e;
                                    }, this.getEngine = function() {
                                        var e = {};
                                        return e.name = a1, e.version = a1, B.call(e, n, r.engine), e;
                                    }, this.getOS = function() {
                                        var e = {};
                                        return e.name = a1, e.version = a1, B.call(e, n, r.os), e;
                                    }, this.getResult = function() {
                                        return {
                                            ua: this.getUA(),
                                            browser: this.getBrowser(),
                                            engine: this.getEngine(),
                                            os: this.getOS(),
                                            device: this.getDevice(),
                                            cpu: this.getCPU()
                                        };
                                    }, this.getUA = function() {
                                        return n;
                                    }, this.setUA = function(e) {
                                        return n = typeof e === l && e.length > 255 ? j(e, 255) : e, this;
                                    }, this.setUA(n), this;
                                };
                                K.VERSION = "1.0.2", K.BROWSER = P([
                                    d,
                                    g,
                                    "major"
                                ]), K.CPU = P([
                                    p
                                ]), K.DEVICE = P([
                                    c,
                                    h,
                                    f,
                                    m,
                                    v,
                                    E,
                                    y,
                                    T,
                                    b
                                ]), K.ENGINE = K.OS = P([
                                    d,
                                    g
                                ]), typeof t !== s1 ? (typeof e !== s1 && e.exports && (t = e.exports = K), t.UAParser = K) : n("./node_modules/webpack/buildin/amd-options.js") ? (r = (function() {
                                    return K;
                                }).call(t, n, t, e)) === a1 || (e.exports = r) : typeof i !== s1 && (i.UAParser = K);
                                var q = typeof i !== s1 && (i.jQuery || i.Zepto);
                                if (q && !q.ua) {
                                    var Y = new K;
                                    q.ua = Y.getResult(), q.ua.get = function() {
                                        return Y.getUA();
                                    }, q.ua.set = function(e) {
                                        Y.setUA(e);
                                        var t = Y.getResult();
                                        for(var n in t)q.ua[n] = t[n];
                                    };
                                }
                            }("object" == typeof window ? window : this);
                        },
                        "./node_modules/util-deprecate/browser.js": function(e, t, n) {
                            (function(t) {
                                function n(e) {
                                    try {
                                        if (!t.localStorage) return !1;
                                    } catch (e) {
                                        return !1;
                                    }
                                    var n = t.localStorage[e];
                                    return null != n && "true" === String(n).toLowerCase();
                                }
                                e.exports = function(e, t) {
                                    if (n("noDeprecation")) return e;
                                    var r = !1;
                                    return function() {
                                        if (!r) {
                                            if (n("throwDeprecation")) throw new Error(t);
                                            n("traceDeprecation") ? console.trace(t) : console.warn(t), r = !0;
                                        }
                                        return e.apply(this, arguments);
                                    };
                                };
                            }).call(this, n("./node_modules/webpack/buildin/global.js"));
                        },
                        "./node_modules/webpack/buildin/amd-options.js": function(e, t) {
                            (function(t) {
                                e.exports = t;
                            }).call(this, {});
                        },
                        "./node_modules/webpack/buildin/global.js": function(e, t) {
                            var n;
                            n = function() {
                                return this;
                            }();
                            try {
                                n = n || new Function("return this")();
                            } catch (e) {
                                "object" == typeof window && (n = window);
                            }
                            e.exports = n;
                        },
                        "./src/core/Debug.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/EventBus.js"), i = n("./src/core/events/Events.js"), a1 = n("./src/core/FactoryMaker.js"), o = 1, s1 = 2, u = 3, l = 4, c = 5;
                            function d(e) {
                                e = e || {};
                                var t, n, a1, d, f = this.context, h = Object(r.default)(f).getInstance(), g = e.settings, p = [];
                                function m(e) {
                                    return e && e.bind ? e.bind(window.console) : window.console.log.bind(window.console);
                                }
                                function v() {
                                    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
                                    A.apply(void 0, [
                                        o,
                                        this
                                    ].concat(t));
                                }
                                function y() {
                                    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
                                    A.apply(void 0, [
                                        s1,
                                        this
                                    ].concat(t));
                                }
                                function E() {
                                    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
                                    A.apply(void 0, [
                                        u,
                                        this
                                    ].concat(t));
                                }
                                function T() {
                                    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
                                    A.apply(void 0, [
                                        l,
                                        this
                                    ].concat(t));
                                }
                                function b() {
                                    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
                                    A.apply(void 0, [
                                        c,
                                        this
                                    ].concat(t));
                                }
                                function A(e, t) {
                                    var r = "", o = null;
                                    n && (o = (new Date).getTime(), r += "[" + (o - d) + "]"), a1 && t && t.getClassName && (r += "[" + t.getClassName() + "]", t.getType && (r += "[" + t.getType() + "]")), r.length > 0 && (r += " ");
                                    for(var s1 = arguments.length, u = new Array(s1 > 2 ? s1 - 2 : 0), l = 2; l < s1; l++)u[l - 2] = arguments[l];
                                    Array.apply(null, u).forEach(function(e) {
                                        r += e + " ";
                                    }), p[e] && g.get().debug.logLevel >= e && p[e](r), g && g.get().debug.dispatchEvent && h.trigger(i.default.LOG, {
                                        message: r,
                                        level: e
                                    });
                                }
                                return t = {
                                    getLogger: function(e) {
                                        return {
                                            fatal: v.bind(e),
                                            error: y.bind(e),
                                            warn: E.bind(e),
                                            info: T.bind(e),
                                            debug: b.bind(e)
                                        };
                                    },
                                    setLogTimestampVisible: function(e) {
                                        n = e;
                                    },
                                    setCalleeNameVisible: function(e) {
                                        a1 = e;
                                    }
                                }, n = !0, a1 = !0, d = (new Date).getTime(), "undefined" != typeof window && window.console && (p[o] = m(window.console.error), p[s1] = m(window.console.error), p[u] = m(window.console.warn), p[l] = m(window.console.info), p[c] = m(window.console.debug)), t;
                            }
                            d.__dashjs_factory_name = "Debug";
                            var f = a1.default.getSingletonFactory(d);
                            f.LOG_LEVEL_NONE = 0, f.LOG_LEVEL_FATAL = o, f.LOG_LEVEL_ERROR = s1, f.LOG_LEVEL_WARNING = u, f.LOG_LEVEL_INFO = l, f.LOG_LEVEL_DEBUG = c, a1.default.updateSingletonFactory(d.__dashjs_factory_name, f), t.default = f;
                        },
                        "./src/core/EventBus.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/streaming/MediaPlayerEvents.js");
                            function a1() {
                                var e = {};
                                function t(t, n, r) {
                                    var i = -1;
                                    return e[t] ? (e[t].some(function(e, t) {
                                        if (e && e.callback === n && (!r || r === e.scope)) return i = t, !0;
                                    }), i) : i;
                                }
                                var n = {
                                    on: function(n, r, i) {
                                        var a1 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
                                        if (!n) throw new Error("event type cannot be null or undefined");
                                        if (!r || "function" != typeof r) throw new Error("listener must be a function: " + r);
                                        var o = a1.priority || 0;
                                        if (!(t(n, r, i) >= 0)) {
                                            e[n] = e[n] || [];
                                            var s1 = {
                                                callback: r,
                                                scope: i,
                                                priority: o
                                            };
                                            i && i.getStreamId && (s1.streamId = i.getStreamId()), i && i.getType && (s1.mediaType = i.getType()), a1 && a1.mode && (s1.mode = a1.mode);
                                            var u = e[n].some(function(t, r) {
                                                if (t && o > t.priority) return e[n].splice(r, 0, s1), !0;
                                            });
                                            u || e[n].push(s1);
                                        }
                                    },
                                    off: function(n, r, i) {
                                        if (n && r && e[n]) {
                                            var a1 = t(n, r, i);
                                            a1 < 0 || (e[n][a1] = null);
                                        }
                                    },
                                    trigger: function(t) {
                                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                                        if (t && e[t]) {
                                            if ((n = n || {}).hasOwnProperty("type")) throw new Error("'type' is a reserved word for event dispatching");
                                            n.type = t, r.streamId && (n.streamId = r.streamId), r.mediaType && (n.mediaType = r.mediaType), e[t].filter(function(e) {
                                                return !(!e || r.streamId && e.streamId && e.streamId !== r.streamId || r.mediaType && e.mediaType && e.mediaType !== r.mediaType || r.mode && e.mode && e.mode !== r.mode || !e.mode && r.mode && r.mode === i.default.EVENT_MODE_ON_RECEIVE);
                                            }).forEach(function(e) {
                                                return e && e.callback.call(e.scope, n);
                                            });
                                        }
                                    },
                                    reset: function() {
                                        e = {};
                                    }
                                };
                                return n;
                            }
                            a1.__dashjs_factory_name = "EventBus";
                            var o = r.default.getSingletonFactory(a1);
                            o.EVENT_PRIORITY_LOW = 0, o.EVENT_PRIORITY_HIGH = 5e3, r.default.updateSingletonFactory(a1.__dashjs_factory_name, o), t.default = o;
                        },
                        "./src/core/FactoryMaker.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = function() {
                                var e, t = [], n = {}, r = {};
                                function i(e, n) {
                                    for(var r in t){
                                        var i = t[r];
                                        if (i.context === e && i.name === n) return i.instance;
                                    }
                                    return null;
                                }
                                function a1(e, t) {
                                    return t[e];
                                }
                                function o(e, t, n) {
                                    e in n && (n[e] = t);
                                }
                                function s1(t, n, r) {
                                    var i, a1 = t.__dashjs_factory_name, o = n[a1];
                                    if (o) {
                                        var s1 = o.instance;
                                        if (!o.override) return s1.apply({
                                            context: n,
                                            factory: e
                                        }, r);
                                        for(var u in i = t.apply({
                                            context: n
                                        }, r), s1 = s1.apply({
                                            context: n,
                                            factory: e,
                                            parent: i
                                        }, r))i.hasOwnProperty(u) && (i[u] = s1[u]);
                                    } else i = t.apply({
                                        context: n
                                    }, r);
                                    return i.getClassName = function() {
                                        return a1;
                                    }, i;
                                }
                                return e = {
                                    extend: function(e, t, n, r) {
                                        !r[e] && t && (r[e] = {
                                            instance: t,
                                            override: n
                                        });
                                    },
                                    getSingletonInstance: i,
                                    setSingletonInstance: function(e, n, r) {
                                        for(var i in t){
                                            var a1 = t[i];
                                            if (a1.context === e && a1.name === n) return void (t[i].instance = r);
                                        }
                                        t.push({
                                            name: n,
                                            context: e,
                                            instance: r
                                        });
                                    },
                                    deleteSingletonInstances: function(e) {
                                        t = t.filter(function(t) {
                                            return t.context !== e;
                                        });
                                    },
                                    getSingletonFactory: function(e) {
                                        var r = a1(e.__dashjs_factory_name, n);
                                        return r || (r = function(n) {
                                            var r;
                                            return void 0 === n && (n = {}), {
                                                getInstance: function() {
                                                    return r || (r = i(n, e.__dashjs_factory_name)), r || (r = s1(e, n, arguments), t.push({
                                                        name: e.__dashjs_factory_name,
                                                        context: n,
                                                        instance: r
                                                    })), r;
                                                }
                                            };
                                        }, n[e.__dashjs_factory_name] = r), r;
                                    },
                                    getSingletonFactoryByName: function(e) {
                                        return a1(e, n);
                                    },
                                    updateSingletonFactory: function(e, t) {
                                        o(e, t, n);
                                    },
                                    getClassFactory: function(e) {
                                        var t = a1(e.__dashjs_factory_name, r);
                                        return t || (t = function(t) {
                                            return void 0 === t && (t = {}), {
                                                create: function() {
                                                    return s1(e, t, arguments);
                                                }
                                            };
                                        }, r[e.__dashjs_factory_name] = t), t;
                                    },
                                    getClassFactoryByName: function(e) {
                                        return a1(e, r);
                                    },
                                    updateClassFactory: function(e, t) {
                                        o(e, t, r);
                                    }
                                }, e;
                            }();
                            t.default = r;
                        },
                        "./src/core/Settings.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/core/Utils.js"), a1 = n("./src/core/Debug.js"), o = n("./src/streaming/constants/Constants.js"), s1 = n("./src/streaming/vo/metrics/HTTPRequest.js"), u = n("./src/core/EventBus.js"), l = n("./src/core/events/Events.js");
                            function c(e) {
                                return c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, c(e);
                            }
                            function d(e, t, n) {
                                return t in e ? Object.defineProperty(e, t, {
                                    value: n,
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0
                                }) : e[t] = n, e;
                            }
                            function f() {
                                var e, t, n = this.context, r = Object(u.default)(n).getInstance(), f = {
                                    "streaming.delay.liveDelay": l.default.SETTING_UPDATED_LIVE_DELAY,
                                    "streaming.delay.liveDelayFragmentCount": l.default.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT,
                                    "streaming.liveCatchup.enabled": l.default.SETTING_UPDATED_CATCHUP_ENABLED,
                                    "streaming.liveCatchup.playbackRate.min": l.default.SETTING_UPDATED_PLAYBACK_RATE_MIN,
                                    "streaming.liveCatchup.playbackRate.max": l.default.SETTING_UPDATED_PLAYBACK_RATE_MAX
                                }, h = {
                                    debug: {
                                        logLevel: a1.default.LOG_LEVEL_WARNING,
                                        dispatchEvent: !1
                                    },
                                    streaming: {
                                        abandonLoadTimeout: 1e4,
                                        wallclockTimeUpdateInterval: 100,
                                        manifestUpdateRetryInterval: 100,
                                        cacheInitSegments: !1,
                                        applyServiceDescription: !0,
                                        applyProducerReferenceTime: !0,
                                        applyContentSteering: !0,
                                        eventControllerRefreshDelay: 100,
                                        enableManifestDurationMismatchFix: !0,
                                        capabilities: {
                                            filterUnsupportedEssentialProperties: !0,
                                            useMediaCapabilitiesApi: !1
                                        },
                                        timeShiftBuffer: {
                                            calcFromSegmentTimeline: !1,
                                            fallbackToSegmentTimeline: !0
                                        },
                                        metrics: {
                                            maxListDepth: 100
                                        },
                                        delay: {
                                            liveDelayFragmentCount: NaN,
                                            liveDelay: NaN,
                                            useSuggestedPresentationDelay: !0
                                        },
                                        protection: {
                                            keepProtectionMediaKeys: !1,
                                            ignoreEmeEncryptedEvent: !1,
                                            detectPlayreadyMessageFormat: !0
                                        },
                                        buffer: {
                                            enableSeekDecorrelationFix: !1,
                                            fastSwitchEnabled: !0,
                                            flushBufferAtTrackSwitch: !1,
                                            reuseExistingSourceBuffers: !0,
                                            bufferPruningInterval: 10,
                                            bufferToKeep: 20,
                                            bufferTimeAtTopQuality: 30,
                                            bufferTimeAtTopQualityLongForm: 60,
                                            initialBufferLevel: NaN,
                                            stableBufferTime: 12,
                                            longFormContentDurationThreshold: 600,
                                            stallThreshold: .3,
                                            useAppendWindow: !0,
                                            setStallState: !0,
                                            avoidCurrentTimeRangePruning: !1,
                                            useChangeTypeForTrackSwitch: !0
                                        },
                                        gaps: {
                                            jumpGaps: !0,
                                            jumpLargeGaps: !0,
                                            smallGapLimit: 1.5,
                                            threshold: .3,
                                            enableSeekFix: !0,
                                            enableStallFix: !1,
                                            stallSeek: .1
                                        },
                                        utcSynchronization: {
                                            enabled: !0,
                                            useManifestDateHeaderTimeSource: !0,
                                            backgroundAttempts: 2,
                                            timeBetweenSyncAttempts: 30,
                                            maximumTimeBetweenSyncAttempts: 600,
                                            minimumTimeBetweenSyncAttempts: 2,
                                            timeBetweenSyncAttemptsAdjustmentFactor: 2,
                                            maximumAllowedDrift: 100,
                                            enableBackgroundSyncAfterSegmentDownloadError: !0,
                                            defaultTimingSource: {
                                                scheme: "urn:mpeg:dash:utc:http-xsdate:2014",
                                                value: "https://time.akamai.com/?iso&ms"
                                            }
                                        },
                                        scheduling: {
                                            defaultTimeout: 500,
                                            lowLatencyTimeout: 0,
                                            scheduleWhilePaused: !0
                                        },
                                        text: {
                                            defaultEnabled: !0
                                        },
                                        liveCatchup: {
                                            maxDrift: NaN,
                                            playbackRate: {
                                                min: NaN,
                                                max: NaN
                                            },
                                            playbackBufferMin: .5,
                                            enabled: null,
                                            mode: o.default.LIVE_CATCHUP_MODE_DEFAULT
                                        },
                                        lastBitrateCachingInfo: {
                                            enabled: !0,
                                            ttl: 36e4
                                        },
                                        lastMediaSettingsCachingInfo: {
                                            enabled: !0,
                                            ttl: 36e4
                                        },
                                        cacheLoadThresholds: {
                                            video: 50,
                                            audio: 5
                                        },
                                        trackSwitchMode: {
                                            audio: o.default.TRACK_SWITCH_MODE_ALWAYS_REPLACE,
                                            video: o.default.TRACK_SWITCH_MODE_NEVER_REPLACE
                                        },
                                        selectionModeForInitialTrack: o.default.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY,
                                        fragmentRequestTimeout: 2e4,
                                        manifestRequestTimeout: 1e4,
                                        retryIntervals: (e = {}, d(e, s1.HTTPRequest.MPD_TYPE, 500), d(e, s1.HTTPRequest.XLINK_EXPANSION_TYPE, 500), d(e, s1.HTTPRequest.MEDIA_SEGMENT_TYPE, 1e3), d(e, s1.HTTPRequest.INIT_SEGMENT_TYPE, 1e3), d(e, s1.HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE, 1e3), d(e, s1.HTTPRequest.INDEX_SEGMENT_TYPE, 1e3), d(e, s1.HTTPRequest.MSS_FRAGMENT_INFO_SEGMENT_TYPE, 1e3), d(e, s1.HTTPRequest.LICENSE, 1e3), d(e, s1.HTTPRequest.OTHER_TYPE, 1e3), d(e, "lowLatencyReductionFactor", 10), e),
                                        retryAttempts: (t = {}, d(t, s1.HTTPRequest.MPD_TYPE, 3), d(t, s1.HTTPRequest.XLINK_EXPANSION_TYPE, 1), d(t, s1.HTTPRequest.MEDIA_SEGMENT_TYPE, 3), d(t, s1.HTTPRequest.INIT_SEGMENT_TYPE, 3), d(t, s1.HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE, 3), d(t, s1.HTTPRequest.INDEX_SEGMENT_TYPE, 3), d(t, s1.HTTPRequest.MSS_FRAGMENT_INFO_SEGMENT_TYPE, 3), d(t, s1.HTTPRequest.LICENSE, 3), d(t, s1.HTTPRequest.OTHER_TYPE, 3), d(t, "lowLatencyMultiplyFactor", 5), t),
                                        abr: {
                                            movingAverageMethod: o.default.MOVING_AVERAGE_SLIDING_WINDOW,
                                            ABRStrategy: o.default.ABR_STRATEGY_DYNAMIC,
                                            additionalAbrRules: {
                                                insufficientBufferRule: !0,
                                                switchHistoryRule: !0,
                                                droppedFramesRule: !0,
                                                abandonRequestsRule: !0
                                            },
                                            bandwidthSafetyFactor: .9,
                                            useDefaultABRRules: !0,
                                            useDeadTimeLatency: !0,
                                            limitBitrateByPortal: !1,
                                            usePixelRatioInLimitBitrateByPortal: !1,
                                            maxBitrate: {
                                                audio: -1,
                                                video: -1
                                            },
                                            minBitrate: {
                                                audio: -1,
                                                video: -1
                                            },
                                            maxRepresentationRatio: {
                                                audio: 1,
                                                video: 1
                                            },
                                            initialBitrate: {
                                                audio: -1,
                                                video: -1
                                            },
                                            initialRepresentationRatio: {
                                                audio: -1,
                                                video: -1
                                            },
                                            autoSwitchBitrate: {
                                                audio: !0,
                                                video: !0
                                            },
                                            fetchThroughputCalculationMode: o.default.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING
                                        },
                                        cmcd: {
                                            enabled: !1,
                                            sid: null,
                                            cid: null,
                                            rtp: null,
                                            rtpSafetyFactor: 5,
                                            mode: o.default.CMCD_MODE_QUERY,
                                            enabledKeys: [
                                                "br",
                                                "d",
                                                "ot",
                                                "tb",
                                                "bl",
                                                "dl",
                                                "mtp",
                                                "nor",
                                                "nrr",
                                                "su",
                                                "bs",
                                                "rtp",
                                                "cid",
                                                "pr",
                                                "sf",
                                                "sid",
                                                "st",
                                                "v"
                                            ]
                                        }
                                    },
                                    errors: {
                                        recoverAttempts: {
                                            mediaErrorDecode: 5
                                        }
                                    }
                                }, g = i.default.clone(h);
                                function p(e, t, n) {
                                    for(var a1 in e)e.hasOwnProperty(a1) && (t.hasOwnProperty(a1) ? "object" !== c(e[a1]) || e[a1] instanceof Array || null === e[a1] ? (t[a1] = i.default.clone(e[a1]), f[n + a1] && r.trigger(f[n + a1])) : p(e[a1], t[a1], n.slice() + a1 + ".") : console.error("Settings parameter " + n + a1 + " is not supported"));
                                }
                                return {
                                    get: function() {
                                        return g;
                                    },
                                    update: function(e) {
                                        "object" === c(e) && p(e, g, "");
                                    },
                                    reset: function() {
                                        g = i.default.clone(h);
                                    }
                                };
                            }
                            f.__dashjs_factory_name = "Settings";
                            var h = r.default.getSingletonFactory(f);
                            t.default = h;
                        },
                        "./src/core/Utils.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./node_modules/path-browserify/index.js"), i = n.n(r), a1 = n("./node_modules/ua-parser-js/src/ua-parser.js");
                            function o(e) {
                                return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, o(e);
                            }
                            function s1(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            var u = function() {
                                function e() {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e);
                                }
                                var t, n;
                                return t = e, n = [
                                    {
                                        key: "mixin",
                                        value: function(t, n, r) {
                                            var i, a1 = {};
                                            if (t) for(var s1 in n)n.hasOwnProperty(s1) && (i = n[s1], s1 in t && (t[s1] === i || s1 in a1 && a1[s1] === i) || ("object" === o(t[s1]) && null !== t[s1] ? t[s1] = e.mixin(t[s1], i, r) : t[s1] = r(i)));
                                            return t;
                                        }
                                    },
                                    {
                                        key: "clone",
                                        value: function(t) {
                                            if (!t || "object" !== o(t)) return t;
                                            var n;
                                            if (t instanceof Array) {
                                                n = [];
                                                for(var r = 0, i = t.length; r < i; ++r)r in t && n.push(e.clone(t[r]));
                                            } else n = {};
                                            return e.mixin(n, t, e.clone);
                                        }
                                    },
                                    {
                                        key: "addAditionalQueryParameterToUrl",
                                        value: function(e, t) {
                                            try {
                                                if (!t || 0 === t.length) return e;
                                                var n = new URL(e);
                                                return t.forEach(function(e) {
                                                    e.key && e.value && n.searchParams.set(e.key, e.value);
                                                }), n.href;
                                            } catch (t) {
                                                return e;
                                            }
                                        }
                                    },
                                    {
                                        key: "parseHttpHeaders",
                                        value: function(e) {
                                            var t = {};
                                            if (!e) return t;
                                            for(var n = e.trim().split("\r\n"), r = 0, i = n.length; r < i; r++){
                                                var a1 = n[r], o = a1.indexOf(": ");
                                                o > 0 && (t[a1.substring(0, o)] = a1.substring(o + 2));
                                            }
                                            return t;
                                        }
                                    },
                                    {
                                        key: "generateUuid",
                                        value: function() {
                                            var e = (new Date).getTime();
                                            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
                                                var n = (e + 16 * Math.random()) % 16 | 0;
                                                return e = Math.floor(e / 16), ("x" == t ? n : 3 & n | 8).toString(16);
                                            });
                                        }
                                    },
                                    {
                                        key: "generateHashCode",
                                        value: function(e) {
                                            var t = 0;
                                            if (0 === e.length) return t;
                                            for(var n = 0; n < e.length; n++)t = (t << 5) - t + e.charCodeAt(n), t |= 0;
                                            return t;
                                        }
                                    },
                                    {
                                        key: "getRelativeUrl",
                                        value: function(e, t) {
                                            try {
                                                var n = new URL(e), r = new URL(t);
                                                if (n.protocol = r.protocol, n.origin !== r.origin) return t;
                                                var a1 = i.a.relative(n.pathname.substr(0, n.pathname.lastIndexOf("/")), r.pathname.substr(0, r.pathname.lastIndexOf("/"))), o = 0 === a1.length ? 1 : 0;
                                                return a1 += r.pathname.substr(r.pathname.lastIndexOf("/") + o, r.pathname.length - 1), r.pathname.length < a1.length ? r.pathname : a1;
                                            } catch (e) {
                                                return t;
                                            }
                                        }
                                    },
                                    {
                                        key: "parseUserAgent",
                                        value: function() {
                                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                                            try {
                                                var t = null === e && "undefined" != typeof navigator ? navigator.userAgent.toLowerCase() : "";
                                                return Object(a1.UAParser)(t);
                                            } catch (e) {
                                                return {};
                                            }
                                        }
                                    }
                                ], n && s1(t, n), e;
                            }();
                            t.default = u;
                        },
                        "./src/core/Version.js": function(e, t, n) {
                            "use strict";
                            function r() {
                                return "4.5.1";
                            }
                            n.r(t), n.d(t, "getVersionString", function() {
                                return r;
                            });
                        },
                        "./src/core/errors/Errors.js": function(e, t, n) {
                            "use strict";
                            function r(e) {
                                return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, r(e);
                            }
                            function i(e, t) {
                                return i = Object.setPrototypeOf || function(e, t) {
                                    return e.__proto__ = t, e;
                                }, i(e, t);
                            }
                            function a1(e, t) {
                                return !t || "object" !== r(t) && "function" != typeof t ? function(e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e;
                                }(e) : t;
                            }
                            function o(e) {
                                return o = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                                    return e.__proto__ || Object.getPrototypeOf(e);
                                }, o(e);
                            }
                            n.r(t);
                            var s1 = new (function(e) {
                                !function(e, t) {
                                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                    e.prototype = Object.create(t && t.prototype, {
                                        constructor: {
                                            value: e,
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }), t && i(e, t);
                                }(s1, e);
                                var t, n, r = (t = s1, n = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e, r = o(t);
                                    if (n) {
                                        var i = o(this).constructor;
                                        e = Reflect.construct(r, arguments, i);
                                    } else e = r.apply(this, arguments);
                                    return a1(this, e);
                                });
                                function s1() {
                                    var e;
                                    return function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, s1), (e = r.call(this)).MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE = 10, e.MANIFEST_LOADER_LOADING_FAILURE_ERROR_CODE = 11, e.XLINK_LOADER_LOADING_FAILURE_ERROR_CODE = 12, e.SEGMENT_BASE_LOADER_ERROR_CODE = 15, e.TIME_SYNC_FAILED_ERROR_CODE = 16, e.FRAGMENT_LOADER_LOADING_FAILURE_ERROR_CODE = 17, e.FRAGMENT_LOADER_NULL_REQUEST_ERROR_CODE = 18, e.URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE = 19, e.APPEND_ERROR_CODE = 20, e.REMOVE_ERROR_CODE = 21, e.DATA_UPDATE_FAILED_ERROR_CODE = 22, e.CAPABILITY_MEDIASOURCE_ERROR_CODE = 23, e.CAPABILITY_MEDIAKEYS_ERROR_CODE = 24, e.DOWNLOAD_ERROR_ID_MANIFEST_CODE = 25, e.DOWNLOAD_ERROR_ID_SIDX_CODE = 26, e.DOWNLOAD_ERROR_ID_CONTENT_CODE = 27, e.DOWNLOAD_ERROR_ID_INITIALIZATION_CODE = 28, e.DOWNLOAD_ERROR_ID_XLINK_CODE = 29, e.MANIFEST_ERROR_ID_PARSE_CODE = 31, e.MANIFEST_ERROR_ID_NOSTREAMS_CODE = 32, e.TIMED_TEXT_ERROR_ID_PARSE_CODE = 33, e.MANIFEST_ERROR_ID_MULTIPLEXED_CODE = 34, e.MEDIASOURCE_TYPE_UNSUPPORTED_CODE = 35, e.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE = "parsing failed for ", e.MANIFEST_LOADER_LOADING_FAILURE_ERROR_MESSAGE = "Failed loading manifest: ", e.XLINK_LOADER_LOADING_FAILURE_ERROR_MESSAGE = "Failed loading Xlink element: ", e.SEGMENTS_UPDATE_FAILED_ERROR_MESSAGE = "Segments update failed", e.SEGMENTS_UNAVAILABLE_ERROR_MESSAGE = "no segments are available yet", e.SEGMENT_BASE_LOADER_ERROR_MESSAGE = "error loading segment ranges from sidx", e.TIME_SYNC_FAILED_ERROR_MESSAGE = "Failed to synchronize client and server time", e.FRAGMENT_LOADER_NULL_REQUEST_ERROR_MESSAGE = "request is null", e.URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE = "Failed to resolve a valid URL", e.APPEND_ERROR_MESSAGE = "chunk is not defined", e.REMOVE_ERROR_MESSAGE = "Removing data from the SourceBuffer", e.DATA_UPDATE_FAILED_ERROR_MESSAGE = "Data update failed", e.CAPABILITY_MEDIASOURCE_ERROR_MESSAGE = "mediasource is not supported", e.CAPABILITY_MEDIAKEYS_ERROR_MESSAGE = "mediakeys is not supported", e.TIMED_TEXT_ERROR_MESSAGE_PARSE = "parsing error :", e.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE = "Error creating source buffer of type : ", e;
                                }
                                return s1;
                            }(n("./src/core/errors/ErrorsBase.js").default));
                            t.default = s1;
                        },
                        "./src/core/errors/ErrorsBase.js": function(e, t, n) {
                            "use strict";
                            function r(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            n.r(t);
                            var i = function() {
                                function e() {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e);
                                }
                                var t, n;
                                return t = e, n = [
                                    {
                                        key: "extend",
                                        value: function(e, t) {
                                            if (e) {
                                                var n = !!t && t.override, r = !!t && t.publicOnly;
                                                for(var i in e)!e.hasOwnProperty(i) || this[i] && !n || r && -1 === e[i].indexOf("public_") || (this[i] = e[i]);
                                            }
                                        }
                                    }
                                ], r(t.prototype, n), e;
                            }();
                            t.default = i;
                        },
                        "./src/core/events/CoreEvents.js": function(e, t, n) {
                            "use strict";
                            function r(e) {
                                return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, r(e);
                            }
                            function i(e, t) {
                                return i = Object.setPrototypeOf || function(e, t) {
                                    return e.__proto__ = t, e;
                                }, i(e, t);
                            }
                            function a1(e, t) {
                                return !t || "object" !== r(t) && "function" != typeof t ? function(e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e;
                                }(e) : t;
                            }
                            function o(e) {
                                return o = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                                    return e.__proto__ || Object.getPrototypeOf(e);
                                }, o(e);
                            }
                            n.r(t);
                            var s1 = function(e) {
                                !function(e, t) {
                                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                    e.prototype = Object.create(t && t.prototype, {
                                        constructor: {
                                            value: e,
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }), t && i(e, t);
                                }(s1, e);
                                var t, n, r = (t = s1, n = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e, r = o(t);
                                    if (n) {
                                        var i = o(this).constructor;
                                        e = Reflect.construct(r, arguments, i);
                                    } else e = r.apply(this, arguments);
                                    return a1(this, e);
                                });
                                function s1() {
                                    var e;
                                    return function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, s1), (e = r.call(this)).ATTEMPT_BACKGROUND_SYNC = "attemptBackgroundSync", e.BUFFERING_COMPLETED = "bufferingCompleted", e.BUFFER_CLEARED = "bufferCleared", e.BYTES_APPENDED_END_FRAGMENT = "bytesAppendedEndFragment", e.BUFFER_REPLACEMENT_STARTED = "bufferReplacementStarted", e.CHECK_FOR_EXISTENCE_COMPLETED = "checkForExistenceCompleted", e.CURRENT_TRACK_CHANGED = "currentTrackChanged", e.DATA_UPDATE_COMPLETED = "dataUpdateCompleted", e.INBAND_EVENTS = "inbandEvents", e.INITIAL_STREAM_SWITCH = "initialStreamSwitch", e.INIT_FRAGMENT_LOADED = "initFragmentLoaded", e.INIT_FRAGMENT_NEEDED = "initFragmentNeeded", e.INTERNAL_MANIFEST_LOADED = "internalManifestLoaded", e.ORIGINAL_MANIFEST_LOADED = "originalManifestLoaded", e.LOADING_COMPLETED = "loadingCompleted", e.LOADING_PROGRESS = "loadingProgress", e.LOADING_DATA_PROGRESS = "loadingDataProgress", e.LOADING_ABANDONED = "loadingAborted", e.MANIFEST_UPDATED = "manifestUpdated", e.MEDIA_FRAGMENT_LOADED = "mediaFragmentLoaded", e.MEDIA_FRAGMENT_NEEDED = "mediaFragmentNeeded", e.QUOTA_EXCEEDED = "quotaExceeded", e.SEGMENT_LOCATION_BLACKLIST_ADD = "segmentLocationBlacklistAdd", e.SEGMENT_LOCATION_BLACKLIST_CHANGED = "segmentLocationBlacklistChanged", e.SERVICE_LOCATION_BLACKLIST_ADD = "serviceLocationBlacklistAdd", e.SERVICE_LOCATION_BLACKLIST_CHANGED = "serviceLocationBlacklistChanged", e.SET_FRAGMENTED_TEXT_AFTER_DISABLED = "setFragmentedTextAfterDisabled", e.SET_NON_FRAGMENTED_TEXT = "setNonFragmentedText", e.SOURCE_BUFFER_ERROR = "sourceBufferError", e.STREAMS_COMPOSED = "streamsComposed", e.STREAM_BUFFERING_COMPLETED = "streamBufferingCompleted", e.STREAM_REQUESTING_COMPLETED = "streamRequestingCompleted", e.TEXT_TRACKS_QUEUE_INITIALIZED = "textTracksQueueInitialized", e.TIME_SYNCHRONIZATION_COMPLETED = "timeSynchronizationComplete", e.UPDATE_TIME_SYNC_OFFSET = "updateTimeSyncOffset", e.URL_RESOLUTION_FAILED = "urlResolutionFailed", e.VIDEO_CHUNK_RECEIVED = "videoChunkReceived", e.WALLCLOCK_TIME_UPDATED = "wallclockTimeUpdated", e.XLINK_ELEMENT_LOADED = "xlinkElementLoaded", e.XLINK_READY = "xlinkReady", e.SEEK_TARGET = "seekTarget", e.SETTING_UPDATED_LIVE_DELAY = "settingUpdatedLiveDelay", e.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT = "settingUpdatedLiveDelayFragmentCount", e.SETTING_UPDATED_CATCHUP_ENABLED = "settingUpdatedCatchupEnabled", e.SETTING_UPDATED_PLAYBACK_RATE_MIN = "settingUpdatedPlaybackRateMin", e.SETTING_UPDATED_PLAYBACK_RATE_MAX = "settingUpdatedPlaybackRateMax", e;
                                }
                                return s1;
                            }(n("./src/core/events/EventsBase.js").default);
                            t.default = s1;
                        },
                        "./src/core/events/Events.js": function(e, t, n) {
                            "use strict";
                            function r(e) {
                                return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, r(e);
                            }
                            function i(e, t) {
                                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                            }
                            function a1(e, t) {
                                return a1 = Object.setPrototypeOf || function(e, t) {
                                    return e.__proto__ = t, e;
                                }, a1(e, t);
                            }
                            function o(e, t) {
                                return !t || "object" !== r(t) && "function" != typeof t ? function(e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e;
                                }(e) : t;
                            }
                            function s1(e) {
                                return s1 = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                                    return e.__proto__ || Object.getPrototypeOf(e);
                                }, s1(e);
                            }
                            n.r(t);
                            var u = function(e) {
                                !function(e, t) {
                                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                    e.prototype = Object.create(t && t.prototype, {
                                        constructor: {
                                            value: e,
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }), t && a1(e, t);
                                }(u, e);
                                var t, n, r = (t = u, n = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e, r = s1(t);
                                    if (n) {
                                        var i = s1(this).constructor;
                                        e = Reflect.construct(r, arguments, i);
                                    } else e = r.apply(this, arguments);
                                    return o(this, e);
                                });
                                function u() {
                                    return i(this, u), r.apply(this, arguments);
                                }
                                return u;
                            }(n("./src/core/events/CoreEvents.js").default), l = new u;
                            t.default = l;
                        },
                        "./src/core/events/EventsBase.js": function(e, t, n) {
                            "use strict";
                            function r(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            n.r(t);
                            var i = function() {
                                function e() {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e);
                                }
                                var t, n;
                                return t = e, n = [
                                    {
                                        key: "extend",
                                        value: function(e, t) {
                                            if (e) {
                                                var n = !!t && t.override, r = !!t && t.publicOnly;
                                                for(var i in e)!e.hasOwnProperty(i) || this[i] && !n || r && -1 === e[i].indexOf("public_") || (this[i] = e[i]);
                                            }
                                        }
                                    }
                                ], r(t.prototype, n), e;
                            }();
                            t.default = i;
                        },
                        "./src/dash/DashAdapter.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/dash/constants/DashConstants.js"), i = n("./src/dash/vo/RepresentationInfo.js"), a1 = n("./src/dash/vo/MediaInfo.js"), o = n("./src/dash/vo/StreamInfo.js"), s1 = n("./src/dash/vo/ManifestInfo.js"), u = n("./src/dash/vo/Event.js"), l = n("./src/core/FactoryMaker.js"), c = n("./src/dash/models/DashManifestModel.js"), d = n("./src/dash/models/PatchManifestModel.js"), f = n("./node_modules/bcp-47-normalize/index.js"), h = n.n(f);
                            function g() {
                                var e, t, n, l, f, g, p, m = this.context;
                                function v(e, n, i) {
                                    var a1, o = t.getAdaptationsForType(l[0].mpd.manifest, e, n);
                                    if (!o || 0 === o.length) return null;
                                    if (o.length > 1 && i) {
                                        var s1 = T(i, n);
                                        if (f[i.id] && f[i.id][n]) {
                                            for(var u = 0, c = o.length; u < c; u++)if (y(f[i.id][n], s1[u])) return o[u];
                                        }
                                        for(var d = 0, h = o.length; d < h; d++)if (a1 = o[d], t.getRolesForAdaptation(a1).filter(function(e) {
                                            return e.value === r.default.MAIN;
                                        })[0]) return o[d];
                                    }
                                    return o[0];
                                }
                                function y(e, t) {
                                    if (!e || !t) return !1;
                                    var n = e.id === t.id, r = e.codec === t.codec, i = e.viewpoint === t.viewpoint, a1 = e.lang === t.lang, o = e.roles.toString() === t.roles.toString(), s1 = e.accessibility.toString() === t.accessibility.toString(), u = e.audioChannelConfiguration.toString() === t.audioChannelConfiguration.toString();
                                    return n && r && i && a1 && o && s1 && u;
                                }
                                function E(e, n, r, i, a1, o) {
                                    var s1, u, l, c, d, f, h = [];
                                    if (!i || 0 === i.length) return [];
                                    var p = t.getAdaptationsForPeriod(n);
                                    for(c = 0, f = i.length; c < f; c++)if (s1 = i[c], u = R(p[l = t.getIndexForAdaptation(s1, e, r.index)]), o) {
                                        var m = u.accessibility.length;
                                        for(d = 0; d < m; d++)if (u) {
                                            var v = u.accessibility[d];
                                            if (0 === v.indexOf("cea-608:")) {
                                                var y = v.substring(8).split(";");
                                                if ("CC" === y[0].substring(0, 2)) for(d = 0; d < y.length; d++)u || (u = R.call(this, p[l])), C(u, y[d].substring(0, 3), y[d].substring(4)), h.push(u), u = null;
                                                else for(d = 0; d < y.length; d++)u || (u = R.call(this, p[l])), C(u, "CC" + (d + 1), y[d]), h.push(u), u = null;
                                            } else 0 === v.indexOf("cea-608") && (C(u, g.CC1, "eng"), h.push(u), u = null);
                                        }
                                    } else a1 === g.IMAGE ? (u.type = g.IMAGE, h.push(u), u = null) : u && h.push(u);
                                    return h;
                                }
                                function T(e, n, r) {
                                    var i = l, a1 = r, o = [];
                                    if (a1) k(), i = b(a1);
                                    else {
                                        if (!(l.length > 0)) return o;
                                        a1 = l[0].mpd.manifest;
                                    }
                                    var s1 = I(e, i), u = t.getAdaptationsForType(a1, e ? e.index : null, n);
                                    return o = E(a1, s1, e, u, n), n === g.TEXT && (u = t.getAdaptationsForType(a1, e ? e.index : null, g.VIDEO), o = o.concat(E(a1, s1, e, u, n, !0))), o;
                                }
                                function b(e) {
                                    var n = A(e);
                                    return t.getRegularPeriods(n);
                                }
                                function A(e) {
                                    var n = S(e);
                                    return t.getMpd(n);
                                }
                                function _() {
                                    l = [], f = {};
                                }
                                function S(e) {
                                    return e || (l.length > 0 ? l[0].mpd.manifest : null);
                                }
                                function w(e) {
                                    try {
                                        var n = I(e.streamInfo, l), r = t.getAdaptationsForPeriod(n);
                                        return e && e.streamInfo && void 0 !== e.streamInfo.id && r ? r[e.index] : null;
                                    } catch (e) {
                                        return null;
                                    }
                                }
                                function I(e, t) {
                                    for(var n = t.length, r = 0; r < n; r++){
                                        var i = t[r];
                                        if (e && e.id === i.id) return i;
                                    }
                                    return null;
                                }
                                function R(e) {
                                    if (!e) return null;
                                    var n, r = new a1.default, i = e.period.mpd.manifest.Period_asArray[e.period.index].AdaptationSet_asArray[e.index];
                                    if (r.id = e.id, r.index = e.index, r.type = e.type, r.streamInfo = D(e.period), r.representationCount = t.getRepresentationCount(i), r.labels = t.getLabelsForAdaptation(i), r.lang = t.getLanguageForAdaptation(i), n = t.getViewpointForAdaptation(i), r.viewpoint = n ? n.value : void 0, r.accessibility = t.getAccessibilityForAdaptation(i).map(function(e) {
                                        var t = e.value, n = t;
                                        return e.schemeIdUri && e.schemeIdUri.search("cea-608") >= 0 && void 0 !== p && (n = t ? "cea-608:" + t : "cea-608", r.embeddedCaptions = !0), n;
                                    }), r.audioChannelConfiguration = t.getAudioChannelConfigurationForAdaptation(i).map(function(e) {
                                        return e.value;
                                    }), 0 === r.audioChannelConfiguration.length && Array.isArray(i.Representation_asArray) && i.Representation_asArray.length > 0 && (r.audioChannelConfiguration = t.getAudioChannelConfigurationForRepresentation(i.Representation_asArray[0]).map(function(e) {
                                        return e.value;
                                    })), r.roles = t.getRolesForAdaptation(i).map(function(e) {
                                        return e.value;
                                    }), r.codec = t.getCodec(i), r.mimeType = t.getMimeType(i), r.contentProtection = t.getContentProtectionData(i), r.bitrateList = t.getBitrateListForAdaptation(i), r.selectionPriority = t.getSelectionPriority(i), r.contentProtection) {
                                        var o = r.contentProtection.map(function(e) {
                                            return t.getKID(e);
                                        }).filter(function(e) {
                                            return null !== e;
                                        });
                                        if (o.length) {
                                            var s1 = o[0];
                                            r.contentProtection.forEach(function(e) {
                                                e.keyId = s1;
                                            });
                                        }
                                    }
                                    return r.isText = t.getIsText(i), r.supplementalProperties = t.getSupplementalProperties(i), r.isFragmented = t.getIsFragmented(i), r.isEmbedded = !1, r;
                                }
                                function C(e, t, n) {
                                    e.id = t, e.index = 100 + parseInt(t.substring(2, 3)), e.type = g.TEXT, e.codec = "cea-608-in-SEI", e.isEmbedded = !0, e.isFragmented = !1, e.lang = h()(n), e.roles = [
                                        "caption"
                                    ];
                                }
                                function D(e) {
                                    var n, r, i = new o.default;
                                    return i.id = e.id, i.index = e.index, i.start = e.start, i.duration = e.duration, i.manifestInfo = (n = e.mpd, (r = new s1.default).dvrWindowSize = n.timeShiftBufferDepth, r.loadedTime = n.manifest.loadedTime, r.availableFrom = n.availabilityStartTime, r.minBufferTime = n.manifest.minBufferTime, r.maxFragmentDuration = n.maxSegmentDuration, r.duration = t.getDuration(n.manifest), r.isDynamic = t.getIsDynamic(n.manifest), r.serviceDescriptions = t.getServiceDescriptions(n.manifest), r.protocol = n.manifest.protocol, r), i.isLast = 1 === e.mpd.manifest.Period_asArray.length || Math.abs(i.start + i.duration - i.manifestInfo.duration) < 1, i;
                                }
                                function k() {
                                    if (!g) throw new Error("setConfig function has to be called previously");
                                }
                                function N(e) {
                                    return l.length > 0 ? l[0].mpd.manifest.Period_asArray[e] : null;
                                }
                                function L(e, t, n) {
                                    var r, i, a1, o, s1;
                                    if (e) {
                                        for(r = e.AdaptationSet_asArray, o = 0; o < r.length; o += 1)for(a1 = r[o].Representation_asArray, s1 = 0; s1 < a1.length; s1 += 1)if (t === (i = a1[s1]).id) return n ? s1 : i;
                                    }
                                    return null;
                                }
                                return e = {
                                    getBandwidthForRepresentation: function(e, t) {
                                        var n;
                                        return (n = L(N(t), e)) ? n.bandwidth : null;
                                    },
                                    getIndexForRepresentation: function(e, t) {
                                        return function(e, t) {
                                            var n = L(e, t, !0);
                                            return null !== n ? n : -1;
                                        }(N(t), e);
                                    },
                                    getMaxIndexForBufferType: function(e, n) {
                                        return function(e, n) {
                                            var r, i, a1, o;
                                            if (!e || !n) return -1;
                                            for(i = e.AdaptationSet_asArray, o = 0; o < i.length; o += 1)if (a1 = (r = i[o]).Representation_asArray, t.getIsTypeOf(r, n)) return a1.length;
                                            return -1;
                                        }(N(n), e);
                                    },
                                    convertRepresentationToRepresentationInfo: function(e) {
                                        if (e) {
                                            var n = new i.default, r = e.adaptation.period.mpd.manifest.Period_asArray[e.adaptation.period.index].AdaptationSet_asArray[e.adaptation.index], a1 = t.getRepresentationFor(e.index, r);
                                            return n.id = e.id, n.quality = e.index, n.bandwidth = t.getBandwidth(a1), n.fragmentDuration = e.segmentDuration || (e.segments && e.segments.length > 0 ? e.segments[0].duration : NaN), n.MSETimeOffset = e.MSETimeOffset, n.mediaInfo = R(e.adaptation), n;
                                        }
                                        return null;
                                    },
                                    getStreamsInfo: function(e, t) {
                                        var n = [], r = l;
                                        if (e && (k(), r = b(e)), r.length > 0) {
                                            (!t || t > r.length) && (t = r.length);
                                            for(var i = 0; i < t; i++)n.push(D(r[i]));
                                        }
                                        return n;
                                    },
                                    getMediaInfoForType: function(e, n) {
                                        if (0 === l.length || !e) return null;
                                        var r = I(e, l);
                                        if (!r) return null;
                                        var i = t.getAdaptationsForPeriod(r), a1 = v(e.index, n, e);
                                        return a1 ? R(i[t.getIndexForAdaptation(a1, l[0].mpd.manifest, e.index)]) : null;
                                    },
                                    getAllMediaInfoForType: T,
                                    getAdaptationForType: v,
                                    getRealAdaptation: function(e, n) {
                                        var r, i, a1 = I(e, l);
                                        return r = n ? n.id : null, l.length > 0 && a1 && (i = r ? t.getAdaptationForId(r, l[0].mpd.manifest, a1.index) : t.getAdaptationForIndex(n ? n.index : null, l[0].mpd.manifest, a1.index)), i;
                                    },
                                    getProducerReferenceTimes: function(e, n) {
                                        var r, i, a1 = I(e, l);
                                        return r = n ? n.id : null, l.length > 0 && a1 && (i = r ? t.getAdaptationForId(r, l[0].mpd.manifest, a1.index) : t.getAdaptationForIndex(n ? n.index : null, l[0].mpd.manifest, a1.index)), i ? t.getProducerReferenceTimesForAdaptation(i) : [];
                                    },
                                    getRealPeriodByIndex: function(e) {
                                        return t.getRealPeriodForIndex(e, l[0].mpd.manifest);
                                    },
                                    getEssentialPropertiesForRepresentation: function(e) {
                                        try {
                                            return t.getEssentialPropertiesForRepresentation(e);
                                        } catch (e) {
                                            return [];
                                        }
                                    },
                                    getVoRepresentations: function(e) {
                                        var n = w(e);
                                        return t.getRepresentationsForAdaptation(n);
                                    },
                                    getEventsFor: function(e, n, r) {
                                        var s1 = [];
                                        if (l.length > 0) {
                                            var u = l[0].mpd.manifest;
                                            if (e instanceof o.default) {
                                                var c = I(e, l);
                                                s1 = t.getEventsForPeriod(c);
                                            } else if (e instanceof a1.default) {
                                                var d = I(r, l);
                                                s1 = t.getEventStreamForAdaptationSet(u, w(e), d);
                                            } else if (e instanceof i.default) {
                                                var f = I(r, l);
                                                s1 = t.getEventStreamForRepresentation(u, n, f);
                                            }
                                        }
                                        return s1;
                                    },
                                    getEvent: function(e, t, n, r) {
                                        try {
                                            if (!e || !t || isNaN(n) || !r) return null;
                                            var i = e.scheme_id_uri, a1 = e.value;
                                            if (!t[i + "/" + a1]) return null;
                                            var o, s1 = new u.default, l = e.timescale || 1, c = r.adaptation.period.start, d = t[i + "/" + a1], f = isNaN(r.presentationTimeOffset) ? isNaN(d.presentationTimeOffset) ? 0 : d.presentationTimeOffset : r.presentationTimeOffset, h = e.presentation_time_delta / l;
                                            o = 0 === e.version ? c + n - f + h : c - f + h;
                                            var g = e.event_duration / l, p = e.id, m = e.message_data;
                                            return s1.eventStream = d, s1.eventStream.value = a1, s1.eventStream.timescale = l, s1.duration = g, s1.id = p, s1.calculatedPresentationTime = o, s1.messageData = m, s1.presentationTimeDelta = h, s1;
                                        } catch (e) {
                                            return null;
                                        }
                                    },
                                    getMpd: A,
                                    setConfig: function(e) {
                                        e && (e.constants && (g = e.constants), e.cea608parser && (p = e.cea608parser), e.errHandler && t.setConfig({
                                            errHandler: e.errHandler
                                        }), e.BASE64 && t.setConfig({
                                            BASE64: e.BASE64
                                        }));
                                    },
                                    updatePeriods: function(e) {
                                        if (!e) return null;
                                        k(), l = b(e);
                                    },
                                    getIsTextTrack: function(e) {
                                        return t.getIsText(e);
                                    },
                                    getUTCTimingSources: function() {
                                        var e = S();
                                        return t.getUTCTimingSources(e);
                                    },
                                    getSuggestedPresentationDelay: function() {
                                        var e = l.length > 0 ? l[0].mpd : null;
                                        return t.getSuggestedPresentationDelay(e);
                                    },
                                    getAvailabilityStartTime: function(e) {
                                        var n = A(e);
                                        return t.getAvailabilityStartTime(n);
                                    },
                                    getIsTypeOf: function(e, n) {
                                        return t.getIsTypeOf(e, n);
                                    },
                                    getIsDynamic: function(e) {
                                        var n = S(e);
                                        return t.getIsDynamic(n);
                                    },
                                    getDuration: function(e) {
                                        var n = S(e);
                                        return t.getDuration(n);
                                    },
                                    getRegularPeriods: b,
                                    getContentSteering: function(e) {
                                        return t.getContentSteering(e);
                                    },
                                    getLocation: function(e) {
                                        return t.getLocation(e);
                                    },
                                    getPatchLocation: function(e) {
                                        var n = t.getPatchLocation(e), r = t.getPublishTime(e);
                                        if (!n || !r) return null;
                                        if (n.hasOwnProperty("ttl") && r) {
                                            var i = 1e3 * parseFloat(n.ttl);
                                            if (r.getTime() + i <= (new Date).getTime()) return null;
                                        }
                                        return n.__text;
                                    },
                                    getManifestUpdatePeriod: function(e) {
                                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                                        return t.getManifestUpdatePeriod(e, n);
                                    },
                                    getPublishTime: function(e) {
                                        return t.getPublishTime(e);
                                    },
                                    getIsDVB: function(e) {
                                        return t.hasProfile(e, "urn:dvb:dash:profile:dvb-dash:2014");
                                    },
                                    getIsPatch: function(e) {
                                        return n.getIsPatch(e);
                                    },
                                    getBaseURLsFromElement: function(e) {
                                        return t.getBaseURLsFromElement(e);
                                    },
                                    getRepresentationSortFunction: function() {
                                        return t.getRepresentationSortFunction();
                                    },
                                    getCodec: function(e, n, r) {
                                        return t.getCodec(e, n, r);
                                    },
                                    getPeriodById: function(e) {
                                        if (!e || 0 === l.length) return null;
                                        var t = l.filter(function(t) {
                                            return t.id === e;
                                        });
                                        return t && t.length > 0 ? t[0] : null;
                                    },
                                    setCurrentMediaInfo: function(e, t, n) {
                                        f[e] = f[e] || {}, f[e][t] = f[e][t] || {}, f[e][t] = n;
                                    },
                                    isPatchValid: function(e, r) {
                                        var i = t.getId(e), a1 = n.getMpdId(r), o = t.getPublishTime(e), s1 = n.getPublishTime(r), u = n.getOriginalPublishTime(r);
                                        return !!(i && a1 && i == a1 && o && u && o.getTime() == u.getTime() && s1 && o.getTime() < s1.getTime());
                                    },
                                    applyPatchToManifest: function(e, t) {
                                        n.getPatchOperations(t).forEach(function(t) {
                                            var n = t.getMpdTarget(e);
                                            if (null !== n) {
                                                var r = n.name, i = n.target, a1 = n.leaf;
                                                if (t.xpath.findsAttribute()) switch(t.action){
                                                    case "add":
                                                    case "replace":
                                                        i[r] = t.value;
                                                        break;
                                                    case "remove":
                                                        delete i[r];
                                                }
                                                else {
                                                    var o = (i[r + "_asArray"] || []).indexOf(a1), s1 = "prepend" === t.position || "before" === t.position;
                                                    if (("remove" === t.action || "replace" === t.action) && (delete i[r], -1 != o)) {
                                                        var u = i[r + "_asArray"];
                                                        u.splice(o, 1), u.length > 1 ? i[r] = u : 1 == u.length ? i[r] = u[0] : delete i[r + "_asArray"];
                                                    }
                                                    "add" !== t.action && "replace" !== t.action || Object.keys(t.value).forEach(function(e) {
                                                        var n = t.value[e], a1 = i[e + "_asArray"] || [];
                                                        if (0 === a1.length && i[e] && a1.push(i[e]), 0 === a1.length) a1 = n;
                                                        else {
                                                            var u = a1.length;
                                                            u = e == r && -1 != o ? o + (s1 ? 0 : 1) + ("replace" == t.action ? -1 : 0) : s1 ? 0 : a1.length, a1.splice.apply(a1, [
                                                                u,
                                                                0
                                                            ].concat(n));
                                                        }
                                                        i[e + "_asArray"] = a1, i[e] = 1 == a1.length ? a1[0] : a1;
                                                    });
                                                }
                                            }
                                        });
                                    },
                                    areMediaInfosEqual: y,
                                    reset: _
                                }, t = Object(c.default)(m).getInstance(), n = Object(d.default)(m).getInstance(), _(), e;
                            }
                            g.__dashjs_factory_name = "DashAdapter", t.default = l.default.getSingletonFactory(g);
                        },
                        "./src/dash/DashHandler.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/vo/FragmentRequest.js"), i = n("./src/streaming/vo/metrics/HTTPRequest.js"), a1 = n("./src/core/FactoryMaker.js"), o = n("./src/streaming/MediaPlayerEvents.js"), s1 = n("./src/dash/utils/SegmentsUtils.js"), u = n("./src/dash/constants/DashConstants.js");
                            function l(e) {
                                var t, n, a1, l, c, d = (e = e || {}).eventBus, f = e.debug, h = e.urlUtils, g = e.type, p = e.streamInfo, m = e.segmentsController, v = e.timelineConverter, y = e.baseURLController;
                                function E() {
                                    return g;
                                }
                                function T() {
                                    a1 = null;
                                }
                                function b(e, t, n) {
                                    var r, i, a1 = y.resolve(n.path);
                                    return a1 && t !== a1.url && h.isRelative(t) ? (r = a1.url, i = a1.serviceLocation, t && (r = h.resolve(t, r))) : r = t, !h.isRelative(r) && (e.url = r, e.serviceLocation = i, !0);
                                }
                                function A(e, t) {
                                    if (null == t) return null;
                                    var n = new r.default, a1 = t.representation, o = a1.adaptation.period.mpd.manifest.Period_asArray[a1.adaptation.period.index].AdaptationSet_asArray[a1.adaptation.index].Representation_asArray[a1.index].bandwidth, u = t.media;
                                    return u = Object(s1.replaceTokenForTemplate)(u, "Number", t.replacementNumber), u = Object(s1.replaceTokenForTemplate)(u, "Time", t.replacementTime), u = Object(s1.replaceTokenForTemplate)(u, "Bandwidth", o), u = Object(s1.replaceIDForTemplate)(u, a1.id), u = Object(s1.unescapeDollarsInTemplate)(u), n.mediaType = E(), n.type = i.HTTPRequest.MEDIA_SEGMENT_TYPE, n.range = t.mediaRange, n.startTime = t.presentationStartTime, n.mediaStartTime = t.mediaStartTime, n.duration = t.duration, n.timescale = a1.timescale, n.availabilityStartTime = t.availabilityStartTime, n.availabilityEndTime = t.availabilityEndTime, n.availabilityTimeComplete = a1.availabilityTimeComplete, n.wallStartTime = t.wallStartTime, n.quality = a1.index, n.index = t.index, n.mediaInfo = e, n.adaptationIndex = a1.adaptation.index, n.representationId = a1.id, b(n, u, a1) ? n : void 0;
                                }
                                function _(e, t, r) {
                                    var i = null;
                                    if (!t || !t.segmentInfoType) return i;
                                    var o = m.getSegmentByTime(t, r);
                                    return o && (a1 = o, n.debug("Index for time " + r + " is " + o.index), i = A(e, o)), i;
                                }
                                function S() {
                                    n.debug("Dynamic stream complete"), c = !0;
                                }
                                return t = {
                                    initialize: function(e) {
                                        l = e, c = !1, m.initialize(e);
                                    },
                                    getStreamId: function() {
                                        return p.id;
                                    },
                                    getType: E,
                                    getStreamInfo: function() {
                                        return p;
                                    },
                                    getInitRequest: function(e, t) {
                                        return t ? function(e, t, n) {
                                            var a1 = new r.default, o = t.adaptation.period, u = o.start;
                                            if (a1.mediaType = n, a1.type = i.HTTPRequest.INIT_SEGMENT_TYPE, a1.range = t.range, a1.availabilityStartTime = v.calcAvailabilityStartTimeFromPresentationTime(u, t, l), a1.availabilityEndTime = v.calcAvailabilityEndTimeFromPresentationTime(u + o.duration, t, l), a1.quality = t.index, a1.mediaInfo = e, a1.representationId = t.id, b(a1, t.initialization, t)) return a1.url = Object(s1.replaceTokenForTemplate)(a1.url, "Bandwidth", t.bandwidth), a1;
                                        }(e, t, E()) : null;
                                    },
                                    getSegmentRequestForTime: _,
                                    getCurrentIndex: function() {
                                        return a1 ? a1.index : -1;
                                    },
                                    getNextSegmentRequest: function(e, t) {
                                        var r = null;
                                        if (!t || !t.segmentInfoType) return null;
                                        var i = a1 ? a1.index + 1 : 0, o = m.getSegmentByIndex(t, i, a1 ? a1.mediaStartTime : -1);
                                        if (o) r = A(e, o), a1 = o;
                                        else {
                                            if (l && !c) return n.debug(E() + " No segment found at index: " + i + ". Wait for next loop"), null;
                                            c = !0;
                                        }
                                        return r;
                                    },
                                    isLastSegmentRequested: function(e, t) {
                                        if (!e || !a1) return !1;
                                        if (c) return !0;
                                        if (!isFinite(e.adaptation.period.duration)) return !1;
                                        if (a1.presentationStartTime + a1.duration > t) return !1;
                                        if (e.mediaFinishedInformation && !isNaN(e.mediaFinishedInformation.numberOfSegments) && !isNaN(a1.index) && a1.index >= e.mediaFinishedInformation.numberOfSegments - 1) {
                                            if (!l || e.segmentInfoType === u.default.SEGMENT_TEMPLATE) return !0;
                                            if (l && e.segmentInfoType === u.default.SEGMENT_LIST && e.adaptation.period.nextPeriodId) return !0;
                                        }
                                        return !!(l && e.adaptation.period.nextPeriodId && e.segmentInfoType === u.default.SEGMENT_TIMELINE && e.mediaFinishedInformation && !isNaN(e.mediaFinishedInformation.mediaTimeOfLastSignaledSegment) && a1 && !isNaN(a1.mediaStartTime) && !isNaN(a1.duration) && a1.mediaStartTime + a1.duration >= e.mediaFinishedInformation.mediaTimeOfLastSignaledSegment - .05);
                                    },
                                    reset: function() {
                                        T(), d.off(o.default.DYNAMIC_TO_STATIC, S, t);
                                    },
                                    getNextSegmentRequestIdempotent: function(e, t) {
                                        var n = a1 ? a1.index + 1 : 0, r = m.getSegmentByIndex(t, n, a1 ? a1.mediaStartTime : -1);
                                        return r ? A(e, r) : null;
                                    },
                                    getValidTimeCloseToTargetTime: function(e, t, n, r) {
                                        try {
                                            if (isNaN(e) || !t || !n) return NaN;
                                            if (e < 0 && (e = 0), isNaN(r) && (r = .5), _(t, n, e)) return e;
                                            for(var i = n.adaptation.period.start, a1 = n.adaptation.period.start + n.adaptation.period.duration, o = Math.min(e + r, a1), s1 = Math.max(e - r, i), u = NaN, l = null; o <= a1 || s1 >= i;){
                                                var c = null, d = null;
                                                if (o <= a1 && (c = _(t, n, o)), s1 >= i && (d = _(t, n, s1)), d) {
                                                    u = s1, l = d;
                                                    break;
                                                }
                                                if (c) {
                                                    u = o, l = c;
                                                    break;
                                                }
                                                o += r, s1 -= r;
                                            }
                                            if (l) {
                                                var f = l.startTime + l.duration;
                                                return e >= l.startTime && f - e > r ? e : e < l.startTime ? l.startTime + .001 : Math.min(f - r, u);
                                            }
                                            return u;
                                        } catch (e) {
                                            return NaN;
                                        }
                                    },
                                    getValidTimeAheadOfTargetTime: function(e, t, n, r) {
                                        try {
                                            if (isNaN(e) || !t || !n) return NaN;
                                            if (e < 0 && (e = 0), isNaN(r) && (r = .5), _(t, n, e)) return e;
                                            if (n.adaptation.period.start + n.adaptation.period.duration < e) return NaN;
                                            for(var i = Math.min(n.adaptation.period.start + n.adaptation.period.duration, e + 30), a1 = Math.min(e + r, i), o = NaN, s1 = null; a1 <= i;){
                                                var u = null;
                                                if (a1 <= i && (u = _(t, n, a1)), u) {
                                                    o = a1, s1 = u;
                                                    break;
                                                }
                                                a1 += r;
                                            }
                                            if (s1) {
                                                var l = s1.startTime + s1.duration;
                                                return e > s1.startTime && l - e > r ? e : !isNaN(s1.startTime) && e < s1.startTime && o > s1.startTime ? s1.startTime + .001 : Math.min(l - r, o);
                                            }
                                            return o;
                                        } catch (e) {
                                            return NaN;
                                        }
                                    }
                                }, n = f.getLogger(t), T(), d.on(o.default.DYNAMIC_TO_STATIC, S, t), t;
                            }
                            l.__dashjs_factory_name = "DashHandler", t.default = a1.default.getClassFactory(l);
                        },
                        "./src/dash/DashMetrics.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/Constants.js"), i = n("./src/streaming/vo/metrics/HTTPRequest.js"), a1 = n("./src/core/FactoryMaker.js"), o = n("./src/streaming/constants/MetricsConstants.js"), s1 = n("./src/dash/utils/Round10.js"), u = n("./src/streaming/models/MetricsModel.js"), l = n("./src/core/Utils.js"), c = n("./src/streaming/vo/metrics/PlayList.js");
                            function d(e) {
                                e = e || {};
                                var t, n, a1, d, f = this.context, h = e.metricsModel;
                                function g(e) {
                                    var t = h.getMetricsFor(e, !0);
                                    if (!t) return null;
                                    var n, r = t.HttpList, i = null;
                                    if (!r || r.length <= 0) return null;
                                    for(n = r.length - 1; n >= 0;){
                                        if (r[n].responsecode) {
                                            i = r[n];
                                            break;
                                        }
                                        n--;
                                    }
                                    return i;
                                }
                                function p(e) {
                                    var t = h.getMetricsFor(e, !0);
                                    return t && t.HttpList ? t.HttpList : [];
                                }
                                function m(e, t) {
                                    if (!e) return null;
                                    var n = e[t];
                                    return n && 0 !== n.length ? n[n.length - 1] : null;
                                }
                                return t = {
                                    getCurrentRepresentationSwitch: function(e) {
                                        return m(h.getMetricsFor(e, !0), o.default.TRACK_SWITCH);
                                    },
                                    getCurrentBufferState: function(e) {
                                        return m(h.getMetricsFor(e, !0), o.default.BUFFER_STATE);
                                    },
                                    getCurrentBufferLevel: function(e) {
                                        var t = m(h.getMetricsFor(e, !0), o.default.BUFFER_LEVEL);
                                        return t ? s1.default.round10(t.level / 1e3, -3) : 0;
                                    },
                                    getCurrentHttpRequest: g,
                                    getHttpRequests: p,
                                    getCurrentDroppedFrames: function() {
                                        return m(h.getMetricsFor(r.default.VIDEO, !0), o.default.DROPPED_FRAMES);
                                    },
                                    getCurrentSchedulingInfo: function(e) {
                                        return m(h.getMetricsFor(e, !0), o.default.SCHEDULING_INFO);
                                    },
                                    getCurrentDVRInfo: function(e) {
                                        return m(e ? h.getMetricsFor(e, !0) : h.getMetricsFor(r.default.VIDEO, !0) || h.getMetricsFor(r.default.AUDIO, !0), o.default.DVR_INFO);
                                    },
                                    getCurrentManifestUpdate: function() {
                                        return m(h.getMetricsFor(r.default.STREAM), o.default.MANIFEST_UPDATE);
                                    },
                                    getLatestFragmentRequestHeaderValueByID: function(e, t) {
                                        if (!t) return null;
                                        var n = {}, r = g(e);
                                        r && (n = l.default.parseHttpHeaders(r._responseHeaders));
                                        var i = n[t.toLowerCase()];
                                        return void 0 === i ? null : i;
                                    },
                                    getLatestMPDRequestHeaderValueByID: function(e) {
                                        if (!e) return null;
                                        var t, n, a1, o = {};
                                        for(a1 = (t = p(r.default.STREAM)).length - 1; a1 >= 0; a1--)if ((n = t[a1]).type === i.HTTPRequest.MPD_TYPE) {
                                            o = l.default.parseHttpHeaders(n._responseHeaders);
                                            break;
                                        }
                                        var s1 = o[e.toLowerCase()];
                                        return void 0 === s1 ? null : s1;
                                    },
                                    addRepresentationSwitch: function(e, t, n, r, i) {
                                        h.addRepresentationSwitch(e, t, n, r, i);
                                    },
                                    addDVRInfo: function(e, t, n, r) {
                                        h.addDVRInfo(e, t, n, r);
                                    },
                                    updateManifestUpdateInfo: function(e) {
                                        var t = this.getCurrentManifestUpdate();
                                        h.updateManifestUpdateInfo(t, e);
                                    },
                                    addManifestUpdateStreamInfo: function(e) {
                                        if (e) {
                                            var t = this.getCurrentManifestUpdate();
                                            h.addManifestUpdateStreamInfo(t, e.id, e.index, e.start, e.duration);
                                        }
                                    },
                                    addManifestUpdateRepresentationInfo: function(e, t) {
                                        if (e) {
                                            var n = this.getCurrentManifestUpdate();
                                            h.addManifestUpdateRepresentationInfo(n, e.id, e.index, e.streamIndex, t, e.presentationTimeOffset, e.startNumber, e.fragmentInfoType);
                                        }
                                    },
                                    addManifestUpdate: function(e) {
                                        h.addManifestUpdate(r.default.STREAM, e.type, e.requestStartDate, e.requestEndDate);
                                    },
                                    addHttpRequest: function(e, t, n, r, i) {
                                        h.addHttpRequest(e.mediaType, null, e.type, e.url, e.quality, t, e.serviceLocation || null, e.range || null, e.requestStartDate, e.firstByteDate, e.requestEndDate, n, e.duration, r, i, e.fileLoaderType);
                                    },
                                    addSchedulingInfo: function(e, t) {
                                        h.addSchedulingInfo(e.mediaType, new Date, e.type, e.startTime, e.availabilityStartTime, e.duration, e.quality, e.range, t);
                                    },
                                    addRequestsQueue: function(e, t, n) {
                                        h.addRequestsQueue(e, t, n);
                                    },
                                    addBufferLevel: function(e, t, n) {
                                        h.addBufferLevel(e, t, n);
                                    },
                                    addBufferState: function(e, t, n) {
                                        h.addBufferState(e, t, n);
                                    },
                                    addDroppedFrames: function(e) {
                                        h.addDroppedFrames(r.default.VIDEO, e);
                                    },
                                    addPlayList: function() {
                                        d && (h.addPlayList(d), d = null);
                                    },
                                    addDVBErrors: function(e) {
                                        h.addDVBErrors(e);
                                    },
                                    createPlaylistMetrics: function(e, t) {
                                        (d = new c.PlayList).start = new Date, d.mstart = e, d.starttype = t;
                                    },
                                    createPlaylistTraceMetrics: function(e, t, r) {
                                        !0 === n && (n = !1, (a1 = new c.PlayListTrace).representationid = e, a1.start = new Date, a1.mstart = t, a1.playbackspeed = null !== r ? r.toString() : null);
                                    },
                                    updatePlayListTraceMetrics: function(e) {
                                        if (a1) for(var t in a1)a1[t] = e[t];
                                    },
                                    pushPlayListTraceMetrics: function(e, t) {
                                        if (!1 === n && d && a1 && a1.start) {
                                            var r = a1.start, i = e.getTime() - r.getTime();
                                            a1.duration = i, a1.stopreason = t, d.trace.push(a1), n = !0;
                                        }
                                    },
                                    clearAllCurrentMetrics: function() {
                                        h.clearAllCurrentMetrics();
                                    }
                                }, h = h || Object(u.default)(f).getInstance({
                                    settings: e.settings
                                }), n = !0, a1 = null, d = null, t;
                            }
                            d.__dashjs_factory_name = "DashMetrics", t.default = a1.default.getSingletonFactory(d);
                        },
                        "./src/dash/SegmentBaseLoader.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/dash/vo/Segment.js"), i = n("./src/streaming/vo/DashJSError.js"), a1 = n("./src/core/FactoryMaker.js"), o = n("./src/streaming/vo/FragmentRequest.js"), s1 = n("./src/streaming/net/URLLoader.js");
                            function u() {
                                var e, t, n, a1, u, l, c, d, f, h, g, p, m, v = this.context;
                                function y(e, n, r, i) {
                                    var o = null, s1 = e ? m.resolve(e.path) : null, u = i || {
                                        init: !0,
                                        url: s1 ? s1.url : void 0,
                                        range: {
                                            start: 0,
                                            end: 1500
                                        },
                                        searching: !1,
                                        bytesLoaded: 0,
                                        bytesToLoad: 1500,
                                        mediaType: n
                                    };
                                    t.debug("Start searching for initialization.");
                                    var l = b(u);
                                    d.load({
                                        request: l,
                                        success: function(t) {
                                            if (u.bytesLoaded = u.range.end, !(o = a1.findInitRange(t))) return u.range.end = u.bytesLoaded + u.bytesToLoad, y(e, n, r, u);
                                            e.range = o, r(e);
                                        },
                                        error: function() {
                                            r(e);
                                        }
                                    }), t.debug("Perform init search: " + u.url);
                                }
                                function E(e, n, i, o, s1, u) {
                                    if (i && (void 0 === i.start || void 0 === i.end)) {
                                        var l = i ? i.toString().split("-") : null;
                                        i = l ? {
                                            start: parseFloat(l[0]),
                                            end: parseFloat(l[1])
                                        } : null;
                                    }
                                    s1 = s1 || T;
                                    var c = null, f = null, h = !!i, g = e ? m.resolve(e.path) : null, p = {
                                        init: !1,
                                        url: g ? g.url : void 0,
                                        range: h ? i : {
                                            start: 0,
                                            end: 1500
                                        },
                                        searching: !h,
                                        bytesLoaded: u ? u.bytesLoaded : 0,
                                        bytesToLoad: 1500,
                                        mediaType: n
                                    }, v = b(p);
                                    d.load({
                                        request: v,
                                        success: function(i) {
                                            var u = p.bytesToLoad, l = i.byteLength;
                                            if (p.bytesLoaded = p.range.end - p.range.start, c = a1.parse(i), (f = c.getBox("sidx")) && f.isComplete) {
                                                var d, h, g = f.references;
                                                if (null != g && g.length > 0 && (d = 1 === g[0].reference_type), d) {
                                                    var m, v, y, T;
                                                    t.debug("Initiate multiple SIDX load."), p.range.end = p.range.start + f.size;
                                                    var b = [], A = 0, _ = (f.offset || p.range.start) + f.size, S = function(t) {
                                                        t ? (b = b.concat(t), ++A >= v && (b.sort(function(e, t) {
                                                            return e.startTime - t.startTime < 0 ? -1 : 0;
                                                        }), s1(b, e, o))) : s1(null, e, o);
                                                    };
                                                    for(m = 0, v = g.length; m < v; m++)y = _, T = _ + g[m].referenced_size - 1, _ += g[m].referenced_size, E(e, n, {
                                                        start: y,
                                                        end: T
                                                    }, o, S, p);
                                                } else t.debug("Parsing segments from SIDX. representation " + n + " - id: " + e.id + " for range : " + p.range.start + " - " + p.range.end), h = function(e, t) {
                                                    for(var n, i, a1, o, s1 = e.references, u = s1.length, l = e.timescale, c = e.earliest_presentation_time, d = t.range.start + e.offset + e.first_offset + e.size, f = [], h = 0; h < u; h++)a1 = s1[h].subsegment_duration, o = s1[h].referenced_size, (n = new r.default).duration = a1, n.startTime = c, n.timescale = l, i = d + o - 1, n.mediaRange = d + "-" + i, f.push(n), c += a1, d += o;
                                                    return f;
                                                }(f, p), s1(h, e, o);
                                            } else {
                                                if (f) p.range.start = f.offset || p.range.start, p.range.end = p.range.start + (f.size || u);
                                                else {
                                                    if (l < p.bytesLoaded) return void s1(null, e, o);
                                                    var w = c.getLastBox();
                                                    w && w.size ? (p.range.start = w.offset + w.size, p.range.end = p.range.start + u) : p.range.end += u;
                                                }
                                                E(e, n, p.range, o, null, p);
                                            }
                                        },
                                        error: function() {
                                            s1(null, e, o);
                                        }
                                    }), t.debug("Perform SIDX load for type ".concat(n, " : ").concat(p.url, " with range ").concat(p.range.start, " - ").concat(p.range.end));
                                }
                                function T(e, t, n) {
                                    n({
                                        segments: e,
                                        representation: t,
                                        error: e ? void 0 : new i.default(f.SEGMENT_BASE_LOADER_ERROR_CODE, f.SEGMENT_BASE_LOADER_ERROR_MESSAGE)
                                    });
                                }
                                function b(e) {
                                    if (e.url) {
                                        var t = new o.default;
                                        return t.setInfo(e), t;
                                    }
                                }
                                return e = {
                                    setConfig: function(r) {
                                        r.baseURLController && (m = r.baseURLController), r.dashMetrics && (l = r.dashMetrics), r.mediaPlayerModel && (c = r.mediaPlayerModel), r.errHandler && (n = r.errHandler), r.boxParser && (a1 = r.boxParser), r.debug && (t = r.debug.getLogger(e)), r.requestModifier && (u = r.requestModifier), r.errors && (f = r.errors), r.urlUtils && (p = r.urlUtils), r.constants && (h = r.constants), r.dashConstants && (g = r.dashConstants);
                                    },
                                    initialize: function() {
                                        d = Object(s1.default)(v).create({
                                            errHandler: n,
                                            dashMetrics: l,
                                            mediaPlayerModel: c,
                                            requestModifier: u,
                                            boxParser: a1,
                                            errors: f,
                                            urlUtils: p,
                                            constants: h,
                                            dashConstants: g
                                        });
                                    },
                                    loadInitialization: function(e, t) {
                                        return new Promise(function(n) {
                                            y(e, t, n);
                                        });
                                    },
                                    loadSegments: function(e, t, n) {
                                        return new Promise(function(r) {
                                            E(e, t, n, r);
                                        });
                                    },
                                    reset: function() {
                                        d && (d.abort(), d = null);
                                    }
                                };
                            }
                            u.__dashjs_factory_name = "SegmentBaseLoader", t.default = a1.default.getSingletonFactory(u);
                        },
                        "./src/dash/WebmSegmentBaseLoader.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/utils/EBMLParser.js"), i = n("./src/streaming/constants/Constants.js"), a1 = n("./src/core/FactoryMaker.js"), o = n("./src/dash/vo/Segment.js"), s1 = n("./src/streaming/vo/FragmentRequest.js"), u = n("./src/streaming/net/URLLoader.js"), l = n("./src/streaming/vo/DashJSError.js");
                            function c() {
                                var e, t, n, a1, c, d, f, h, g, p, m = this.context;
                                function v(e) {
                                    var t = new s1.default;
                                    return t.setInfo(e), t;
                                }
                                return e = {
                                    setConfig: function(n) {
                                        if (!(n.baseURLController && n.dashMetrics && n.mediaPlayerModel && n.errHandler)) throw new Error(i.default.MISSING_CONFIG_ERROR);
                                        p = n.baseURLController, d = n.dashMetrics, f = n.mediaPlayerModel, a1 = n.errHandler, g = n.errors, t = n.debug.getLogger(e), c = n.requestModifier;
                                    },
                                    initialize: function() {
                                        h = Object(u.default)(m).create({
                                            errHandler: a1,
                                            dashMetrics: d,
                                            mediaPlayerModel: f,
                                            requestModifier: c,
                                            errors: g
                                        });
                                    },
                                    loadInitialization: function(e, n) {
                                        return new Promise(function(r) {
                                            var i = null, a1 = e ? p.resolve(e.path) : null, o = e ? e.range.split("-") : null, s1 = {
                                                range: {
                                                    start: o ? parseFloat(o[0]) : null,
                                                    end: o ? parseFloat(o[1]) : null
                                                },
                                                request: i,
                                                url: a1 ? a1.url : void 0,
                                                init: !0,
                                                mediaType: n
                                            };
                                            t.info("Start loading initialization."), i = v(s1), h.load({
                                                request: i,
                                                success: function() {
                                                    r(e);
                                                },
                                                error: function() {
                                                    r(e);
                                                }
                                            }), t.debug("Perform init load: " + s1.url);
                                        });
                                    },
                                    loadSegments: function(e, i, a1) {
                                        return new Promise(function(s1) {
                                            var u = null, c = e ? p.resolve(e.path) : null, d = c ? c.url : void 0;
                                            u = v({
                                                bytesLoaded: 0,
                                                bytesToLoad: 8192,
                                                range: {
                                                    start: 0,
                                                    end: 8192
                                                },
                                                request: u,
                                                url: d,
                                                init: !1,
                                                mediaType: i
                                            }), t.debug("Parsing ebml header"), h.load({
                                                request: u,
                                                success: function(i) {
                                                    !function(e, i, a1, s1) {
                                                        if (e && 0 !== e.byteLength) {
                                                            var u, l, c, d, f = Object(r.default)(m).create({
                                                                data: e
                                                            }), g = a1 ? a1.split("-") : null, p = null, y = {
                                                                url: i,
                                                                range: {
                                                                    start: g ? parseFloat(g[0]) : null,
                                                                    end: g ? parseFloat(g[1]) : null
                                                                },
                                                                request: p
                                                            };
                                                            for(t.debug("Parse EBML header: " + y.url), f.skipOverElement(n.EBML), f.consumeTag(n.Segment), c = f.getMatroskaCodedNum(), c += f.getPos(), d = f.getPos(); f.moreData() && !f.consumeTagAndSize(n.Segment.Info, !0);)if (!(f.skipOverElement(n.Segment.SeekHead, !0) || f.skipOverElement(n.Segment.Tracks, !0) || f.skipOverElement(n.Segment.Cues, !0) || f.skipOverElement(n.Void, !0))) throw new Error("no valid top level element found");
                                                            for(; void 0 === u;){
                                                                var E = f.getMatroskaCodedNum(!0), T = f.getMatroskaCodedNum();
                                                                E === n.Segment.Info.Duration.tag ? u = f[n.Segment.Info.Duration.parse](T) : f.setPos(f.getPos() + T);
                                                            }
                                                            p = v(y), h.load({
                                                                request: p,
                                                                success: function(e) {
                                                                    l = function(e, i, a1, s1) {
                                                                        var u, l, c, d, f, h, g, p;
                                                                        for(c = [], f = 0, h = (l = function(e) {
                                                                            var t, i, a1 = [], o = Object(r.default)(m).create({
                                                                                data: e
                                                                            });
                                                                            for(o.consumeTagAndSize(n.Segment.Cues); o.moreData() && o.consumeTagAndSize(n.Segment.Cues.CuePoint, !0);){
                                                                                for((t = {}).CueTime = o.parseTag(n.Segment.Cues.CuePoint.CueTime), t.CueTracks = []; o.moreData() && o.consumeTag(n.Segment.Cues.CuePoint.CueTrackPositions, !0);){
                                                                                    var s1 = o.getMatroskaCodedNum(), u = o.getPos();
                                                                                    if ((i = {}).Track = o.parseTag(n.Segment.Cues.CuePoint.CueTrackPositions.CueTrack), 0 === i.Track) throw new Error("Cue track cannot be 0");
                                                                                    i.ClusterPosition = o.parseTag(n.Segment.Cues.CuePoint.CueTrackPositions.CueClusterPosition), t.CueTracks.push(i), o.setPos(u + s1);
                                                                                }
                                                                                if (0 === t.CueTracks.length) throw new Error("Mandatory cuetrack not found");
                                                                                a1.push(t);
                                                                            }
                                                                            if (0 === a1.length) throw new Error("mandatory cuepoint not found");
                                                                            return a1;
                                                                        }(e)).length; f < h; f += 1)d = new o.default, u = f < l.length - 1 ? l[f + 1].CueTime - l[f].CueTime : s1 - l[f].CueTime, d.duration = u, d.startTime = l[f].CueTime, d.timescale = 1e3, g = l[f].CueTracks[0].ClusterPosition + i, p = f < l.length - 1 ? l[f + 1].CueTracks[0].ClusterPosition + i - 1 : a1 - 1, d.mediaRange = g + "-" + p, c.push(d);
                                                                        return t.debug("Parsed cues: " + c.length + " cues."), c;
                                                                    }(e, d, c, u), s1(l);
                                                                },
                                                                error: function() {
                                                                    t.error("Download Error: Cues " + y.url), s1(null);
                                                                }
                                                            }), t.debug("Perform cues load: " + y.url + " bytes=" + y.range.start + "-" + y.range.end);
                                                        } else s1(null);
                                                    }(i, d, a1, function(t) {
                                                        s1({
                                                            segments: t,
                                                            representation: e,
                                                            error: t ? void 0 : new l.default(g.SEGMENT_BASE_LOADER_ERROR_CODE, g.SEGMENT_BASE_LOADER_ERROR_MESSAGE)
                                                        });
                                                    });
                                                },
                                                error: function() {
                                                    s1({
                                                        representation: e,
                                                        error: new l.default(g.SEGMENT_BASE_LOADER_ERROR_CODE, g.SEGMENT_BASE_LOADER_ERROR_MESSAGE)
                                                    });
                                                }
                                            });
                                        });
                                    },
                                    reset: function() {
                                        h && (h.abort(), h = null);
                                    }
                                }, n = {
                                    EBML: {
                                        tag: 440786851,
                                        required: !0
                                    },
                                    Segment: {
                                        tag: 408125543,
                                        required: !0,
                                        SeekHead: {
                                            tag: 290298740,
                                            required: !0
                                        },
                                        Info: {
                                            tag: 357149030,
                                            required: !0,
                                            TimecodeScale: {
                                                tag: 2807729,
                                                required: !0,
                                                parse: "getMatroskaUint"
                                            },
                                            Duration: {
                                                tag: 17545,
                                                required: !0,
                                                parse: "getMatroskaFloat"
                                            }
                                        },
                                        Tracks: {
                                            tag: 374648427,
                                            required: !0
                                        },
                                        Cues: {
                                            tag: 475249515,
                                            required: !0,
                                            CuePoint: {
                                                tag: 187,
                                                required: !0,
                                                CueTime: {
                                                    tag: 179,
                                                    required: !0,
                                                    parse: "getMatroskaUint"
                                                },
                                                CueTrackPositions: {
                                                    tag: 183,
                                                    required: !0,
                                                    CueTrack: {
                                                        tag: 247,
                                                        required: !0,
                                                        parse: "getMatroskaUint"
                                                    },
                                                    CueClusterPosition: {
                                                        tag: 241,
                                                        required: !0,
                                                        parse: "getMatroskaUint"
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    Void: {
                                        tag: 236,
                                        required: !0
                                    }
                                }, e;
                            }
                            c.__dashjs_factory_name = "WebmSegmentBaseLoader", t.default = a1.default.getSingletonFactory(c);
                        },
                        "./src/dash/constants/DashConstants.js": function(e, t, n) {
                            "use strict";
                            function r(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            n.r(t);
                            var i = new (function() {
                                function e() {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), this.init();
                                }
                                var t, n;
                                return t = e, n = [
                                    {
                                        key: "init",
                                        value: function() {
                                            this.BASE_URL = "BaseURL", this.SEGMENT_BASE = "SegmentBase", this.SEGMENT_TEMPLATE = "SegmentTemplate", this.SEGMENT_LIST = "SegmentList", this.SEGMENT_URL = "SegmentURL", this.SEGMENT_TIMELINE = "SegmentTimeline", this.SEGMENT_PROFILES = "segmentProfiles", this.ADAPTATION_SET = "AdaptationSet", this.REPRESENTATION = "Representation", this.REPRESENTATION_INDEX = "RepresentationIndex", this.SUB_REPRESENTATION = "SubRepresentation", this.INITIALIZATION = "Initialization", this.INITIALIZATION_MINUS = "initialization", this.MPD = "MPD", this.PERIOD = "Period", this.ASSET_IDENTIFIER = "AssetIdentifier", this.EVENT_STREAM = "EventStream", this.ID = "id", this.PROFILES = "profiles", this.SERVICE_LOCATION = "serviceLocation", this.RANGE = "range", this.INDEX = "index", this.MEDIA = "media", this.BYTE_RANGE = "byteRange", this.INDEX_RANGE = "indexRange", this.MEDIA_RANGE = "mediaRange", this.VALUE = "value", this.CONTENT_TYPE = "contentType", this.MIME_TYPE = "mimeType", this.BITSTREAM_SWITCHING = "BitstreamSwitching", this.BITSTREAM_SWITCHING_MINUS = "bitstreamSwitching", this.CODECS = "codecs", this.DEPENDENCY_ID = "dependencyId", this.MEDIA_STREAM_STRUCTURE_ID = "mediaStreamStructureId", this.METRICS = "Metrics", this.METRICS_MINUS = "metrics", this.REPORTING = "Reporting", this.WIDTH = "width", this.HEIGHT = "height", this.SAR = "sar", this.FRAMERATE = "frameRate", this.AUDIO_SAMPLING_RATE = "audioSamplingRate", this.MAXIMUM_SAP_PERIOD = "maximumSAPPeriod", this.START_WITH_SAP = "startWithSAP", this.MAX_PLAYOUT_RATE = "maxPlayoutRate", this.CODING_DEPENDENCY = "codingDependency", this.SCAN_TYPE = "scanType", this.FRAME_PACKING = "FramePacking", this.AUDIO_CHANNEL_CONFIGURATION = "AudioChannelConfiguration", this.CONTENT_PROTECTION = "ContentProtection", this.ESSENTIAL_PROPERTY = "EssentialProperty", this.SUPPLEMENTAL_PROPERTY = "SupplementalProperty", this.INBAND_EVENT_STREAM = "InbandEventStream", this.PRODUCER_REFERENCE_TIME = "ProducerReferenceTime", this.ACCESSIBILITY = "Accessibility", this.ROLE = "Role", this.RATING = "Rating", this.CONTENT_COMPONENT = "ContentComponent", this.SUBSET = "Subset", this.LANG = "lang", this.VIEWPOINT = "Viewpoint", this.ROLE_ASARRAY = "Role_asArray", this.REPRESENTATION_ASARRAY = "Representation_asArray", this.PRODUCERREFERENCETIME_ASARRAY = "ProducerReferenceTime_asArray", this.ACCESSIBILITY_ASARRAY = "Accessibility_asArray", this.AUDIOCHANNELCONFIGURATION_ASARRAY = "AudioChannelConfiguration_asArray", this.CONTENTPROTECTION_ASARRAY = "ContentProtection_asArray", this.MAIN = "main", this.DYNAMIC = "dynamic", this.STATIC = "static", this.MEDIA_PRESENTATION_DURATION = "mediaPresentationDuration", this.MINIMUM_UPDATE_PERIOD = "minimumUpdatePeriod", this.CODEC_PRIVATE_DATA = "codecPrivateData", this.BANDWITH = "bandwidth", this.SOURCE_URL = "sourceURL", this.TIMESCALE = "timescale", this.DURATION = "duration", this.START_NUMBER = "startNumber", this.PRESENTATION_TIME_OFFSET = "presentationTimeOffset", this.AVAILABILITY_START_TIME = "availabilityStartTime", this.AVAILABILITY_END_TIME = "availabilityEndTime", this.TIMESHIFT_BUFFER_DEPTH = "timeShiftBufferDepth", this.MAX_SEGMENT_DURATION = "maxSegmentDuration", this.PRESENTATION_TIME = "presentationTime", this.MIN_BUFFER_TIME = "minBufferTime", this.MAX_SUBSEGMENT_DURATION = "maxSubsegmentDuration", this.START = "start", this.AVAILABILITY_TIME_OFFSET = "availabilityTimeOffset", this.AVAILABILITY_TIME_COMPLETE = "availabilityTimeComplete", this.CENC_DEFAULT_KID = "cenc:default_KID", this.DVB_PRIORITY = "dvb:priority", this.DVB_WEIGHT = "dvb:weight", this.SUGGESTED_PRESENTATION_DELAY = "suggestedPresentationDelay", this.SERVICE_DESCRIPTION = "ServiceDescription", this.SERVICE_DESCRIPTION_SCOPE = "Scope", this.SERVICE_DESCRIPTION_LATENCY = "Latency", this.SERVICE_DESCRIPTION_PLAYBACK_RATE = "PlaybackRate", this.SERVICE_DESCRIPTION_OPERATING_QUALITY = "OperatingQuality", this.SERVICE_DESCRIPTION_OPERATING_BANDWIDTH = "OperatingBandwidth", this.PATCH_LOCATION = "PatchLocation", this.PUBLISH_TIME = "publishTime", this.ORIGINAL_PUBLISH_TIME = "originalPublishTime", this.ORIGINAL_MPD_ID = "mpdId", this.WALL_CLOCK_TIME = "wallClockTime", this.PRESENTATION_TIME = "presentationTime", this.LABEL = "Label", this.GROUP_LABEL = "GroupLabel", this.CONTENT_STEERING = "ContentSteering", this.CONTENT_STEERING_AS_ARRAY = "ContentSteering_asArray", this.DEFAULT_SERVICE_LOCATION = "defaultServiceLocation", this.QUERY_BEFORE_START = "queryBeforeStart", this.PROXY_SERVER_URL = "proxyServerURL", this.CONTENT_STEERING_RESPONSE = {
                                                VERSION: "VERSION",
                                                TTL: "TTL",
                                                RELOAD_URI: "RELOAD-URI",
                                                SERVICE_LOCATION_PRIORITY: "SERVICE-LOCATION-PRIORITY"
                                            };
                                        }
                                    }
                                ], r(t.prototype, n), e;
                            }());
                            t.default = i;
                        },
                        "./src/dash/controllers/ContentSteeringController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/core/Debug.js"), a1 = n("./src/streaming/net/URLLoader.js"), o = n("./src/core/errors/Errors.js"), s1 = n("./src/dash/vo/ContentSteeringRequest.js"), u = n("./src/dash/vo/ContentSteeringResponse.js"), l = n("./src/dash/constants/DashConstants.js"), c = n("./src/streaming/MediaPlayerEvents.js"), d = n("./src/core/events/Events.js"), f = n("./src/streaming/constants/Constants.js"), h = n("./src/core/Utils.js"), g = n("./src/streaming/utils/URLUtils.js");
                            function p() {
                                var e, t, n, r, p, m, v, y, E, T, b, A, _, S, w, I = this.context, R = Object(g.default)(I).getInstance();
                                function C(e) {
                                    e && e.toStreamInfo && (r = e.toStreamInfo);
                                }
                                function D(e) {
                                    e && e.request && e.request.serviceLocation && (p = e.request.serviceLocation);
                                }
                                function k() {
                                    var e = b.getValue();
                                    return w.getContentSteering(e);
                                }
                                function N() {
                                    return new Promise(function(e) {
                                        try {
                                            var i = k();
                                            if (!i || !i.serverUrl) return void e();
                                            var a1 = function(e) {
                                                var t = e.proxyServerUrl ? e.proxyServerUrl : e.serverUrl;
                                                n && n.reloadUri && (t = R.isRelative(n.reloadUri) ? R.resolve(n.reloadUri, e.serverUrl) : n.reloadUri);
                                                var i = [];
                                                if (r) {
                                                    var a1 = w.getIsDynamic(), o = w.getAllMediaInfoForType(r, f.default.VIDEO).length > 0 ? f.default.VIDEO : f.default.AUDIO, s1 = _.getThroughputHistory(), u = s1 ? s1.getAverageThroughput(o, a1) : NaN;
                                                    isNaN(u) || i.push({
                                                        key: "_DASH_throughput",
                                                        value: 1e3 * u
                                                    });
                                                }
                                                return p && i.push({
                                                    key: "_DASH_pathway",
                                                    value: p
                                                }), e.proxyServerUrl && e.proxyServerUrl === t && e.serverUrl && i.push({
                                                    key: "url",
                                                    value: encodeURI(e.serverUrl)
                                                }), h.default.addAditionalQueryParameterToUrl(t, i);
                                            }(i), o = new s1.default(a1);
                                            v.load({
                                                request: o,
                                                success: function(t) {
                                                    !function(e) {
                                                        e && e[l.default.CONTENT_STEERING_RESPONSE.VERSION] && 1 === parseInt(e[l.default.CONTENT_STEERING_RESPONSE.VERSION]) && ((n = new u.default).version = e[l.default.CONTENT_STEERING_RESPONSE.VERSION], e[l.default.CONTENT_STEERING_RESPONSE.TTL] && !isNaN(e[l.default.CONTENT_STEERING_RESPONSE.TTL]) && (n.ttl = e[l.default.CONTENT_STEERING_RESPONSE.TTL]), e[l.default.CONTENT_STEERING_RESPONSE.RELOAD_URI] && (n.reloadUri = e[l.default.CONTENT_STEERING_RESPONSE.RELOAD_URI]), e[l.default.CONTENT_STEERING_RESPONSE.SERVICE_LOCATION_PRIORITY] && (n.serviceLocationPriority = e[l.default.CONTENT_STEERING_RESPONSE.SERVICE_LOCATION_PRIORITY]), L());
                                                    }(t), S.trigger(c.default.CONTENT_STEERING_REQUEST_COMPLETED, {
                                                        currentSteeringResponseData: n,
                                                        url: a1
                                                    }), e();
                                                },
                                                error: function(n) {
                                                    !function(e) {
                                                        t.warn("Error fetching data from content steering server", e), L();
                                                    }(n), e(n);
                                                }
                                            });
                                        } catch (t) {
                                            e(t);
                                        }
                                    });
                                }
                                function L() {
                                    n && n.ttl && !isNaN(n.ttl) && (m && clearTimeout(m), m = setTimeout(function() {
                                        N();
                                    }, 1e3 * n.ttl));
                                }
                                function x() {
                                    m && clearTimeout(m), m = null;
                                }
                                function M() {
                                    n = null, r = null, p = null, x();
                                }
                                return e = {
                                    reset: function() {
                                        M(), S.off(c.default.PERIOD_SWITCH_COMPLETED, C, e), S.off(d.default.FRAGMENT_LOADING_STARTED, D, e);
                                    },
                                    setConfig: function(e) {
                                        e && (e.adapter && (w = e.adapter), e.errHandler && (y = e.errHandler), e.dashMetrics && (E = e.dashMetrics), e.mediaPlayerModel && (T = e.mediaPlayerModel), e.requestModifier && (A = e.requestModifier), e.manifestModel && (b = e.manifestModel), e.abrController && (_ = e.abrController), e.eventBus && (S = e.eventBus));
                                    },
                                    loadSteeringData: N,
                                    getCurrentSteeringResponseData: function() {
                                        return n;
                                    },
                                    shouldQueryBeforeStart: function() {
                                        var e = k();
                                        return e && e.queryBeforeStart;
                                    },
                                    getSteeringDataFromManifest: k,
                                    stopSteeringRequestTimer: x,
                                    initialize: function() {
                                        v = Object(a1.default)(I).create({
                                            errHandler: y,
                                            dashMetrics: E,
                                            mediaPlayerModel: T,
                                            requestModifier: A,
                                            errors: o.default
                                        }), S.on(c.default.PERIOD_SWITCH_COMPLETED, C, e), S.on(d.default.FRAGMENT_LOADING_STARTED, D, e);
                                    }
                                }, t = Object(i.default)(I).getInstance().getLogger(e), M(), e;
                            }
                            p.__dashjs_factory_name = "ContentSteeringController", t.default = r.default.getSingletonFactory(p);
                        },
                        "./src/dash/controllers/RepresentationController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/Constants.js"), i = n("./src/core/FactoryMaker.js"), a1 = n("./src/streaming/MediaPlayerEvents.js"), o = n("./src/dash/utils/SegmentsUtils.js");
                            function s1(e) {
                                var t, n, i, s1, u, l = (e = e || {}).eventBus, c = e.events, d = e.abrController, f = e.dashMetrics, h = e.playbackController, g = e.timelineConverter, p = e.type, m = e.streamInfo, v = e.dashConstants, y = e.segmentsController, E = e.isDynamic;
                                function T() {
                                    return p;
                                }
                                function b() {
                                    if (!(d && f && h && g)) throw new Error(r.default.MISSING_CONFIG_ERROR);
                                }
                                function A() {
                                    return i;
                                }
                                function _() {
                                    return u;
                                }
                                function S() {
                                    n = null, i = !0, s1 = [];
                                }
                                function w(e) {
                                    return new Promise(function(t, n) {
                                        var r = e.hasInitialization(), i = e.hasSegments(), a1 = [];
                                        a1.push(y.updateInitData(e, r)), a1.push(y.updateSegmentData(e, i)), Promise.all(a1).then(function(n) {
                                            var r;
                                            n[0] && !n[0].error && (e = function(e, t) {
                                                return t && !t.error && t.representation ? t.representation : e;
                                            }(e, n[0])), n[1] && !n[1].error && (e = function(e, t) {
                                                if (t && !t.error) {
                                                    var n, r, i, a1, s1 = t.segments, u = [], l = 0;
                                                    for(n = 0, r = s1 ? s1.length : 0; n < r; n++)i = s1[n], (a1 = Object(o.getTimeBasedSegment)(g, E, e, i.startTime, i.duration, i.timescale, i.media, i.mediaRange, l)) && (u.push(a1), a1 = null, l++);
                                                    return u.length > 0 && (e.segments = u), e;
                                                }
                                            }(e, n[1])), (r = e).mediaFinishedInformation = y.getMediaFinishedInformation(r), function(e) {
                                                if (A()) {
                                                    var t, n, r = f.getCurrentManifestUpdate(), i = !1;
                                                    if (r) {
                                                        for(var a1 = 0; a1 < r.representationInfo.length; a1++)if ((t = r.representationInfo[a1]).index === e.index && t.mediaType === T()) {
                                                            i = !0;
                                                            break;
                                                        }
                                                        i || f.addManifestUpdateRepresentationInfo(e, T());
                                                    }
                                                    if (function() {
                                                        for(var e = 0, t = s1.length; e < t; e++){
                                                            var n = s1[e].segmentInfoType;
                                                            if (!s1[e].hasInitialization() || (n === v.SEGMENT_BASE || n === v.BASE_URL) && !s1[e].segments) return !1;
                                                        }
                                                        return !0;
                                                    }()) {
                                                        d.setPlaybackQuality(p, m, (n = u, s1.indexOf(n)));
                                                        var o = f.getCurrentDVRInfo(p);
                                                        o && f.updateManifestUpdateInfo({
                                                            latency: o.range.end - h.getTime()
                                                        }), f.getCurrentRepresentationSwitch(_().adaptation.type) || I(), C();
                                                    }
                                                }
                                            }(e), t();
                                        }).catch(function(e) {
                                            n(e);
                                        });
                                    });
                                }
                                function I() {
                                    b();
                                    var e = new Date, t = _(), n = 1e3 * h.getTime();
                                    t && f.addRepresentationSwitch(t.adaptation.type, e, n, t.id), l.trigger(a1.default.REPRESENTATION_SWITCH, {
                                        mediaType: p,
                                        streamId: m.id,
                                        currentRepresentation: t,
                                        numberOfRepresentations: s1.length
                                    }, {
                                        streamId: m.id,
                                        mediaType: p
                                    });
                                }
                                function R(e) {
                                    return null == e || e >= s1.length ? null : s1[e];
                                }
                                function C(e) {
                                    i = !1, l.trigger(c.DATA_UPDATE_COMPLETED, {
                                        data: n,
                                        currentRepresentation: u,
                                        error: e
                                    }, {
                                        streamId: m.id,
                                        mediaType: p
                                    });
                                }
                                function D(e) {
                                    u = e;
                                }
                                function k(e) {
                                    if (e.newDuration) {
                                        var t = _();
                                        t && t.adaptation.period && (t.adaptation.period.duration = e.newDuration);
                                    }
                                }
                                return t = {
                                    getStreamId: function() {
                                        return m.id;
                                    },
                                    getType: T,
                                    getData: function() {
                                        return n;
                                    },
                                    isUpdating: A,
                                    updateData: function(e, t, a1, o, u) {
                                        if (b(), i = !0, s1 = t, D(R(u)), n = e, a1 !== r.default.VIDEO && a1 !== r.default.AUDIO && (a1 !== r.default.TEXT || !o)) return C(), Promise.resolve();
                                        for(var l = [], c = 0, d = s1.length; c < d; c++){
                                            var f = s1[c];
                                            l.push(w(f));
                                        }
                                        return Promise.all(l);
                                    },
                                    getCurrentRepresentation: _,
                                    getRepresentationForQuality: R,
                                    prepareQualityChange: function(e) {
                                        D(R(e)), I();
                                    },
                                    reset: function() {
                                        l.off(a1.default.MANIFEST_VALIDITY_CHANGED, k, t), S();
                                    }
                                }, S(), l.on(a1.default.MANIFEST_VALIDITY_CHANGED, k, t), t;
                            }
                            s1.__dashjs_factory_name = "RepresentationController", t.default = i.default.getClassFactory(s1);
                        },
                        "./src/dash/controllers/SegmentBaseController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/dash/SegmentBaseLoader.js"), a1 = n("./src/dash/WebmSegmentBaseLoader.js");
                            function o(e) {
                                e = e || {};
                                var t, n, r, o = this.context, s1 = e.eventBus, u = e.events, l = e.dashMetrics, c = e.mediaPlayerModel, d = e.errHandler, f = e.baseURLController, h = e.debug, g = e.boxParser, p = e.requestModifier, m = e.errors;
                                function v(e) {
                                    return "webm" === (e ? e.split("/")[1] : "").toLowerCase();
                                }
                                return t = {
                                    initialize: function() {
                                        n.initialize(), r.initialize();
                                    },
                                    getSegmentBaseInitSegment: function(e) {
                                        return v(e.representation.mimeType) ? r.loadInitialization(e.representation, e.mediaType) : n.loadInitialization(e.representation, e.mediaType);
                                    },
                                    getSegmentList: function(e) {
                                        return v(e.mimeType) ? r.loadSegments(e.representation, e.mediaType, e.representation ? e.representation.indexRange : null) : n.loadSegments(e.representation, e.mediaType, e.representation ? e.representation.indexRange : null);
                                    },
                                    reset: function() {
                                        n.reset(), r.reset();
                                    }
                                }, n = Object(i.default)(o).getInstance(), r = Object(a1.default)(o).getInstance(), n.setConfig({
                                    baseURLController: f,
                                    dashMetrics: l,
                                    mediaPlayerModel: c,
                                    errHandler: d,
                                    eventBus: s1,
                                    events: u,
                                    errors: m,
                                    debug: h,
                                    boxParser: g,
                                    requestModifier: p
                                }), r.setConfig({
                                    baseURLController: f,
                                    dashMetrics: l,
                                    mediaPlayerModel: c,
                                    errHandler: d,
                                    eventBus: s1,
                                    events: u,
                                    errors: m,
                                    debug: h,
                                    requestModifier: p
                                }), t;
                            }
                            o.__dashjs_factory_name = "SegmentBaseController";
                            var s1 = r.default.getSingletonFactory(o);
                            t.default = s1;
                        },
                        "./src/dash/controllers/SegmentsController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/dash/utils/TimelineSegmentsGetter.js"), a1 = n("./src/dash/utils/TemplateSegmentsGetter.js"), o = n("./src/dash/utils/ListSegmentsGetter.js"), s1 = n("./src/dash/utils/SegmentBaseGetter.js");
                            function u(e) {
                                e = e || {};
                                var t, n, r = this.context, u = e.dashConstants, l = e.type, c = e.segmentBaseController;
                                function d(e) {
                                    return e ? e.segments ? n[u.SEGMENT_BASE] : n[e.segmentInfoType] : null;
                                }
                                return t = {
                                    initialize: function(t) {
                                        n[u.SEGMENT_TIMELINE] = Object(i.default)(r).create(e, t), n[u.SEGMENT_TEMPLATE] = Object(a1.default)(r).create(e, t), n[u.SEGMENT_LIST] = Object(o.default)(r).create(e, t), n[u.SEGMENT_BASE] = Object(s1.default)(r).create(e, t);
                                    },
                                    updateInitData: function(e, t) {
                                        return t ? Promise.resolve() : c.getSegmentBaseInitSegment({
                                            representation: e,
                                            mediaType: l
                                        });
                                    },
                                    updateSegmentData: function(e, t) {
                                        return t ? Promise.resolve() : c.getSegmentList({
                                            mimeType: e.mimeType,
                                            representation: e,
                                            mediaType: l
                                        });
                                    },
                                    getSegmentByIndex: function(e, t, n) {
                                        var r = d(e);
                                        return r ? r.getSegmentByIndex(e, t, n) : null;
                                    },
                                    getSegmentByTime: function(e, t) {
                                        var n = d(e);
                                        return n ? n.getSegmentByTime(e, t) : null;
                                    },
                                    getMediaFinishedInformation: function(e) {
                                        var t = d(e);
                                        return t ? t.getMediaFinishedInformation(e) : {
                                            numberOfSegments: 0,
                                            mediaTimeOfLastSignaledSegment: NaN
                                        };
                                    }
                                }, n = {}, t;
                            }
                            u.__dashjs_factory_name = "SegmentsController";
                            var l = r.default.getClassFactory(u);
                            t.default = l;
                        },
                        "./src/dash/controllers/ServiceDescriptionController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/core/Debug.js"), a1 = n("./src/streaming/constants/Constants.js"), o = n("./src/dash/constants/DashConstants.js"), s1 = [
                                a1.default.SERVICE_DESCRIPTION_DVB_LL_SCHEME
                            ], u = "video", l = "audio";
                            function c() {
                                var e, t, n, r, c, d = this.context;
                                function f() {
                                    t = {
                                        liveDelay: NaN,
                                        liveCatchup: {
                                            maxDrift: NaN,
                                            playbackRate: {
                                                min: NaN,
                                                max: NaN
                                            }
                                        },
                                        minBitrate: {},
                                        maxBitrate: {},
                                        initialBitrate: {}
                                    }, n = [];
                                }
                                function h(e, n, i) {
                                    try {
                                        t[e][n] = i / 1e3;
                                    } catch (e) {
                                        r.error(e);
                                    }
                                }
                                return e = {
                                    getServiceDescriptionSettings: function() {
                                        return t;
                                    },
                                    getProducerReferenceTimeOffsets: function() {
                                        return n;
                                    },
                                    calculateProducerReferenceTimeOffsets: function(e) {
                                        try {
                                            var t = [];
                                            if (e && e.length > 0) {
                                                var i = [
                                                    a1.default.VIDEO,
                                                    a1.default.AUDIO,
                                                    a1.default.TEXT
                                                ], s1 = c.getAvailabilityStartTime() / 1e3;
                                                e.forEach(function(e) {
                                                    var n = i.reduce(function(t, n) {
                                                        return t.concat(c.getAllMediaInfoForType(e, n));
                                                    }, []).reduce(function(t, n) {
                                                        return c.getProducerReferenceTimes(e, n).forEach(function(r) {
                                                            var i = c.getVoRepresentations(n);
                                                            if (i && i.length > 0 && i[0].adaptation && i[0].segmentInfoType === o.default.SEGMENT_TEMPLATE) {
                                                                var a1 = i[0], u = new Date(r[o.default.WALL_CLOCK_TIME]).getTime() / 1e3 - (r[o.default.PRESENTATION_TIME] / a1[o.default.TIMESCALE] - a1[o.default.PRESENTATION_TIME_OFFSET] + e.start), l = s1 - u;
                                                                t.push({
                                                                    id: r[o.default.ID],
                                                                    to: l
                                                                });
                                                            }
                                                        }), t;
                                                    }, []);
                                                    t = t.concat(n);
                                                });
                                            }
                                            n = t;
                                        } catch (e) {
                                            r.error(e), n = [];
                                        }
                                    },
                                    applyServiceDescription: function(e) {
                                        if (e && e.serviceDescriptions) {
                                            var i = e.serviceDescriptions.filter(function(e) {
                                                return s1.includes(e.schemeIdUri);
                                            }), o = e.serviceDescriptions.filter(function(e) {
                                                return null == e.schemeIdUri;
                                            }), c = i.length > 0 ? i[i.length - 1] : o[o.length - 1];
                                            c && (c.latency && c.latency.target > 0 && function(e) {
                                                var i;
                                                if (e.schemeIdUri, a1.default.SERVICE_DESCRIPTION_DVB_LL_SCHEME, i = function(e) {
                                                    return {
                                                        liveDelay: e.latency.target / 1e3,
                                                        maxDrift: !isNaN(e.latency.max) && e.latency.max > e.latency.target ? (e.latency.max - e.latency.target + 500) / 1e3 : NaN,
                                                        referenceId: e.latency.referenceId || NaN
                                                    };
                                                }(e), n.length > 0) {
                                                    var o = function(e) {
                                                        var t, r = 0, i = n.filter(function(t) {
                                                            return t.id === e.referenceId;
                                                        });
                                                        return 0 === i.length ? (r = n.length > 0 ? n[0].to : 0, t = n[0].id || NaN) : (r = i[0].to || 0, t = i[0].id || NaN), {
                                                            to: r,
                                                            id: t
                                                        };
                                                    }(i), s1 = o.to, u = o.id;
                                                    t.liveDelay = i.liveDelay - s1, t.liveCatchup.maxDrift = i.maxDrift, r.debug("\n                Found latency properties coming from service description. Applied time offset of ".concat(s1, " from ProducerReferenceTime element with id ").concat(u, ".\n                Live Delay: ").concat(i.liveDelay - s1, ", Live catchup max drift: ").concat(i.maxDrift, "\n            "));
                                                } else t.liveDelay = i.liveDelay, t.liveCatchup.maxDrift = i.maxDrift, r.debug("Found latency properties coming from service description: Live Delay: ".concat(i.liveDelay, ", Live catchup max drift: ").concat(i.maxDrift));
                                            }(c), c.playbackRate && function(e) {
                                                var n = e.playbackRate.min ? Math.round(1e3 * (e.playbackRate.min - 1)) / 1e3 : NaN, i = e.playbackRate.max ? Math.round(1e3 * (e.playbackRate.max - 1)) / 1e3 : NaN;
                                                t.liveCatchup.playbackRate.min = n, t.liveCatchup.playbackRate.max = i, r.debug("Found latency properties coming from service description: Live catchup min playback rate: ".concat(n)), r.debug("Found latency properties coming from service description: Live catchup max playback rate: ".concat(i));
                                            }(c), c.operatingQuality, c.operatingBandwidth && function(e) {
                                                if (e && e.operatingBandwidth && e.operatingBandwidth.mediaType && "all" !== e.operatingBandwidth.mediaType) {
                                                    var t = {};
                                                    t.minBandwidth = e.operatingBandwidth.min, t.maxBandwidth = e.operatingBandwidth.max, t.targetBandwidth = e.operatingBandwidth.target;
                                                    var n = [];
                                                    e.operatingBandwidth.mediaType === u || e.operatingBandwidth.mediaType === l ? n.push(e.operatingBandwidth.mediaType) : "any" === e.operatingBandwidth.mediaType && (n.push(l), n.push(u)), n.forEach(function(e) {
                                                        isNaN(t.minBandwidth) || h("minBitrate", e, t.minBandwidth), isNaN(t.maxBandwidth) || h("maxBitrate", e, t.maxBandwidth), isNaN(t.targetBandwidth) || h("initialBitrate", e, t.targetBandwidth);
                                                    });
                                                }
                                            }(c));
                                        }
                                    },
                                    reset: function() {
                                        f();
                                    },
                                    setConfig: function(e) {
                                        e && e.adapter && (c = e.adapter);
                                    }
                                }, r = Object(i.default)(d).getInstance().getLogger(e), f(), e;
                            }
                            c.__dashjs_factory_name = "ServiceDescriptionController", t.default = r.default.getSingletonFactory(c);
                        },
                        "./src/dash/models/DashManifestModel.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/Constants.js"), i = n("./src/dash/constants/DashConstants.js"), a1 = n("./src/dash/vo/Representation.js"), o = n("./src/dash/vo/AdaptationSet.js"), s1 = n("./src/dash/vo/Period.js"), u = n("./src/dash/vo/Mpd.js"), l = n("./src/dash/vo/UTCTiming.js"), c = n("./src/dash/vo/Event.js"), d = n("./src/dash/vo/BaseURL.js"), f = n("./src/dash/vo/EventStream.js"), h = n("./src/dash/vo/ProducerReferenceTime.js"), g = n("./src/dash/vo/ContentSteering.js"), p = n("./src/streaming/utils/ObjectUtils.js"), m = n("./src/streaming/utils/URLUtils.js"), v = n("./src/core/FactoryMaker.js"), y = n("./src/core/Debug.js"), E = n("./src/streaming/vo/DashJSError.js"), T = n("./src/core/errors/Errors.js"), b = n("./src/streaming/thumbnail/ThumbnailTracks.js");
                            function A(e, t) {
                                var n;
                                if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
                                    if (Array.isArray(e) || (n = _(e)) || t && e && "number" == typeof e.length) {
                                        n && (e = n);
                                        var r = 0, i = function() {};
                                        return {
                                            s: i,
                                            n: function() {
                                                return r >= e.length ? {
                                                    done: !0
                                                } : {
                                                    done: !1,
                                                    value: e[r++]
                                                };
                                            },
                                            e: function(e) {
                                                throw e;
                                            },
                                            f: i
                                        };
                                    }
                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }
                                var a1, o = !0, s1 = !1;
                                return {
                                    s: function() {
                                        n = e[Symbol.iterator]();
                                    },
                                    n: function() {
                                        var e = n.next();
                                        return o = e.done, e;
                                    },
                                    e: function(e) {
                                        s1 = !0, a1 = e;
                                    },
                                    f: function() {
                                        try {
                                            o || null == n.return || n.return();
                                        } finally{
                                            if (s1) throw a1;
                                        }
                                    }
                                };
                            }
                            function _(e, t) {
                                if (e) {
                                    if ("string" == typeof e) return S(e, t);
                                    var n = Object.prototype.toString.call(e).slice(8, -1);
                                    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? S(e, t) : void 0;
                                }
                            }
                            function S(e, t) {
                                (null == t || t > e.length) && (t = e.length);
                                for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                                return r;
                            }
                            function w() {
                                var e, t, n, v, w = this.context, I = Object(m.default)(w).getInstance(), R = Number.isInteger || function(e) {
                                    return "number" == typeof e && isFinite(e) && Math.floor(e) === e;
                                };
                                function C(e, t) {
                                    if (!e) throw new Error("adaptation is not defined");
                                    if (!t) throw new Error("type is not defined");
                                    if (e.Representation_asArray && e.Representation_asArray.length) {
                                        var n = F(e.Representation_asArray[0]);
                                        if (n && n.length > 0 && b.THUMBNAILS_SCHEME_ID_URIS.indexOf(n[0].schemeIdUri) >= 0) return t === r.default.IMAGE;
                                    }
                                    if (e.ContentComponent_asArray && e.ContentComponent_asArray.length > 0) {
                                        if (e.ContentComponent_asArray.length > 1) return t === r.default.MUXED;
                                        if (e.ContentComponent_asArray[0].contentType === t) return !0;
                                    }
                                    var a1 = t === r.default.TEXT ? new RegExp("(ttml|vtt|wvtt|stpp)") : new RegExp(t);
                                    if (e.Representation_asArray && e.Representation_asArray.length) {
                                        var o = e.Representation_asArray[0].codecs;
                                        if (a1.test(o)) return !0;
                                    }
                                    if (e.hasOwnProperty(i.default.MIME_TYPE)) return a1.test(e.mimeType);
                                    if (e.Representation_asArray) {
                                        for(var s1, u = 0; u < e.Representation_asArray.length; u++)if ((s1 = e.Representation_asArray[u]).hasOwnProperty(i.default.MIME_TYPE)) return a1.test(s1.mimeType);
                                    }
                                    return !1;
                                }
                                function D(e) {
                                    if (!e) throw new Error("adaptation is not defined");
                                    if (e.hasOwnProperty(i.default.SEGMENT_TEMPLATE) || e.hasOwnProperty(i.default.SEGMENT_TIMELINE) || e.hasOwnProperty(i.default.SEGMENT_LIST) || e.hasOwnProperty(i.default.SEGMENT_BASE)) return !0;
                                    if (e.Representation_asArray && e.Representation_asArray.length > 0) {
                                        var t = e.Representation_asArray[0];
                                        if (t.hasOwnProperty(i.default.SEGMENT_TEMPLATE) || t.hasOwnProperty(i.default.SEGMENT_TIMELINE) || t.hasOwnProperty(i.default.SEGMENT_LIST) || t.hasOwnProperty(i.default.SEGMENT_BASE)) return !0;
                                    }
                                    return !1;
                                }
                                function k(e) {
                                    return C(e, r.default.VIDEO);
                                }
                                function N(e) {
                                    return C(e, r.default.TEXT);
                                }
                                function L(e) {
                                    return C(e, r.default.IMAGE);
                                }
                                function x(e) {
                                    return e && Array.isArray(e.Representation_asArray) && e.Representation_asArray.sort(function(e, t) {
                                        return e.bandwidth - t.bandwidth;
                                    }), e;
                                }
                                function M(e, t) {
                                    return e && e.Period_asArray && R(t) && e.Period_asArray[t] ? e.Period_asArray[t].AdaptationSet_asArray : [];
                                }
                                function O(e) {
                                    return e && e.Period_asArray ? e.Period_asArray : [];
                                }
                                function P(e) {
                                    var t = !1;
                                    return e && e.hasOwnProperty("type") && (t = e.type === i.default.DYNAMIC), t;
                                }
                                function F(e) {
                                    return e && e.EssentialProperty_asArray && e.EssentialProperty_asArray.length ? e.EssentialProperty_asArray.map(function(e) {
                                        return {
                                            schemeIdUri: e.schemeIdUri,
                                            value: e.value
                                        };
                                    }) : null;
                                }
                                function U(e) {
                                    if (!e || !e.S_asArray) return NaN;
                                    var t = e.S_asArray[0], n = e.S_asArray[1];
                                    return t.hasOwnProperty("d") ? t.d : n.t - t.t;
                                }
                                function j(e, t) {
                                    if (!e) throw new Error("Period cannot be null or undefined");
                                    var n = s1.default.DEFAULT_ID + "_" + t;
                                    return e.hasOwnProperty(i.default.ID) && e.id.length > 0 && "__proto__" !== e.id && (n = e.id), n;
                                }
                                function B(e, t, n) {
                                    var a1, o = [];
                                    if (!e) return o;
                                    for(a1 = 0; a1 < e.length; a1++){
                                        var s1 = new f.default;
                                        if (s1.timescale = 1, s1.representation = t, !e[a1].hasOwnProperty(r.default.SCHEME_ID_URI)) throw new Error("Invalid EventStream. SchemeIdUri has to be set");
                                        s1.schemeIdUri = e[a1].schemeIdUri, e[a1].hasOwnProperty(i.default.TIMESCALE) && (s1.timescale = e[a1].timescale), e[a1].hasOwnProperty(i.default.VALUE) && (s1.value = e[a1].value), o.push(s1), s1.period = n;
                                    }
                                    return o;
                                }
                                function G(e) {
                                    var t = [], n = e.BaseURL_asArray || [
                                        e.baseUri
                                    ], r = !1;
                                    return n.some(function(n) {
                                        if (n) {
                                            var a1 = new d.default, o = n.__text || n;
                                            return I.isRelative(o) && (r = !0, e.baseUri && (o = I.resolve(o, e.baseUri))), a1.url = o, n.hasOwnProperty(i.default.SERVICE_LOCATION) && n.serviceLocation.length ? a1.serviceLocation = n.serviceLocation : a1.serviceLocation = o, n.hasOwnProperty(i.default.DVB_PRIORITY) && (a1.dvb_priority = n[i.default.DVB_PRIORITY]), n.hasOwnProperty(i.default.DVB_WEIGHT) && (a1.dvb_weight = n[i.default.DVB_WEIGHT]), n.hasOwnProperty(i.default.AVAILABILITY_TIME_OFFSET) && (a1.availabilityTimeOffset = n[i.default.AVAILABILITY_TIME_OFFSET]), n.hasOwnProperty(i.default.AVAILABILITY_TIME_COMPLETE) && (a1.availabilityTimeComplete = "false" !== n[i.default.AVAILABILITY_TIME_COMPLETE]), t.push(a1), r;
                                        }
                                    }), t;
                                }
                                return e = {
                                    getIsTypeOf: C,
                                    getIsText: N,
                                    getIsFragmented: D,
                                    getProducerReferenceTimesForAdaptation: function(e) {
                                        var t = e && e.hasOwnProperty(i.default.PRODUCERREFERENCETIME_ASARRAY) ? e[i.default.PRODUCERREFERENCETIME_ASARRAY] : [];
                                        (e && e.hasOwnProperty(i.default.REPRESENTATION_ASARRAY) ? e[i.default.REPRESENTATION_ASARRAY] : []).forEach(function(e) {
                                            var n;
                                            e.hasOwnProperty(i.default.PRODUCERREFERENCETIME_ASARRAY) && t.push.apply(t, function(e) {
                                                if (Array.isArray(e)) return S(e);
                                            }(n = e[i.default.PRODUCERREFERENCETIME_ASARRAY]) || function(e) {
                                                if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
                                            }(n) || _(n) || function() {
                                                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                            }());
                                        });
                                        var n = [];
                                        return t.forEach(function(e) {
                                            var t = new h.default;
                                            e.hasOwnProperty(i.default.ID) && (t[i.default.ID] = e[i.default.ID], e.hasOwnProperty(i.default.WALL_CLOCK_TIME) && (t[i.default.WALL_CLOCK_TIME] = e[i.default.WALL_CLOCK_TIME], e.hasOwnProperty(i.default.PRESENTATION_TIME) && (t[i.default.PRESENTATION_TIME] = e[i.default.PRESENTATION_TIME], n.push(t))));
                                        }), n;
                                    },
                                    getLanguageForAdaptation: function(e) {
                                        var t = "";
                                        return e && e.hasOwnProperty(i.default.LANG) && (t = e.lang), t;
                                    },
                                    getViewpointForAdaptation: function(e) {
                                        return e && e.hasOwnProperty(i.default.VIEWPOINT) ? e.Viewpoint : null;
                                    },
                                    getRolesForAdaptation: function(e) {
                                        return e && e.hasOwnProperty(i.default.ROLE_ASARRAY) ? e.Role_asArray : [];
                                    },
                                    getAccessibilityForAdaptation: function(e) {
                                        return e && e.hasOwnProperty(i.default.ACCESSIBILITY_ASARRAY) ? e.Accessibility_asArray : [];
                                    },
                                    getAudioChannelConfigurationForAdaptation: function(e) {
                                        return e && e.hasOwnProperty(i.default.AUDIOCHANNELCONFIGURATION_ASARRAY) ? e.AudioChannelConfiguration_asArray : [];
                                    },
                                    getAudioChannelConfigurationForRepresentation: function(e) {
                                        return e && e.hasOwnProperty(i.default.AUDIOCHANNELCONFIGURATION_ASARRAY) ? e.AudioChannelConfiguration_asArray : [];
                                    },
                                    getAdaptationForIndex: function(e, t, n) {
                                        var r = M(t, n);
                                        return r.length > 0 && R(e) ? r[e] : null;
                                    },
                                    getIndexForAdaptation: function(e, t, n) {
                                        if (!e) return -1;
                                        for(var r = M(t, n), i = 0; i < r.length; i++)if (Object(p.default)(w).getInstance().areEqual(r[i], e)) return i;
                                        return -1;
                                    },
                                    getAdaptationForId: function(e, t, n) {
                                        var r, a1, o = M(t, n);
                                        for(r = 0, a1 = o.length; r < a1; r++)if (o[r].hasOwnProperty(i.default.ID) && o[r].id === e) return o[r];
                                        return null;
                                    },
                                    getAdaptationsForType: function(e, t, n) {
                                        var r, i, a1 = M(e, t), o = [];
                                        for(r = 0, i = a1.length; r < i; r++)C(a1[r], n) && o.push(x(a1[r]));
                                        return o;
                                    },
                                    getRealPeriods: O,
                                    getRealPeriodForIndex: function(e, t) {
                                        var n = O(t);
                                        return n.length > 0 && R(e) ? n[e] : null;
                                    },
                                    getCodec: function(e, t, n) {
                                        var r = null;
                                        if (e && e.Representation_asArray && e.Representation_asArray.length > 0) {
                                            var i = R(t) && t >= 0 && t < e.Representation_asArray.length ? e.Representation_asArray[t] : e.Representation_asArray[0];
                                            i && (r = i.mimeType + ';codecs="' + i.codecs + '"', n && void 0 !== i.width && (r += ';width="' + i.width + '";height="' + i.height + '"'));
                                        }
                                        return r && (r = r.replace(/\sprofiles=[^;]*/g, "")), r;
                                    },
                                    getSelectionPriority: function(e) {
                                        try {
                                            var t = e && void 0 !== e.selectionPriority ? parseInt(e.selectionPriority) : 1;
                                            return isNaN(t) ? 1 : t;
                                        } catch (e) {
                                            return 1;
                                        }
                                    },
                                    getMimeType: function(e) {
                                        return e && e.Representation_asArray && e.Representation_asArray.length > 0 ? e.Representation_asArray[0].mimeType : null;
                                    },
                                    getKID: function(e) {
                                        return e && e.hasOwnProperty(i.default.CENC_DEFAULT_KID) ? e[i.default.CENC_DEFAULT_KID] : null;
                                    },
                                    getLabelsForAdaptation: function(e) {
                                        if (!e || !Array.isArray(e.Label_asArray)) return [];
                                        for(var t = [], n = 0; n < e.Label_asArray.length; n++)t.push({
                                            lang: e.Label_asArray[n].lang,
                                            text: e.Label_asArray[n].__text || e.Label_asArray[n]
                                        });
                                        return t;
                                    },
                                    getContentProtectionData: function(e) {
                                        return e && e.hasOwnProperty(i.default.CONTENTPROTECTION_ASARRAY) && 0 !== e.ContentProtection_asArray.length ? e.ContentProtection_asArray : null;
                                    },
                                    getIsDynamic: P,
                                    getId: function(e) {
                                        return e && e[i.default.ID] || null;
                                    },
                                    hasProfile: function(e, t) {
                                        var n = !1;
                                        return e && e.profiles && e.profiles.length > 0 && (n = -1 !== e.profiles.indexOf(t)), n;
                                    },
                                    getDuration: function(e) {
                                        return e && e.hasOwnProperty(i.default.MEDIA_PRESENTATION_DURATION) ? e.mediaPresentationDuration : e && "dynamic" == e.type ? Number.POSITIVE_INFINITY : Number.MAX_SAFE_INTEGER || Number.MAX_VALUE;
                                    },
                                    getBandwidth: function(e) {
                                        return e && e.bandwidth ? e.bandwidth : NaN;
                                    },
                                    getManifestUpdatePeriod: function(e) {
                                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = NaN;
                                        return e && e.hasOwnProperty(i.default.MINIMUM_UPDATE_PERIOD) && (n = e.minimumUpdatePeriod), isNaN(n) ? n : Math.max(n - t, 1);
                                    },
                                    getPublishTime: function(e) {
                                        return e && e.hasOwnProperty(i.default.PUBLISH_TIME) ? new Date(e[i.default.PUBLISH_TIME]) : null;
                                    },
                                    getRepresentationCount: function(e) {
                                        return e && Array.isArray(e.Representation_asArray) ? e.Representation_asArray.length : 0;
                                    },
                                    getBitrateListForAdaptation: function(e) {
                                        var t = x(e);
                                        return (t && Array.isArray(t.Representation_asArray) ? t.Representation_asArray : []).map(function(e) {
                                            return {
                                                bandwidth: e.bandwidth,
                                                width: e.width || 0,
                                                height: e.height || 0,
                                                scanType: e.scanType || null,
                                                id: e.id || null
                                            };
                                        });
                                    },
                                    getRepresentationFor: function(e, t) {
                                        return t && t.Representation_asArray && t.Representation_asArray.length > 0 && R(e) ? t.Representation_asArray[e] : null;
                                    },
                                    getRepresentationsForAdaptation: function(e) {
                                        var t, n, r, o, s1 = [], u = function(e) {
                                            if (e && e.period && R(e.period.index)) {
                                                var t = e.period.mpd.manifest.Period_asArray[e.period.index];
                                                if (t && t.AdaptationSet_asArray && R(e.index)) return x(t.AdaptationSet_asArray[e.index]);
                                            }
                                        }(e);
                                        if (u && u.Representation_asArray) {
                                            if (e && e.period && R(e.period.index)) {
                                                var l = G(e.period.mpd.manifest);
                                                l && (n = l[0]);
                                            }
                                            for(var c = 0, d = u.Representation_asArray.length; c < d; ++c){
                                                var f = u.Representation_asArray[c], h = new a1.default;
                                                if (h.index = c, h.adaptation = e, f.hasOwnProperty(i.default.ID) && (h.id = f.id), f.hasOwnProperty(i.default.CODECS) && (h.codecs = f.codecs), f.hasOwnProperty(i.default.MIME_TYPE) && (h.mimeType = f[i.default.MIME_TYPE]), f.hasOwnProperty(i.default.CODEC_PRIVATE_DATA) && (h.codecPrivateData = f.codecPrivateData), f.hasOwnProperty(i.default.BANDWITH) && (h.bandwidth = f.bandwidth), f.hasOwnProperty(i.default.WIDTH) && (h.width = f.width), f.hasOwnProperty(i.default.HEIGHT) && (h.height = f.height), f.hasOwnProperty(i.default.SCAN_TYPE) && (h.scanType = f.scanType), f.hasOwnProperty(i.default.MAX_PLAYOUT_RATE) && (h.maxPlayoutRate = f.maxPlayoutRate), f.hasOwnProperty(i.default.SEGMENT_BASE) ? (t = f.SegmentBase, h.segmentInfoType = i.default.SEGMENT_BASE) : f.hasOwnProperty(i.default.SEGMENT_LIST) ? (t = f.SegmentList).hasOwnProperty(i.default.SEGMENT_TIMELINE) ? h.segmentInfoType = i.default.SEGMENT_TIMELINE : h.segmentInfoType = i.default.SEGMENT_LIST : f.hasOwnProperty(i.default.SEGMENT_TEMPLATE) ? ((t = f.SegmentTemplate).hasOwnProperty(i.default.SEGMENT_TIMELINE) ? h.segmentInfoType = i.default.SEGMENT_TIMELINE : h.segmentInfoType = i.default.SEGMENT_TEMPLATE, t.hasOwnProperty(i.default.INITIALIZATION_MINUS) && (h.initialization = t.initialization.split("$Bandwidth$").join(f.bandwidth).split("$RepresentationID$").join(f.id))) : h.segmentInfoType = i.default.BASE_URL, h.essentialProperties = F(f), t) {
                                                    if (t.hasOwnProperty(i.default.INITIALIZATION)) {
                                                        var g = t.Initialization;
                                                        g.hasOwnProperty(i.default.SOURCE_URL) && (h.initialization = g.sourceURL), g.hasOwnProperty(i.default.RANGE) && (h.range = g.range);
                                                    } else N(u) && D(u) && u.mimeType && -1 === u.mimeType.indexOf("application/mp4") && (h.range = 0);
                                                    t.hasOwnProperty(i.default.TIMESCALE) && (h.timescale = t.timescale), t.hasOwnProperty(i.default.DURATION) ? h.segmentDuration = t.duration / h.timescale : f.hasOwnProperty(i.default.SEGMENT_TEMPLATE) && (t = f.SegmentTemplate).hasOwnProperty(i.default.SEGMENT_TIMELINE) && (h.segmentDuration = U(t.SegmentTimeline) / h.timescale), t.hasOwnProperty(i.default.MEDIA) && (h.media = t.media), t.hasOwnProperty(i.default.START_NUMBER) && (h.startNumber = t.startNumber), t.hasOwnProperty(i.default.INDEX_RANGE) && (h.indexRange = t.indexRange), t.hasOwnProperty(i.default.PRESENTATION_TIME_OFFSET) && (h.presentationTimeOffset = t.presentationTimeOffset / h.timescale), t.hasOwnProperty(i.default.AVAILABILITY_TIME_OFFSET) ? h.availabilityTimeOffset = t.availabilityTimeOffset : n && void 0 !== n.availabilityTimeOffset && (h.availabilityTimeOffset = n.availabilityTimeOffset), t.hasOwnProperty(i.default.AVAILABILITY_TIME_COMPLETE) ? h.availabilityTimeComplete = "false" !== t.availabilityTimeComplete : n && void 0 !== n.availabilityTimeComplete && (h.availabilityTimeComplete = n.availabilityTimeComplete);
                                                }
                                                h.MSETimeOffset = (o = (r = h).presentationTimeOffset, r.adaptation.period.start - o), h.path = [
                                                    e.period.index,
                                                    e.index,
                                                    c
                                                ], s1.push(h);
                                            }
                                        }
                                        return s1;
                                    },
                                    getAdaptationsForPeriod: function(e) {
                                        var n, a1, s1, u = e && R(e.index) ? e.mpd.manifest.Period_asArray[e.index] : null, l = [];
                                        if (u && u.AdaptationSet_asArray) for(s1 = 0; s1 < u.AdaptationSet_asArray.length; s1++)a1 = u.AdaptationSet_asArray[s1], n = new o.default, a1.hasOwnProperty(i.default.ID) && (n.id = a1.id), n.index = s1, n.period = e, C(a1, r.default.MUXED) ? n.type = r.default.MUXED : C(a1, r.default.AUDIO) ? n.type = r.default.AUDIO : k(a1) ? n.type = r.default.VIDEO : N(a1) ? n.type = r.default.TEXT : L(a1) ? n.type = r.default.IMAGE : t.warn("Unknown Adaptation stream type"), l.push(n);
                                        return l;
                                    },
                                    getRegularPeriods: function(e) {
                                        var a1, o, u = !!e && P(e.manifest), l = [], c = null, d = null, f = null, h = null;
                                        for(o = 0, a1 = e && e.manifest && e.manifest.Period_asArray ? e.manifest.Period_asArray.length : 0; o < a1; o++)(d = e.manifest.Period_asArray[o]).hasOwnProperty(i.default.START) ? (h = new s1.default).start = d.start : null !== c && c.hasOwnProperty(i.default.DURATION) && null !== f ? (h = new s1.default).start = parseFloat((f.start + f.duration).toFixed(5)) : 0 !== o || u || ((h = new s1.default).start = 0), null !== f && isNaN(f.duration) && (null !== h ? f.duration = parseFloat((h.start - f.start).toFixed(5)) : t.warn("First period duration could not be calculated because lack of start and duration period properties. This will cause timing issues during playback")), null !== h && (h.id = j(d, o), h.index = o, h.mpd = e, d.hasOwnProperty(i.default.DURATION) && (h.duration = d.duration), f && (f.nextPeriodId = h.id), l.push(h), c = d, f = h), d = null, h = null;
                                        return 0 === l.length || null !== f && isNaN(f.duration) && (f.duration = parseFloat(((function(e) {
                                            !function() {
                                                if (!n || !n.hasOwnProperty("error")) throw new Error(r.default.MISSING_CONFIG_ERROR);
                                            }();
                                            var t, i = P(e.mpd.manifest);
                                            return e.mpd.manifest.mediaPresentationDuration ? t = e.mpd.manifest.mediaPresentationDuration : e.duration ? t = e.duration : i ? t = Number.POSITIVE_INFINITY : n.error(new E.default(T.default.MANIFEST_ERROR_ID_PARSE_CODE, "Must have @mediaPresentationDuration on MPD or an explicit @duration on the last period.", e)), t;
                                        })(f) - f.start).toFixed(5))), l;
                                    },
                                    getMpd: function(e) {
                                        var t = new u.default;
                                        return e && (t.manifest = e, e.hasOwnProperty(i.default.AVAILABILITY_START_TIME) ? t.availabilityStartTime = new Date(e.availabilityStartTime.getTime()) : e.loadedTime && (t.availabilityStartTime = new Date(e.loadedTime.getTime())), e.hasOwnProperty(i.default.AVAILABILITY_END_TIME) && (t.availabilityEndTime = new Date(e.availabilityEndTime.getTime())), e.hasOwnProperty(i.default.MINIMUM_UPDATE_PERIOD) && (t.minimumUpdatePeriod = e.minimumUpdatePeriod), e.hasOwnProperty(i.default.MEDIA_PRESENTATION_DURATION) && (t.mediaPresentationDuration = e.mediaPresentationDuration), e.hasOwnProperty(i.default.SUGGESTED_PRESENTATION_DELAY) && (t.suggestedPresentationDelay = e.suggestedPresentationDelay), e.hasOwnProperty(i.default.TIMESHIFT_BUFFER_DEPTH) && (t.timeShiftBufferDepth = e.timeShiftBufferDepth), e.hasOwnProperty(i.default.MAX_SEGMENT_DURATION) && (t.maxSegmentDuration = e.maxSegmentDuration), e.hasOwnProperty(i.default.PUBLISH_TIME) && (t.publishTime = new Date(e.publishTime))), t;
                                    },
                                    getEventsForPeriod: function(e) {
                                        var t, n, a1 = e && e.mpd && e.mpd.manifest ? e.mpd.manifest : null, o = a1 ? a1.Period_asArray : null, s1 = o && e && R(e.index) ? o[e.index].EventStream_asArray : null, u = [];
                                        if (s1) for(t = 0; t < s1.length; t++){
                                            var l = new f.default;
                                            if (l.period = e, l.timescale = 1, !s1[t].hasOwnProperty(r.default.SCHEME_ID_URI)) throw new Error("Invalid EventStream. SchemeIdUri has to be set");
                                            for(l.schemeIdUri = s1[t][r.default.SCHEME_ID_URI], s1[t].hasOwnProperty(i.default.TIMESCALE) && (l.timescale = s1[t][i.default.TIMESCALE]), s1[t].hasOwnProperty(i.default.VALUE) && (l.value = s1[t][i.default.VALUE]), s1[t].hasOwnProperty(i.default.PRESENTATION_TIME_OFFSET) && (l.presentationTimeOffset = s1[t][i.default.PRESENTATION_TIME_OFFSET]), n = 0; s1[t].Event_asArray && n < s1[t].Event_asArray.length; n++){
                                                var d = s1[t].Event_asArray[n], h = new c.default;
                                                h.presentationTime = 0, h.eventStream = l, d.hasOwnProperty(i.default.PRESENTATION_TIME) && (h.presentationTime = d.presentationTime);
                                                var g = l.presentationTimeOffset ? l.presentationTimeOffset / l.timescale : 0;
                                                h.calculatedPresentationTime = h.presentationTime / l.timescale + e.start - g, d.hasOwnProperty(i.default.DURATION) && (h.duration = d.duration / l.timescale), d.hasOwnProperty(i.default.ID) ? h.id = d.id : h.id = null, d.Signal && d.Signal.Binary ? h.messageData = v.decodeArray(d.Signal.Binary.toString()) : h.messageData = d.messageData || d.__cdata || d.__text, u.push(h);
                                            }
                                        }
                                        return u;
                                    },
                                    getEssentialPropertiesForRepresentation: F,
                                    getEventStreamForAdaptationSet: function(e, t, n) {
                                        var r, i, a1;
                                        return e && e.Period_asArray && t && t.period && R(t.period.index) && (i = e.Period_asArray[t.period.index]) && i.AdaptationSet_asArray && R(t.index) && (a1 = i.AdaptationSet_asArray[t.index]) && (r = a1.InbandEventStream_asArray), B(r, null, n);
                                    },
                                    getEventStreamForRepresentation: function(e, t, n) {
                                        var r, i, a1, o;
                                        return e && e.Period_asArray && t && t.adaptation && t.adaptation.period && R(t.adaptation.period.index) && (i = e.Period_asArray[t.adaptation.period.index]) && i.AdaptationSet_asArray && R(t.adaptation.index) && (a1 = i.AdaptationSet_asArray[t.adaptation.index]) && a1.Representation_asArray && R(t.index) && (o = a1.Representation_asArray[t.index]) && (r = o.InbandEventStream_asArray), B(r, t, n);
                                    },
                                    getUTCTimingSources: function(e) {
                                        var t = P(e), n = !!e && e.hasOwnProperty(i.default.AVAILABILITY_START_TIME), a1 = e ? e.UTCTiming_asArray : null, o = [];
                                        return (t || n) && a1 && a1.forEach(function(e) {
                                            var t = new l.default;
                                            e.hasOwnProperty(r.default.SCHEME_ID_URI) && (t.schemeIdUri = e.schemeIdUri, e.hasOwnProperty(i.default.VALUE) && (t.value = e.value.toString(), o.push(t)));
                                        }), o;
                                    },
                                    getBaseURLsFromElement: G,
                                    getRepresentationSortFunction: function() {
                                        return function(e, t) {
                                            return e.bandwidth - t.bandwidth;
                                        };
                                    },
                                    getContentSteering: function(e) {
                                        if (e && e.hasOwnProperty(i.default.CONTENT_STEERING_AS_ARRAY)) {
                                            var t = e[i.default.CONTENT_STEERING_AS_ARRAY][0], n = new g.default;
                                            return n.serverUrl = t.__text, t.hasOwnProperty(i.default.DEFAULT_SERVICE_LOCATION) && (n.defaultServiceLocation = t[i.default.DEFAULT_SERVICE_LOCATION]), t.hasOwnProperty(i.default.QUERY_BEFORE_START) && (n.queryBeforeStart = "true" === t[i.default.QUERY_BEFORE_START].toLowerCase()), t.hasOwnProperty(i.default.PROXY_SERVER_URL) && (n.proxyServerUrl = t[i.default.PROXY_SERVER_URL]), n;
                                        }
                                    },
                                    getLocation: function(e) {
                                        if (e && e.hasOwnProperty(r.default.LOCATION)) return e.Location = e.Location_asArray[0], e.Location;
                                    },
                                    getPatchLocation: function(e) {
                                        if (e && e.hasOwnProperty(i.default.PATCH_LOCATION)) return e.PatchLocation = e.PatchLocation_asArray[0], e.PatchLocation;
                                    },
                                    getSuggestedPresentationDelay: function(e) {
                                        return e && e.hasOwnProperty(i.default.SUGGESTED_PRESENTATION_DELAY) ? e.suggestedPresentationDelay : null;
                                    },
                                    getAvailabilityStartTime: function(e) {
                                        return e && e.hasOwnProperty(i.default.AVAILABILITY_START_TIME) && null !== e.availabilityStartTime ? e.availabilityStartTime.getTime() : null;
                                    },
                                    getServiceDescriptions: function(e) {
                                        var t = [];
                                        if (e && e.hasOwnProperty(i.default.SERVICE_DESCRIPTION)) {
                                            var n, r = A(e.ServiceDescription_asArray);
                                            try {
                                                for(r.s(); !(n = r.n()).done;){
                                                    var a1 = n.value, o = null, s1 = null, u = null, l = null, c = null, d = null;
                                                    for(var f in a1)a1.hasOwnProperty(f) && (f === i.default.ID ? o = a1[f] : f === i.default.SERVICE_DESCRIPTION_SCOPE ? s1 = a1[f].schemeIdUri : f === i.default.SERVICE_DESCRIPTION_LATENCY ? u = {
                                                        target: parseInt(a1[f].target),
                                                        max: parseInt(a1[f].max),
                                                        min: parseInt(a1[f].min),
                                                        referenceId: parseInt(a1[f].referenceId)
                                                    } : f === i.default.SERVICE_DESCRIPTION_PLAYBACK_RATE ? l = {
                                                        max: parseFloat(a1[f].max),
                                                        min: parseFloat(a1[f].min)
                                                    } : f === i.default.SERVICE_DESCRIPTION_OPERATING_QUALITY ? c = {
                                                        mediaType: a1[f].mediaType,
                                                        max: parseInt(a1[f].max),
                                                        min: parseInt(a1[f].min),
                                                        target: parseInt(a1[f].target),
                                                        type: a1[f].type,
                                                        maxQualityDifference: parseInt(a1[f].maxQualityDifference)
                                                    } : f === i.default.SERVICE_DESCRIPTION_OPERATING_BANDWIDTH && (d = {
                                                        mediaType: a1[f].mediaType,
                                                        max: parseInt(a1[f].max),
                                                        min: parseInt(a1[f].min),
                                                        target: parseInt(a1[f].target)
                                                    }));
                                                    t.push({
                                                        id: o,
                                                        schemeIdUri: s1,
                                                        latency: u,
                                                        playbackRate: l,
                                                        operatingQuality: c,
                                                        operatingBandwidth: d
                                                    });
                                                }
                                            } catch (e) {
                                                r.e(e);
                                            } finally{
                                                r.f();
                                            }
                                        }
                                        return t;
                                    },
                                    getSupplementalProperties: function(e) {
                                        var t = {};
                                        if (e && e.hasOwnProperty(i.default.SUPPLEMENTAL_PROPERTY)) {
                                            var n, a1 = A(e.SupplementalProperty_asArray);
                                            try {
                                                for(a1.s(); !(n = a1.n()).done;){
                                                    var o = n.value;
                                                    o.hasOwnProperty(r.default.SCHEME_ID_URI) && o.hasOwnProperty(i.default.VALUE) && (t[o[r.default.SCHEME_ID_URI]] = o[i.default.VALUE]);
                                                }
                                            } catch (e) {
                                                a1.e(e);
                                            } finally{
                                                a1.f();
                                            }
                                        }
                                        return t;
                                    },
                                    setConfig: function(e) {
                                        e && (e.errHandler && (n = e.errHandler), e.BASE64 && (v = e.BASE64));
                                    }
                                }, t = Object(y.default)(w).getInstance().getLogger(e), e;
                            }
                            w.__dashjs_factory_name = "DashManifestModel", t.default = v.default.getSingletonFactory(w);
                        },
                        "./src/dash/models/PatchManifestModel.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/dash/constants/DashConstants.js"), i = n("./src/core/FactoryMaker.js"), a1 = n("./src/core/Debug.js"), o = n("./src/dash/vo/SimpleXPath.js"), s1 = n("./src/dash/vo/PatchOperation.js");
                            function u() {
                                var e, t, n = this.context;
                                return e = {
                                    getIsPatch: function(e) {
                                        return e && e.hasOwnProperty(r.default.ORIGINAL_MPD_ID) || !1;
                                    },
                                    getPublishTime: function(e) {
                                        return e && e.hasOwnProperty(r.default.PUBLISH_TIME) ? new Date(e[r.default.PUBLISH_TIME]) : null;
                                    },
                                    getOriginalPublishTime: function(e) {
                                        return e && e.hasOwnProperty(r.default.ORIGINAL_PUBLISH_TIME) ? new Date(e[r.default.ORIGINAL_PUBLISH_TIME]) : null;
                                    },
                                    getMpdId: function(e) {
                                        return e && e[r.default.ORIGINAL_MPD_ID] || null;
                                    },
                                    getPatchOperations: function(e) {
                                        return e ? (e.__children || []).map(function(e) {
                                            var n = Object.keys(e)[0];
                                            if ("add" !== n && "remove" !== n && "replace" !== n) return t.warn("Ignoring node of invalid action: ".concat(n)), null;
                                            var r = e[n], i = r.sel;
                                            if ("add" === n && r.type) {
                                                if (!r.type.startsWith("@")) return t.warn("Ignoring add action for prefixed namespace declaration: ".concat(r.type, "=").concat(r.__text)), null;
                                                i = "".concat(i, "/").concat(r.type);
                                            }
                                            var a1 = new o.default(i);
                                            if (!a1.isValid()) return t.warn("Ignoring action with invalid selector: ".concat(n, " - ").concat(i)), null;
                                            var u = null;
                                            a1.findsAttribute() ? u = r.__text || "" : "remove" !== n && (u = r.__children.reduce(function(e, t) {
                                                var n = Object.keys(t)[0];
                                                return "#text" !== n && (e[n] = e[n] || [], e[n].push(t[n])), e;
                                            }, {}));
                                            var l = new s1.default(n, a1, u);
                                            return "add" === n && (l.position = r.pos), l;
                                        }).filter(function(e) {
                                            return !!e;
                                        }) : [];
                                    }
                                }, t = Object(a1.default)(n).getInstance().getLogger(e), e;
                            }
                            u.__dashjs_factory_name = "PatchManifestModel", t.default = i.default.getSingletonFactory(u);
                        },
                        "./src/dash/parser/DashParser.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/dash/parser/objectiron.js"), a1 = n("./externals/xml2json.js"), o = n("./src/dash/parser/matchers/StringMatcher.js"), s1 = n("./src/dash/parser/matchers/DurationMatcher.js"), u = n("./src/dash/parser/matchers/DateTimeMatcher.js"), l = n("./src/dash/parser/matchers/NumericMatcher.js"), c = n("./src/dash/parser/matchers/LangMatcher.js"), d = n("./src/dash/parser/maps/RepresentationBaseValuesMap.js"), f = n("./src/dash/parser/maps/SegmentValuesMap.js");
                            function h(e) {
                                e = e || {};
                                var t, n, r, h, g, p = this.context, m = e.debug;
                                return t = {
                                    parse: function(e) {
                                        var t, r = window.performance.now();
                                        if (!(t = h.xml_str2json(e))) throw new Error("parsing the manifest failed");
                                        var i = window.performance.now();
                                        t.Patch ? ((t = t.Patch).add_asArray && t.add_asArray.forEach(function(e) {
                                            return g.run(e);
                                        }), t.replace_asArray && t.replace_asArray.forEach(function(e) {
                                            return g.run(e);
                                        })) : (t = t.MPD, g.run(t));
                                        var a1 = window.performance.now();
                                        return n.info("Parsing complete: ( xml2json: " + (i - r).toPrecision(3) + "ms, objectiron: " + (a1 - i).toPrecision(3) + "ms, total: " + ((a1 - r) / 1e3).toPrecision(3) + "s)"), t.protocol = "DASH", t;
                                    },
                                    getMatchers: function() {
                                        return r;
                                    },
                                    getIron: function() {
                                        return g;
                                    }
                                }, n = m.getLogger(t), r = [
                                    new s1.default,
                                    new u.default,
                                    new l.default,
                                    new c.default,
                                    new o.default
                                ], h = new a1.default({
                                    escapeMode: !1,
                                    attributePrefix: "",
                                    arrayAccessForm: "property",
                                    emptyNodeForm: "object",
                                    stripWhitespaces: !1,
                                    enableToStringFunc: !0,
                                    ignoreRoot: !1,
                                    matchers: r
                                }), g = Object(i.default)(p).create({
                                    adaptationset: new d.default,
                                    period: new f.default
                                }), t;
                            }
                            h.__dashjs_factory_name = "DashParser", t.default = r.default.getClassFactory(h);
                        },
                        "./src/dash/parser/maps/CommonProperty.js": function(e, t, n) {
                            "use strict";
                            function r(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            n.r(t);
                            var i = function() {
                                function e(t) {
                                    var n;
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), this._name = t, this._merge = (n = t) && n.length && n.charAt(0) === n.charAt(0).toUpperCase();
                                }
                                var t, n;
                                return t = e, n = [
                                    {
                                        key: "name",
                                        get: function() {
                                            return this._name;
                                        }
                                    },
                                    {
                                        key: "merge",
                                        get: function() {
                                            return this._merge;
                                        }
                                    }
                                ], r(t.prototype, n), e;
                            }();
                            t.default = i;
                        },
                        "./src/dash/parser/maps/MapNode.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/dash/parser/maps/CommonProperty.js");
                            function i(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            var a1 = function() {
                                function e(t, n, i) {
                                    var a1 = this;
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), this._name = t || "", this._properties = [], this._children = i || [], Array.isArray(n) && n.forEach(function(e) {
                                        a1._properties.push(new r.default(e));
                                    });
                                }
                                var t, n;
                                return t = e, n = [
                                    {
                                        key: "name",
                                        get: function() {
                                            return this._name;
                                        }
                                    },
                                    {
                                        key: "children",
                                        get: function() {
                                            return this._children;
                                        }
                                    },
                                    {
                                        key: "properties",
                                        get: function() {
                                            return this._properties;
                                        }
                                    }
                                ], i(t.prototype, n), e;
                            }();
                            t.default = a1;
                        },
                        "./src/dash/parser/maps/RepresentationBaseValuesMap.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/dash/parser/maps/MapNode.js"), i = n("./src/dash/constants/DashConstants.js");
                            function a1(e) {
                                return a1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, a1(e);
                            }
                            function o(e, t) {
                                return o = Object.setPrototypeOf || function(e, t) {
                                    return e.__proto__ = t, e;
                                }, o(e, t);
                            }
                            function s1(e, t) {
                                return !t || "object" !== a1(t) && "function" != typeof t ? function(e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e;
                                }(e) : t;
                            }
                            function u(e) {
                                return u = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                                    return e.__proto__ || Object.getPrototypeOf(e);
                                }, u(e);
                            }
                            var l = function(e) {
                                !function(e, t) {
                                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                    e.prototype = Object.create(t && t.prototype, {
                                        constructor: {
                                            value: e,
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }), t && o(e, t);
                                }(l, e);
                                var t, n, a1 = (t = l, n = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e, r = u(t);
                                    if (n) {
                                        var i = u(this).constructor;
                                        e = Reflect.construct(r, arguments, i);
                                    } else e = r.apply(this, arguments);
                                    return s1(this, e);
                                });
                                function l() {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, l);
                                    var e = [
                                        i.default.PROFILES,
                                        i.default.WIDTH,
                                        i.default.HEIGHT,
                                        i.default.SAR,
                                        i.default.FRAMERATE,
                                        i.default.AUDIO_SAMPLING_RATE,
                                        i.default.MIME_TYPE,
                                        i.default.SEGMENT_PROFILES,
                                        i.default.CODECS,
                                        i.default.MAXIMUM_SAP_PERIOD,
                                        i.default.START_WITH_SAP,
                                        i.default.MAX_PLAYOUT_RATE,
                                        i.default.CODING_DEPENDENCY,
                                        i.default.SCAN_TYPE,
                                        i.default.FRAME_PACKING,
                                        i.default.AUDIO_CHANNEL_CONFIGURATION,
                                        i.default.CONTENT_PROTECTION,
                                        i.default.ESSENTIAL_PROPERTY,
                                        i.default.SUPPLEMENTAL_PROPERTY,
                                        i.default.INBAND_EVENT_STREAM
                                    ];
                                    return a1.call(this, i.default.ADAPTATION_SET, e, [
                                        new r.default(i.default.REPRESENTATION, e, [
                                            new r.default(i.default.SUB_REPRESENTATION, e)
                                        ])
                                    ]);
                                }
                                return l;
                            }(r.default);
                            t.default = l;
                        },
                        "./src/dash/parser/maps/SegmentValuesMap.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/dash/parser/maps/MapNode.js"), i = n("./src/dash/constants/DashConstants.js");
                            function a1(e) {
                                return a1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, a1(e);
                            }
                            function o(e, t) {
                                return o = Object.setPrototypeOf || function(e, t) {
                                    return e.__proto__ = t, e;
                                }, o(e, t);
                            }
                            function s1(e, t) {
                                return !t || "object" !== a1(t) && "function" != typeof t ? function(e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e;
                                }(e) : t;
                            }
                            function u(e) {
                                return u = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                                    return e.__proto__ || Object.getPrototypeOf(e);
                                }, u(e);
                            }
                            var l = function(e) {
                                !function(e, t) {
                                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                    e.prototype = Object.create(t && t.prototype, {
                                        constructor: {
                                            value: e,
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }), t && o(e, t);
                                }(l, e);
                                var t, n, a1 = (t = l, n = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e, r = u(t);
                                    if (n) {
                                        var i = u(this).constructor;
                                        e = Reflect.construct(r, arguments, i);
                                    } else e = r.apply(this, arguments);
                                    return s1(this, e);
                                });
                                function l() {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, l);
                                    var e = [
                                        i.default.SEGMENT_BASE,
                                        i.default.SEGMENT_TEMPLATE,
                                        i.default.SEGMENT_LIST
                                    ];
                                    return a1.call(this, i.default.PERIOD, e, [
                                        new r.default(i.default.ADAPTATION_SET, e, [
                                            new r.default(i.default.REPRESENTATION, e)
                                        ])
                                    ]);
                                }
                                return l;
                            }(r.default);
                            t.default = l;
                        },
                        "./src/dash/parser/matchers/BaseMatcher.js": function(e, t, n) {
                            "use strict";
                            function r(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            n.r(t);
                            var i = function() {
                                function e(t, n) {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), this._test = t, this._converter = n;
                                }
                                var t, n;
                                return t = e, n = [
                                    {
                                        key: "test",
                                        get: function() {
                                            return this._test;
                                        }
                                    },
                                    {
                                        key: "converter",
                                        get: function() {
                                            return this._converter;
                                        }
                                    }
                                ], r(t.prototype, n), e;
                            }();
                            t.default = i;
                        },
                        "./src/dash/parser/matchers/DateTimeMatcher.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/dash/parser/matchers/BaseMatcher.js");
                            function i(e) {
                                return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, i(e);
                            }
                            function a1(e, t) {
                                return a1 = Object.setPrototypeOf || function(e, t) {
                                    return e.__proto__ = t, e;
                                }, a1(e, t);
                            }
                            function o(e, t) {
                                return !t || "object" !== i(t) && "function" != typeof t ? function(e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e;
                                }(e) : t;
                            }
                            function s1(e) {
                                return s1 = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                                    return e.__proto__ || Object.getPrototypeOf(e);
                                }, s1(e);
                            }
                            var u = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+-])([0-9]{2})(?::?)([0-9]{2}))?/, l = function(e) {
                                !function(e, t) {
                                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                    e.prototype = Object.create(t && t.prototype, {
                                        constructor: {
                                            value: e,
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }), t && a1(e, t);
                                }(i, e);
                                var t, n, r = (t = i, n = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e, r = s1(t);
                                    if (n) {
                                        var i = s1(this).constructor;
                                        e = Reflect.construct(r, arguments, i);
                                    } else e = r.apply(this, arguments);
                                    return o(this, e);
                                });
                                function i() {
                                    return function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, i), r.call(this, function(e) {
                                        return u.test(e.value);
                                    }, function(e) {
                                        var t, n = u.exec(e);
                                        if (t = Date.UTC(parseInt(n[1], 10), parseInt(n[2], 10) - 1, parseInt(n[3], 10), parseInt(n[4], 10), parseInt(n[5], 10), n[6] && parseInt(n[6], 10) || 0, n[7] && 1e3 * parseFloat(n[7]) || 0), n[9] && n[10]) {
                                            var r = 60 * parseInt(n[9], 10) + parseInt(n[10], 10);
                                            t += ("+" === n[8] ? -1 : 1) * r * 60000;
                                        }
                                        return new Date(t);
                                    });
                                }
                                return i;
                            }(r.default);
                            t.default = l;
                        },
                        "./src/dash/parser/matchers/DurationMatcher.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/dash/parser/matchers/BaseMatcher.js"), i = n("./src/streaming/constants/Constants.js"), a1 = n("./src/dash/constants/DashConstants.js");
                            function o(e) {
                                return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, o(e);
                            }
                            function s1(e, t) {
                                return s1 = Object.setPrototypeOf || function(e, t) {
                                    return e.__proto__ = t, e;
                                }, s1(e, t);
                            }
                            function u(e, t) {
                                return !t || "object" !== o(t) && "function" != typeof t ? function(e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e;
                                }(e) : t;
                            }
                            function l(e) {
                                return l = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                                    return e.__proto__ || Object.getPrototypeOf(e);
                                }, l(e);
                            }
                            var c = /^([-])?P(([\d.]*)Y)?(([\d.]*)M)?(([\d.]*)D)?T?(([\d.]*)H)?(([\d.]*)M)?(([\d.]*)S)?/, d = function(e) {
                                !function(e, t) {
                                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                    e.prototype = Object.create(t && t.prototype, {
                                        constructor: {
                                            value: e,
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }), t && s1(e, t);
                                }(o, e);
                                var t, n, r = (t = o, n = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e, r = l(t);
                                    if (n) {
                                        var i = l(this).constructor;
                                        e = Reflect.construct(r, arguments, i);
                                    } else e = r.apply(this, arguments);
                                    return u(this, e);
                                });
                                function o() {
                                    return function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, o), r.call(this, function(e) {
                                        for(var t = [
                                            a1.default.MIN_BUFFER_TIME,
                                            a1.default.MEDIA_PRESENTATION_DURATION,
                                            a1.default.MINIMUM_UPDATE_PERIOD,
                                            a1.default.TIMESHIFT_BUFFER_DEPTH,
                                            a1.default.MAX_SEGMENT_DURATION,
                                            a1.default.MAX_SUBSEGMENT_DURATION,
                                            a1.default.SUGGESTED_PRESENTATION_DELAY,
                                            a1.default.START,
                                            i.default.START_TIME,
                                            a1.default.DURATION
                                        ], n = t.length, r = 0; r < n; r++)if (e.nodeName === t[r]) return c.test(e.value);
                                        return !1;
                                    }, function(e) {
                                        var t = c.exec(e), n = 31536e3 * parseFloat(t[3] || 0) + 2592e3 * parseFloat(t[5] || 0) + 86400 * parseFloat(t[7] || 0) + 3600 * parseFloat(t[9] || 0) + 60 * parseFloat(t[11] || 0) + parseFloat(t[13] || 0);
                                        return void 0 !== t[1] && (n = -n), n;
                                    });
                                }
                                return o;
                            }(r.default);
                            t.default = d;
                        },
                        "./src/dash/parser/matchers/LangMatcher.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/dash/parser/matchers/BaseMatcher.js"), i = n("./src/dash/constants/DashConstants.js"), a1 = n("./node_modules/bcp-47-normalize/index.js"), o = n.n(a1);
                            function s1(e) {
                                return s1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, s1(e);
                            }
                            function u(e, t, n) {
                                return t in e ? Object.defineProperty(e, t, {
                                    value: n,
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0
                                }) : e[t] = n, e;
                            }
                            function l(e, t) {
                                return l = Object.setPrototypeOf || function(e, t) {
                                    return e.__proto__ = t, e;
                                }, l(e, t);
                            }
                            function c(e, t) {
                                return !t || "object" !== s1(t) && "function" != typeof t ? function(e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e;
                                }(e) : t;
                            }
                            function d(e) {
                                return d = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                                    return e.__proto__ || Object.getPrototypeOf(e);
                                }, d(e);
                            }
                            var f = function(e) {
                                !function(e, t) {
                                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                    e.prototype = Object.create(t && t.prototype, {
                                        constructor: {
                                            value: e,
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }), t && l(e, t);
                                }(a1, e);
                                var t, n, r = (t = a1, n = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e, r = d(t);
                                    if (n) {
                                        var i = d(this).constructor;
                                        e = Reflect.construct(r, arguments, i);
                                    } else e = r.apply(this, arguments);
                                    return c(this, e);
                                });
                                function a1() {
                                    return function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, a1), r.call(this, function(e, t) {
                                        var n, r = (u(n = {}, i.default.ADAPTATION_SET, [
                                            i.default.LANG
                                        ]), u(n, i.default.REPRESENTATION, [
                                            i.default.LANG
                                        ]), u(n, i.default.CONTENT_COMPONENT, [
                                            i.default.LANG
                                        ]), u(n, i.default.LABEL, [
                                            i.default.LANG
                                        ]), u(n, i.default.GROUP_LABEL, [
                                            i.default.LANG
                                        ]), n);
                                        if (r.hasOwnProperty(t)) {
                                            var a1 = r[t];
                                            return void 0 !== a1 && a1.indexOf(e.name) >= 0;
                                        }
                                        return !1;
                                    }, function(e) {
                                        var t = o()(e);
                                        return void 0 !== t ? t : String(e);
                                    });
                                }
                                return a1;
                            }(r.default);
                            t.default = f;
                        },
                        "./src/dash/parser/matchers/NumericMatcher.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/dash/parser/matchers/BaseMatcher.js");
                            function i(e) {
                                return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, i(e);
                            }
                            function a1(e, t) {
                                return a1 = Object.setPrototypeOf || function(e, t) {
                                    return e.__proto__ = t, e;
                                }, a1(e, t);
                            }
                            function o(e, t) {
                                return !t || "object" !== i(t) && "function" != typeof t ? function(e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e;
                                }(e) : t;
                            }
                            function s1(e) {
                                return s1 = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                                    return e.__proto__ || Object.getPrototypeOf(e);
                                }, s1(e);
                            }
                            var u = /^[-+]?[0-9]+[.]?[0-9]*([eE][-+]?[0-9]+)?$/, l = function(e) {
                                !function(e, t) {
                                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                    e.prototype = Object.create(t && t.prototype, {
                                        constructor: {
                                            value: e,
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }), t && a1(e, t);
                                }(i, e);
                                var t, n, r = (t = i, n = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e, r = s1(t);
                                    if (n) {
                                        var i = s1(this).constructor;
                                        e = Reflect.construct(r, arguments, i);
                                    } else e = r.apply(this, arguments);
                                    return o(this, e);
                                });
                                function i() {
                                    return function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, i), r.call(this, function(e) {
                                        return u.test(e.value);
                                    }, function(e) {
                                        return parseFloat(e);
                                    });
                                }
                                return i;
                            }(r.default);
                            t.default = l;
                        },
                        "./src/dash/parser/matchers/StringMatcher.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/dash/parser/matchers/BaseMatcher.js"), i = n("./src/dash/constants/DashConstants.js");
                            function a1(e) {
                                return a1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, a1(e);
                            }
                            function o(e, t, n) {
                                return t in e ? Object.defineProperty(e, t, {
                                    value: n,
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0
                                }) : e[t] = n, e;
                            }
                            function s1(e, t) {
                                return s1 = Object.setPrototypeOf || function(e, t) {
                                    return e.__proto__ = t, e;
                                }, s1(e, t);
                            }
                            function u(e, t) {
                                return !t || "object" !== a1(t) && "function" != typeof t ? function(e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e;
                                }(e) : t;
                            }
                            function l(e) {
                                return l = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                                    return e.__proto__ || Object.getPrototypeOf(e);
                                }, l(e);
                            }
                            var c = function(e) {
                                !function(e, t) {
                                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                    e.prototype = Object.create(t && t.prototype, {
                                        constructor: {
                                            value: e,
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }), t && s1(e, t);
                                }(a1, e);
                                var t, n, r = (t = a1, n = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e, r = l(t);
                                    if (n) {
                                        var i = l(this).constructor;
                                        e = Reflect.construct(r, arguments, i);
                                    } else e = r.apply(this, arguments);
                                    return u(this, e);
                                });
                                function a1() {
                                    return function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, a1), r.call(this, function(e, t) {
                                        var n, r = (o(n = {}, i.default.MPD, [
                                            i.default.ID,
                                            i.default.PROFILES
                                        ]), o(n, i.default.PERIOD, [
                                            i.default.ID
                                        ]), o(n, i.default.BASE_URL, [
                                            i.default.SERVICE_LOCATION,
                                            i.default.BYTE_RANGE
                                        ]), o(n, i.default.SEGMENT_BASE, [
                                            i.default.INDEX_RANGE
                                        ]), o(n, i.default.INITIALIZATION, [
                                            i.default.RANGE
                                        ]), o(n, i.default.REPRESENTATION_INDEX, [
                                            i.default.RANGE
                                        ]), o(n, i.default.SEGMENT_LIST, [
                                            i.default.INDEX_RANGE
                                        ]), o(n, i.default.BITSTREAM_SWITCHING, [
                                            i.default.RANGE
                                        ]), o(n, i.default.SEGMENT_URL, [
                                            i.default.MEDIA_RANGE,
                                            i.default.INDEX_RANGE
                                        ]), o(n, i.default.SEGMENT_TEMPLATE, [
                                            i.default.INDEX_RANGE,
                                            i.default.MEDIA,
                                            i.default.INDEX,
                                            i.default.INITIALIZATION_MINUS,
                                            i.default.BITSTREAM_SWITCHING_MINUS
                                        ]), o(n, i.default.ASSET_IDENTIFIER, [
                                            i.default.VALUE,
                                            i.default.ID
                                        ]), o(n, i.default.EVENT_STREAM, [
                                            i.default.VALUE
                                        ]), o(n, i.default.ADAPTATION_SET, [
                                            i.default.PROFILES,
                                            i.default.MIME_TYPE,
                                            i.default.SEGMENT_PROFILES,
                                            i.default.CODECS,
                                            i.default.CONTENT_TYPE
                                        ]), o(n, i.default.FRAME_PACKING, [
                                            i.default.VALUE,
                                            i.default.ID
                                        ]), o(n, i.default.AUDIO_CHANNEL_CONFIGURATION, [
                                            i.default.VALUE,
                                            i.default.ID
                                        ]), o(n, i.default.CONTENT_PROTECTION, [
                                            i.default.VALUE,
                                            i.default.ID
                                        ]), o(n, i.default.ESSENTIAL_PROPERTY, [
                                            i.default.VALUE,
                                            i.default.ID
                                        ]), o(n, i.default.SUPPLEMENTAL_PROPERTY, [
                                            i.default.VALUE,
                                            i.default.ID
                                        ]), o(n, i.default.INBAND_EVENT_STREAM, [
                                            i.default.VALUE,
                                            i.default.ID
                                        ]), o(n, i.default.ACCESSIBILITY, [
                                            i.default.VALUE,
                                            i.default.ID
                                        ]), o(n, i.default.ROLE, [
                                            i.default.VALUE,
                                            i.default.ID
                                        ]), o(n, i.default.RATING, [
                                            i.default.VALUE,
                                            i.default.ID
                                        ]), o(n, i.default.VIEWPOINT, [
                                            i.default.VALUE,
                                            i.default.ID
                                        ]), o(n, i.default.CONTENT_COMPONENT, [
                                            i.default.CONTENT_TYPE
                                        ]), o(n, i.default.REPRESENTATION, [
                                            i.default.ID,
                                            i.default.DEPENDENCY_ID,
                                            i.default.MEDIA_STREAM_STRUCTURE_ID
                                        ]), o(n, i.default.SUBSET, [
                                            i.default.ID
                                        ]), o(n, i.default.METRICS, [
                                            i.default.METRICS_MINUS
                                        ]), o(n, i.default.REPORTING, [
                                            i.default.VALUE,
                                            i.default.ID
                                        ]), n);
                                        if (r.hasOwnProperty(t)) {
                                            var a1 = r[t];
                                            return void 0 !== a1 && a1.indexOf(e.name) >= 0;
                                        }
                                        return !1;
                                    }, function(e) {
                                        return String(e);
                                    });
                                }
                                return a1;
                            }(r.default);
                            t.default = c;
                        },
                        "./src/dash/parser/objectiron.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js");
                            function i(e) {
                                return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, i(e);
                            }
                            function a1(e) {
                                function t(e, t) {
                                    for(var n in e)t.hasOwnProperty(n) || (t[n] = e[n]);
                                }
                                function n(e, n, r) {
                                    for(var a1 = 0, o = e.length; a1 < o; ++a1){
                                        var s1 = e[a1];
                                        if (n[s1.name]) {
                                            if (r[s1.name]) {
                                                if (s1.merge) {
                                                    var u = n[s1.name], l = r[s1.name];
                                                    "object" === i(u) && "object" === i(l) ? t(u, l) : r[s1.name] = u + l;
                                                }
                                            } else r[s1.name] = n[s1.name];
                                        }
                                    }
                                }
                                function r(e, t) {
                                    for(var i = 0, a1 = e.children.length; i < a1; ++i){
                                        var o = e.children[i], s1 = t[o.name + "_asArray"];
                                        if (s1) for(var u = 0, l = s1.length; u < l; ++u){
                                            var c = s1[u];
                                            n(e.properties, t, c), r(o, c);
                                        }
                                    }
                                }
                                return {
                                    run: function(t) {
                                        if (null === t || "object" !== i(t)) return t;
                                        if (t.Period_asArray && "period" in e) for(var n = e.period, a1 = t.Period_asArray, o = 0, s1 = a1.length; o < s1; ++o){
                                            var u = a1[o];
                                            if (r(n, u), "adaptationset" in e) {
                                                var l = u.AdaptationSet_asArray;
                                                if (l) for(var c = e.adaptationset, d = 0, f = l.length; d < f; ++d)r(c, l[d]);
                                            }
                                        }
                                        return t;
                                    }
                                };
                            }
                            a1.__dashjs_factory_name = "ObjectIron";
                            var o = r.default.getClassFactory(a1);
                            t.default = o;
                        },
                        "./src/dash/utils/ListSegmentsGetter.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/streaming/constants/Constants.js"), a1 = n("./src/dash/utils/SegmentsUtils.js");
                            function o(e, t) {
                                var n = (e = e || {}).timelineConverter;
                                function r() {
                                    if (!n || !n.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime")) throw new Error(i.default.MISSING_CONFIG_ERROR);
                                }
                                function o(e, i) {
                                    if (r(), !e) return null;
                                    var o = e.adaptation.period.mpd.manifest.Period_asArray[e.adaptation.period.index].AdaptationSet_asArray[e.adaptation.index].Representation_asArray[e.index].SegmentList, s1 = o.SegmentURL_asArray.length, u = e && !isNaN(e.startNumber) ? e.startNumber : 1, l = Math.max(u - 1, 0), c = Math.max(i - l, 0), d = null;
                                    if (c < s1) {
                                        var f = o.SegmentURL_asArray[c];
                                        (d = Object(a1.getIndexBasedSegment)(n, t, e, i)) && (d.replacementTime = (u + i - 1) * e.segmentDuration, d.media = f.media ? f.media : "", d.mediaRange = f.mediaRange, d.indexRange = f.indexRange);
                                    }
                                    return d;
                                }
                                return {
                                    getSegmentByIndex: o,
                                    getSegmentByTime: function(e, t) {
                                        if (r(), !e) return null;
                                        var i = e.segmentDuration;
                                        if (isNaN(i)) return null;
                                        var a1 = n.calcPeriodRelativeTimeFromMpdRelativeTime(e, t);
                                        return o(e, Math.floor(a1 / i));
                                    },
                                    getMediaFinishedInformation: function(e) {
                                        var t = {
                                            numberOfSegments: 0,
                                            mediaTimeOfLastSignaledSegment: NaN
                                        };
                                        if (!e) return t;
                                        var n = e.adaptation.period.mpd.manifest.Period_asArray[e.adaptation.period.index].AdaptationSet_asArray[e.adaptation.index].Representation_asArray[e.index].SegmentList, r = e && !isNaN(e.startNumber) ? e.startNumber : 1, i = Math.max(r - 1, 0);
                                        return t.numberOfSegments = i + n.SegmentURL_asArray.length, t;
                                    }
                                };
                            }
                            o.__dashjs_factory_name = "ListSegmentsGetter";
                            var s1 = r.default.getClassFactory(o);
                            t.default = s1;
                        },
                        "./src/dash/utils/Round10.js": function(e, t, n) {
                            "use strict";
                            function r(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            n.r(t), n.d(t, "default", function() {
                                return i;
                            });
                            var i = function() {
                                function e() {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e);
                                }
                                var t, n;
                                return t = e, n = [
                                    {
                                        key: "round10",
                                        value: function(e, t) {
                                            return function(e, t, n) {
                                                return void 0 === n || 0 == +n ? Math.round(t) : (n = +n, (t = +t, isNaN(t)) || "number" != typeof n || n % 1 != 0 ? NaN : (t = t.toString().split("e"), +((t = (t = Math.round(+(t[0] + "e" + (t[1] ? +t[1] - n : -n)))).toString().split("e"))[0] + "e" + (t[1] ? +t[1] + n : n))));
                                            }(0, e, t);
                                        }
                                    }
                                ], n && r(t, n), e;
                            }();
                        },
                        "./src/dash/utils/SegmentBaseGetter.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/streaming/constants/Constants.js");
                            function a1(e) {
                                var t = (e = e || {}).timelineConverter;
                                function n() {
                                    if (!t || !t.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime")) throw new Error(i.default.MISSING_CONFIG_ERROR);
                                }
                                function r(e, t) {
                                    if (n(), !e) return null;
                                    var r, i = e.segments ? e.segments.length : -1;
                                    if (t < i && (r = e.segments[t]) && r.index === t) return r;
                                    for(var a1 = 0; a1 < i; a1++)if ((r = e.segments[a1]) && r.index === t) return r;
                                    return null;
                                }
                                return {
                                    getSegmentByIndex: r,
                                    getSegmentByTime: function(e, t) {
                                        n();
                                        var i = function(e, t) {
                                            if (!e) return -1;
                                            var n, r, i, a1, o, s1 = e.segments, u = s1 ? s1.length : null, l = -1;
                                            if (s1 && u > 0) {
                                                for(o = 0; o < u; o++)if (i = (r = s1[o]).presentationStartTime, t + (n = (a1 = r.duration) / 2) >= i && t - n < i + a1) {
                                                    l = r.index;
                                                    break;
                                                }
                                            }
                                            return l;
                                        }(e, t);
                                        return r(e, i);
                                    },
                                    getMediaFinishedInformation: function(e) {
                                        var t = {
                                            numberOfSegments: 0,
                                            mediaTimeOfLastSignaledSegment: NaN
                                        };
                                        return e && e.segments ? (t.numberOfSegments = e.segments.length, t) : t;
                                    }
                                };
                            }
                            a1.__dashjs_factory_name = "SegmentBaseGetter";
                            var o = r.default.getClassFactory(a1);
                            t.default = o;
                        },
                        "./src/dash/utils/SegmentsUtils.js": function(e, t, n) {
                            "use strict";
                            n.r(t), n.d(t, "unescapeDollarsInTemplate", function() {
                                return a1;
                            }), n.d(t, "replaceIDForTemplate", function() {
                                return o;
                            }), n.d(t, "replaceTokenForTemplate", function() {
                                return s1;
                            }), n.d(t, "getIndexBasedSegment", function() {
                                return c;
                            }), n.d(t, "getTimeBasedSegment", function() {
                                return d;
                            });
                            var r = n("./src/dash/vo/Segment.js");
                            function i(e, t) {
                                for(; e.length < t;)e = "0" + e;
                                return e;
                            }
                            function a1(e) {
                                return e ? e.split("$$").join("$") : e;
                            }
                            function o(e, t) {
                                if (!t || !e || -1 === e.indexOf("$RepresentationID$")) return e;
                                var n = t.toString();
                                return e.split("$RepresentationID$").join(n);
                            }
                            function s1(e, t, n) {
                                var r, a1, o, s1, u, l, c = t.length, d = 2;
                                if (!e) return e;
                                for(;;){
                                    if ((r = e.indexOf("$" + t)) < 0) return e;
                                    if ((a1 = e.indexOf("$", r + c)) < 0) return e;
                                    if ((o = e.indexOf("%0", r + c)) > r && o < a1) switch(s1 = e.charAt(a1 - 1), u = parseInt(e.substring(o + d, a1 - 1), 10), s1){
                                        case "d":
                                        case "i":
                                        case "u":
                                            l = i(n.toString(), u);
                                            break;
                                        case "x":
                                            l = i(n.toString(16), u);
                                            break;
                                        case "X":
                                            l = i(n.toString(16), u).toUpperCase();
                                            break;
                                        case "o":
                                            l = i(n.toString(8), u);
                                            break;
                                        default:
                                            return e;
                                    }
                                    else l = n;
                                    e = e.substring(0, r) + l + e.substring(a1 + 1);
                                }
                            }
                            function u(e, t, n, i, a1, o, s1, u) {
                                var l, c = new r.default;
                                return c.representation = e, c.duration = t, c.presentationStartTime = n, c.mediaStartTime = i, c.availabilityStartTime = a1.calcAvailabilityStartTimeFromPresentationTime(o, e, s1), c.availabilityEndTime = a1.calcAvailabilityEndTimeFromPresentationTime(o + t, e, s1), c.wallStartTime = a1.calcWallTimeForSegment(c, s1), c.replacementNumber = (l = u, c.representation.startNumber + l), c.index = u, c;
                            }
                            function l(e, t, n, r) {
                                var i = t.adaptation.period;
                                if (isFinite(i.duration) && i.start + i.duration <= n.presentationStartTime) return !1;
                                if (r) {
                                    if ("INF" === t.availabilityTimeOffset) return !0;
                                    var a1 = e.getClientReferenceTime();
                                    return n.availabilityStartTime.getTime() <= a1 && (!isFinite(n.availabilityEndTime) || n.availabilityEndTime.getTime() >= a1);
                                }
                                return !0;
                            }
                            function c(e, t, n, r) {
                                var i, a1, o;
                                i = n.segmentDuration, isNaN(i) && (i = n.adaptation.period.duration), a1 = parseFloat((n.adaptation.period.start + r * i).toFixed(5)), o = parseFloat((a1 + i).toFixed(5));
                                var s1 = u(n, i, a1, e.calcMediaTimeFromPresentationTime(a1, n), e, o, t, r);
                                return l(e, n, s1, t) ? s1 : null;
                            }
                            function d(e, t, n, r, i, a1, o, c, d, f) {
                                var h, g, p = r / a1, m = i / a1;
                                return h = e.calcPresentationTimeFromMediaTime(p, n), l(e, n, g = u(n, m, h, p, e, h + m, t, d), t) ? (g.replacementTime = f || r, o = s1(o, "Number", g.replacementNumber), o = s1(o, "Time", g.replacementTime), g.media = o, g.mediaRange = c, g) : null;
                            }
                        },
                        "./src/dash/utils/TemplateSegmentsGetter.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/streaming/constants/Constants.js"), a1 = n("./src/dash/utils/SegmentsUtils.js");
                            function o(e, t) {
                                var n = (e = e || {}).timelineConverter;
                                function r() {
                                    if (!n || !n.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime")) throw new Error(i.default.MISSING_CONFIG_ERROR);
                                }
                                function o(e, i) {
                                    if (r(), !e) return null;
                                    var o = e.adaptation.period.mpd.manifest.Period_asArray[e.adaptation.period.index].AdaptationSet_asArray[e.adaptation.index].Representation_asArray[e.index].SegmentTemplate;
                                    i = Math.max(i, 0);
                                    var s1 = Object(a1.getIndexBasedSegment)(n, t, e, i);
                                    if (s1) {
                                        s1.replacementTime = Math.round((i - 1) * e.segmentDuration * e.timescale, 10);
                                        var u = o.media;
                                        u = Object(a1.replaceTokenForTemplate)(u, "Number", s1.replacementNumber), u = Object(a1.replaceTokenForTemplate)(u, "Time", s1.replacementTime), s1.media = u;
                                    }
                                    return s1;
                                }
                                return {
                                    getSegmentByIndex: o,
                                    getSegmentByTime: function(e, t) {
                                        if (r(), !e) return null;
                                        var i = e.segmentDuration;
                                        if (isNaN(i)) return null;
                                        var a1 = n.calcPeriodRelativeTimeFromMpdRelativeTime(e, t);
                                        return o(e, Math.floor(a1 / i));
                                    },
                                    getMediaFinishedInformation: function(e) {
                                        var t = {
                                            numberOfSegments: 0,
                                            mediaTimeOfLastSignaledSegment: NaN
                                        };
                                        if (!e) return t;
                                        var n = e.segmentDuration;
                                        return isNaN(n) ? t.numberOfSegments = 1 : t.numberOfSegments = Math.ceil(e.adaptation.period.duration / n), t;
                                    }
                                };
                            }
                            o.__dashjs_factory_name = "TemplateSegmentsGetter";
                            var s1 = r.default.getClassFactory(o);
                            t.default = s1;
                        },
                        "./src/dash/utils/TimelineConverter.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/EventBus.js"), i = n("./src/core/events/Events.js"), a1 = n("./src/core/FactoryMaker.js"), o = n("./src/dash/constants/DashConstants.js"), s1 = n("./src/dash/models/DashManifestModel.js"), u = n("./src/core/Settings.js"), l = n("./src/streaming/constants/Constants.js"), c = n("./src/streaming/MediaPlayerEvents.js"), d = n("./src/streaming/constants/ConformanceViolationConstants.js");
                            function f() {
                                var e, t, n, a1, f = this.context, h = Object(r.default)(f).getInstance(), g = Object(u.default)(f).getInstance();
                                function p(e) {
                                    a1 = e;
                                }
                                function m(e, t, n, r) {
                                    var i, a1 = t.adaptation.period.mpd, o = a1.availabilityStartTime;
                                    if (r) i = n && a1.timeShiftBufferDepth !== Number.POSITIVE_INFINITY ? new Date(o.getTime() + 1e3 * (e + a1.timeShiftBufferDepth)) : a1.availabilityEndTime;
                                    else if (n) {
                                        var s1 = t.availabilityTimeOffset;
                                        i = new Date(o.getTime() + 1e3 * (e - s1));
                                    } else i = o;
                                    return i;
                                }
                                function v(e, t) {
                                    return (e.getTime() - t.mpd.availabilityStartTime.getTime() + 1e3 * a1) / 1e3;
                                }
                                function y(e, t) {
                                    return e + (t.adaptation.period.start - t.presentationTimeOffset);
                                }
                                function E(e) {
                                    var n = {
                                        start: NaN,
                                        end: NaN
                                    }, r = e[0].getAdapter().getRegularPeriods()[0], i = v(new Date, r);
                                    if (!e || 0 === e.length) return {
                                        range: n,
                                        now: i
                                    };
                                    e.forEach(function(e) {
                                        var r = e.getAdapter(), a1 = r.getMediaInfoForType(e.getStreamInfo(), l.default.VIDEO) || r.getMediaInfoForType(e.getStreamInfo(), l.default.AUDIO), s1 = r.getVoRepresentations(a1)[0], u = {
                                            start: NaN,
                                            end: NaN
                                        };
                                        if (s1) {
                                            if (s1.segmentInfoType === o.default.SEGMENT_TIMELINE) u = function(e) {
                                                var n, r, i, a1, o = e.adaptation.period.mpd.manifest.Period_asArray[e.adaptation.period.index].AdaptationSet_asArray[e.adaptation.index], s1 = t.getRepresentationFor(e.index, o), u = s1.SegmentTemplate.SegmentTimeline, l = s1.SegmentTemplate.timescale, c = u.S_asArray, d = {
                                                    start: 0,
                                                    end: 0
                                                }, f = 0;
                                                for(d.start = y(c[0].t / l, e), i = 0, a1 = c.length; i < a1; i++)r = 0, (n = c[i]).hasOwnProperty("r") && (r = n.r), f += n.d * (1 + r);
                                                return d.end = y((c[0].t + f) / l, e), d;
                                            }(s1);
                                            else {
                                                var c = s1.adaptation.period;
                                                u.start = c.start, u.end = Math.max(i, c.start + c.duration);
                                            }
                                        }
                                        !isNaN(u.start) && (isNaN(n.start) || n.start > u.start) && (n.start = u.start), !isNaN(u.end) && (isNaN(n.end) || n.end < u.end) && (n.end = u.end);
                                    }), n.end = Math.min(i, n.end);
                                    var a1 = b(e, n.end, !0);
                                    return n.end = isNaN(a1) ? n.end : a1, n.start = r && r.mpd && r.mpd.timeShiftBufferDepth && !isNaN(r.mpd.timeShiftBufferDepth) && !isNaN(n.end) ? Math.max(n.end - r.mpd.timeShiftBufferDepth, n.start) : n.start, n.start = b(e, n.start), {
                                        range: n,
                                        now: i
                                    };
                                }
                                function T(e, t) {
                                    n = e - t.end;
                                }
                                function b(e, t) {
                                    var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                                    try {
                                        for(var r = 0, i = !1, a1 = NaN; !i && r < e.length;){
                                            var o = e[r].getStreamInfo();
                                            o.start <= t && (!isFinite(o.duration) || o.start + o.duration >= t) ? (a1 = t, i = !0) : !n && o.start > t && (isNaN(a1) || o.start < a1) ? a1 = o.start : n && o.start + o.duration < t && (isNaN(a1) || o.start + o.duration > a1) && (a1 = o.start + o.duration), r += 1;
                                        }
                                        return a1;
                                    } catch (e) {
                                        return t;
                                    }
                                }
                                function A(e) {
                                    void 0 === e.offset || isNaN(e.offset) || p(e.offset / 1e3);
                                }
                                function _() {
                                    a1 = 0, n = 0;
                                }
                                function S() {
                                    h.off(i.default.UPDATE_TIME_SYNC_OFFSET, A, this), _();
                                }
                                return e = {
                                    initialize: function() {
                                        _(), h.on(i.default.UPDATE_TIME_SYNC_OFFSET, A, this);
                                    },
                                    getClientTimeOffset: function() {
                                        return a1;
                                    },
                                    setClientTimeOffset: p,
                                    getClientReferenceTime: function() {
                                        return Date.now() - 1e3 * n + 1e3 * a1;
                                    },
                                    calcAvailabilityStartTimeFromPresentationTime: function(e, t, n) {
                                        return m(e, t, n);
                                    },
                                    calcAvailabilityEndTimeFromPresentationTime: function(e, t, n) {
                                        return m(e, t, n, !0);
                                    },
                                    calcPresentationTimeFromWallTime: v,
                                    calcPresentationTimeFromMediaTime: y,
                                    calcPeriodRelativeTimeFromMpdRelativeTime: function(e, t) {
                                        return t - e.adaptation.period.start;
                                    },
                                    calcMediaTimeFromPresentationTime: function(e, t) {
                                        return e - t.adaptation.period.start + t.presentationTimeOffset;
                                    },
                                    calcWallTimeForSegment: function(e, t) {
                                        var n, r, i;
                                        return t && (n = e.representation.adaptation.period.mpd.suggestedPresentationDelay, r = e.presentationStartTime + n, i = new Date(e.availabilityStartTime.getTime() + 1e3 * r)), i;
                                    },
                                    calcTimeShiftBufferWindow: function(e, t) {
                                        if (!t) return function(e) {
                                            var t = {
                                                start: NaN,
                                                end: NaN
                                            }, n = 0, r = NaN;
                                            return e.forEach(function(e) {
                                                var t = e.getStreamInfo();
                                                n += t.duration, (isNaN(r) || t.start < r) && (r = t.start);
                                            }), t.start = r, t.end = r + n, t;
                                        }(e);
                                        if (g.get().streaming.timeShiftBuffer.calcFromSegmentTimeline) {
                                            var n = E(e);
                                            return T(n.now, n.range), n.range;
                                        }
                                        return function(e) {
                                            var t = {
                                                start: NaN,
                                                end: NaN
                                            };
                                            if (!e || 0 === e.length) return t;
                                            var n = e[0].getAdapter().getRegularPeriods()[0], r = v(new Date, n), i = n.mpd.timeShiftBufferDepth, a1 = isNaN(i) ? 0 : r - i;
                                            if (t.start = b(e, a1), t.end = !isNaN(t.start) && r < t.start ? r : b(e, r, !0), !isNaN(i) && t.end < r - i && (t.end = NaN), g.get().streaming.timeShiftBuffer.fallbackToSegmentTimeline) {
                                                var o = E(e);
                                                if (o.range.end < t.start) return h.trigger(c.default.CONFORMANCE_VIOLATION, {
                                                    level: d.default.LEVELS.WARNING,
                                                    event: d.default.EVENTS.INVALID_DVR_WINDOW
                                                }), T(o.now, o.range), o.range;
                                            }
                                            return t;
                                        }(e);
                                    },
                                    reset: S
                                }, t = Object(s1.default)(f).getInstance(), S(), e;
                            }
                            f.__dashjs_factory_name = "TimelineConverter", t.default = a1.default.getSingletonFactory(f);
                        },
                        "./src/dash/utils/TimelineSegmentsGetter.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/streaming/constants/Constants.js"), a1 = n("./src/dash/utils/SegmentsUtils.js");
                            function o(e, t) {
                                var n = (e = e || {}).timelineConverter, r = e.dashMetrics;
                                function o() {
                                    if (!n) throw new Error(i.default.MISSING_CONFIG_ERROR);
                                }
                                function s1(e, t) {
                                    var n, r, i, a1, o, s1, l, c = e.adaptation.period.mpd.manifest.Period_asArray[e.adaptation.period.index].AdaptationSet_asArray[e.adaptation.index].Representation_asArray[e.index].SegmentTemplate || e.adaptation.period.mpd.manifest.Period_asArray[e.adaptation.period.index].AdaptationSet_asArray[e.adaptation.index].Representation_asArray[e.index].SegmentList, d = c.SegmentTimeline, f = c.SegmentURL_asArray, h = 0, g = -1;
                                    l = e.timescale;
                                    var p = !1;
                                    for(i = 0, a1 = (n = d.S_asArray).length; i < a1 && !p; i++)for(s1 = 0, (r = n[i]).hasOwnProperty("r") && (s1 = r.r), r.hasOwnProperty("t") && (h = r.t), s1 < 0 && (s1 = u(e, n[i + 1], r, l, h / l)), o = 0; o <= s1 && !p; o++)(p = t(h, c, f, r, l, ++g, i)) && (e.segmentDuration = r.d / l), h += r.d;
                                }
                                function u(e, t, i, a1, o) {
                                    var s1;
                                    if (t && t.hasOwnProperty("t")) s1 = t.t / a1;
                                    else try {
                                        var u = 0;
                                        if (isNaN(e.adaptation.period.start) || isNaN(e.adaptation.period.duration) || !isFinite(e.adaptation.period.duration)) {
                                            var l = r.getCurrentDVRInfo();
                                            u = isNaN(l.end) ? 0 : l.end;
                                        } else u = e.adaptation.period.start + e.adaptation.period.duration;
                                        s1 = n.calcMediaTimeFromPresentationTime(u, e), e.segmentDuration = i.d / a1;
                                    } catch (e) {
                                        s1 = 0;
                                    }
                                    return Math.max(Math.ceil((s1 - o) / (i.d / a1)) - 1, 0);
                                }
                                return {
                                    getSegmentByIndex: function(e, r, i) {
                                        if (o(), !e) return null;
                                        var u = null, l = !1;
                                        return s1(e, function(r, o, s1, c, d, f, h) {
                                            if (l || i < 0) {
                                                var g = o.media, p = c.mediaRange;
                                                return s1 && (g = s1[h].media || "", p = s1[h].mediaRange), u = Object(a1.getTimeBasedSegment)(n, t, e, r, c.d, d, g, p, f, c.tManifest), !0;
                                            }
                                            return r >= i * d - .5 * c.d && (l = !0), !1;
                                        }), u;
                                    },
                                    getSegmentByTime: function(e, r) {
                                        if (o(), !e) return null;
                                        void 0 === r && (r = null);
                                        var i = null, u = n.calcMediaTimeFromPresentationTime(r, e);
                                        return s1(e, function(r, o, s1, l, c, d, f) {
                                            var h = parseFloat((u * c).toPrecision(15));
                                            if (h < r + l.d && h >= r) {
                                                var g = o.media, p = l.mediaRange;
                                                return s1 && (g = s1[f].media || "", p = s1[f].mediaRange), i = Object(a1.getTimeBasedSegment)(n, t, e, r, l.d, c, g, p, d, l.tManifest), !0;
                                            }
                                            return !1;
                                        }), i;
                                    },
                                    getMediaFinishedInformation: function(e) {
                                        if (!e) return 0;
                                        var t, n, r, i, a1, o, s1, l = (e.adaptation.period.mpd.manifest.Period_asArray[e.adaptation.period.index].AdaptationSet_asArray[e.adaptation.index].Representation_asArray[e.index].SegmentTemplate || e.adaptation.period.mpd.manifest.Period_asArray[e.adaptation.period.index].AdaptationSet_asArray[e.adaptation.index].Representation_asArray[e.index].SegmentList).SegmentTimeline, c = 0, d = 0, f = 0;
                                        for(s1 = e.timescale, i = (t = l.S_asArray).length, r = 0; r < i; r++)for(o = 0, (n = t[r]).hasOwnProperty("r") && (o = n.r), n.hasOwnProperty("t") && (d = (c = n.t) / s1), o < 0 && (o = u(e, t[r + 1], n, s1, d)), a1 = 0; a1 <= o; a1++)f++, d = (c += n.d) / s1;
                                        return {
                                            numberOfSegments: f,
                                            mediaTimeOfLastSignaledSegment: d
                                        };
                                    }
                                };
                            }
                            o.__dashjs_factory_name = "TimelineSegmentsGetter";
                            var s1 = r.default.getClassFactory(o);
                            t.default = s1;
                        },
                        "./src/dash/vo/AdaptationSet.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.period = null, this.index = -1, this.type = null;
                            };
                        },
                        "./src/dash/vo/BaseURL.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = function e(t, n, r, i) {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.url = t || "", this.serviceLocation = n || t || "", this.dvb_priority = r || 1, this.dvb_weight = i || 1, this.availabilityTimeOffset = 0, this.availabilityTimeComplete = !0;
                            };
                            r.DEFAULT_DVB_PRIORITY = 1, r.DEFAULT_DVB_WEIGHT = 1, t.default = r;
                        },
                        "./src/dash/vo/ContentSteering.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.defaultServiceLocation = null, this.queryBeforeStart = !1, this.proxyServerUrl = null, this.serverUrl = null;
                            };
                        },
                        "./src/dash/vo/ContentSteeringRequest.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/vo/metrics/HTTPRequest.js");
                            t.default = function e(t) {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.url = t || null, this.type = r.HTTPRequest.CONTENT_STEERING_TYPE, this.responseType = "json";
                            };
                        },
                        "./src/dash/vo/ContentSteeringResponse.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.version = null, this.ttl = 300, this.reloadUri = null, this.serviceLocationPriority = [];
                            };
                        },
                        "./src/dash/vo/Event.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.duration = NaN, this.presentationTime = NaN, this.id = NaN, this.messageData = "", this.eventStream = null, this.presentationTimeDelta = NaN;
                            };
                        },
                        "./src/dash/vo/EventStream.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.adaptionSet = null, this.representation = null, this.period = null, this.timescale = 1, this.value = "", this.schemeIdUri = "", this.presentationTimeOffset = 0;
                            };
                        },
                        "./src/dash/vo/ManifestInfo.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.dvrWindowSize = NaN, this.loadedTime = null, this.availableFrom = null, this.minBufferTime = NaN, this.duration = NaN, this.isDynamic = !1, this.maxFragmentDuration = null;
                            };
                        },
                        "./src/dash/vo/MediaInfo.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.id = null, this.index = null, this.type = null, this.streamInfo = null, this.representationCount = 0, this.labels = null, this.lang = null, this.viewpoint = null, this.accessibility = null, this.audioChannelConfiguration = null, this.roles = null, this.codec = null, this.mimeType = null, this.contentProtection = null, this.KID = null, this.bitrateList = null, this.isFragmented = null, this.isEmbedded = null, this.selectionPriority = 1, this.supplementalProperties = {};
                            };
                        },
                        "./src/dash/vo/Mpd.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.manifest = null, this.suggestedPresentationDelay = 0, this.availabilityStartTime = null, this.availabilityEndTime = Number.POSITIVE_INFINITY, this.timeShiftBufferDepth = Number.POSITIVE_INFINITY, this.maxSegmentDuration = Number.POSITIVE_INFINITY, this.publishTime = null, this.minimumUpdatePeriod = NaN, this.mediaPresentationDuration = NaN;
                            };
                        },
                        "./src/dash/vo/PatchOperation.js": function(e, t, n) {
                            "use strict";
                            function r(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            n.r(t);
                            var i = function() {
                                function e(t, n, r) {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), this.action = t, this.xpath = n, this.value = r, this.position = null;
                                }
                                var t, n;
                                return t = e, n = [
                                    {
                                        key: "getMpdTarget",
                                        value: function(e) {
                                            var t = "remove" === this.action || "replace" === this.action || "before" === this.position || "after" === this.position;
                                            return this.xpath.getMpdTarget(e, t);
                                        }
                                    }
                                ], r(t.prototype, n), e;
                            }();
                            t.default = i;
                        },
                        "./src/dash/vo/Period.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.id = null, this.index = -1, this.duration = NaN, this.start = NaN, this.mpd = null, this.nextPeriodId = null;
                            };
                            r.DEFAULT_ID = "defaultId", t.default = r;
                        },
                        "./src/dash/vo/ProducerReferenceTime.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.id = null, this.inband = !1, this.type = "encoder", this.applicationScheme = null, this.wallClockTime = null, this.presentationTime = NaN, this.UTCTiming = null;
                            };
                        },
                        "./src/dash/vo/Representation.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/dash/constants/DashConstants.js");
                            function i(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            var a1 = function() {
                                function e() {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), this.id = null, this.index = -1, this.adaptation = null, this.segmentInfoType = null, this.initialization = null, this.codecs = null, this.mimeType = null, this.codecPrivateData = null, this.segmentDuration = NaN, this.timescale = 1, this.startNumber = 1, this.indexRange = null, this.range = null, this.presentationTimeOffset = 0, this.MSETimeOffset = NaN, this.mediaFinishedInformation = {
                                        numberOfSegments: 0,
                                        mediaTimeOfLastSignaledSegment: NaN
                                    }, this.bandwidth = NaN, this.width = NaN, this.height = NaN, this.scanType = null, this.maxPlayoutRate = NaN, this.availabilityTimeOffset = 0, this.availabilityTimeComplete = !0;
                                }
                                var t, n;
                                return t = e, n = [
                                    {
                                        key: "hasInitialization",
                                        value: function() {
                                            return null !== this.initialization || null !== this.range;
                                        }
                                    },
                                    {
                                        key: "hasSegments",
                                        value: function() {
                                            return this.segmentInfoType !== r.default.BASE_URL && this.segmentInfoType !== r.default.SEGMENT_BASE && !this.indexRange;
                                        }
                                    }
                                ], i(t.prototype, n), e;
                            }();
                            t.default = a1;
                        },
                        "./src/dash/vo/RepresentationInfo.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.id = null, this.quality = null, this.fragmentDuration = null, this.mediaInfo = null, this.MSETimeOffset = null;
                            };
                        },
                        "./src/dash/vo/Segment.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.indexRange = null, this.index = null, this.mediaRange = null, this.media = null, this.duration = NaN, this.replacementTime = null, this.replacementNumber = NaN, this.mediaStartTime = NaN, this.presentationStartTime = NaN, this.availabilityStartTime = NaN, this.availabilityEndTime = NaN, this.wallStartTime = NaN, this.representation = null;
                            };
                        },
                        "./src/dash/vo/SimpleXPath.js": function(e, t, n) {
                            "use strict";
                            function r(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            n.r(t);
                            var i = function() {
                                function e(t) {
                                    var n = this;
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), this.valid = "/" == t[0], this.path = t.split("/").filter(function(e) {
                                        return 0 !== e.length;
                                    }).map(function(e) {
                                        var t = {
                                            name: e
                                        }, r = e.indexOf("[");
                                        if (-1 != r) {
                                            t.name = e.substring(0, r);
                                            var i = e.substring(r + 1, e.length - 1);
                                            n.valid = n.valid && -1 == i.indexOf("[");
                                            var a1 = i.indexOf("=");
                                            -1 != a1 ? (t.attribute = {
                                                name: i.substring(1, a1),
                                                value: i.substring(a1 + 1)
                                            }, -1 != [
                                                "'",
                                                '"'
                                            ].indexOf(t.attribute.value[0]) && (t.attribute.value = t.attribute.value.substring(1, t.attribute.value.length - 1))) : t.position = parseInt(i, 10) - 1;
                                        }
                                        return t;
                                    });
                                }
                                var t, n;
                                return t = e, n = [
                                    {
                                        key: "isValid",
                                        value: function() {
                                            return this.valid;
                                        }
                                    },
                                    {
                                        key: "findsElement",
                                        value: function() {
                                            return !this.findsAttribute();
                                        }
                                    },
                                    {
                                        key: "findsAttribute",
                                        value: function() {
                                            return this.path[this.path.length - 1].name.startsWith("@");
                                        }
                                    },
                                    {
                                        key: "getMpdTarget",
                                        value: function(e, t) {
                                            for(var n = null, r = e, i = 1, a1 = "MPD"; i < this.path.length && null !== r;){
                                                n = r;
                                                var o = this.path[i];
                                                if (a1 = o.name, i !== this.path.length - 1 || !a1.startsWith("@")) {
                                                    var s1 = n[a1 + "_asArray"] || [];
                                                    0 === s1.length && n[a1] && s1.push(n[a1]), o.position ? r = s1[o.position] || null : o.attribute ? function() {
                                                        var e = o.attribute;
                                                        r = s1.filter(function(t) {
                                                            return t[e.name] == e.value;
                                                        })[0] || null;
                                                    }() : r = s1[0] || null;
                                                }
                                                i++;
                                            }
                                            return null === r ? null : a1.startsWith("@") ? {
                                                name: a1.substring(1),
                                                leaf: r,
                                                target: r
                                            } : {
                                                name: a1,
                                                leaf: r,
                                                target: t ? n : r
                                            };
                                        }
                                    }
                                ], r(t.prototype, n), e;
                            }();
                            t.default = i;
                        },
                        "./src/dash/vo/StreamInfo.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.id = null, this.index = null, this.start = NaN, this.duration = NaN, this.manifestInfo = null, this.isLast = !0;
                            };
                        },
                        "./src/dash/vo/UTCTiming.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.schemeIdUri = "", this.value = "";
                            };
                        },
                        "./src/streaming/FragmentLoader.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/Constants.js"), i = n("./src/streaming/net/URLLoader.js"), a1 = n("./src/streaming/vo/HeadRequest.js"), o = n("./src/streaming/vo/DashJSError.js"), s1 = n("./src/core/FactoryMaker.js");
                            function u(e) {
                                e = e || {};
                                var t, n, s1 = this.context, u = e.eventBus, l = e.events, c = e.urlUtils, d = e.errors, f = e.streamId;
                                return t = {
                                    checkForExistence: function(e) {
                                        var t = function(t) {
                                            u.trigger(l.CHECK_FOR_EXISTENCE_COMPLETED, {
                                                request: e,
                                                exists: t
                                            });
                                        };
                                        if (e) {
                                            var r = new a1.default(e.url);
                                            n.load({
                                                request: r,
                                                success: function() {
                                                    t(!0);
                                                },
                                                error: function() {
                                                    t(!1);
                                                }
                                            });
                                        } else t(!1);
                                    },
                                    load: function(e) {
                                        var r = function(n, r) {
                                            u.trigger(l.LOADING_COMPLETED, {
                                                request: e,
                                                response: n || null,
                                                error: r || null,
                                                sender: t
                                            });
                                        };
                                        e ? n.load({
                                            request: e,
                                            progress: function(n) {
                                                u.trigger(l.LOADING_PROGRESS, {
                                                    request: e,
                                                    stream: n.stream,
                                                    streamId: f
                                                }), n.data && u.trigger(l.LOADING_DATA_PROGRESS, {
                                                    request: e,
                                                    response: n.data || null,
                                                    error: null,
                                                    sender: t
                                                });
                                            },
                                            success: function(e) {
                                                r(e);
                                            },
                                            error: function(e, t, n) {
                                                r(void 0, new o.default(d.FRAGMENT_LOADER_LOADING_FAILURE_ERROR_CODE, n, t));
                                            },
                                            abort: function(e) {
                                                e && u.trigger(l.LOADING_ABANDONED, {
                                                    mediaType: e.mediaType,
                                                    request: e,
                                                    sender: t
                                                });
                                            }
                                        }) : r(void 0, new o.default(d.FRAGMENT_LOADER_NULL_REQUEST_ERROR_CODE, d.FRAGMENT_LOADER_NULL_REQUEST_ERROR_MESSAGE));
                                    },
                                    abort: function() {
                                        n && n.abort();
                                    },
                                    reset: function() {
                                        n && (n.abort(), n = null);
                                    }
                                }, n = Object(i.default)(s1).create({
                                    errHandler: e.errHandler,
                                    errors: d,
                                    dashMetrics: e.dashMetrics,
                                    mediaPlayerModel: e.mediaPlayerModel,
                                    requestModifier: e.requestModifier,
                                    urlUtils: c,
                                    constants: r.default,
                                    boxParser: e.boxParser,
                                    dashConstants: e.dashConstants,
                                    requestTimeout: e.settings.get().streaming.fragmentRequestTimeout
                                }), t;
                            }
                            u.__dashjs_factory_name = "FragmentLoader", t.default = s1.default.getClassFactory(u);
                        },
                        "./src/streaming/ManifestLoader.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/Constants.js"), i = n("./src/dash/constants/DashConstants.js"), a1 = n("./src/streaming/controllers/XlinkController.js"), o = n("./src/streaming/net/URLLoader.js"), s1 = n("./src/streaming/utils/URLUtils.js"), u = n("./src/streaming/vo/TextRequest.js"), l = n("./src/streaming/vo/DashJSError.js"), c = n("./src/streaming/vo/metrics/HTTPRequest.js"), d = n("./src/core/EventBus.js"), f = n("./src/core/events/Events.js"), h = n("./src/core/errors/Errors.js"), g = n("./src/core/FactoryMaker.js"), p = n("./src/dash/parser/DashParser.js");
                            function m(e) {
                                e = e || {};
                                var t, n, g, m, v, y = this.context, E = e.debug, T = e.settings, b = Object(d.default)(y).getInstance(), A = Object(s1.default)(y).getInstance(), _ = e.mssHandler, S = e.errHandler;
                                function w(e) {
                                    b.trigger(f.default.INTERNAL_MANIFEST_LOADED, {
                                        manifest: e.manifest
                                    });
                                }
                                return t = {
                                    load: function(e) {
                                        var t = new u.default(e, c.HTTPRequest.MPD_TYPE);
                                        g.load({
                                            request: t,
                                            success: function(t, i, a1) {
                                                var o, s1, u;
                                                if (m) {
                                                    if (a1 && a1 !== e ? (s1 = A.parseBaseUrl(a1), o = a1) : (A.isRelative(e) && (e = A.resolve(e, window.location.href)), s1 = A.parseBaseUrl(e)), "No Content" != i) {
                                                        if (null === v && (v = function(e) {
                                                            var t = null;
                                                            return e.indexOf("SmoothStreamingMedia") > -1 ? (_ && (t = _.createMssParser(), _.registerEvents()), t) : e.indexOf("MPD") > -1 || e.indexOf("Patch") > -1 ? Object(p.default)(y).create({
                                                                debug: E
                                                            }) : t;
                                                        }(t)), null !== v) {
                                                            m.setMatchers(v.getMatchers()), m.setIron(v.getIron());
                                                            try {
                                                                u = v.parse(t);
                                                            } catch (t) {
                                                                return void b.trigger(f.default.INTERNAL_MANIFEST_LOADED, {
                                                                    manifest: null,
                                                                    error: new l.default(h.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, h.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(e))
                                                                });
                                                            }
                                                            if (u) {
                                                                if (u.url = o || e, u.originalUrl || (u.originalUrl = u.url), u.hasOwnProperty(r.default.LOCATION) && (s1 = A.parseBaseUrl(u.Location_asArray[0]), n.debug("BaseURI set by Location to: " + s1)), T && T.get().streaming.enableManifestDurationMismatchFix && u.mediaPresentationDuration && u.Period_asArray.length > 1) {
                                                                    var c = u.Period_asArray.reduce(function(e, t) {
                                                                        return e + t.duration;
                                                                    }, 0);
                                                                    !isNaN(c) && u.mediaPresentationDuration > c && (n.warn("Media presentation duration greater than duration of all periods. Setting duration to total period duration"), u.mediaPresentationDuration = c);
                                                                }
                                                                u.baseUri = s1, u.loadedTime = new Date, m.resolveManifestOnLoad(u), b.trigger(f.default.ORIGINAL_MANIFEST_LOADED, {
                                                                    originalManifest: t
                                                                });
                                                            } else b.trigger(f.default.INTERNAL_MANIFEST_LOADED, {
                                                                manifest: null,
                                                                error: new l.default(h.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, h.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(e))
                                                            });
                                                        } else b.trigger(f.default.INTERNAL_MANIFEST_LOADED, {
                                                            manifest: null,
                                                            error: new l.default(h.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, h.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(e))
                                                        });
                                                    } else b.trigger(f.default.INTERNAL_MANIFEST_LOADED, {
                                                        manifest: null
                                                    });
                                                }
                                            },
                                            error: function(t, n, r) {
                                                b.trigger(f.default.INTERNAL_MANIFEST_LOADED, {
                                                    manifest: null,
                                                    error: new l.default(h.default.MANIFEST_LOADER_LOADING_FAILURE_ERROR_CODE, h.default.MANIFEST_LOADER_LOADING_FAILURE_ERROR_MESSAGE + "".concat(e, ", ").concat(r))
                                                });
                                            }
                                        });
                                    },
                                    reset: function() {
                                        b.off(f.default.XLINK_READY, w, t), _ && _.reset(), m && (m.reset(), m = null), g && (g.abort(), g = null);
                                    }
                                }, n = E.getLogger(t), b.on(f.default.XLINK_READY, w, t), g = Object(o.default)(y).create({
                                    errHandler: e.errHandler,
                                    dashMetrics: e.dashMetrics,
                                    mediaPlayerModel: e.mediaPlayerModel,
                                    requestModifier: e.requestModifier,
                                    urlUtils: A,
                                    constants: r.default,
                                    dashConstants: i.default,
                                    errors: h.default,
                                    requestTimeout: e.settings.get().streaming.manifestRequestTimeout
                                }), m = Object(a1.default)(y).create({
                                    errHandler: S,
                                    dashMetrics: e.dashMetrics,
                                    mediaPlayerModel: e.mediaPlayerModel,
                                    requestModifier: e.requestModifier,
                                    settings: e.settings
                                }), v = null, t;
                            }
                            m.__dashjs_factory_name = "ManifestLoader";
                            var v = g.default.getClassFactory(m);
                            t.default = v;
                        },
                        "./src/streaming/ManifestUpdater.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/EventBus.js"), i = n("./src/core/events/Events.js"), a1 = n("./src/streaming/MediaPlayerEvents.js"), o = n("./src/core/FactoryMaker.js"), s1 = n("./src/core/Debug.js"), u = n("./src/core/errors/Errors.js"), l = n("./src/dash/constants/DashConstants.js"), c = n("./src/streaming/utils/URLUtils.js");
                            function d() {
                                var e, t, n, o, d, f, h, g, p, m, v, y, E = this.context, T = Object(r.default)(E).getInstance(), b = Object(c.default)(E).getInstance();
                                function A() {
                                    n = NaN, h = !1, d = !0, f = !1, _();
                                }
                                function _() {
                                    null !== o && (clearTimeout(o), o = null);
                                }
                                function S(e) {
                                    _(), f || (isNaN(e) && !isNaN(n) && (e = 1e3 * n), isNaN(e) || (t.debug("Refresh manifest in " + e + " milliseconds."), o = setTimeout(R, e)));
                                }
                                function w() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                                    h = !0;
                                    var t = p.getValue(), n = t.url, r = m.getPatchLocation(t), i = m.getLocation(t);
                                    r && !e ? n = r : i && (n = i), b.isRelative(n) && (n = b.resolve(n, t.url)), g.load(n);
                                }
                                function I(e) {
                                    if (e) {
                                        if (m.getIsPatch(e)) {
                                            var r = e;
                                            e = p.getValue();
                                            var a1 = m.isPatchValid(e, r), o = a1;
                                            if (a1) {
                                                var s1 = m.getPublishTime(e);
                                                o = m.applyPatchToManifest(e, r);
                                                var u = m.getPublishTime(e);
                                                o = s1.getTime() != u.getTime();
                                            }
                                            if (!o) return t.debug("Patch provided is invalid, performing full manifest refresh"), void w(!0);
                                            e.loadedTime = new Date;
                                        }
                                    } else (e = p.getValue()).loadedTime = new Date;
                                    if (p.getValue() && p.getValue().type === l.default.DYNAMIC && e.type === l.default.STATIC) return T.trigger(i.default.DYNAMIC_TO_STATIC), h = !1, void (f = !0);
                                    p.setValue(e);
                                    var c = new Date, g = (c.getTime() - e.loadedTime.getTime()) / 1e3;
                                    1e3 * (n = m.getManifestUpdatePeriod(e, g)) > 2147483647 && (n = 2147483.647), T.trigger(i.default.MANIFEST_UPDATED, {
                                        manifest: e
                                    }), t.info("Manifest has been refreshed at " + c + "[" + c.getTime() / 1e3 + "] "), d || S();
                                }
                                function R() {
                                    d || (h ? S(y.get().streaming.manifestUpdateRetryInterval) : w());
                                }
                                function C(e) {
                                    e.error ? e.error.code === u.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE && v.error(e.error) : I(e.manifest);
                                }
                                function D() {
                                    d = !1, S();
                                }
                                function k() {
                                    (d = !y.get().streaming.scheduling.scheduleWhilePaused) && _();
                                }
                                function N() {
                                    h = !1;
                                }
                                return e = {
                                    initialize: function() {
                                        A(), T.on(i.default.STREAMS_COMPOSED, N, this), T.on(a1.default.PLAYBACK_STARTED, D, this), T.on(a1.default.PLAYBACK_PAUSED, k, this), T.on(i.default.INTERNAL_MANIFEST_LOADED, C, this);
                                    },
                                    setManifest: function(e) {
                                        I(e);
                                    },
                                    refreshManifest: w,
                                    getIsUpdating: function() {
                                        return h;
                                    },
                                    setConfig: function(e) {
                                        e && (e.manifestModel && (p = e.manifestModel), e.adapter && (m = e.adapter), e.manifestLoader && (g = e.manifestLoader), e.errHandler && (v = e.errHandler), e.settings && (y = e.settings));
                                    },
                                    reset: function() {
                                        T.off(a1.default.PLAYBACK_STARTED, D, this), T.off(a1.default.PLAYBACK_PAUSED, k, this), T.off(i.default.STREAMS_COMPOSED, N, this), T.off(i.default.INTERNAL_MANIFEST_LOADED, C, this), A();
                                    }
                                }, t = Object(s1.default)(E).getInstance().getLogger(e), e;
                            }
                            d.__dashjs_factory_name = "ManifestUpdater", t.default = o.default.getClassFactory(d);
                        },
                        "./src/streaming/MediaPlayer.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./externals/cea608-parser.js"), i = n.n(r), a1 = n("./src/streaming/constants/Constants.js"), o = n("./src/dash/constants/DashConstants.js"), s1 = n("./src/streaming/constants/MetricsConstants.js"), u = n("./src/streaming/controllers/PlaybackController.js"), l = n("./src/streaming/controllers/StreamController.js"), c = n("./src/streaming/controllers/GapController.js"), d = n("./src/streaming/controllers/CatchupController.js"), f = n("./src/dash/controllers/ServiceDescriptionController.js"), h = n("./src/dash/controllers/ContentSteeringController.js"), g = n("./src/streaming/controllers/MediaController.js"), p = n("./src/streaming/controllers/BaseURLController.js"), m = n("./src/streaming/ManifestLoader.js"), v = n("./src/streaming/utils/ErrorHandler.js"), y = n("./src/streaming/utils/Capabilities.js"), E = n("./src/streaming/utils/CapabilitiesFilter.js"), T = n("./src/streaming/utils/RequestModifier.js"), b = n("./src/streaming/models/URIFragmentModel.js"), A = n("./src/streaming/models/ManifestModel.js"), _ = n("./src/streaming/models/MediaPlayerModel.js"), S = n("./src/streaming/controllers/AbrController.js"), w = n("./src/streaming/net/SchemeLoaderFactory.js"), I = n("./src/streaming/models/VideoModel.js"), R = n("./src/streaming/models/CmcdModel.js"), C = n("./src/streaming/utils/DOMStorage.js"), D = n("./src/core/Debug.js"), k = n("./src/core/errors/Errors.js"), N = n("./src/core/EventBus.js"), L = n("./src/core/events/Events.js"), x = n("./src/streaming/MediaPlayerEvents.js"), M = n("./src/core/FactoryMaker.js"), O = n("./src/core/Settings.js"), P = n("./src/core/Version.js"), F = n("./src/dash/controllers/SegmentBaseController.js"), U = n("./src/dash/DashAdapter.js"), j = n("./src/dash/DashMetrics.js"), B = n("./src/dash/utils/TimelineConverter.js"), G = n("./src/streaming/vo/metrics/HTTPRequest.js"), H = n("./externals/base64.js"), V = n.n(H), K = n("./node_modules/codem-isoboxer/dist/iso_boxer.js"), q = n.n(K), Y = n("./src/streaming/vo/DashJSError.js"), W = n("./src/streaming/utils/SupervisorTools.js"), z = n("./src/streaming/ManifestUpdater.js"), X = n("./src/streaming/utils/URLUtils.js"), Q = n("./src/streaming/utils/BoxParser.js"), J = n("./src/streaming/text/TextController.js"), Z = n("./src/streaming/models/CustomParametersModel.js");
                            function $() {
                                var e, t, n, r, H, K, $, ee, te, ne, re, ie, ae, oe, se, ue, le, ce, de, fe, he, ge, pe, me, ve, ye, Ee, Te, be, Ae, _e, Se, we, Ie, Re, Ce, De, ke = "You must first call initialize() and set a source before calling this method", Ne = "You must first call initialize() and set a valid source and view before calling this method", Le = "You must first call attachView() to set the video element before calling this method", xe = "MediaPlayer not initialized!", Me = this.context, Oe = Object(N.default)(Me).getInstance(), Pe = Object(O.default)(Me).getInstance(), Fe = Object(D.default)(Me).getInstance({
                                    settings: Pe
                                });
                                function Ue() {
                                    Ze(null), Qe(null), r = null, ae && (ae.reset(), ae = null), oe && (oe.reset(), oe = null), de && de.reset(), Pe.reset(), ue && (ue.reset(), ue = null);
                                }
                                function je() {
                                    return !!n && !!Ie.getElement();
                                }
                                function Be() {
                                    return Object(P.getVersionString)();
                                }
                                function Ge() {
                                    if (!$) throw Ne;
                                    return Ee.isPaused();
                                }
                                function He() {
                                    if (!$) throw Ne;
                                    return Ee.getIsDynamic();
                                }
                                function Ve(e) {
                                    var t = me && me.hasVideoTrack() ? a1.default.VIDEO : a1.default.AUDIO, n = _e.getCurrentDVRInfo(t);
                                    if (!n) return 0;
                                    var r = Ee.getOriginalLiveDelay(), i = n.range.start + e;
                                    return i > n.range.end - r && (i = n.range.end - r), i;
                                }
                                function Ke(e) {
                                    if (!$) throw Ne;
                                    var t = Xe().currentTime;
                                    if (void 0 !== e) t = me.getTimeRelativeToStreamId(t, e);
                                    else if (Ee.getIsDynamic()) {
                                        var n = me && me.hasVideoTrack() ? a1.default.VIDEO : a1.default.AUDIO, r = _e.getCurrentDVRInfo(n);
                                        t = null === r || 0 === t ? 0 : Math.max(0, t - r.range.start);
                                    }
                                    return t;
                                }
                                function qe() {
                                    if (!$) throw Ne;
                                    var e = Xe().duration;
                                    if (Ee.getIsDynamic()) {
                                        var t = me && me.hasVideoTrack() ? a1.default.VIDEO : a1.default.AUDIO, n = _e.getCurrentDVRInfo(t);
                                        e = n ? n.range.end - n.range.start : 0;
                                    }
                                    return e;
                                }
                                function Ye(e) {
                                    Object(W.checkParameterType)(e, "boolean"), ee = e;
                                }
                                function We() {
                                    de.restoreDefaultUTCTimingSources();
                                }
                                function ze() {
                                    return _e;
                                }
                                function Xe() {
                                    if (!Ie.getElement()) throw Le;
                                    return Ie.getElement();
                                }
                                function Qe(e) {
                                    if (!H) throw xe;
                                    Ie.setElement(e), e && (rt(), function() {
                                        if (!oe) {
                                            var e = dashjs.MetricsReporting;
                                            if ("function" == typeof e) {
                                                var t = e(Me).create();
                                                oe = t.createMetricsReporting({
                                                    debug: Fe,
                                                    eventBus: Oe,
                                                    mediaElement: Xe(),
                                                    adapter: le,
                                                    dashMetrics: _e,
                                                    mediaPlayerModel: ce,
                                                    events: L.default,
                                                    constants: a1.default,
                                                    metricsConstants: s1.default
                                                });
                                            }
                                        }
                                    }(), function() {
                                        if (!se) {
                                            var e = dashjs.MssHandler;
                                            "function" == typeof e && (k.default.extend(e.errors), se = e(Me).create({
                                                eventBus: Oe,
                                                mediaPlayerModel: ce,
                                                dashMetrics: _e,
                                                manifestModel: Se,
                                                playbackController: Ee,
                                                streamController: me,
                                                protectionController: ae,
                                                baseURLController: he,
                                                errHandler: fe,
                                                events: L.default,
                                                constants: a1.default,
                                                debug: Fe,
                                                initSegmentType: G.HTTPRequest.INIT_SEGMENT_TYPE,
                                                BASE64: V.a,
                                                ISOBoxer: q.a,
                                                settings: Pe
                                            }));
                                        }
                                    }(), me && me.switchToVideoElement()), $ && et(), ot();
                                }
                                function Je(e) {
                                    if (!K) throw ke;
                                    var t = me.getActiveStreamInfo();
                                    return t ? ie.getTracksFor(e, t.id) : [];
                                }
                                function Ze(e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : NaN;
                                    if (!H) throw xe;
                                    "string" == typeof e && Re.initialize(e), n = e, (K || $) && et(), je() && ot(t);
                                }
                                function $e() {
                                    if (!K) throw ke;
                                    var e = me.getActiveStreamInfo();
                                    return e ? me.getStreamById(e.id) : null;
                                }
                                function et() {
                                    $ = !1, K = !1, le.reset(), me.reset(), ye.reset(), Ae.reset(), Ee.reset(), Te.reset(), be.reset(), te.reset(), ie.reset(), De.reset(), ae && (Pe.get().streaming.protection.keepProtectionMediaKeys ? ae.stop() : (ae.reset(), ae = null, rt())), ve.reset(), we.reset();
                                }
                                function tt() {
                                    var e = nt();
                                    me || (me = Object(l.default)(Me).getInstance()), ve || (ve = Object(J.default)(Me).create({
                                        errHandler: fe,
                                        manifestModel: Se,
                                        adapter: le,
                                        mediaController: ie,
                                        videoModel: Ie,
                                        settings: Pe
                                    })), pe.setConfig({
                                        capabilities: ge,
                                        customParametersModel: de,
                                        adapter: le,
                                        settings: Pe,
                                        manifestModel: Se,
                                        errHandler: fe
                                    }), me.setConfig({
                                        capabilities: ge,
                                        capabilitiesFilter: pe,
                                        manifestLoader: e,
                                        manifestModel: Se,
                                        mediaPlayerModel: ce,
                                        customParametersModel: de,
                                        protectionController: ae,
                                        textController: ve,
                                        adapter: le,
                                        dashMetrics: _e,
                                        errHandler: fe,
                                        timelineConverter: re,
                                        videoModel: Ie,
                                        playbackController: Ee,
                                        serviceDescriptionController: Te,
                                        contentSteeringController: be,
                                        abrController: te,
                                        mediaController: ie,
                                        settings: Pe,
                                        baseURLController: he,
                                        uriFragmentModel: Re,
                                        segmentBaseController: De
                                    }), ye.setConfig({
                                        settings: Pe,
                                        playbackController: Ee,
                                        streamController: me,
                                        videoModel: Ie,
                                        timelineConverter: re,
                                        adapter: le
                                    }), Ee.setConfig({
                                        streamController: me,
                                        serviceDescriptionController: Te,
                                        dashMetrics: _e,
                                        adapter: le,
                                        videoModel: Ie,
                                        timelineConverter: re,
                                        settings: Pe
                                    }), Ae.setConfig({
                                        streamController: me,
                                        playbackController: Ee,
                                        mediaPlayerModel: ce,
                                        videoModel: Ie,
                                        settings: Pe
                                    }), te.setConfig({
                                        streamController: me,
                                        domStorage: Ce,
                                        mediaPlayerModel: ce,
                                        customParametersModel: de,
                                        dashMetrics: _e,
                                        adapter: le,
                                        videoModel: Ie,
                                        settings: Pe
                                    }), we.setConfig({
                                        abrController: te,
                                        dashMetrics: _e,
                                        playbackController: Ee
                                    }), be.setConfig({
                                        adapter: le,
                                        errHandler: fe,
                                        dashMetrics: _e,
                                        mediaPlayerModel: ce,
                                        manifestModel: Se,
                                        abrController: te,
                                        eventBus: Oe,
                                        requestModifier: Object(T.default)(Me).getInstance()
                                    }), te.initialize(), me.initialize(ee, r), ve.initialize(), ye.initialize(), Ae.initialize(), we.initialize(), be.initialize(), De.initialize();
                                }
                                function nt() {
                                    return Object(m.default)(Me).create({
                                        debug: Fe,
                                        errHandler: fe,
                                        dashMetrics: _e,
                                        mediaPlayerModel: ce,
                                        requestModifier: Object(T.default)(Me).getInstance(),
                                        mssHandler: se,
                                        settings: Pe
                                    });
                                }
                                function rt() {
                                    if (ae) return ae;
                                    var e = dashjs.Protection;
                                    if ("function" == typeof e) {
                                        var t = e(Me).create();
                                        return L.default.extend(e.events), x.default.extend(e.events, {
                                            publicOnly: !0
                                        }), k.default.extend(e.errors), ge || (ge = Object(y.default)(Me).getInstance()), ae = t.createProtectionSystem({
                                            debug: Fe,
                                            errHandler: fe,
                                            videoModel: Ie,
                                            customParametersModel: de,
                                            capabilities: ge,
                                            eventBus: Oe,
                                            events: L.default,
                                            BASE64: V.a,
                                            constants: a1.default,
                                            cmcdModel: we,
                                            settings: Pe
                                        });
                                    }
                                    return null;
                                }
                                function it() {
                                    if (!H) throw xe;
                                    if (ue) return ue;
                                    var e = dashjs.OfflineController;
                                    if ("function" == typeof e) {
                                        L.default.extend(e.events), x.default.extend(e.events, {
                                            publicOnly: !0
                                        }), k.default.extend(e.errors);
                                        var t = nt(), n = Object(z.default)(Me).create();
                                        return n.setConfig({
                                            manifestModel: Se,
                                            adapter: le,
                                            manifestLoader: t,
                                            errHandler: fe
                                        }), ue = e(Me).create({
                                            debug: Fe,
                                            manifestUpdater: n,
                                            baseURLController: he,
                                            manifestLoader: t,
                                            manifestModel: Se,
                                            mediaPlayerModel: ce,
                                            abrController: te,
                                            playbackController: Ee,
                                            adapter: le,
                                            errHandler: fe,
                                            dashMetrics: _e,
                                            timelineConverter: re,
                                            segmentBaseController: De,
                                            schemeLoaderFactory: ne,
                                            eventBus: Oe,
                                            events: L.default,
                                            errors: k.default,
                                            constants: a1.default,
                                            settings: Pe,
                                            dashConstants: o.default,
                                            urlUtils: Object(X.default)(Me).getInstance()
                                        });
                                    }
                                    return null;
                                }
                                function at(e) {
                                    var t = me && me.hasVideoTrack() ? a1.default.VIDEO : a1.default.AUDIO, n = _e.getCurrentDVRInfo(t);
                                    return n ? e + (n.manifestInfo.availableFrom.getTime() / 1e3 + n.range.start) : 0;
                                }
                                function ot() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : NaN;
                                    ue && ue.resetRecords(), !K && n && (K = !0, t.info("Streaming Initialized"), tt(), "string" == typeof n ? me.load(n, e) : me.loadWithManifest(n, e)), !$ && je() && ($ = !0, t.info("Playback Initialized"));
                                }
                                return e = {
                                    initialize: function(e, n, r) {
                                        var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : NaN;
                                        ge || (ge = Object(y.default)(Me).getInstance()).setConfig({
                                            settings: Pe
                                        }), fe || (fe = Object(v.default)(Me).getInstance()), ge.supportsMediaSource() ? (H || (H = !0, re = Object(B.default)(Me).getInstance(), te || (te = Object(S.default)(Me).getInstance()).setConfig({
                                            settings: Pe
                                        }), ne || (ne = Object(w.default)(Me).getInstance()), Ee || (Ee = Object(u.default)(Me).getInstance()), ie || (ie = Object(g.default)(Me).getInstance()), me || (me = Object(l.default)(Me).getInstance()), ye || (ye = Object(c.default)(Me).getInstance()), Ae || (Ae = Object(d.default)(Me).getInstance()), Te || (Te = Object(f.default)(Me).getInstance()), be || (be = Object(h.default)(Me).getInstance()), pe || (pe = Object(E.default)(Me).getInstance()), le = Object(U.default)(Me).getInstance(), Se = Object(A.default)(Me).getInstance(), we = Object(R.default)(Me).getInstance(), _e = Object(j.default)(Me).getInstance({
                                            settings: Pe
                                        }), Ce = Object(C.default)(Me).getInstance({
                                            settings: Pe
                                        }), le.setConfig({
                                            constants: a1.default,
                                            cea608parser: i.a,
                                            errHandler: fe,
                                            BASE64: V.a
                                        }), he || (he = Object(p.default)(Me).create()), he.setConfig({
                                            adapter: le
                                        }), Te.setConfig({
                                            adapter: le
                                        }), De || (De = Object(F.default)(Me).getInstance({
                                            dashMetrics: _e,
                                            mediaPlayerModel: ce,
                                            errHandler: fe,
                                            baseURLController: he,
                                            events: L.default,
                                            eventBus: Oe,
                                            debug: Fe,
                                            boxParser: Object(Q.default)(Me).getInstance(),
                                            requestModifier: Object(T.default)(Me).getInstance(),
                                            errors: k.default
                                        })), ie.setConfig({
                                            domStorage: Ce,
                                            settings: Pe,
                                            customParametersModel: de
                                        }), ce.setConfig({
                                            playbackController: Ee,
                                            serviceDescriptionController: Te
                                        }), We(), Ye(void 0 === r || r), it()), e && Qe(e), n && Ze(n, o), t.info("[dash.js " + Be() + "] MediaPlayer has been initialized")) : fe.error(new Y.default(k.default.CAPABILITY_MEDIASOURCE_ERROR_CODE, k.default.CAPABILITY_MEDIASOURCE_ERROR_MESSAGE));
                                    },
                                    setConfig: function(e) {
                                        e && (e.capabilities && (ge = e.capabilities), e.capabilitiesFilter && (pe = e.capabilitiesFilter), e.streamController && (me = e.streamController), e.textController && (ve = e.textController), e.gapController && (ye = e.gapController), e.playbackController && (Ee = e.playbackController), e.serviceDescriptionController && (Te = e.serviceDescriptionController), e.contentSteeringController && (be = e.contentSteeringController), e.catchupController && (Ae = e.catchupController), e.mediaPlayerModel && (ce = e.mediaPlayerModel), e.customParametersModel && (de = e.customParametersModel), e.abrController && (te = e.abrController), e.schemeLoaderFactory && (ne = e.schemeLoaderFactory), e.mediaController && (ie = e.mediaController), e.settings && (Pe = e.settings));
                                    },
                                    on: function(e, t, n, r) {
                                        Oe.on(e, t, n, r);
                                    },
                                    off: function(e, t, n) {
                                        Oe.off(e, t, n);
                                    },
                                    extend: function(e, t, n) {
                                        M.default.extend(e, t, n, Me);
                                    },
                                    attachView: Qe,
                                    attachSource: Ze,
                                    isReady: je,
                                    play: function() {
                                        if (!$) throw Ne;
                                        (!ee || Ge() && $) && Ee.play(!0);
                                    },
                                    isPaused: Ge,
                                    pause: function() {
                                        if (!$) throw Ne;
                                        Ee.pause();
                                    },
                                    isSeeking: function() {
                                        if (!$) throw Ne;
                                        return Ee.isSeeking();
                                    },
                                    isDynamic: He,
                                    getLowLatencyModeEnabled: function() {
                                        if (!$) throw Ne;
                                        return Ee.getLowLatencyModeEnabled();
                                    },
                                    seek: function(e) {
                                        if (!$) throw Ne;
                                        if (Object(W.checkParameterType)(e, "number"), isNaN(e)) throw a1.default.BAD_ARGUMENT_ERROR;
                                        var t = Ee.getIsDynamic() ? Ve(e) : e, n = Xe();
                                        !Ee.getIsDynamic() && n.duration && (t = Math.min(n.duration, t)), Ee.seek(t, !1, !1, !0);
                                    },
                                    seekToOriginalLive: function() {
                                        $ && He() && Ee.seekToOriginalLive();
                                    },
                                    setPlaybackRate: function(e) {
                                        Xe().playbackRate = e;
                                    },
                                    getPlaybackRate: function() {
                                        return Xe().playbackRate;
                                    },
                                    setMute: function(e) {
                                        Object(W.checkParameterType)(e, "boolean"), Xe().muted = e;
                                    },
                                    isMuted: function() {
                                        return Xe().muted;
                                    },
                                    setVolume: function(e) {
                                        if ("number" != typeof e || isNaN(e) || e < 0 || e > 1) throw a1.default.BAD_ARGUMENT_ERROR;
                                        Xe().volume = e;
                                    },
                                    getVolume: function() {
                                        return Xe().volume;
                                    },
                                    time: Ke,
                                    duration: qe,
                                    timeAsUTC: function() {
                                        if (!$) throw Ne;
                                        return Ke() < 0 ? NaN : at(Ke());
                                    },
                                    durationAsUTC: function() {
                                        if (!$) throw Ne;
                                        return at(qe());
                                    },
                                    getActiveStream: $e,
                                    getDVRWindowSize: function() {
                                        var e = me && me.hasVideoTrack() ? a1.default.VIDEO : a1.default.AUDIO, t = _e.getCurrentDVRInfo(e);
                                        return t ? t.manifestInfo.dvrWindowSize : 0;
                                    },
                                    getDVRSeekOffset: Ve,
                                    getTargetLiveDelay: function() {
                                        if (!$) throw Ne;
                                        return Ee.getOriginalLiveDelay();
                                    },
                                    convertToTimeCode: function(e) {
                                        e = Math.max(e, 0);
                                        var t = Math.floor(e / 3600), n = Math.floor(e % 3600 / 60), r = Math.floor(e % 3600 % 60);
                                        return (0 === t ? "" : t < 10 ? "0" + t.toString() + ":" : t.toString() + ":") + (n < 10 ? "0" + n.toString() : n.toString()) + ":" + (r < 10 ? "0" + r.toString() : r.toString());
                                    },
                                    formatUTC: function(e, t, n) {
                                        var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], i = new Date(1e3 * e), a1 = i.toLocaleDateString(t), o = i.toLocaleTimeString(t, {
                                            hour12: n
                                        });
                                        return r ? o + " " + a1 : o;
                                    },
                                    getVersion: Be,
                                    getDebug: function() {
                                        return Fe;
                                    },
                                    getBufferLength: function(e) {
                                        var n = [
                                            a1.default.VIDEO,
                                            a1.default.AUDIO,
                                            a1.default.TEXT
                                        ];
                                        if (e) return -1 !== n.indexOf(e) ? ze().getCurrentBufferLevel(e) || NaN : (t.warn("getBufferLength requested for invalid type"), NaN);
                                        var r = n.map(function(e) {
                                            return Je(e).length > 0 ? ze().getCurrentBufferLevel(e) : Number.MAX_VALUE;
                                        }).reduce(function(e, t) {
                                            return Math.min(e, t);
                                        });
                                        return r === Number.MAX_VALUE ? NaN : r;
                                    },
                                    getTTMLRenderingDiv: function() {
                                        return Ie ? Ie.getTTMLRenderingDiv() : null;
                                    },
                                    getVideoElement: Xe,
                                    getSource: function() {
                                        if (!n) throw "You must first call attachSource() with a valid source before calling this method";
                                        return n;
                                    },
                                    updateSource: function(e) {
                                        n = e, me.load(n);
                                    },
                                    getCurrentLiveLatency: function() {
                                        if (!H) throw xe;
                                        return $ ? Ee.getCurrentLiveLatency() : NaN;
                                    },
                                    getTopBitrateInfoFor: function(e) {
                                        if (!K) throw ke;
                                        return te.getTopBitrateInfoFor(e);
                                    },
                                    setAutoPlay: Ye,
                                    getAutoPlay: function() {
                                        return ee;
                                    },
                                    getDashMetrics: ze,
                                    getQualityFor: function(e) {
                                        if (!K) throw ke;
                                        if (e === a1.default.IMAGE) {
                                            var t = $e();
                                            if (!t) return -1;
                                            var n = t.getThumbnailController();
                                            return n ? n.getCurrentTrackIndex() : -1;
                                        }
                                        return te.getQualityFor(e);
                                    },
                                    setQualityFor: function(e, t) {
                                        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                                        if (!K) throw ke;
                                        if (e === a1.default.IMAGE) {
                                            var r = $e();
                                            if (!r) return;
                                            var i = r.getThumbnailController();
                                            i && i.setTrackByIndex(t);
                                        }
                                        te.setPlaybackQuality(e, me.getActiveStreamInfo(), t, {
                                            forceReplace: n
                                        });
                                    },
                                    updatePortalSize: function() {
                                        te.setElementSize(), te.setWindowResizeEventCalled(!0);
                                    },
                                    enableText: function(e) {
                                        var t = me.getActiveStreamInfo();
                                        return !(!t || !ve) && ve.enableText(t.id, e);
                                    },
                                    enableForcedTextStreaming: function(e) {
                                        return !(!me.getActiveStreamInfo() || !ve) && ve.enableForcedTextStreaming(e);
                                    },
                                    isTextEnabled: function() {
                                        var e = me.getActiveStreamInfo();
                                        return !(!e || !ve) && ve.isTextEnabled(e);
                                    },
                                    setTextTrack: function(e) {
                                        if (!$) throw Ne;
                                        var t = me.getActiveStreamInfo();
                                        t && ve && ve.setTextTrack(t.id, e);
                                    },
                                    getBitrateInfoListFor: function(e) {
                                        if (!K) throw ke;
                                        var t = $e();
                                        return t ? t.getBitrateListFor(e) : [];
                                    },
                                    getStreamsFromManifest: function(e) {
                                        if (!K) throw ke;
                                        return le.getStreamsInfo(e);
                                    },
                                    getTracksFor: Je,
                                    getTracksForTypeFromManifest: function(e, t, n) {
                                        if (!K) throw ke;
                                        return (n = n || le.getStreamsInfo(t, 1)[0]) ? le.getAllMediaInfoForType(n, e, t) : [];
                                    },
                                    getCurrentTrackFor: function(e) {
                                        if (!K) throw ke;
                                        var t = me.getActiveStreamInfo();
                                        return ie.getCurrentTrackFor(e, t.id);
                                    },
                                    setInitialMediaSettingsFor: function(e, t) {
                                        if (!H) throw xe;
                                        ie.setInitialSettings(e, t);
                                    },
                                    getInitialMediaSettingsFor: function(e) {
                                        if (!H) throw xe;
                                        return ie.getInitialSettings(e);
                                    },
                                    setCurrentTrack: function(e) {
                                        if (!K) throw ke;
                                        ie.setTrack(e);
                                    },
                                    addABRCustomRule: function(e, t, n) {
                                        de.addAbrCustomRule(e, t, n);
                                    },
                                    removeABRCustomRule: function(e) {
                                        de.removeAbrCustomRule(e);
                                    },
                                    removeAllABRCustomRule: function() {
                                        de.removeAllAbrCustomRule();
                                    },
                                    getABRCustomRules: function() {
                                        return de.getAbrCustomRules();
                                    },
                                    getAverageThroughput: function(e) {
                                        var t = te.getThroughputHistory(), n = Ee.getIsDynamic();
                                        return t ? t.getAverageThroughput(e, n) : 0;
                                    },
                                    retrieveManifest: function(e, t) {
                                        var n = nt(), r = this;
                                        Oe.on(L.default.INTERNAL_MANIFEST_LOADED, function e(i) {
                                            i.error ? t(null, i.error) : t(i.manifest), Oe.off(L.default.INTERNAL_MANIFEST_LOADED, e, r), n.reset();
                                        }, r), Re.initialize(e), n.load(e);
                                    },
                                    addUTCTimingSource: function(e, t) {
                                        de.addUTCTimingSource(e, t);
                                    },
                                    removeUTCTimingSource: function(e, t) {
                                        de.removeUTCTimingSource(e, t);
                                    },
                                    clearDefaultUTCTimingSources: function() {
                                        de.clearDefaultUTCTimingSources();
                                    },
                                    restoreDefaultUTCTimingSources: We,
                                    setXHRWithCredentialsForType: function(e, t) {
                                        de.setXHRWithCredentialsForType(e, t);
                                    },
                                    getXHRWithCredentialsForType: function(e) {
                                        return de.getXHRWithCredentialsForType(e);
                                    },
                                    getProtectionController: function() {
                                        return rt();
                                    },
                                    attachProtectionController: function(e) {
                                        ae = e;
                                    },
                                    setProtectionData: function(e) {
                                        r = e, me && me.setProtectionData(r);
                                    },
                                    registerLicenseRequestFilter: function(e) {
                                        de.registerLicenseRequestFilter(e);
                                    },
                                    registerLicenseResponseFilter: function(e) {
                                        de.registerLicenseResponseFilter(e);
                                    },
                                    unregisterLicenseRequestFilter: function(e) {
                                        de.unregisterLicenseRequestFilter(e);
                                    },
                                    unregisterLicenseResponseFilter: function(e) {
                                        de.unregisterLicenseResponseFilter(e);
                                    },
                                    registerCustomCapabilitiesFilter: function(e) {
                                        de.registerCustomCapabilitiesFilter(e);
                                    },
                                    unregisterCustomCapabilitiesFilter: function(e) {
                                        de.unregisterCustomCapabilitiesFilter(e);
                                    },
                                    setCustomInitialTrackSelectionFunction: function(e) {
                                        de.setCustomInitialTrackSelectionFunction(e);
                                    },
                                    resetCustomInitialTrackSelectionFunction: function() {
                                        de.resetCustomInitialTrackSelectionFunction(null);
                                    },
                                    attachTTMLRenderingDiv: function(e) {
                                        if (!Ie.getElement()) throw Le;
                                        Ie.setTTMLRenderingDiv(e);
                                    },
                                    getCurrentTextTrackIndex: function() {
                                        var e = me.getActiveStreamInfo();
                                        if (e && ve) return ve.getCurrentTrackIdx(e.id);
                                    },
                                    provideThumbnail: function(e, t) {
                                        if ("function" == typeof t) {
                                            if (e < 0) t(null);
                                            else {
                                                var n = Ee.getIsDynamic() ? Ve(e) : e, r = me.getStreamForTime(n);
                                                if (null !== r) {
                                                    var i = r.getThumbnailController();
                                                    if (i) return i.provide(n, t);
                                                    t(null);
                                                } else t(null);
                                            }
                                        }
                                    },
                                    getDashAdapter: function() {
                                        return le;
                                    },
                                    getOfflineController: function() {
                                        return it();
                                    },
                                    triggerSteeringRequest: function() {
                                        if (be) return be.loadSteeringData();
                                    },
                                    getCurrentSteeringResponseData: function() {
                                        if (be) return be.getCurrentSteeringResponseData();
                                    },
                                    getSettings: function() {
                                        return Pe.get();
                                    },
                                    updateSettings: function(e) {
                                        Pe.update(e);
                                    },
                                    resetSettings: function() {
                                        Pe.reset();
                                    },
                                    reset: Ue,
                                    destroy: function() {
                                        Ue(), M.default.deleteSingletonInstances(Me);
                                    }
                                }, t = Fe.getLogger(e), H = !1, $ = !1, K = !1, ee = !0, ae = null, ue = null, r = null, le = null, De = null, L.default.extend(x.default), ce = Object(_.default)(Me).getInstance(), de = Object(Z.default)(Me).getInstance(), Ie = Object(I.default)(Me).getInstance(), Re = Object(b.default)(Me).getInstance(), e;
                            }
                            $.__dashjs_factory_name = "MediaPlayer";
                            var ee = M.default.getClassFactory($);
                            ee.events = x.default, ee.errors = k.default, M.default.updateClassFactory($.__dashjs_factory_name, ee), t.default = ee;
                        },
                        "./src/streaming/MediaPlayerEvents.js": function(e, t, n) {
                            "use strict";
                            function r(e) {
                                return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, r(e);
                            }
                            function i(e, t) {
                                return i = Object.setPrototypeOf || function(e, t) {
                                    return e.__proto__ = t, e;
                                }, i(e, t);
                            }
                            function a1(e, t) {
                                return !t || "object" !== r(t) && "function" != typeof t ? function(e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e;
                                }(e) : t;
                            }
                            function o(e) {
                                return o = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                                    return e.__proto__ || Object.getPrototypeOf(e);
                                }, o(e);
                            }
                            n.r(t);
                            var s1 = new (function(e) {
                                !function(e, t) {
                                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                    e.prototype = Object.create(t && t.prototype, {
                                        constructor: {
                                            value: e,
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }), t && i(e, t);
                                }(s1, e);
                                var t, n, r = (t = s1, n = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e, r = o(t);
                                    if (n) {
                                        var i = o(this).constructor;
                                        e = Reflect.construct(r, arguments, i);
                                    } else e = r.apply(this, arguments);
                                    return a1(this, e);
                                });
                                function s1() {
                                    var e;
                                    return function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, s1), (e = r.call(this)).AST_IN_FUTURE = "astInFuture", e.BUFFER_EMPTY = "bufferStalled", e.BUFFER_LOADED = "bufferLoaded", e.BUFFER_LEVEL_STATE_CHANGED = "bufferStateChanged", e.BUFFER_LEVEL_UPDATED = "bufferLevelUpdated", e.DYNAMIC_TO_STATIC = "dynamicToStatic", e.ERROR = "error", e.FRAGMENT_LOADING_COMPLETED = "fragmentLoadingCompleted", e.FRAGMENT_LOADING_PROGRESS = "fragmentLoadingProgress", e.FRAGMENT_LOADING_STARTED = "fragmentLoadingStarted", e.FRAGMENT_LOADING_ABANDONED = "fragmentLoadingAbandoned", e.LOG = "log", e.MANIFEST_LOADED = "manifestLoaded", e.METRICS_CHANGED = "metricsChanged", e.METRIC_CHANGED = "metricChanged", e.METRIC_ADDED = "metricAdded", e.METRIC_UPDATED = "metricUpdated", e.PERIOD_SWITCH_STARTED = "periodSwitchStarted", e.PERIOD_SWITCH_COMPLETED = "periodSwitchCompleted", e.QUALITY_CHANGE_REQUESTED = "qualityChangeRequested", e.QUALITY_CHANGE_RENDERED = "qualityChangeRendered", e.TRACK_CHANGE_RENDERED = "trackChangeRendered", e.STREAM_INITIALIZING = "streamInitializing", e.STREAM_UPDATED = "streamUpdated", e.STREAM_ACTIVATED = "streamActivated", e.STREAM_DEACTIVATED = "streamDeactivated", e.STREAM_INITIALIZED = "streamInitialized", e.STREAM_TEARDOWN_COMPLETE = "streamTeardownComplete", e.TEXT_TRACKS_ADDED = "allTextTracksAdded", e.TEXT_TRACK_ADDED = "textTrackAdded", e.TTML_PARSED = "ttmlParsed", e.TTML_TO_PARSE = "ttmlToParse", e.CAPTION_RENDERED = "captionRendered", e.CAPTION_CONTAINER_RESIZE = "captionContainerResize", e.CAN_PLAY = "canPlay", e.CAN_PLAY_THROUGH = "canPlayThrough", e.PLAYBACK_ENDED = "playbackEnded", e.PLAYBACK_ERROR = "playbackError", e.PLAYBACK_NOT_ALLOWED = "playbackNotAllowed", e.PLAYBACK_METADATA_LOADED = "playbackMetaDataLoaded", e.PLAYBACK_LOADED_DATA = "playbackLoadedData", e.PLAYBACK_PAUSED = "playbackPaused", e.PLAYBACK_PLAYING = "playbackPlaying", e.PLAYBACK_PROGRESS = "playbackProgress", e.PLAYBACK_RATE_CHANGED = "playbackRateChanged", e.PLAYBACK_SEEKED = "playbackSeeked", e.PLAYBACK_SEEKING = "playbackSeeking", e.PLAYBACK_STALLED = "playbackStalled", e.PLAYBACK_STARTED = "playbackStarted", e.PLAYBACK_TIME_UPDATED = "playbackTimeUpdated", e.PLAYBACK_VOLUME_CHANGED = "playbackVolumeChanged", e.PLAYBACK_WAITING = "playbackWaiting", e.MANIFEST_VALIDITY_CHANGED = "manifestValidityChanged", e.EVENT_MODE_ON_START = "eventModeOnStart", e.EVENT_MODE_ON_RECEIVE = "eventModeOnReceive", e.CONFORMANCE_VIOLATION = "conformanceViolation", e.REPRESENTATION_SWITCH = "representationSwitch", e.ADAPTATION_SET_REMOVED_NO_CAPABILITIES = "adaptationSetRemovedNoCapabilities", e.CONTENT_STEERING_REQUEST_COMPLETED = "contentSteeringRequestCompleted", e;
                                }
                                return s1;
                            }(n("./src/core/events/EventsBase.js").default));
                            t.default = s1;
                        },
                        "./src/streaming/MediaPlayerFactory.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r, i = n("./src/streaming/MediaPlayer.js"), a1 = function() {
                                var e;
                                function t(t, n, r) {
                                    if (!t || !/^VIDEO$/i.test(t.nodeName)) return null;
                                    if (t._dashjs_player) return t._dashjs_player;
                                    var a1, o = t.id || t.name || "video element";
                                    if (!(n = n || [].slice.call(t.querySelectorAll("source")).filter(function(e) {
                                        return "application/dash+xml" == e.type;
                                    })[0]) && t.src) (n = document.createElement("source")).src = t.src;
                                    else if (!n && !t.src) return null;
                                    return r = r || {}, (a1 = Object(i.default)(r).create()).initialize(t, n.src, t.autoplay), e || (e = a1.getDebug().getLogger()), e.debug("Converted " + o + " to dash.js player and added content: " + n.src), t._dashjs_player = a1, a1;
                                }
                                function n(e) {
                                    return /^VIDEO$/i.test(e.nodeName) ? e : n(e.parentNode);
                                }
                                return {
                                    create: t,
                                    createAll: function(e, r) {
                                        var i = [];
                                        e = e || "[data-dashjs-player]";
                                        for(var a1 = (r = r || document).querySelectorAll(e), o = 0; o < a1.length; o++){
                                            var s1 = t(a1[o], null);
                                            i.push(s1);
                                        }
                                        for(var u = r.querySelectorAll('source[type="application/dash+xml"]'), l = 0; l < u.length; l++){
                                            var c = t(n(u[l]), null);
                                            i.push(c);
                                        }
                                        return i;
                                    }
                                };
                            }();
                            !("undefined" != typeof window && window && window.dashjs && window.dashjs.skipAutoCreate) && "undefined" != typeof window && window && window.addEventListener && ("complete" === window.document.readyState ? window.dashjs ? a1.createAll() : r = window.setInterval(function() {
                                window.dashjs && (window.clearInterval(r), a1.createAll());
                            }, 500) : window.addEventListener("load", function e() {
                                window.removeEventListener("load", e), a1.createAll();
                            })), t.default = a1;
                        },
                        "./src/streaming/SourceBufferSink.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/Debug.js"), i = n("./src/streaming/vo/DashJSError.js"), a1 = n("./src/core/FactoryMaker.js"), o = n("./src/core/errors/Errors.js"), s1 = n("./src/core/Settings.js"), u = n("./src/streaming/constants/Constants.js"), l = n("./src/streaming/vo/metrics/HTTPRequest.js"), c = n("./src/core/events/Events.js");
                            function d(e) {
                                var t, n, a1, d, f, h, g = this.context, p = Object(s1.default)(g).getInstance(), m = e.textController, v = e.eventBus, y = [], E = [], T = !1, b = e.mediaSource, A = null;
                                function _(e) {
                                    return new Promise(function(t) {
                                        L(function() {
                                            d.changeType && d.changeType(e), t();
                                        });
                                    });
                                }
                                function S(e) {
                                    return d = m.getTextSourceBuffer(e), Promise.resolve();
                                }
                                function w() {
                                    if ("function" == typeof d.addEventListener) try {
                                        d.addEventListener("updateend", k, !1), d.addEventListener("error", N, !1), d.addEventListener("abort", N, !1);
                                    } catch (e) {
                                        h = setInterval(k, 50);
                                    }
                                    else h = setInterval(k, 50);
                                }
                                function I(e) {
                                    return new Promise(function(t) {
                                        d && p.get().streaming.buffer.useAppendWindow ? L(function() {
                                            try {
                                                if (!d) return void t();
                                                var n = b.duration, r = 0;
                                                e && !isNaN(e.start) && !isNaN(e.duration) && isFinite(e.duration) && (n = e.start + e.duration), e && !isNaN(e.start) && (r = e.start), d.appendWindowEnd === n && d.appendWindowStart === r || (d.appendWindowStart = 0, d.appendWindowEnd = n + .01, d.appendWindowStart = Math.max(r - .1, 0), a1.debug("Updated append window for ".concat(f.type, ". Set start to ").concat(d.appendWindowStart, " and end to ").concat(d.appendWindowEnd))), t();
                                            } catch (e) {
                                                a1.warn("Failed to set append window"), t();
                                            }
                                        }) : t();
                                    });
                                }
                                function R(e) {
                                    return new Promise(function(t) {
                                        d ? L(function() {
                                            try {
                                                d.timestampOffset === e || isNaN(e) || (d.timestampOffset = e, a1.debug("Set MSE timestamp offset to ".concat(e))), t();
                                            } catch (e) {
                                                t();
                                            }
                                        }) : t();
                                    });
                                }
                                function C() {
                                    if (!T && E.length > 0) {
                                        T = !0;
                                        var e = E[0];
                                        E.splice(0, 1);
                                        var t = function() {
                                            T = !1, E.length > 0 && C.call(this), e && e.data && e.data.segmentType && e.data.segmentType !== l.HTTPRequest.INIT_SEGMENT_TYPE && delete e.data.bytes, e.promise.resolve({
                                                chunk: e.data
                                            });
                                        };
                                        try {
                                            A = e.request, 0 === e.data.bytes.byteLength ? t.call(this) : (d.appendBuffer ? d.appendBuffer(e.data.bytes) : d.append(e.data.bytes, e.data), L(t.bind(this)));
                                        } catch (t) {
                                            a1.fatal('SourceBuffer append failed "' + t + '"'), E.length > 0 ? C() : T = !1, delete e.data.bytes, e.promise.reject({
                                                chunk: e.data,
                                                error: new i.default(t.code, t.message)
                                            });
                                        }
                                    }
                                }
                                function D() {
                                    y.length > 0 && (d.updating || (y.shift()(), D()));
                                }
                                function k() {
                                    d.updating || D();
                                }
                                function N(e) {
                                    var t, r, i = e.target || {};
                                    t = c.default.SOURCE_BUFFER_ERROR, r = {
                                        error: i,
                                        lastRequestAppended: A
                                    }, v.trigger(t, r, {
                                        streamId: f.streamInfo.id,
                                        mediaType: n
                                    });
                                }
                                function L(e) {
                                    y.push(e), d.updating || D();
                                }
                                return t = {
                                    getType: function() {
                                        return n;
                                    },
                                    getAllBufferRanges: function() {
                                        try {
                                            return d.buffered;
                                        } catch (e) {
                                            return a1.error("getAllBufferRanges exception: " + e.message), null;
                                        }
                                    },
                                    getBuffer: function() {
                                        return d;
                                    },
                                    append: function(e) {
                                        var t = this, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                                        return new Promise(function(r, a1) {
                                            e ? (E.push({
                                                data: e,
                                                promise: {
                                                    resolve: r,
                                                    reject: a1
                                                },
                                                request: n
                                            }), L(C.bind(t))) : a1({
                                                chunk: e,
                                                error: new i.default(o.default.APPEND_ERROR_CODE, o.default.APPEND_ERROR_MESSAGE)
                                            });
                                        });
                                    },
                                    remove: function(e) {
                                        return new Promise(function(t, n) {
                                            var r = e.start, a1 = e.end;
                                            r >= 0 && a1 > r ? L(function() {
                                                try {
                                                    d.remove(r, a1), L(function() {
                                                        t({
                                                            from: r,
                                                            to: a1,
                                                            unintended: !1
                                                        }), e.resolve && e.resolve();
                                                    });
                                                } catch (t) {
                                                    n({
                                                        from: r,
                                                        to: a1,
                                                        unintended: !1,
                                                        error: new i.default(o.default.REMOVE_ERROR_CODE, o.default.REMOVE_ERROR_MESSAGE)
                                                    }), e.reject && e.reject(t);
                                                }
                                            }) : t();
                                        });
                                    },
                                    abort: function() {
                                        return new Promise(function(e) {
                                            try {
                                                E = [], "open" === b.readyState ? L(function() {
                                                    try {
                                                        d && d.abort(), e();
                                                    } catch (t) {
                                                        e();
                                                    }
                                                }) : d && d.setTextTrack && "ended" === b.readyState ? (d.abort(), e()) : e();
                                            } catch (t) {
                                                e();
                                            }
                                        });
                                    },
                                    reset: function() {
                                        if (d) {
                                            try {
                                                y = [], function() {
                                                    try {
                                                        "function" == typeof d.removeEventListener && (d.removeEventListener("updateend", k, !1), d.removeEventListener("error", N, !1), d.removeEventListener("abort", N, !1)), clearInterval(h);
                                                    } catch (e) {
                                                        a1.error(e);
                                                    }
                                                }(), T = !1, E = [], d.getClassName && "TextSourceBuffer" === d.getClassName() || (a1.debug("Removing sourcebuffer from media source"), b.removeSourceBuffer(d));
                                            } catch (e) {}
                                            d = null;
                                        }
                                        A = null;
                                    },
                                    updateTimestampOffset: R,
                                    initializeForStreamSwitch: function(e, t, r) {
                                        n = (f = e).type;
                                        var i = f.codec;
                                        !function(e) {
                                            d = e.getBuffer();
                                        }(r), w();
                                        var a1 = [];
                                        return a1.push(new Promise(function(e) {
                                            L(function() {
                                                var t = d.appendWindowStart, n = d.appendWindowEnd;
                                                d && (d.abort(), d.appendWindowStart = t, d.appendWindowEnd = n), e();
                                            });
                                        })), a1.push(I(f.streamInfo)), a1.push(_(i)), t && void 0 !== t.MSETimeOffset && a1.push(R(t.MSETimeOffset)), Promise.all(a1);
                                    },
                                    initializeForFirstUse: function(e, t, r) {
                                        n = (f = t).type;
                                        var i = f.codec;
                                        try {
                                            if (i.match(/application\/mp4;\s*codecs="(stpp|wvtt).*"/i)) return S(e);
                                            d = b.addSourceBuffer(i), w();
                                            var a1 = [];
                                            return a1.push(I(f.streamInfo)), r && void 0 !== r.MSETimeOffset && a1.push(R(r.MSETimeOffset)), Promise.all(a1);
                                        } catch (t) {
                                            return f.type == u.default.TEXT && !f.isFragmented || -1 !== i.indexOf('codecs="stpp') || -1 !== i.indexOf('codecs="vtt') ? S(e) : Promise.reject(t);
                                        }
                                    },
                                    updateAppendWindow: I,
                                    changeType: _
                                }, a1 = Object(r.default)(g).getInstance().getLogger(t), t;
                            }
                            d.__dashjs_factory_name = "SourceBufferSink";
                            var f = a1.default.getClassFactory(d);
                            t.default = f;
                        },
                        "./src/streaming/Stream.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/Constants.js"), i = n("./src/dash/constants/DashConstants.js"), a1 = n("./src/streaming/StreamProcessor.js"), o = n("./src/streaming/controllers/FragmentController.js"), s1 = n("./src/streaming/thumbnail/ThumbnailController.js"), u = n("./src/core/EventBus.js"), l = n("./src/core/events/Events.js"), c = n("./src/core/Debug.js"), d = n("./src/core/errors/Errors.js"), f = n("./src/core/FactoryMaker.js"), h = n("./src/streaming/vo/DashJSError.js"), g = n("./src/streaming/utils/BoxParser.js"), p = n("./src/streaming/utils/URLUtils.js"), m = n("./src/streaming/controllers/BlacklistController.js"), v = [
                                r.default.VIDEO,
                                r.default.AUDIO,
                                r.default.TEXT,
                                r.default.MUXED,
                                r.default.IMAGE
                            ];
                            function y(e) {
                                e = e || {};
                                var t, n, f, y, E, T, b, A, _, S, w, I, R, C, D, k, N, L, x = this.context, M = Object(u.default)(x).getInstance(), O = Object(p.default)(x).getInstance(), P = e.manifestModel, F = e.mediaPlayerModel, U = e.dashMetrics, j = e.manifestUpdater, B = e.adapter, G = e.timelineConverter, H = e.capabilities, V = e.errHandler, K = e.abrController, q = e.playbackController, Y = e.eventController, W = e.mediaController, z = e.protectionController, X = e.textController, Q = e.videoModel, J = e.streamInfo, Z = e.settings;
                                function $(t, o) {
                                    return new Promise(function(u, c) {
                                        se(), S = !0, le();
                                        var g, p = Q.getElement();
                                        v.forEach(function(o) {
                                            (o !== r.default.VIDEO || !p || p && /^VIDEO$/i.test(p.nodeName)) && function(t, o) {
                                                var u, c = B.getAllMediaInfoForType(J, t), d = [], h = null;
                                                if (c && 0 !== c.length) {
                                                    t === r.default.VIDEO && (b = !0), t === r.default.AUDIO && (A = !0);
                                                    for(var g = 0, p = c.length; g < p; g++)h = c[g], t === r.default.TEXT && h.isEmbedded && (X.addEmbeddedTrack(J, h), d.push(h)), ee(h) && W.addTrack(h);
                                                    if (d.length > 0 && (W.setInitialMediaSettingsForType(t, J), X.addMediaInfosToBuffer(J, t, d)), c = c.filter(function(e) {
                                                        return !e.isEmbedded;
                                                    }), 0 !== c.length) {
                                                        if (t !== r.default.IMAGE) {
                                                            M.trigger(l.default.STREAM_INITIALIZING, {
                                                                streamInfo: J,
                                                                mediaInfo: h
                                                            }), W.setInitialMediaSettingsForType(t, J);
                                                            var m = function(t, n) {
                                                                var i = t && t.length > 0 ? t[0] : null, o = w.getModel(i ? i.type : null), s1 = i ? i.type : null, u = i ? i.mimeType : null, l = i ? i.isFragmented : null, c = Object(a1.default)(x).create({
                                                                    streamInfo: J,
                                                                    type: s1,
                                                                    mimeType: u,
                                                                    timelineConverter: G,
                                                                    adapter: B,
                                                                    manifestModel: P,
                                                                    mediaPlayerModel: F,
                                                                    fragmentModel: o,
                                                                    dashMetrics: e.dashMetrics,
                                                                    baseURLController: e.baseURLController,
                                                                    segmentBaseController: e.segmentBaseController,
                                                                    abrController: K,
                                                                    playbackController: q,
                                                                    mediaController: W,
                                                                    textController: X,
                                                                    errHandler: V,
                                                                    settings: Z,
                                                                    boxParser: D,
                                                                    segmentBlacklistController: R
                                                                });
                                                                c.initialize(n, b, l), f.push(c);
                                                                for(var d = 0; d < t.length; d++)c.addMediaInfo(t[d]);
                                                                return s1 === r.default.TEXT && X.addMediaInfosToBuffer(J, s1, t, o), c;
                                                            }(c, o);
                                                            (u = W.getCurrentTrackFor(t, J.id)) && (K.updateTopQualityIndex(u), m.selectMediaInfo(t === r.default.TEXT && u.isEmbedded ? c[0] : u));
                                                        } else (I = Object(s1.default)(x).create({
                                                            streamInfo: J,
                                                            adapter: B,
                                                            baseURLController: e.baseURLController,
                                                            timelineConverter: e.timelineConverter,
                                                            debug: k,
                                                            eventBus: M,
                                                            events: l.default,
                                                            dashConstants: i.default,
                                                            dashMetrics: e.dashMetrics,
                                                            segmentBaseController: e.segmentBaseController
                                                        })).initialize();
                                                    }
                                                } else n.info("No " + t + " data.");
                                            }(o, t);
                                        }), (g = o, new Promise(function(e) {
                                            var t = {}, n = f.map(function(e) {
                                                return e.createBufferSinks(g);
                                            });
                                            Promise.all(n).then(function(n) {
                                                n.forEach(function(e) {
                                                    e && (t[e.getType()] = e);
                                                }), e(t);
                                            }).catch(function() {
                                                e(t);
                                            });
                                        })).then(function(e) {
                                            if (S = !1, 0 === f.length) {
                                                var t = "No streams to play.";
                                                V.error(new h.default(d.default.MANIFEST_ERROR_ID_NOSTREAMS_CODE, t, P.getValue())), n.fatal(t);
                                            } else ce();
                                            X.createTracks(J), u(e);
                                        }).catch(function(e) {
                                            c(e);
                                        });
                                    });
                                }
                                function ee(e) {
                                    var t, i = e ? e.type : null;
                                    return i === r.default.MUXED ? (t = "Multiplexed representations are intentionally not supported, as they are not compliant with the DASH-AVC/264 guidelines", n.fatal(t), V.error(new h.default(d.default.MANIFEST_ERROR_ID_MULTIPLEXED_CODE, t, P.getValue())), !1) : !(i !== r.default.TEXT && i !== r.default.IMAGE && e.contentProtection && !H.supportsEncryptedMedia() && (V.error(new h.default(d.default.CAPABILITY_MEDIAKEYS_ERROR_CODE, d.default.CAPABILITY_MEDIAKEYS_ERROR_MESSAGE)), 1));
                                }
                                function te(e) {
                                    for(var t = f ? f.length : 0, n = 0; n < t; n++){
                                        var r = f[n].getFragmentModel();
                                        r.abortRequests(), r.resetInitialSettings(), f[n].reset(!1, e);
                                    }
                                    X && X.deactivateStream(J), f = [], E = !1, T = !1, Te(!1), re(!1), M.trigger(l.default.STREAM_DEACTIVATED, {
                                        streamInfo: J
                                    });
                                }
                                function ne(e) {
                                    te(e), y = !1, b = !1, A = !1, _ = {}, S = !1, N = !1, L = [];
                                }
                                function re(e) {
                                    N = e;
                                }
                                function ie() {
                                    return J ? J.start : NaN;
                                }
                                function ae() {
                                    return J ? J.id : null;
                                }
                                function oe() {
                                    return J;
                                }
                                function se() {
                                    if (!Q || !K) throw new Error(r.default.MISSING_CONFIG_ERROR);
                                }
                                function ue(e) {
                                    e.error && (V.error(e.error), n.fatal(e.error.message));
                                }
                                function le() {
                                    if (Y) {
                                        var e = B.getEventsFor(J);
                                        e && e.length > 0 && Y.addInlineEvents(e, J.id);
                                    }
                                }
                                function ce() {
                                    for(var e = f.length, t = _.audio || _.video ? new h.default(d.default.DATA_UPDATE_FAILED_ERROR_CODE, d.default.DATA_UPDATE_FAILED_ERROR_MESSAGE) : null, n = 0; n < e; n++)if (f[n].isUpdating() || S) return;
                                    if (z) {
                                        z.clearMediaInfoArray();
                                        for(var i = 0; i < e && f[i]; i++){
                                            var a1 = f[i].getType(), o = f[i].getMediaInfo();
                                            if (a1 === r.default.AUDIO || a1 === r.default.VIDEO || a1 === r.default.TEXT && o.isFragmented) {
                                                var s1 = f[i].getMediaInfo();
                                                s1 && z.initializeForMedia(s1);
                                            }
                                        }
                                        z.handleKeySystemFromManifest();
                                    }
                                    t ? V.error(t) : y || (y = !0, Q.waitForReadyState(r.default.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, function() {
                                        M.trigger(l.default.STREAM_INITIALIZED, {
                                            streamInfo: J
                                        });
                                    }));
                                }
                                function de() {
                                    var e = me(), t = e.length;
                                    if (0 !== t) {
                                        for(var i = 0; i < t; i++)if (!e[i].isBufferingCompleted() && (e[i].getType() === r.default.AUDIO || e[i].getType() === r.default.VIDEO)) return void n.debug("onBufferingCompleted - One streamProcessor has finished but", e[i].getType(), "one is not buffering completed");
                                        n.debug("onBufferingCompleted - trigger STREAM_BUFFERING_COMPLETED"), T = !0, M.trigger(l.default.STREAM_BUFFERING_COMPLETED, {
                                            streamInfo: J
                                        }, {
                                            streamInfo: J
                                        });
                                    } else n.warn("onBufferingCompleted - can't trigger STREAM_BUFFERING_COMPLETED because no streamProcessor is defined");
                                }
                                function fe(e) {
                                    _[e.mediaType] = e.error, ce();
                                }
                                function he(e) {
                                    Y && Y.addInbandEvents(e.events, J.id);
                                }
                                function ge(e) {
                                    return e && e.type ? pe(e.type) : null;
                                }
                                function pe(e) {
                                    return e ? me().filter(function(t) {
                                        return t.getType() === e;
                                    })[0] : null;
                                }
                                function me() {
                                    for(var e, t, n = [], i = 0; i < f.length; i++)(e = (t = f[i]).getType()) !== r.default.AUDIO && e !== r.default.VIDEO && e !== r.default.TEXT || n.push(t);
                                    return n;
                                }
                                function ve(e, t) {
                                    var n = oe(), r = t.getStreamInfo();
                                    if (!r || !n) return !0;
                                    var i = B.getAdaptationForType(r.index, e, r), a1 = B.getAdaptationForType(n.index, e, n);
                                    return i && a1 ? !(!ye(a1) && ye(i)) : !i && !a1;
                                }
                                function ye(e) {
                                    return !!e && !!(e.ContentProtection || e.Representation && e.Representation.length > 0 && e.Representation[0].ContentProtection);
                                }
                                function Ee(e, t) {
                                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                                    if (!e || !e.hasOwnProperty("getStreamInfo")) return !1;
                                    var r = e.getStreamInfo(), i = n ? n.getStreamInfo() : oe();
                                    if (!r || !i) return !1;
                                    var a1 = B.getAdaptationForType(r.index, t, r), o = B.getAdaptationForType(i.index, t, i);
                                    if (!a1 || !o) return !a1 && !o;
                                    var s1 = a1 && o && a1.mimeType === o.mimeType, u = o.Representation_asArray.map(function(e) {
                                        return e.codecs;
                                    }), l = a1.Representation_asArray.map(function(e) {
                                        return e.codecs;
                                    }), c = l.some(function(e) {
                                        return u.indexOf(e) > -1;
                                    }), d = l.some(function(e) {
                                        return u.some(function(t) {
                                            return H.codecRootCompatibleWithCodec(t, e);
                                        });
                                    });
                                    return c || d && s1;
                                }
                                function Te(e) {
                                    C = e;
                                }
                                function be() {
                                    return C;
                                }
                                return t = {
                                    initialize: function() {
                                        M.on(l.default.BUFFERING_COMPLETED, de, t), M.on(l.default.DATA_UPDATE_COMPLETED, fe, t), M.on(l.default.INBAND_EVENTS, he, t), z && (M.on(l.default.KEY_ERROR, ue, t), M.on(l.default.SERVER_CERTIFICATE_UPDATED, ue, t), M.on(l.default.LICENSE_REQUEST_COMPLETE, ue, t), M.on(l.default.KEY_SYSTEM_SELECTED, ue, t), M.on(l.default.KEY_SESSION_CREATED, ue, t), M.on(l.default.KEY_STATUSES_CHANGED, ue, t)), X.initializeForStream(J), M.trigger(l.default.STREAM_UPDATED, {
                                            streamInfo: J
                                        });
                                    },
                                    getStreamId: function() {
                                        return J ? J.id : null;
                                    },
                                    activate: function(e, t) {
                                        return new Promise(function(n, r) {
                                            if (!E) return be() ? (E = !0, M.trigger(l.default.STREAM_ACTIVATED, {
                                                streamInfo: J
                                            }), void n(t)) : void (function(e, t) {
                                                return $(e, t);
                                            })(e, t).then(function(e) {
                                                E = !0, M.trigger(l.default.STREAM_ACTIVATED, {
                                                    streamInfo: J
                                                }), n(e);
                                            }).catch(function(e) {
                                                r(e);
                                            });
                                            n(t);
                                        });
                                    },
                                    deactivate: te,
                                    getIsActive: function() {
                                        return E;
                                    },
                                    getDuration: function() {
                                        return J ? J.duration : NaN;
                                    },
                                    getStartTime: ie,
                                    getId: ae,
                                    getStreamInfo: oe,
                                    getHasAudioTrack: function() {
                                        return A;
                                    },
                                    getHasVideoTrack: function() {
                                        return b;
                                    },
                                    startPreloading: function(e, t) {
                                        return new Promise(function(r, i) {
                                            be() ? i() : (n.info("[startPreloading] Preloading next stream with id ".concat(ae())), Te(!0), $(e, t).then(function() {
                                                for(var e = 0; e < f.length && f[e]; e++)f[e].setExplicitBufferingTime(ie()), f[e].getScheduleController().startScheduleTimer();
                                                r();
                                            }).catch(function() {
                                                Te(!1), i();
                                            }));
                                        });
                                    },
                                    getThumbnailController: function() {
                                        return I;
                                    },
                                    getBitrateListFor: function(e) {
                                        if (se(), e === r.default.IMAGE) return I ? I.getBitrateList() : [];
                                        var t = function(e) {
                                            for(var t = null, n = 0; n < f.length; n++)if ((t = f[n]).getType() === e) return t.getMediaInfo();
                                            return null;
                                        }(e);
                                        return K.getBitrateList(t);
                                    },
                                    updateData: function(e) {
                                        return new Promise(function(t) {
                                            S = !0, J = e, Y && le();
                                            for(var n = [], r = 0, i = f.length; r < i; r++){
                                                var a1 = f[r], o = a1.getMediaInfo();
                                                n.push(a1.updateStreamInfo(J));
                                                var s1 = B.getAllMediaInfoForType(J, a1.getType());
                                                if (s1) {
                                                    a1.clearMediaInfoArray();
                                                    for(var u = 0; u < s1.length; u++){
                                                        var c = s1[u];
                                                        a1.addMediaInfo(s1[u]), B.areMediaInfosEqual(o, c) && (K.updateTopQualityIndex(c), n.push(a1.selectMediaInfo(c)));
                                                    }
                                                }
                                            }
                                            Promise.all(n).then(function() {
                                                for(n = []; L.length > 0;){
                                                    var e = L.pop(), t = e.newMediaInfo, r = ge(e.oldMediaInfo);
                                                    if (!r) return;
                                                    n.push(r.prepareTrackSwitch()), r.selectMediaInfo(t);
                                                }
                                                return Promise.all(n);
                                            }).then(function() {
                                                S = !1, ce(), M.trigger(l.default.STREAM_UPDATED, {
                                                    streamInfo: J
                                                }), t();
                                            });
                                        });
                                    },
                                    reset: function(e) {
                                        w && (w.reset(), w = null), K && J && K.clearDataForStream(J.id), R && (R.reset(), R = null), ne(e), J = null, M.off(l.default.DATA_UPDATE_COMPLETED, fe, t), M.off(l.default.BUFFERING_COMPLETED, de, t), M.off(l.default.INBAND_EVENTS, he, t), z && (M.off(l.default.KEY_ERROR, ue, t), M.off(l.default.SERVER_CERTIFICATE_UPDATED, ue, t), M.off(l.default.LICENSE_REQUEST_COMPLETE, ue, t), M.off(l.default.KEY_SYSTEM_SELECTED, ue, t), M.off(l.default.KEY_SESSION_CREATED, ue, t), M.off(l.default.KEY_STATUSES_CHANGED, ue, t));
                                    },
                                    getProcessors: me,
                                    setMediaSource: function(e) {
                                        for(var t = 0; t < f.length;)ee(f[t].getMediaInfo()) ? (f[t].setMediaSource(e), t++) : (f[t].reset(), f.splice(t, 1));
                                        if (0 === f.length) {
                                            var r = "No streams to play.";
                                            V.error(new h.default(d.default.MANIFEST_ERROR_ID_NOSTREAMS_CODE, r + "nostreams", P.getValue())), n.fatal(r);
                                        }
                                    },
                                    isMediaCodecCompatible: function(e) {
                                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                                        return Ee(e, r.default.VIDEO, t) && Ee(e, r.default.AUDIO, t);
                                    },
                                    isProtectionCompatible: function(e) {
                                        return !e || ve(r.default.VIDEO, e) && ve(r.default.AUDIO, e);
                                    },
                                    getPreloaded: be,
                                    getIsEndedEventSignaled: function() {
                                        return N;
                                    },
                                    setIsEndedEventSignaled: re,
                                    getAdapter: function() {
                                        return B;
                                    },
                                    getHasFinishedBuffering: function() {
                                        return T;
                                    },
                                    setPreloaded: Te,
                                    startScheduleControllers: function() {
                                        for(var e = f.length, t = 0; t < e && f[t]; t++)f[t].getScheduleController().startScheduleTimer();
                                    },
                                    prepareTrackChange: function(e) {
                                        if (E && J) {
                                            T = !1;
                                            var t = e.newMediaInfo, i = P.getValue();
                                            B.setCurrentMediaInfo(J.id, t.type, t);
                                            var a1 = ge(t);
                                            if (a1) {
                                                var o = q.getTime();
                                                n.info("Stream -  Process track changed at current time " + o), i.refreshManifestOnSwitchTrack ? (L.push(e), j.getIsUpdating() || (n.debug("Stream -  Refreshing manifest for switch track"), j.refreshManifest())) : a1.selectMediaInfo(t).then(function() {
                                                    t.type !== r.default.VIDEO && t.type !== r.default.AUDIO || K.updateTopQualityIndex(t), a1.prepareTrackSwitch();
                                                });
                                            }
                                        }
                                    },
                                    prepareQualityChange: function(e) {
                                        var t = pe(e.mediaType);
                                        t && t.prepareQualityChange(e);
                                    }
                                }, function() {
                                    try {
                                        k = Object(c.default)(x).getInstance(), n = k.getLogger(t), ne(), D = Object(g.default)(x).getInstance(), R = Object(m.default)(x).create({
                                            updateEventName: l.default.SEGMENT_LOCATION_BLACKLIST_CHANGED,
                                            addBlacklistEventName: l.default.SEGMENT_LOCATION_BLACKLIST_ADD
                                        }), w = Object(o.default)(x).create({
                                            streamInfo: J,
                                            mediaPlayerModel: F,
                                            dashMetrics: U,
                                            errHandler: V,
                                            settings: Z,
                                            boxParser: D,
                                            dashConstants: i.default,
                                            urlUtils: O
                                        });
                                    } catch (e) {
                                        throw e;
                                    }
                                }(), t;
                            }
                            y.__dashjs_factory_name = "Stream", t.default = f.default.getClassFactory(y);
                        },
                        "./src/streaming/StreamProcessor.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/Constants.js"), i = n("./src/dash/constants/DashConstants.js"), a1 = n("./src/streaming/constants/MetricsConstants.js"), o = n("./src/streaming/models/FragmentModel.js"), s1 = n("./src/streaming/controllers/BufferController.js"), u = n("./src/streaming/text/NotFragmentedTextBufferController.js"), l = n("./src/streaming/controllers/ScheduleController.js"), c = n("./src/dash/controllers/RepresentationController.js"), d = n("./src/core/FactoryMaker.js"), f = n("./src/streaming/utils/SupervisorTools.js"), h = n("./src/core/EventBus.js"), g = n("./src/core/events/Events.js"), p = n("./src/dash/DashHandler.js"), m = n("./src/core/errors/Errors.js"), v = n("./src/streaming/vo/DashJSError.js"), y = n("./src/core/Debug.js"), E = n("./src/streaming/utils/RequestModifier.js"), T = n("./src/streaming/utils/URLUtils.js"), b = n("./src/streaming/utils/BoxParser.js"), A = n("./src/streaming/vo/metrics/PlayList.js"), _ = n("./src/dash/controllers/SegmentsController.js"), S = n("./src/streaming/vo/metrics/HTTPRequest.js");
                            function w(e) {
                                e = e || {};
                                var t, n, d, w, I, R, C, D, k, N, L, x, M, O = this.context, P = Object(h.default)(O).getInstance(), F = e.streamInfo, U = e.type, j = e.errHandler, B = e.mimeType, G = e.timelineConverter, H = e.adapter, V = e.manifestModel, K = e.mediaPlayerModel, q = e.fragmentModel, Y = e.abrController, W = e.playbackController, z = e.mediaController, X = e.textController, Q = e.dashMetrics, J = e.settings, Z = e.boxParser, $ = e.segmentBlacklistController;
                                function ee() {
                                    return F.id;
                                }
                                function te() {
                                    return U;
                                }
                                function ne() {
                                    return H.getIsTextTrack(D.getData());
                                }
                                function re() {
                                    I = [], w = null, M = 0, k = !1, N = !1;
                                }
                                function ie(e) {
                                    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                                    if (e.sender) {
                                        if (W.getIsManifestUpdateInProgress()) le();
                                        else if ((!ne() || X.isTextEnabled()) && R && e.representationId && !R.appendInitSegmentFromCache(e.representationId)) {
                                            var n = D.getCurrentRepresentation();
                                            if (0 === n.range) return void ae();
                                            var r = L ? L.getInitRequest(w, n) : null;
                                            r ? q.executeRequest(r) : t && (C.setInitSegmentRequired(!0), le());
                                        }
                                    }
                                }
                                function ae(e) {
                                    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                                    if (W.getIsManifestUpdateInProgress() || R.getIsPruningInProgress()) le();
                                    else {
                                        var n = ue();
                                        n ? (k = !1, oe(n)) : se(t);
                                    }
                                }
                                function oe(e) {
                                    isNaN(e.startTime + e.duration) || (M = e.startTime + e.duration), e.delayLoadingTime = (new Date).getTime() + C.getTimeToLoadDelay(), C.setTimeToLoadDelay(0), function(e) {
                                        var t = e.url;
                                        return e.range && (t = t.concat("_", e.range)), $.contains(t);
                                    }(e) ? (n.warn("Fragment request url ".concat(e.url, " for stream id ").concat(F.id, " and media type ").concat(U, " is on the ignore list and will be skipped")), le()) : (n.debug("Next fragment request url for stream id ".concat(F.id, " and media type ").concat(U, " is ").concat(e.url)), q.executeRequest(e));
                                }
                                function se(e) {
                                    var t, r = D.getCurrentRepresentation();
                                    if (!J.get().streaming.gaps.enableSeekFix || !k && 0 !== W.getTime() || (d ? d && r.segmentInfoType === i.default.SEGMENT_TIMELINE && (t = L.getValidTimeAheadOfTargetTime(M, w, r, J.get().streaming.gaps.threshold)) : t = L.getValidTimeAheadOfTargetTime(M, w, r, J.get().streaming.gaps.threshold), isNaN(t) || t === M)) {
                                        if (L.isLastSegmentRequested(r, M)) {
                                            var a1 = L.getCurrentIndex();
                                            return n.debug("Segment requesting for stream ".concat(F.id, " has finished")), P.trigger(g.default.STREAM_REQUESTING_COMPLETED, {
                                                segmentIndex: a1
                                            }, {
                                                streamId: F.id,
                                                mediaType: U
                                            }), R.segmentRequestingCompleted(a1), void C.clearScheduleTimer();
                                        }
                                        e && le();
                                    } else W.isSeeking() || 0 === W.getTime() ? (n.warn("Adjusting playback time ".concat(t, " because of gap in the manifest. Seeking by ").concat(t - M)), W.seek(t, !1, !1)) : (n.warn("Adjusting buffering time ".concat(t, " because of gap in the manifest. Adjusting time by ").concat(t - M)), De(t), e && le());
                                }
                                function ue() {
                                    var e, t = _e();
                                    if (isNaN(M) || te() === r.default.TEXT && !X.isTextEnabled()) return null;
                                    var n = k;
                                    if (L) {
                                        var i = D && t ? D.getRepresentationForQuality(t.quality) : null;
                                        e = n ? L.getSegmentRequestForTime(w, i, M) : L.getNextSegmentRequest(w, i);
                                    }
                                    return e;
                                }
                                function le() {
                                    C.startScheduleTimer(W.getLowLatencyModeEnabled() ? J.get().streaming.scheduling.lowLatencyTimeout : J.get().streaming.scheduling.defaultTimeout);
                                }
                                function ce(e) {
                                    e.error || (C.setCurrentRepresentation(H.convertRepresentationToRepresentationInfo(e.currentRepresentation)), R.getIsBufferingCompleted() || R.updateBufferTimestampOffset(e.currentRepresentation));
                                }
                                function de(e) {
                                    Q.addBufferState(U, e.state, C.getBufferTarget()), e.state !== a1.default.BUFFER_EMPTY || W.isSeeking() || (n.info("Buffer is empty! Stalling!"), Q.pushPlayListTraceMetrics(new Date, A.PlayListTrace.REBUFFERING_REASON));
                                }
                                function fe(e) {
                                    q.syncExecutedRequestsWithBufferedRange(R.getBuffer().getAllBufferRanges(), F.duration), e.quotaExceeded && e.from > W.getTime() && De(e.from), e.hasEnoughSpaceToAppend && e.quotaExceeded && C.startScheduleTimer();
                                }
                                function he(e) {
                                    if (e && e.lastRequestAppended && e.lastRequestAppended.url) {
                                        var t = e.lastRequestAppended.url;
                                        e.lastRequestAppended.range && (t = t.concat("_", e.lastRequestAppended.range)), n.warn("Blacklisting segment with url ".concat(t)), $.add(t);
                                    }
                                }
                                function ge() {
                                    Re(), N = !1;
                                }
                                function pe(e) {
                                    n.info("onFragmentLoadingAbandoned request: " + e.request.url + " has been aborted"), W.isSeeking() || C.getSwitchStrack() || N || (n.info("onFragmentLoadingAbandoned request: " + e.request.url + " has to be downloaded again, origin is not seeking process or switch track call"), e.request && e.request.isInitializationRequest() ? C.setInitSegmentRequired(!0) : De(e.request.startTime + e.request.duration / 2), C.startScheduleTimer(0));
                                }
                                function me(e) {
                                    n.info("OnFragmentLoadingCompleted for stream id " + F.id + " and media type " + U + " - Url:", e.request ? e.request.url : "undefined", e.request.range ? ", Range:" + e.request.range : ""), ne() && C.startScheduleTimer(0), e.error && e.request.serviceLocation && function(e) {
                                        n.info("Fragment loading completed with an error"), e && e.request && e.request.type && (e.request.type === S.HTTPRequest.INIT_SEGMENT_TYPE ? ie({
                                            representationId: e.request.representationId,
                                            sender: {}
                                        }, !1) : e.request.type === S.HTTPRequest.MEDIA_SEGMENT_TYPE && (De(e.request.startTime + e.request.duration / 2), ae({}, !1)));
                                    }(e);
                                }
                                function ve() {
                                    De(W.getTime()), Ae().startScheduleTimer();
                                }
                                function ye(e) {
                                    var t = e.currentTrackInfo;
                                    if (t) {
                                        var n = I.find(function(e) {
                                            return e.index === t.index && e.lang === t.lang;
                                        });
                                        n && be(n).then(function() {
                                            R.setIsBufferingCompleted(!1), De(W.getTime()), C.setInitSegmentRequired(!0), C.startScheduleTimer();
                                        });
                                    }
                                }
                                function Ee(e) {
                                    De(e.quotaExceededTime), C.clearScheduleTimer();
                                }
                                function Te() {
                                    return R ? R.getBuffer() : null;
                                }
                                function be(e) {
                                    e === w || e && w && e.type !== w.type || (w = e);
                                    var t = H.getRealAdaptation(F, w), n = H.getVoRepresentations(w);
                                    if (D) {
                                        var i, a1 = D.getData(), o = Y.getMaxAllowedIndexFor(U, F.id), s1 = Y.getMinAllowedIndexFor(U, F.id), u = null;
                                        return null !== a1 && a1.id === t.id || U === r.default.TEXT ? i = Y.getQualityFor(U, F.id) : (u = Y.getThroughputHistory().getAverageThroughput(U, d) || Y.getInitialBitrateFor(U, F.id), i = Y.getQualityForBitrate(w, u, F.id)), void 0 !== s1 && i < s1 && (i = s1), i > o && (i = o), D.updateData(t, n, U, w.isFragmented, i);
                                    }
                                    return Promise.resolve();
                                }
                                function Ae() {
                                    return C;
                                }
                                function _e(e) {
                                    var t;
                                    return void 0 !== e ? (Object(f.checkInteger)(e), t = D ? D.getRepresentationForQuality(e) : null) : t = D ? D.getCurrentRepresentation() : null, H.convertRepresentationToRepresentationInfo(t);
                                }
                                function Se() {
                                    return !!R && R.getIsBufferingCompleted();
                                }
                                function we(e) {
                                    var t = e.chunk, n = t.bytes, r = t.quality, i = _e(r), a1 = D && i ? D.getRepresentationForQuality(i.quality) : null;
                                    if (i && a1) {
                                        var s1 = H.getEventsFor(i.mediaInfo, null, F), u = H.getEventsFor(i, a1, F);
                                        if (s1 && s1.length > 0 || u && u.length > 0) {
                                            var l = function(e, t, n, r) {
                                                try {
                                                    for(var i = {}, a1 = [], o = n.concat(r), s1 = 0, u = o.length; s1 < u; s1++)i[o[s1].schemeIdUri + "/" + o[s1].value] = o[s1];
                                                    var l = Object(b.default)(O).getInstance().parse(e), c = l.getBoxes("emsg");
                                                    if (!c || 0 === c.length) return a1;
                                                    for(var d = l.getBox("sidx"), f = !d || isNaN(d.earliest_presentation_time) || isNaN(d.timescale) ? t && !isNaN(t.mediaStartTime) ? t.mediaStartTime : 0 : d.earliest_presentation_time / d.timescale, h = Math.max(f, 0), g = D.getCurrentRepresentation(), p = 0, m = c.length; p < m; p++){
                                                        var v = H.getEvent(c[p], i, h, g);
                                                        v && a1.push(v);
                                                    }
                                                    return a1;
                                                } catch (e) {
                                                    return [];
                                                }
                                            }(n, q.getRequests({
                                                state: o.default.FRAGMENT_MODEL_EXECUTED,
                                                quality: r,
                                                index: t.index
                                            })[0], s1, u);
                                            P.trigger(g.default.INBAND_EVENTS, {
                                                events: l
                                            }, {
                                                streamId: F.id
                                            });
                                        }
                                    }
                                }
                                function Ie() {
                                    var e = W.getTime();
                                    J.get().streaming.buffer.flushBufferAtTrackSwitch && W.seek(e + .001, !1, !0), De(e), R.setSeekTarget(e), C.startScheduleTimer();
                                }
                                function Re() {
                                    var e = W.getTime(), t = R.getContinuousBufferTimeForTargetTime(e);
                                    De(isNaN(t) ? e : t), C.startScheduleTimer();
                                }
                                function Ce(e) {
                                    e && !isNaN(e.time) && (De(e.time), R.setSeekTarget(e.time));
                                }
                                function De(e) {
                                    M = e, k = !0;
                                }
                                return t = {
                                    initialize: function(n, a1, o) {
                                        x = Object(_.default)(O).create({
                                            events: g.default,
                                            eventBus: P,
                                            streamInfo: F,
                                            timelineConverter: G,
                                            dashConstants: i.default,
                                            segmentBaseController: e.segmentBaseController,
                                            type: U
                                        }), L = Object(p.default)(O).create({
                                            streamInfo: F,
                                            type: U,
                                            timelineConverter: G,
                                            dashMetrics: Q,
                                            mediaPlayerModel: K,
                                            baseURLController: e.baseURLController,
                                            errHandler: j,
                                            segmentsController: x,
                                            settings: J,
                                            boxParser: Z,
                                            events: g.default,
                                            eventBus: P,
                                            errors: m.default,
                                            debug: Object(y.default)(O).getInstance(),
                                            requestModifier: Object(E.default)(O).getInstance(),
                                            dashConstants: i.default,
                                            constants: r.default,
                                            urlUtils: Object(T.default)(O).getInstance()
                                        }), d = F.manifestInfo.isDynamic, L.initialize(d), Y.registerStreamType(U, t), D = Object(c.default)(O).create({
                                            streamInfo: F,
                                            type: U,
                                            abrController: Y,
                                            dashMetrics: Q,
                                            playbackController: W,
                                            timelineConverter: G,
                                            dashConstants: i.default,
                                            events: g.default,
                                            eventBus: P,
                                            errors: m.default,
                                            isDynamic: d,
                                            segmentsController: x
                                        }), R = function(e, t) {
                                            return e ? e !== r.default.TEXT || t ? Object(s1.default)(O).create({
                                                streamInfo: F,
                                                type: e,
                                                mediaPlayerModel: K,
                                                manifestModel: V,
                                                fragmentModel: q,
                                                errHandler: j,
                                                mediaController: z,
                                                representationController: D,
                                                adapter: H,
                                                textController: X,
                                                abrController: Y,
                                                playbackController: W,
                                                settings: J
                                            }) : Object(u.default)(O).create({
                                                streamInfo: F,
                                                type: e,
                                                mimeType: B,
                                                fragmentModel: q,
                                                textController: X,
                                                errHandler: j,
                                                settings: J
                                            }) : (j.error(new v.default(m.default.MEDIASOURCE_TYPE_UNSUPPORTED_CODE, m.default.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + "not properly defined")), null);
                                        }(U, o), R && R.initialize(n), (C = Object(l.default)(O).create({
                                            streamInfo: F,
                                            type: U,
                                            mimeType: B,
                                            adapter: H,
                                            dashMetrics: Q,
                                            mediaPlayerModel: K,
                                            fragmentModel: q,
                                            abrController: Y,
                                            playbackController: W,
                                            textController: X,
                                            mediaController: z,
                                            bufferController: R,
                                            settings: J
                                        })).initialize(a1), M = 0, k = !1;
                                    },
                                    getStreamId: ee,
                                    getType: te,
                                    isUpdating: function() {
                                        return !!D && D.isUpdating();
                                    },
                                    getBufferController: function() {
                                        return R;
                                    },
                                    getFragmentModel: function() {
                                        return q;
                                    },
                                    getScheduleController: Ae,
                                    getRepresentationController: function() {
                                        return D;
                                    },
                                    getRepresentationInfo: _e,
                                    getBufferLevel: function() {
                                        return R ? R.getBufferLevel() : 0;
                                    },
                                    isBufferingCompleted: Se,
                                    createBufferSinks: function(e) {
                                        var t = Te();
                                        return t ? Promise.resolve(t) : R ? R.createBufferSink(w, e) : Promise.resolve(null);
                                    },
                                    updateStreamInfo: function(e) {
                                        return F = e, Se() ? Promise.resolve() : R.updateAppendWindow();
                                    },
                                    getStreamInfo: function() {
                                        return F;
                                    },
                                    selectMediaInfo: be,
                                    clearMediaInfoArray: function() {
                                        I = [];
                                    },
                                    addMediaInfo: function(e) {
                                        -1 === I.indexOf(e) && I.push(e);
                                    },
                                    prepareTrackSwitch: function() {
                                        return new Promise(function(e) {
                                            n.debug("Preparing track switch for type ".concat(U));
                                            var t = U === r.default.TEXT || J.get().streaming.trackSwitchMode[U] === r.default.TRACK_SWITCH_MODE_ALWAYS_REPLACE && W.getTimeToStreamEnd(F) > J.get().streaming.buffer.stallThreshold;
                                            if (R.getIsBufferingCompleted() && !t) return R.prepareForNonReplacementTrackSwitch(w.codec).then(function() {
                                                P.trigger(g.default.BUFFERING_COMPLETED, {}, {
                                                    streamId: F.id,
                                                    mediaType: U
                                                });
                                            }).catch(function() {
                                                P.trigger(g.default.BUFFERING_COMPLETED, {}, {
                                                    streamId: F.id,
                                                    mediaType: U
                                                });
                                            }), void e();
                                            C.clearScheduleTimer(), C.setSwitchTrack(!0), t ? (P.trigger(g.default.BUFFER_REPLACEMENT_STARTED, {
                                                mediaType: U,
                                                streamId: F.id
                                            }, {
                                                mediaType: U,
                                                streamId: F.id
                                            }), q.abortRequests(), R.prepareForReplacementTrackSwitch(w.codec).then(function() {
                                                var e = _e();
                                                return R.updateBufferTimestampOffset(e);
                                            }).then(function() {
                                                Ie(), e();
                                            }).catch(function() {
                                                Ie(), e();
                                            })) : R.prepareForNonReplacementTrackSwitch(w.codec).then(function() {
                                                Re(), e();
                                            }).catch(function() {
                                                Re(), e();
                                            });
                                        });
                                    },
                                    prepareQualityChange: function(e) {
                                        n.debug("Preparing quality switch for type ".concat(U));
                                        var t = e.newQuality;
                                        N = !0, C.clearScheduleTimer();
                                        var r = _e(t);
                                        C.setCurrentRepresentation(r), D.prepareQualityChange(t), q.abortRequests(), R.updateBufferTimestampOffset(r).then(function() {
                                            e.reason && e.reason.forceReplace ? (P.trigger(g.default.BUFFER_REPLACEMENT_STARTED, {
                                                mediaType: U,
                                                streamId: F.id
                                            }, {
                                                mediaType: U,
                                                streamId: F.id
                                            }), R.prepareForReplacementQualitySwitch().then(function() {
                                                Ie(), N = !1;
                                            }).catch(function() {
                                                Ie(), N = !1;
                                            })) : J.get().streaming.buffer.fastSwitchEnabled ? function(e) {
                                                var t = W.getTime(), n = 1.5 * (isNaN(e.fragmentDuration) ? 1 : e.fragmentDuration), r = q.getRequests({
                                                    state: o.default.FRAGMENT_MODEL_EXECUTED,
                                                    time: t + n,
                                                    threshold: 0
                                                })[0];
                                                if (r && !ne()) {
                                                    var i = R.getBufferLevel(), s1 = Y.getAbandonmentStateFor(F.id, U);
                                                    r.quality < e.quality && i >= n && s1 !== a1.default.ABANDON_LOAD ? (De(t + n), C.setCheckPlaybackQuality(!1), C.startScheduleTimer()) : ge();
                                                } else C.startScheduleTimer();
                                                N = !1;
                                            }(r) : ge(), Q.pushPlayListTraceMetrics(new Date, A.PlayListTrace.REPRESENTATION_SWITCH_STOP_REASON), Q.createPlaylistTraceMetrics(r.id, 1e3 * W.getTime(), W.getPlaybackRate());
                                        });
                                    },
                                    getMediaInfo: function() {
                                        return w;
                                    },
                                    getMediaSource: function() {
                                        return R.getMediaSource();
                                    },
                                    setMediaSource: function(e) {
                                        R.setMediaSource(e);
                                    },
                                    getBuffer: Te,
                                    setExplicitBufferingTime: De,
                                    finalisePlayList: function(e, t) {
                                        Q.pushPlayListTraceMetrics(e, t);
                                    },
                                    probeNextRequest: function() {
                                        var e = _e(), t = D && e ? D.getRepresentationForQuality(e.quality) : null;
                                        return L.getNextSegmentRequestIdempotent(w, t);
                                    },
                                    prepareInnerPeriodPlaybackSeeking: function(e) {
                                        return new Promise(function(t) {
                                            C.clearScheduleTimer(), q.abortRequests(), R.prepareForPlaybackSeek().then(function() {
                                                var t = R.getAllRangesWithSafetyFactor(e.seekTime);
                                                return R.clearBuffers(t);
                                            }).then(function() {
                                                var n = R.getContinuousBufferTimeForTargetTime(e.seekTime);
                                                if (!isNaN(n) && !isNaN(F.duration) && isFinite(F.duration) && n >= F.start + F.duration) R.setIsBufferingCompleted(!0), t();
                                                else {
                                                    var r = isNaN(n) ? e.seekTime : n;
                                                    De(r), R.setSeekTarget(r);
                                                    var i = [];
                                                    i.push(R.updateAppendWindow());
                                                    var a1 = _e();
                                                    i.push(R.updateBufferTimestampOffset(a1)), Promise.all(i).then(function() {
                                                        C.setInitSegmentRequired(!0), C.setCheckPlaybackQuality(!1), C.startScheduleTimer(), t();
                                                    });
                                                }
                                            }).catch(function(e) {
                                                n.error(e);
                                            });
                                        });
                                    },
                                    prepareOuterPeriodPlaybackSeeking: function() {
                                        return new Promise(function(e, t) {
                                            try {
                                                C.clearScheduleTimer(), q.abortRequests(), R.prepareForPlaybackSeek().then(function() {
                                                    return R.pruneAllSafely();
                                                }).then(function() {
                                                    e();
                                                });
                                            } catch (e) {
                                                t(e);
                                            }
                                        });
                                    },
                                    reset: function(e, n) {
                                        L && L.reset(), R && (R.reset(e, n), R = null), C && (C.reset(), C = null), D && (D.reset(), D = null), x && (x = null), Y && Y.unRegisterStreamType(ee(), U), P.off(g.default.DATA_UPDATE_COMPLETED, ce, t), P.off(g.default.INIT_FRAGMENT_NEEDED, ie, t), P.off(g.default.MEDIA_FRAGMENT_NEEDED, ae, t), P.off(g.default.MEDIA_FRAGMENT_LOADED, we, t), P.off(g.default.BUFFER_LEVEL_STATE_CHANGED, de, t), P.off(g.default.BUFFER_CLEARED, fe, t), P.off(g.default.SEEK_TARGET, Ce, t), P.off(g.default.FRAGMENT_LOADING_ABANDONED, pe, t), P.off(g.default.FRAGMENT_LOADING_COMPLETED, me, t), P.off(g.default.SET_FRAGMENTED_TEXT_AFTER_DISABLED, ve, t), P.off(g.default.SET_NON_FRAGMENTED_TEXT, ye, t), P.off(g.default.QUOTA_EXCEEDED, Ee, t), P.off(g.default.SOURCE_BUFFER_ERROR, he, t), re(), U = null, F = null;
                                    }
                                }, n = Object(y.default)(O).getInstance().getLogger(t), re(), P.on(g.default.DATA_UPDATE_COMPLETED, ce, t, {
                                    priority: h.default.EVENT_PRIORITY_HIGH
                                }), P.on(g.default.INIT_FRAGMENT_NEEDED, ie, t), P.on(g.default.MEDIA_FRAGMENT_NEEDED, ae, t), P.on(g.default.MEDIA_FRAGMENT_LOADED, we, t), P.on(g.default.BUFFER_LEVEL_STATE_CHANGED, de, t), P.on(g.default.BUFFER_CLEARED, fe, t), P.on(g.default.SEEK_TARGET, Ce, t), P.on(g.default.FRAGMENT_LOADING_ABANDONED, pe, t), P.on(g.default.FRAGMENT_LOADING_COMPLETED, me, t), P.on(g.default.QUOTA_EXCEEDED, Ee, t), P.on(g.default.SET_FRAGMENTED_TEXT_AFTER_DISABLED, ve, t), P.on(g.default.SET_NON_FRAGMENTED_TEXT, ye, t), P.on(g.default.SOURCE_BUFFER_ERROR, he, t), t;
                            }
                            w.__dashjs_factory_name = "StreamProcessor", t.default = d.default.getClassFactory(w);
                        },
                        "./src/streaming/XlinkLoader.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/vo/DashJSError.js"), i = n("./src/streaming/net/URLLoader.js"), a1 = n("./src/streaming/vo/metrics/HTTPRequest.js"), o = n("./src/streaming/vo/TextRequest.js"), s1 = n("./src/core/EventBus.js"), u = n("./src/core/events/Events.js"), l = n("./src/core/FactoryMaker.js"), c = n("./src/core/errors/Errors.js");
                            function d(e) {
                                e = e || {};
                                var t = this.context, n = Object(s1.default)(t).getInstance(), l = Object(i.default)(t).create({
                                    errHandler: e.errHandler,
                                    dashMetrics: e.dashMetrics,
                                    mediaPlayerModel: e.mediaPlayerModel,
                                    requestModifier: e.requestModifier,
                                    errors: c.default
                                });
                                return {
                                    load: function(e, t, i) {
                                        var s1 = function(a1, o) {
                                            t.resolved = !0, t.resolvedContent = a1 || null, n.trigger(u.default.XLINK_ELEMENT_LOADED, {
                                                element: t,
                                                resolveObject: i,
                                                error: a1 || o ? null : new r.default(c.default.XLINK_LOADER_LOADING_FAILURE_ERROR_CODE, c.default.XLINK_LOADER_LOADING_FAILURE_ERROR_MESSAGE + e)
                                            });
                                        };
                                        if ("urn:mpeg:dash:resolve-to-zero:2013" === e) s1(null, !0);
                                        else {
                                            var d = new o.default(e, a1.HTTPRequest.XLINK_EXPANSION_TYPE);
                                            l.load({
                                                request: d,
                                                success: function(e) {
                                                    s1(e);
                                                },
                                                error: function() {
                                                    s1(null);
                                                }
                                            });
                                        }
                                    },
                                    reset: function() {
                                        l && (l.abort(), l = null);
                                    }
                                };
                            }
                            d.__dashjs_factory_name = "XlinkLoader", t.default = l.default.getClassFactory(d);
                        },
                        "./src/streaming/constants/ConformanceViolationConstants.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = {
                                LEVELS: {
                                    SUGGESTION: "Suggestion",
                                    WARNING: "Warning",
                                    ERROR: "Error"
                                },
                                EVENTS: {
                                    NO_UTC_TIMING_ELEMENT: {
                                        key: "NO_UTC_TIMING_ELEMENT",
                                        message: "No UTCTiming element is present in the manifest. You may experience playback failures. For a detailed validation use https://conformance.dashif.org/"
                                    },
                                    NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE: {
                                        key: "NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE",
                                        message: 'SMPTE 2052-1:2013 defines the attribute name as "imageType" and does not define "imagetype"'
                                    },
                                    INVALID_DVR_WINDOW: {
                                        key: "INVALID_DVR_WINDOW",
                                        message: "No valid segment found when applying a specification compliant DVR window calculation. Using SegmentTimeline entries as a fallback."
                                    }
                                }
                            };
                        },
                        "./src/streaming/constants/Constants.js": function(e, t, n) {
                            "use strict";
                            function r(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            n.r(t);
                            var i = new (function() {
                                function e() {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), this.init();
                                }
                                var t, n;
                                return t = e, n = [
                                    {
                                        key: "init",
                                        value: function() {
                                            this.STREAM = "stream", this.VIDEO = "video", this.AUDIO = "audio", this.TEXT = "text", this.MUXED = "muxed", this.IMAGE = "image", this.STPP = "stpp", this.TTML = "ttml", this.VTT = "vtt", this.WVTT = "wvtt", this.CONTENT_STEERING = "contentSteering", this.ABR_STRATEGY_DYNAMIC = "abrDynamic", this.ABR_STRATEGY_BOLA = "abrBola", this.ABR_STRATEGY_L2A = "abrL2A", this.ABR_STRATEGY_LoLP = "abrLoLP", this.ABR_STRATEGY_THROUGHPUT = "abrThroughput", this.ABR_FETCH_THROUGHPUT_CALCULATION_DOWNLOADED_DATA = "abrFetchThroughputCalculationDownloadedData", this.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING = "abrFetchThroughputCalculationMoofParsing", this.ABR_FETCH_THROUGHPUT_CALCULATION_AAST = "abrFetchThroughputCalculationAAST", this.LIVE_CATCHUP_MODE_DEFAULT = "liveCatchupModeDefault", this.LIVE_CATCHUP_MODE_LOLP = "liveCatchupModeLoLP", this.MOVING_AVERAGE_SLIDING_WINDOW = "slidingWindow", this.MOVING_AVERAGE_EWMA = "ewma", this.BAD_ARGUMENT_ERROR = "Invalid Arguments", this.MISSING_CONFIG_ERROR = "Missing config parameter(s)", this.TRACK_SWITCH_MODE_ALWAYS_REPLACE = "alwaysReplace", this.TRACK_SWITCH_MODE_NEVER_REPLACE = "neverReplace", this.TRACK_SELECTION_MODE_FIRST_TRACK = "firstTrack", this.TRACK_SELECTION_MODE_HIGHEST_BITRATE = "highestBitrate", this.TRACK_SELECTION_MODE_HIGHEST_EFFICIENCY = "highestEfficiency", this.TRACK_SELECTION_MODE_WIDEST_RANGE = "widestRange", this.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY = "highestSelectionPriority", this.CMCD_MODE_QUERY = "query", this.CMCD_MODE_HEADER = "header", this.LOCATION = "Location", this.INITIALIZE = "initialize", this.TEXT_SHOWING = "showing", this.TEXT_HIDDEN = "hidden", this.CC1 = "CC1", this.CC3 = "CC3", this.UTF8 = "utf-8", this.SCHEME_ID_URI = "schemeIdUri", this.START_TIME = "starttime", this.SERVICE_DESCRIPTION_DVB_LL_SCHEME = "urn:dvb:dash:lowlatency:scope:2019", this.SUPPLEMENTAL_PROPERTY_DVB_LL_SCHEME = "urn:dvb:dash:lowlatency:critical:2019", this.XML = "XML", this.ARRAY_BUFFER = "ArrayBuffer", this.DVB_REPORTING_URL = "dvb:reportingUrl", this.DVB_PROBABILITY = "dvb:probability", this.VIDEO_ELEMENT_READY_STATES = {
                                                HAVE_NOTHING: 0,
                                                HAVE_METADATA: 1,
                                                HAVE_CURRENT_DATA: 2,
                                                HAVE_FUTURE_DATA: 3,
                                                HAVE_ENOUGH_DATA: 4
                                            }, this.FILE_LOADER_TYPES = {
                                                FETCH: "fetch_loader",
                                                XHR: "xhr_loader"
                                            };
                                        }
                                    }
                                ], r(t.prototype, n), e;
                            }());
                            t.default = i;
                        },
                        "./src/streaming/constants/MetricsConstants.js": function(e, t, n) {
                            "use strict";
                            function r(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            n.r(t);
                            var i = new (function() {
                                function e() {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), this.init();
                                }
                                var t, n;
                                return t = e, n = [
                                    {
                                        key: "init",
                                        value: function() {
                                            this.TCP_CONNECTION = "TcpList", this.HTTP_REQUEST = "HttpList", this.TRACK_SWITCH = "RepSwitchList", this.BUFFER_LEVEL = "BufferLevel", this.BUFFER_LOADED = "bufferLoaded", this.ABANDON_LOAD = "abandonload", this.ALLOW_LOAD = "allowload", this.BUFFER_EMPTY = "bufferStalled", this.BUFFER_STATE = "BufferState", this.DVR_INFO = "DVRInfo", this.DROPPED_FRAMES = "DroppedFrames", this.SCHEDULING_INFO = "SchedulingInfo", this.REQUESTS_QUEUE = "RequestsQueue", this.MANIFEST_UPDATE = "ManifestUpdate", this.MANIFEST_UPDATE_STREAM_INFO = "ManifestUpdatePeriodInfo", this.MANIFEST_UPDATE_TRACK_INFO = "ManifestUpdateRepresentationInfo", this.PLAY_LIST = "PlayList", this.DVB_ERRORS = "DVBErrors", this.HTTP_REQUEST_DVB_REPORTING_TYPE = "DVBReporting";
                                        }
                                    }
                                ], r(t.prototype, n), e;
                            }());
                            t.default = i;
                        },
                        "./src/streaming/constants/ProtectionConstants.js": function(e, t, n) {
                            "use strict";
                            function r(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            n.r(t);
                            var i = new (function() {
                                function e() {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), this.init();
                                }
                                var t, n;
                                return t = e, n = [
                                    {
                                        key: "init",
                                        value: function() {
                                            this.CLEARKEY_KEYSTEM_STRING = "org.w3.clearkey", this.WIDEVINE_KEYSTEM_STRING = "com.widevine.alpha", this.PLAYREADY_KEYSTEM_STRING = "com.microsoft.playready", this.PLAYREADY_RECOMMENDATION_KEYSTEM_STRING = "com.microsoft.playready.recommendation", this.INITIALIZATION_DATA_TYPE_CENC = "cenc", this.INITIALIZATION_DATA_TYPE_KEYIDS = "keyids", this.INITIALIZATION_DATA_TYPE_WEBM = "webm";
                                        }
                                    }
                                ], r(t.prototype, n), e;
                            }());
                            t.default = i;
                        },
                        "./src/streaming/controllers/AbrController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/rules/abr/ABRRulesCollection.js"), i = n("./src/streaming/constants/Constants.js"), a1 = n("./src/streaming/constants/MetricsConstants.js"), o = n("./src/streaming/vo/BitrateInfo.js"), s1 = n("./src/streaming/models/FragmentModel.js"), u = n("./src/core/EventBus.js"), l = n("./src/core/events/Events.js"), c = n("./src/core/FactoryMaker.js"), d = n("./src/streaming/rules/RulesContext.js"), f = n("./src/streaming/rules/SwitchRequest.js"), h = n("./src/streaming/rules/SwitchRequestHistory.js"), g = n("./src/streaming/rules/DroppedFramesHistory.js"), p = n("./src/streaming/rules/ThroughputHistory.js"), m = n("./src/core/Debug.js"), v = n("./src/streaming/vo/metrics/HTTPRequest.js"), y = n("./src/streaming/utils/SupervisorTools.js"), E = n("./src/streaming/MediaPlayerEvents.js");
                            function T() {
                                var e, t, n, c, T, b, A, _, S, w, I, R, C, D, k, N, L, x, M, O, P, F, U, j, B, G, H = this.context, V = Object(m.default)(H).getInstance(), K = Object(u.default)(H).getInstance();
                                function q() {
                                    T = {}, b = {}, _ = {}, A = {}, M = {}, F = {}, U = {}, j = {}, void 0 === w && (w = !1), O && O.reset(), x = void 0, O = void 0, P = void 0, clearTimeout(S), S = null;
                                }
                                function Y(t) {
                                    var r = t.request.mediaType, i = t.streamId;
                                    if (r && i && A[i] && G.get().streaming.abr.autoSwitchBitrate[r]) {
                                        var o = A[i][r];
                                        if (o) {
                                            var u = Object(d.default)(H).create({
                                                abrController: e,
                                                streamProcessor: o,
                                                currentRequest: t.request,
                                                useBufferOccupancyABR: F[r],
                                                useL2AABR: U[r],
                                                useLoLPABR: j[r],
                                                videoModel: D
                                            }), l = n.shouldAbandonFragment(u, i);
                                            l.quality > f.default.NO_CHANGE && o.getFragmentModel().getRequests({
                                                state: s1.default.FRAGMENT_MODEL_LOADING,
                                                index: t.request.index
                                            })[0] && (_[i][r].state = a1.default.ABANDON_LOAD, M[i][r].reset(), M[i][r].push({
                                                oldValue: J(r, i),
                                                newValue: l.quality,
                                                confidence: 1,
                                                reason: l.reason
                                            }), Z(r, c.getActiveStreamInfo(), l.quality, l.reason), clearTimeout(S), S = setTimeout(function() {
                                                _[i][r].state = a1.default.ALLOW_LOAD, S = null;
                                            }, G.get().streaming.abandonLoadTimeout));
                                        }
                                    }
                                }
                                function W(e) {
                                    e.mediaType === i.default.VIDEO && (void 0 !== x && O.push(e.streamId, x, D.getPlaybackQuality()), x = e.newQuality);
                                }
                                function z(e) {
                                    var n, r;
                                    e.metric !== a1.default.HTTP_REQUEST || !e.value || e.value.type !== v.HTTPRequest.MEDIA_SEGMENT_TYPE || e.mediaType !== i.default.AUDIO && e.mediaType !== i.default.VIDEO || P.push(e.mediaType, e.value, G.get().streaming.abr.useDeadTimeLatency), e.metric !== a1.default.BUFFER_LEVEL || e.mediaType !== i.default.AUDIO && e.mediaType !== i.default.VIDEO || (n = e.mediaType, r = .001 * e.value.level, G.get().streaming.abr.ABRStrategy === i.default.ABR_STRATEGY_DYNAMIC && function(e, n) {
                                        try {
                                            var r = k.getStableBufferTime(), i = r, a1 = .5 * r, o = F[e], s1 = n > (o ? a1 : i);
                                            F[e] = s1, s1 !== o && (s1 ? t.info("[" + e + "] switching from throughput to buffer occupancy ABR rule (buffer: " + n.toFixed(3) + ").") : t.info("[" + e + "] switching from buffer occupancy to throughput ABR rule (buffer: " + n.toFixed(3) + ")."));
                                        } catch (e) {
                                            t.error(e);
                                        }
                                    }(n, r));
                                }
                                function X(e, t) {
                                    try {
                                        var n;
                                        return T[t] = T[t] || {}, T[t].hasOwnProperty(e) || (T[t][e] = 0), n = function(e, t) {
                                            var n = T[t][e], r = n;
                                            if (!A[t] || !A[t][e]) return r;
                                            var i = Q(e, t);
                                            void 0 !== i && (r = Math.max(n, i));
                                            var a1 = function(e, t) {
                                                try {
                                                    var n = k.getAbrBitrateParameter("maxBitrate", e);
                                                    return n > -1 ? ee(A[t][e].getMediaInfo(), n, t) : void 0;
                                                } catch (e) {
                                                    return;
                                                }
                                            }(e, t);
                                            return void 0 !== a1 && (r = Math.min(r, a1)), r;
                                        }(e, t), n = function(e, t, n) {
                                            var r = T[n][t], i = G.get().streaming.abr.maxRepresentationRatio[t];
                                            return isNaN(i) || i >= 1 || i < 0 ? e : Math.min(e, Math.round(r * i));
                                        }(n, e, t), n = function(e, t, n) {
                                            if (t !== i.default.VIDEO || !G.get().streaming.abr.limitBitrateByPortal || !A[n] || !A[n][t]) return e;
                                            w || ne();
                                            var r = A[n][t].getStreamInfo(), a1 = C.getAdaptationForType(r.index, t, r).Representation_asArray, o = e;
                                            if (I > 0 && R > 0) {
                                                for(; o > 0 && a1[o] && I < a1[o].width && I - a1[o - 1].width < a1[o].width - I;)o -= 1;
                                                for(; o < a1.length - 1 && a1[o].width === a1[o + 1].width;)o += 1;
                                            }
                                            return o;
                                        }(n, e, t), n;
                                    } catch (e) {
                                        return;
                                    }
                                }
                                function Q(e, t) {
                                    try {
                                        return function(e, t) {
                                            try {
                                                var n = k.getAbrBitrateParameter("minBitrate", e);
                                                if (n > -1) {
                                                    var r = A[t][e].getMediaInfo(), i = te(r), a1 = ee(r, n, t);
                                                    return i[a1] && a1 < i.length - 1 && i[a1].bitrate < 1e3 * n && a1++, a1;
                                                }
                                                return;
                                            } catch (e) {
                                                return;
                                            }
                                        }(e, t);
                                    } catch (e) {
                                        return;
                                    }
                                }
                                function J(e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                                    try {
                                        return t || (t = c.getActiveStreamInfo().id), e && A[t] && A[t][e] && t ? (b[t] = b[t] || {}, b[t].hasOwnProperty(e) || (b[t][e] = 0), b[t][e]) : 0;
                                    } catch (e) {
                                        return 0;
                                    }
                                }
                                function Z(e, t, n) {
                                    var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
                                    if (t && t.id && e) {
                                        var i = t.id, a1 = J(e, i);
                                        Object(y.checkInteger)(n);
                                        var o = X(e, i);
                                        n !== a1 && n >= 0 && n <= o && $(e, a1, n, o, r, i);
                                    }
                                }
                                function $(e, n, r, i, a1, o) {
                                    if (e && A[o] && A[o][e]) {
                                        var s1 = A[o][e].getStreamInfo(), u = s1 && s1.manifestInfo && s1.manifestInfo.isDynamic, c = B.getCurrentBufferLevel(e);
                                        t.info("Stream ID: " + o + " [" + e + "] switch from " + n + " to " + r + "/" + i + " (buffer: " + c + ") " + (a1 ? JSON.stringify(a1) : ".")), b[o] = b[o] || {}, b[o][e] = r;
                                        var d = function(e, t, n) {
                                            if (t && A && A[e] && A[e][t]) {
                                                var r = te(A[e][t].getMediaInfo());
                                                return r[n] ? r[n] : null;
                                            }
                                            return null;
                                        }(o, e, r);
                                        K.trigger(l.default.QUALITY_CHANGE_REQUESTED, {
                                            oldQuality: n,
                                            newQuality: r,
                                            reason: a1,
                                            streamInfo: s1,
                                            bitrateInfo: d,
                                            maxIdx: i,
                                            mediaType: e
                                        }, {
                                            streamId: s1.id,
                                            mediaType: e
                                        });
                                        var f = P.getAverageThroughput(e, u);
                                        isNaN(f) || L.setSavedBitrateSettings(e, f);
                                    }
                                }
                                function ee(e, t, n) {
                                    var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, i = e && e.type ? A[n][e.type].getRepresentationInfo() : null;
                                    if (G.get().streaming.abr.useDeadTimeLatency && r && i && i.fragmentDuration) {
                                        r /= 1e3;
                                        var a1 = i.fragmentDuration;
                                        if (r > a1) return 0;
                                        var o = r / a1;
                                        t *= 1 - o;
                                    }
                                    for(var s1 = te(e), u = s1.length - 1; u >= 0; u--){
                                        var l = s1[u];
                                        if (1e3 * t >= l.bitrate) return u;
                                    }
                                    return 0;
                                }
                                function te(e) {
                                    var t = [];
                                    if (!e || !e.bitrateList) return t;
                                    for(var n, r = e.bitrateList, i = e.type, a1 = 0, s1 = r.length; a1 < s1; a1++)(n = new o.default).mediaType = i, n.qualityIndex = a1, n.bitrate = r[a1].bandwidth, n.width = r[a1].width, n.height = r[a1].height, n.scanType = r[a1].scanType, t.push(n);
                                    return t;
                                }
                                function ne() {
                                    if (D) {
                                        var e = G.get().streaming.abr.usePixelRatioInLimitBitrateByPortal && window.hasOwnProperty("devicePixelRatio") ? window.devicePixelRatio : 1;
                                        I = D.getClientWidth() * e, R = D.getClientHeight() * e;
                                    }
                                }
                                return e = {
                                    initialize: function() {
                                        O = Object(g.default)(H).create(), P = Object(p.default)(H).create({
                                            settings: G
                                        }), (n = Object(r.default)(H).create({
                                            dashMetrics: B,
                                            customParametersModel: N,
                                            mediaPlayerModel: k,
                                            settings: G
                                        })).initialize(), K.on(E.default.QUALITY_CHANGE_RENDERED, W, e), K.on(E.default.METRIC_ADDED, z, e), K.on(l.default.LOADING_PROGRESS, Y, e);
                                    },
                                    isPlayingAtTopQuality: function(e) {
                                        var t = e ? e.id : null, n = J(i.default.AUDIO, t), r = J(i.default.VIDEO, t);
                                        return n === X(i.default.AUDIO, t) && r === X(i.default.VIDEO, t);
                                    },
                                    updateTopQualityIndex: function(e) {
                                        var t = e.type, n = e.streamInfo.id, r = e.representationCount - 1;
                                        return T[n] = T[n] || {}, T[n][t] = r, r;
                                    },
                                    clearDataForStream: function(e) {
                                        O && O.clearForStream(e), A[e] && delete A[e], M[e] && delete M[e], _[e] && delete _[e];
                                    },
                                    getThroughputHistory: function() {
                                        return P;
                                    },
                                    getBitrateList: te,
                                    getQualityForBitrate: ee,
                                    getTopBitrateInfoFor: function(e) {
                                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                                        if (t || (t = c.getActiveStreamInfo().id), e && A && A[t] && A[t][e]) {
                                            var n = X(e, t), r = te(A[t][e].getMediaInfo());
                                            return r[n] ? r[n] : null;
                                        }
                                        return null;
                                    },
                                    getMinAllowedIndexFor: Q,
                                    getMaxAllowedIndexFor: X,
                                    getInitialBitrateFor: function(e, t) {
                                        if (function() {
                                            if (!L || !L.hasOwnProperty("getSavedBitrateSettings")) throw new Error(i.default.MISSING_CONFIG_ERROR);
                                        }(), e === i.default.TEXT) return NaN;
                                        var n = L.getSavedBitrateSettings(e), r = k.getAbrBitrateParameter("initialBitrate", e), a1 = G.get().streaming.abr.initialRepresentationRatio[e];
                                        if (-1 === r) {
                                            if (a1 > -1) {
                                                var o = A[t][e].getStreamInfo(), s1 = C.getAdaptationForType(o.index, e, o).Representation_asArray;
                                                r = Array.isArray(s1) ? s1[Math.max(Math.round(s1.length * a1) - 1, 0)].bandwidth / 1e3 : 0;
                                            } else r = isNaN(n) ? e === i.default.VIDEO ? 1e3 : 100 : n;
                                        }
                                        return r;
                                    },
                                    getQualityFor: J,
                                    getAbandonmentStateFor: function(e, t) {
                                        return _[e] && _[e][t] ? _[e][t].state : null;
                                    },
                                    setPlaybackQuality: Z,
                                    checkPlaybackQuality: function(t, r) {
                                        try {
                                            if (!(t && A && A[r] && A[r][t])) return !1;
                                            if (O) {
                                                var i = D.getPlaybackQuality();
                                                i && O.push(r, x, i);
                                            }
                                            if (!G.get().streaming.abr.autoSwitchBitrate[t]) return !1;
                                            var o = J(t, r), s1 = Object(d.default)(H).create({
                                                abrController: e,
                                                switchHistory: M[r][t],
                                                droppedFramesHistory: O,
                                                streamProcessor: A[r][t],
                                                currentValue: o,
                                                useBufferOccupancyABR: F[t],
                                                useL2AABR: U[t],
                                                useLoLPABR: j[t],
                                                videoModel: D
                                            }), u = Q(t, r), l = X(t, r), c = n.getMaxQuality(s1), h = c.quality;
                                            return void 0 !== u && (h > f.default.NO_CHANGE ? h : o) < u && (h = u), h > l && (h = l), M[r][t].push({
                                                oldValue: o,
                                                newValue: h
                                            }), h > f.default.NO_CHANGE && h !== o && (_[r][t].state === a1.default.ALLOW_LOAD || h < o) && ($(t, o, h, l, c.reason, r), !0);
                                        } catch (e) {
                                            return !1;
                                        }
                                    },
                                    setElementSize: ne,
                                    setWindowResizeEventCalled: function(e) {
                                        w = e;
                                    },
                                    registerStreamType: function(e, t) {
                                        var n = t.getStreamInfo().id;
                                        A[n] || (A[n] = {}), M[n] || (M[n] = {}), _[n] || (_[n] = {}), M[n][e] = Object(h.default)(H).create(), A[n][e] = t, _[n][e] = {}, _[n][e].state = a1.default.ALLOW_LOAD, function(e) {
                                            var t = G.get().streaming.abr.ABRStrategy;
                                            t === i.default.ABR_STRATEGY_L2A ? (F[e] = !1, j[e] = !1, U[e] = !0) : t === i.default.ABR_STRATEGY_LoLP ? (F[e] = !1, j[e] = !0, U[e] = !1) : t === i.default.ABR_STRATEGY_BOLA ? (F[e] = !0, j[e] = !1, U[e] = !1) : t === i.default.ABR_STRATEGY_THROUGHPUT ? (F[e] = !1, j[e] = !1, U[e] = !1) : t === i.default.ABR_STRATEGY_DYNAMIC && (F[e] = !(!F || !F[e]) && F[e], j[e] = !1, U[e] = !1);
                                        }(e), e === i.default.VIDEO && ne();
                                    },
                                    unRegisterStreamType: function(e, t) {
                                        try {
                                            A[e] && A[e][t] && delete A[e][t], M[e] && M[e][t] && delete M[e][t], _[e] && _[e][t] && delete _[e][t];
                                        } catch (e) {}
                                    },
                                    setConfig: function(e) {
                                        e && (e.streamController && (c = e.streamController), e.domStorage && (L = e.domStorage), e.mediaPlayerModel && (k = e.mediaPlayerModel), e.customParametersModel && (N = e.customParametersModel), e.dashMetrics && (B = e.dashMetrics), e.adapter && (C = e.adapter), e.videoModel && (D = e.videoModel), e.settings && (G = e.settings));
                                    },
                                    reset: function() {
                                        q(), K.off(l.default.LOADING_PROGRESS, Y, e), K.off(E.default.QUALITY_CHANGE_RENDERED, W, e), K.off(E.default.METRIC_ADDED, z, e), n && n.reset();
                                    }
                                }, t = V.getLogger(e), q(), e;
                            }
                            T.__dashjs_factory_name = "AbrController";
                            var b = c.default.getSingletonFactory(T);
                            b.QUALITY_DEFAULT = 0, c.default.updateSingletonFactory(T.__dashjs_factory_name, b), t.default = b;
                        },
                        "./src/streaming/controllers/BaseURLController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/models/BaseURLTreeModel.js"), i = n("./src/streaming/utils/BaseURLSelector.js"), a1 = n("./src/streaming/utils/URLUtils.js"), o = n("./src/dash/vo/BaseURL.js"), s1 = n("./src/core/FactoryMaker.js"), u = n("./src/core/EventBus.js"), l = n("./src/core/events/Events.js");
                            function c() {
                                var e, t, n, s1, c = this.context, d = Object(u.default)(c).getInstance(), f = Object(a1.default)(c).getInstance();
                                return e = {
                                    reset: function() {
                                        n.reset(), s1.reset();
                                    },
                                    initialize: function(e) {
                                        var r;
                                        n.setConfig({
                                            adapter: t
                                        }), r = e, n.update(r), s1.chooseSelector(t.getIsDVB(r));
                                    },
                                    resolve: function(e) {
                                        var t = n.getForPath(e).reduce(function(e, t) {
                                            var n = s1.select(t);
                                            return n ? (f.isRelative(n.url) ? e.url = f.resolve(n.url, e.url) : (e.url = n.url, e.serviceLocation = n.serviceLocation), e.availabilityTimeOffset = n.availabilityTimeOffset, e.availabilityTimeComplete = n.availabilityTimeComplete, e) : new o.default;
                                        }, new o.default);
                                        if (!f.isRelative(t.url)) return t;
                                    },
                                    setConfig: function(e) {
                                        e.baseURLTreeModel && (n = e.baseURLTreeModel), e.baseURLSelector && (s1 = e.baseURLSelector), e.adapter && (t = e.adapter);
                                    }
                                }, n = Object(r.default)(c).create(), s1 = Object(i.default)(c).create(), d.on(l.default.SERVICE_LOCATION_BLACKLIST_CHANGED, function(e) {
                                    n.invalidateSelectedIndexes(e.entry);
                                }, e), e;
                            }
                            c.__dashjs_factory_name = "BaseURLController", t.default = s1.default.getClassFactory(c);
                        },
                        "./src/streaming/controllers/BlacklistController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/core/EventBus.js");
                            function a1(e) {
                                var t;
                                e = e || {};
                                var n = [], r = Object(i.default)(this.context).getInstance(), a1 = e.updateEventName, o = e.addBlacklistEventName;
                                function s1(e) {
                                    -1 === n.indexOf(e) && (n.push(e), r.trigger(a1, {
                                        entry: e
                                    }));
                                }
                                return t = {
                                    add: s1,
                                    contains: function(e) {
                                        return !!(n.length && e && e.length) && -1 !== n.indexOf(e);
                                    },
                                    reset: function() {
                                        n = [];
                                    }
                                }, o && r.on(o, function(e) {
                                    s1(e.entry);
                                }, t), t;
                            }
                            a1.__dashjs_factory_name = "BlackListController", t.default = r.default.getClassFactory(a1);
                        },
                        "./src/streaming/controllers/BufferController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/Constants.js"), i = n("./src/streaming/constants/MetricsConstants.js"), a1 = n("./src/streaming/models/FragmentModel.js"), o = n("./src/streaming/SourceBufferSink.js"), s1 = n("./src/core/EventBus.js"), u = n("./src/core/events/Events.js"), l = n("./src/core/FactoryMaker.js"), c = n("./src/core/Debug.js"), d = n("./src/streaming/utils/InitCache.js"), f = n("./src/streaming/vo/DashJSError.js"), h = n("./src/core/errors/Errors.js"), g = n("./src/streaming/vo/metrics/HTTPRequest.js"), p = n("./src/streaming/MediaPlayerEvents.js"), m = .01, v = "BufferController";
                            function y(e) {
                                e = e || {};
                                var t, n, l, y, E, T, b, A, _, S, w, I, R, C, D, k, N, L, x = this.context, M = Object(s1.default)(x).getInstance(), O = e.errHandler, P = e.fragmentModel, F = e.representationController, U = e.adapter, j = e.textController, B = e.abrController, G = e.playbackController, H = e.streamInfo, V = e.type, K = e.settings;
                                function q(e) {
                                    T = e;
                                }
                                function Y(e) {
                                    return U.convertRepresentationToRepresentationInfo(F.getRepresentationForQuality(e));
                                }
                                function W(e, t, n) {
                                    var i = Y(n);
                                    return t && t[V] && (V === r.default.VIDEO || V === r.default.AUDIO) ? _.initializeForStreamSwitch(e, i, t[V]) : _.initializeForFirstUse(H, e, i);
                                }
                                function z(e) {
                                    K.get().streaming.cacheInitSegments && (n.info("Init fragment finished loading saving to", V + "'s init cache"), D.save(e.chunk)), n.debug("Append Init fragment", V, " with representationId:", e.chunk.representationId, " and quality:", e.chunk.quality, ", data size:", e.chunk.bytes.byteLength), Q(e.chunk);
                                }
                                function X(e) {
                                    Q(e.chunk, e.request);
                                }
                                function Q(e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                                    _.append(e, t).then(function(e) {
                                        Z(e);
                                    }).catch(function(e) {
                                        Z(e);
                                    }), e.mediaInfo.type === r.default.VIDEO && be(u.default.VIDEO_CHUNK_RECEIVED, {
                                        chunk: e
                                    });
                                }
                                function J(e) {
                                    if (e && e.length > 0) for(var t = 0, r = e.length; t < r; t++)n.debug("Buffered range: " + e.start(t) + " - " + e.end(t) + ", currentTime = ", G.getTime());
                                }
                                function Z(e) {
                                    if (e.error) return 22 === e.error.code && function() {
                                        if (C = !0, E = .8 * ye(), n.warn("Quota exceeded, Critical Buffer: " + E), E > 0) {
                                            var e = Math.max(.2 * E, 1), t = E - e, r = Math.min(K.get().streaming.buffer.bufferTimeAtTopQuality, .9 * t), i = Math.min(K.get().streaming.buffer.bufferTimeAtTopQualityLongForm, .9 * t), a1 = {
                                                streaming: {
                                                    buffer: {
                                                        bufferToKeep: parseFloat(e.toFixed(5)),
                                                        bufferTimeAtTopQuality: parseFloat(r.toFixed(5)),
                                                        bufferTimeAtTopQualityLongForm: parseFloat(i.toFixed(5))
                                                    }
                                                }
                                            };
                                            K.update(a1);
                                        }
                                    }(), void (22 !== e.error.code && Te() || (n.warn("Clearing playback buffer to overcome quota exceed situation"), be(u.default.QUOTA_EXCEEDED, {
                                        criticalBufferLevel: E,
                                        quotaExceededTime: e.chunk.start
                                    }), ce(le())));
                                    if (_ && (ae(), C = !1, (w = e.chunk) && w.endFragment)) {
                                        w && !isNaN(w.index) && (b = Math.max(w.index, b), oe());
                                        var t = _.getAllBufferRanges();
                                        w.segmentType === g.HTTPRequest.MEDIA_SEGMENT_TYPE && (J(t), te(), function() {
                                            if (!isNaN(L)) {
                                                if (V === r.default.AUDIO || V === r.default.VIDEO) {
                                                    var e = G.getTime(), t = ie(e, 0), n = ie(L, 0);
                                                    if (t && n && t.start === n.start) L = NaN;
                                                    else {
                                                        var i = F.getCurrentRepresentation().segmentDuration, a1 = ie(L, i);
                                                        a1 && (K.get().streaming.buffer.enableSeekDecorrelationFix && Math.abs(e - L) > i ? L <= a1.end && G.seek(Math.max(L, a1.start), !1, !0) : e < a1.start && G.seek(a1.start, !1, !0));
                                                    }
                                                } else L = NaN;
                                            }
                                        }()), w && be(u.default.BYTES_APPENDED_END_FRAGMENT, {
                                            quality: w.quality,
                                            startTime: w.start,
                                            index: w.index,
                                            bufferedRanges: t,
                                            segmentType: w.segmentType,
                                            mediaType: V
                                        });
                                    }
                                }
                                function $() {
                                    return new Promise(function(e, t) {
                                        var n = ee();
                                        if (!n || 0 === n.length) return te(), void e();
                                        ce(n).then(function() {
                                            e();
                                        }).catch(function(e) {
                                            t(e);
                                        });
                                    });
                                }
                                function ee(e) {
                                    var t = [], r = _.getAllBufferRanges();
                                    if (!r || 0 === r.length) return t;
                                    if (!e && 0 !== e || isNaN(e)) t.push({
                                        start: r.start(0),
                                        end: r.end(r.length - 1) + .5
                                    });
                                    else {
                                        var i = function(e, t) {
                                            var n = K.get().streaming.buffer.bufferToKeep, r = t.start(0);
                                            if (e - r > n) {
                                                var i = Math.max(0, e - n), o = P.getRequests({
                                                    state: a1.default.FRAGMENT_MODEL_EXECUTED,
                                                    time: e,
                                                    threshold: m
                                                })[0];
                                                if (o && (i = Math.min(o.startTime, i)), i > 0) return {
                                                    start: r,
                                                    end: i
                                                };
                                            }
                                            return null;
                                        }(e, r), o = function(e, t) {
                                            var r = t.end(t.length - 1) + .5, i = Ee(e), o = H.manifestInfo.duration >= K.get().streaming.buffer.longFormContentDurationThreshold ? K.get().streaming.buffer.bufferTimeAtTopQualityLongForm : K.get().streaming.buffer.bufferTimeAtTopQuality, s1 = isNaN(i) ? e : Math.min(i, e + o);
                                            if (s1 >= t.end(t.length - 1)) return null;
                                            var u = P.getRequests({
                                                state: a1.default.FRAGMENT_MODEL_EXECUTED,
                                                time: e,
                                                threshold: m
                                            })[0];
                                            if (u && (s1 = Math.max(u.startTime + u.duration, s1)), K.get().streaming.buffer.avoidCurrentTimeRangePruning) {
                                                for(var l = 0; l < t.length; l++)if (t.start(l) <= e && e <= t.end(l) && t.start(l) <= s1 && s1 <= t.end(l)) {
                                                    var c = s1;
                                                    s1 = l + 1 < t.length ? t.start(l + 1) : t.end(l) + 1, n.debug("Buffered range [" + t.start(l) + ", " + t.end(l) + "] overlaps with targetTime " + e + " and range to be pruned [" + c + ", " + r + "], using [" + s1 + ", " + r + "] instead" + (s1 < r ? "" : " (no actual pruning)"));
                                                    break;
                                                }
                                            }
                                            return s1 < t.end(t.length - 1) ? {
                                                start: s1,
                                                end: r
                                            } : null;
                                        }(e, r);
                                        i && t.push(i), o && t.push(o);
                                    }
                                    return t;
                                }
                                function te() {
                                    (!N || V === r.default.TEXT && j.isTextEnabled()) && ae();
                                }
                                function ne() {
                                    se();
                                }
                                function re() {
                                    se(), L = NaN;
                                }
                                function ie(e, t) {
                                    var n, r, i = _.getAllBufferRanges(), a1 = 0, o = 0, s1 = null, u = null, l = 0, c = isNaN(t) ? .15 : t;
                                    if (null != i) {
                                        for(r = 0, n = i.length; r < n; r++)if (a1 = i.start(r), o = i.end(r), null === s1) l = Math.abs(a1 - e), (e >= a1 && e < o || l <= c) && (s1 = a1, u = o);
                                        else {
                                            if (!((l = a1 - u) <= c)) break;
                                            u = o;
                                        }
                                        if (null !== s1) return {
                                            start: s1,
                                            end: u
                                        };
                                    }
                                    return null;
                                }
                                function ae() {
                                    if (G) {
                                        var e = K.get().streaming.gaps.jumpGaps && !isNaN(K.get().streaming.gaps.smallGapLimit) ? K.get().streaming.gaps.smallGapLimit : NaN;
                                        y = Math.max(function(e, t) {
                                            var n;
                                            return K.get().streaming.gaps.jumpGaps && (t = K.get().streaming.gaps.smallGapLimit), null === (n = ie(e, t)) ? 0 : n.end - e;
                                        }(G.getTime() || 0, e), 0), be(u.default.BUFFER_LEVEL_UPDATED, {
                                            mediaType: V,
                                            bufferLevel: y
                                        }), se();
                                    }
                                }
                                function oe() {
                                    var e = b >= A - 1, t = G.getTimeToStreamEnd(H) - y < 1e-5;
                                    !e && !t || l || (ve(!0), n.debug("checkIfBufferingCompleted trigger BUFFERING_COMPLETED for stream id ".concat(H.id, " and type ").concat(V)));
                                }
                                function se() {
                                    V !== r.default.AUDIO && V !== r.default.VIDEO || ((!G.getLowLatencyModeEnabled() && y < K.get().streaming.buffer.stallThreshold || 0 === y) && !l ? ue(i.default.BUFFER_EMPTY) : (l || y >= K.get().streaming.buffer.stallThreshold || G.getLowLatencyModeEnabled() && y > 0) && ue(i.default.BUFFER_LOADED));
                                }
                                function ue(e) {
                                    S === e || e === i.default.BUFFER_EMPTY && 0 === G.getTime() || V === r.default.TEXT && !j.isTextEnabled() || (S = e, be(u.default.BUFFER_LEVEL_STATE_CHANGED, {
                                        state: e
                                    }), be(e === i.default.BUFFER_LOADED ? u.default.BUFFER_LOADED : u.default.BUFFER_EMPTY), n.debug(e === i.default.BUFFER_LOADED ? "Got enough buffer to start" : "Waiting for more buffer before starting playback"));
                                }
                                function le() {
                                    var e = [], t = _.getAllBufferRanges();
                                    if (!t || 0 === t.length) return e;
                                    var n = G.getTime(), r = Math.max(0, n - K.get().streaming.buffer.bufferToKeep), i = P.getRequests({
                                        state: a1.default.FRAGMENT_MODEL_EXECUTED,
                                        time: n,
                                        threshold: m
                                    })[0];
                                    if (i) r = Math.min(i.startTime, r);
                                    else if (0 === n && G.getIsDynamic()) return [];
                                    if (t.start(0) <= r) {
                                        for(var o = {
                                            start: 0,
                                            end: r
                                        }, s1 = 0; s1 < t.length && t.end(s1) <= r; s1++)o.end = t.end(s1);
                                        o.start < o.end && e.push(o);
                                    }
                                    return e;
                                }
                                function ce(e) {
                                    return new Promise(function(t, n) {
                                        if (e && _ && 0 !== e.length) {
                                            var r = [];
                                            e.forEach(function(e) {
                                                r.push(function(e) {
                                                    return new Promise(function(t, n) {
                                                        e.resolve = t, e.reject = n, k.push(e);
                                                    });
                                                }(e));
                                            }), R || de(), Promise.all(r).then(function() {
                                                t();
                                            }).catch(function(e) {
                                                n(e);
                                            });
                                        } else t();
                                    });
                                }
                                function de() {
                                    try {
                                        if (0 === k.length || !_) return n.debug("Nothing to prune, halt pruning"), k = [], void (R = !1);
                                        var e = _.getBuffer();
                                        if (!e || !e.buffered || 0 === e.buffered.length) return n.debug("SourceBuffer is empty (or does not exist), halt pruning"), k = [], void (R = !1);
                                        var t = k.shift();
                                        n.debug("".concat(V, ": Removing buffer from: ").concat(t.start, " to ").concat(t.end)), R = !0, G.getTime() < t.end && ve(!1), _.remove(t).then(function(e) {
                                            fe(e);
                                        }).catch(function(e) {
                                            fe(e);
                                        });
                                    } catch (e) {
                                        R = !1;
                                    }
                                }
                                function fe(e) {
                                    n.debug("onRemoved buffer from:", e.from, "to", e.to), J(_.getAllBufferRanges()), 0 === k.length && (R = !1, ae()), e.unintended && (n.warn("Detected unintended removal from:", e.from, "to", e.to, "setting streamprocessor time to", e.from), be(u.default.SEEK_TARGET, {
                                        time: e.from
                                    })), R ? de() : (N ? N = !1 : ae(), be(u.default.BUFFER_CLEARED, {
                                        from: e.from,
                                        to: e.to,
                                        unintended: e.unintended,
                                        hasEnoughSpaceToAppend: Te(),
                                        quotaExceeded: C
                                    }));
                                }
                                function he(e) {
                                    return new Promise(function(t) {
                                        e && void 0 !== e.MSETimeOffset && _ && _.updateTimestampOffset ? _.updateTimestampOffset(e.MSETimeOffset).then(function() {
                                            t();
                                        }).catch(function() {
                                            t();
                                        }) : t();
                                    });
                                }
                                function ge() {
                                    return _ && !l ? _.updateAppendWindow(H) : Promise.resolve();
                                }
                                function pe() {
                                    ++I * (K.get().streaming.wallclockTimeUpdateInterval / 1e3) >= K.get().streaming.buffer.bufferPruningInterval && (I = 0, _ && V !== r.default.TEXT && (l || ce(le())));
                                }
                                function me() {
                                    se();
                                }
                                function ve(e) {
                                    l !== e && ((l = e) ? be(u.default.BUFFERING_COMPLETED) : A = Number.POSITIVE_INFINITY);
                                }
                                function ye() {
                                    try {
                                        var e, t, n = _.getAllBufferRanges(), r = 0;
                                        if (!n) return r;
                                        for(t = 0, e = n.length; t < e; t++)r += n.end(t) - n.start(t);
                                        return r;
                                    } catch (e) {
                                        return 0;
                                    }
                                }
                                function Ee(e) {
                                    try {
                                        var t = e, n = _.getAllBufferRanges();
                                        if (!n || 0 === n.length) return NaN;
                                        for(var r = 0; t === e && r < n.length;){
                                            var i = n.start(r), a1 = n.end(r);
                                            t >= i && t <= a1 && (t = a1), r += 1;
                                        }
                                        return t === e ? NaN : t;
                                    } catch (e) {}
                                }
                                function Te() {
                                    var e = ye();
                                    return isNaN(e) || e < E;
                                }
                                function be(e, t) {
                                    var n = t || {};
                                    M.trigger(e, n, {
                                        streamId: H.id,
                                        mediaType: V
                                    });
                                }
                                function Ae(e, t) {
                                    if (E = Number.POSITIVE_INFINITY, S = void 0, A = Number.POSITIVE_INFINITY, b = 0, w = null, l = !1, R = !1, C = !1, y = 0, I = 0, k = [], L = NaN, _) {
                                        var n = _;
                                        _ = null, e || t || n.abort().then(function() {
                                            n.reset(t), n = null;
                                        });
                                    }
                                    N = !1;
                                }
                                return t = {
                                    initialize: function(e) {
                                        q(e), M.on(u.default.INIT_FRAGMENT_LOADED, z, t), M.on(u.default.MEDIA_FRAGMENT_LOADED, X, t), M.on(u.default.WALLCLOCK_TIME_UPDATED, pe, t), M.on(p.default.PLAYBACK_PLAYING, re, t), M.on(p.default.PLAYBACK_PROGRESS, te, t), M.on(p.default.PLAYBACK_TIME_UPDATED, te, t), M.on(p.default.PLAYBACK_RATE_CHANGED, me, t), M.on(p.default.PLAYBACK_STALLED, ne, t);
                                    },
                                    getStreamId: function() {
                                        return H.id;
                                    },
                                    getType: function() {
                                        return V;
                                    },
                                    getBufferControllerType: function() {
                                        return v;
                                    },
                                    createBufferSink: function(e) {
                                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
                                        return new Promise(function(r, i) {
                                            if (D && e && T) {
                                                var a1 = B.getQualityFor(V, H.id);
                                                _ = Object(o.default)(x).create({
                                                    mediaSource: T,
                                                    textController: j,
                                                    eventBus: M
                                                }), W(e, t, a1).then(function() {
                                                    return he(Y(a1));
                                                }).then(function() {
                                                    r(_);
                                                }).catch(function(e) {
                                                    n.fatal("Caught error on create SourceBuffer: " + e), O.error(new f.default(h.default.MEDIASOURCE_TYPE_UNSUPPORTED_CODE, h.default.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + V)), i(e);
                                                });
                                            } else r(null);
                                        });
                                    },
                                    getBuffer: function() {
                                        return _;
                                    },
                                    getBufferLevel: function() {
                                        return y;
                                    },
                                    getRangeAt: ie,
                                    setMediaSource: q,
                                    getMediaSource: function() {
                                        return T;
                                    },
                                    appendInitSegmentFromCache: function(e) {
                                        var t = D.extract(H.id, e);
                                        return !!t && (n.info("Append Init fragment", V, " with representationId:", t.representationId, " and quality:", t.quality, ", data size:", t.bytes.byteLength), Q(t), !0);
                                    },
                                    getIsBufferingCompleted: function() {
                                        return l;
                                    },
                                    setIsBufferingCompleted: ve,
                                    getIsPruningInProgress: function() {
                                        return R;
                                    },
                                    reset: function(e, t) {
                                        M.off(u.default.INIT_FRAGMENT_LOADED, z, this), M.off(u.default.MEDIA_FRAGMENT_LOADED, X, this), M.off(u.default.WALLCLOCK_TIME_UPDATED, pe, this), M.off(p.default.PLAYBACK_PLAYING, re, this), M.off(p.default.PLAYBACK_PROGRESS, te, this), M.off(p.default.PLAYBACK_TIME_UPDATED, te, this), M.off(p.default.PLAYBACK_RATE_CHANGED, me, this), M.off(p.default.PLAYBACK_STALLED, ne, this), Ae(e, t);
                                    },
                                    prepareForPlaybackSeek: function() {
                                        return l && ve(!1), _.abort();
                                    },
                                    prepareForReplacementTrackSwitch: function(e) {
                                        return new Promise(function(t, n) {
                                            _.abort().then(function() {
                                                return ge();
                                            }).then(function() {
                                                return K.get().streaming.buffer.useChangeTypeForTrackSwitch ? _.changeType(e) : Promise.resolve();
                                            }).then(function() {
                                                return $();
                                            }).then(function() {
                                                ve(!1), t();
                                            }).catch(function(e) {
                                                n(e);
                                            });
                                        });
                                    },
                                    prepareForNonReplacementTrackSwitch: function(e) {
                                        return new Promise(function(t, n) {
                                            ge().then(function() {
                                                return K.get().streaming.buffer.useChangeTypeForTrackSwitch ? _.changeType(e) : Promise.resolve();
                                            }).then(function() {
                                                t();
                                            }).catch(function(e) {
                                                n(e);
                                            });
                                        });
                                    },
                                    prepareForReplacementQualitySwitch: function() {
                                        return new Promise(function(e, t) {
                                            _.abort().then(function() {
                                                return ge();
                                            }).then(function() {
                                                return $();
                                            }).then(function() {
                                                ve(!1), e();
                                            }).catch(function(e) {
                                                t(e);
                                            });
                                        });
                                    },
                                    updateAppendWindow: ge,
                                    getAllRangesWithSafetyFactor: ee,
                                    getContinuousBufferTimeForTargetTime: Ee,
                                    clearBuffers: ce,
                                    pruneAllSafely: $,
                                    updateBufferTimestampOffset: he,
                                    setSeekTarget: function(e) {
                                        L = e;
                                    },
                                    segmentRequestingCompleted: function(e) {
                                        isNaN(e) || (A = e, oe());
                                    }
                                }, n = Object(c.default)(x).getInstance().getLogger(t), D = Object(d.default)(x).getInstance(), Ae(), t;
                            }
                            y.__dashjs_factory_name = v, t.default = l.default.getClassFactory(y);
                        },
                        "./src/streaming/controllers/CatchupController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/core/Debug.js"), a1 = n("./src/core/EventBus.js"), o = n("./src/streaming/constants/Constants.js"), s1 = n("./src/streaming/MediaPlayerEvents.js"), u = n("./src/core/events/Events.js"), l = n("./src/streaming/constants/MetricsConstants.js"), c = n("./src/core/Utils.js");
                            function d() {
                                var e, t, n, r, d, f, h, g, p, m, v = this.context, y = Object(a1.default)(v).getInstance();
                                function E() {
                                    t = !1;
                                    var e = c.default.parseUserAgent();
                                    n = e && e.browser && e.browser.name && "safari" === e.browser.name.toLowerCase();
                                }
                                function T() {
                                    t = !1;
                                }
                                function b(e) {
                                    if (e.streamId === f.getActiveStreamInfo().id && p) {
                                        var t = h.getLiveDelay();
                                        h.getBufferLevel() > t / 2 && (p = !1);
                                    }
                                }
                                function A(e) {
                                    e.streamId === f.getActiveStreamInfo().id && (p = e.state === l.default.BUFFER_EMPTY);
                                }
                                function _() {
                                    g.getCatchupModeEnabled() || r.setPlaybackRate(1);
                                }
                                function S() {
                                    h.getIsDynamic() && g.getCatchupModeEnabled() && (g.getCatchupPlaybackRates().max > 0 || g.getCatchupPlaybackRates().min < 0) && !h.isPaused() && !h.isSeeking() && function() {
                                        try {
                                            return !(!h.getTime() > 0 || t) && (I() === o.default.LIVE_CATCHUP_MODE_LOLP ? function(e, t) {
                                                try {
                                                    return Math.abs(w()) > 0 || e < t;
                                                } catch (e) {
                                                    return !1;
                                                }
                                            }(h.getBufferLevel(), d.get().streaming.liveCatchup.playbackBufferMin) : function() {
                                                try {
                                                    return Math.abs(w()) > 0;
                                                } catch (e) {
                                                    return !1;
                                                }
                                            }());
                                        } catch (e) {
                                            return !1;
                                        }
                                    }() && function() {
                                        if (!t && r) {
                                            var e, i = r.getPlaybackRate(), a1 = g.getCatchupPlaybackRates(), s1 = h.getBufferLevel(), u = w(), l = g.getCatchupMaxDrift();
                                            if (!isNaN(l) && l > 0 && u > l) m.info("[CatchupController]: Low Latency catchup mechanism. Latency too high, doing a seek to live point"), t = !0, h.seekToCurrentLive(!0, !1);
                                            else {
                                                var c = h.getCurrentLiveLatency(), f = h.getLiveDelay();
                                                e = I() === o.default.LIVE_CATCHUP_MODE_LOLP ? function(e, t, n, r, i) {
                                                    var a1;
                                                    if (i < r) {
                                                        var o = Math.abs(e.min), s1 = 5 * (i - r);
                                                        a1 = 1 - o + 2 * o / (1 + Math.pow(Math.E, -s1)), m.debug("[LoL+ playback control_buffer-based] bufferLevel: " + i + ", newRate: " + a1);
                                                    } else {
                                                        var u = e.max;
                                                        if (Math.abs(t - n) <= .02 * n) a1 = 1;
                                                        else {
                                                            var l = 5 * (t - n);
                                                            a1 = 1 - u + 2 * u / (1 + Math.pow(Math.E, -l));
                                                        }
                                                        m.debug("[LoL+ playback control_latency-based] latency: " + t + ", newRate: " + a1);
                                                    }
                                                    return a1;
                                                }(a1, c, f, d.get().streaming.liveCatchup.playbackBufferMin, s1) : function(e, t, n, r) {
                                                    if (p) return 1;
                                                    var i = t - n, a1 = i < 0 ? Math.abs(e.min) : e.max, o = 5 * i, s1 = 1 - a1 + 2 * a1 / (1 + Math.pow(Math.E, -o));
                                                    return h.getPlaybackStalled() && r <= n / 2 && i > 0 && (s1 = 1), s1;
                                                }(a1, c, f, s1);
                                                var v = n ? .25 : .02 / (.5 / a1.max);
                                                e && Math.abs(i - e) >= v && (m.debug("[CatchupController]: Setting playback rate to ".concat(e)), r.setPlaybackRate(e));
                                            }
                                        }
                                    }();
                                }
                                function w() {
                                    return h.getCurrentLiveLatency() - h.getLiveDelay();
                                }
                                function I() {
                                    var e = d.get().streaming.liveCatchup.playbackBufferMin;
                                    return d.get().streaming.liveCatchup.mode !== o.default.LIVE_CATCHUP_MODE_LOLP || null === e || isNaN(e) ? o.default.LIVE_CATCHUP_MODE_DEFAULT : o.default.LIVE_CATCHUP_MODE_LOLP;
                                }
                                function R() {
                                    g.getCatchupPlaybackRates(!0);
                                }
                                return e = {
                                    reset: function() {
                                        y.off(s1.default.BUFFER_LEVEL_UPDATED, b, e), y.off(s1.default.BUFFER_LEVEL_STATE_CHANGED, A, e), y.off(s1.default.PLAYBACK_PROGRESS, S, e), y.off(s1.default.PLAYBACK_TIME_UPDATED, S, e), y.off(s1.default.PLAYBACK_SEEKED, S, e), y.off(u.default.SETTING_UPDATED_CATCHUP_ENABLED, _, e), y.off(u.default.SETTING_UPDATED_PLAYBACK_RATE_MIN, R, e), y.off(u.default.SETTING_UPDATED_PLAYBACK_RATE_MAX, R, e), y.off(s1.default.STREAM_INITIALIZED, R, e), E(), r.setPlaybackRate(1, !0);
                                    },
                                    setConfig: function(e) {
                                        e && (e.settings && (d = e.settings), e.videoModel && (r = e.videoModel), e.streamController && (f = e.streamController), e.playbackController && (h = e.playbackController), e.mediaPlayerModel && (g = e.mediaPlayerModel));
                                    },
                                    initialize: function() {
                                        y.on(s1.default.BUFFER_LEVEL_UPDATED, b, e), y.on(s1.default.BUFFER_LEVEL_STATE_CHANGED, A, e), y.on(s1.default.PLAYBACK_PROGRESS, S, e), y.on(s1.default.PLAYBACK_TIME_UPDATED, S, e), y.on(s1.default.PLAYBACK_SEEKED, T, e), y.on(u.default.SETTING_UPDATED_CATCHUP_ENABLED, _, e), y.on(u.default.SETTING_UPDATED_PLAYBACK_RATE_MIN, R, e), y.on(u.default.SETTING_UPDATED_PLAYBACK_RATE_MAX, R, e), y.on(s1.default.STREAM_INITIALIZED, R, e), R();
                                    }
                                }, m = Object(i.default)(v).getInstance().getLogger(e), E(), e;
                            }
                            d.__dashjs_factory_name = "CatchupController", t.default = r.default.getSingletonFactory(d);
                        },
                        "./src/streaming/controllers/EventController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/core/Debug.js"), a1 = n("./src/core/EventBus.js"), o = n("./src/streaming/MediaPlayerEvents.js"), s1 = n("./src/streaming/net/XHRLoader.js");
                            function u() {
                                var e, t, n, r, u, l, c, d, f, h, g, p = "urn:mpeg:dash:event:2012", m = "discarded", v = "updated", y = "added", E = this.context, T = Object(a1.default)(E).getInstance();
                                function b() {
                                    if (!c || !d) throw new Error("setConfig function has to be called previously");
                                }
                                function A() {
                                    g = !1, n = {}, r = {}, u = null, h = !1, l = Date.now() / 1e3;
                                }
                                function _() {
                                    try {
                                        if (!h) {
                                            h = !0;
                                            var e = d.getTime(), i = e - l;
                                            i = l > 0 ? Math.max(0, i) : 0, S(r, i, e), S(n, i, e), w(r), w(n), l = e, h = !1;
                                        }
                                    } catch (e) {
                                        h = !1, t.error(e);
                                    }
                                }
                                function S(e, n, r) {
                                    try {
                                        D(e, function(i) {
                                            if (void 0 !== i) {
                                                var a1 = isNaN(i.duration) ? 0 : i.duration;
                                                i.calculatedPresentationTime <= r && i.calculatedPresentationTime + n + a1 >= r ? N(i, o.default.EVENT_MODE_ON_START) : (k(r, a1 + n, i.calculatedPresentationTime) || function(e) {
                                                    try {
                                                        var n = e.eventStream.period.start + e.eventStream.period.duration;
                                                        return e.calculatedPresentationTime > n;
                                                    } catch (e) {
                                                        return t.error(e), !1;
                                                    }
                                                }(i)) && (t.debug("Removing event ".concat(i.id, " from period ").concat(i.eventStream.period.id, " as it is expired or invalid")), function(e, n) {
                                                    try {
                                                        var r = n.eventStream.schemeIdUri, i = n.eventStream.period.id, a1 = n.eventStream.value, o = n.id;
                                                        e[i][r] = e[i][r].filter(function(e) {
                                                            return a1 && e.eventStream.value && e.eventStream.value !== a1 || e.id !== o;
                                                        }), 0 === e[i][r].length && delete e[i][r];
                                                    } catch (e) {
                                                        t.error(e);
                                                    }
                                                }(e, i));
                                            }
                                        });
                                    } catch (e) {
                                        t.error(e);
                                    }
                                }
                                function w(e) {
                                    try {
                                        for(var n in e)e.hasOwnProperty(n) && 0 === Object.keys(e[n]).length && delete e[n];
                                    } catch (e) {
                                        t.error(e);
                                    }
                                }
                                function I(e, t) {
                                    var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = e.eventStream.schemeIdUri, i = e.eventStream.value, a1 = e.id, o = m;
                                    t[r] || (t[r] = []);
                                    var s1 = t[r].findIndex(function(e) {
                                        return (!i || e.eventStream.value && e.eventStream.value === i) && e.id === a1;
                                    });
                                    if (-1 === s1) t[r].push(e), e.triggeredReceivedEvent = !1, e.triggeredStartEvent = !1, o = y;
                                    else if (n) {
                                        var u = t[r][s1];
                                        e.triggeredReceivedEvent = u.triggeredReceivedEvent, e.triggeredStartEvent = u.triggeredStartEvent, t[r][s1] = e, o = v;
                                    }
                                    return o;
                                }
                                function R(e) {
                                    try {
                                        if (1 == e.eventStream.value) {
                                            var n, r = e.calculatedPresentationTime;
                                            n = 4294967295 == e.calculatedPresentationTime ? NaN : e.calculatedPresentationTime + e.duration, T.trigger(o.default.MANIFEST_VALIDITY_CHANGED, {
                                                id: e.id,
                                                validUntil: r,
                                                newDuration: n,
                                                newManifestValidAfter: NaN
                                            }, {
                                                mode: o.default.EVENT_MODE_ON_START
                                            });
                                        }
                                    } catch (e) {
                                        t.error(e);
                                    }
                                }
                                function C(e) {
                                    try {
                                        var n = d.getTime();
                                        D(e, function(e) {
                                            var t = e.eventStream && e.eventStream.period && !isNaN(e.eventStream.period.duration) ? e.eventStream.period.duration : NaN, r = e.eventStream && e.eventStream.period && !isNaN(e.eventStream.period.start) ? e.eventStream.period.start : NaN;
                                            if (!isNaN(t) && !isNaN(r)) {
                                                var i = e.calculatedPresentationTime;
                                                Math.abs(i - n) < 300 && N(e, o.default.EVENT_MODE_ON_START);
                                            }
                                        });
                                    } catch (e) {
                                        t.error(e);
                                    }
                                }
                                function D(e, n) {
                                    try {
                                        if (e) for(var r = Object.keys(e), i = 0; i < r.length; i++)for(var a1 = e[r[i]], o = Object.keys(a1), s1 = 0; s1 < o.length; s1++)a1[o[s1]].forEach(function(e) {
                                            void 0 !== e && n(e);
                                        });
                                    } catch (e) {
                                        t.error(e);
                                    }
                                }
                                function k(e, n, r) {
                                    try {
                                        return e - n > r;
                                    } catch (e) {
                                        return t.error(e), !1;
                                    }
                                }
                                function N(e, n) {
                                    try {
                                        var r = d.getTime(), i = e.id;
                                        if (n === o.default.EVENT_MODE_ON_RECEIVE && !e.triggeredReceivedEvent) return t.debug("Received event ".concat(i)), e.triggeredReceivedEvent = !0, void T.trigger(e.eventStream.schemeIdUri, {
                                            event: e
                                        }, {
                                            mode: n
                                        });
                                        e.triggeredStartEvent || (e.eventStream.schemeIdUri === p && 1 == e.eventStream.value ? 0 === e.duration && 0 === e.presentationTimeDelta || (t.debug("Starting manifest refresh event ".concat(i, " at ").concat(r)), function() {
                                            try {
                                                b(), c.refreshManifest();
                                            } catch (e) {
                                                t.error(e);
                                            }
                                        }()) : "urn:mpeg:dash:event:callback:2015" === e.eventStream.schemeIdUri && 1 == e.eventStream.value ? (t.debug("Starting callback event ".concat(i, " at ").concat(r)), function(e) {
                                            try {
                                                Object(s1.default)(E).create({}).load({
                                                    method: "get",
                                                    url: e,
                                                    request: {
                                                        responseType: "arraybuffer"
                                                    }
                                                });
                                            } catch (e) {
                                                t.error(e);
                                            }
                                        }(e.messageData)) : (t.debug("Starting event ".concat(i, " from period ").concat(e.eventStream.period.id, " at ").concat(r)), T.trigger(e.eventStream.schemeIdUri, {
                                            event: e
                                        }, {
                                            mode: n
                                        })), e.triggeredStartEvent = !0);
                                    } catch (e) {
                                        t.error(e);
                                    }
                                }
                                return e = {
                                    addInlineEvents: function(e, r) {
                                        try {
                                            if (b(), n[r] || (n[r] = {}), e) for(var i = 0; i < e.length; i++){
                                                var a1 = e[i];
                                                if (!k(d.getTime(), isNaN(a1.duration) ? 0 : a1.duration, a1.calculatedPresentationTime)) {
                                                    var s1 = I(a1, n[r], !0);
                                                    s1 === y ? (t.debug("Added inline event with id ".concat(a1.id, " from period ").concat(r)), N(a1, o.default.EVENT_MODE_ON_RECEIVE)) : s1 === v && t.debug("Updated inline event with id ".concat(a1.id, " from period ").concat(r));
                                                }
                                            }
                                        } catch (e) {
                                            throw e;
                                        }
                                    },
                                    addInbandEvents: function(e, n) {
                                        try {
                                            b(), r[n] || (r[n] = {});
                                            for(var i = 0; i < e.length; i++){
                                                var a1 = e[i];
                                                k(d.getTime(), isNaN(a1.duration) ? 0 : a1.duration, a1.calculatedPresentationTime) || (I(a1, r[n], !1) === y ? (a1.eventStream.schemeIdUri === p && R(a1), t.debug("Added inband event with id ".concat(a1.id, " from period ").concat(n)), N(a1, o.default.EVENT_MODE_ON_RECEIVE)) : t.debug("Inband event with scheme_id_uri ".concat(a1.eventStream.schemeIdUri, ", value ").concat(a1.eventStream.value, ", period id ").concat(n, " and event id ").concat(a1.id, " was ignored because it has been added before.")));
                                            }
                                            _();
                                        } catch (e) {
                                            throw e;
                                        }
                                    },
                                    getInbandEvents: function() {
                                        return r;
                                    },
                                    getInlineEvents: function() {
                                        return n;
                                    },
                                    start: function() {
                                        try {
                                            b(), t.debug("Start Event Controller");
                                            var e = f.get().streaming.eventControllerRefreshDelay;
                                            g || isNaN(e) || (g = !0, u = setInterval(_, e));
                                        } catch (e) {
                                            throw e;
                                        }
                                    },
                                    setConfig: function(e) {
                                        try {
                                            if (!e) return;
                                            e.manifestUpdater && (c = e.manifestUpdater), e.playbackController && (d = e.playbackController), e.settings && (f = e.settings);
                                        } catch (e) {
                                            throw e;
                                        }
                                    },
                                    reset: function() {
                                        (function() {
                                            try {
                                                null !== u && g && (clearInterval(u), u = null, g = !1, function() {
                                                    try {
                                                        C(r), C(n);
                                                    } catch (e) {
                                                        t.error(e);
                                                    }
                                                }());
                                            } catch (e) {
                                                throw e;
                                            }
                                        })(), A();
                                    }
                                }, t = Object(i.default)(E).getInstance().getLogger(e), A(), e;
                            }
                            u.__dashjs_factory_name = "EventController", t.default = r.default.getSingletonFactory(u);
                        },
                        "./src/streaming/controllers/FragmentController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/Constants.js"), i = n("./src/streaming/vo/DataChunk.js"), a1 = n("./src/streaming/models/FragmentModel.js"), o = n("./src/streaming/FragmentLoader.js"), s1 = n("./src/streaming/utils/RequestModifier.js"), u = n("./src/core/EventBus.js"), l = n("./src/core/events/Events.js"), c = n("./src/streaming/MediaPlayerEvents.js"), d = n("./src/core/errors/Errors.js"), f = n("./src/core/FactoryMaker.js"), h = n("./src/core/Debug.js");
                            function g(e) {
                                e = e || {};
                                var t, n, f, g = this.context, p = Object(u.default)(g).getInstance(), m = e.errHandler, v = e.mediaPlayerModel, y = e.dashMetrics, E = Object(h.default)(g).getInstance(), T = e.streamInfo;
                                function b() {
                                    return T.id;
                                }
                                function A() {
                                    for(var e in f)f[e].reset();
                                    f = {};
                                }
                                function _(e) {
                                    if (e.sender) {
                                        var t = e.request, a1 = e.response, o = t.isInitializationRequest(), s1 = t.mediaInfo.streamInfo;
                                        if (e.error && (t.mediaType === r.default.AUDIO || t.mediaType === r.default.VIDEO || t.mediaType === r.default.TEXT && t.mediaInfo.isFragmented) && p.trigger(l.default.SERVICE_LOCATION_BLACKLIST_ADD, {
                                            entry: e.request.serviceLocation
                                        }), a1 && s1) {
                                            var u = function(e, t, n, r) {
                                                var a1 = new i.default;
                                                return a1.streamId = n, a1.mediaInfo = t.mediaInfo, a1.segmentType = t.type, a1.start = t.startTime, a1.duration = t.duration, a1.end = a1.start + a1.duration, a1.bytes = e, a1.index = t.index, a1.quality = t.quality, a1.representationId = t.representationId, a1.endFragment = r, a1;
                                            }(a1, t, T.id, e.type !== l.default.FRAGMENT_LOADING_PROGRESS);
                                            p.trigger(o ? l.default.INIT_FRAGMENT_LOADED : l.default.MEDIA_FRAGMENT_LOADED, {
                                                chunk: u,
                                                request: t
                                            }, {
                                                streamId: s1.id,
                                                mediaType: t.mediaType
                                            });
                                        } else n.warn("No " + t.mediaType + " bytes to push or stream is inactive.");
                                    }
                                }
                                return t = {
                                    getStreamId: b,
                                    getModel: function(t) {
                                        var n = f[t];
                                        return n || (n = Object(a1.default)(g).create({
                                            streamInfo: T,
                                            type: t,
                                            dashMetrics: y,
                                            fragmentLoader: Object(o.default)(g).create({
                                                dashMetrics: y,
                                                mediaPlayerModel: v,
                                                errHandler: m,
                                                requestModifier: Object(s1.default)(g).getInstance(),
                                                settings: e.settings,
                                                boxParser: e.boxParser,
                                                eventBus: p,
                                                events: l.default,
                                                errors: d.default,
                                                dashConstants: e.dashConstants,
                                                urlUtils: e.urlUtils,
                                                streamId: b()
                                            }),
                                            debug: E,
                                            eventBus: p,
                                            events: l.default
                                        }), f[t] = n), n;
                                    },
                                    reset: function() {
                                        p.off(c.default.FRAGMENT_LOADING_COMPLETED, _, this), p.off(c.default.FRAGMENT_LOADING_PROGRESS, _, this), A();
                                    }
                                }, n = E.getLogger(t), A(), p.on(c.default.FRAGMENT_LOADING_COMPLETED, _, t), p.on(c.default.FRAGMENT_LOADING_PROGRESS, _, t), t;
                            }
                            g.__dashjs_factory_name = "FragmentController", t.default = f.default.getClassFactory(g);
                        },
                        "./src/streaming/controllers/GapController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/core/Debug.js"), a1 = n("./src/core/events/Events.js"), o = n("./src/core/EventBus.js"), s1 = n("./src/streaming/constants/Constants.js");
                            function u() {
                                var e, t, n, r, u, l, c, d, f, h, g, p, m = this.context, v = Object(o.default)(m).getInstance();
                                function y() {
                                    p.debug("Stopping the gap controller"), u && (clearInterval(u), u = null), function() {
                                        v.off(a1.default.WALLCLOCK_TIME_UPDATED, _, this), v.off(a1.default.INITIAL_STREAM_SWITCH, A, this), v.off(a1.default.PLAYBACK_SEEKING, E, this), v.off(a1.default.BUFFER_REPLACEMENT_STARTED, T, e), v.off(a1.default.TRACK_CHANGE_RENDERED, b, e);
                                    }(), u = null, l = NaN, r = 0, h = null, g = {};
                                }
                                function E() {
                                    h && (clearTimeout(h), h = null);
                                }
                                function T(e) {
                                    try {
                                        if (e.streamId !== d.getActiveStreamInfo().id || e.mediaType !== s1.default.VIDEO && e.mediaType !== s1.default.AUDIO) return;
                                        e.streamId === d.getActiveStreamInfo().id && (g[e.mediaType] = !0);
                                    } catch (e) {
                                        p.error(e);
                                    }
                                }
                                function b(e) {
                                    e && e.mediaType && (g[e.mediaType] = !1);
                                }
                                function A() {
                                    u || function() {
                                        try {
                                            u || (p.debug("Starting the gap controller"), u = setInterval(function() {
                                                S() && C(c.getTime());
                                            }, 100));
                                        } catch (e) {}
                                    }();
                                }
                                function _() {
                                    if (S(n.get().streaming.gaps.enableSeekFix) && ++r >= 10) {
                                        var e = c.getTime();
                                        t === e ? C(e, !0) : (t = e, l = NaN), r = 0;
                                    }
                                }
                                function S() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                                    if (!d.getActiveStream()) return !1;
                                    var t = Object.keys(g).some(function(e) {
                                        return g[e];
                                    }), r = !!e && w();
                                    return !t && n.get().streaming.gaps.jumpGaps && d.getActiveStreamProcessors().length > 0 && (!c.isSeeking() || r) && !c.isPaused() && !d.getIsStreamSwitchInProgress() && !d.getHasMediaOrInitialisationError();
                                }
                                function w() {
                                    var e = d.getActiveStream(), t = parseFloat((e.getStartTime() + e.getDuration()).toFixed(5));
                                    return c.getTime() + n.get().streaming.gaps.threshold >= t;
                                }
                                function I(e, t) {
                                    try {
                                        if (!e || e.length <= 1 && t > 0) return NaN;
                                        for(var r = NaN, i = 0; isNaN(r) && i < e.length;){
                                            var a1 = i > 0 ? e.end(i - 1) : 0;
                                            t < e.start(i) && a1 - t < n.get().streaming.gaps.threshold && (r = i), i += 1;
                                        }
                                        return r;
                                    } catch (e) {
                                        return null;
                                    }
                                }
                                function R(e, t) {
                                    for(var n = 0, r = e.length; n < r; n++)if (t >= e.start(n) && t <= e.end(n)) return !0;
                                    return !1;
                                }
                                function C(e) {
                                    var t, r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], i = n.get().streaming.gaps.enableStallFix, a1 = n.get().streaming.gaps.stallSeek, o = n.get().streaming.gaps.smallGapLimit, s1 = n.get().streaming.gaps.jumpLargeGaps, u = f.getBufferRange(), g = NaN, m = !1;
                                    if (t = I(u, e), !isNaN(t)) {
                                        var v = u.start(t), y = v - e;
                                        y > 0 && (y <= o || s1) && (g = v);
                                    }
                                    var E = c.getTimeToStreamEnd();
                                    if (isNaN(g) && r && isFinite(E) && !isNaN(E) && E < o && (g = parseFloat(c.getStreamEndTime().toFixed(5)), m = !0), i && isNaN(g) && r && isNaN(t) && R(u, e) && (0 === a1 ? (p.warn("Toggle play pause to break stall"), f.pause(), f.play()) : (p.warn("Jumping ".concat(a1, "s to break stall")), g = e + a1)), g > 0 && l !== g && g > e && !h) {
                                        var T = g - e;
                                        if (m) {
                                            var b = d.getStreamForTime(g), A = b && !!b.getPreloaded();
                                            p.warn("Jumping to end of stream because of gap from ".concat(e, " to ").concat(g, ". Gap duration: ").concat(T)), c.seek(g, !0, A);
                                        } else {
                                            var _ = c.getIsDynamic(), S = t > 0 ? u.end(t - 1) : e, w = _ ? 1e3 * Math.max(0, T - .1) : 0;
                                            h = window.setTimeout(function() {
                                                c.seek(g, !0, !0), p.warn("Jumping gap occuring in period ".concat(d.getActiveStream().getStreamId(), " starting at ").concat(S, " and ending at ").concat(g, ". Jumping by: ").concat(g - S)), h = null;
                                            }, w);
                                        }
                                        l = g;
                                    }
                                }
                                return e = {
                                    reset: y,
                                    setConfig: function(e) {
                                        e && (e.settings && (n = e.settings), e.playbackController && (c = e.playbackController), e.streamController && (d = e.streamController), e.videoModel && (f = e.videoModel));
                                    },
                                    initialize: function() {
                                        !function() {
                                            v.on(a1.default.WALLCLOCK_TIME_UPDATED, _, this), v.on(a1.default.INITIAL_STREAM_SWITCH, A, this), v.on(a1.default.PLAYBACK_SEEKING, E, this), v.on(a1.default.BUFFER_REPLACEMENT_STARTED, T, e), v.on(a1.default.TRACK_CHANGE_RENDERED, b, e);
                                        }();
                                    }
                                }, p = Object(i.default)(m).getInstance().getLogger(e), y(), e;
                            }
                            u.__dashjs_factory_name = "GapController", t.default = r.default.getSingletonFactory(u);
                        },
                        "./src/streaming/controllers/MediaController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/Constants.js"), i = n("./src/core/events/Events.js"), a1 = n("./src/core/EventBus.js"), o = n("./src/core/FactoryMaker.js"), s1 = n("./src/core/Debug.js"), u = n("./node_modules/bcp-47-normalize/index.js"), l = n.n(u), c = n("./node_modules/bcp-47-match/index.js");
                            function d() {
                                var e, t, n, o, u, d, f, h, g = this.context, p = Object(a1.default)(g).getInstance();
                                function m(e, t) {
                                    return e && n[t] && n[t][e] ? n[t][e].list : [];
                                }
                                function v(e, t) {
                                    return e && n[t] && n[t][e] ? n[t][e].current : null;
                                }
                                function y(e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                                    if (e && e.streamInfo) {
                                        var a1 = e.type, s1 = e.streamInfo, u = s1.id, l = v(a1, u);
                                        if (n[u] && n[u][a1] && (n[u][a1].current = e, n[u][a1].current && (a1 !== r.default.TEXT && !b(e, l) || a1 === r.default.TEXT && e.isFragmented) && p.trigger(i.default.CURRENT_TRACK_CHANGED, {
                                            oldMediaInfo: l,
                                            newMediaInfo: e,
                                            switchMode: o.get().streaming.trackSwitchMode[a1]
                                        }, {
                                            streamId: u
                                        }), !t)) {
                                            var c = _(e);
                                            if (!c || !n[u][a1].storeLastSettings) return;
                                            c.roles && (c.role = c.roles[0], delete c.roles), c.accessibility && (c.accessibility = c.accessibility[0]), c.audioChannelConfiguration && (c.audioChannelConfiguration = c.audioChannelConfiguration[0]), d[a1] = c, h.setSavedMediaSettings(a1, c);
                                        }
                                    }
                                }
                                function E(e, t) {
                                    e && t && (u[e] = t);
                                }
                                function T(e) {
                                    return e ? u[e] : null;
                                }
                                function b(e, t) {
                                    if (!e && !t) return !0;
                                    if (!e || !t) return !1;
                                    var n = e.id === t.id, r = e.viewpoint === t.viewpoint, i = e.lang === t.lang, a1 = e.codec === t.codec, o = e.roles.toString() === t.roles.toString(), s1 = e.accessibility.toString() === t.accessibility.toString(), u = e.audioChannelConfiguration.toString() === t.audioChannelConfiguration.toString();
                                    return n && a1 && r && i && o && s1 && u;
                                }
                                function A() {
                                    n = {}, d = {}, u = {
                                        audio: null,
                                        video: null,
                                        text: null
                                    };
                                }
                                function _(e) {
                                    var t = {
                                        lang: e.lang,
                                        viewpoint: e.viewpoint,
                                        roles: e.roles,
                                        accessibility: e.accessibility,
                                        audioChannelConfiguration: e.audioChannelConfiguration
                                    };
                                    return t.lang || t.viewpoint || t.role && t.role.length > 0 || t.accessibility && t.accessibility.length > 0 || t.audioChannelConfiguration && t.audioChannelConfiguration.length > 0 ? t : null;
                                }
                                function S(e, t, n) {
                                    var r = [];
                                    return e.forEach(function(e) {
                                        t(n, e) && r.push(e);
                                    }), 0 !== r.length ? r : e;
                                }
                                function w(e, t) {
                                    return !e.lang || e.lang instanceof RegExp ? t.lang.match(e.lang) : "" !== t.lang && Object(c.extendedFilter)(t.lang, l()(e.lang)).length > 0;
                                }
                                function I(e, t) {
                                    return void 0 === e.index || null === e.index || t.index === e.index;
                                }
                                function R(e, t) {
                                    return !e.viewpoint || e.viewpoint === t.viewpoint;
                                }
                                function C(e, t) {
                                    var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], i = !e.role || !!t.roles.filter(function(t) {
                                        return t === e.role;
                                    })[0];
                                    return i || t.type === r.default.AUDIO && n;
                                }
                                function D(e, t) {
                                    return e.accessibility ? !!t.accessibility.filter(function(t) {
                                        return t === e.accessibility;
                                    })[0] : !t.accessibility.length;
                                }
                                function k(e, t) {
                                    return !e.audioChannelConfiguration || !!t.audioChannelConfiguration.filter(function(t) {
                                        return t === e.audioChannelConfiguration;
                                    })[0];
                                }
                                function N(e) {
                                    var t, n = 0, r = [];
                                    return e.forEach(function(e) {
                                        (t = Math.max.apply(Math, e.bitrateList.map(function(e) {
                                            return e.bandwidth;
                                        }))) > n ? (n = t, r = [
                                            e
                                        ]) : t === n && r.push(e);
                                    }), r;
                                }
                                function L(e) {
                                    var t, n = 1 / 0, r = [];
                                    return e.forEach(function(e) {
                                        var i = e.bitrateList.reduce(function(e, t) {
                                            var n = Math.max(1, t.width * t.height);
                                            return e + t.bandwidth / n;
                                        }, 0);
                                        (t = i / e.bitrateList.length) < n ? (n = t, r = [
                                            e
                                        ]) : t === n && r.push(e);
                                    }), r;
                                }
                                function x(e) {
                                    var t, n = 0, r = [];
                                    return e.forEach(function(e) {
                                        (t = e.representationCount) > n ? (n = t, r = [
                                            e
                                        ]) : t === n && r.push(e);
                                    }), r;
                                }
                                function M(e, n) {
                                    if (e === r.default.TEXT) return n[0];
                                    var i, a1 = o.get().streaming.selectionModeForInitialTrack, s1 = f.getCustomInitialTrackSelectionFunction();
                                    if (s1 && "function" == typeof s1) i = s1(n);
                                    else switch(a1){
                                        case r.default.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY:
                                            i = function(e) {
                                                var t, n, r = (t = 0, n = [], e.forEach(function(e) {
                                                    isNaN(e.selectionPriority) || (e.selectionPriority > t ? (t = e.selectionPriority, n = [
                                                        e
                                                    ]) : e.selectionPriority === t && n.push(e));
                                                }), n);
                                                return r.length > 1 && (r = N(r)), r.length > 1 && (r = x(r)), r;
                                            }(n);
                                            break;
                                        case r.default.TRACK_SELECTION_MODE_HIGHEST_BITRATE:
                                            i = function(e) {
                                                var t = N(e);
                                                return t.length > 1 && (t = x(t)), t;
                                            }(n);
                                            break;
                                        case r.default.TRACK_SELECTION_MODE_FIRST_TRACK:
                                            i = O(n);
                                            break;
                                        case r.default.TRACK_SELECTION_MODE_HIGHEST_EFFICIENCY:
                                            i = function(e) {
                                                var t = L(e);
                                                return t.length > 1 && (t = N(t)), t;
                                            }(n);
                                            break;
                                        case r.default.TRACK_SELECTION_MODE_WIDEST_RANGE:
                                            i = function(e) {
                                                var t = x(e);
                                                return t.length > 1 && (t = N(e)), t;
                                            }(n);
                                            break;
                                        default:
                                            t.warn("Track selection mode ".concat(a1, " is not supported. Falling back to TRACK_SELECTION_MODE_FIRST_TRACK")), i = O(n);
                                    }
                                    return i.length > 0 ? i[0] : n[0];
                                }
                                function O(e) {
                                    return e[0];
                                }
                                return e = {
                                    setInitialMediaSettingsForType: function(e, t) {
                                        var n = d[e] || T(e), i = m(e, t.id), a1 = [];
                                        n || E(e, n = h.getSavedMediaSettings(e)), i && 0 !== i.length && (n && (a1 = S(a1 = Array.from(i), w, n), a1 = S(a1, I, n), a1 = S(a1, R, n), e === r.default.AUDIO && d[e] || (a1 = S(a1, C, n)), a1 = S(a1, D, n), a1 = S(a1, k, n)), 0 === a1.length ? y(M(e, i), !0) : a1.length > 1 ? y(M(e, a1, d[e])) : y(a1[0]));
                                    },
                                    addTrack: function(e) {
                                        if (e) {
                                            var t = e.type;
                                            if ((i = t) === r.default.AUDIO || i === r.default.VIDEO || i === r.default.TEXT || i === r.default.IMAGE) {
                                                var i, a1 = e.streamInfo.id;
                                                n[a1] || (n[a1] = {
                                                    audio: {
                                                        list: [],
                                                        storeLastSettings: !0,
                                                        current: null
                                                    },
                                                    video: {
                                                        list: [],
                                                        storeLastSettings: !0,
                                                        current: null
                                                    },
                                                    text: {
                                                        list: [],
                                                        storeLastSettings: !0,
                                                        current: null
                                                    },
                                                    image: {
                                                        list: [],
                                                        storeLastSettings: !0,
                                                        current: null
                                                    }
                                                });
                                                for(var o = n[a1][t].list, s1 = 0, u = o.length; s1 < u; ++s1)if (b(o[s1], e)) return;
                                                o.push(e);
                                            }
                                        }
                                    },
                                    getTracksFor: m,
                                    getCurrentTrackFor: v,
                                    isCurrentTrack: function(e) {
                                        if (!e) return !1;
                                        var t = e.type, r = e.streamInfo.id;
                                        return n[r] && n[r][t] && b(n[r][t].current, e);
                                    },
                                    setTrack: y,
                                    selectInitialTrack: M,
                                    setInitialSettings: E,
                                    getInitialSettings: T,
                                    getTracksWithHighestBitrate: N,
                                    getTracksWithHighestEfficiency: L,
                                    getTracksWithWidestRange: x,
                                    isTracksEqual: b,
                                    matchSettings: function(e, t) {
                                        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                                        try {
                                            var i = !1;
                                            if (e.lang) {
                                                if (e.lang instanceof RegExp) i = t.lang.match(e.lang);
                                                else if ("" !== t.lang) {
                                                    var a1 = l()(e.lang);
                                                    a1 && (i = Object(c.extendedFilter)(t.lang, a1).length > 0);
                                                }
                                            } else i = !0;
                                            var o = void 0 === e.index || null === e.index || t.index === e.index, s1 = !e.viewpoint || e.viewpoint === t.viewpoint, u = !e.role || !!t.roles.filter(function(t) {
                                                return t === e.role;
                                            })[0], d = !e.accessibility || !!t.accessibility.filter(function(t) {
                                                return t === e.accessibility;
                                            })[0], f = !e.audioChannelConfiguration || !!t.audioChannelConfiguration.filter(function(t) {
                                                return t === e.audioChannelConfiguration;
                                            })[0];
                                            return i && o && s1 && (u || t.type === r.default.AUDIO && n) && d && f;
                                        } catch (e) {
                                            return !1;
                                        }
                                    },
                                    matchSettingsLang: w,
                                    matchSettingsIndex: I,
                                    matchSettingsViewPoint: R,
                                    matchSettingsRole: C,
                                    matchSettingsAccessibility: D,
                                    matchSettingsAudioChannelConfig: k,
                                    saveTextSettingsDisabled: function() {
                                        h.setSavedMediaSettings(r.default.TEXT, null);
                                    },
                                    setConfig: function(e) {
                                        e && (e.domStorage && (h = e.domStorage), e.settings && (o = e.settings), e.customParametersModel && (f = e.customParametersModel));
                                    },
                                    reset: A
                                }, t = Object(s1.default)(g).getInstance().getLogger(e), A(), e;
                            }
                            d.__dashjs_factory_name = "MediaController";
                            var f = o.default.getSingletonFactory(d);
                            o.default.updateSingletonFactory(d.__dashjs_factory_name, f), t.default = f;
                        },
                        "./src/streaming/controllers/MediaSourceController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/core/Debug.js");
                            function a1() {
                                var e, t, n, r = this.context;
                                return e = {
                                    createMediaSource: function() {
                                        var e = "WebKitMediaSource" in window;
                                        return "MediaSource" in window ? t = new MediaSource : e && (t = new WebKitMediaSource), t;
                                    },
                                    attachMediaSource: function(e) {
                                        var n = window.URL.createObjectURL(t);
                                        return e.setSource(n), n;
                                    },
                                    detachMediaSource: function(e) {
                                        e.setSource(null);
                                    },
                                    setDuration: function e(r) {
                                        t && "open" === t.readyState && (null === r && isNaN(r) || t.duration !== r && (function(e) {
                                            for(var t = e.sourceBuffers, n = 0; n < t.length; n++)if (t[n].updating) return !0;
                                            return !1;
                                        }(t) ? setTimeout(e.bind(null, r), 50) : (n.info("Set MediaSource duration:" + r), t.duration = r)));
                                    },
                                    setSeekable: function(e, n) {
                                        t && "function" == typeof t.setLiveSeekableRange && "function" == typeof t.clearLiveSeekableRange && "open" === t.readyState && e >= 0 && e < n && (t.clearLiveSeekableRange(), t.setLiveSeekableRange(e, n));
                                    },
                                    signalEndOfStream: function(e) {
                                        if (e && "open" === e.readyState) {
                                            for(var t = e.sourceBuffers, r = 0; r < t.length; r++){
                                                if (t[r].updating) return;
                                                if (0 === t[r].buffered.length) return;
                                            }
                                            n.info("call to mediaSource endOfStream"), e.endOfStream();
                                        }
                                    }
                                }, n = Object(i.default)(r).getInstance().getLogger(e), e;
                            }
                            a1.__dashjs_factory_name = "MediaSourceController", t.default = r.default.getSingletonFactory(a1);
                        },
                        "./src/streaming/controllers/PlaybackController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/Constants.js"), i = n("./src/core/EventBus.js"), a1 = n("./src/core/events/Events.js"), o = n("./src/core/FactoryMaker.js"), s1 = n("./src/core/Debug.js"), u = n("./src/streaming/MediaPlayerEvents.js"), l = n("./src/streaming/constants/MetricsConstants.js");
                            function c() {
                                var e, t, n, o, c, d, f, h, g, p, m, v, y, E, T, b, A, _, S, w, I, R, C, D, k = this.context, N = Object(i.default)(k).getInstance();
                                function L() {
                                    P(), E = !1, p = 0, m = 0, b = 0, R = !1, A = !0, _ = !1, C = !1, S = NaN, f && (N.off(a1.default.DATA_UPDATE_COMPLETED, J, e), N.off(a1.default.LOADING_PROGRESS, me, e), N.off(a1.default.MANIFEST_UPDATED, Te, e), N.off(a1.default.STREAMS_COMPOSED, be, e), N.off(u.default.PLAYBACK_ENDED, ge, e), N.off(u.default.STREAM_INITIALIZING, ye, e), N.off(u.default.REPRESENTATION_SWITCH, Ee, e), N.off(u.default.BUFFER_LEVEL_STATE_CHANGED, ee, e), Q(), f.removeEventListener("canplay", Z), f.removeEventListener("canplaythrough", $), f.removeEventListener("play", te), f.removeEventListener("waiting", ne), f.removeEventListener("playing", re), f.removeEventListener("pause", ie), f.removeEventListener("error", pe), f.removeEventListener("seeking", ae), f.removeEventListener("seeked", oe), f.removeEventListener("timeupdate", se), f.removeEventListener("progress", ue), f.removeEventListener("ratechange", le), f.removeEventListener("loadedmetadata", ce), f.removeEventListener("loadeddata", de), f.removeEventListener("stalled", ve), f.removeEventListener("ended", fe), f.removeEventListener("volumechange", he)), g = null, f = null, v = null, y = null;
                                }
                                function x() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                                    return parseFloat((M(e) - B()).toFixed(5));
                                }
                                function M(e) {
                                    var t = e || v;
                                    return t.start + t.duration;
                                }
                                function O() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                                    v && f && f.getElement() ? (e && y && j(B()), f.play()) : E = !0;
                                }
                                function P() {
                                    v && f && f.pause();
                                }
                                function F(e) {
                                    var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                                    if (v && f) {
                                        var a1 = isNaN(S) ? f.getTime() : S;
                                        e !== a1 && ((w = !0 === r) || (S = e), t.info("Requesting seek to time: " + e + (w ? " (internal)" : "")), y && i && j(e), f.setCurrentTime(e, n));
                                    }
                                }
                                function U() {
                                    if (v && f && y) {
                                        var e = n && n.hasVideoTrack() ? r.default.VIDEO : r.default.AUDIO, t = c.getCurrentDVRInfo(e);
                                        return t && t.range ? t.range.end : 0;
                                    }
                                }
                                function j(e) {
                                    var t = new Date(h.getClientReferenceTime()), n = d.getRegularPeriods()[0], r = h.calcPresentationTimeFromWallTime(t, n);
                                    p = r - e;
                                }
                                function B() {
                                    return v && f ? f.getTime() : null;
                                }
                                function G() {
                                    return v && f ? f.isPaused() : null;
                                }
                                function H() {
                                    return v && f ? f.isSeeking() : null;
                                }
                                function V() {
                                    return v && f ? f.isStalled() : null;
                                }
                                function K() {
                                    return v && f ? f.getPlaybackRate() : null;
                                }
                                function q() {
                                    return v && f ? f.getEnded() : null;
                                }
                                function Y() {
                                    return y;
                                }
                                function W() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                                    if (!G() && y && 0 !== f.getReadyState() && !H() && !R) {
                                        e || (e = n.hasVideoTrack() ? r.default.VIDEO : r.default.AUDIO);
                                        var i = B(), a1 = z(i, e), o = !isNaN(a1) && a1 !== i;
                                        o && !H() && (V() || I || 1 === f.getReadyState()) && (t.debug("UpdateCurrentTime: Seek to actual time: ".concat(a1, " from currentTime: ").concat(i)), F(a1, !1, !1));
                                    }
                                }
                                function z(e, t) {
                                    var n = c.getCurrentDVRInfo(t), r = n ? n.range : null;
                                    return r ? e > r.end ? Math.max(r.end - p, r.start) : e > 0 && e + .25 < r.start && Math.abs(e - r.start) < 31536e4 ? _ ? Math.max(r.end - p, r.start) : r.start : e : NaN;
                                }
                                function X() {
                                    null === g && (g = setInterval(function() {
                                        var e;
                                        N.trigger(a1.default.WALLCLOCK_TIME_UPDATED, {
                                            isDynamic: y,
                                            time: new Date
                                        }), Y() && (n.addDVRMetric(), G() ? (e = Date.now(), (!T || e > T + 500) && (T = e, se())) : W());
                                    }, D.get().streaming.wallclockTimeUpdateInterval));
                                }
                                function Q() {
                                    clearInterval(g), g = null;
                                }
                                function J(e) {
                                    var t = d.convertRepresentationToRepresentationInfo(e.currentRepresentation), n = t ? t.mediaInfo.streamInfo : null;
                                    null !== n && v.id === n.id && (v = n);
                                }
                                function Z() {
                                    N.trigger(a1.default.CAN_PLAY);
                                }
                                function $() {
                                    N.trigger(a1.default.CAN_PLAY_THROUGH);
                                }
                                function ee(e) {
                                    e.streamId === n.getActiveStreamInfo().id && (I = e.state === l.default.BUFFER_EMPTY, D.get().streaming.buffer.setStallState && f.setStallState(e.mediaType, e.state === l.default.BUFFER_EMPTY));
                                }
                                function te() {
                                    t.info("Native video element event: play"), W(), X(), N.trigger(a1.default.PLAYBACK_STARTED, {
                                        startTime: B()
                                    });
                                }
                                function ne() {
                                    t.info("Native video element event: waiting"), N.trigger(a1.default.PLAYBACK_WAITING, {
                                        playingTime: B()
                                    });
                                }
                                function re() {
                                    t.info("Native video element event: playing"), w = !1, N.trigger(a1.default.PLAYBACK_PLAYING, {
                                        playingTime: B()
                                    });
                                }
                                function ie() {
                                    t.info("Native video element event: pause"), N.trigger(a1.default.PLAYBACK_PAUSED, {
                                        ended: q()
                                    });
                                }
                                function ae() {
                                    if (!w) {
                                        var e = B();
                                        isNaN(S) || S === e || (e = S), S = NaN, t.info("Seeking to: " + e), X(), N.trigger(a1.default.PLAYBACK_SEEKING, {
                                            seekTime: e,
                                            streamId: v.id
                                        });
                                    }
                                }
                                function oe() {
                                    t.info("Native video element event: seeked"), w = !1, N.trigger(a1.default.PLAYBACK_SEEKED);
                                }
                                function se() {
                                    v && N.trigger(a1.default.PLAYBACK_TIME_UPDATED, {
                                        timeToEnd: x(),
                                        time: B(),
                                        streamId: v.id
                                    });
                                }
                                function ue() {
                                    N.trigger(a1.default.PLAYBACK_PROGRESS, {
                                        streamId: v.id
                                    });
                                }
                                function le() {
                                    var e = K();
                                    t.info("Native video element event: ratechange: ", e), N.trigger(a1.default.PLAYBACK_RATE_CHANGED, {
                                        playbackRate: e
                                    });
                                }
                                function ce() {
                                    t.info("Native video element event: loadedmetadata"), N.trigger(a1.default.PLAYBACK_METADATA_LOADED), X();
                                }
                                function de() {
                                    t.info("Native video element event: loadeddata"), N.trigger(a1.default.PLAYBACK_LOADED_DATA);
                                }
                                function fe() {
                                    t.info("Native video element event: ended"), P(), Q();
                                    var e = n ? n.getActiveStreamInfo() : null;
                                    e && N.trigger(a1.default.PLAYBACK_ENDED, {
                                        isLast: e.isLast
                                    });
                                }
                                function he() {
                                    N.trigger(a1.default.PLAYBACK_VOLUME_CHANGED);
                                }
                                function ge(e) {
                                    if (g && e.isLast) {
                                        t.info("onPlaybackEnded -- PLAYBACK_ENDED but native video element didn't fire ended");
                                        var n = e.seekTime ? e.seekTime : M();
                                        f.setCurrentTime(n), P(), Q();
                                    }
                                }
                                function pe(e) {
                                    var t = e.target || e.srcElement;
                                    N.trigger(a1.default.PLAYBACK_ERROR, {
                                        error: t.error
                                    });
                                }
                                function me(e) {
                                    if (!1 === e.stream && _ && !isNaN(e.request.duration)) {
                                        var n = 1.2 * e.request.duration;
                                        n > p && (t.warn("Browser does not support fetch API with StreamReader. Increasing live delay to be 20% higher than segment duration:", n.toFixed(2)), p = n, m = n);
                                    }
                                }
                                function ve(e) {
                                    N.trigger(a1.default.PLAYBACK_STALLED, {
                                        e
                                    });
                                }
                                function ye(e) {
                                    var n;
                                    (n = e.mediaInfo) && n.supplementalProperties && "true" === n.supplementalProperties[r.default.SUPPLEMENTAL_PROPERTY_DVB_LL_SCHEME] && (t.debug("Low Latency critical SupplementalProperty set: Enabling low Latency"), _ = !0);
                                }
                                function Ee(e) {
                                    var t = n.getActiveStreamInfo();
                                    e && t && e.currentRepresentation && e.streamId && e.streamId === t.id && e.mediaType && (e.mediaType === r.default.VIDEO || e.mediaType === r.default.AUDIO) && (A = e.currentRepresentation.availabilityTimeComplete, (_ = !A) && !C && (C = !0));
                                }
                                function Te() {
                                    R = !0;
                                }
                                function be() {
                                    R = !1;
                                }
                                return e = {
                                    initialize: function(t, n) {
                                        v = t, !0 !== n && (f.addEventListener("canplay", Z), f.addEventListener("canplaythrough", $), f.addEventListener("play", te), f.addEventListener("waiting", ne), f.addEventListener("playing", re), f.addEventListener("pause", ie), f.addEventListener("error", pe), f.addEventListener("seeking", ae), f.addEventListener("seeked", oe), f.addEventListener("timeupdate", se), f.addEventListener("progress", ue), f.addEventListener("ratechange", le), f.addEventListener("loadedmetadata", ce), f.addEventListener("loadeddata", de), f.addEventListener("stalled", ve), f.addEventListener("ended", fe), f.addEventListener("volumechange", he), y = v.manifestInfo.isDynamic, I = !1, w = !1, N.on(a1.default.DATA_UPDATE_COMPLETED, J, e), N.on(a1.default.LOADING_PROGRESS, me, e), N.on(a1.default.MANIFEST_UPDATED, Te, e), N.on(a1.default.STREAMS_COMPOSED, be, e), N.on(u.default.PLAYBACK_ENDED, ge, e, {
                                            priority: i.default.EVENT_PRIORITY_HIGH
                                        }), N.on(u.default.STREAM_INITIALIZING, ye, e), N.on(u.default.REPRESENTATION_SWITCH, Ee, e), N.on(u.default.BUFFER_LEVEL_STATE_CHANGED, ee, e), E && (E = !1, O()));
                                    },
                                    setConfig: function(e) {
                                        e && (e.streamController && (n = e.streamController), e.serviceDescriptionController && (o = e.serviceDescriptionController), e.dashMetrics && (c = e.dashMetrics), e.adapter && (d = e.adapter), e.videoModel && (f = e.videoModel), e.timelineConverter && (h = e.timelineConverter), e.settings && (D = e.settings));
                                    },
                                    getTimeToStreamEnd: x,
                                    getBufferLevel: function() {
                                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = null;
                                        return n.getActiveStreamProcessors().forEach(function(n) {
                                            if (!e || 0 === e.length || -1 === e.indexOf(n.getType())) {
                                                var r = n.getBufferLevel();
                                                t = null === t ? r : Math.min(t, r);
                                            }
                                        }), t;
                                    },
                                    getPlaybackStalled: function() {
                                        return I;
                                    },
                                    getTime: B,
                                    getLowLatencyModeEnabled: function() {
                                        return _;
                                    },
                                    getInitialCatchupModeActivated: function() {
                                        return C;
                                    },
                                    getIsManifestUpdateInProgress: function() {
                                        return R;
                                    },
                                    getPlaybackRate: K,
                                    getPlayedRanges: function() {
                                        return v && f ? f.getPlayedRanges() : null;
                                    },
                                    getEnded: q,
                                    getIsDynamic: Y,
                                    getStreamController: function() {
                                        return n;
                                    },
                                    computeAndSetLiveDelay: function(e, t) {
                                        var n, r, i, a1 = !isNaN(e) && isFinite(e) ? e : NaN, s1 = d.getSuggestedPresentationDelay(), u = o.getServiceDescriptionSettings();
                                        return n = isNaN(D.get().streaming.delay.liveDelay) ? null === D.get().streaming.delay.liveDelayFragmentCount || isNaN(D.get().streaming.delay.liveDelayFragmentCount) || isNaN(a1) ? u && !isNaN(u.liveDelay) && u.liveDelay > 0 ? u.liveDelay : !0 === D.get().streaming.delay.useSuggestedPresentationDelay && null !== s1 && !isNaN(s1) && s1 > 0 ? s1 : isNaN(a1) ? t && !isNaN(t.minBufferTime) ? 4 * t.minBufferTime : 4 * v.manifestInfo.minBufferTime : 4 * a1 : a1 * D.get().streaming.delay.liveDelayFragmentCount : D.get().streaming.delay.liveDelay, null !== (i = d.getAvailabilityStartTime()) && (b = i), r = t && t.dvrWindowSize > 0 ? Math.min(n, t.dvrWindowSize) : n, p = r, m = r, r;
                                    },
                                    getLiveDelay: function() {
                                        return p;
                                    },
                                    getOriginalLiveDelay: function() {
                                        return m;
                                    },
                                    getCurrentLiveLatency: function() {
                                        if (!y || isNaN(b)) return NaN;
                                        var e = B();
                                        if (isNaN(e) || 0 === e) return 0;
                                        var t = (new Date).getTime() + 1e3 * h.getClientTimeOffset();
                                        return Math.max(((t - b - 1e3 * e) / 1e3).toFixed(3), 0);
                                    },
                                    play: O,
                                    isPaused: G,
                                    isStalled: V,
                                    pause: P,
                                    isSeeking: H,
                                    getStreamEndTime: M,
                                    seek: F,
                                    seekToOriginalLive: function() {
                                        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = U();
                                        if (0 !== r) {
                                            var i = r - (p = m);
                                            F(i, e, t, n);
                                        }
                                    },
                                    seekToCurrentLive: function() {
                                        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = U();
                                        if (0 !== r) {
                                            var i = r - p;
                                            F(i, e, t, n);
                                        }
                                    },
                                    reset: L,
                                    updateCurrentTime: W,
                                    getAvailabilityStartTime: function() {
                                        return b;
                                    }
                                }, t = Object(s1.default)(k).getInstance().getLogger(e), L(), e;
                            }
                            c.__dashjs_factory_name = "PlaybackController", t.default = o.default.getSingletonFactory(c);
                        },
                        "./src/streaming/controllers/ScheduleController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/Constants.js"), i = n("./src/streaming/models/FragmentModel.js"), a1 = n("./src/core/EventBus.js"), o = n("./src/core/events/Events.js"), s1 = n("./src/core/FactoryMaker.js"), u = n("./src/core/Debug.js"), l = n("./src/streaming/constants/MetricsConstants.js"), c = n("./src/streaming/MediaPlayerEvents.js");
                            function d(e) {
                                e = e || {};
                                var t, n, s1, d, f, h, g, p, m, v, y, E, T, b = this.context, A = Object(a1.default)(b).getInstance(), _ = e.dashMetrics, S = e.mediaPlayerModel, w = e.fragmentModel, I = e.abrController, R = e.playbackController, C = e.textController, D = e.type, k = e.bufferController, N = e.settings;
                                function L(e) {
                                    if (!k.getIsBufferingCompleted()) {
                                        x();
                                        var t = isNaN(e) ? 0 : e;
                                        h = setTimeout(M, t);
                                    }
                                }
                                function x() {
                                    h && (clearTimeout(h), h = null);
                                }
                                function M() {
                                    try {
                                        if (function() {
                                            try {
                                                return D === r.default.TEXT && !C.isTextEnabled() || R.isPaused() && (!R.getStreamController().getInitialPlayback() || !R.getStreamController().getAutoPlay()) && !N.get().streaming.scheduling.scheduleWhilePaused;
                                            } catch (e) {
                                                return !1;
                                            }
                                        }()) return void x();
                                        if (function() {
                                            try {
                                                return d && (isNaN(v) || y || (e = n.id, t = I.getMaxAllowedIndexFor(D, e), !(!isNaN(m) && m == t || (s1.info("Top quality " + D + " index has changed from " + m + " to " + t), m = t, 0))) || !D || !d || _.getCurrentBufferLevel(D) < O());
                                            } catch (e) {
                                                return !1;
                                            }
                                            var e, t;
                                        }()) {
                                            var e = !1;
                                            T && (e = I.checkPlaybackQuality(D, n.id)), e || (E || d.quality !== v || y ? (y ? (s1.debug("Switch track for " + D + ", representation id = " + d.id), y = !1) : s1.debug("Quality has changed, get init request for representationid = " + d.id), A.trigger(o.default.INIT_FRAGMENT_NEEDED, {
                                                representationId: d.id,
                                                sender: t
                                            }, {
                                                streamId: n.id,
                                                mediaType: D
                                            }), T = !1, E = !1) : (s1.debug("Media segment needed for ".concat(D, " and stream id ").concat(n.id)), A.trigger(o.default.MEDIA_FRAGMENT_NEEDED, {}, {
                                                streamId: n.id,
                                                mediaType: D
                                            }), T = !0));
                                        } else L(R.getLowLatencyModeEnabled() ? N.get().streaming.scheduling.lowLatencyTimeout : N.get().streaming.scheduling.defaultTimeout);
                                    } catch (e) {
                                        L(R.getLowLatencyModeEnabled() ? N.get().streaming.scheduling.lowLatencyTimeout : N.get().streaming.scheduling.defaultTimeout);
                                    }
                                }
                                function O() {
                                    var e = NaN;
                                    return D && d ? e = D === r.default.TEXT ? function() {
                                        try {
                                            if (C.isTextEnabled()) {
                                                if (isNaN(d.fragmentDuration)) {
                                                    var e = _.getCurrentSchedulingInfo(l.default.SCHEDULING_INFO);
                                                    return e ? e.duration : 0;
                                                }
                                                return d.fragmentDuration;
                                            }
                                            return 0;
                                        } catch (e) {
                                            return 0;
                                        }
                                    }() : D === r.default.AUDIO && g ? function() {
                                        try {
                                            var e = _.getCurrentBufferLevel(r.default.VIDEO);
                                            return isNaN(d.fragmentDuration) ? e + 1 : Math.max(e + 1, d.fragmentDuration);
                                        } catch (e) {
                                            return 0;
                                        }
                                    }() : function() {
                                        try {
                                            var e = d.mediaInfo.streamInfo;
                                            return I.isPlayingAtTopQuality(e) ? e.manifestInfo.duration >= N.get().streaming.buffer.longFormContentDurationThreshold ? N.get().streaming.buffer.bufferTimeAtTopQualityLongForm : N.get().streaming.buffer.bufferTimeAtTopQuality : S.getStableBufferTime();
                                        } catch (e) {
                                            return S.getStableBufferTime();
                                        }
                                    }() : e;
                                }
                                function P() {
                                    F(!0);
                                }
                                function F(e) {
                                    if (R && w) {
                                        var t = w.getRequests({
                                            state: i.default.FRAGMENT_MODEL_EXECUTED,
                                            time: R.getTime(),
                                            threshold: 0
                                        })[0];
                                        t && R.getTime() >= t.startTime && ((!p.mediaInfo || t.mediaInfo.type === p.mediaInfo.type && t.mediaInfo.id !== p.mediaInfo.id) && e && A.trigger(o.default.TRACK_CHANGE_RENDERED, {
                                            mediaType: D,
                                            oldMediaInfo: p.mediaInfo,
                                            newMediaInfo: t.mediaInfo,
                                            streamId: n.id
                                        }), t.quality === p.quality && t.adaptationIndex === p.adaptationIndex || !e || (s1.debug("Quality change rendered for streamId ".concat(n.id, " and type ").concat(D)), A.trigger(o.default.QUALITY_CHANGE_RENDERED, {
                                            mediaType: D,
                                            oldQuality: p.quality,
                                            newQuality: t.quality,
                                            streamId: n.id
                                        })), p = {
                                            mediaInfo: t.mediaInfo,
                                            quality: t.quality,
                                            adaptationIndex: t.adaptationIndex
                                        });
                                    }
                                }
                                function U(e) {
                                    s1.debug("Appended bytes for ".concat(e.mediaType, " and stream id ").concat(n.id)), (isNaN(e.index) || isNaN(v)) && (v = e.quality, s1.info("[" + D + "] lastInitializedRepresentationInfo changed to " + e.quality)), L(0);
                                }
                                function j() {
                                    w.abortRequests(), x();
                                }
                                function B() {
                                    N.get().streaming.scheduling.scheduleWhilePaused || L();
                                }
                                function G(e) {
                                    _.updatePlayListTraceMetrics({
                                        playbackspeed: e.playbackRate.toString()
                                    });
                                }
                                function H() {
                                    T = !0, f = 0, v = NaN, p = {
                                        mediaInfo: void 0,
                                        quality: NaN,
                                        adaptationIndex: NaN
                                    }, m = NaN, y = !1, E = !1;
                                }
                                return t = {
                                    initialize: function(e) {
                                        g = e, A.on(o.default.BYTES_APPENDED_END_FRAGMENT, U, t), A.on(o.default.URL_RESOLUTION_FAILED, j, t), A.on(c.default.PLAYBACK_STARTED, B, t), A.on(c.default.PLAYBACK_RATE_CHANGED, G, t), A.on(c.default.PLAYBACK_TIME_UPDATED, P, t);
                                    },
                                    getType: function() {
                                        return D;
                                    },
                                    getStreamId: function() {
                                        return n.id;
                                    },
                                    setCurrentRepresentation: function(e) {
                                        d = e;
                                    },
                                    setTimeToLoadDelay: function(e) {
                                        f = e;
                                    },
                                    getTimeToLoadDelay: function() {
                                        return f;
                                    },
                                    setSwitchTrack: function(e) {
                                        y = e;
                                    },
                                    getSwitchStrack: function() {
                                        return y;
                                    },
                                    startScheduleTimer: L,
                                    clearScheduleTimer: x,
                                    reset: function() {
                                        A.off(o.default.BYTES_APPENDED_END_FRAGMENT, U, t), A.off(o.default.URL_RESOLUTION_FAILED, j, t), A.off(c.default.PLAYBACK_STARTED, B, t), A.off(c.default.PLAYBACK_RATE_CHANGED, G, t), A.off(c.default.PLAYBACK_TIME_UPDATED, P, t), x(), F(!1), H(), n = null;
                                    },
                                    getBufferTarget: O,
                                    getPlaybackController: function() {
                                        return R;
                                    },
                                    setCheckPlaybackQuality: function(e) {
                                        T = e;
                                    },
                                    setInitSegmentRequired: function(e) {
                                        E = e;
                                    }
                                }, s1 = Object(u.default)(b).getInstance().getLogger(t), H(), n = e.streamInfo, t;
                            }
                            d.__dashjs_factory_name = "ScheduleController", t.default = s1.default.getClassFactory(d);
                        },
                        "./src/streaming/controllers/StreamController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/Constants.js"), i = n("./src/streaming/constants/MetricsConstants.js"), a1 = n("./src/streaming/Stream.js"), o = n("./src/streaming/ManifestUpdater.js"), s1 = n("./src/core/EventBus.js"), u = n("./src/core/events/Events.js"), l = n("./src/core/FactoryMaker.js"), c = n("./src/streaming/vo/metrics/PlayList.js"), d = n("./src/core/Debug.js"), f = n("./src/streaming/utils/InitCache.js"), h = n("./src/streaming/utils/URLUtils.js"), g = n("./src/streaming/MediaPlayerEvents.js"), p = n("./src/streaming/controllers/TimeSyncController.js"), m = n("./src/streaming/controllers/MediaSourceController.js"), v = n("./src/streaming/vo/DashJSError.js"), y = n("./src/core/errors/Errors.js"), E = n("./src/streaming/controllers/EventController.js"), T = n("./src/streaming/constants/ConformanceViolationConstants.js");
                            function b(e, t) {
                                (null == t || t > e.length) && (t = e.length);
                                for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                                return r;
                            }
                            function A() {
                                var e, t, n, l, A, _, S, w, I, R, C, D, k, N, L, x, M, O, P, F, U, j, B, G, H, V, K, q, Y, W, z, X, Q, J, Z, $, ee, te, ne, re, ie, ae, oe, se, ue, le, ce, de, fe, he = this.context, ge = Object(s1.default)(he).getInstance();
                                function pe() {
                                    if (!(_ && _.hasOwnProperty("load") && j && j.hasOwnProperty("initialize") && j.hasOwnProperty("reset") && j.hasOwnProperty("getClientTimeOffset") && S && U && I && J)) throw new Error(r.default.MISSING_CONFIG_ERROR);
                                }
                                function me() {
                                    if (!A || !A.hasOwnProperty("setManifest")) throw new Error("initialize function has to be called previously");
                                }
                                function ve() {
                                    !function() {
                                        try {
                                            var e = w.getStreamsInfo();
                                            if (!G && 0 === e.length) throw new Error("There are no periods in the MPD");
                                            G && e.length > 0 && I.updateManifestUpdateInfo({
                                                currentTime: J.getTime(),
                                                buffered: Q.getBufferRange(),
                                                presentationStartTime: e[0].start,
                                                clientTimeOffset: j.getClientTimeOffset()
                                            }), B.length > 0 && function(e) {
                                                0 !== e.length ? B = B.filter(function(n) {
                                                    var r = e.filter(function(e) {
                                                        return e.id === n.getId();
                                                    }).length > 0 || n.getId() === G.getId();
                                                    return r || (t.debug("Removing stream ".concat(n.getId())), n.reset(!0)), r;
                                                }) : t.warn("No periods included in the current manifest. Skipping the filtering of outdated stream objects.");
                                            }(e);
                                            for(var n = [], r = 0, i = e.length; r < i; r++){
                                                var a1 = e[r];
                                                n.push(Ee(a1)), I.addManifestUpdateStreamInfo(a1);
                                            }
                                            Promise.all(n).then(function() {
                                                return ue.get().streaming.applyContentSteering && !G && D.shouldQueryBeforeStart() ? D.loadSteeringData() : Promise.resolve();
                                            }).then(function() {
                                                G || Te(e), ge.trigger(u.default.STREAMS_COMPOSED), je();
                                            }).catch(function(e) {
                                                throw e;
                                            });
                                        } catch (e) {
                                            U.error(new v.default(y.default.MANIFEST_ERROR_ID_NOSTREAMS_CODE, e.message + " nostreamscomposed", S.getValue())), z = !0, it();
                                        }
                                    }();
                                }
                                function ye() {
                                    le = !0;
                                }
                                function Ee(e) {
                                    var t = tt(e.id);
                                    return t ? t.updateData(e) : (t = Object(a1.default)(he).create({
                                        manifestModel: S,
                                        mediaPlayerModel: $,
                                        dashMetrics: I,
                                        manifestUpdater: A,
                                        adapter: w,
                                        timelineConverter: j,
                                        capabilities: n,
                                        capabilitiesFilter: l,
                                        errHandler: U,
                                        baseURLController: k,
                                        segmentBaseController: N,
                                        textController: V,
                                        abrController: x,
                                        playbackController: J,
                                        eventController: O,
                                        mediaController: M,
                                        protectionController: H,
                                        videoModel: Q,
                                        streamInfo: e,
                                        settings: ue
                                    }), B.push(t), t.initialize(), Promise.resolve());
                                }
                                function Te(e) {
                                    Ne();
                                    var n = I.getCurrentDVRInfo().range;
                                    if (n.end < n.start) {
                                        ce && clearTimeout(ce);
                                        var r = Math.min(1e3 * (-1 * (n.end - n.start) + 2), 2147483647);
                                        return t.debug("Waiting for ".concat(r, " ms before playback can start")), ge.trigger(u.default.AST_IN_FUTURE, {
                                            delay: r
                                        }), void (ce = setTimeout(function() {
                                            Te(e);
                                        }, r));
                                    }
                                    ue.get().streaming.applyProducerReferenceTime && Z.calculateProducerReferenceTimeOffsets(e);
                                    var i = e[0].manifestInfo;
                                    if (ue.get().streaming.applyServiceDescription && Z.applyServiceDescription(i), w.getIsDynamic()) {
                                        var a1 = We(e, i);
                                        J.computeAndSetLiveDelay(a1, i);
                                    }
                                    var o = function() {
                                        var e;
                                        if (w.getIsDynamic()) {
                                            var n = I.getCurrentDVRInfo();
                                            e = (n && n.range ? n.range.end : 0) - J.getOriginalLiveDelay();
                                            var r = n ? n.range : null;
                                            if (r) {
                                                if (isNaN(de) && -1 === de.toString().indexOf("posix:")) {
                                                    var i = Ke(!0);
                                                    isNaN(i) || (t.info("Start time from URI parameters: ".concat(i)), e = Math.min(e, i));
                                                } else {
                                                    t.info("Start time provided by the app: ".concat(de));
                                                    var a1 = qe(!0, de);
                                                    isNaN(a1) || (e = Math.min(e, a1));
                                                }
                                                var o = ue.get().streaming.timeShiftBuffer.calcFromSegmentTimeline ? .1 : 0;
                                                e = Math.max(e, r.start + o);
                                            }
                                        } else if (e = ot()[0].getStreamInfo().start, isNaN(de)) {
                                            var s1 = Ke(!1);
                                            isNaN(s1) || (t.info("Start time from URI parameters: ".concat(s1)), e = Math.max(e, s1));
                                        } else {
                                            t.info("Start time provided by the app: ".concat(de));
                                            var u = qe(!1, de);
                                            isNaN(u) || (e = Math.max(e, u));
                                        }
                                        return e;
                                    }(), s1 = ke(o), l = null !== s1 ? s1 : B[0];
                                    ge.trigger(u.default.INITIAL_STREAM_SWITCH, {
                                        startTime: o
                                    }), be(l, null, o), ie || (ie = setInterval(function() {
                                        !Y && J.getTimeToStreamEnd() <= 0 && !J.isSeeking() && ge.trigger(u.default.PLAYBACK_ENDED, {
                                            isLast: et().isLast
                                        });
                                    }, 200));
                                }
                                function be(e, n, r) {
                                    try {
                                        if (Y || !e || n === e && e.getIsActive()) return;
                                        Y = !0, ge.trigger(u.default.PERIOD_SWITCH_STARTED, {
                                            fromStreamInfo: n ? n.getStreamInfo() : null,
                                            toStreamInfo: e.getStreamInfo()
                                        });
                                        var i = !1;
                                        G = e, n && (i = Ce(e, n), n.deactivate(i)), r = isNaN(r) ? !i && n ? e.getStreamInfo().start : NaN : r, t.info("Switch to stream ".concat(e.getId(), ". Seektime is ").concat(r, ", current playback time is ").concat(J.getTime(), ". Seamless period switch is set to ").concat(i)), oe = oe.filter(function(e) {
                                            return e.getId() !== G.getId();
                                        }), J.initialize(et(), !!n), Q.getElement() && Ae(r, i);
                                    } catch (e) {
                                        Y = !1;
                                    }
                                }
                                function Ae(e, n) {
                                    var r;
                                    function i() {
                                        if (X && "open" === X.readyState) {
                                            t.debug("MediaSource is open!"), window.URL.revokeObjectURL(r), X.removeEventListener("sourceopen", i), X.removeEventListener("webkitsourceopen", i), Ve();
                                            var a1 = I.getCurrentDVRInfo();
                                            R.setSeekable(a1.range.start, a1.range.end), _e(e, n);
                                        }
                                    }
                                    function a1() {
                                        X.addEventListener("sourceopen", i, !1), X.addEventListener("webkitsourceopen", i, !1), r = R.attachMediaSource(Q), t.debug("MediaSource attached to element.  Waiting on open...");
                                    }
                                    X ? n ? _e(e, n) : (R.detachMediaSource(Q), a1()) : (X = R.createMediaSource(), a1());
                                }
                                function _e(e, t) {
                                    G.activate(X, t ? ae : void 0, e).then(function(t) {
                                        if (t) {
                                            var n = Object.keys(t);
                                            n.length > 0 && t[n[0]].getBuffer().changeType && (se = !0), ae = t;
                                        }
                                        isNaN(e) || (ge.trigger(u.default.SEEK_TARGET, {
                                            time: e
                                        }, {
                                            streamId: G.getId()
                                        }), J.seek(e, !1, !0), G.startScheduleControllers()), Y = !1, ge.trigger(u.default.PERIOD_SWITCH_COMPLETED, {
                                            toStreamInfo: et()
                                        });
                                    });
                                }
                                function Se(e) {
                                    var t = J.getTime(), n = e.seekTime, r = ke(n);
                                    r && r !== G ? r && r !== G && (we(t, n), function(e, t) {
                                        var n = e && !isNaN(e.seekTime) ? e.seekTime : NaN, r = G.getProcessors().map(function(t) {
                                            return t.prepareOuterPeriodPlaybackSeeking(e);
                                        });
                                        Promise.all(r).then(function() {
                                            be(t, G, n);
                                        }).catch(function(e) {
                                            U.error(e);
                                        });
                                    }(e, r)) : (we(t, n), function(e) {
                                        G.getProcessors().forEach(function(t) {
                                            return t.prepareInnerPeriodPlaybackSeeking(e);
                                        }), Je(c.PlayListTrace.USER_REQUEST_STOP_REASON);
                                    }(e)), Ze(c.PlayList.SEEK_START_REASON);
                                }
                                function we(e, t) {
                                    Ie();
                                }
                                function Ie() {
                                    oe && oe.length > 0 && (oe.forEach(function(e) {
                                        e.deactivate(!0);
                                    }), oe = []);
                                }
                                function Re(e) {
                                    e.newMediaInfo.streamInfo.id === G.getId() && (Ie(), G.prepareTrackChange(e));
                                }
                                function Ce(e, t) {
                                    try {
                                        return ue.get().streaming.buffer.reuseExistingSourceBuffers && (t.isProtectionCompatible(e) || le) && (se || t.isMediaCodecCompatible(e, t));
                                    } catch (e) {
                                        return !1;
                                    }
                                }
                                function De(e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                                    if (X && !e.getPreloaded()) {
                                        var n = Ce(e, t);
                                        n && e.startPreloading(X, ae).then(function() {
                                            oe.push(e);
                                        });
                                    }
                                }
                                function ke(e) {
                                    if (isNaN(e)) return null;
                                    for(var t = B.length, n = 0; n < t; n++){
                                        var r = B[n];
                                        if (e < parseFloat((r.getStartTime() + r.getDuration()).toFixed(5))) return r;
                                    }
                                    return null;
                                }
                                function Ne() {
                                    try {
                                        var e = w.getIsDynamic(), t = w.getStreamsInfo()[0].manifestInfo, n = J.getTime(), i = j.calcTimeShiftBufferWindow(B, e), a1 = Ge();
                                        if (void 0 === i.start || void 0 === i.end) return;
                                        a1 && 0 !== a1.length ? a1.forEach(function(e) {
                                            I.addDVRInfo(e.getType(), n, t, i);
                                        }) : I.addDVRInfo(r.default.VIDEO, n, t, i);
                                    } catch (e) {}
                                }
                                function Le(e) {
                                    if (ne && q) {
                                        var t = $.getInitialBufferLevel(), n = [
                                            r.default.TEXT
                                        ];
                                        (isNaN(t) || t <= J.getBufferLevel(n) || w.getIsDynamic() && t > J.getLiveDelay()) && (ne = !1, Ze(c.PlayList.INITIAL_PLAYOUT_START_REASON), J.play());
                                    }
                                    e && e.mediaType && I.addBufferLevel(e.mediaType, new Date, 1e3 * e.bufferLevel);
                                }
                                function xe(e) {
                                    e.streamInfo.id === G.getId() && e.reason && e.reason.forceReplace && Ie(), tt(e.streamInfo.id).prepareQualityChange(e);
                                }
                                function Me() {
                                    if (w.getIsDynamic() && 0 !== J.getOriginalLiveDelay()) {
                                        var e = w.getStreamsInfo();
                                        if (e.length > 0) {
                                            var t = e[0].manifestInfo, n = We(e, t);
                                            J.computeAndSetLiveDelay(n, t);
                                        }
                                    }
                                }
                                function Oe() {
                                    if (Xe()) {
                                        var e = Q.getPlaybackQuality();
                                        e && I.addDroppedFrames(e);
                                    }
                                }
                                function Pe() {
                                    t.debug("[onPlaybackStarted]"), !ne && te && Ze(c.PlayList.RESUME_FROM_PAUSE_START_REASON), ne && (ne = !1), re && (re = !1, ue.get().streaming.applyContentSteering && !D.shouldQueryBeforeStart() && D.loadSteeringData()), te = !1;
                                }
                                function Fe(e) {
                                    t.debug("[onPlaybackPaused]"), e.ended || (te = !0, Je(c.PlayListTrace.USER_REQUEST_STOP_REASON));
                                }
                                function Ue(e) {
                                    t.debug("Stream with id ".concat(e.streamInfo.id, " finished buffering"));
                                    var n = e.streamInfo.isLast;
                                    X && n ? (t.info("[onStreamBufferingCompleted] calls signalEndOfStream of mediaSourceController."), R.signalEndOfStream(X)) : je();
                                }
                                function je() {
                                    if (G && G.getHasFinishedBuffering()) for(var e = function() {
                                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                                        try {
                                            var t = e || G || null;
                                            if (t) {
                                                var n = t.getStreamInfo();
                                                return B.filter(function(e) {
                                                    var t = e.getStreamInfo();
                                                    return t.start > n.start && n.id !== t.id;
                                                });
                                            }
                                        } catch (e) {
                                            return [];
                                        }
                                    }(G), t = 0; t < e.length;){
                                        var n = e[t], r = 0 === t ? G : e[t - 1];
                                        !n.getPreloaded() && r.getHasFinishedBuffering() && X && De(n, r), t += 1;
                                    }
                                }
                                function Be() {
                                    ie && (clearInterval(ie), ie = null);
                                }
                                function Ge() {
                                    return G ? G.getProcessors() : [];
                                }
                                function He(e) {
                                    if (G && !G.getIsEndedEventSignaled()) {
                                        G.setIsEndedEventSignaled(!0);
                                        var n = function() {
                                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = e || G || null;
                                            if (!t) return null;
                                            for(var n = t.getStreamInfo(), r = n.start, i = 0, a1 = -1, o = NaN; i < B.length;){
                                                var s1 = B[i].getStreamInfo(), u = s1.start - r;
                                                u > 0 && (isNaN(o) || u < o) && n.id !== s1.id && (o = u, a1 = i), i += 1;
                                            }
                                            return a1 >= 0 ? B[a1] : null;
                                        }();
                                        n ? (t.debug("StreamController onEnded, found next stream with id ".concat(n.getStreamInfo().id, ". Switching from ").concat(G.getStreamInfo().id, " to ").concat(n.getStreamInfo().id)), be(n, G, NaN)) : (t.debug("StreamController no next stream found"), G.setIsEndedEventSignaled(!1)), Je(n ? c.PlayListTrace.END_OF_PERIOD_STOP_REASON : c.PlayListTrace.END_OF_CONTENT_STOP_REASON);
                                    }
                                    e && e.isLast && (Be(), D.stopSteeringRequestTimer());
                                }
                                function Ve(e) {
                                    var t = e || et().manifestInfo.duration;
                                    R.setDuration(t);
                                }
                                function Ke(e) {
                                    var t = L.getURIFragmentData();
                                    if (!t || !t.t) return NaN;
                                    var n = ot()[0].getStreamInfo().start;
                                    return t.t = t.t.split(",")[0], Ye(e, t.t, n);
                                }
                                function qe(e, t) {
                                    var n = 0;
                                    return e || (n = ot()[0].getStreamInfo().start), Ye(e, t, n);
                                }
                                function Ye(e, t, n) {
                                    var r = w.getRegularPeriods()[0], i = t.toString(), a1 = -1 !== i.indexOf("posix:") ? "now" === i.substring(6) ? Date.now() / 1e3 : parseFloat(i.substring(6)) : NaN;
                                    return e && !isNaN(a1) ? j.calcPresentationTimeFromWallTime(new Date(1e3 * a1), r) : parseFloat(i) + n;
                                }
                                function We(e, t) {
                                    try {
                                        var n = NaN;
                                        if (t && !isNaN(t.maxFragmentDuration) && isFinite(t.maxFragmentDuration)) return t.maxFragmentDuration;
                                        if (e && 1 === e.length) {
                                            var i = e[0], a1 = [
                                                r.default.VIDEO,
                                                r.default.AUDIO,
                                                r.default.TEXT
                                            ].reduce(function(e, t) {
                                                var n = w.getMediaInfoForType(i, t);
                                                return n && !1 !== n.isFragmented && e.push(n), e;
                                            }, []).reduce(function(e, t) {
                                                var n = w.getVoRepresentations(t);
                                                return n && n.length > 0 && n.forEach(function(t) {
                                                    t && e.push(t);
                                                }), e;
                                            }, []).reduce(function(e, t) {
                                                var n = w.convertRepresentationToRepresentationInfo(t);
                                                return n && n.fragmentDuration && !isNaN(n.fragmentDuration) && e.push(n.fragmentDuration), e;
                                            }, []);
                                            n = Math.max.apply(Math, function(e) {
                                                if (Array.isArray(e)) return b(e);
                                            }(o = a1) || function(e) {
                                                if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
                                            }(o) || function(e, t) {
                                                if (e) {
                                                    if ("string" == typeof e) return b(e, t);
                                                    var n = Object.prototype.toString.call(e).slice(8, -1);
                                                    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? b(e, t) : void 0;
                                                }
                                            }(o) || function() {
                                                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                            }());
                                        }
                                        return isFinite(n) ? n : NaN;
                                    } catch (e) {
                                        return NaN;
                                    }
                                    var o;
                                }
                                function ze(e) {
                                    if (e.error) z = !0, it();
                                    else {
                                        t.info("Manifest updated... updating data system wide.");
                                        var n = e.manifest;
                                        w.updatePeriods(n);
                                        var r = w.getUTCTimingSources();
                                        !w.getIsDynamic() || r && 0 !== r.length || ge.trigger(g.default.CONFORMANCE_VIOLATION, {
                                            level: T.default.LEVELS.WARNING,
                                            event: T.default.EVENTS.NO_UTC_TIMING_ELEMENT
                                        });
                                        var i = w.getIsDynamic() ? r.concat(ee.getUTCTimingSources()) : r, a1 = F.isHTTPS(e.manifest.url);
                                        i.forEach(function(e) {
                                            e.value.replace(/.*?:\/\//g, "") === ue.get().streaming.utcSynchronization.defaultTimingSource.value.replace(/.*?:\/\//g, "") && (e.value = e.value.replace(a1 ? new RegExp(/^(http:)?\/\//i) : new RegExp(/^(https:)?\/\//i), a1 ? "https://" : "http://"), t.debug("Matching default timing source protocol to manifest protocol: ", e.value));
                                        }), l.filterUnsupportedFeatures(n).then(function() {
                                            k.initialize(n), C.attemptSync(i, w.getIsDynamic());
                                        });
                                    }
                                }
                                function Xe() {
                                    return !!G && G.getHasVideoTrack();
                                }
                                function Qe() {
                                    return !!G && G.getHasAudioTrack();
                                }
                                function Je(e, t) {
                                    t = t || new Date, Ge().forEach(function(n) {
                                        n.finalisePlayList(t, e);
                                    }), I.addPlayList();
                                }
                                function Ze(e) {
                                    I.createPlaylistMetrics(1e3 * J.getTime(), e);
                                }
                                function $e(e) {
                                    if (e.error) {
                                        var n = "";
                                        switch(e.error.code){
                                            case 1:
                                                n = "MEDIA_ERR_ABORTED";
                                                break;
                                            case 2:
                                                n = "MEDIA_ERR_NETWORK";
                                                break;
                                            case 3:
                                                n = "MEDIA_ERR_DECODE", fe.counts.mediaErrorDecode += 1;
                                                break;
                                            case 4:
                                                n = "MEDIA_ERR_SRC_NOT_SUPPORTED";
                                                break;
                                            case 5:
                                                n = "MEDIA_ERR_ENCRYPTED";
                                                break;
                                            default:
                                                n = "UNKNOWN";
                                        }
                                        "MEDIA_ERR_DECODE" === n && ue.get().errors.recoverAttempts.mediaErrorDecode >= fe.counts.mediaErrorDecode ? function() {
                                            t.warn("A MEDIA_ERR_DECODE occured: Resetting the MediaSource");
                                            var e = J.getTime();
                                            G.deactivate(!1), t.warn("MediaSource has been resetted. Resuming playback from time ".concat(e)), Ae(e, !1);
                                        }() : (W = !0, e.error.message && (n += " (" + e.error.message + ")"), e.error.msExtendedCode && (n += " (0x" + (e.error.msExtendedCode >>> 0).toString(16).toUpperCase() + ")"), t.fatal("Video Element Error: " + n), e.error && t.fatal(e.error), U.error(new v.default(e.error.code, n)), it());
                                    }
                                }
                                function et() {
                                    return G ? G.getStreamInfo() : null;
                                }
                                function tt(e) {
                                    for(var t = 0, n = B.length; t < n; t++)if (B[t].getId() === e) return B[t];
                                    return null;
                                }
                                function nt(e) {
                                    isNaN(e.newDuration) || Ve(e.newDuration);
                                }
                                function rt() {
                                    B = [], de = NaN, H = null, Y = !1, G = null, W = !1, z = !1, ne = !0, re = !0, te = !1, q = !0, ie = null, le = !1, se = !1, oe = [], ce = null, fe = {
                                        counts: {
                                            mediaErrorDecode: 0
                                        }
                                    };
                                }
                                function it() {
                                    pe(), C.reset(), Je(W || z ? c.PlayListTrace.FAILURE_STOP_REASON : c.PlayListTrace.USER_REQUEST_STOP_REASON);
                                    for(var t = 0, n = B ? B.length : 0; t < n; t++)B[t].reset(W);
                                    ge.off(g.default.PLAYBACK_TIME_UPDATED, Oe, e), ge.off(g.default.PLAYBACK_SEEKING, Se, e), ge.off(g.default.PLAYBACK_ERROR, $e, e), ge.off(g.default.PLAYBACK_STARTED, Pe, e), ge.off(g.default.PLAYBACK_PAUSED, Fe, e), ge.off(g.default.PLAYBACK_ENDED, He, e), ge.off(g.default.METRIC_ADDED, at, e), ge.off(g.default.MANIFEST_VALIDITY_CHANGED, nt, e), ge.off(g.default.BUFFER_LEVEL_UPDATED, Le, e), ge.off(g.default.QUALITY_CHANGE_REQUESTED, xe, e), u.default.KEY_SESSION_UPDATED && ge.off(u.default.KEY_SESSION_UPDATED, ye, e), ge.off(u.default.MANIFEST_UPDATED, ze, e), ge.off(u.default.STREAM_BUFFERING_COMPLETED, Ue, e), ge.off(u.default.TIME_SYNCHRONIZATION_COMPLETED, ve, e), ge.off(u.default.CURRENT_TRACK_CHANGED, Re, e), ge.off(u.default.SETTING_UPDATED_LIVE_DELAY, Me, e), ge.off(u.default.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT, Me, e), k.reset(), A.reset(), O.reset(), I.clearAllCurrentMetrics(), S.setValue(null), _.reset(), j.reset(), P.reset(), X && (R.detachMediaSource(Q), X = null), Q = null, H && (H = null, K = null, S.getValue() && ge.trigger(u.default.PROTECTION_DESTROYED, {
                                        data: S.getValue().url
                                    })), Be(), ge.trigger(u.default.STREAM_TEARDOWN_COMPLETE), rt();
                                }
                                function at(e) {
                                    if (e.metric === i.default.DVR_INFO) {
                                        var t = Qe() ? r.default.AUDIO : r.default.VIDEO;
                                        e.mediaType === t && R.setSeekable(e.value.range.start, e.value.range.end);
                                    }
                                }
                                function ot() {
                                    return B;
                                }
                                return e = {
                                    initialize: function(t, n) {
                                        pe(), q = t, K = n, j.initialize(), (A = Object(o.default)(he).create()).setConfig({
                                            manifestModel: S,
                                            adapter: w,
                                            manifestLoader: _,
                                            errHandler: U,
                                            settings: ue
                                        }), A.initialize(), (O = Object(E.default)(he).getInstance()).setConfig({
                                            manifestUpdater: A,
                                            playbackController: J,
                                            settings: ue
                                        }), O.start(), C.setConfig({
                                            dashMetrics: I,
                                            baseURLController: k,
                                            errHandler: U,
                                            settings: ue
                                        }), C.initialize(), H && (ge.trigger(u.default.PROTECTION_CREATED, {
                                            controller: H
                                        }), H.setMediaElement(Q.getElement()), K && H.setProtectionData(K)), ge.on(g.default.PLAYBACK_TIME_UPDATED, Oe, e), ge.on(g.default.PLAYBACK_SEEKING, Se, e), ge.on(g.default.PLAYBACK_ERROR, $e, e), ge.on(g.default.PLAYBACK_STARTED, Pe, e), ge.on(g.default.PLAYBACK_PAUSED, Fe, e), ge.on(g.default.PLAYBACK_ENDED, He, e), ge.on(g.default.METRIC_ADDED, at, e), ge.on(g.default.MANIFEST_VALIDITY_CHANGED, nt, e), ge.on(g.default.BUFFER_LEVEL_UPDATED, Le, e), ge.on(g.default.QUALITY_CHANGE_REQUESTED, xe, e), u.default.KEY_SESSION_UPDATED && ge.on(u.default.KEY_SESSION_UPDATED, ye, e), ge.on(u.default.MANIFEST_UPDATED, ze, e), ge.on(u.default.STREAM_BUFFERING_COMPLETED, Ue, e), ge.on(u.default.TIME_SYNCHRONIZATION_COMPLETED, ve, e), ge.on(u.default.CURRENT_TRACK_CHANGED, Re, e), ge.on(u.default.SETTING_UPDATED_LIVE_DELAY, Me, e), ge.on(u.default.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT, Me, e);
                                    },
                                    getActiveStreamInfo: et,
                                    addDVRMetric: Ne,
                                    hasVideoTrack: Xe,
                                    hasAudioTrack: Qe,
                                    getStreamById: tt,
                                    getStreamForTime: ke,
                                    getTimeRelativeToStreamId: function(e, t) {
                                        for(var n = null, r = 0, i = 0, a1 = null, o = 0; o < B.length; o++){
                                            if (i = (n = B[o]).getStartTime(), a1 = n.getDuration(), Number.isFinite(i) && (r = i), n.getId() === t) return e - r;
                                            Number.isFinite(a1) && (r += a1);
                                        }
                                        return null;
                                    },
                                    load: function(e) {
                                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : NaN;
                                        pe(), de = t, _.load(e);
                                    },
                                    loadWithManifest: function(e) {
                                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : NaN;
                                        me(), de = t, A.setManifest(e);
                                    },
                                    getActiveStreamProcessors: Ge,
                                    setConfig: function(e) {
                                        e && (e.capabilities && (n = e.capabilities), e.capabilitiesFilter && (l = e.capabilitiesFilter), e.manifestLoader && (_ = e.manifestLoader), e.manifestModel && (S = e.manifestModel), e.mediaPlayerModel && ($ = e.mediaPlayerModel), e.customParametersModel && (ee = e.customParametersModel), e.protectionController && (H = e.protectionController), e.adapter && (w = e.adapter), e.dashMetrics && (I = e.dashMetrics), e.errHandler && (U = e.errHandler), e.timelineConverter && (j = e.timelineConverter), e.videoModel && (Q = e.videoModel), e.playbackController && (J = e.playbackController), e.serviceDescriptionController && (Z = e.serviceDescriptionController), e.contentSteeringController && (D = e.contentSteeringController), e.textController && (V = e.textController), e.abrController && (x = e.abrController), e.mediaController && (M = e.mediaController), e.settings && (ue = e.settings), e.baseURLController && (k = e.baseURLController), e.uriFragmentModel && (L = e.uriFragmentModel), e.segmentBaseController && (N = e.segmentBaseController));
                                    },
                                    setProtectionData: function(e) {
                                        K = e, H && H.setProtectionData(K);
                                    },
                                    getIsStreamSwitchInProgress: function() {
                                        return Y;
                                    },
                                    switchToVideoElement: function(e) {
                                        G && (J.initialize(et()), Ae(e, !1));
                                    },
                                    getHasMediaOrInitialisationError: function() {
                                        return W || z;
                                    },
                                    getStreams: ot,
                                    getActiveStream: function() {
                                        return G;
                                    },
                                    getInitialPlayback: function() {
                                        return ne;
                                    },
                                    getAutoPlay: function() {
                                        return q;
                                    },
                                    reset: it
                                }, t = Object(d.default)(he).getInstance().getLogger(e), C = Object(p.default)(he).getInstance(), R = Object(m.default)(he).getInstance(), P = Object(f.default)(he).getInstance(), F = Object(h.default)(he).getInstance(), rt(), e;
                            }
                            A.__dashjs_factory_name = "StreamController", t.default = l.default.getSingletonFactory(A);
                        },
                        "./src/streaming/controllers/TimeSyncController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/vo/DashJSError.js"), i = n("./src/streaming/vo/metrics/HTTPRequest.js"), a1 = n("./src/core/EventBus.js"), o = n("./src/core/events/Events.js"), s1 = n("./src/core/errors/Errors.js"), u = n("./src/core/FactoryMaker.js"), l = n("./src/core/Debug.js"), c = n("./src/streaming/utils/URLUtils.js");
                            function d() {
                                var e, t, n, u, d, f, h, g, p, m, v, y, E, T, b, A, _ = this.context, S = Object(a1.default)(_).getInstance(), w = Object(c.default)(_).getInstance();
                                function I() {
                                    g = [], p = [], m = null, v = null, E = null, y = NaN, n = !1, u = !1, T = d.get().streaming.utcSynchronization.timeBetweenSyncAttempts;
                                }
                                function R() {
                                    d.get().streaming.utcSynchronization.enabled && !n && !u && E && E.value && E.schemeIdUri && !isNaN(y) && !isNaN(d.get().streaming.utcSynchronization.backgroundAttempts) && (v && (Date.now() - v) / 1e3 < 30 || (g = [], u = !0, C(isNaN(d.get().streaming.utcSynchronization.backgroundAttempts) ? 2 : d.get().streaming.utcSynchronization.backgroundAttempts)));
                                }
                                function C(e) {
                                    try {
                                        if (e <= 0) return void G();
                                        var t = Date.now();
                                        f[E.schemeIdUri](E.value, function(n) {
                                            var r = Date.now(), i = k(t, r, n);
                                            g.push(i), C(e - 1);
                                        }, function() {
                                            G();
                                        });
                                    } catch (e) {
                                        G();
                                    }
                                }
                                function D() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = e || 0;
                                    if (!p || 0 === p.length || t >= p.length) N();
                                    else {
                                        var n = p[t];
                                        if (n) {
                                            if (f.hasOwnProperty(n.schemeIdUri)) {
                                                var r = (new Date).getTime();
                                                f[n.schemeIdUri](n.value, function(e) {
                                                    var t = (new Date).getTime(), i = k(r, t, e);
                                                    E = n, N(i);
                                                }, function() {
                                                    D(t + 1);
                                                });
                                            } else D(t + 1);
                                        } else N();
                                    }
                                }
                                function k(e, t, n) {
                                    return n - (t - (t - e) / 2);
                                }
                                function N() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : NaN, t = isNaN(e);
                                    t && d.get().streaming.utcSynchronization.useManifestDateHeaderTimeSource ? j() : B(t, e);
                                }
                                function L(e) {
                                    var t = Date.parse(e);
                                    return isNaN(t) && (t = function(e) {
                                        var t, n, r = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+\-])([0-9]{2})([0-9]{2}))?/.exec(e);
                                        return t = Date.UTC(parseInt(r[1], 10), parseInt(r[2], 10) - 1, parseInt(r[3], 10), parseInt(r[4], 10), parseInt(r[5], 10), r[6] && (parseInt(r[6], 10) || 0), r[7] && 1e3 * parseFloat(r[7]) || 0), r[9] && r[10] && (n = 60 * parseInt(r[9], 10) + parseInt(r[10], 10), t += ("+" === r[8] ? -1 : 1) * n * 60000), new Date(t).getTime();
                                    }(e)), t;
                                }
                                function x(e) {
                                    return Date.parse(e);
                                }
                                function M(e) {
                                    return Date.parse(e);
                                }
                                function O(e, t, n) {
                                    n();
                                }
                                function P(e, t, n) {
                                    var r = L(e);
                                    isNaN(r) ? n() : t(r);
                                }
                                function F(e, t, n, r, a1) {
                                    var o, s1, u = !1, l = new XMLHttpRequest, c = a1 ? i.HTTPRequest.HEAD : i.HTTPRequest.GET, d = t.match(/\S+/g);
                                    if (t = d.shift(), o = function() {
                                        u || (u = !0, d.length ? F(e, d.join(" "), n, r, a1) : r());
                                    }, s1 = function() {
                                        var t, r;
                                        200 === l.status && (t = a1 ? l.getResponseHeader("Date") : l.response, r = e(t), isNaN(r) || (n(r), u = !0));
                                    }, w.isRelative(t)) {
                                        var f = A.resolve();
                                        f && (t = w.resolve(t, f.url));
                                    }
                                    l.open(c, t), l.timeout = 5e3, l.onload = s1, l.onloadend = o, l.send();
                                }
                                function U(e, t, n) {
                                    F(M, e, t, n, !0);
                                }
                                function j() {
                                    var e = h.getLatestMPDRequestHeaderValueByID("Date"), t = null !== e ? new Date(e).getTime() : Number.NaN;
                                    isNaN(t) ? B(!0) : B(!1, t - Date.now());
                                }
                                function B(e, i) {
                                    if (isNaN(y) || isNaN(i) || e || function(e) {
                                        try {
                                            var n, r = H(e), i = isNaN(T) ? 30 : T, a1 = isNaN(d.get().streaming.utcSynchronization.timeBetweenSyncAttemptsAdjustmentFactor) ? 2 : d.get().streaming.utcSynchronization.timeBetweenSyncAttemptsAdjustmentFactor, o = isNaN(d.get().streaming.utcSynchronization.maximumTimeBetweenSyncAttempts) ? 600 : d.get().streaming.utcSynchronization.maximumTimeBetweenSyncAttempts, s1 = isNaN(d.get().streaming.utcSynchronization.minimumTimeBetweenSyncAttempts) ? 2 : d.get().streaming.utcSynchronization.minimumTimeBetweenSyncAttempts;
                                            r ? (n = Math.min(i * a1, o), t.debug("Increasing timeBetweenSyncAttempts to ".concat(n))) : (n = Math.max(i / a1, s1), t.debug("Decreasing timeBetweenSyncAttempts to ".concat(n))), T = n;
                                        } catch (e) {}
                                    }(i), !e && !isNaN(i)) {
                                        m = Date.now(), n = !1;
                                        var a1 = isNaN(y);
                                        y = i, a1 && R(), t.debug("Completed UTC sync. Setting client - server offset to ".concat(i));
                                    }
                                    e && (E = null, n = !1, b.error(new r.default(s1.default.TIME_SYNC_FAILED_ERROR_CODE, s1.default.TIME_SYNC_FAILED_ERROR_MESSAGE))), S.trigger(o.default.UPDATE_TIME_SYNC_OFFSET, {
                                        offset: i
                                    }), S.trigger(o.default.TIME_SYNCHRONIZATION_COMPLETED);
                                }
                                function G() {
                                    if (g && 0 !== g.length) {
                                        var e = g.reduce(function(e, t) {
                                            return e + t;
                                        }, 0) / g.length;
                                        H(e) ? t.debug("Completed background UTC sync. Offset is within allowed threshold and is not adjusted.") : (t.debug("Completed background UTC sync. Setting client - server offset to ".concat(e)), y = e, S.trigger(o.default.UPDATE_TIME_SYNC_OFFSET, {
                                            offset: y
                                        })), u = !1, v = Date.now();
                                    }
                                }
                                function H(e) {
                                    try {
                                        if (isNaN(y)) return !0;
                                        var t = d.get().streaming.utcSynchronization.maximumAllowedDrift && !isNaN(d.get().streaming.utcSynchronization.maximumAllowedDrift) ? d.get().streaming.utcSynchronization.maximumAllowedDrift : 100;
                                        return e >= y - t && e <= y + t;
                                    } catch (e) {
                                        return !0;
                                    }
                                }
                                return e = {
                                    initialize: function() {
                                        I(), f = {
                                            "urn:mpeg:dash:utc:http-head:2014": U,
                                            "urn:mpeg:dash:utc:http-xsdate:2014": F.bind(null, L),
                                            "urn:mpeg:dash:utc:http-iso:2014": F.bind(null, x),
                                            "urn:mpeg:dash:utc:direct:2014": P,
                                            "urn:mpeg:dash:utc:http-head:2012": U,
                                            "urn:mpeg:dash:utc:http-xsdate:2012": F.bind(null, L),
                                            "urn:mpeg:dash:utc:http-iso:2012": F.bind(null, x),
                                            "urn:mpeg:dash:utc:direct:2012": P,
                                            "urn:mpeg:dash:utc:http-ntp:2014": O,
                                            "urn:mpeg:dash:utc:ntp:2014": O,
                                            "urn:mpeg:dash:utc:sntp:2014": O
                                        };
                                    },
                                    attemptSync: function(e, t) {
                                        p = e, n || (function(e) {
                                            try {
                                                if (!e || !d.get().streaming.utcSynchronization.enabled) return !1;
                                                var t = isNaN(T) ? 30 : T;
                                                return !(m && t && !isNaN(t)) || (Date.now() - m) / 1e3 >= t;
                                            } catch (e) {
                                                return !0;
                                            }
                                        }(t) ? (n = !0, D()) : S.trigger(o.default.TIME_SYNCHRONIZATION_COMPLETED));
                                    },
                                    setConfig: function(e) {
                                        e && (e.dashMetrics && (h = e.dashMetrics), e.baseURLController && (A = e.baseURLController), e.errHandler && (b = e.errHandler), e.settings && (d = e.settings));
                                    },
                                    reset: function() {
                                        I(), S.off(o.default.ATTEMPT_BACKGROUND_SYNC, R, e);
                                    }
                                }, t = Object(l.default)(_).getInstance().getLogger(e), S.on(o.default.ATTEMPT_BACKGROUND_SYNC, R, e), e;
                            }
                            d.__dashjs_factory_name = "TimeSyncController";
                            var f = u.default.getSingletonFactory(d);
                            f.HTTP_TIMEOUT_MS = 5e3, u.default.updateSingletonFactory(d.__dashjs_factory_name, f), t.default = f;
                        },
                        "./src/streaming/controllers/XlinkController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/XlinkLoader.js"), i = n("./src/core/EventBus.js"), a1 = n("./src/core/events/Events.js"), o = n("./src/core/FactoryMaker.js"), s1 = n("./externals/xml2json.js"), u = n("./src/streaming/utils/URLUtils.js"), l = n("./src/dash/constants/DashConstants.js"), c = "onLoad";
                            function d(e) {
                                e = e || {};
                                var t, n, o, d, f, h, g = this.context, p = Object(i.default)(g).getInstance(), m = Object(u.default)(g).getInstance();
                                function v(e, t, n) {
                                    var r, i, a1 = {};
                                    a1.elements = e, a1.type = t, a1.resolveType = n, 0 === a1.elements.length && E(a1);
                                    for(var o = 0; o < a1.elements.length; o++)r = a1.elements[o], i = m.isHTTPURL(r.url) ? r.url : r.originalContent.BaseURL + r.url, h.load(i, r, a1);
                                }
                                function y(e) {
                                    var t, n, r = "";
                                    if (t = e.element, n = e.resolveObject, t.resolvedContent) {
                                        var i = 0;
                                        0 === t.resolvedContent.indexOf("<?xml") && (i = t.resolvedContent.indexOf("?>") + 2), r = t.resolvedContent.substr(0, i) + "<response>" + t.resolvedContent.substr(i) + "</response>", t.resolvedContent = f.xml_str2json(r);
                                    }
                                    (function(e) {
                                        var t;
                                        for(t = 0; t < e.elements.length; t++)if (!1 === e.elements[t].resolved) return !1;
                                        return !0;
                                    })(n) && E(n);
                                }
                                function E(e) {
                                    var t, n, r = [];
                                    if (function(e) {
                                        var t, n, r, i, a1, s1, u = [];
                                        for(i = e.elements.length - 1; i >= 0; i--){
                                            if (n = (t = e.elements[i]).type + "_asArray", t.resolvedContent) {
                                                if (t.resolvedContent) for(a1 = 0; a1 < t.resolvedContent[n].length; a1++)r = t.resolvedContent[n][a1], u.push(r);
                                            } else delete t.originalContent["xlink:actuate"], delete t.originalContent["xlink:href"], u.push(t.originalContent);
                                            for(t.parentElement[n].splice(t.index, 1), s1 = 0; s1 < u.length; s1++)t.parentElement[n].splice(t.index + s1, 0, u[s1]);
                                            u = [];
                                        }
                                        e.elements.length > 0 && o.run(d);
                                    }(e), "onActuate" === e.resolveType && p.trigger(a1.default.XLINK_READY, {
                                        manifest: d
                                    }), e.resolveType === c) switch(e.type){
                                        case l.default.PERIOD:
                                            for(t = 0; t < d[l.default.PERIOD + "_asArray"].length; t++)(n = d[l.default.PERIOD + "_asArray"][t]).hasOwnProperty(l.default.ADAPTATION_SET + "_asArray") && (r = r.concat(T(n[l.default.ADAPTATION_SET + "_asArray"], n, l.default.ADAPTATION_SET, c))), n.hasOwnProperty(l.default.EVENT_STREAM + "_asArray") && (r = r.concat(T(n[l.default.EVENT_STREAM + "_asArray"], n, l.default.EVENT_STREAM, c)));
                                            v(r, l.default.ADAPTATION_SET, c);
                                            break;
                                        case l.default.ADAPTATION_SET:
                                            p.trigger(a1.default.XLINK_READY, {
                                                manifest: d
                                            });
                                    }
                                }
                                function T(e, t, n, r) {
                                    var i, a1, o, s1 = [];
                                    for(a1 = e.length - 1; a1 >= 0; a1--)(i = e[a1]).hasOwnProperty("xlink:href") && "urn:mpeg:dash:resolve-to-zero:2013" === i["xlink:href"] && e.splice(a1, 1);
                                    for(a1 = 0; a1 < e.length; a1++)(i = e[a1]).hasOwnProperty("xlink:href") && i.hasOwnProperty("xlink:actuate") && i["xlink:actuate"] === r && (o = b(i["xlink:href"], t, n, a1, r, i), s1.push(o));
                                    return s1;
                                }
                                function b(e, t, n, r, i, a1) {
                                    return {
                                        url: e,
                                        parentElement: t,
                                        type: n,
                                        index: r,
                                        resolveType: i,
                                        originalContent: a1,
                                        resolvedContent: null,
                                        resolved: !1
                                    };
                                }
                                return t = {
                                    resolveManifestOnLoad: function(e) {
                                        f = new s1.default({
                                            escapeMode: !1,
                                            attributePrefix: "",
                                            arrayAccessForm: "property",
                                            emptyNodeForm: "object",
                                            stripWhitespaces: !1,
                                            enableToStringFunc: !1,
                                            ignoreRoot: !0,
                                            matchers: n
                                        }), (d = e).Period_asArray ? v(T(d.Period_asArray, d, l.default.PERIOD, c), l.default.PERIOD, c) : p.trigger(a1.default.XLINK_READY, {
                                            manifest: d
                                        });
                                    },
                                    setMatchers: function(e) {
                                        e && (n = e);
                                    },
                                    setIron: function(e) {
                                        e && (o = e);
                                    },
                                    reset: function() {
                                        p.off(a1.default.XLINK_ELEMENT_LOADED, y, t), h && (h.reset(), h = null);
                                    }
                                }, p.on(a1.default.XLINK_ELEMENT_LOADED, y, t), h = Object(r.default)(g).create({
                                    errHandler: e.errHandler,
                                    dashMetrics: e.dashMetrics,
                                    mediaPlayerModel: e.mediaPlayerModel,
                                    requestModifier: e.requestModifier,
                                    settings: e.settings
                                }), t;
                            }
                            d.__dashjs_factory_name = "XlinkController", t.default = o.default.getClassFactory(d);
                        },
                        "./src/streaming/metrics/MetricsReporting.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/metrics/utils/DVBErrorsTranslator.js"), i = n("./src/streaming/metrics/MetricsReportingEvents.js"), a1 = n("./src/streaming/metrics/controllers/MetricsCollectionController.js"), o = n("./src/streaming/metrics/metrics/MetricsHandlerFactory.js"), s1 = n("./src/streaming/metrics/reporting/ReportingFactory.js");
                            function u() {
                                var e = this.context;
                                return {
                                    createMetricsReporting: function(t) {
                                        return Object(r.default)(e).getInstance({
                                            eventBus: t.eventBus,
                                            dashMetrics: t.dashMetrics,
                                            metricsConstants: t.metricsConstants,
                                            events: t.events
                                        }).initialise(), Object(a1.default)(e).create(t);
                                    },
                                    getReportingFactory: function() {
                                        return Object(s1.default)(e).getInstance();
                                    },
                                    getMetricsHandlerFactory: function() {
                                        return Object(o.default)(e).getInstance();
                                    }
                                };
                            }
                            u.__dashjs_factory_name = "MetricsReporting";
                            var l = dashjs.FactoryMaker.getClassFactory(u);
                            l.events = i.default, dashjs.FactoryMaker.updateClassFactory(u.__dashjs_factory_name, l), t.default = l;
                        },
                        "./src/streaming/metrics/MetricsReportingEvents.js": function(e, t, n) {
                            "use strict";
                            function r(e) {
                                return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, r(e);
                            }
                            function i(e, t) {
                                return i = Object.setPrototypeOf || function(e, t) {
                                    return e.__proto__ = t, e;
                                }, i(e, t);
                            }
                            function a1(e, t) {
                                return !t || "object" !== r(t) && "function" != typeof t ? function(e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e;
                                }(e) : t;
                            }
                            function o(e) {
                                return o = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                                    return e.__proto__ || Object.getPrototypeOf(e);
                                }, o(e);
                            }
                            n.r(t);
                            var s1 = new (function(e) {
                                !function(e, t) {
                                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                    e.prototype = Object.create(t && t.prototype, {
                                        constructor: {
                                            value: e,
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }), t && i(e, t);
                                }(s1, e);
                                var t, n, r = (t = s1, n = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e, r = o(t);
                                    if (n) {
                                        var i = o(this).constructor;
                                        e = Reflect.construct(r, arguments, i);
                                    } else e = r.apply(this, arguments);
                                    return a1(this, e);
                                });
                                function s1() {
                                    var e;
                                    return function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, s1), (e = r.call(this)).METRICS_INITIALISATION_COMPLETE = "internal_metricsReportingInitialized", e.BECAME_REPORTING_PLAYER = "internal_becameReportingPlayer", e.CMCD_DATA_GENERATED = "cmcdDataGenerated", e;
                                }
                                return s1;
                            }(n("./src/core/events/EventsBase.js").default));
                            t.default = s1;
                        },
                        "./src/streaming/metrics/controllers/MetricsCollectionController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/metrics/controllers/MetricsController.js"), i = n("./src/streaming/metrics/utils/ManifestParsing.js"), a1 = n("./src/streaming/metrics/MetricsReportingEvents.js");
                            function o(e) {
                                var t;
                                e = e || {};
                                var n = {}, o = this.context, s1 = e.eventBus, u = e.events;
                                function l(t) {
                                    if (!t.error) {
                                        var u = Object.keys(n);
                                        Object(i.default)(o).getInstance({
                                            adapter: e.adapter,
                                            constants: e.constants
                                        }).getMetrics(t.manifest).forEach(function(t) {
                                            var i = JSON.stringify(t);
                                            if (n.hasOwnProperty(i)) u.splice(i, 1);
                                            else try {
                                                var a1 = Object(r.default)(o).create(e);
                                                a1.initialize(t), n[i] = a1;
                                            } catch (e) {}
                                        }), u.forEach(function(e) {
                                            n[e].reset(), delete n[e];
                                        }), s1.trigger(a1.default.METRICS_INITIALISATION_COMPLETE);
                                    }
                                }
                                function c() {
                                    Object.keys(n).forEach(function(e) {
                                        n[e].reset();
                                    }), n = {};
                                }
                                return t = {
                                    reset: function() {
                                        s1.off(u.MANIFEST_UPDATED, l, t), s1.off(u.STREAM_TEARDOWN_COMPLETE, c, t);
                                    }
                                }, s1.on(u.MANIFEST_UPDATED, l, t), s1.on(u.STREAM_TEARDOWN_COMPLETE, c, t), t;
                            }
                            o.__dashjs_factory_name = "MetricsCollectionController", t.default = dashjs.FactoryMaker.getClassFactory(o);
                        },
                        "./src/streaming/metrics/controllers/MetricsController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/metrics/controllers/RangeController.js"), i = n("./src/streaming/metrics/controllers/ReportingController.js"), a1 = n("./src/streaming/metrics/controllers/MetricsHandlersController.js");
                            function o(e) {
                                var t, n, o;
                                e = e || {};
                                var s1 = this.context;
                                function u() {
                                    t && t.reset(), n && n.reset(), o && o.reset();
                                }
                                return {
                                    initialize: function(l) {
                                        try {
                                            (o = Object(r.default)(s1).create({
                                                mediaElement: e.mediaElement
                                            })).initialize(l.Range), (n = Object(i.default)(s1).create({
                                                debug: e.debug,
                                                metricsConstants: e.metricsConstants,
                                                mediaPlayerModel: e.mediaPlayerModel
                                            })).initialize(l.Reporting, o), (t = Object(a1.default)(s1).create({
                                                debug: e.debug,
                                                eventBus: e.eventBus,
                                                metricsConstants: e.metricsConstants,
                                                events: e.events
                                            })).initialize(l.metrics, n);
                                        } catch (e) {
                                            throw u(), e;
                                        }
                                    },
                                    reset: u
                                };
                            }
                            o.__dashjs_factory_name = "MetricsController", t.default = dashjs.FactoryMaker.getClassFactory(o);
                        },
                        "./src/streaming/metrics/controllers/MetricsHandlersController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/metrics/metrics/MetricsHandlerFactory.js");
                            function i(e) {
                                e = e || {};
                                var t, n = [], i = this.context, a1 = e.eventBus, o = e.events, s1 = Object(r.default)(i).getInstance({
                                    debug: e.debug,
                                    eventBus: e.eventBus,
                                    metricsConstants: e.metricsConstants
                                });
                                function u(e) {
                                    n.forEach(function(t) {
                                        t.handleNewMetric(e.metric, e.value, e.mediaType);
                                    });
                                }
                                return t = {
                                    initialize: function(e, r) {
                                        e.split(",").forEach(function(e, t, i) {
                                            var a1;
                                            if (-1 !== e.indexOf("(") && -1 === e.indexOf(")")) {
                                                var o = i[t + 1];
                                                o && -1 === o.indexOf("(") && -1 !== o.indexOf(")") && (e += "," + o, delete i[t + 1]);
                                            }
                                            (a1 = s1.create(e, r)) && n.push(a1);
                                        }), a1.on(o.METRIC_ADDED, u, t), a1.on(o.METRIC_UPDATED, u, t);
                                    },
                                    reset: function() {
                                        a1.off(o.METRIC_ADDED, u, t), a1.off(o.METRIC_UPDATED, u, t), n.forEach(function(e) {
                                            return e.reset();
                                        }), n = [];
                                    }
                                };
                            }
                            i.__dashjs_factory_name = "MetricsHandlersController", t.default = dashjs.FactoryMaker.getClassFactory(i);
                        },
                        "./src/streaming/metrics/controllers/RangeController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/utils/CustomTimeRanges.js");
                            function i(e) {
                                e = e || {};
                                var t, n, i = !1, a1 = this.context, o = e.mediaElement;
                                return t = {
                                    initialize: function(e) {
                                        e && e.length && (e.forEach(function(e) {
                                            var t = e.starttime, r = t + e.duration;
                                            n.add(t, r);
                                        }), i = !!e[0]._useWallClockTime);
                                    },
                                    reset: function() {
                                        n.clear();
                                    },
                                    isEnabled: function() {
                                        var e, t = n.length;
                                        if (!t) return !0;
                                        e = i ? (new Date).getTime() / 1e3 : o.currentTime;
                                        for(var r = 0; r < t; r += 1){
                                            var a1 = n.start(r), s1 = n.end(r);
                                            if (a1 <= e && e < s1) return !0;
                                        }
                                        return !1;
                                    }
                                }, n = Object(r.default)(a1).create(), t;
                            }
                            i.__dashjs_factory_name = "RangeController", t.default = dashjs.FactoryMaker.getClassFactory(i);
                        },
                        "./src/streaming/metrics/controllers/ReportingController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/metrics/reporting/ReportingFactory.js");
                            function i(e) {
                                var t = [], n = Object(r.default)(this.context).getInstance(e);
                                return {
                                    initialize: function(e, r) {
                                        e.some(function(e) {
                                            var i = n.create(e, r);
                                            if (i) return t.push(i), !0;
                                        });
                                    },
                                    reset: function() {
                                        t.forEach(function(e) {
                                            return e.reset();
                                        }), t = [];
                                    },
                                    report: function(e, n) {
                                        t.forEach(function(t) {
                                            return t.report(e, n);
                                        });
                                    }
                                };
                            }
                            i.__dashjs_factory_name = "ReportingController", t.default = dashjs.FactoryMaker.getClassFactory(i);
                        },
                        "./src/streaming/metrics/metrics/MetricsHandlerFactory.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/metrics/metrics/handlers/BufferLevelHandler.js"), i = n("./src/streaming/metrics/metrics/handlers/DVBErrorsHandler.js"), a1 = n("./src/streaming/metrics/metrics/handlers/HttpListHandler.js"), o = n("./src/streaming/metrics/metrics/handlers/GenericMetricHandler.js");
                            function s1(e) {
                                var t, n = (e = e || {}).debug ? e.debug.getLogger(t) : {}, s1 = /([a-zA-Z]*)(\(([0-9]*)(\,\s*([a-zA-Z]*))?\))?/, u = this.context, l = {
                                    BufferLevel: r.default,
                                    DVBErrors: i.default,
                                    HttpList: a1.default,
                                    PlayList: o.default,
                                    RepSwitchList: o.default,
                                    TcpList: o.default
                                };
                                return {
                                    create: function(t, r) {
                                        var i, a1 = t.match(s1);
                                        if (a1) {
                                            try {
                                                (i = l[a1[1]](u).create({
                                                    eventBus: e.eventBus,
                                                    metricsConstants: e.metricsConstants
                                                })).initialize(a1[1], r, a1[3], a1[5]);
                                            } catch (e) {
                                                i = null, n.error("MetricsHandlerFactory: Could not create handler for type ".concat(a1[1], " with args ").concat(a1[3], ", ").concat(a1[5], " (").concat(e.message, ")"));
                                            }
                                            return i;
                                        }
                                    },
                                    register: function(e, t) {
                                        l[e] = t;
                                    },
                                    unregister: function(e) {
                                        delete l[e];
                                    }
                                };
                            }
                            s1.__dashjs_factory_name = "MetricsHandlerFactory", t.default = dashjs.FactoryMaker.getSingletonFactory(s1);
                        },
                        "./src/streaming/metrics/metrics/handlers/BufferLevelHandler.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/metrics/utils/HandlerHelpers.js");
                            function i(e) {
                                var t, n, i, a1, o;
                                e = e || {};
                                var s1 = this.context, u = Object(r.default)(s1).getInstance(), l = [], c = e.metricsConstants;
                                function d() {
                                    var e = function() {
                                        try {
                                            return Object.keys(l).map(function(e) {
                                                return l[e];
                                            }).reduce(function(e, t) {
                                                return e.level < t.level ? e : t;
                                            });
                                        } catch (e) {
                                            return;
                                        }
                                    }();
                                    e && o !== e.t && (o = e.t, t.report(i, e));
                                }
                                return {
                                    initialize: function(e, r, o) {
                                        r && (n = u.validateN(o), t = r, i = u.reconstructFullMetricName(e, o), a1 = setInterval(d, n));
                                    },
                                    reset: function() {
                                        clearInterval(a1), a1 = null, n = 0, t = null, o = null;
                                    },
                                    handleNewMetric: function(e, t, n) {
                                        e === c.BUFFER_LEVEL && (l[n] = t);
                                    }
                                };
                            }
                            i.__dashjs_factory_name = "BufferLevelHandler", t.default = dashjs.FactoryMaker.getClassFactory(i);
                        },
                        "./src/streaming/metrics/metrics/handlers/DVBErrorsHandler.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/metrics/MetricsReportingEvents.js");
                            t.default = dashjs.FactoryMaker.getClassFactory(function(e) {
                                var t, n = (e = e || {}).eventBus, i = e.metricsConstants;
                                function a1() {
                                    n.off(r.default.METRICS_INITIALISATION_COMPLETE, a1, this), n.trigger(r.default.BECAME_REPORTING_PLAYER);
                                }
                                return {
                                    initialize: function(e, i) {
                                        i && (t = i, n.on(r.default.METRICS_INITIALISATION_COMPLETE, a1, this));
                                    },
                                    reset: function() {
                                        t = null;
                                    },
                                    handleNewMetric: function(e, n) {
                                        e === i.DVB_ERRORS && t && t.report(e, n);
                                    }
                                };
                            });
                        },
                        "./src/streaming/metrics/metrics/handlers/GenericMetricHandler.js": function(e, t, n) {
                            "use strict";
                            function r() {
                                var e, t;
                                return {
                                    initialize: function(n, r) {
                                        e = n, t = r;
                                    },
                                    reset: function() {
                                        t = null, e = void 0;
                                    },
                                    handleNewMetric: function(n, r) {
                                        n === e && t && t.report(e, r);
                                    }
                                };
                            }
                            n.r(t), r.__dashjs_factory_name = "GenericMetricHandler", t.default = dashjs.FactoryMaker.getClassFactory(r);
                        },
                        "./src/streaming/metrics/metrics/handlers/HttpListHandler.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/metrics/utils/HandlerHelpers.js");
                            function i(e) {
                                var t, n, i, a1, o;
                                e = e || {};
                                var s1 = [], u = Object(r.default)(this.context).getInstance(), l = e.metricsConstants;
                                function c() {
                                    var e = s1;
                                    e.length && t && t.report(a1, e), s1 = [];
                                }
                                return {
                                    initialize: function(e, r, s1, l) {
                                        r && (n = u.validateN(s1), t = r, l && l.length && (i = l), a1 = u.reconstructFullMetricName(e, s1, l), o = setInterval(c, n));
                                    },
                                    reset: function() {
                                        clearInterval(o), o = null, n = null, i = null, s1 = [], t = null;
                                    },
                                    handleNewMetric: function(e, t) {
                                        e === l.HTTP_REQUEST && (i && i !== t.type || s1.push(t));
                                    }
                                };
                            }
                            i.__dashjs_factory_name = "HttpListHandler", t.default = dashjs.FactoryMaker.getClassFactory(i);
                        },
                        "./src/streaming/metrics/reporting/ReportingFactory.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/metrics/reporting/reporters/DVBReporting.js");
                            function i(e) {
                                e = e || {};
                                var t, n = {
                                    "urn:dvb:dash:reporting:2014": r.default
                                }, i = this.context, a1 = e.debug ? e.debug.getLogger(t) : {}, o = e.metricsConstants, s1 = e.mediaPlayerModel || {};
                                return {
                                    create: function(e, t) {
                                        var r;
                                        try {
                                            (r = n[e.schemeIdUri](i).create({
                                                metricsConstants: o,
                                                mediaPlayerModel: s1
                                            })).initialize(e, t);
                                        } catch (t) {
                                            r = null, a1.error("ReportingFactory: could not create Reporting with schemeIdUri ".concat(e.schemeIdUri, " (").concat(t.message, ")"));
                                        }
                                        return r;
                                    },
                                    register: function(e, t) {
                                        n[e] = t;
                                    },
                                    unregister: function(e) {
                                        delete n[e];
                                    }
                                };
                            }
                            i.__dashjs_factory_name = "ReportingFactory", t.default = dashjs.FactoryMaker.getSingletonFactory(i);
                        },
                        "./src/streaming/metrics/reporting/reporters/DVBReporting.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/metrics/utils/MetricSerialiser.js"), i = n("./src/streaming/metrics/utils/RNG.js"), a1 = n("./src/streaming/models/CustomParametersModel.js");
                            function o(e) {
                                var t;
                                e = e || {};
                                var n, o, s1, u, l, c, d, f = this.context, h = [], g = e.metricsConstants;
                                function p() {
                                    u = !1, l = !1, c = null, d = null;
                                }
                                return t = {
                                    report: function(e, t) {
                                        Array.isArray(t) || (t = [
                                            t
                                        ]), l && d.isEnabled() && t.forEach(function(t) {
                                            var r = n.serialise(t);
                                            e !== g.DVB_ERRORS && (r = "metricname=".concat(e, "&").concat(r)), function(e, t, n) {
                                                var r = new XMLHttpRequest;
                                                r.withCredentials = o.getXHRWithCredentialsForType(g.HTTP_REQUEST_DVB_REPORTING_TYPE);
                                                var i = function() {
                                                    var e = h.indexOf(r);
                                                    -1 !== e && (h.splice(e, 1), !(r.status >= 200 && r.status < 300) && n && n());
                                                };
                                                h.push(r);
                                                try {
                                                    r.open("GET", e), r.onloadend = i, r.onerror = i, r.send();
                                                } catch (e) {
                                                    r.onerror();
                                                }
                                            }(r = "".concat(c, "?").concat(r), 0, function() {
                                                l = !1;
                                            });
                                        });
                                    },
                                    initialize: function(e, t) {
                                        var n;
                                        if (d = t, !(c = e.dvb_reportingUrl)) throw new Error("required parameter missing (dvb:reportingUrl)");
                                        u || ((n = e.dvb_probability) && (1e3 === n || n / 1e3 >= s1.random()) && (l = !0), u = !0);
                                    },
                                    reset: function() {
                                        p();
                                    }
                                }, n = Object(r.default)(f).getInstance(), s1 = Object(i.default)(f).getInstance(), o = Object(a1.default)(f).getInstance(), p(), t;
                            }
                            o.__dashjs_factory_name = "DVBReporting", t.default = dashjs.FactoryMaker.getClassFactory(o);
                        },
                        "./src/streaming/metrics/utils/DVBErrorsTranslator.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/metrics/vo/DVBErrors.js"), i = n("./src/streaming/metrics/MetricsReportingEvents.js");
                            function a1(e) {
                                var t, n, a1 = (e = e || {}).eventBus, o = e.dashMetrics, s1 = e.metricsConstants, u = e.events;
                                function l(e) {
                                    var t = new r.default;
                                    if (n) {
                                        for(var i in e)e.hasOwnProperty(i) && (t[i] = e[i]);
                                        t.mpdurl || (t.mpdurl = n.originalUrl || n.url), t.terror || (t.terror = new Date), o.addDVBErrors(t);
                                    }
                                }
                                function c(e) {
                                    e.error || (n = e.manifest);
                                }
                                function d(e) {
                                    l({
                                        errorcode: r.default.BASE_URL_CHANGED,
                                        servicelocation: e.entry
                                    });
                                }
                                function f() {
                                    l({
                                        errorcode: r.default.BECAME_REPORTER
                                    });
                                }
                                function h(e) {
                                    var t;
                                    e.metric === s1.HTTP_REQUEST && (0 === (t = e.value).responsecode || null == t.responsecode || t.responsecode >= 400 || t.responsecode < 100 || t.responsecode >= 600) && l({
                                        errorcode: t.responsecode || r.default.CONNECTION_ERROR,
                                        url: t.url,
                                        terror: t.tresponse,
                                        servicelocation: t._serviceLocation
                                    });
                                }
                                function g(e) {
                                    var t;
                                    switch(e.error ? e.error.code : 0){
                                        case MediaError.MEDIA_ERR_NETWORK:
                                            t = r.default.CONNECTION_ERROR;
                                            break;
                                        case MediaError.MEDIA_ERR_DECODE:
                                            t = r.default.CORRUPT_MEDIA_OTHER;
                                            break;
                                        default:
                                            return;
                                    }
                                    l({
                                        errorcode: t
                                    });
                                }
                                return t = {
                                    initialise: function() {
                                        a1.on(u.MANIFEST_UPDATED, c, t), a1.on(u.SERVICE_LOCATION_BLACKLIST_CHANGED, d, t), a1.on(u.METRIC_ADDED, h, t), a1.on(u.METRIC_UPDATED, h, t), a1.on(u.PLAYBACK_ERROR, g, t), a1.on(i.default.BECAME_REPORTING_PLAYER, f, t);
                                    },
                                    reset: function() {
                                        a1.off(u.MANIFEST_UPDATED, c, t), a1.off(u.SERVICE_LOCATION_BLACKLIST_CHANGED, d, t), a1.off(u.METRIC_ADDED, h, t), a1.off(u.METRIC_UPDATED, h, t), a1.off(u.PLAYBACK_ERROR, g, t), a1.off(i.default.BECAME_REPORTING_PLAYER, f, t);
                                    }
                                };
                            }
                            a1.__dashjs_factory_name = "DVBErrorsTranslator", t.default = dashjs.FactoryMaker.getSingletonFactory(a1);
                        },
                        "./src/streaming/metrics/utils/HandlerHelpers.js": function(e, t, n) {
                            "use strict";
                            function r() {
                                return {
                                    reconstructFullMetricName: function(e, t, n) {
                                        var r = e;
                                        return t && (r += "(" + t, n && n.length && (r += "," + n), r += ")"), r;
                                    },
                                    validateN: function(e) {
                                        if (!e) throw new Error("missing n");
                                        if (isNaN(e)) throw new Error("n is NaN");
                                        if (e < 0) throw new Error("n must be positive");
                                        return e;
                                    }
                                };
                            }
                            n.r(t), r.__dashjs_factory_name = "HandlerHelpers", t.default = dashjs.FactoryMaker.getSingletonFactory(r);
                        },
                        "./src/streaming/metrics/utils/ManifestParsing.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/metrics/vo/Metrics.js"), i = n("./src/streaming/metrics/vo/Range.js"), a1 = n("./src/streaming/metrics/vo/Reporting.js");
                            function o(e) {
                                var t = (e = e || {}).adapter, n = e.constants;
                                return {
                                    getMetrics: function(e) {
                                        var o = [];
                                        return e && e.Metrics_asArray && e.Metrics_asArray.forEach(function(s1) {
                                            var u = new r.default, l = t.getIsDynamic(e);
                                            s1.hasOwnProperty("metrics") && (u.metrics = s1.metrics, s1.Range_asArray && s1.Range_asArray.forEach(function(r) {
                                                var a1 = new i.default;
                                                a1.starttime = function(e, r, i) {
                                                    var a1, o, s1 = 0;
                                                    return r ? s1 = t.getAvailabilityStartTime(e) / 1e3 : (a1 = t.getRegularPeriods(e)).length && (s1 = a1[0].start), o = s1, i && i.hasOwnProperty(n.START_TIME) && (o += i.starttime), o;
                                                }(e, l, r), r.hasOwnProperty("duration") ? a1.duration = r.duration : a1.duration = t.getDuration(e), a1._useWallClockTime = l, u.Range.push(a1);
                                            }), s1.Reporting_asArray && (s1.Reporting_asArray.forEach(function(e) {
                                                var t = new a1.default;
                                                e.hasOwnProperty(n.SCHEME_ID_URI) && (t.schemeIdUri = e.schemeIdUri, e.hasOwnProperty("value") && (t.value = e.value), e.hasOwnProperty(n.DVB_REPORTING_URL) && (t.dvb_reportingUrl = e[n.DVB_REPORTING_URL]), e.hasOwnProperty(n.DVB_PROBABILITY) && (t.dvb_probability = e[n.DVB_PROBABILITY]), u.Reporting.push(t));
                                            }), o.push(u)));
                                        }), o;
                                    }
                                };
                            }
                            o.__dashjs_factory_name = "ManifestParsing", t.default = dashjs.FactoryMaker.getSingletonFactory(o);
                        },
                        "./src/streaming/metrics/utils/MetricSerialiser.js": function(e, t, n) {
                            "use strict";
                            function r() {
                                return {
                                    serialise: function e(t) {
                                        var n, r, i = [], a1 = [];
                                        for(n in t)if (t.hasOwnProperty(n) && 0 !== n.indexOf("_")) {
                                            if (null == (r = t[n]) && (r = ""), Array.isArray(r)) {
                                                if (!r.length) continue;
                                                a1 = [], r.forEach(function(t) {
                                                    var n = "Object" !== Object.prototype.toString.call(t).slice(8, -1);
                                                    a1.push(n ? t : e(t));
                                                }), r = a1.map(encodeURIComponent).join(",");
                                            } else "string" == typeof r ? r = encodeURIComponent(r) : r instanceof Date ? r = r.toISOString() : "number" == typeof r && (r = Math.round(r));
                                            i.push(n + "=" + r);
                                        }
                                        return i.join("&");
                                    }
                                };
                            }
                            n.r(t), r.__dashjs_factory_name = "MetricSerialiser", t.default = dashjs.FactoryMaker.getSingletonFactory(r);
                        },
                        "./src/streaming/metrics/utils/RNG.js": function(e, t, n) {
                            "use strict";
                            function r() {
                                var e, t, n, r = window.crypto || window.msCrypto, i = Uint32Array, a1 = Math.pow(2, 8 * i.BYTES_PER_ELEMENT) - 1;
                                function o() {
                                    r && (e || (e = new i(10)), r.getRandomValues(e), t = 0);
                                }
                                return n = {
                                    random: function(n, i) {
                                        var s1;
                                        return n || (n = 0), i || (i = 1), r ? (t === e.length && o(), s1 = e[t] / a1, t += 1) : s1 = Math.random(), s1 * (i - n) + n;
                                    }
                                }, o(), n;
                            }
                            n.r(t), r.__dashjs_factory_name = "RNG", t.default = dashjs.FactoryMaker.getSingletonFactory(r);
                        },
                        "./src/streaming/metrics/vo/DVBErrors.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.mpdurl = null, this.errorcode = null, this.terror = null, this.url = null, this.ipaddress = null, this.servicelocation = null;
                            };
                            r.SSL_CONNECTION_FAILED_PREFIX = "SSL", r.DNS_RESOLUTION_FAILED = "C00", r.HOST_UNREACHABLE = "C01", r.CONNECTION_REFUSED = "C02", r.CONNECTION_ERROR = "C03", r.CORRUPT_MEDIA_ISOBMFF = "M00", r.CORRUPT_MEDIA_OTHER = "M01", r.BASE_URL_CHANGED = "F00", r.BECAME_REPORTER = "S00", t.default = r;
                        },
                        "./src/streaming/metrics/vo/Metrics.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.metrics = "", this.Range = [], this.Reporting = [];
                            };
                        },
                        "./src/streaming/metrics/vo/Range.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.starttime = 0, this.duration = 1 / 0, this._useWallClockTime = !1;
                            };
                        },
                        "./src/streaming/metrics/vo/Reporting.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.schemeIdUri = "", this.value = "", this.dvb_reportingUrl = "", this.dvb_probability = 1e3;
                            };
                        },
                        "./src/streaming/models/BaseURLTreeModel.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/utils/ObjectUtils.js"), i = n("./src/core/FactoryMaker.js"), a1 = NaN, o = function e(t, n) {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.data = {
                                    baseUrls: t || null,
                                    selectedIdx: n || a1
                                }, this.children = [];
                            };
                            function s1() {
                                var e, t, n, i = this.context, s1 = Object(r.default)(i).getInstance();
                                function u(e, t, r) {
                                    var i = n.getBaseURLsFromElement(r);
                                    e[t] ? s1.areEqual(i, e[t].data.baseUrls) || (e[t].data.baseUrls = i, e[t].data.selectedIdx = a1) : e[t] = new o(i);
                                }
                                function l(e, n) {
                                    var r = n || t;
                                    e(r.data), r.children && r.children.forEach(function(t) {
                                        return l(e, t);
                                    });
                                }
                                function c() {
                                    t = new o;
                                }
                                return e = {
                                    reset: c,
                                    update: function(e) {
                                        !function(e) {
                                            !function() {
                                                if (!n || !n.hasOwnProperty("getBaseURLsFromElement") || !n.hasOwnProperty("getRepresentationSortFunction")) throw new Error("setConfig function has to be called previously");
                                            }();
                                            var r = n.getBaseURLsFromElement(e);
                                            s1.areEqual(r, t.data.baseUrls) || (t.data.baseUrls = r, t.data.selectedIdx = a1), e && e.Period_asArray && e.Period_asArray.forEach(function(e, r) {
                                                u(t.children, r, e), e.AdaptationSet_asArray && e.AdaptationSet_asArray.forEach(function(e, i) {
                                                    u(t.children[r].children, i, e), e.Representation_asArray && e.Representation_asArray.sort(n.getRepresentationSortFunction()).forEach(function(e, n) {
                                                        u(t.children[r].children[i].children, n, e);
                                                    });
                                                });
                                            });
                                        }(e);
                                    },
                                    getForPath: function(e) {
                                        var n = t, r = [
                                            n.data
                                        ];
                                        return e && e.forEach(function(e) {
                                            (n = n.children[e]) && r.push(n.data);
                                        }), r.filter(function(e) {
                                            return e.baseUrls.length;
                                        });
                                    },
                                    invalidateSelectedIndexes: function(e) {
                                        l(function(t) {
                                            isNaN(t.selectedIdx) || e === t.baseUrls[t.selectedIdx].serviceLocation && (t.selectedIdx = a1);
                                        });
                                    },
                                    setConfig: function(e) {
                                        e.adapter && (n = e.adapter);
                                    }
                                }, c(), e;
                            }
                            s1.__dashjs_factory_name = "BaseURLTreeModel", t.default = i.default.getClassFactory(s1);
                        },
                        "./src/streaming/models/CmcdModel.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/EventBus.js"), i = n("./src/streaming/MediaPlayerEvents.js"), a1 = n("./src/streaming/metrics/MetricsReportingEvents.js"), o = n("./src/core/FactoryMaker.js"), s1 = n("./src/core/Settings.js"), u = n("./src/streaming/constants/Constants.js"), l = n("./src/streaming/vo/metrics/HTTPRequest.js"), c = n("./src/dash/models/DashManifestModel.js"), d = n("./src/core/Utils.js");
                            function f(e, t) {
                                var n;
                                if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
                                    if (Array.isArray(e) || (n = function(e, t) {
                                        if (e) {
                                            if ("string" == typeof e) return h(e, t);
                                            var n = Object.prototype.toString.call(e).slice(8, -1);
                                            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? h(e, t) : void 0;
                                        }
                                    }(e)) || t && e && "number" == typeof e.length) {
                                        n && (e = n);
                                        var r = 0, i = function() {};
                                        return {
                                            s: i,
                                            n: function() {
                                                return r >= e.length ? {
                                                    done: !0
                                                } : {
                                                    done: !1,
                                                    value: e[r++]
                                                };
                                            },
                                            e: function(e) {
                                                throw e;
                                            },
                                            f: i
                                        };
                                    }
                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }
                                var a1, o = !0, s1 = !1;
                                return {
                                    s: function() {
                                        n = e[Symbol.iterator]();
                                    },
                                    n: function() {
                                        var e = n.next();
                                        return o = e.done, e;
                                    },
                                    e: function(e) {
                                        s1 = !0, a1 = e;
                                    },
                                    f: function() {
                                        try {
                                            o || null == n.return || n.return();
                                        } finally{
                                            if (s1) throw a1;
                                        }
                                    }
                                };
                            }
                            function h(e, t) {
                                (null == t || t > e.length) && (t = e.length);
                                for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                                return r;
                            }
                            function g() {
                                var e, t, n, o, h, g, p, m, v, y, E = this.context, T = Object(r.default)(E).getInstance(), b = Object(s1.default)(E).getInstance();
                                function A() {
                                    n = {
                                        pr: 1,
                                        nor: null,
                                        st: null,
                                        sf: null,
                                        sid: "".concat(d.default.generateUuid()),
                                        cid: null
                                    }, v = {}, m = {}, y = {}, S();
                                }
                                function _() {
                                    S();
                                }
                                function S() {
                                    if (g) {
                                        var e = g.getStreamController();
                                        if (e && "function" == typeof e.getActiveStream) {
                                            var t = e.getActiveStream();
                                            t && (p = t.getProcessors());
                                        }
                                    }
                                }
                                function w(e, t) {
                                    var n, r = {}, i = f(t);
                                    try {
                                        for(i.s(); !(n = i.n()).done;){
                                            var a1 = n.value;
                                            e[a1] && (r[a1] = e[a1]);
                                        }
                                    } catch (e) {
                                        i.e(e);
                                    } finally{
                                        i.f();
                                    }
                                    return r;
                                }
                                function I(e) {
                                    var t = b.get().streaming.cmcd.enabledKeys;
                                    return e.filter(function(e) {
                                        return t.includes(e);
                                    });
                                }
                                function R(e) {
                                    try {
                                        return e.type === l.HTTPRequest.MPD_TYPE ? ((r = C()).ot = "m", r) : e.type === l.HTTPRequest.MEDIA_SEGMENT_TYPE ? (t = e.mediaType, y.hasOwnProperty(t) || (y[t] = !1), m.hasOwnProperty(t) || (m[t] = !1), v.hasOwnProperty(t) || (v[t] = !1), function(e) {
                                            var t, r = C(), i = function(e) {
                                                try {
                                                    var t = e.quality, n = e.mediaInfo.bitrateList;
                                                    return parseInt(n[t].bandwidth / 1e3);
                                                } catch (e) {
                                                    return null;
                                                }
                                            }(e), a1 = function(e) {
                                                try {
                                                    return isNaN(e.duration) ? null : Math.round(1e3 * e.duration);
                                                } catch (e) {
                                                    return null;
                                                }
                                            }(e), s1 = function(e) {
                                                try {
                                                    return 100 * parseInt(o.getThroughputHistory().getSafeAverageThroughput(e) / 100);
                                                } catch (e) {
                                                    return null;
                                                }
                                            }(e.mediaType), l = function(e) {
                                                try {
                                                    var t = n.pr, r = h.getCurrentBufferLevel(e);
                                                    return isNaN(t) || isNaN(r) ? null : 100 * parseInt(r / t * 10);
                                                } catch (e) {
                                                    return null;
                                                }
                                            }(e.mediaType), c = D(e.mediaType), E = function(e) {
                                                try {
                                                    var t = o.getTopBitrateInfoFor(e);
                                                    return Math.round(t.bitrate / 1e3);
                                                } catch (e) {
                                                    return null;
                                                }
                                            }(e.mediaType), T = n.pr, A = function(e) {
                                                if (p && 0 !== p.length) {
                                                    var t, n = f(p);
                                                    try {
                                                        for(n.s(); !(t = n.n()).done;){
                                                            var r = t.value;
                                                            if (r.getType() === e) return r.probeNextRequest();
                                                        }
                                                    } catch (e) {
                                                        n.e(e);
                                                    } finally{
                                                        n.f();
                                                    }
                                                }
                                            }(e.mediaType);
                                            e.mediaType === u.default.VIDEO && (t = "v"), e.mediaType === u.default.AUDIO && (t = "a"), e.mediaType === u.default.TEXT && (t = "application/mp4" === e.mediaInfo.mimeType ? "tt" : "c");
                                            var _ = b.get().streaming.cmcd.rtp;
                                            return _ || (_ = function(e) {
                                                var t = g.getPlaybackRate();
                                                t || (t = 1);
                                                var n = e.quality, r = e.mediaType, i = e.mediaInfo, a1 = e.duration, o = D(r);
                                                0 === o && (o = 500);
                                                var s1 = i.bitrateList[n].bandwidth * a1 / 1e3 / (o / t / 1e3), u = b.get().streaming.cmcd.rtpSafetyFactor && !isNaN(b.get().streaming.cmcd.rtpSafetyFactor) ? b.get().streaming.cmcd.rtpSafetyFactor : 5;
                                                return 100 * (parseInt(s1 * u / 100) + 1);
                                            }(e)), r.rtp = _, A && (e.url !== A.url ? r.nor = encodeURIComponent(d.default.getRelativeUrl(e.url, A.url)) : A.range && (r.nrr = A.range)), i && (r.br = i), t && (r.ot = t), isNaN(a1) || (r.d = a1), isNaN(s1) || (r.mtp = s1), isNaN(l) || (r.dl = l), isNaN(c) || (r.bl = c), isNaN(E) || (r.tb = E), isNaN(T) || 1 === T || (r.pr = T), v[e.mediaType] && (r.bs = !0, v[e.mediaType] = !1), !m[e.mediaType] && y[e.mediaType] || (r.su = !0, m[e.mediaType] = !1, y[e.mediaType] = !0), r;
                                        }(e)) : e.type === l.HTTPRequest.INIT_SEGMENT_TYPE ? function() {
                                            var e = C();
                                            return e.ot = "i", e.su = !0, e;
                                        }() : e.type === l.HTTPRequest.OTHER_TYPE || e.type === l.HTTPRequest.XLINK_EXPANSION_TYPE ? function() {
                                            var e = C();
                                            return e.ot = "o", e;
                                        }() : e.type === l.HTTPRequest.LICENSE ? function(e) {
                                            var t = C();
                                            return t.ot = "k", t;
                                        }() : null;
                                    } catch (e) {
                                        return null;
                                    }
                                    var t, r;
                                }
                                function C() {
                                    var e = {}, t = b.get().streaming.cmcd.cid ? b.get().streaming.cmcd.cid : n.cid;
                                    return e.v = 1, e.sid = b.get().streaming.cmcd.sid ? b.get().streaming.cmcd.sid : n.sid, e.sid = "".concat(e.sid), t && (e.cid = "".concat(t)), isNaN(n.pr) || 1 === n.pr || null === n.pr || (e.pr = n.pr), n.st && (e.st = n.st), n.sf && (e.sf = n.sf), e;
                                }
                                function D(e) {
                                    try {
                                        var t = h.getCurrentBufferLevel(e);
                                        return isNaN(t) ? null : 100 * parseInt(10 * t);
                                    } catch (e) {
                                        return null;
                                    }
                                }
                                function k(e) {
                                    try {
                                        n.pr = e.playbackRate;
                                    } catch (e) {}
                                }
                                function N(t) {
                                    try {
                                        var r = e.getIsDynamic(t.data) ? "l" : "v", i = t.protocol && "MSS" === t.protocol ? "s" : "d";
                                        n.st = "".concat(r), n.sf = "".concat(i);
                                    } catch (e) {}
                                }
                                function L(e) {
                                    try {
                                        e.state && e.mediaType && e.state === i.default.BUFFER_EMPTY && (v[e.mediaType] || (v[e.mediaType] = !0), m[e.mediaType] || (m[e.mediaType] = !0));
                                    } catch (e) {}
                                }
                                function x() {
                                    for(var e in v)v.hasOwnProperty(e) && (v[e] = !0);
                                    for(var t in m)m.hasOwnProperty(t) && (m[t] = !0);
                                }
                                function M(e) {
                                    try {
                                        if (!e) return null;
                                        var t = Object.keys(e).sort(function(e, t) {
                                            return e.localeCompare(t);
                                        }), n = t.length, r = t.reduce(function(t, r, i) {
                                            return "v" === r && 1 === e[r] || ("string" == typeof e[r] && "ot" !== r && "sf" !== r && "st" !== r ? t += "".concat(r, "=").concat(JSON.stringify(e[r])) : t += "".concat(r, "=").concat(e[r]), i < n - 1 && (t += ",")), t;
                                        }, "");
                                        return (r = r.replace(/=true/g, "")).replace(/,\s*$/, "");
                                    } catch (e) {
                                        return null;
                                    }
                                }
                                return t = {
                                    getQueryParameter: function(e) {
                                        try {
                                            if (b.get().streaming.cmcd && b.get().streaming.cmcd.enabled) {
                                                var t = R(e), n = function(e) {
                                                    try {
                                                        var t = b.get().streaming.cmcd.enabledKeys;
                                                        return Object.keys(e).filter(function(e) {
                                                            return t.includes(e);
                                                        }).reduce(function(t, n) {
                                                            return t[n] = e[n], t;
                                                        }, {});
                                                    } catch (t) {
                                                        return e;
                                                    }
                                                }(t), r = M(n);
                                                return T.trigger(a1.default.CMCD_DATA_GENERATED, {
                                                    url: e.url,
                                                    mediaType: e.mediaType,
                                                    cmcdData: t,
                                                    cmcdString: r
                                                }), {
                                                    key: "CMCD",
                                                    value: r
                                                };
                                            }
                                            return null;
                                        } catch (e) {
                                            return null;
                                        }
                                    },
                                    getHeaderParameters: function(e) {
                                        try {
                                            if (b.get().streaming.cmcd && b.get().streaming.cmcd.enabled) {
                                                var t = R(e), n = w(t, I([
                                                    "br",
                                                    "d",
                                                    "ot",
                                                    "tb"
                                                ])), r = w(t, I([
                                                    "bl",
                                                    "dl",
                                                    "mtp",
                                                    "nor",
                                                    "nrr",
                                                    "su"
                                                ])), i = w(t, I([
                                                    "bs",
                                                    "rtp"
                                                ])), o = w(t, I([
                                                    "cid",
                                                    "pr",
                                                    "sf",
                                                    "sid",
                                                    "st",
                                                    "v"
                                                ])), s1 = {
                                                    "CMCD-Object": M(n),
                                                    "CMCD-Request": M(r),
                                                    "CMCD-Status": M(i),
                                                    "CMCD-Session": M(o)
                                                };
                                                return T.trigger(a1.default.CMCD_DATA_GENERATED, {
                                                    url: e.url,
                                                    mediaType: e.mediaType,
                                                    cmcdData: t,
                                                    headers: s1
                                                }), s1;
                                            }
                                            return null;
                                        } catch (e) {
                                            return null;
                                        }
                                    },
                                    setConfig: function(e) {
                                        e && (e.abrController && (o = e.abrController), e.dashMetrics && (h = e.dashMetrics), e.playbackController && (g = e.playbackController));
                                    },
                                    reset: function() {
                                        T.off(i.default.PLAYBACK_RATE_CHANGED, k, this), T.off(i.default.MANIFEST_LOADED, N, this), T.off(i.default.BUFFER_LEVEL_STATE_CHANGED, L, t), T.off(i.default.PLAYBACK_SEEKED, x, t), A();
                                    },
                                    initialize: function() {
                                        T.on(i.default.PLAYBACK_RATE_CHANGED, k, t), T.on(i.default.MANIFEST_LOADED, N, t), T.on(i.default.BUFFER_LEVEL_STATE_CHANGED, L, t), T.on(i.default.PLAYBACK_SEEKED, x, t), T.on(i.default.PERIOD_SWITCH_COMPLETED, _, t);
                                    }
                                }, e = Object(c.default)(E).getInstance(), A(), t;
                            }
                            g.__dashjs_factory_name = "CmcdModel", t.default = o.default.getSingletonFactory(g);
                        },
                        "./src/streaming/models/CustomParametersModel.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/dash/vo/UTCTiming.js"), i = n("./src/core/FactoryMaker.js"), a1 = n("./src/core/Settings.js"), o = n("./src/streaming/utils/SupervisorTools.js"), s1 = n("./src/streaming/rules/abr/ABRRulesCollection.js"), u = n("./src/streaming/constants/Constants.js");
                            function l() {
                                var e, t, n, i, l, c, d, f, h = this.context, g = Object(a1.default)(h).getInstance();
                                function p() {
                                    i = [], l = [], c = [], f = [], d = null, t = [];
                                }
                                function m(e, t) {
                                    var n = -1;
                                    e.some(function(e, r) {
                                        if (e === t) return n = r, !0;
                                    }), n < 0 || e.splice(n, 1);
                                }
                                function v(e) {
                                    var t;
                                    for(t = 0; t < f.length; t++)if (f[t].rulename === e) return t;
                                    return -1;
                                }
                                function y(e, n) {
                                    E(e, n);
                                    var i = new r.default;
                                    i.schemeIdUri = e, i.value = n, t.push(i);
                                }
                                function E(e, n) {
                                    Object(o.checkParameterType)(e, "string"), Object(o.checkParameterType)(n, "string"), t.forEach(function(r, i) {
                                        r.schemeIdUri === e && r.value === n && t.splice(i, 1);
                                    });
                                }
                                return e = {
                                    getCustomInitialTrackSelectionFunction: function() {
                                        return d;
                                    },
                                    setCustomInitialTrackSelectionFunction: function(e) {
                                        d = e;
                                    },
                                    resetCustomInitialTrackSelectionFunction: function() {
                                        d = null;
                                    },
                                    getLicenseResponseFilters: function() {
                                        return l;
                                    },
                                    getLicenseRequestFilters: function() {
                                        return i;
                                    },
                                    getCustomCapabilitiesFilters: function() {
                                        return c;
                                    },
                                    registerCustomCapabilitiesFilter: function(e) {
                                        c.push(e);
                                    },
                                    registerLicenseResponseFilter: function(e) {
                                        l.push(e);
                                    },
                                    registerLicenseRequestFilter: function(e) {
                                        i.push(e);
                                    },
                                    unregisterCustomCapabilitiesFilter: function(e) {
                                        m(c, e);
                                    },
                                    unregisterLicenseResponseFilter: function(e) {
                                        m(l, e);
                                    },
                                    unregisterLicenseRequestFilter: function(e) {
                                        m(i, e);
                                    },
                                    addAbrCustomRule: function(e, t, n) {
                                        if ("string" != typeof e || e !== s1.default.ABANDON_FRAGMENT_RULES && e !== s1.default.QUALITY_SWITCH_RULES || "string" != typeof t) throw u.default.BAD_ARGUMENT_ERROR;
                                        var r = v(t);
                                        -1 === r ? f.push({
                                            type: e,
                                            rulename: t,
                                            rule: n
                                        }) : (f[r].type = e, f[r].rule = n);
                                    },
                                    removeAllAbrCustomRule: function() {
                                        f = [];
                                    },
                                    removeAbrCustomRule: function(e) {
                                        if (e) {
                                            var t = v(e);
                                            -1 !== t && f.splice(t, 1);
                                        } else f = [];
                                    },
                                    getAbrCustomRules: function() {
                                        return f;
                                    },
                                    addUTCTimingSource: y,
                                    removeUTCTimingSource: E,
                                    getUTCTimingSources: function() {
                                        return t;
                                    },
                                    clearDefaultUTCTimingSources: function() {
                                        t = [];
                                    },
                                    restoreDefaultUTCTimingSources: function() {
                                        var e = g.get().streaming.utcSynchronization.defaultTimingSource;
                                        y(e.scheme, e.value);
                                    },
                                    setXHRWithCredentialsForType: function e(t, r) {
                                        t ? n[t] = !!r : Object.keys(n).forEach(function(t) {
                                            e(t, r);
                                        });
                                    },
                                    getXHRWithCredentialsForType: function(e) {
                                        var t = n[e];
                                        return void 0 === t ? n.default : t;
                                    },
                                    setConfig: function() {},
                                    reset: function() {
                                        p();
                                    }
                                }, n = {
                                    default: !1
                                }, p(), e;
                            }
                            l.__dashjs_factory_name = "CustomParametersModel", t.default = i.default.getSingletonFactory(l);
                        },
                        "./src/streaming/models/FragmentModel.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/streaming/vo/FragmentRequest.js"), a1 = "loading", o = "executed", s1 = "failed";
                            function u(e) {
                                var t, n, r, u, l = (e = e || {}).eventBus, c = e.events, d = e.dashMetrics, f = e.fragmentLoader, h = e.debug, g = e.streamInfo, p = e.type;
                                function m(e) {
                                    var t;
                                    return !!e && (t = !1, r.some(function(n) {
                                        if (r = e, a1 = n, !isNaN(r.index) && r.startTime === a1.startTime && r.adaptationIndex === a1.adaptationIndex && r.type === a1.type || function(e, t) {
                                            return isNaN(e.index) && isNaN(t.index) && e.quality === t.quality;
                                        }(e, n) || function(e, t) {
                                            return e.action === i.default.ACTION_COMPLETE && e.action === t.action;
                                        }(e, n)) return t = !0;
                                        var r, a1;
                                    }), t);
                                }
                                function v(e) {
                                    return isNaN(e.duration) ? .25 : Math.min(e.duration / 8, .5);
                                }
                                function y(e) {
                                    r = r.filter(function(t) {
                                        var n = v(t);
                                        return isNaN(t.startTime) || void 0 !== e && t.startTime >= e - n;
                                    });
                                }
                                function E(e, t) {
                                    t <= e + .5 || (r = r.filter(function(n) {
                                        var r = v(n);
                                        return isNaN(n.startTime) || n.startTime >= t - r || isNaN(n.duration) || n.startTime + n.duration <= e + r;
                                    }));
                                }
                                function T(e, t, n) {
                                    for(var r = e.length - 1; r >= 0; r--){
                                        var i = e[r], a1 = i.startTime, o = a1 + i.duration;
                                        if (n = isNaN(n) ? v(i) : n, !isNaN(a1) && !isNaN(o) && t + n >= a1 && t - n < o || isNaN(a1) && isNaN(t)) return i;
                                    }
                                    return null;
                                }
                                function b(e, t) {
                                    d.addSchedulingInfo(e, t), d.addRequestsQueue(e.mediaType, u, r);
                                }
                                function A(e) {
                                    e.sender === f && (u.splice(u.indexOf(e.request), 1), e.response && !e.error && r.push(e.request), b(e.request, e.error ? s1 : o), l.trigger(c.FRAGMENT_LOADING_COMPLETED, {
                                        request: e.request,
                                        response: e.response,
                                        error: e.error,
                                        sender: this
                                    }, {
                                        streamId: g.id,
                                        mediaType: p
                                    }));
                                }
                                function _(e) {
                                    e.sender === f && l.trigger(c.FRAGMENT_LOADING_PROGRESS, {
                                        request: e.request,
                                        response: e.response,
                                        error: e.error,
                                        sender: this
                                    }, {
                                        streamId: g.id,
                                        mediaType: p
                                    });
                                }
                                function S(e) {
                                    e.sender === f && l.trigger(c.FRAGMENT_LOADING_ABANDONED, {
                                        request: e.request
                                    }, {
                                        streamId: g.id,
                                        mediaType: p
                                    });
                                }
                                function w() {
                                    r = [], u = [];
                                }
                                return t = {
                                    getStreamId: function() {
                                        return g.id;
                                    },
                                    getType: function() {
                                        return p;
                                    },
                                    getRequests: function(e) {
                                        var t = e ? e.state instanceof Array ? e.state : [
                                            e.state
                                        ] : [], n = [];
                                        return t.forEach(function(t) {
                                            var i = function(e) {
                                                var t;
                                                switch(e){
                                                    case a1:
                                                        t = u;
                                                        break;
                                                    case o:
                                                        t = r;
                                                        break;
                                                    default:
                                                        t = [];
                                                }
                                                return t;
                                            }(t);
                                            n = n.concat(function(e, t) {
                                                return t.hasOwnProperty("time") ? [
                                                    T(e, t.time, t.threshold)
                                                ] : e.filter(function(e) {
                                                    for(var n in t)if ("state" !== n && t.hasOwnProperty(n) && e[n] != t[n]) return !1;
                                                    return !0;
                                                });
                                            }(i, e));
                                        }), n;
                                    },
                                    isFragmentLoaded: m,
                                    isFragmentLoadedOrPending: function(e) {
                                        var t, n = !1, r = 0;
                                        if (!(n = m(e))) for(r = 0; r < u.length; r++)t = u[r], e.url === t.url && e.startTime === t.startTime && (n = !0);
                                        return n;
                                    },
                                    removeExecutedRequestsBeforeTime: y,
                                    removeExecutedRequestsAfterTime: function(e) {
                                        r = r.filter(function(t) {
                                            return isNaN(t.startTime) || void 0 !== e && t.startTime < e;
                                        });
                                    },
                                    syncExecutedRequestsWithBufferedRange: function(e, t) {
                                        if (e && 0 !== e.length) {
                                            for(var n = 0, r = 0, i = e.length; r < i; r++)E(n, e.start(r)), n = e.end(r);
                                            t > 0 && E(n, t);
                                        } else y();
                                    },
                                    abortRequests: function() {
                                        n.debug("abort requests"), f.abort(), u = [];
                                    },
                                    executeRequest: function(e) {
                                        e.action === i.default.ACTION_DOWNLOAD ? (b(e, a1), u.push(e), function(e) {
                                            l.trigger(c.FRAGMENT_LOADING_STARTED, {
                                                request: e
                                            }, {
                                                streamId: g.id,
                                                mediaType: p
                                            }), f.load(e);
                                        }(e)) : n.warn("Unknown request action.");
                                    },
                                    reset: function() {
                                        l.off(c.LOADING_COMPLETED, A, this), l.off(c.LOADING_DATA_PROGRESS, _, this), l.off(c.LOADING_ABANDONED, S, this), f && f.reset(), w();
                                    },
                                    resetInitialSettings: w,
                                    addExecutedRequest: function(e) {
                                        r.push(e);
                                    }
                                }, n = h.getLogger(t), w(), l.on(c.LOADING_COMPLETED, A, t), l.on(c.LOADING_DATA_PROGRESS, _, t), l.on(c.LOADING_ABANDONED, S, t), t;
                            }
                            u.__dashjs_factory_name = "FragmentModel";
                            var l = r.default.getClassFactory(u);
                            l.FRAGMENT_MODEL_LOADING = a1, l.FRAGMENT_MODEL_EXECUTED = o, l.FRAGMENT_MODEL_CANCELED = "canceled", l.FRAGMENT_MODEL_FAILED = s1, r.default.updateClassFactory(u.__dashjs_factory_name, l), t.default = l;
                        },
                        "./src/streaming/models/LowLatencyThroughputModel.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/Debug.js"), i = n("./src/core/FactoryMaker.js");
                            function a1() {
                                var e, t, n = this.context, i = {};
                                function a1() {
                                    t = Object(r.default)(n).getInstance().getLogger(e);
                                }
                                function o(e) {
                                    for(var t = {}, n = 0, r = 0, i = 0, a1 = 0, o = e.length, s1 = 0; s1 < o; ++s1)n += e[s1].chunkDownloadTimeRelativeMS, r += e[s1].bufferLevel, i += e[s1].chunkDownloadTimeRelativeMS * e[s1].bufferLevel, a1 += e[s1].chunkDownloadTimeRelativeMS * e[s1].chunkDownloadTimeRelativeMS;
                                    return t.m = (i - n * r / o) / (a1 - n * n / o), t.b = r / o - t.m * n / o, function(e) {
                                        return t.m * e + t.b;
                                    };
                                }
                                function s1(e) {
                                    var t, n = !0, r = e.reduce(function(e, t) {
                                        return e + t.bufferLevelAtSegmentEnd;
                                    }, 0) / e.length;
                                    return e.forEach(function(e) {
                                        Math.abs(e.bufferLevelAtSegmentEnd / e.bufferLevelAtSegmentStart) < .95 && (n = !1), e.bufferLevelAtSegmentEnd / r < .8 && (n = !1), t ? t > e.bitrate && (n = !1) : t = e.bitrate;
                                    }), n;
                                }
                                return e = {
                                    setup: a1,
                                    addMeasurement: function(e, t, n, r, a1) {
                                        e && e.mediaType && !i[e.mediaType] && (i[e.mediaType] = []);
                                        var s1 = e.mediaInfo.bitrateList.find(function(t) {
                                            return t.id === e.representationId;
                                        });
                                        i[e.mediaType].push({
                                            index: e.index,
                                            repId: e.representationId,
                                            mediaType: e.mediaType,
                                            requestTimeMS: r,
                                            adjustedAvailabilityStartTimeMS: e.availabilityStartTime.getTime(),
                                            segDurationMS: 1e3 * e.duration,
                                            chunksDurationMS: n.reduce(function(e, t) {
                                                return e + t.chunkDownloadDurationMS;
                                            }, 0),
                                            segmentBytes: n.reduce(function(e, t) {
                                                return e + t.chunkBytes;
                                            }, 0),
                                            bitrate: s1 && s1.bandwidth,
                                            bitrateList: e.mediaInfo.bitrateList,
                                            chunkMeasurements: n,
                                            fetchDownloadDurationMS: t,
                                            throughputCapacityDelayMS: a1,
                                            getEstimatedBufferLevel: o(n.slice(1))
                                        }), i[e.mediaType].length > 10 && i[e.mediaType].shift();
                                    },
                                    getThroughputCapacityDelayMS: function(e, t) {
                                        var n = i[e.mediaType] && i[e.mediaType].slice(-3);
                                        return !n || n.length < 3 ? 0 : s1(n) ? t / 4 > 250 ? 250 : t / 4 : 0;
                                    },
                                    getEstimatedDownloadDurationMS: function(e) {
                                        var n = i[e.mediaType].slice(-1).pop(), r = i[e.mediaType].slice(-3), a1 = n.chunkMeasurements.slice(-1).pop().chunkDownloadTimeRelativeMS;
                                        n.bufferLevelAtSegmentStart = n.getEstimatedBufferLevel(a1 / 2), n.bufferLevelAtSegmentEnd = n.getEstimatedBufferLevel(a1);
                                        var o = s1(r), u = o ? .6 : .8;
                                        if (n.isBufferStable && 1.05 * n.segDurationMS < n.fetchDownloadDurationMS) return n.fetchDownloadDurationMS;
                                        if (!o || n.segDurationMS < n.fetchDownloadDurationMS) return .8 * n.fetchDownloadDurationMS;
                                        if (n.adjustedAvailabilityStartTimeMS <= n.requestTimeMS + n.throughputCapacityDelayMS - n.segDurationMS) return .8 * n.fetchDownloadDurationMS;
                                        for(var l = n.requestTimeMS + n.throughputCapacityDelayMS - n.adjustedAvailabilityStartTimeMS, c = 0, d = 0, f = 0, h = 0; h < n.chunkMeasurements.length; h++){
                                            var g = n.chunkMeasurements[h];
                                            if (l < d + g.chunkDownloadDurationMS) break;
                                            d += g.chunkDownloadDurationMS, c += g.chunkBytes, f++;
                                        }
                                        if (l < 0 && t.warn("request time was before adjusted availibitly start time"), c && d && f > .2 * n.chunkMeasurements.length) {
                                            var p = c / d, m = n.segmentBytes / p;
                                            return n.fetchDownloadDurationMS < m ? n.fetchDownloadDurationMS * u : m * u;
                                        }
                                        var v = n.bitrate;
                                        return n.bitrateList.some(function(e) {
                                            if (e.bandwidth > n.bitrate) return v = e.bandwidth, !0;
                                        }), v === n.bitrate ? n.fetchDownloadDurationMS * u : u * n.segmentBytes * 8000 / v;
                                    }
                                }, a1(), e;
                            }
                            a1.__dashjs_factory_name = "LowLatencyThroughputModel", t.default = i.default.getSingletonFactory(a1);
                        },
                        "./src/streaming/models/ManifestModel.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/EventBus.js"), i = n("./src/core/events/Events.js"), a1 = n("./src/core/FactoryMaker.js");
                            function o() {
                                var e, t = this.context, n = Object(r.default)(t).getInstance();
                                return {
                                    getValue: function() {
                                        return e;
                                    },
                                    setValue: function(t) {
                                        e = t, t && n.trigger(i.default.MANIFEST_LOADED, {
                                            data: t
                                        });
                                    }
                                };
                            }
                            o.__dashjs_factory_name = "ManifestModel", t.default = a1.default.getSingletonFactory(o);
                        },
                        "./src/streaming/models/MediaPlayerModel.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/Debug.js"), i = n("./src/core/FactoryMaker.js"), a1 = n("./src/core/Settings.js"), o = -0.5;
                            function s1() {
                                var e, t, n, i, s1 = this.context, u = Object(a1.default)(s1).getInstance();
                                function l(e, n) {
                                    return isNaN(e) ? 0 : e > 0 ? (n && t.warn("Supplied minimum playback rate is a positive value when it should be negative or 0. The supplied rate will not be applied and set to 0: 100% playback speed."), 0) : e < o ? (n && t.warn("Supplied minimum playback rate is out of range and will be limited to ".concat(o, ": ").concat(-50, "% playback speed.")), o) : e;
                                }
                                function c(e, n) {
                                    return isNaN(e) ? 0 : e < 0 ? (n && t.warn("Supplied maximum playback rate is a negative value when it should be negative or 0. The supplied rate will not be applied and set to 0: 100% playback speed."), 0) : e > 1 ? (n && t.warn("Supplied maximum playback rate is out of range and will be limited to ".concat(1, ": ").concat(200, "% playback speed.")), 1) : e;
                                }
                                function d() {
                                    var e = u.get().streaming.buffer.stableBufferTime > 0 ? u.get().streaming.buffer.stableBufferTime : u.get().streaming.buffer.fastSwitchEnabled ? 20 : 12, t = n.getLiveDelay();
                                    return !isNaN(t) && t > 0 ? Math.min(e, t) : e;
                                }
                                return e = {
                                    getCatchupMaxDrift: function() {
                                        if (!isNaN(u.get().streaming.liveCatchup.maxDrift) && u.get().streaming.liveCatchup.maxDrift > 0) return u.get().streaming.liveCatchup.maxDrift;
                                        var e = i.getServiceDescriptionSettings();
                                        return e && e.liveCatchup && !isNaN(e.liveCatchup.maxDrift) && e.liveCatchup.maxDrift > 0 ? e.liveCatchup.maxDrift : 12;
                                    },
                                    getCatchupModeEnabled: function() {
                                        return null !== u.get().streaming.liveCatchup.enabled ? u.get().streaming.liveCatchup.enabled : n.getInitialCatchupModeActivated();
                                    },
                                    getStableBufferTime: d,
                                    getInitialBufferLevel: function() {
                                        var e = u.get().streaming.buffer.initialBufferLevel;
                                        return isNaN(e) || e < 0 ? 0 : Math.min(d(), e);
                                    },
                                    getRetryAttemptsForType: function(e) {
                                        var t = isNaN(u.get().streaming.retryAttempts.lowLatencyMultiplyFactor) ? 5 : u.get().streaming.retryAttempts.lowLatencyMultiplyFactor;
                                        return n.getLowLatencyModeEnabled() ? u.get().streaming.retryAttempts[e] * t : u.get().streaming.retryAttempts[e];
                                    },
                                    getRetryIntervalsForType: function(e) {
                                        var t = isNaN(u.get().streaming.retryIntervals.lowLatencyReductionFactor) ? 10 : u.get().streaming.retryIntervals.lowLatencyReductionFactor;
                                        return n.getLowLatencyModeEnabled() ? u.get().streaming.retryIntervals[e] / t : u.get().streaming.retryIntervals[e];
                                    },
                                    getCatchupPlaybackRates: function(e) {
                                        var t = u.get().streaming.liveCatchup.playbackRate;
                                        if (!isNaN(t.min) || !isNaN(t.max)) return {
                                            min: l(t.min, e),
                                            max: c(t.max, e)
                                        };
                                        var n = i.getServiceDescriptionSettings();
                                        if (n && n.liveCatchup && (!isNaN(n.liveCatchup.playbackRate.min) || !isNaN(n.liveCatchup.playbackRate.max))) {
                                            var r = n.liveCatchup.playbackRate;
                                            return {
                                                min: l(r.min, e),
                                                max: c(r.max, e)
                                            };
                                        }
                                        return {
                                            min: -0.5,
                                            max: .5
                                        };
                                    },
                                    getAbrBitrateParameter: function(e, t) {
                                        try {
                                            var n = u.get().streaming.abr[e][t];
                                            if (!isNaN(n) && -1 !== n) return n;
                                            var r = i.getServiceDescriptionSettings();
                                            return r && r[e] && !isNaN(r[e][t]) ? r[e][t] : -1;
                                        } catch (e) {
                                            return -1;
                                        }
                                    },
                                    setConfig: function(e) {
                                        e.playbackController && (n = e.playbackController), e.serviceDescriptionController && (i = e.serviceDescriptionController);
                                    },
                                    reset: function() {}
                                }, t = Object(r.default)(s1).getInstance().getLogger(e), e;
                            }
                            s1.__dashjs_factory_name = "MediaPlayerModel", t.default = i.default.getSingletonFactory(s1);
                        },
                        "./src/streaming/models/MetricsModel.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/Constants.js"), i = n("./src/streaming/constants/MetricsConstants.js"), a1 = n("./src/streaming/vo/MetricsList.js"), o = n("./src/streaming/vo/metrics/HTTPRequest.js"), s1 = n("./src/streaming/vo/metrics/RepresentationSwitch.js"), u = n("./src/streaming/vo/metrics/BufferLevel.js"), l = n("./src/streaming/vo/metrics/BufferState.js"), c = n("./src/streaming/vo/metrics/DVRInfo.js"), d = n("./src/streaming/vo/metrics/DroppedFrames.js"), f = n("./src/streaming/vo/metrics/ManifestUpdate.js"), h = n("./src/streaming/vo/metrics/SchedulingInfo.js"), g = n("./src/core/EventBus.js"), p = n("./src/streaming/vo/metrics/RequestsQueue.js"), m = n("./src/core/events/Events.js"), v = n("./src/core/FactoryMaker.js");
                            function y(e) {
                                var t, n, v = (e = e || {}).settings, y = this.context, E = Object(g.default)(y).getInstance();
                                function T() {
                                    E.trigger(m.default.METRICS_CHANGED);
                                }
                                function b(e) {
                                    E.trigger(m.default.METRIC_CHANGED, {
                                        mediaType: e
                                    }), T();
                                }
                                function A(e, t, n) {
                                    E.trigger(m.default.METRIC_UPDATED, {
                                        mediaType: e,
                                        metric: t,
                                        value: n
                                    }), b(e);
                                }
                                function _(e, t, n) {
                                    E.trigger(m.default.METRIC_ADDED, {
                                        mediaType: e,
                                        metric: t,
                                        value: n
                                    }), b(e);
                                }
                                function S(e, t) {
                                    var r = null;
                                    return e ? (n.hasOwnProperty(e) ? r = n[e] : t || (r = new a1.default, n[e] = r), r) : r;
                                }
                                function w(e, t, n) {
                                    var r = S(e);
                                    null !== r && (r[t].push(n), r[t].length > v.get().streaming.metrics.maxListDepth && r[t].shift());
                                }
                                function I(e, t, n) {
                                    w(e, t, n), _(e, t, n);
                                }
                                return t = {
                                    clearCurrentMetricsForType: function(e) {
                                        delete n[e], b(e);
                                    },
                                    clearAllCurrentMetrics: function() {
                                        n = {}, T();
                                    },
                                    getMetricsFor: S,
                                    addHttpRequest: function e(t, n, r, a1, s1, u, l, c, d, f, h, g, p, m, v, y) {
                                        var E = new o.HTTPRequest;
                                        u && u !== a1 && (e(t, null, r, a1, s1, null, null, c, d, null, null, null, p, null, null, y), E.actualurl = u), E.tcpid = n, E.type = r, E.url = a1, E.range = c, E.trequest = d, E.tresponse = f, E.responsecode = g, E._tfinish = h, E._stream = t, E._mediaduration = p, E._quality = s1, E._responseHeaders = m, E._serviceLocation = l, E._fileLoaderType = y, v ? v.forEach(function(e) {
                                            !function(e, t, n, r) {
                                                var i = new o.HTTPRequestTrace;
                                                i.s = t, i.d = n, i.b = r, e.trace.push(i), e.interval || (e.interval = 0), e.interval += n;
                                            }(E, e.s, e.d, e.b);
                                        }) : (delete E.interval, delete E.trace), I(t, i.default.HTTP_REQUEST, E);
                                    },
                                    addRepresentationSwitch: function(e, t, n, r, a1) {
                                        var o = new s1.default;
                                        o.t = t, o.mt = n, o.to = r, a1 ? o.lto = a1 : delete o.lto, I(e, i.default.TRACK_SWITCH, o);
                                    },
                                    addBufferLevel: function(e, t, n) {
                                        var r = new u.default;
                                        r.t = t, r.level = n, I(e, i.default.BUFFER_LEVEL, r);
                                    },
                                    addBufferState: function(e, t, n) {
                                        var r = new l.default;
                                        r.target = n, r.state = t, I(e, i.default.BUFFER_STATE, r);
                                    },
                                    addDVRInfo: function(e, t, n, r) {
                                        var a1 = new c.default;
                                        a1.time = t, a1.range = r, a1.manifestInfo = n, I(e, i.default.DVR_INFO, a1);
                                    },
                                    addDroppedFrames: function(e, t) {
                                        var n = new d.default, r = S(e).DroppedFrames;
                                        t && (n.time = t.creationTime, n.droppedFrames = t.droppedVideoFrames, r.length > 0 && r[r.length - 1] == n || I(e, i.default.DROPPED_FRAMES, n));
                                    },
                                    addSchedulingInfo: function(e, t, n, r, a1, o, s1, u, l) {
                                        var c = new h.default;
                                        c.mediaType = e, c.t = t, c.type = n, c.startTime = r, c.availabilityStartTime = a1, c.duration = o, c.quality = s1, c.range = u, c.state = l, I(e, i.default.SCHEDULING_INFO, c);
                                    },
                                    addRequestsQueue: function(e, t, n) {
                                        var r = new p.default;
                                        r.loadingRequests = t, r.executedRequests = n, S(e).RequestsQueue = r, _(e, i.default.REQUESTS_QUEUE, r);
                                    },
                                    addManifestUpdate: function(e, t, n, a1, o, s1, u, l, c, d) {
                                        var h = new f.ManifestUpdate;
                                        h.mediaType = e, h.type = t, h.requestTime = n, h.fetchTime = a1, h.availabilityStartTime = o, h.presentationStartTime = s1, h.clientTimeOffset = u, h.currentTime = l, h.buffered = c, h.latency = d, w(r.default.STREAM, i.default.MANIFEST_UPDATE, h), _(e, i.default.MANIFEST_UPDATE, h);
                                    },
                                    updateManifestUpdateInfo: function(e, t) {
                                        if (e) {
                                            for(var n in t)e[n] = t[n];
                                            A(e.mediaType, i.default.MANIFEST_UPDATE, e);
                                        }
                                    },
                                    addManifestUpdateStreamInfo: function(e, t, n, r, a1) {
                                        if (e) {
                                            var o = new f.ManifestUpdateStreamInfo;
                                            o.id = t, o.index = n, o.start = r, o.duration = a1, e.streamInfo.push(o), A(e.mediaType, i.default.MANIFEST_UPDATE_STREAM_INFO, e);
                                        }
                                    },
                                    addManifestUpdateRepresentationInfo: function(e, t, n, r, a1, o, s1, u) {
                                        if (e && e.representationInfo) {
                                            var l = new f.ManifestUpdateRepresentationInfo;
                                            l.id = t, l.index = n, l.streamIndex = r, l.mediaType = a1, l.startNumber = s1, l.fragmentInfoType = u, l.presentationTimeOffset = o, e.representationInfo.push(l), A(e.mediaType, i.default.MANIFEST_UPDATE_TRACK_INFO, e);
                                        }
                                    },
                                    addPlayList: function(e) {
                                        e.trace && Array.isArray(e.trace) ? e.trace.forEach(function(e) {
                                            e.hasOwnProperty("subreplevel") && !e.subreplevel && delete e.subreplevel;
                                        }) : delete e.trace, I(r.default.STREAM, i.default.PLAY_LIST, e);
                                    },
                                    addDVBErrors: function(e) {
                                        I(r.default.STREAM, i.default.DVB_ERRORS, e);
                                    }
                                }, n = {}, t;
                            }
                            y.__dashjs_factory_name = "MetricsModel", t.default = v.default.getSingletonFactory(y);
                        },
                        "./src/streaming/models/URIFragmentModel.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/vo/URIFragmentData.js"), i = n("./src/core/FactoryMaker.js");
                            function a1() {
                                var e;
                                return {
                                    initialize: function(t) {
                                        if (e = new r.default, !t) return null;
                                        var n = t.indexOf("#");
                                        if (-1 !== n) for(var i = t.substr(n + 1).split("&"), a1 = 0, o = i.length; a1 < o; ++a1){
                                            var s1 = i[a1], u = s1.indexOf("=");
                                            if (-1 !== u) {
                                                var l = s1.substring(0, u);
                                                e.hasOwnProperty(l) && (e[l] = s1.substr(u + 1));
                                            }
                                        }
                                    },
                                    getURIFragmentData: function() {
                                        return e;
                                    }
                                };
                            }
                            a1.__dashjs_factory_name = "URIFragmentModel", t.default = i.default.getSingletonFactory(a1);
                        },
                        "./src/streaming/models/VideoModel.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/core/EventBus.js"), a1 = n("./src/core/events/Events.js"), o = n("./src/core/Debug.js"), s1 = n("./src/streaming/constants/Constants.js"), u = new Map([
                                [
                                    s1.default.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA,
                                    "loadedmetadata"
                                ],
                                [
                                    s1.default.VIDEO_ELEMENT_READY_STATES.HAVE_CURRENT_DATA,
                                    "loadeddata"
                                ],
                                [
                                    s1.default.VIDEO_ELEMENT_READY_STATES.HAVE_FUTURE_DATA,
                                    "canplay"
                                ],
                                [
                                    s1.default.VIDEO_ELEMENT_READY_STATES.HAVE_ENOUGH_DATA,
                                    "canplaythrough"
                                ]
                            ]);
                            function l() {
                                var e, t, n, r, l, c = this.context, d = Object(i.default)(c).getInstance(), f = [];
                                function h() {
                                    n && (n.playbackRate = 1, n.removeEventListener("canplay", h));
                                }
                                function g() {
                                    return f.length > 0;
                                }
                                function p() {
                                    if (n && g() && 0 === n.playbackRate) {
                                        var e = document.createEvent("Event");
                                        e.initEvent("waiting", !0, !1), n.dispatchEvent(e);
                                    }
                                }
                                function m(e, t) {
                                    n && n.addEventListener(e, t);
                                }
                                function v(e, t) {
                                    n && n.removeEventListener(e, t);
                                }
                                function y() {
                                    return n ? n.readyState : NaN;
                                }
                                function E() {
                                    return n ? n.buffered : null;
                                }
                                function T(e, t, r, i, a1) {
                                    if (n) {
                                        for(var o = 0; o < n.textTracks.length; o++)if (n.textTracks[o].kind === e && (!t || n.textTracks[o].label == t) && n.textTracks[o].language === r && n.textTracks[o].isTTML === i && n.textTracks[o].isEmbedded === a1) return n.textTracks[o];
                                    }
                                    return null;
                                }
                                function b(e, t) {
                                    e === s1.default.VIDEO_ELEMENT_READY_STATES.HAVE_NOTHING || y() >= e ? t() : function(e, t) {
                                        m(e, function n() {
                                            v(e, n), t(e);
                                        });
                                    }(u.get(e), t);
                                }
                                return e = {
                                    initialize: function() {
                                        d.on(a1.default.PLAYBACK_PLAYING, p, this);
                                    },
                                    setCurrentTime: function(e, t) {
                                        r = e, b(s1.default.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, function() {
                                            if (n) {
                                                if (n.currentTime === r) return void (r = NaN);
                                                try {
                                                    r = t ? function(e) {
                                                        var t = E(), n = e, r = 9999999999;
                                                        if (t) for(var i = 0; i < t.length; i++){
                                                            var a1 = t.start(i), o = t.end(i), s1 = Math.abs(a1 - e), u = Math.abs(o - e);
                                                            if (e >= a1 && e <= o) return e;
                                                            s1 < r && (r = s1, n = a1), u < r && (r = u, n = o);
                                                        }
                                                        return n;
                                                    }(r) : r, n.currentTime = r, r = NaN;
                                                } catch (e) {
                                                    0 === n.readyState && e.code === e.INVALID_STATE_ERR && setTimeout(function() {
                                                        n.currentTime = r, r = NaN;
                                                    }, 400);
                                                }
                                            }
                                        });
                                    },
                                    play: function() {
                                        if (n) {
                                            n.autoplay = !0;
                                            var e = n.play();
                                            e && e.catch && "undefined" != typeof Promise && e.catch(function(e) {
                                                "NotAllowedError" === e.name && d.trigger(a1.default.PLAYBACK_NOT_ALLOWED), t.warn("Caught pending play exception - continuing (".concat(e, ")"));
                                            });
                                        }
                                    },
                                    isPaused: function() {
                                        return n ? n.paused : null;
                                    },
                                    pause: function() {
                                        n && (n.pause(), n.autoplay = !1);
                                    },
                                    isStalled: g,
                                    isSeeking: function() {
                                        return n ? n.seeking || !isNaN(r) : null;
                                    },
                                    getTime: function() {
                                        return n ? isNaN(r) ? n.currentTime : r : null;
                                    },
                                    getPlaybackRate: function() {
                                        return n ? n.playbackRate : null;
                                    },
                                    setPlaybackRate: function(e) {
                                        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                                        n && (!t && n.readyState <= 2 && e > 0 ? n.addEventListener("canplay", h) : n.playbackRate = e);
                                    },
                                    getPlayedRanges: function() {
                                        return n ? n.played : null;
                                    },
                                    getEnded: function() {
                                        return n ? n.ended : null;
                                    },
                                    setStallState: function(e, t) {
                                        !function(e, t) {
                                            t ? function(e) {
                                                null !== e && n && !n.seeking && -1 === f.indexOf(e) && f.push(e);
                                            }(e) : function(e) {
                                                var t = f.indexOf(e);
                                                null !== e && -1 !== t && f.splice(t, 1);
                                            }(e);
                                        }(e, t);
                                    },
                                    getElement: function() {
                                        return n;
                                    },
                                    setElement: function(e) {
                                        if (!(null == e || e && /^(VIDEO|AUDIO)$/i.test(e.nodeName))) throw "element is not video or audio DOM type!";
                                        (n = e) && (n.preload = "auto");
                                    },
                                    setSource: function(e) {
                                        n && (e ? n.src = e : (n.removeAttribute("src"), n.load()));
                                    },
                                    getSource: function() {
                                        return n ? n.src : null;
                                    },
                                    getTTMLRenderingDiv: function() {
                                        return l;
                                    },
                                    setTTMLRenderingDiv: function(e) {
                                        (l = e).style.position = "absolute", l.style.display = "flex", l.style.overflow = "hidden", l.style.pointerEvents = "none", l.style.top = 0, l.style.left = 0;
                                    },
                                    getPlaybackQuality: function() {
                                        if (!n) return null;
                                        var e = "webkitDroppedFrameCount" in n && "webkitDecodedFrameCount" in n, t = null;
                                        return "getVideoPlaybackQuality" in n ? t = n.getVideoPlaybackQuality() : e && (t = {
                                            droppedVideoFrames: n.webkitDroppedFrameCount,
                                            totalVideoFrames: n.webkitDroppedFrameCount + n.webkitDecodedFrameCount,
                                            creationTime: new Date
                                        }), t;
                                    },
                                    addEventListener: m,
                                    removeEventListener: v,
                                    getReadyState: y,
                                    getBufferRange: E,
                                    getClientWidth: function() {
                                        return n ? n.clientWidth : NaN;
                                    },
                                    getClientHeight: function() {
                                        return n ? n.clientHeight : NaN;
                                    },
                                    getTextTracks: function() {
                                        return n ? n.textTracks : [];
                                    },
                                    getTextTrack: T,
                                    addTextTrack: function(e, t, r, i, a1) {
                                        if (!n) return null;
                                        var o = T(e, t, r, i, a1);
                                        return o || ((o = n.addTextTrack(e, t, r)).isEmbedded = a1, o.isTTML = i), o;
                                    },
                                    appendChild: function(e) {
                                        n && (n.appendChild(e), void 0 !== e.isTTML && (n.textTracks[n.textTracks.length - 1].isTTML = e.isTTML, n.textTracks[n.textTracks.length - 1].isEmbedded = e.isEmbedded));
                                    },
                                    removeChild: function(e) {
                                        n && n.removeChild(e);
                                    },
                                    getVideoWidth: function() {
                                        return n ? n.videoWidth : NaN;
                                    },
                                    getVideoHeight: function() {
                                        return n ? n.videoHeight : NaN;
                                    },
                                    getVideoRelativeOffsetTop: function() {
                                        var e = n.parentNode.host || n.parentNode;
                                        return e ? n.getBoundingClientRect().top - e.getBoundingClientRect().top : NaN;
                                    },
                                    getVideoRelativeOffsetLeft: function() {
                                        var e = n.parentNode.host || n.parentNode;
                                        return e ? n.getBoundingClientRect().left - e.getBoundingClientRect().left : NaN;
                                    },
                                    waitForReadyState: b,
                                    reset: function() {
                                        d.off(a1.default.PLAYBACK_PLAYING, p, this);
                                    }
                                }, t = Object(o.default)(c).getInstance().getLogger(e), r = NaN, e;
                            }
                            l.__dashjs_factory_name = "VideoModel", t.default = r.default.getSingletonFactory(l);
                        },
                        "./src/streaming/net/FetchLoader.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/core/Settings.js"), a1 = n("./src/streaming/constants/Constants.js"), o = n("./src/streaming/utils/RequestModifier.js");
                            function s1(e, t) {
                                if (e) {
                                    if ("string" == typeof e) return u(e, t);
                                    var n = Object.prototype.toString.call(e).slice(8, -1);
                                    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? u(e, t) : void 0;
                                }
                            }
                            function u(e, t) {
                                (null == t || t > e.length) && (t = e.length);
                                for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                                return r;
                            }
                            function l(e) {
                                e = e || {};
                                var t, n, r = this.context, u = e.requestModifier, l = e.lowLatencyThroughputModel, c = e.boxParser, d = Object(i.default)(r).getInstance();
                                function f(e) {
                                    var t, r = new Date, i = e.request, o = new Headers;
                                    if (i.range && o.append("Range", "bytes=" + i.range), e.headers) for(var f in e.headers){
                                        var p = e.headers[f];
                                        p && o.append(f, p);
                                    }
                                    i.requestStartDate || (i.requestStartDate = r), u && u.modifyRequestHeader && u.modifyRequestHeader({
                                        setRequestHeader: function(e, t) {
                                            o.append(e, t);
                                        }
                                    }, {
                                        url: e.url
                                    }), "function" == typeof window.AbortController && (t = new AbortController, e.abortController = t, t.signal.onabort = e.onabort);
                                    var m = {
                                        method: e.method,
                                        headers: o,
                                        credentials: e.withCredentials ? "include" : void 0,
                                        signal: t ? t.signal : void 0
                                    }, v = d.get().streaming.abr.fetchThroughputCalculationMode, y = Date.now(), E = 0;
                                    new Promise(function(e) {
                                        if (v === a1.default.ABR_FETCH_THROUGHPUT_CALCULATION_AAST && l && (E = l.getThroughputCapacityDelayMS(i, 1e3 * n.getCurrentBufferLevel(i.mediaType)))) return setTimeout(e, E);
                                        e();
                                    }).then(function() {
                                        var t = Date.now();
                                        fetch(e.url, m).then(function(r) {
                                            e.response || (e.response = {}), e.response.status = r.status, e.response.statusText = r.statusText, e.response.responseURL = r.url, r.ok || e.onerror();
                                            var o, u = "", d = function(e, t) {
                                                var n;
                                                if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
                                                    if (Array.isArray(e) || (n = s1(e))) {
                                                        n && (e = n);
                                                        var r = 0, i = function() {};
                                                        return {
                                                            s: i,
                                                            n: function() {
                                                                return r >= e.length ? {
                                                                    done: !0
                                                                } : {
                                                                    done: !1,
                                                                    value: e[r++]
                                                                };
                                                            },
                                                            e: function(e) {
                                                                throw e;
                                                            },
                                                            f: i
                                                        };
                                                    }
                                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                                }
                                                var a1, o = !0, u = !1;
                                                return {
                                                    s: function() {
                                                        n = e[Symbol.iterator]();
                                                    },
                                                    n: function() {
                                                        var e = n.next();
                                                        return o = e.done, e;
                                                    },
                                                    e: function(e) {
                                                        u = !0, a1 = e;
                                                    },
                                                    f: function() {
                                                        try {
                                                            o || null == n.return || n.return();
                                                        } finally{
                                                            if (u) throw a1;
                                                        }
                                                    }
                                                };
                                            }(r.headers.keys());
                                            try {
                                                for(d.s(); !(o = d.n()).done;){
                                                    var f = o.value;
                                                    u += f + ": " + r.headers.get(f) + "\r\n";
                                                }
                                            } catch (e) {
                                                d.e(e);
                                            } finally{
                                                d.f();
                                            }
                                            if (e.response.responseHeaders = u, !r.body) return r.arrayBuffer().then(function(t) {
                                                e.response.response = t;
                                                var n = {
                                                    loaded: t.byteLength,
                                                    total: t.byteLength,
                                                    stream: !1
                                                };
                                                e.progress(n), e.onload(), e.onend();
                                            });
                                            var p, m, T, b, A = parseInt(r.headers.get("Content-Length"), 10), _ = 0, S = !1, w = new Uint8Array, I = 0;
                                            if (v === a1.default.ABR_FETCH_THROUGHPUT_CALCULATION_AAST && l) {
                                                var R = t, C = 0, D = (T = r.body.tee(), b = 2, function(e) {
                                                    if (Array.isArray(e)) return e;
                                                }(T) || function(e, t) {
                                                    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
                                                        var n = [], r = !0, i = !1, a1 = void 0;
                                                        try {
                                                            for(var o, s1 = e[Symbol.iterator](); !(r = (o = s1.next()).done) && (n.push(o.value), !t || n.length !== t); r = !0);
                                                        } catch (e) {
                                                            i = !0, a1 = e;
                                                        } finally{
                                                            try {
                                                                r || null == s1.return || s1.return();
                                                            } finally{
                                                                if (i) throw a1;
                                                            }
                                                        }
                                                        return n;
                                                    }
                                                }(T, b) || s1(T, b) || function() {
                                                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                                }()), k = D[0], N = D[1];
                                                p = k.getReader(), m = [], p.read().then(function r(a1) {
                                                    var o = a1.value, s1 = a1.done;
                                                    if (C = Date.now(), o && o.length) {
                                                        var c = C - R, d = o.length;
                                                        m.push({
                                                            chunkDownloadTimeRelativeMS: C - t,
                                                            chunkDownloadDurationMS: c,
                                                            chunkBytes: d,
                                                            kbps: Math.round(8 * d / (c / 1e3)),
                                                            bufferLevel: n.getCurrentBufferLevel(i.mediaType)
                                                        });
                                                    }
                                                    if (s1) {
                                                        var f = C - t, h = m.reduce(function(e, t) {
                                                            return e + t.chunkBytes;
                                                        }, 0);
                                                        return l.addMeasurement(i, f, m, y, E, u), void e.progress({
                                                            loaded: h,
                                                            total: h,
                                                            lengthComputable: !0,
                                                            time: l.getEstimatedDownloadDurationMS(i),
                                                            stream: !0
                                                        });
                                                    }
                                                    return R = Date.now(), p.read().then(r);
                                                }), e.reader = N.getReader();
                                            } else e.reader = r.body.getReader();
                                            var L = [], x = [], M = [], O = !0;
                                            h(e, function t(n) {
                                                var r = n.value;
                                                if (n.done) {
                                                    if (w) {
                                                        if (v !== a1.default.ABR_FETCH_THROUGHPUT_CALCULATION_AAST) {
                                                            var i = null, o = null;
                                                            v === a1.default.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING ? (i = function(e, t) {
                                                                try {
                                                                    var n, r;
                                                                    n = e.filter(function(t, n) {
                                                                        return n < e.length - 1;
                                                                    }), r = t.filter(function(e, n) {
                                                                        return n < t.length - 1;
                                                                    });
                                                                    var i = [];
                                                                    if (n.length > 1) {
                                                                        for(var a1 = 0, o = 0, s1 = 0; s1 < n.length; s1++)if (n[s1] && r[s1]) {
                                                                            var u = r[s1].ts - n[s1].ts;
                                                                            if (u > 1) i.push(8 * r[s1].bytes / u);
                                                                            else {
                                                                                0 === o && (o = n[s1].ts);
                                                                                var l = r[s1].ts - o;
                                                                                l > 1 ? (i.push(8 * a1 / l), a1 = 0, o = 0) : a1 += r[s1].bytes;
                                                                            }
                                                                        }
                                                                        if (i.length > 0) return i.reduce(function(e, t) {
                                                                            return e + t;
                                                                        }, 0) / i.length;
                                                                    }
                                                                    return null;
                                                                } catch (e) {
                                                                    return null;
                                                                }
                                                            }(x, M), i && (o = 8 * _ / i)) : v === a1.default.ABR_FETCH_THROUGHPUT_CALCULATION_DOWNLOADED_DATA && (o = g(L, _)), e.progress({
                                                                loaded: _,
                                                                total: isNaN(A) ? _ : A,
                                                                lengthComputable: !0,
                                                                time: o,
                                                                stream: !0
                                                            });
                                                        }
                                                        e.response.response = w.buffer;
                                                    }
                                                    return e.onload(), void e.onend();
                                                }
                                                if (r && r.length > 0) {
                                                    w = function(e, t) {
                                                        if (0 === e.length) return t;
                                                        var n = new Uint8Array(e.length + t.length);
                                                        return n.set(e), n.set(t, e.length), n;
                                                    }(w, r), _ += r.length, L.push({
                                                        ts: Date.now(),
                                                        bytes: r.length
                                                    }), v === a1.default.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING && O && c.findLastTopIsoBoxCompleted([
                                                        "moof"
                                                    ], w, I).found && (O = !1, x.push({
                                                        ts: performance.now(),
                                                        bytes: r.length
                                                    }));
                                                    var s1 = c.findLastTopIsoBoxCompleted([
                                                        "moov",
                                                        "mdat"
                                                    ], w, I);
                                                    if (s1.found) {
                                                        var u, l = s1.lastCompletedOffset + s1.size;
                                                        v !== a1.default.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING || O || (O = !0, M.push({
                                                            ts: performance.now(),
                                                            bytes: w.length
                                                        })), l === w.length ? (u = w, w = new Uint8Array) : (u = new Uint8Array(w.subarray(0, l)), w = w.subarray(l)), e.progress({
                                                            data: u.buffer,
                                                            lengthComputable: !1,
                                                            noTrace: !0
                                                        }), I = 0;
                                                    } else I = s1.lastCompletedOffset, S || (e.progress({
                                                        lengthComputable: !1,
                                                        noTrace: !0
                                                    }), S = !0);
                                                }
                                                h(e, t);
                                            });
                                        }).catch(function(t) {
                                            e.onerror && e.onerror(t);
                                        });
                                    });
                                }
                                function h(e, t) {
                                    e.reader.read().then(t).catch(function(t) {
                                        e.onerror && 200 === e.response.status && e.onerror(t);
                                    });
                                }
                                function g(e, t) {
                                    try {
                                        if ((e = e.filter(function(n) {
                                            return n.bytes > t / 4 / e.length;
                                        })).length > 1) {
                                            var n = 0, r = (e[e.length - 1].ts - e[0].ts) / e.length;
                                            return e.forEach(function(t, i) {
                                                var a1 = e[i + 1];
                                                if (a1) {
                                                    var o = a1.ts - t.ts;
                                                    n += o < r ? o : 0;
                                                }
                                            }), n;
                                        }
                                        return null;
                                    } catch (e) {
                                        return null;
                                    }
                                }
                                return t = {
                                    load: function(e) {
                                        u && u.modifyRequest ? Object(o.modifyRequest)(e, u).then(function() {
                                            return f(e);
                                        }) : f(e);
                                    },
                                    abort: function(e) {
                                        if (e.abortController) e.abortController.abort();
                                        else if (e.reader) try {
                                            e.reader.cancel(), e.onabort();
                                        } catch (e) {}
                                    },
                                    calculateDownloadedTime: g,
                                    setup: function(e) {
                                        n = e.dashMetrics;
                                    }
                                }, t;
                            }
                            l.__dashjs_factory_name = "FetchLoader";
                            var c = r.default.getClassFactory(l);
                            t.default = c;
                        },
                        "./src/streaming/net/HTTPLoader.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/net/XHRLoader.js"), i = n("./src/streaming/net/FetchLoader.js"), a1 = n("./src/streaming/vo/metrics/HTTPRequest.js"), o = n("./src/core/FactoryMaker.js"), s1 = n("./src/streaming/vo/DashJSError.js"), u = n("./src/streaming/models/CmcdModel.js"), l = n("./src/core/Utils.js"), c = n("./src/core/Debug.js"), d = n("./src/core/EventBus.js"), f = n("./src/core/events/Events.js"), h = n("./src/core/Settings.js"), g = n("./src/streaming/constants/Constants.js"), p = n("./src/streaming/models/LowLatencyThroughputModel.js"), m = n("./src/streaming/models/CustomParametersModel.js");
                            function v(e, t, n) {
                                return t in e ? Object.defineProperty(e, t, {
                                    value: n,
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0
                                }) : e[t] = n, e;
                            }
                            function y(e) {
                                e = e || {};
                                var t, n, o, y, E, T, b, A, _, S, w = this.context, I = e.errHandler, R = e.dashMetrics, C = e.mediaPlayerModel, D = e.requestModifier, k = e.boxParser, N = e.errors, L = e.requestTimeout || 0, x = Object(d.default)(w).getInstance(), M = Object(h.default)(w).getInstance();
                                function O(e, t) {
                                    var u, c = e.request, d = [], h = !0, p = !0, m = new Date, v = m, S = 0, N = null;
                                    if (!D || !R || !I) throw new Error("config object is not correct or missing");
                                    var P, F = function(e) {
                                        if (p = !1, c.requestStartDate = m, c.requestEndDate = new Date, c.firstByteDate = c.firstByteDate || m, c.fileLoaderType = N, !c.checkExistenceOnly) {
                                            var t = u.response ? u.response.responseURL : null, n = u.response ? u.response.status : null, r = u.response && u.response.getAllResponseHeaders ? u.response.getAllResponseHeaders() : u.response ? u.response.responseHeaders : [];
                                            R.addHttpRequest(c, t, n, r, e ? d : null), c.type === a1.HTTPRequest.MPD_TYPE && R.addManifestUpdate(c);
                                        }
                                    }, U = function() {
                                        if (-1 !== n.indexOf(u) && (n.splice(n.indexOf(u), 1), p)) {
                                            if (F(!1), t > 0) {
                                                try {
                                                    M.get().streaming.utcSynchronization.enableBackgroundSyncAfterSegmentDownloadError && c.type === a1.HTTPRequest.MEDIA_SEGMENT_TYPE && C.getRetryAttemptsForType(a1.HTTPRequest.MEDIA_SEGMENT_TYPE) === t && x.trigger(f.default.ATTEMPT_BACKGROUND_SYNC);
                                                } catch (e) {}
                                                t--;
                                                var r = {
                                                    config: e
                                                };
                                                y.push(r), r.timeout = setTimeout(function() {
                                                    -1 !== y.indexOf(r) && (y.splice(y.indexOf(r), 1), O(e, t));
                                                }, C.getRetryIntervalsForType(c.type));
                                            } else {
                                                if (c.type === a1.HTTPRequest.MSS_FRAGMENT_INFO_SEGMENT_TYPE) return;
                                                I.error(new s1.default(E[c.type], c.url + " is not available", {
                                                    request: c,
                                                    response: u.response
                                                })), e.error && e.error(c, "error", u.response.statusText), e.complete && e.complete(c, u.response.statusText);
                                            }
                                        }
                                    };
                                    c.hasOwnProperty("availabilityTimeComplete") && !1 === c.availabilityTimeComplete && window.fetch && "arraybuffer" === c.responseType && c.type === a1.HTTPRequest.MEDIA_SEGMENT_TYPE ? ((P = Object(i.default)(w).create({
                                        requestModifier: D,
                                        lowLatencyThroughputModel: A,
                                        boxParser: k
                                    })).setup({
                                        dashMetrics: R
                                    }), N = g.default.FILE_LOADER_TYPES.FETCH) : (P = Object(r.default)(w).create({
                                        requestModifier: D
                                    }), N = g.default.FILE_LOADER_TYPES.XHR);
                                    var j = null, B = D.modifyRequestURL ? D.modifyRequestURL(c.url) : c.url;
                                    if (M.get().streaming.cmcd && M.get().streaming.cmcd.enabled) {
                                        var G = M.get().streaming.cmcd.mode;
                                        if (G === g.default.CMCD_MODE_QUERY) {
                                            var H = function(e) {
                                                try {
                                                    var t = [], n = T.getQueryParameter(e);
                                                    return n && t.push(n), t;
                                                } catch (e) {
                                                    return [];
                                                }
                                            }(c);
                                            B = l.default.addAditionalQueryParameterToUrl(B, H);
                                        } else G === g.default.CMCD_MODE_HEADER && (j = T.getHeaderParameters(c));
                                    }
                                    c.url = B;
                                    var V = c.checkExistenceOnly ? a1.HTTPRequest.HEAD : a1.HTTPRequest.GET, K = b.getXHRWithCredentialsForType(c.type);
                                    u = {
                                        url: B,
                                        method: V,
                                        withCredentials: K,
                                        request: c,
                                        onload: function() {
                                            u.response.status >= 200 && u.response.status <= 299 && (F(!0), e.success && e.success(u.response.response, u.response.statusText, u.response.responseURL), e.complete && e.complete(c, u.response.statusText));
                                        },
                                        onend: U,
                                        onerror: U,
                                        progress: function(t) {
                                            var n = new Date;
                                            h && (h = !1, (!t.lengthComputable || t.lengthComputable && t.total !== t.loaded) && (c.firstByteDate = n)), t.lengthComputable && (c.bytesLoaded = t.loaded, c.bytesTotal = t.total), t.noTrace || (d.push({
                                                s: v,
                                                d: t.time ? t.time : n.getTime() - v.getTime(),
                                                b: [
                                                    t.loaded ? t.loaded - S : 0
                                                ]
                                            }), v = n, S = t.loaded), e.progress && t && e.progress(t);
                                        },
                                        onabort: function() {
                                            e.abort && e.abort(c);
                                        },
                                        ontimeout: function(e) {
                                            var t;
                                            if (e.lengthComputable) {
                                                var n = e.loaded / e.total * 100;
                                                t = "Request timeout: loaded: " + e.loaded + ", out of: " + e.total + " : " + n.toFixed(3) + "% Completed";
                                            } else t = "Request timeout: non-computable download size";
                                            _.warn(t);
                                        },
                                        loader: P,
                                        timeout: L,
                                        headers: j
                                    };
                                    var q = (new Date).getTime();
                                    if (isNaN(c.delayLoadingTime) || q >= c.delayLoadingTime) n.push(u), P.load(u);
                                    else {
                                        var Y = {
                                            httpRequest: u
                                        };
                                        o.push(Y), Y.delayTimeout = setTimeout(function() {
                                            if (-1 !== o.indexOf(Y)) {
                                                o.splice(o.indexOf(Y), 1);
                                                try {
                                                    m = new Date, v = m, n.push(Y.httpRequest), P.load(Y.httpRequest);
                                                } catch (e) {
                                                    Y.httpRequest.onerror();
                                                }
                                            }
                                        }, c.delayLoadingTime - q);
                                    }
                                }
                                return t = {
                                    load: function(e) {
                                        e.request ? O(e, C.getRetryAttemptsForType(e.request.type)) : e.error && e.error(e.request, "error");
                                    },
                                    abort: function() {
                                        y.forEach(function(e) {
                                            clearTimeout(e.timeout), e.config.request && e.config.abort && e.config.abort(e.config.request);
                                        }), y = [], o.forEach(function(e) {
                                            return clearTimeout(e.delayTimeout);
                                        }), o = [], n.forEach(function(e) {
                                            e.request.type !== a1.HTTPRequest.MSS_FRAGMENT_INFO_SEGMENT_TYPE && (e.onloadend = e.onerror = e.onprogress = void 0, e.loader.abort(e));
                                        }), n = [];
                                    }
                                }, _ = Object(c.default)(w).getInstance().getLogger(t), n = [], o = [], y = [], T = Object(u.default)(w).getInstance(), A = Object(p.default)(w).getInstance(), b = Object(m.default)(w).getInstance(), v(S = {}, a1.HTTPRequest.MPD_TYPE, N.DOWNLOAD_ERROR_ID_MANIFEST_CODE), v(S, a1.HTTPRequest.XLINK_EXPANSION_TYPE, N.DOWNLOAD_ERROR_ID_XLINK_CODE), v(S, a1.HTTPRequest.INIT_SEGMENT_TYPE, N.DOWNLOAD_ERROR_ID_INITIALIZATION_CODE), v(S, a1.HTTPRequest.MEDIA_SEGMENT_TYPE, N.DOWNLOAD_ERROR_ID_CONTENT_CODE), v(S, a1.HTTPRequest.INDEX_SEGMENT_TYPE, N.DOWNLOAD_ERROR_ID_CONTENT_CODE), v(S, a1.HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE, N.DOWNLOAD_ERROR_ID_CONTENT_CODE), v(S, a1.HTTPRequest.OTHER_TYPE, N.DOWNLOAD_ERROR_ID_CONTENT_CODE), E = S, t;
                            }
                            y.__dashjs_factory_name = "HTTPLoader";
                            var E = o.default.getClassFactory(y);
                            t.default = E;
                        },
                        "./src/streaming/net/SchemeLoaderFactory.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/streaming/net/HTTPLoader.js");
                            function a1() {
                                var e;
                                function t() {
                                    e = {};
                                }
                                function n() {
                                    t();
                                }
                                return n(), {
                                    getLoader: function(t) {
                                        for(var n in e)if (e.hasOwnProperty(n) && t.startsWith(n)) return e[n];
                                        return i.default;
                                    },
                                    registerLoader: function(t, n) {
                                        e[t] = n;
                                    },
                                    unregisterLoader: function(t) {
                                        e[t] && delete e[t];
                                    },
                                    unregisterAllLoader: t,
                                    reset: n
                                };
                            }
                            a1.__dashjs_factory_name = "SchemeLoaderFactory";
                            var o = r.default.getSingletonFactory(a1);
                            t.default = o;
                        },
                        "./src/streaming/net/URLLoader.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/streaming/net/SchemeLoaderFactory.js");
                            function a1(e) {
                                e = e || {};
                                var t, n, r = this.context;
                                return t = Object(i.default)(r).getInstance(), {
                                    load: function(i) {
                                        if (!n) {
                                            var a1 = t.getLoader(i && i.request ? i.request.url : null);
                                            n = a1(r).create({
                                                errHandler: e.errHandler,
                                                mediaPlayerModel: e.mediaPlayerModel,
                                                requestModifier: e.requestModifier,
                                                dashMetrics: e.dashMetrics,
                                                boxParser: e.boxParser ? e.boxParser : null,
                                                constants: e.constants ? e.constants : null,
                                                dashConstants: e.dashConstants ? e.dashConstants : null,
                                                urlUtils: e.urlUtils ? e.urlUtils : null,
                                                requestTimeout: isNaN(e.requestTimeout) ? 0 : e.requestTimeout,
                                                errors: e.errors
                                            });
                                        }
                                        n.load(i);
                                    },
                                    abort: function() {
                                        n && n.abort();
                                    }
                                };
                            }
                            a1.__dashjs_factory_name = "URLLoader";
                            var o = r.default.getClassFactory(a1);
                            t.default = o;
                        },
                        "./src/streaming/net/XHRLoader.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/streaming/utils/RequestModifier.js");
                            function a1(e) {
                                var t = (e = e || {}).requestModifier;
                                function n(e) {
                                    var n = new Date, r = e.request, i = new XMLHttpRequest;
                                    if (i.open(e.method, e.url, !0), r.responseType && (i.responseType = r.responseType), r.range && i.setRequestHeader("Range", "bytes=" + r.range), r.requestStartDate || (r.requestStartDate = n), t && t.modifyRequestHeader && (i = t.modifyRequestHeader(i, {
                                        url: e.url
                                    })), e.headers) for(var a1 in e.headers){
                                        var o = e.headers[a1];
                                        o && i.setRequestHeader(a1, o);
                                    }
                                    i.withCredentials = e.withCredentials, i.onload = e.onload, i.onloadend = e.onend, i.onerror = e.onerror, i.onprogress = e.progress, i.onabort = e.onabort, i.ontimeout = e.ontimeout, i.timeout = e.timeout, i.send(), e.response = i;
                                }
                                return {
                                    load: function(e) {
                                        t && t.modifyRequest ? Object(i.modifyRequest)(e, t).then(function() {
                                            return n(e);
                                        }) : n(e);
                                    },
                                    abort: function(e) {
                                        var t = e.response;
                                        t.onloadend = t.onerror = t.onprogress = void 0, t.abort();
                                    }
                                };
                            }
                            a1.__dashjs_factory_name = "XHRLoader";
                            var o = r.default.getClassFactory(a1);
                            t.default = o;
                        },
                        "./src/streaming/protection/CommonEncryption.js": function(e, t, n) {
                            "use strict";
                            function r(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            n.r(t);
                            var i = {
                                attributes: [
                                    "Laurl",
                                    "laurl"
                                ],
                                prefixes: [
                                    "clearkey",
                                    "dashif"
                                ]
                            }, a1 = function() {
                                function e() {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e);
                                }
                                var t, n;
                                return t = e, n = [
                                    {
                                        key: "findCencContentProtection",
                                        value: function(e) {
                                            for(var t = null, n = 0; n < e.length; ++n){
                                                var r = e[n];
                                                "urn:mpeg:dash:mp4protection:2011" !== r.schemeIdUri.toLowerCase() || "cenc" !== r.value.toLowerCase() && "cbcs" !== r.value.toLowerCase() || (t = r);
                                            }
                                            return t;
                                        }
                                    },
                                    {
                                        key: "getPSSHData",
                                        value: function(e) {
                                            var t = 8, n = new DataView(e), r = n.getUint8(t);
                                            return t += 20, r > 0 && (t += 4 + 16 * n.getUint32(t)), t += 4, e.slice(t);
                                        }
                                    },
                                    {
                                        key: "getPSSHForKeySystem",
                                        value: function(t, n) {
                                            var r = e.parsePSSHList(n);
                                            return t && r.hasOwnProperty(t.uuid.toLowerCase()) ? r[t.uuid.toLowerCase()] : null;
                                        }
                                    },
                                    {
                                        key: "parseInitDataFromContentProtection",
                                        value: function(e, t) {
                                            return "pssh" in e ? (e.pssh.__text = e.pssh.__text.replace(/\r?\n|\r/g, "").replace(/\s+/g, ""), t.decodeArray(e.pssh.__text).buffer) : null;
                                        }
                                    },
                                    {
                                        key: "parsePSSHList",
                                        value: function(e) {
                                            if (null == e) return [];
                                            for(var t = new DataView(e.buffer || e), n = {}, r = 0;;){
                                                var i, a1, o = void 0, s1 = r;
                                                if (r >= t.buffer.byteLength) break;
                                                if (i = r + t.getUint32(r), r += 4, 1886614376 === t.getUint32(r)) {
                                                    if (r += 4, 0 === (a1 = t.getUint8(r)) || 1 === a1) {
                                                        r++, r += 3, o = "";
                                                        var u = void 0, l = void 0;
                                                        for(u = 0; u < 4; u++)o += 1 === (l = t.getUint8(r + u).toString(16)).length ? "0" + l : l;
                                                        for(r += 4, o += "-", u = 0; u < 2; u++)o += 1 === (l = t.getUint8(r + u).toString(16)).length ? "0" + l : l;
                                                        for(r += 2, o += "-", u = 0; u < 2; u++)o += 1 === (l = t.getUint8(r + u).toString(16)).length ? "0" + l : l;
                                                        for(r += 2, o += "-", u = 0; u < 2; u++)o += 1 === (l = t.getUint8(r + u).toString(16)).length ? "0" + l : l;
                                                        for(r += 2, o += "-", u = 0; u < 6; u++)o += 1 === (l = t.getUint8(r + u).toString(16)).length ? "0" + l : l;
                                                        r += 6, r += 4, n[o = o.toLowerCase()] = t.buffer.slice(s1, i), r = i;
                                                    } else r = i;
                                                } else r = i;
                                            }
                                            return n;
                                        }
                                    },
                                    {
                                        key: "getLicenseServerUrlFromMediaInfo",
                                        value: function(e, t) {
                                            try {
                                                if (!e || 0 === e.length) return null;
                                                for(var n = 0, r = null; n < e.length && !r;){
                                                    var a1 = e[n];
                                                    if (a1 && a1.contentProtection && a1.contentProtection.length > 0) {
                                                        var o = a1.contentProtection.filter(function(e) {
                                                            return e.schemeIdUri && e.schemeIdUri === t;
                                                        });
                                                        if (o && o.length > 0) for(var s1 = 0; s1 < o.length && !r;){
                                                            for(var u = o[s1], l = 0; l < i.attributes.length && !r;){
                                                                for(var c = 0, d = i.attributes[l]; c < i.prefixes.length && !r;){
                                                                    var f = i.prefixes[c];
                                                                    u[d] && u[d].__prefix && u[d].__prefix === f && u[d].__text && (r = u[d].__text), c += 1;
                                                                }
                                                                l += 1;
                                                            }
                                                            s1 += 1;
                                                        }
                                                    }
                                                    n += 1;
                                                }
                                                return r;
                                            } catch (e) {
                                                return null;
                                            }
                                        }
                                    }
                                ], n && r(t, n), e;
                            }();
                            t.default = a1;
                        },
                        "./src/streaming/protection/Protection.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/protection/controllers/ProtectionController.js"), i = n("./src/streaming/protection/controllers/ProtectionKeyController.js"), a1 = n("./src/streaming/protection/ProtectionEvents.js"), o = n("./src/streaming/protection/errors/ProtectionErrors.js"), s1 = n("./src/streaming/protection/models/ProtectionModel_21Jan2015.js"), u = n("./src/streaming/protection/models/ProtectionModel_3Feb2014.js"), l = n("./src/streaming/protection/models/ProtectionModel_01b.js"), c = [
                                {
                                    generateKeyRequest: "generateKeyRequest",
                                    addKey: "addKey",
                                    cancelKeyRequest: "cancelKeyRequest",
                                    needkey: "needkey",
                                    keyerror: "keyerror",
                                    keyadded: "keyadded",
                                    keymessage: "keymessage"
                                },
                                {
                                    generateKeyRequest: "webkitGenerateKeyRequest",
                                    addKey: "webkitAddKey",
                                    cancelKeyRequest: "webkitCancelKeyRequest",
                                    needkey: "webkitneedkey",
                                    keyerror: "webkitkeyerror",
                                    keyadded: "webkitkeyadded",
                                    keymessage: "webkitkeymessage"
                                }
                            ], d = [
                                {
                                    setMediaKeys: "setMediaKeys",
                                    MediaKeys: "MediaKeys",
                                    release: "close",
                                    needkey: "needkey",
                                    error: "keyerror",
                                    message: "keymessage",
                                    ready: "keyadded",
                                    close: "keyclose"
                                },
                                {
                                    setMediaKeys: "msSetMediaKeys",
                                    MediaKeys: "MSMediaKeys",
                                    release: "close",
                                    needkey: "msneedkey",
                                    error: "mskeyerror",
                                    message: "mskeymessage",
                                    ready: "mskeyadded",
                                    close: "mskeyclose"
                                }
                            ];
                            function f() {
                                var e, t = this.context;
                                function n(e, t) {
                                    for(var n = 0; n < t.length; n++){
                                        var r = t[n];
                                        if ("function" == typeof e[r[Object.keys(r)[0]]]) return r;
                                    }
                                    return null;
                                }
                                return e = {
                                    createProtectionSystem: function(a1) {
                                        var o = null, f = Object(i.default)(t).getInstance();
                                        f.setConfig({
                                            debug: a1.debug,
                                            BASE64: a1.BASE64,
                                            settings: a1.settings
                                        }), f.initialize();
                                        var h = function(r) {
                                            var i = r.debug, a1 = i.getLogger(e), o = r.eventBus, f = r.errHandler, h = r.videoModel ? r.videoModel.getElement() : null;
                                            return h && void 0 === h.onencrypted || h && void 0 === h.mediaKeys ? n(h, d) ? (a1.info("EME detected on this user agent! (ProtectionModel_3Feb2014)"), Object(u.default)(t).create({
                                                debug: i,
                                                eventBus: o,
                                                events: r.events,
                                                api: n(h, d)
                                            })) : n(h, c) ? (a1.info("EME detected on this user agent! (ProtectionModel_01b)"), Object(l.default)(t).create({
                                                debug: i,
                                                eventBus: o,
                                                errHandler: f,
                                                events: r.events,
                                                api: n(h, c)
                                            })) : (a1.warn("No supported version of EME detected on this user agent! - Attempts to play encrypted content will fail!"), null) : (a1.info("EME detected on this user agent! (ProtectionModel_21Jan2015)"), Object(s1.default)(t).create({
                                                debug: i,
                                                eventBus: o,
                                                events: r.events
                                            }));
                                        }(a1);
                                        return !o && h && (o = Object(r.default)(t).create({
                                            protectionModel: h,
                                            protectionKeyController: f,
                                            eventBus: a1.eventBus,
                                            debug: a1.debug,
                                            events: a1.events,
                                            BASE64: a1.BASE64,
                                            constants: a1.constants,
                                            cmcdModel: a1.cmcdModel,
                                            customParametersModel: a1.customParametersModel,
                                            settings: a1.settings
                                        }), a1.capabilities.setEncryptedMediaSupported(!0)), o;
                                    }
                                };
                            }
                            f.__dashjs_factory_name = "Protection";
                            var h = dashjs.FactoryMaker.getClassFactory(f);
                            h.events = a1.default, h.errors = o.default, dashjs.FactoryMaker.updateClassFactory(f.__dashjs_factory_name, h), t.default = h;
                        },
                        "./src/streaming/protection/ProtectionEvents.js": function(e, t, n) {
                            "use strict";
                            function r(e) {
                                return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, r(e);
                            }
                            function i(e, t) {
                                return i = Object.setPrototypeOf || function(e, t) {
                                    return e.__proto__ = t, e;
                                }, i(e, t);
                            }
                            function a1(e, t) {
                                return !t || "object" !== r(t) && "function" != typeof t ? function(e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e;
                                }(e) : t;
                            }
                            function o(e) {
                                return o = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                                    return e.__proto__ || Object.getPrototypeOf(e);
                                }, o(e);
                            }
                            n.r(t);
                            var s1 = new (function(e) {
                                !function(e, t) {
                                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                    e.prototype = Object.create(t && t.prototype, {
                                        constructor: {
                                            value: e,
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }), t && i(e, t);
                                }(s1, e);
                                var t, n, r = (t = s1, n = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e, r = o(t);
                                    if (n) {
                                        var i = o(this).constructor;
                                        e = Reflect.construct(r, arguments, i);
                                    } else e = r.apply(this, arguments);
                                    return a1(this, e);
                                });
                                function s1() {
                                    var e;
                                    return function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, s1), (e = r.call(this)).INTERNAL_KEY_MESSAGE = "internalKeyMessage", e.INTERNAL_KEY_STATUS_CHANGED = "internalkeyStatusChanged", e.KEY_ADDED = "public_keyAdded", e.KEY_ERROR = "public_keyError", e.KEY_MESSAGE = "public_keyMessage", e.KEY_SESSION_CLOSED = "public_keySessionClosed", e.KEY_SESSION_CREATED = "public_keySessionCreated", e.KEY_SESSION_REMOVED = "public_keySessionRemoved", e.KEY_STATUSES_CHANGED = "public_keyStatusesChanged", e.KEY_SYSTEM_ACCESS_COMPLETE = "public_keySystemAccessComplete", e.KEY_SYSTEM_SELECTED = "public_keySystemSelected", e.LICENSE_REQUEST_COMPLETE = "public_licenseRequestComplete", e.LICENSE_REQUEST_SENDING = "public_licenseRequestSending", e.NEED_KEY = "needkey", e.PROTECTION_CREATED = "public_protectioncreated", e.PROTECTION_DESTROYED = "public_protectiondestroyed", e.SERVER_CERTIFICATE_UPDATED = "serverCertificateUpdated", e.TEARDOWN_COMPLETE = "protectionTeardownComplete", e.VIDEO_ELEMENT_SELECTED = "videoElementSelected", e.KEY_SESSION_UPDATED = "public_keySessionUpdated", e;
                                }
                                return s1;
                            }(n("./src/core/events/EventsBase.js").default));
                            t.default = s1;
                        },
                        "./src/streaming/protection/controllers/ProtectionController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/protection/CommonEncryption.js"), i = n("./src/streaming/protection/vo/MediaCapability.js"), a1 = n("./src/streaming/protection/vo/KeySystemConfiguration.js"), o = n("./src/streaming/protection/errors/ProtectionErrors.js"), s1 = n("./src/streaming/vo/DashJSError.js"), u = n("./src/streaming/protection/vo/LicenseRequest.js"), l = n("./src/streaming/protection/vo/LicenseResponse.js"), c = n("./src/streaming/vo/metrics/HTTPRequest.js"), d = n("./src/core/Utils.js"), f = n("./src/streaming/constants/Constants.js"), h = n("./src/core/FactoryMaker.js");
                            function g(e) {
                                return g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, g(e);
                            }
                            function p(e) {
                                var t, n, h, p, m, v, y, E, T, b, A, _ = (e = e || {}).protectionKeyController, S = e.protectionModel, w = e.eventBus, I = e.events, R = e.debug, C = e.BASE64, D = e.constants, k = [], N = e.cmcdModel, L = e.settings, x = e.customParametersModel;
                                function M() {
                                    if (!(w && w.hasOwnProperty("on") && _ && _.hasOwnProperty("getSupportedKeySystemsFromContentProtection"))) throw new Error("Missing config parameter(s)");
                                }
                                function O(e, t) {
                                    E || T ? E && P() : function(e, t) {
                                        if (!T) {
                                            T = !0;
                                            var r, i = [];
                                            e = e.sort(function(t, n) {
                                                return (m && m[t.ks.systemString] && m[t.ks.systemString].priority >= 0 ? m[t.ks.systemString].priority : e.length) - (m && m[n.ks.systemString] && m[n.ks.systemString].priority >= 0 ? m[n.ks.systemString].priority : e.length);
                                            });
                                            for(var a1 = 0; a1 < e.length; a1++){
                                                var u = V(e[a1]);
                                                i.push({
                                                    ks: e[a1].ks,
                                                    configs: [
                                                        u
                                                    ],
                                                    protData: e[a1].protData
                                                });
                                            }
                                            S.requestKeySystemAccess(i).then(function(e) {
                                                var t = (r = e.data).mksa && r.mksa.selectedSystemString ? r.mksa.selectedSystemString : r.keySystem.systemString;
                                                return n.info("DRM: KeySystem Access Granted for system string (" + t + ")!  Selecting key system..."), S.selectKeySystem(r);
                                            }).then(function(e) {
                                                if (E = e, T = !1, S) {
                                                    w.trigger(I.KEY_SYSTEM_SELECTED, {
                                                        data: r
                                                    });
                                                    var t = B(E);
                                                    t && t.serverCertificate && t.serverCertificate.length > 0 && S.setServerCertificate(C.decodeArray(t.serverCertificate).buffer), P();
                                                }
                                            }).catch(function(e) {
                                                E = null, T = !1, t || w.trigger(I.KEY_SYSTEM_SELECTED, {
                                                    data: null,
                                                    error: new s1.default(o.default.KEY_SYSTEM_ACCESS_DENIED_ERROR_CODE, o.default.KEY_SYSTEM_ACCESS_DENIED_ERROR_MESSAGE + "Error selecting key system! -- " + e.error)
                                                });
                                            });
                                        }
                                    }(e, t);
                                }
                                function P() {
                                    for(var e, t = 0; t < h.length; t++)for(e = 0; e < h[t].length; e++)if (E === h[t][e].ks) {
                                        F(h[t][e]);
                                        break;
                                    }
                                    h = [];
                                }
                                function F(e) {
                                    if (_.isClearKey(E) && e.protData && e.protData.hasOwnProperty("clearkeys") && 0 !== Object.keys(e.protData.clearkeys).length) {
                                        var t = {
                                            kids: Object.keys(e.protData.clearkeys)
                                        };
                                        e.initData = (new TextEncoder).encode(JSON.stringify(t));
                                    }
                                    e.sessionId ? U(e) : null !== e.initData && j(e);
                                }
                                function U(e) {
                                    M(), S.loadKeySession(e);
                                }
                                function j(e) {
                                    var t = r.default.getPSSHForKeySystem(E, e ? e.initData : null);
                                    if (t) {
                                        if (function(e) {
                                            if (!e) return !1;
                                            try {
                                                for(var t = S.getSessions(), n = 0; n < t.length; n++)if (t[n].getKeyId() === e) return !0;
                                                return !1;
                                            } catch (e) {
                                                return !1;
                                            }
                                        }(e.keyId)) return;
                                        if (G(t)) return;
                                        try {
                                            e.initData = t, S.createKeySession(e);
                                        } catch (e) {
                                            w.trigger(I.KEY_SESSION_CREATED, {
                                                data: null,
                                                error: new s1.default(o.default.KEY_SESSION_CREATED_ERROR_CODE, o.default.KEY_SESSION_CREATED_ERROR_MESSAGE + e.message)
                                            });
                                        }
                                    } else e && e.initData ? S.createKeySession(e) : w.trigger(I.KEY_SESSION_CREATED, {
                                        data: null,
                                        error: new s1.default(o.default.KEY_SESSION_CREATED_ERROR_CODE, o.default.KEY_SESSION_CREATED_ERROR_MESSAGE + "Selected key system is " + (E ? E.systemString : null) + ".  needkey/encrypted event contains no initData corresponding to that key system!")
                                    });
                                }
                                function B(e) {
                                    if (e) {
                                        var t = e.systemString;
                                        if (m) return t in m ? m[t] : null;
                                    }
                                    return null;
                                }
                                function G(e) {
                                    if (!e) return !1;
                                    try {
                                        for(var t = S.getAllInitData(), r = 0; r < t.length; r++)if (_.initDataEquals(e, t[r])) return n.debug("DRM: Ignoring initData because we have already seen it!"), !0;
                                        return !1;
                                    } catch (e) {
                                        return !1;
                                    }
                                }
                                function H(e) {
                                    M(), e ? (S.setMediaElement(e), w.on(I.NEED_KEY, Z, t)) : null === e && (S.setMediaElement(e), w.off(I.NEED_KEY, Z, t));
                                }
                                function V(e) {
                                    var t = e.protData, n = [], r = [], o = t && t.audioRobustness && t.audioRobustness.length > 0 ? t.audioRobustness : y, s1 = t && t.videoRobustness && t.videoRobustness.length > 0 ? t.videoRobustness : y, u = e.sessionType, l = t && t.distinctiveIdentifier ? t.distinctiveIdentifier : "optional", c = t && t.persistentState ? t.persistentState : "temporary" === u ? "optional" : "required";
                                    return p.forEach(function(e) {
                                        e.type === D.AUDIO ? n.push(new i.default(e.codec, o)) : e.type === D.VIDEO && r.push(new i.default(e.codec, s1));
                                    }), new a1.default(n, r, l, c, [
                                        u
                                    ]);
                                }
                                function K(e) {
                                    e.error ? w.trigger(I.KEY_STATUSES_CHANGED, {
                                        data: null,
                                        error: e.error
                                    }) : n.debug("DRM: key status = " + e.status);
                                }
                                function q(e) {
                                    n.debug("DRM: onKeyMessage");
                                    var t = e.data;
                                    w.trigger(I.KEY_MESSAGE, {
                                        data: t
                                    });
                                    var i = t.messageType ? t.messageType : "license-request", a1 = t.message, f = t.sessionToken, h = B(E), m = _.getLicenseServerModelInstance(E, h, i), v = {
                                        sessionToken: f,
                                        messageType: i
                                    };
                                    if (a1 && 0 !== a1.byteLength) {
                                        if (!m) return n.debug("DRM: License server request not required for this message (type = " + e.data.messageType + ").  Session ID = " + f.getSessionId()), void Y(v);
                                        if (_.isClearKey(E)) {
                                            var y = _.processClearKeyLicenseRequest(E, h, a1);
                                            if (y && y.keyPairs && y.keyPairs.length > 0) return n.debug("DRM: ClearKey license request handled by application!"), Y(v), void S.updateKeySession(f, y);
                                        }
                                        !function(e, t, n) {
                                            var i = e.sessionToken, a1 = e.messageType ? e.messageType : "license-request", f = {
                                                sessionToken: i,
                                                messageType: a1
                                            }, h = E ? E.systemString : null, m = function(e, t, n, i, a1) {
                                                var o = null, s1 = i.message;
                                                if (e && e.serverURL) {
                                                    var u = e.serverURL;
                                                    "string" == typeof u && "" !== u ? o = u : "object" === g(u) && u.hasOwnProperty(t) && (o = u[t]);
                                                } else if (e && e.laURL && "" !== e.laURL) o = e.laURL;
                                                else if (!(o = r.default.getLicenseServerUrlFromMediaInfo(p, E.schemeIdURI)) && !_.isClearKey(E)) {
                                                    var l = r.default.getPSSHData(n.initData);
                                                    (o = E.getLicenseServerURLFromInitData(l)) || (o = i.laURL);
                                                }
                                                return a1.getServerURLFromMessage(o, s1, t);
                                            }(n, a1, i, e, t);
                                            if (m) {
                                                var v = {}, y = !1;
                                                n && X(v, n.httpRequestHeaders);
                                                var T = e.message;
                                                X(v, E.getRequestHeadersFromMessage(T)), Object.keys(v).forEach(function(e) {
                                                    "authorization" === e.toLowerCase() && (y = !0);
                                                }), n && "boolean" == typeof n.withCredentials && (y = n.withCredentials);
                                                var b = function(e) {
                                                    if (S) {
                                                        if (e.status >= 200 && e.status <= 299) {
                                                            var n = d.default.parseHttpHeaders(e.getAllResponseHeaders ? e.getAllResponseHeaders() : null), r = new l.default(e.responseURL, n, e.response);
                                                            J(x.getLicenseResponseFilters(), r).then(function() {
                                                                var n = t.getLicenseMessage(r.data, h, a1);
                                                                null !== n ? (Y(f), S.updateKeySession(i, n)) : Q(e, f, h, a1, t);
                                                            });
                                                        } else Q(e, f, h, a1, t);
                                                    }
                                                }, A = function(e) {
                                                    Y(f, new s1.default(o.default.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, o.default.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + h + ' update, XHR aborted. status is "' + e.statusText + '" (' + e.status + "), readyState is " + e.readyState));
                                                }, w = function(e) {
                                                    Y(f, new s1.default(o.default.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, o.default.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + h + ' update, XHR error. status is "' + e.statusText + '" (' + e.status + "), readyState is " + e.readyState));
                                                }, I = E.getLicenseRequestFromMessage(T), R = t.getHTTPMethod(a1), C = t.getResponseType(h, a1), D = n && !isNaN(n.httpTimeout) ? n.httpTimeout : 8e3, k = i.getSessionId() || null, N = new u.default(m, R, C, v, y, a1, k, I), M = isNaN(L.get().streaming.retryAttempts[c.HTTPRequest.LICENSE]) ? 3 : L.get().streaming.retryAttempts[c.HTTPRequest.LICENSE];
                                                J(x.getLicenseRequestFilters(), N).then(function() {
                                                    W(N, M, D, b, A, w);
                                                });
                                            } else Y(f, new s1.default(o.default.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_CODE, o.default.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_MESSAGE));
                                        }(t, m, h);
                                    } else Y(v, new s1.default(o.default.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_CODE, o.default.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_MESSAGE));
                                }
                                function Y(e, t) {
                                    w.trigger(I.LICENSE_REQUEST_COMPLETE, {
                                        data: e,
                                        error: t
                                    });
                                }
                                function W(e, t, r, i, a1, o) {
                                    var s1 = new XMLHttpRequest;
                                    if (L.get().streaming.cmcd && L.get().streaming.cmcd.enabled && L.get().streaming.cmcd.mode === f.default.CMCD_MODE_QUERY) {
                                        var u = N.getQueryParameter({
                                            url: e.url,
                                            type: c.HTTPRequest.LICENSE
                                        });
                                        u && (e.url = d.default.addAditionalQueryParameterToUrl(e.url, [
                                            u
                                        ]));
                                    }
                                    for(var l in s1.open(e.method, e.url, !0), s1.responseType = e.responseType, s1.withCredentials = e.withCredentials, r > 0 && (s1.timeout = r), e.headers)s1.setRequestHeader(l, e.headers[l]);
                                    if (L.get().streaming.cmcd && L.get().streaming.cmcd.enabled && L.get().streaming.cmcd.mode === f.default.CMCD_MODE_HEADER) {
                                        var h = N.getHeaderParameters({
                                            url: e.url,
                                            type: c.HTTPRequest.LICENSE
                                        });
                                        if (h) for(var g in h){
                                            var p = h[g];
                                            p && s1.setRequestHeader(g, p);
                                        }
                                    }
                                    var m = function() {
                                        t--;
                                        var n = isNaN(L.get().streaming.retryIntervals[c.HTTPRequest.LICENSE]) ? 1e3 : L.get().streaming.retryIntervals[c.HTTPRequest.LICENSE];
                                        A = setTimeout(function() {
                                            W(e, t, r, i, a1, o);
                                        }, n);
                                    };
                                    s1.onload = function() {
                                        b = null, this.status >= 200 && this.status <= 299 || t <= 0 ? i(this) : (n.warn("License request failed (" + this.status + "). Retrying it... Pending retries: " + t), m());
                                    }, s1.ontimeout = s1.onerror = function() {
                                        b = null, t <= 0 ? o(this) : (n.warn("License request network request failed . Retrying it... Pending retries: " + t), m());
                                    }, s1.onabort = function() {
                                        a1(this);
                                    }, w.trigger(I.LICENSE_REQUEST_SENDING, {
                                        url: e.url,
                                        headers: e.headers,
                                        payload: e.data,
                                        sessionId: e.sessionId
                                    }), b = s1, s1.send(e.data);
                                }
                                function z() {
                                    b && (b.onloadend = b.onerror = b.onprogress = void 0, b.abort(), b = null), A && (clearTimeout(A), A = null);
                                }
                                function X(e, t) {
                                    if (t) for(var n in t)e[n] = t[n];
                                }
                                function Q(e, t, n, r, i) {
                                    var a1 = "NONE", u = null;
                                    e.response && (a1 = i.getErrorResponse(e.response, n, r), u = {
                                        serverResponse: e.response || null,
                                        responseCode: e.status || null,
                                        responseText: e.statusText || null
                                    }), Y(t, new s1.default(o.default.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, o.default.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + n + ' update, XHR complete. status is "' + e.statusText + '" (' + e.status + "), readyState is " + e.readyState + ".  Response is " + a1, u));
                                }
                                function J(e, t) {
                                    return e ? e.reduce(function(e, n) {
                                        return e.then(function() {
                                            return n(t);
                                        });
                                    }, Promise.resolve()) : Promise.resolve();
                                }
                                function Z(e, t) {
                                    if (!L.get().streaming.protection.ignoreEmeEncryptedEvent) {
                                        if (n.debug("DRM: onNeedKey"), "cenc" !== e.key.initDataType) return void n.warn("DRM:  Only 'cenc' initData is supported!  Ignoring initData of type: " + e.key.initDataType);
                                        if (0 === p.length && (n.warn("DRM: onNeedKey called before initializeForMedia, wait until initialized"), (t = void 0 === t ? 1 : t + 1) < 5)) return void k.push(setTimeout(function() {
                                            Z(e, t);
                                        }, 500));
                                        var i = e.key.initData;
                                        if (ArrayBuffer.isView(i) && (i = i.buffer), E) {
                                            var a1 = r.default.getPSSHForKeySystem(E, i);
                                            if (a1 && G(a1)) return;
                                        }
                                        n.debug("DRM: initData:", String.fromCharCode.apply(null, new Uint8Array(i)));
                                        var o = _.getSupportedKeySystemsFromSegmentPssh(i, m, v);
                                        if (0 === o.length) return void n.debug("DRM: Received needkey event with initData, but we don't support any of the key systems!");
                                        !function(e) {
                                            h.push(e), O(e, !1);
                                        }(o);
                                    }
                                }
                                return t = {
                                    initializeForMedia: function(e) {
                                        if (!e) throw new Error("mediaInfo can not be null or undefined");
                                        M(), p.push(e);
                                    },
                                    clearMediaInfoArray: function() {
                                        p = [];
                                    },
                                    handleKeySystemFromManifest: function() {
                                        if (p && 0 !== p.length) {
                                            var e = [];
                                            p.forEach(function(t) {
                                                var n = _.getSupportedKeySystemsFromContentProtection(t.contentProtection, m, v);
                                                n.length > 0 && (0 === e.length && (e = n), h.push(n));
                                            }), e && e.length > 0 && O(e, !0);
                                        }
                                    },
                                    createKeySession: j,
                                    loadKeySession: U,
                                    removeKeySession: function(e) {
                                        M(), S.removeKeySession(e);
                                    },
                                    closeKeySession: function(e) {
                                        M(), S.closeKeySession(e);
                                    },
                                    setServerCertificate: function(e) {
                                        M(), S.setServerCertificate(e);
                                    },
                                    setMediaElement: H,
                                    setSessionType: function(e) {
                                        v = e;
                                    },
                                    setRobustnessLevel: function(e) {
                                        y = e;
                                    },
                                    setProtectionData: function(e) {
                                        m = e, _.setProtectionData(e);
                                    },
                                    getSupportedKeySystemsFromContentProtection: function(e) {
                                        return M(), _.getSupportedKeySystemsFromContentProtection(e, m, v);
                                    },
                                    getKeySystems: function() {
                                        return _ ? _.getKeySystems() : [];
                                    },
                                    setKeySystems: function(e) {
                                        _ && _.setKeySystems(e);
                                    },
                                    stop: function() {
                                        z(), S && S.stop();
                                    },
                                    reset: function() {
                                        w.off(I.INTERNAL_KEY_MESSAGE, q, t), w.off(I.INTERNAL_KEY_STATUS_CHANGED, K, t), M(), z(), H(null), E = null, T = !1, S && (S.reset(), S = null), k.forEach(function(e) {
                                            return clearTimeout(e);
                                        }), k = [], p = [], h = [];
                                    }
                                }, n = R.getLogger(t), h = [], p = [], v = "temporary", y = "", b = null, A = null, w.on(I.INTERNAL_KEY_MESSAGE, q, t), w.on(I.INTERNAL_KEY_STATUS_CHANGED, K, t), t;
                            }
                            p.__dashjs_factory_name = "ProtectionController", t.default = h.default.getClassFactory(p);
                        },
                        "./src/streaming/protection/controllers/ProtectionKeyController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/protection/CommonEncryption.js"), i = n("./src/streaming/protection/drm/KeySystemClearKey.js"), a1 = n("./src/streaming/protection/drm/KeySystemW3CClearKey.js"), o = n("./src/streaming/protection/drm/KeySystemWidevine.js"), s1 = n("./src/streaming/protection/drm/KeySystemPlayReady.js"), u = n("./src/streaming/protection/servers/DRMToday.js"), l = n("./src/streaming/protection/servers/PlayReady.js"), c = n("./src/streaming/protection/servers/Widevine.js"), d = n("./src/streaming/protection/servers/ClearKey.js"), f = n("./src/streaming/constants/ProtectionConstants.js");
                            function h() {
                                var e, t, n, h, g, p, m, v, y = this.context;
                                function E(e, t) {
                                    return t && e in t ? t[e] : null;
                                }
                                function T(e, t) {
                                    return e && e.sessionId ? e.sessionId : t && t.sessionId ? t.sessionId : null;
                                }
                                function b(e, t) {
                                    return e && e.sessionType ? e.sessionType : t;
                                }
                                return e = {
                                    initialize: function() {
                                        var e;
                                        h = [], e = Object(s1.default)(y).getInstance({
                                            BASE64: g,
                                            settings: p
                                        }), h.push(e), e = Object(o.default)(y).getInstance({
                                            BASE64: g
                                        }), h.push(e), e = Object(i.default)(y).getInstance({
                                            BASE64: g
                                        }), h.push(e), m = e, e = Object(a1.default)(y).getInstance({
                                            BASE64: g,
                                            debug: t
                                        }), h.push(e), v = e;
                                    },
                                    setProtectionData: function(e) {
                                        for(var t, n, r = 0; r < h.length; r++){
                                            var i = h[r];
                                            i.hasOwnProperty("init") && i.init((t = i.systemString, n = void 0, n = null, e && (n = t in e ? e[t] : null), n));
                                        }
                                    },
                                    isClearKey: function(e) {
                                        return e === m || e === v;
                                    },
                                    initDataEquals: function(e, t) {
                                        if (e.byteLength === t.byteLength) {
                                            for(var n = new Uint8Array(e), r = new Uint8Array(t), i = 0; i < n.length; i++)if (n[i] !== r[i]) return !1;
                                            return !0;
                                        }
                                        return !1;
                                    },
                                    getKeySystems: function() {
                                        return h;
                                    },
                                    setKeySystems: function(e) {
                                        h = e;
                                    },
                                    getKeySystemBySystemString: function(e) {
                                        for(var t = 0; t < h.length; t++)if (h[t].systemString === e) return h[t];
                                        return null;
                                    },
                                    getSupportedKeySystemsFromContentProtection: function(e, t, n) {
                                        var i, a1, o, s1, u = [];
                                        if (e) {
                                            var l = r.default.findCencContentProtection(e);
                                            for(o = 0; o < h.length; ++o){
                                                var c = E((a1 = h[o]).systemString, t);
                                                for(s1 = 0; s1 < e.length; ++s1)if ((i = e[s1]).schemeIdUri.toLowerCase() === a1.schemeIdURI) {
                                                    var d = a1.getInitData(i, l);
                                                    u.push({
                                                        ks: h[o],
                                                        keyId: i.keyId,
                                                        initData: d,
                                                        protData: c,
                                                        cdmData: a1.getCDMData(c ? c.cdmData : null),
                                                        sessionId: T(c, i),
                                                        sessionType: b(c, n)
                                                    });
                                                }
                                            }
                                        }
                                        return u;
                                    },
                                    getSupportedKeySystemsFromSegmentPssh: function(e, t, n) {
                                        for(var i, a1 = [], o = r.default.parsePSSHList(e), s1 = 0; s1 < h.length; ++s1){
                                            var u = E((i = h[s1]).systemString, t);
                                            i.uuid in o && a1.push({
                                                ks: i,
                                                initData: o[i.uuid],
                                                protData: u,
                                                cdmData: i.getCDMData(u ? u.cdmData : null),
                                                sessionId: T(u),
                                                sessionType: b(u, n)
                                            });
                                        }
                                        return a1;
                                    },
                                    getLicenseServerModelInstance: function(e, t, n) {
                                        if ("license-release" === n || "individualization-request" === n) return null;
                                        var r = null;
                                        return t && t.hasOwnProperty("drmtoday") ? r = Object(u.default)(y).getInstance({
                                            BASE64: g
                                        }) : e.systemString === f.default.WIDEVINE_KEYSTEM_STRING ? r = Object(c.default)(y).getInstance() : e.systemString === f.default.PLAYREADY_KEYSTEM_STRING ? r = Object(l.default)(y).getInstance() : e.systemString === f.default.CLEARKEY_KEYSTEM_STRING && (r = Object(d.default)(y).getInstance()), r;
                                    },
                                    processClearKeyLicenseRequest: function(e, t, r) {
                                        try {
                                            return e.getClearKeysFromProtectionData(t, r);
                                        } catch (e) {
                                            return n.error("Failed to retrieve clearkeys from ProtectionData"), null;
                                        }
                                    },
                                    setConfig: function(r) {
                                        r && (r.debug && (t = r.debug, n = t.getLogger(e)), r.BASE64 && (g = r.BASE64), r.settings && (p = r.settings));
                                    }
                                };
                            }
                            h.__dashjs_factory_name = "ProtectionKeyController", t.default = dashjs.FactoryMaker.getSingletonFactory(h);
                        },
                        "./src/streaming/protection/drm/KeySystemClearKey.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/protection/vo/KeyPair.js"), i = n("./src/streaming/protection/vo/ClearKeyKeySet.js"), a1 = n("./src/streaming/protection/CommonEncryption.js"), o = n("./src/streaming/constants/ProtectionConstants.js"), s1 = o.default.CLEARKEY_KEYSTEM_STRING;
                            function u(e) {
                                var t = (e = e || {}).BASE64;
                                return {
                                    uuid: "e2719d58-a985-b3c9-781a-b030af78d30e",
                                    schemeIdURI: "urn:uuid:e2719d58-a985-b3c9-781a-b030af78d30e",
                                    systemString: s1,
                                    getInitData: function(e, n) {
                                        try {
                                            var r = a1.default.parseInitDataFromContentProtection(e, t);
                                            if (!r && n) {
                                                var i = {
                                                    kids: [
                                                        function(e) {
                                                            try {
                                                                var t = e.replace(/-/g, "");
                                                                return (t = btoa(t.match(/\w{2}/g).map(function(e) {
                                                                    return String.fromCharCode(parseInt(e, 16));
                                                                }).join(""))).replace(/=/g, "").replace(/\//g, "_").replace(/\+/g, "-");
                                                            } catch (e) {
                                                                return null;
                                                            }
                                                        }(n["cenc:default_KID"])
                                                    ]
                                                };
                                                r = (new TextEncoder).encode(JSON.stringify(i));
                                            }
                                            return r;
                                        } catch (e) {
                                            return null;
                                        }
                                    },
                                    getRequestHeadersFromMessage: function() {
                                        return {
                                            "Content-Type": "application/json"
                                        };
                                    },
                                    getLicenseRequestFromMessage: function(e) {
                                        return JSON.stringify(JSON.parse(String.fromCharCode.apply(null, new Uint8Array(e))));
                                    },
                                    getLicenseServerURLFromInitData: function() {
                                        return null;
                                    },
                                    getCDMData: function() {
                                        return null;
                                    },
                                    getClearKeysFromProtectionData: function(e, t) {
                                        var n = null;
                                        if (e) {
                                            for(var a1 = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(t))), o = [], s1 = 0; s1 < a1.kids.length; s1++){
                                                var u = a1.kids[s1], l = e.clearkeys && e.clearkeys.hasOwnProperty(u) ? e.clearkeys[u] : null;
                                                if (!l) throw new Error("DRM: ClearKey keyID (" + u + ") is not known!");
                                                o.push(new r.default(u, l));
                                            }
                                            n = new i.default(o);
                                        }
                                        return n;
                                    }
                                };
                            }
                            u.__dashjs_factory_name = "KeySystemClearKey", t.default = dashjs.FactoryMaker.getSingletonFactory(u);
                        },
                        "./src/streaming/protection/drm/KeySystemPlayReady.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/protection/CommonEncryption.js"), i = n("./src/streaming/constants/ProtectionConstants.js"), a1 = i.default.PLAYREADY_KEYSTEM_STRING;
                            function o(e) {
                                var t = "utf-16", n = (e = e || {}).BASE64, i = e.settings;
                                function o() {
                                    if (!n || !n.hasOwnProperty("decodeArray") || !n.hasOwnProperty("decodeArray")) throw new Error("Missing config parameter(s)");
                                }
                                return {
                                    uuid: "9a04f079-9840-4286-ab92-e65be0885f95",
                                    schemeIdURI: "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95",
                                    systemString: a1,
                                    getInitData: function(e) {
                                        var t, i, a1, s1, u, l = new Uint8Array([
                                            112,
                                            115,
                                            115,
                                            104,
                                            0,
                                            0,
                                            0,
                                            0
                                        ]), c = new Uint8Array([
                                            154,
                                            4,
                                            240,
                                            121,
                                            152,
                                            64,
                                            66,
                                            134,
                                            171,
                                            146,
                                            230,
                                            91,
                                            224,
                                            136,
                                            95,
                                            149
                                        ]), d = 0, f = null;
                                        if (o(), !e) return null;
                                        if ("pssh" in e) return r.default.parseInitDataFromContentProtection(e, n);
                                        if ("pro" in e) f = n.decodeArray(e.pro.__text);
                                        else {
                                            if (!("prheader" in e)) return null;
                                            f = n.decodeArray(e.prheader.__text);
                                        }
                                        return t = f.length, i = 4 + l.length + c.length + 4 + t, a1 = new ArrayBuffer(i), s1 = new Uint8Array(a1), (u = new DataView(a1)).setUint32(d, i), d += 4, s1.set(l, d), d += l.length, s1.set(c, d), d += c.length, u.setUint32(d, t), d += 4, s1.set(f, d), d += t, s1.buffer;
                                    },
                                    getRequestHeadersFromMessage: function(e) {
                                        var n, r, a1 = {}, o = new DOMParser;
                                        if (i && i.get().streaming.protection.detectPlayreadyMessageFormat && "utf-16" === t && e && e.byteLength % 2 == 1) return a1["Content-Type"] = "text/xml; charset=utf-8", a1;
                                        var s1 = "utf-16" === t ? new Uint16Array(e) : new Uint8Array(e);
                                        n = String.fromCharCode.apply(null, s1);
                                        for(var u = (r = o.parseFromString(n, "application/xml")).getElementsByTagName("name"), l = r.getElementsByTagName("value"), c = 0; c < u.length; c++)a1[u[c].childNodes[0].nodeValue] = l[c].childNodes[0].nodeValue;
                                        return a1.hasOwnProperty("Content") && (a1["Content-Type"] = a1.Content, delete a1.Content), a1.hasOwnProperty("Content-Type") || (a1["Content-Type"] = "text/xml; charset=utf-8"), a1;
                                    },
                                    getLicenseRequestFromMessage: function(e) {
                                        var r = null, a1 = new DOMParser;
                                        if (i && i.get().streaming.protection.detectPlayreadyMessageFormat && "utf-16" === t && e && e.byteLength % 2 == 1) return e;
                                        var s1 = "utf-16" === t ? new Uint16Array(e) : new Uint8Array(e);
                                        o();
                                        var u = String.fromCharCode.apply(null, s1), l = a1.parseFromString(u, "application/xml");
                                        if (!l.getElementsByTagName("PlayReadyKeyMessage")[0]) return e;
                                        var c = l.getElementsByTagName("Challenge")[0].childNodes[0].nodeValue;
                                        return c && (r = n.decode(c)), r;
                                    },
                                    getLicenseServerURLFromInitData: function(e) {
                                        if (e) for(var t = new DataView(e), n = t.getUint16(4, !0), r = 6, i = new DOMParser, a1 = 0; a1 < n; a1++){
                                            var o = t.getUint16(r, !0);
                                            r += 2;
                                            var s1 = t.getUint16(r, !0);
                                            if (r += 2, 1 === o) {
                                                var u = e.slice(r, r + s1), l = String.fromCharCode.apply(null, new Uint16Array(u)), c = i.parseFromString(l, "application/xml");
                                                if (c.getElementsByTagName("LA_URL")[0]) {
                                                    var d = c.getElementsByTagName("LA_URL")[0].childNodes[0].nodeValue;
                                                    if (d) return d;
                                                }
                                                if (c.getElementsByTagName("LUI_URL")[0]) {
                                                    var f = c.getElementsByTagName("LUI_URL")[0].childNodes[0].nodeValue;
                                                    if (f) return f;
                                                }
                                            } else r += s1;
                                        }
                                        return null;
                                    },
                                    getCDMData: function(e) {
                                        var t, r, i, a1;
                                        if (o(), !e) return null;
                                        for(t = [], a1 = 0; a1 < e.length; ++a1)t.push(e.charCodeAt(a1)), t.push(0);
                                        for(t = String.fromCharCode.apply(null, t), t = n.encode(t), r = '<PlayReadyCDMData type="LicenseAcquisition"><LicenseAcquisition version="1.0" Proactive="false"><CustomData encoding="base64encoded">%CUSTOMDATA%</CustomData></LicenseAcquisition></PlayReadyCDMData>'.replace("%CUSTOMDATA%", t), i = [], a1 = 0; a1 < r.length; ++a1)i.push(r.charCodeAt(a1)), i.push(0);
                                        return new Uint8Array(i).buffer;
                                    },
                                    setPlayReadyMessageFormat: function(e) {
                                        if ("utf-8" !== e && "utf-16" !== e) throw new Error('Specified message format is not one of "utf-8" or "utf-16"');
                                        t = e;
                                    }
                                };
                            }
                            o.__dashjs_factory_name = "KeySystemPlayReady", t.default = dashjs.FactoryMaker.getSingletonFactory(o);
                        },
                        "./src/streaming/protection/drm/KeySystemW3CClearKey.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/protection/vo/KeyPair.js"), i = n("./src/streaming/protection/vo/ClearKeyKeySet.js"), a1 = n("./src/streaming/protection/CommonEncryption.js"), o = n("./src/streaming/constants/ProtectionConstants.js"), s1 = o.default.CLEARKEY_KEYSTEM_STRING;
                            function u(e) {
                                var t, n = e.BASE64, o = e.debug.getLogger(t);
                                return {
                                    uuid: "1077efec-c0b2-4d02-ace3-3c1e52e2fb4b",
                                    schemeIdURI: "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b",
                                    systemString: s1,
                                    getInitData: function(e) {
                                        return a1.default.parseInitDataFromContentProtection(e, n);
                                    },
                                    getRequestHeadersFromMessage: function() {
                                        return null;
                                    },
                                    getLicenseRequestFromMessage: function(e) {
                                        return new Uint8Array(e);
                                    },
                                    getLicenseServerURLFromInitData: function() {
                                        return null;
                                    },
                                    getCDMData: function() {
                                        return null;
                                    },
                                    getClearKeysFromProtectionData: function(e, t) {
                                        var n = null;
                                        if (e) {
                                            for(var a1 = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(t))), s1 = [], u = 0; u < a1.kids.length; u++){
                                                var l = a1.kids[u], c = e.clearkeys && e.clearkeys.hasOwnProperty(l) ? e.clearkeys[l] : null;
                                                if (!c) throw new Error("DRM: ClearKey keyID (" + l + ") is not known!");
                                                s1.push(new r.default(l, c));
                                            }
                                            n = new i.default(s1), o.warn("ClearKey schemeIdURI is using W3C Common PSSH systemID (1077efec-c0b2-4d02-ace3-3c1e52e2fb4b) in Content Protection. See DASH-IF IOP v4.1 section 7.6.2.4");
                                        }
                                        return n;
                                    }
                                };
                            }
                            u.__dashjs_factory_name = "KeySystemW3CClearKey", t.default = dashjs.FactoryMaker.getSingletonFactory(u);
                        },
                        "./src/streaming/protection/drm/KeySystemWidevine.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/protection/CommonEncryption.js"), i = n("./src/streaming/constants/ProtectionConstants.js"), a1 = i.default.WIDEVINE_KEYSTEM_STRING;
                            function o(e) {
                                var t = (e = e || {}).BASE64;
                                return {
                                    uuid: "edef8ba9-79d6-4ace-a3c8-27dcd51d21ed",
                                    schemeIdURI: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed",
                                    systemString: a1,
                                    getInitData: function(e) {
                                        return r.default.parseInitDataFromContentProtection(e, t);
                                    },
                                    getRequestHeadersFromMessage: function() {
                                        return null;
                                    },
                                    getLicenseRequestFromMessage: function(e) {
                                        return new Uint8Array(e);
                                    },
                                    getLicenseServerURLFromInitData: function() {
                                        return null;
                                    },
                                    getCDMData: function() {
                                        return null;
                                    }
                                };
                            }
                            o.__dashjs_factory_name = "KeySystemWidevine", t.default = dashjs.FactoryMaker.getSingletonFactory(o);
                        },
                        "./src/streaming/protection/errors/ProtectionErrors.js": function(e, t, n) {
                            "use strict";
                            function r(e) {
                                return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, r(e);
                            }
                            function i(e, t) {
                                return i = Object.setPrototypeOf || function(e, t) {
                                    return e.__proto__ = t, e;
                                }, i(e, t);
                            }
                            function a1(e, t) {
                                return !t || "object" !== r(t) && "function" != typeof t ? function(e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e;
                                }(e) : t;
                            }
                            function o(e) {
                                return o = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                                    return e.__proto__ || Object.getPrototypeOf(e);
                                }, o(e);
                            }
                            n.r(t);
                            var s1 = new (function(e) {
                                !function(e, t) {
                                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                    e.prototype = Object.create(t && t.prototype, {
                                        constructor: {
                                            value: e,
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }), t && i(e, t);
                                }(s1, e);
                                var t, n, r = (t = s1, n = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e, r = o(t);
                                    if (n) {
                                        var i = o(this).constructor;
                                        e = Reflect.construct(r, arguments, i);
                                    } else e = r.apply(this, arguments);
                                    return a1(this, e);
                                });
                                function s1() {
                                    var e;
                                    return function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, s1), (e = r.call(this)).MEDIA_KEYERR_CODE = 100, e.MEDIA_KEYERR_UNKNOWN_CODE = 101, e.MEDIA_KEYERR_CLIENT_CODE = 102, e.MEDIA_KEYERR_SERVICE_CODE = 103, e.MEDIA_KEYERR_OUTPUT_CODE = 104, e.MEDIA_KEYERR_HARDWARECHANGE_CODE = 105, e.MEDIA_KEYERR_DOMAIN_CODE = 106, e.MEDIA_KEY_MESSAGE_ERROR_CODE = 107, e.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_CODE = 108, e.SERVER_CERTIFICATE_UPDATED_ERROR_CODE = 109, e.KEY_STATUS_CHANGED_EXPIRED_ERROR_CODE = 110, e.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_CODE = 111, e.KEY_SYSTEM_ACCESS_DENIED_ERROR_CODE = 112, e.KEY_SESSION_CREATED_ERROR_CODE = 113, e.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE = 114, e.MEDIA_KEYERR_UNKNOWN_MESSAGE = "An unspecified error occurred. This value is used for errors that don't match any of the other codes.", e.MEDIA_KEYERR_CLIENT_MESSAGE = "The Key System could not be installed or updated.", e.MEDIA_KEYERR_SERVICE_MESSAGE = "The message passed into update indicated an error from the license service.", e.MEDIA_KEYERR_OUTPUT_MESSAGE = "There is no available output device with the required characteristics for the content protection system.", e.MEDIA_KEYERR_HARDWARECHANGE_MESSAGE = "A hardware configuration change caused a content protection error.", e.MEDIA_KEYERR_DOMAIN_MESSAGE = "An error occurred in a multi-device domain licensing configuration. The most common error is a failure to join the domain.", e.MEDIA_KEY_MESSAGE_ERROR_MESSAGE = "Multiple key sessions were creates with a user-agent that does not support sessionIDs!! Unpredictable behavior ahead!", e.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_MESSAGE = "DRM: Empty key message from CDM", e.SERVER_CERTIFICATE_UPDATED_ERROR_MESSAGE = "Error updating server certificate -- ", e.KEY_STATUS_CHANGED_EXPIRED_ERROR_MESSAGE = "DRM: KeyStatusChange error! -- License has expired", e.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_MESSAGE = "DRM: No license server URL specified!", e.KEY_SYSTEM_ACCESS_DENIED_ERROR_MESSAGE = "DRM: KeySystem Access Denied! -- ", e.KEY_SESSION_CREATED_ERROR_MESSAGE = "DRM: unable to create session! --", e.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE = "DRM: licenser error! --", e;
                                }
                                return s1;
                            }(n("./src/core/errors/ErrorsBase.js").default));
                            t.default = s1;
                        },
                        "./src/streaming/protection/models/ProtectionModel_01b.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/protection/controllers/ProtectionKeyController.js"), i = n("./src/streaming/protection/vo/NeedKey.js"), a1 = n("./src/streaming/vo/DashJSError.js"), o = n("./src/streaming/protection/vo/KeyMessage.js"), s1 = n("./src/streaming/protection/vo/KeySystemConfiguration.js"), u = n("./src/streaming/protection/vo/KeySystemAccess.js"), l = n("./src/streaming/protection/errors/ProtectionErrors.js");
                            function c(e) {
                                e = e || {};
                                var t, n, c, d, f, h, g, p, m, v = this.context, y = e.eventBus, E = e.events, T = e.debug, b = e.api, A = e.errHandler;
                                function _() {
                                    c && I();
                                    for(var e = 0; e < g.length; e++)S(g[e]);
                                    y.trigger(E.TEARDOWN_COMPLETE);
                                }
                                function S(e) {
                                    try {
                                        c[b.cancelKeyRequest](d.systemString, e.sessionId);
                                    } catch (t) {
                                        y.trigger(E.KEY_SESSION_CLOSED, {
                                            data: null,
                                            error: "Error closing session (" + e.sessionId + ") " + t.message
                                        });
                                    }
                                }
                                function w(e, t) {
                                    if (t && e) {
                                        for(var n = e.length, r = 0; r < n; r++)if (e[r].sessionId == t) return e[r];
                                        return null;
                                    }
                                    return null;
                                }
                                function I() {
                                    c.removeEventListener(b.keyerror, m), c.removeEventListener(b.needkey, m), c.removeEventListener(b.keymessage, m), c.removeEventListener(b.keyadded, m);
                                }
                                return t = {
                                    getAllInitData: function() {
                                        for(var e = [], t = 0; t < h.length; t++)e.push(h[t].initData);
                                        for(var n = 0; n < g.length; n++)e.push(g[n].initData);
                                        return e;
                                    },
                                    getSessions: function() {
                                        return g.concat(h);
                                    },
                                    requestKeySystemAccess: function(e) {
                                        return new Promise(function(t, n) {
                                            var r = c;
                                            r || (r = document.createElement("video"));
                                            for(var i = !1, a1 = 0; a1 < e.length; a1++)for(var o = e[a1].ks.systemString, l = e[a1].configs, d = null, h = 0; h < l.length; h++){
                                                var g = l[h].videoCapabilities;
                                                if (g && 0 !== g.length) {
                                                    d = [];
                                                    for(var p = 0; p < g.length; p++)"" !== r.canPlayType(g[p].contentType, o) && d.push(g[p]);
                                                }
                                                if (d && (!d || 0 !== d.length)) {
                                                    i = !0;
                                                    var m = new s1.default(null, d), v = f.getKeySystemBySystemString(o), T = new u.default(v, m);
                                                    y.trigger(E.KEY_SYSTEM_ACCESS_COMPLETE, {
                                                        data: T
                                                    }), t({
                                                        data: T
                                                    });
                                                    break;
                                                }
                                            }
                                            if (!i) {
                                                var b = "Key system access denied! -- No valid audio/video content configurations detected!";
                                                y.trigger(E.KEY_SYSTEM_ACCESS_COMPLETE, {
                                                    error: b
                                                }), n({
                                                    error: b
                                                });
                                            }
                                        });
                                    },
                                    selectKeySystem: function(e) {
                                        return d = e.keySystem, Promise.resolve(d);
                                    },
                                    setMediaElement: function(e) {
                                        if (c !== e) {
                                            if (c) {
                                                I();
                                                for(var t = 0; t < g.length; t++)S(g[t]);
                                                g = [];
                                            }
                                            (c = e) && (c.addEventListener(b.keyerror, m), c.addEventListener(b.needkey, m), c.addEventListener(b.keymessage, m), c.addEventListener(b.keyadded, m), y.trigger(E.VIDEO_ELEMENT_SELECTED));
                                        }
                                    },
                                    createKeySession: function(e) {
                                        if (!d) throw new Error("Can not create sessions until you have selected a key system");
                                        if (p || 0 === g.length) {
                                            var t = {
                                                sessionId: null,
                                                keyId: e.keyId,
                                                initData: e.initData,
                                                getKeyId: function() {
                                                    return this.keyId;
                                                },
                                                getSessionId: function() {
                                                    return this.sessionId;
                                                },
                                                getExpirationTime: function() {
                                                    return NaN;
                                                },
                                                getSessionType: function() {
                                                    return "temporary";
                                                }
                                            };
                                            return h.push(t), c[b.generateKeyRequest](d.systemString, new Uint8Array(e.initData)), t;
                                        }
                                        throw new Error("Multiple sessions not allowed!");
                                    },
                                    updateKeySession: function(e, t) {
                                        var n = e.sessionId;
                                        if (f.isClearKey(d)) for(var r = 0; r < t.keyPairs.length; r++)c[b.addKey](d.systemString, t.keyPairs[r].key, t.keyPairs[r].keyID, n);
                                        else c[b.addKey](d.systemString, new Uint8Array(t), new Uint8Array(e.initData), n);
                                        y.trigger(E.KEY_SESSION_UPDATED);
                                    },
                                    closeKeySession: S,
                                    setServerCertificate: function() {},
                                    loadKeySession: function() {},
                                    removeKeySession: function() {},
                                    stop: _,
                                    reset: _
                                }, n = T.getLogger(t), c = null, d = null, h = [], g = [], f = Object(r.default)(v).getInstance(), m = {
                                    handleEvent: function(e) {
                                        var t = null;
                                        switch(e.type){
                                            case b.needkey:
                                                var r = ArrayBuffer.isView(e.initData) ? e.initData.buffer : e.initData;
                                                y.trigger(E.NEED_KEY, {
                                                    key: new i.default(r, "cenc")
                                                });
                                                break;
                                            case b.keyerror:
                                                if ((t = w(g, e.sessionId)) || (t = w(h, e.sessionId)), t) {
                                                    var s1 = l.default.MEDIA_KEYERR_CODE, u = "";
                                                    switch(e.errorCode.code){
                                                        case 1:
                                                            s1 = l.default.MEDIA_KEYERR_UNKNOWN_CODE, u += "MEDIA_KEYERR_UNKNOWN - " + l.default.MEDIA_KEYERR_UNKNOWN_MESSAGE;
                                                            break;
                                                        case 2:
                                                            s1 = l.default.MEDIA_KEYERR_CLIENT_CODE, u += "MEDIA_KEYERR_CLIENT - " + l.default.MEDIA_KEYERR_CLIENT_MESSAGE;
                                                            break;
                                                        case 3:
                                                            s1 = l.default.MEDIA_KEYERR_SERVICE_CODE, u += "MEDIA_KEYERR_SERVICE - " + l.default.MEDIA_KEYERR_SERVICE_MESSAGE;
                                                            break;
                                                        case 4:
                                                            s1 = l.default.MEDIA_KEYERR_OUTPUT_CODE, u += "MEDIA_KEYERR_OUTPUT - " + l.default.MEDIA_KEYERR_OUTPUT_MESSAGE;
                                                            break;
                                                        case 5:
                                                            s1 = l.default.MEDIA_KEYERR_HARDWARECHANGE_CODE, u += "MEDIA_KEYERR_HARDWARECHANGE - " + l.default.MEDIA_KEYERR_HARDWARECHANGE_MESSAGE;
                                                            break;
                                                        case 6:
                                                            s1 = l.default.MEDIA_KEYERR_DOMAIN_CODE, u += "MEDIA_KEYERR_DOMAIN - " + l.default.MEDIA_KEYERR_DOMAIN_MESSAGE;
                                                    }
                                                    u += "  System Code = " + e.systemCode, y.trigger(E.KEY_ERROR, {
                                                        error: new a1.default(s1, u, t)
                                                    });
                                                } else n.error("No session token found for key error");
                                                break;
                                            case b.keyadded:
                                                (t = w(g, e.sessionId)) || (t = w(h, e.sessionId)), t ? (n.debug("DRM: Key added."), y.trigger(E.KEY_ADDED, {
                                                    data: t
                                                })) : n.debug("No session token found for key added");
                                                break;
                                            case b.keymessage:
                                                if ((p = null !== e.sessionId && void 0 !== e.sessionId) ? !(t = w(g, e.sessionId)) && h.length > 0 && (t = h.shift(), g.push(t), t.sessionId = e.sessionId, y.trigger(E.KEY_SESSION_CREATED, {
                                                    data: t
                                                })) : h.length > 0 && (t = h.shift(), g.push(t), 0 !== h.length && A.error(new a1.default(l.default.MEDIA_KEY_MESSAGE_ERROR_CODE, l.default.MEDIA_KEY_MESSAGE_ERROR_MESSAGE))), t) {
                                                    var c = ArrayBuffer.isView(e.message) ? e.message.buffer : e.message;
                                                    t.keyMessage = c, y.trigger(E.INTERNAL_KEY_MESSAGE, {
                                                        data: new o.default(t, c, e.defaultURL)
                                                    });
                                                } else n.warn("No session token found for key message");
                                        }
                                    }
                                }, t;
                            }
                            c.__dashjs_factory_name = "ProtectionModel_01b", t.default = dashjs.FactoryMaker.getClassFactory(c);
                        },
                        "./src/streaming/protection/models/ProtectionModel_21Jan2015.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/protection/controllers/ProtectionKeyController.js"), i = n("./src/streaming/protection/vo/NeedKey.js"), a1 = n("./src/streaming/protection/errors/ProtectionErrors.js"), o = n("./src/streaming/vo/DashJSError.js"), s1 = n("./src/streaming/protection/vo/KeyMessage.js"), u = n("./src/streaming/protection/vo/KeySystemAccess.js"), l = n("./src/streaming/constants/ProtectionConstants.js"), c = {};
                            function d(e) {
                                e = e || {};
                                var t, n, d, f, h, g, p, m, v = this.context, y = e.eventBus, E = e.events, T = e.debug;
                                function b(e, t, n, r) {
                                    if (void 0 === navigator.requestMediaKeySystemAccess || "function" != typeof navigator.requestMediaKeySystemAccess) {
                                        var i = "Insecure origins are not allowed";
                                        return y.trigger(E.KEY_SYSTEM_ACCESS_COMPLETE, {
                                            error: i
                                        }), void r({
                                            error: i
                                        });
                                    }
                                    var a1 = e[t].protData && e[t].protData.systemStringPriority ? e[t].protData.systemStringPriority : null, o = e[t].configs, s1 = e[t].ks, l = s1.systemString;
                                    (function(e, t) {
                                        return new Promise(function(n, r) {
                                            A(e, t, 0, n, r);
                                        });
                                    })(a1 || (c[l] ? c[l] : [
                                        l
                                    ]), o).then(function(e) {
                                        var t = "function" == typeof e.getConfiguration ? e.getConfiguration() : null, r = new u.default(s1, t);
                                        r.mksa = e, y.trigger(E.KEY_SYSTEM_ACCESS_COMPLETE, {
                                            data: r
                                        }), n({
                                            data: r
                                        });
                                    }).catch(function(i) {
                                        if (t + 1 < e.length) b(e, t + 1, n, r);
                                        else {
                                            var a1 = "Key system access denied! ";
                                            y.trigger(E.KEY_SYSTEM_ACCESS_COMPLETE, {
                                                error: a1 + i.message
                                            }), r({
                                                error: a1 + i.message
                                            });
                                        }
                                    });
                                }
                                function A(e, t, r, i, a1) {
                                    var o = e[r];
                                    n.debug("Requesting key system access for system string ".concat(o)), navigator.requestMediaKeySystemAccess(o, t).then(function(e) {
                                        e.selectedSystemString = o, i(e);
                                    }).catch(function(n) {
                                        r + 1 < e.length ? A(e, t, r + 1, i, a1) : a1(n);
                                    });
                                }
                                function _(e) {
                                    var t = e.session;
                                    return t.removeEventListener("keystatuseschange", e), t.removeEventListener("message", e), t.close();
                                }
                                function S(e) {
                                    for(var t = 0; t < g.length; t++)if (g[t] === e) {
                                        g.splice(t, 1);
                                        break;
                                    }
                                }
                                function w(e) {
                                    var t, n;
                                    return e && e.length > 0 && (e[0] && ("string" == typeof e[0] ? t = e[0] : n = e[0]), e[1] && ("string" == typeof e[1] ? t = e[1] : n = e[1])), {
                                        status: t,
                                        keyId: n
                                    };
                                }
                                function I(e, t) {
                                    var r = {
                                        session: e,
                                        keyId: t.keyId,
                                        initData: t.initData,
                                        sessionId: t.sessionId,
                                        sessionType: t.sessionType,
                                        handleEvent: function(e) {
                                            switch(e.type){
                                                case "keystatuseschange":
                                                    y.trigger(E.KEY_STATUSES_CHANGED, {
                                                        data: this
                                                    }), e.target.keyStatuses.forEach(function() {
                                                        var e = w(arguments);
                                                        "expired" === e.status ? y.trigger(E.INTERNAL_KEY_STATUS_CHANGED, {
                                                            error: new o.default(a1.default.KEY_STATUS_CHANGED_EXPIRED_ERROR_CODE, a1.default.KEY_STATUS_CHANGED_EXPIRED_ERROR_MESSAGE)
                                                        }) : y.trigger(E.INTERNAL_KEY_STATUS_CHANGED, e);
                                                    });
                                                    break;
                                                case "message":
                                                    var t = ArrayBuffer.isView(e.message) ? e.message.buffer : e.message;
                                                    y.trigger(E.INTERNAL_KEY_MESSAGE, {
                                                        data: new s1.default(this, t, void 0, e.messageType)
                                                    });
                                            }
                                        },
                                        getKeyId: function() {
                                            return this.keyId;
                                        },
                                        getSessionId: function() {
                                            return e.sessionId;
                                        },
                                        getSessionType: function() {
                                            return this.sessionType;
                                        },
                                        getExpirationTime: function() {
                                            return e.expiration;
                                        },
                                        getKeyStatuses: function() {
                                            return e.keyStatuses;
                                        },
                                        getUsable: function() {
                                            var t = !1;
                                            return e.keyStatuses.forEach(function() {
                                                var e = w(arguments);
                                                "usable" === e.status && (t = !0);
                                            }), t;
                                        }
                                    };
                                    return e.addEventListener("keystatuseschange", r), e.addEventListener("message", r), e.closed.then(function() {
                                        S(r), n.debug("DRM: Session closed.  SessionID = " + r.getSessionId()), y.trigger(E.KEY_SESSION_CLOSED, {
                                            data: r.getSessionId()
                                        });
                                    }), g.push(r), r;
                                }
                                return t = {
                                    getAllInitData: function() {
                                        for(var e = [], t = 0; t < g.length; t++)g[t].initData && e.push(g[t].initData);
                                        return e;
                                    },
                                    getSessions: function() {
                                        return g;
                                    },
                                    requestKeySystemAccess: function(e) {
                                        return new Promise(function(t, n) {
                                            b(e, 0, t, n);
                                        });
                                    },
                                    selectKeySystem: function(e) {
                                        return new Promise(function(t, n) {
                                            e.mksa.createMediaKeys().then(function(t) {
                                                return d = e.keySystem, h = t, f ? f.setMediaKeys(h) : Promise.resolve();
                                            }).then(function() {
                                                t(d);
                                            }).catch(function() {
                                                n({
                                                    error: "Error selecting keys system (" + e.keySystem.systemString + ")! Could not create MediaKeys -- TODO"
                                                });
                                            });
                                        });
                                    },
                                    setMediaElement: function(e) {
                                        f !== e && (f && (f.removeEventListener("encrypted", p), f.setMediaKeys && f.setMediaKeys(null)), (f = e) && (f.addEventListener("encrypted", p), f.setMediaKeys && h && f.setMediaKeys(h)));
                                    },
                                    setServerCertificate: function(e) {
                                        if (!d || !h) throw new Error("Can not set server certificate until you have selected a key system");
                                        h.setServerCertificate(e).then(function() {
                                            n.info("DRM: License server certificate successfully updated."), y.trigger(E.SERVER_CERTIFICATE_UPDATED);
                                        }).catch(function(e) {
                                            y.trigger(E.SERVER_CERTIFICATE_UPDATED, {
                                                error: new o.default(a1.default.SERVER_CERTIFICATE_UPDATED_ERROR_CODE, a1.default.SERVER_CERTIFICATE_UPDATED_ERROR_MESSAGE + e.name)
                                            });
                                        });
                                    },
                                    createKeySession: function(e) {
                                        if (!d || !h) throw new Error("Can not create sessions until you have selected a key system");
                                        var t = h.createSession(e.sessionType), r = I(t, e), i = d.systemString === l.default.CLEARKEY_KEYSTEM_STRING && (e.initData || e.protData && e.protData.clearkeys) ? l.default.INITIALIZATION_DATA_TYPE_KEYIDS : l.default.INITIALIZATION_DATA_TYPE_CENC;
                                        t.generateRequest(i, e.initData).then(function() {
                                            n.debug("DRM: Session created.  SessionID = " + r.getSessionId()), y.trigger(E.KEY_SESSION_CREATED, {
                                                data: r
                                            });
                                        }).catch(function(e) {
                                            S(r), y.trigger(E.KEY_SESSION_CREATED, {
                                                data: null,
                                                error: new o.default(a1.default.KEY_SESSION_CREATED_ERROR_CODE, a1.default.KEY_SESSION_CREATED_ERROR_MESSAGE + "Error generating key request -- " + e.name)
                                            });
                                        });
                                    },
                                    updateKeySession: function(e, t) {
                                        var n = e.session;
                                        m.isClearKey(d) && (t = t.toJWK()), n.update(t).then(function() {
                                            y.trigger(E.KEY_SESSION_UPDATED);
                                        }).catch(function(t) {
                                            y.trigger(E.KEY_ERROR, {
                                                error: new o.default(a1.default.MEDIA_KEYERR_CODE, "Error sending update() message! " + t.name, e)
                                            });
                                        });
                                    },
                                    loadKeySession: function(e) {
                                        if (!d || !h) throw new Error("Can not load sessions until you have selected a key system");
                                        for(var t = e.sessionId, r = 0; r < g.length; r++)if (t === g[r].sessionId) return void n.warn("DRM: Ignoring session ID because we have already seen it!");
                                        var i = h.createSession(e.sessionType), s1 = I(i, e);
                                        i.load(t).then(function(e) {
                                            e ? (n.debug("DRM: Session loaded.  SessionID = " + s1.getSessionId()), y.trigger(E.KEY_SESSION_CREATED, {
                                                data: s1
                                            })) : (S(s1), y.trigger(E.KEY_SESSION_CREATED, {
                                                data: null,
                                                error: new o.default(a1.default.KEY_SESSION_CREATED_ERROR_CODE, a1.default.KEY_SESSION_CREATED_ERROR_MESSAGE + "Could not load session! Invalid Session ID (" + t + ")")
                                            }));
                                        }).catch(function(e) {
                                            S(s1), y.trigger(E.KEY_SESSION_CREATED, {
                                                data: null,
                                                error: new o.default(a1.default.KEY_SESSION_CREATED_ERROR_CODE, a1.default.KEY_SESSION_CREATED_ERROR_MESSAGE + "Could not load session (" + t + ")! " + e.name)
                                            });
                                        });
                                    },
                                    removeKeySession: function(e) {
                                        e.session.remove().then(function() {
                                            n.debug("DRM: Session removed.  SessionID = " + e.getSessionId()), y.trigger(E.KEY_SESSION_REMOVED, {
                                                data: e.getSessionId()
                                            });
                                        }, function(t) {
                                            y.trigger(E.KEY_SESSION_REMOVED, {
                                                data: null,
                                                error: "Error removing session (" + e.getSessionId() + "). " + t.name
                                            });
                                        });
                                    },
                                    closeKeySession: function(e) {
                                        _(e).catch(function(t) {
                                            S(e), y.trigger(E.KEY_SESSION_CLOSED, {
                                                data: null,
                                                error: "Error closing session (" + e.getSessionId() + ") " + t.name
                                            });
                                        });
                                    },
                                    stop: function() {
                                        for(var e, t = 0; t < g.length; t++)(e = g[t]).getUsable() || _(e).catch(function() {
                                            S(e);
                                        });
                                    },
                                    reset: function() {
                                        var e, t = g.length;
                                        0 !== t ? function() {
                                            for(var n = function(e) {
                                                S(e), 0 === g.length && (f ? (f.removeEventListener("encrypted", p), f.setMediaKeys(null).then(function() {
                                                    y.trigger(E.TEARDOWN_COMPLETE);
                                                })) : y.trigger(E.TEARDOWN_COMPLETE));
                                            }, r = 0; r < t; r++)!function(t) {
                                                e.session.closed.then(function() {
                                                    n(t);
                                                }), _(e).catch(function() {
                                                    n(t);
                                                });
                                            }(e = g[r]);
                                        }() : y.trigger(E.TEARDOWN_COMPLETE);
                                    }
                                }, n = T.getLogger(t), d = null, f = null, h = null, g = [], m = Object(r.default)(v).getInstance(), p = {
                                    handleEvent: function(e) {
                                        if ("encrypted" === e.type && e.initData) {
                                            var t = ArrayBuffer.isView(e.initData) ? e.initData.buffer : e.initData;
                                            y.trigger(E.NEED_KEY, {
                                                key: new i.default(t, e.initDataType)
                                            });
                                        }
                                    }
                                }, t;
                            }
                            c[l.default.PLAYREADY_KEYSTEM_STRING] = [
                                l.default.PLAYREADY_KEYSTEM_STRING,
                                l.default.PLAYREADY_RECOMMENDATION_KEYSTEM_STRING
                            ], c[l.default.WIDEVINE_KEYSTEM_STRING] = [
                                l.default.WIDEVINE_KEYSTEM_STRING
                            ], c[l.default.CLEARKEY_KEYSTEM_STRING] = [
                                l.default.CLEARKEY_KEYSTEM_STRING
                            ], d.__dashjs_factory_name = "ProtectionModel_21Jan2015", t.default = dashjs.FactoryMaker.getClassFactory(d);
                        },
                        "./src/streaming/protection/models/ProtectionModel_3Feb2014.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/protection/controllers/ProtectionKeyController.js"), i = n("./src/streaming/protection/vo/NeedKey.js"), a1 = n("./src/streaming/vo/DashJSError.js"), o = n("./src/streaming/protection/errors/ProtectionErrors.js"), s1 = n("./src/streaming/protection/vo/KeyMessage.js"), u = n("./src/streaming/protection/vo/KeySystemConfiguration.js"), l = n("./src/streaming/protection/vo/KeySystemAccess.js");
                            function c(e) {
                                e = e || {};
                                var t, n, c, d, f, h, g, p, m, v = this.context, y = e.eventBus, E = e.events, T = e.debug, b = e.api;
                                function A() {
                                    try {
                                        for(var e = 0; e < g.length; e++)_(g[e]);
                                        c && c.removeEventListener(b.needkey, p), y.trigger(E.TEARDOWN_COMPLETE);
                                    } catch (e) {
                                        y.trigger(E.TEARDOWN_COMPLETE, {
                                            error: "Error tearing down key sessions and MediaKeys! -- " + e.message
                                        });
                                    }
                                }
                                function _(e) {
                                    var t = e.session;
                                    t.removeEventListener(b.error, e), t.removeEventListener(b.message, e), t.removeEventListener(b.ready, e), t.removeEventListener(b.close, e);
                                    for(var n = 0; n < g.length; n++)if (g[n] === e) {
                                        g.splice(n, 1);
                                        break;
                                    }
                                    t[b.release]();
                                }
                                function S() {
                                    var e = null, t = function() {
                                        c.removeEventListener("loadedmetadata", e), c[b.setMediaKeys](f), y.trigger(E.VIDEO_ELEMENT_SELECTED);
                                    };
                                    c.readyState >= 1 ? t() : (e = t.bind(this), c.addEventListener("loadedmetadata", e));
                                }
                                return t = {
                                    getAllInitData: function() {
                                        for(var e = [], t = 0; t < g.length; t++)e.push(g[t].initData);
                                        return e;
                                    },
                                    getSessions: function() {
                                        return g;
                                    },
                                    requestKeySystemAccess: function(e) {
                                        return new Promise(function(t, n) {
                                            for(var r = !1, i = 0; i < e.length; i++)for(var a1 = e[i].ks.systemString, o = e[i].configs, s1 = null, c = null, d = 0; d < o.length; d++){
                                                var f = o[d].audioCapabilities, h = o[d].videoCapabilities;
                                                if (f && 0 !== f.length) {
                                                    s1 = [];
                                                    for(var g = 0; g < f.length; g++)window[b.MediaKeys].isTypeSupported(a1, f[g].contentType) && s1.push(f[g]);
                                                }
                                                if (h && 0 !== h.length) {
                                                    c = [];
                                                    for(var p = 0; p < h.length; p++)window[b.MediaKeys].isTypeSupported(a1, h[p].contentType) && c.push(h[p]);
                                                }
                                                if (!(!s1 && !c || s1 && 0 === s1.length || c && 0 === c.length)) {
                                                    r = !0;
                                                    var v = new u.default(s1, c), T = m.getKeySystemBySystemString(a1), A = new l.default(T, v);
                                                    y.trigger(E.KEY_SYSTEM_ACCESS_COMPLETE, {
                                                        data: A
                                                    }), t({
                                                        data: A
                                                    });
                                                    break;
                                                }
                                            }
                                            if (!r) {
                                                var _ = "Key system access denied! -- No valid audio/video content configurations detected!";
                                                y.trigger(E.KEY_SYSTEM_ACCESS_COMPLETE, {
                                                    error: _
                                                }), n({
                                                    error: _
                                                });
                                            }
                                        });
                                    },
                                    selectKeySystem: function(e) {
                                        return new Promise(function(t, n) {
                                            try {
                                                f = e.mediaKeys = new window[b.MediaKeys](e.keySystem.systemString), d = e.keySystem, h = e, c && S(), t(d);
                                            } catch (e) {
                                                n({
                                                    error: "Error selecting keys system (" + d.systemString + ")! Could not create MediaKeys -- TODO"
                                                });
                                            }
                                        });
                                    },
                                    setMediaElement: function(e) {
                                        c !== e && (c && c.removeEventListener(b.needkey, p), (c = e) && (c.addEventListener(b.needkey, p), f && S()));
                                    },
                                    createKeySession: function(e) {
                                        if (!d || !f || !h) throw new Error("Can not create sessions until you have selected a key system");
                                        var t = null;
                                        if (h.ksConfiguration.videoCapabilities && h.ksConfiguration.videoCapabilities.length > 0 && (t = h.ksConfiguration.videoCapabilities[0]), null === t && h.ksConfiguration.audioCapabilities && h.ksConfiguration.audioCapabilities.length > 0 && (t = h.ksConfiguration.audioCapabilities[0]), null === t) throw new Error("Can not create sessions for unknown content types.");
                                        var r = t.contentType, i = f.createSession(r, new Uint8Array(e.initData), e.cdmData ? new Uint8Array(e.cdmData) : null), u = function(e, t) {
                                            return {
                                                session: e,
                                                keyId: t.keyId,
                                                initData: t.initData,
                                                getKeyId: function() {
                                                    return this.keyId;
                                                },
                                                getSessionId: function() {
                                                    return this.session.sessionId;
                                                },
                                                getExpirationTime: function() {
                                                    return NaN;
                                                },
                                                getSessionType: function() {
                                                    return "temporary";
                                                },
                                                handleEvent: function(e) {
                                                    switch(e.type){
                                                        case b.error:
                                                            y.trigger(E.KEY_ERROR, {
                                                                error: new a1.default(o.default.MEDIA_KEYERR_CODE, "KeyError", this)
                                                            });
                                                            break;
                                                        case b.message:
                                                            var t = ArrayBuffer.isView(e.message) ? e.message.buffer : e.message;
                                                            y.trigger(E.INTERNAL_KEY_MESSAGE, {
                                                                data: new s1.default(this, t, e.destinationURL)
                                                            });
                                                            break;
                                                        case b.ready:
                                                            n.debug("DRM: Key added."), y.trigger(E.KEY_ADDED);
                                                            break;
                                                        case b.close:
                                                            n.debug("DRM: Session closed.  SessionID = " + this.getSessionId()), y.trigger(E.KEY_SESSION_CLOSED, {
                                                                data: this.getSessionId()
                                                            });
                                                    }
                                                }
                                            };
                                        }(i, e);
                                        i.addEventListener(b.error, u), i.addEventListener(b.message, u), i.addEventListener(b.ready, u), i.addEventListener(b.close, u), g.push(u), n.debug("DRM: Session created.  SessionID = " + u.getSessionId()), y.trigger(E.KEY_SESSION_CREATED, {
                                            data: u
                                        });
                                    },
                                    updateKeySession: function(e, t) {
                                        var n = e.session;
                                        m.isClearKey(d) ? n.update(new Uint8Array(t.toJWK())) : n.update(new Uint8Array(t)), y.trigger(E.KEY_SESSION_UPDATED);
                                    },
                                    closeKeySession: _,
                                    setServerCertificate: function() {},
                                    loadKeySession: function() {},
                                    removeKeySession: function() {},
                                    stop: A,
                                    reset: A
                                }, n = T.getLogger(t), c = null, d = null, f = null, h = null, g = [], m = Object(r.default)(v).getInstance(), p = {
                                    handleEvent: function(e) {
                                        if (e.type === b.needkey && e.initData) {
                                            var t = ArrayBuffer.isView(e.initData) ? e.initData.buffer : e.initData;
                                            y.trigger(E.NEED_KEY, {
                                                key: new i.default(t, "cenc")
                                            });
                                        }
                                    }
                                }, t;
                            }
                            c.__dashjs_factory_name = "ProtectionModel_3Feb2014", t.default = dashjs.FactoryMaker.getClassFactory(c);
                        },
                        "./src/streaming/protection/servers/ClearKey.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/protection/vo/KeyPair.js"), i = n("./src/streaming/protection/vo/ClearKeyKeySet.js");
                            function a1() {
                                return {
                                    getServerURLFromMessage: function(e) {
                                        return e;
                                    },
                                    getHTTPMethod: function() {
                                        return "POST";
                                    },
                                    getResponseType: function() {
                                        return "json";
                                    },
                                    getLicenseMessage: function(e) {
                                        if (!e.hasOwnProperty("keys")) return null;
                                        for(var t = [], n = 0; n < e.keys.length; n++){
                                            var a1 = e.keys[n], o = a1.kid.replace(/=/g, ""), s1 = a1.k.replace(/=/g, "");
                                            t.push(new r.default(o, s1));
                                        }
                                        return new i.default(t);
                                    },
                                    getErrorResponse: function(e) {
                                        return String.fromCharCode.apply(null, new Uint8Array(e));
                                    }
                                };
                            }
                            a1.__dashjs_factory_name = "ClearKey", t.default = dashjs.FactoryMaker.getSingletonFactory(a1);
                        },
                        "./src/streaming/protection/servers/DRMToday.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/ProtectionConstants.js");
                            function i(e) {
                                var t = (e = e || {}).BASE64, n = {};
                                return n[r.default.WIDEVINE_KEYSTEM_STRING] = {
                                    responseType: "json",
                                    getLicenseMessage: function(e) {
                                        return t.decodeArray(e.license);
                                    },
                                    getErrorResponse: function(e) {
                                        return e;
                                    }
                                }, n[r.default.PLAYREADY_KEYSTEM_STRING] = {
                                    responseType: "arraybuffer",
                                    getLicenseMessage: function(e) {
                                        return e;
                                    },
                                    getErrorResponse: function(e) {
                                        return String.fromCharCode.apply(null, new Uint8Array(e));
                                    }
                                }, {
                                    getServerURLFromMessage: function(e) {
                                        return e;
                                    },
                                    getHTTPMethod: function() {
                                        return "POST";
                                    },
                                    getResponseType: function(e) {
                                        return n[e].responseType;
                                    },
                                    getLicenseMessage: function(e, r) {
                                        return function() {
                                            if (!t || !t.hasOwnProperty("decodeArray")) throw new Error("Missing config parameter(s)");
                                        }(), n[r].getLicenseMessage(e);
                                    },
                                    getErrorResponse: function(e, t) {
                                        return n[t].getErrorResponse(e);
                                    }
                                };
                            }
                            i.__dashjs_factory_name = "DRMToday", t.default = dashjs.FactoryMaker.getSingletonFactory(i);
                        },
                        "./src/streaming/protection/servers/PlayReady.js": function(e, t, n) {
                            "use strict";
                            function r() {
                                var e = "http://schemas.xmlsoap.org/soap/envelope/";
                                function t(e) {
                                    var t = String.fromCharCode.apply(null, new Uint8Array(e));
                                    return decodeURIComponent(escape(t));
                                }
                                function n(n) {
                                    if (window.DOMParser) {
                                        var r = t(n), i = (new window.DOMParser).parseFromString(r, "text/xml"), a1 = i ? i.getElementsByTagNameNS(e, "Envelope")[0] : null, o = a1 ? a1.getElementsByTagNameNS(e, "Body")[0] : null;
                                        if (o && o.getElementsByTagNameNS(e, "Fault")[0]) return null;
                                    }
                                    return n;
                                }
                                function r(n) {
                                    var r = "", i = "", a1 = "", o = -1, s1 = -1;
                                    if (window.DOMParser) {
                                        var u = t(n), l = (new window.DOMParser).parseFromString(u, "text/xml"), c = l ? l.getElementsByTagNameNS(e, "Envelope")[0] : null, d = c ? c.getElementsByTagNameNS(e, "Body")[0] : null, f = d ? d.getElementsByTagNameNS(e, "Fault")[0] : null, h = f ? f.getElementsByTagName("detail")[0] : null, g = h ? h.getElementsByTagName("Exception")[0] : null, p = null;
                                        if (null === f) return u;
                                        r = (p = f.getElementsByTagName("faultstring")[0].firstChild) ? p.nodeValue : null, null !== g && (i = (p = g.getElementsByTagName("StatusCode")[0]) ? p.firstChild.nodeValue : null, o = (a1 = (p = g.getElementsByTagName("Message")[0]) ? p.firstChild.nodeValue : null) ? a1.lastIndexOf("[") + 1 : -1, s1 = a1 ? a1.indexOf("]") : -1, a1 = a1 ? a1.substring(o, s1) : "");
                                    }
                                    var m = "code: ".concat(i, ", name: ").concat(r);
                                    return a1 && (m += ", message: ".concat(a1)), m;
                                }
                                return {
                                    getServerURLFromMessage: function(e) {
                                        return e;
                                    },
                                    getHTTPMethod: function() {
                                        return "POST";
                                    },
                                    getResponseType: function() {
                                        return "arraybuffer";
                                    },
                                    getLicenseMessage: function(e) {
                                        return n.call(this, e);
                                    },
                                    getErrorResponse: function(e) {
                                        return r.call(this, e);
                                    }
                                };
                            }
                            n.r(t), r.__dashjs_factory_name = "PlayReady", t.default = dashjs.FactoryMaker.getSingletonFactory(r);
                        },
                        "./src/streaming/protection/servers/Widevine.js": function(e, t, n) {
                            "use strict";
                            function r() {
                                return {
                                    getServerURLFromMessage: function(e) {
                                        return e;
                                    },
                                    getHTTPMethod: function() {
                                        return "POST";
                                    },
                                    getResponseType: function() {
                                        return "arraybuffer";
                                    },
                                    getLicenseMessage: function(e) {
                                        return e;
                                    },
                                    getErrorResponse: function(e) {
                                        return String.fromCharCode.apply(null, new Uint8Array(e));
                                    }
                                };
                            }
                            n.r(t), r.__dashjs_factory_name = "Widevine", t.default = dashjs.FactoryMaker.getSingletonFactory(r);
                        },
                        "./src/streaming/protection/vo/ClearKeyKeySet.js": function(e, t, n) {
                            "use strict";
                            function r(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            n.r(t);
                            var i = function() {
                                function e(t, n) {
                                    if (function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), n && "persistent" !== n && "temporary" !== n) throw new Error("Invalid ClearKey key set type!  Must be one of 'persistent' or 'temporary'");
                                    this.keyPairs = t, this.type = n;
                                }
                                var t, n;
                                return t = e, n = [
                                    {
                                        key: "toJWK",
                                        value: function() {
                                            var e, t = this.keyPairs.length, n = {
                                                keys: []
                                            };
                                            for(e = 0; e < t; e++){
                                                var r = {
                                                    kty: "oct",
                                                    alg: "A128KW",
                                                    kid: this.keyPairs[e].keyID,
                                                    k: this.keyPairs[e].key
                                                };
                                                n.keys.push(r);
                                            }
                                            this.type && (n.type = this.type);
                                            var i = JSON.stringify(n), a1 = i.length, o = new ArrayBuffer(a1), s1 = new Uint8Array(o);
                                            for(e = 0; e < a1; e++)s1[e] = i.charCodeAt(e);
                                            return o;
                                        }
                                    }
                                ], r(t.prototype, n), e;
                            }();
                            t.default = i;
                        },
                        "./src/streaming/protection/vo/KeyMessage.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e(t, n, r, i) {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.sessionToken = t, this.message = n, this.defaultURL = r, this.messageType = i || "license-request";
                            };
                        },
                        "./src/streaming/protection/vo/KeyPair.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e(t, n) {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.keyID = t, this.key = n;
                            };
                        },
                        "./src/streaming/protection/vo/KeySystemAccess.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e(t, n) {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.keySystem = t, this.ksConfiguration = n;
                            };
                        },
                        "./src/streaming/protection/vo/KeySystemConfiguration.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e(t, n, r, i, a1) {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.initDataTypes = [
                                    "cenc"
                                ], t && t.length && (this.audioCapabilities = t), n && n.length && (this.videoCapabilities = n), this.distinctiveIdentifier = r, this.persistentState = i, this.sessionTypes = a1;
                            };
                        },
                        "./src/streaming/protection/vo/LicenseRequest.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e(t, n, r, i, a1, o, s1, u) {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.url = t, this.method = n, this.responseType = r, this.headers = i, this.withCredentials = a1, this.messageType = o, this.sessionId = s1, this.data = u;
                            };
                        },
                        "./src/streaming/protection/vo/LicenseResponse.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e(t, n, r) {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.url = t, this.headers = n, this.data = r;
                            };
                        },
                        "./src/streaming/protection/vo/MediaCapability.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e(t, n) {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.contentType = t, this.robustness = n;
                            };
                        },
                        "./src/streaming/protection/vo/NeedKey.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e(t, n) {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.initData = t, this.initDataType = n;
                            };
                        },
                        "./src/streaming/rules/DroppedFramesHistory.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js");
                            function i() {
                                var e = {}, t = {}, n = {};
                                return {
                                    push: function(r, i, a1) {
                                        if (i) {
                                            e[r] || (e[r] = [], t[r] = 0, n[r] = 0);
                                            var o = a1 && a1.droppedVideoFrames ? a1.droppedVideoFrames : 0, s1 = a1 && a1.totalVideoFrames ? a1.totalVideoFrames : 0, u = o - t[r];
                                            t[r] = o;
                                            var l = s1 - n[r];
                                            n[r] = s1;
                                            var c = e[r];
                                            isNaN(i) || (c[i] ? (c[i].droppedVideoFrames += u, c[i].totalVideoFrames += l) : c[i] = {
                                                droppedVideoFrames: u,
                                                totalVideoFrames: l
                                            });
                                        }
                                    },
                                    getFrameHistory: function(t) {
                                        return e[t];
                                    },
                                    clearForStream: function(r) {
                                        try {
                                            delete e[r], delete t[r], delete n[r];
                                        } catch (e) {}
                                    },
                                    reset: function() {
                                        e = {}, t = {}, n = {};
                                    }
                                };
                            }
                            i.__dashjs_factory_name = "DroppedFramesHistory";
                            var a1 = r.default.getClassFactory(i);
                            t.default = a1;
                        },
                        "./src/streaming/rules/RulesContext.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js");
                            function i(e) {
                                var t = (e = e || {}).abrController, n = e.switchHistory, r = e.droppedFramesHistory, i = e.currentRequest, a1 = e.useBufferOccupancyABR, o = e.useL2AABR, s1 = e.useLoLPABR, u = e.streamProcessor ? e.streamProcessor.getScheduleController() : null, l = e.streamProcessor ? e.streamProcessor.getRepresentationInfo() : null, c = e.videoModel ? e.videoModel : null;
                                function d() {
                                    return l ? l.mediaInfo : null;
                                }
                                return {
                                    getMediaType: function() {
                                        var e = d();
                                        return e ? e.type : null;
                                    },
                                    getMediaInfo: d,
                                    getDroppedFramesHistory: function() {
                                        return r;
                                    },
                                    getCurrentRequest: function() {
                                        return i;
                                    },
                                    getSwitchHistory: function() {
                                        return n;
                                    },
                                    getStreamInfo: function() {
                                        var e = d();
                                        return e ? e.streamInfo : null;
                                    },
                                    getScheduleController: function() {
                                        return u;
                                    },
                                    getAbrController: function() {
                                        return t;
                                    },
                                    getRepresentationInfo: function() {
                                        return l;
                                    },
                                    useBufferOccupancyABR: function() {
                                        return a1;
                                    },
                                    useL2AABR: function() {
                                        return o;
                                    },
                                    useLoLPABR: function() {
                                        return s1;
                                    },
                                    getVideoModel: function() {
                                        return c;
                                    }
                                };
                            }
                            i.__dashjs_factory_name = "RulesContext", t.default = r.default.getClassFactory(i);
                        },
                        "./src/streaming/rules/SwitchRequest.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = {
                                DEFAULT: .5,
                                STRONG: 1,
                                WEAK: 0
                            };
                            function a1(e, t, n) {
                                var r, a1;
                                return r = void 0 === e ? -1 : e, a1 = function(e) {
                                    var t = i.DEFAULT;
                                    return e !== i.DEFAULT && e !== i.STRONG && e !== i.WEAK || (t = e), t;
                                }(n), {
                                    quality: r,
                                    reason: void 0 === t ? null : t,
                                    priority: a1
                                };
                            }
                            a1.__dashjs_factory_name = "SwitchRequest";
                            var o = r.default.getClassFactory(a1);
                            o.NO_CHANGE = -1, o.PRIORITY = i, r.default.updateClassFactory(a1.__dashjs_factory_name, o), t.default = o;
                        },
                        "./src/streaming/rules/SwitchRequestHistory.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/streaming/rules/SwitchRequest.js");
                            function a1() {
                                var e = [], t = [];
                                return {
                                    push: function(n) {
                                        n.newValue === i.default.NO_CHANGE && (n.newValue = n.oldValue), e[n.oldValue] || (e[n.oldValue] = {
                                            noDrops: 0,
                                            drops: 0,
                                            dropSize: 0
                                        });
                                        var r = n.newValue - n.oldValue, a1 = r < 0 ? 1 : 0, o = a1 ? -r : 0, s1 = a1 ? 0 : 1;
                                        if (e[n.oldValue].drops += a1, e[n.oldValue].dropSize += o, e[n.oldValue].noDrops += s1, t.push({
                                            idx: n.oldValue,
                                            noDrop: s1,
                                            drop: a1,
                                            dropSize: o
                                        }), t.length > 8) {
                                            var u = t.shift();
                                            e[u.idx].drops -= u.drop, e[u.idx].dropSize -= u.dropSize, e[u.idx].noDrops -= u.noDrop;
                                        }
                                    },
                                    getSwitchRequests: function() {
                                        return e;
                                    },
                                    reset: function() {
                                        e = [], t = [];
                                    }
                                };
                            }
                            a1.__dashjs_factory_name = "SwitchRequestHistory";
                            var o = r.default.getClassFactory(a1);
                            t.default = o;
                        },
                        "./src/streaming/rules/ThroughputHistory.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/Constants.js"), i = n("./src/core/FactoryMaker.js");
                            function a1(e) {
                                var t, n, i, a1, o, s1 = (e = e || {}).settings;
                                function u(e, t, n, r) {
                                    var i = Math.pow(.5, n / r.fast);
                                    e.fastEstimate = (1 - i) * t + i * e.fastEstimate;
                                    var a1 = Math.pow(.5, n / r.slow);
                                    e.slowEstimate = (1 - a1) * t + a1 * e.slowEstimate, e.totalWeight += n;
                                }
                                function l(e, u, l) {
                                    return s1.get().streaming.abr.movingAverageMethod !== r.default.MOVING_AVERAGE_SLIDING_WINDOW ? function(e, t) {
                                        var n = e ? o.throughputHalfLife : o.latencyHalfLife, r = e ? i[t] : a1[t];
                                        if (!r || r.totalWeight <= 0) return NaN;
                                        var s1 = r.fastEstimate / (1 - Math.pow(.5, r.totalWeight / n.fast)), u = r.slowEstimate / (1 - Math.pow(.5, r.totalWeight / n.slow));
                                        return e ? Math.min(s1, u) : Math.max(s1, u);
                                    }(e, u) : function(e, r, i) {
                                        var a1 = function(e, r, i) {
                                            var a1, o;
                                            if (e ? (a1 = t[r], o = i ? 3 : 4) : (a1 = n[r], o = 4), a1) {
                                                if (o >= a1.length) o = a1.length;
                                                else if (e) for(var s1 = 1; s1 < o; ++s1){
                                                    var u = a1[a1.length - s1] / a1[a1.length - s1 - 1];
                                                    if ((u >= 1.3 || u <= 1 / 1.3) && (o += 1) === a1.length) break;
                                                }
                                            } else o = 0;
                                            return o;
                                        }(e, r, i), o = (e ? t : n)[r];
                                        return 0 !== a1 && o && 0 !== o.length ? (o = o.slice(-a1)).reduce(function(e, t) {
                                            return e + t;
                                        }) / o.length : NaN;
                                    }(e, u, l);
                                }
                                function c(e, t) {
                                    return l(!0, e, t);
                                }
                                function d(e) {
                                    t[e] = t[e] || [], n[e] = n[e] || [], i[e] = i[e] || {
                                        fastEstimate: 0,
                                        slowEstimate: 0,
                                        totalWeight: 0
                                    }, a1[e] = a1[e] || {
                                        fastEstimate: 0,
                                        slowEstimate: 0,
                                        totalWeight: 0
                                    };
                                }
                                function f() {
                                    t = {}, n = {}, i = {}, a1 = {};
                                }
                                var h = {
                                    push: function(e, l, c) {
                                        if (l.trace && l.trace.length) {
                                            var f, h = l.tresponse.getTime() - l.trequest.getTime() || 1, g = l._tfinish.getTime() - l.tresponse.getTime() || 1, p = l.trace.reduce(function(e, t) {
                                                return e + t.b[0];
                                            }, 0), m = 0;
                                            if (0 !== (f = l._fileLoaderType && l._fileLoaderType === r.default.FILE_LOADER_TYPES.FETCH ? l.trace.reduce(function(e, t) {
                                                return e + t.d;
                                            }, 0) : c ? g : h + g) && (m = Math.round(8 * p / f)), d(e), function(e, t, n) {
                                                return e === r.default.VIDEO ? n < s1.get().streaming.cacheLoadThresholds[r.default.VIDEO] : e === r.default.AUDIO ? n < s1.get().streaming.cacheLoadThresholds[r.default.AUDIO] : void 0;
                                            }(e, 0, g)) {
                                                if (t[e].length > 0 && !t[e].hasCachedEntries) return;
                                                t[e].hasCachedEntries = !0;
                                            } else t[e] && t[e].hasCachedEntries && function(e) {
                                                delete t[e], delete n[e], delete i[e], delete a1[e], d(e);
                                            }(e);
                                            t[e].push(m), t[e].length > 20 && t[e].shift(), n[e].push(h), n[e].length > 20 && n[e].shift(), u(i[e], m, .001 * g, o.throughputHalfLife), u(a1[e], h, 1, o.latencyHalfLife);
                                        }
                                    },
                                    getAverageThroughput: c,
                                    getSafeAverageThroughput: function(e, t) {
                                        var n = c(e, t);
                                        return isNaN(n) || (n *= s1.get().streaming.abr.bandwidthSafetyFactor), n;
                                    },
                                    getAverageLatency: function(e) {
                                        return l(!1, e);
                                    },
                                    reset: f
                                };
                                return o = {
                                    throughputHalfLife: {
                                        fast: 3,
                                        slow: 8
                                    },
                                    latencyHalfLife: {
                                        fast: 1,
                                        slow: 2
                                    }
                                }, f(), h;
                            }
                            a1.__dashjs_factory_name = "ThroughputHistory", t.default = i.default.getClassFactory(a1);
                        },
                        "./src/streaming/rules/abr/ABRRulesCollection.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/rules/abr/ThroughputRule.js"), i = n("./src/streaming/rules/abr/InsufficientBufferRule.js"), a1 = n("./src/streaming/rules/abr/AbandonRequestsRule.js"), o = n("./src/streaming/rules/abr/DroppedFramesRule.js"), s1 = n("./src/streaming/rules/abr/SwitchHistoryRule.js"), u = n("./src/streaming/rules/abr/BolaRule.js"), l = n("./src/streaming/rules/abr/L2ARule.js"), c = n("./src/streaming/rules/abr/lolp/LoLpRule.js"), d = n("./src/core/FactoryMaker.js"), f = n("./src/streaming/rules/SwitchRequest.js"), h = n("./src/streaming/constants/Constants.js"), g = "qualitySwitchRules", p = "abandonFragmentRules";
                            function m(e) {
                                e = e || {};
                                var t, n, d = this.context, m = e.mediaPlayerModel, v = e.customParametersModel, y = e.dashMetrics, E = e.settings;
                                function T(e) {
                                    return e.filter(function(e) {
                                        return e.quality > f.default.NO_CHANGE;
                                    });
                                }
                                function b(e) {
                                    var t, n, r, i, a1, o = {}, s1 = null;
                                    if (0 !== e.length) {
                                        for(o[f.default.PRIORITY.STRONG] = {
                                            quality: f.default.NO_CHANGE,
                                            reason: null
                                        }, o[f.default.PRIORITY.WEAK] = {
                                            quality: f.default.NO_CHANGE,
                                            reason: null
                                        }, o[f.default.PRIORITY.DEFAULT] = {
                                            quality: f.default.NO_CHANGE,
                                            reason: null
                                        }, t = 0, n = e.length; t < n; t += 1)(r = e[t]).quality !== f.default.NO_CHANGE && (o[r.priority].quality === f.default.NO_CHANGE || o[r.priority].quality > r.quality) && (o[r.priority].quality = r.quality, o[r.priority].reason = r.reason || null);
                                        return o[f.default.PRIORITY.WEAK].quality !== f.default.NO_CHANGE && (s1 = o[f.default.PRIORITY.WEAK]), o[f.default.PRIORITY.DEFAULT].quality !== f.default.NO_CHANGE && (s1 = o[f.default.PRIORITY.DEFAULT]), o[f.default.PRIORITY.STRONG].quality !== f.default.NO_CHANGE && (s1 = o[f.default.PRIORITY.STRONG]), s1 && (i = s1.quality, a1 = s1.reason), Object(f.default)(d).create(i, a1);
                                    }
                                }
                                return {
                                    initialize: function() {
                                        t = [], n = [], E.get().streaming.abr.useDefaultABRRules && (E.get().streaming.abr.ABRStrategy === h.default.ABR_STRATEGY_L2A ? t.push(Object(l.default)(d).create({
                                            dashMetrics: y,
                                            settings: E
                                        })) : E.get().streaming.abr.ABRStrategy === h.default.ABR_STRATEGY_LoLP ? t.push(Object(c.default)(d).create({
                                            dashMetrics: y
                                        })) : (t.push(Object(u.default)(d).create({
                                            dashMetrics: y,
                                            mediaPlayerModel: m,
                                            settings: E
                                        })), t.push(Object(r.default)(d).create({
                                            dashMetrics: y
                                        })), E.get().streaming.abr.additionalAbrRules.insufficientBufferRule && t.push(Object(i.default)(d).create({
                                            dashMetrics: y,
                                            settings: E
                                        })), E.get().streaming.abr.additionalAbrRules.switchHistoryRule && t.push(Object(s1.default)(d).create()), E.get().streaming.abr.additionalAbrRules.droppedFramesRule && t.push(Object(o.default)(d).create()), E.get().streaming.abr.additionalAbrRules.abandonRequestsRule && n.push(Object(a1.default)(d).create({
                                            dashMetrics: y,
                                            mediaPlayerModel: m,
                                            settings: E
                                        })))), v.getAbrCustomRules().forEach(function(e) {
                                            e.type === g && t.push(e.rule(d).create()), e.type === p && n.push(e.rule(d).create());
                                        });
                                    },
                                    reset: function() {
                                        [
                                            t,
                                            n
                                        ].forEach(function(e) {
                                            e && e.length && e.forEach(function(e) {
                                                return e.reset && e.reset();
                                            });
                                        }), t = [], n = [];
                                    },
                                    getMaxQuality: function(e) {
                                        return b(T(t.map(function(t) {
                                            return t.getMaxIndex(e);
                                        }))) || Object(f.default)(d).create();
                                    },
                                    getMinSwitchRequest: b,
                                    shouldAbandonFragment: function(e, t) {
                                        return b(T(n.map(function(n) {
                                            return n.shouldAbandon(e, t);
                                        }))) || Object(f.default)(d).create();
                                    },
                                    getQualitySwitchRules: function() {
                                        return t;
                                    }
                                };
                            }
                            m.__dashjs_factory_name = "ABRRulesCollection";
                            var v = d.default.getClassFactory(m);
                            v.QUALITY_SWITCH_RULES = g, v.ABANDON_FRAGMENT_RULES = p, d.default.updateSingletonFactory(m.__dashjs_factory_name, v), t.default = v;
                        },
                        "./src/streaming/rules/abr/AbandonRequestsRule.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/rules/SwitchRequest.js"), i = n("./src/core/FactoryMaker.js"), a1 = n("./src/core/Debug.js");
                            function o(e) {
                                e = e || {};
                                var t, n, i, s1, u, l = this.context, c = e.mediaPlayerModel, d = e.dashMetrics, f = e.settings;
                                function h() {
                                    i = {}, s1 = {}, u = [];
                                }
                                return t = {
                                    shouldAbandon: function(e) {
                                        var t = Object(r.default)(l).create(r.default.NO_CHANGE, {
                                            name: o.__dashjs_factory_name
                                        });
                                        if (!(e && e.hasOwnProperty("getMediaInfo") && e.hasOwnProperty("getMediaType") && e.hasOwnProperty("getCurrentRequest") && e.hasOwnProperty("getRepresentationInfo") && e.hasOwnProperty("getAbrController"))) return t;
                                        var a1, h, g = e.getMediaInfo(), p = e.getMediaType(), m = e.getStreamInfo(), v = m ? m.id : null, y = e.getCurrentRequest();
                                        if (!isNaN(y.index)) {
                                            a1 = p, h = y.index, i[a1] = i[a1] || {}, i[a1][h] = i[a1][h] || {};
                                            var E = c.getStableBufferTime();
                                            if (d.getCurrentBufferLevel(p) > E) return t;
                                            var T = i[p][y.index];
                                            if (null === T || null === y.firstByteDate || s1.hasOwnProperty(T.id)) return t;
                                            if (void 0 === T.firstByteTime && (u[p] = [], T.firstByteTime = y.firstByteDate.getTime(), T.segmentDuration = y.duration, T.bytesTotal = y.bytesTotal, T.id = y.index), T.bytesLoaded = y.bytesLoaded, T.elapsedTime = (new Date).getTime() - T.firstByteTime, T.bytesLoaded > 0 && T.elapsedTime > 0 && function(e, t) {
                                                u[e] = u[e] || [], u[e].push(t);
                                            }(p, Math.round(8 * T.bytesLoaded / T.elapsedTime)), u[p].length >= 5 && T.elapsedTime > 500 && T.bytesLoaded < T.bytesTotal) {
                                                var b = u[p].reduce(function(e, t) {
                                                    return e + t;
                                                }, 0);
                                                if (T.measuredBandwidthInKbps = Math.round(b / u[p].length), T.estimatedTimeOfDownload = +(8 * T.bytesTotal / T.measuredBandwidthInKbps / 1e3).toFixed(2), T.estimatedTimeOfDownload < 1.8 * T.segmentDuration || 0 === e.getRepresentationInfo().quality) return t;
                                                if (!s1.hasOwnProperty(T.id)) {
                                                    var A = e.getAbrController(), _ = T.bytesTotal - T.bytesLoaded, S = A.getBitrateList(g), w = A.getQualityForBitrate(g, T.measuredBandwidthInKbps * f.get().streaming.abr.bandwidthSafetyFactor, v), I = A.getMinAllowedIndexFor(p, v), R = void 0 !== I ? Math.max(I, w) : w;
                                                    _ > T.bytesTotal * S[R].bitrate / S[A.getQualityFor(p, v)].bitrate && (t.quality = R, t.reason.throughput = T.measuredBandwidthInKbps, t.reason.fragmentID = T.id, s1[T.id] = T, n.debug("[" + p + "] frag id", T.id, " is asking to abandon and switch to quality to ", R, " measured bandwidth was", T.measuredBandwidthInKbps), delete i[p][T.id]);
                                                }
                                            } else T.bytesLoaded === T.bytesTotal && delete i[p][T.id];
                                        }
                                        return t;
                                    },
                                    reset: h
                                }, n = Object(a1.default)(l).getInstance().getLogger(t), h(), t;
                            }
                            o.__dashjs_factory_name = "AbandonRequestsRule", t.default = i.default.getClassFactory(o);
                        },
                        "./src/streaming/rules/abr/BolaRule.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/MetricsConstants.js"), i = n("./src/streaming/rules/SwitchRequest.js"), a1 = n("./src/core/FactoryMaker.js"), o = n("./src/streaming/vo/metrics/HTTPRequest.js"), s1 = n("./src/core/EventBus.js"), u = n("./src/core/events/Events.js"), l = n("./src/core/Debug.js"), c = n("./src/streaming/MediaPlayerEvents.js"), d = n("./src/streaming/constants/Constants.js"), f = 10;
                            function h(e) {
                                e = e || {};
                                var t, n, a1, h = this.context, g = e.dashMetrics, p = e.mediaPlayerModel, m = Object(s1.default)(h).getInstance();
                                function v(e, t, n) {
                                    var r = n.reduce(function(e, t, r) {
                                        return t > n[e] ? r : e;
                                    }, 0);
                                    if (0 === r) return null;
                                    var i = Math.max(e, f + 2 * t.length), a1 = (n[r] - 1) / (i / f - 1);
                                    return {
                                        gp: a1,
                                        Vp: f / a1
                                    };
                                }
                                function y(e) {
                                    e.placeholderBuffer = 0, e.mostAdvancedSegmentStart = NaN, e.lastSegmentWasReplacement = !1, e.lastSegmentStart = NaN, e.lastSegmentDurationS = NaN, e.lastSegmentRequestTimeMs = NaN, e.lastSegmentFinishTimeMs = NaN;
                                }
                                function E(e, t) {
                                    var n = p.getStableBufferTime();
                                    if (e.stableBufferTime !== n) {
                                        var r = v(n, e.bitrates, e.utilities);
                                        if (r.Vp !== e.Vp || r.gp !== e.gp) {
                                            var i = g.getCurrentBufferLevel(t), a1 = i + e.placeholderBuffer;
                                            a1 -= f, a1 *= r.Vp / e.Vp, a1 += f, e.stableBufferTime = n, e.Vp = r.Vp, e.gp = r.gp, e.placeholderBuffer = Math.max(0, a1 - i);
                                        }
                                    }
                                }
                                function T(e, t) {
                                    return e.Vp * (e.utilities[t] + e.gp);
                                }
                                function b(e, t) {
                                    for(var n = e.bitrates[t], r = e.utilities[t], i = 0, a1 = t - 1; a1 >= 0; --a1)if (e.utilities[a1] < e.utilities[t]) {
                                        var o = e.bitrates[a1], s1 = e.utilities[a1], u = e.Vp * (e.gp + (n * s1 - o * r) / (n - o));
                                        i = Math.max(i, u);
                                    }
                                    return i;
                                }
                                function A(e) {
                                    var t = e.mediaType === d.default.AUDIO ? [
                                        d.default.AUDIO
                                    ] : a1;
                                    for(var n in t)a1.hasOwnProperty(n) && 2 === a1[n].state && (a1[n].placeholderBuffer = 0);
                                }
                                function _() {
                                    for(var e in a1)if (a1.hasOwnProperty(e)) {
                                        var t = a1[e];
                                        0 !== t.state && (t.state = 1, y(t));
                                    }
                                }
                                function S(e) {
                                    if (e && e.chunk && e.chunk.mediaInfo) {
                                        var t = a1[e.chunk.mediaInfo.type];
                                        if (t && 0 !== t.state) {
                                            var n = e.chunk.start;
                                            isNaN(t.mostAdvancedSegmentStart) || n > t.mostAdvancedSegmentStart ? (t.mostAdvancedSegmentStart = n, t.lastSegmentWasReplacement = !1) : t.lastSegmentWasReplacement = !0, t.lastSegmentStart = n, t.lastSegmentDurationS = e.chunk.duration, t.lastQuality = e.chunk.quality, I(t, e.chunk.mediaInfo.type);
                                        }
                                    }
                                }
                                function w(e) {
                                    if (e && e.metric === r.default.HTTP_REQUEST && e.value && e.value.type === o.HTTPRequest.MEDIA_SEGMENT_TYPE && e.value.trace && e.value.trace.length) {
                                        var t = a1[e.mediaType];
                                        t && 0 !== t.state && (t.lastSegmentRequestTimeMs = e.value.trequest.getTime(), t.lastSegmentFinishTimeMs = e.value._tfinish.getTime(), I(t, e.mediaType));
                                    }
                                }
                                function I(e, t) {
                                    if (!isNaN(e.lastSegmentStart) && !isNaN(e.lastSegmentRequestTimeMs) && !isNaN(e.placeholderBuffer)) {
                                        if (e.placeholderBuffer *= .99, !isNaN(e.lastSegmentFinishTimeMs)) {
                                            var n = g.getCurrentBufferLevel(t) + .001 * (e.lastSegmentFinishTimeMs - e.lastSegmentRequestTimeMs), r = T(e, e.lastQuality), i = Math.max(0, r - n);
                                            e.placeholderBuffer = Math.min(i, e.placeholderBuffer);
                                        }
                                        e.lastSegmentWasReplacement && !isNaN(e.lastSegmentDurationS) && (e.placeholderBuffer += e.lastSegmentDurationS), e.lastSegmentStart = NaN, e.lastSegmentRequestTimeMs = NaN;
                                    }
                                }
                                function R(e) {
                                    if (e) {
                                        var t = a1[e.mediaType];
                                        t && 0 !== t.state && (t.abrQuality = e.newQuality);
                                    }
                                }
                                function C(e) {
                                    if (e) {
                                        var t = a1[e.mediaType];
                                        if (t && 0 !== t.state) {
                                            var n, r = g.getCurrentBufferLevel(e.mediaType);
                                            n = t.abrQuality > 0 ? b(t, t.abrQuality) : f;
                                            var i = Math.max(0, n - r);
                                            t.placeholderBuffer = Math.min(t.placeholderBuffer, i);
                                        }
                                    }
                                }
                                function D() {
                                    a1 = {};
                                }
                                return t = {
                                    getMaxIndex: function(e) {
                                        var t = Object(i.default)(h).create();
                                        if (!(e && e.hasOwnProperty("getMediaInfo") && e.hasOwnProperty("getMediaType") && e.hasOwnProperty("getScheduleController") && e.hasOwnProperty("getStreamInfo") && e.hasOwnProperty("getAbrController") && e.hasOwnProperty("useBufferOccupancyABR"))) return t;
                                        var r = e.getMediaInfo(), o = e.getMediaType(), s1 = e.getScheduleController(), u = e.getStreamInfo(), l = e.getAbrController(), c = l.getThroughputHistory(), d = u ? u.id : null, f = u && u.manifestInfo && u.manifestInfo.isDynamic, m = e.useBufferOccupancyABR();
                                        if (t.reason = t.reason || {}, !m) return t;
                                        s1.setTimeToLoadDelay(0);
                                        var A = function(e) {
                                            var t = e.getMediaType(), n = a1[t];
                                            return n ? 0 !== n.state && E(n, t) : (n = function(e) {
                                                var t = {}, n = e.getMediaInfo().bitrateList.map(function(e) {
                                                    return e.bandwidth;
                                                }), r = function(e) {
                                                    return e.map(function(e) {
                                                        return Math.log(e);
                                                    });
                                                }(n);
                                                r = r.map(function(e) {
                                                    return e - r[0] + 1;
                                                });
                                                var i = p.getStableBufferTime(), a1 = v(i, n, r);
                                                return a1 ? (t.state = 1, t.bitrates = n, t.utilities = r, t.stableBufferTime = i, t.Vp = a1.Vp, t.gp = a1.gp, t.lastQuality = 0, y(t)) : t.state = 0, t;
                                            }(e), a1[t] = n), n;
                                        }(e);
                                        if (0 === A.state) return t;
                                        var _, S = g.getCurrentBufferLevel(o), w = c.getAverageThroughput(o, f), I = c.getSafeAverageThroughput(o, f), R = c.getAverageLatency(o);
                                        if (t.reason.state = A.state, t.reason.throughput = w, t.reason.latency = R, isNaN(w)) return t;
                                        switch(A.state){
                                            case 1:
                                                _ = l.getQualityForBitrate(r, I, d, R), t.quality = _, t.reason.throughput = I, A.placeholderBuffer = Math.max(0, b(A, _) - S), A.lastQuality = _, !isNaN(A.lastSegmentDurationS) && S >= A.lastSegmentDurationS && (A.state = 2);
                                                break;
                                            case 2:
                                                !function(e, t) {
                                                    var n = Date.now();
                                                    if (isNaN(e.lastSegmentFinishTimeMs)) {
                                                        if (!isNaN(e.lastCallTimeMs)) {
                                                            var r = .001 * (n - e.lastCallTimeMs);
                                                            e.placeholderBuffer += Math.max(0, r);
                                                        }
                                                    } else {
                                                        var i = .001 * (n - e.lastSegmentFinishTimeMs);
                                                        e.placeholderBuffer += Math.max(0, i);
                                                    }
                                                    e.lastCallTimeMs = n, e.lastSegmentStart = NaN, e.lastSegmentRequestTimeMs = NaN, e.lastSegmentFinishTimeMs = NaN, E(e, t);
                                                }(A, o), _ = function(e, t) {
                                                    for(var n = e.bitrates.length, r = NaN, i = NaN, a1 = 0; a1 < n; ++a1){
                                                        var o = (e.Vp * (e.utilities[a1] + e.gp) - t) / e.bitrates[a1];
                                                        (isNaN(i) || o >= i) && (i = o, r = a1);
                                                    }
                                                    return r;
                                                }(A, S + A.placeholderBuffer);
                                                var C = l.getQualityForBitrate(r, I, d, R);
                                                _ > A.lastQuality && _ > C && (_ = Math.max(C, A.lastQuality));
                                                var D = Math.max(0, S + A.placeholderBuffer - T(A, _));
                                                D <= A.placeholderBuffer ? (A.placeholderBuffer -= D, D = 0) : (D -= A.placeholderBuffer, A.placeholderBuffer = 0, _ < l.getMaxAllowedIndexFor(o, d) ? s1.setTimeToLoadDelay(1e3 * D) : D = 0), t.quality = _, t.reason.throughput = w, t.reason.latency = R, t.reason.bufferLevel = S, t.reason.placeholderBuffer = A.placeholderBuffer, t.reason.delay = D, A.lastQuality = _;
                                                break;
                                            default:
                                                n.debug("BOLA ABR rule invoked in bad state."), t.quality = l.getQualityForBitrate(r, I, d, R), t.reason.state = A.state, t.reason.throughput = I, t.reason.latency = R, A.state = 1, y(A);
                                        }
                                        return t;
                                    },
                                    reset: function() {
                                        D(), m.off(c.default.BUFFER_EMPTY, A, t), m.off(c.default.PLAYBACK_SEEKING, _, t), m.off(c.default.METRIC_ADDED, w, t), m.off(c.default.QUALITY_CHANGE_REQUESTED, R, t), m.off(c.default.FRAGMENT_LOADING_ABANDONED, C, t), m.off(u.default.MEDIA_FRAGMENT_LOADED, S, t);
                                    }
                                }, n = Object(l.default)(h).getInstance().getLogger(t), D(), m.on(c.default.BUFFER_EMPTY, A, t), m.on(c.default.PLAYBACK_SEEKING, _, t), m.on(c.default.METRIC_ADDED, w, t), m.on(c.default.QUALITY_CHANGE_REQUESTED, R, t), m.on(c.default.FRAGMENT_LOADING_ABANDONED, C, t), m.on(u.default.MEDIA_FRAGMENT_LOADED, S, t), t;
                            }
                            h.__dashjs_factory_name = "BolaRule", t.default = a1.default.getClassFactory(h);
                        },
                        "./src/streaming/rules/abr/DroppedFramesRule.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/streaming/rules/SwitchRequest.js"), a1 = n("./src/core/Debug.js");
                            function o() {
                                var e, t, n = this.context;
                                return e = {
                                    getMaxIndex: function(e) {
                                        var r = Object(i.default)(n).create();
                                        if (!e || !e.hasOwnProperty("getDroppedFramesHistory")) return r;
                                        var a1 = e.getDroppedFramesHistory(), o = e.getStreamInfo().id;
                                        if (a1) {
                                            var s1 = a1.getFrameHistory(o);
                                            if (!s1 || 0 === s1.length) return r;
                                            for(var u = 0, l = 0, c = i.default.NO_CHANGE, d = 1; d < s1.length; d++)if (s1[d] && (u = s1[d].droppedVideoFrames, (l = s1[d].totalVideoFrames) > 375 && u / l > .15)) {
                                                c = d - 1, t.debug("index: " + c + " Dropped Frames: " + u + " Total Frames: " + l);
                                                break;
                                            }
                                            return Object(i.default)(n).create(c, {
                                                droppedFrames: u
                                            });
                                        }
                                        return r;
                                    }
                                }, t = Object(a1.default)(n).getInstance().getLogger(e), e;
                            }
                            o.__dashjs_factory_name = "DroppedFramesRule", t.default = r.default.getClassFactory(o);
                        },
                        "./src/streaming/rules/abr/InsufficientBufferRule.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/EventBus.js"), i = n("./src/core/events/Events.js"), a1 = n("./src/core/FactoryMaker.js"), o = n("./src/core/Debug.js"), s1 = n("./src/streaming/rules/SwitchRequest.js"), u = n("./src/streaming/constants/Constants.js"), l = n("./src/streaming/constants/MetricsConstants.js"), c = n("./src/streaming/MediaPlayerEvents.js");
                            function d(e) {
                                e = e || {};
                                var t, n, a1, d = this.context, f = Object(r.default)(d).getInstance(), h = e.dashMetrics;
                                function g() {
                                    (a1 = {})[u.default.VIDEO] = {
                                        ignoreCount: 2
                                    }, a1[u.default.AUDIO] = {
                                        ignoreCount: 2
                                    };
                                }
                                function p() {
                                    g();
                                }
                                function m(e) {
                                    isNaN(e.startTime) || e.mediaType !== u.default.AUDIO && e.mediaType !== u.default.VIDEO || a1[e.mediaType].ignoreCount > 0 && a1[e.mediaType].ignoreCount--;
                                }
                                return t = {
                                    getMaxIndex: function(e) {
                                        var t = Object(s1.default)(d).create();
                                        if (!e || !e.hasOwnProperty("getMediaType")) return t;
                                        !function() {
                                            if (!h || !h.hasOwnProperty("getCurrentBufferLevel") || !h.hasOwnProperty("getCurrentBufferState")) throw new Error(u.default.MISSING_CONFIG_ERROR);
                                        }();
                                        var r = e.getMediaType(), i = h.getCurrentBufferState(r), o = e.getRepresentationInfo().fragmentDuration, c = e.getStreamInfo(), f = c ? c.id : null, g = e.getScheduleController(), p = c && c.manifestInfo && c.manifestInfo.isDynamic;
                                        if (function(e, t) {
                                            return !e && a1[t].ignoreCount > 0;
                                        }(g.getPlaybackController().getLowLatencyModeEnabled(), r) || !o) return t;
                                        if (i && i.state === l.default.BUFFER_EMPTY) n.debug("[" + r + "] Switch to index 0; buffer is empty."), t.quality = 0, t.reason = "InsufficientBufferRule: Buffer is empty";
                                        else {
                                            var m = e.getMediaInfo(), v = e.getAbrController(), y = v.getThroughputHistory(), E = h.getCurrentBufferLevel(r), T = y.getAverageThroughput(r, p), b = y.getAverageLatency(r), A = T * (E / o) * .5;
                                            t.quality = v.getQualityForBitrate(m, A, f, b), t.reason = "InsufficientBufferRule: being conservative to avoid immediate rebuffering";
                                        }
                                        return t;
                                    },
                                    reset: function() {
                                        g(), f.off(c.default.PLAYBACK_SEEKING, p, t), f.off(i.default.BYTES_APPENDED_END_FRAGMENT, m, t);
                                    }
                                }, n = Object(o.default)(d).getInstance().getLogger(t), g(), f.on(c.default.PLAYBACK_SEEKING, p, t), f.on(i.default.BYTES_APPENDED_END_FRAGMENT, m, t), t;
                            }
                            d.__dashjs_factory_name = "InsufficientBufferRule", t.default = a1.default.getClassFactory(d);
                        },
                        "./src/streaming/rules/abr/L2ARule.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/MetricsConstants.js"), i = n("./src/streaming/rules/SwitchRequest.js"), a1 = n("./src/core/FactoryMaker.js"), o = n("./src/streaming/vo/metrics/HTTPRequest.js"), s1 = n("./src/core/EventBus.js"), u = n("./src/core/events/Events.js"), l = n("./src/core/Debug.js"), c = n("./src/streaming/constants/Constants.js");
                            function d(e) {
                                e = e || {};
                                var t, n, a1, d, f = this.context, h = e.dashMetrics, g = Object(s1.default)(f).getInstance();
                                function p(e) {
                                    e.placeholderBuffer = 0, e.mostAdvancedSegmentStart = NaN, e.lastSegmentWasReplacement = !1, e.lastSegmentStart = NaN, e.lastSegmentDurationS = NaN, e.lastSegmentRequestTimeMs = NaN, e.lastSegmentFinishTimeMs = NaN;
                                }
                                function m() {
                                    for(var e in n)if (n.hasOwnProperty(e)) {
                                        var t = n[e];
                                        0 !== t.state && (t.state = 1, p(t));
                                    }
                                }
                                function v(e) {
                                    if (e && e.chunk && e.chunk.mediaInfo) {
                                        var t = n[e.chunk.mediaInfo.type], r = a1[e.chunk.mediaInfo.type];
                                        if (t && 0 !== t.state) {
                                            var i = e.chunk.start;
                                            isNaN(t.mostAdvancedSegmentStart) || i > t.mostAdvancedSegmentStart ? (t.mostAdvancedSegmentStart = i, t.lastSegmentWasReplacement = !1) : t.lastSegmentWasReplacement = !0, t.lastSegmentStart = i, t.lastSegmentDurationS = e.chunk.duration, t.lastQuality = e.chunk.quality, E(t, r);
                                        }
                                    }
                                }
                                function y(e) {
                                    if (e && e.metric === r.default.HTTP_REQUEST && e.value && e.value.type === o.HTTPRequest.MEDIA_SEGMENT_TYPE && e.value.trace && e.value.trace.length) {
                                        var t = n[e.mediaType], i = a1[e.mediaType];
                                        t && 0 !== t.state && (t.lastSegmentRequestTimeMs = e.value.trequest.getTime(), t.lastSegmentFinishTimeMs = e.value._tfinish.getTime(), E(t, i));
                                    }
                                }
                                function E(e, t) {
                                    isNaN(e.lastSegmentStart) || isNaN(e.lastSegmentRequestTimeMs) || (t.segment_request_start_s = .001 * e.lastSegmentRequestTimeMs, t.segment_download_finish_s = .001 * e.lastSegmentFinishTimeMs, e.lastSegmentStart = NaN, e.lastSegmentRequestTimeMs = NaN);
                                }
                                function T(e) {
                                    if (e && e.mediaType) {
                                        var t = n[e.mediaType];
                                        t && 0 !== t.state && (t.abrQuality = e.newQuality);
                                    }
                                }
                                function b(e, t) {
                                    if (e.length !== t.length) return -1;
                                    for(var n = 0, r = 0; r < e.length; r++)n += e[r] * t[r];
                                    return n;
                                }
                                function A() {
                                    n = {}, a1 = {};
                                }
                                return t = {
                                    getMaxIndex: function(e) {
                                        var t, r = Object(i.default)(f).create(), o = Math.pow(4, .99), s1 = Math.max(Math.pow(4, 1), o * Math.sqrt(4)), u = e.getMediaInfo(), l = e.getMediaType(), g = u.bitrateList.map(function(e) {
                                            return e.bandwidth;
                                        }), m = g.length, v = e.getScheduleController(), y = e.getStreamInfo(), E = e.getAbrController(), T = E.getThroughputHistory(), A = y && y.manifestInfo && y.manifestInfo.isDynamic, _ = e.useL2AABR(), S = h.getCurrentBufferLevel(l, !0), w = T.getSafeAverageThroughput(l, A), I = T.getAverageThroughput(l, A), R = T.getAverageLatency(l), C = e.getVideoModel().getPlaybackRate();
                                        if (!(e && e.hasOwnProperty("getMediaInfo") && e.hasOwnProperty("getMediaType") && e.hasOwnProperty("getScheduleController") && e.hasOwnProperty("getStreamInfo") && e.hasOwnProperty("getAbrController") && e.hasOwnProperty("useL2AABR"))) return r;
                                        if (r.reason = r.reason || {}, !_ || l === c.default.AUDIO) return r;
                                        v.setTimeToLoadDelay(0);
                                        var D = function(e) {
                                            var t = e.getMediaType(), r = n[t];
                                            return r || (r = function(e) {
                                                var t = {}, n = e.getMediaInfo(), r = n.bitrateList.map(function(e) {
                                                    return e.bandwidth / 1e3;
                                                });
                                                return t.state = 1, t.bitrates = r, t.lastQuality = 0, function(e) {
                                                    e && e.type && (a1[e.type] = {}, a1[e.type].w = [], a1[e.type].prev_w = [], a1[e.type].Q = 0, a1[e.type].segment_request_start_s = 0, a1[e.type].segment_download_finish_s = 0, a1[e.type].B_target = 1.5);
                                                }(n), p(t), t;
                                            }(e), n[t] = r), r;
                                        }(e);
                                        if (0 === D.state) return r;
                                        var k = a1[l];
                                        if (!k) return r;
                                        if (r.reason.state = D.state, r.reason.throughput = I, r.reason.latency = R, isNaN(I)) return r;
                                        switch(D.state){
                                            case 1:
                                                if (t = E.getQualityForBitrate(u, w, y.id, R), r.quality = t, r.reason.throughput = w, D.lastQuality = t, !isNaN(D.lastSegmentDurationS) && S >= k.B_target) {
                                                    D.state = 2, k.Q = o;
                                                    for(var N = 0; N < m; ++N)N === D.lastQuality ? k.prev_w[N] = 1 : k.prev_w[N] = 0;
                                                }
                                                break;
                                            case 2:
                                                var L = [], x = h.getCurrentHttpRequest(l).trace.reduce(function(e, t) {
                                                    return e + t.d;
                                                }, 0), M = h.getCurrentHttpRequest(l).trace.reduce(function(e, t) {
                                                    return e + t.b[0];
                                                }, 0), O = Math.round(8 * M / x);
                                                O < 1 && (O = 1);
                                                for(var P = D.lastSegmentDurationS, F = 1, U = 0; U < m; ++U)g[U] = g[U] / 1e3, C * g[U] > O && (F = -1), k.w[U] = k.prev_w[U] + F * (P / (2 * s1)) * ((k.Q + o) * (C * g[U] / O));
                                                k.w = function(e) {
                                                    for(var t = e.length, n = !1, r = [], i = 0; i < t; ++i)r[i] = e[i];
                                                    for(var a1 = e.sort(function(e, t) {
                                                        return t - e;
                                                    }), o = 0, s1 = 0, u = [], l = 0; l < t - 1; ++l)if ((s1 = ((o += a1[l]) - 1) / (l + 1)) >= a1[l + 1]) {
                                                        n = !0;
                                                        break;
                                                    }
                                                    n || (s1 = (o + a1[t - 1] - 1) / t);
                                                    for(var c = 0; c < t; ++c)u[c] = Math.max(r[c] - s1, 0);
                                                    return u;
                                                }(k.w);
                                                for(var j = 0; j < m; ++j)L[j] = k.w[j] - k.prev_w[j], k.prev_w[j] = k.w[j];
                                                k.Q = Math.max(0, k.Q - P + P * C * ((b(g, k.prev_w) + b(g, L)) / O));
                                                for(var B = [], G = 0; G < m; ++G)B[G] = Math.abs(g[G] - b(k.w, g));
                                                (t = B.indexOf(Math.min.apply(Math, B))) > D.lastQuality && g[D.lastQuality + 1] <= O && (t = D.lastQuality + 1), g[t] >= O && (k.Q = 2 * Math.max(o, k.Q)), r.quality = t, r.reason.throughput = I, r.reason.latency = R, r.reason.bufferLevel = S, D.lastQuality = r.quality;
                                                break;
                                            default:
                                                d.debug("L2A ABR rule invoked in bad state."), r.quality = E.getQualityForBitrate(u, w, y.id, R), r.reason.state = D.state, r.reason.throughput = w, r.reason.latency = R, D.state = 1, p(D);
                                        }
                                        return r;
                                    },
                                    reset: function() {
                                        A(), g.off(u.default.PLAYBACK_SEEKING, m, t), g.off(u.default.MEDIA_FRAGMENT_LOADED, v, t), g.off(u.default.METRIC_ADDED, y, t), g.off(u.default.QUALITY_CHANGE_REQUESTED, T, t);
                                    }
                                }, d = Object(l.default)(f).getInstance().getLogger(t), A(), g.on(u.default.PLAYBACK_SEEKING, m, t), g.on(u.default.MEDIA_FRAGMENT_LOADED, v, t), g.on(u.default.METRIC_ADDED, y, t), g.on(u.default.QUALITY_CHANGE_REQUESTED, T, t), t;
                            }
                            d.__dashjs_factory_name = "L2ARule", t.default = a1.default.getClassFactory(d);
                        },
                        "./src/streaming/rules/abr/SwitchHistoryRule.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/core/Debug.js"), a1 = n("./src/streaming/rules/SwitchRequest.js");
                            function o() {
                                var e, t, n = this.context;
                                return e = {
                                    getMaxIndex: function(e) {
                                        for(var r = e ? e.getSwitchHistory() : null, i = r ? r.getSwitchRequests() : [], o = 0, s1 = 0, u = 0, l = Object(a1.default)(n).create(), c = 0; c < i.length; c++)if (void 0 !== i[c] && (o += i[c].drops, s1 += i[c].noDrops, u += i[c].dropSize, o + s1 >= 6 && o / s1 > .075)) {
                                            l.quality = c > 0 && i[c].drops > 0 ? c - 1 : c, l.reason = {
                                                index: l.quality,
                                                drops: o,
                                                noDrops: s1,
                                                dropSize: u
                                            }, t.debug("Switch history rule index: " + l.quality + " samples: " + (o + s1) + " drops: " + o);
                                            break;
                                        }
                                        return l;
                                    }
                                }, t = Object(i.default)(n).getInstance().getLogger(e), e;
                            }
                            o.__dashjs_factory_name = "SwitchHistoryRule", t.default = r.default.getClassFactory(o);
                        },
                        "./src/streaming/rules/abr/ThroughputRule.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/streaming/rules/SwitchRequest.js"), a1 = n("./src/streaming/constants/Constants.js"), o = n("./src/streaming/constants/MetricsConstants.js");
                            function s1(e) {
                                e = e || {};
                                var t = this.context, n = e.dashMetrics;
                                return {
                                    getMaxIndex: function(e) {
                                        var r = Object(i.default)(t).create();
                                        if (!(e && e.hasOwnProperty("getMediaInfo") && e.hasOwnProperty("getMediaType") && e.hasOwnProperty("useBufferOccupancyABR") && e.hasOwnProperty("getAbrController") && e.hasOwnProperty("getScheduleController"))) return r;
                                        !function() {
                                            if (!n || !n.hasOwnProperty("getCurrentBufferState")) throw new Error(a1.default.MISSING_CONFIG_ERROR);
                                        }();
                                        var s1 = e.getMediaInfo(), u = e.getMediaType(), l = n.getCurrentBufferState(u), c = e.getScheduleController(), d = e.getAbrController(), f = e.getStreamInfo(), h = f ? f.id : null, g = f && f.manifestInfo ? f.manifestInfo.isDynamic : null, p = d.getThroughputHistory(), m = p.getSafeAverageThroughput(u, g), v = p.getAverageLatency(u), y = e.useBufferOccupancyABR();
                                        return isNaN(m) || !l || y || d.getAbandonmentStateFor(h, u) !== o.default.ABANDON_LOAD && (l.state === o.default.BUFFER_LOADED || g) && (r.quality = d.getQualityForBitrate(s1, m, h, v), c.setTimeToLoadDelay(0), r.reason = {
                                            throughput: m,
                                            latency: v
                                        }), r;
                                    },
                                    reset: function() {}
                                };
                            }
                            s1.__dashjs_factory_name = "ThroughputRule", t.default = r.default.getClassFactory(s1);
                        },
                        "./src/streaming/rules/abr/lolp/LearningAbrController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/core/Debug.js");
                            function a1() {
                                var e, t, n, r, a1, o, s1, u, l, c = this.context;
                                function d() {
                                    n = null, r = 1, a1 = 100, o = 0, s1 = null, u = null, l = "dynamic_weight_selection";
                                }
                                function f() {
                                    var e = 0;
                                    if (n) for(var t = 0; t < n.length; t++){
                                        var r = n[t];
                                        r.state.throughput > e && (e = r.state.throughput);
                                    }
                                    return e;
                                }
                                function h(e, t, n) {
                                    var r = e.map(function(e, r) {
                                        return n[r] * Math.pow(e - t[r], 2);
                                    }).reduce(function(e, t) {
                                        return e + t;
                                    });
                                    return (r < 0 ? -1 : 1) * Math.sqrt(Math.abs(r));
                                }
                                function g(e, t) {
                                    return h([
                                        e.state.throughput,
                                        e.state.latency,
                                        e.state.rebuffer,
                                        e.state.switch
                                    ], [
                                        t.state.throughput,
                                        t.state.latency,
                                        t.state.rebuffer,
                                        t.state.switch
                                    ], [
                                        1,
                                        1,
                                        1,
                                        1
                                    ]);
                                }
                                function p(e, t, n) {
                                    for(var r = 0; r < t.length; r++){
                                        var i = t[r], a1 = g(i, e);
                                        m(i, n, Math.exp(-1 * Math.pow(a1, 2) / (2 * Math.pow(.1, 2))));
                                    }
                                }
                                function m(e, t, n) {
                                    var r = e.state, i = [
                                        .01,
                                        .01,
                                        .01,
                                        .01
                                    ];
                                    r.throughput = r.throughput + (t[0] - r.throughput) * i[0] * n, r.latency = r.latency + (t[1] - r.latency) * i[1] * n, r.rebuffer = r.rebuffer + (t[2] - r.rebuffer) * i[2] * n, r.switch = r.switch + (t[3] - r.switch) * i[3] * n;
                                }
                                return e = {
                                    getNextQuality: function(e, i, c, d, g, m, v) {
                                        var y = c, E = d, T = i, b = function(e) {
                                            if (!n) {
                                                n = [];
                                                var t = e.bitrateList, i = [];
                                                o = t[0].bandwidth, t.forEach(function(e) {
                                                    i.push(e.bandwidth), e.bandwidth < o && (o = e.bandwidth);
                                                }), l = i.map(function(e) {
                                                    return Math.pow(e, 2);
                                                }).reduce(function(e, t) {
                                                    return e + t;
                                                }), r = Math.sqrt(l);
                                                for(var a1 = 0; a1 < t.length; a1++){
                                                    var s1 = {
                                                        qualityIndex: a1,
                                                        bitrate: t[a1].bandwidth,
                                                        state: {
                                                            throughput: t[a1].bandwidth / r,
                                                            latency: 0,
                                                            rebuffer: 0,
                                                            switch: 0
                                                        }
                                                    };
                                                    n.push(s1);
                                                }
                                                u = function(e) {
                                                    var t = [], n = function(e) {
                                                        for(var t = [], n = 0; n < e; n++){
                                                            var r = [
                                                                Math.random() * f(),
                                                                Math.random(),
                                                                Math.random(),
                                                                Math.random()
                                                            ];
                                                            t.push(r);
                                                        }
                                                        return t;
                                                    }(Math.pow(e.length, 2));
                                                    t.push(n[0]);
                                                    for(var r = [
                                                        1,
                                                        1,
                                                        1,
                                                        1
                                                    ], i = 1; i < e.length; i++){
                                                        for(var a1 = null, o = null, s1 = 0; s1 < n.length; s1++){
                                                            for(var u = n[s1], l = null, c = 0; c < t.length; c++){
                                                                var d = h(u, t[c], r);
                                                                (null === l || d < l) && (l = d);
                                                            }
                                                            (null === o || l > o) && (a1 = u, o = l);
                                                        }
                                                        t.push(a1);
                                                    }
                                                    for(var g = null, p = null, m = 0; m < t.length; m++){
                                                        for(var v = 0, y = 0; y < t.length; y++)m !== y && (v += h(t[m], t[y], r));
                                                        (null === g || v > g) && (g = v, p = m);
                                                    }
                                                    var E = [];
                                                    for(E.push(t[p]), t.splice(p, 1); t.length > 0;){
                                                        for(var T = null, b = null, A = 0; A < t.length; A++){
                                                            var _ = h(E[0], t[A], r);
                                                            (null === T || _ < T) && (T = _, b = A);
                                                        }
                                                        E.push(t[b]), t.splice(b, 1);
                                                    }
                                                    return E;
                                                }(n);
                                            }
                                            var l;
                                            return n;
                                        }(e), A = i / r;
                                        A > 1 && (A = f()), c /= a1, t.debug("getNextQuality called throughput:".concat(A, " latency:").concat(c, " bufferSize:").concat(d, " currentQualityIndex:").concat(m, " playbackRate:").concat(g));
                                        var _ = b[m], S = _.bitrate * v.getSegmentDuration() / T, w = Math.max(0, S - E);
                                        if (E - S < v.getMinBuffer()) return t.debug("Buffer is low for bitrate= ".concat(_.bitrate, " downloadTime=").concat(S, " currentBuffer=").concat(E, " rebuffer=").concat(w)), function(e, t) {
                                            var r = 0, i = e;
                                            if (n) for(var a1 = 0; a1 < n.length; a1++){
                                                var o = n[a1];
                                                o.bitrate < e.bitrate && o.bitrate > r && t > o.bitrate && (r = o.bitrate, i = o);
                                            }
                                            return i;
                                        }(_, T).qualityIndex;
                                        switch(l){
                                            case "manual_weight_selection":
                                                s1 = [
                                                    .4,
                                                    .4,
                                                    .4,
                                                    .4
                                                ];
                                                break;
                                            case "random_weight_selection":
                                                !function(e) {
                                                    s1 = function(e, t) {
                                                        for(var n = [], r = Math.sqrt(2 / e), i = 0; i < 4; i++)n.push(Math.random() * r);
                                                        return s1 = n;
                                                    }(e.length);
                                                }(b);
                                                break;
                                            default:
                                                !function(e, t, n, r, i, a1, o) {
                                                    s1 || (s1 = u[u.length - 1]);
                                                    var l = e.findWeightVector(t, n, r, i, a1, o);
                                                    null !== l && -1 !== l && (s1 = l);
                                                }(v, b, y, E, w, T, g);
                                        }
                                        for(var I = null, R = null, C = null, D = 0; D < b.length; D++){
                                            var k = b[D], N = k.state, L = [
                                                N.throughput,
                                                N.latency,
                                                N.rebuffer,
                                                N.switch
                                            ], x = s1.slice(), M = v.getNextBufferWithBitrate(k.bitrate, E, T), O = M < v.getMinBuffer();
                                            O && t.debug("Buffer is low for bitrate=".concat(k.bitrate, " downloadTime=").concat(S, " currentBuffer=").concat(E, " nextBuffer=").concat(M)), (k.bitrate > i - 1e4 || O) && k.bitrate !== o && (x[0] = 100);
                                            var P = h(L, [
                                                A,
                                                0,
                                                0,
                                                0
                                            ], x);
                                            (null === I || P < I) && (I = P, R = k.qualityIndex, C = k);
                                        }
                                        var F = Math.abs(_.bitrate - C.bitrate) / r;
                                        return p(_, b, [
                                            A,
                                            c,
                                            w,
                                            F
                                        ]), p(C, b, [
                                            A,
                                            0,
                                            0,
                                            F
                                        ]), R;
                                    },
                                    reset: function() {
                                        d();
                                    }
                                }, t = Object(i.default)(c).getInstance().getLogger(e), d(), e;
                            }
                            a1.__dashjs_factory_name = "LearningAbrController", t.default = r.default.getClassFactory(a1);
                        },
                        "./src/streaming/rules/abr/lolp/LoLpQoEEvaluator.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/streaming/rules/abr/lolp/QoeInfo.js");
                            function a1() {
                                var e, t, n, r, a1;
                                function o() {
                                    t = null, n = null, r = null, a1 = null;
                                }
                                function s1(e, t, n, r) {
                                    var a1 = new i.default;
                                    return a1.type = e, a1.weights.bitrateReward = t || 1, a1.weights.bitrateSwitchPenalty = 1, a1.weights.rebufferPenalty = n || 1e3, a1.weights.latencyPenalty = [], a1.weights.latencyPenalty.push({
                                        threshold: 1.1,
                                        penalty: .05 * r
                                    }), a1.weights.latencyPenalty.push({
                                        threshold: 1e8,
                                        penalty: .1 * n
                                    }), a1.weights.playbackSpeedPenalty = r || 200, a1;
                                }
                                function u(e, t, n, r, i) {
                                    i.bitrateWSum += i.weights.bitrateReward * e, i.lastBitrate && (i.bitrateSwitchWSum += i.weights.bitrateSwitchPenalty * Math.abs(e - i.lastBitrate)), i.lastBitrate = e, i.rebufferWSum += i.weights.rebufferPenalty * t;
                                    for(var a1 = 0; a1 < i.weights.latencyPenalty.length; a1++){
                                        var o = i.weights.latencyPenalty[a1];
                                        if (n <= o.threshold) {
                                            i.latencyWSum += o.penalty * n;
                                            break;
                                        }
                                    }
                                    i.playbackSpeedWSum += i.weights.playbackSpeedPenalty * Math.abs(1 - r), i.totalQoe = i.bitrateWSum - i.bitrateSwitchWSum - i.rebufferWSum - i.latencyWSum - i.playbackSpeedWSum;
                                }
                                return e = {
                                    setupPerSegmentQoe: function(e, i, o) {
                                        t = s1("segment", e, i, o), n = e, r = i, a1 = o;
                                    },
                                    logSegmentMetrics: function(e, n, r, i) {
                                        t && u(e, n, r, i, t);
                                    },
                                    getPerSegmentQoe: function() {
                                        return t;
                                    },
                                    calculateSingleUseQoe: function(e, t, i, o) {
                                        var l = null;
                                        return n && r && a1 && (l = s1("segment", n, r, a1)), l ? (u(e, t, i, o, l), l.totalQoe) : 0;
                                    },
                                    reset: function() {
                                        o();
                                    }
                                }, o(), e;
                            }
                            a1.__dashjs_factory_name = "LoLpQoeEvaluator", t.default = r.default.getClassFactory(a1);
                        },
                        "./src/streaming/rules/abr/lolp/LoLpRule.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/Debug.js"), i = n("./src/core/FactoryMaker.js"), a1 = n("./src/streaming/rules/abr/lolp/LearningAbrController.js"), o = n("./src/streaming/rules/abr/lolp/LoLpQoEEvaluator.js"), s1 = n("./src/streaming/rules/SwitchRequest.js"), u = n("./src/streaming/constants/MetricsConstants.js"), l = n("./src/streaming/rules/abr/lolp/LoLpWeightSelector.js"), c = n("./src/streaming/constants/Constants.js");
                            function d(e) {
                                var t, n, i, d, f = (e = e || {}).dashMetrics, h = this.context;
                                return n = {
                                    getMaxIndex: function(e) {
                                        try {
                                            var n = Object(s1.default)(h).create(), r = e.getMediaInfo().type, a1 = e.getAbrController(), o = e.getStreamInfo(), g = a1.getQualityFor(r, o.id), p = e.getMediaInfo(), m = f.getCurrentBufferState(r), v = e.getScheduleController(), y = f.getCurrentBufferLevel(r, !0), E = o && o.manifestInfo ? o.manifestInfo.isDynamic : null, T = v.getPlaybackController(), b = T.getCurrentLiveLatency();
                                            if (!e.useLoLPABR() || r === c.default.AUDIO) return n;
                                            b || (b = 0);
                                            var A = T.getPlaybackRate(), _ = a1.getThroughputHistory().getSafeAverageThroughput(r, E);
                                            if (t.debug("Throughput ".concat(Math.round(_), " kbps")), isNaN(_) || !m) return n;
                                            if (a1.getAbandonmentStateFor(o.id, r) === u.default.ABANDON_LOAD) return n;
                                            for(var S = p.bitrateList, w = e.getRepresentationInfo().fragmentDuration, I = S[0].bandwidth / 1e3, R = S[S.length - 1].bandwidth / 1e3, C = 0; C < S.length; C++){
                                                var D = S[C].bandwidth / 1e3;
                                                D > R ? R = D : D < I && (I = D);
                                            }
                                            var k = S[g].bandwidth / 1e3, N = f.getCurrentHttpRequest(r, !0), L = (N.tresponse.getTime() - N.trequest.getTime()) / 1e3, x = L > w ? L - w : 0;
                                            d.setupPerSegmentQoe(w, R, I), d.logSegmentMetrics(k, x, b, A);
                                            var M = Object(l.default)(h).create({
                                                targetLatency: 1.5,
                                                bufferMin: .3,
                                                segmentDuration: w,
                                                qoeEvaluator: d
                                            });
                                            return n.quality = i.getNextQuality(p, 1e3 * _, b, y, A, g, M), n.reason = {
                                                throughput: _,
                                                latency: b
                                            }, n.priority = s1.default.PRIORITY.STRONG, v.setTimeToLoadDelay(0), n.quality !== g && console.log("[TgcLearningRule][" + r + "] requesting switch to index: ", n.quality, "Average throughput", Math.round(_), "kbps"), n;
                                        } catch (e) {
                                            throw e;
                                        }
                                    },
                                    reset: function() {
                                        i.reset(), d.reset();
                                    }
                                }, t = Object(r.default)(h).getInstance().getLogger(n), i = Object(a1.default)(h).create(), d = Object(o.default)(h).create(), n;
                            }
                            d.__dashjs_factory_name = "LoLPRule", t.default = i.default.getClassFactory(d);
                        },
                        "./src/streaming/rules/abr/lolp/LoLpWeightSelector.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js");
                            function i(e) {
                                var t, n, r, i, a1, o, s1 = e.targetLatency, u = e.bufferMin, l = e.segmentDuration, c = e.qoeEvaluator;
                                function d() {
                                    return l;
                                }
                                function f(e, t) {
                                    var n = d();
                                    return t > n ? e - n : e + n - t;
                                }
                                return t = {
                                    getMinBuffer: function() {
                                        return u;
                                    },
                                    getSegmentDuration: d,
                                    getNextBufferWithBitrate: function(e, t, n) {
                                        return f(t, e * l / n);
                                    },
                                    getNextBuffer: f,
                                    findWeightVector: function(e, t, i, a1, o, d) {
                                        var h = null, g = null, p = null, m = Math.abs(t - r);
                                        return e.forEach(function(e) {
                                            n.forEach(function(n) {
                                                n[0];
                                                var r = n[1], a1 = n[2], v = (n[3], e.bitrate * l / o), y = f(i, v), E = (0 === a1 ? 10 : 1 / a1) * Math.max(1e-5, v - y), T = (0 === r ? 10 : 1 / r) * e.state.latency, b = c.calculateSingleUseQoe(e.bitrate, E, T, d);
                                                (null === h || b > h) && function(e, t, n) {
                                                    return !(e > s1 + n) && t >= u;
                                                }(t, y, m) && (h = b, g = n, p = e.bitrate);
                                            });
                                        }), null === g && null === p && (g = -1), r = t, g;
                                    }
                                }, a1 = (i = [
                                    .2,
                                    .4,
                                    .6,
                                    .8,
                                    1
                                ]).map(function(e) {
                                    return [
                                        e
                                    ];
                                }), o = function e(t, n, r) {
                                    if (r === n) return t;
                                    for(var a1 = t.length, o = 0; o < a1; o++)for(var s1 = t.shift(), u = 0; u < i.length; u++)t.push(s1.concat(i[u]));
                                    return e(t, n, r + 1);
                                }, n = o(a1, 4, 1), r = 0, t;
                            }
                            i.__dashjs_factory_name = "LoLpWeightSelector", t.default = r.default.getClassFactory(i);
                        },
                        "./src/streaming/rules/abr/lolp/QoeInfo.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.type = null, this.lastBitrate = null, this.weights = {}, this.weights.bitrateReward = null, this.weights.bitrateSwitchPenalty = null, this.weights.rebufferPenalty = null, this.weights.latencyPenalty = null, this.weights.playbackSpeedPenalty = null, this.bitrateWSum = 0, this.bitrateSwitchWSum = 0, this.rebufferWSum = 0, this.latencyWSum = 0, this.playbackSpeedWSum = 0, this.totalQoe = 0;
                            };
                        },
                        "./src/streaming/text/EmbeddedTextHtmlRender.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js");
                            function i() {
                                var e = 0;
                                function t(e) {
                                    for(var t = "", n = 0; n < e.length; ++n)t += e[n].uchar;
                                    return t.length - t.replace(/^\s+/, "").length;
                                }
                                function n(e) {
                                    return "left: " + 3.125 * e.x + "%; top: " + 6.66 * e.y1 + "%; width: " + (100 - 3.125 * e.x) + "%; height: " + 6.66 * Math.max(e.y2 - 1 - e.y1, 1) + "%; align-items: flex-start; overflow: visible; -webkit-writing-mode: horizontal-tb;";
                                }
                                function r(e) {
                                    return "red" === e ? "rgb(255, 0, 0)" : "green" === e ? "rgb(0, 255, 0)" : "blue" === e ? "rgb(0, 0, 255)" : "cyan" === e ? "rgb(0, 255, 255)" : "magenta" === e ? "rgb(255, 0, 255)" : "yellow" === e ? "rgb(255, 255, 0)" : "white" === e ? "rgb(255, 255, 255)" : "black" === e ? "rgb(0, 0, 0)" : e;
                                }
                                function i(e, t) {
                                    var n = e.videoHeight / 15;
                                    return t ? "font-size: " + n + "px; font-family: Menlo, Consolas, 'Cutive Mono', monospace; color: " + (t.foreground ? r(t.foreground) : "rgb(255, 255, 255)") + "; font-style: " + (t.italics ? "italic" : "normal") + "; text-decoration: " + (t.underline ? "underline" : "none") + "; white-space: pre; background-color: " + (t.background ? r(t.background) : "transparent") + ";" : "font-size: " + n + "px; font-family: Menlo, Consolas, 'Cutive Mono', monospace; justify-content: flex-start; text-align: left; color: rgb(255, 255, 255); font-style: normal; white-space: pre; line-height: normal; font-weight: normal; text-decoration: none; width: 100%; display: flex;";
                                }
                                function a1(e) {
                                    return e.replace(/^\s+/g, "");
                                }
                                function o(e) {
                                    return e.replace(/\s+$/g, "");
                                }
                                return {
                                    createHTMLCaptionsFromScreen: function(r, s1, u, l) {
                                        var c, d, f = null, h = !1, g = -1, p = {
                                            start: s1,
                                            end: u,
                                            spans: []
                                        }, m = "style_cea608_white_black", v = {}, y = {}, E = [];
                                        for(c = 0; c < 15; ++c){
                                            var T = l.rows[c], b = "", A = null;
                                            if (!1 === T.isEmpty()) {
                                                var _ = t(T.chars);
                                                null === f && (f = {
                                                    x: _,
                                                    y1: c,
                                                    y2: c + 1,
                                                    p: []
                                                }), _ !== g && h && (f.p.push(p), p = {
                                                    start: s1,
                                                    end: u,
                                                    spans: []
                                                }, f.y2 = c, f.name = "region_" + f.x + "_" + f.y1 + "_" + f.y2, !1 === v.hasOwnProperty(f.name) ? (E.push(f), v[f.name] = f) : v[f.name].p.contat(f.p), f = {
                                                    x: _,
                                                    y1: c,
                                                    y2: c + 1,
                                                    p: []
                                                });
                                                for(var S = 0; S < T.chars.length; ++S){
                                                    var w = T.chars[S], I = w.penState;
                                                    if (null === A || !I.equals(A)) {
                                                        b.trim().length > 0 && (p.spans.push({
                                                            name: m,
                                                            line: b,
                                                            row: c
                                                        }), b = "");
                                                        var R = "style_cea608_" + I.foreground + "_" + I.background;
                                                        I.underline && (R += "_underline"), I.italics && (R += "_italics"), y.hasOwnProperty(R) || (y[R] = JSON.parse(JSON.stringify(I))), A = I, m = R;
                                                    }
                                                    b += w.uchar;
                                                }
                                                b.trim().length > 0 && p.spans.push({
                                                    name: m,
                                                    line: b,
                                                    row: c
                                                }), h = !0, g = _;
                                            } else h = !1, g = -1, f && (f.p.push(p), p = {
                                                start: s1,
                                                end: u,
                                                spans: []
                                            }, f.y2 = c, f.name = "region_" + f.x + "_" + f.y1 + "_" + f.y2, !1 === v.hasOwnProperty(f.name) ? (E.push(f), v[f.name] = f) : v[f.name].p.contat(f.p), f = null);
                                        }
                                        f && (f.p.push(p), f.y2 = c + 1, f.name = "region_" + f.x + "_" + f.y1 + "_" + f.y2, !1 === v.hasOwnProperty(f.name) ? (E.push(f), v[f.name] = f) : v[f.name].p.contat(f.p), f = null);
                                        var C = [];
                                        for(c = 0; c < E.length; ++c){
                                            var D = E[c], k = "sub_cea608_" + e++, N = document.createElement("div");
                                            N.id = k;
                                            var L = n(D);
                                            N.style.cssText = "position: absolute; margin: 0; display: flex; box-sizing: border-box; pointer-events: none;" + L;
                                            var x = document.createElement("div");
                                            x.className = "paragraph bodyStyle", x.style.cssText = i(r);
                                            var M = document.createElement("div");
                                            M.className = "cueUniWrapper", M.style.cssText = "unicode-bidi: normal; direction: ltr;";
                                            for(var O = 0; O < D.p.length; ++O){
                                                var P = D.p[O], F = 0;
                                                for(d = 0; d < P.spans.length; ++d){
                                                    var U = P.spans[d];
                                                    if (U.line.length > 0) {
                                                        if (0 !== d && F != U.row) {
                                                            var j = document.createElement("br");
                                                            j.className = "lineBreak", M.appendChild(j);
                                                        }
                                                        var B = !1;
                                                        F === U.row && (B = !0), F = U.row;
                                                        var G = y[U.name], H = document.createElement("span");
                                                        H.className = "spanPadding " + U.name + " customSpanColor", H.style.cssText = i(r, G), 0 !== d && B ? d === P.spans.length - 1 ? H.textContent = o(U.line) : H.textContent = U.line : P.spans.length > 1 && d < P.spans.length - 1 && U.row === P.spans[d + 1].row ? H.textContent = a1(U.line) : H.textContent = U.line.trim(), M.appendChild(H);
                                                    }
                                                }
                                            }
                                            x.appendChild(M), N.appendChild(x);
                                            var V = {
                                                bodyStyle: [
                                                    "%",
                                                    90
                                                ]
                                            };
                                            for(var K in y)y.hasOwnProperty(K) && (V[K] = [
                                                "%",
                                                90
                                            ]);
                                            C.push({
                                                type: "html",
                                                start: s1,
                                                end: u,
                                                cueHTMLElement: N,
                                                cueID: k,
                                                cellResolution: [
                                                    32,
                                                    15
                                                ],
                                                isFromCEA608: !0,
                                                fontSize: V,
                                                lineHeight: {},
                                                linePadding: {}
                                            });
                                        }
                                        return C;
                                    }
                                };
                            }
                            i.__dashjs_factory_name = "EmbeddedTextHtmlRender", t.default = r.default.getSingletonFactory(i);
                        },
                        "./src/streaming/text/NotFragmentedTextBufferController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/EventBus.js"), i = n("./src/core/events/Events.js"), a1 = n("./src/core/FactoryMaker.js"), o = n("./src/streaming/utils/InitCache.js"), s1 = n("./src/streaming/SourceBufferSink.js"), u = n("./src/streaming/vo/DashJSError.js"), l = n("./src/core/errors/Errors.js"), c = "NotFragmentedTextBufferController";
                            function d(e) {
                                e = e || {};
                                var t, n, a1, d, f, h, g = this.context, p = Object(r.default)(g).getInstance(), m = e.textController, v = e.errHandler, y = e.streamInfo, E = e.type;
                                function T(e) {
                                    d = e;
                                }
                                function b(e) {
                                    var t, r;
                                    n !== e && (n = e) && (t = i.default.BUFFERING_COMPLETED, r = {}, p.trigger(t, r, {
                                        streamId: y.id,
                                        mediaType: E
                                    }));
                                }
                                function A(e) {
                                    e.chunk.bytes && !n && (h.save(e.chunk), f.append(e.chunk), b(!0));
                                }
                                return t = {
                                    initialize: function(e) {
                                        T(e);
                                    },
                                    getStreamId: function() {
                                        return y.id;
                                    },
                                    getType: function() {
                                        return E;
                                    },
                                    getBufferControllerType: function() {
                                        return c;
                                    },
                                    createBufferSink: function(e) {
                                        return new Promise(function(t, n) {
                                            try {
                                                (f = Object(s1.default)(g).create({
                                                    mediaSource: d,
                                                    textController: m,
                                                    eventBus: p
                                                })).initializeForFirstUse(y, e), a1 || (f.getBuffer() && "function" == typeof f.getBuffer().initialize && f.getBuffer().initialize(), a1 = !0), t(f);
                                            } catch (e) {
                                                v.error(new u.default(l.default.MEDIASOURCE_TYPE_UNSUPPORTED_CODE, l.default.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + E)), n(e);
                                            }
                                        });
                                    },
                                    getBuffer: function() {
                                        return f;
                                    },
                                    getBufferLevel: function() {
                                        return 0;
                                    },
                                    getRangeAt: function() {
                                        return null;
                                    },
                                    getAllRangesWithSafetyFactor: function() {
                                        return [];
                                    },
                                    getContinuousBufferTimeForTargetTime: function() {
                                        return Number.POSITIVE_INFINITY;
                                    },
                                    setMediaSource: T,
                                    getMediaSource: function() {
                                        return d;
                                    },
                                    appendInitSegmentFromCache: function(e) {
                                        return null !== h.extract(y.id, e);
                                    },
                                    getIsBufferingCompleted: function() {
                                        return n;
                                    },
                                    setIsBufferingCompleted: b,
                                    getIsPruningInProgress: function() {
                                        return !1;
                                    },
                                    reset: function(e) {
                                        p.off(i.default.INIT_FRAGMENT_LOADED, A, t), !e && f && (f.abort(), f.reset(), f = null);
                                    },
                                    clearBuffers: function() {
                                        return Promise.resolve();
                                    },
                                    prepareForPlaybackSeek: function() {
                                        return Promise.resolve();
                                    },
                                    prepareForReplacementTrackSwitch: function() {
                                        return n = !1, Promise.resolve();
                                    },
                                    setSeekTarget: function() {},
                                    updateAppendWindow: function() {
                                        return Promise.resolve();
                                    },
                                    pruneAllSafely: function() {
                                        return Promise.resolve();
                                    },
                                    updateBufferTimestampOffset: function() {
                                        return Promise.resolve();
                                    },
                                    segmentRequestingCompleted: function() {}
                                }, a1 = !1, d = null, n = !1, h = Object(o.default)(g).getInstance(), p.on(i.default.INIT_FRAGMENT_LOADED, A, t), t;
                            }
                            d.__dashjs_factory_name = c, t.default = a1.default.getClassFactory(d);
                        },
                        "./src/streaming/text/TextController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/Constants.js"), i = n("./src/core/FactoryMaker.js"), a1 = n("./src/streaming/text/TextSourceBuffer.js"), o = n("./src/streaming/text/TextTracks.js"), s1 = n("./src/streaming/utils/VTTParser.js"), u = n("./src/streaming/utils/TTMLParser.js"), l = n("./src/core/EventBus.js"), c = n("./src/core/events/Events.js"), d = n("./src/streaming/MediaPlayerEvents.js"), f = n("./src/streaming/utils/SupervisorTools.js");
                            function h(e) {
                                var t, n, i, h, g, p, m, v, y, E, T, b = this.context, A = e.adapter, _ = e.errHandler, S = e.manifestModel, w = e.mediaController, I = e.videoModel, R = e.settings;
                                function C(e) {
                                    var t = e.tracks, i = e.index, a1 = e.streamId;
                                    if (!1 === R.get().streaming.text.defaultEnabled && !D() || T) k(a1, -1);
                                    else {
                                        var o = w.getCurrentTrackFor(r.default.TEXT, a1);
                                        if (o) {
                                            var s1 = {
                                                lang: o.lang,
                                                role: o.roles[0],
                                                index: o.index,
                                                codec: o.codec,
                                                accessibility: o.accessibility[0]
                                            };
                                            t.some(function(e, t) {
                                                if (w.matchSettings(s1, e)) return k(a1, t), i = t, !0;
                                            });
                                        }
                                        v = !1;
                                    }
                                    n[a1].lastEnabledIndex = i, m.trigger(d.default.TEXT_TRACKS_ADDED, {
                                        enabled: D(),
                                        index: i,
                                        tracks: t,
                                        streamId: a1
                                    }), E = !0;
                                }
                                function D() {
                                    var e = !0;
                                    return v && !y && (e = !1), e;
                                }
                                function k(e, t) {
                                    (v = -1 === t) && w && w.saveTextSettingsDisabled();
                                    var n = N(e);
                                    if (n !== t && h[e]) {
                                        h[e].setModeForTrackIdx(n, r.default.TEXT_HIDDEN), h[e].setCurrentTrackIdx(t), h[e].setModeForTrackIdx(t, r.default.TEXT_SHOWING);
                                        var a1 = h[e].getCurrentTrackInfo();
                                        a1 && a1.isFragmented && !a1.isEmbedded ? function(e, t, n) {
                                            if (i[e]) for(var a1 = i[e].getConfig().fragmentedTracks, o = 0; o < a1.length; o++){
                                                var s1 = a1[o];
                                                if (t.lang === s1.lang && (s1.id ? t.id === s1.id : t.index === s1.index)) {
                                                    var u = w.getCurrentTrackFor(r.default.TEXT, e);
                                                    (s1.id ? u.id !== s1.id : u.index !== s1.index) ? (h[e].deleteCuesFromTrackIdx(n), i[e].setCurrentFragmentedTrackIdx(o)) : -1 === n && m.trigger(c.default.SET_FRAGMENTED_TEXT_AFTER_DISABLED, {}, {
                                                        streamId: e,
                                                        mediaType: r.default.TEXT
                                                    });
                                                }
                                            }
                                        }(e, a1, n) : a1 && !a1.isFragmented && function(e, t) {
                                            m.trigger(c.default.SET_NON_FRAGMENTED_TEXT, {
                                                currentTrackInfo: t
                                            }, {
                                                streamId: e,
                                                mediaType: r.default.TEXT
                                            });
                                        }(e, a1), w.setTrack(a1);
                                    }
                                }
                                function N(e) {
                                    return h[e].getCurrentTrackIdx();
                                }
                                function L() {
                                    i = {}, h = {}, n = {}, v = !0, E = !1, T = !1;
                                }
                                return t = {
                                    deactivateStream: function(e) {
                                        if (e) {
                                            var t = e.id;
                                            i[t] && i[t].resetMediaInfos(), h[t] && h[t].deleteAllTextTracks();
                                        }
                                    },
                                    initialize: function() {
                                        m.on(c.default.TEXT_TRACKS_QUEUE_INITIALIZED, C, t);
                                    },
                                    initializeForStream: function(e) {
                                        var t = e.id, r = Object(o.default)(b).create({
                                            videoModel: I,
                                            streamInfo: e
                                        });
                                        r.initialize(), h[t] = r;
                                        var s1 = Object(a1.default)(b).create({
                                            errHandler: _,
                                            adapter: A,
                                            manifestModel: S,
                                            mediaController: w,
                                            videoModel: I,
                                            textTracks: r,
                                            vttParser: g,
                                            ttmlParser: p,
                                            streamInfo: e
                                        });
                                        s1.initialize(), i[t] = s1, n[t] = {}, n[t].lastEnabledIndex = -1;
                                    },
                                    createTracks: function(e) {
                                        var t = e.id;
                                        h[t] && h[t].createTracks();
                                    },
                                    getTextSourceBuffer: function(e) {
                                        var t = e.id;
                                        if (i && i[t]) return i[t];
                                    },
                                    getAllTracksAreDisabled: function() {
                                        return v;
                                    },
                                    addEmbeddedTrack: function(e, t) {
                                        var n = e.id;
                                        i[n] && i[n].addEmbeddedTrack(t);
                                    },
                                    enableText: function(e, t) {
                                        Object(f.checkParameterType)(t, "boolean"), D() !== t && (t && k(e, n[e].lastEnabledIndex), t || (n[e].lastEnabledIndex = N(e), E ? k(e, -1) : T = !0));
                                    },
                                    isTextEnabled: D,
                                    setTextTrack: k,
                                    getCurrentTrackIdx: N,
                                    enableForcedTextStreaming: function(e) {
                                        Object(f.checkParameterType)(e, "boolean"), y = e;
                                    },
                                    addMediaInfosToBuffer: function(e, t, n) {
                                        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, a1 = e.id;
                                        i[a1] && i[a1].addMediaInfos(t, n, r);
                                    },
                                    reset: function() {
                                        L(), m.off(c.default.TEXT_TRACKS_QUEUE_INITIALIZED, C, t), Object.keys(i).forEach(function(e) {
                                            i[e].resetEmbedded(), i[e].reset();
                                        });
                                    }
                                }, y = !1, E = !1, T = !1, g = Object(s1.default)(b).getInstance(), p = Object(u.default)(b).getInstance(), m = Object(l.default)(b).getInstance(), L(), t;
                            }
                            h.__dashjs_factory_name = "TextController", t.default = i.default.getClassFactory(h);
                        },
                        "./src/streaming/text/TextSourceBuffer.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/Constants.js"), i = n("./src/streaming/vo/metrics/HTTPRequest.js"), a1 = n("./src/streaming/vo/TextTrackInfo.js"), o = n("./src/streaming/utils/BoxParser.js"), s1 = n("./src/streaming/utils/CustomTimeRanges.js"), u = n("./src/core/FactoryMaker.js"), l = n("./src/core/Debug.js"), c = n("./src/streaming/text/EmbeddedTextHtmlRender.js"), d = n("./node_modules/codem-isoboxer/dist/iso_boxer.js"), f = n.n(d), h = n("./externals/cea608-parser.js"), g = n.n(h), p = n("./src/core/EventBus.js"), m = n("./src/core/events/Events.js"), v = n("./src/streaming/vo/DashJSError.js"), y = n("./src/core/errors/Errors.js");
                            function E(e) {
                                var t, n, u, d, h, E, T, b, A, _, S, w, I, R, C, D, k = e.errHandler, N = e.manifestModel, L = e.mediaController, x = e.videoModel, M = e.textTracks, O = e.vttParser, P = e.ttmlParser, F = e.streamInfo, U = this.context, j = Object(p.default)(U).getInstance(), B = !1;
                                function G() {
                                    E = null, b = NaN, A = [], _ = null, T = !1, h = [], d = null;
                                }
                                function H(e) {
                                    var t = new a1.default;
                                    for(var n in e)t[n] = e[n];
                                    t.labels = e.labels, t.defaultTrack = function(e) {
                                        var t = !1;
                                        return w.length > 1 && e.isEmbedded ? t = e.id && e.id === r.default.CC1 : 1 === w.length ? e.id && "string" == typeof e.id && "CC" === e.id.substring(0, 2) && (t = !0) : 0 === w.length && (t = e.index === h[0].index), t;
                                    }(e), t.isFragmented = e.isFragmented, t.isEmbedded = !!e.isEmbedded, t.isTTML = function(e) {
                                        return e.codec && e.codec.search(r.default.STPP) >= 0 || e.mimeType && e.mimeType.search(r.default.TTML) >= 0;
                                    }(e), t.kind = function(e, t) {
                                        var n = e.roles && e.roles.length > 0 ? t[e.roles[0]] : t.caption;
                                        return n === t.caption || n === t.subtitle ? n : t.caption;
                                    }(e, {
                                        subtitle: "subtitles",
                                        caption: "captions"
                                    }), M.addTextTrack(t);
                                }
                                function V(e) {
                                    var t = e.chunk;
                                    t.mediaInfo.embeddedCaptions && q(t.bytes, t);
                                }
                                function K(e) {
                                    S = e;
                                }
                                function q(e, a1) {
                                    var o = a1.mediaInfo, s1 = o.type, l = o.mimeType, c = o.codec || l;
                                    c ? -1 !== o.codec.indexOf("application/mp4") ? function(e, i, a1) {
                                        var o;
                                        if ("InitializationSegment" === i.segmentType) T = !0, b = u.getMediaTimescaleFromMoov(e);
                                        else {
                                            if (!T) return;
                                            (o = u.getSamplesInfo(e).sampleList).length > 0 && (_ = o[0].cts - i.start * b), a1.search(r.default.STPP) >= 0 ? function(e, i, a1) {
                                                var o, s1;
                                                for(d = null !== d ? d : z(a1), o = 0; o < i.length; o++){
                                                    var u = i[o], l = u.cts, c = W(), h = c + l / b, g = h + u.duration / b;
                                                    t.buffered.add(h, g);
                                                    var p = new DataView(e, u.offset, u.subSizes[0]), m = f.a.Utils.dataViewToString(p, r.default.UTF8), v = [], y = u.offset + u.subSizes[0];
                                                    for(s1 = 1; s1 < u.subSizes.length; s1++){
                                                        var T = new Uint8Array(e, y, u.subSizes[s1]), A = String.fromCharCode.apply(null, T);
                                                        v.push(A), y += u.subSizes[s1];
                                                    }
                                                    try {
                                                        var _ = N.getValue().ttmlTimeIsRelative ? l / b : 0, w = d.parse(m, _, l / b, (l + u.duration) / b, v);
                                                        M.addCaptions(S, c, w);
                                                    } catch (e) {
                                                        E.removeExecutedRequestsBeforeTime(), this.remove(), n.error("TTML parser error: " + e.message);
                                                    }
                                                }
                                            }(e, o, a1) : function(e, r) {
                                                var i, a1, o, s1 = [];
                                                for(i = 0; i < r.length; i++){
                                                    var u = r[i];
                                                    u.cts -= _;
                                                    var l = W() + u.cts / b, c = l + u.duration / b;
                                                    t.buffered.add(l, c);
                                                    var d = e.slice(u.offset, u.offset + u.size), h = f.a.parseBuffer(d);
                                                    for(a1 = 0; a1 < h.boxes.length; a1++){
                                                        var g = h.boxes[a1];
                                                        if (n.debug("VTT box1: " + g.type), "vtte" !== g.type && "vttc" === g.type) for(n.debug("VTT vttc boxes.length = " + g.boxes.length), o = 0; o < g.boxes.length; o++){
                                                            var p = g.boxes[o];
                                                            if (n.debug("VTT box2: " + p.type), "payl" === p.type) {
                                                                var m = p.cue_text;
                                                                n.debug("VTT cue_text = " + m);
                                                                var v = u.cts / b, y = (u.cts + u.duration) / b;
                                                                s1.push({
                                                                    start: v,
                                                                    end: y,
                                                                    data: m,
                                                                    styles: {}
                                                                }), n.debug("VTT " + v + "-" + y + " : " + m);
                                                            }
                                                        }
                                                    }
                                                }
                                                s1.length > 0 && M.addCaptions(S, 0, s1);
                                            }(e, o);
                                        }
                                    }(e, a1, c) : s1 === r.default.VIDEO ? function(e, t) {
                                        var r, a1;
                                        if (t.segmentType === i.HTTPRequest.INIT_SEGMENT_TYPE) 0 === I && (I = u.getMediaTimescaleFromMoov(e));
                                        else if (t.segmentType === i.HTTPRequest.MEDIA_SEGMENT_TYPE) {
                                            if (0 === I) return void n.warn("CEA-608: No timescale for embeddedTextTrack yet");
                                            var o = (a1 = u.getSamplesInfo(e)).lastSequenceNumber;
                                            if (C[0] || C[1] || function() {
                                                for(var e, t = 0; t < w.length; t++){
                                                    if (-1 === (e = M.getTrackIdxForId(w[t].id))) return void n.warn("CEA-608: data before track is ready.");
                                                    var r = Y(e);
                                                    C[t] = new g.a.Cea608Parser(t + 1, {
                                                        newCue: r
                                                    }, null);
                                                }
                                            }(), I) {
                                                if (null !== R && o !== R + a1.numSequences) for(r = 0; r < C.length; r++)C[r] && C[r].reset();
                                                for(var s1 = function(e, t) {
                                                    if (0 === t.length) return null;
                                                    for(var n = {
                                                        splits: [],
                                                        fields: [
                                                            [],
                                                            []
                                                        ]
                                                    }, r = new DataView(e), i = 0; i < t.length; i++)for(var a1 = t[i], o = g.a.findCea608Nalus(r, a1.offset, a1.size), s1 = null, u = 0, l = 0; l < o.length; l++)for(var c = g.a.extractCea608DataFromRange(r, o[l]), d = 0; d < 2; d++)if (c[d].length > 0) {
                                                        a1.cts !== s1 ? u = 0 : u += 1;
                                                        var f = W();
                                                        n.fields[d].push([
                                                            a1.cts + f * I,
                                                            c[d],
                                                            u
                                                        ]), s1 = a1.cts;
                                                    }
                                                    return n.fields.forEach(function(e) {
                                                        e.sort(function(e, t) {
                                                            return e[0] === t[0] ? e[2] - t[2] : e[0] - t[0];
                                                        });
                                                    }), n;
                                                }(e, a1.sampleList), l = 0; l < C.length; l++){
                                                    var c = s1.fields[l], d = C[l];
                                                    if (d) for(r = 0; r < c.length; r++)d.addData(c[r][0] / I, c[r][1]);
                                                }
                                                R = o;
                                            }
                                        }
                                    }(e, a1) : function(e, n, i) {
                                        var a1, o, s1 = new DataView(e, 0, e.byteLength);
                                        o = f.a.Utils.dataViewToString(s1, r.default.UTF8);
                                        try {
                                            a1 = z(i).parse(o, 0), M.addCaptions(M.getCurrentTrackIdx(), 0, a1), t.buffered && t.buffered.add(n.start, n.end);
                                        } catch (e) {
                                            k.error(new v.default(y.default.TIMED_TEXT_ERROR_ID_PARSE_CODE, y.default.TIMED_TEXT_ERROR_MESSAGE_PARSE + e.message, o));
                                        }
                                    }(e, a1, c) : n.error("No text type defined");
                                }
                                function Y(e) {
                                    return function(t, n, r) {
                                        var i;
                                        (i = x.getTTMLRenderingDiv() ? D.createHTMLCaptionsFromScreen(x.getElement(), t, n, r) : [
                                            {
                                                start: t,
                                                end: n,
                                                data: r.getDisplayText(),
                                                styles: {}
                                            }
                                        ]) && M.addCaptions(e, 0, i);
                                    };
                                }
                                function W() {
                                    return isNaN(t.timestampOffset) ? 0 : t.timestampOffset;
                                }
                                function z(e) {
                                    var t;
                                    return e.search(r.default.VTT) >= 0 ? t = O : (e.search(r.default.TTML) >= 0 || e.search(r.default.STPP) >= 0) && (t = P), t;
                                }
                                function X(e) {
                                    w.forEach(function(t) {
                                        var n = M.getTrackIdxForId(t.id);
                                        n >= 0 && M.deleteCuesFromTrackIdx(n, e.from, e.to);
                                    });
                                }
                                return t = {
                                    initialize: function() {
                                        B || (w = [], S = null, I = 0, C = [], R = null, B = !0, D = Object(c.default)(U).getInstance(), j.on(m.default.VIDEO_CHUNK_RECEIVED, V, t), j.on(m.default.BUFFER_CLEARED, X, t));
                                    },
                                    addMediaInfos: function(e, n, i) {
                                        if (h = h.concat(n), e === r.default.TEXT && n[0].isFragmented && !n[0].isEmbedded) {
                                            E = i, t.buffered = Object(s1.default)(U).create(), A = L.getTracksFor(r.default.TEXT, F.id).filter(function(e) {
                                                return e.isFragmented;
                                            });
                                            for(var a1 = L.getCurrentTrackFor(r.default.TEXT, F.id), o = 0; o < A.length; o++)if (A[o] === a1) {
                                                K(o);
                                                break;
                                            }
                                        }
                                        for(var u = 0; u < n.length; u++)H(n[u]);
                                    },
                                    resetMediaInfos: function() {
                                        h = [];
                                    },
                                    getStreamId: function() {
                                        return F.id;
                                    },
                                    append: q,
                                    abort: function() {},
                                    addEmbeddedTrack: function(e) {
                                        if (B && e) {
                                            if (e.id === r.default.CC1 || e.id === r.default.CC3) {
                                                for(var t = 0; t < w.length; t++)if (w[t].id === e.id) return;
                                                w.push(e);
                                            } else n.warn("Embedded track " + e.id + " not supported!");
                                        }
                                    },
                                    resetEmbedded: function() {
                                        j.off(m.default.VIDEO_CHUNK_RECEIVED, V, t), j.off(m.default.BUFFER_CLEARED, X, t), M && M.deleteAllTextTracks(), B = !1, w = [], C = [
                                            null,
                                            null
                                        ], R = null;
                                    },
                                    getConfig: function() {
                                        return {
                                            fragmentModel: E,
                                            fragmentedTracks: A,
                                            videoModel: x
                                        };
                                    },
                                    setCurrentFragmentedTrackIdx: K,
                                    remove: function(e, n) {
                                        void 0 === e && e === n && (e = t.buffered.start(0), n = t.buffered.end(t.buffered.length - 1)), t.buffered.remove(e, n), M.deleteCuesFromTrackIdx(S, e, n);
                                    },
                                    reset: function() {
                                        G(), h = [], u = null;
                                    }
                                }, n = Object(l.default)(U).getInstance().getLogger(t), u = Object(o.default)(U).getInstance(), G(), t;
                            }
                            E.__dashjs_factory_name = "TextSourceBuffer", t.default = u.default.getClassFactory(E);
                        },
                        "./src/streaming/text/TextTracks.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/Constants.js"), i = n("./src/core/EventBus.js"), a1 = n("./src/core/events/Events.js"), o = n("./src/streaming/MediaPlayerEvents.js"), s1 = n("./src/core/FactoryMaker.js"), u = n("./src/core/Debug.js"), l = n("./node_modules/imsc/src/main/js/main.js");
                            function c(e) {
                                var t, n, s1, c, d, f, h, g, p, m, v, y, E, T, b, A, _, S = this.context, w = Object(i.default)(S).getInstance(), I = e.videoModel, R = e.streamInfo;
                                function C(e, t, n, r, i, a1) {
                                    var o = 0, s1 = 0;
                                    e / t > n / r ? o = (s1 = t) / r * n : s1 = (o = e) / n * r;
                                    var u, l, c = 0, d = 0;
                                    return o / s1 > i ? (d = s1, c = s1 * i) : (c = o, d = o / i), u = (e - c) / 2, l = (t - d) / 2, a1 ? {
                                        x: u + .1 * c,
                                        y: l + .1 * d,
                                        w: .8 * c,
                                        h: .8 * d
                                    } : {
                                        x: u,
                                        y: l,
                                        w: c,
                                        h: d
                                    };
                                }
                                function D(e, t) {
                                    var n = I.getClientWidth(), r = I.getClientHeight(), i = I.getVideoWidth(), a1 = I.getVideoHeight(), s1 = I.getVideoRelativeOffsetTop(), u = I.getVideoRelativeOffsetLeft();
                                    if (0 !== i && 0 !== a1) {
                                        var l = i / a1, c = !1;
                                        e.isFromCEA608 && (l = 3.5 / 3, c = !0);
                                        var d = C.call(this, n, r, i, a1, l, c), f = d.w, y = d.h, b = d.x, _ = d.y;
                                        if (f != p || y != m || b != h || _ != g || t) {
                                            if (h = b + u, g = _ + s1, p = f, m = y, v) {
                                                var S = v.style;
                                                S && (S.left = h + "px", S.top = g + "px", S.width = p + "px", S.height = m + "px", S.zIndex = E && document[E] || T ? A : null, w.trigger(o.default.CAPTION_CONTAINER_RESIZE));
                                            }
                                            var R = e.activeCues;
                                            if (R) for(var D = R.length, k = 0; k < D; ++k){
                                                var N = R[k];
                                                N.scaleCue(N);
                                            }
                                        }
                                    }
                                }
                                function k(e) {
                                    var t, n, r, i, a1, o = p, s1 = m;
                                    if (e.cellResolution) {
                                        var u = [
                                            o / e.cellResolution[0],
                                            s1 / e.cellResolution[1]
                                        ];
                                        if (e.linePadding) {
                                            for(t in e.linePadding)if (e.linePadding.hasOwnProperty(t)) {
                                                n = (e.linePadding[t] * u[0]).toString();
                                                for(var l = document.getElementsByClassName("spanPadding"), c = 0; c < l.length; c++)l[c].style.cssText = l[c].style.cssText.replace(/(padding-left\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + n), l[c].style.cssText = l[c].style.cssText.replace(/(padding-right\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + n);
                                            }
                                        }
                                        if (e.fontSize) {
                                            for(t in e.fontSize)if (e.fontSize.hasOwnProperty(t)) {
                                                "%" === e.fontSize[t][0] ? r = e.fontSize[t][1] / 100 : "c" === e.fontSize[t][0] && (r = e.fontSize[t][1]), n = (r * u[1]).toString(), a1 = "defaultFontSize" !== t ? document.getElementsByClassName(t) : document.getElementsByClassName("paragraph");
                                                for(var d = 0; d < a1.length; d++)a1[d].style.cssText = a1[d].style.cssText.replace(/(font-size\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + n);
                                            }
                                            if (e.lineHeight) {
                                                for(t in e.lineHeight)if (e.lineHeight.hasOwnProperty(t)) {
                                                    "%" === e.lineHeight[t][0] ? i = e.lineHeight[t][1] / 100 : "c" === e.fontSize[t][0] && (i = e.lineHeight[t][1]), n = (i * u[1]).toString(), a1 = document.getElementsByClassName(t);
                                                    for(var f = 0; f < a1.length; f++)a1[f].style.cssText = a1[f].style.cssText.replace(/(line-height\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + n);
                                                }
                                            }
                                        }
                                    }
                                    if (e.isd) {
                                        var h = document.getElementById(e.cueID);
                                        h && v.removeChild(h), N(e);
                                    }
                                }
                                function N(e) {
                                    if (v) {
                                        var t = document.createElement("div");
                                        v.appendChild(t), b = Object(l.renderHTML)(e.isd, t, function(t) {
                                            var n = /^(urn:)(mpeg:[a-z0-9][a-z0-9-]{0,31}:)(subs:)([0-9]+)$/, r = /^#(.*)$/;
                                            if (n.test(t)) {
                                                var i = n.exec(t), a1 = parseInt(i[4], 10) - 1;
                                                return "data:image/png;base64," + btoa(e.images[a1]);
                                            }
                                            if (r.test(t)) {
                                                var o = r.exec(t)[1];
                                                return "data:image/png;base64," + e.embeddedImages[o];
                                            }
                                            return null;
                                        }, v.clientHeight, v.clientWidth, !1, function(e) {
                                            n.info("renderCaption :", e);
                                        }, b, !0), t.id = e.cueID, w.trigger(o.default.CAPTION_RENDERED, {
                                            captionDiv: t,
                                            currentTrackIdx: f
                                        });
                                    }
                                }
                                function L(e, t, i) {
                                    var a1 = x(e), u = this;
                                    if (a1 && Array.isArray(i) && 0 !== i.length) for(var l = 0; l < i.length; l++){
                                        var c = void 0, d = i[l];
                                        if (a1.cellResolution = d.cellResolution, a1.isFromCEA608 = d.isFromCEA608, "html" !== d.type || !v || isNaN(d.start) || isNaN(d.end)) {
                                            if (d.data && !isNaN(d.start) && !isNaN(d.end)) {
                                                if (c = new s1(d.start - t, d.end - t, d.data), d.styles) try {
                                                    void 0 !== d.styles.align && "align" in c && (c.align = d.styles.align), void 0 !== d.styles.line && "line" in c && (c.line = d.styles.line), void 0 !== d.styles.position && "position" in c && (c.position = d.styles.position), void 0 !== d.styles.size && "size" in c && (c.size = d.styles.size);
                                                } catch (e) {
                                                    n.error(e);
                                                }
                                                c.onenter = function() {
                                                    a1.mode === r.default.TEXT_SHOWING && w.trigger(o.default.CAPTION_RENDERED, {
                                                        currentTrackIdx: f
                                                    });
                                                };
                                            }
                                        } else (c = new s1(d.start + t, d.end + t, "")).cueHTMLElement = d.cueHTMLElement, c.isd = d.isd, c.images = d.images, c.embeddedImages = d.embeddedImages, c.cueID = d.cueID, c.scaleCue = k.bind(u), c.cellResolution = d.cellResolution, c.lineHeight = d.lineHeight, c.linePadding = d.linePadding, c.fontSize = d.fontSize, v.style.left = h + "px", v.style.top = g + "px", v.style.width = p + "px", v.style.height = m + "px", c.onenter = function() {
                                            a1.mode === r.default.TEXT_SHOWING && (this.isd ? (N(this), n.debug("Cue enter id:" + this.cueID)) : (v.appendChild(this.cueHTMLElement), k.call(u, this), w.trigger(o.default.CAPTION_RENDERED, {
                                                captionDiv: this.cueHTMLElement,
                                                currentTrackIdx: f
                                            })));
                                        }, c.onexit = function() {
                                            if (v) for(var e = v.childNodes, t = 0; t < e.length; ++t)e[t].id === this.cueID && (n.debug("Cue exit id:" + e[t].id), v.removeChild(e[t]), --t);
                                        };
                                        try {
                                            c ? P(a1, c) || a1.addCue(c) : n.error("impossible to display subtitles.");
                                        } catch (e) {
                                            throw U(a1), a1.addCue(c), e;
                                        }
                                    }
                                }
                                function x(e) {
                                    return e >= 0 && c[e] ? I.getTextTrack(c[e].kind, c[e].id, c[e].lang, c[e].isTTML, c[e].isEmbedded) : null;
                                }
                                function M(e) {
                                    var t = this;
                                    if (e !== f) {
                                        var n = x(f = e);
                                        O.call(this, n), y && (clearInterval(y), y = null), n && "html" === n.renderingType && (D.call(this, n, !0), window.ResizeObserver ? (_ = new window.ResizeObserver(function() {
                                            D.call(t, n, !0);
                                        })).observe(I.getElement()) : y = setInterval(D.bind(this, n), 500));
                                    }
                                }
                                function O(e) {
                                    G.call(this), e && "html" === e.renderingType ? j.call(this) : B.call(this);
                                }
                                function P(e, t) {
                                    if (!e.cues) return !1;
                                    for(var n = 0; n < e.cues.length; n++)if (e.cues[n].startTime === t.startTime && e.cues[n].endTime === t.endTime) return !0;
                                    return !1;
                                }
                                function F(e, t, n) {
                                    var r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
                                    return (isNaN(t) || (r ? e.startTime : e.endTime) >= t) && (isNaN(n) || (r ? e.endTime : e.startTime) <= n);
                                }
                                function U(e, t, n) {
                                    var r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
                                    if (e.cues) for(var i = e.cues, a1 = i.length - 1, o = a1; o >= 0; o--)F(i[o], t, n, r) && (i[o].onexit && i[o].onexit(), e.removeCue(i[o]));
                                }
                                function j() {
                                    var e = document.getElementById("native-cue-style");
                                    if (!e) {
                                        (e = document.createElement("style")).id = "native-cue-style", document.head.appendChild(e);
                                        var t = e.sheet, r = I.getElement();
                                        try {
                                            r && (r.id ? t.insertRule("#" + r.id + "::cue {background: transparent}", 0) : 0 !== r.classList.length ? t.insertRule("." + r.className + "::cue {background: transparent}", 0) : t.insertRule("video::cue {background: transparent}", 0));
                                        } catch (e) {
                                            n.info("" + e.message);
                                        }
                                    }
                                }
                                function B() {
                                    var e = document.getElementById("native-cue-style");
                                    e && document.head.removeChild(e);
                                }
                                function G() {
                                    if (v) for(; v.firstChild;)v.removeChild(v.firstChild);
                                }
                                return t = {
                                    initialize: function() {
                                        "undefined" != typeof window && "undefined" != typeof navigator && (s1 = window.VTTCue || window.TextTrackCue, c = [], d = [], f = -1, h = 0, g = 0, p = 0, m = 0, v = null, y = null, T = !1, A = 2147483647, b = null, void 0 !== document.fullscreenElement ? E = "fullscreenElement" : void 0 !== document.webkitIsFullScreen ? E = "webkitIsFullScreen" : document.msFullscreenElement ? E = "msFullscreenElement" : document.mozFullScreen && (E = "mozFullScreen"));
                                    },
                                    getStreamId: function() {
                                        return R.id;
                                    },
                                    addTextTrack: function(e) {
                                        c.push(e);
                                    },
                                    addCaptions: L,
                                    createTracks: function() {
                                        c.sort(function(e, t) {
                                            return e.index - t.index;
                                        }), v = I.getTTMLRenderingDiv();
                                        for(var e, t, n, i, s1, u, l = -1, h = 0; h < c.length; h++){
                                            var g = (t = (e = c[h]).kind, n = void 0 !== e.id ? e.id : e.lang, i = e.lang, s1 = e.isTTML, u = e.isEmbedded, I.addTextTrack(t, n, i, s1, u));
                                            d.push(g), c[h].defaultTrack && (g.default = !0, l = h);
                                            var p = x(h);
                                            p && (p.mode = r.default.TEXT_SHOWING, v && (c[h].isTTML || c[h].isEmbedded) ? p.renderingType = "html" : p.renderingType = "default"), L(h, 0, c[h].captionData), w.trigger(o.default.TEXT_TRACK_ADDED);
                                        }
                                        if (M.call(this, l), l >= 0) {
                                            w.on(o.default.PLAYBACK_METADATA_LOADED, function e() {
                                                var t = x(l);
                                                t && "html" === t.renderingType && D.call(this, t, !0), w.off(o.default.PLAYBACK_METADATA_LOADED, e, this);
                                            }, this);
                                            for(var m = 0; m < c.length; m++){
                                                var y = x(m);
                                                y && (y.mode = m === l ? r.default.TEXT_SHOWING : r.default.TEXT_HIDDEN);
                                            }
                                        }
                                        w.trigger(a1.default.TEXT_TRACKS_QUEUE_INITIALIZED, {
                                            index: f,
                                            tracks: c,
                                            streamId: R.id
                                        });
                                    },
                                    getCurrentTrackIdx: function() {
                                        return f;
                                    },
                                    setCurrentTrackIdx: M,
                                    getTrackIdxForId: function(e) {
                                        for(var t = -1, n = 0; n < c.length; n++)if (c[n].id === e) {
                                            t = n;
                                            break;
                                        }
                                        return t;
                                    },
                                    getCurrentTrackInfo: function() {
                                        return c[f];
                                    },
                                    setModeForTrackIdx: function(e, t) {
                                        var n = x(e);
                                        n && n.mode !== t && (n.mode = t);
                                    },
                                    deleteCuesFromTrackIdx: function(e, t, n) {
                                        var r = x(e);
                                        r && U(r, t, n);
                                    },
                                    deleteAllTextTracks: function() {
                                        for(var e = d ? d.length : 0, t = 0; t < e; t++){
                                            var n = x(t);
                                            n && U.call(this, n, R.start, R.start + R.duration, !1);
                                        }
                                        d = [], c = [], y && (clearInterval(y), y = null), _ && I && (_.unobserve(I.getElement()), _ = null), f = -1, G.call(this);
                                    },
                                    deleteTextTrack: function(e) {
                                        I.removeChild(d[e]), d.splice(e, 1);
                                    }
                                }, n = Object(u.default)(S).getInstance().getLogger(t), t;
                            }
                            c.__dashjs_factory_name = "TextTracks", t.default = s1.default.getClassFactory(c);
                        },
                        "./src/streaming/thumbnail/ThumbnailController.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/streaming/constants/Constants.js"), a1 = n("./src/streaming/vo/Thumbnail.js"), o = n("./src/streaming/thumbnail/ThumbnailTracks.js"), s1 = n("./src/streaming/vo/BitrateInfo.js"), u = n("./src/dash/utils/SegmentsUtils.js");
                            function l(e) {
                                var t, n, r = this.context, l = e.streamInfo;
                                function c(e) {
                                    n.setTrackByIndex(e);
                                }
                                function d() {
                                    n && n.reset();
                                }
                                return t = {
                                    getStreamId: function() {
                                        return l.id;
                                    },
                                    initialize: function() {
                                        n.addTracks();
                                        var e = n.getTracks();
                                        e && e.length > 0 && c(0);
                                    },
                                    provide: function(e, t) {
                                        if ("function" == typeof t) {
                                            var r, i, o = n.getCurrentTrack();
                                            if (!o || o.segmentDuration <= 0 || null == e) t(null);
                                            else {
                                                (i = n.getThumbnailRequestForTime(e)) && (o.segmentDuration = i.duration), r = e % o.segmentDuration;
                                                var s1 = Math.floor(r * o.tilesHor * o.tilesVert / o.segmentDuration), l = new a1.default;
                                                if (l.width = Math.floor(o.widthPerTile), l.height = Math.floor(o.heightPerTile), l.x = Math.floor(s1 % o.tilesHor) * o.widthPerTile, l.y = Math.floor(s1 / o.tilesHor) * o.heightPerTile, "readThumbnail" in o) return o.readThumbnail(e, function(e) {
                                                    l.url = e, t(l);
                                                });
                                                if (i) l.url = i.url, o.segmentDuration = NaN;
                                                else {
                                                    var c = Math.floor(e / o.segmentDuration);
                                                    l.url = function(e, t) {
                                                        var n = t + e.startNumber, r = Object(u.replaceTokenForTemplate)(e.templateUrl, "Number", n);
                                                        return r = Object(u.replaceTokenForTemplate)(r, "Time", (n - 1) * e.segmentDuration * e.timescale), r = Object(u.replaceTokenForTemplate)(r, "Bandwidth", e.bandwidth), Object(u.unescapeDollarsInTemplate)(r);
                                                    }(o, c);
                                                }
                                                t(l);
                                            }
                                        }
                                    },
                                    setTrackByIndex: c,
                                    getCurrentTrackIndex: function() {
                                        return n.getCurrentTrackIndex();
                                    },
                                    getBitrateList: function() {
                                        var e = n.getTracks(), t = 0;
                                        return e.map(function(e) {
                                            var n = new s1.default;
                                            return n.mediaType = i.default.IMAGE, n.qualityIndex = t++, n.bitrate = e.bitrate, n.width = e.width, n.height = e.height, n;
                                        });
                                    },
                                    reset: d
                                }, d(), n = Object(o.default)(r).create({
                                    streamInfo: l,
                                    adapter: e.adapter,
                                    baseURLController: e.baseURLController,
                                    timelineConverter: e.timelineConverter,
                                    debug: e.debug,
                                    eventBus: e.eventBus,
                                    events: e.events,
                                    dashConstants: e.dashConstants,
                                    dashMetrics: e.dashMetrics,
                                    segmentBaseController: e.segmentBaseController
                                }), t;
                            }
                            l.__dashjs_factory_name = "ThumbnailController", t.default = r.default.getClassFactory(l);
                        },
                        "./src/streaming/thumbnail/ThumbnailTracks.js": function(e, t, n) {
                            "use strict";
                            n.r(t), n.d(t, "THUMBNAILS_SCHEME_ID_URIS", function() {
                                return h;
                            });
                            var r = n("./src/streaming/constants/Constants.js"), i = n("./src/dash/constants/DashConstants.js"), a1 = n("./src/core/FactoryMaker.js"), o = n("./src/streaming/vo/ThumbnailTrackInfo.js"), s1 = n("./src/streaming/utils/URLUtils.js"), u = n("./src/dash/utils/SegmentsUtils.js"), l = n("./src/streaming/utils/BoxParser.js"), c = n("./src/streaming/net/XHRLoader.js"), d = n("./src/dash/DashHandler.js"), f = n("./src/dash/controllers/SegmentsController.js"), h = [
                                "http://dashif.org/thumbnail_tile",
                                "http://dashif.org/guidelines/thumbnail_tile"
                            ];
                            function g(e) {
                                var t, n, a1, g, p, m, v, y, E = this.context, T = e.adapter, b = e.baseURLController, A = e.streamInfo, _ = e.timelineConverter, S = e.debug, w = e.eventBus, I = e.events, R = e.dashConstants, C = Object(s1.default)(E).getInstance();
                                function D(e, t) {
                                    var r = new o.default;
                                    r.id = e.id, r.bitrate = e.bandwidth, r.width = e.width, r.height = e.height, r.tilesHor = 1, r.tilesVert = 1, e.essentialProperties && e.essentialProperties.forEach(function(e) {
                                        if (h.indexOf(e.schemeIdUri) >= 0 && e.value) {
                                            var t = e.value.split("x");
                                            2 !== t.length || isNaN(t[0]) || isNaN(t[1]) || (r.tilesHor = parseInt(t[0], 10), r.tilesVert = parseInt(t[1], 10));
                                        }
                                    }), t ? m.updateSegmentData(e).then(function(t) {
                                        !function(e, t, n) {
                                            var r = [], i = function(e, t) {
                                                var n, r, i, a1, o = [], s1 = 0;
                                                for(n = 0, r = e.segments.length; n < r; n++)i = e.segments[n], (a1 = Object(u.getTimeBasedSegment)(_, T.getIsDynamic(), t, i.startTime, i.duration, i.timescale, i.media, i.mediaRange, s1)) && (o.push(a1), a1 = null, s1++);
                                                return o;
                                            }(n, t);
                                            t.segments = i, e.segmentDuration = t.segments[0].duration, e.readThumbnail = function(e, n) {
                                                var i = null;
                                                r.some(function(t) {
                                                    if (t.start <= e && t.end > e) return i = t.url, !0;
                                                }), i ? n(i) : t.segments.some(function(i) {
                                                    if (i.mediaStartTime <= e && i.mediaStartTime + i.duration > e) {
                                                        var a1 = b.resolve(t.path);
                                                        return v.load({
                                                            method: "get",
                                                            url: a1.url,
                                                            request: {
                                                                range: i.mediaRange,
                                                                responseType: "arraybuffer"
                                                            },
                                                            onload: function(e) {
                                                                var t = y.getSamplesInfo(e.target.response), a1 = new Blob([
                                                                    e.target.response.slice(t.sampleList[0].offset, t.sampleList[0].offset + t.sampleList[0].size)
                                                                ], {
                                                                    type: "image/jpeg"
                                                                }), o = window.URL.createObjectURL(a1);
                                                                r.push({
                                                                    start: i.mediaStartTime,
                                                                    end: i.mediaStartTime + i.duration,
                                                                    url: o
                                                                }), n && n(o);
                                                            }
                                                        }), !0;
                                                    }
                                                });
                                            };
                                        }(r, e, t);
                                    }) : (r.startNumber = e.startNumber, r.segmentDuration = e.segmentDuration, r.timescale = e.timescale, r.templateUrl = function(e) {
                                        var t = C.isRelative(e.media) ? C.resolve(e.media, b.resolve(e.path).url) : e.media;
                                        return t ? Object(u.replaceIDForTemplate)(t, e.id) : "";
                                    }(e)), r.tilesHor > 0 && r.tilesVert > 0 && (r.widthPerTile = r.width / r.tilesHor, r.heightPerTile = r.height / r.tilesVert, n.push(r));
                                }
                                function k() {
                                    n = [], g = -1, p = null;
                                }
                                return t = {
                                    getTracks: function() {
                                        return n;
                                    },
                                    addTracks: function() {
                                        if (A && T && (p = T.getMediaInfoForType(A, r.default.IMAGE))) {
                                            var e = T.getVoRepresentations(p);
                                            e && e.length > 0 && e.forEach(function(e) {
                                                (e.segmentInfoType === i.default.SEGMENT_TEMPLATE && e.segmentDuration > 0 && e.media || e.segmentInfoType === i.default.SEGMENT_TIMELINE) && D(e), e.segmentInfoType === i.default.SEGMENT_BASE && D(e, !0);
                                            }), n.length > 0 && n.sort(function(e, t) {
                                                return e.bitrate - t.bitrate;
                                            });
                                        }
                                    },
                                    reset: k,
                                    setTrackByIndex: function(e) {
                                        n && 0 !== n.length && (e >= n.length && (e = n.length - 1), g = e);
                                    },
                                    getCurrentTrack: function() {
                                        return g < 0 ? null : n[g];
                                    },
                                    getCurrentTrackIndex: function() {
                                        return g;
                                    },
                                    getThumbnailRequestForTime: function(e) {
                                        for(var t, r = T.getVoRepresentations(p), i = 0; i < r.length; i++)if (n[g].id === r[i].id) {
                                            t = r[i];
                                            break;
                                        }
                                        return a1.getSegmentRequestForTime(p, t, e);
                                    }
                                }, k(), v = Object(c.default)(E).create({}), y = Object(l.default)(E).getInstance(), m = Object(f.default)(E).create({
                                    events: I,
                                    eventBus: w,
                                    streamInfo: A,
                                    timelineConverter: _,
                                    dashConstants: R,
                                    dashMetrics: e.dashMetrics,
                                    segmentBaseController: e.segmentBaseController,
                                    type: r.default.IMAGE
                                }), (a1 = Object(d.default)(E).create({
                                    streamInfo: A,
                                    type: r.default.IMAGE,
                                    timelineConverter: _,
                                    segmentsController: m,
                                    baseURLController: b,
                                    debug: S,
                                    eventBus: w,
                                    events: I,
                                    dashConstants: R,
                                    urlUtils: C
                                })).initialize(!!T && T.getIsDynamic()), t;
                            }
                            g.__dashjs_factory_name = "ThumbnailTracks", t.default = a1.default.getClassFactory(g);
                        },
                        "./src/streaming/utils/BaseURLSelector.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/errors/Errors.js"), i = n("./src/core/EventBus.js"), a1 = n("./src/core/events/Events.js"), o = n("./src/streaming/controllers/BlacklistController.js"), s1 = n("./src/streaming/utils/baseUrlResolution/DVBSelector.js"), u = n("./src/streaming/utils/baseUrlResolution/BasicSelector.js"), l = n("./src/core/FactoryMaker.js"), c = n("./src/streaming/vo/DashJSError.js"), d = n("./src/streaming/utils/SupervisorTools.js"), f = n("./src/streaming/utils/baseUrlResolution/ContentSteeringSelector.js"), h = n("./src/core/Settings.js");
                            function g() {
                                var e, t, n, l, g, p, m = this.context, v = Object(i.default)(m).getInstance(), y = Object(h.default)(m).getInstance();
                                function E() {
                                    t.reset();
                                }
                                return e = {
                                    chooseSelector: function(e) {
                                        Object(d.checkParameterType)(e, "boolean"), p = e ? l : n;
                                    },
                                    select: function(e) {
                                        if (e) {
                                            if (y.get().streaming.applyContentSteering) {
                                                var t = g.selectBaseUrlIndex(e);
                                                isNaN(t) || -1 === t || (e.selectedIdx = t);
                                            }
                                            if (!isNaN(e.selectedIdx)) return e.baseUrls[e.selectedIdx];
                                            var i = p.select(e.baseUrls);
                                            return i ? (e.selectedIdx = e.baseUrls.indexOf(i), i) : (v.trigger(a1.default.URL_RESOLUTION_FAILED, {
                                                error: new c.default(r.default.URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE, r.default.URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE)
                                            }), void (p === n && E()));
                                        }
                                    },
                                    reset: E,
                                    setConfig: function(e) {
                                        e.selector && (p = e.selector), e.contentSteeringSelector && (g = e.contentSteeringSelector);
                                    }
                                }, t = Object(o.default)(m).create({
                                    updateEventName: a1.default.SERVICE_LOCATION_BLACKLIST_CHANGED,
                                    addBlacklistEventName: a1.default.SERVICE_LOCATION_BLACKLIST_ADD
                                }), n = Object(u.default)(m).create({
                                    blacklistController: t
                                }), l = Object(s1.default)(m).create({
                                    blacklistController: t
                                }), (g = Object(f.default)(m).create()).setConfig({
                                    blacklistController: t
                                }), p = n, e;
                            }
                            g.__dashjs_factory_name = "BaseURLSelector", t.default = l.default.getClassFactory(g);
                        },
                        "./src/streaming/utils/BoxParser.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/Debug.js"), i = n("./src/streaming/utils/IsoFile.js"), a1 = n("./src/core/FactoryMaker.js"), o = n("./node_modules/codem-isoboxer/dist/iso_boxer.js"), s1 = n.n(o), u = n("./src/streaming/vo/IsoBoxSearchInfo.js");
                            function l() {
                                var e, t, n = this.context;
                                function a1(e) {
                                    if (!e) return null;
                                    void 0 === e.fileStart && (e.fileStart = 0);
                                    var t = s1.a.parseBuffer(e), r = Object(i.default)(n).create();
                                    return r.setData(t), r;
                                }
                                function o(e, t) {
                                    return e[t + 3] >>> 0 | e[t + 2] << 8 >>> 0 | e[t + 1] << 16 >>> 0 | e[t] << 24 >>> 0;
                                }
                                function l(e, t) {
                                    return String.fromCharCode(e[t++]) + String.fromCharCode(e[t++]) + String.fromCharCode(e[t++]) + String.fromCharCode(e[t]);
                                }
                                return t = {
                                    parse: a1,
                                    findLastTopIsoBoxCompleted: function(e, t, n) {
                                        if (void 0 === n && (n = 0), !t || n + 8 >= t.byteLength) return new u.default(0, !1);
                                        for(var r, i = t instanceof ArrayBuffer ? new Uint8Array(t) : t, a1 = 0; n < i.byteLength;){
                                            var s1 = o(i, n), c = l(i, n + 4);
                                            if (0 === s1) break;
                                            n + s1 <= i.byteLength && (e.indexOf(c) >= 0 ? r = new u.default(n, !0, s1) : a1 = n + s1), n += s1;
                                        }
                                        return r || new u.default(a1, !1);
                                    },
                                    getMediaTimescaleFromMoov: function(e) {
                                        var t = a1(e), n = t ? t.getBox("mdhd") : void 0;
                                        return n ? n.timescale : NaN;
                                    },
                                    getSamplesInfo: function(e) {
                                        if (!e || 0 === e.byteLength) return {
                                            sampleList: [],
                                            lastSequenceNumber: NaN,
                                            totalDuration: NaN,
                                            numSequences: NaN
                                        };
                                        var t, n, r, i, o, s1, u, l, c, d, f, h, g, p, m, v, y = a1(e), E = y.getBoxes("moof"), T = y.getBoxes("mfhd");
                                        m = y.getBoxes("moof").length, p = T[T.length - 1].sequence_number, n = 0, o = [];
                                        var b = -1, A = -1;
                                        for(d = 0; d < E.length; d++){
                                            var _ = E[d], S = _.getChildBoxes("traf");
                                            for(l = 0; l < S.length; l++){
                                                var w = S[l], I = w.getChildBox("tfhd"), R = w.getChildBox("tfdt");
                                                i = R.baseMediaDecodeTime;
                                                var C = w.getChildBoxes("trun"), D = w.getChildBoxes("subs");
                                                for(c = 0; c < C.length; c++){
                                                    var k = C[c];
                                                    for(n = k.sample_count, g = (I.base_data_offset || 0) + (k.data_offset || 0), u = 0; u < n; u++){
                                                        t = void 0 !== (s1 = k.samples[u]).sample_duration ? s1.sample_duration : I.default_sample_duration, r = void 0 !== s1.sample_size ? s1.sample_size : I.default_sample_size;
                                                        var N = {
                                                            dts: i,
                                                            cts: i + (void 0 !== s1.sample_composition_time_offset ? s1.sample_composition_time_offset : 0),
                                                            duration: t,
                                                            offset: _.offset + g,
                                                            size: r,
                                                            subSizes: [
                                                                r
                                                            ]
                                                        };
                                                        if (D) for(f = 0; f < D.length; f++){
                                                            var L = D[f];
                                                            if (b < L.entry_count - 1 && u > A && (b++, A += L.entries[b].sample_delta), u == A) {
                                                                N.subSizes = [];
                                                                var x = L.entries[b];
                                                                for(h = 0; h < x.subsample_count; h++)N.subSizes.push(x.subsamples[h].subsample_size);
                                                            }
                                                        }
                                                        o.push(N), g += r, i += t;
                                                    }
                                                }
                                                v = i - R.baseMediaDecodeTime;
                                            }
                                        }
                                        return {
                                            sampleList: o,
                                            lastSequenceNumber: p,
                                            totalDuration: v,
                                            numSequences: m
                                        };
                                    },
                                    findInitRange: function(t) {
                                        var n = null, r = a1(t);
                                        if (!r) return n;
                                        var i = r.getBox("ftyp"), o = r.getBox("moov");
                                        return e.debug("Searching for initialization."), o && o.isComplete && (n = (i ? i.offset : o.offset) + "-" + (o.offset + o.size - 1), e.debug("Found the initialization.  Range: " + n)), n;
                                    },
                                    parsePayload: function(e, t, n) {
                                        if (void 0 === n && (n = 0), !t || n + 8 >= t.byteLength) return new u.default(0, !1);
                                        for(var r, i = t instanceof ArrayBuffer ? new Uint8Array(t) : t, a1 = 0; n < i.byteLength;){
                                            var s1 = o(i, n), c = l(i, n + 4);
                                            if (0 === s1) break;
                                            n + s1 <= i.byteLength && (e.indexOf(c) >= 0 ? r = new u.default(n, !0, s1, c) : a1 = n + s1), n += s1;
                                        }
                                        return r || new u.default(a1, !1);
                                    }
                                }, e = Object(r.default)(n).getInstance().getLogger(t), t;
                            }
                            l.__dashjs_factory_name = "BoxParser", t.default = a1.default.getSingletonFactory(l);
                        },
                        "./src/streaming/utils/Capabilities.js": function(e, t, n) {
                            "use strict";
                            n.r(t), n.d(t, "supportsMediaSource", function() {
                                return s1;
                            });
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/streaming/thumbnail/ThumbnailTracks.js"), a1 = n("./src/streaming/constants/Constants.js"), o = [
                                {
                                    codec: "avc1",
                                    compatibleCodecs: [
                                        "avc3"
                                    ]
                                },
                                {
                                    codec: "avc3",
                                    compatibleCodecs: [
                                        "avc1"
                                    ]
                                }
                            ];
                            function s1() {
                                var e = "WebKitMediaSource" in window, t = "MediaSource" in window;
                                return e || t;
                            }
                            function u() {
                                var e, t, n;
                                return e = {
                                    setConfig: function(e) {
                                        e && e.settings && (t = e.settings);
                                    },
                                    supportsMediaSource: s1,
                                    supportsEncryptedMedia: function() {
                                        return n;
                                    },
                                    supportsCodec: function(e, n) {
                                        return n !== a1.default.AUDIO && n !== a1.default.VIDEO ? Promise.resolve(!0) : function(e, n) {
                                            return t.get().streaming.capabilities.useMediaCapabilitiesApi && navigator.mediaCapabilities && navigator.mediaCapabilities.decodingInfo && (e.codec && n === a1.default.AUDIO || n === a1.default.VIDEO && e.codec && e.width && e.height && e.bitrate && e.framerate);
                                        }(e, n) ? function(e, t) {
                                            return new Promise(function(n) {
                                                if (e && e.codec) {
                                                    var r = {
                                                        type: "media-source"
                                                    };
                                                    r[t] = {}, r[t].contentType = e.codec, r[t].width = e.width, r[t].height = e.height, r[t].bitrate = parseInt(e.bitrate), r[t].framerate = parseFloat(e.framerate), navigator.mediaCapabilities.decodingInfo(r).then(function(e) {
                                                        n(e.supported);
                                                    }).catch(function() {
                                                        n(!1);
                                                    });
                                                } else n(!1);
                                            });
                                        }(e, n) : function(e) {
                                            return new Promise(function(t) {
                                                if (e && e.codec) {
                                                    var n = e.codec;
                                                    e.width && e.height && (n += ';width="' + e.width + '";height="' + e.height + '"'), "MediaSource" in window && MediaSource.isTypeSupported(n) || "WebKitMediaSource" in window && WebKitMediaSource.isTypeSupported(n) ? t(!0) : t(!1);
                                                } else t(!1);
                                            });
                                        }(e);
                                    },
                                    setEncryptedMediaSupported: function(e) {
                                        n = e;
                                    },
                                    supportsEssentialProperty: function(e) {
                                        try {
                                            return -1 !== i.THUMBNAILS_SCHEME_ID_URIS.indexOf(e.schemeIdUri);
                                        } catch (e) {
                                            return !0;
                                        }
                                    },
                                    codecRootCompatibleWithCodec: function(e, t) {
                                        for(var n, r = e.split(".")[0], i = 0 === t.indexOf(r), a1 = 0; a1 < o.length; a1++)if (o[a1].codec === r) {
                                            n = o[a1];
                                            break;
                                        }
                                        return n ? i || n.compatibleCodecs.some(function(e) {
                                            return 0 === t.indexOf(e);
                                        }) : i;
                                    }
                                }, n = !1, e;
                            }
                            u.__dashjs_factory_name = "Capabilities", t.default = r.default.getSingletonFactory(u);
                        },
                        "./src/streaming/utils/CapabilitiesFilter.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/core/Debug.js"), a1 = n("./src/streaming/constants/Constants.js"), o = n("./src/core/EventBus.js"), s1 = n("./src/core/events/Events.js");
                            function u() {
                                var e, t, n, r, u, l, c = this.context, d = Object(o.default)(c).getInstance();
                                function f(e, r) {
                                    if (!r || !r.Period_asArray || 0 === r.Period_asArray.length) return Promise.resolve();
                                    var i = [];
                                    return r.Period_asArray.forEach(function(r) {
                                        i.push(function(e, r) {
                                            return new Promise(function(i) {
                                                if (e && e.AdaptationSet_asArray && 0 !== e.AdaptationSet_asArray.length) {
                                                    var o = [];
                                                    e.AdaptationSet_asArray.forEach(function(e) {
                                                        t.getIsTypeOf(e, r) && o.push(function(e, r) {
                                                            return new Promise(function(i) {
                                                                if (e.Representation_asArray && 0 !== e.Representation_asArray.length) {
                                                                    var o = [], s1 = [];
                                                                    e.Representation_asArray.forEach(function(i, u) {
                                                                        var l = t.getCodec(e, u, !1), c = function(e, t, n) {
                                                                            switch(e){
                                                                                case a1.default.VIDEO:
                                                                                    return function(e, t) {
                                                                                        return {
                                                                                            codec: t,
                                                                                            width: e.width || null,
                                                                                            height: e.height || null,
                                                                                            framerate: e.frameRate || null,
                                                                                            bitrate: e.bandwidth || null
                                                                                        };
                                                                                    }(t, n);
                                                                                case a1.default.AUDIO:
                                                                                    return function(e, t) {
                                                                                        var n = e.audioSamplingRate || null;
                                                                                        return {
                                                                                            codec: t,
                                                                                            bitrate: e.bandwidth || null,
                                                                                            samplerate: n
                                                                                        };
                                                                                    }(t, n);
                                                                                default:
                                                                                    return null;
                                                                            }
                                                                        }(r, i, l);
                                                                        s1.push(c), o.push(n.supportsCodec(c, r));
                                                                    }), Promise.all(o).then(function(t) {
                                                                        e.Representation_asArray = e.Representation_asArray.filter(function(e, n) {
                                                                            return t[n] || l.debug("[Stream] Codec ".concat(s1[n].codec, " not supported ")), t[n];
                                                                        }), i();
                                                                    }).catch(function() {
                                                                        i();
                                                                    });
                                                                } else i();
                                                            });
                                                        }(e, r));
                                                    }), Promise.all(o).then(function() {
                                                        e.AdaptationSet_asArray = e.AdaptationSet_asArray.filter(function(e) {
                                                            var t = e.Representation_asArray && e.Representation_asArray.length > 0;
                                                            return t || (d.trigger(s1.default.ADAPTATION_SET_REMOVED_NO_CAPABILITIES, {
                                                                adaptationSet: e
                                                            }), l.warn("AdaptationSet has been removed because of no supported Representation")), t;
                                                        }), i();
                                                    }).catch(function() {
                                                        i();
                                                    });
                                                } else i();
                                            });
                                        }(r, e));
                                    }), Promise.all(i);
                                }
                                return e = {
                                    setConfig: function(e) {
                                        e && (e.adapter && (t = e.adapter), e.capabilities && (n = e.capabilities), e.settings && (r = e.settings), e.customParametersModel && (u = e.customParametersModel));
                                    },
                                    filterUnsupportedFeatures: function(e) {
                                        return new Promise(function(i) {
                                            var o = [];
                                            o.push(f(a1.default.VIDEO, e)), o.push(f(a1.default.AUDIO, e)), Promise.all(o).then(function() {
                                                r.get().streaming.capabilities.filterUnsupportedEssentialProperties && function(e) {
                                                    e && e.Period_asArray && 0 !== e.Period_asArray.length && e.Period_asArray.forEach(function(e) {
                                                        e.AdaptationSet_asArray = e.AdaptationSet_asArray.filter(function(e) {
                                                            return !e.Representation_asArray || 0 === e.Representation_asArray.length || (e.Representation_asArray = e.Representation_asArray.filter(function(e) {
                                                                var r = t.getEssentialPropertiesForRepresentation(e);
                                                                if (r && r.length > 0) for(var i = 0; i < r.length;){
                                                                    if (!n.supportsEssentialProperty(r[i])) return l.debug("[Stream] EssentialProperty not supported: " + r[i].schemeIdUri), !1;
                                                                    i += 1;
                                                                }
                                                                return !0;
                                                            }), e.Representation_asArray && e.Representation_asArray.length > 0);
                                                        });
                                                    });
                                                }(e), function(e) {
                                                    var t = u.getCustomCapabilitiesFilters();
                                                    t && 0 !== t.length && e && e.Period_asArray && 0 !== e.Period_asArray.length && e.Period_asArray.forEach(function(e) {
                                                        e.AdaptationSet_asArray = e.AdaptationSet_asArray.filter(function(e) {
                                                            return !e.Representation_asArray || 0 === e.Representation_asArray.length || (e.Representation_asArray = e.Representation_asArray.filter(function(e) {
                                                                return !t.some(function(t) {
                                                                    return !t(e);
                                                                });
                                                            }), e.Representation_asArray && e.Representation_asArray.length > 0);
                                                        });
                                                    });
                                                }(e), i();
                                            }).catch(function() {
                                                i();
                                            });
                                        });
                                    }
                                }, l = Object(i.default)(c).getInstance().getLogger(e), e;
                            }
                            u.__dashjs_factory_name = "CapabilitiesFilter", t.default = r.default.getSingletonFactory(u);
                        },
                        "./src/streaming/utils/CustomTimeRanges.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/streaming/utils/SupervisorTools.js");
                            function a1() {
                                return {
                                    customTimeRangeArray: [],
                                    length: 0,
                                    add: function(e, t) {
                                        var n = 0;
                                        for(n = 0; n < this.customTimeRangeArray.length && e > this.customTimeRangeArray[n].start; n++);
                                        for(this.customTimeRangeArray.splice(n, 0, {
                                            start: e,
                                            end: t
                                        }), n = 0; n < this.customTimeRangeArray.length - 1; n++)this.mergeRanges(n, n + 1) && n--;
                                        this.length = this.customTimeRangeArray.length;
                                    },
                                    clear: function() {
                                        this.customTimeRangeArray = [], this.length = 0;
                                    },
                                    remove: function(e, t) {
                                        for(var n = 0; n < this.customTimeRangeArray.length; n++)if (e <= this.customTimeRangeArray[n].start && t >= this.customTimeRangeArray[n].end) this.customTimeRangeArray.splice(n, 1), n--;
                                        else {
                                            if (e > this.customTimeRangeArray[n].start && t < this.customTimeRangeArray[n].end) {
                                                this.customTimeRangeArray.splice(n + 1, 0, {
                                                    start: t,
                                                    end: this.customTimeRangeArray[n].end
                                                }), this.customTimeRangeArray[n].end = e;
                                                break;
                                            }
                                            e > this.customTimeRangeArray[n].start && e < this.customTimeRangeArray[n].end ? this.customTimeRangeArray[n].end = e : t > this.customTimeRangeArray[n].start && t < this.customTimeRangeArray[n].end && (this.customTimeRangeArray[n].start = t);
                                        }
                                        this.length = this.customTimeRangeArray.length;
                                    },
                                    mergeRanges: function(e, t) {
                                        var n = this.customTimeRangeArray[e], r = this.customTimeRangeArray[t];
                                        return n.start <= r.start && r.start <= n.end && n.end <= r.end ? (n.end = r.end, this.customTimeRangeArray.splice(t, 1), !0) : r.start <= n.start && n.start <= r.end && r.end <= n.end ? (n.start = r.start, this.customTimeRangeArray.splice(t, 1), !0) : r.start <= n.start && n.start <= r.end && n.end <= r.end ? (this.customTimeRangeArray.splice(e, 1), !0) : n.start <= r.start && r.start <= n.end && r.end <= n.end && (this.customTimeRangeArray.splice(t, 1), !0);
                                    },
                                    start: function(e) {
                                        return Object(i.checkInteger)(e), e >= this.customTimeRangeArray.length || e < 0 ? NaN : this.customTimeRangeArray[e].start;
                                    },
                                    end: function(e) {
                                        return Object(i.checkInteger)(e), e >= this.customTimeRangeArray.length || e < 0 ? NaN : this.customTimeRangeArray[e].end;
                                    }
                                };
                            }
                            a1.__dashjs_factory_name = "CustomTimeRanges", t.default = r.default.getClassFactory(a1);
                        },
                        "./src/streaming/utils/DOMStorage.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/core/Debug.js"), a1 = n("./src/streaming/constants/Constants.js"), o = [
                                {
                                    oldKey: "dashjs_vbitrate",
                                    newKey: "dashjs_video_bitrate"
                                },
                                {
                                    oldKey: "dashjs_abitrate",
                                    newKey: "dashjs_audio_bitrate"
                                },
                                {
                                    oldKey: "dashjs_vsettings",
                                    newKey: "dashjs_video_settings"
                                },
                                {
                                    oldKey: "dashjs_asettings",
                                    newKey: "dashjs_audio_settings"
                                }
                            ], s1 = "dashjs_?_bitrate", u = "dashjs_?_settings", l = "localStorage", c = "lastBitrate", d = "lastMediaSettings";
                            function f(e) {
                                e = e || {};
                                var t, n, r, f = this.context, h = e.settings;
                                function g(e) {
                                    if (void 0 !== r) return r;
                                    var t;
                                    r = !1;
                                    try {
                                        "undefined" != typeof window && (t = window[e]);
                                    } catch (e) {
                                        return n.warn("DOMStorage access denied: " + e.message), r;
                                    }
                                    if (!t || e !== l && "sessionStorage" !== e) return r;
                                    try {
                                        t.setItem("1", "1"), t.removeItem("1"), r = !0;
                                    } catch (e) {
                                        n.warn("DOMStorage is supported, but cannot be used: " + e.message);
                                    }
                                    return r;
                                }
                                function p() {
                                    var e = 6e5;
                                    return Math.round((new Date).getTime() / e) * e;
                                }
                                function m(e, t) {
                                    return g(e) && h.get().streaming[t + "CachingInfo"].enabled;
                                }
                                function v() {
                                    if (!h) throw new Error(a1.default.MISSING_CONFIG_ERROR);
                                }
                                return t = {
                                    getSavedBitrateSettings: function(e) {
                                        if (v(), !h.get().streaming.lastBitrateCachingInfo.enabled) return NaN;
                                        var t = NaN;
                                        if (m(l, c)) {
                                            var r = s1.replace(/\?/, e);
                                            try {
                                                var i = JSON.parse(localStorage.getItem(r)) || {}, a1 = (new Date).getTime() - parseInt(i.timestamp, 10) >= h.get().streaming.lastBitrateCachingInfo.ttl || !1, o = parseFloat(i.bitrate);
                                                isNaN(o) || a1 ? a1 && localStorage.removeItem(r) : (t = o, n.debug("Last saved bitrate for " + e + " was " + o));
                                            } catch (e) {
                                                return null;
                                            }
                                        }
                                        return t;
                                    },
                                    setSavedBitrateSettings: function(e, t) {
                                        if (m(l, c) && t) {
                                            var r = s1.replace(/\?/, e);
                                            try {
                                                localStorage.setItem(r, JSON.stringify({
                                                    bitrate: t.toFixed(3),
                                                    timestamp: p()
                                                }));
                                            } catch (e) {
                                                n.error(e.message);
                                            }
                                        }
                                    },
                                    getSavedMediaSettings: function(e) {
                                        if (v(), !h.get().streaming.lastMediaSettingsCachingInfo.enabled) return null;
                                        var t = null;
                                        if (m(l, d)) {
                                            var n = u.replace(/\?/, e);
                                            try {
                                                var r = JSON.parse(localStorage.getItem(n)) || {}, i = (new Date).getTime() - parseInt(r.timestamp, 10) >= h.get().streaming.lastMediaSettingsCachingInfo.ttl || !1;
                                                t = r.settings, i && (localStorage.removeItem(n), t = null);
                                            } catch (e) {
                                                return null;
                                            }
                                        }
                                        return t;
                                    },
                                    setSavedMediaSettings: function(e, t) {
                                        if (m(l, d)) {
                                            var r = u.replace(/\?/, e);
                                            try {
                                                localStorage.setItem(r, JSON.stringify({
                                                    settings: t,
                                                    timestamp: p()
                                                }));
                                            } catch (e) {
                                                n.error(e.message);
                                            }
                                        }
                                    }
                                }, n = Object(i.default)(f).getInstance().getLogger(t), g(l) && o.forEach(function(e) {
                                    var t = localStorage.getItem(e.oldKey);
                                    if (t) {
                                        localStorage.removeItem(e.oldKey);
                                        try {
                                            localStorage.setItem(e.newKey, t);
                                        } catch (e) {
                                            n.error(e.message);
                                        }
                                    }
                                }), t;
                            }
                            f.__dashjs_factory_name = "DOMStorage";
                            var h = r.default.getSingletonFactory(f);
                            t.default = h;
                        },
                        "./src/streaming/utils/DefaultURLUtils.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js");
                            function i() {
                                var e, t = /^[a-z][a-z0-9+\-_.]*:/i, n = /^https?:\/\//i, r = /^https:\/\//i, i = /^([a-z][a-z0-9+\-_.]*:\/\/[^\/]+)\/?/i, a1 = function(e, t) {
                                    try {
                                        return new window.URL(e, t).toString();
                                    } catch (t) {
                                        return e;
                                    }
                                }, o = function(e, t) {
                                    var n = s1;
                                    if (!t) return e;
                                    if (!c(e)) return e;
                                    d(e) && (n = u), f(e) && (n = l);
                                    var r = n(t), i = "/" !== r.charAt(r.length - 1) && "/" !== e.charAt(0) ? "/" : "";
                                    return [
                                        r,
                                        e
                                    ].join(i);
                                };
                                function s1(e) {
                                    var t = e.indexOf("/"), n = e.lastIndexOf("/");
                                    return -1 !== t ? n === t + 1 ? e : (-1 !== e.indexOf("?") && (e = e.substring(0, e.indexOf("?"))), e.substring(0, n + 1)) : "";
                                }
                                function u(e) {
                                    var t = e.match(i);
                                    return t ? t[1] : "";
                                }
                                function l(e) {
                                    var n = e.match(t);
                                    return n ? n[0] : "";
                                }
                                function c(e) {
                                    return !t.test(e);
                                }
                                function d(e) {
                                    return c(e) && "/" === e.charAt(0);
                                }
                                function f(e) {
                                    return 0 === e.indexOf("//");
                                }
                                return function() {
                                    try {
                                        new window.URL("x", "http://y"), e = a1;
                                    } catch (e) {} finally{
                                        e = e || o;
                                    }
                                }(), {
                                    parseBaseUrl: s1,
                                    parseOrigin: u,
                                    parseScheme: l,
                                    isRelative: c,
                                    isPathAbsolute: d,
                                    isSchemeRelative: f,
                                    isHTTPURL: function(e) {
                                        return n.test(e);
                                    },
                                    isHTTPS: function(e) {
                                        return r.test(e);
                                    },
                                    removeHostname: function(e) {
                                        return /^(?:\w+\:\/\/)?([^\/]+)(.*)$/.exec(e)[2].substring(1);
                                    },
                                    resolve: function(t, n) {
                                        return e(t, n);
                                    }
                                };
                            }
                            i.__dashjs_factory_name = "DefaultURLUtils", t.default = r.default.getSingletonFactory(i);
                        },
                        "./src/streaming/utils/EBMLParser.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js");
                            function i(e) {
                                var t;
                                e = e || {};
                                var n = new DataView(e.data), r = 0;
                                function i(e, t) {
                                    var i = !0, a1 = 0;
                                    if (void 0 === t && (t = !1), e.tag > 16777215 ? (n.getUint32(r) !== e.tag && (i = !1), a1 = 4) : e.tag > 65535 ? (256 * n.getUint16(r) + n.getUint8(r + 2) !== e.tag && (i = !1), a1 = 3) : e.tag > 255 ? (n.getUint16(r) !== e.tag && (i = !1), a1 = 2) : (n.getUint8(r) !== e.tag && (i = !1), a1 = 1), !i && e.required && !t) throw new Error("required tag not found");
                                    return i && (r += a1), i;
                                }
                                function a1(e) {
                                    var t = 1, i = 128, a1 = -1, o = 0, s1 = n.getUint8(r), u = 0;
                                    for(u = 0; u < 8; u += 1){
                                        if ((s1 & i) === i) {
                                            o = void 0 === e ? s1 & ~i : s1, a1 = u;
                                            break;
                                        }
                                        i >>= 1;
                                    }
                                    for(u = 0; u < a1; u += 1, t += 1)o = o << 8 | 255 & n.getUint8(r + t);
                                    return r += t, o;
                                }
                                return t = {
                                    getPos: function() {
                                        return r;
                                    },
                                    setPos: function(e) {
                                        r = e;
                                    },
                                    consumeTag: i,
                                    consumeTagAndSize: function(e, t) {
                                        var n = i(e, t);
                                        return n && a1(), n;
                                    },
                                    parseTag: function(e) {
                                        var n;
                                        return i(e), n = a1(), t[e.parse](n);
                                    },
                                    skipOverElement: function(e, t) {
                                        var n, o = i(e, t);
                                        return o && (n = a1(), r += n), o;
                                    },
                                    getMatroskaCodedNum: a1,
                                    getMatroskaFloat: function(e) {
                                        var t;
                                        switch(e){
                                            case 4:
                                                t = n.getFloat32(r), r += 4;
                                                break;
                                            case 8:
                                                t = n.getFloat64(r), r += 8;
                                        }
                                        return t;
                                    },
                                    getMatroskaUint: function(e) {
                                        for(var t = 0, i = 0; i < e; i += 1)t <<= 8, t |= 255 & n.getUint8(r + i);
                                        return r += e, t;
                                    },
                                    moreData: function() {
                                        return r < n.byteLength;
                                    }
                                };
                            }
                            i.__dashjs_factory_name = "EBMLParser", t.default = r.default.getClassFactory(i);
                        },
                        "./src/streaming/utils/ErrorHandler.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/EventBus.js"), i = n("./src/core/events/Events.js"), a1 = n("./src/core/FactoryMaker.js");
                            function o() {
                                var e = this.context, t = Object(r.default)(e).getInstance();
                                return {
                                    error: function(e) {
                                        t.trigger(i.default.ERROR, {
                                            error: e
                                        });
                                    }
                                };
                            }
                            o.__dashjs_factory_name = "ErrorHandler", t.default = a1.default.getSingletonFactory(o);
                        },
                        "./src/streaming/utils/InitCache.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js");
                            function i() {
                                var e = {};
                                return {
                                    save: function(t) {
                                        var n = t.streamId, r = t.representationId;
                                        e[n] = e[n] || {}, e[n][r] = t;
                                    },
                                    extract: function(t, n) {
                                        return e && e[t] && e[t][n] ? e[t][n] : null;
                                    },
                                    reset: function() {
                                        e = {};
                                    }
                                };
                            }
                            i.__dashjs_factory_name = "InitCache", t.default = r.default.getSingletonFactory(i);
                        },
                        "./src/streaming/utils/IsoFile.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/vo/IsoBox.js"), i = n("./src/core/FactoryMaker.js");
                            function a1() {
                                var e;
                                function t(t) {
                                    var r = [];
                                    if (!t || !e || "function" != typeof e.fetchAll) return r;
                                    for(var i, a1 = e.fetchAll(t), o = 0, s1 = a1.length; o < s1; o++)(i = n(a1[o])) && r.push(i);
                                    return r;
                                }
                                function n(e) {
                                    if (!e) return null;
                                    var t = new r.default(e);
                                    return e.hasOwnProperty("_incomplete") && (t.isComplete = !e._incomplete), t;
                                }
                                return {
                                    getBox: function(t) {
                                        return t && e && e.boxes && 0 !== e.boxes.length && "function" == typeof e.fetch ? n(e.fetch(t)) : null;
                                    },
                                    getBoxes: t,
                                    setData: function(t) {
                                        e = t;
                                    },
                                    getLastBox: function() {
                                        if (!e || !e.boxes || !e.boxes.length) return null;
                                        var n = t(e.boxes[e.boxes.length - 1].type);
                                        return n.length > 0 ? n[n.length - 1] : null;
                                    }
                                };
                            }
                            a1.__dashjs_factory_name = "IsoFile", t.default = i.default.getClassFactory(a1);
                        },
                        "./src/streaming/utils/ObjectUtils.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./node_modules/fast-deep-equal/index.js"), a1 = n.n(i);
                            function o() {
                                return {
                                    areEqual: function(e, t) {
                                        return a1()(e, t);
                                    }
                                };
                            }
                            o.__dashjs_factory_name = "ObjectUtils", t.default = r.default.getSingletonFactory(o);
                        },
                        "./src/streaming/utils/RequestModifier.js": function(e, t, n) {
                            "use strict";
                            n.r(t), n.d(t, "modifyRequest", function() {
                                return i;
                            });
                            var r = n("./src/core/FactoryMaker.js");
                            function i(e, t) {
                                var n = {
                                    url: e.url,
                                    method: e.method,
                                    headers: Object.assign({}, e.headers),
                                    credentials: e.withCredentials ? "include" : void 0
                                };
                                return Promise.resolve(t.modifyRequest(n)).then(function() {
                                    return Object.assign(e, n, {
                                        withCredentials: "include" === n.credentials
                                    });
                                });
                            }
                            function a1() {
                                return {
                                    modifyRequest: null,
                                    modifyRequestURL: function(e) {
                                        return e;
                                    },
                                    modifyRequestHeader: function(e, t) {
                                        return t.url, e;
                                    }
                                };
                            }
                            a1.__dashjs_factory_name = "RequestModifier", t.default = r.default.getSingletonFactory(a1);
                        },
                        "./src/streaming/utils/SupervisorTools.js": function(e, t, n) {
                            "use strict";
                            n.r(t), n.d(t, "checkParameterType", function() {
                                return a1;
                            }), n.d(t, "checkInteger", function() {
                                return o;
                            }), n.d(t, "checkRange", function() {
                                return s1;
                            }), n.d(t, "checkIsVideoOrAudioType", function() {
                                return u;
                            });
                            var r = n("./src/streaming/constants/Constants.js");
                            function i(e) {
                                return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, i(e);
                            }
                            function a1(e, t) {
                                if (i(e) !== t) throw r.default.BAD_ARGUMENT_ERROR;
                            }
                            function o(e) {
                                if (null === e || isNaN(e) || e % 1 != 0) throw r.default.BAD_ARGUMENT_ERROR + " : argument is not an integer";
                            }
                            function s1(e, t, n) {
                                if (e < t || e > n) throw r.default.BAD_ARGUMENT_ERROR + " : argument out of range";
                            }
                            function u(e) {
                                if ("string" != typeof e || e !== r.default.AUDIO && e !== r.default.VIDEO) throw r.default.BAD_ARGUMENT_ERROR;
                            }
                        },
                        "./src/streaming/utils/TTMLParser.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/core/Debug.js"), a1 = n("./src/core/EventBus.js"), o = n("./src/core/events/Events.js"), s1 = n("./node_modules/imsc/src/main/js/main.js"), u = n("./src/streaming/MediaPlayerEvents.js"), l = n("./src/streaming/constants/ConformanceViolationConstants.js");
                            function c() {
                                var e, t, n = this.context, r = Object(a1.default)(n).getInstance(), c = 0;
                                return e = {
                                    parse: function(e, n, i, a1, d) {
                                        var f, h, g, p = "", m = [], v = {}, y = {}, E = "", T = "", b = {
                                            onOpenTag: function(e, n, i) {
                                                if (i[" imagetype"] && !i[" imageType"] && (r.trigger(u.default.CONFORMANCE_VIOLATION, {
                                                    level: l.default.LEVELS.ERROR,
                                                    event: l.default.EVENTS.NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE
                                                }), i[" imageType"] = i[" imagetype"]), "image" === n && ("http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt" === e || "http://www.smpte-ra.org/schemas/2052-1/2013/smpte-tt" === e)) {
                                                    if (!i[" imageType"] || "PNG" !== i[" imageType"].value) return void t.warn("smpte-tt imageType != PNG. Discarded");
                                                    E = i["http://www.w3.org/XML/1998/namespace id"].value;
                                                }
                                            },
                                            onCloseTag: function() {
                                                E && (y[E] = T.trim()), T = "", E = "";
                                            },
                                            onText: function(e) {
                                                E && (T += e);
                                            }
                                        };
                                        if (!e) throw p = "no ttml data to parse", new Error(p);
                                        v.data = e, r.trigger(o.default.TTML_TO_PARSE, v);
                                        var A = Object(s1.fromXML)(v.data, function(e) {
                                            p = e;
                                        }, b);
                                        r.trigger(o.default.TTML_PARSED, {
                                            ttmlString: v.data,
                                            ttmlDoc: A
                                        });
                                        var _, S = A.getMediaTimeEvents();
                                        for(g = 0; g < S.length; g++){
                                            var w = Object(s1.generateISD)(A, S[g], function(e) {
                                                p = e;
                                            });
                                            w.contents.some(function(e) {
                                                return e.contents.length;
                                            }) && (f = S[g] + n < i ? i : S[g] + n) < (h = S[g + 1] + n > a1 ? a1 : S[g + 1] + n) && m.push({
                                                start: f,
                                                end: h,
                                                type: "html",
                                                cueID: (_ = "cue_TTML_" + c, c++, _),
                                                isd: w,
                                                images: d,
                                                embeddedImages: y
                                            });
                                        }
                                        if ("" !== p) throw t.error(p), new Error(p);
                                        return m;
                                    }
                                }, t = Object(i.default)(n).getInstance().getLogger(e), e;
                            }
                            c.__dashjs_factory_name = "TTMLParser", t.default = r.default.getSingletonFactory(c);
                        },
                        "./src/streaming/utils/URLUtils.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/streaming/utils/DefaultURLUtils.js");
                            function a1() {
                                var e, t = [], n = this.context;
                                function r(n, r, i) {
                                    var a1 = function(n) {
                                        var r;
                                        for(r = 0; r < t.length; r++)if (t[r].regex.test(n)) return t[r].utils;
                                        return e;
                                    }(i || r);
                                    return a1 && "function" == typeof a1[n] ? a1[n](r, i) : e[n](r, i);
                                }
                                return e = Object(i.default)(n).getInstance(), {
                                    registerUrlRegex: function(e, n) {
                                        t.push({
                                            regex: e,
                                            utils: n
                                        });
                                    },
                                    parseBaseUrl: function(e) {
                                        return r("parseBaseUrl", e);
                                    },
                                    parseOrigin: function(e) {
                                        return r("parseOrigin", e);
                                    },
                                    parseScheme: function(e) {
                                        return r("parseScheme", e);
                                    },
                                    isRelative: function(e) {
                                        return r("isRelative", e);
                                    },
                                    isPathAbsolute: function(e) {
                                        return r("isPathAbsolute", e);
                                    },
                                    isSchemeRelative: function(e) {
                                        return r("isSchemeRelative", e);
                                    },
                                    isHTTPURL: function(e) {
                                        return r("isHTTPURL", e);
                                    },
                                    isHTTPS: function(e) {
                                        return r("isHTTPS", e);
                                    },
                                    removeHostname: function(e) {
                                        return r("removeHostname", e);
                                    },
                                    resolve: function(e, t) {
                                        return r("resolve", e, t);
                                    }
                                };
                            }
                            a1.__dashjs_factory_name = "URLUtils";
                            var o = r.default.getSingletonFactory(a1);
                            t.default = o;
                        },
                        "./src/streaming/utils/VTTParser.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/core/Debug.js");
                            function a1() {
                                var e, t, n, r, a1, o, s1 = this.context;
                                function u(e) {
                                    var t = e.split(":"), n = t.length - 1;
                                    return e = 60 * parseInt(t[n - 1], 10) + parseFloat(t[n]), 2 === n && (e += 3600 * parseInt(t[0], 10)), e;
                                }
                                function l(e) {
                                    var t = e.split(r), n = t[1].split(o);
                                    return n.shift(), t[1] = n[0], n.shift(), {
                                        cuePoints: t,
                                        styles: c(n)
                                    };
                                }
                                function c(e) {
                                    var t = {};
                                    return e.forEach(function(e) {
                                        if (e.split(/:/).length > 1) {
                                            var n = e.split(/:/)[1];
                                            n && -1 != n.search(/%/) && (n = parseInt(n.replace(/%/, ""), 10)), (e.match(/align/) || e.match(/A/)) && (t.align = n), (e.match(/line/) || e.match(/L/)) && (t.line = n), (e.match(/position/) || e.match(/P/)) && (t.position = n), (e.match(/size/) || e.match(/S/)) && (t.size = n);
                                        }
                                    }), t;
                                }
                                function d(e, t) {
                                    for(var n, i = t, a1 = "", o = ""; "" !== e[i] && i < e.length;)i++;
                                    if ((n = i - t) > 1) for(var s1 = 0; s1 < n; s1++){
                                        if ((o = e[t + s1]).match(r)) {
                                            a1 = "";
                                            break;
                                        }
                                        a1 += o, s1 !== n - 1 && (a1 += "\n");
                                    }
                                    else (o = e[t]).match(r) || (a1 = o);
                                    return a1;
                                }
                                return e = {
                                    parse: function(e) {
                                        var i, o, s1 = [];
                                        if (!e) return s1;
                                        i = (e = e.split(n)).length, o = -1;
                                        for(var c = 0; c < i; c++){
                                            var f = e[c];
                                            if (f.length > 0 && "WEBVTT" !== f && f.match(r)) {
                                                var h = l(f), g = h.cuePoints, p = h.styles, m = d(e, c + 1), v = u(g[0].replace(a1, "")), y = u(g[1].replace(a1, ""));
                                                !isNaN(v) && !isNaN(y) && v >= o && y > v ? "" !== m ? (o = v, s1.push({
                                                    start: v,
                                                    end: y,
                                                    data: m,
                                                    styles: p
                                                })) : t.error("Skipping cue due to empty/malformed cue text") : t.error("Skipping cue due to incorrect cue timing");
                                            }
                                        }
                                        return s1;
                                    }
                                }, t = Object(i.default)(s1).getInstance().getLogger(e), n = /(?:\r\n|\r|\n)/gm, r = /-->/, a1 = /(^[\s]+|[\s]+$)/g, o = /\s\b/g, e;
                            }
                            a1.__dashjs_factory_name = "VTTParser", t.default = r.default.getSingletonFactory(a1);
                        },
                        "./src/streaming/utils/baseUrlResolution/BasicSelector.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js");
                            function i(e) {
                                var t = (e = e || {}).blacklistController;
                                return {
                                    select: function(e) {
                                        var n, r = 0;
                                        return e && e.some(function(e, n) {
                                            return r = n, !t.contains(e.serviceLocation);
                                        }) && (n = e[r]), n;
                                    }
                                };
                            }
                            i.__dashjs_factory_name = "BasicSelector", t.default = r.default.getClassFactory(i);
                        },
                        "./src/streaming/utils/baseUrlResolution/ContentSteeringSelector.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js"), i = n("./src/dash/controllers/ContentSteeringController.js");
                            function a1() {
                                var e, t, n, r = this.context;
                                function a1() {
                                    for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], r = 0, i = NaN, a1 = function() {
                                        var a1 = e[r], o = t.findIndex(function(e) {
                                            return e.serviceLocation && e.serviceLocation === a1;
                                        });
                                        if (-1 !== o && !n.contains(t[o].serviceLocation)) return i = o, "break";
                                        r += 1;
                                    }; r < e.length;){
                                        var o = a1();
                                        if ("break" === o) break;
                                    }
                                    return i;
                                }
                                return e = {
                                    selectBaseUrlIndex: function(e) {
                                        var n = NaN;
                                        if (isNaN(e.selectedIdx)) {
                                            var r = t.getSteeringDataFromManifest();
                                            r && r.defaultServiceLocation && (n = a1([
                                                r.defaultServiceLocation
                                            ], e.baseUrls));
                                        }
                                        var i = t.getCurrentSteeringResponseData();
                                        return e.baseUrls && e.baseUrls.length && i && i.serviceLocationPriority && i.serviceLocationPriority.length && (n = a1(i.serviceLocationPriority, e.baseUrls)), n;
                                    },
                                    setConfig: function(e) {
                                        e.blacklistController && (n = e.blacklistController), e.contentSteeringController && (t = e.contentSteeringController);
                                    }
                                }, t = Object(i.default)(r).getInstance(), e;
                            }
                            a1.__dashjs_factory_name = "ContentSteeringSelector", t.default = r.default.getClassFactory(a1);
                        },
                        "./src/streaming/utils/baseUrlResolution/DVBSelector.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/core/FactoryMaker.js");
                            function i(e) {
                                var t = (e = e || {}).blacklistController;
                                return {
                                    select: function(e) {
                                        var n;
                                        return e && function(e) {
                                            var t, n, r = 0, i = [], a1 = 0;
                                            if (n = e.sort(function(e, t) {
                                                var n = e.dvb_priority - t.dvb_priority;
                                                return isNaN(n) ? 0 : n;
                                            }).filter(function(e, t, n) {
                                                return !t || n[0].dvb_priority && e.dvb_priority && n[0].dvb_priority === e.dvb_priority;
                                            }), n.length) return n.length > 1 && (n.forEach(function(e) {
                                                r += e.dvb_weight, i.push(r);
                                            }), t = Math.floor(Math.random() * (r - 1)), i.every(function(e, n) {
                                                return a1 = n, !(t < e);
                                            })), n[a1];
                                        }((n = [], e.filter(function(e) {
                                            return !t.contains(e.serviceLocation) || (e.dvb_priority && n.push(e.dvb_priority), !1);
                                        }).filter(function(e) {
                                            return !n.length || !e.dvb_priority || -1 === n.indexOf(e.dvb_priority);
                                        })));
                                    }
                                };
                            }
                            i.__dashjs_factory_name = "DVBSelector", t.default = r.default.getClassFactory(i);
                        },
                        "./src/streaming/vo/BitrateInfo.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.mediaType = null, this.bitrate = null, this.width = null, this.height = null, this.scanType = null, this.qualityIndex = NaN;
                            };
                        },
                        "./src/streaming/vo/DashJSError.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e(t, n, r) {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.code = t || null, this.message = n || null, this.data = r || null;
                            };
                        },
                        "./src/streaming/vo/DataChunk.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.streamId = null, this.mediaInfo = null, this.segmentType = null, this.quality = NaN, this.index = NaN, this.bytes = null, this.start = NaN, this.end = NaN, this.duration = NaN, this.representationId = null, this.endFragment = null;
                            };
                        },
                        "./src/streaming/vo/FragmentRequest.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/vo/metrics/HTTPRequest.js");
                            function i(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            var a1 = function() {
                                function e(t) {
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), this.action = e.ACTION_DOWNLOAD, this.startTime = NaN, this.mediaStartTime = NaN, this.mediaType = null, this.mediaInfo = null, this.type = null, this.duration = NaN, this.timescale = NaN, this.range = null, this.url = t || null, this.serviceLocation = null, this.requestStartDate = null, this.firstByteDate = null, this.requestEndDate = null, this.quality = NaN, this.index = NaN, this.availabilityStartTime = null, this.availabilityEndTime = null, this.wallStartTime = null, this.bytesLoaded = NaN, this.bytesTotal = NaN, this.delayLoadingTime = NaN, this.responseType = "arraybuffer", this.representationId = null;
                                }
                                var t, n;
                                return t = e, n = [
                                    {
                                        key: "isInitializationRequest",
                                        value: function() {
                                            return this.type && this.type === r.HTTPRequest.INIT_SEGMENT_TYPE;
                                        }
                                    },
                                    {
                                        key: "setInfo",
                                        value: function(e) {
                                            this.type = e && e.init ? r.HTTPRequest.INIT_SEGMENT_TYPE : r.HTTPRequest.MEDIA_SEGMENT_TYPE, this.url = e && e.url ? e.url : null, this.range = e && e.range ? e.range.start + "-" + e.range.end : null, this.mediaType = e && e.mediaType ? e.mediaType : null;
                                        }
                                    }
                                ], i(t.prototype, n), e;
                            }();
                            a1.ACTION_DOWNLOAD = "download", a1.ACTION_COMPLETE = "complete", t.default = a1;
                        },
                        "./src/streaming/vo/HeadRequest.js": function(e, t, n) {
                            "use strict";
                            function r(e) {
                                return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, r(e);
                            }
                            function i(e, t) {
                                return i = Object.setPrototypeOf || function(e, t) {
                                    return e.__proto__ = t, e;
                                }, i(e, t);
                            }
                            function a1(e, t) {
                                return !t || "object" !== r(t) && "function" != typeof t ? function(e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e;
                                }(e) : t;
                            }
                            function o(e) {
                                return o = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                                    return e.__proto__ || Object.getPrototypeOf(e);
                                }, o(e);
                            }
                            n.r(t);
                            var s1 = function(e) {
                                !function(e, t) {
                                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                    e.prototype = Object.create(t && t.prototype, {
                                        constructor: {
                                            value: e,
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }), t && i(e, t);
                                }(s1, e);
                                var t, n, r = (t = s1, n = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e, r = o(t);
                                    if (n) {
                                        var i = o(this).constructor;
                                        e = Reflect.construct(r, arguments, i);
                                    } else e = r.apply(this, arguments);
                                    return a1(this, e);
                                });
                                function s1(e) {
                                    var t;
                                    return function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, s1), (t = r.call(this, e)).checkForExistenceOnly = !0, t;
                                }
                                return s1;
                            }(n("./src/streaming/vo/FragmentRequest.js").default);
                            t.default = s1;
                        },
                        "./src/streaming/vo/IsoBox.js": function(e, t, n) {
                            "use strict";
                            function r(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var r = t[n];
                                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                }
                            }
                            n.r(t);
                            var i = function() {
                                function e(t) {
                                    if (function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, e), this.offset = t._offset, this.type = t.type, this.size = t.size, this.boxes = [], t.boxes) for(var n = 0; n < t.boxes.length; n++)this.boxes.push(new e(t.boxes[n]));
                                    switch(this.isComplete = !0, t.type){
                                        case "sidx":
                                            if (this.timescale = t.timescale, this.earliest_presentation_time = t.earliest_presentation_time, this.first_offset = t.first_offset, this.references = t.references, t.references) {
                                                this.references = [];
                                                for(var r = 0; r < t.references.length; r++){
                                                    var i = {
                                                        reference_type: t.references[r].reference_type,
                                                        referenced_size: t.references[r].referenced_size,
                                                        subsegment_duration: t.references[r].subsegment_duration
                                                    };
                                                    this.references.push(i);
                                                }
                                            }
                                            break;
                                        case "emsg":
                                            this.id = t.id, this.version = 1 === t.version ? 1 : 0, this.value = t.value, this.timescale = t.timescale, this.scheme_id_uri = t.scheme_id_uri, this.presentation_time_delta = 1 === t.version ? t.presentation_time : t.presentation_time_delta, this.event_duration = t.event_duration, this.message_data = t.message_data;
                                            break;
                                        case "mdhd":
                                            this.timescale = t.timescale;
                                            break;
                                        case "mfhd":
                                            this.sequence_number = t.sequence_number;
                                            break;
                                        case "subs":
                                            this.entry_count = t.entry_count, this.entries = t.entries;
                                            break;
                                        case "tfhd":
                                            this.base_data_offset = t.base_data_offset, this.sample_description_index = t.sample_description_index, this.default_sample_duration = t.default_sample_duration, this.default_sample_size = t.default_sample_size, this.default_sample_flags = t.default_sample_flags, this.flags = t.flags;
                                            break;
                                        case "tfdt":
                                            this.version = t.version, this.baseMediaDecodeTime = t.baseMediaDecodeTime, this.flags = t.flags;
                                            break;
                                        case "trun":
                                            if (this.sample_count = t.sample_count, this.first_sample_flags = t.first_sample_flags, this.data_offset = t.data_offset, this.flags = t.flags, this.samples = t.samples, t.samples) {
                                                this.samples = [];
                                                for(var a1 = 0, o = t.samples.length; a1 < o; a1++){
                                                    var s1 = {
                                                        sample_size: t.samples[a1].sample_size,
                                                        sample_duration: t.samples[a1].sample_duration,
                                                        sample_composition_time_offset: t.samples[a1].sample_composition_time_offset
                                                    };
                                                    this.samples.push(s1);
                                                }
                                            }
                                    }
                                }
                                var t, n;
                                return t = e, n = [
                                    {
                                        key: "getChildBox",
                                        value: function(e) {
                                            for(var t = 0; t < this.boxes.length; t++)if (this.boxes[t].type === e) return this.boxes[t];
                                        }
                                    },
                                    {
                                        key: "getChildBoxes",
                                        value: function(e) {
                                            for(var t = [], n = 0; n < this.boxes.length; n++)this.boxes[n].type === e && t.push(this.boxes[n]);
                                            return t;
                                        }
                                    }
                                ], r(t.prototype, n), e;
                            }();
                            t.default = i;
                        },
                        "./src/streaming/vo/IsoBoxSearchInfo.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e(t, n, r) {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.lastCompletedOffset = t, this.found = n, this.size = r;
                            };
                        },
                        "./src/streaming/vo/MetricsList.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.TcpList = [], this.HttpList = [], this.RepSwitchList = [], this.BufferLevel = [], this.BufferState = [], this.PlayList = [], this.DroppedFrames = [], this.SchedulingInfo = [], this.DVRInfo = [], this.ManifestUpdate = [], this.RequestsQueue = null, this.DVBErrors = [];
                            };
                        },
                        "./src/streaming/vo/TextRequest.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/Constants.js");
                            function i(e) {
                                return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, i(e);
                            }
                            function a1(e, t) {
                                return a1 = Object.setPrototypeOf || function(e, t) {
                                    return e.__proto__ = t, e;
                                }, a1(e, t);
                            }
                            function o(e, t) {
                                return !t || "object" !== i(t) && "function" != typeof t ? function(e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e;
                                }(e) : t;
                            }
                            function s1(e) {
                                return s1 = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                                    return e.__proto__ || Object.getPrototypeOf(e);
                                }, s1(e);
                            }
                            var u = function(e) {
                                !function(e, t) {
                                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                    e.prototype = Object.create(t && t.prototype, {
                                        constructor: {
                                            value: e,
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }), t && a1(e, t);
                                }(u, e);
                                var t, n, i = (t = u, n = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e, r = s1(t);
                                    if (n) {
                                        var i = s1(this).constructor;
                                        e = Reflect.construct(r, arguments, i);
                                    } else e = r.apply(this, arguments);
                                    return o(this, e);
                                });
                                function u(e, t) {
                                    var n;
                                    return function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, u), (n = i.call(this)).url = e || null, n.type = t || null, n.mediaType = r.default.STREAM, n.responseType = "", n;
                                }
                                return u;
                            }(n("./src/streaming/vo/FragmentRequest.js").default);
                            t.default = u;
                        },
                        "./src/streaming/vo/TextTrackInfo.js": function(e, t, n) {
                            "use strict";
                            function r(e) {
                                return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                    return typeof e;
                                } : function(e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                }, r(e);
                            }
                            function i(e, t) {
                                return i = Object.setPrototypeOf || function(e, t) {
                                    return e.__proto__ = t, e;
                                }, i(e, t);
                            }
                            function a1(e, t) {
                                return !t || "object" !== r(t) && "function" != typeof t ? function(e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e;
                                }(e) : t;
                            }
                            function o(e) {
                                return o = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                                    return e.__proto__ || Object.getPrototypeOf(e);
                                }, o(e);
                            }
                            n.r(t);
                            var s1 = function(e) {
                                !function(e, t) {
                                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                    e.prototype = Object.create(t && t.prototype, {
                                        constructor: {
                                            value: e,
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }), t && i(e, t);
                                }(s1, e);
                                var t, n, r = (t = s1, n = function() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }(), function() {
                                    var e, r = o(t);
                                    if (n) {
                                        var i = o(this).constructor;
                                        e = Reflect.construct(r, arguments, i);
                                    } else e = r.apply(this, arguments);
                                    return a1(this, e);
                                });
                                function s1() {
                                    var e;
                                    return function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, s1), (e = r.call(this)).captionData = null, e.label = null, e.defaultTrack = !1, e.kind = null, e.isFragmented = !1, e.isEmbedded = !1, e.isTTML = null, e;
                                }
                                return s1;
                            }(n("./src/dash/vo/MediaInfo.js").default);
                            t.default = s1;
                        },
                        "./src/streaming/vo/Thumbnail.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.url = null, this.width = null, this.height = null, this.x = null, this.y = null;
                            };
                        },
                        "./src/streaming/vo/ThumbnailTrackInfo.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.bitrate = 0, this.width = 0, this.height = 0, this.tilesHor = 0, this.tilesVert = 0, this.widthPerTile = 0, this.heightPerTile = 0, this.startNumber = 0, this.segmentDuration = 0, this.timescale = 0, this.templateUrl = "", this.id = "";
                            };
                        },
                        "./src/streaming/vo/URIFragmentData.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.t = null, this.xywh = null, this.track = null, this.id = null, this.s = null, this.r = null;
                            };
                        },
                        "./src/streaming/vo/metrics/BufferLevel.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.t = null, this.level = null;
                            };
                        },
                        "./src/streaming/vo/metrics/BufferState.js": function(e, t, n) {
                            "use strict";
                            n.r(t);
                            var r = n("./src/streaming/constants/MetricsConstants.js");
                            t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.target = null, this.state = r.default.BUFFER_EMPTY;
                            };
                        },
                        "./src/streaming/vo/metrics/DVRInfo.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.time = null, this.range = null, this.manifestInfo = null;
                            };
                        },
                        "./src/streaming/vo/metrics/DroppedFrames.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.time = null, this.droppedFrames = null;
                            };
                        },
                        "./src/streaming/vo/metrics/HTTPRequest.js": function(e, t, n) {
                            "use strict";
                            function r(e, t) {
                                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                            }
                            n.r(t), n.d(t, "HTTPRequest", function() {
                                return i;
                            }), n.d(t, "HTTPRequestTrace", function() {
                                return a1;
                            });
                            var i = function e() {
                                r(this, e), this.tcpid = null, this.type = null, this.url = null, this.actualurl = null, this.range = null, this.trequest = null, this.tresponse = null, this.responsecode = null, this.interval = null, this.trace = [], this._stream = null, this._tfinish = null, this._mediaduration = null, this._quality = null, this._responseHeaders = null, this._serviceLocation = null, this._fileLoaderType = null;
                            }, a1 = function e() {
                                r(this, e), this.s = null, this.d = null, this.b = [];
                            };
                            i.GET = "GET", i.HEAD = "HEAD", i.MPD_TYPE = "MPD", i.XLINK_EXPANSION_TYPE = "XLinkExpansion", i.INIT_SEGMENT_TYPE = "InitializationSegment", i.INDEX_SEGMENT_TYPE = "IndexSegment", i.MEDIA_SEGMENT_TYPE = "MediaSegment", i.BITSTREAM_SWITCHING_SEGMENT_TYPE = "BitstreamSwitchingSegment", i.MSS_FRAGMENT_INFO_SEGMENT_TYPE = "FragmentInfoSegment", i.DVB_REPORTING_TYPE = "DVBReporting", i.LICENSE = "license", i.CONTENT_STEERING_TYPE = "ContentSteering", i.OTHER_TYPE = "other";
                        },
                        "./src/streaming/vo/metrics/ManifestUpdate.js": function(e, t, n) {
                            "use strict";
                            function r(e, t) {
                                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                            }
                            n.r(t), n.d(t, "ManifestUpdate", function() {
                                return i;
                            }), n.d(t, "ManifestUpdateStreamInfo", function() {
                                return a1;
                            }), n.d(t, "ManifestUpdateRepresentationInfo", function() {
                                return o;
                            });
                            var i = function e() {
                                r(this, e), this.mediaType = null, this.type = null, this.requestTime = null, this.fetchTime = null, this.availabilityStartTime = null, this.presentationStartTime = 0, this.clientTimeOffset = 0, this.currentTime = null, this.buffered = null, this.latency = 0, this.streamInfo = [], this.representationInfo = [];
                            }, a1 = function e() {
                                r(this, e), this.id = null, this.index = null, this.start = null, this.duration = null;
                            }, o = function e() {
                                r(this, e), this.id = null, this.index = null, this.mediaType = null, this.streamIndex = null, this.presentationTimeOffset = null, this.startNumber = null, this.fragmentInfoType = null;
                            };
                        },
                        "./src/streaming/vo/metrics/PlayList.js": function(e, t, n) {
                            "use strict";
                            function r(e, t) {
                                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                            }
                            n.r(t), n.d(t, "PlayList", function() {
                                return i;
                            }), n.d(t, "PlayListTrace", function() {
                                return a1;
                            });
                            var i = function e() {
                                r(this, e), this.start = null, this.mstart = null, this.starttype = null, this.trace = [];
                            };
                            i.INITIAL_PLAYOUT_START_REASON = "initial_playout", i.SEEK_START_REASON = "seek", i.RESUME_FROM_PAUSE_START_REASON = "resume", i.METRICS_COLLECTION_START_REASON = "metrics_collection_start";
                            var a1 = function e() {
                                r(this, e), this.representationid = null, this.subreplevel = null, this.start = null, this.mstart = null, this.duration = null, this.playbackspeed = null, this.stopreason = null;
                            };
                            a1.REPRESENTATION_SWITCH_STOP_REASON = "representation_switch", a1.REBUFFERING_REASON = "rebuffering", a1.USER_REQUEST_STOP_REASON = "user_request", a1.END_OF_PERIOD_STOP_REASON = "end_of_period", a1.END_OF_CONTENT_STOP_REASON = "end_of_content", a1.METRICS_COLLECTION_STOP_REASON = "metrics_collection_end", a1.FAILURE_STOP_REASON = "failure";
                        },
                        "./src/streaming/vo/metrics/RepresentationSwitch.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.t = null, this.mt = null, this.to = null, this.lto = null;
                            };
                        },
                        "./src/streaming/vo/metrics/RequestsQueue.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.loadingRequests = [], this.executedRequests = [];
                            };
                        },
                        "./src/streaming/vo/metrics/SchedulingInfo.js": function(e, t, n) {
                            "use strict";
                            n.r(t), t.default = function e() {
                                !function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                }(this, e), this.mediaType = null, this.t = null, this.type = null, this.startTime = null, this.availabilityStartTime = null, this.duration = null, this.quality = null, this.range = null, this.state = null;
                            };
                        },
                        0: function(e, t) {},
                        1: function(e, t) {}
                    }).default;
                }, e.exports = t();
            },
            758: (e)=>{
                "use strict";
                var t, n = "object" == typeof Reflect ? Reflect : null, r = n && "function" == typeof n.apply ? n.apply : function(e, t, n) {
                    return Function.prototype.apply.call(e, t, n);
                };
                t = n && "function" == typeof n.ownKeys ? n.ownKeys : Object.getOwnPropertySymbols ? function(e) {
                    return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
                } : function(e) {
                    return Object.getOwnPropertyNames(e);
                };
                var i = Number.isNaN || function(e) {
                    return e != e;
                };
                function a1() {
                    a1.init.call(this);
                }
                e.exports = a1, e.exports.once = function(e, t) {
                    return new Promise(function(n, r) {
                        function i(n) {
                            e.removeListener(t, a1), r(n);
                        }
                        function a1() {
                            "function" == typeof e.removeListener && e.removeListener("error", i), n([].slice.call(arguments));
                        }
                        p(e, t, a1, {
                            once: !0
                        }), "error" !== t && function(e, t, n) {
                            "function" == typeof e.on && p(e, "error", t, {
                                once: !0
                            });
                        }(e, i);
                    });
                }, a1.EventEmitter = a1, a1.prototype._events = void 0, a1.prototype._eventsCount = 0, a1.prototype._maxListeners = void 0;
                var o = 10;
                function s1(e) {
                    if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
                }
                function u(e) {
                    return void 0 === e._maxListeners ? a1.defaultMaxListeners : e._maxListeners;
                }
                function l(e, t, n, r) {
                    var i, a1, o, l;
                    if (s1(n), void 0 === (a1 = e._events) ? (a1 = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== a1.newListener && (e.emit("newListener", t, n.listener ? n.listener : n), a1 = e._events), o = a1[t]), void 0 === o) o = a1[t] = n, ++e._eventsCount;
                    else if ("function" == typeof o ? o = a1[t] = r ? [
                        n,
                        o
                    ] : [
                        o,
                        n
                    ] : r ? o.unshift(n) : o.push(n), (i = u(e)) > 0 && o.length > i && !o.warned) {
                        o.warned = !0;
                        var c = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                        c.name = "MaxListenersExceededWarning", c.emitter = e, c.type = t, c.count = o.length, l = c, console && console.warn && console.warn(l);
                    }
                    return e;
                }
                function c() {
                    if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
                }
                function d(e, t, n) {
                    var r = {
                        fired: !1,
                        wrapFn: void 0,
                        target: e,
                        type: t,
                        listener: n
                    }, i = c.bind(r);
                    return i.listener = n, r.wrapFn = i, i;
                }
                function f(e, t, n) {
                    var r = e._events;
                    if (void 0 === r) return [];
                    var i = r[t];
                    return void 0 === i ? [] : "function" == typeof i ? n ? [
                        i.listener || i
                    ] : [
                        i
                    ] : n ? function(e) {
                        for(var t = new Array(e.length), n = 0; n < t.length; ++n)t[n] = e[n].listener || e[n];
                        return t;
                    }(i) : g(i, i.length);
                }
                function h(e) {
                    var t = this._events;
                    if (void 0 !== t) {
                        var n = t[e];
                        if ("function" == typeof n) return 1;
                        if (void 0 !== n) return n.length;
                    }
                    return 0;
                }
                function g(e, t) {
                    for(var n = new Array(t), r = 0; r < t; ++r)n[r] = e[r];
                    return n;
                }
                function p(e, t, n, r) {
                    if ("function" == typeof e.on) r.once ? e.once(t, n) : e.on(t, n);
                    else {
                        if ("function" != typeof e.addEventListener) throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
                        e.addEventListener(t, function i(a1) {
                            r.once && e.removeEventListener(t, i), n(a1);
                        });
                    }
                }
                Object.defineProperty(a1, "defaultMaxListeners", {
                    enumerable: !0,
                    get: function() {
                        return o;
                    },
                    set: function(e) {
                        if ("number" != typeof e || e < 0 || i(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
                        o = e;
                    }
                }), a1.init = function() {
                    void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                }, a1.prototype.setMaxListeners = function(e) {
                    if ("number" != typeof e || e < 0 || i(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
                    return this._maxListeners = e, this;
                }, a1.prototype.getMaxListeners = function() {
                    return u(this);
                }, a1.prototype.emit = function(e) {
                    for(var t = [], n = 1; n < arguments.length; n++)t.push(arguments[n]);
                    var i = "error" === e, a1 = this._events;
                    if (void 0 !== a1) i = i && void 0 === a1.error;
                    else if (!i) return !1;
                    if (i) {
                        var o;
                        if (t.length > 0 && (o = t[0]), o instanceof Error) throw o;
                        var s1 = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
                        throw s1.context = o, s1;
                    }
                    var u = a1[e];
                    if (void 0 === u) return !1;
                    if ("function" == typeof u) r(u, this, t);
                    else {
                        var l = u.length, c = g(u, l);
                        for(n = 0; n < l; ++n)r(c[n], this, t);
                    }
                    return !0;
                }, a1.prototype.addListener = function(e, t) {
                    return l(this, e, t, !1);
                }, a1.prototype.on = a1.prototype.addListener, a1.prototype.prependListener = function(e, t) {
                    return l(this, e, t, !0);
                }, a1.prototype.once = function(e, t) {
                    return s1(t), this.on(e, d(this, e, t)), this;
                }, a1.prototype.prependOnceListener = function(e, t) {
                    return s1(t), this.prependListener(e, d(this, e, t)), this;
                }, a1.prototype.removeListener = function(e, t) {
                    var n, r, i, a1, o;
                    if (s1(t), void 0 === (r = this._events)) return this;
                    if (void 0 === (n = r[e])) return this;
                    if (n === t || n.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t));
                    else if ("function" != typeof n) {
                        for(i = -1, a1 = n.length - 1; a1 >= 0; a1--)if (n[a1] === t || n[a1].listener === t) {
                            o = n[a1].listener, i = a1;
                            break;
                        }
                        if (i < 0) return this;
                        0 === i ? n.shift() : function(e, t) {
                            for(; t + 1 < e.length; t++)e[t] = e[t + 1];
                            e.pop();
                        }(n, i), 1 === n.length && (r[e] = n[0]), void 0 !== r.removeListener && this.emit("removeListener", e, o || t);
                    }
                    return this;
                }, a1.prototype.off = a1.prototype.removeListener, a1.prototype.removeAllListeners = function(e) {
                    var t, n, r;
                    if (void 0 === (n = this._events)) return this;
                    if (void 0 === n.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== n[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete n[e]), this;
                    if (0 === arguments.length) {
                        var i, a1 = Object.keys(n);
                        for(r = 0; r < a1.length; ++r)"removeListener" !== (i = a1[r]) && this.removeAllListeners(i);
                        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
                    }
                    if ("function" == typeof (t = n[e])) this.removeListener(e, t);
                    else if (void 0 !== t) for(r = t.length - 1; r >= 0; r--)this.removeListener(e, t[r]);
                    return this;
                }, a1.prototype.listeners = function(e) {
                    return f(this, e, !0);
                }, a1.prototype.rawListeners = function(e) {
                    return f(this, e, !1);
                }, a1.listenerCount = function(e, t) {
                    return "function" == typeof e.listenerCount ? e.listenerCount(t) : h.call(e, t);
                }, a1.prototype.listenerCount = h, a1.prototype.eventNames = function() {
                    return this._eventsCount > 0 ? t(this._events) : [];
                };
            },
            793: function(e) {
                var t;
                "undefined" != typeof window && (t = ()=>(()=>{
                        var e = {
                            "./src/config.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    enableStreamingMode: ()=>w,
                                    hlsDefaultConfig: ()=>_,
                                    mergeConfig: ()=>S
                                });
                                var r = n("./src/controller/abr-controller.ts"), i = n("./src/controller/audio-stream-controller.ts"), a1 = n("./src/controller/audio-track-controller.ts"), o = n("./src/controller/subtitle-stream-controller.ts"), s1 = n("./src/controller/subtitle-track-controller.ts"), u = n("./src/controller/buffer-controller.ts"), l = n("./src/controller/timeline-controller.ts"), c = n("./src/controller/cap-level-controller.ts"), d = n("./src/controller/fps-controller.ts"), f = n("./src/controller/eme-controller.ts"), h = n("./src/controller/cmcd-controller.ts"), g = n("./src/utils/xhr-loader.ts"), p = n("./src/utils/fetch-loader.ts"), m = n("./src/utils/cues.ts"), v = n("./src/utils/mediakeys-helper.ts"), y = n("./src/utils/logger.ts");
                                function E() {
                                    return E = Object.assign ? Object.assign.bind() : function(e) {
                                        for(var t = 1; t < arguments.length; t++){
                                            var n = arguments[t];
                                            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                                        }
                                        return e;
                                    }, E.apply(this, arguments);
                                }
                                function T(e, t) {
                                    var n = Object.keys(e);
                                    if (Object.getOwnPropertySymbols) {
                                        var r = Object.getOwnPropertySymbols(e);
                                        t && (r = r.filter(function(t) {
                                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                                        })), n.push.apply(n, r);
                                    }
                                    return n;
                                }
                                function b(e) {
                                    for(var t = 1; t < arguments.length; t++){
                                        var n = null != arguments[t] ? arguments[t] : {};
                                        t % 2 ? T(Object(n), !0).forEach(function(t) {
                                            A(e, t, n[t]);
                                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : T(Object(n)).forEach(function(t) {
                                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                                        });
                                    }
                                    return e;
                                }
                                function A(e, t, n) {
                                    return t in e ? Object.defineProperty(e, t, {
                                        value: n,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }) : e[t] = n, e;
                                }
                                var _ = b(b({
                                    autoStartLoad: !0,
                                    startPosition: -1,
                                    defaultAudioCodec: void 0,
                                    debug: !1,
                                    capLevelOnFPSDrop: !1,
                                    capLevelToPlayerSize: !1,
                                    ignoreDevicePixelRatio: !1,
                                    initialLiveManifestSize: 1,
                                    maxBufferLength: 30,
                                    backBufferLength: 1 / 0,
                                    maxBufferSize: 6e7,
                                    maxBufferHole: .1,
                                    highBufferWatchdogPeriod: 2,
                                    nudgeOffset: .1,
                                    nudgeMaxRetry: 3,
                                    maxFragLookUpTolerance: .25,
                                    liveSyncDurationCount: 3,
                                    liveMaxLatencyDurationCount: 1 / 0,
                                    liveSyncDuration: void 0,
                                    liveMaxLatencyDuration: void 0,
                                    maxLiveSyncPlaybackRate: 1,
                                    liveDurationInfinity: !1,
                                    liveBackBufferLength: null,
                                    maxMaxBufferLength: 600,
                                    enableWorker: !0,
                                    enableSoftwareAES: !0,
                                    manifestLoadingTimeOut: 1e4,
                                    manifestLoadingMaxRetry: 1,
                                    manifestLoadingRetryDelay: 1e3,
                                    manifestLoadingMaxRetryTimeout: 64e3,
                                    startLevel: void 0,
                                    levelLoadingTimeOut: 1e4,
                                    levelLoadingMaxRetry: 4,
                                    levelLoadingRetryDelay: 1e3,
                                    levelLoadingMaxRetryTimeout: 64e3,
                                    fragLoadingTimeOut: 2e4,
                                    fragLoadingMaxRetry: 6,
                                    fragLoadingRetryDelay: 1e3,
                                    fragLoadingMaxRetryTimeout: 64e3,
                                    startFragPrefetch: !1,
                                    fpsDroppedMonitoringPeriod: 5e3,
                                    fpsDroppedMonitoringThreshold: .2,
                                    appendErrorMaxRetry: 3,
                                    loader: g.default,
                                    fLoader: void 0,
                                    pLoader: void 0,
                                    xhrSetup: void 0,
                                    licenseXhrSetup: void 0,
                                    licenseResponseCallback: void 0,
                                    abrController: r.default,
                                    bufferController: u.default,
                                    capLevelController: c.default,
                                    fpsController: d.default,
                                    stretchShortVideoTrack: !1,
                                    maxAudioFramesDrift: 1,
                                    forceKeyFrameOnDiscontinuity: !0,
                                    abrEwmaFastLive: 3,
                                    abrEwmaSlowLive: 9,
                                    abrEwmaFastVoD: 3,
                                    abrEwmaSlowVoD: 9,
                                    abrEwmaDefaultEstimate: 5e5,
                                    abrBandWidthFactor: .95,
                                    abrBandWidthUpFactor: .7,
                                    abrMaxWithRealBitrate: !1,
                                    maxStarvationDelay: 4,
                                    maxLoadingDelay: 4,
                                    minAutoBitrate: 0,
                                    emeEnabled: !1,
                                    widevineLicenseUrl: void 0,
                                    drmSystemOptions: {},
                                    requestMediaKeySystemAccessFunc: v.requestMediaKeySystemAccess,
                                    testBandwidth: !0,
                                    progressive: !1,
                                    lowLatencyMode: !0,
                                    cmcd: void 0,
                                    enableDateRangeMetadataCues: !0,
                                    enableEmsgMetadataCues: !0,
                                    enableID3MetadataCues: !0
                                }, {
                                    cueHandler: m.default,
                                    enableWebVTT: !0,
                                    enableIMSC1: !0,
                                    enableCEA708Captions: !0,
                                    captionsTextTrack1Label: "English",
                                    captionsTextTrack1LanguageCode: "en",
                                    captionsTextTrack2Label: "Spanish",
                                    captionsTextTrack2LanguageCode: "es",
                                    captionsTextTrack3Label: "Unknown CC",
                                    captionsTextTrack3LanguageCode: "",
                                    captionsTextTrack4Label: "Unknown CC",
                                    captionsTextTrack4LanguageCode: "",
                                    renderTextTracksNatively: !0
                                }), {}, {
                                    subtitleStreamController: o.SubtitleStreamController,
                                    subtitleTrackController: s1.default,
                                    timelineController: l.TimelineController,
                                    audioStreamController: i.default,
                                    audioTrackController: a1.default,
                                    emeController: f.default,
                                    cmcdController: h.default
                                });
                                function S(e, t) {
                                    if ((t.liveSyncDurationCount || t.liveMaxLatencyDurationCount) && (t.liveSyncDuration || t.liveMaxLatencyDuration)) throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
                                    if (void 0 !== t.liveMaxLatencyDurationCount && (void 0 === t.liveSyncDurationCount || t.liveMaxLatencyDurationCount <= t.liveSyncDurationCount)) throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
                                    if (void 0 !== t.liveMaxLatencyDuration && (void 0 === t.liveSyncDuration || t.liveMaxLatencyDuration <= t.liveSyncDuration)) throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
                                    return E({}, e, t);
                                }
                                function w(e) {
                                    var t = e.loader;
                                    t !== p.default && t !== g.default ? (y.logger.log("[config]: Custom loader detected, cannot enable progressive streaming"), e.progressive = !1) : (0, p.fetchSupported)() && (e.loader = p.default, e.progressive = !0, e.enableSoftwareAES = !0, y.logger.log("[config]: Progressive streaming enabled, using FetchLoader"));
                                }
                            },
                            "./src/controller/abr-controller.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>c
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./src/utils/ewma-bandwidth-estimator.ts"), a1 = n("./src/events.ts"), o = n("./src/errors.ts"), s1 = n("./src/types/loader.ts"), u = n("./src/utils/logger.ts");
                                function l(e, t) {
                                    for(var n = 0; n < t.length; n++){
                                        var r = t[n];
                                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                    }
                                }
                                const c = function() {
                                    function e(e) {
                                        this.hls = void 0, this.lastLoadedFragLevel = 0, this._nextAutoLevel = -1, this.timer = void 0, this.onCheck = this._abandonRulesCheck.bind(this), this.fragCurrent = null, this.partCurrent = null, this.bitrateTestDelay = 0, this.bwEstimator = void 0, this.hls = e;
                                        var t = e.config;
                                        this.bwEstimator = new i.default(t.abrEwmaSlowVoD, t.abrEwmaFastVoD, t.abrEwmaDefaultEstimate), this.registerListeners();
                                    }
                                    var t, n, c = e.prototype;
                                    return c.registerListeners = function() {
                                        var e = this.hls;
                                        e.on(a1.Events.FRAG_LOADING, this.onFragLoading, this), e.on(a1.Events.FRAG_LOADED, this.onFragLoaded, this), e.on(a1.Events.FRAG_BUFFERED, this.onFragBuffered, this), e.on(a1.Events.LEVEL_LOADED, this.onLevelLoaded, this), e.on(a1.Events.ERROR, this.onError, this);
                                    }, c.unregisterListeners = function() {
                                        var e = this.hls;
                                        e.off(a1.Events.FRAG_LOADING, this.onFragLoading, this), e.off(a1.Events.FRAG_LOADED, this.onFragLoaded, this), e.off(a1.Events.FRAG_BUFFERED, this.onFragBuffered, this), e.off(a1.Events.LEVEL_LOADED, this.onLevelLoaded, this), e.off(a1.Events.ERROR, this.onError, this);
                                    }, c.destroy = function() {
                                        this.unregisterListeners(), this.clearTimer(), this.hls = this.onCheck = null, this.fragCurrent = this.partCurrent = null;
                                    }, c.onFragLoading = function(e, t) {
                                        var n, r = t.frag;
                                        r.type === s1.PlaylistLevelType.MAIN && (this.timer || (this.fragCurrent = r, this.partCurrent = null != (n = t.part) ? n : null, this.timer = self.setInterval(this.onCheck, 100)));
                                    }, c.onLevelLoaded = function(e, t) {
                                        var n = this.hls.config;
                                        t.details.live ? this.bwEstimator.update(n.abrEwmaSlowLive, n.abrEwmaFastLive) : this.bwEstimator.update(n.abrEwmaSlowVoD, n.abrEwmaFastVoD);
                                    }, c._abandonRulesCheck = function() {
                                        var e = this.fragCurrent, t = this.partCurrent, n = this.hls, i = n.autoLevelEnabled, o = (n.config, n.media);
                                        if (e && o) {
                                            var s1 = t ? t.stats : e.stats, l = t ? t.duration : e.duration;
                                            if (s1.aborted || s1.loaded && s1.loaded === s1.total || 0 === e.level) return this.clearTimer(), void (this._nextAutoLevel = -1);
                                            if (i && !o.paused && o.playbackRate && o.readyState) {
                                                var c = n.mainForwardBufferInfo;
                                                if (null !== c) {
                                                    var d = performance.now() - s1.loading.start, f = Math.abs(o.playbackRate);
                                                    if (!(d <= 500 * l / f)) {
                                                        var h = s1.loaded && s1.loading.first, g = this.bwEstimator.getEstimate(), p = n.levels, m = n.minAutoLevel, v = p[e.level], y = s1.total || Math.max(s1.loaded, Math.round(l * v.maxBitrate / 8)), E = h ? 1e3 * s1.loaded / d : 0, T = E ? (y - s1.loaded) / E : 8 * y / g, b = c.len / f;
                                                        if (!(T <= b)) {
                                                            var A, _ = Number.POSITIVE_INFINITY;
                                                            for(A = e.level - 1; A > m; A--){
                                                                var S = p[A].maxBitrate;
                                                                if ((_ = E ? l * S / (6.4 * E) : l * S / g) < b) break;
                                                            }
                                                            _ >= T || (u.logger.warn("Fragment " + e.sn + (t ? " part " + t.index : "") + " of level " + e.level + " is loading too slowly and will cause an underbuffer; aborting and switching to level " + A + "\n      Current BW estimate: " + ((0, r.isFiniteNumber)(g) ? (g / 1024).toFixed(3) : "Unknown") + " Kb/s\n      Estimated load time for current fragment: " + T.toFixed(3) + " s\n      Estimated load time for the next fragment: " + _.toFixed(3) + " s\n      Time to underbuffer: " + b.toFixed(3) + " s"), n.nextLoadLevel = A, h && this.bwEstimator.sample(d, s1.loaded), this.clearTimer(), e.loader && (this.fragCurrent = this.partCurrent = null, e.loader.abort()), n.trigger(a1.Events.FRAG_LOAD_EMERGENCY_ABORTED, {
                                                                frag: e,
                                                                part: t,
                                                                stats: s1
                                                            }));
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }, c.onFragLoaded = function(e, t) {
                                        var n = t.frag, i = t.part;
                                        if (n.type === s1.PlaylistLevelType.MAIN && (0, r.isFiniteNumber)(n.sn)) {
                                            var o = i ? i.stats : n.stats, u = i ? i.duration : n.duration;
                                            if (this.clearTimer(), this.lastLoadedFragLevel = n.level, this._nextAutoLevel = -1, this.hls.config.abrMaxWithRealBitrate) {
                                                var l = this.hls.levels[n.level], c = (l.loaded ? l.loaded.bytes : 0) + o.loaded, d = (l.loaded ? l.loaded.duration : 0) + u;
                                                l.loaded = {
                                                    bytes: c,
                                                    duration: d
                                                }, l.realBitrate = Math.round(8 * c / d);
                                            }
                                            if (n.bitrateTest) {
                                                var f = {
                                                    stats: o,
                                                    frag: n,
                                                    part: i,
                                                    id: n.type
                                                };
                                                this.onFragBuffered(a1.Events.FRAG_BUFFERED, f);
                                            }
                                        }
                                    }, c.onFragBuffered = function(e, t) {
                                        var n = t.frag, r = t.part, i = r ? r.stats : n.stats;
                                        if (!i.aborted && n.type === s1.PlaylistLevelType.MAIN && "initSegment" !== n.sn) {
                                            var a1 = i.parsing.end - i.loading.start;
                                            this.bwEstimator.sample(a1, i.loaded), i.bwEstimate = this.bwEstimator.getEstimate(), n.bitrateTest ? this.bitrateTestDelay = a1 / 1e3 : this.bitrateTestDelay = 0;
                                        }
                                    }, c.onError = function(e, t) {
                                        switch(t.details){
                                            case o.ErrorDetails.FRAG_LOAD_ERROR:
                                            case o.ErrorDetails.FRAG_LOAD_TIMEOUT:
                                                this.clearTimer();
                                        }
                                    }, c.clearTimer = function() {
                                        self.clearInterval(this.timer), this.timer = void 0;
                                    }, c.getNextABRAutoLevel = function() {
                                        var e = this.fragCurrent, t = this.partCurrent, n = this.hls, r = n.maxAutoLevel, i = n.config, a1 = n.minAutoLevel, o = n.media, s1 = t ? t.duration : e ? e.duration : 0, l = (o && o.currentTime, o && 0 !== o.playbackRate ? Math.abs(o.playbackRate) : 1), c = this.bwEstimator ? this.bwEstimator.getEstimate() : i.abrEwmaDefaultEstimate, d = n.mainForwardBufferInfo, f = (d ? d.len : 0) / l, h = this.findBestLevel(c, a1, r, f, i.abrBandWidthFactor, i.abrBandWidthUpFactor);
                                        if (h >= 0) return h;
                                        u.logger.trace((f ? "rebuffering expected" : "buffer is empty") + ", finding optimal quality level");
                                        var g = s1 ? Math.min(s1, i.maxStarvationDelay) : i.maxStarvationDelay, p = i.abrBandWidthFactor, m = i.abrBandWidthUpFactor;
                                        if (!f) {
                                            var v = this.bitrateTestDelay;
                                            v && (g = (s1 ? Math.min(s1, i.maxLoadingDelay) : i.maxLoadingDelay) - v, u.logger.trace("bitrate test took " + Math.round(1e3 * v) + "ms, set first fragment max fetchDuration to " + Math.round(1e3 * g) + " ms"), p = m = 1);
                                        }
                                        return h = this.findBestLevel(c, a1, r, f + g, p, m), Math.max(h, 0);
                                    }, c.findBestLevel = function(e, t, n, i, a1, o) {
                                        for(var s1, l = this.fragCurrent, c = this.partCurrent, d = this.lastLoadedFragLevel, f = this.hls.levels, h = f[d], g = !(null == h || null === (s1 = h.details) || void 0 === s1 || !s1.live), p = null == h ? void 0 : h.codecSet, m = c ? c.duration : l ? l.duration : 0, v = n; v >= t; v--){
                                            var y = f[v];
                                            if (y && (!p || y.codecSet === p)) {
                                                var E, T = y.details, b = (c ? null == T ? void 0 : T.partTarget : null == T ? void 0 : T.averagetargetduration) || m;
                                                E = v <= d ? a1 * e : o * e;
                                                var A = f[v].maxBitrate, _ = A * b / E;
                                                if (u.logger.trace("level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: " + v + "/" + Math.round(E) + "/" + A + "/" + b + "/" + i + "/" + _), E > A && (0 === _ || !(0, r.isFiniteNumber)(_) || g && !this.bitrateTestDelay || _ < i)) return v;
                                            }
                                        }
                                        return -1;
                                    }, t = e, n = [
                                        {
                                            key: "nextAutoLevel",
                                            get: function() {
                                                var e = this._nextAutoLevel, t = this.bwEstimator;
                                                if (-1 !== e && !t.canEstimate()) return e;
                                                var n = this.getNextABRAutoLevel();
                                                return -1 !== e && this.hls.levels[n].loadError ? e : (-1 !== e && (n = Math.min(e, n)), n);
                                            },
                                            set: function(e) {
                                                this._nextAutoLevel = e;
                                            }
                                        }
                                    ], l(t.prototype, n), Object.defineProperty(t, "prototype", {
                                        writable: !1
                                    }), e;
                                }();
                            },
                            "./src/controller/audio-stream-controller.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>E
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./src/controller/base-stream-controller.ts"), a1 = n("./src/events.ts"), o = n("./src/utils/buffer-helper.ts"), s1 = n("./src/controller/fragment-tracker.ts"), u = n("./src/types/level.ts"), l = n("./src/types/loader.ts"), c = n("./src/loader/fragment.ts"), d = n("./src/demux/chunk-cache.ts"), f = n("./src/demux/transmuxer-interface.ts"), h = n("./src/types/transmuxer.ts"), g = n("./src/controller/fragment-finders.ts"), p = n("./src/utils/discontinuities.ts"), m = n("./src/errors.ts");
                                function v() {
                                    return v = Object.assign ? Object.assign.bind() : function(e) {
                                        for(var t = 1; t < arguments.length; t++){
                                            var n = arguments[t];
                                            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                                        }
                                        return e;
                                    }, v.apply(this, arguments);
                                }
                                function y(e, t) {
                                    return y = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, y(e, t);
                                }
                                const E = function(e) {
                                    var t, n;
                                    function E(t, n) {
                                        var r;
                                        return (r = e.call(this, t, n, "[audio-stream-controller]") || this).videoBuffer = null, r.videoTrackCC = -1, r.waitingVideoCC = -1, r.audioSwitch = !1, r.trackId = -1, r.waitingData = null, r.mainDetails = null, r.bufferFlushed = !1, r.cachedTrackLoadedData = null, r._registerListeners(), r;
                                    }
                                    n = e, (t = E).prototype = Object.create(n.prototype), t.prototype.constructor = t, y(t, n);
                                    var T = E.prototype;
                                    return T.onHandlerDestroying = function() {
                                        this._unregisterListeners(), this.mainDetails = null;
                                    }, T._registerListeners = function() {
                                        var e = this.hls;
                                        e.on(a1.Events.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(a1.Events.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(a1.Events.MANIFEST_LOADING, this.onManifestLoading, this), e.on(a1.Events.LEVEL_LOADED, this.onLevelLoaded, this), e.on(a1.Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.on(a1.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(a1.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(a1.Events.ERROR, this.onError, this), e.on(a1.Events.BUFFER_RESET, this.onBufferReset, this), e.on(a1.Events.BUFFER_CREATED, this.onBufferCreated, this), e.on(a1.Events.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(a1.Events.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(a1.Events.FRAG_BUFFERED, this.onFragBuffered, this);
                                    }, T._unregisterListeners = function() {
                                        var e = this.hls;
                                        e.off(a1.Events.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(a1.Events.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(a1.Events.MANIFEST_LOADING, this.onManifestLoading, this), e.off(a1.Events.LEVEL_LOADED, this.onLevelLoaded, this), e.off(a1.Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.off(a1.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(a1.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(a1.Events.ERROR, this.onError, this), e.off(a1.Events.BUFFER_RESET, this.onBufferReset, this), e.off(a1.Events.BUFFER_CREATED, this.onBufferCreated, this), e.off(a1.Events.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(a1.Events.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(a1.Events.FRAG_BUFFERED, this.onFragBuffered, this);
                                    }, T.onInitPtsFound = function(e, t) {
                                        var n = t.frag, r = t.id, a1 = t.initPTS;
                                        if ("main" === r) {
                                            var o = n.cc;
                                            this.initPTS[n.cc] = a1, this.log("InitPTS for cc: " + o + " found from main: " + a1), this.videoTrackCC = o, this.state === i.State.WAITING_INIT_PTS && this.tick();
                                        }
                                    }, T.startLoad = function(e) {
                                        if (!this.levels) return this.startPosition = e, void (this.state = i.State.STOPPED);
                                        var t = this.lastCurrentTime;
                                        this.stopLoad(), this.setInterval(100), this.fragLoadError = 0, t > 0 && -1 === e ? (this.log("Override startPosition with lastCurrentTime @" + t.toFixed(3)), e = t, this.state = i.State.IDLE) : (this.loadedmetadata = !1, this.state = i.State.WAITING_TRACK), this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
                                    }, T.doTick = function() {
                                        switch(this.state){
                                            case i.State.IDLE:
                                                this.doTickIdle();
                                                break;
                                            case i.State.WAITING_TRACK:
                                                var t, n = this.levels, r = this.trackId, a1 = null == n || null === (t = n[r]) || void 0 === t ? void 0 : t.details;
                                                if (a1) {
                                                    if (this.waitForCdnTuneIn(a1)) break;
                                                    this.state = i.State.WAITING_INIT_PTS;
                                                }
                                                break;
                                            case i.State.FRAG_LOADING_WAITING_RETRY:
                                                var s1, u = performance.now(), l = this.retryDate;
                                                (!l || u >= l || null !== (s1 = this.media) && void 0 !== s1 && s1.seeking) && (this.log("RetryDate reached, switch back to IDLE state"), this.resetStartWhenNotLoaded(this.trackId), this.state = i.State.IDLE);
                                                break;
                                            case i.State.WAITING_INIT_PTS:
                                                var c = this.waitingData;
                                                if (c) {
                                                    var d = c.frag, f = c.part, h = c.cache, p = c.complete;
                                                    if (void 0 !== this.initPTS[d.cc]) {
                                                        this.waitingData = null, this.waitingVideoCC = -1, this.state = i.State.FRAG_LOADING;
                                                        var m = {
                                                            frag: d,
                                                            part: f,
                                                            payload: h.flush(),
                                                            networkDetails: null
                                                        };
                                                        this._handleFragmentLoadProgress(m), p && e.prototype._handleFragmentLoadComplete.call(this, m);
                                                    } else if (this.videoTrackCC !== this.waitingVideoCC) this.log("Waiting fragment cc (" + d.cc + ") cancelled because video is at cc " + this.videoTrackCC), this.clearWaitingFragment();
                                                    else {
                                                        var v = this.getLoadPosition(), y = o.BufferHelper.bufferInfo(this.mediaBuffer, v, this.config.maxBufferHole);
                                                        (0, g.fragmentWithinToleranceTest)(y.end, this.config.maxFragLookUpTolerance, d) < 0 && (this.log("Waiting fragment cc (" + d.cc + ") @ " + d.start + " cancelled because another fragment at " + y.end + " is needed"), this.clearWaitingFragment());
                                                    }
                                                } else this.state = i.State.IDLE;
                                        }
                                        this.onTickEnd();
                                    }, T.clearWaitingFragment = function() {
                                        var e = this.waitingData;
                                        e && (this.fragmentTracker.removeFragment(e.frag), this.waitingData = null, this.waitingVideoCC = -1, this.state = i.State.IDLE);
                                    }, T.resetLoadingState = function() {
                                        this.clearWaitingFragment(), e.prototype.resetLoadingState.call(this);
                                    }, T.onTickEnd = function() {
                                        var e = this.media;
                                        if (e && e.readyState) {
                                            var t = (this.mediaBuffer ? this.mediaBuffer : e).buffered;
                                            !this.loadedmetadata && t.length && (this.loadedmetadata = !0), this.lastCurrentTime = e.currentTime;
                                        }
                                    }, T.doTickIdle = function() {
                                        var e, t, n = this.hls, r = this.levels, o = this.media, s1 = this.trackId, u = n.config;
                                        if (r && r[s1] && (o || !this.startFragRequested && u.startFragPrefetch)) {
                                            var d = r[s1].details;
                                            if (!d || d.live && this.levelLastLoaded !== s1 || this.waitForCdnTuneIn(d)) this.state = i.State.WAITING_TRACK;
                                            else {
                                                var f = this.mediaBuffer ? this.mediaBuffer : this.media;
                                                this.bufferFlushed && f && (this.bufferFlushed = !1, this.afterBufferFlushed(f, c.ElementaryStreamTypes.AUDIO, l.PlaylistLevelType.AUDIO));
                                                var h = this.getFwdBufferInfo(f, l.PlaylistLevelType.AUDIO);
                                                if (null !== h) {
                                                    var g = this.getFwdBufferInfo(this.videoBuffer ? this.videoBuffer : this.media, l.PlaylistLevelType.MAIN), p = h.len, m = this.getMaxBufferLength(null == g ? void 0 : g.len), v = this.audioSwitch;
                                                    if (!(p >= m) || v) {
                                                        if (!v && this._streamEnded(h, d)) return n.trigger(a1.Events.BUFFER_EOS, {
                                                            type: "audio"
                                                        }), void (this.state = i.State.ENDED);
                                                        var y = d.fragments[0].start, E = h.end;
                                                        if (v && o) {
                                                            var T = this.getLoadPosition();
                                                            E = T, d.PTSKnown && T < y && (h.end > y || h.nextStart) && (this.log("Alt audio track ahead of main track, seek to start of alt audio track"), o.currentTime = y + .05);
                                                        }
                                                        if (!(g && E > g.end + d.targetduration) && (g && g.len || !h.len)) {
                                                            var b = this.getNextFragment(E, d);
                                                            b ? "identity" !== (null === (e = b.decryptdata) || void 0 === e ? void 0 : e.keyFormat) || null !== (t = b.decryptdata) && void 0 !== t && t.key ? this.loadFragment(b, d, E) : this.loadKey(b, d) : this.bufferFlushed = !0;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }, T.getMaxBufferLength = function(t) {
                                        var n = e.prototype.getMaxBufferLength.call(this);
                                        return t ? Math.max(n, t) : n;
                                    }, T.onMediaDetaching = function() {
                                        this.videoBuffer = null, e.prototype.onMediaDetaching.call(this);
                                    }, T.onAudioTracksUpdated = function(e, t) {
                                        var n = t.audioTracks;
                                        this.resetTransmuxer(), this.levels = n.map(function(e) {
                                            return new u.Level(e);
                                        });
                                    }, T.onAudioTrackSwitching = function(e, t) {
                                        var n = !!t.url;
                                        this.trackId = t.id;
                                        var r = this.fragCurrent;
                                        null != r && r.loader && r.loader.abort(), this.fragCurrent = null, this.clearWaitingFragment(), n ? this.setInterval(100) : this.resetTransmuxer(), n ? (this.audioSwitch = !0, this.state = i.State.IDLE) : this.state = i.State.STOPPED, this.tick();
                                    }, T.onManifestLoading = function() {
                                        this.mainDetails = null, this.fragmentTracker.removeAllFragments(), this.startPosition = this.lastCurrentTime = 0, this.bufferFlushed = !1;
                                    }, T.onLevelLoaded = function(e, t) {
                                        this.mainDetails = t.details, null !== this.cachedTrackLoadedData && (this.hls.trigger(a1.Events.AUDIO_TRACK_LOADED, this.cachedTrackLoadedData), this.cachedTrackLoadedData = null);
                                    }, T.onAudioTrackLoaded = function(e, t) {
                                        var n;
                                        if (null != this.mainDetails) {
                                            var r = this.levels, a1 = t.details, o = t.id;
                                            if (r) {
                                                this.log("Track " + o + " loaded [" + a1.startSN + "," + a1.endSN + "],duration:" + a1.totalduration);
                                                var s1 = r[o], u = 0;
                                                if (a1.live || null !== (n = s1.details) && void 0 !== n && n.live) {
                                                    var l = this.mainDetails;
                                                    if (a1.fragments[0] || (a1.deltaUpdateFailed = !0), a1.deltaUpdateFailed || !l) return;
                                                    !s1.details && a1.hasProgramDateTime && l.hasProgramDateTime ? ((0, p.alignMediaPlaylistByPDT)(a1, l), u = a1.fragments[0].start) : u = this.alignPlaylists(a1, s1.details);
                                                }
                                                s1.details = a1, this.levelLastLoaded = o, this.startFragRequested || !this.mainDetails && a1.live || this.setStartPosition(s1.details, u), this.state !== i.State.WAITING_TRACK || this.waitForCdnTuneIn(a1) || (this.state = i.State.IDLE), this.tick();
                                            } else this.warn("Audio tracks were reset while loading level " + o);
                                        } else this.cachedTrackLoadedData = t;
                                    }, T._handleFragmentLoadProgress = function(e) {
                                        var t, n = e.frag, r = e.part, a1 = e.payload, o = this.config, s1 = this.trackId, u = this.levels;
                                        if (u) {
                                            var c = u[s1];
                                            console.assert(c, "Audio track is defined on fragment load progress");
                                            var g = c.details;
                                            console.assert(g, "Audio track details are defined on fragment load progress");
                                            var p = o.defaultAudioCodec || c.audioCodec || "mp4a.40.2", m = this.transmuxer;
                                            m || (m = this.transmuxer = new f.default(this.hls, l.PlaylistLevelType.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)));
                                            var v = this.initPTS[n.cc], y = null === (t = n.initSegment) || void 0 === t ? void 0 : t.data;
                                            if (void 0 !== v) {
                                                var E = r ? r.index : -1, T = -1 !== E, b = new h.ChunkMetadata(n.level, n.sn, n.stats.chunkCount, a1.byteLength, E, T);
                                                m.push(a1, y, p, "", n, r, g.totalduration, !1, b, v);
                                            } else this.log("Unknown video PTS for cc " + n.cc + ", waiting for video PTS before demuxing audio frag " + n.sn + " of [" + g.startSN + " ," + g.endSN + "],track " + s1), (this.waitingData = this.waitingData || {
                                                frag: n,
                                                part: r,
                                                cache: new d.default,
                                                complete: !1
                                            }).cache.push(new Uint8Array(a1)), this.waitingVideoCC = this.videoTrackCC, this.state = i.State.WAITING_INIT_PTS;
                                        } else this.warn("Audio tracks were reset while fragment load was in progress. Fragment " + n.sn + " of level " + n.level + " will not be buffered");
                                    }, T._handleFragmentLoadComplete = function(t) {
                                        this.waitingData ? this.waitingData.complete = !0 : e.prototype._handleFragmentLoadComplete.call(this, t);
                                    }, T.onBufferReset = function() {
                                        this.mediaBuffer = this.videoBuffer = null, this.loadedmetadata = !1;
                                    }, T.onBufferCreated = function(e, t) {
                                        var n = t.tracks.audio;
                                        n && (this.mediaBuffer = n.buffer || null), t.tracks.video && (this.videoBuffer = t.tracks.video.buffer || null);
                                    }, T.onFragBuffered = function(e, t) {
                                        var n = t.frag, r = t.part;
                                        n.type === l.PlaylistLevelType.AUDIO && (this.fragContextChanged(n) ? this.warn("Fragment " + n.sn + (r ? " p: " + r.index : "") + " of level " + n.level + " finished buffering, but was aborted. state: " + this.state + ", audioSwitch: " + this.audioSwitch) : ("initSegment" !== n.sn && (this.fragPrevious = n, this.audioSwitch && (this.audioSwitch = !1, this.hls.trigger(a1.Events.AUDIO_TRACK_SWITCHED, {
                                            id: this.trackId
                                        }))), this.fragBufferedComplete(n, r)));
                                    }, T.onError = function(t, n) {
                                        switch(n.details){
                                            case m.ErrorDetails.FRAG_LOAD_ERROR:
                                            case m.ErrorDetails.FRAG_LOAD_TIMEOUT:
                                            case m.ErrorDetails.KEY_LOAD_ERROR:
                                            case m.ErrorDetails.KEY_LOAD_TIMEOUT:
                                                this.onFragmentOrKeyLoadError(l.PlaylistLevelType.AUDIO, n);
                                                break;
                                            case m.ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
                                            case m.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
                                                this.state !== i.State.ERROR && this.state !== i.State.STOPPED && (this.state = n.fatal ? i.State.ERROR : i.State.IDLE, this.warn(n.details + " while loading frag, switching to " + this.state + " state"));
                                                break;
                                            case m.ErrorDetails.BUFFER_FULL_ERROR:
                                                if ("audio" === n.parent && (this.state === i.State.PARSING || this.state === i.State.PARSED)) {
                                                    var r = !0, a1 = this.getFwdBufferInfo(this.mediaBuffer, l.PlaylistLevelType.AUDIO);
                                                    a1 && a1.len > .5 && (r = !this.reduceMaxBufferLength(a1.len)), r && (this.warn("Buffer full error also media.currentTime is not buffered, flush audio buffer"), this.fragCurrent = null, e.prototype.flushMainBuffer.call(this, 0, Number.POSITIVE_INFINITY, "audio")), this.resetLoadingState();
                                                }
                                        }
                                    }, T.onBufferFlushed = function(e, t) {
                                        t.type === c.ElementaryStreamTypes.AUDIO && (this.bufferFlushed = !0);
                                    }, T._handleTransmuxComplete = function(e) {
                                        var t, n = "audio", r = this.hls, o = e.remuxResult, s1 = e.chunkMeta, u = this.getCurrentContext(s1);
                                        if (!u) return this.warn("The loading context changed while buffering fragment " + s1.sn + " of level " + s1.level + ". This chunk will not be buffered."), void this.resetStartWhenNotLoaded(s1.level);
                                        var l = u.frag, d = u.part, f = u.level.details, h = o.audio, g = o.text, p = o.id3, m = o.initSegment;
                                        if (!this.fragContextChanged(l) && f) {
                                            if (this.state = i.State.PARSING, this.audioSwitch && h && this.completeAudioSwitch(), null != m && m.tracks && (this._bufferInitSegment(m.tracks, l, s1), r.trigger(a1.Events.FRAG_PARSING_INIT_SEGMENT, {
                                                frag: l,
                                                id: n,
                                                tracks: m.tracks
                                            })), h) {
                                                var y = h.startPTS, E = h.endPTS, T = h.startDTS, b = h.endDTS;
                                                d && (d.elementaryStreams[c.ElementaryStreamTypes.AUDIO] = {
                                                    startPTS: y,
                                                    endPTS: E,
                                                    startDTS: T,
                                                    endDTS: b
                                                }), l.setElementaryStreamInfo(c.ElementaryStreamTypes.AUDIO, y, E, T, b), this.bufferFragmentData(h, l, d, s1);
                                            }
                                            if (null != p && null !== (t = p.samples) && void 0 !== t && t.length) {
                                                var A = v({
                                                    id: n,
                                                    frag: l,
                                                    details: f
                                                }, p);
                                                r.trigger(a1.Events.FRAG_PARSING_METADATA, A);
                                            }
                                            if (g) {
                                                var _ = v({
                                                    id: n,
                                                    frag: l,
                                                    details: f
                                                }, g);
                                                r.trigger(a1.Events.FRAG_PARSING_USERDATA, _);
                                            }
                                        }
                                    }, T._bufferInitSegment = function(e, t, n) {
                                        if (this.state === i.State.PARSING) {
                                            e.video && delete e.video;
                                            var r = e.audio;
                                            if (r) {
                                                r.levelCodec = r.codec, r.id = "audio", this.log("Init audio buffer, container:" + r.container + ", codecs[parsed]=[" + r.codec + "]"), this.hls.trigger(a1.Events.BUFFER_CODECS, e);
                                                var o = r.initSegment;
                                                if (null != o && o.byteLength) {
                                                    var s1 = {
                                                        type: "audio",
                                                        frag: t,
                                                        part: null,
                                                        chunkMeta: n,
                                                        parent: t.type,
                                                        data: o
                                                    };
                                                    this.hls.trigger(a1.Events.BUFFER_APPENDING, s1);
                                                }
                                                this.tick();
                                            }
                                        }
                                    }, T.loadFragment = function(t, n, a1) {
                                        var o = this.fragmentTracker.getState(t);
                                        this.fragCurrent = t, (this.audioSwitch || o === s1.FragmentState.NOT_LOADED || o === s1.FragmentState.PARTIAL) && ("initSegment" === t.sn ? this._loadInitSegment(t) : n.live && !(0, r.isFiniteNumber)(this.initPTS[t.cc]) ? (this.log("Waiting for video PTS in continuity counter " + t.cc + " of live stream before loading audio fragment " + t.sn + " of level " + this.trackId), this.state = i.State.WAITING_INIT_PTS) : (this.startFragRequested = !0, e.prototype.loadFragment.call(this, t, n, a1)));
                                    }, T.completeAudioSwitch = function() {
                                        var t = this.hls, n = this.media, r = this.trackId;
                                        n && (this.log("Switching audio track : flushing all audio"), e.prototype.flushMainBuffer.call(this, 0, Number.POSITIVE_INFINITY, "audio")), this.audioSwitch = !1, t.trigger(a1.Events.AUDIO_TRACK_SWITCHED, {
                                            id: r
                                        });
                                    }, E;
                                }(i.default);
                            },
                            "./src/controller/audio-track-controller.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>l
                                });
                                var r = n("./src/events.ts"), i = n("./src/errors.ts"), a1 = n("./src/controller/base-playlist-controller.ts"), o = n("./src/types/loader.ts");
                                function s1(e, t) {
                                    for(var n = 0; n < t.length; n++){
                                        var r = t[n];
                                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                    }
                                }
                                function u(e, t) {
                                    return u = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, u(e, t);
                                }
                                const l = function(e) {
                                    var t, n;
                                    function a1(t) {
                                        var n;
                                        return (n = e.call(this, t, "[audio-track-controller]") || this).tracks = [], n.groupId = null, n.tracksInGroup = [], n.trackId = -1, n.trackName = "", n.selectDefaultTrack = !0, n.registerListeners(), n;
                                    }
                                    n = e, (t = a1).prototype = Object.create(n.prototype), t.prototype.constructor = t, u(t, n);
                                    var l, c, d = a1.prototype;
                                    return d.registerListeners = function() {
                                        var e = this.hls;
                                        e.on(r.Events.MANIFEST_LOADING, this.onManifestLoading, this), e.on(r.Events.MANIFEST_PARSED, this.onManifestParsed, this), e.on(r.Events.LEVEL_LOADING, this.onLevelLoading, this), e.on(r.Events.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(r.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(r.Events.ERROR, this.onError, this);
                                    }, d.unregisterListeners = function() {
                                        var e = this.hls;
                                        e.off(r.Events.MANIFEST_LOADING, this.onManifestLoading, this), e.off(r.Events.MANIFEST_PARSED, this.onManifestParsed, this), e.off(r.Events.LEVEL_LOADING, this.onLevelLoading, this), e.off(r.Events.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(r.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(r.Events.ERROR, this.onError, this);
                                    }, d.destroy = function() {
                                        this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, e.prototype.destroy.call(this);
                                    }, d.onManifestLoading = function() {
                                        this.tracks = [], this.groupId = null, this.tracksInGroup = [], this.trackId = -1, this.trackName = "", this.selectDefaultTrack = !0;
                                    }, d.onManifestParsed = function(e, t) {
                                        this.tracks = t.audioTracks || [];
                                    }, d.onAudioTrackLoaded = function(e, t) {
                                        var n = t.id, r = t.details, i = this.tracksInGroup[n];
                                        if (i) {
                                            var a1 = i.details;
                                            i.details = t.details, this.log("audioTrack " + n + " loaded [" + r.startSN + "-" + r.endSN + "]"), n === this.trackId && (this.retryCount = 0, this.playlistLoaded(n, t, a1));
                                        } else this.warn("Invalid audio track id " + n);
                                    }, d.onLevelLoading = function(e, t) {
                                        this.switchLevel(t.level);
                                    }, d.onLevelSwitching = function(e, t) {
                                        this.switchLevel(t.level);
                                    }, d.switchLevel = function(e) {
                                        var t = this.hls.levels[e];
                                        if (null != t && t.audioGroupIds) {
                                            var n = t.audioGroupIds[t.urlId];
                                            if (this.groupId !== n) {
                                                this.groupId = n;
                                                var i = this.tracks.filter(function(e) {
                                                    return !n || e.groupId === n;
                                                });
                                                this.selectDefaultTrack && !i.some(function(e) {
                                                    return e.default;
                                                }) && (this.selectDefaultTrack = !1), this.tracksInGroup = i;
                                                var a1 = {
                                                    audioTracks: i
                                                };
                                                this.log("Updating audio tracks, " + i.length + ' track(s) found in "' + n + '" group-id'), this.hls.trigger(r.Events.AUDIO_TRACKS_UPDATED, a1), this.selectInitialTrack();
                                            }
                                        }
                                    }, d.onError = function(t, n) {
                                        e.prototype.onError.call(this, t, n), !n.fatal && n.context && n.context.type === o.PlaylistContextType.AUDIO_TRACK && n.context.id === this.trackId && n.context.groupId === this.groupId && this.retryLoadingOrFail(n);
                                    }, d.setAudioTrack = function(e) {
                                        var t = this.tracksInGroup;
                                        if (e < 0 || e >= t.length) this.warn("Invalid id passed to audio-track controller");
                                        else {
                                            this.clearTimer();
                                            var n = t[this.trackId];
                                            this.log("Now switching to audio-track index " + e);
                                            var i = t[e], a1 = i.id, o = i.groupId, s1 = void 0 === o ? "" : o, u = i.name, l = i.type, c = i.url;
                                            if (this.trackId = e, this.trackName = u, this.selectDefaultTrack = !1, this.hls.trigger(r.Events.AUDIO_TRACK_SWITCHING, {
                                                id: a1,
                                                groupId: s1,
                                                name: u,
                                                type: l,
                                                url: c
                                            }), !i.details || i.details.live) {
                                                var d = this.switchParams(i.url, null == n ? void 0 : n.details);
                                                this.loadPlaylist(d);
                                            }
                                        }
                                    }, d.selectInitialTrack = function() {
                                        var e = this.tracksInGroup;
                                        console.assert(e.length, "Initial audio track should be selected when tracks are known");
                                        var t = this.trackName, n = this.findTrackId(t) || this.findTrackId();
                                        -1 !== n ? this.setAudioTrack(n) : (this.warn("No track found for running audio group-ID: " + this.groupId), this.hls.trigger(r.Events.ERROR, {
                                            type: i.ErrorTypes.MEDIA_ERROR,
                                            details: i.ErrorDetails.AUDIO_TRACK_LOAD_ERROR,
                                            fatal: !0
                                        }));
                                    }, d.findTrackId = function(e) {
                                        for(var t = this.tracksInGroup, n = 0; n < t.length; n++){
                                            var r = t[n];
                                            if ((!this.selectDefaultTrack || r.default) && (!e || e === r.name)) return r.id;
                                        }
                                        return -1;
                                    }, d.loadPlaylist = function(e) {
                                        var t = this.tracksInGroup[this.trackId];
                                        if (this.shouldLoadTrack(t)) {
                                            var n = t.id, i = t.groupId, a1 = t.url;
                                            if (e) try {
                                                a1 = e.addDirectives(a1);
                                            } catch (e) {
                                                this.warn("Could not construct new URL with HLS Delivery Directives: " + e);
                                            }
                                            this.log("loading audio-track playlist for id: " + n), this.clearTimer(), this.hls.trigger(r.Events.AUDIO_TRACK_LOADING, {
                                                url: a1,
                                                id: n,
                                                groupId: i,
                                                deliveryDirectives: e || null
                                            });
                                        }
                                    }, l = a1, c = [
                                        {
                                            key: "audioTracks",
                                            get: function() {
                                                return this.tracksInGroup;
                                            }
                                        },
                                        {
                                            key: "audioTrack",
                                            get: function() {
                                                return this.trackId;
                                            },
                                            set: function(e) {
                                                this.selectDefaultTrack = !1, this.setAudioTrack(e);
                                            }
                                        }
                                    ], s1(l.prototype, c), Object.defineProperty(l, "prototype", {
                                        writable: !1
                                    }), a1;
                                }(a1.default);
                            },
                            "./src/controller/base-playlist-controller.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>u
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./src/types/level.ts"), a1 = n("./src/controller/level-helper.ts"), o = n("./src/utils/logger.ts"), s1 = n("./src/errors.ts"), u = function() {
                                    function e(e, t) {
                                        this.hls = void 0, this.timer = -1, this.canLoad = !1, this.retryCount = 0, this.log = void 0, this.warn = void 0, this.log = o.logger.log.bind(o.logger, t + ":"), this.warn = o.logger.warn.bind(o.logger, t + ":"), this.hls = e;
                                    }
                                    var t = e.prototype;
                                    return t.destroy = function() {
                                        this.clearTimer(), this.hls = this.log = this.warn = null;
                                    }, t.onError = function(e, t) {
                                        t.fatal && t.type === s1.ErrorTypes.NETWORK_ERROR && this.clearTimer();
                                    }, t.clearTimer = function() {
                                        clearTimeout(this.timer), this.timer = -1;
                                    }, t.startLoad = function() {
                                        this.canLoad = !0, this.retryCount = 0, this.loadPlaylist();
                                    }, t.stopLoad = function() {
                                        this.canLoad = !1, this.clearTimer();
                                    }, t.switchParams = function(e, t) {
                                        var n = null == t ? void 0 : t.renditionReports;
                                        if (n) for(var a1 = 0; a1 < n.length; a1++){
                                            var o = n[a1], s1 = "" + o.URI;
                                            if (s1 === e.slice(-s1.length)) {
                                                var u = parseInt(o["LAST-MSN"]), l = parseInt(o["LAST-PART"]);
                                                if (t && this.hls.config.lowLatencyMode) {
                                                    var c = Math.min(t.age - t.partTarget, t.targetduration);
                                                    void 0 !== l && c > t.partTarget && (l += 1);
                                                }
                                                if ((0, r.isFiniteNumber)(u)) return new i.HlsUrlParameters(u, (0, r.isFiniteNumber)(l) ? l : void 0, i.HlsSkip.No);
                                            }
                                        }
                                    }, t.loadPlaylist = function(e) {}, t.shouldLoadTrack = function(e) {
                                        return this.canLoad && e && !!e.url && (!e.details || e.details.live);
                                    }, t.playlistLoaded = function(e, t, n) {
                                        var r = this, i = t.details, o = t.stats, s1 = o.loading.end ? Math.max(0, self.performance.now() - o.loading.end) : 0;
                                        if (i.advancedDateTime = Date.now() - s1, i.live || null != n && n.live) {
                                            if (i.reloaded(n), n && this.log("live playlist " + e + " " + (i.advanced ? "REFRESHED " + i.lastPartSn + "-" + i.lastPartIndex : "MISSED")), n && i.fragments.length > 0 && (0, a1.mergeDetails)(n, i), !this.canLoad || !i.live) return;
                                            var u, l = void 0, c = void 0;
                                            if (i.canBlockReload && i.endSN && i.advanced) {
                                                var d = this.hls.config.lowLatencyMode, f = i.lastPartSn, h = i.endSN, g = i.lastPartIndex, p = f === h;
                                                -1 !== g ? (l = p ? h + 1 : f, c = p ? d ? 0 : g : g + 1) : l = h + 1;
                                                var m = i.age, v = m + i.ageHeader, y = Math.min(v - i.partTarget, 1.5 * i.targetduration);
                                                if (y > 0) {
                                                    if (n && y > n.tuneInGoal) this.warn("CDN Tune-in goal increased from: " + n.tuneInGoal + " to: " + y + " with playlist age: " + i.age), y = 0;
                                                    else {
                                                        var E = Math.floor(y / i.targetduration);
                                                        l += E, void 0 !== c && (c += Math.round(y % i.targetduration / i.partTarget)), this.log("CDN Tune-in age: " + i.ageHeader + "s last advanced " + m.toFixed(2) + "s goal: " + y + " skip sn " + E + " to part " + c);
                                                    }
                                                    i.tuneInGoal = y;
                                                }
                                                if (u = this.getDeliveryDirectives(i, t.deliveryDirectives, l, c), d || !p) return void this.loadPlaylist(u);
                                            } else u = this.getDeliveryDirectives(i, t.deliveryDirectives, l, c);
                                            var T = (0, a1.computeReloadInterval)(i, o);
                                            void 0 !== l && i.canBlockReload && (T -= i.partTarget || 1), this.log("reload live playlist " + e + " in " + Math.round(T) + " ms"), this.timer = self.setTimeout(function() {
                                                return r.loadPlaylist(u);
                                            }, T);
                                        } else this.clearTimer();
                                    }, t.getDeliveryDirectives = function(e, t, n, r) {
                                        var a1 = (0, i.getSkipValue)(e, n);
                                        return null != t && t.skip && e.deltaUpdateFailed && (n = t.msn, r = t.part, a1 = i.HlsSkip.No), new i.HlsUrlParameters(n, r, a1);
                                    }, t.retryLoadingOrFail = function(e) {
                                        var t, n = this, r = this.hls.config, i = this.retryCount < r.levelLoadingMaxRetry;
                                        if (i) {
                                            if (this.retryCount++, e.details.indexOf("LoadTimeOut") > -1 && null !== (t = e.context) && void 0 !== t && t.deliveryDirectives) this.warn("retry playlist loading #" + this.retryCount + ' after "' + e.details + '"'), this.loadPlaylist();
                                            else {
                                                var a1 = Math.min(Math.pow(2, this.retryCount) * r.levelLoadingRetryDelay, r.levelLoadingMaxRetryTimeout);
                                                this.timer = self.setTimeout(function() {
                                                    return n.loadPlaylist();
                                                }, a1), this.warn("retry playlist loading #" + this.retryCount + " in " + a1 + ' ms after "' + e.details + '"');
                                            }
                                        } else this.warn('cannot recover from error "' + e.details + '"'), this.clearTimer(), e.fatal = !0;
                                        return i;
                                    }, e;
                                }();
                            },
                            "./src/controller/base-stream-controller.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    State: ()=>A,
                                    default: ()=>_
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./src/task-loop.ts"), a1 = n("./src/controller/fragment-tracker.ts"), o = n("./src/utils/buffer-helper.ts"), s1 = n("./src/utils/logger.ts"), u = n("./src/events.ts"), l = n("./src/errors.ts"), c = n("./src/types/transmuxer.ts"), d = n("./src/utils/mp4-tools.ts"), f = n("./src/utils/discontinuities.ts"), h = n("./src/controller/fragment-finders.ts"), g = n("./src/controller/level-helper.ts"), p = n("./src/loader/fragment-loader.ts"), m = n("./src/crypt/decrypter.ts"), v = n("./src/utils/time-ranges.ts"), y = n("./src/types/loader.ts");
                                function E(e, t) {
                                    for(var n = 0; n < t.length; n++){
                                        var r = t[n];
                                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                    }
                                }
                                function T(e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e;
                                }
                                function b(e, t) {
                                    return b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, b(e, t);
                                }
                                var A = {
                                    STOPPED: "STOPPED",
                                    IDLE: "IDLE",
                                    KEY_LOADING: "KEY_LOADING",
                                    FRAG_LOADING: "FRAG_LOADING",
                                    FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
                                    WAITING_TRACK: "WAITING_TRACK",
                                    PARSING: "PARSING",
                                    PARSED: "PARSED",
                                    ENDED: "ENDED",
                                    ERROR: "ERROR",
                                    WAITING_INIT_PTS: "WAITING_INIT_PTS",
                                    WAITING_LEVEL: "WAITING_LEVEL"
                                }, _ = function(e) {
                                    var t, n;
                                    function i(t, n, r) {
                                        var i;
                                        return (i = e.call(this) || this).hls = void 0, i.fragPrevious = null, i.fragCurrent = null, i.fragmentTracker = void 0, i.transmuxer = null, i._state = A.STOPPED, i.media = null, i.mediaBuffer = null, i.config = void 0, i.bitrateTest = !1, i.lastCurrentTime = 0, i.nextLoadPosition = 0, i.startPosition = 0, i.loadedmetadata = !1, i.fragLoadError = 0, i.retryDate = 0, i.levels = null, i.fragmentLoader = void 0, i.levelLastLoaded = null, i.startFragRequested = !1, i.decrypter = void 0, i.initPTS = [], i.onvseeking = null, i.onvended = null, i.logPrefix = "", i.log = void 0, i.warn = void 0, i.logPrefix = r, i.log = s1.logger.log.bind(s1.logger, r + ":"), i.warn = s1.logger.warn.bind(s1.logger, r + ":"), i.hls = t, i.fragmentLoader = new p.default(t.config), i.fragmentTracker = n, i.config = t.config, i.decrypter = new m.default(t, t.config), t.on(u.Events.KEY_LOADED, i.onKeyLoaded, T(i)), t.on(u.Events.LEVEL_SWITCHING, i.onLevelSwitching, T(i)), i;
                                    }
                                    n = e, (t = i).prototype = Object.create(n.prototype), t.prototype.constructor = t, b(t, n);
                                    var _, S, w = i.prototype;
                                    return w.doTick = function() {
                                        this.onTickEnd();
                                    }, w.onTickEnd = function() {}, w.startLoad = function(e) {}, w.stopLoad = function() {
                                        this.fragmentLoader.abort();
                                        var e = this.fragCurrent;
                                        e && this.fragmentTracker.removeFragment(e), this.resetTransmuxer(), this.fragCurrent = null, this.fragPrevious = null, this.clearInterval(), this.clearNextTick(), this.state = A.STOPPED;
                                    }, w._streamEnded = function(e, t) {
                                        var n = this.fragCurrent, r = this.fragmentTracker;
                                        if (!t.live && n && this.media && n.sn >= t.endSN && !e.nextStart) {
                                            var i = t.partList;
                                            if (null != i && i.length) {
                                                var s1 = i[i.length - 1];
                                                return o.BufferHelper.isBuffered(this.media, s1.start + s1.duration / 2);
                                            }
                                            var u = r.getState(n);
                                            return u === a1.FragmentState.PARTIAL || u === a1.FragmentState.OK;
                                        }
                                        return !1;
                                    }, w.onMediaAttached = function(e, t) {
                                        var n = this.media = this.mediaBuffer = t.media;
                                        this.onvseeking = this.onMediaSeeking.bind(this), this.onvended = this.onMediaEnded.bind(this), n.addEventListener("seeking", this.onvseeking), n.addEventListener("ended", this.onvended);
                                        var r = this.config;
                                        this.levels && r.autoStartLoad && this.state === A.STOPPED && this.startLoad(r.startPosition);
                                    }, w.onMediaDetaching = function() {
                                        var e = this.media;
                                        null != e && e.ended && (this.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0), e && this.onvseeking && this.onvended && (e.removeEventListener("seeking", this.onvseeking), e.removeEventListener("ended", this.onvended), this.onvseeking = this.onvended = null), this.media = this.mediaBuffer = null, this.loadedmetadata = !1, this.fragmentTracker.removeAllFragments(), this.stopLoad();
                                    }, w.onMediaSeeking = function() {
                                        var e = this.config, t = this.fragCurrent, n = this.media, i = this.mediaBuffer, a1 = this.state, s1 = n ? n.currentTime : 0, u = o.BufferHelper.bufferInfo(i || n, s1, e.maxBufferHole);
                                        if (this.log("media seeking to " + ((0, r.isFiniteNumber)(s1) ? s1.toFixed(3) : s1) + ", state: " + a1), a1 === A.ENDED) this.resetLoadingState();
                                        else if (t && !u.len) {
                                            var l = e.maxFragLookUpTolerance, c = t.start - l, d = s1 > t.start + t.duration + l;
                                            (s1 < c || d) && (d && t.loader && (this.log("seeking outside of buffer while fragment load in progress, cancel fragment load"), t.loader.abort()), this.resetLoadingState());
                                        }
                                        n && (this.lastCurrentTime = s1), this.loadedmetadata || u.len || (this.nextLoadPosition = this.startPosition = s1), this.tickImmediate();
                                    }, w.onMediaEnded = function() {
                                        this.startPosition = this.lastCurrentTime = 0;
                                    }, w.onKeyLoaded = function(e, t) {
                                        if (this.state === A.KEY_LOADING && t.frag === this.fragCurrent && this.levels) {
                                            this.state = A.IDLE;
                                            var n = this.levels[t.frag.level].details;
                                            n && this.loadFragment(t.frag, n, t.frag.start);
                                        }
                                    }, w.onLevelSwitching = function(e, t) {
                                        this.fragLoadError = 0;
                                    }, w.onHandlerDestroying = function() {
                                        this.stopLoad(), e.prototype.onHandlerDestroying.call(this);
                                    }, w.onHandlerDestroyed = function() {
                                        this.state = A.STOPPED, this.hls.off(u.Events.KEY_LOADED, this.onKeyLoaded, this), this.hls.off(u.Events.LEVEL_SWITCHING, this.onLevelSwitching, this), this.fragmentLoader && this.fragmentLoader.destroy(), this.decrypter && this.decrypter.destroy(), this.hls = this.log = this.warn = this.decrypter = this.fragmentLoader = this.fragmentTracker = null, e.prototype.onHandlerDestroyed.call(this);
                                    }, w.loadKey = function(e, t) {
                                        this.log("Loading key for " + e.sn + " of [" + t.startSN + "-" + t.endSN + "], " + ("[stream-controller]" === this.logPrefix ? "level" : "track") + " " + e.level), this.state = A.KEY_LOADING, this.fragCurrent = e, this.hls.trigger(u.Events.KEY_LOADING, {
                                            frag: e
                                        });
                                    }, w.loadFragment = function(e, t, n) {
                                        this._loadFragForPlayback(e, t, n);
                                    }, w._loadFragForPlayback = function(e, t, n) {
                                        var r = this;
                                        this._doFragLoad(e, t, n, function(t) {
                                            if (r.fragContextChanged(e)) return r.warn("Fragment " + e.sn + (t.part ? " p: " + t.part.index : "") + " of level " + e.level + " was dropped during download."), void r.fragmentTracker.removeFragment(e);
                                            e.stats.chunkCount++, r._handleFragmentLoadProgress(t);
                                        }).then(function(t) {
                                            if (t) {
                                                r.fragLoadError = 0;
                                                var n = r.state;
                                                r.fragContextChanged(e) ? (n === A.FRAG_LOADING || !r.fragCurrent && n === A.PARSING) && (r.fragmentTracker.removeFragment(e), r.state = A.IDLE) : ("payload" in t && (r.log("Loaded fragment " + e.sn + " of level " + e.level), r.hls.trigger(u.Events.FRAG_LOADED, t)), r._handleFragmentLoadComplete(t));
                                            }
                                        }).catch(function(t) {
                                            r.state !== A.STOPPED && r.state !== A.ERROR && (r.warn(t), r.resetFragmentLoading(e));
                                        });
                                    }, w.flushMainBuffer = function(e, t, n) {
                                        if (void 0 === n && (n = null), e - t) {
                                            var r = {
                                                startOffset: e,
                                                endOffset: t,
                                                type: n
                                            };
                                            this.fragLoadError = 0, this.hls.trigger(u.Events.BUFFER_FLUSHING, r);
                                        }
                                    }, w._loadInitSegment = function(e) {
                                        var t = this;
                                        this._doFragLoad(e).then(function(n) {
                                            if (!n || t.fragContextChanged(e) || !t.levels) throw new Error("init load aborted");
                                            return n;
                                        }).then(function(n) {
                                            var r = t.hls, i = n.payload, a1 = e.decryptdata;
                                            if (i && i.byteLength > 0 && a1 && a1.key && a1.iv && "AES-128" === a1.method) {
                                                var o = self.performance.now();
                                                return t.decrypter.webCryptoDecrypt(new Uint8Array(i), a1.key.buffer, a1.iv.buffer).then(function(t) {
                                                    var i = self.performance.now();
                                                    return r.trigger(u.Events.FRAG_DECRYPTED, {
                                                        frag: e,
                                                        payload: t,
                                                        stats: {
                                                            tstart: o,
                                                            tdecrypt: i
                                                        }
                                                    }), n.payload = t, n;
                                                });
                                            }
                                            return n;
                                        }).then(function(n) {
                                            var r = t.fragCurrent, i = t.hls, a1 = t.levels;
                                            if (!a1) throw new Error("init load aborted, missing levels");
                                            var o = a1[e.level].details;
                                            console.assert(o, "Level details are defined when init segment is loaded");
                                            var s1 = e.stats;
                                            t.state = A.IDLE, t.fragLoadError = 0, e.data = new Uint8Array(n.payload), s1.parsing.start = s1.buffering.start = self.performance.now(), s1.parsing.end = s1.buffering.end = self.performance.now(), n.frag === r && i.trigger(u.Events.FRAG_BUFFERED, {
                                                stats: s1,
                                                frag: r,
                                                part: null,
                                                id: e.type
                                            }), t.tick();
                                        }).catch(function(n) {
                                            t.state !== A.STOPPED && t.state !== A.ERROR && (t.warn(n), t.resetFragmentLoading(e));
                                        });
                                    }, w.fragContextChanged = function(e) {
                                        var t = this.fragCurrent;
                                        return !e || !t || e.level !== t.level || e.sn !== t.sn || e.urlId !== t.urlId;
                                    }, w.fragBufferedComplete = function(e, t) {
                                        var n, r, i = this.mediaBuffer ? this.mediaBuffer : this.media;
                                        this.log("Buffered " + e.type + " sn: " + e.sn + (t ? " part: " + t.index : "") + " of " + ("[stream-controller]" === this.logPrefix ? "level" : "track") + " " + e.level + " " + (i ? v.default.toString(o.BufferHelper.getBuffered(i)) : "(detached)")), this.state = A.IDLE, i && (!this.loadedmetadata && i.buffered.length && (null === (n = this.fragCurrent) || void 0 === n ? void 0 : n.sn) === (null === (r = this.fragPrevious) || void 0 === r ? void 0 : r.sn) && (this.loadedmetadata = !0, this.seekToStartPos()), this.tick());
                                    }, w.seekToStartPos = function() {}, w._handleFragmentLoadComplete = function(e) {
                                        var t = this.transmuxer;
                                        if (t) {
                                            var n = e.frag, r = e.part, i = e.partsLoaded, a1 = !i || 0 === i.length || i.some(function(e) {
                                                return !e;
                                            }), o = new c.ChunkMetadata(n.level, n.sn, n.stats.chunkCount + 1, 0, r ? r.index : -1, !a1);
                                            t.flush(o);
                                        }
                                    }, w._handleFragmentLoadProgress = function(e) {}, w._doFragLoad = function(e, t, n, i) {
                                        var a1 = this;
                                        if (void 0 === n && (n = null), !this.levels) throw new Error("frag load aborted, missing levels");
                                        if (n = Math.max(e.start, n || 0), this.config.lowLatencyMode && t) {
                                            var o = t.partList;
                                            if (o && i) {
                                                n > e.end && t.fragmentHint && (e = t.fragmentHint);
                                                var s1 = this.getNextPart(o, e, n);
                                                if (s1 > -1) {
                                                    var l = o[s1];
                                                    return this.log("Loading part sn: " + e.sn + " p: " + l.index + " cc: " + e.cc + " of playlist [" + t.startSN + "-" + t.endSN + "] parts [0-" + s1 + "-" + (o.length - 1) + "] " + ("[stream-controller]" === this.logPrefix ? "level" : "track") + ": " + e.level + ", target: " + parseFloat(n.toFixed(3))), this.nextLoadPosition = l.start + l.duration, this.state = A.FRAG_LOADING, this.hls.trigger(u.Events.FRAG_LOADING, {
                                                        frag: e,
                                                        part: o[s1],
                                                        targetBufferTime: n
                                                    }), this.doFragPartsLoad(e, o, s1, i).catch(function(e) {
                                                        return a1.handleFragLoadError(e);
                                                    });
                                                }
                                                if (!e.url || this.loadedEndOfParts(o, n)) return Promise.resolve(null);
                                            }
                                        }
                                        return this.log("Loading fragment " + e.sn + " cc: " + e.cc + " " + (t ? "of [" + t.startSN + "-" + t.endSN + "] " : "") + ("[stream-controller]" === this.logPrefix ? "level" : "track") + ": " + e.level + ", target: " + parseFloat(n.toFixed(3))), (0, r.isFiniteNumber)(e.sn) && !this.bitrateTest && (this.nextLoadPosition = e.start + e.duration), this.state = A.FRAG_LOADING, this.hls.trigger(u.Events.FRAG_LOADING, {
                                            frag: e,
                                            targetBufferTime: n
                                        }), this.fragmentLoader.load(e, i).catch(function(e) {
                                            return a1.handleFragLoadError(e);
                                        });
                                    }, w.doFragPartsLoad = function(e, t, n, r) {
                                        var i = this;
                                        return new Promise(function(a1, o) {
                                            var s1 = [];
                                            !function n(l) {
                                                var c = t[l];
                                                i.fragmentLoader.loadPart(e, c, r).then(function(r) {
                                                    s1[c.index] = r;
                                                    var o = r.part;
                                                    i.hls.trigger(u.Events.FRAG_LOADED, r);
                                                    var d = t[l + 1];
                                                    if (!d || d.fragment !== e) return a1({
                                                        frag: e,
                                                        part: o,
                                                        partsLoaded: s1
                                                    });
                                                    n(l + 1);
                                                }).catch(o);
                                            }(n);
                                        });
                                    }, w.handleFragLoadError = function(e) {
                                        var t = e.data;
                                        return t && t.details === l.ErrorDetails.INTERNAL_ABORTED ? this.handleFragLoadAborted(t.frag, t.part) : this.hls.trigger(u.Events.ERROR, t), null;
                                    }, w._handleTransmuxerFlush = function(e) {
                                        var t = this.getCurrentContext(e);
                                        if (t && this.state === A.PARSING) {
                                            var n = t.frag, r = t.part, i = t.level, a1 = self.performance.now();
                                            n.stats.parsing.end = a1, r && (r.stats.parsing.end = a1), this.updateLevelTiming(n, r, i, e.partial);
                                        } else this.fragCurrent || (this.state = A.IDLE);
                                    }, w.getCurrentContext = function(e) {
                                        var t = this.levels, n = e.level, r = e.sn, i = e.part;
                                        if (!t || !t[n]) return this.warn("Levels object was unset while buffering fragment " + r + " of level " + n + ". The current chunk will not be buffered."), null;
                                        var a1 = t[n], o = i > -1 ? (0, g.getPartWith)(a1, r, i) : null, s1 = o ? o.fragment : (0, g.getFragmentWithSN)(a1, r, this.fragCurrent);
                                        return s1 ? {
                                            frag: s1,
                                            part: o,
                                            level: a1
                                        } : null;
                                    }, w.bufferFragmentData = function(e, t, n, r) {
                                        if (e && this.state === A.PARSING) {
                                            var i = e.data1, a1 = e.data2, o = i;
                                            if (i && a1 && (o = (0, d.appendUint8Array)(i, a1)), o && o.length) {
                                                var s1 = {
                                                    type: e.type,
                                                    frag: t,
                                                    part: n,
                                                    chunkMeta: r,
                                                    parent: t.type,
                                                    data: o
                                                };
                                                this.hls.trigger(u.Events.BUFFER_APPENDING, s1), e.dropped && e.independent && !n && this.flushBufferGap(t);
                                            }
                                        }
                                    }, w.flushBufferGap = function(e) {
                                        var t = this.media;
                                        if (t) {
                                            if (o.BufferHelper.isBuffered(t, t.currentTime)) {
                                                var n = t.currentTime, r = o.BufferHelper.bufferInfo(t, n, 0), i = e.duration, a1 = Math.min(2 * this.config.maxFragLookUpTolerance, .25 * i), s1 = Math.max(Math.min(e.start - a1, r.end - a1), n + a1);
                                                e.start - s1 > a1 && this.flushMainBuffer(s1, e.start);
                                            } else this.flushMainBuffer(0, e.start);
                                        }
                                    }, w.getFwdBufferInfo = function(e, t) {
                                        var n = this.config, i = this.getLoadPosition();
                                        if (!(0, r.isFiniteNumber)(i)) return null;
                                        var a1 = o.BufferHelper.bufferInfo(e, i, n.maxBufferHole);
                                        if (0 === a1.len && void 0 !== a1.nextStart) {
                                            var s1 = this.fragmentTracker.getBufferedFrag(i, t);
                                            if (s1 && a1.nextStart < s1.end) return o.BufferHelper.bufferInfo(e, i, Math.max(a1.nextStart, n.maxBufferHole));
                                        }
                                        return a1;
                                    }, w.getMaxBufferLength = function(e) {
                                        var t, n = this.config;
                                        return t = e ? Math.max(8 * n.maxBufferSize / e, n.maxBufferLength) : n.maxBufferLength, Math.min(t, n.maxMaxBufferLength);
                                    }, w.reduceMaxBufferLength = function(e) {
                                        var t = this.config, n = e || t.maxBufferLength;
                                        return t.maxMaxBufferLength >= n && (t.maxMaxBufferLength /= 2, this.warn("Reduce max buffer length to " + t.maxMaxBufferLength + "s"), !0);
                                    }, w.getNextFragment = function(e, t) {
                                        var n = t.fragments, r = n.length;
                                        if (!r) return null;
                                        var i, a1 = this.config, o = n[0].start;
                                        if (t.live) {
                                            var s1 = a1.initialLiveManifestSize;
                                            if (r < s1) return this.warn("Not enough fragments to start playback (have: " + r + ", need: " + s1 + ")"), null;
                                            t.PTSKnown || this.startFragRequested || -1 !== this.startPosition || (i = this.getInitialLiveFragment(t, n), this.startPosition = i ? this.hls.liveSyncPosition || i.start : e);
                                        } else e <= o && (i = n[0]);
                                        if (!i) {
                                            var u = a1.lowLatencyMode ? t.partEnd : t.fragmentEnd;
                                            i = this.getFragmentAtPosition(e, u, t);
                                        }
                                        return this.mapToInitFragWhenRequired(i);
                                    }, w.mapToInitFragWhenRequired = function(e) {
                                        return null == e || !e.initSegment || null != e && e.initSegment.data || this.bitrateTest ? e : e.initSegment;
                                    }, w.getNextPart = function(e, t, n) {
                                        for(var r = -1, i = !1, a1 = !0, o = 0, s1 = e.length; o < s1; o++){
                                            var u = e[o];
                                            if (a1 = a1 && !u.independent, r > -1 && n < u.start) break;
                                            var l = u.loaded;
                                            !l && (i || u.independent || a1) && u.fragment === t && (r = o), i = l;
                                        }
                                        return r;
                                    }, w.loadedEndOfParts = function(e, t) {
                                        var n = e[e.length - 1];
                                        return n && t > n.start && n.loaded;
                                    }, w.getInitialLiveFragment = function(e, t) {
                                        var n = this.fragPrevious, r = null;
                                        if (n) {
                                            if (e.hasProgramDateTime && (this.log("Live playlist, switching playlist, load frag with same PDT: " + n.programDateTime), r = (0, h.findFragmentByPDT)(t, n.endProgramDateTime, this.config.maxFragLookUpTolerance)), !r) {
                                                var i = n.sn + 1;
                                                if (i >= e.startSN && i <= e.endSN) {
                                                    var a1 = t[i - e.startSN];
                                                    n.cc === a1.cc && (r = a1, this.log("Live playlist, switching playlist, load frag with next SN: " + r.sn));
                                                }
                                                r || (r = (0, h.findFragWithCC)(t, n.cc)) && this.log("Live playlist, switching playlist, load frag with same CC: " + r.sn);
                                            }
                                        } else {
                                            var o = this.hls.liveSyncPosition;
                                            null !== o && (r = this.getFragmentAtPosition(o, this.bitrateTest ? e.fragmentEnd : e.edge, e));
                                        }
                                        return r;
                                    }, w.getFragmentAtPosition = function(e, t, n) {
                                        var r, i = this.config, o = this.fragPrevious, s1 = n.fragments, u = n.endSN, l = n.fragmentHint, c = i.maxFragLookUpTolerance, d = !!(i.lowLatencyMode && n.partList && l);
                                        if (d && l && !this.bitrateTest && (s1 = s1.concat(l), u = l.sn), e < t) {
                                            var f = e > t - c ? 0 : c;
                                            r = (0, h.findFragmentByPTS)(o, s1, e, f);
                                        } else r = s1[s1.length - 1];
                                        if (r) {
                                            var g = r.sn - n.startSN;
                                            if (this.fragmentTracker.getState(r) === a1.FragmentState.OK && (o = r), o && r.sn === o.sn && !d && o && r.level === o.level) {
                                                var p = s1[g + 1];
                                                r.sn < u && this.fragmentTracker.getState(p) !== a1.FragmentState.OK ? (this.log("SN " + r.sn + " just loaded, load next one: " + p.sn), r = p) : r = null;
                                            }
                                        }
                                        return r;
                                    }, w.synchronizeToLiveEdge = function(e) {
                                        var t = this.config, n = this.media;
                                        if (n) {
                                            var r = this.hls.liveSyncPosition, i = n.currentTime, a1 = e.fragments[0].start, o = e.edge, s1 = i >= a1 - t.maxFragLookUpTolerance && i <= o;
                                            if (null !== r && n.duration > r && (i < r || !s1)) {
                                                var u = void 0 !== t.liveMaxLatencyDuration ? t.liveMaxLatencyDuration : t.liveMaxLatencyDurationCount * e.targetduration;
                                                (!s1 && n.readyState < 4 || i < o - u) && (this.loadedmetadata || (this.nextLoadPosition = r), n.readyState && (this.warn("Playback: " + i.toFixed(3) + " is located too far from the end of live sliding playlist: " + o + ", reset currentTime to : " + r.toFixed(3)), n.currentTime = r));
                                            }
                                        }
                                    }, w.alignPlaylists = function(e, t) {
                                        var n = this.levels, i = this.levelLastLoaded, a1 = this.fragPrevious, o = null !== i ? n[i] : null, s1 = e.fragments.length;
                                        if (!s1) return this.warn("No fragments in live playlist"), 0;
                                        var u = e.fragments[0].start, l = !t, c = e.alignedSliding && (0, r.isFiniteNumber)(u);
                                        if (l || !c && !u) {
                                            (0, f.alignStream)(a1, o, e);
                                            var d = e.fragments[0].start;
                                            return this.log("Live playlist sliding: " + d.toFixed(2) + " start-sn: " + (t ? t.startSN : "na") + "->" + e.startSN + " prev-sn: " + (a1 ? a1.sn : "na") + " fragments: " + s1), d;
                                        }
                                        return u;
                                    }, w.waitForCdnTuneIn = function(e) {
                                        return e.live && e.canBlockReload && e.partTarget && e.tuneInGoal > Math.max(e.partHoldBack, 3 * e.partTarget);
                                    }, w.setStartPosition = function(e, t) {
                                        var n = this.startPosition;
                                        if (n < t && (n = -1), -1 === n || -1 === this.lastCurrentTime) {
                                            var i = e.startTimeOffset;
                                            (0, r.isFiniteNumber)(i) ? (n = t + i, i < 0 && (n += e.totalduration), n = Math.min(Math.max(t, n), t + e.totalduration), this.log("Start time offset " + i + " found in playlist, adjust startPosition to " + n), this.startPosition = n) : e.live ? n = this.hls.liveSyncPosition || t : this.startPosition = n = 0, this.lastCurrentTime = n;
                                        }
                                        this.nextLoadPosition = n;
                                    }, w.getLoadPosition = function() {
                                        var e = this.media, t = 0;
                                        return this.loadedmetadata && e ? t = e.currentTime : this.nextLoadPosition && (t = this.nextLoadPosition), t;
                                    }, w.handleFragLoadAborted = function(e, t) {
                                        this.transmuxer && "initSegment" !== e.sn && e.stats.aborted && (this.warn("Fragment " + e.sn + (t ? " part" + t.index : "") + " of level " + e.level + " was aborted"), this.resetFragmentLoading(e));
                                    }, w.resetFragmentLoading = function(e) {
                                        this.fragCurrent && (this.fragContextChanged(e) || this.state === A.FRAG_LOADING_WAITING_RETRY) || (this.state = A.IDLE);
                                    }, w.onFragmentOrKeyLoadError = function(e, t) {
                                        if (!t.fatal) {
                                            var n = t.frag;
                                            if (n && n.type === e) {
                                                var r = this.fragCurrent;
                                                console.assert(r && n.sn === r.sn && n.level === r.level && n.urlId === r.urlId, "Frag load error must match current frag to retry");
                                                var i = this.config;
                                                if (this.fragLoadError + 1 <= i.fragLoadingMaxRetry) {
                                                    this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition);
                                                    var a1 = Math.min(Math.pow(2, this.fragLoadError) * i.fragLoadingRetryDelay, i.fragLoadingMaxRetryTimeout);
                                                    this.warn("Fragment " + n.sn + " of " + e + " " + n.level + " failed to load, retrying in " + a1 + "ms"), this.retryDate = self.performance.now() + a1, this.fragLoadError++, this.state = A.FRAG_LOADING_WAITING_RETRY;
                                                } else t.levelRetry ? (e === y.PlaylistLevelType.AUDIO && (this.fragCurrent = null), this.fragLoadError = 0, this.state = A.IDLE) : (s1.logger.error(t.details + " reaches max retry, redispatch as fatal ..."), t.fatal = !0, this.hls.stopLoad(), this.state = A.ERROR);
                                            }
                                        }
                                    }, w.afterBufferFlushed = function(e, t, n) {
                                        if (e) {
                                            var r = o.BufferHelper.getBuffered(e);
                                            this.fragmentTracker.detectEvictedFragments(t, r, n), this.state === A.ENDED && this.resetLoadingState();
                                        }
                                    }, w.resetLoadingState = function() {
                                        this.fragCurrent = null, this.fragPrevious = null, this.state = A.IDLE;
                                    }, w.resetStartWhenNotLoaded = function(e) {
                                        if (!this.loadedmetadata) {
                                            this.startFragRequested = !1;
                                            var t = this.levels ? this.levels[e].details : null;
                                            null != t && t.live ? (this.startPosition = -1, this.setStartPosition(t, 0), this.resetLoadingState()) : this.nextLoadPosition = this.startPosition;
                                        }
                                    }, w.updateLevelTiming = function(e, t, n, r) {
                                        var i = this, a1 = n.details;
                                        console.assert(!!a1, "level.details must be defined"), Object.keys(e.elementaryStreams).reduce(function(t, o) {
                                            var s1 = e.elementaryStreams[o];
                                            if (s1) {
                                                var l = s1.endPTS - s1.startPTS;
                                                if (l <= 0) return i.warn("Could not parse fragment " + e.sn + " " + o + " duration reliably (" + l + ")"), t || !1;
                                                var c = r ? 0 : (0, g.updateFragPTSDTS)(a1, e, s1.startPTS, s1.endPTS, s1.startDTS, s1.endDTS);
                                                return i.hls.trigger(u.Events.LEVEL_PTS_UPDATED, {
                                                    details: a1,
                                                    level: n,
                                                    drift: c,
                                                    type: o,
                                                    frag: e,
                                                    start: s1.startPTS,
                                                    end: s1.endPTS
                                                }), !0;
                                            }
                                            return t;
                                        }, !1) || (this.warn("Found no media in fragment " + e.sn + " of level " + n.id + " resetting transmuxer to fallback to playlist timing"), this.resetTransmuxer()), this.state = A.PARSED, this.hls.trigger(u.Events.FRAG_PARSED, {
                                            frag: e,
                                            part: t
                                        });
                                    }, w.resetTransmuxer = function() {
                                        this.transmuxer && (this.transmuxer.destroy(), this.transmuxer = null);
                                    }, _ = i, S = [
                                        {
                                            key: "state",
                                            get: function() {
                                                return this._state;
                                            },
                                            set: function(e) {
                                                var t = this._state;
                                                t !== e && (this._state = e, this.log(t + "->" + e));
                                            }
                                        }
                                    ], E(_.prototype, S), Object.defineProperty(_, "prototype", {
                                        writable: !1
                                    }), i;
                                }(i.default);
                            },
                            "./src/controller/buffer-controller.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>h
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./src/events.ts"), a1 = n("./src/utils/logger.ts"), o = n("./src/errors.ts"), s1 = n("./src/utils/buffer-helper.ts"), u = n("./src/utils/mediasource-helper.ts"), l = n("./src/loader/fragment.ts"), c = n("./src/controller/buffer-operation-queue.ts"), d = (0, u.getMediaSource)(), f = /([ha]vc.)(?:\.[^.,]+)+/, h = function() {
                                    function e(e) {
                                        var t = this;
                                        this.details = null, this._objectUrl = null, this.operationQueue = void 0, this.listeners = void 0, this.hls = void 0, this.bufferCodecEventsExpected = 0, this._bufferCodecEventsTotal = 0, this.media = null, this.mediaSource = null, this.appendError = 0, this.tracks = {}, this.pendingTracks = {}, this.sourceBuffer = void 0, this._onMediaSourceOpen = function() {
                                            var e = t.hls, n = t.media, r = t.mediaSource;
                                            a1.logger.log("[buffer-controller]: Media source opened"), n && (t.updateMediaElementDuration(), e.trigger(i.Events.MEDIA_ATTACHED, {
                                                media: n
                                            })), r && r.removeEventListener("sourceopen", t._onMediaSourceOpen), t.checkPendingTracks();
                                        }, this._onMediaSourceClose = function() {
                                            a1.logger.log("[buffer-controller]: Media source closed");
                                        }, this._onMediaSourceEnded = function() {
                                            a1.logger.log("[buffer-controller]: Media source ended");
                                        }, this.hls = e, this._initSourceBuffer(), this.registerListeners();
                                    }
                                    var t = e.prototype;
                                    return t.hasSourceTypes = function() {
                                        return this.getSourceBufferTypes().length > 0 || Object.keys(this.pendingTracks).length > 0;
                                    }, t.destroy = function() {
                                        this.unregisterListeners(), this.details = null;
                                    }, t.registerListeners = function() {
                                        var e = this.hls;
                                        e.on(i.Events.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(i.Events.MANIFEST_PARSED, this.onManifestParsed, this), e.on(i.Events.BUFFER_RESET, this.onBufferReset, this), e.on(i.Events.BUFFER_APPENDING, this.onBufferAppending, this), e.on(i.Events.BUFFER_CODECS, this.onBufferCodecs, this), e.on(i.Events.BUFFER_EOS, this.onBufferEos, this), e.on(i.Events.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(i.Events.LEVEL_UPDATED, this.onLevelUpdated, this), e.on(i.Events.FRAG_PARSED, this.onFragParsed, this), e.on(i.Events.FRAG_CHANGED, this.onFragChanged, this);
                                    }, t.unregisterListeners = function() {
                                        var e = this.hls;
                                        e.off(i.Events.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(i.Events.MANIFEST_PARSED, this.onManifestParsed, this), e.off(i.Events.BUFFER_RESET, this.onBufferReset, this), e.off(i.Events.BUFFER_APPENDING, this.onBufferAppending, this), e.off(i.Events.BUFFER_CODECS, this.onBufferCodecs, this), e.off(i.Events.BUFFER_EOS, this.onBufferEos, this), e.off(i.Events.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(i.Events.LEVEL_UPDATED, this.onLevelUpdated, this), e.off(i.Events.FRAG_PARSED, this.onFragParsed, this), e.off(i.Events.FRAG_CHANGED, this.onFragChanged, this);
                                    }, t._initSourceBuffer = function() {
                                        this.sourceBuffer = {}, this.operationQueue = new c.default(this.sourceBuffer), this.listeners = {
                                            audio: [],
                                            video: [],
                                            audiovideo: []
                                        };
                                    }, t.onManifestParsed = function(e, t) {
                                        var n = 2;
                                        (t.audio && !t.video || !t.altAudio) && (n = 1), this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = n, this.details = null, a1.logger.log(this.bufferCodecEventsExpected + " bufferCodec event(s) expected");
                                    }, t.onMediaAttaching = function(e, t) {
                                        var n = this.media = t.media;
                                        if (n && d) {
                                            var r = this.mediaSource = new d;
                                            r.addEventListener("sourceopen", this._onMediaSourceOpen), r.addEventListener("sourceended", this._onMediaSourceEnded), r.addEventListener("sourceclose", this._onMediaSourceClose), n.src = self.URL.createObjectURL(r), this._objectUrl = n.src;
                                        }
                                    }, t.onMediaDetaching = function() {
                                        var e = this.media, t = this.mediaSource, n = this._objectUrl;
                                        if (t) {
                                            if (a1.logger.log("[buffer-controller]: media source detaching"), "open" === t.readyState) try {
                                                t.endOfStream();
                                            } catch (e) {
                                                a1.logger.warn("[buffer-controller]: onMediaDetaching: " + e.message + " while calling endOfStream");
                                            }
                                            this.onBufferReset(), t.removeEventListener("sourceopen", this._onMediaSourceOpen), t.removeEventListener("sourceended", this._onMediaSourceEnded), t.removeEventListener("sourceclose", this._onMediaSourceClose), e && (n && self.URL.revokeObjectURL(n), e.src === n ? (e.removeAttribute("src"), e.load()) : a1.logger.warn("[buffer-controller]: media.src was changed by a third party - skip cleanup")), this.mediaSource = null, this.media = null, this._objectUrl = null, this.bufferCodecEventsExpected = this._bufferCodecEventsTotal, this.pendingTracks = {}, this.tracks = {};
                                        }
                                        this.hls.trigger(i.Events.MEDIA_DETACHED, void 0);
                                    }, t.onBufferReset = function() {
                                        var e = this;
                                        this.getSourceBufferTypes().forEach(function(t) {
                                            var n = e.sourceBuffer[t];
                                            try {
                                                n && (e.removeBufferListeners(t), e.mediaSource && e.mediaSource.removeSourceBuffer(n), e.sourceBuffer[t] = void 0);
                                            } catch (e) {
                                                a1.logger.warn("[buffer-controller]: Failed to reset the " + t + " buffer", e);
                                            }
                                        }), this._initSourceBuffer();
                                    }, t.onBufferCodecs = function(e, t) {
                                        var n = this, r = this.getSourceBufferTypes().length;
                                        Object.keys(t).forEach(function(e) {
                                            if (r) {
                                                var i = n.tracks[e];
                                                if (i && "function" == typeof i.buffer.changeType) {
                                                    var o = t[e], s1 = o.id, u = o.codec, l = o.levelCodec, c = o.container, d = o.metadata, h = (i.levelCodec || i.codec).replace(f, "$1"), g = (l || u).replace(f, "$1");
                                                    if (h !== g) {
                                                        var p = c + ";codecs=" + (l || u);
                                                        n.appendChangeType(e, p), a1.logger.log("[buffer-controller]: switching codec " + h + " to " + g), n.tracks[e] = {
                                                            buffer: i.buffer,
                                                            codec: u,
                                                            container: c,
                                                            levelCodec: l,
                                                            metadata: d,
                                                            id: s1
                                                        };
                                                    }
                                                }
                                            } else n.pendingTracks[e] = t[e];
                                        }), r || (this.bufferCodecEventsExpected = Math.max(this.bufferCodecEventsExpected - 1, 0), this.mediaSource && "open" === this.mediaSource.readyState && this.checkPendingTracks());
                                    }, t.appendChangeType = function(e, t) {
                                        var n = this, r = this.operationQueue, i = {
                                            execute: function() {
                                                var i = n.sourceBuffer[e];
                                                i && (a1.logger.log("[buffer-controller]: changing " + e + " sourceBuffer type to " + t), i.changeType(t)), r.shiftAndExecuteNext(e);
                                            },
                                            onStart: function() {},
                                            onComplete: function() {},
                                            onError: function(t) {
                                                a1.logger.warn("[buffer-controller]: Failed to change " + e + " SourceBuffer type", t);
                                            }
                                        };
                                        r.append(i, e);
                                    }, t.onBufferAppending = function(e, t) {
                                        var n = this, r = this.hls, u = this.operationQueue, l = this.tracks, c = t.data, d = t.type, f = t.frag, h = t.part, g = t.chunkMeta, p = g.buffering[d], m = self.performance.now();
                                        p.start = m;
                                        var v = f.stats.buffering, y = h ? h.stats.buffering : null;
                                        0 === v.start && (v.start = m), y && 0 === y.start && (y.start = m);
                                        var E = l.audio, T = "audio" === d && 1 === g.id && "audio/mpeg" === (null == E ? void 0 : E.container), b = {
                                            execute: function() {
                                                if (p.executeStart = self.performance.now(), T) {
                                                    var e = n.sourceBuffer[d];
                                                    if (e) {
                                                        var t = f.start - e.timestampOffset;
                                                        Math.abs(t) >= .1 && (a1.logger.log("[buffer-controller]: Updating audio SourceBuffer timestampOffset to " + f.start + " (delta: " + t + ") sn: " + f.sn + ")"), e.timestampOffset = f.start);
                                                    }
                                                }
                                                n.appendExecutor(c, d);
                                            },
                                            onStart: function() {},
                                            onComplete: function() {
                                                var e = self.performance.now();
                                                p.executeEnd = p.end = e, 0 === v.first && (v.first = e), y && 0 === y.first && (y.first = e);
                                                var t = n.sourceBuffer, r = {};
                                                for(var a1 in t)r[a1] = s1.BufferHelper.getBuffered(t[a1]);
                                                n.appendError = 0, n.hls.trigger(i.Events.BUFFER_APPENDED, {
                                                    type: d,
                                                    frag: f,
                                                    part: h,
                                                    chunkMeta: g,
                                                    parent: f.type,
                                                    timeRanges: r
                                                });
                                            },
                                            onError: function(e) {
                                                a1.logger.error("[buffer-controller]: Error encountered while trying to append to the " + d + " SourceBuffer", e);
                                                var t = {
                                                    type: o.ErrorTypes.MEDIA_ERROR,
                                                    parent: f.type,
                                                    details: o.ErrorDetails.BUFFER_APPEND_ERROR,
                                                    err: e,
                                                    fatal: !1
                                                };
                                                e.code === DOMException.QUOTA_EXCEEDED_ERR ? t.details = o.ErrorDetails.BUFFER_FULL_ERROR : (n.appendError++, t.details = o.ErrorDetails.BUFFER_APPEND_ERROR, n.appendError > r.config.appendErrorMaxRetry && (a1.logger.error("[buffer-controller]: Failed " + r.config.appendErrorMaxRetry + " times to append segment in sourceBuffer"), t.fatal = !0, r.stopLoad())), r.trigger(i.Events.ERROR, t);
                                            }
                                        };
                                        u.append(b, d);
                                    }, t.onBufferFlushing = function(e, t) {
                                        var n = this, r = this.operationQueue, o = function(e) {
                                            return {
                                                execute: n.removeExecutor.bind(n, e, t.startOffset, t.endOffset),
                                                onStart: function() {},
                                                onComplete: function() {
                                                    n.hls.trigger(i.Events.BUFFER_FLUSHED, {
                                                        type: e
                                                    });
                                                },
                                                onError: function(t) {
                                                    a1.logger.warn("[buffer-controller]: Failed to remove from " + e + " SourceBuffer", t);
                                                }
                                            };
                                        };
                                        t.type ? r.append(o(t.type), t.type) : this.getSourceBufferTypes().forEach(function(e) {
                                            r.append(o(e), e);
                                        });
                                    }, t.onFragParsed = function(e, t) {
                                        var n = this, r = t.frag, o = t.part, s1 = [], u = o ? o.elementaryStreams : r.elementaryStreams;
                                        u[l.ElementaryStreamTypes.AUDIOVIDEO] ? s1.push("audiovideo") : (u[l.ElementaryStreamTypes.AUDIO] && s1.push("audio"), u[l.ElementaryStreamTypes.VIDEO] && s1.push("video")), 0 === s1.length && a1.logger.warn("Fragments must have at least one ElementaryStreamType set. type: " + r.type + " level: " + r.level + " sn: " + r.sn), this.blockBuffers(function() {
                                            var e = self.performance.now();
                                            r.stats.buffering.end = e, o && (o.stats.buffering.end = e);
                                            var t = o ? o.stats : r.stats;
                                            n.hls.trigger(i.Events.FRAG_BUFFERED, {
                                                frag: r,
                                                part: o,
                                                stats: t,
                                                id: r.type
                                            });
                                        }, s1);
                                    }, t.onFragChanged = function(e, t) {
                                        this.flushBackBuffer();
                                    }, t.onBufferEos = function(e, t) {
                                        var n = this;
                                        this.getSourceBufferTypes().reduce(function(e, r) {
                                            var i = n.sourceBuffer[r];
                                            return t.type && t.type !== r || i && !i.ended && (i.ended = !0, a1.logger.log("[buffer-controller]: " + r + " sourceBuffer now EOS")), e && !(i && !i.ended);
                                        }, !0) && this.blockBuffers(function() {
                                            var e = n.mediaSource;
                                            e && "open" === e.readyState && e.endOfStream();
                                        });
                                    }, t.onLevelUpdated = function(e, t) {
                                        var n = t.details;
                                        n.fragments.length && (this.details = n, this.getSourceBufferTypes().length ? this.blockBuffers(this.updateMediaElementDuration.bind(this)) : this.updateMediaElementDuration());
                                    }, t.flushBackBuffer = function() {
                                        var e = this.hls, t = this.details, n = this.media, a1 = this.sourceBuffer;
                                        if (n && null !== t) {
                                            var o = this.getSourceBufferTypes();
                                            if (o.length) {
                                                var u = t.live && null !== e.config.liveBackBufferLength ? e.config.liveBackBufferLength : e.config.backBufferLength;
                                                if ((0, r.isFiniteNumber)(u) && !(u < 0)) {
                                                    var l = n.currentTime, c = t.levelTargetDuration, d = Math.max(u, c), f = Math.floor(l / c) * c - d;
                                                    o.forEach(function(n) {
                                                        var r = a1[n];
                                                        if (r) {
                                                            var o = s1.BufferHelper.getBuffered(r);
                                                            o.length > 0 && f > o.start(0) && (e.trigger(i.Events.BACK_BUFFER_REACHED, {
                                                                bufferEnd: f
                                                            }), t.live && e.trigger(i.Events.LIVE_BACK_BUFFER_REACHED, {
                                                                bufferEnd: f
                                                            }), e.trigger(i.Events.BUFFER_FLUSHING, {
                                                                startOffset: 0,
                                                                endOffset: f,
                                                                type: n
                                                            }));
                                                        }
                                                    });
                                                }
                                            }
                                        }
                                    }, t.updateMediaElementDuration = function() {
                                        if (this.details && this.media && this.mediaSource && "open" === this.mediaSource.readyState) {
                                            var e = this.details, t = this.hls, n = this.media, i = this.mediaSource, o = e.fragments[0].start + e.totalduration, s1 = n.duration, u = (0, r.isFiniteNumber)(i.duration) ? i.duration : 0;
                                            e.live && t.config.liveDurationInfinity ? (a1.logger.log("[buffer-controller]: Media Source duration is set to Infinity"), i.duration = 1 / 0, this.updateSeekableRange(e)) : (o > u && o > s1 || !(0, r.isFiniteNumber)(s1)) && (a1.logger.log("[buffer-controller]: Updating Media Source duration to " + o.toFixed(3)), i.duration = o);
                                        }
                                    }, t.updateSeekableRange = function(e) {
                                        var t = this.mediaSource, n = e.fragments;
                                        if (n.length && e.live && null != t && t.setLiveSeekableRange) {
                                            var r = Math.max(0, n[0].start), i = Math.max(r, r + e.totalduration);
                                            t.setLiveSeekableRange(r, i);
                                        }
                                    }, t.checkPendingTracks = function() {
                                        var e = this.bufferCodecEventsExpected, t = this.operationQueue, n = this.pendingTracks, r = Object.keys(n).length;
                                        if (r && !e || 2 === r) {
                                            this.createSourceBuffers(n), this.pendingTracks = {};
                                            var a1 = this.getSourceBufferTypes();
                                            if (0 === a1.length) return void this.hls.trigger(i.Events.ERROR, {
                                                type: o.ErrorTypes.MEDIA_ERROR,
                                                details: o.ErrorDetails.BUFFER_INCOMPATIBLE_CODECS_ERROR,
                                                fatal: !0,
                                                reason: "could not create source buffer for media codec(s)"
                                            });
                                            a1.forEach(function(e) {
                                                t.executeNext(e);
                                            });
                                        }
                                    }, t.createSourceBuffers = function(e) {
                                        var t = this.sourceBuffer, n = this.mediaSource;
                                        if (!n) throw Error("createSourceBuffers called when mediaSource was null");
                                        var r = 0;
                                        for(var s1 in e)if (!t[s1]) {
                                            var u = e[s1];
                                            if (!u) throw Error("source buffer exists for track " + s1 + ", however track does not");
                                            var l = u.levelCodec || u.codec, c = u.container + ";codecs=" + l;
                                            a1.logger.log("[buffer-controller]: creating sourceBuffer(" + c + ")");
                                            try {
                                                var d = t[s1] = n.addSourceBuffer(c), f = s1;
                                                this.addBufferListener(f, "updatestart", this._onSBUpdateStart), this.addBufferListener(f, "updateend", this._onSBUpdateEnd), this.addBufferListener(f, "error", this._onSBUpdateError), this.tracks[s1] = {
                                                    buffer: d,
                                                    codec: l,
                                                    container: u.container,
                                                    levelCodec: u.levelCodec,
                                                    metadata: u.metadata,
                                                    id: u.id
                                                }, r++;
                                            } catch (e) {
                                                a1.logger.error("[buffer-controller]: error while trying to add sourceBuffer: " + e.message), this.hls.trigger(i.Events.ERROR, {
                                                    type: o.ErrorTypes.MEDIA_ERROR,
                                                    details: o.ErrorDetails.BUFFER_ADD_CODEC_ERROR,
                                                    fatal: !1,
                                                    error: e,
                                                    mimeType: c
                                                });
                                            }
                                        }
                                        r && this.hls.trigger(i.Events.BUFFER_CREATED, {
                                            tracks: this.tracks
                                        });
                                    }, t._onSBUpdateStart = function(e) {
                                        this.operationQueue.current(e).onStart();
                                    }, t._onSBUpdateEnd = function(e) {
                                        var t = this.operationQueue;
                                        t.current(e).onComplete(), t.shiftAndExecuteNext(e);
                                    }, t._onSBUpdateError = function(e, t) {
                                        a1.logger.error("[buffer-controller]: " + e + " SourceBuffer error", t), this.hls.trigger(i.Events.ERROR, {
                                            type: o.ErrorTypes.MEDIA_ERROR,
                                            details: o.ErrorDetails.BUFFER_APPENDING_ERROR,
                                            fatal: !1
                                        });
                                        var n = this.operationQueue.current(e);
                                        n && n.onError(t);
                                    }, t.removeExecutor = function(e, t, n) {
                                        var i = this.media, o = this.mediaSource, s1 = this.operationQueue, u = this.sourceBuffer[e];
                                        if (!i || !o || !u) return a1.logger.warn("[buffer-controller]: Attempting to remove from the " + e + " SourceBuffer, but it does not exist"), void s1.shiftAndExecuteNext(e);
                                        var l = (0, r.isFiniteNumber)(i.duration) ? i.duration : 1 / 0, c = (0, r.isFiniteNumber)(o.duration) ? o.duration : 1 / 0, d = Math.max(0, t), f = Math.min(n, l, c);
                                        f > d ? (a1.logger.log("[buffer-controller]: Removing [" + d + "," + f + "] from the " + e + " SourceBuffer"), console.assert(!u.updating, e + " sourceBuffer must not be updating"), u.remove(d, f)) : s1.shiftAndExecuteNext(e);
                                    }, t.appendExecutor = function(e, t) {
                                        var n = this.operationQueue, r = this.sourceBuffer[t];
                                        if (!r) return a1.logger.warn("[buffer-controller]: Attempting to append to the " + t + " SourceBuffer, but it does not exist"), void n.shiftAndExecuteNext(t);
                                        r.ended = !1, console.assert(!r.updating, t + " sourceBuffer must not be updating"), r.appendBuffer(e);
                                    }, t.blockBuffers = function(e, t) {
                                        var n = this;
                                        if (void 0 === t && (t = this.getSourceBufferTypes()), !t.length) return a1.logger.log("[buffer-controller]: Blocking operation requested, but no SourceBuffers exist"), void Promise.resolve().then(e);
                                        var r = this.operationQueue, i = t.map(function(e) {
                                            return r.appendBlocker(e);
                                        });
                                        Promise.all(i).then(function() {
                                            e(), t.forEach(function(e) {
                                                var t = n.sourceBuffer[e];
                                                t && t.updating || r.shiftAndExecuteNext(e);
                                            });
                                        });
                                    }, t.getSourceBufferTypes = function() {
                                        return Object.keys(this.sourceBuffer);
                                    }, t.addBufferListener = function(e, t, n) {
                                        var r = this.sourceBuffer[e];
                                        if (r) {
                                            var i = n.bind(this, e);
                                            this.listeners[e].push({
                                                event: t,
                                                listener: i
                                            }), r.addEventListener(t, i);
                                        }
                                    }, t.removeBufferListeners = function(e) {
                                        var t = this.sourceBuffer[e];
                                        t && this.listeners[e].forEach(function(e) {
                                            t.removeEventListener(e.event, e.listener);
                                        });
                                    }, e;
                                }();
                            },
                            "./src/controller/buffer-operation-queue.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>i
                                });
                                var r = n("./src/utils/logger.ts"), i = function() {
                                    function e(e) {
                                        this.buffers = void 0, this.queues = {
                                            video: [],
                                            audio: [],
                                            audiovideo: []
                                        }, this.buffers = e;
                                    }
                                    var t = e.prototype;
                                    return t.append = function(e, t) {
                                        var n = this.queues[t];
                                        n.push(e), 1 === n.length && this.buffers[t] && this.executeNext(t);
                                    }, t.insertAbort = function(e, t) {
                                        this.queues[t].unshift(e), this.executeNext(t);
                                    }, t.appendBlocker = function(e) {
                                        var t, n = new Promise(function(e) {
                                            t = e;
                                        }), r = {
                                            execute: t,
                                            onStart: function() {},
                                            onComplete: function() {},
                                            onError: function() {}
                                        };
                                        return this.append(r, e), n;
                                    }, t.executeNext = function(e) {
                                        var t = this.buffers, n = this.queues, i = t[e], a1 = n[e];
                                        if (a1.length) {
                                            var o = a1[0];
                                            try {
                                                o.execute();
                                            } catch (t) {
                                                r.logger.warn("[buffer-operation-queue]: Unhandled exception executing the current operation"), o.onError(t), i && i.updating || (a1.shift(), this.executeNext(e));
                                            }
                                        }
                                    }, t.shiftAndExecuteNext = function(e) {
                                        this.queues[e].shift(), this.executeNext(e);
                                    }, t.current = function(e) {
                                        return this.queues[e][0];
                                    }, e;
                                }();
                            },
                            "./src/controller/cap-level-controller.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>a1
                                });
                                var r = n("./src/events.ts");
                                function i(e, t) {
                                    for(var n = 0; n < t.length; n++){
                                        var r = t[n];
                                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                    }
                                }
                                const a1 = function() {
                                    function e(e) {
                                        this.autoLevelCapping = void 0, this.firstLevel = void 0, this.media = void 0, this.restrictedLevels = void 0, this.timer = void 0, this.hls = void 0, this.streamController = void 0, this.clientRect = void 0, this.hls = e, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.firstLevel = -1, this.media = null, this.restrictedLevels = [], this.timer = void 0, this.clientRect = null, this.registerListeners();
                                    }
                                    var t, n, a1 = e.prototype;
                                    return a1.setStreamController = function(e) {
                                        this.streamController = e;
                                    }, a1.destroy = function() {
                                        this.unregisterListener(), this.hls.config.capLevelToPlayerSize && this.stopCapping(), this.media = null, this.clientRect = null, this.hls = this.streamController = null;
                                    }, a1.registerListeners = function() {
                                        var e = this.hls;
                                        e.on(r.Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.on(r.Events.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(r.Events.MANIFEST_PARSED, this.onManifestParsed, this), e.on(r.Events.BUFFER_CODECS, this.onBufferCodecs, this), e.on(r.Events.MEDIA_DETACHING, this.onMediaDetaching, this);
                                    }, a1.unregisterListener = function() {
                                        var e = this.hls;
                                        e.off(r.Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.off(r.Events.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(r.Events.MANIFEST_PARSED, this.onManifestParsed, this), e.off(r.Events.BUFFER_CODECS, this.onBufferCodecs, this), e.off(r.Events.MEDIA_DETACHING, this.onMediaDetaching, this);
                                    }, a1.onFpsDropLevelCapping = function(t, n) {
                                        e.isLevelAllowed(n.droppedLevel, this.restrictedLevels) && this.restrictedLevels.push(n.droppedLevel);
                                    }, a1.onMediaAttaching = function(e, t) {
                                        this.media = t.media instanceof HTMLVideoElement ? t.media : null;
                                    }, a1.onManifestParsed = function(e, t) {
                                        var n = this.hls;
                                        this.restrictedLevels = [], this.firstLevel = t.firstLevel, n.config.capLevelToPlayerSize && t.video && this.startCapping();
                                    }, a1.onBufferCodecs = function(e, t) {
                                        this.hls.config.capLevelToPlayerSize && t.video && this.startCapping();
                                    }, a1.onMediaDetaching = function() {
                                        this.stopCapping();
                                    }, a1.detectPlayerSize = function() {
                                        if (this.media && this.mediaHeight > 0 && this.mediaWidth > 0) {
                                            var e = this.hls.levels;
                                            if (e.length) {
                                                var t = this.hls;
                                                t.autoLevelCapping = this.getMaxLevel(e.length - 1), t.autoLevelCapping > this.autoLevelCapping && this.streamController && this.streamController.nextLevelSwitch(), this.autoLevelCapping = t.autoLevelCapping;
                                            }
                                        }
                                    }, a1.getMaxLevel = function(t) {
                                        var n = this, r = this.hls.levels;
                                        if (!r.length) return -1;
                                        var i = r.filter(function(r, i) {
                                            return e.isLevelAllowed(i, n.restrictedLevels) && i <= t;
                                        });
                                        return this.clientRect = null, e.getMaxLevelByMediaSize(i, this.mediaWidth, this.mediaHeight);
                                    }, a1.startCapping = function() {
                                        this.timer || (this.autoLevelCapping = Number.POSITIVE_INFINITY, this.hls.firstLevel = this.getMaxLevel(this.firstLevel), self.clearInterval(this.timer), this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1e3), this.detectPlayerSize());
                                    }, a1.stopCapping = function() {
                                        this.restrictedLevels = [], this.firstLevel = -1, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.timer && (self.clearInterval(this.timer), this.timer = void 0);
                                    }, a1.getDimensions = function() {
                                        if (this.clientRect) return this.clientRect;
                                        var e = this.media, t = {
                                            width: 0,
                                            height: 0
                                        };
                                        if (e) {
                                            var n = e.getBoundingClientRect();
                                            t.width = n.width, t.height = n.height, t.width || t.height || (t.width = n.right - n.left || e.width || 0, t.height = n.bottom - n.top || e.height || 0);
                                        }
                                        return this.clientRect = t, t;
                                    }, e.isLevelAllowed = function(e, t) {
                                        return void 0 === t && (t = []), -1 === t.indexOf(e);
                                    }, e.getMaxLevelByMediaSize = function(e, t, n) {
                                        if (!e || !e.length) return -1;
                                        for(var r, i, a1 = e.length - 1, o = 0; o < e.length; o += 1){
                                            var s1 = e[o];
                                            if ((s1.width >= t || s1.height >= n) && (r = s1, !(i = e[o + 1]) || r.width !== i.width || r.height !== i.height)) {
                                                a1 = o;
                                                break;
                                            }
                                        }
                                        return a1;
                                    }, t = e, n = [
                                        {
                                            key: "mediaWidth",
                                            get: function() {
                                                return this.getDimensions().width * this.contentScaleFactor;
                                            }
                                        },
                                        {
                                            key: "mediaHeight",
                                            get: function() {
                                                return this.getDimensions().height * this.contentScaleFactor;
                                            }
                                        },
                                        {
                                            key: "contentScaleFactor",
                                            get: function() {
                                                var e = 1;
                                                if (!this.hls.config.ignoreDevicePixelRatio) try {
                                                    e = self.devicePixelRatio;
                                                } catch (e) {}
                                                return e;
                                            }
                                        }
                                    ], i(t.prototype, n), Object.defineProperty(t, "prototype", {
                                        writable: !1
                                    }), e;
                                }();
                            },
                            "./src/controller/cmcd-controller.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>f
                                });
                                var r = n("./src/events.ts"), i = n("./src/types/cmcd.ts"), a1 = n("./src/utils/buffer-helper.ts"), o = n("./src/utils/logger.ts");
                                function s1(e, t) {
                                    for(var n = 0; n < t.length; n++){
                                        var r = t[n];
                                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                    }
                                }
                                function u(e, t, n) {
                                    return t && s1(e.prototype, t), n && s1(e, n), Object.defineProperty(e, "prototype", {
                                        writable: !1
                                    }), e;
                                }
                                function l(e, t) {
                                    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                    if (n) return (n = n.call(e)).next.bind(n);
                                    if (Array.isArray(e) || (n = function(e, t) {
                                        if (e) {
                                            if ("string" == typeof e) return c(e, t);
                                            var n = Object.prototype.toString.call(e).slice(8, -1);
                                            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? c(e, t) : void 0;
                                        }
                                    }(e)) || t && e && "number" == typeof e.length) {
                                        n && (e = n);
                                        var r = 0;
                                        return function() {
                                            return r >= e.length ? {
                                                done: !0
                                            } : {
                                                done: !1,
                                                value: e[r++]
                                            };
                                        };
                                    }
                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }
                                function c(e, t) {
                                    (null == t || t > e.length) && (t = e.length);
                                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                                    return r;
                                }
                                function d() {
                                    return d = Object.assign ? Object.assign.bind() : function(e) {
                                        for(var t = 1; t < arguments.length; t++){
                                            var n = arguments[t];
                                            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                                        }
                                        return e;
                                    }, d.apply(this, arguments);
                                }
                                var f = function() {
                                    function e(t) {
                                        var n = this;
                                        this.hls = void 0, this.config = void 0, this.media = void 0, this.sid = void 0, this.cid = void 0, this.useHeaders = !1, this.initialized = !1, this.starved = !1, this.buffering = !0, this.audioBuffer = void 0, this.videoBuffer = void 0, this.onWaiting = function() {
                                            n.initialized && (n.starved = !0), n.buffering = !0;
                                        }, this.onPlaying = function() {
                                            n.initialized || (n.initialized = !0), n.buffering = !1;
                                        }, this.applyPlaylistData = function(e) {
                                            try {
                                                n.apply(e, {
                                                    ot: i.CMCDObjectType.MANIFEST,
                                                    su: !n.initialized
                                                });
                                            } catch (e) {
                                                o.logger.warn("Could not generate manifest CMCD data.", e);
                                            }
                                        }, this.applyFragmentData = function(e) {
                                            try {
                                                var t = e.frag, r = n.hls.levels[t.level], a1 = n.getObjectType(t), s1 = {
                                                    d: 1e3 * t.duration,
                                                    ot: a1
                                                };
                                                a1 !== i.CMCDObjectType.VIDEO && a1 !== i.CMCDObjectType.AUDIO && a1 != i.CMCDObjectType.MUXED || (s1.br = r.bitrate / 1e3, s1.tb = n.getTopBandwidth(a1) / 1e3, s1.bl = n.getBufferLength(a1)), n.apply(e, s1);
                                            } catch (e) {
                                                o.logger.warn("Could not generate segment CMCD data.", e);
                                            }
                                        }, this.hls = t;
                                        var r = this.config = t.config, a1 = r.cmcd;
                                        null != a1 && (r.pLoader = this.createPlaylistLoader(), r.fLoader = this.createFragmentLoader(), this.sid = a1.sessionId || e.uuid(), this.cid = a1.contentId, this.useHeaders = !0 === a1.useHeaders, this.registerListeners());
                                    }
                                    var t = e.prototype;
                                    return t.registerListeners = function() {
                                        var e = this.hls;
                                        e.on(r.Events.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(r.Events.MEDIA_DETACHED, this.onMediaDetached, this), e.on(r.Events.BUFFER_CREATED, this.onBufferCreated, this);
                                    }, t.unregisterListeners = function() {
                                        var e = this.hls;
                                        e.off(r.Events.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(r.Events.MEDIA_DETACHED, this.onMediaDetached, this), e.off(r.Events.BUFFER_CREATED, this.onBufferCreated, this), this.onMediaDetached();
                                    }, t.destroy = function() {
                                        this.unregisterListeners(), this.hls = this.config = this.audioBuffer = this.videoBuffer = null;
                                    }, t.onMediaAttached = function(e, t) {
                                        this.media = t.media, this.media.addEventListener("waiting", this.onWaiting), this.media.addEventListener("playing", this.onPlaying);
                                    }, t.onMediaDetached = function() {
                                        this.media && (this.media.removeEventListener("waiting", this.onWaiting), this.media.removeEventListener("playing", this.onPlaying), this.media = null);
                                    }, t.onBufferCreated = function(e, t) {
                                        var n, r;
                                        this.audioBuffer = null === (n = t.tracks.audio) || void 0 === n ? void 0 : n.buffer, this.videoBuffer = null === (r = t.tracks.video) || void 0 === r ? void 0 : r.buffer;
                                    }, t.createData = function() {
                                        var e;
                                        return {
                                            v: i.CMCDVersion,
                                            sf: i.CMCDStreamingFormat.HLS,
                                            sid: this.sid,
                                            cid: this.cid,
                                            pr: null === (e = this.media) || void 0 === e ? void 0 : e.playbackRate,
                                            mtp: this.hls.bandwidthEstimate / 1e3
                                        };
                                    }, t.apply = function(t, n) {
                                        void 0 === n && (n = {}), d(n, this.createData());
                                        var r = n.ot === i.CMCDObjectType.INIT || n.ot === i.CMCDObjectType.VIDEO || n.ot === i.CMCDObjectType.MUXED;
                                        if (this.starved && r && (n.bs = !0, n.su = !0, this.starved = !1), null == n.su && (n.su = this.buffering), this.useHeaders) {
                                            var a1 = e.toHeaders(n);
                                            if (!Object.keys(a1).length) return;
                                            t.headers || (t.headers = {}), d(t.headers, a1);
                                        } else {
                                            var o = e.toQuery(n);
                                            if (!o) return;
                                            t.url = e.appendQueryToUri(t.url, o);
                                        }
                                    }, t.getObjectType = function(e) {
                                        var t = e.type;
                                        return "subtitle" === t ? i.CMCDObjectType.TIMED_TEXT : "initSegment" === e.sn ? i.CMCDObjectType.INIT : "audio" === t ? i.CMCDObjectType.AUDIO : "main" === t ? this.hls.audioTracks.length ? i.CMCDObjectType.VIDEO : i.CMCDObjectType.MUXED : void 0;
                                    }, t.getTopBandwidth = function(e) {
                                        var t, n = 0, r = this.hls;
                                        if (e === i.CMCDObjectType.AUDIO) t = r.audioTracks;
                                        else {
                                            var a1 = r.maxAutoLevel, o = a1 > -1 ? a1 + 1 : r.levels.length;
                                            t = r.levels.slice(0, o);
                                        }
                                        for(var s1, u = l(t); !(s1 = u()).done;){
                                            var c = s1.value;
                                            c.bitrate > n && (n = c.bitrate);
                                        }
                                        return n > 0 ? n : NaN;
                                    }, t.getBufferLength = function(e) {
                                        var t = this.hls.media, n = e === i.CMCDObjectType.AUDIO ? this.audioBuffer : this.videoBuffer;
                                        return n && t ? 1e3 * a1.BufferHelper.bufferInfo(n, t.currentTime, this.config.maxBufferHole).len : NaN;
                                    }, t.createPlaylistLoader = function() {
                                        var e = this.config.pLoader, t = this.applyPlaylistData, n = e || this.config.loader;
                                        return function() {
                                            function e(e) {
                                                this.loader = void 0, this.loader = new n(e);
                                            }
                                            var r = e.prototype;
                                            return r.destroy = function() {
                                                this.loader.destroy();
                                            }, r.abort = function() {
                                                this.loader.abort();
                                            }, r.load = function(e, n, r) {
                                                t(e), this.loader.load(e, n, r);
                                            }, u(e, [
                                                {
                                                    key: "stats",
                                                    get: function() {
                                                        return this.loader.stats;
                                                    }
                                                },
                                                {
                                                    key: "context",
                                                    get: function() {
                                                        return this.loader.context;
                                                    }
                                                }
                                            ]), e;
                                        }();
                                    }, t.createFragmentLoader = function() {
                                        var e = this.config.fLoader, t = this.applyFragmentData, n = e || this.config.loader;
                                        return function() {
                                            function e(e) {
                                                this.loader = void 0, this.loader = new n(e);
                                            }
                                            var r = e.prototype;
                                            return r.destroy = function() {
                                                this.loader.destroy();
                                            }, r.abort = function() {
                                                this.loader.abort();
                                            }, r.load = function(e, n, r) {
                                                t(e), this.loader.load(e, n, r);
                                            }, u(e, [
                                                {
                                                    key: "stats",
                                                    get: function() {
                                                        return this.loader.stats;
                                                    }
                                                },
                                                {
                                                    key: "context",
                                                    get: function() {
                                                        return this.loader.context;
                                                    }
                                                }
                                            ]), e;
                                        }();
                                    }, e.uuid = function() {
                                        var e = URL.createObjectURL(new Blob), t = e.toString();
                                        return URL.revokeObjectURL(e), t.slice(t.lastIndexOf("/") + 1);
                                    }, e.serialize = function(e) {
                                        for(var t, n = [], r = function(e) {
                                            return !Number.isNaN(e) && null != e && "" !== e && !1 !== e;
                                        }, i = function(e) {
                                            return Math.round(e);
                                        }, a1 = function(e) {
                                            return 100 * i(e / 100);
                                        }, o = {
                                            br: i,
                                            d: i,
                                            bl: a1,
                                            dl: a1,
                                            mtp: a1,
                                            nor: function(e) {
                                                return encodeURIComponent(e);
                                            },
                                            rtp: a1,
                                            tb: i
                                        }, s1 = l(Object.keys(e || {}).sort()); !(t = s1()).done;){
                                            var u = t.value, c = e[u];
                                            if (r(c) && !("v" === u && 1 === c || "pr" == u && 1 === c)) {
                                                var d = o[u];
                                                d && (c = d(c));
                                                var f, h = typeof c;
                                                f = "ot" === u || "sf" === u || "st" === u ? u + "=" + c : "boolean" === h ? u : "number" === h ? u + "=" + c : u + "=" + JSON.stringify(c), n.push(f);
                                            }
                                        }
                                        return n.join(",");
                                    }, e.toHeaders = function(t) {
                                        for(var n = {}, r = [
                                            "Object",
                                            "Request",
                                            "Session",
                                            "Status"
                                        ], i = [
                                            {},
                                            {},
                                            {},
                                            {}
                                        ], a1 = {
                                            br: 0,
                                            d: 0,
                                            ot: 0,
                                            tb: 0,
                                            bl: 1,
                                            dl: 1,
                                            mtp: 1,
                                            nor: 1,
                                            nrr: 1,
                                            su: 1,
                                            cid: 2,
                                            pr: 2,
                                            sf: 2,
                                            sid: 2,
                                            st: 2,
                                            v: 2,
                                            bs: 3,
                                            rtp: 3
                                        }, o = 0, s1 = Object.keys(t); o < s1.length; o++){
                                            var u = s1[o];
                                            i[null != a1[u] ? a1[u] : 1][u] = t[u];
                                        }
                                        for(var l = 0; l < i.length; l++){
                                            var c = e.serialize(i[l]);
                                            c && (n["CMCD-" + r[l]] = c);
                                        }
                                        return n;
                                    }, e.toQuery = function(t) {
                                        return "CMCD=" + encodeURIComponent(e.serialize(t));
                                    }, e.appendQueryToUri = function(e, t) {
                                        if (!t) return e;
                                        var n = e.includes("?") ? "&" : "?";
                                        return "" + e + n + t;
                                    }, e;
                                }();
                            },
                            "./src/controller/eme-controller.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>u
                                });
                                var r = n("./src/events.ts"), i = n("./src/errors.ts"), a1 = n("./src/utils/logger.ts"), o = n("./src/utils/mediakeys-helper.ts");
                                function s1(e, t) {
                                    for(var n = 0; n < t.length; n++){
                                        var r = t[n];
                                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                    }
                                }
                                const u = function() {
                                    function e(e) {
                                        this.hls = void 0, this._widevineLicenseUrl = void 0, this._licenseXhrSetup = void 0, this._licenseResponseCallback = void 0, this._emeEnabled = void 0, this._requestMediaKeySystemAccess = void 0, this._drmSystemOptions = void 0, this._config = void 0, this._mediaKeysList = [], this._media = null, this._hasSetMediaKeys = !1, this._requestLicenseFailureCount = 0, this.mediaKeysPromise = null, this._onMediaEncrypted = this.onMediaEncrypted.bind(this), this.hls = e, this._config = e.config, this._widevineLicenseUrl = this._config.widevineLicenseUrl, this._licenseXhrSetup = this._config.licenseXhrSetup, this._licenseResponseCallback = this._config.licenseResponseCallback, this._emeEnabled = this._config.emeEnabled, this._requestMediaKeySystemAccess = this._config.requestMediaKeySystemAccessFunc, this._drmSystemOptions = this._config.drmSystemOptions, this._registerListeners();
                                    }
                                    var t, n, u = e.prototype;
                                    return u.destroy = function() {
                                        this._unregisterListeners(), this.hls = this._onMediaEncrypted = null, this._requestMediaKeySystemAccess = null;
                                    }, u._registerListeners = function() {
                                        this.hls.on(r.Events.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(r.Events.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.on(r.Events.MANIFEST_PARSED, this.onManifestParsed, this);
                                    }, u._unregisterListeners = function() {
                                        this.hls.off(r.Events.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(r.Events.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.off(r.Events.MANIFEST_PARSED, this.onManifestParsed, this);
                                    }, u.getLicenseServerUrl = function(e) {
                                        switch(e){
                                            case o.KeySystems.WIDEVINE:
                                                if (!this._widevineLicenseUrl) break;
                                                return this._widevineLicenseUrl;
                                        }
                                        throw new Error('no license server URL configured for key-system "' + e + '"');
                                    }, u._attemptKeySystemAccess = function(e, t, n) {
                                        var r = this, i = function(e, t, n, r) {
                                            if (e === o.KeySystems.WIDEVINE) return function(e, t, n) {
                                                var r = {
                                                    audioCapabilities: [],
                                                    videoCapabilities: []
                                                };
                                                return e.forEach(function(e) {
                                                    r.audioCapabilities.push({
                                                        contentType: 'audio/mp4; codecs="' + e + '"',
                                                        robustness: n.audioRobustness || ""
                                                    });
                                                }), t.forEach(function(e) {
                                                    r.videoCapabilities.push({
                                                        contentType: 'video/mp4; codecs="' + e + '"',
                                                        robustness: n.videoRobustness || ""
                                                    });
                                                }), [
                                                    r
                                                ];
                                            }(t, n, r);
                                            throw new Error("Unknown key-system: " + e);
                                        }(e, t, n, this._drmSystemOptions);
                                        a1.logger.log("Requesting encrypted media key-system access");
                                        var s1 = this.requestMediaKeySystemAccess(e, i);
                                        this.mediaKeysPromise = s1.then(function(t) {
                                            return r._onMediaKeySystemAccessObtained(e, t);
                                        }), s1.catch(function(t) {
                                            a1.logger.error('Failed to obtain key-system "' + e + '" access:', t);
                                        });
                                    }, u._onMediaKeySystemAccessObtained = function(e, t) {
                                        var n = this;
                                        a1.logger.log('Access for key-system "' + e + '" obtained');
                                        var r = {
                                            mediaKeysSessionInitialized: !1,
                                            mediaKeySystemAccess: t,
                                            mediaKeySystemDomain: e
                                        };
                                        this._mediaKeysList.push(r);
                                        var i = Promise.resolve().then(function() {
                                            return t.createMediaKeys();
                                        }).then(function(t) {
                                            return r.mediaKeys = t, a1.logger.log('Media-keys created for key-system "' + e + '"'), n._onMediaKeysCreated(), t;
                                        });
                                        return i.catch(function(e) {
                                            a1.logger.error("Failed to create media-keys:", e);
                                        }), i;
                                    }, u._onMediaKeysCreated = function() {
                                        var e = this;
                                        this._mediaKeysList.forEach(function(t) {
                                            t.mediaKeysSession || (t.mediaKeysSession = t.mediaKeys.createSession(), e._onNewMediaKeySession(t.mediaKeysSession));
                                        });
                                    }, u._onNewMediaKeySession = function(e) {
                                        var t = this;
                                        a1.logger.log("New key-system session " + e.sessionId), e.addEventListener("message", function(n) {
                                            t._onKeySessionMessage(e, n.message);
                                        }, !1);
                                    }, u._onKeySessionMessage = function(e, t) {
                                        a1.logger.log("Got EME message event, creating license request"), this._requestLicense(t, function(t) {
                                            a1.logger.log("Received license data (length: " + (t ? t.byteLength : t) + "), updating key-session"), e.update(t).catch(function(e) {
                                                a1.logger.warn("Updating key-session failed: " + e);
                                            });
                                        });
                                    }, u.onMediaEncrypted = function(e) {
                                        var t = this;
                                        if (a1.logger.log('Media is encrypted using "' + e.initDataType + '" init data type'), !this.mediaKeysPromise) return a1.logger.error("Fatal: Media is encrypted but no CDM access or no keys have been requested"), void this.hls.trigger(r.Events.ERROR, {
                                            type: i.ErrorTypes.KEY_SYSTEM_ERROR,
                                            details: i.ErrorDetails.KEY_SYSTEM_NO_KEYS,
                                            fatal: !0
                                        });
                                        var n = function(n) {
                                            t._media && (t._attemptSetMediaKeys(n), t._generateRequestWithPreferredKeySession(e.initDataType, e.initData));
                                        };
                                        this.mediaKeysPromise.then(n).catch(n);
                                    }, u._attemptSetMediaKeys = function(e) {
                                        if (!this._media) throw new Error("Attempted to set mediaKeys without first attaching a media element");
                                        if (!this._hasSetMediaKeys) {
                                            var t = this._mediaKeysList[0];
                                            if (!t || !t.mediaKeys) return a1.logger.error("Fatal: Media is encrypted but no CDM access or no keys have been obtained yet"), void this.hls.trigger(r.Events.ERROR, {
                                                type: i.ErrorTypes.KEY_SYSTEM_ERROR,
                                                details: i.ErrorDetails.KEY_SYSTEM_NO_KEYS,
                                                fatal: !0
                                            });
                                            a1.logger.log("Setting keys for encrypted media"), this._media.setMediaKeys(t.mediaKeys), this._hasSetMediaKeys = !0;
                                        }
                                    }, u._generateRequestWithPreferredKeySession = function(e, t) {
                                        var n = this, o = this._mediaKeysList[0];
                                        if (!o) return a1.logger.error("Fatal: Media is encrypted but not any key-system access has been obtained yet"), void this.hls.trigger(r.Events.ERROR, {
                                            type: i.ErrorTypes.KEY_SYSTEM_ERROR,
                                            details: i.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                                            fatal: !0
                                        });
                                        if (o.mediaKeysSessionInitialized) a1.logger.warn("Key-Session already initialized but requested again");
                                        else {
                                            var s1 = o.mediaKeysSession;
                                            if (!s1) return a1.logger.error("Fatal: Media is encrypted but no key-session existing"), void this.hls.trigger(r.Events.ERROR, {
                                                type: i.ErrorTypes.KEY_SYSTEM_ERROR,
                                                details: i.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                                                fatal: !0
                                            });
                                            if (!t) return a1.logger.warn("Fatal: initData required for generating a key session is null"), void this.hls.trigger(r.Events.ERROR, {
                                                type: i.ErrorTypes.KEY_SYSTEM_ERROR,
                                                details: i.ErrorDetails.KEY_SYSTEM_NO_INIT_DATA,
                                                fatal: !0
                                            });
                                            a1.logger.log('Generating key-session request for "' + e + '" init data type'), o.mediaKeysSessionInitialized = !0, s1.generateRequest(e, t).then(function() {
                                                a1.logger.debug("Key-session generation succeeded");
                                            }).catch(function(e) {
                                                a1.logger.error("Error generating key-session request:", e), n.hls.trigger(r.Events.ERROR, {
                                                    type: i.ErrorTypes.KEY_SYSTEM_ERROR,
                                                    details: i.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                                                    fatal: !1
                                                });
                                            });
                                        }
                                    }, u._createLicenseXhr = function(e, t, n) {
                                        var r = new XMLHttpRequest;
                                        r.responseType = "arraybuffer", r.onreadystatechange = this._onLicenseRequestReadyStageChange.bind(this, r, e, t, n);
                                        var i = this._licenseXhrSetup;
                                        if (i) try {
                                            i.call(this.hls, r, e), i = void 0;
                                        } catch (e) {
                                            a1.logger.error(e);
                                        }
                                        try {
                                            r.readyState || r.open("POST", e, !0), i && i.call(this.hls, r, e);
                                        } catch (e) {
                                            throw new Error("issue setting up KeySystem license XHR " + e);
                                        }
                                        return r;
                                    }, u._onLicenseRequestReadyStageChange = function(e, t, n, o) {
                                        if (4 === e.readyState) {
                                            if (200 === e.status) {
                                                this._requestLicenseFailureCount = 0, a1.logger.log("License request succeeded");
                                                var s1 = e.response, u = this._licenseResponseCallback;
                                                if (u) try {
                                                    s1 = u.call(this.hls, e, t);
                                                } catch (e) {
                                                    a1.logger.error(e);
                                                }
                                                o(s1);
                                            } else {
                                                if (a1.logger.error("License Request XHR failed (" + t + "). Status: " + e.status + " (" + e.statusText + ")"), this._requestLicenseFailureCount++, this._requestLicenseFailureCount > 3) return void this.hls.trigger(r.Events.ERROR, {
                                                    type: i.ErrorTypes.KEY_SYSTEM_ERROR,
                                                    details: i.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                                                    fatal: !0
                                                });
                                                var l = 3 - this._requestLicenseFailureCount + 1;
                                                a1.logger.warn("Retrying license request, " + l + " attempts left"), this._requestLicense(n, o);
                                            }
                                        }
                                    }, u._generateLicenseRequestChallenge = function(e, t) {
                                        if (e.mediaKeySystemDomain === o.KeySystems.WIDEVINE) return t;
                                        throw new Error("unsupported key-system: " + e.mediaKeySystemDomain);
                                    }, u._requestLicense = function(e, t) {
                                        a1.logger.log("Requesting content license for key-system");
                                        var n = this._mediaKeysList[0];
                                        if (!n) return a1.logger.error("Fatal error: Media is encrypted but no key-system access has been obtained yet"), void this.hls.trigger(r.Events.ERROR, {
                                            type: i.ErrorTypes.KEY_SYSTEM_ERROR,
                                            details: i.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                                            fatal: !0
                                        });
                                        try {
                                            var o = this.getLicenseServerUrl(n.mediaKeySystemDomain), s1 = this._createLicenseXhr(o, e, t);
                                            a1.logger.log("Sending license request to URL: " + o);
                                            var u = this._generateLicenseRequestChallenge(n, e);
                                            s1.send(u);
                                        } catch (e) {
                                            a1.logger.error("Failure requesting DRM license: " + e), this.hls.trigger(r.Events.ERROR, {
                                                type: i.ErrorTypes.KEY_SYSTEM_ERROR,
                                                details: i.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                                                fatal: !0
                                            });
                                        }
                                    }, u.onMediaAttached = function(e, t) {
                                        if (this._emeEnabled) {
                                            var n = t.media;
                                            this._media = n, n.addEventListener("encrypted", this._onMediaEncrypted);
                                        }
                                    }, u.onMediaDetached = function() {
                                        var e = this._media, t = this._mediaKeysList;
                                        e && (e.removeEventListener("encrypted", this._onMediaEncrypted), this._media = null, this._mediaKeysList = [], Promise.all(t.map(function(e) {
                                            if (e.mediaKeysSession) return e.mediaKeysSession.close().catch(function() {});
                                        })).then(function() {
                                            return e.setMediaKeys(null);
                                        }).catch(function() {}));
                                    }, u.onManifestParsed = function(e, t) {
                                        if (this._emeEnabled) {
                                            var n = t.levels.map(function(e) {
                                                return e.audioCodec;
                                            }).filter(function(e) {
                                                return !!e;
                                            }), r = t.levels.map(function(e) {
                                                return e.videoCodec;
                                            }).filter(function(e) {
                                                return !!e;
                                            });
                                            this._attemptKeySystemAccess(o.KeySystems.WIDEVINE, n, r);
                                        }
                                    }, t = e, n = [
                                        {
                                            key: "requestMediaKeySystemAccess",
                                            get: function() {
                                                if (!this._requestMediaKeySystemAccess) throw new Error("No requestMediaKeySystemAccess function configured");
                                                return this._requestMediaKeySystemAccess;
                                            }
                                        }
                                    ], s1(t.prototype, n), Object.defineProperty(t, "prototype", {
                                        writable: !1
                                    }), e;
                                }();
                            },
                            "./src/controller/fps-controller.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>a1
                                });
                                var r = n("./src/events.ts"), i = n("./src/utils/logger.ts");
                                const a1 = function() {
                                    function e(e) {
                                        this.hls = void 0, this.isVideoPlaybackQualityAvailable = !1, this.timer = void 0, this.media = null, this.lastTime = void 0, this.lastDroppedFrames = 0, this.lastDecodedFrames = 0, this.streamController = void 0, this.hls = e, this.registerListeners();
                                    }
                                    var t = e.prototype;
                                    return t.setStreamController = function(e) {
                                        this.streamController = e;
                                    }, t.registerListeners = function() {
                                        this.hls.on(r.Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
                                    }, t.unregisterListeners = function() {
                                        this.hls.off(r.Events.MEDIA_ATTACHING, this.onMediaAttaching);
                                    }, t.destroy = function() {
                                        this.timer && clearInterval(this.timer), this.unregisterListeners(), this.isVideoPlaybackQualityAvailable = !1, this.media = null;
                                    }, t.onMediaAttaching = function(e, t) {
                                        var n = this.hls.config;
                                        if (n.capLevelOnFPSDrop) {
                                            var r = t.media instanceof self.HTMLVideoElement ? t.media : null;
                                            this.media = r, r && "function" == typeof r.getVideoPlaybackQuality && (this.isVideoPlaybackQualityAvailable = !0), self.clearInterval(this.timer), this.timer = self.setInterval(this.checkFPSInterval.bind(this), n.fpsDroppedMonitoringPeriod);
                                        }
                                    }, t.checkFPS = function(e, t, n) {
                                        var a1 = performance.now();
                                        if (t) {
                                            if (this.lastTime) {
                                                var o = a1 - this.lastTime, s1 = n - this.lastDroppedFrames, u = t - this.lastDecodedFrames, l = 1e3 * s1 / o, c = this.hls;
                                                if (c.trigger(r.Events.FPS_DROP, {
                                                    currentDropped: s1,
                                                    currentDecoded: u,
                                                    totalDroppedFrames: n
                                                }), l > 0 && s1 > c.config.fpsDroppedMonitoringThreshold * u) {
                                                    var d = c.currentLevel;
                                                    i.logger.warn("drop FPS ratio greater than max allowed value for currentLevel: " + d), d > 0 && (-1 === c.autoLevelCapping || c.autoLevelCapping >= d) && (d -= 1, c.trigger(r.Events.FPS_DROP_LEVEL_CAPPING, {
                                                        level: d,
                                                        droppedLevel: c.currentLevel
                                                    }), c.autoLevelCapping = d, this.streamController.nextLevelSwitch());
                                                }
                                            }
                                            this.lastTime = a1, this.lastDroppedFrames = n, this.lastDecodedFrames = t;
                                        }
                                    }, t.checkFPSInterval = function() {
                                        var e = this.media;
                                        if (e) {
                                            if (this.isVideoPlaybackQualityAvailable) {
                                                var t = e.getVideoPlaybackQuality();
                                                this.checkFPS(e, t.totalVideoFrames, t.droppedVideoFrames);
                                            } else this.checkFPS(e, e.webkitDecodedFrameCount, e.webkitDroppedFrameCount);
                                        }
                                    }, e;
                                }();
                            },
                            "./src/controller/fragment-finders.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    findFragWithCC: ()=>l,
                                    findFragmentByPDT: ()=>a1,
                                    findFragmentByPTS: ()=>o,
                                    fragmentWithinToleranceTest: ()=>s1,
                                    pdtWithinToleranceTest: ()=>u
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./src/utils/binary-search.ts");
                                function a1(e, t, n) {
                                    if (null === t || !Array.isArray(e) || !e.length || !(0, r.isFiniteNumber)(t)) return null;
                                    if (t < (e[0].programDateTime || 0)) return null;
                                    if (t >= (e[e.length - 1].endProgramDateTime || 0)) return null;
                                    n = n || 0;
                                    for(var i = 0; i < e.length; ++i){
                                        var a1 = e[i];
                                        if (u(t, n, a1)) return a1;
                                    }
                                    return null;
                                }
                                function o(e, t, n, r) {
                                    void 0 === n && (n = 0), void 0 === r && (r = 0);
                                    var a1 = null;
                                    return e ? a1 = t[e.sn - t[0].sn + 1] || null : 0 === n && 0 === t[0].start && (a1 = t[0]), a1 && 0 === s1(n, r, a1) ? a1 : i.default.search(t, s1.bind(null, n, r)) || a1;
                                }
                                function s1(e, t, n) {
                                    void 0 === e && (e = 0), void 0 === t && (t = 0);
                                    var r = Math.min(t, n.duration + (n.deltaPTS ? n.deltaPTS : 0));
                                    return n.start + n.duration - r <= e ? 1 : n.start - r > e && n.start ? -1 : 0;
                                }
                                function u(e, t, n) {
                                    var r = 1e3 * Math.min(t, n.duration + (n.deltaPTS ? n.deltaPTS : 0));
                                    return (n.endProgramDateTime || 0) - r > e;
                                }
                                function l(e, t) {
                                    return i.default.search(e, function(e) {
                                        return e.cc < t ? 1 : e.cc > t ? -1 : 0;
                                    });
                                }
                            },
                            "./src/controller/fragment-tracker.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    FragmentState: ()=>r,
                                    FragmentTracker: ()=>o
                                });
                                var r, i = n("./src/events.ts"), a1 = n("./src/types/loader.ts");
                                !function(e) {
                                    e.NOT_LOADED = "NOT_LOADED", e.APPENDING = "APPENDING", e.PARTIAL = "PARTIAL", e.OK = "OK";
                                }(r || (r = {}));
                                var o = function() {
                                    function e(e) {
                                        this.activeFragment = null, this.activeParts = null, this.fragments = Object.create(null), this.timeRanges = Object.create(null), this.bufferPadding = .2, this.hls = void 0, this.hls = e, this._registerListeners();
                                    }
                                    var t = e.prototype;
                                    return t._registerListeners = function() {
                                        var e = this.hls;
                                        e.on(i.Events.BUFFER_APPENDED, this.onBufferAppended, this), e.on(i.Events.FRAG_BUFFERED, this.onFragBuffered, this), e.on(i.Events.FRAG_LOADED, this.onFragLoaded, this);
                                    }, t._unregisterListeners = function() {
                                        var e = this.hls;
                                        e.off(i.Events.BUFFER_APPENDED, this.onBufferAppended, this), e.off(i.Events.FRAG_BUFFERED, this.onFragBuffered, this), e.off(i.Events.FRAG_LOADED, this.onFragLoaded, this);
                                    }, t.destroy = function() {
                                        this._unregisterListeners(), this.fragments = this.timeRanges = null;
                                    }, t.getAppendedFrag = function(e, t) {
                                        if (t === a1.PlaylistLevelType.MAIN) {
                                            var n = this.activeFragment, r = this.activeParts;
                                            if (!n) return null;
                                            if (r) for(var i = r.length; i--;){
                                                var o = r[i], s1 = o ? o.end : n.appendedPTS;
                                                if (o.start <= e && void 0 !== s1 && e <= s1) return i > 9 && (this.activeParts = r.slice(i - 9)), o;
                                            }
                                            else if (n.start <= e && void 0 !== n.appendedPTS && e <= n.appendedPTS) return n;
                                        }
                                        return this.getBufferedFrag(e, t);
                                    }, t.getBufferedFrag = function(e, t) {
                                        for(var n = this.fragments, r = Object.keys(n), i = r.length; i--;){
                                            var a1 = n[r[i]];
                                            if ((null == a1 ? void 0 : a1.body.type) === t && a1.buffered) {
                                                var o = a1.body;
                                                if (o.start <= e && e <= o.end) return o;
                                            }
                                        }
                                        return null;
                                    }, t.detectEvictedFragments = function(e, t, n) {
                                        var r = this;
                                        Object.keys(this.fragments).forEach(function(i) {
                                            var a1 = r.fragments[i];
                                            if (a1) {
                                                if (a1.buffered) {
                                                    var o = a1.range[e];
                                                    o && o.time.some(function(e) {
                                                        var n = !r.isTimeBuffered(e.startPTS, e.endPTS, t);
                                                        return n && r.removeFragment(a1.body), n;
                                                    });
                                                } else a1.body.type === n && r.removeFragment(a1.body);
                                            }
                                        });
                                    }, t.detectPartialFragments = function(e) {
                                        var t = this, n = this.timeRanges, r = e.frag, i = e.part;
                                        if (n && "initSegment" !== r.sn) {
                                            var a1 = u(r), o = this.fragments[a1];
                                            o && (Object.keys(n).forEach(function(e) {
                                                var a1 = r.elementaryStreams[e];
                                                if (a1) {
                                                    var s1 = n[e], u = null !== i || !0 === a1.partial;
                                                    o.range[e] = t.getBufferedTimes(r, i, u, s1);
                                                }
                                            }), o.loaded = null, Object.keys(o.range).length ? o.buffered = !0 : this.removeFragment(o.body));
                                        }
                                    }, t.fragBuffered = function(e) {
                                        var t = u(e), n = this.fragments[t];
                                        n && (n.loaded = null, n.buffered = !0);
                                    }, t.getBufferedTimes = function(e, t, n, r) {
                                        for(var i = {
                                            time: [],
                                            partial: n
                                        }, a1 = t ? t.start : e.start, o = t ? t.end : e.end, s1 = e.minEndPTS || o, u = e.maxStartPTS || a1, l = 0; l < r.length; l++){
                                            var c = r.start(l) - this.bufferPadding, d = r.end(l) + this.bufferPadding;
                                            if (u >= c && s1 <= d) {
                                                i.time.push({
                                                    startPTS: Math.max(a1, r.start(l)),
                                                    endPTS: Math.min(o, r.end(l))
                                                });
                                                break;
                                            }
                                            if (a1 < d && o > c) i.partial = !0, i.time.push({
                                                startPTS: Math.max(a1, r.start(l)),
                                                endPTS: Math.min(o, r.end(l))
                                            });
                                            else if (o <= c) break;
                                        }
                                        return i;
                                    }, t.getPartialFragment = function(e) {
                                        var t, n, r, i = null, a1 = 0, o = this.bufferPadding, u = this.fragments;
                                        return Object.keys(u).forEach(function(l) {
                                            var c = u[l];
                                            c && s1(c) && (n = c.body.start - o, r = c.body.end + o, e >= n && e <= r && (t = Math.min(e - n, r - e), a1 <= t && (i = c.body, a1 = t)));
                                        }), i;
                                    }, t.getState = function(e) {
                                        var t = u(e), n = this.fragments[t];
                                        return n ? n.buffered ? s1(n) ? r.PARTIAL : r.OK : r.APPENDING : r.NOT_LOADED;
                                    }, t.isTimeBuffered = function(e, t, n) {
                                        for(var r, i, a1 = 0; a1 < n.length; a1++){
                                            if (r = n.start(a1) - this.bufferPadding, i = n.end(a1) + this.bufferPadding, e >= r && t <= i) return !0;
                                            if (t <= r) return !1;
                                        }
                                        return !1;
                                    }, t.onFragLoaded = function(e, t) {
                                        var n = t.frag, r = t.part;
                                        if ("initSegment" !== n.sn && !n.bitrateTest && !r) {
                                            var i = u(n);
                                            this.fragments[i] = {
                                                body: n,
                                                loaded: t,
                                                buffered: !1,
                                                range: Object.create(null)
                                            };
                                        }
                                    }, t.onBufferAppended = function(e, t) {
                                        var n = this, r = t.frag, i = t.part, o = t.timeRanges;
                                        if (r.type === a1.PlaylistLevelType.MAIN) {
                                            if (this.activeFragment = r, i) {
                                                var s1 = this.activeParts;
                                                s1 || (this.activeParts = s1 = []), s1.push(i);
                                            } else this.activeParts = null;
                                        }
                                        this.timeRanges = o, Object.keys(o).forEach(function(e) {
                                            var t = o[e];
                                            if (n.detectEvictedFragments(e, t), !i) for(var a1 = 0; a1 < t.length; a1++)r.appendedPTS = Math.max(t.end(a1), r.appendedPTS || 0);
                                        });
                                    }, t.onFragBuffered = function(e, t) {
                                        this.detectPartialFragments(t);
                                    }, t.hasFragment = function(e) {
                                        var t = u(e);
                                        return !!this.fragments[t];
                                    }, t.removeFragmentsInRange = function(e, t, n) {
                                        var r = this;
                                        Object.keys(this.fragments).forEach(function(i) {
                                            var a1 = r.fragments[i];
                                            if (a1 && a1.buffered) {
                                                var o = a1.body;
                                                o.type === n && o.start < t && o.end > e && r.removeFragment(o);
                                            }
                                        });
                                    }, t.removeFragment = function(e) {
                                        var t = u(e);
                                        e.stats.loaded = 0, e.clearElementaryStreamInfo(), delete this.fragments[t];
                                    }, t.removeAllFragments = function() {
                                        this.fragments = Object.create(null), this.activeFragment = null, this.activeParts = null;
                                    }, e;
                                }();
                                function s1(e) {
                                    var t, n;
                                    return e.buffered && ((null === (t = e.range.video) || void 0 === t ? void 0 : t.partial) || (null === (n = e.range.audio) || void 0 === n ? void 0 : n.partial));
                                }
                                function u(e) {
                                    return e.type + "_" + e.level + "_" + e.urlId + "_" + e.sn;
                                }
                            },
                            "./src/controller/gap-controller.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    MAX_START_GAP_JUMP: ()=>u,
                                    SKIP_BUFFER_HOLE_STEP_SECONDS: ()=>l,
                                    SKIP_BUFFER_RANGE_START: ()=>c,
                                    STALL_MINIMUM_DURATION_MS: ()=>s1,
                                    default: ()=>d
                                });
                                var r = n("./src/utils/buffer-helper.ts"), i = n("./src/errors.ts"), a1 = n("./src/events.ts"), o = n("./src/utils/logger.ts"), s1 = 250, u = 2, l = .1, c = .05, d = function() {
                                    function e(e, t, n, r) {
                                        this.config = void 0, this.media = null, this.fragmentTracker = void 0, this.hls = void 0, this.nudgeRetry = 0, this.stallReported = !1, this.stalled = null, this.moved = !1, this.seeking = !1, this.config = e, this.media = t, this.fragmentTracker = n, this.hls = r;
                                    }
                                    var t = e.prototype;
                                    return t.destroy = function() {
                                        this.media = null, this.hls = this.fragmentTracker = null;
                                    }, t.poll = function(e, t) {
                                        var n = this.config, i = this.media, a1 = this.stalled;
                                        if (null !== i) {
                                            var l = i.currentTime, c = i.seeking, d = this.seeking && !c, f = !this.seeking && c;
                                            if (this.seeking = c, l === e) {
                                                if ((f || d) && (this.stalled = null), !(i.paused && !c || i.ended || 0 === i.playbackRate) && r.BufferHelper.getBuffered(i).length) {
                                                    var h = r.BufferHelper.bufferInfo(i, l, 0), g = h.len > 0, p = h.nextStart || 0;
                                                    if (g || p) {
                                                        if (c) {
                                                            var m = h.len > u, v = !p || t && t.start <= l || p - l > u && !this.fragmentTracker.getPartialFragment(l);
                                                            if (m || v) return;
                                                            this.moved = !1;
                                                        }
                                                        if (!this.moved && null !== this.stalled) {
                                                            var y, E = Math.max(p, h.start || 0) - l, T = this.hls.levels ? this.hls.levels[this.hls.currentLevel] : null, b = (null == T || null === (y = T.details) || void 0 === y ? void 0 : y.live) ? 2 * T.details.targetduration : u;
                                                            if (E > 0 && E <= b) return void this._trySkipBufferHole(null);
                                                        }
                                                        var A = self.performance.now();
                                                        if (null !== a1) {
                                                            var _ = A - a1;
                                                            if (c || !(_ >= s1) || (this._reportStall(h), this.media)) {
                                                                var S = r.BufferHelper.bufferInfo(i, l, n.maxBufferHole);
                                                                this._tryFixBufferStall(S, _);
                                                            }
                                                        } else this.stalled = A;
                                                    }
                                                }
                                            } else if (this.moved = !0, null !== a1) {
                                                if (this.stallReported) {
                                                    var w = self.performance.now() - a1;
                                                    o.logger.warn("playback not stuck anymore @" + l + ", after " + Math.round(w) + "ms"), this.stallReported = !1;
                                                }
                                                this.stalled = null, this.nudgeRetry = 0;
                                            }
                                        }
                                    }, t._tryFixBufferStall = function(e, t) {
                                        var n = this.config, r = this.fragmentTracker, i = this.media;
                                        if (null !== i) {
                                            var a1 = i.currentTime, s1 = r.getPartialFragment(a1);
                                            if (s1 && (this._trySkipBufferHole(s1) || !this.media)) return;
                                            e.len > n.maxBufferHole && t > 1e3 * n.highBufferWatchdogPeriod && (o.logger.warn("Trying to nudge playhead over buffer-hole"), this.stalled = null, this._tryNudgeBuffer());
                                        }
                                    }, t._reportStall = function(e) {
                                        var t = this.hls, n = this.media;
                                        !this.stallReported && n && (this.stallReported = !0, o.logger.warn("Playback stalling at @" + n.currentTime + " due to low buffer (" + JSON.stringify(e) + ")"), t.trigger(a1.Events.ERROR, {
                                            type: i.ErrorTypes.MEDIA_ERROR,
                                            details: i.ErrorDetails.BUFFER_STALLED_ERROR,
                                            fatal: !1,
                                            buffer: e.len
                                        }));
                                    }, t._trySkipBufferHole = function(e) {
                                        var t = this.config, n = this.hls, s1 = this.media;
                                        if (null === s1) return 0;
                                        for(var u = s1.currentTime, d = 0, f = r.BufferHelper.getBuffered(s1), h = 0; h < f.length; h++){
                                            var g = f.start(h);
                                            if (u + t.maxBufferHole >= d && u < g) {
                                                var p = Math.max(g + c, s1.currentTime + l);
                                                return o.logger.warn("skipping hole, adjusting currentTime from " + u + " to " + p), this.moved = !0, this.stalled = null, s1.currentTime = p, e && n.trigger(a1.Events.ERROR, {
                                                    type: i.ErrorTypes.MEDIA_ERROR,
                                                    details: i.ErrorDetails.BUFFER_SEEK_OVER_HOLE,
                                                    fatal: !1,
                                                    reason: "fragment loaded with buffer holes, seeking from " + u + " to " + p,
                                                    frag: e
                                                }), p;
                                            }
                                            d = f.end(h);
                                        }
                                        return 0;
                                    }, t._tryNudgeBuffer = function() {
                                        var e = this.config, t = this.hls, n = this.media, r = this.nudgeRetry;
                                        if (null !== n) {
                                            var s1 = n.currentTime;
                                            if (this.nudgeRetry++, r < e.nudgeMaxRetry) {
                                                var u = s1 + (r + 1) * e.nudgeOffset;
                                                o.logger.warn("Nudging 'currentTime' from " + s1 + " to " + u), n.currentTime = u, t.trigger(a1.Events.ERROR, {
                                                    type: i.ErrorTypes.MEDIA_ERROR,
                                                    details: i.ErrorDetails.BUFFER_NUDGE_ON_STALL,
                                                    fatal: !1
                                                });
                                            } else o.logger.error("Playhead still not moving while enough data buffered @" + s1 + " after " + e.nudgeMaxRetry + " nudges"), t.trigger(a1.Events.ERROR, {
                                                type: i.ErrorTypes.MEDIA_ERROR,
                                                details: i.ErrorDetails.BUFFER_STALLED_ERROR,
                                                fatal: !0
                                            });
                                        }
                                    }, e;
                                }();
                            },
                            "./src/controller/id3-track-controller.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>f
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./src/events.ts"), a1 = n("./src/utils/texttrack-utils.ts"), o = n("./src/demux/id3.ts"), s1 = n("./src/loader/date-range.ts"), u = n("./src/types/demuxer.ts");
                                function l() {
                                    return self.WebKitDataCue || self.VTTCue || self.TextTrackCue;
                                }
                                var c = function() {
                                    var e = l();
                                    try {
                                        new e(0, Number.POSITIVE_INFINITY, "");
                                    } catch (e) {
                                        return Number.MAX_VALUE;
                                    }
                                    return Number.POSITIVE_INFINITY;
                                }();
                                function d(e, t) {
                                    return e.getTime() / 1e3 - t;
                                }
                                const f = function() {
                                    function e(e) {
                                        this.hls = void 0, this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = e, this._registerListeners();
                                    }
                                    var t = e.prototype;
                                    return t.destroy = function() {
                                        this._unregisterListeners(), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = null;
                                    }, t._registerListeners = function() {
                                        var e = this.hls;
                                        e.on(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(i.Events.MANIFEST_LOADING, this.onManifestLoading, this), e.on(i.Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.on(i.Events.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(i.Events.LEVEL_UPDATED, this.onLevelUpdated, this);
                                    }, t._unregisterListeners = function() {
                                        var e = this.hls;
                                        e.off(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(i.Events.MANIFEST_LOADING, this.onManifestLoading, this), e.off(i.Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.off(i.Events.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(i.Events.LEVEL_UPDATED, this.onLevelUpdated, this);
                                    }, t.onMediaAttached = function(e, t) {
                                        this.media = t.media;
                                    }, t.onMediaDetaching = function() {
                                        this.id3Track && ((0, a1.clearCurrentCues)(this.id3Track), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {});
                                    }, t.onManifestLoading = function() {
                                        this.dateRangeCuesAppended = {};
                                    }, t.createTrack = function(e) {
                                        var t = this.getID3Track(e.textTracks);
                                        return t.mode = "hidden", t;
                                    }, t.getID3Track = function(e) {
                                        if (this.media) {
                                            for(var t = 0; t < e.length; t++){
                                                var n = e[t];
                                                if ("metadata" === n.kind && "id3" === n.label) return (0, a1.sendAddTrackEvent)(n, this.media), n;
                                            }
                                            return this.media.addTextTrack("metadata", "id3");
                                        }
                                    }, t.onFragParsingMetadata = function(e, t) {
                                        if (this.media) {
                                            var n = this.hls.config, r = n.enableEmsgMetadataCues, i = n.enableID3MetadataCues;
                                            if (r || i) {
                                                t.frag;
                                                var a1 = t.samples;
                                                t.details, this.id3Track || (this.id3Track = this.createTrack(this.media));
                                                for(var s1 = l(), d = 0; d < a1.length; d++){
                                                    var f = a1[d].type;
                                                    if ((f !== u.MetadataSchema.emsg || r) && i) {
                                                        var h = o.getID3Frames(a1[d].data);
                                                        if (h) {
                                                            var g = a1[d].pts, p = g + a1[d].duration;
                                                            p > c && (p = c), p - g <= 0 && (p = g + .25);
                                                            for(var m = 0; m < h.length; m++){
                                                                var v = h[m];
                                                                if (!o.isTimeStampFrame(v)) {
                                                                    this.updateId3CueEnds(g);
                                                                    var y = new s1(g, p, "");
                                                                    y.value = v, f && (y.type = f), this.id3Track.addCue(y);
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }, t.updateId3CueEnds = function(e) {
                                        var t, n = null === (t = this.id3Track) || void 0 === t ? void 0 : t.cues;
                                        if (n) for(var r = n.length; r--;){
                                            var i = n[r];
                                            i.startTime < e && i.endTime === c && (i.endTime = e);
                                        }
                                    }, t.onBufferFlushing = function(e, t) {
                                        var n = t.startOffset, r = t.endOffset, i = t.type, o = this.id3Track, s1 = this.hls;
                                        if (s1) {
                                            var l, c = s1.config, d = c.enableEmsgMetadataCues, f = c.enableID3MetadataCues;
                                            o && (d || f) && (l = "audio" === i ? function(e) {
                                                return e.type === u.MetadataSchema.audioId3 && f;
                                            } : "video" === i ? function(e) {
                                                return e.type === u.MetadataSchema.emsg && d;
                                            } : function(e) {
                                                return e.type === u.MetadataSchema.audioId3 && f || e.type === u.MetadataSchema.emsg && d;
                                            }, (0, a1.removeCuesInRange)(o, n, r, l));
                                        }
                                    }, t.onLevelUpdated = function(e, t) {
                                        var n = this, i = t.details;
                                        if (this.media && i.hasProgramDateTime && this.hls.config.enableDateRangeMetadataCues) {
                                            var a1 = this.dateRangeCuesAppended, o = this.id3Track, f = i.dateRanges, h = Object.keys(f);
                                            if (o) for(var g = Object.keys(a1).filter(function(e) {
                                                return !h.includes(e);
                                            }), p = function(e) {
                                                var t = g[e];
                                                Object.keys(a1[t].cues).forEach(function(e) {
                                                    o.removeCue(a1[t].cues[e]);
                                                }), delete a1[t];
                                            }, m = g.length; m--;)p(m);
                                            var v = i.fragments[i.fragments.length - 1];
                                            if (0 !== h.length && (0, r.isFiniteNumber)(null == v ? void 0 : v.programDateTime)) {
                                                this.id3Track || (this.id3Track = this.createTrack(this.media));
                                                for(var y = v.programDateTime / 1e3 - v.start, E = l(), T = function(e) {
                                                    var t = h[e], r = f[t], i = a1[t], o = (null == i ? void 0 : i.cues) || {}, l = (null == i ? void 0 : i.durationKnown) || !1, g = d(r.startDate, y), p = c, m = r.endDate;
                                                    if (m) p = d(m, y), l = !0;
                                                    else if (r.endOnNext && !l) {
                                                        var v = h.reduce(function(e, t) {
                                                            var n = f[t];
                                                            return n.class === r.class && n.id !== t && n.startDate > r.startDate && e.push(n), e;
                                                        }, []).sort(function(e, t) {
                                                            return e.startDate.getTime() - t.startDate.getTime();
                                                        })[0];
                                                        v && (p = d(v.startDate, y), l = !0);
                                                    }
                                                    for(var T, b = Object.keys(r.attr), A = 0; A < b.length; A++){
                                                        var _ = b[A];
                                                        if (_ !== s1.DateRangeAttribute.ID && _ !== s1.DateRangeAttribute.CLASS && _ !== s1.DateRangeAttribute.START_DATE && _ !== s1.DateRangeAttribute.DURATION && _ !== s1.DateRangeAttribute.END_DATE && _ !== s1.DateRangeAttribute.END_ON_NEXT) {
                                                            var S = o[_];
                                                            if (S) l && !i.durationKnown && (S.endTime = p);
                                                            else {
                                                                var w = r.attr[_];
                                                                S = new E(g, p, ""), _ !== s1.DateRangeAttribute.SCTE35_OUT && _ !== s1.DateRangeAttribute.SCTE35_IN || (T = w, w = Uint8Array.from(T.replace(/^0x/, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ")).buffer), S.value = {
                                                                    key: _,
                                                                    data: w
                                                                }, S.type = u.MetadataSchema.dateRange, n.id3Track.addCue(S), o[_] = S;
                                                            }
                                                        }
                                                    }
                                                    a1[t] = {
                                                        cues: o,
                                                        dateRange: r,
                                                        durationKnown: l
                                                    };
                                                }, b = 0; b < h.length; b++)T(b);
                                            }
                                        }
                                    }, e;
                                }();
                            },
                            "./src/controller/latency-controller.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>s1
                                });
                                var r = n("./src/errors.ts"), i = n("./src/events.ts"), a1 = n("./src/utils/logger.ts");
                                function o(e, t) {
                                    for(var n = 0; n < t.length; n++){
                                        var r = t[n];
                                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                    }
                                }
                                var s1 = function() {
                                    function e(e) {
                                        var t = this;
                                        this.hls = void 0, this.config = void 0, this.media = null, this.levelDetails = null, this.currentTime = 0, this.stallCount = 0, this._latency = null, this.timeupdateHandler = function() {
                                            return t.timeupdate();
                                        }, this.hls = e, this.config = e.config, this.registerListeners();
                                    }
                                    var t, n, s1 = e.prototype;
                                    return s1.destroy = function() {
                                        this.unregisterListeners(), this.onMediaDetaching(), this.levelDetails = null, this.hls = this.timeupdateHandler = null;
                                    }, s1.registerListeners = function() {
                                        this.hls.on(i.Events.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this), this.hls.on(i.Events.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(i.Events.LEVEL_UPDATED, this.onLevelUpdated, this), this.hls.on(i.Events.ERROR, this.onError, this);
                                    }, s1.unregisterListeners = function() {
                                        this.hls.off(i.Events.MEDIA_ATTACHED, this.onMediaAttached), this.hls.off(i.Events.MEDIA_DETACHING, this.onMediaDetaching), this.hls.off(i.Events.MANIFEST_LOADING, this.onManifestLoading), this.hls.off(i.Events.LEVEL_UPDATED, this.onLevelUpdated), this.hls.off(i.Events.ERROR, this.onError);
                                    }, s1.onMediaAttached = function(e, t) {
                                        this.media = t.media, this.media.addEventListener("timeupdate", this.timeupdateHandler);
                                    }, s1.onMediaDetaching = function() {
                                        this.media && (this.media.removeEventListener("timeupdate", this.timeupdateHandler), this.media = null);
                                    }, s1.onManifestLoading = function() {
                                        this.levelDetails = null, this._latency = null, this.stallCount = 0;
                                    }, s1.onLevelUpdated = function(e, t) {
                                        var n = t.details;
                                        this.levelDetails = n, n.advanced && this.timeupdate(), !n.live && this.media && this.media.removeEventListener("timeupdate", this.timeupdateHandler);
                                    }, s1.onError = function(e, t) {
                                        t.details === r.ErrorDetails.BUFFER_STALLED_ERROR && (this.stallCount++, a1.logger.warn("[playback-rate-controller]: Stall detected, adjusting target latency"));
                                    }, s1.timeupdate = function() {
                                        var e = this.media, t = this.levelDetails;
                                        if (e && t) {
                                            this.currentTime = e.currentTime;
                                            var n = this.computeLatency();
                                            if (null !== n) {
                                                this._latency = n;
                                                var r = this.config, i = r.lowLatencyMode, a1 = r.maxLiveSyncPlaybackRate;
                                                if (i && 1 !== a1) {
                                                    var o = this.targetLatency;
                                                    if (null !== o) {
                                                        var s1 = n - o, u = s1 < Math.min(this.maxLatency, o + t.targetduration);
                                                        if (t.live && u && s1 > .05 && this.forwardBufferLength > 1) {
                                                            var l = Math.min(2, Math.max(1, a1)), c = Math.round(2 / (1 + Math.exp(-0.75 * s1 - this.edgeStalled)) * 20) / 20;
                                                            e.playbackRate = Math.min(l, Math.max(1, c));
                                                        } else 1 !== e.playbackRate && 0 !== e.playbackRate && (e.playbackRate = 1);
                                                    }
                                                }
                                            }
                                        }
                                    }, s1.estimateLiveEdge = function() {
                                        var e = this.levelDetails;
                                        return null === e ? null : e.edge + e.age;
                                    }, s1.computeLatency = function() {
                                        var e = this.estimateLiveEdge();
                                        return null === e ? null : e - this.currentTime;
                                    }, t = e, n = [
                                        {
                                            key: "latency",
                                            get: function() {
                                                return this._latency || 0;
                                            }
                                        },
                                        {
                                            key: "maxLatency",
                                            get: function() {
                                                var e = this.config, t = this.levelDetails;
                                                return void 0 !== e.liveMaxLatencyDuration ? e.liveMaxLatencyDuration : t ? e.liveMaxLatencyDurationCount * t.targetduration : 0;
                                            }
                                        },
                                        {
                                            key: "targetLatency",
                                            get: function() {
                                                var e = this.levelDetails;
                                                if (null === e) return null;
                                                var t = e.holdBack, n = e.partHoldBack, r = e.targetduration, i = this.config, a1 = i.liveSyncDuration, o = i.liveSyncDurationCount, s1 = i.lowLatencyMode, u = this.hls.userConfig, l = s1 && n || t;
                                                (u.liveSyncDuration || u.liveSyncDurationCount || 0 === l) && (l = void 0 !== a1 ? a1 : o * r);
                                                var c = r;
                                                return l + Math.min(1 * this.stallCount, c);
                                            }
                                        },
                                        {
                                            key: "liveSyncPosition",
                                            get: function() {
                                                var e = this.estimateLiveEdge(), t = this.targetLatency, n = this.levelDetails;
                                                if (null === e || null === t || null === n) return null;
                                                var r = n.edge, i = e - t - this.edgeStalled, a1 = r - n.totalduration, o = r - (this.config.lowLatencyMode && n.partTarget || n.targetduration);
                                                return Math.min(Math.max(a1, i), o);
                                            }
                                        },
                                        {
                                            key: "drift",
                                            get: function() {
                                                var e = this.levelDetails;
                                                return null === e ? 1 : e.drift;
                                            }
                                        },
                                        {
                                            key: "edgeStalled",
                                            get: function() {
                                                var e = this.levelDetails;
                                                if (null === e) return 0;
                                                var t = 3 * (this.config.lowLatencyMode && e.partTarget || e.targetduration);
                                                return Math.max(e.age - t, 0);
                                            }
                                        },
                                        {
                                            key: "forwardBufferLength",
                                            get: function() {
                                                var e = this.media, t = this.levelDetails;
                                                if (!e || !t) return 0;
                                                var n = e.buffered.length;
                                                return (n ? e.buffered.end(n - 1) : t.edge) - this.currentTime;
                                            }
                                        }
                                    ], o(t.prototype, n), Object.defineProperty(t, "prototype", {
                                        writable: !1
                                    }), e;
                                }();
                            },
                            "./src/controller/level-controller.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>g
                                });
                                var r = n("./src/types/level.ts"), i = n("./src/events.ts"), a1 = n("./src/errors.ts"), o = n("./src/utils/codecs.ts"), s1 = n("./src/controller/level-helper.ts"), u = n("./src/controller/base-playlist-controller.ts"), l = n("./src/types/loader.ts");
                                function c() {
                                    return c = Object.assign ? Object.assign.bind() : function(e) {
                                        for(var t = 1; t < arguments.length; t++){
                                            var n = arguments[t];
                                            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                                        }
                                        return e;
                                    }, c.apply(this, arguments);
                                }
                                function d(e, t) {
                                    for(var n = 0; n < t.length; n++){
                                        var r = t[n];
                                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                    }
                                }
                                function f(e, t) {
                                    return f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, f(e, t);
                                }
                                var h = /chrome|firefox/.test(navigator.userAgent.toLowerCase()), g = function(e) {
                                    var t, n;
                                    function u(t) {
                                        var n;
                                        return (n = e.call(this, t, "[level-controller]") || this)._levels = [], n._firstLevel = -1, n._startLevel = void 0, n.currentLevelIndex = -1, n.manualLevelIndex = -1, n.onParsedComplete = void 0, n._registerListeners(), n;
                                    }
                                    n = e, (t = u).prototype = Object.create(n.prototype), t.prototype.constructor = t, f(t, n);
                                    var g, p, m = u.prototype;
                                    return m._registerListeners = function() {
                                        var e = this.hls;
                                        e.on(i.Events.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(i.Events.LEVEL_LOADED, this.onLevelLoaded, this), e.on(i.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.on(i.Events.FRAG_LOADED, this.onFragLoaded, this), e.on(i.Events.ERROR, this.onError, this);
                                    }, m._unregisterListeners = function() {
                                        var e = this.hls;
                                        e.off(i.Events.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(i.Events.LEVEL_LOADED, this.onLevelLoaded, this), e.off(i.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.off(i.Events.FRAG_LOADED, this.onFragLoaded, this), e.off(i.Events.ERROR, this.onError, this);
                                    }, m.destroy = function() {
                                        this._unregisterListeners(), this.manualLevelIndex = -1, this._levels.length = 0, e.prototype.destroy.call(this);
                                    }, m.startLoad = function() {
                                        this._levels.forEach(function(e) {
                                            e.loadError = 0;
                                        }), e.prototype.startLoad.call(this);
                                    }, m.onManifestLoaded = function(e, t) {
                                        var n, u, l = [], c = [], d = [], f = {}, g = !1, p = !1, m = !1;
                                        if (t.levels.forEach(function(e) {
                                            var t = e.attrs;
                                            g = g || !(!e.width || !e.height), p = p || !!e.videoCodec, m = m || !!e.audioCodec, h && e.audioCodec && -1 !== e.audioCodec.indexOf("mp4a.40.34") && (e.audioCodec = void 0);
                                            var n = e.bitrate + "-" + e.attrs.RESOLUTION + "-" + e.attrs.CODECS;
                                            (u = f[n]) ? u.url.push(e.url) : (u = new r.Level(e), f[n] = u, l.push(u)), t && (t.AUDIO && (0, s1.addGroupId)(u, "audio", t.AUDIO), t.SUBTITLES && (0, s1.addGroupId)(u, "text", t.SUBTITLES));
                                        }), (g || p) && m && (l = l.filter(function(e) {
                                            var t = e.videoCodec, n = e.width, r = e.height;
                                            return !!t || !(!n || !r);
                                        })), l = l.filter(function(e) {
                                            var t = e.audioCodec, n = e.videoCodec;
                                            return (!t || (0, o.isCodecSupportedInMp4)(t, "audio")) && (!n || (0, o.isCodecSupportedInMp4)(n, "video"));
                                        }), t.audioTracks && (c = t.audioTracks.filter(function(e) {
                                            return !e.audioCodec || (0, o.isCodecSupportedInMp4)(e.audioCodec, "audio");
                                        }), (0, s1.assignTrackIdsByGroup)(c)), t.subtitles && (d = t.subtitles, (0, s1.assignTrackIdsByGroup)(d)), l.length > 0) {
                                            n = l[0].bitrate, l.sort(function(e, t) {
                                                return e.bitrate - t.bitrate;
                                            }), this._levels = l;
                                            for(var v = 0; v < l.length; v++)if (l[v].bitrate === n) {
                                                this._firstLevel = v, this.log("manifest loaded, " + l.length + " level(s) found, first bitrate: " + n);
                                                break;
                                            }
                                            var y = m && !p, E = {
                                                levels: l,
                                                audioTracks: c,
                                                subtitleTracks: d,
                                                firstLevel: this._firstLevel,
                                                stats: t.stats,
                                                audio: m,
                                                video: p,
                                                altAudio: !y && c.some(function(e) {
                                                    return !!e.url;
                                                })
                                            };
                                            this.hls.trigger(i.Events.MANIFEST_PARSED, E), (this.hls.config.autoStartLoad || this.hls.forceStartLoad) && this.hls.startLoad(this.hls.config.startPosition);
                                        } else this.hls.trigger(i.Events.ERROR, {
                                            type: a1.ErrorTypes.MEDIA_ERROR,
                                            details: a1.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
                                            fatal: !0,
                                            url: t.url,
                                            reason: "no level with compatible codecs found in manifest"
                                        });
                                    }, m.onError = function(t, n) {
                                        var r;
                                        if (e.prototype.onError.call(this, t, n), !n.fatal) {
                                            var i = n.context, o = this._levels[this.currentLevelIndex];
                                            if (i && (i.type === l.PlaylistContextType.AUDIO_TRACK && o.audioGroupIds && i.groupId === o.audioGroupIds[o.urlId] || i.type === l.PlaylistContextType.SUBTITLE_TRACK && o.textGroupIds && i.groupId === o.textGroupIds[o.urlId])) this.redundantFailover(this.currentLevelIndex);
                                            else {
                                                var s1, u = !1, c = !0;
                                                switch(n.details){
                                                    case a1.ErrorDetails.FRAG_LOAD_ERROR:
                                                    case a1.ErrorDetails.FRAG_LOAD_TIMEOUT:
                                                    case a1.ErrorDetails.KEY_LOAD_ERROR:
                                                    case a1.ErrorDetails.KEY_LOAD_TIMEOUT:
                                                        if (n.frag) {
                                                            var d = n.frag.type === l.PlaylistLevelType.MAIN ? n.frag.level : this.currentLevelIndex, f = this._levels[d];
                                                            f ? (f.fragmentError++, f.fragmentError > this.hls.config.fragLoadingMaxRetry && (s1 = d)) : s1 = d;
                                                        }
                                                        break;
                                                    case a1.ErrorDetails.LEVEL_LOAD_ERROR:
                                                    case a1.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                                                        i && (i.deliveryDirectives && (c = !1), s1 = i.level), u = !0;
                                                        break;
                                                    case a1.ErrorDetails.REMUX_ALLOC_ERROR:
                                                        s1 = null != (r = n.level) ? r : this.currentLevelIndex, u = !0;
                                                }
                                                void 0 !== s1 && this.recoverLevel(n, s1, u, c);
                                            }
                                        }
                                    }, m.recoverLevel = function(e, t, n, r) {
                                        var i = e.details, a1 = this._levels[t];
                                        if (a1.loadError++, n) {
                                            if (!this.retryLoadingOrFail(e)) return void (this.currentLevelIndex = -1);
                                            e.levelRetry = !0;
                                        }
                                        if (r) {
                                            var o = a1.url.length;
                                            if (o > 1 && a1.loadError < o) e.levelRetry = !0, this.redundantFailover(t);
                                            else if (-1 === this.manualLevelIndex) {
                                                for(var s1 = -1, u = this._levels, l = u.length; l--;){
                                                    var c = (l + this.currentLevelIndex) % u.length;
                                                    if (c !== this.currentLevelIndex && 0 === u[c].loadError) {
                                                        s1 = c;
                                                        break;
                                                    }
                                                }
                                                s1 > -1 && this.currentLevelIndex !== s1 && (this.warn(i + ": switch to " + s1), e.levelRetry = !0, this.hls.nextAutoLevel = s1);
                                            }
                                        }
                                    }, m.redundantFailover = function(e) {
                                        var t = this._levels[e], n = t.url.length;
                                        if (n > 1) {
                                            var r = (t.urlId + 1) % n;
                                            this.warn("Switching to redundant URL-id " + r), this._levels.forEach(function(e) {
                                                e.urlId = r;
                                            }), this.level = e;
                                        }
                                    }, m.onFragLoaded = function(e, t) {
                                        var n = t.frag;
                                        if (void 0 !== n && n.type === l.PlaylistLevelType.MAIN) {
                                            var r = this._levels[n.level];
                                            void 0 !== r && (r.fragmentError = 0, r.loadError = 0);
                                        }
                                    }, m.onLevelLoaded = function(e, t) {
                                        var n, r, i = t.level, a1 = t.details, o = this._levels[i];
                                        if (!o) return this.warn("Invalid level index " + i), void (null !== (r = t.deliveryDirectives) && void 0 !== r && r.skip && (a1.deltaUpdateFailed = !0));
                                        i === this.currentLevelIndex ? (0 === o.fragmentError && (o.loadError = 0, this.retryCount = 0), this.playlistLoaded(i, t, o.details)) : null !== (n = t.deliveryDirectives) && void 0 !== n && n.skip && (a1.deltaUpdateFailed = !0);
                                    }, m.onAudioTrackSwitched = function(e, t) {
                                        var n = this.hls.levels[this.currentLevelIndex];
                                        if (n && n.audioGroupIds) {
                                            for(var r = -1, i = this.hls.audioTracks[t.id].groupId, a1 = 0; a1 < n.audioGroupIds.length; a1++)if (n.audioGroupIds[a1] === i) {
                                                r = a1;
                                                break;
                                            }
                                            r !== n.urlId && (n.urlId = r, this.startLoad());
                                        }
                                    }, m.loadPlaylist = function(e) {
                                        var t = this.currentLevelIndex, n = this._levels[t];
                                        if (this.canLoad && n && n.url.length > 0) {
                                            var r = n.urlId, a1 = n.url[r];
                                            if (e) try {
                                                a1 = e.addDirectives(a1);
                                            } catch (e) {
                                                this.warn("Could not construct new URL with HLS Delivery Directives: " + e);
                                            }
                                            this.log("Attempt loading level index " + t + (e ? " at sn " + e.msn + " part " + e.part : "") + " with URL-id " + r + " " + a1), this.clearTimer(), this.hls.trigger(i.Events.LEVEL_LOADING, {
                                                url: a1,
                                                level: t,
                                                id: r,
                                                deliveryDirectives: e || null
                                            });
                                        }
                                    }, m.removeLevel = function(e, t) {
                                        var n = function(e, n) {
                                            return n !== t;
                                        }, r = this._levels.filter(function(r, i) {
                                            return i !== e || r.url.length > 1 && void 0 !== t && (r.url = r.url.filter(n), r.audioGroupIds && (r.audioGroupIds = r.audioGroupIds.filter(n)), r.textGroupIds && (r.textGroupIds = r.textGroupIds.filter(n)), r.urlId = 0, !0);
                                        }).map(function(e, t) {
                                            var n = e.details;
                                            return null != n && n.fragments && n.fragments.forEach(function(e) {
                                                e.level = t;
                                            }), e;
                                        });
                                        this._levels = r, this.hls.trigger(i.Events.LEVELS_UPDATED, {
                                            levels: r
                                        });
                                    }, g = u, p = [
                                        {
                                            key: "levels",
                                            get: function() {
                                                return 0 === this._levels.length ? null : this._levels;
                                            }
                                        },
                                        {
                                            key: "level",
                                            get: function() {
                                                return this.currentLevelIndex;
                                            },
                                            set: function(e) {
                                                var t, n = this._levels;
                                                if (0 !== n.length && (this.currentLevelIndex !== e || null === (t = n[e]) || void 0 === t || !t.details)) {
                                                    if (e < 0 || e >= n.length) {
                                                        var r = e < 0;
                                                        if (this.hls.trigger(i.Events.ERROR, {
                                                            type: a1.ErrorTypes.OTHER_ERROR,
                                                            details: a1.ErrorDetails.LEVEL_SWITCH_ERROR,
                                                            level: e,
                                                            fatal: r,
                                                            reason: "invalid level idx"
                                                        }), r) return;
                                                        e = Math.min(e, n.length - 1);
                                                    }
                                                    this.clearTimer();
                                                    var o = this.currentLevelIndex, s1 = n[o], u = n[e];
                                                    this.log("switching to level " + e + " from " + o), this.currentLevelIndex = e;
                                                    var l = c({}, u, {
                                                        level: e,
                                                        maxBitrate: u.maxBitrate,
                                                        uri: u.uri,
                                                        urlId: u.urlId
                                                    });
                                                    delete l._urlId, this.hls.trigger(i.Events.LEVEL_SWITCHING, l);
                                                    var d = u.details;
                                                    if (!d || d.live) {
                                                        var f = this.switchParams(u.uri, null == s1 ? void 0 : s1.details);
                                                        this.loadPlaylist(f);
                                                    }
                                                }
                                            }
                                        },
                                        {
                                            key: "manualLevel",
                                            get: function() {
                                                return this.manualLevelIndex;
                                            },
                                            set: function(e) {
                                                this.manualLevelIndex = e, void 0 === this._startLevel && (this._startLevel = e), -1 !== e && (this.level = e);
                                            }
                                        },
                                        {
                                            key: "firstLevel",
                                            get: function() {
                                                return this._firstLevel;
                                            },
                                            set: function(e) {
                                                this._firstLevel = e;
                                            }
                                        },
                                        {
                                            key: "startLevel",
                                            get: function() {
                                                if (void 0 === this._startLevel) {
                                                    var e = this.hls.config.startLevel;
                                                    return void 0 !== e ? e : this._firstLevel;
                                                }
                                                return this._startLevel;
                                            },
                                            set: function(e) {
                                                this._startLevel = e;
                                            }
                                        },
                                        {
                                            key: "nextLoadLevel",
                                            get: function() {
                                                return -1 !== this.manualLevelIndex ? this.manualLevelIndex : this.hls.nextAutoLevel;
                                            },
                                            set: function(e) {
                                                this.level = e, -1 === this.manualLevelIndex && (this.hls.nextAutoLevel = e);
                                            }
                                        }
                                    ], d(g.prototype, p), Object.defineProperty(g, "prototype", {
                                        writable: !1
                                    }), u;
                                }(u.default);
                            },
                            "./src/controller/level-helper.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    addGroupId: ()=>s1,
                                    addSliding: ()=>m,
                                    adjustSliding: ()=>p,
                                    assignTrackIdsByGroup: ()=>u,
                                    computeReloadInterval: ()=>v,
                                    getFragmentWithSN: ()=>y,
                                    getPartWith: ()=>E,
                                    mapFragmentIntersection: ()=>g,
                                    mapPartIntersection: ()=>h,
                                    mergeDetails: ()=>f,
                                    updateFragPTSDTS: ()=>d,
                                    updatePTS: ()=>l
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./src/utils/logger.ts"), a1 = n("./src/loader/date-range.ts");
                                function o() {
                                    return o = Object.assign ? Object.assign.bind() : function(e) {
                                        for(var t = 1; t < arguments.length; t++){
                                            var n = arguments[t];
                                            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                                        }
                                        return e;
                                    }, o.apply(this, arguments);
                                }
                                function s1(e, t, n) {
                                    switch(t){
                                        case "audio":
                                            e.audioGroupIds || (e.audioGroupIds = []), e.audioGroupIds.push(n);
                                            break;
                                        case "text":
                                            e.textGroupIds || (e.textGroupIds = []), e.textGroupIds.push(n);
                                    }
                                }
                                function u(e) {
                                    var t = {};
                                    e.forEach(function(e) {
                                        var n = e.groupId || "";
                                        e.id = t[n] = t[n] || 0, t[n]++;
                                    });
                                }
                                function l(e, t, n) {
                                    c(e[t], e[n]);
                                }
                                function c(e, t) {
                                    var n = t.startPTS;
                                    if ((0, r.isFiniteNumber)(n)) {
                                        var i, a1 = 0;
                                        t.sn > e.sn ? (a1 = n - e.start, i = e) : (a1 = e.start - n, i = t), i.duration !== a1 && (i.duration = a1);
                                    } else t.sn > e.sn ? e.cc === t.cc && e.minEndPTS ? t.start = e.start + (e.minEndPTS - e.start) : t.start = e.start + e.duration : t.start = Math.max(e.start - t.duration, 0);
                                }
                                function d(e, t, n, a1, o, s1) {
                                    a1 - n <= 0 && (i.logger.warn("Fragment should have a positive duration", t), a1 = n + t.duration, s1 = o + t.duration);
                                    var u = n, l = a1, d = t.startPTS, f = t.endPTS;
                                    if ((0, r.isFiniteNumber)(d)) {
                                        var h = Math.abs(d - n);
                                        (0, r.isFiniteNumber)(t.deltaPTS) ? t.deltaPTS = Math.max(h, t.deltaPTS) : t.deltaPTS = h, u = Math.max(n, d), n = Math.min(n, d), o = Math.min(o, t.startDTS), l = Math.min(a1, f), a1 = Math.max(a1, f), s1 = Math.max(s1, t.endDTS);
                                    }
                                    t.duration = a1 - n;
                                    var g = n - t.start;
                                    t.appendedPTS = a1, t.start = t.startPTS = n, t.maxStartPTS = u, t.startDTS = o, t.endPTS = a1, t.minEndPTS = l, t.endDTS = s1;
                                    var p, m = t.sn;
                                    if (!e || m < e.startSN || m > e.endSN) return 0;
                                    var v = m - e.startSN, y = e.fragments;
                                    for(y[v] = t, p = v; p > 0; p--)c(y[p], y[p - 1]);
                                    for(p = v; p < y.length - 1; p++)c(y[p], y[p + 1]);
                                    return e.fragmentHint && c(y[y.length - 1], e.fragmentHint), e.PTSKnown = e.alignedSliding = !0, g;
                                }
                                function f(e, t) {
                                    for(var n = null, s1 = e.fragments, u = s1.length - 1; u >= 0; u--){
                                        var l = s1[u].initSegment;
                                        if (l) {
                                            n = l;
                                            break;
                                        }
                                    }
                                    e.fragmentHint && delete e.fragmentHint.endPTS;
                                    var c, f, m, v, y, E = 0;
                                    if (g(e, t, function(e, i) {
                                        e.relurl && (E = e.cc - i.cc), (0, r.isFiniteNumber)(e.startPTS) && (0, r.isFiniteNumber)(e.endPTS) && (i.start = i.startPTS = e.startPTS, i.startDTS = e.startDTS, i.appendedPTS = e.appendedPTS, i.maxStartPTS = e.maxStartPTS, i.endPTS = e.endPTS, i.endDTS = e.endDTS, i.minEndPTS = e.minEndPTS, i.duration = e.endPTS - e.startPTS, i.duration && (c = i), t.PTSKnown = t.alignedSliding = !0), i.elementaryStreams = e.elementaryStreams, i.loader = e.loader, i.stats = e.stats, i.urlId = e.urlId, e.initSegment && (i.initSegment = e.initSegment, n = e.initSegment);
                                    }), n && (t.fragmentHint ? t.fragments.concat(t.fragmentHint) : t.fragments).forEach(function(e) {
                                        var t;
                                        e.initSegment && e.initSegment.relurl !== (null === (t = n) || void 0 === t ? void 0 : t.relurl) || (e.initSegment = n);
                                    }), t.skippedSegments) {
                                        if (t.deltaUpdateFailed = t.fragments.some(function(e) {
                                            return !e;
                                        }), t.deltaUpdateFailed) {
                                            i.logger.warn("[level-helper] Previous playlist missing segments skipped in delta playlist");
                                            for(var T = t.skippedSegments; T--;)t.fragments.shift();
                                            t.startSN = t.fragments[0].sn, t.startCC = t.fragments[0].cc;
                                        } else t.canSkipDateRanges && (t.dateRanges = (f = e.dateRanges, m = t.dateRanges, v = t.recentlyRemovedDateranges, y = o({}, f), v && v.forEach(function(e) {
                                            delete y[e];
                                        }), Object.keys(m).forEach(function(e) {
                                            var t = new a1.DateRange(m[e].attr, y[e]);
                                            t.isValid ? y[e] = t : i.logger.warn('Ignoring invalid Playlist Delta Update DATERANGE tag: "' + JSON.stringify(m[e].attr) + '"');
                                        }), y));
                                    }
                                    var b = t.fragments;
                                    if (E) {
                                        i.logger.warn("discontinuity sliding from playlist, take drift into account");
                                        for(var A = 0; A < b.length; A++)b[A].cc += E;
                                    }
                                    t.skippedSegments && (t.startCC = t.fragments[0].cc), h(e.partList, t.partList, function(e, t) {
                                        t.elementaryStreams = e.elementaryStreams, t.stats = e.stats;
                                    }), c ? d(t, c, c.startPTS, c.endPTS, c.startDTS, c.endDTS) : p(e, t), b.length && (t.totalduration = t.edge - b[0].start), t.driftStartTime = e.driftStartTime, t.driftStart = e.driftStart;
                                    var _ = t.advancedDateTime;
                                    if (t.advanced && _) {
                                        var S = t.edge;
                                        t.driftStart || (t.driftStartTime = _, t.driftStart = S), t.driftEndTime = _, t.driftEnd = S;
                                    } else t.driftEndTime = e.driftEndTime, t.driftEnd = e.driftEnd, t.advancedDateTime = e.advancedDateTime;
                                }
                                function h(e, t, n) {
                                    if (e && t) for(var r = 0, i = 0, a1 = e.length; i <= a1; i++){
                                        var o = e[i], s1 = t[i + r];
                                        o && s1 && o.index === s1.index && o.fragment.sn === s1.fragment.sn ? n(o, s1) : r--;
                                    }
                                }
                                function g(e, t, n) {
                                    for(var r = t.skippedSegments, i = Math.max(e.startSN, t.startSN) - t.startSN, a1 = (e.fragmentHint ? 1 : 0) + (r ? t.endSN : Math.min(e.endSN, t.endSN)) - t.startSN, o = t.startSN - e.startSN, s1 = t.fragmentHint ? t.fragments.concat(t.fragmentHint) : t.fragments, u = e.fragmentHint ? e.fragments.concat(e.fragmentHint) : e.fragments, l = i; l <= a1; l++){
                                        var c = u[o + l], d = s1[l];
                                        r && !d && l < r && (d = t.fragments[l] = c), c && d && n(c, d);
                                    }
                                }
                                function p(e, t) {
                                    var n = t.startSN + t.skippedSegments - e.startSN, r = e.fragments;
                                    n < 0 || n >= r.length || m(t, r[n].start);
                                }
                                function m(e, t) {
                                    if (t) {
                                        for(var n = e.fragments, r = e.skippedSegments; r < n.length; r++)n[r].start += t;
                                        e.fragmentHint && (e.fragmentHint.start += t);
                                    }
                                }
                                function v(e, t) {
                                    var n, r = 1e3 * e.levelTargetDuration, i = r / 2, a1 = e.age, o = a1 > 0 && a1 < 3 * r, s1 = t.loading.end - t.loading.start, u = e.availabilityDelay;
                                    if (!1 === e.updated) {
                                        if (o) {
                                            var l = 333 * e.misses;
                                            n = Math.max(Math.min(i, 2 * s1), l), e.availabilityDelay = (e.availabilityDelay || 0) + n;
                                        } else n = i;
                                    } else o ? (u = Math.min(u || r / 2, a1), e.availabilityDelay = u, n = u + r - a1) : n = r - s1;
                                    return Math.round(n);
                                }
                                function y(e, t, n) {
                                    if (!e || !e.details) return null;
                                    var r = e.details, i = r.fragments[t - r.startSN];
                                    return i || ((i = r.fragmentHint) && i.sn === t ? i : t < r.startSN && n && n.sn === t ? n : null);
                                }
                                function E(e, t, n) {
                                    if (!e || !e.details) return null;
                                    var r = e.details.partList;
                                    if (r) for(var i = r.length; i--;){
                                        var a1 = r[i];
                                        if (a1.index === n && a1.fragment.sn === t) return a1;
                                    }
                                    return null;
                                }
                            },
                            "./src/controller/stream-controller.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>v
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./src/controller/base-stream-controller.ts"), a1 = n("./src/is-supported.ts"), o = n("./src/events.ts"), s1 = n("./src/utils/buffer-helper.ts"), u = n("./src/controller/fragment-tracker.ts"), l = n("./src/types/loader.ts"), c = n("./src/loader/fragment.ts"), d = n("./src/demux/transmuxer-interface.ts"), f = n("./src/types/transmuxer.ts"), h = n("./src/controller/gap-controller.ts"), g = n("./src/errors.ts");
                                function p(e, t) {
                                    for(var n = 0; n < t.length; n++){
                                        var r = t[n];
                                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                    }
                                }
                                function m(e, t) {
                                    return m = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, m(e, t);
                                }
                                var v = function(e) {
                                    var t, n;
                                    function v(t, n) {
                                        var r;
                                        return (r = e.call(this, t, n, "[stream-controller]") || this).audioCodecSwap = !1, r.gapController = null, r.level = -1, r._forceStartLoad = !1, r.altAudio = !1, r.audioOnly = !1, r.fragPlaying = null, r.onvplaying = null, r.onvseeked = null, r.fragLastKbps = 0, r.couldBacktrack = !1, r.backtrackFragment = null, r.audioCodecSwitch = !1, r.videoBuffer = null, r._registerListeners(), r;
                                    }
                                    n = e, (t = v).prototype = Object.create(n.prototype), t.prototype.constructor = t, m(t, n);
                                    var y, E, T = v.prototype;
                                    return T._registerListeners = function() {
                                        var e = this.hls;
                                        e.on(o.Events.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(o.Events.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(o.Events.MANIFEST_LOADING, this.onManifestLoading, this), e.on(o.Events.MANIFEST_PARSED, this.onManifestParsed, this), e.on(o.Events.LEVEL_LOADING, this.onLevelLoading, this), e.on(o.Events.LEVEL_LOADED, this.onLevelLoaded, this), e.on(o.Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.on(o.Events.ERROR, this.onError, this), e.on(o.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(o.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.on(o.Events.BUFFER_CREATED, this.onBufferCreated, this), e.on(o.Events.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(o.Events.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(o.Events.FRAG_BUFFERED, this.onFragBuffered, this);
                                    }, T._unregisterListeners = function() {
                                        var e = this.hls;
                                        e.off(o.Events.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(o.Events.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(o.Events.MANIFEST_LOADING, this.onManifestLoading, this), e.off(o.Events.MANIFEST_PARSED, this.onManifestParsed, this), e.off(o.Events.LEVEL_LOADED, this.onLevelLoaded, this), e.off(o.Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.off(o.Events.ERROR, this.onError, this), e.off(o.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(o.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.off(o.Events.BUFFER_CREATED, this.onBufferCreated, this), e.off(o.Events.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(o.Events.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(o.Events.FRAG_BUFFERED, this.onFragBuffered, this);
                                    }, T.onHandlerDestroying = function() {
                                        this._unregisterListeners(), this.onMediaDetaching();
                                    }, T.startLoad = function(e) {
                                        if (this.levels) {
                                            var t = this.lastCurrentTime, n = this.hls;
                                            if (this.stopLoad(), this.setInterval(100), this.level = -1, this.fragLoadError = 0, !this.startFragRequested) {
                                                var r = n.startLevel;
                                                -1 === r && (n.config.testBandwidth && this.levels.length > 1 ? (r = 0, this.bitrateTest = !0) : r = n.nextAutoLevel), this.level = n.nextLoadLevel = r, this.loadedmetadata = !1;
                                            }
                                            t > 0 && -1 === e && (this.log("Override startPosition with lastCurrentTime @" + t.toFixed(3)), e = t), this.state = i.State.IDLE, this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
                                        } else this._forceStartLoad = !0, this.state = i.State.STOPPED;
                                    }, T.stopLoad = function() {
                                        this._forceStartLoad = !1, e.prototype.stopLoad.call(this);
                                    }, T.doTick = function() {
                                        switch(this.state){
                                            case i.State.IDLE:
                                                this.doTickIdle();
                                                break;
                                            case i.State.WAITING_LEVEL:
                                                var e, t = this.levels, n = this.level, r = null == t || null === (e = t[n]) || void 0 === e ? void 0 : e.details;
                                                if (r && (!r.live || this.levelLastLoaded === this.level)) {
                                                    if (this.waitForCdnTuneIn(r)) break;
                                                    this.state = i.State.IDLE;
                                                    break;
                                                }
                                                break;
                                            case i.State.FRAG_LOADING_WAITING_RETRY:
                                                var a1, o = self.performance.now(), s1 = this.retryDate;
                                                (!s1 || o >= s1 || null !== (a1 = this.media) && void 0 !== a1 && a1.seeking) && (this.log("retryDate reached, switch back to IDLE state"), this.resetStartWhenNotLoaded(this.level), this.state = i.State.IDLE);
                                        }
                                        this.onTickEnd();
                                    }, T.onTickEnd = function() {
                                        e.prototype.onTickEnd.call(this), this.checkBuffer(), this.checkFragmentChanged();
                                    }, T.doTickIdle = function() {
                                        var e, t, n = this.hls, r = this.levelLastLoaded, a1 = this.levels, s1 = this.media, d = n.config, f = n.nextLoadLevel;
                                        if (null !== r && (s1 || !this.startFragRequested && d.startFragPrefetch) && (!this.altAudio || !this.audioOnly) && a1 && a1[f]) {
                                            var h = a1[f];
                                            this.level = n.nextLoadLevel = f;
                                            var g = h.details;
                                            if (!g || this.state === i.State.WAITING_LEVEL || g.live && this.levelLastLoaded !== f) this.state = i.State.WAITING_LEVEL;
                                            else {
                                                var p = this.getMainFwdBufferInfo();
                                                if (null !== p && !(p.len >= this.getMaxBufferLength(h.maxBitrate))) {
                                                    if (this._streamEnded(p, g)) {
                                                        var m = {};
                                                        return this.altAudio && (m.type = "video"), this.hls.trigger(o.Events.BUFFER_EOS, m), void (this.state = i.State.ENDED);
                                                    }
                                                    this.backtrackFragment && this.backtrackFragment.start > p.end && (this.backtrackFragment = null);
                                                    var v = this.backtrackFragment ? this.backtrackFragment.start : p.end, y = this.getNextFragment(v, g);
                                                    if (this.couldBacktrack && !this.fragPrevious && y && "initSegment" !== y.sn && this.fragmentTracker.getState(y) !== u.FragmentState.OK) {
                                                        var E, T = (null != (E = this.backtrackFragment) ? E : y).sn - g.startSN, b = g.fragments[T - 1];
                                                        b && y.cc === b.cc && (y = b, this.fragmentTracker.removeFragment(b));
                                                    } else this.backtrackFragment && p.len && (this.backtrackFragment = null);
                                                    if (y && this.fragmentTracker.getState(y) === u.FragmentState.OK && this.nextLoadPosition > v) {
                                                        var A = this.audioOnly && !this.altAudio ? c.ElementaryStreamTypes.AUDIO : c.ElementaryStreamTypes.VIDEO;
                                                        s1 && this.afterBufferFlushed(s1, A, l.PlaylistLevelType.MAIN), y = this.getNextFragment(this.nextLoadPosition, g);
                                                    }
                                                    y && (!y.initSegment || y.initSegment.data || this.bitrateTest || (y = y.initSegment), "identity" !== (null === (e = y.decryptdata) || void 0 === e ? void 0 : e.keyFormat) || null !== (t = y.decryptdata) && void 0 !== t && t.key ? this.loadFragment(y, g, v) : this.loadKey(y, g));
                                                }
                                            }
                                        }
                                    }, T.loadFragment = function(t, n, r) {
                                        var i, a1 = this.fragmentTracker.getState(t);
                                        this.fragCurrent = t, a1 === u.FragmentState.NOT_LOADED ? "initSegment" === t.sn ? this._loadInitSegment(t) : this.bitrateTest ? (this.log("Fragment " + t.sn + " of level " + t.level + " is being downloaded to test bitrate and will not be buffered"), this._loadBitrateTestFrag(t)) : (this.startFragRequested = !0, e.prototype.loadFragment.call(this, t, n, r)) : a1 === u.FragmentState.APPENDING ? this.reduceMaxBufferLength(t.duration) && this.fragmentTracker.removeFragment(t) : 0 === (null === (i = this.media) || void 0 === i ? void 0 : i.buffered.length) && this.fragmentTracker.removeAllFragments();
                                    }, T.getAppendedFrag = function(e) {
                                        var t = this.fragmentTracker.getAppendedFrag(e, l.PlaylistLevelType.MAIN);
                                        return t && "fragment" in t ? t.fragment : t;
                                    }, T.getBufferedFrag = function(e) {
                                        return this.fragmentTracker.getBufferedFrag(e, l.PlaylistLevelType.MAIN);
                                    }, T.followingBufferedFrag = function(e) {
                                        return e ? this.getBufferedFrag(e.end + .5) : null;
                                    }, T.immediateLevelSwitch = function() {
                                        this.abortCurrentFrag(), this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
                                    }, T.nextLevelSwitch = function() {
                                        var e = this.levels, t = this.media;
                                        if (null != t && t.readyState) {
                                            var n, r = this.getAppendedFrag(t.currentTime);
                                            if (r && r.start > 1 && this.flushMainBuffer(0, r.start - 1), !t.paused && e) {
                                                var i = e[this.hls.nextLoadLevel], a1 = this.fragLastKbps;
                                                n = a1 && this.fragCurrent ? this.fragCurrent.duration * i.maxBitrate / (1e3 * a1) + 1 : 0;
                                            } else n = 0;
                                            var o = this.getBufferedFrag(t.currentTime + n);
                                            if (o) {
                                                var s1 = this.followingBufferedFrag(o);
                                                if (s1) {
                                                    this.abortCurrentFrag();
                                                    var u = s1.maxStartPTS ? s1.maxStartPTS : s1.start, l = s1.duration, c = Math.max(o.end, u + Math.min(Math.max(l - this.config.maxFragLookUpTolerance, .5 * l), .75 * l));
                                                    this.flushMainBuffer(c, Number.POSITIVE_INFINITY);
                                                }
                                            }
                                        }
                                    }, T.abortCurrentFrag = function() {
                                        var e = this.fragCurrent;
                                        switch(this.fragCurrent = null, this.backtrackFragment = null, null != e && e.loader && e.loader.abort(), this.state){
                                            case i.State.KEY_LOADING:
                                            case i.State.FRAG_LOADING:
                                            case i.State.FRAG_LOADING_WAITING_RETRY:
                                            case i.State.PARSING:
                                            case i.State.PARSED:
                                                this.state = i.State.IDLE;
                                        }
                                        this.nextLoadPosition = this.getLoadPosition();
                                    }, T.flushMainBuffer = function(t, n) {
                                        e.prototype.flushMainBuffer.call(this, t, n, this.altAudio ? "video" : null);
                                    }, T.onMediaAttached = function(t, n) {
                                        e.prototype.onMediaAttached.call(this, t, n);
                                        var r = n.media;
                                        this.onvplaying = this.onMediaPlaying.bind(this), this.onvseeked = this.onMediaSeeked.bind(this), r.addEventListener("playing", this.onvplaying), r.addEventListener("seeked", this.onvseeked), this.gapController = new h.default(this.config, r, this.fragmentTracker, this.hls);
                                    }, T.onMediaDetaching = function() {
                                        var t = this.media;
                                        t && this.onvplaying && this.onvseeked && (t.removeEventListener("playing", this.onvplaying), t.removeEventListener("seeked", this.onvseeked), this.onvplaying = this.onvseeked = null, this.videoBuffer = null), this.fragPlaying = null, this.gapController && (this.gapController.destroy(), this.gapController = null), e.prototype.onMediaDetaching.call(this);
                                    }, T.onMediaPlaying = function() {
                                        this.tick();
                                    }, T.onMediaSeeked = function() {
                                        var e = this.media, t = e ? e.currentTime : null;
                                        (0, r.isFiniteNumber)(t) && this.log("Media seeked to " + t.toFixed(3)), this.tick();
                                    }, T.onManifestLoading = function() {
                                        this.log("Trigger BUFFER_RESET"), this.hls.trigger(o.Events.BUFFER_RESET, void 0), this.fragmentTracker.removeAllFragments(), this.couldBacktrack = !1, this.startPosition = this.lastCurrentTime = 0, this.fragPlaying = null, this.backtrackFragment = null;
                                    }, T.onManifestParsed = function(e, t) {
                                        var n, r = !1, i = !1;
                                        t.levels.forEach(function(e) {
                                            (n = e.audioCodec) && (-1 !== n.indexOf("mp4a.40.2") && (r = !0), -1 !== n.indexOf("mp4a.40.5") && (i = !0));
                                        }), this.audioCodecSwitch = r && i && !(0, a1.changeTypeSupported)(), this.audioCodecSwitch && this.log("Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"), this.levels = t.levels, this.startFragRequested = !1;
                                    }, T.onLevelLoading = function(e, t) {
                                        var n = this.levels;
                                        if (n && this.state === i.State.IDLE) {
                                            var r = n[t.level];
                                            (!r.details || r.details.live && this.levelLastLoaded !== t.level || this.waitForCdnTuneIn(r.details)) && (this.state = i.State.WAITING_LEVEL);
                                        }
                                    }, T.onLevelLoaded = function(e, t) {
                                        var n, r = this.levels, a1 = t.level, s1 = t.details, u = s1.totalduration;
                                        if (r) {
                                            this.log("Level " + a1 + " loaded [" + s1.startSN + "," + s1.endSN + "], cc [" + s1.startCC + ", " + s1.endCC + "] duration:" + u);
                                            var l = this.fragCurrent;
                                            !l || this.state !== i.State.FRAG_LOADING && this.state !== i.State.FRAG_LOADING_WAITING_RETRY || l.level !== t.level && l.loader && (this.state = i.State.IDLE, this.backtrackFragment = null, l.loader.abort());
                                            var c = r[a1], d = 0;
                                            if (s1.live || null !== (n = c.details) && void 0 !== n && n.live) {
                                                if (s1.fragments[0] || (s1.deltaUpdateFailed = !0), s1.deltaUpdateFailed) return;
                                                d = this.alignPlaylists(s1, c.details);
                                            }
                                            if (c.details = s1, this.levelLastLoaded = a1, this.hls.trigger(o.Events.LEVEL_UPDATED, {
                                                details: s1,
                                                level: a1
                                            }), this.state === i.State.WAITING_LEVEL) {
                                                if (this.waitForCdnTuneIn(s1)) return;
                                                this.state = i.State.IDLE;
                                            }
                                            this.startFragRequested ? s1.live && this.synchronizeToLiveEdge(s1) : this.setStartPosition(s1, d), this.tick();
                                        } else this.warn("Levels were reset while loading level " + a1);
                                    }, T._handleFragmentLoadProgress = function(e) {
                                        var t, n = e.frag, r = e.part, i = e.payload, a1 = this.levels;
                                        if (a1) {
                                            var o = a1[n.level], s1 = o.details;
                                            if (s1) {
                                                var u = o.videoCodec, c = s1.PTSKnown || !s1.live, h = null === (t = n.initSegment) || void 0 === t ? void 0 : t.data, g = this._getAudioCodec(o), p = this.transmuxer = this.transmuxer || new d.default(this.hls, l.PlaylistLevelType.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)), m = r ? r.index : -1, v = -1 !== m, y = new f.ChunkMetadata(n.level, n.sn, n.stats.chunkCount, i.byteLength, m, v), E = this.initPTS[n.cc];
                                                p.push(i, h, g, u, n, r, s1.totalduration, c, y, E);
                                            } else this.warn("Dropping fragment " + n.sn + " of level " + n.level + " after level details were reset");
                                        } else this.warn("Levels were reset while fragment load was in progress. Fragment " + n.sn + " of level " + n.level + " will not be buffered");
                                    }, T.onAudioTrackSwitching = function(e, t) {
                                        var n = this.altAudio, r = !!t.url, i = t.id;
                                        if (!r) {
                                            if (this.mediaBuffer !== this.media) {
                                                this.log("Switching on main audio, use media.buffered to schedule main fragment loading"), this.mediaBuffer = this.media;
                                                var a1 = this.fragCurrent;
                                                null != a1 && a1.loader && (this.log("Switching to main audio track, cancel main fragment load"), a1.loader.abort()), this.resetTransmuxer(), this.resetLoadingState();
                                            } else this.audioOnly && this.resetTransmuxer();
                                            var s1 = this.hls;
                                            n && s1.trigger(o.Events.BUFFER_FLUSHING, {
                                                startOffset: 0,
                                                endOffset: Number.POSITIVE_INFINITY,
                                                type: "audio"
                                            }), s1.trigger(o.Events.AUDIO_TRACK_SWITCHED, {
                                                id: i
                                            });
                                        }
                                    }, T.onAudioTrackSwitched = function(e, t) {
                                        var n = t.id, r = !!this.hls.audioTracks[n].url;
                                        if (r) {
                                            var i = this.videoBuffer;
                                            i && this.mediaBuffer !== i && (this.log("Switching on alternate audio, use video.buffered to schedule main fragment loading"), this.mediaBuffer = i);
                                        }
                                        this.altAudio = r, this.tick();
                                    }, T.onBufferCreated = function(e, t) {
                                        var n, r, i = t.tracks, a1 = !1;
                                        for(var o in i){
                                            var s1 = i[o];
                                            if ("main" === s1.id) {
                                                if (r = o, n = s1, "video" === o) {
                                                    var u = i[o];
                                                    u && (this.videoBuffer = u.buffer);
                                                }
                                            } else a1 = !0;
                                        }
                                        a1 && n ? (this.log("Alternate track found, use " + r + ".buffered to schedule main fragment loading"), this.mediaBuffer = n.buffer) : this.mediaBuffer = this.media;
                                    }, T.onFragBuffered = function(e, t) {
                                        var n = t.frag, r = t.part;
                                        if (!n || n.type === l.PlaylistLevelType.MAIN) {
                                            if (this.fragContextChanged(n)) return this.warn("Fragment " + n.sn + (r ? " p: " + r.index : "") + " of level " + n.level + " finished buffering, but was aborted. state: " + this.state), void (this.state === i.State.PARSED && (this.state = i.State.IDLE));
                                            var a1 = r ? r.stats : n.stats;
                                            this.fragLastKbps = Math.round(8 * a1.total / (a1.buffering.end - a1.loading.first)), "initSegment" !== n.sn && (this.fragPrevious = n), this.fragBufferedComplete(n, r);
                                        }
                                    }, T.onError = function(e, t) {
                                        switch(t.details){
                                            case g.ErrorDetails.FRAG_LOAD_ERROR:
                                            case g.ErrorDetails.FRAG_LOAD_TIMEOUT:
                                            case g.ErrorDetails.KEY_LOAD_ERROR:
                                            case g.ErrorDetails.KEY_LOAD_TIMEOUT:
                                                this.onFragmentOrKeyLoadError(l.PlaylistLevelType.MAIN, t);
                                                break;
                                            case g.ErrorDetails.LEVEL_LOAD_ERROR:
                                            case g.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                                                this.state !== i.State.ERROR && (t.fatal ? (this.warn("" + t.details), this.state = i.State.ERROR) : t.levelRetry || this.state !== i.State.WAITING_LEVEL || (this.state = i.State.IDLE));
                                                break;
                                            case g.ErrorDetails.BUFFER_FULL_ERROR:
                                                if ("main" === t.parent && (this.state === i.State.PARSING || this.state === i.State.PARSED)) {
                                                    var n = !0, r = this.getFwdBufferInfo(this.media, l.PlaylistLevelType.MAIN);
                                                    r && r.len > .5 && (n = !this.reduceMaxBufferLength(r.len)), n && (this.warn("buffer full error also media.currentTime is not buffered, flush main"), this.immediateLevelSwitch()), this.resetLoadingState();
                                                }
                                        }
                                    }, T.checkBuffer = function() {
                                        var e = this.media, t = this.gapController;
                                        if (e && t && e.readyState) {
                                            if (this.loadedmetadata || !s1.BufferHelper.getBuffered(e).length) {
                                                var n = this.state !== i.State.IDLE ? this.fragCurrent : null;
                                                t.poll(this.lastCurrentTime, n);
                                            }
                                            this.lastCurrentTime = e.currentTime;
                                        }
                                    }, T.onFragLoadEmergencyAborted = function() {
                                        this.state = i.State.IDLE, this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition), this.tickImmediate();
                                    }, T.onBufferFlushed = function(e, t) {
                                        var n = t.type;
                                        if (n !== c.ElementaryStreamTypes.AUDIO || this.audioOnly && !this.altAudio) {
                                            var r = (n === c.ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
                                            this.afterBufferFlushed(r, n, l.PlaylistLevelType.MAIN);
                                        }
                                    }, T.onLevelsUpdated = function(e, t) {
                                        this.levels = t.levels;
                                    }, T.swapAudioCodec = function() {
                                        this.audioCodecSwap = !this.audioCodecSwap;
                                    }, T.seekToStartPos = function() {
                                        var e = this.media;
                                        if (e) {
                                            var t = e.currentTime, n = this.startPosition;
                                            if (n >= 0 && t < n) {
                                                if (e.seeking) return void this.log("could not seek to " + n + ", already seeking at " + t);
                                                var r = s1.BufferHelper.getBuffered(e), i = (r.length ? r.start(0) : 0) - n;
                                                i > 0 && (i < this.config.maxBufferHole || i < this.config.maxFragLookUpTolerance) && (this.log("adjusting start position by " + i + " to match buffer start"), n += i, this.startPosition = n), this.log("seek to target start position " + n + " from current time " + t), e.currentTime = n;
                                            }
                                        }
                                    }, T._getAudioCodec = function(e) {
                                        var t = this.config.defaultAudioCodec || e.audioCodec;
                                        return this.audioCodecSwap && t && (this.log("Swapping audio codec"), t = -1 !== t.indexOf("mp4a.40.5") ? "mp4a.40.2" : "mp4a.40.5"), t;
                                    }, T._loadBitrateTestFrag = function(e) {
                                        var t = this;
                                        e.bitrateTest = !0, this._doFragLoad(e).then(function(n) {
                                            var r = t.hls;
                                            if (n && !r.nextLoadLevel && !t.fragContextChanged(e)) {
                                                t.fragLoadError = 0, t.state = i.State.IDLE, t.startFragRequested = !1, t.bitrateTest = !1;
                                                var a1 = e.stats;
                                                a1.parsing.start = a1.parsing.end = a1.buffering.start = a1.buffering.end = self.performance.now(), r.trigger(o.Events.FRAG_LOADED, n), e.bitrateTest = !1;
                                            }
                                        });
                                    }, T._handleTransmuxComplete = function(e) {
                                        var t, n = "main", a1 = this.hls, s1 = e.remuxResult, u = e.chunkMeta, l = this.getCurrentContext(u);
                                        if (!l) return this.warn("The loading context changed while buffering fragment " + u.sn + " of level " + u.level + ". This chunk will not be buffered."), void this.resetStartWhenNotLoaded(u.level);
                                        var d = l.frag, f = l.part, h = l.level, g = s1.video, p = s1.text, m = s1.id3, v = s1.initSegment, y = h.details, E = this.altAudio ? void 0 : s1.audio;
                                        if (!this.fragContextChanged(d)) {
                                            if (this.state = i.State.PARSING, v) {
                                                v.tracks && (this._bufferInitSegment(h, v.tracks, d, u), a1.trigger(o.Events.FRAG_PARSING_INIT_SEGMENT, {
                                                    frag: d,
                                                    id: n,
                                                    tracks: v.tracks
                                                }));
                                                var T = v.initPTS, b = v.timescale;
                                                (0, r.isFiniteNumber)(T) && (this.initPTS[d.cc] = T, a1.trigger(o.Events.INIT_PTS_FOUND, {
                                                    frag: d,
                                                    id: n,
                                                    initPTS: T,
                                                    timescale: b
                                                }));
                                            }
                                            if (g && !1 !== s1.independent) {
                                                if (y) {
                                                    var A = g.startPTS, _ = g.endPTS, S = g.startDTS, w = g.endDTS;
                                                    if (f) f.elementaryStreams[g.type] = {
                                                        startPTS: A,
                                                        endPTS: _,
                                                        startDTS: S,
                                                        endDTS: w
                                                    };
                                                    else if (g.firstKeyFrame && g.independent && (this.couldBacktrack = !0), g.dropped && g.independent) {
                                                        var I = this.getMainFwdBufferInfo();
                                                        if ((I ? I.end : this.getLoadPosition()) + this.config.maxBufferHole < (g.firstKeyFramePTS ? g.firstKeyFramePTS : A) - this.config.maxBufferHole) return void this.backtrack(d);
                                                        d.setElementaryStreamInfo(g.type, d.start, _, d.start, w, !0);
                                                    }
                                                    d.setElementaryStreamInfo(g.type, A, _, S, w), this.backtrackFragment && (this.backtrackFragment = d), this.bufferFragmentData(g, d, f, u);
                                                }
                                            } else if (!1 === s1.independent) return void this.backtrack(d);
                                            if (E) {
                                                var R = E.startPTS, C = E.endPTS, D = E.startDTS, k = E.endDTS;
                                                f && (f.elementaryStreams[c.ElementaryStreamTypes.AUDIO] = {
                                                    startPTS: R,
                                                    endPTS: C,
                                                    startDTS: D,
                                                    endDTS: k
                                                }), d.setElementaryStreamInfo(c.ElementaryStreamTypes.AUDIO, R, C, D, k), this.bufferFragmentData(E, d, f, u);
                                            }
                                            if (y && null != m && null !== (t = m.samples) && void 0 !== t && t.length) {
                                                var N = {
                                                    id: n,
                                                    frag: d,
                                                    details: y,
                                                    samples: m.samples
                                                };
                                                a1.trigger(o.Events.FRAG_PARSING_METADATA, N);
                                            }
                                            if (y && p) {
                                                var L = {
                                                    id: n,
                                                    frag: d,
                                                    details: y,
                                                    samples: p.samples
                                                };
                                                a1.trigger(o.Events.FRAG_PARSING_USERDATA, L);
                                            }
                                        }
                                    }, T._bufferInitSegment = function(e, t, n, r) {
                                        var a1 = this;
                                        if (this.state === i.State.PARSING) {
                                            this.audioOnly = !!t.audio && !t.video, this.altAudio && !this.audioOnly && delete t.audio;
                                            var s1 = t.audio, u = t.video, l = t.audiovideo;
                                            if (s1) {
                                                var c = e.audioCodec, d = navigator.userAgent.toLowerCase();
                                                this.audioCodecSwitch && (c && (c = -1 !== c.indexOf("mp4a.40.5") ? "mp4a.40.2" : "mp4a.40.5"), 1 !== s1.metadata.channelCount && -1 === d.indexOf("firefox") && (c = "mp4a.40.5")), -1 !== d.indexOf("android") && "audio/mpeg" !== s1.container && (c = "mp4a.40.2", this.log("Android: force audio codec to " + c)), e.audioCodec && e.audioCodec !== c && this.log('Swapping manifest audio codec "' + e.audioCodec + '" for "' + c + '"'), s1.levelCodec = c, s1.id = "main", this.log("Init audio buffer, container:" + s1.container + ", codecs[selected/level/parsed]=[" + (c || "") + "/" + (e.audioCodec || "") + "/" + s1.codec + "]");
                                            }
                                            u && (u.levelCodec = e.videoCodec, u.id = "main", this.log("Init video buffer, container:" + u.container + ", codecs[level/parsed]=[" + (e.videoCodec || "") + "/" + u.codec + "]")), l && this.log("Init audiovideo buffer, container:" + l.container + ", codecs[level/parsed]=[" + (e.attrs.CODECS || "") + "/" + l.codec + "]"), this.hls.trigger(o.Events.BUFFER_CODECS, t), Object.keys(t).forEach(function(e) {
                                                var i = t[e].initSegment;
                                                null != i && i.byteLength && a1.hls.trigger(o.Events.BUFFER_APPENDING, {
                                                    type: e,
                                                    data: i,
                                                    frag: n,
                                                    part: null,
                                                    chunkMeta: r,
                                                    parent: n.type
                                                });
                                            }), this.tick();
                                        }
                                    }, T.getMainFwdBufferInfo = function() {
                                        return this.getFwdBufferInfo(this.mediaBuffer ? this.mediaBuffer : this.media, l.PlaylistLevelType.MAIN);
                                    }, T.backtrack = function(e) {
                                        this.couldBacktrack = !0, this.backtrackFragment = e, this.resetTransmuxer(), this.flushBufferGap(e), this.fragmentTracker.removeFragment(e), this.fragPrevious = null, this.nextLoadPosition = e.start, this.state = i.State.IDLE;
                                    }, T.checkFragmentChanged = function() {
                                        var e = this.media, t = null;
                                        if (e && e.readyState > 1 && !1 === e.seeking) {
                                            var n = e.currentTime;
                                            if (s1.BufferHelper.isBuffered(e, n) ? t = this.getAppendedFrag(n) : s1.BufferHelper.isBuffered(e, n + .1) && (t = this.getAppendedFrag(n + .1)), t) {
                                                this.backtrackFragment = null;
                                                var r = this.fragPlaying, i = t.level;
                                                r && t.sn === r.sn && r.level === i && t.urlId === r.urlId || (this.hls.trigger(o.Events.FRAG_CHANGED, {
                                                    frag: t
                                                }), r && r.level === i || this.hls.trigger(o.Events.LEVEL_SWITCHED, {
                                                    level: i
                                                }), this.fragPlaying = t);
                                            }
                                        }
                                    }, y = v, E = [
                                        {
                                            key: "nextLevel",
                                            get: function() {
                                                var e = this.nextBufferedFrag;
                                                return e ? e.level : -1;
                                            }
                                        },
                                        {
                                            key: "currentFrag",
                                            get: function() {
                                                var e = this.media;
                                                return e ? this.fragPlaying || this.getAppendedFrag(e.currentTime) : null;
                                            }
                                        },
                                        {
                                            key: "currentProgramDateTime",
                                            get: function() {
                                                var e = this.media;
                                                if (e) {
                                                    var t = e.currentTime, n = this.currentFrag;
                                                    if (n && (0, r.isFiniteNumber)(t) && (0, r.isFiniteNumber)(n.programDateTime)) {
                                                        var i = n.programDateTime + 1e3 * (t - n.start);
                                                        return new Date(i);
                                                    }
                                                }
                                                return null;
                                            }
                                        },
                                        {
                                            key: "currentLevel",
                                            get: function() {
                                                var e = this.currentFrag;
                                                return e ? e.level : -1;
                                            }
                                        },
                                        {
                                            key: "nextBufferedFrag",
                                            get: function() {
                                                var e = this.currentFrag;
                                                return e ? this.followingBufferedFrag(e) : null;
                                            }
                                        },
                                        {
                                            key: "forceStartLoad",
                                            get: function() {
                                                return this._forceStartLoad;
                                            }
                                        }
                                    ], p(y.prototype, E), Object.defineProperty(y, "prototype", {
                                        writable: !1
                                    }), v;
                                }(i.default);
                            },
                            "./src/controller/subtitle-stream-controller.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    SubtitleStreamController: ()=>g
                                });
                                var r = n("./src/events.ts"), i = n("./src/utils/buffer-helper.ts"), a1 = n("./src/controller/fragment-finders.ts"), o = n("./src/utils/discontinuities.ts"), s1 = n("./src/controller/level-helper.ts"), u = n("./src/controller/fragment-tracker.ts"), l = n("./src/controller/base-stream-controller.ts"), c = n("./src/types/loader.ts"), d = n("./src/types/level.ts");
                                function f(e, t) {
                                    for(var n = 0; n < t.length; n++){
                                        var r = t[n];
                                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                    }
                                }
                                function h(e, t) {
                                    return h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, h(e, t);
                                }
                                var g = function(e) {
                                    var t, n;
                                    function g(t, n) {
                                        var r;
                                        return (r = e.call(this, t, n, "[subtitle-stream-controller]") || this).levels = [], r.currentTrackId = -1, r.tracksBuffered = [], r.mainDetails = null, r._registerListeners(), r;
                                    }
                                    n = e, (t = g).prototype = Object.create(n.prototype), t.prototype.constructor = t, h(t, n);
                                    var m, v, y = g.prototype;
                                    return y.onHandlerDestroying = function() {
                                        this._unregisterListeners(), this.mainDetails = null;
                                    }, y._registerListeners = function() {
                                        var e = this.hls;
                                        e.on(r.Events.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(r.Events.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(r.Events.MANIFEST_LOADING, this.onManifestLoading, this), e.on(r.Events.LEVEL_LOADED, this.onLevelLoaded, this), e.on(r.Events.ERROR, this.onError, this), e.on(r.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(r.Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.on(r.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(r.Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.on(r.Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
                                    }, y._unregisterListeners = function() {
                                        var e = this.hls;
                                        e.off(r.Events.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(r.Events.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(r.Events.MANIFEST_LOADING, this.onManifestLoading, this), e.off(r.Events.LEVEL_LOADED, this.onLevelLoaded, this), e.off(r.Events.ERROR, this.onError, this), e.off(r.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(r.Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.off(r.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(r.Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.off(r.Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
                                    }, y.startLoad = function() {
                                        this.stopLoad(), this.state = l.State.IDLE, this.setInterval(500), this.tick();
                                    }, y.onManifestLoading = function() {
                                        this.mainDetails = null, this.fragmentTracker.removeAllFragments();
                                    }, y.onLevelLoaded = function(e, t) {
                                        this.mainDetails = t.details;
                                    }, y.onSubtitleFragProcessed = function(e, t) {
                                        var n = t.frag, r = t.success;
                                        if (this.fragPrevious = n, this.state = l.State.IDLE, r) {
                                            var i = this.tracksBuffered[this.currentTrackId];
                                            if (i) {
                                                for(var a1, o = n.start, s1 = 0; s1 < i.length; s1++)if (o >= i[s1].start && o <= i[s1].end) {
                                                    a1 = i[s1];
                                                    break;
                                                }
                                                var u = n.start + n.duration;
                                                a1 ? a1.end = u : (a1 = {
                                                    start: o,
                                                    end: u
                                                }, i.push(a1)), this.fragmentTracker.fragBuffered(n);
                                            }
                                        }
                                    }, y.onBufferFlushing = function(e, t) {
                                        var n = t.startOffset, r = t.endOffset;
                                        if (0 === n && r !== Number.POSITIVE_INFINITY) {
                                            var i = this.currentTrackId, a1 = this.levels;
                                            if (!a1.length || !a1[i] || !a1[i].details) return;
                                            var o = r - a1[i].details.targetduration;
                                            if (o <= 0) return;
                                            t.endOffsetSubtitles = Math.max(0, o), this.tracksBuffered.forEach(function(e) {
                                                for(var t = 0; t < e.length;)if (e[t].end <= o) e.shift();
                                                else {
                                                    if (!(e[t].start < o)) break;
                                                    e[t].start = o, t++;
                                                }
                                            }), this.fragmentTracker.removeFragmentsInRange(n, o, c.PlaylistLevelType.SUBTITLE);
                                        }
                                    }, y.onError = function(e, t) {
                                        var n, r = t.frag;
                                        r && r.type === c.PlaylistLevelType.SUBTITLE && (null !== (n = this.fragCurrent) && void 0 !== n && n.loader && this.fragCurrent.loader.abort(), this.state = l.State.IDLE);
                                    }, y.onSubtitleTracksUpdated = function(e, t) {
                                        var n = this, r = t.subtitleTracks;
                                        this.tracksBuffered = [], this.levels = r.map(function(e) {
                                            return new d.Level(e);
                                        }), this.fragmentTracker.removeAllFragments(), this.fragPrevious = null, this.levels.forEach(function(e) {
                                            n.tracksBuffered[e.id] = [];
                                        }), this.mediaBuffer = null;
                                    }, y.onSubtitleTrackSwitch = function(e, t) {
                                        if (this.currentTrackId = t.id, this.levels.length && -1 !== this.currentTrackId) {
                                            var n = this.levels[this.currentTrackId];
                                            null != n && n.details ? this.mediaBuffer = this.mediaBufferTimeRanges : this.mediaBuffer = null, n && this.setInterval(500);
                                        } else this.clearInterval();
                                    }, y.onSubtitleTrackLoaded = function(e, t) {
                                        var n, r = t.details, i = t.id, u = this.currentTrackId, c = this.levels;
                                        if (c.length) {
                                            var d = c[u];
                                            if (!(i >= c.length || i !== u) && d) {
                                                if (this.mediaBuffer = this.mediaBufferTimeRanges, r.live || null !== (n = d.details) && void 0 !== n && n.live) {
                                                    var f = this.mainDetails;
                                                    if (r.deltaUpdateFailed || !f) return;
                                                    var h = f.fragments[0];
                                                    d.details ? 0 === this.alignPlaylists(r, d.details) && h && (0, s1.addSliding)(r, h.start) : r.hasProgramDateTime && f.hasProgramDateTime ? (0, o.alignMediaPlaylistByPDT)(r, f) : h && (0, s1.addSliding)(r, h.start);
                                                }
                                                d.details = r, this.levelLastLoaded = i, this.tick(), r.live && !this.fragCurrent && this.media && this.state === l.State.IDLE && ((0, a1.findFragmentByPTS)(null, r.fragments, this.media.currentTime, 0) || (this.warn("Subtitle playlist not aligned with playback"), d.details = void 0));
                                            }
                                        }
                                    }, y._handleFragmentLoadComplete = function(e) {
                                        var t = e.frag, n = e.payload, i = t.decryptdata, a1 = this.hls;
                                        if (!this.fragContextChanged(t) && n && n.byteLength > 0 && i && i.key && i.iv && "AES-128" === i.method) {
                                            var o = performance.now();
                                            this.decrypter.webCryptoDecrypt(new Uint8Array(n), i.key.buffer, i.iv.buffer).then(function(e) {
                                                var n = performance.now();
                                                a1.trigger(r.Events.FRAG_DECRYPTED, {
                                                    frag: t,
                                                    payload: e,
                                                    stats: {
                                                        tstart: o,
                                                        tdecrypt: n
                                                    }
                                                });
                                            });
                                        }
                                    }, y.doTick = function() {
                                        if (this.media) {
                                            if (this.state === l.State.IDLE) {
                                                var e = this.currentTrackId, t = this.levels;
                                                if (!t.length || !t[e] || !t[e].details) return;
                                                var n = t[e].details, r = n.targetduration, o = this.config, s1 = this.media, c = i.BufferHelper.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], s1.currentTime - r, o.maxBufferHole), d = c.end;
                                                if (c.len > this.getMaxBufferLength() + r) return;
                                                console.assert(n, "Subtitle track details are defined on idle subtitle stream controller tick");
                                                var f, h = n.fragments, g = h.length, p = n.edge, m = this.fragPrevious;
                                                if (d < p) {
                                                    var v = o.maxFragLookUpTolerance;
                                                    !(f = (0, a1.findFragmentByPTS)(m, h, Math.max(h[0].start, d), v)) && m && m.start < h[0].start && (f = h[0]);
                                                } else f = h[g - 1];
                                                if (!(f = this.mapToInitFragWhenRequired(f))) return;
                                                if (this.fragmentTracker.getState(f) !== u.FragmentState.NOT_LOADED) return;
                                                f.encrypted ? this.loadKey(f, n) : this.loadFragment(f, n, d);
                                            }
                                        } else this.state = l.State.IDLE;
                                    }, y.loadFragment = function(t, n, r) {
                                        this.fragCurrent = t, "initSegment" === t.sn ? this._loadInitSegment(t) : e.prototype.loadFragment.call(this, t, n, r);
                                    }, m = g, v = [
                                        {
                                            key: "mediaBufferTimeRanges",
                                            get: function() {
                                                return new p(this.tracksBuffered[this.currentTrackId] || []);
                                            }
                                        }
                                    ], f(m.prototype, v), Object.defineProperty(m, "prototype", {
                                        writable: !1
                                    }), g;
                                }(l.default), p = function(e) {
                                    this.buffered = void 0;
                                    var t = function(t, n, r) {
                                        if ((n >>>= 0) > r - 1) throw new DOMException("Failed to execute '" + t + "' on 'TimeRanges': The index provided (" + n + ") is greater than the maximum bound (" + r + ")");
                                        return e[n][t];
                                    };
                                    this.buffered = {
                                        get length () {
                                            return e.length;
                                        },
                                        end: function(n) {
                                            return t("end", n, e.length);
                                        },
                                        start: function(n) {
                                            return t("start", n, e.length);
                                        }
                                    };
                                };
                            },
                            "./src/controller/subtitle-track-controller.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>c
                                });
                                var r = n("./src/events.ts"), i = n("./src/utils/texttrack-utils.ts"), a1 = n("./src/controller/base-playlist-controller.ts"), o = n("./src/types/loader.ts");
                                function s1(e, t) {
                                    for(var n = 0; n < t.length; n++){
                                        var r = t[n];
                                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                    }
                                }
                                function u(e, t) {
                                    return u = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, u(e, t);
                                }
                                function l(e) {
                                    for(var t = [], n = 0; n < e.length; n++){
                                        var r = e[n];
                                        "subtitles" === r.kind && r.label && t.push(e[n]);
                                    }
                                    return t;
                                }
                                const c = function(e) {
                                    var t, n;
                                    function a1(t) {
                                        var n;
                                        return (n = e.call(this, t, "[subtitle-track-controller]") || this).media = null, n.tracks = [], n.groupId = null, n.tracksInGroup = [], n.trackId = -1, n.selectDefaultTrack = !0, n.queuedDefaultTrack = -1, n.trackChangeListener = function() {
                                            return n.onTextTracksChanged();
                                        }, n.asyncPollTrackChange = function() {
                                            return n.pollTrackChange(0);
                                        }, n.useTextTrackPolling = !1, n.subtitlePollingInterval = -1, n._subtitleDisplay = !0, n.registerListeners(), n;
                                    }
                                    n = e, (t = a1).prototype = Object.create(n.prototype), t.prototype.constructor = t, u(t, n);
                                    var c, d, f = a1.prototype;
                                    return f.destroy = function() {
                                        this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.trackChangeListener = this.asyncPollTrackChange = null, e.prototype.destroy.call(this);
                                    }, f.registerListeners = function() {
                                        var e = this.hls;
                                        e.on(r.Events.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(r.Events.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(r.Events.MANIFEST_LOADING, this.onManifestLoading, this), e.on(r.Events.MANIFEST_PARSED, this.onManifestParsed, this), e.on(r.Events.LEVEL_LOADING, this.onLevelLoading, this), e.on(r.Events.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(r.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(r.Events.ERROR, this.onError, this);
                                    }, f.unregisterListeners = function() {
                                        var e = this.hls;
                                        e.off(r.Events.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(r.Events.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(r.Events.MANIFEST_LOADING, this.onManifestLoading, this), e.off(r.Events.MANIFEST_PARSED, this.onManifestParsed, this), e.off(r.Events.LEVEL_LOADING, this.onLevelLoading, this), e.off(r.Events.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(r.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(r.Events.ERROR, this.onError, this);
                                    }, f.onMediaAttached = function(e, t) {
                                        this.media = t.media, this.media && (this.queuedDefaultTrack > -1 && (this.subtitleTrack = this.queuedDefaultTrack, this.queuedDefaultTrack = -1), this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks), this.useTextTrackPolling ? this.pollTrackChange(500) : this.media.textTracks.addEventListener("change", this.asyncPollTrackChange));
                                    }, f.pollTrackChange = function(e) {
                                        self.clearInterval(this.subtitlePollingInterval), this.subtitlePollingInterval = self.setInterval(this.trackChangeListener, e);
                                    }, f.onMediaDetaching = function() {
                                        this.media && (self.clearInterval(this.subtitlePollingInterval), this.useTextTrackPolling || this.media.textTracks.removeEventListener("change", this.asyncPollTrackChange), this.trackId > -1 && (this.queuedDefaultTrack = this.trackId), l(this.media.textTracks).forEach(function(e) {
                                            (0, i.clearCurrentCues)(e);
                                        }), this.subtitleTrack = -1, this.media = null);
                                    }, f.onManifestLoading = function() {
                                        this.tracks = [], this.groupId = null, this.tracksInGroup = [], this.trackId = -1, this.selectDefaultTrack = !0;
                                    }, f.onManifestParsed = function(e, t) {
                                        this.tracks = t.subtitleTracks;
                                    }, f.onSubtitleTrackLoaded = function(e, t) {
                                        var n = t.id, r = t.details, i = this.trackId, a1 = this.tracksInGroup[i];
                                        if (a1) {
                                            var o = a1.details;
                                            a1.details = t.details, this.log("subtitle track " + n + " loaded [" + r.startSN + "-" + r.endSN + "]"), n === this.trackId && (this.retryCount = 0, this.playlistLoaded(n, t, o));
                                        } else this.warn("Invalid subtitle track id " + n);
                                    }, f.onLevelLoading = function(e, t) {
                                        this.switchLevel(t.level);
                                    }, f.onLevelSwitching = function(e, t) {
                                        this.switchLevel(t.level);
                                    }, f.switchLevel = function(e) {
                                        var t = this.hls.levels[e];
                                        if (null != t && t.textGroupIds) {
                                            var n = t.textGroupIds[t.urlId];
                                            if (this.groupId !== n) {
                                                var i = this.tracksInGroup ? this.tracksInGroup[this.trackId] : void 0, a1 = this.tracks.filter(function(e) {
                                                    return !n || e.groupId === n;
                                                });
                                                this.tracksInGroup = a1;
                                                var o = this.findTrackId(null == i ? void 0 : i.name) || this.findTrackId();
                                                this.groupId = n;
                                                var s1 = {
                                                    subtitleTracks: a1
                                                };
                                                this.log("Updating subtitle tracks, " + a1.length + ' track(s) found in "' + n + '" group-id'), this.hls.trigger(r.Events.SUBTITLE_TRACKS_UPDATED, s1), -1 !== o && this.setSubtitleTrack(o, i);
                                            }
                                        }
                                    }, f.findTrackId = function(e) {
                                        for(var t = this.tracksInGroup, n = 0; n < t.length; n++){
                                            var r = t[n];
                                            if ((!this.selectDefaultTrack || r.default) && (!e || e === r.name)) return r.id;
                                        }
                                        return -1;
                                    }, f.onError = function(t, n) {
                                        e.prototype.onError.call(this, t, n), !n.fatal && n.context && n.context.type === o.PlaylistContextType.SUBTITLE_TRACK && n.context.id === this.trackId && n.context.groupId === this.groupId && this.retryLoadingOrFail(n);
                                    }, f.loadPlaylist = function(e) {
                                        var t = this.tracksInGroup[this.trackId];
                                        if (this.shouldLoadTrack(t)) {
                                            var n = t.id, i = t.groupId, a1 = t.url;
                                            if (e) try {
                                                a1 = e.addDirectives(a1);
                                            } catch (e) {
                                                this.warn("Could not construct new URL with HLS Delivery Directives: " + e);
                                            }
                                            this.log("Loading subtitle playlist for id " + n), this.hls.trigger(r.Events.SUBTITLE_TRACK_LOADING, {
                                                url: a1,
                                                id: n,
                                                groupId: i,
                                                deliveryDirectives: e || null
                                            });
                                        }
                                    }, f.toggleTrackModes = function(e) {
                                        var t = this, n = this.media, r = this.trackId;
                                        if (n) {
                                            var i = l(n.textTracks), a1 = i.filter(function(e) {
                                                return e.groupId === t.groupId;
                                            });
                                            if (-1 === e) [].slice.call(i).forEach(function(e) {
                                                e.mode = "disabled";
                                            });
                                            else {
                                                var o = a1[r];
                                                o && (o.mode = "disabled");
                                            }
                                            var s1 = a1[e];
                                            s1 && (s1.mode = this.subtitleDisplay ? "showing" : "hidden");
                                        }
                                    }, f.setSubtitleTrack = function(e, t) {
                                        var n, i = this.tracksInGroup;
                                        if (this.media) {
                                            if (this.trackId !== e && this.toggleTrackModes(e), !(this.trackId === e && (-1 === e || null !== (n = i[e]) && void 0 !== n && n.details) || e < -1 || e >= i.length)) {
                                                this.clearTimer();
                                                var a1 = i[e];
                                                if (this.log("Switching to subtitle track " + e), this.trackId = e, a1) {
                                                    var o = a1.id, s1 = a1.groupId, u = void 0 === s1 ? "" : s1, l = a1.name, c = a1.type, d = a1.url;
                                                    this.hls.trigger(r.Events.SUBTITLE_TRACK_SWITCH, {
                                                        id: o,
                                                        groupId: u,
                                                        name: l,
                                                        type: c,
                                                        url: d
                                                    });
                                                    var f = this.switchParams(a1.url, null == t ? void 0 : t.details);
                                                    this.loadPlaylist(f);
                                                } else this.hls.trigger(r.Events.SUBTITLE_TRACK_SWITCH, {
                                                    id: e
                                                });
                                            }
                                        } else this.queuedDefaultTrack = e;
                                    }, f.onTextTracksChanged = function() {
                                        if (this.useTextTrackPolling || self.clearInterval(this.subtitlePollingInterval), this.media && this.hls.config.renderTextTracksNatively) {
                                            for(var e = -1, t = l(this.media.textTracks), n = 0; n < t.length; n++)if ("hidden" === t[n].mode) e = n;
                                            else if ("showing" === t[n].mode) {
                                                e = n;
                                                break;
                                            }
                                            this.subtitleTrack !== e && (this.subtitleTrack = e);
                                        }
                                    }, c = a1, d = [
                                        {
                                            key: "subtitleDisplay",
                                            get: function() {
                                                return this._subtitleDisplay;
                                            },
                                            set: function(e) {
                                                this._subtitleDisplay = e, this.trackId > -1 && this.toggleTrackModes(this.trackId);
                                            }
                                        },
                                        {
                                            key: "subtitleTracks",
                                            get: function() {
                                                return this.tracksInGroup;
                                            }
                                        },
                                        {
                                            key: "subtitleTrack",
                                            get: function() {
                                                return this.trackId;
                                            },
                                            set: function(e) {
                                                this.selectDefaultTrack = !1;
                                                var t = this.tracksInGroup ? this.tracksInGroup[this.trackId] : void 0;
                                                this.setSubtitleTrack(e, t);
                                            }
                                        }
                                    ], s1(c.prototype, d), Object.defineProperty(c, "prototype", {
                                        writable: !1
                                    }), a1;
                                }(a1.default);
                            },
                            "./src/controller/timeline-controller.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    TimelineController: ()=>h
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./src/events.ts"), a1 = n("./src/utils/cea-608-parser.ts"), o = n("./src/utils/output-filter.ts"), s1 = n("./src/utils/webvtt-parser.ts"), u = n("./src/utils/texttrack-utils.ts"), l = n("./src/utils/imsc1-ttml-parser.ts"), c = n("./src/utils/mp4-tools.ts"), d = n("./src/types/loader.ts"), f = n("./src/utils/logger.ts"), h = function() {
                                    function e(e) {
                                        if (this.hls = void 0, this.media = null, this.config = void 0, this.enabled = !0, this.Cues = void 0, this.textTracks = [], this.tracks = [], this.initPTS = [], this.timescale = [], this.unparsedVttFrags = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.cea608Parser1 = void 0, this.cea608Parser2 = void 0, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = {
                                            ccOffset: 0,
                                            presentationOffset: 0,
                                            0: {
                                                start: 0,
                                                prevCC: -1,
                                                new: !0
                                            }
                                        }, this.captionsProperties = void 0, this.hls = e, this.config = e.config, this.Cues = e.config.cueHandler, this.captionsProperties = {
                                            textTrack1: {
                                                label: this.config.captionsTextTrack1Label,
                                                languageCode: this.config.captionsTextTrack1LanguageCode
                                            },
                                            textTrack2: {
                                                label: this.config.captionsTextTrack2Label,
                                                languageCode: this.config.captionsTextTrack2LanguageCode
                                            },
                                            textTrack3: {
                                                label: this.config.captionsTextTrack3Label,
                                                languageCode: this.config.captionsTextTrack3LanguageCode
                                            },
                                            textTrack4: {
                                                label: this.config.captionsTextTrack4Label,
                                                languageCode: this.config.captionsTextTrack4LanguageCode
                                            }
                                        }, this.config.enableCEA708Captions) {
                                            var t = new o.default(this, "textTrack1"), n = new o.default(this, "textTrack2"), r = new o.default(this, "textTrack3"), s1 = new o.default(this, "textTrack4");
                                            this.cea608Parser1 = new a1.default(1, t, n), this.cea608Parser2 = new a1.default(3, r, s1);
                                        }
                                        e.on(i.Events.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(i.Events.MANIFEST_LOADING, this.onManifestLoading, this), e.on(i.Events.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(i.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(i.Events.FRAG_LOADING, this.onFragLoading, this), e.on(i.Events.FRAG_LOADED, this.onFragLoaded, this), e.on(i.Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.on(i.Events.FRAG_DECRYPTED, this.onFragDecrypted, this), e.on(i.Events.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(i.Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.on(i.Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
                                    }
                                    var t = e.prototype;
                                    return t.destroy = function() {
                                        var e = this.hls;
                                        e.off(i.Events.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(i.Events.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(i.Events.MANIFEST_LOADING, this.onManifestLoading, this), e.off(i.Events.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(i.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(i.Events.FRAG_LOADING, this.onFragLoading, this), e.off(i.Events.FRAG_LOADED, this.onFragLoaded, this), e.off(i.Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.off(i.Events.FRAG_DECRYPTED, this.onFragDecrypted, this), e.off(i.Events.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(i.Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.off(i.Events.BUFFER_FLUSHING, this.onBufferFlushing, this), this.hls = this.config = this.cea608Parser1 = this.cea608Parser2 = null;
                                    }, t.addCues = function(e, t, n, r, a1) {
                                        for(var o, s1, u, l, c = !1, d = a1.length; d--;){
                                            var f = a1[d], h = (o = f[0], s1 = f[1], u = t, l = n, Math.min(s1, l) - Math.max(o, u));
                                            if (h >= 0 && (f[0] = Math.min(f[0], t), f[1] = Math.max(f[1], n), c = !0, h / (n - t) > .5)) return;
                                        }
                                        if (c || a1.push([
                                            t,
                                            n
                                        ]), this.config.renderTextTracksNatively) {
                                            var g = this.captionsTracks[e];
                                            this.Cues.newCue(g, t, n, r);
                                        } else {
                                            var p = this.Cues.newCue(null, t, n, r);
                                            this.hls.trigger(i.Events.CUES_PARSED, {
                                                type: "captions",
                                                cues: p,
                                                track: e
                                            });
                                        }
                                    }, t.onInitPtsFound = function(e, t) {
                                        var n = this, r = t.frag, a1 = t.id, o = t.initPTS, s1 = t.timescale, u = this.unparsedVttFrags;
                                        "main" === a1 && (this.initPTS[r.cc] = o, this.timescale[r.cc] = s1), u.length && (this.unparsedVttFrags = [], u.forEach(function(e) {
                                            n.onFragLoaded(i.Events.FRAG_LOADED, e);
                                        }));
                                    }, t.getExistingTrack = function(e) {
                                        var t = this.media;
                                        if (t) for(var n = 0; n < t.textTracks.length; n++){
                                            var r = t.textTracks[n];
                                            if (r[e]) return r;
                                        }
                                        return null;
                                    }, t.createCaptionsTrack = function(e) {
                                        this.config.renderTextTracksNatively ? this.createNativeTrack(e) : this.createNonNativeTrack(e);
                                    }, t.createNativeTrack = function(e) {
                                        if (!this.captionsTracks[e]) {
                                            var t = this.captionsProperties, n = this.captionsTracks, r = this.media, i = t[e], a1 = i.label, o = i.languageCode, s1 = this.getExistingTrack(e);
                                            if (s1) n[e] = s1, (0, u.clearCurrentCues)(n[e]), (0, u.sendAddTrackEvent)(n[e], r);
                                            else {
                                                var l = this.createTextTrack("captions", a1, o);
                                                l && (l[e] = !0, n[e] = l);
                                            }
                                        }
                                    }, t.createNonNativeTrack = function(e) {
                                        if (!this.nonNativeCaptionsTracks[e]) {
                                            var t = this.captionsProperties[e];
                                            if (t) {
                                                var n = {
                                                    _id: e,
                                                    label: t.label,
                                                    kind: "captions",
                                                    default: !!t.media && !!t.media.default,
                                                    closedCaptions: t.media
                                                };
                                                this.nonNativeCaptionsTracks[e] = n, this.hls.trigger(i.Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
                                                    tracks: [
                                                        n
                                                    ]
                                                });
                                            }
                                        }
                                    }, t.createTextTrack = function(e, t, n) {
                                        var r = this.media;
                                        if (r) return r.addTextTrack(e, t, n);
                                    }, t.onMediaAttaching = function(e, t) {
                                        this.media = t.media, this._cleanTracks();
                                    }, t.onMediaDetaching = function() {
                                        var e = this.captionsTracks;
                                        Object.keys(e).forEach(function(t) {
                                            (0, u.clearCurrentCues)(e[t]), delete e[t];
                                        }), this.nonNativeCaptionsTracks = {};
                                    }, t.onManifestLoading = function() {
                                        this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = {
                                            ccOffset: 0,
                                            presentationOffset: 0,
                                            0: {
                                                start: 0,
                                                prevCC: -1,
                                                new: !0
                                            }
                                        }, this._cleanTracks(), this.tracks = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.textTracks = [], this.unparsedVttFrags = this.unparsedVttFrags || [], this.initPTS = [], this.timescale = [], this.cea608Parser1 && this.cea608Parser2 && (this.cea608Parser1.reset(), this.cea608Parser2.reset());
                                    }, t._cleanTracks = function() {
                                        var e = this.media;
                                        if (e) {
                                            var t = e.textTracks;
                                            if (t) for(var n = 0; n < t.length; n++)(0, u.clearCurrentCues)(t[n]);
                                        }
                                    }, t.onSubtitleTracksUpdated = function(e, t) {
                                        var n = this;
                                        this.textTracks = [];
                                        var r = t.subtitleTracks || [], a1 = r.some(function(e) {
                                            return e.textCodec === l.IMSC1_CODEC;
                                        });
                                        if (this.config.enableWebVTT || a1 && this.config.enableIMSC1) {
                                            var o = this.tracks && r && this.tracks.length === r.length;
                                            if (this.tracks = r || [], this.config.renderTextTracksNatively) {
                                                var s1 = this.media ? this.media.textTracks : [];
                                                this.tracks.forEach(function(e, t) {
                                                    var r;
                                                    if (t < s1.length) {
                                                        for(var i = null, a1 = 0; a1 < s1.length; a1++)if (g(s1[a1], e)) {
                                                            i = s1[a1];
                                                            break;
                                                        }
                                                        i && (r = i);
                                                    }
                                                    if (r) (0, u.clearCurrentCues)(r);
                                                    else {
                                                        var o = n._captionsOrSubtitlesFromCharacteristics(e);
                                                        (r = n.createTextTrack(o, e.name, e.lang)) && (r.mode = "disabled");
                                                    }
                                                    r && (r.groupId = e.groupId, n.textTracks.push(r));
                                                });
                                            } else if (!o && this.tracks && this.tracks.length) {
                                                var c = this.tracks.map(function(e) {
                                                    return {
                                                        label: e.name,
                                                        kind: e.type.toLowerCase(),
                                                        default: e.default,
                                                        subtitleTrack: e
                                                    };
                                                });
                                                this.hls.trigger(i.Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
                                                    tracks: c
                                                });
                                            }
                                        }
                                    }, t._captionsOrSubtitlesFromCharacteristics = function(e) {
                                        var t;
                                        if (null !== (t = e.attrs) && void 0 !== t && t.CHARACTERISTICS) {
                                            var n = /transcribes-spoken-dialog/gi.test(e.attrs.CHARACTERISTICS), r = /describes-music-and-sound/gi.test(e.attrs.CHARACTERISTICS);
                                            if (n && r) return "captions";
                                        }
                                        return "subtitles";
                                    }, t.onManifestLoaded = function(e, t) {
                                        var n = this;
                                        this.config.enableCEA708Captions && t.captions && t.captions.forEach(function(e) {
                                            var t = /(?:CC|SERVICE)([1-4])/.exec(e.instreamId);
                                            if (t) {
                                                var r = "textTrack" + t[1], i = n.captionsProperties[r];
                                                i && (i.label = e.name, e.lang && (i.languageCode = e.lang), i.media = e);
                                            }
                                        });
                                    }, t.closedCaptionsForLevel = function(e) {
                                        var t = this.hls.levels[e.level];
                                        return null == t ? void 0 : t.attrs["CLOSED-CAPTIONS"];
                                    }, t.onFragLoading = function(e, t) {
                                        var n = this.cea608Parser1, r = this.cea608Parser2, i = this.lastSn, a1 = this.lastPartIndex;
                                        if (this.enabled && n && r && t.frag.type === d.PlaylistLevelType.MAIN) {
                                            var o, s1, u = t.frag.sn, l = null != (o = null == t || null === (s1 = t.part) || void 0 === s1 ? void 0 : s1.index) ? o : -1;
                                            u === i + 1 || u === i && l === a1 + 1 || (n.reset(), r.reset()), this.lastSn = u, this.lastPartIndex = l;
                                        }
                                    }, t.onFragLoaded = function(e, t) {
                                        var n = t.frag, a1 = t.payload, o = this.initPTS, s1 = this.unparsedVttFrags;
                                        if (n.type === d.PlaylistLevelType.SUBTITLE) {
                                            if (a1.byteLength) {
                                                if (!(0, r.isFiniteNumber)(o[n.cc])) return s1.push(t), void (o.length && this.hls.trigger(i.Events.SUBTITLE_FRAG_PROCESSED, {
                                                    success: !1,
                                                    frag: n,
                                                    error: new Error("Missing initial subtitle PTS")
                                                }));
                                                var u = n.decryptdata, c = "stats" in t;
                                                if (null == u || null == u.key || "AES-128" !== u.method || c) {
                                                    var f = this.tracks[n.level], h = this.vttCCs;
                                                    h[n.cc] || (h[n.cc] = {
                                                        start: n.start,
                                                        prevCC: this.prevCC,
                                                        new: !0
                                                    }, this.prevCC = n.cc), f && f.textCodec === l.IMSC1_CODEC ? this._parseIMSC1(n, a1) : this._parseVTTs(n, a1, h);
                                                }
                                            } else this.hls.trigger(i.Events.SUBTITLE_FRAG_PROCESSED, {
                                                success: !1,
                                                frag: n,
                                                error: new Error("Empty subtitle payload")
                                            });
                                        }
                                    }, t._parseIMSC1 = function(e, t) {
                                        var n = this, r = this.hls;
                                        (0, l.parseIMSC1)(t, this.initPTS[e.cc], this.timescale[e.cc], function(t) {
                                            n._appendCues(t, e.level), r.trigger(i.Events.SUBTITLE_FRAG_PROCESSED, {
                                                success: !0,
                                                frag: e
                                            });
                                        }, function(t) {
                                            f.logger.log("Failed to parse IMSC1: " + t), r.trigger(i.Events.SUBTITLE_FRAG_PROCESSED, {
                                                success: !1,
                                                frag: e,
                                                error: t
                                            });
                                        });
                                    }, t._parseVTTs = function(e, t, n) {
                                        var r, a1 = this, o = this.hls, u = null !== (r = e.initSegment) && void 0 !== r && r.data ? (0, c.appendUint8Array)(e.initSegment.data, new Uint8Array(t)) : t;
                                        (0, s1.parseWebVTT)(u, this.initPTS[e.cc], this.timescale[e.cc], n, e.cc, e.start, function(t) {
                                            a1._appendCues(t, e.level), o.trigger(i.Events.SUBTITLE_FRAG_PROCESSED, {
                                                success: !0,
                                                frag: e
                                            });
                                        }, function(n) {
                                            a1._fallbackToIMSC1(e, t), f.logger.log("Failed to parse VTT cue: " + n), o.trigger(i.Events.SUBTITLE_FRAG_PROCESSED, {
                                                success: !1,
                                                frag: e,
                                                error: n
                                            });
                                        });
                                    }, t._fallbackToIMSC1 = function(e, t) {
                                        var n = this, r = this.tracks[e.level];
                                        r.textCodec || (0, l.parseIMSC1)(t, this.initPTS[e.cc], this.timescale[e.cc], function() {
                                            r.textCodec = l.IMSC1_CODEC, n._parseIMSC1(e, t);
                                        }, function() {
                                            r.textCodec = "wvtt";
                                        });
                                    }, t._appendCues = function(e, t) {
                                        var n = this.hls;
                                        if (this.config.renderTextTracksNatively) {
                                            var r = this.textTracks[t];
                                            if (!r || "disabled" === r.mode) return;
                                            e.forEach(function(e) {
                                                return (0, u.addCueToTrack)(r, e);
                                            });
                                        } else {
                                            var a1 = this.tracks[t];
                                            if (!a1) return;
                                            var o = a1.default ? "default" : "subtitles" + t;
                                            n.trigger(i.Events.CUES_PARSED, {
                                                type: "subtitles",
                                                cues: e,
                                                track: o
                                            });
                                        }
                                    }, t.onFragDecrypted = function(e, t) {
                                        var n = t.frag;
                                        if (n.type === d.PlaylistLevelType.SUBTITLE) {
                                            if (!(0, r.isFiniteNumber)(this.initPTS[n.cc])) return void this.unparsedVttFrags.push(t);
                                            this.onFragLoaded(i.Events.FRAG_LOADED, t);
                                        }
                                    }, t.onSubtitleTracksCleared = function() {
                                        this.tracks = [], this.captionsTracks = {};
                                    }, t.onFragParsingUserdata = function(e, t) {
                                        var n = this.cea608Parser1, r = this.cea608Parser2;
                                        if (this.enabled && n && r) {
                                            var i = t.frag, a1 = t.samples;
                                            if (i.type !== d.PlaylistLevelType.MAIN || "NONE" !== this.closedCaptionsForLevel(i)) for(var o = 0; o < a1.length; o++){
                                                var s1 = a1[o].bytes;
                                                if (s1) {
                                                    var u = this.extractCea608Data(s1);
                                                    n.addData(a1[o].pts, u[0]), r.addData(a1[o].pts, u[1]);
                                                }
                                            }
                                        }
                                    }, t.onBufferFlushing = function(e, t) {
                                        var n = t.startOffset, r = t.endOffset, i = t.endOffsetSubtitles, a1 = t.type, o = this.media;
                                        if (o && !(o.currentTime < r)) {
                                            if (!a1 || "video" === a1) {
                                                var s1 = this.captionsTracks;
                                                Object.keys(s1).forEach(function(e) {
                                                    return (0, u.removeCuesInRange)(s1[e], n, r);
                                                });
                                            }
                                            if (this.config.renderTextTracksNatively && 0 === n && void 0 !== i) {
                                                var l = this.textTracks;
                                                Object.keys(l).forEach(function(e) {
                                                    return (0, u.removeCuesInRange)(l[e], n, i);
                                                });
                                            }
                                        }
                                    }, t.extractCea608Data = function(e) {
                                        for(var t = [
                                            [],
                                            []
                                        ], n = 31 & e[0], r = 2, i = 0; i < n; i++){
                                            var a1 = e[r++], o = 127 & e[r++], s1 = 127 & e[r++];
                                            if ((0 !== o || 0 !== s1) && 0 != (4 & a1)) {
                                                var u = 3 & a1;
                                                0 !== u && 1 !== u || (t[u].push(o), t[u].push(s1));
                                            }
                                        }
                                        return t;
                                    }, e;
                                }();
                                function g(e, t) {
                                    return e && e.label === t.name && !(e.textTrack1 || e.textTrack2);
                                }
                            },
                            "./src/crypt/aes-crypto.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>r
                                });
                                var r = function() {
                                    function e(e, t) {
                                        this.subtle = void 0, this.aesIV = void 0, this.subtle = e, this.aesIV = t;
                                    }
                                    return e.prototype.decrypt = function(e, t) {
                                        return this.subtle.decrypt({
                                            name: "AES-CBC",
                                            iv: this.aesIV
                                        }, t, e);
                                    }, e;
                                }();
                            },
                            "./src/crypt/aes-decryptor.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>a1,
                                    removePadding: ()=>i
                                });
                                var r = n("./src/utils/typed-array.ts");
                                function i(e) {
                                    var t = e.byteLength, n = t && new DataView(e.buffer).getUint8(t - 1);
                                    return n ? (0, r.sliceUint8)(e, 0, t - n) : e;
                                }
                                var a1 = function() {
                                    function e() {
                                        this.rcon = [
                                            0,
                                            1,
                                            2,
                                            4,
                                            8,
                                            16,
                                            32,
                                            64,
                                            128,
                                            27,
                                            54
                                        ], this.subMix = [
                                            new Uint32Array(256),
                                            new Uint32Array(256),
                                            new Uint32Array(256),
                                            new Uint32Array(256)
                                        ], this.invSubMix = [
                                            new Uint32Array(256),
                                            new Uint32Array(256),
                                            new Uint32Array(256),
                                            new Uint32Array(256)
                                        ], this.sBox = new Uint32Array(256), this.invSBox = new Uint32Array(256), this.key = new Uint32Array(0), this.ksRows = 0, this.keySize = 0, this.keySchedule = void 0, this.invKeySchedule = void 0, this.initTable();
                                    }
                                    var t = e.prototype;
                                    return t.uint8ArrayToUint32Array_ = function(e) {
                                        for(var t = new DataView(e), n = new Uint32Array(4), r = 0; r < 4; r++)n[r] = t.getUint32(4 * r);
                                        return n;
                                    }, t.initTable = function() {
                                        var e = this.sBox, t = this.invSBox, n = this.subMix, r = n[0], i = n[1], a1 = n[2], o = n[3], s1 = this.invSubMix, u = s1[0], l = s1[1], c = s1[2], d = s1[3], f = new Uint32Array(256), h = 0, g = 0, p = 0;
                                        for(p = 0; p < 256; p++)f[p] = p < 128 ? p << 1 : p << 1 ^ 283;
                                        for(p = 0; p < 256; p++){
                                            var m = g ^ g << 1 ^ g << 2 ^ g << 3 ^ g << 4;
                                            m = m >>> 8 ^ 255 & m ^ 99, e[h] = m, t[m] = h;
                                            var v = f[h], y = f[v], E = f[y], T = 257 * f[m] ^ 16843008 * m;
                                            r[h] = T << 24 | T >>> 8, i[h] = T << 16 | T >>> 16, a1[h] = T << 8 | T >>> 24, o[h] = T, T = 16843009 * E ^ 65537 * y ^ 257 * v ^ 16843008 * h, u[m] = T << 24 | T >>> 8, l[m] = T << 16 | T >>> 16, c[m] = T << 8 | T >>> 24, d[m] = T, h ? (h = v ^ f[f[f[E ^ v]]], g ^= f[f[g]]) : h = g = 1;
                                        }
                                    }, t.expandKey = function(e) {
                                        for(var t = this.uint8ArrayToUint32Array_(e), n = !0, r = 0; r < t.length && n;)n = t[r] === this.key[r], r++;
                                        if (!n) {
                                            this.key = t;
                                            var i = this.keySize = t.length;
                                            if (4 !== i && 6 !== i && 8 !== i) throw new Error("Invalid aes key size=" + i);
                                            var a1, o, s1, u, l = this.ksRows = 4 * (i + 6 + 1), c = this.keySchedule = new Uint32Array(l), d = this.invKeySchedule = new Uint32Array(l), f = this.sBox, h = this.rcon, g = this.invSubMix, p = g[0], m = g[1], v = g[2], y = g[3];
                                            for(a1 = 0; a1 < l; a1++)a1 < i ? s1 = c[a1] = t[a1] : (u = s1, a1 % i == 0 ? (u = f[(u = u << 8 | u >>> 24) >>> 24] << 24 | f[u >>> 16 & 255] << 16 | f[u >>> 8 & 255] << 8 | f[255 & u], u ^= h[a1 / i | 0] << 24) : i > 6 && a1 % i == 4 && (u = f[u >>> 24] << 24 | f[u >>> 16 & 255] << 16 | f[u >>> 8 & 255] << 8 | f[255 & u]), c[a1] = s1 = (c[a1 - i] ^ u) >>> 0);
                                            for(o = 0; o < l; o++)a1 = l - o, u = 3 & o ? c[a1] : c[a1 - 4], d[o] = o < 4 || a1 <= 4 ? u : p[f[u >>> 24]] ^ m[f[u >>> 16 & 255]] ^ v[f[u >>> 8 & 255]] ^ y[f[255 & u]], d[o] = d[o] >>> 0;
                                        }
                                    }, t.networkToHostOrderSwap = function(e) {
                                        return e << 24 | (65280 & e) << 8 | (16711680 & e) >> 8 | e >>> 24;
                                    }, t.decrypt = function(e, t, n) {
                                        for(var r, i, a1, o, s1, u, l, c, d, f, h, g, p, m, v = this.keySize + 6, y = this.invKeySchedule, E = this.invSBox, T = this.invSubMix, b = T[0], A = T[1], _ = T[2], S = T[3], w = this.uint8ArrayToUint32Array_(n), I = w[0], R = w[1], C = w[2], D = w[3], k = new Int32Array(e), N = new Int32Array(k.length), L = this.networkToHostOrderSwap; t < k.length;){
                                            for(d = L(k[t]), f = L(k[t + 1]), h = L(k[t + 2]), g = L(k[t + 3]), s1 = d ^ y[0], u = g ^ y[1], l = h ^ y[2], c = f ^ y[3], p = 4, m = 1; m < v; m++)r = b[s1 >>> 24] ^ A[u >> 16 & 255] ^ _[l >> 8 & 255] ^ S[255 & c] ^ y[p], i = b[u >>> 24] ^ A[l >> 16 & 255] ^ _[c >> 8 & 255] ^ S[255 & s1] ^ y[p + 1], a1 = b[l >>> 24] ^ A[c >> 16 & 255] ^ _[s1 >> 8 & 255] ^ S[255 & u] ^ y[p + 2], o = b[c >>> 24] ^ A[s1 >> 16 & 255] ^ _[u >> 8 & 255] ^ S[255 & l] ^ y[p + 3], s1 = r, u = i, l = a1, c = o, p += 4;
                                            r = E[s1 >>> 24] << 24 ^ E[u >> 16 & 255] << 16 ^ E[l >> 8 & 255] << 8 ^ E[255 & c] ^ y[p], i = E[u >>> 24] << 24 ^ E[l >> 16 & 255] << 16 ^ E[c >> 8 & 255] << 8 ^ E[255 & s1] ^ y[p + 1], a1 = E[l >>> 24] << 24 ^ E[c >> 16 & 255] << 16 ^ E[s1 >> 8 & 255] << 8 ^ E[255 & u] ^ y[p + 2], o = E[c >>> 24] << 24 ^ E[s1 >> 16 & 255] << 16 ^ E[u >> 8 & 255] << 8 ^ E[255 & l] ^ y[p + 3], N[t] = L(r ^ I), N[t + 1] = L(o ^ R), N[t + 2] = L(a1 ^ C), N[t + 3] = L(i ^ D), I = d, R = f, C = h, D = g, t += 4;
                                        }
                                        return N.buffer;
                                    }, e;
                                }();
                            },
                            "./src/crypt/decrypter.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>l
                                });
                                var r = n("./src/crypt/aes-crypto.ts"), i = n("./src/crypt/fast-aes-key.ts"), a1 = n("./src/crypt/aes-decryptor.ts"), o = n("./src/utils/logger.ts"), s1 = n("./src/utils/mp4-tools.ts"), u = n("./src/utils/typed-array.ts"), l = function() {
                                    function e(e, t, n) {
                                        var r = (void 0 === n ? {} : n).removePKCS7Padding, i = void 0 === r || r;
                                        if (this.logEnabled = !0, this.observer = void 0, this.config = void 0, this.removePKCS7Padding = void 0, this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null, this.observer = e, this.config = t, this.removePKCS7Padding = i, i) try {
                                            var a1 = self.crypto;
                                            a1 && (this.subtle = a1.subtle || a1.webkitSubtle);
                                        } catch (e) {}
                                        null === this.subtle && (this.config.enableSoftwareAES = !0);
                                    }
                                    var t = e.prototype;
                                    return t.destroy = function() {
                                        this.observer = null;
                                    }, t.isSync = function() {
                                        return this.config.enableSoftwareAES;
                                    }, t.flush = function() {
                                        var e = this.currentResult;
                                        if (e) {
                                            var t = new Uint8Array(e);
                                            return this.reset(), this.removePKCS7Padding ? (0, a1.removePadding)(t) : t;
                                        }
                                        this.reset();
                                    }, t.reset = function() {
                                        this.currentResult = null, this.currentIV = null, this.remainderData = null, this.softwareDecrypter && (this.softwareDecrypter = null);
                                    }, t.decrypt = function(e, t, n, r) {
                                        if (this.config.enableSoftwareAES) {
                                            this.softwareDecrypt(new Uint8Array(e), t, n);
                                            var i = this.flush();
                                            i && r(i.buffer);
                                        } else this.webCryptoDecrypt(new Uint8Array(e), t, n).then(r);
                                    }, t.softwareDecrypt = function(e, t, n) {
                                        var r = this.currentIV, i = this.currentResult, o = this.remainderData;
                                        this.logOnce("JS AES decrypt"), o && (e = (0, s1.appendUint8Array)(o, e), this.remainderData = null);
                                        var l = this.getValidChunk(e);
                                        if (!l.length) return null;
                                        r && (n = r);
                                        var c = this.softwareDecrypter;
                                        c || (c = this.softwareDecrypter = new a1.default), c.expandKey(t);
                                        var d = i;
                                        return this.currentResult = c.decrypt(l.buffer, 0, n), this.currentIV = (0, u.sliceUint8)(l, -16).buffer, d || null;
                                    }, t.webCryptoDecrypt = function(e, t, n) {
                                        var a1 = this, o = this.subtle;
                                        return this.key === t && this.fastAesKey || (this.key = t, this.fastAesKey = new i.default(o, t)), this.fastAesKey.expandKey().then(function(t) {
                                            return o ? new r.default(o, n).decrypt(e.buffer, t) : Promise.reject(new Error("web crypto not initialized"));
                                        }).catch(function(r) {
                                            return a1.onWebCryptoError(r, e, t, n);
                                        });
                                    }, t.onWebCryptoError = function(e, t, n, r) {
                                        return o.logger.warn("[decrypter.ts]: WebCrypto Error, disable WebCrypto API:", e), this.config.enableSoftwareAES = !0, this.logEnabled = !0, this.softwareDecrypt(t, n, r);
                                    }, t.getValidChunk = function(e) {
                                        var t = e, n = e.length - e.length % 16;
                                        return n !== e.length && (t = (0, u.sliceUint8)(e, 0, n), this.remainderData = (0, u.sliceUint8)(e, n)), t;
                                    }, t.logOnce = function(e) {
                                        this.logEnabled && (o.logger.log("[decrypter.ts]: " + e), this.logEnabled = !1);
                                    }, e;
                                }();
                            },
                            "./src/crypt/fast-aes-key.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>r
                                });
                                var r = function() {
                                    function e(e, t) {
                                        this.subtle = void 0, this.key = void 0, this.subtle = e, this.key = t;
                                    }
                                    return e.prototype.expandKey = function() {
                                        return this.subtle.importKey("raw", this.key, {
                                            name: "AES-CBC"
                                        }, !1, [
                                            "encrypt",
                                            "decrypt"
                                        ]);
                                    }, e;
                                }();
                            },
                            "./src/demux/aacdemuxer.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>u
                                });
                                var r = n("./src/demux/base-audio-demuxer.ts"), i = n("./src/demux/adts.ts"), a1 = n("./src/utils/logger.ts"), o = n("./src/demux/id3.ts");
                                function s1(e, t) {
                                    return s1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, s1(e, t);
                                }
                                const u = function(e) {
                                    var t, n;
                                    function r(t, n) {
                                        var r;
                                        return (r = e.call(this) || this).observer = void 0, r.config = void 0, r.observer = t, r.config = n, r;
                                    }
                                    n = e, (t = r).prototype = Object.create(n.prototype), t.prototype.constructor = t, s1(t, n);
                                    var u = r.prototype;
                                    return u.resetInitSegment = function(t, n, r, i) {
                                        e.prototype.resetInitSegment.call(this, t, n, r, i), this._audioTrack = {
                                            container: "audio/adts",
                                            type: "audio",
                                            id: 2,
                                            pid: -1,
                                            sequenceNumber: 0,
                                            segmentCodec: "aac",
                                            samples: [],
                                            manifestCodec: n,
                                            duration: i,
                                            inputTimeScale: 9e4,
                                            dropped: 0
                                        };
                                    }, r.probe = function(e) {
                                        if (!e) return !1;
                                        for(var t = (o.getID3Data(e, 0) || []).length, n = e.length; t < n; t++)if (i.probe(e, t)) return a1.logger.log("ADTS sync word found !"), !0;
                                        return !1;
                                    }, u.canParse = function(e, t) {
                                        return i.canParse(e, t);
                                    }, u.appendFrame = function(e, t, n) {
                                        i.initTrackConfig(e, this.observer, t, n, e.manifestCodec);
                                        var r = i.appendFrame(e, t, n, this.basePTS, this.frameIndex);
                                        if (r && 0 === r.missing) return r;
                                    }, r;
                                }(r.default);
                            },
                            "./src/demux/adts.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    appendFrame: ()=>v,
                                    canGetFrameLength: ()=>c,
                                    canParse: ()=>f,
                                    getAudioConfig: ()=>o,
                                    getFrameDuration: ()=>p,
                                    getFullFrameLength: ()=>l,
                                    getHeaderLength: ()=>u,
                                    initTrackConfig: ()=>g,
                                    isHeader: ()=>d,
                                    isHeaderPattern: ()=>s1,
                                    parseFrameHeader: ()=>m,
                                    probe: ()=>h
                                });
                                var r = n("./src/utils/logger.ts"), i = n("./src/errors.ts"), a1 = n("./src/events.ts");
                                function o(e, t, n, o) {
                                    var s1, u, l, c, d = navigator.userAgent.toLowerCase(), f = o, h = [
                                        96e3,
                                        88200,
                                        64e3,
                                        48e3,
                                        44100,
                                        32e3,
                                        24e3,
                                        22050,
                                        16e3,
                                        12e3,
                                        11025,
                                        8e3,
                                        7350
                                    ];
                                    s1 = 1 + ((192 & t[n + 2]) >>> 6);
                                    var g = (60 & t[n + 2]) >>> 2;
                                    if (!(g > h.length - 1)) return l = (1 & t[n + 2]) << 2, l |= (192 & t[n + 3]) >>> 6, r.logger.log("manifest codec:" + o + ", ADTS type:" + s1 + ", samplingIndex:" + g), /firefox/i.test(d) ? g >= 6 ? (s1 = 5, c = new Array(4), u = g - 3) : (s1 = 2, c = new Array(2), u = g) : -1 !== d.indexOf("android") ? (s1 = 2, c = new Array(2), u = g) : (s1 = 5, c = new Array(4), o && (-1 !== o.indexOf("mp4a.40.29") || -1 !== o.indexOf("mp4a.40.5")) || !o && g >= 6 ? u = g - 3 : ((o && -1 !== o.indexOf("mp4a.40.2") && (g >= 6 && 1 === l || /vivaldi/i.test(d)) || !o && 1 === l) && (s1 = 2, c = new Array(2)), u = g)), c[0] = s1 << 3, c[0] |= (14 & g) >> 1, c[1] |= (1 & g) << 7, c[1] |= l << 3, 5 === s1 && (c[1] |= (14 & u) >> 1, c[2] = (1 & u) << 7, c[2] |= 8, c[3] = 0), {
                                        config: c,
                                        samplerate: h[g],
                                        channelCount: l,
                                        codec: "mp4a.40." + s1,
                                        manifestCodec: f
                                    };
                                    e.trigger(a1.Events.ERROR, {
                                        type: i.ErrorTypes.MEDIA_ERROR,
                                        details: i.ErrorDetails.FRAG_PARSING_ERROR,
                                        fatal: !0,
                                        reason: "invalid ADTS sampling index:" + g
                                    });
                                }
                                function s1(e, t) {
                                    return 255 === e[t] && 240 == (246 & e[t + 1]);
                                }
                                function u(e, t) {
                                    return 1 & e[t + 1] ? 7 : 9;
                                }
                                function l(e, t) {
                                    return (3 & e[t + 3]) << 11 | e[t + 4] << 3 | (224 & e[t + 5]) >>> 5;
                                }
                                function c(e, t) {
                                    return t + 5 < e.length;
                                }
                                function d(e, t) {
                                    return t + 1 < e.length && s1(e, t);
                                }
                                function f(e, t) {
                                    return c(e, t) && s1(e, t) && l(e, t) <= e.length - t;
                                }
                                function h(e, t) {
                                    if (d(e, t)) {
                                        var n = u(e, t);
                                        if (t + n >= e.length) return !1;
                                        var r = l(e, t);
                                        if (r <= n) return !1;
                                        var i = t + r;
                                        return i === e.length || d(e, i);
                                    }
                                    return !1;
                                }
                                function g(e, t, n, i, a1) {
                                    if (!e.samplerate) {
                                        var s1 = o(t, n, i, a1);
                                        if (!s1) return;
                                        e.config = s1.config, e.samplerate = s1.samplerate, e.channelCount = s1.channelCount, e.codec = s1.codec, e.manifestCodec = s1.manifestCodec, r.logger.log("parsed codec:" + e.codec + ", rate:" + s1.samplerate + ", channels:" + s1.channelCount);
                                    }
                                }
                                function p(e) {
                                    return 9216e4 / e;
                                }
                                function m(e, t) {
                                    var n = u(e, t);
                                    if (t + n <= e.length) {
                                        var r = l(e, t) - n;
                                        if (r > 0) return {
                                            headerLength: n,
                                            frameLength: r
                                        };
                                    }
                                }
                                function v(e, t, n, r, i) {
                                    var a1, o = r + i * p(e.samplerate), s1 = m(t, n);
                                    if (s1) {
                                        var u = s1.frameLength, l = s1.headerLength, c = l + u, d = Math.max(0, n + c - t.length);
                                        d ? (a1 = new Uint8Array(c - l)).set(t.subarray(n + l, t.length), 0) : a1 = t.subarray(n + l, n + c);
                                        var f = {
                                            unit: a1,
                                            pts: o
                                        };
                                        return d || e.samples.push(f), {
                                            sample: f,
                                            length: c,
                                            missing: d
                                        };
                                    }
                                    var h = t.length - n;
                                    return (a1 = new Uint8Array(h)).set(t.subarray(n, t.length), 0), {
                                        sample: {
                                            unit: a1,
                                            pts: o
                                        },
                                        length: h,
                                        missing: -1
                                    };
                                }
                            },
                            "./src/demux/base-audio-demuxer.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>d,
                                    initPTSFn: ()=>c
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./src/demux/id3.ts"), a1 = n("./src/types/demuxer.ts"), o = n("./src/demux/dummy-demuxed-track.ts"), s1 = n("./src/utils/mp4-tools.ts"), u = n("./src/utils/typed-array.ts"), l = function() {
                                    function e() {
                                        this._audioTrack = void 0, this._id3Track = void 0, this.frameIndex = 0, this.cachedData = null, this.basePTS = null, this.initPTS = null, this.lastPTS = null;
                                    }
                                    var t = e.prototype;
                                    return t.resetInitSegment = function(e, t, n, r) {
                                        this._id3Track = {
                                            type: "id3",
                                            id: 3,
                                            pid: -1,
                                            inputTimeScale: 9e4,
                                            sequenceNumber: 0,
                                            samples: [],
                                            dropped: 0
                                        };
                                    }, t.resetTimeStamp = function(e) {
                                        this.initPTS = e, this.resetContiguity();
                                    }, t.resetContiguity = function() {
                                        this.basePTS = null, this.lastPTS = null, this.frameIndex = 0;
                                    }, t.canParse = function(e, t) {
                                        return !1;
                                    }, t.appendFrame = function(e, t, n) {}, t.demux = function(e, t) {
                                        this.cachedData && (e = (0, s1.appendUint8Array)(this.cachedData, e), this.cachedData = null);
                                        var n, l = i.getID3Data(e, 0), d = l ? l.length : 0, f = this._audioTrack, h = this._id3Track, g = l ? i.getTimeStamp(l) : void 0, p = e.length;
                                        for((null === this.basePTS || 0 === this.frameIndex && (0, r.isFiniteNumber)(g)) && (this.basePTS = c(g, t, this.initPTS), this.lastPTS = this.basePTS), null === this.lastPTS && (this.lastPTS = this.basePTS), l && l.length > 0 && h.samples.push({
                                            pts: this.lastPTS,
                                            dts: this.lastPTS,
                                            data: l,
                                            type: a1.MetadataSchema.audioId3,
                                            duration: Number.POSITIVE_INFINITY
                                        }); d < p;){
                                            if (this.canParse(e, d)) {
                                                var m = this.appendFrame(f, e, d);
                                                m ? (this.frameIndex++, this.lastPTS = m.sample.pts, n = d += m.length) : d = p;
                                            } else i.canParse(e, d) ? (l = i.getID3Data(e, d), h.samples.push({
                                                pts: this.lastPTS,
                                                dts: this.lastPTS,
                                                data: l,
                                                type: a1.MetadataSchema.audioId3,
                                                duration: Number.POSITIVE_INFINITY
                                            }), n = d += l.length) : d++;
                                            if (d === p && n !== p) {
                                                var v = (0, u.sliceUint8)(e, n);
                                                this.cachedData ? this.cachedData = (0, s1.appendUint8Array)(this.cachedData, v) : this.cachedData = v;
                                            }
                                        }
                                        return {
                                            audioTrack: f,
                                            videoTrack: (0, o.dummyTrack)(),
                                            id3Track: h,
                                            textTrack: (0, o.dummyTrack)()
                                        };
                                    }, t.demuxSampleAes = function(e, t, n) {
                                        return Promise.reject(new Error("[" + this + "] This demuxer does not support Sample-AES decryption"));
                                    }, t.flush = function(e) {
                                        var t = this.cachedData;
                                        return t && (this.cachedData = null, this.demux(t, 0)), {
                                            audioTrack: this._audioTrack,
                                            videoTrack: (0, o.dummyTrack)(),
                                            id3Track: this._id3Track,
                                            textTrack: (0, o.dummyTrack)()
                                        };
                                    }, t.destroy = function() {}, e;
                                }(), c = function(e, t, n) {
                                    return (0, r.isFiniteNumber)(e) ? 90 * e : 9e4 * t + (n || 0);
                                };
                                const d = l;
                            },
                            "./src/demux/chunk-cache.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>r
                                });
                                var r = function() {
                                    function e() {
                                        this.chunks = [], this.dataLength = 0;
                                    }
                                    var t = e.prototype;
                                    return t.push = function(e) {
                                        this.chunks.push(e), this.dataLength += e.length;
                                    }, t.flush = function() {
                                        var e, t = this.chunks, n = this.dataLength;
                                        return t.length ? (e = 1 === t.length ? t[0] : function(e, t) {
                                            for(var n = new Uint8Array(t), r = 0, i = 0; i < e.length; i++){
                                                var a1 = e[i];
                                                n.set(a1, r), r += a1.length;
                                            }
                                            return n;
                                        }(t, n), this.reset(), e) : new Uint8Array(0);
                                    }, t.reset = function() {
                                        this.chunks.length = 0, this.dataLength = 0;
                                    }, e;
                                }();
                            },
                            "./src/demux/dummy-demuxed-track.ts": (e, t, n)=>{
                                "use strict";
                                function r(e, t) {
                                    return void 0 === e && (e = ""), void 0 === t && (t = 9e4), {
                                        type: e,
                                        id: -1,
                                        pid: -1,
                                        inputTimeScale: t,
                                        sequenceNumber: -1,
                                        samples: [],
                                        dropped: 0
                                    };
                                }
                                n.r(t), n.d(t, {
                                    dummyTrack: ()=>r
                                });
                            },
                            "./src/demux/exp-golomb.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>i
                                });
                                var r = n("./src/utils/logger.ts");
                                const i = function() {
                                    function e(e) {
                                        this.data = void 0, this.bytesAvailable = void 0, this.word = void 0, this.bitsAvailable = void 0, this.data = e, this.bytesAvailable = e.byteLength, this.word = 0, this.bitsAvailable = 0;
                                    }
                                    var t = e.prototype;
                                    return t.loadWord = function() {
                                        var e = this.data, t = this.bytesAvailable, n = e.byteLength - t, r = new Uint8Array(4), i = Math.min(4, t);
                                        if (0 === i) throw new Error("no bytes available");
                                        r.set(e.subarray(n, n + i)), this.word = new DataView(r.buffer).getUint32(0), this.bitsAvailable = 8 * i, this.bytesAvailable -= i;
                                    }, t.skipBits = function(e) {
                                        var t;
                                        this.bitsAvailable > e ? (this.word <<= e, this.bitsAvailable -= e) : (e -= this.bitsAvailable, e -= (t = e >> 3) >> 3, this.bytesAvailable -= t, this.loadWord(), this.word <<= e, this.bitsAvailable -= e);
                                    }, t.readBits = function(e) {
                                        var t = Math.min(this.bitsAvailable, e), n = this.word >>> 32 - t;
                                        return e > 32 && r.logger.error("Cannot read more than 32 bits at a time"), this.bitsAvailable -= t, this.bitsAvailable > 0 ? this.word <<= t : this.bytesAvailable > 0 && this.loadWord(), (t = e - t) > 0 && this.bitsAvailable ? n << t | this.readBits(t) : n;
                                    }, t.skipLZ = function() {
                                        var e;
                                        for(e = 0; e < this.bitsAvailable; ++e)if (0 != (this.word & 2147483648 >>> e)) return this.word <<= e, this.bitsAvailable -= e, e;
                                        return this.loadWord(), e + this.skipLZ();
                                    }, t.skipUEG = function() {
                                        this.skipBits(1 + this.skipLZ());
                                    }, t.skipEG = function() {
                                        this.skipBits(1 + this.skipLZ());
                                    }, t.readUEG = function() {
                                        var e = this.skipLZ();
                                        return this.readBits(e + 1) - 1;
                                    }, t.readEG = function() {
                                        var e = this.readUEG();
                                        return 1 & e ? 1 + e >>> 1 : -1 * (e >>> 1);
                                    }, t.readBoolean = function() {
                                        return 1 === this.readBits(1);
                                    }, t.readUByte = function() {
                                        return this.readBits(8);
                                    }, t.readUShort = function() {
                                        return this.readBits(16);
                                    }, t.readUInt = function() {
                                        return this.readBits(32);
                                    }, t.skipScalingList = function(e) {
                                        for(var t = 8, n = 8, r = 0; r < e; r++)0 !== n && (n = (t + this.readEG() + 256) % 256), t = 0 === n ? t : n;
                                    }, t.readSPS = function() {
                                        var e, t, n, r = 0, i = 0, a1 = 0, o = 0, s1 = this.readUByte.bind(this), u = this.readBits.bind(this), l = this.readUEG.bind(this), c = this.readBoolean.bind(this), d = this.skipBits.bind(this), f = this.skipEG.bind(this), h = this.skipUEG.bind(this), g = this.skipScalingList.bind(this);
                                        s1();
                                        var p = s1();
                                        if (u(5), d(3), s1(), h(), 100 === p || 110 === p || 122 === p || 244 === p || 44 === p || 83 === p || 86 === p || 118 === p || 128 === p) {
                                            var m = l();
                                            if (3 === m && d(1), h(), h(), d(1), c()) for(t = 3 !== m ? 8 : 12, n = 0; n < t; n++)c() && g(n < 6 ? 16 : 64);
                                        }
                                        h();
                                        var v = l();
                                        if (0 === v) l();
                                        else if (1 === v) for(d(1), f(), f(), e = l(), n = 0; n < e; n++)f();
                                        h(), d(1);
                                        var y = l(), E = l(), T = u(1);
                                        0 === T && d(1), d(1), c() && (r = l(), i = l(), a1 = l(), o = l());
                                        var b = [
                                            1,
                                            1
                                        ];
                                        if (c() && c()) switch(s1()){
                                            case 1:
                                                b = [
                                                    1,
                                                    1
                                                ];
                                                break;
                                            case 2:
                                                b = [
                                                    12,
                                                    11
                                                ];
                                                break;
                                            case 3:
                                                b = [
                                                    10,
                                                    11
                                                ];
                                                break;
                                            case 4:
                                                b = [
                                                    16,
                                                    11
                                                ];
                                                break;
                                            case 5:
                                                b = [
                                                    40,
                                                    33
                                                ];
                                                break;
                                            case 6:
                                                b = [
                                                    24,
                                                    11
                                                ];
                                                break;
                                            case 7:
                                                b = [
                                                    20,
                                                    11
                                                ];
                                                break;
                                            case 8:
                                                b = [
                                                    32,
                                                    11
                                                ];
                                                break;
                                            case 9:
                                                b = [
                                                    80,
                                                    33
                                                ];
                                                break;
                                            case 10:
                                                b = [
                                                    18,
                                                    11
                                                ];
                                                break;
                                            case 11:
                                                b = [
                                                    15,
                                                    11
                                                ];
                                                break;
                                            case 12:
                                                b = [
                                                    64,
                                                    33
                                                ];
                                                break;
                                            case 13:
                                                b = [
                                                    160,
                                                    99
                                                ];
                                                break;
                                            case 14:
                                                b = [
                                                    4,
                                                    3
                                                ];
                                                break;
                                            case 15:
                                                b = [
                                                    3,
                                                    2
                                                ];
                                                break;
                                            case 16:
                                                b = [
                                                    2,
                                                    1
                                                ];
                                                break;
                                            case 255:
                                                b = [
                                                    s1() << 8 | s1(),
                                                    s1() << 8 | s1()
                                                ];
                                        }
                                        return {
                                            width: Math.ceil(16 * (y + 1) - 2 * r - 2 * i),
                                            height: (2 - T) * (E + 1) * 16 - (T ? 2 : 4) * (a1 + o),
                                            pixelRatio: b
                                        };
                                    }, t.readSliceType = function() {
                                        return this.readUByte(), this.readUEG(), this.readUEG();
                                    }, e;
                                }();
                            },
                            "./src/demux/id3.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    canParse: ()=>u,
                                    decodeFrame: ()=>h,
                                    getID3Data: ()=>o,
                                    getID3Frames: ()=>f,
                                    getTimeStamp: ()=>l,
                                    isFooter: ()=>a1,
                                    isHeader: ()=>i,
                                    isTimeStampFrame: ()=>c,
                                    testables: ()=>E,
                                    utf8ArrayToStr: ()=>y
                                });
                                var r, i = function(e, t) {
                                    return t + 10 <= e.length && 73 === e[t] && 68 === e[t + 1] && 51 === e[t + 2] && e[t + 3] < 255 && e[t + 4] < 255 && e[t + 6] < 128 && e[t + 7] < 128 && e[t + 8] < 128 && e[t + 9] < 128;
                                }, a1 = function(e, t) {
                                    return t + 10 <= e.length && 51 === e[t] && 68 === e[t + 1] && 73 === e[t + 2] && e[t + 3] < 255 && e[t + 4] < 255 && e[t + 6] < 128 && e[t + 7] < 128 && e[t + 8] < 128 && e[t + 9] < 128;
                                }, o = function(e, t) {
                                    for(var n = t, r = 0; i(e, t);)r += 10, r += s1(e, t + 6), a1(e, t + 10) && (r += 10), t += r;
                                    if (r > 0) return e.subarray(n, n + r);
                                }, s1 = function(e, t) {
                                    var n = 0;
                                    return n = (127 & e[t]) << 21, n |= (127 & e[t + 1]) << 14, (n |= (127 & e[t + 2]) << 7) | 127 & e[t + 3];
                                }, u = function(e, t) {
                                    return i(e, t) && s1(e, t + 6) + 10 <= e.length - t;
                                }, l = function(e) {
                                    for(var t = f(e), n = 0; n < t.length; n++){
                                        var r = t[n];
                                        if (c(r)) return v(r);
                                    }
                                }, c = function(e) {
                                    return e && "PRIV" === e.key && "com.apple.streaming.transportStreamTimestamp" === e.info;
                                }, d = function(e) {
                                    var t = String.fromCharCode(e[0], e[1], e[2], e[3]), n = s1(e, 4);
                                    return {
                                        type: t,
                                        size: n,
                                        data: e.subarray(10, 10 + n)
                                    };
                                }, f = function(e) {
                                    for(var t = 0, n = []; i(e, t);){
                                        for(var r = s1(e, t + 6), o = (t += 10) + r; t + 8 < o;){
                                            var u = d(e.subarray(t)), l = h(u);
                                            l && n.push(l), t += u.size + 10;
                                        }
                                        a1(e, t) && (t += 10);
                                    }
                                    return n;
                                }, h = function(e) {
                                    return "PRIV" === e.type ? g(e) : "W" === e.type[0] ? m(e) : p(e);
                                }, g = function(e) {
                                    if (!(e.size < 2)) {
                                        var t = y(e.data, !0), n = new Uint8Array(e.data.subarray(t.length + 1));
                                        return {
                                            key: e.type,
                                            info: t,
                                            data: n.buffer
                                        };
                                    }
                                }, p = function(e) {
                                    if (!(e.size < 2)) {
                                        if ("TXXX" === e.type) {
                                            var t = 1, n = y(e.data.subarray(t), !0);
                                            t += n.length + 1;
                                            var r = y(e.data.subarray(t));
                                            return {
                                                key: e.type,
                                                info: n,
                                                data: r
                                            };
                                        }
                                        var i = y(e.data.subarray(1));
                                        return {
                                            key: e.type,
                                            data: i
                                        };
                                    }
                                }, m = function(e) {
                                    if ("WXXX" === e.type) {
                                        if (e.size < 2) return;
                                        var t = 1, n = y(e.data.subarray(t), !0);
                                        t += n.length + 1;
                                        var r = y(e.data.subarray(t));
                                        return {
                                            key: e.type,
                                            info: n,
                                            data: r
                                        };
                                    }
                                    var i = y(e.data);
                                    return {
                                        key: e.type,
                                        data: i
                                    };
                                }, v = function(e) {
                                    if (8 === e.data.byteLength) {
                                        var t = new Uint8Array(e.data), n = 1 & t[3], r = (t[4] << 23) + (t[5] << 15) + (t[6] << 7) + t[7];
                                        return r /= 45, n && (r += 47721858.84), Math.round(r);
                                    }
                                }, y = function(e, t) {
                                    void 0 === t && (t = !1);
                                    var n = T();
                                    if (n) {
                                        var r = n.decode(e);
                                        if (t) {
                                            var i = r.indexOf("\0");
                                            return -1 !== i ? r.substring(0, i) : r;
                                        }
                                        return r.replace(/\0/g, "");
                                    }
                                    for(var a1, o, s1, u = e.length, l = "", c = 0; c < u;){
                                        if (0 === (a1 = e[c++]) && t) return l;
                                        if (0 !== a1 && 3 !== a1) switch(a1 >> 4){
                                            case 0:
                                            case 1:
                                            case 2:
                                            case 3:
                                            case 4:
                                            case 5:
                                            case 6:
                                            case 7:
                                                l += String.fromCharCode(a1);
                                                break;
                                            case 12:
                                            case 13:
                                                o = e[c++], l += String.fromCharCode((31 & a1) << 6 | 63 & o);
                                                break;
                                            case 14:
                                                o = e[c++], s1 = e[c++], l += String.fromCharCode((15 & a1) << 12 | (63 & o) << 6 | (63 & s1) << 0);
                                        }
                                    }
                                    return l;
                                }, E = {
                                    decodeTextFrame: p
                                };
                                function T() {
                                    return r || void 0 === self.TextDecoder || (r = new self.TextDecoder("utf-8")), r;
                                }
                            },
                            "./src/demux/mp3demuxer.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>l
                                });
                                var r = n("./src/demux/base-audio-demuxer.ts"), i = n("./src/demux/id3.ts"), a1 = n("./src/utils/logger.ts"), o = n("./src/demux/mpegaudio.ts");
                                function s1(e, t) {
                                    return s1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, s1(e, t);
                                }
                                var u = function(e) {
                                    var t, n;
                                    function r() {
                                        return e.apply(this, arguments) || this;
                                    }
                                    n = e, (t = r).prototype = Object.create(n.prototype), t.prototype.constructor = t, s1(t, n);
                                    var u = r.prototype;
                                    return u.resetInitSegment = function(t, n, r, i) {
                                        e.prototype.resetInitSegment.call(this, t, n, r, i), this._audioTrack = {
                                            container: "audio/mpeg",
                                            type: "audio",
                                            id: 2,
                                            pid: -1,
                                            sequenceNumber: 0,
                                            segmentCodec: "mp3",
                                            samples: [],
                                            manifestCodec: n,
                                            duration: i,
                                            inputTimeScale: 9e4,
                                            dropped: 0
                                        };
                                    }, r.probe = function(e) {
                                        if (!e) return !1;
                                        for(var t = (i.getID3Data(e, 0) || []).length, n = e.length; t < n; t++)if (o.probe(e, t)) return a1.logger.log("MPEG Audio sync word found !"), !0;
                                        return !1;
                                    }, u.canParse = function(e, t) {
                                        return o.canParse(e, t);
                                    }, u.appendFrame = function(e, t, n) {
                                        if (null !== this.basePTS) return o.appendFrame(e, t, n, this.basePTS, this.frameIndex);
                                    }, r;
                                }(r.default);
                                const l = u;
                            },
                            "./src/demux/mp4demuxer.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>u
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./src/types/demuxer.ts"), a1 = n("./src/utils/mp4-tools.ts"), o = n("./src/demux/dummy-demuxed-track.ts"), s1 = /\/emsg[-/]ID3/i;
                                const u = function() {
                                    function e(e, t) {
                                        this.remainderData = null, this.timeOffset = 0, this.config = void 0, this.videoTrack = void 0, this.audioTrack = void 0, this.id3Track = void 0, this.txtTrack = void 0, this.config = t;
                                    }
                                    var t = e.prototype;
                                    return t.resetTimeStamp = function() {}, t.resetInitSegment = function(e, t, n, r) {
                                        var i = (0, a1.parseInitSegment)(e), s1 = this.videoTrack = (0, o.dummyTrack)("video", 1), u = this.audioTrack = (0, o.dummyTrack)("audio", 1), l = this.txtTrack = (0, o.dummyTrack)("text", 1);
                                        if (this.id3Track = (0, o.dummyTrack)("id3", 1), this.timeOffset = 0, i.video) {
                                            var c = i.video, d = c.id, f = c.timescale, h = c.codec;
                                            s1.id = d, s1.timescale = l.timescale = f, s1.codec = h;
                                        }
                                        if (i.audio) {
                                            var g = i.audio, p = g.id, m = g.timescale, v = g.codec;
                                            u.id = p, u.timescale = m, u.codec = v;
                                        }
                                        l.id = a1.RemuxerTrackIdConfig.text, s1.sampleDuration = 0, s1.duration = u.duration = r;
                                    }, t.resetContiguity = function() {}, e.probe = function(e) {
                                        return e = e.length > 16384 ? e.subarray(0, 16384) : e, (0, a1.findBox)(e, [
                                            "moof"
                                        ]).length > 0;
                                    }, t.demux = function(e, t) {
                                        this.timeOffset = t;
                                        var n = e, r = this.videoTrack, i = this.txtTrack;
                                        if (this.config.progressive) {
                                            this.remainderData && (n = (0, a1.appendUint8Array)(this.remainderData, e));
                                            var o = (0, a1.segmentValidRange)(n);
                                            this.remainderData = o.remainder, r.samples = o.valid || new Uint8Array;
                                        } else r.samples = n;
                                        var s1 = this.extractID3Track(r, t);
                                        return i.samples = (0, a1.parseSamples)(t, r), {
                                            videoTrack: r,
                                            audioTrack: this.audioTrack,
                                            id3Track: s1,
                                            textTrack: this.txtTrack
                                        };
                                    }, t.flush = function() {
                                        var e = this.timeOffset, t = this.videoTrack, n = this.txtTrack;
                                        t.samples = this.remainderData || new Uint8Array, this.remainderData = null;
                                        var r = this.extractID3Track(t, this.timeOffset);
                                        return n.samples = (0, a1.parseSamples)(e, t), {
                                            videoTrack: t,
                                            audioTrack: (0, o.dummyTrack)(),
                                            id3Track: r,
                                            textTrack: (0, o.dummyTrack)()
                                        };
                                    }, t.extractID3Track = function(e, t) {
                                        var n = this.id3Track;
                                        if (e.samples.length) {
                                            var o = (0, a1.findBox)(e.samples, [
                                                "emsg"
                                            ]);
                                            o && o.forEach(function(e) {
                                                var o = (0, a1.parseEmsg)(e);
                                                if (s1.test(o.schemeIdUri)) {
                                                    var u = (0, r.isFiniteNumber)(o.presentationTime) ? o.presentationTime / o.timeScale : t + o.presentationTimeDelta / o.timeScale, l = 4294967295 === o.eventDuration ? Number.POSITIVE_INFINITY : o.eventDuration / o.timeScale;
                                                    l <= .001 && (l = Number.POSITIVE_INFINITY);
                                                    var c = o.payload;
                                                    n.samples.push({
                                                        data: c,
                                                        len: c.byteLength,
                                                        dts: u,
                                                        pts: u,
                                                        type: i.MetadataSchema.emsg,
                                                        duration: l
                                                    });
                                                }
                                            });
                                        }
                                        return n;
                                    }, t.demuxSampleAes = function(e, t, n) {
                                        return Promise.reject(new Error("The MP4 demuxer does not support SAMPLE-AES decryption"));
                                    }, t.destroy = function() {}, e;
                                }();
                            },
                            "./src/demux/mpegaudio.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    appendFrame: ()=>u,
                                    canParse: ()=>f,
                                    isHeader: ()=>d,
                                    isHeaderPattern: ()=>c,
                                    parseHeader: ()=>l,
                                    probe: ()=>h
                                });
                                var r = null, i = [
                                    32,
                                    64,
                                    96,
                                    128,
                                    160,
                                    192,
                                    224,
                                    256,
                                    288,
                                    320,
                                    352,
                                    384,
                                    416,
                                    448,
                                    32,
                                    48,
                                    56,
                                    64,
                                    80,
                                    96,
                                    112,
                                    128,
                                    160,
                                    192,
                                    224,
                                    256,
                                    320,
                                    384,
                                    32,
                                    40,
                                    48,
                                    56,
                                    64,
                                    80,
                                    96,
                                    112,
                                    128,
                                    160,
                                    192,
                                    224,
                                    256,
                                    320,
                                    32,
                                    48,
                                    56,
                                    64,
                                    80,
                                    96,
                                    112,
                                    128,
                                    144,
                                    160,
                                    176,
                                    192,
                                    224,
                                    256,
                                    8,
                                    16,
                                    24,
                                    32,
                                    40,
                                    48,
                                    56,
                                    64,
                                    80,
                                    96,
                                    112,
                                    128,
                                    144,
                                    160
                                ], a1 = [
                                    44100,
                                    48e3,
                                    32e3,
                                    22050,
                                    24e3,
                                    16e3,
                                    11025,
                                    12e3,
                                    8e3
                                ], o = [
                                    [
                                        0,
                                        72,
                                        144,
                                        12
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        72,
                                        144,
                                        12
                                    ],
                                    [
                                        0,
                                        144,
                                        144,
                                        12
                                    ]
                                ], s1 = [
                                    0,
                                    1,
                                    1,
                                    4
                                ];
                                function u(e, t, n, r, i) {
                                    if (!(n + 24 > t.length)) {
                                        var a1 = l(t, n);
                                        if (a1 && n + a1.frameLength <= t.length) {
                                            var o = r + i * (9e4 * a1.samplesPerFrame / a1.sampleRate), s1 = {
                                                unit: t.subarray(n, n + a1.frameLength),
                                                pts: o,
                                                dts: o
                                            };
                                            return e.config = [], e.channelCount = a1.channelCount, e.samplerate = a1.sampleRate, e.samples.push(s1), {
                                                sample: s1,
                                                length: a1.frameLength,
                                                missing: 0
                                            };
                                        }
                                    }
                                }
                                function l(e, t) {
                                    var n = e[t + 1] >> 3 & 3, u = e[t + 1] >> 1 & 3, l = e[t + 2] >> 4 & 15, c = e[t + 2] >> 2 & 3;
                                    if (1 !== n && 0 !== l && 15 !== l && 3 !== c) {
                                        var d = e[t + 2] >> 1 & 1, f = e[t + 3] >> 6, h = 1e3 * i[14 * (3 === n ? 3 - u : 3 === u ? 3 : 4) + l - 1], g = a1[3 * (3 === n ? 0 : 2 === n ? 1 : 2) + c], p = 3 === f ? 1 : 2, m = o[n][u], v = s1[u], y = 8 * m * v, E = Math.floor(m * h / g + d) * v;
                                        if (null === r) {
                                            var T = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
                                            r = T ? parseInt(T[1]) : 0;
                                        }
                                        return !!r && r <= 87 && 2 === u && h >= 224e3 && 0 === f && (e[t + 3] = 128 | e[t + 3]), {
                                            sampleRate: g,
                                            channelCount: p,
                                            frameLength: E,
                                            samplesPerFrame: y
                                        };
                                    }
                                }
                                function c(e, t) {
                                    return 255 === e[t] && 224 == (224 & e[t + 1]) && 0 != (6 & e[t + 1]);
                                }
                                function d(e, t) {
                                    return t + 1 < e.length && c(e, t);
                                }
                                function f(e, t) {
                                    return c(e, t) && 4 <= e.length - t;
                                }
                                function h(e, t) {
                                    if (t + 1 < e.length && c(e, t)) {
                                        var n = l(e, t), r = 4;
                                        null != n && n.frameLength && (r = n.frameLength);
                                        var i = t + r;
                                        return i === e.length || d(e, i);
                                    }
                                    return !1;
                                }
                            },
                            "./src/demux/sample-aes.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>a1
                                });
                                var r = n("./src/crypt/decrypter.ts"), i = n("./src/utils/mp4-tools.ts");
                                const a1 = function() {
                                    function e(e, t, n) {
                                        this.keyData = void 0, this.decrypter = void 0, this.keyData = n, this.decrypter = new r.default(e, t, {
                                            removePKCS7Padding: !1
                                        });
                                    }
                                    var t = e.prototype;
                                    return t.decryptBuffer = function(e, t) {
                                        this.decrypter.decrypt(e, this.keyData.key.buffer, this.keyData.iv.buffer, t);
                                    }, t.decryptAacSample = function(e, t, n, r) {
                                        var i = e[t].unit;
                                        if (!(i.length <= 16)) {
                                            var a1 = i.subarray(16, i.length - i.length % 16), o = a1.buffer.slice(a1.byteOffset, a1.byteOffset + a1.length), s1 = this;
                                            this.decryptBuffer(o, function(a1) {
                                                var o = new Uint8Array(a1);
                                                i.set(o, 16), r || s1.decryptAacSamples(e, t + 1, n);
                                            });
                                        }
                                    }, t.decryptAacSamples = function(e, t, n) {
                                        for(;; t++){
                                            if (t >= e.length) return void n();
                                            if (!(e[t].unit.length < 32)) {
                                                var r = this.decrypter.isSync();
                                                if (this.decryptAacSample(e, t, n, r), !r) return;
                                            }
                                        }
                                    }, t.getAvcEncryptedData = function(e) {
                                        for(var t = 16 * Math.floor((e.length - 48) / 160) + 16, n = new Int8Array(t), r = 0, i = 32; i < e.length - 16; i += 160, r += 16)n.set(e.subarray(i, i + 16), r);
                                        return n;
                                    }, t.getAvcDecryptedUnit = function(e, t) {
                                        for(var n = new Uint8Array(t), r = 0, i = 32; i < e.length - 16; i += 160, r += 16)e.set(n.subarray(r, r + 16), i);
                                        return e;
                                    }, t.decryptAvcSample = function(e, t, n, r, a1, o) {
                                        var s1 = (0, i.discardEPB)(a1.data), u = this.getAvcEncryptedData(s1), l = this;
                                        this.decryptBuffer(u.buffer, function(i) {
                                            a1.data = l.getAvcDecryptedUnit(s1, i), o || l.decryptAvcSamples(e, t, n + 1, r);
                                        });
                                    }, t.decryptAvcSamples = function(e, t, n, r) {
                                        if (e instanceof Uint8Array) throw new Error("Cannot decrypt samples of type Uint8Array");
                                        for(;; t++, n = 0){
                                            if (t >= e.length) return void r();
                                            for(var i = e[t].units; !(n >= i.length); n++){
                                                var a1 = i[n];
                                                if (!(a1.data.length <= 48 || 1 !== a1.type && 5 !== a1.type)) {
                                                    var o = this.decrypter.isSync();
                                                    if (this.decryptAvcSample(e, t, n, r, a1, o), !o) return;
                                                }
                                            }
                                        }
                                    }, e;
                                }();
                            },
                            "./src/demux/transmuxer-interface.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>d
                                });
                                var r = n("./src/demux/webworkify-webpack.js"), i = n("./src/events.ts"), a1 = n("./src/demux/transmuxer.ts"), o = n("./src/utils/logger.ts"), s1 = n("./src/errors.ts"), u = n("./src/utils/mediasource-helper.ts"), l = n("./node_modules/eventemitter3/index.js"), c = (0, u.getMediaSource)() || {
                                    isTypeSupported: function() {
                                        return !1;
                                    }
                                }, d = function() {
                                    function e(e, t, n, u) {
                                        var d = this;
                                        this.hls = void 0, this.id = void 0, this.observer = void 0, this.frag = null, this.part = null, this.useWorker = void 0, this.worker = void 0, this.onwmsg = void 0, this.transmuxer = null, this.onTransmuxComplete = void 0, this.onFlush = void 0;
                                        var f = e.config;
                                        this.hls = e, this.id = t, this.useWorker = !!f.enableWorker, this.onTransmuxComplete = n, this.onFlush = u;
                                        var h = function(e, t) {
                                            (t = t || {}).frag = d.frag, t.id = d.id, d.hls.trigger(e, t);
                                        };
                                        this.observer = new l.EventEmitter, this.observer.on(i.Events.FRAG_DECRYPTED, h), this.observer.on(i.Events.ERROR, h);
                                        var g = {
                                            mp4: c.isTypeSupported("video/mp4"),
                                            mpeg: c.isTypeSupported("audio/mpeg"),
                                            mp3: c.isTypeSupported('audio/mp4; codecs="mp3"')
                                        }, p = navigator.vendor;
                                        if (this.useWorker && "undefined" != typeof Worker) {
                                            var m;
                                            o.logger.log("demuxing in webworker");
                                            try {
                                                m = this.worker = (0, r.default)("./src/demux/transmuxer-worker.ts"), this.onwmsg = this.onWorkerMessage.bind(this), m.addEventListener("message", this.onwmsg), m.onerror = function(e) {
                                                    d.useWorker = !1, o.logger.warn("Exception in webworker, fallback to inline"), d.hls.trigger(i.Events.ERROR, {
                                                        type: s1.ErrorTypes.OTHER_ERROR,
                                                        details: s1.ErrorDetails.INTERNAL_EXCEPTION,
                                                        fatal: !1,
                                                        event: "demuxerWorker",
                                                        error: new Error(e.message + "  (" + e.filename + ":" + e.lineno + ")")
                                                    });
                                                }, m.postMessage({
                                                    cmd: "init",
                                                    typeSupported: g,
                                                    vendor: p,
                                                    id: t,
                                                    config: JSON.stringify(f)
                                                });
                                            } catch (e) {
                                                o.logger.warn("Error in worker:", e), o.logger.error("Error while initializing DemuxerWorker, fallback to inline"), m && self.URL.revokeObjectURL(m.objectURL), this.transmuxer = new a1.default(this.observer, g, f, p, t), this.worker = null;
                                            }
                                        } else this.transmuxer = new a1.default(this.observer, g, f, p, t);
                                    }
                                    var t = e.prototype;
                                    return t.destroy = function() {
                                        var e = this.worker;
                                        if (e) e.removeEventListener("message", this.onwmsg), e.terminate(), this.worker = null, this.onwmsg = void 0;
                                        else {
                                            var t = this.transmuxer;
                                            t && (t.destroy(), this.transmuxer = null);
                                        }
                                        var n = this.observer;
                                        n && n.removeAllListeners(), this.frag = null, this.observer = null, this.hls = null;
                                    }, t.push = function(e, t, n, r, i, s1, u, l, c, d) {
                                        var f, h, g = this;
                                        c.transmuxing.start = self.performance.now();
                                        var p = this.transmuxer, m = this.worker, v = s1 ? s1.start : i.start, y = i.decryptdata, E = this.frag, T = !(E && i.cc === E.cc), b = !(E && c.level === E.level), A = E ? c.sn - E.sn : -1, _ = this.part ? c.part - this.part.index : -1, S = 0 === A && c.id > 1 && c.id === (null == E ? void 0 : E.stats.chunkCount), w = !b && (1 === A || 0 === A && (1 === _ || S && _ <= 0)), I = self.performance.now();
                                        (b || A || 0 === i.stats.parsing.start) && (i.stats.parsing.start = I), !s1 || !_ && w || (s1.stats.parsing.start = I);
                                        var R = !(E && (null === (f = i.initSegment) || void 0 === f ? void 0 : f.url) === (null === (h = E.initSegment) || void 0 === h ? void 0 : h.url)), C = new a1.TransmuxState(T, w, l, b, v, R);
                                        if (!w || T || R) {
                                            o.logger.log("[transmuxer-interface, " + i.type + "]: Starting new transmux session for sn: " + c.sn + " p: " + c.part + " level: " + c.level + " id: " + c.id + "\n        discontinuity: " + T + "\n        trackSwitch: " + b + "\n        contiguous: " + w + "\n        accurateTimeOffset: " + l + "\n        timeOffset: " + v + "\n        initSegmentChange: " + R);
                                            var D = new a1.TransmuxConfig(n, r, t, u, d);
                                            this.configureTransmuxer(D);
                                        }
                                        if (this.frag = i, this.part = s1, m) m.postMessage({
                                            cmd: "demux",
                                            data: e,
                                            decryptdata: y,
                                            chunkMeta: c,
                                            state: C
                                        }, e instanceof ArrayBuffer ? [
                                            e
                                        ] : []);
                                        else if (p) {
                                            var k = p.push(e, y, c, C);
                                            (0, a1.isPromise)(k) ? k.then(function(e) {
                                                g.handleTransmuxComplete(e);
                                            }) : this.handleTransmuxComplete(k);
                                        }
                                    }, t.flush = function(e) {
                                        var t = this;
                                        e.transmuxing.start = self.performance.now();
                                        var n = this.transmuxer, r = this.worker;
                                        if (r) r.postMessage({
                                            cmd: "flush",
                                            chunkMeta: e
                                        });
                                        else if (n) {
                                            var i = n.flush(e);
                                            (0, a1.isPromise)(i) ? i.then(function(n) {
                                                t.handleFlushResult(n, e);
                                            }) : this.handleFlushResult(i, e);
                                        }
                                    }, t.handleFlushResult = function(e, t) {
                                        var n = this;
                                        e.forEach(function(e) {
                                            n.handleTransmuxComplete(e);
                                        }), this.onFlush(t);
                                    }, t.onWorkerMessage = function(e) {
                                        var t = e.data, n = this.hls;
                                        switch(t.event){
                                            case "init":
                                                self.URL.revokeObjectURL(this.worker.objectURL);
                                                break;
                                            case "transmuxComplete":
                                                this.handleTransmuxComplete(t.data);
                                                break;
                                            case "flush":
                                                this.onFlush(t.data);
                                                break;
                                            case "workerLog":
                                                o.logger[t.data.logType] && o.logger[t.data.logType](t.data.message);
                                                break;
                                            default:
                                                t.data = t.data || {}, t.data.frag = this.frag, t.data.id = this.id, n.trigger(t.event, t.data);
                                        }
                                    }, t.configureTransmuxer = function(e) {
                                        var t = this.worker, n = this.transmuxer;
                                        t ? t.postMessage({
                                            cmd: "configure",
                                            config: e
                                        }) : n && n.configure(e);
                                    }, t.handleTransmuxComplete = function(e) {
                                        e.chunkMeta.transmuxing.end = self.performance.now(), this.onTransmuxComplete(e);
                                    }, e;
                                }();
                            },
                            "./src/demux/transmuxer-worker.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>s1
                                });
                                var r = n("./src/demux/transmuxer.ts"), i = n("./src/events.ts"), a1 = n("./src/utils/logger.ts"), o = n("./node_modules/eventemitter3/index.js");
                                function s1(e) {
                                    var t = new o.EventEmitter, n = function(t, n) {
                                        e.postMessage({
                                            event: t,
                                            data: n
                                        });
                                    };
                                    t.on(i.Events.FRAG_DECRYPTED, n), t.on(i.Events.ERROR, n), e.addEventListener("message", function(i) {
                                        var o = i.data;
                                        switch(o.cmd){
                                            case "init":
                                                var s1 = JSON.parse(o.config);
                                                e.transmuxer = new r.default(t, o.typeSupported, s1, o.vendor, o.id), (0, a1.enableLogs)(s1.debug, o.id), function() {
                                                    var e = function(e) {
                                                        a1.logger[e] = function(t) {
                                                            n("workerLog", {
                                                                logType: e,
                                                                message: t
                                                            });
                                                        };
                                                    };
                                                    for(var t in a1.logger)e(t);
                                                }(), n("init", null);
                                                break;
                                            case "configure":
                                                e.transmuxer.configure(o.config);
                                                break;
                                            case "demux":
                                                var l = e.transmuxer.push(o.data, o.decryptdata, o.chunkMeta, o.state);
                                                (0, r.isPromise)(l) ? l.then(function(t) {
                                                    u(e, t);
                                                }) : u(e, l);
                                                break;
                                            case "flush":
                                                var d = o.chunkMeta, f = e.transmuxer.flush(d);
                                                (0, r.isPromise)(f) ? f.then(function(t) {
                                                    c(e, t, d);
                                                }) : c(e, f, d);
                                        }
                                    });
                                }
                                function u(e, t) {
                                    if (!((n = t.remuxResult).audio || n.video || n.text || n.id3 || n.initSegment)) return !1;
                                    var n, r = [], i = t.remuxResult, a1 = i.audio, o = i.video;
                                    return a1 && l(r, a1), o && l(r, o), e.postMessage({
                                        event: "transmuxComplete",
                                        data: t
                                    }, r), !0;
                                }
                                function l(e, t) {
                                    t.data1 && e.push(t.data1.buffer), t.data2 && e.push(t.data2.buffer);
                                }
                                function c(e, t, n) {
                                    t.reduce(function(t, n) {
                                        return u(e, n) || t;
                                    }, !1) || e.postMessage({
                                        event: "transmuxComplete",
                                        data: t[0]
                                    }), e.postMessage({
                                        event: "flush",
                                        data: n
                                    });
                                }
                            },
                            "./src/demux/transmuxer.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    TransmuxConfig: ()=>y,
                                    TransmuxState: ()=>E,
                                    default: ()=>p,
                                    isPromise: ()=>v
                                });
                                var r, i = n("./src/events.ts"), a1 = n("./src/errors.ts"), o = n("./src/crypt/decrypter.ts"), s1 = n("./src/demux/aacdemuxer.ts"), u = n("./src/demux/mp4demuxer.ts"), l = n("./src/demux/tsdemuxer.ts"), c = n("./src/demux/mp3demuxer.ts"), d = n("./src/remux/mp4-remuxer.ts"), f = n("./src/remux/passthrough-remuxer.ts"), h = n("./src/utils/logger.ts");
                                try {
                                    r = self.performance.now.bind(self.performance);
                                } catch (e) {
                                    h.logger.debug("Unable to use Performance API on this environment"), r = self.Date.now;
                                }
                                var g = [
                                    {
                                        demux: l.default,
                                        remux: d.default
                                    },
                                    {
                                        demux: u.default,
                                        remux: f.default
                                    },
                                    {
                                        demux: s1.default,
                                        remux: d.default
                                    },
                                    {
                                        demux: c.default,
                                        remux: d.default
                                    }
                                ], p = function() {
                                    function e(e, t, n, r, i) {
                                        this.observer = void 0, this.typeSupported = void 0, this.config = void 0, this.vendor = void 0, this.id = void 0, this.demuxer = void 0, this.remuxer = void 0, this.decrypter = void 0, this.probe = void 0, this.decryptionPromise = null, this.transmuxConfig = void 0, this.currentTransmuxState = void 0, this.observer = e, this.typeSupported = t, this.config = n, this.vendor = r, this.id = i;
                                    }
                                    var t = e.prototype;
                                    return t.configure = function(e) {
                                        this.transmuxConfig = e, this.decrypter && this.decrypter.reset();
                                    }, t.push = function(e, t, n, i) {
                                        var a1 = this, o = n.transmuxing;
                                        o.executeStart = r();
                                        var s1 = new Uint8Array(e), u = this.config, l = this.currentTransmuxState, c = this.transmuxConfig;
                                        i && (this.currentTransmuxState = i);
                                        var d = i || l, f = d.contiguous, h = d.discontinuity, g = d.trackSwitch, p = d.accurateTimeOffset, v = d.timeOffset, y = d.initSegmentChange, E = c.audioCodec, T = c.videoCodec, b = c.defaultInitPts, A = c.duration, _ = c.initSegmentData;
                                        (h || g || y) && this.resetInitSegment(_, E, T, A), (h || y) && this.resetInitialTimestamp(b), f || this.resetContiguity();
                                        var S = function(e, t) {
                                            var n = null;
                                            return e.byteLength > 0 && null != t && null != t.key && null !== t.iv && null != t.method && (n = t), n;
                                        }(s1, t);
                                        if (S && "AES-128" === S.method) {
                                            var w = this.getDecrypter();
                                            if (!u.enableSoftwareAES) return this.decryptionPromise = w.webCryptoDecrypt(s1, S.key.buffer, S.iv.buffer).then(function(e) {
                                                var t = a1.push(e, null, n);
                                                return a1.decryptionPromise = null, t;
                                            }), this.decryptionPromise;
                                            var I = w.softwareDecrypt(s1, S.key.buffer, S.iv.buffer);
                                            if (!I) return o.executeEnd = r(), m(n);
                                            s1 = new Uint8Array(I);
                                        }
                                        this.needsProbing(s1, h, g) && this.configureTransmuxer(s1, c);
                                        var R = this.transmux(s1, S, v, p, n), C = this.currentTransmuxState;
                                        return C.contiguous = !0, C.discontinuity = !1, C.trackSwitch = !1, o.executeEnd = r(), R;
                                    }, t.flush = function(e) {
                                        var t = this, n = e.transmuxing;
                                        n.executeStart = r();
                                        var o = this.decrypter, s1 = this.currentTransmuxState, u = this.decryptionPromise;
                                        if (u) return u.then(function() {
                                            return t.flush(e);
                                        });
                                        var l = [], c = s1.timeOffset;
                                        if (o) {
                                            var d = o.flush();
                                            d && l.push(this.push(d, null, e));
                                        }
                                        var f = this.demuxer, h = this.remuxer;
                                        if (!f || !h) return this.observer.emit(i.Events.ERROR, i.Events.ERROR, {
                                            type: a1.ErrorTypes.MEDIA_ERROR,
                                            details: a1.ErrorDetails.FRAG_PARSING_ERROR,
                                            fatal: !0,
                                            reason: "no demux matching with content found"
                                        }), n.executeEnd = r(), [
                                            m(e)
                                        ];
                                        var g = f.flush(c);
                                        return v(g) ? g.then(function(n) {
                                            return t.flushRemux(l, n, e), l;
                                        }) : (this.flushRemux(l, g, e), l);
                                    }, t.flushRemux = function(e, t, n) {
                                        var i = t.audioTrack, a1 = t.videoTrack, o = t.id3Track, s1 = t.textTrack, u = this.currentTransmuxState, l = u.accurateTimeOffset, c = u.timeOffset;
                                        h.logger.log("[transmuxer.ts]: Flushed fragment " + n.sn + (n.part > -1 ? " p: " + n.part : "") + " of level " + n.level);
                                        var d = this.remuxer.remux(i, a1, o, s1, c, l, !0, this.id);
                                        e.push({
                                            remuxResult: d,
                                            chunkMeta: n
                                        }), n.transmuxing.executeEnd = r();
                                    }, t.resetInitialTimestamp = function(e) {
                                        var t = this.demuxer, n = this.remuxer;
                                        t && n && (t.resetTimeStamp(e), n.resetTimeStamp(e));
                                    }, t.resetContiguity = function() {
                                        var e = this.demuxer, t = this.remuxer;
                                        e && t && (e.resetContiguity(), t.resetNextTimestamp());
                                    }, t.resetInitSegment = function(e, t, n, r) {
                                        var i = this.demuxer, a1 = this.remuxer;
                                        i && a1 && (i.resetInitSegment(e, t, n, r), a1.resetInitSegment(e, t, n));
                                    }, t.destroy = function() {
                                        this.demuxer && (this.demuxer.destroy(), this.demuxer = void 0), this.remuxer && (this.remuxer.destroy(), this.remuxer = void 0);
                                    }, t.transmux = function(e, t, n, r, i) {
                                        return t && "SAMPLE-AES" === t.method ? this.transmuxSampleAes(e, t, n, r, i) : this.transmuxUnencrypted(e, n, r, i);
                                    }, t.transmuxUnencrypted = function(e, t, n, r) {
                                        var i = this.demuxer.demux(e, t, !1, !this.config.progressive), a1 = i.audioTrack, o = i.videoTrack, s1 = i.id3Track, u = i.textTrack;
                                        return {
                                            remuxResult: this.remuxer.remux(a1, o, s1, u, t, n, !1, this.id),
                                            chunkMeta: r
                                        };
                                    }, t.transmuxSampleAes = function(e, t, n, r, i) {
                                        var a1 = this;
                                        return this.demuxer.demuxSampleAes(e, t, n).then(function(e) {
                                            return {
                                                remuxResult: a1.remuxer.remux(e.audioTrack, e.videoTrack, e.id3Track, e.textTrack, n, r, !1, a1.id),
                                                chunkMeta: i
                                            };
                                        });
                                    }, t.configureTransmuxer = function(e, t) {
                                        for(var n, r = this.config, i = this.observer, a1 = this.typeSupported, o = this.vendor, s1 = t.audioCodec, l = t.defaultInitPts, c = t.duration, d = t.initSegmentData, p = t.videoCodec, m = 0, v = g.length; m < v; m++)if (g[m].demux.probe(e)) {
                                            n = g[m];
                                            break;
                                        }
                                        n || (h.logger.warn("Failed to find demuxer by probing frag, treating as mp4 passthrough"), n = {
                                            demux: u.default,
                                            remux: f.default
                                        });
                                        var y = this.demuxer, E = this.remuxer, T = n.remux, b = n.demux;
                                        E && E instanceof T || (this.remuxer = new T(i, r, a1, o)), y && y instanceof b || (this.demuxer = new b(i, r, a1), this.probe = b.probe), this.resetInitSegment(d, s1, p, c), this.resetInitialTimestamp(l);
                                    }, t.needsProbing = function(e, t, n) {
                                        return !this.demuxer || !this.remuxer || t || n;
                                    }, t.getDecrypter = function() {
                                        var e = this.decrypter;
                                        return e || (e = this.decrypter = new o.default(this.observer, this.config)), e;
                                    }, e;
                                }(), m = function(e) {
                                    return {
                                        remuxResult: {},
                                        chunkMeta: e
                                    };
                                };
                                function v(e) {
                                    return "then" in e && e.then instanceof Function;
                                }
                                var y = function(e, t, n, r, i) {
                                    this.audioCodec = void 0, this.videoCodec = void 0, this.initSegmentData = void 0, this.duration = void 0, this.defaultInitPts = void 0, this.audioCodec = e, this.videoCodec = t, this.initSegmentData = n, this.duration = r, this.defaultInitPts = i;
                                }, E = function(e, t, n, r, i, a1) {
                                    this.discontinuity = void 0, this.contiguous = void 0, this.accurateTimeOffset = void 0, this.trackSwitch = void 0, this.timeOffset = void 0, this.initSegmentChange = void 0, this.discontinuity = e, this.contiguous = t, this.accurateTimeOffset = n, this.trackSwitch = r, this.timeOffset = i, this.initSegmentChange = a1;
                                };
                            },
                            "./src/demux/tsdemuxer.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>E
                                });
                                var r = n("./src/demux/adts.ts"), i = n("./src/demux/mpegaudio.ts"), a1 = n("./src/demux/exp-golomb.ts"), o = n("./src/demux/sample-aes.ts"), s1 = n("./src/events.ts"), u = n("./src/utils/mp4-tools.ts"), l = n("./src/utils/logger.ts"), c = n("./src/errors.ts"), d = n("./src/types/demuxer.ts");
                                function f() {
                                    return f = Object.assign ? Object.assign.bind() : function(e) {
                                        for(var t = 1; t < arguments.length; t++){
                                            var n = arguments[t];
                                            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                                        }
                                        return e;
                                    }, f.apply(this, arguments);
                                }
                                var h = 188;
                                function g(e, t, n, r) {
                                    return {
                                        key: e,
                                        frame: !1,
                                        pts: t,
                                        dts: n,
                                        units: [],
                                        debug: r,
                                        length: 0
                                    };
                                }
                                function p(e, t) {
                                    return (31 & e[t + 10]) << 8 | e[t + 11];
                                }
                                function m(e, t, n, r) {
                                    var i = {
                                        audio: -1,
                                        avc: -1,
                                        id3: -1,
                                        segmentCodec: "aac"
                                    }, a1 = t + 3 + ((15 & e[t + 1]) << 8 | e[t + 2]) - 4;
                                    for(t += 12 + ((15 & e[t + 10]) << 8 | e[t + 11]); t < a1;){
                                        var o = (31 & e[t + 1]) << 8 | e[t + 2];
                                        switch(e[t]){
                                            case 207:
                                                if (!r) {
                                                    l.logger.log("ADTS AAC with AES-128-CBC frame encryption found in unencrypted stream");
                                                    break;
                                                }
                                            case 15:
                                                -1 === i.audio && (i.audio = o);
                                                break;
                                            case 21:
                                                -1 === i.id3 && (i.id3 = o);
                                                break;
                                            case 219:
                                                if (!r) {
                                                    l.logger.log("H.264 with AES-128-CBC slice encryption found in unencrypted stream");
                                                    break;
                                                }
                                            case 27:
                                                -1 === i.avc && (i.avc = o);
                                                break;
                                            case 3:
                                            case 4:
                                                !0 !== n.mpeg && !0 !== n.mp3 ? l.logger.log("MPEG audio found, not supported in this browser") : -1 === i.audio && (i.audio = o, i.segmentCodec = "mp3");
                                                break;
                                            case 36:
                                                l.logger.warn("Unsupported HEVC stream type found");
                                        }
                                        t += 5 + ((15 & e[t + 3]) << 8 | e[t + 4]);
                                    }
                                    return i;
                                }
                                function v(e) {
                                    var t, n, r, i, a1, o = 0, s1 = e.data;
                                    if (!e || 0 === e.size) return null;
                                    for(; s1[0].length < 19 && s1.length > 1;){
                                        var u = new Uint8Array(s1[0].length + s1[1].length);
                                        u.set(s1[0]), u.set(s1[1], s1[0].length), s1[0] = u, s1.splice(1, 1);
                                    }
                                    if (1 === ((t = s1[0])[0] << 16) + (t[1] << 8) + t[2]) {
                                        if ((n = (t[4] << 8) + t[5]) && n > e.size - 6) return null;
                                        var c = t[7];
                                        192 & c && (i = 536870912 * (14 & t[9]) + 4194304 * (255 & t[10]) + 16384 * (254 & t[11]) + 128 * (255 & t[12]) + (254 & t[13]) / 2, 64 & c ? i - (a1 = 536870912 * (14 & t[14]) + 4194304 * (255 & t[15]) + 16384 * (254 & t[16]) + 128 * (255 & t[17]) + (254 & t[18]) / 2) > 54e5 && (l.logger.warn(Math.round((i - a1) / 9e4) + "s delta between PTS and DTS, align them"), i = a1) : a1 = i);
                                        var d = (r = t[8]) + 9;
                                        if (e.size <= d) return null;
                                        e.size -= d;
                                        for(var f = new Uint8Array(e.size), h = 0, g = s1.length; h < g; h++){
                                            var p = (t = s1[h]).byteLength;
                                            if (d) {
                                                if (d > p) {
                                                    d -= p;
                                                    continue;
                                                }
                                                t = t.subarray(d), p -= d, d = 0;
                                            }
                                            f.set(t, o), o += p;
                                        }
                                        return n && (n -= r + 3), {
                                            data: f,
                                            pts: i,
                                            dts: a1,
                                            len: n
                                        };
                                    }
                                    return null;
                                }
                                function y(e, t) {
                                    if (e.units.length && e.frame) {
                                        if (void 0 === e.pts) {
                                            var n = t.samples, r = n.length;
                                            if (!r) return void t.dropped++;
                                            var i = n[r - 1];
                                            e.pts = i.pts, e.dts = i.dts;
                                        }
                                        t.samples.push(e);
                                    }
                                    e.debug.length && l.logger.log(e.pts + "/" + e.dts + ":" + e.debug);
                                }
                                const E = function() {
                                    function e(e, t, n) {
                                        this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.sampleAes = null, this.pmtParsed = !1, this.audioCodec = void 0, this.videoCodec = void 0, this._duration = 0, this._pmtId = -1, this._avcTrack = void 0, this._audioTrack = void 0, this._id3Track = void 0, this._txtTrack = void 0, this.aacOverFlow = null, this.avcSample = null, this.remainderData = null, this.observer = e, this.config = t, this.typeSupported = n;
                                    }
                                    e.probe = function(t) {
                                        var n = e.syncOffset(t);
                                        return n > 0 && l.logger.warn("MPEG2-TS detected but first sync word found @ offset " + n), -1 !== n;
                                    }, e.syncOffset = function(e) {
                                        for(var t = Math.min(940, e.length - 376) + 1, n = 0; n < t;){
                                            if (71 === e[n] && 71 === e[n + h]) return n;
                                            n++;
                                        }
                                        return -1;
                                    }, e.createTrack = function(e, t) {
                                        return {
                                            container: "video" === e || "audio" === e ? "video/mp2t" : void 0,
                                            type: e,
                                            id: u.RemuxerTrackIdConfig[e],
                                            pid: -1,
                                            inputTimeScale: 9e4,
                                            sequenceNumber: 0,
                                            samples: [],
                                            dropped: 0,
                                            duration: "audio" === e ? t : void 0
                                        };
                                    };
                                    var t = e.prototype;
                                    return t.resetInitSegment = function(t, n, r, i) {
                                        this.pmtParsed = !1, this._pmtId = -1, this._avcTrack = e.createTrack("video"), this._audioTrack = e.createTrack("audio", i), this._id3Track = e.createTrack("id3"), this._txtTrack = e.createTrack("text"), this._audioTrack.segmentCodec = "aac", this.aacOverFlow = null, this.avcSample = null, this.remainderData = null, this.audioCodec = n, this.videoCodec = r, this._duration = i;
                                    }, t.resetTimeStamp = function() {}, t.resetContiguity = function() {
                                        var e = this._audioTrack, t = this._avcTrack, n = this._id3Track;
                                        e && (e.pesData = null), t && (t.pesData = null), n && (n.pesData = null), this.aacOverFlow = null, this.avcSample = null, this.remainderData = null;
                                    }, t.demux = function(t, n, r, i) {
                                        var a1;
                                        void 0 === r && (r = !1), void 0 === i && (i = !1), r || (this.sampleAes = null);
                                        var o = this._avcTrack, d = this._audioTrack, f = this._id3Track, g = this._txtTrack, y = o.pid, E = o.pesData, T = d.pid, b = f.pid, A = d.pesData, _ = f.pesData, S = null, w = this.pmtParsed, I = this._pmtId, R = t.length;
                                        if (this.remainderData && (R = (t = (0, u.appendUint8Array)(this.remainderData, t)).length, this.remainderData = null), R < h && !i) return this.remainderData = t, {
                                            audioTrack: d,
                                            videoTrack: o,
                                            id3Track: f,
                                            textTrack: g
                                        };
                                        var C = Math.max(0, e.syncOffset(t));
                                        (R -= (R - C) % h) < t.byteLength && !i && (this.remainderData = new Uint8Array(t.buffer, R, t.buffer.byteLength - R));
                                        for(var D = 0, k = C; k < R; k += h)if (71 === t[k]) {
                                            var N = !!(64 & t[k + 1]), L = ((31 & t[k + 1]) << 8) + t[k + 2], x = void 0;
                                            if ((48 & t[k + 3]) >> 4 > 1) {
                                                if ((x = k + 5 + t[k + 4]) === k + h) continue;
                                            } else x = k + 4;
                                            switch(L){
                                                case y:
                                                    N && (E && (a1 = v(E)) && this.parseAVCPES(o, g, a1, !1), E = {
                                                        data: [],
                                                        size: 0
                                                    }), E && (E.data.push(t.subarray(x, k + h)), E.size += k + h - x);
                                                    break;
                                                case T:
                                                    if (N) {
                                                        if (A && (a1 = v(A))) switch(d.segmentCodec){
                                                            case "aac":
                                                                this.parseAACPES(d, a1);
                                                                break;
                                                            case "mp3":
                                                                this.parseMPEGPES(d, a1);
                                                        }
                                                        A = {
                                                            data: [],
                                                            size: 0
                                                        };
                                                    }
                                                    A && (A.data.push(t.subarray(x, k + h)), A.size += k + h - x);
                                                    break;
                                                case b:
                                                    N && (_ && (a1 = v(_)) && this.parseID3PES(f, a1), _ = {
                                                        data: [],
                                                        size: 0
                                                    }), _ && (_.data.push(t.subarray(x, k + h)), _.size += k + h - x);
                                                    break;
                                                case 0:
                                                    N && (x += t[x] + 1), I = this._pmtId = p(t, x);
                                                    break;
                                                case I:
                                                    N && (x += t[x] + 1);
                                                    var M = m(t, x, this.typeSupported, r);
                                                    (y = M.avc) > 0 && (o.pid = y), (T = M.audio) > 0 && (d.pid = T, d.segmentCodec = M.segmentCodec), (b = M.id3) > 0 && (f.pid = b), null === S || w || (l.logger.log("unknown PID '" + S + "' in TS found"), S = null, k = C - 188), w = this.pmtParsed = !0;
                                                    break;
                                                case 17:
                                                case 8191:
                                                    break;
                                                default:
                                                    S = L;
                                            }
                                        } else D++;
                                        D > 0 && this.observer.emit(s1.Events.ERROR, s1.Events.ERROR, {
                                            type: c.ErrorTypes.MEDIA_ERROR,
                                            details: c.ErrorDetails.FRAG_PARSING_ERROR,
                                            fatal: !1,
                                            reason: "Found " + D + " TS packet/s that do not start with 0x47"
                                        }), o.pesData = E, d.pesData = A, f.pesData = _;
                                        var O = {
                                            audioTrack: d,
                                            videoTrack: o,
                                            id3Track: f,
                                            textTrack: g
                                        };
                                        return i && this.extractRemainingSamples(O), O;
                                    }, t.flush = function() {
                                        var e, t = this.remainderData;
                                        return this.remainderData = null, e = t ? this.demux(t, -1, !1, !0) : {
                                            videoTrack: this._avcTrack,
                                            audioTrack: this._audioTrack,
                                            id3Track: this._id3Track,
                                            textTrack: this._txtTrack
                                        }, this.extractRemainingSamples(e), this.sampleAes ? this.decrypt(e, this.sampleAes) : e;
                                    }, t.extractRemainingSamples = function(e) {
                                        var t, n = e.audioTrack, r = e.videoTrack, i = e.id3Track, a1 = e.textTrack, o = r.pesData, s1 = n.pesData, u = i.pesData;
                                        if (o && (t = v(o)) ? (this.parseAVCPES(r, a1, t, !0), r.pesData = null) : r.pesData = o, s1 && (t = v(s1))) {
                                            switch(n.segmentCodec){
                                                case "aac":
                                                    this.parseAACPES(n, t);
                                                    break;
                                                case "mp3":
                                                    this.parseMPEGPES(n, t);
                                            }
                                            n.pesData = null;
                                        } else null != s1 && s1.size && l.logger.log("last AAC PES packet truncated,might overlap between fragments"), n.pesData = s1;
                                        u && (t = v(u)) ? (this.parseID3PES(i, t), i.pesData = null) : i.pesData = u;
                                    }, t.demuxSampleAes = function(e, t, n) {
                                        var r = this.demux(e, n, !0, !this.config.progressive), i = this.sampleAes = new o.default(this.observer, this.config, t);
                                        return this.decrypt(r, i);
                                    }, t.decrypt = function(e, t) {
                                        return new Promise(function(n) {
                                            var r = e.audioTrack, i = e.videoTrack;
                                            r.samples && "aac" === r.segmentCodec ? t.decryptAacSamples(r.samples, 0, function() {
                                                i.samples ? t.decryptAvcSamples(i.samples, 0, 0, function() {
                                                    n(e);
                                                }) : n(e);
                                            }) : i.samples && t.decryptAvcSamples(i.samples, 0, 0, function() {
                                                n(e);
                                            });
                                        });
                                    }, t.destroy = function() {
                                        this._duration = 0;
                                    }, t.parseAVCPES = function(e, t, n, r) {
                                        var i, o = this, s1 = this.parseAVCNALu(e, n.data), l = this.avcSample, c = !1;
                                        n.data = null, l && s1.length && !e.audFound && (y(l, e), l = this.avcSample = g(!1, n.pts, n.dts, "")), s1.forEach(function(r) {
                                            switch(r.type){
                                                case 1:
                                                    i = !0, l || (l = o.avcSample = g(!0, n.pts, n.dts, "")), l.frame = !0;
                                                    var s1 = r.data;
                                                    if (c && s1.length > 4) {
                                                        var d = new a1.default(s1).readSliceType();
                                                        2 !== d && 4 !== d && 7 !== d && 9 !== d || (l.key = !0);
                                                    }
                                                    break;
                                                case 5:
                                                    i = !0, l || (l = o.avcSample = g(!0, n.pts, n.dts, "")), l.key = !0, l.frame = !0;
                                                    break;
                                                case 6:
                                                    i = !0, (0, u.parseSEIMessageFromNALu)(r.data, 1, n.pts, t.samples);
                                                    break;
                                                case 7:
                                                    if (i = !0, c = !0, !e.sps) {
                                                        var f = new a1.default(r.data).readSPS();
                                                        e.width = f.width, e.height = f.height, e.pixelRatio = f.pixelRatio, e.sps = [
                                                            r.data
                                                        ], e.duration = o._duration;
                                                        for(var h = r.data.subarray(1, 4), p = "avc1.", m = 0; m < 3; m++){
                                                            var v = h[m].toString(16);
                                                            v.length < 2 && (v = "0" + v), p += v;
                                                        }
                                                        e.codec = p;
                                                    }
                                                    break;
                                                case 8:
                                                    i = !0, e.pps || (e.pps = [
                                                        r.data
                                                    ]);
                                                    break;
                                                case 9:
                                                    i = !1, e.audFound = !0, l && y(l, e), l = o.avcSample = g(!1, n.pts, n.dts, "");
                                                    break;
                                                case 12:
                                                    i = !0;
                                                    break;
                                                default:
                                                    i = !1, l && (l.debug += "unknown NAL " + r.type + " ");
                                            }
                                            l && i && l.units.push(r);
                                        }), r && l && (y(l, e), this.avcSample = null);
                                    }, t.getLastNalUnit = function(e) {
                                        var t, n, r = this.avcSample;
                                        if (r && 0 !== r.units.length || (r = e[e.length - 1]), null !== (t = r) && void 0 !== t && t.units) {
                                            var i = r.units;
                                            n = i[i.length - 1];
                                        }
                                        return n;
                                    }, t.parseAVCNALu = function(e, t) {
                                        var n, r, i = t.byteLength, a1 = e.naluState || 0, o = a1, s1 = [], u = 0, l = -1, c = 0;
                                        for(-1 === a1 && (l = 0, c = 31 & t[0], a1 = 0, u = 1); u < i;)if (n = t[u++], a1) {
                                            if (1 !== a1) {
                                                if (n) {
                                                    if (1 === n) {
                                                        if (l >= 0) {
                                                            var d = {
                                                                data: t.subarray(l, u - a1 - 1),
                                                                type: c
                                                            };
                                                            s1.push(d);
                                                        } else {
                                                            var f = this.getLastNalUnit(e.samples);
                                                            if (f && (o && u <= 4 - o && f.state && (f.data = f.data.subarray(0, f.data.byteLength - o)), (r = u - a1 - 1) > 0)) {
                                                                var h = new Uint8Array(f.data.byteLength + r);
                                                                h.set(f.data, 0), h.set(t.subarray(0, r), f.data.byteLength), f.data = h, f.state = 0;
                                                            }
                                                        }
                                                        u < i ? (l = u, c = 31 & t[u], a1 = 0) : a1 = -1;
                                                    } else a1 = 0;
                                                } else a1 = 3;
                                            } else a1 = n ? 0 : 2;
                                        } else a1 = n ? 0 : 1;
                                        if (l >= 0 && a1 >= 0) {
                                            var g = {
                                                data: t.subarray(l, i),
                                                type: c,
                                                state: a1
                                            };
                                            s1.push(g);
                                        }
                                        if (0 === s1.length) {
                                            var p = this.getLastNalUnit(e.samples);
                                            if (p) {
                                                var m = new Uint8Array(p.data.byteLength + t.byteLength);
                                                m.set(p.data, 0), m.set(t, p.data.byteLength), p.data = m;
                                            }
                                        }
                                        return e.naluState = a1, s1;
                                    }, t.parseAACPES = function(e, t) {
                                        var n, i, a1, o, u, d = 0, f = this.aacOverFlow, h = t.data;
                                        if (f) {
                                            this.aacOverFlow = null;
                                            var g = f.missing, p = f.sample.unit.byteLength;
                                            if (-1 === g) {
                                                var m = new Uint8Array(p + h.byteLength);
                                                m.set(f.sample.unit, 0), m.set(h, p), h = m;
                                            } else {
                                                var v = p - g;
                                                f.sample.unit.set(h.subarray(0, g), v), e.samples.push(f.sample), d = f.missing;
                                            }
                                        }
                                        for(n = d, i = h.length; n < i - 1 && !r.isHeader(h, n); n++);
                                        if (n === d || (n < i - 1 ? (a1 = "AAC PES did not start with ADTS header,offset:" + n, o = !1) : (a1 = "no ADTS header found in AAC PES", o = !0), l.logger.warn("parsing error:" + a1), this.observer.emit(s1.Events.ERROR, s1.Events.ERROR, {
                                            type: c.ErrorTypes.MEDIA_ERROR,
                                            details: c.ErrorDetails.FRAG_PARSING_ERROR,
                                            fatal: o,
                                            reason: a1
                                        }), !o)) {
                                            if (r.initTrackConfig(e, this.observer, h, n, this.audioCodec), void 0 !== t.pts) u = t.pts;
                                            else {
                                                if (!f) return void l.logger.warn("[tsdemuxer]: AAC PES unknown PTS");
                                                var y = r.getFrameDuration(e.samplerate);
                                                u = f.sample.pts + y;
                                            }
                                            for(var E, T = 0; n < i;){
                                                if (n += (E = r.appendFrame(e, h, n, u, T)).length, E.missing) {
                                                    this.aacOverFlow = E;
                                                    break;
                                                }
                                                for(T++; n < i - 1 && !r.isHeader(h, n); n++);
                                            }
                                        }
                                    }, t.parseMPEGPES = function(e, t) {
                                        var n = t.data, r = n.length, a1 = 0, o = 0, s1 = t.pts;
                                        if (void 0 !== s1) for(; o < r;)if (i.isHeader(n, o)) {
                                            var u = i.appendFrame(e, n, o, s1, a1);
                                            if (!u) break;
                                            o += u.length, a1++;
                                        } else o++;
                                        else l.logger.warn("[tsdemuxer]: MPEG PES unknown PTS");
                                    }, t.parseID3PES = function(e, t) {
                                        if (void 0 !== t.pts) {
                                            var n = f({}, t, {
                                                type: this._avcTrack ? d.MetadataSchema.emsg : d.MetadataSchema.audioId3,
                                                duration: Number.POSITIVE_INFINITY
                                            });
                                            e.samples.push(n);
                                        } else l.logger.warn("[tsdemuxer]: ID3 PES unknown PTS");
                                    }, e;
                                }();
                            },
                            "./src/demux/webworkify-webpack.js": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>l
                                });
                                var r = function() {
                                    var e = ENTRY_MODULE, t = {};
                                    function n(r) {
                                        var i = t[r];
                                        if (void 0 !== i) return i.exports;
                                        var a1 = t[r] = {
                                            exports: {}
                                        };
                                        return e[r].call(a1.exports, a1, a1.exports, n), a1.exports;
                                    }
                                    n.m = e, n.n = function(e) {
                                        var t = e && e.__esModule ? function() {
                                            return e.default;
                                        } : function() {
                                            return e;
                                        };
                                        return n.d(t, {
                                            a: t
                                        }), t;
                                    }, n.d = function(e, t) {
                                        for(var r in t)n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
                                            enumerable: !0,
                                            get: t[r]
                                        });
                                    }, n.o = function(e, t) {
                                        return Object.prototype.hasOwnProperty.call(e, t);
                                    }, n.r = function(e) {
                                        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                                            value: "Module"
                                        }), Object.defineProperty(e, "__esModule", {
                                            value: !0
                                        });
                                    };
                                    var r = n(ENTRY_MODULE);
                                    return r.default || r;
                                };
                                r.toString();
                                var i = "\\(\\s*(/\\*.*?\\*/)?\\s*.*?([\\.|\\-|\\+|\\w|/|@]+).*?\\)";
                                function a1(e) {
                                    return (e + "").replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
                                }
                                function o(e, t, r) {
                                    var o = {};
                                    o[r] = [];
                                    var s1, u = t.toString(), l = u.match(/^function\s?\w*\(\w+,\s*\w+,\s*(\w+)\)/) || u.match(/^\(\w+,\s*\w+,\s*(\w+)\)\s?\=\s?\>/);
                                    if (!l) return o;
                                    for(var c, d = l[1], f = new RegExp("(\\\\n|\\W)" + a1(d) + i, "g"); c = f.exec(u);)"dll-reference" !== c[3] && o[r].push(c[3]);
                                    for(f = new RegExp("\\(" + a1(d) + '\\("(dll-reference\\s([\\.|\\-|\\+|\\w|/|@]+))"\\)\\)' + i, "g"); c = f.exec(u);)e[c[2]] || (o[r].push(c[1]), e[c[2]] = n(c[1]).m), o[c[2]] = o[c[2]] || [], o[c[2]].push(c[4]);
                                    for(var h = Object.keys(o), g = 0; g < h.length; g++)for(var p = 0; p < o[h[g]].length; p++)s1 = o[h[g]][p], !isNaN(1 * s1) && (o[h[g]][p] = 1 * o[h[g]][p]);
                                    return o;
                                }
                                function s1(e) {
                                    return Object.keys(e).reduce(function(t, n) {
                                        return t || e[n].length > 0;
                                    }, !1);
                                }
                                function u(e, t, n, i) {
                                    var a1 = e[i].map(function(e) {
                                        return '"' + e + '": ' + t[i][e].toString();
                                    }).join(","), o = r.toString().split("ENTRY_MODULE");
                                    return o[0] + "{" + a1 + "}" + o[1] + '"' + n + '"' + o[2];
                                }
                                function l(e, t) {
                                    t = t || {};
                                    var r = {
                                        main: n.m
                                    }, i = t.all ? {
                                        main: Object.keys(r.main)
                                    } : function(e, t) {
                                        for(var n = {
                                            main: [
                                                t
                                            ]
                                        }, r = {
                                            main: []
                                        }, i = {
                                            main: {}
                                        }; s1(n);)for(var a1 = Object.keys(n), u = 0; u < a1.length; u++){
                                            var l = a1[u], c = n[l].pop();
                                            if (i[l] = i[l] || {}, !i[l][c] && e[l][c]) {
                                                i[l][c] = !0, r[l] = r[l] || [], r[l].push(c);
                                                for(var d = o(e, e[l][c], l), f = Object.keys(d), h = 0; h < f.length; h++)n[f[h]] = n[f[h]] || [], n[f[h]] = n[f[h]].concat(d[f[h]]);
                                            }
                                        }
                                        return r;
                                    }(r, e), a1 = "";
                                    Object.keys(i).filter(function(e) {
                                        return "main" !== e;
                                    }).forEach(function(e) {
                                        for(var t = 0; i[e][t];)t++;
                                        i[e].push(t), r[e][t] = "(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })", a1 = a1 + "var " + e + " = (" + u(i, r, t, modules) + ")();\n";
                                    }), a1 = a1 + "((" + u(i, r, e, "main") + ")())(self);";
                                    var l = new window.Blob([
                                        a1
                                    ], {
                                        type: "text/javascript"
                                    }), c = (window.URL || window.webkitURL || window.mozURL || window.msURL).createObjectURL(l), d = new window.Worker(c);
                                    return d.objectURL = c, d;
                                }
                            },
                            "./src/errors.ts": (e, t, n)=>{
                                "use strict";
                                var r, i;
                                n.r(t), n.d(t, {
                                    ErrorDetails: ()=>i,
                                    ErrorTypes: ()=>r
                                }), function(e) {
                                    e.NETWORK_ERROR = "networkError", e.MEDIA_ERROR = "mediaError", e.KEY_SYSTEM_ERROR = "keySystemError", e.MUX_ERROR = "muxError", e.OTHER_ERROR = "otherError";
                                }(r || (r = {})), function(e) {
                                    e.KEY_SYSTEM_NO_KEYS = "keySystemNoKeys", e.KEY_SYSTEM_NO_ACCESS = "keySystemNoAccess", e.KEY_SYSTEM_NO_SESSION = "keySystemNoSession", e.KEY_SYSTEM_LICENSE_REQUEST_FAILED = "keySystemLicenseRequestFailed", e.KEY_SYSTEM_NO_INIT_DATA = "keySystemNoInitData", e.MANIFEST_LOAD_ERROR = "manifestLoadError", e.MANIFEST_LOAD_TIMEOUT = "manifestLoadTimeOut", e.MANIFEST_PARSING_ERROR = "manifestParsingError", e.MANIFEST_INCOMPATIBLE_CODECS_ERROR = "manifestIncompatibleCodecsError", e.LEVEL_EMPTY_ERROR = "levelEmptyError", e.LEVEL_LOAD_ERROR = "levelLoadError", e.LEVEL_LOAD_TIMEOUT = "levelLoadTimeOut", e.LEVEL_SWITCH_ERROR = "levelSwitchError", e.AUDIO_TRACK_LOAD_ERROR = "audioTrackLoadError", e.AUDIO_TRACK_LOAD_TIMEOUT = "audioTrackLoadTimeOut", e.SUBTITLE_LOAD_ERROR = "subtitleTrackLoadError", e.SUBTITLE_TRACK_LOAD_TIMEOUT = "subtitleTrackLoadTimeOut", e.FRAG_LOAD_ERROR = "fragLoadError", e.FRAG_LOAD_TIMEOUT = "fragLoadTimeOut", e.FRAG_DECRYPT_ERROR = "fragDecryptError", e.FRAG_PARSING_ERROR = "fragParsingError", e.REMUX_ALLOC_ERROR = "remuxAllocError", e.KEY_LOAD_ERROR = "keyLoadError", e.KEY_LOAD_TIMEOUT = "keyLoadTimeOut", e.BUFFER_ADD_CODEC_ERROR = "bufferAddCodecError", e.BUFFER_INCOMPATIBLE_CODECS_ERROR = "bufferIncompatibleCodecsError", e.BUFFER_APPEND_ERROR = "bufferAppendError", e.BUFFER_APPENDING_ERROR = "bufferAppendingError", e.BUFFER_STALLED_ERROR = "bufferStalledError", e.BUFFER_FULL_ERROR = "bufferFullError", e.BUFFER_SEEK_OVER_HOLE = "bufferSeekOverHole", e.BUFFER_NUDGE_ON_STALL = "bufferNudgeOnStall", e.INTERNAL_EXCEPTION = "internalException", e.INTERNAL_ABORTED = "aborted", e.UNKNOWN = "unknown";
                                }(i || (i = {}));
                            },
                            "./src/events.ts": (e, t, n)=>{
                                "use strict";
                                var r;
                                n.r(t), n.d(t, {
                                    Events: ()=>r
                                }), function(e) {
                                    e.MEDIA_ATTACHING = "hlsMediaAttaching", e.MEDIA_ATTACHED = "hlsMediaAttached", e.MEDIA_DETACHING = "hlsMediaDetaching", e.MEDIA_DETACHED = "hlsMediaDetached", e.BUFFER_RESET = "hlsBufferReset", e.BUFFER_CODECS = "hlsBufferCodecs", e.BUFFER_CREATED = "hlsBufferCreated", e.BUFFER_APPENDING = "hlsBufferAppending", e.BUFFER_APPENDED = "hlsBufferAppended", e.BUFFER_EOS = "hlsBufferEos", e.BUFFER_FLUSHING = "hlsBufferFlushing", e.BUFFER_FLUSHED = "hlsBufferFlushed", e.MANIFEST_LOADING = "hlsManifestLoading", e.MANIFEST_LOADED = "hlsManifestLoaded", e.MANIFEST_PARSED = "hlsManifestParsed", e.LEVEL_SWITCHING = "hlsLevelSwitching", e.LEVEL_SWITCHED = "hlsLevelSwitched", e.LEVEL_LOADING = "hlsLevelLoading", e.LEVEL_LOADED = "hlsLevelLoaded", e.LEVEL_UPDATED = "hlsLevelUpdated", e.LEVEL_PTS_UPDATED = "hlsLevelPtsUpdated", e.LEVELS_UPDATED = "hlsLevelsUpdated", e.AUDIO_TRACKS_UPDATED = "hlsAudioTracksUpdated", e.AUDIO_TRACK_SWITCHING = "hlsAudioTrackSwitching", e.AUDIO_TRACK_SWITCHED = "hlsAudioTrackSwitched", e.AUDIO_TRACK_LOADING = "hlsAudioTrackLoading", e.AUDIO_TRACK_LOADED = "hlsAudioTrackLoaded", e.SUBTITLE_TRACKS_UPDATED = "hlsSubtitleTracksUpdated", e.SUBTITLE_TRACKS_CLEARED = "hlsSubtitleTracksCleared", e.SUBTITLE_TRACK_SWITCH = "hlsSubtitleTrackSwitch", e.SUBTITLE_TRACK_LOADING = "hlsSubtitleTrackLoading", e.SUBTITLE_TRACK_LOADED = "hlsSubtitleTrackLoaded", e.SUBTITLE_FRAG_PROCESSED = "hlsSubtitleFragProcessed", e.CUES_PARSED = "hlsCuesParsed", e.NON_NATIVE_TEXT_TRACKS_FOUND = "hlsNonNativeTextTracksFound", e.INIT_PTS_FOUND = "hlsInitPtsFound", e.FRAG_LOADING = "hlsFragLoading", e.FRAG_LOAD_EMERGENCY_ABORTED = "hlsFragLoadEmergencyAborted", e.FRAG_LOADED = "hlsFragLoaded", e.FRAG_DECRYPTED = "hlsFragDecrypted", e.FRAG_PARSING_INIT_SEGMENT = "hlsFragParsingInitSegment", e.FRAG_PARSING_USERDATA = "hlsFragParsingUserdata", e.FRAG_PARSING_METADATA = "hlsFragParsingMetadata", e.FRAG_PARSED = "hlsFragParsed", e.FRAG_BUFFERED = "hlsFragBuffered", e.FRAG_CHANGED = "hlsFragChanged", e.FPS_DROP = "hlsFpsDrop", e.FPS_DROP_LEVEL_CAPPING = "hlsFpsDropLevelCapping", e.ERROR = "hlsError", e.DESTROYING = "hlsDestroying", e.KEY_LOADING = "hlsKeyLoading", e.KEY_LOADED = "hlsKeyLoaded", e.LIVE_BACK_BUFFER_REACHED = "hlsLiveBackBufferReached", e.BACK_BUFFER_REACHED = "hlsBackBufferReached";
                                }(r || (r = {}));
                            },
                            "./src/hls.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>y
                                });
                                var r = n("./node_modules/url-toolkit/src/url-toolkit.js"), i = n("./src/loader/playlist-loader.ts"), a1 = n("./src/loader/key-loader.ts"), o = n("./src/controller/id3-track-controller.ts"), s1 = n("./src/controller/latency-controller.ts"), u = n("./src/controller/level-controller.ts"), l = n("./src/controller/fragment-tracker.ts"), c = n("./src/controller/stream-controller.ts"), d = n("./src/is-supported.ts"), f = n("./src/utils/logger.ts"), h = n("./src/config.ts"), g = n("./node_modules/eventemitter3/index.js"), p = n("./src/events.ts"), m = n("./src/errors.ts");
                                function v(e, t) {
                                    for(var n = 0; n < t.length; n++){
                                        var r = t[n];
                                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                    }
                                }
                                var y = function() {
                                    function e(t) {
                                        void 0 === t && (t = {}), this.config = void 0, this.userConfig = void 0, this.coreComponents = void 0, this.networkControllers = void 0, this._emitter = new g.EventEmitter, this._autoLevelCapping = void 0, this.abrController = void 0, this.bufferController = void 0, this.capLevelController = void 0, this.latencyController = void 0, this.levelController = void 0, this.streamController = void 0, this.audioTrackController = void 0, this.subtitleTrackController = void 0, this.emeController = void 0, this.cmcdController = void 0, this._media = null, this.url = null;
                                        var n = this.config = (0, h.mergeConfig)(e.DefaultConfig, t);
                                        this.userConfig = t, (0, f.enableLogs)(n.debug, "Hls instance"), this._autoLevelCapping = -1, n.progressive && (0, h.enableStreamingMode)(n);
                                        var r = n.abrController, d = n.bufferController, p = n.capLevelController, m = n.fpsController, v = this.abrController = new r(this), y = this.bufferController = new d(this), E = this.capLevelController = new p(this), T = new m(this), b = new i.default(this), A = new a1.default(this), _ = new o.default(this), S = this.levelController = new u.default(this), w = new l.FragmentTracker(this), I = this.streamController = new c.default(this, w);
                                        E.setStreamController(I), T.setStreamController(I);
                                        var R = [
                                            b,
                                            A,
                                            S,
                                            I
                                        ];
                                        this.networkControllers = R;
                                        var C = [
                                            v,
                                            y,
                                            E,
                                            T,
                                            _,
                                            w
                                        ];
                                        this.audioTrackController = this.createController(n.audioTrackController, null, R), this.createController(n.audioStreamController, w, R), this.subtitleTrackController = this.createController(n.subtitleTrackController, null, R), this.createController(n.subtitleStreamController, w, R), this.createController(n.timelineController, null, C), this.emeController = this.createController(n.emeController, null, C), this.cmcdController = this.createController(n.cmcdController, null, C), this.latencyController = this.createController(s1.default, null, C), this.coreComponents = C;
                                    }
                                    e.isSupported = function() {
                                        return (0, d.isSupported)();
                                    };
                                    var t, n, y, E = e.prototype;
                                    return E.createController = function(e, t, n) {
                                        if (e) {
                                            var r = t ? new e(this, t) : new e(this);
                                            return n && n.push(r), r;
                                        }
                                        return null;
                                    }, E.on = function(e, t, n) {
                                        void 0 === n && (n = this), this._emitter.on(e, t, n);
                                    }, E.once = function(e, t, n) {
                                        void 0 === n && (n = this), this._emitter.once(e, t, n);
                                    }, E.removeAllListeners = function(e) {
                                        this._emitter.removeAllListeners(e);
                                    }, E.off = function(e, t, n, r) {
                                        void 0 === n && (n = this), this._emitter.off(e, t, n, r);
                                    }, E.listeners = function(e) {
                                        return this._emitter.listeners(e);
                                    }, E.emit = function(e, t, n) {
                                        return this._emitter.emit(e, t, n);
                                    }, E.trigger = function(e, t) {
                                        if (this.config.debug) return this.emit(e, e, t);
                                        try {
                                            return this.emit(e, e, t);
                                        } catch (t) {
                                            f.logger.error("An internal error happened while handling event " + e + '. Error message: "' + t.message + '". Here is a stacktrace:', t), this.trigger(p.Events.ERROR, {
                                                type: m.ErrorTypes.OTHER_ERROR,
                                                details: m.ErrorDetails.INTERNAL_EXCEPTION,
                                                fatal: !1,
                                                event: e,
                                                error: t
                                            });
                                        }
                                        return !1;
                                    }, E.listenerCount = function(e) {
                                        return this._emitter.listenerCount(e);
                                    }, E.destroy = function() {
                                        f.logger.log("destroy"), this.trigger(p.Events.DESTROYING, void 0), this.detachMedia(), this.removeAllListeners(), this._autoLevelCapping = -1, this.url = null, this.networkControllers.forEach(function(e) {
                                            return e.destroy();
                                        }), this.networkControllers.length = 0, this.coreComponents.forEach(function(e) {
                                            return e.destroy();
                                        }), this.coreComponents.length = 0;
                                    }, E.attachMedia = function(e) {
                                        f.logger.log("attachMedia"), this._media = e, this.trigger(p.Events.MEDIA_ATTACHING, {
                                            media: e
                                        });
                                    }, E.detachMedia = function() {
                                        f.logger.log("detachMedia"), this.trigger(p.Events.MEDIA_DETACHING, void 0), this._media = null;
                                    }, E.loadSource = function(e) {
                                        this.stopLoad();
                                        var t = this.media, n = this.url, i = this.url = r.buildAbsoluteURL(self.location.href, e, {
                                            alwaysNormalize: !0
                                        });
                                        f.logger.log("loadSource:" + i), t && n && n !== i && this.bufferController.hasSourceTypes() && (this.detachMedia(), this.attachMedia(t)), this.trigger(p.Events.MANIFEST_LOADING, {
                                            url: e
                                        });
                                    }, E.startLoad = function(e) {
                                        void 0 === e && (e = -1), f.logger.log("startLoad(" + e + ")"), this.networkControllers.forEach(function(t) {
                                            t.startLoad(e);
                                        });
                                    }, E.stopLoad = function() {
                                        f.logger.log("stopLoad"), this.networkControllers.forEach(function(e) {
                                            e.stopLoad();
                                        });
                                    }, E.swapAudioCodec = function() {
                                        f.logger.log("swapAudioCodec"), this.streamController.swapAudioCodec();
                                    }, E.recoverMediaError = function() {
                                        f.logger.log("recoverMediaError");
                                        var e = this._media;
                                        this.detachMedia(), e && this.attachMedia(e);
                                    }, E.removeLevel = function(e, t) {
                                        void 0 === t && (t = 0), this.levelController.removeLevel(e, t);
                                    }, t = e, y = [
                                        {
                                            key: "version",
                                            get: function() {
                                                return "1.2.7";
                                            }
                                        },
                                        {
                                            key: "Events",
                                            get: function() {
                                                return p.Events;
                                            }
                                        },
                                        {
                                            key: "ErrorTypes",
                                            get: function() {
                                                return m.ErrorTypes;
                                            }
                                        },
                                        {
                                            key: "ErrorDetails",
                                            get: function() {
                                                return m.ErrorDetails;
                                            }
                                        },
                                        {
                                            key: "DefaultConfig",
                                            get: function() {
                                                return e.defaultConfig ? e.defaultConfig : h.hlsDefaultConfig;
                                            },
                                            set: function(t) {
                                                e.defaultConfig = t;
                                            }
                                        }
                                    ], n = [
                                        {
                                            key: "levels",
                                            get: function() {
                                                return this.levelController.levels || [];
                                            }
                                        },
                                        {
                                            key: "currentLevel",
                                            get: function() {
                                                return this.streamController.currentLevel;
                                            },
                                            set: function(e) {
                                                f.logger.log("set currentLevel:" + e), this.loadLevel = e, this.abrController.clearTimer(), this.streamController.immediateLevelSwitch();
                                            }
                                        },
                                        {
                                            key: "nextLevel",
                                            get: function() {
                                                return this.streamController.nextLevel;
                                            },
                                            set: function(e) {
                                                f.logger.log("set nextLevel:" + e), this.levelController.manualLevel = e, this.streamController.nextLevelSwitch();
                                            }
                                        },
                                        {
                                            key: "loadLevel",
                                            get: function() {
                                                return this.levelController.level;
                                            },
                                            set: function(e) {
                                                f.logger.log("set loadLevel:" + e), this.levelController.manualLevel = e;
                                            }
                                        },
                                        {
                                            key: "nextLoadLevel",
                                            get: function() {
                                                return this.levelController.nextLoadLevel;
                                            },
                                            set: function(e) {
                                                this.levelController.nextLoadLevel = e;
                                            }
                                        },
                                        {
                                            key: "firstLevel",
                                            get: function() {
                                                return Math.max(this.levelController.firstLevel, this.minAutoLevel);
                                            },
                                            set: function(e) {
                                                f.logger.log("set firstLevel:" + e), this.levelController.firstLevel = e;
                                            }
                                        },
                                        {
                                            key: "startLevel",
                                            get: function() {
                                                return this.levelController.startLevel;
                                            },
                                            set: function(e) {
                                                f.logger.log("set startLevel:" + e), -1 !== e && (e = Math.max(e, this.minAutoLevel)), this.levelController.startLevel = e;
                                            }
                                        },
                                        {
                                            key: "capLevelToPlayerSize",
                                            get: function() {
                                                return this.config.capLevelToPlayerSize;
                                            },
                                            set: function(e) {
                                                var t = !!e;
                                                t !== this.config.capLevelToPlayerSize && (t ? this.capLevelController.startCapping() : (this.capLevelController.stopCapping(), this.autoLevelCapping = -1, this.streamController.nextLevelSwitch()), this.config.capLevelToPlayerSize = t);
                                            }
                                        },
                                        {
                                            key: "autoLevelCapping",
                                            get: function() {
                                                return this._autoLevelCapping;
                                            },
                                            set: function(e) {
                                                this._autoLevelCapping !== e && (f.logger.log("set autoLevelCapping:" + e), this._autoLevelCapping = e);
                                            }
                                        },
                                        {
                                            key: "bandwidthEstimate",
                                            get: function() {
                                                var e = this.abrController.bwEstimator;
                                                return e ? e.getEstimate() : NaN;
                                            }
                                        },
                                        {
                                            key: "autoLevelEnabled",
                                            get: function() {
                                                return -1 === this.levelController.manualLevel;
                                            }
                                        },
                                        {
                                            key: "manualLevel",
                                            get: function() {
                                                return this.levelController.manualLevel;
                                            }
                                        },
                                        {
                                            key: "minAutoLevel",
                                            get: function() {
                                                var e = this.levels, t = this.config.minAutoBitrate;
                                                if (!e) return 0;
                                                for(var n = e.length, r = 0; r < n; r++)if (e[r].maxBitrate >= t) return r;
                                                return 0;
                                            }
                                        },
                                        {
                                            key: "maxAutoLevel",
                                            get: function() {
                                                var e = this.levels, t = this.autoLevelCapping;
                                                return -1 === t && e && e.length ? e.length - 1 : t;
                                            }
                                        },
                                        {
                                            key: "nextAutoLevel",
                                            get: function() {
                                                return Math.min(Math.max(this.abrController.nextAutoLevel, this.minAutoLevel), this.maxAutoLevel);
                                            },
                                            set: function(e) {
                                                this.abrController.nextAutoLevel = Math.max(this.minAutoLevel, e);
                                            }
                                        },
                                        {
                                            key: "playingDate",
                                            get: function() {
                                                return this.streamController.currentProgramDateTime;
                                            }
                                        },
                                        {
                                            key: "mainForwardBufferInfo",
                                            get: function() {
                                                return this.streamController.getMainFwdBufferInfo();
                                            }
                                        },
                                        {
                                            key: "audioTracks",
                                            get: function() {
                                                var e = this.audioTrackController;
                                                return e ? e.audioTracks : [];
                                            }
                                        },
                                        {
                                            key: "audioTrack",
                                            get: function() {
                                                var e = this.audioTrackController;
                                                return e ? e.audioTrack : -1;
                                            },
                                            set: function(e) {
                                                var t = this.audioTrackController;
                                                t && (t.audioTrack = e);
                                            }
                                        },
                                        {
                                            key: "subtitleTracks",
                                            get: function() {
                                                var e = this.subtitleTrackController;
                                                return e ? e.subtitleTracks : [];
                                            }
                                        },
                                        {
                                            key: "subtitleTrack",
                                            get: function() {
                                                var e = this.subtitleTrackController;
                                                return e ? e.subtitleTrack : -1;
                                            },
                                            set: function(e) {
                                                var t = this.subtitleTrackController;
                                                t && (t.subtitleTrack = e);
                                            }
                                        },
                                        {
                                            key: "media",
                                            get: function() {
                                                return this._media;
                                            }
                                        },
                                        {
                                            key: "subtitleDisplay",
                                            get: function() {
                                                var e = this.subtitleTrackController;
                                                return !!e && e.subtitleDisplay;
                                            },
                                            set: function(e) {
                                                var t = this.subtitleTrackController;
                                                t && (t.subtitleDisplay = e);
                                            }
                                        },
                                        {
                                            key: "lowLatencyMode",
                                            get: function() {
                                                return this.config.lowLatencyMode;
                                            },
                                            set: function(e) {
                                                this.config.lowLatencyMode = e;
                                            }
                                        },
                                        {
                                            key: "liveSyncPosition",
                                            get: function() {
                                                return this.latencyController.liveSyncPosition;
                                            }
                                        },
                                        {
                                            key: "latency",
                                            get: function() {
                                                return this.latencyController.latency;
                                            }
                                        },
                                        {
                                            key: "maxLatency",
                                            get: function() {
                                                return this.latencyController.maxLatency;
                                            }
                                        },
                                        {
                                            key: "targetLatency",
                                            get: function() {
                                                return this.latencyController.targetLatency;
                                            }
                                        },
                                        {
                                            key: "drift",
                                            get: function() {
                                                return this.latencyController.drift;
                                            }
                                        },
                                        {
                                            key: "forceStartLoad",
                                            get: function() {
                                                return this.streamController.forceStartLoad;
                                            }
                                        }
                                    ], v(t.prototype, n), y && v(t, y), Object.defineProperty(t, "prototype", {
                                        writable: !1
                                    }), e;
                                }();
                                y.defaultConfig = void 0;
                            },
                            "./src/is-supported.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    changeTypeSupported: ()=>o,
                                    isSupported: ()=>a1
                                });
                                var r = n("./src/utils/mediasource-helper.ts");
                                function i() {
                                    return self.SourceBuffer || self.WebKitSourceBuffer;
                                }
                                function a1() {
                                    var e = (0, r.getMediaSource)();
                                    if (!e) return !1;
                                    var t = i(), n = e && "function" == typeof e.isTypeSupported && e.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), a1 = !t || t.prototype && "function" == typeof t.prototype.appendBuffer && "function" == typeof t.prototype.remove;
                                    return !!n && !!a1;
                                }
                                function o() {
                                    var e, t = i();
                                    return "function" == typeof (null == t || null === (e = t.prototype) || void 0 === e ? void 0 : e.changeType);
                                }
                            },
                            "./src/loader/date-range.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    DateRange: ()=>l,
                                    DateRangeAttribute: ()=>r
                                });
                                var r, i = n("./src/polyfills/number.ts"), a1 = n("./src/utils/attr-list.ts"), o = n("./src/utils/logger.ts");
                                function s1() {
                                    return s1 = Object.assign ? Object.assign.bind() : function(e) {
                                        for(var t = 1; t < arguments.length; t++){
                                            var n = arguments[t];
                                            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                                        }
                                        return e;
                                    }, s1.apply(this, arguments);
                                }
                                function u(e, t) {
                                    for(var n = 0; n < t.length; n++){
                                        var r = t[n];
                                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                    }
                                }
                                !function(e) {
                                    e.ID = "ID", e.CLASS = "CLASS", e.START_DATE = "START-DATE", e.DURATION = "DURATION", e.END_DATE = "END-DATE", e.END_ON_NEXT = "END-ON-NEXT", e.PLANNED_DURATION = "PLANNED-DURATION", e.SCTE35_OUT = "SCTE35-OUT", e.SCTE35_IN = "SCTE35-IN";
                                }(r || (r = {}));
                                var l = function() {
                                    function e(e, t) {
                                        if (this.attr = void 0, this._startDate = void 0, this._endDate = void 0, this._badValueForSameId = void 0, t) {
                                            var n = t.attr;
                                            for(var u in n)if (Object.prototype.hasOwnProperty.call(e, u) && e[u] !== n[u]) {
                                                o.logger.warn('DATERANGE tag attribute: "' + u + '" does not match for tags with ID: "' + e.ID + '"'), this._badValueForSameId = u;
                                                break;
                                            }
                                            e = s1(new a1.AttrList({}), n, e);
                                        }
                                        if (this.attr = e, this._startDate = new Date(e[r.START_DATE]), r.END_DATE in this.attr) {
                                            var l = new Date(this.attr[r.END_DATE]);
                                            (0, i.isFiniteNumber)(l.getTime()) && (this._endDate = l);
                                        }
                                    }
                                    var t, n;
                                    return t = e, n = [
                                        {
                                            key: "id",
                                            get: function() {
                                                return this.attr.ID;
                                            }
                                        },
                                        {
                                            key: "class",
                                            get: function() {
                                                return this.attr.CLASS;
                                            }
                                        },
                                        {
                                            key: "startDate",
                                            get: function() {
                                                return this._startDate;
                                            }
                                        },
                                        {
                                            key: "endDate",
                                            get: function() {
                                                if (this._endDate) return this._endDate;
                                                var e = this.duration;
                                                return null !== e ? new Date(this._startDate.getTime() + 1e3 * e) : null;
                                            }
                                        },
                                        {
                                            key: "duration",
                                            get: function() {
                                                if (r.DURATION in this.attr) {
                                                    var e = this.attr.decimalFloatingPoint(r.DURATION);
                                                    if ((0, i.isFiniteNumber)(e)) return e;
                                                } else if (this._endDate) return (this._endDate.getTime() - this._startDate.getTime()) / 1e3;
                                                return null;
                                            }
                                        },
                                        {
                                            key: "plannedDuration",
                                            get: function() {
                                                return r.PLANNED_DURATION in this.attr ? this.attr.decimalFloatingPoint(r.PLANNED_DURATION) : null;
                                            }
                                        },
                                        {
                                            key: "endOnNext",
                                            get: function() {
                                                return this.attr.bool(r.END_ON_NEXT);
                                            }
                                        },
                                        {
                                            key: "isValid",
                                            get: function() {
                                                return !!this.id && !this._badValueForSameId && (0, i.isFiniteNumber)(this.startDate.getTime()) && (null === this.duration || this.duration >= 0) && (!this.endOnNext || !!this.class);
                                            }
                                        }
                                    ], u(t.prototype, n), Object.defineProperty(t, "prototype", {
                                        writable: !1
                                    }), e;
                                }();
                            },
                            "./src/loader/fragment-loader.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    LoadError: ()=>h,
                                    default: ()=>d
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./src/errors.ts");
                                function a1(e) {
                                    var t = "function" == typeof Map ? new Map : void 0;
                                    return a1 = function(e) {
                                        if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
                                        var n;
                                        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                                        if (void 0 !== t) {
                                            if (t.has(e)) return t.get(e);
                                            t.set(e, r);
                                        }
                                        function r() {
                                            return o(e, arguments, l(this).constructor);
                                        }
                                        return r.prototype = Object.create(e.prototype, {
                                            constructor: {
                                                value: r,
                                                enumerable: !1,
                                                writable: !0,
                                                configurable: !0
                                            }
                                        }), u(r, e);
                                    }, a1(e);
                                }
                                function o(e, t, n) {
                                    return o = s1() ? Reflect.construct.bind() : function(e, t, n) {
                                        var r = [
                                            null
                                        ];
                                        r.push.apply(r, t);
                                        var i = new (Function.bind.apply(e, r));
                                        return n && u(i, n.prototype), i;
                                    }, o.apply(null, arguments);
                                }
                                function s1() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }
                                function u(e, t) {
                                    return u = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, u(e, t);
                                }
                                function l(e) {
                                    return l = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                                        return e.__proto__ || Object.getPrototypeOf(e);
                                    }, l(e);
                                }
                                var c = Math.pow(2, 17), d = function() {
                                    function e(e) {
                                        this.config = void 0, this.loader = null, this.partLoadTimeout = -1, this.config = e;
                                    }
                                    var t = e.prototype;
                                    return t.destroy = function() {
                                        this.loader && (this.loader.destroy(), this.loader = null);
                                    }, t.abort = function() {
                                        this.loader && this.loader.abort();
                                    }, t.load = function(e, t) {
                                        var n = this, r = e.url;
                                        if (!r) return Promise.reject(new h({
                                            type: i.ErrorTypes.NETWORK_ERROR,
                                            details: i.ErrorDetails.FRAG_LOAD_ERROR,
                                            fatal: !1,
                                            frag: e,
                                            networkDetails: null
                                        }, "Fragment does not have a " + (r ? "part list" : "url")));
                                        this.abort();
                                        var a1 = this.config, o = a1.fLoader, s1 = a1.loader;
                                        return new Promise(function(r, u) {
                                            n.loader && n.loader.destroy();
                                            var l = n.loader = e.loader = o ? new o(a1) : new s1(a1), d = f(e), g = {
                                                timeout: a1.fragLoadingTimeOut,
                                                maxRetry: 0,
                                                retryDelay: 0,
                                                maxRetryDelay: a1.fragLoadingMaxRetryTimeout,
                                                highWaterMark: "initSegment" === e.sn ? 1 / 0 : c
                                            };
                                            e.stats = l.stats, l.load(d, g, {
                                                onSuccess: function(t, i, a1, o) {
                                                    n.resetLoader(e, l), r({
                                                        frag: e,
                                                        part: null,
                                                        payload: t.data,
                                                        networkDetails: o
                                                    });
                                                },
                                                onError: function(t, r, a1) {
                                                    n.resetLoader(e, l), u(new h({
                                                        type: i.ErrorTypes.NETWORK_ERROR,
                                                        details: i.ErrorDetails.FRAG_LOAD_ERROR,
                                                        fatal: !1,
                                                        frag: e,
                                                        response: t,
                                                        networkDetails: a1
                                                    }));
                                                },
                                                onAbort: function(t, r, a1) {
                                                    n.resetLoader(e, l), u(new h({
                                                        type: i.ErrorTypes.NETWORK_ERROR,
                                                        details: i.ErrorDetails.INTERNAL_ABORTED,
                                                        fatal: !1,
                                                        frag: e,
                                                        networkDetails: a1
                                                    }));
                                                },
                                                onTimeout: function(t, r, a1) {
                                                    n.resetLoader(e, l), u(new h({
                                                        type: i.ErrorTypes.NETWORK_ERROR,
                                                        details: i.ErrorDetails.FRAG_LOAD_TIMEOUT,
                                                        fatal: !1,
                                                        frag: e,
                                                        networkDetails: a1
                                                    }));
                                                },
                                                onProgress: function(n, r, i, a1) {
                                                    t && t({
                                                        frag: e,
                                                        part: null,
                                                        payload: i,
                                                        networkDetails: a1
                                                    });
                                                }
                                            });
                                        });
                                    }, t.loadPart = function(e, t, n) {
                                        var r = this;
                                        this.abort();
                                        var a1 = this.config, o = a1.fLoader, s1 = a1.loader;
                                        return new Promise(function(u, l) {
                                            r.loader && r.loader.destroy();
                                            var d = r.loader = e.loader = o ? new o(a1) : new s1(a1), g = f(e, t), p = {
                                                timeout: a1.fragLoadingTimeOut,
                                                maxRetry: 0,
                                                retryDelay: 0,
                                                maxRetryDelay: a1.fragLoadingMaxRetryTimeout,
                                                highWaterMark: c
                                            };
                                            t.stats = d.stats, d.load(g, p, {
                                                onSuccess: function(i, a1, o, s1) {
                                                    r.resetLoader(e, d), r.updateStatsFromPart(e, t);
                                                    var l = {
                                                        frag: e,
                                                        part: t,
                                                        payload: i.data,
                                                        networkDetails: s1
                                                    };
                                                    n(l), u(l);
                                                },
                                                onError: function(n, a1, o) {
                                                    r.resetLoader(e, d), l(new h({
                                                        type: i.ErrorTypes.NETWORK_ERROR,
                                                        details: i.ErrorDetails.FRAG_LOAD_ERROR,
                                                        fatal: !1,
                                                        frag: e,
                                                        part: t,
                                                        response: n,
                                                        networkDetails: o
                                                    }));
                                                },
                                                onAbort: function(n, a1, o) {
                                                    e.stats.aborted = t.stats.aborted, r.resetLoader(e, d), l(new h({
                                                        type: i.ErrorTypes.NETWORK_ERROR,
                                                        details: i.ErrorDetails.INTERNAL_ABORTED,
                                                        fatal: !1,
                                                        frag: e,
                                                        part: t,
                                                        networkDetails: o
                                                    }));
                                                },
                                                onTimeout: function(n, a1, o) {
                                                    r.resetLoader(e, d), l(new h({
                                                        type: i.ErrorTypes.NETWORK_ERROR,
                                                        details: i.ErrorDetails.FRAG_LOAD_TIMEOUT,
                                                        fatal: !1,
                                                        frag: e,
                                                        part: t,
                                                        networkDetails: o
                                                    }));
                                                }
                                            });
                                        });
                                    }, t.updateStatsFromPart = function(e, t) {
                                        var n = e.stats, r = t.stats, i = r.total;
                                        if (n.loaded += r.loaded, i) {
                                            var a1 = Math.round(e.duration / t.duration), o = Math.min(Math.round(n.loaded / i), a1), s1 = (a1 - o) * Math.round(n.loaded / o);
                                            n.total = n.loaded + s1;
                                        } else n.total = Math.max(n.loaded, n.total);
                                        var u = n.loading, l = r.loading;
                                        u.start ? u.first += l.first - l.start : (u.start = l.start, u.first = l.first), u.end = l.end;
                                    }, t.resetLoader = function(e, t) {
                                        e.loader = null, this.loader === t && (self.clearTimeout(this.partLoadTimeout), this.loader = null), t.destroy();
                                    }, e;
                                }();
                                function f(e, t) {
                                    void 0 === t && (t = null);
                                    var n = t || e, i = {
                                        frag: e,
                                        part: t,
                                        responseType: "arraybuffer",
                                        url: n.url,
                                        headers: {},
                                        rangeStart: 0,
                                        rangeEnd: 0
                                    }, a1 = n.byteRangeStartOffset, o = n.byteRangeEndOffset;
                                    return (0, r.isFiniteNumber)(a1) && (0, r.isFiniteNumber)(o) && (i.rangeStart = a1, i.rangeEnd = o), i;
                                }
                                var h = function(e) {
                                    var t, n;
                                    function r(t) {
                                        for(var n, r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a1 = 1; a1 < r; a1++)i[a1 - 1] = arguments[a1];
                                        return (n = e.call.apply(e, [
                                            this
                                        ].concat(i)) || this).data = void 0, n.data = t, n;
                                    }
                                    return n = e, (t = r).prototype = Object.create(n.prototype), t.prototype.constructor = t, u(t, n), r;
                                }(a1(Error));
                            },
                            "./src/loader/fragment.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    BaseSegment: ()=>h,
                                    ElementaryStreamTypes: ()=>r,
                                    Fragment: ()=>g,
                                    Part: ()=>p
                                });
                                var r, i = n("./src/polyfills/number.ts"), a1 = n("./node_modules/url-toolkit/src/url-toolkit.js"), o = n("./src/utils/logger.ts"), s1 = n("./src/loader/level-key.ts"), u = n("./src/loader/load-stats.ts");
                                function l(e, t) {
                                    e.prototype = Object.create(t.prototype), e.prototype.constructor = e, c(e, t);
                                }
                                function c(e, t) {
                                    return c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, c(e, t);
                                }
                                function d(e, t) {
                                    for(var n = 0; n < t.length; n++){
                                        var r = t[n];
                                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                    }
                                }
                                function f(e, t, n) {
                                    return t && d(e.prototype, t), n && d(e, n), Object.defineProperty(e, "prototype", {
                                        writable: !1
                                    }), e;
                                }
                                !function(e) {
                                    e.AUDIO = "audio", e.VIDEO = "video", e.AUDIOVIDEO = "audiovideo";
                                }(r || (r = {}));
                                var h = function() {
                                    function e(e) {
                                        var t;
                                        this._byteRange = null, this._url = null, this.baseurl = void 0, this.relurl = void 0, this.elementaryStreams = ((t = {})[r.AUDIO] = null, t[r.VIDEO] = null, t[r.AUDIOVIDEO] = null, t), this.baseurl = e;
                                    }
                                    return e.prototype.setByteRange = function(e, t) {
                                        var n = e.split("@", 2), r = [];
                                        1 === n.length ? r[0] = t ? t.byteRangeEndOffset : 0 : r[0] = parseInt(n[1]), r[1] = parseInt(n[0]) + r[0], this._byteRange = r;
                                    }, f(e, [
                                        {
                                            key: "byteRange",
                                            get: function() {
                                                return this._byteRange ? this._byteRange : [];
                                            }
                                        },
                                        {
                                            key: "byteRangeStartOffset",
                                            get: function() {
                                                return this.byteRange[0];
                                            }
                                        },
                                        {
                                            key: "byteRangeEndOffset",
                                            get: function() {
                                                return this.byteRange[1];
                                            }
                                        },
                                        {
                                            key: "url",
                                            get: function() {
                                                return !this._url && this.baseurl && this.relurl && (this._url = (0, a1.buildAbsoluteURL)(this.baseurl, this.relurl, {
                                                    alwaysNormalize: !0
                                                })), this._url || "";
                                            },
                                            set: function(e) {
                                                this._url = e;
                                            }
                                        }
                                    ]), e;
                                }(), g = function(e) {
                                    function t(t, n) {
                                        var r;
                                        return (r = e.call(this, n) || this)._decryptdata = null, r.rawProgramDateTime = null, r.programDateTime = null, r.tagList = [], r.duration = 0, r.sn = 0, r.levelkey = void 0, r.type = void 0, r.loader = null, r.level = -1, r.cc = 0, r.startPTS = void 0, r.endPTS = void 0, r.appendedPTS = void 0, r.startDTS = void 0, r.endDTS = void 0, r.start = 0, r.deltaPTS = void 0, r.maxStartPTS = void 0, r.minEndPTS = void 0, r.stats = new u.LoadStats, r.urlId = 0, r.data = void 0, r.bitrateTest = !1, r.title = null, r.initSegment = null, r.type = t, r;
                                    }
                                    l(t, e);
                                    var n = t.prototype;
                                    return n.createInitializationVector = function(e) {
                                        for(var t = new Uint8Array(16), n = 12; n < 16; n++)t[n] = e >> 8 * (15 - n) & 255;
                                        return t;
                                    }, n.setDecryptDataFromLevelKey = function(e, t) {
                                        var n = e;
                                        return "AES-128" === (null == e ? void 0 : e.method) && e.uri && !e.iv && ((n = s1.LevelKey.fromURI(e.uri)).method = e.method, n.iv = this.createInitializationVector(t), n.keyFormat = "identity"), n;
                                    }, n.setElementaryStreamInfo = function(e, t, n, r, i, a1) {
                                        void 0 === a1 && (a1 = !1);
                                        var o = this.elementaryStreams, s1 = o[e];
                                        s1 ? (s1.startPTS = Math.min(s1.startPTS, t), s1.endPTS = Math.max(s1.endPTS, n), s1.startDTS = Math.min(s1.startDTS, r), s1.endDTS = Math.max(s1.endDTS, i)) : o[e] = {
                                            startPTS: t,
                                            endPTS: n,
                                            startDTS: r,
                                            endDTS: i,
                                            partial: a1
                                        };
                                    }, n.clearElementaryStreamInfo = function() {
                                        var e = this.elementaryStreams;
                                        e[r.AUDIO] = null, e[r.VIDEO] = null, e[r.AUDIOVIDEO] = null;
                                    }, f(t, [
                                        {
                                            key: "decryptdata",
                                            get: function() {
                                                if (!this.levelkey && !this._decryptdata) return null;
                                                if (!this._decryptdata && this.levelkey) {
                                                    var e = this.sn;
                                                    "number" != typeof e && (this.levelkey && "AES-128" === this.levelkey.method && !this.levelkey.iv && o.logger.warn('missing IV for initialization segment with method="' + this.levelkey.method + '" - compliance issue'), e = 0), this._decryptdata = this.setDecryptDataFromLevelKey(this.levelkey, e);
                                                }
                                                return this._decryptdata;
                                            }
                                        },
                                        {
                                            key: "end",
                                            get: function() {
                                                return this.start + this.duration;
                                            }
                                        },
                                        {
                                            key: "endProgramDateTime",
                                            get: function() {
                                                if (null === this.programDateTime) return null;
                                                if (!(0, i.isFiniteNumber)(this.programDateTime)) return null;
                                                var e = (0, i.isFiniteNumber)(this.duration) ? this.duration : 0;
                                                return this.programDateTime + 1e3 * e;
                                            }
                                        },
                                        {
                                            key: "encrypted",
                                            get: function() {
                                                var e;
                                                return !(null === (e = this.decryptdata) || void 0 === e || !e.keyFormat || !this.decryptdata.uri);
                                            }
                                        }
                                    ]), t;
                                }(h), p = function(e) {
                                    function t(t, n, r, i, a1) {
                                        var o;
                                        (o = e.call(this, r) || this).fragOffset = 0, o.duration = 0, o.gap = !1, o.independent = !1, o.relurl = void 0, o.fragment = void 0, o.index = void 0, o.stats = new u.LoadStats, o.duration = t.decimalFloatingPoint("DURATION"), o.gap = t.bool("GAP"), o.independent = t.bool("INDEPENDENT"), o.relurl = t.enumeratedString("URI"), o.fragment = n, o.index = i;
                                        var s1 = t.enumeratedString("BYTERANGE");
                                        return s1 && o.setByteRange(s1, a1), a1 && (o.fragOffset = a1.fragOffset + a1.duration), o;
                                    }
                                    return l(t, e), f(t, [
                                        {
                                            key: "start",
                                            get: function() {
                                                return this.fragment.start + this.fragOffset;
                                            }
                                        },
                                        {
                                            key: "end",
                                            get: function() {
                                                return this.start + this.duration;
                                            }
                                        },
                                        {
                                            key: "loaded",
                                            get: function() {
                                                var e = this.elementaryStreams;
                                                return !!(e.audio || e.video || e.audiovideo);
                                            }
                                        }
                                    ]), t;
                                }(h);
                            },
                            "./src/loader/key-loader.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>o
                                });
                                var r = n("./src/events.ts"), i = n("./src/errors.ts"), a1 = n("./src/utils/logger.ts"), o = function() {
                                    function e(e) {
                                        this.hls = void 0, this.loaders = {}, this.decryptkey = null, this.decrypturl = null, this.hls = e, this.registerListeners();
                                    }
                                    var t = e.prototype;
                                    return t.startLoad = function(e) {}, t.stopLoad = function() {
                                        this.destroyInternalLoaders();
                                    }, t.registerListeners = function() {
                                        this.hls.on(r.Events.KEY_LOADING, this.onKeyLoading, this);
                                    }, t.unregisterListeners = function() {
                                        this.hls.off(r.Events.KEY_LOADING, this.onKeyLoading);
                                    }, t.destroyInternalLoaders = function() {
                                        for(var e in this.loaders){
                                            var t = this.loaders[e];
                                            t && t.destroy();
                                        }
                                        this.loaders = {};
                                    }, t.destroy = function() {
                                        this.unregisterListeners(), this.destroyInternalLoaders();
                                    }, t.onKeyLoading = function(e, t) {
                                        var n = t.frag, i = n.type, o = this.loaders[i];
                                        if (n.decryptdata) {
                                            var s1 = n.decryptdata.uri;
                                            if (s1 !== this.decrypturl || null === this.decryptkey) {
                                                var u = this.hls.config;
                                                if (o && (a1.logger.warn("abort previous key loader for type:" + i), o.abort()), !s1) return void a1.logger.warn("key uri is falsy");
                                                var l = u.loader, c = n.loader = this.loaders[i] = new l(u);
                                                this.decrypturl = s1, this.decryptkey = null;
                                                var d = {
                                                    url: s1,
                                                    frag: n,
                                                    responseType: "arraybuffer"
                                                }, f = {
                                                    timeout: u.fragLoadingTimeOut,
                                                    maxRetry: 0,
                                                    retryDelay: u.fragLoadingRetryDelay,
                                                    maxRetryDelay: u.fragLoadingMaxRetryTimeout,
                                                    highWaterMark: 0
                                                }, h = {
                                                    onSuccess: this.loadsuccess.bind(this),
                                                    onError: this.loaderror.bind(this),
                                                    onTimeout: this.loadtimeout.bind(this)
                                                };
                                                c.load(d, f, h);
                                            } else this.decryptkey && (n.decryptdata.key = this.decryptkey, this.hls.trigger(r.Events.KEY_LOADED, {
                                                frag: n
                                            }));
                                        } else a1.logger.warn("Missing decryption data on fragment in onKeyLoading");
                                    }, t.loadsuccess = function(e, t, n) {
                                        var i = n.frag;
                                        i.decryptdata ? (this.decryptkey = i.decryptdata.key = new Uint8Array(e.data), i.loader = null, delete this.loaders[i.type], this.hls.trigger(r.Events.KEY_LOADED, {
                                            frag: i
                                        })) : a1.logger.error("after key load, decryptdata unset");
                                    }, t.loaderror = function(e, t) {
                                        var n = t.frag, a1 = n.loader;
                                        a1 && a1.abort(), delete this.loaders[n.type], this.hls.trigger(r.Events.ERROR, {
                                            type: i.ErrorTypes.NETWORK_ERROR,
                                            details: i.ErrorDetails.KEY_LOAD_ERROR,
                                            fatal: !1,
                                            frag: n,
                                            response: e
                                        });
                                    }, t.loadtimeout = function(e, t) {
                                        var n = t.frag, a1 = n.loader;
                                        a1 && a1.abort(), delete this.loaders[n.type], this.hls.trigger(r.Events.ERROR, {
                                            type: i.ErrorTypes.NETWORK_ERROR,
                                            details: i.ErrorDetails.KEY_LOAD_TIMEOUT,
                                            fatal: !1,
                                            frag: n
                                        });
                                    }, e;
                                }();
                            },
                            "./src/loader/level-details.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    LevelDetails: ()=>a1
                                });
                                var r = n("./src/polyfills/number.ts");
                                function i(e, t) {
                                    for(var n = 0; n < t.length; n++){
                                        var r = t[n];
                                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                    }
                                }
                                var a1 = function() {
                                    function e(e) {
                                        this.PTSKnown = !1, this.alignedSliding = !1, this.averagetargetduration = void 0, this.endCC = 0, this.endSN = 0, this.fragments = void 0, this.fragmentHint = void 0, this.partList = null, this.dateRanges = void 0, this.live = !0, this.ageHeader = 0, this.advancedDateTime = void 0, this.updated = !0, this.advanced = !0, this.availabilityDelay = void 0, this.misses = 0, this.needSidxRanges = !1, this.startCC = 0, this.startSN = 0, this.startTimeOffset = null, this.targetduration = 0, this.totalduration = 0, this.type = null, this.url = void 0, this.m3u8 = "", this.version = null, this.canBlockReload = !1, this.canSkipUntil = 0, this.canSkipDateRanges = !1, this.skippedSegments = 0, this.recentlyRemovedDateranges = void 0, this.partHoldBack = 0, this.holdBack = 0, this.partTarget = 0, this.preloadHint = void 0, this.renditionReports = void 0, this.tuneInGoal = 0, this.deltaUpdateFailed = void 0, this.driftStartTime = 0, this.driftEndTime = 0, this.driftStart = 0, this.driftEnd = 0, this.fragments = [], this.dateRanges = {}, this.url = e;
                                    }
                                    var t, n;
                                    return e.prototype.reloaded = function(e) {
                                        if (!e) return this.advanced = !0, void (this.updated = !0);
                                        var t = this.lastPartSn - e.lastPartSn, n = this.lastPartIndex - e.lastPartIndex;
                                        this.updated = this.endSN !== e.endSN || !!n || !!t, this.advanced = this.endSN > e.endSN || t > 0 || 0 === t && n > 0, this.updated || this.advanced ? this.misses = Math.floor(.6 * e.misses) : this.misses = e.misses + 1, this.availabilityDelay = e.availabilityDelay;
                                    }, t = e, n = [
                                        {
                                            key: "hasProgramDateTime",
                                            get: function() {
                                                return !!this.fragments.length && (0, r.isFiniteNumber)(this.fragments[this.fragments.length - 1].programDateTime);
                                            }
                                        },
                                        {
                                            key: "levelTargetDuration",
                                            get: function() {
                                                return this.averagetargetduration || this.targetduration || 10;
                                            }
                                        },
                                        {
                                            key: "drift",
                                            get: function() {
                                                var e = this.driftEndTime - this.driftStartTime;
                                                return e > 0 ? 1e3 * (this.driftEnd - this.driftStart) / e : 1;
                                            }
                                        },
                                        {
                                            key: "edge",
                                            get: function() {
                                                return this.partEnd || this.fragmentEnd;
                                            }
                                        },
                                        {
                                            key: "partEnd",
                                            get: function() {
                                                var e;
                                                return null !== (e = this.partList) && void 0 !== e && e.length ? this.partList[this.partList.length - 1].end : this.fragmentEnd;
                                            }
                                        },
                                        {
                                            key: "fragmentEnd",
                                            get: function() {
                                                var e;
                                                return null !== (e = this.fragments) && void 0 !== e && e.length ? this.fragments[this.fragments.length - 1].end : 0;
                                            }
                                        },
                                        {
                                            key: "age",
                                            get: function() {
                                                return this.advancedDateTime ? Math.max(Date.now() - this.advancedDateTime, 0) / 1e3 : 0;
                                            }
                                        },
                                        {
                                            key: "lastPartIndex",
                                            get: function() {
                                                var e;
                                                return null !== (e = this.partList) && void 0 !== e && e.length ? this.partList[this.partList.length - 1].index : -1;
                                            }
                                        },
                                        {
                                            key: "lastPartSn",
                                            get: function() {
                                                var e;
                                                return null !== (e = this.partList) && void 0 !== e && e.length ? this.partList[this.partList.length - 1].fragment.sn : this.endSN;
                                            }
                                        }
                                    ], i(t.prototype, n), Object.defineProperty(t, "prototype", {
                                        writable: !1
                                    }), e;
                                }();
                            },
                            "./src/loader/level-key.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    LevelKey: ()=>a1
                                });
                                var r = n("./node_modules/url-toolkit/src/url-toolkit.js");
                                function i(e, t) {
                                    for(var n = 0; n < t.length; n++){
                                        var r = t[n];
                                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                    }
                                }
                                var a1 = function() {
                                    function e(e, t) {
                                        this._uri = null, this.method = null, this.keyFormat = null, this.keyFormatVersions = null, this.keyID = null, this.key = null, this.iv = null, this._uri = t ? (0, r.buildAbsoluteURL)(e, t, {
                                            alwaysNormalize: !0
                                        }) : e;
                                    }
                                    var t, n;
                                    return e.fromURL = function(t, n) {
                                        return new e(t, n);
                                    }, e.fromURI = function(t) {
                                        return new e(t);
                                    }, t = e, n = [
                                        {
                                            key: "uri",
                                            get: function() {
                                                return this._uri;
                                            }
                                        }
                                    ], i(t.prototype, n), Object.defineProperty(t, "prototype", {
                                        writable: !1
                                    }), e;
                                }();
                            },
                            "./src/loader/load-stats.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    LoadStats: ()=>r
                                });
                                var r = function() {
                                    this.aborted = !1, this.loaded = 0, this.retry = 0, this.total = 0, this.chunkCount = 0, this.bwEstimate = 0, this.loading = {
                                        start: 0,
                                        first: 0,
                                        end: 0
                                    }, this.parsing = {
                                        start: 0,
                                        end: 0
                                    }, this.buffering = {
                                        start: 0,
                                        first: 0,
                                        end: 0
                                    };
                                };
                            },
                            "./src/loader/m3u8-parser.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>v
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./node_modules/url-toolkit/src/url-toolkit.js"), a1 = n("./src/loader/date-range.ts"), o = n("./src/loader/fragment.ts"), s1 = n("./src/loader/level-details.ts"), u = n("./src/loader/level-key.ts"), l = n("./src/utils/attr-list.ts"), c = n("./src/utils/logger.ts"), d = n("./src/utils/codecs.ts"), f = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-SESSION-DATA:([^\r\n]*)[\r\n]+/g, h = /#EXT-X-MEDIA:(.*)/g, g = new RegExp([
                                    /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
                                    /(?!#) *(\S[\S ]*)/.source,
                                    /#EXT-X-BYTERANGE:*(.+)/.source,
                                    /#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
                                    /#.*/.source
                                ].join("|"), "g"), p = new RegExp([
                                    /#(EXTM3U)/.source,
                                    /#EXT-X-(DATERANGE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source,
                                    /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source,
                                    /#EXT-X-(DISCONTINUITY|ENDLIST|GAP)/.source,
                                    /(#)([^:]*):(.*)/.source,
                                    /(#)(.*)(?:.*)\r?\n?/.source
                                ].join("|")), m = /\.(mp4|m4s|m4v|m4a)$/i, v = function() {
                                    function e() {}
                                    return e.findGroup = function(e, t) {
                                        for(var n = 0; n < e.length; n++){
                                            var r = e[n];
                                            if (r.id === t) return r;
                                        }
                                    }, e.convertAVC1ToAVCOTI = function(e) {
                                        var t = e.split(".");
                                        if (t.length > 2) {
                                            var n = t.shift() + ".";
                                            return (n += parseInt(t.shift()).toString(16)) + ("000" + parseInt(t.shift()).toString(16)).slice(-4);
                                        }
                                        return e;
                                    }, e.resolve = function(e, t) {
                                        return i.buildAbsoluteURL(t, e, {
                                            alwaysNormalize: !0
                                        });
                                    }, e.parseMasterPlaylist = function(t, n) {
                                        var r, i = [], a1 = [], o = {}, s1 = !1;
                                        for(f.lastIndex = 0; null != (r = f.exec(t));)if (r[1]) {
                                            var u, c = new l.AttrList(r[1]), d = {
                                                attrs: c,
                                                bitrate: c.decimalInteger("AVERAGE-BANDWIDTH") || c.decimalInteger("BANDWIDTH"),
                                                name: c.NAME,
                                                url: e.resolve(r[2], n)
                                            }, h = c.decimalResolution("RESOLUTION");
                                            h && (d.width = h.width, d.height = h.height), y((c.CODECS || "").split(/[ ,]+/).filter(function(e) {
                                                return e;
                                            }), d), d.videoCodec && -1 !== d.videoCodec.indexOf("avc1") && (d.videoCodec = e.convertAVC1ToAVCOTI(d.videoCodec)), null !== (u = d.unknownCodecs) && void 0 !== u && u.length || a1.push(d), i.push(d);
                                        } else if (r[3]) {
                                            var g = new l.AttrList(r[3]);
                                            g["DATA-ID"] && (s1 = !0, o[g["DATA-ID"]] = g);
                                        }
                                        return {
                                            levels: a1.length > 0 && a1.length < i.length ? a1 : i,
                                            sessionData: s1 ? o : null
                                        };
                                    }, e.parseMasterPlaylistMedia = function(t, n, r, i) {
                                        var a1;
                                        void 0 === i && (i = []);
                                        var o = [], s1 = 0;
                                        for(h.lastIndex = 0; null !== (a1 = h.exec(t));){
                                            var u = new l.AttrList(a1[1]);
                                            if (u.TYPE === r) {
                                                var c = {
                                                    attrs: u,
                                                    bitrate: 0,
                                                    id: s1++,
                                                    groupId: u["GROUP-ID"],
                                                    instreamId: u["INSTREAM-ID"],
                                                    name: u.NAME || u.LANGUAGE || "",
                                                    type: r,
                                                    default: u.bool("DEFAULT"),
                                                    autoselect: u.bool("AUTOSELECT"),
                                                    forced: u.bool("FORCED"),
                                                    lang: u.LANGUAGE,
                                                    url: u.URI ? e.resolve(u.URI, n) : ""
                                                };
                                                if (i.length) {
                                                    var d = e.findGroup(i, c.groupId) || i[0];
                                                    E(c, d, "audioCodec"), E(c, d, "textCodec");
                                                }
                                                o.push(c);
                                            }
                                        }
                                        return o;
                                    }, e.parseLevelPlaylist = function(e, t, n, d, f) {
                                        var h, v, y, E = new s1.LevelDetails(t), A = E.fragments, _ = null, S = 0, w = 0, I = 0, R = 0, C = null, D = new o.Fragment(d, t), k = -1, N = !1;
                                        for(g.lastIndex = 0, E.m3u8 = e; null !== (h = g.exec(e));){
                                            N && (N = !1, (D = new o.Fragment(d, t)).start = I, D.sn = S, D.cc = R, D.level = n, _ && (D.initSegment = _, D.rawProgramDateTime = _.rawProgramDateTime, _.rawProgramDateTime = null));
                                            var L = h[1];
                                            if (L) {
                                                D.duration = parseFloat(L);
                                                var x = (" " + h[2]).slice(1);
                                                D.title = x || null, D.tagList.push(x ? [
                                                    "INF",
                                                    L,
                                                    x
                                                ] : [
                                                    "INF",
                                                    L
                                                ]);
                                            } else if (h[3]) (0, r.isFiniteNumber)(D.duration) && (D.start = I, y && (D.levelkey = y), D.sn = S, D.level = n, D.cc = R, D.urlId = f, A.push(D), D.relurl = (" " + h[3]).slice(1), T(D, C), C = D, I += D.duration, S++, w = 0, N = !0);
                                            else if (h[4]) {
                                                var M = (" " + h[4]).slice(1);
                                                C ? D.setByteRange(M, C) : D.setByteRange(M);
                                            } else if (h[5]) D.rawProgramDateTime = (" " + h[5]).slice(1), D.tagList.push([
                                                "PROGRAM-DATE-TIME",
                                                D.rawProgramDateTime
                                            ]), -1 === k && (k = A.length);
                                            else {
                                                if (!(h = h[0].match(p))) {
                                                    c.logger.warn("No matches on slow regex match for level playlist!");
                                                    continue;
                                                }
                                                for(v = 1; v < h.length && void 0 === h[v]; v++);
                                                var O = (" " + h[v]).slice(1), P = (" " + h[v + 1]).slice(1), F = h[v + 2] ? (" " + h[v + 2]).slice(1) : "";
                                                switch(O){
                                                    case "PLAYLIST-TYPE":
                                                        E.type = P.toUpperCase();
                                                        break;
                                                    case "MEDIA-SEQUENCE":
                                                        S = E.startSN = parseInt(P);
                                                        break;
                                                    case "SKIP":
                                                        var U = new l.AttrList(P), j = U.decimalInteger("SKIPPED-SEGMENTS");
                                                        if ((0, r.isFiniteNumber)(j)) {
                                                            E.skippedSegments = j;
                                                            for(var B = j; B--;)A.unshift(null);
                                                            S += j;
                                                        }
                                                        var G = U.enumeratedString("RECENTLY-REMOVED-DATERANGES");
                                                        G && (E.recentlyRemovedDateranges = G.split("\t"));
                                                        break;
                                                    case "TARGETDURATION":
                                                        E.targetduration = parseFloat(P);
                                                        break;
                                                    case "VERSION":
                                                        E.version = parseInt(P);
                                                        break;
                                                    case "EXTM3U":
                                                        break;
                                                    case "ENDLIST":
                                                        E.live = !1;
                                                        break;
                                                    case "#":
                                                        (P || F) && D.tagList.push(F ? [
                                                            P,
                                                            F
                                                        ] : [
                                                            P
                                                        ]);
                                                        break;
                                                    case "DISCONTINUITY":
                                                        R++, D.tagList.push([
                                                            "DIS"
                                                        ]);
                                                        break;
                                                    case "GAP":
                                                        D.tagList.push([
                                                            O
                                                        ]);
                                                        break;
                                                    case "BITRATE":
                                                        D.tagList.push([
                                                            O,
                                                            P
                                                        ]);
                                                        break;
                                                    case "DATERANGE":
                                                        var H = new l.AttrList(P), V = new a1.DateRange(H, E.dateRanges[H.ID]);
                                                        V.isValid || E.skippedSegments ? E.dateRanges[V.id] = V : c.logger.warn('Ignoring invalid DATERANGE tag: "' + P + '"'), D.tagList.push([
                                                            "EXT-X-DATERANGE",
                                                            P
                                                        ]);
                                                        break;
                                                    case "DISCONTINUITY-SEQUENCE":
                                                        R = parseInt(P);
                                                        break;
                                                    case "KEY":
                                                        var K, q = new l.AttrList(P), Y = q.enumeratedString("METHOD"), W = q.URI, z = q.hexadecimalInteger("IV"), X = q.enumeratedString("KEYFORMATVERSIONS"), Q = q.enumeratedString("KEYID"), J = null != (K = q.enumeratedString("KEYFORMAT")) ? K : "identity";
                                                        if ([
                                                            "com.apple.streamingkeydelivery",
                                                            "com.microsoft.playready",
                                                            "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed",
                                                            "com.widevine"
                                                        ].indexOf(J) > -1) {
                                                            c.logger.warn("Keyformat " + J + " is not supported from the manifest");
                                                            continue;
                                                        }
                                                        if ("identity" !== J) continue;
                                                        Y && (y = u.LevelKey.fromURL(t, W), W && [
                                                            "AES-128",
                                                            "SAMPLE-AES",
                                                            "SAMPLE-AES-CENC"
                                                        ].indexOf(Y) >= 0 && (y.method = Y, y.keyFormat = J, Q && (y.keyID = Q), X && (y.keyFormatVersions = X), y.iv = z));
                                                        break;
                                                    case "START":
                                                        var Z = new l.AttrList(P).decimalFloatingPoint("TIME-OFFSET");
                                                        (0, r.isFiniteNumber)(Z) && (E.startTimeOffset = Z);
                                                        break;
                                                    case "MAP":
                                                        var $ = new l.AttrList(P);
                                                        if (D.duration) {
                                                            var ee = new o.Fragment(d, t);
                                                            b(ee, $, n, y), _ = ee, D.initSegment = _, _.rawProgramDateTime && !D.rawProgramDateTime && (D.rawProgramDateTime = _.rawProgramDateTime);
                                                        } else b(D, $, n, y), _ = D, N = !0;
                                                        break;
                                                    case "SERVER-CONTROL":
                                                        var te = new l.AttrList(P);
                                                        E.canBlockReload = te.bool("CAN-BLOCK-RELOAD"), E.canSkipUntil = te.optionalFloat("CAN-SKIP-UNTIL", 0), E.canSkipDateRanges = E.canSkipUntil > 0 && te.bool("CAN-SKIP-DATERANGES"), E.partHoldBack = te.optionalFloat("PART-HOLD-BACK", 0), E.holdBack = te.optionalFloat("HOLD-BACK", 0);
                                                        break;
                                                    case "PART-INF":
                                                        var ne = new l.AttrList(P);
                                                        E.partTarget = ne.decimalFloatingPoint("PART-TARGET");
                                                        break;
                                                    case "PART":
                                                        var re = E.partList;
                                                        re || (re = E.partList = []);
                                                        var ie = w > 0 ? re[re.length - 1] : void 0, ae = w++, oe = new o.Part(new l.AttrList(P), D, t, ae, ie);
                                                        re.push(oe), D.duration += oe.duration;
                                                        break;
                                                    case "PRELOAD-HINT":
                                                        var se = new l.AttrList(P);
                                                        E.preloadHint = se;
                                                        break;
                                                    case "RENDITION-REPORT":
                                                        var ue = new l.AttrList(P);
                                                        E.renditionReports = E.renditionReports || [], E.renditionReports.push(ue);
                                                        break;
                                                    default:
                                                        c.logger.warn("line parsed but not handled: " + h);
                                                }
                                            }
                                        }
                                        C && !C.relurl ? (A.pop(), I -= C.duration, E.partList && (E.fragmentHint = C)) : E.partList && (T(D, C), D.cc = R, E.fragmentHint = D);
                                        var le = A.length, ce = A[0], de = A[le - 1];
                                        if ((I += E.skippedSegments * E.targetduration) > 0 && le && de) {
                                            E.averagetargetduration = I / le;
                                            var fe = de.sn;
                                            E.endSN = "initSegment" !== fe ? fe : 0, ce && (E.startCC = ce.cc, ce.initSegment || E.fragments.every(function(e) {
                                                var t, n, r;
                                                return e.relurl && (t = e.relurl, m.test(null != (n = null === (r = i.parseURL(t)) || void 0 === r ? void 0 : r.path) ? n : ""));
                                            }) && (c.logger.warn("MP4 fragments found but no init segment (probably no MAP, incomplete M3U8), trying to fetch SIDX"), (D = new o.Fragment(d, t)).relurl = de.relurl, D.level = n, D.sn = "initSegment", ce.initSegment = D, E.needSidxRanges = !0));
                                        } else E.endSN = 0, E.startCC = 0;
                                        return E.fragmentHint && (I += E.fragmentHint.duration), E.totalduration = I, E.endCC = R, k > 0 && function(e, t) {
                                            for(var n = e[t], r = t; r--;){
                                                var i = e[r];
                                                if (!i) return;
                                                i.programDateTime = n.programDateTime - 1e3 * i.duration, n = i;
                                            }
                                        }(A, k), E;
                                    }, e;
                                }();
                                function y(e, t) {
                                    [
                                        "video",
                                        "audio",
                                        "text"
                                    ].forEach(function(n) {
                                        var r = e.filter(function(e) {
                                            return (0, d.isCodecType)(e, n);
                                        });
                                        if (r.length) {
                                            var i = r.filter(function(e) {
                                                return 0 === e.lastIndexOf("avc1", 0) || 0 === e.lastIndexOf("mp4a", 0);
                                            });
                                            t[n + "Codec"] = i.length > 0 ? i[0] : r[0], e = e.filter(function(e) {
                                                return -1 === r.indexOf(e);
                                            });
                                        }
                                    }), t.unknownCodecs = e;
                                }
                                function E(e, t, n) {
                                    var r = t[n];
                                    r && (e[n] = r);
                                }
                                function T(e, t) {
                                    e.rawProgramDateTime ? e.programDateTime = Date.parse(e.rawProgramDateTime) : null != t && t.programDateTime && (e.programDateTime = t.endProgramDateTime), (0, r.isFiniteNumber)(e.programDateTime) || (e.programDateTime = null, e.rawProgramDateTime = null);
                                }
                                function b(e, t, n, r) {
                                    e.relurl = t.URI, t.BYTERANGE && e.setByteRange(t.BYTERANGE), e.level = n, e.sn = "initSegment", r && (e.levelkey = r), e.initSegment = null;
                                }
                            },
                            "./src/loader/playlist-loader.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>f
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./src/events.ts"), a1 = n("./src/errors.ts"), o = n("./src/utils/logger.ts"), s1 = n("./src/utils/mp4-tools.ts"), u = n("./src/loader/m3u8-parser.ts"), l = n("./src/types/loader.ts"), c = n("./src/utils/attr-list.ts");
                                function d(e, t) {
                                    var n = e.url;
                                    return void 0 !== n && 0 !== n.indexOf("data:") || (n = t.url), n;
                                }
                                const f = function() {
                                    function e(e) {
                                        this.hls = void 0, this.loaders = Object.create(null), this.hls = e, this.registerListeners();
                                    }
                                    var t = e.prototype;
                                    return t.startLoad = function(e) {}, t.stopLoad = function() {
                                        this.destroyInternalLoaders();
                                    }, t.registerListeners = function() {
                                        var e = this.hls;
                                        e.on(i.Events.MANIFEST_LOADING, this.onManifestLoading, this), e.on(i.Events.LEVEL_LOADING, this.onLevelLoading, this), e.on(i.Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.on(i.Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
                                    }, t.unregisterListeners = function() {
                                        var e = this.hls;
                                        e.off(i.Events.MANIFEST_LOADING, this.onManifestLoading, this), e.off(i.Events.LEVEL_LOADING, this.onLevelLoading, this), e.off(i.Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.off(i.Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
                                    }, t.createInternalLoader = function(e) {
                                        var t = this.hls.config, n = t.pLoader, r = t.loader, i = new (n || r)(t);
                                        return e.loader = i, this.loaders[e.type] = i, i;
                                    }, t.getInternalLoader = function(e) {
                                        return this.loaders[e.type];
                                    }, t.resetInternalLoader = function(e) {
                                        this.loaders[e] && delete this.loaders[e];
                                    }, t.destroyInternalLoaders = function() {
                                        for(var e in this.loaders){
                                            var t = this.loaders[e];
                                            t && t.destroy(), this.resetInternalLoader(e);
                                        }
                                    }, t.destroy = function() {
                                        this.unregisterListeners(), this.destroyInternalLoaders();
                                    }, t.onManifestLoading = function(e, t) {
                                        var n = t.url;
                                        this.load({
                                            id: null,
                                            groupId: null,
                                            level: 0,
                                            responseType: "text",
                                            type: l.PlaylistContextType.MANIFEST,
                                            url: n,
                                            deliveryDirectives: null
                                        });
                                    }, t.onLevelLoading = function(e, t) {
                                        var n = t.id, r = t.level, i = t.url, a1 = t.deliveryDirectives;
                                        this.load({
                                            id: n,
                                            groupId: null,
                                            level: r,
                                            responseType: "text",
                                            type: l.PlaylistContextType.LEVEL,
                                            url: i,
                                            deliveryDirectives: a1
                                        });
                                    }, t.onAudioTrackLoading = function(e, t) {
                                        var n = t.id, r = t.groupId, i = t.url, a1 = t.deliveryDirectives;
                                        this.load({
                                            id: n,
                                            groupId: r,
                                            level: null,
                                            responseType: "text",
                                            type: l.PlaylistContextType.AUDIO_TRACK,
                                            url: i,
                                            deliveryDirectives: a1
                                        });
                                    }, t.onSubtitleTrackLoading = function(e, t) {
                                        var n = t.id, r = t.groupId, i = t.url, a1 = t.deliveryDirectives;
                                        this.load({
                                            id: n,
                                            groupId: r,
                                            level: null,
                                            responseType: "text",
                                            type: l.PlaylistContextType.SUBTITLE_TRACK,
                                            url: i,
                                            deliveryDirectives: a1
                                        });
                                    }, t.load = function(e) {
                                        var t, n, r, i, a1, s1, u = this.hls.config, c = this.getInternalLoader(e);
                                        if (c) {
                                            var d = c.context;
                                            if (d && d.url === e.url) return void o.logger.trace("[playlist-loader]: playlist request ongoing");
                                            o.logger.log("[playlist-loader]: aborting previous loader for type: " + e.type), c.abort();
                                        }
                                        switch(e.type){
                                            case l.PlaylistContextType.MANIFEST:
                                                n = u.manifestLoadingMaxRetry, r = u.manifestLoadingTimeOut, i = u.manifestLoadingRetryDelay, a1 = u.manifestLoadingMaxRetryTimeout;
                                                break;
                                            case l.PlaylistContextType.LEVEL:
                                            case l.PlaylistContextType.AUDIO_TRACK:
                                            case l.PlaylistContextType.SUBTITLE_TRACK:
                                                n = 0, r = u.levelLoadingTimeOut;
                                                break;
                                            default:
                                                n = u.levelLoadingMaxRetry, r = u.levelLoadingTimeOut, i = u.levelLoadingRetryDelay, a1 = u.levelLoadingMaxRetryTimeout;
                                        }
                                        if (c = this.createInternalLoader(e), null !== (t = e.deliveryDirectives) && void 0 !== t && t.part && (e.type === l.PlaylistContextType.LEVEL && null !== e.level ? s1 = this.hls.levels[e.level].details : e.type === l.PlaylistContextType.AUDIO_TRACK && null !== e.id ? s1 = this.hls.audioTracks[e.id].details : e.type === l.PlaylistContextType.SUBTITLE_TRACK && null !== e.id && (s1 = this.hls.subtitleTracks[e.id].details), s1)) {
                                            var f = s1.partTarget, h = s1.targetduration;
                                            f && h && (r = Math.min(1e3 * Math.max(3 * f, .8 * h), r));
                                        }
                                        var g = {
                                            timeout: r,
                                            maxRetry: n,
                                            retryDelay: i,
                                            maxRetryDelay: a1,
                                            highWaterMark: 0
                                        }, p = {
                                            onSuccess: this.loadsuccess.bind(this),
                                            onError: this.loaderror.bind(this),
                                            onTimeout: this.loadtimeout.bind(this)
                                        };
                                        c.load(e, g, p);
                                    }, t.loadsuccess = function(e, t, n, r) {
                                        if (void 0 === r && (r = null), n.isSidxRequest) return this.handleSidxRequest(e, n), void this.handlePlaylistLoaded(e, t, n, r);
                                        this.resetInternalLoader(n.type);
                                        var i = e.data;
                                        0 === i.indexOf("#EXTM3U") ? (t.parsing.start = performance.now(), i.indexOf("#EXTINF:") > 0 || i.indexOf("#EXT-X-TARGETDURATION:") > 0 ? this.handleTrackOrLevelPlaylist(e, t, n, r) : this.handleMasterPlaylist(e, t, n, r)) : this.handleManifestParsingError(e, n, "no EXTM3U delimiter", r);
                                    }, t.loaderror = function(e, t, n) {
                                        void 0 === n && (n = null), this.handleNetworkError(t, n, !1, e);
                                    }, t.loadtimeout = function(e, t, n) {
                                        void 0 === n && (n = null), this.handleNetworkError(t, n, !0);
                                    }, t.handleMasterPlaylist = function(e, t, n, r) {
                                        var a1 = this.hls, s1 = e.data, l = d(e, n), f = u.default.parseMasterPlaylist(s1, l), h = f.levels, g = f.sessionData;
                                        if (h.length) {
                                            var p = h.map(function(e) {
                                                return {
                                                    id: e.attrs.AUDIO,
                                                    audioCodec: e.audioCodec
                                                };
                                            }), m = h.map(function(e) {
                                                return {
                                                    id: e.attrs.SUBTITLES,
                                                    textCodec: e.textCodec
                                                };
                                            }), v = u.default.parseMasterPlaylistMedia(s1, l, "AUDIO", p), y = u.default.parseMasterPlaylistMedia(s1, l, "SUBTITLES", m), E = u.default.parseMasterPlaylistMedia(s1, l, "CLOSED-CAPTIONS");
                                            v.length && (v.some(function(e) {
                                                return !e.url;
                                            }) || !h[0].audioCodec || h[0].attrs.AUDIO || (o.logger.log("[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one"), v.unshift({
                                                type: "main",
                                                name: "main",
                                                default: !1,
                                                autoselect: !1,
                                                forced: !1,
                                                id: -1,
                                                attrs: new c.AttrList({}),
                                                bitrate: 0,
                                                url: ""
                                            }))), a1.trigger(i.Events.MANIFEST_LOADED, {
                                                levels: h,
                                                audioTracks: v,
                                                subtitles: y,
                                                captions: E,
                                                url: l,
                                                stats: t,
                                                networkDetails: r,
                                                sessionData: g
                                            });
                                        } else this.handleManifestParsingError(e, n, "no level found in manifest", r);
                                    }, t.handleTrackOrLevelPlaylist = function(e, t, n, o) {
                                        var s1 = this.hls, f = n.id, h = n.level, g = n.type, p = d(e, n), m = (0, r.isFiniteNumber)(f) ? f : 0, v = (0, r.isFiniteNumber)(h) ? h : m, y = function(e) {
                                            switch(e.type){
                                                case l.PlaylistContextType.AUDIO_TRACK:
                                                    return l.PlaylistLevelType.AUDIO;
                                                case l.PlaylistContextType.SUBTITLE_TRACK:
                                                    return l.PlaylistLevelType.SUBTITLE;
                                                default:
                                                    return l.PlaylistLevelType.MAIN;
                                            }
                                        }(n), E = u.default.parseLevelPlaylist(e.data, p, v, y, m);
                                        if (E.fragments.length) {
                                            if (g === l.PlaylistContextType.MANIFEST) {
                                                var T = {
                                                    attrs: new c.AttrList({}),
                                                    bitrate: 0,
                                                    details: E,
                                                    name: "",
                                                    url: p
                                                };
                                                s1.trigger(i.Events.MANIFEST_LOADED, {
                                                    levels: [
                                                        T
                                                    ],
                                                    audioTracks: [],
                                                    url: p,
                                                    stats: t,
                                                    networkDetails: o,
                                                    sessionData: null
                                                });
                                            }
                                            if (t.parsing.end = performance.now(), E.needSidxRanges) {
                                                var b, A = null === (b = E.fragments[0].initSegment) || void 0 === b ? void 0 : b.url;
                                                this.load({
                                                    url: A,
                                                    isSidxRequest: !0,
                                                    type: g,
                                                    level: h,
                                                    levelDetails: E,
                                                    id: f,
                                                    groupId: null,
                                                    rangeStart: 0,
                                                    rangeEnd: 2048,
                                                    responseType: "arraybuffer",
                                                    deliveryDirectives: null
                                                });
                                            } else n.levelDetails = E, this.handlePlaylistLoaded(e, t, n, o);
                                        } else s1.trigger(i.Events.ERROR, {
                                            type: a1.ErrorTypes.NETWORK_ERROR,
                                            details: a1.ErrorDetails.LEVEL_EMPTY_ERROR,
                                            fatal: !1,
                                            url: p,
                                            reason: "no fragments found in level",
                                            level: "number" == typeof n.level ? n.level : void 0
                                        });
                                    }, t.handleSidxRequest = function(e, t) {
                                        var n = new Uint8Array(e.data), r = (0, s1.findBox)(n, [
                                            "sidx"
                                        ])[0];
                                        if (r) {
                                            var i = (0, s1.parseSegmentIndex)(r);
                                            if (i) {
                                                var a1 = i.references, o = t.levelDetails;
                                                a1.forEach(function(e, t) {
                                                    var r = e.info, i = o.fragments[t];
                                                    if (0 === i.byteRange.length && i.setByteRange(String(1 + r.end - r.start) + "@" + String(r.start)), i.initSegment) {
                                                        var a1 = (0, s1.findBox)(n, [
                                                            "moov"
                                                        ])[0], u = a1 ? a1.length : null;
                                                        i.initSegment.setByteRange(String(u) + "@0");
                                                    }
                                                });
                                            }
                                        }
                                    }, t.handleManifestParsingError = function(e, t, n, r) {
                                        this.hls.trigger(i.Events.ERROR, {
                                            type: a1.ErrorTypes.NETWORK_ERROR,
                                            details: a1.ErrorDetails.MANIFEST_PARSING_ERROR,
                                            fatal: t.type === l.PlaylistContextType.MANIFEST,
                                            url: e.url,
                                            reason: n,
                                            response: e,
                                            context: t,
                                            networkDetails: r
                                        });
                                    }, t.handleNetworkError = function(e, t, n, r) {
                                        void 0 === n && (n = !1), o.logger.warn("[playlist-loader]: A network " + (n ? "timeout" : "error") + " occurred while loading " + e.type + " level: " + e.level + " id: " + e.id + ' group-id: "' + e.groupId + '"');
                                        var s1 = a1.ErrorDetails.UNKNOWN, u = !1, c = this.getInternalLoader(e);
                                        switch(e.type){
                                            case l.PlaylistContextType.MANIFEST:
                                                s1 = n ? a1.ErrorDetails.MANIFEST_LOAD_TIMEOUT : a1.ErrorDetails.MANIFEST_LOAD_ERROR, u = !0;
                                                break;
                                            case l.PlaylistContextType.LEVEL:
                                                s1 = n ? a1.ErrorDetails.LEVEL_LOAD_TIMEOUT : a1.ErrorDetails.LEVEL_LOAD_ERROR, u = !1;
                                                break;
                                            case l.PlaylistContextType.AUDIO_TRACK:
                                                s1 = n ? a1.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT : a1.ErrorDetails.AUDIO_TRACK_LOAD_ERROR, u = !1;
                                                break;
                                            case l.PlaylistContextType.SUBTITLE_TRACK:
                                                s1 = n ? a1.ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT : a1.ErrorDetails.SUBTITLE_LOAD_ERROR, u = !1;
                                        }
                                        c && this.resetInternalLoader(e.type);
                                        var d = {
                                            type: a1.ErrorTypes.NETWORK_ERROR,
                                            details: s1,
                                            fatal: u,
                                            url: e.url,
                                            loader: c,
                                            context: e,
                                            networkDetails: t
                                        };
                                        r && (d.response = r), this.hls.trigger(i.Events.ERROR, d);
                                    }, t.handlePlaylistLoaded = function(e, t, n, r) {
                                        var a1 = n.type, o = n.level, s1 = n.id, u = n.groupId, c = n.loader, d = n.levelDetails, f = n.deliveryDirectives;
                                        if (null != d && d.targetduration) {
                                            if (c) switch(d.live && (c.getCacheAge && (d.ageHeader = c.getCacheAge() || 0), c.getCacheAge && !isNaN(d.ageHeader) || (d.ageHeader = 0)), a1){
                                                case l.PlaylistContextType.MANIFEST:
                                                case l.PlaylistContextType.LEVEL:
                                                    this.hls.trigger(i.Events.LEVEL_LOADED, {
                                                        details: d,
                                                        level: o || 0,
                                                        id: s1 || 0,
                                                        stats: t,
                                                        networkDetails: r,
                                                        deliveryDirectives: f
                                                    });
                                                    break;
                                                case l.PlaylistContextType.AUDIO_TRACK:
                                                    this.hls.trigger(i.Events.AUDIO_TRACK_LOADED, {
                                                        details: d,
                                                        id: s1 || 0,
                                                        groupId: u || "",
                                                        stats: t,
                                                        networkDetails: r,
                                                        deliveryDirectives: f
                                                    });
                                                    break;
                                                case l.PlaylistContextType.SUBTITLE_TRACK:
                                                    this.hls.trigger(i.Events.SUBTITLE_TRACK_LOADED, {
                                                        details: d,
                                                        id: s1 || 0,
                                                        groupId: u || "",
                                                        stats: t,
                                                        networkDetails: r,
                                                        deliveryDirectives: f
                                                    });
                                            }
                                        } else this.handleManifestParsingError(e, n, "invalid target duration", r);
                                    }, e;
                                }();
                            },
                            "./src/polyfills/number.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    MAX_SAFE_INTEGER: ()=>i,
                                    isFiniteNumber: ()=>r
                                });
                                var r = Number.isFinite || function(e) {
                                    return "number" == typeof e && isFinite(e);
                                }, i = Number.MAX_SAFE_INTEGER || 9007199254740991;
                            },
                            "./src/remux/aac-helper.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>r
                                });
                                const r = function() {
                                    function e() {}
                                    return e.getSilentFrame = function(e, t) {
                                        if ("mp4a.40.2" === e) {
                                            if (1 === t) return new Uint8Array([
                                                0,
                                                200,
                                                0,
                                                128,
                                                35,
                                                128
                                            ]);
                                            if (2 === t) return new Uint8Array([
                                                33,
                                                0,
                                                73,
                                                144,
                                                2,
                                                25,
                                                0,
                                                35,
                                                128
                                            ]);
                                            if (3 === t) return new Uint8Array([
                                                0,
                                                200,
                                                0,
                                                128,
                                                32,
                                                132,
                                                1,
                                                38,
                                                64,
                                                8,
                                                100,
                                                0,
                                                142
                                            ]);
                                            if (4 === t) return new Uint8Array([
                                                0,
                                                200,
                                                0,
                                                128,
                                                32,
                                                132,
                                                1,
                                                38,
                                                64,
                                                8,
                                                100,
                                                0,
                                                128,
                                                44,
                                                128,
                                                8,
                                                2,
                                                56
                                            ]);
                                            if (5 === t) return new Uint8Array([
                                                0,
                                                200,
                                                0,
                                                128,
                                                32,
                                                132,
                                                1,
                                                38,
                                                64,
                                                8,
                                                100,
                                                0,
                                                130,
                                                48,
                                                4,
                                                153,
                                                0,
                                                33,
                                                144,
                                                2,
                                                56
                                            ]);
                                            if (6 === t) return new Uint8Array([
                                                0,
                                                200,
                                                0,
                                                128,
                                                32,
                                                132,
                                                1,
                                                38,
                                                64,
                                                8,
                                                100,
                                                0,
                                                130,
                                                48,
                                                4,
                                                153,
                                                0,
                                                33,
                                                144,
                                                2,
                                                0,
                                                178,
                                                0,
                                                32,
                                                8,
                                                224
                                            ]);
                                        } else {
                                            if (1 === t) return new Uint8Array([
                                                1,
                                                64,
                                                34,
                                                128,
                                                163,
                                                78,
                                                230,
                                                128,
                                                186,
                                                8,
                                                0,
                                                0,
                                                0,
                                                28,
                                                6,
                                                241,
                                                193,
                                                10,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                94
                                            ]);
                                            if (2 === t) return new Uint8Array([
                                                1,
                                                64,
                                                34,
                                                128,
                                                163,
                                                94,
                                                230,
                                                128,
                                                186,
                                                8,
                                                0,
                                                0,
                                                0,
                                                0,
                                                149,
                                                0,
                                                6,
                                                241,
                                                161,
                                                10,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                94
                                            ]);
                                            if (3 === t) return new Uint8Array([
                                                1,
                                                64,
                                                34,
                                                128,
                                                163,
                                                94,
                                                230,
                                                128,
                                                186,
                                                8,
                                                0,
                                                0,
                                                0,
                                                0,
                                                149,
                                                0,
                                                6,
                                                241,
                                                161,
                                                10,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                90,
                                                94
                                            ]);
                                        }
                                    }, e;
                                }();
                            },
                            "./src/remux/mp4-generator.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>a1
                                });
                                var r = Math.pow(2, 32) - 1, i = function() {
                                    function e() {}
                                    return e.init = function() {
                                        var t;
                                        for(t in e.types = {
                                            avc1: [],
                                            avcC: [],
                                            btrt: [],
                                            dinf: [],
                                            dref: [],
                                            esds: [],
                                            ftyp: [],
                                            hdlr: [],
                                            mdat: [],
                                            mdhd: [],
                                            mdia: [],
                                            mfhd: [],
                                            minf: [],
                                            moof: [],
                                            moov: [],
                                            mp4a: [],
                                            ".mp3": [],
                                            mvex: [],
                                            mvhd: [],
                                            pasp: [],
                                            sdtp: [],
                                            stbl: [],
                                            stco: [],
                                            stsc: [],
                                            stsd: [],
                                            stsz: [],
                                            stts: [],
                                            tfdt: [],
                                            tfhd: [],
                                            traf: [],
                                            trak: [],
                                            trun: [],
                                            trex: [],
                                            tkhd: [],
                                            vmhd: [],
                                            smhd: []
                                        }, e.types)e.types.hasOwnProperty(t) && (e.types[t] = [
                                            t.charCodeAt(0),
                                            t.charCodeAt(1),
                                            t.charCodeAt(2),
                                            t.charCodeAt(3)
                                        ]);
                                        var n = new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            118,
                                            105,
                                            100,
                                            101,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            86,
                                            105,
                                            100,
                                            101,
                                            111,
                                            72,
                                            97,
                                            110,
                                            100,
                                            108,
                                            101,
                                            114,
                                            0
                                        ]), r = new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            115,
                                            111,
                                            117,
                                            110,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            83,
                                            111,
                                            117,
                                            110,
                                            100,
                                            72,
                                            97,
                                            110,
                                            100,
                                            108,
                                            101,
                                            114,
                                            0
                                        ]);
                                        e.HDLR_TYPES = {
                                            video: n,
                                            audio: r
                                        };
                                        var i = new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            12,
                                            117,
                                            114,
                                            108,
                                            32,
                                            0,
                                            0,
                                            0,
                                            1
                                        ]), a1 = new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0
                                        ]);
                                        e.STTS = e.STSC = e.STCO = a1, e.STSZ = new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0
                                        ]), e.VMHD = new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0
                                        ]), e.SMHD = new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0
                                        ]), e.STSD = new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ]);
                                        var o = new Uint8Array([
                                            105,
                                            115,
                                            111,
                                            109
                                        ]), s1 = new Uint8Array([
                                            97,
                                            118,
                                            99,
                                            49
                                        ]), u = new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            1
                                        ]);
                                        e.FTYP = e.box(e.types.ftyp, o, u, o, s1), e.DINF = e.box(e.types.dinf, e.box(e.types.dref, i));
                                    }, e.box = function(e) {
                                        for(var t = 8, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)r[i - 1] = arguments[i];
                                        for(var a1 = r.length, o = a1; a1--;)t += r[a1].byteLength;
                                        var s1 = new Uint8Array(t);
                                        for(s1[0] = t >> 24 & 255, s1[1] = t >> 16 & 255, s1[2] = t >> 8 & 255, s1[3] = 255 & t, s1.set(e, 4), a1 = 0, t = 8; a1 < o; a1++)s1.set(r[a1], t), t += r[a1].byteLength;
                                        return s1;
                                    }, e.hdlr = function(t) {
                                        return e.box(e.types.hdlr, e.HDLR_TYPES[t]);
                                    }, e.mdat = function(t) {
                                        return e.box(e.types.mdat, t);
                                    }, e.mdhd = function(t, n) {
                                        n *= t;
                                        var i = Math.floor(n / (r + 1)), a1 = Math.floor(n % (r + 1));
                                        return e.box(e.types.mdhd, new Uint8Array([
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            2,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            3,
                                            t >> 24 & 255,
                                            t >> 16 & 255,
                                            t >> 8 & 255,
                                            255 & t,
                                            i >> 24,
                                            i >> 16 & 255,
                                            i >> 8 & 255,
                                            255 & i,
                                            a1 >> 24,
                                            a1 >> 16 & 255,
                                            a1 >> 8 & 255,
                                            255 & a1,
                                            85,
                                            196,
                                            0,
                                            0
                                        ]));
                                    }, e.mdia = function(t) {
                                        return e.box(e.types.mdia, e.mdhd(t.timescale, t.duration), e.hdlr(t.type), e.minf(t));
                                    }, e.mfhd = function(t) {
                                        return e.box(e.types.mfhd, new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            0,
                                            t >> 24,
                                            t >> 16 & 255,
                                            t >> 8 & 255,
                                            255 & t
                                        ]));
                                    }, e.minf = function(t) {
                                        return "audio" === t.type ? e.box(e.types.minf, e.box(e.types.smhd, e.SMHD), e.DINF, e.stbl(t)) : e.box(e.types.minf, e.box(e.types.vmhd, e.VMHD), e.DINF, e.stbl(t));
                                    }, e.moof = function(t, n, r) {
                                        return e.box(e.types.moof, e.mfhd(t), e.traf(r, n));
                                    }, e.moov = function(t) {
                                        for(var n = t.length, r = []; n--;)r[n] = e.trak(t[n]);
                                        return e.box.apply(null, [
                                            e.types.moov,
                                            e.mvhd(t[0].timescale, t[0].duration)
                                        ].concat(r).concat(e.mvex(t)));
                                    }, e.mvex = function(t) {
                                        for(var n = t.length, r = []; n--;)r[n] = e.trex(t[n]);
                                        return e.box.apply(null, [
                                            e.types.mvex
                                        ].concat(r));
                                    }, e.mvhd = function(t, n) {
                                        n *= t;
                                        var i = Math.floor(n / (r + 1)), a1 = Math.floor(n % (r + 1)), o = new Uint8Array([
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            2,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            3,
                                            t >> 24 & 255,
                                            t >> 16 & 255,
                                            t >> 8 & 255,
                                            255 & t,
                                            i >> 24,
                                            i >> 16 & 255,
                                            i >> 8 & 255,
                                            255 & i,
                                            a1 >> 24,
                                            a1 >> 16 & 255,
                                            a1 >> 8 & 255,
                                            255 & a1,
                                            0,
                                            1,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            64,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            255,
                                            255,
                                            255,
                                            255
                                        ]);
                                        return e.box(e.types.mvhd, o);
                                    }, e.sdtp = function(t) {
                                        var n, r, i = t.samples || [], a1 = new Uint8Array(4 + i.length);
                                        for(n = 0; n < i.length; n++)r = i[n].flags, a1[n + 4] = r.dependsOn << 4 | r.isDependedOn << 2 | r.hasRedundancy;
                                        return e.box(e.types.sdtp, a1);
                                    }, e.stbl = function(t) {
                                        return e.box(e.types.stbl, e.stsd(t), e.box(e.types.stts, e.STTS), e.box(e.types.stsc, e.STSC), e.box(e.types.stsz, e.STSZ), e.box(e.types.stco, e.STCO));
                                    }, e.avc1 = function(t) {
                                        var n, r, i, a1 = [], o = [];
                                        for(n = 0; n < t.sps.length; n++)i = (r = t.sps[n]).byteLength, a1.push(i >>> 8 & 255), a1.push(255 & i), a1 = a1.concat(Array.prototype.slice.call(r));
                                        for(n = 0; n < t.pps.length; n++)i = (r = t.pps[n]).byteLength, o.push(i >>> 8 & 255), o.push(255 & i), o = o.concat(Array.prototype.slice.call(r));
                                        var s1 = e.box(e.types.avcC, new Uint8Array([
                                            1,
                                            a1[3],
                                            a1[4],
                                            a1[5],
                                            255,
                                            224 | t.sps.length
                                        ].concat(a1).concat([
                                            t.pps.length
                                        ]).concat(o))), u = t.width, l = t.height, c = t.pixelRatio[0], d = t.pixelRatio[1];
                                        return e.box(e.types.avc1, new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            u >> 8 & 255,
                                            255 & u,
                                            l >> 8 & 255,
                                            255 & l,
                                            0,
                                            72,
                                            0,
                                            0,
                                            0,
                                            72,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            18,
                                            100,
                                            97,
                                            105,
                                            108,
                                            121,
                                            109,
                                            111,
                                            116,
                                            105,
                                            111,
                                            110,
                                            47,
                                            104,
                                            108,
                                            115,
                                            46,
                                            106,
                                            115,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            24,
                                            17,
                                            17
                                        ]), s1, e.box(e.types.btrt, new Uint8Array([
                                            0,
                                            28,
                                            156,
                                            128,
                                            0,
                                            45,
                                            198,
                                            192,
                                            0,
                                            45,
                                            198,
                                            192
                                        ])), e.box(e.types.pasp, new Uint8Array([
                                            c >> 24,
                                            c >> 16 & 255,
                                            c >> 8 & 255,
                                            255 & c,
                                            d >> 24,
                                            d >> 16 & 255,
                                            d >> 8 & 255,
                                            255 & d
                                        ])));
                                    }, e.esds = function(e) {
                                        var t = e.config.length;
                                        return new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            0,
                                            3,
                                            23 + t,
                                            0,
                                            1,
                                            0,
                                            4,
                                            15 + t,
                                            64,
                                            21,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            5
                                        ].concat([
                                            t
                                        ]).concat(e.config).concat([
                                            6,
                                            1,
                                            2
                                        ]));
                                    }, e.mp4a = function(t) {
                                        var n = t.samplerate;
                                        return e.box(e.types.mp4a, new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            t.channelCount,
                                            0,
                                            16,
                                            0,
                                            0,
                                            0,
                                            0,
                                            n >> 8 & 255,
                                            255 & n,
                                            0,
                                            0
                                        ]), e.box(e.types.esds, e.esds(t)));
                                    }, e.mp3 = function(t) {
                                        var n = t.samplerate;
                                        return e.box(e.types[".mp3"], new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            t.channelCount,
                                            0,
                                            16,
                                            0,
                                            0,
                                            0,
                                            0,
                                            n >> 8 & 255,
                                            255 & n,
                                            0,
                                            0
                                        ]));
                                    }, e.stsd = function(t) {
                                        return "audio" === t.type ? "mp3" === t.segmentCodec && "mp3" === t.codec ? e.box(e.types.stsd, e.STSD, e.mp3(t)) : e.box(e.types.stsd, e.STSD, e.mp4a(t)) : e.box(e.types.stsd, e.STSD, e.avc1(t));
                                    }, e.tkhd = function(t) {
                                        var n = t.id, i = t.duration * t.timescale, a1 = t.width, o = t.height, s1 = Math.floor(i / (r + 1)), u = Math.floor(i % (r + 1));
                                        return e.box(e.types.tkhd, new Uint8Array([
                                            1,
                                            0,
                                            0,
                                            7,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            2,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            3,
                                            n >> 24 & 255,
                                            n >> 16 & 255,
                                            n >> 8 & 255,
                                            255 & n,
                                            0,
                                            0,
                                            0,
                                            0,
                                            s1 >> 24,
                                            s1 >> 16 & 255,
                                            s1 >> 8 & 255,
                                            255 & s1,
                                            u >> 24,
                                            u >> 16 & 255,
                                            u >> 8 & 255,
                                            255 & u,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            64,
                                            0,
                                            0,
                                            0,
                                            a1 >> 8 & 255,
                                            255 & a1,
                                            0,
                                            0,
                                            o >> 8 & 255,
                                            255 & o,
                                            0,
                                            0
                                        ]));
                                    }, e.traf = function(t, n) {
                                        var i = e.sdtp(t), a1 = t.id, o = Math.floor(n / (r + 1)), s1 = Math.floor(n % (r + 1));
                                        return e.box(e.types.traf, e.box(e.types.tfhd, new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            0,
                                            a1 >> 24,
                                            a1 >> 16 & 255,
                                            a1 >> 8 & 255,
                                            255 & a1
                                        ])), e.box(e.types.tfdt, new Uint8Array([
                                            1,
                                            0,
                                            0,
                                            0,
                                            o >> 24,
                                            o >> 16 & 255,
                                            o >> 8 & 255,
                                            255 & o,
                                            s1 >> 24,
                                            s1 >> 16 & 255,
                                            s1 >> 8 & 255,
                                            255 & s1
                                        ])), e.trun(t, i.length + 16 + 20 + 8 + 16 + 8 + 8), i);
                                    }, e.trak = function(t) {
                                        return t.duration = t.duration || 4294967295, e.box(e.types.trak, e.tkhd(t), e.mdia(t));
                                    }, e.trex = function(t) {
                                        var n = t.id;
                                        return e.box(e.types.trex, new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            0,
                                            n >> 24,
                                            n >> 16 & 255,
                                            n >> 8 & 255,
                                            255 & n,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            1
                                        ]));
                                    }, e.trun = function(t, n) {
                                        var r, i, a1, o, s1, u, l = t.samples || [], c = l.length, d = 12 + 16 * c, f = new Uint8Array(d);
                                        for(n += 8 + d, f.set([
                                            "video" === t.type ? 1 : 0,
                                            0,
                                            15,
                                            1,
                                            c >>> 24 & 255,
                                            c >>> 16 & 255,
                                            c >>> 8 & 255,
                                            255 & c,
                                            n >>> 24 & 255,
                                            n >>> 16 & 255,
                                            n >>> 8 & 255,
                                            255 & n
                                        ], 0), r = 0; r < c; r++)a1 = (i = l[r]).duration, o = i.size, s1 = i.flags, u = i.cts, f.set([
                                            a1 >>> 24 & 255,
                                            a1 >>> 16 & 255,
                                            a1 >>> 8 & 255,
                                            255 & a1,
                                            o >>> 24 & 255,
                                            o >>> 16 & 255,
                                            o >>> 8 & 255,
                                            255 & o,
                                            s1.isLeading << 2 | s1.dependsOn,
                                            s1.isDependedOn << 6 | s1.hasRedundancy << 4 | s1.paddingValue << 1 | s1.isNonSync,
                                            61440 & s1.degradPrio,
                                            15 & s1.degradPrio,
                                            u >>> 24 & 255,
                                            u >>> 16 & 255,
                                            u >>> 8 & 255,
                                            255 & u
                                        ], 12 + 16 * r);
                                        return e.box(e.types.trun, f);
                                    }, e.initSegment = function(t) {
                                        e.types || e.init();
                                        var n = e.moov(t), r = new Uint8Array(e.FTYP.byteLength + n.byteLength);
                                        return r.set(e.FTYP), r.set(n, e.FTYP.byteLength), r;
                                    }, e;
                                }();
                                i.types = void 0, i.HDLR_TYPES = void 0, i.STTS = void 0, i.STSC = void 0, i.STCO = void 0, i.STSZ = void 0, i.VMHD = void 0, i.SMHD = void 0, i.STSD = void 0, i.FTYP = void 0, i.DINF = void 0;
                                const a1 = i;
                            },
                            "./src/remux/mp4-remuxer.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>g,
                                    flushTextTrackMetadataCueSamples: ()=>m,
                                    flushTextTrackUserdataCueSamples: ()=>v,
                                    normalizePts: ()=>p
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./src/remux/aac-helper.ts"), a1 = n("./src/remux/mp4-generator.ts"), o = n("./src/events.ts"), s1 = n("./src/errors.ts"), u = n("./src/utils/logger.ts"), l = n("./src/types/loader.ts"), c = n("./src/utils/timescale-conversion.ts");
                                function d() {
                                    return d = Object.assign ? Object.assign.bind() : function(e) {
                                        for(var t = 1; t < arguments.length; t++){
                                            var n = arguments[t];
                                            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                                        }
                                        return e;
                                    }, d.apply(this, arguments);
                                }
                                var f = null, h = null, g = function() {
                                    function e(e, t, n, r) {
                                        if (void 0 === r && (r = ""), this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.ISGenerated = !1, this._initPTS = void 0, this._initDTS = void 0, this.nextAvcDts = null, this.nextAudioPts = null, this.videoSampleDuration = null, this.isAudioContiguous = !1, this.isVideoContiguous = !1, this.observer = e, this.config = t, this.typeSupported = n, this.ISGenerated = !1, null === f) {
                                            var i = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
                                            f = i ? parseInt(i[1]) : 0;
                                        }
                                        if (null === h) {
                                            var a1 = navigator.userAgent.match(/Safari\/(\d+)/i);
                                            h = a1 ? parseInt(a1[1]) : 0;
                                        }
                                    }
                                    var t = e.prototype;
                                    return t.destroy = function() {}, t.resetTimeStamp = function(e) {
                                        u.logger.log("[mp4-remuxer]: initPTS & initDTS reset"), this._initPTS = this._initDTS = e;
                                    }, t.resetNextTimestamp = function() {
                                        u.logger.log("[mp4-remuxer]: reset next timestamp"), this.isVideoContiguous = !1, this.isAudioContiguous = !1;
                                    }, t.resetInitSegment = function() {
                                        u.logger.log("[mp4-remuxer]: ISGenerated flag reset"), this.ISGenerated = !1;
                                    }, t.getVideoStartPts = function(e) {
                                        var t = !1, n = e.reduce(function(e, n) {
                                            var r = n.pts - e;
                                            return r < -4294967296 ? (t = !0, p(e, n.pts)) : r > 0 ? e : n.pts;
                                        }, e[0].pts);
                                        return t && u.logger.debug("PTS rollover detected"), n;
                                    }, t.remux = function(e, t, n, r, i, a1, o, s1) {
                                        var c, d, f, h, g, y, E = i, T = i, b = e.pid > -1, A = t.pid > -1, _ = t.samples.length, S = e.samples.length > 0, w = o && _ > 0 || _ > 1;
                                        if ((!b || S) && (!A || w) || this.ISGenerated || o) {
                                            this.ISGenerated || (f = this.generateIS(e, t, i));
                                            var I, R = this.isVideoContiguous, C = -1;
                                            if (w && (C = function(e) {
                                                for(var t = 0; t < e.length; t++)if (e[t].key) return t;
                                                return -1;
                                            }(t.samples), !R && this.config.forceKeyFrameOnDiscontinuity)) {
                                                if (y = !0, C > 0) {
                                                    u.logger.warn("[mp4-remuxer]: Dropped " + C + " out of " + _ + " video samples due to a missing keyframe");
                                                    var D = this.getVideoStartPts(t.samples);
                                                    t.samples = t.samples.slice(C), t.dropped += C, I = T += (t.samples[0].pts - D) / t.inputTimeScale;
                                                } else -1 === C && (u.logger.warn("[mp4-remuxer]: No keyframe found out of " + _ + " video samples"), y = !1);
                                            }
                                            if (this.ISGenerated) {
                                                if (S && w) {
                                                    var k = this.getVideoStartPts(t.samples), N = (p(e.samples[0].pts, k) - k) / t.inputTimeScale;
                                                    E += Math.max(0, N), T += Math.max(0, -N);
                                                }
                                                if (S) {
                                                    if (e.samplerate || (u.logger.warn("[mp4-remuxer]: regenerate InitSegment as audio detected"), f = this.generateIS(e, t, i)), d = this.remuxAudio(e, E, this.isAudioContiguous, a1, A || w || s1 === l.PlaylistLevelType.AUDIO ? T : void 0), w) {
                                                        var L = d ? d.endPTS - d.startPTS : 0;
                                                        t.inputTimeScale || (u.logger.warn("[mp4-remuxer]: regenerate InitSegment as video detected"), f = this.generateIS(e, t, i)), c = this.remuxVideo(t, T, R, L);
                                                    }
                                                } else w && (c = this.remuxVideo(t, T, R, 0));
                                                c && (c.firstKeyFrame = C, c.independent = -1 !== C, c.firstKeyFramePTS = I);
                                            }
                                        }
                                        return this.ISGenerated && (n.samples.length && (g = m(n, i, this._initPTS, this._initDTS)), r.samples.length && (h = v(r, i, this._initPTS))), {
                                            audio: d,
                                            video: c,
                                            initSegment: f,
                                            independent: y,
                                            text: h,
                                            id3: g
                                        };
                                    }, t.generateIS = function(e, t, n) {
                                        var i, o, s1, u = e.samples, l = t.samples, c = this.typeSupported, d = {}, f = !(0, r.isFiniteNumber)(this._initPTS), h = "audio/mp4";
                                        if (f && (i = o = 1 / 0), e.config && u.length && (e.timescale = e.samplerate, "mp3" === e.segmentCodec && (c.mpeg ? (h = "audio/mpeg", e.codec = "") : c.mp3 && (e.codec = "mp3")), d.audio = {
                                            id: "audio",
                                            container: h,
                                            codec: e.codec,
                                            initSegment: "mp3" === e.segmentCodec && c.mpeg ? new Uint8Array(0) : a1.default.initSegment([
                                                e
                                            ]),
                                            metadata: {
                                                channelCount: e.channelCount
                                            }
                                        }, f && (s1 = e.inputTimeScale, i = o = u[0].pts - Math.round(s1 * n))), t.sps && t.pps && l.length && (t.timescale = t.inputTimeScale, d.video = {
                                            id: "main",
                                            container: "video/mp4",
                                            codec: t.codec,
                                            initSegment: a1.default.initSegment([
                                                t
                                            ]),
                                            metadata: {
                                                width: t.width,
                                                height: t.height
                                            }
                                        }, f)) {
                                            s1 = t.inputTimeScale;
                                            var g = this.getVideoStartPts(l), m = Math.round(s1 * n);
                                            o = Math.min(o, p(l[0].dts, g) - m), i = Math.min(i, g - m);
                                        }
                                        if (Object.keys(d).length) return this.ISGenerated = !0, f && (this._initPTS = i, this._initDTS = o), {
                                            tracks: d,
                                            initPTS: i,
                                            timescale: s1
                                        };
                                    }, t.remuxVideo = function(e, t, n, r) {
                                        var i, l, g = e.inputTimeScale, m = e.samples, v = [], E = m.length, T = this._initPTS, b = this.nextAvcDts, A = 8, _ = this.videoSampleDuration, S = Number.POSITIVE_INFINITY, w = Number.NEGATIVE_INFINITY, I = !1;
                                        n && null !== b || (b = t * g - (m[0].pts - p(m[0].dts, m[0].pts)));
                                        for(var R = 0; R < E; R++){
                                            var C = m[R];
                                            C.pts = p(C.pts - T, b), C.dts = p(C.dts - T, b), C.dts < m[R > 0 ? R - 1 : R].dts && (I = !0);
                                        }
                                        I && m.sort(function(e, t) {
                                            var n = e.dts - t.dts, r = e.pts - t.pts;
                                            return n || r;
                                        }), i = m[0].dts;
                                        var D = m[m.length - 1].dts - i, k = D ? Math.round(D / (E - 1)) : _ || e.inputTimeScale / 30;
                                        if (n) {
                                            var N = i - b, L = N > k, x = N < -1;
                                            if ((L || x) && (L ? u.logger.warn("AVC: " + (0, c.toMsFromMpegTsClock)(N, !0) + " ms (" + N + "dts) hole between fragments detected, filling it") : u.logger.warn("AVC: " + (0, c.toMsFromMpegTsClock)(-N, !0) + " ms (" + N + "dts) overlapping between fragments detected"), !x || b > m[0].pts)) {
                                                i = b;
                                                var M = m[0].pts - N;
                                                m[0].dts = i, m[0].pts = M, u.logger.log("Video: First PTS/DTS adjusted: " + (0, c.toMsFromMpegTsClock)(M, !0) + "/" + (0, c.toMsFromMpegTsClock)(i, !0) + ", delta: " + (0, c.toMsFromMpegTsClock)(N, !0) + " ms");
                                            }
                                        }
                                        i = Math.max(0, i);
                                        for(var O = 0, P = 0, F = 0; F < E; F++){
                                            for(var U = m[F], j = U.units, B = j.length, G = 0, H = 0; H < B; H++)G += j[H].data.length;
                                            P += G, O += B, U.length = G, U.dts = Math.max(U.dts, i), S = Math.min(U.pts, S), w = Math.max(U.pts, w);
                                        }
                                        l = m[E - 1].dts;
                                        var V, K = P + 4 * O + 8;
                                        try {
                                            V = new Uint8Array(K);
                                        } catch (e) {
                                            return void this.observer.emit(o.Events.ERROR, o.Events.ERROR, {
                                                type: s1.ErrorTypes.MUX_ERROR,
                                                details: s1.ErrorDetails.REMUX_ALLOC_ERROR,
                                                fatal: !1,
                                                bytes: K,
                                                reason: "fail allocating video mdat " + K
                                            });
                                        }
                                        var q = new DataView(V.buffer);
                                        q.setUint32(0, K), V.set(a1.default.types.mdat, 4);
                                        for(var Y = !1, W = Number.POSITIVE_INFINITY, z = Number.POSITIVE_INFINITY, X = Number.NEGATIVE_INFINITY, Q = Number.NEGATIVE_INFINITY, J = 0; J < E; J++){
                                            for(var Z = m[J], $ = Z.units, ee = 0, te = 0, ne = $.length; te < ne; te++){
                                                var re = $[te], ie = re.data, ae = re.data.byteLength;
                                                q.setUint32(A, ae), A += 4, V.set(ie, A), A += ae, ee += 4 + ae;
                                            }
                                            var oe = void 0;
                                            if (J < E - 1) _ = m[J + 1].dts - Z.dts, oe = m[J + 1].pts - Z.pts;
                                            else {
                                                var se = this.config, ue = J > 0 ? Z.dts - m[J - 1].dts : k;
                                                if (oe = J > 0 ? Z.pts - m[J - 1].pts : k, se.stretchShortVideoTrack && null !== this.nextAudioPts) {
                                                    var le = Math.floor(se.maxBufferHole * g), ce = (r ? S + r * g : this.nextAudioPts) - Z.pts;
                                                    ce > le ? ((_ = ce - ue) < 0 ? _ = ue : Y = !0, u.logger.log("[mp4-remuxer]: It is approximately " + ce / 90 + " ms to the next segment; using duration " + _ / 90 + " ms for the last video frame.")) : _ = ue;
                                                } else _ = ue;
                                            }
                                            var de = Math.round(Z.pts - Z.dts);
                                            W = Math.min(W, _), X = Math.max(X, _), z = Math.min(z, oe), Q = Math.max(Q, oe), v.push(new y(Z.key, _, ee, de));
                                        }
                                        if (v.length) {
                                            if (f) {
                                                if (f < 70) {
                                                    var fe = v[0].flags;
                                                    fe.dependsOn = 2, fe.isNonSync = 0;
                                                }
                                            } else if (h && Q - z < X - W && k / X < .025 && 0 === v[0].cts) {
                                                u.logger.warn("Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.");
                                                for(var he = i, ge = 0, pe = v.length; ge < pe; ge++){
                                                    var me = he + v[ge].duration, ve = he + v[ge].cts;
                                                    if (ge < pe - 1) {
                                                        var ye = me + v[ge + 1].cts;
                                                        v[ge].duration = ye - ve;
                                                    } else v[ge].duration = ge ? v[ge - 1].duration : k;
                                                    v[ge].cts = 0, he = me;
                                                }
                                            }
                                        }
                                        console.assert(null !== _, "mp4SampleDuration must be computed"), _ = Y || !_ ? k : _, this.nextAvcDts = b = l + _, this.videoSampleDuration = _, this.isVideoContiguous = !0;
                                        var Ee = {
                                            data1: a1.default.moof(e.sequenceNumber++, i, d({}, e, {
                                                samples: v
                                            })),
                                            data2: V,
                                            startPTS: S / g,
                                            endPTS: (w + _) / g,
                                            startDTS: i / g,
                                            endDTS: b / g,
                                            type: "video",
                                            hasAudio: !1,
                                            hasVideo: !0,
                                            nb: v.length,
                                            dropped: e.dropped
                                        };
                                        return e.samples = [], e.dropped = 0, console.assert(V.length, "MDAT length must not be zero"), Ee;
                                    }, t.remuxAudio = function(e, t, n, r, l) {
                                        var c = e.inputTimeScale, f = c / (e.samplerate ? e.samplerate : c), h = "aac" === e.segmentCodec ? 1024 : 1152, g = h * f, m = this._initPTS, v = "mp3" === e.segmentCodec && this.typeSupported.mpeg, E = [], T = void 0 !== l, b = e.samples, A = v ? 0 : 8, _ = this.nextAudioPts || -1, S = t * c;
                                        if (this.isAudioContiguous = n = n || b.length && _ > 0 && (r && Math.abs(S - _) < 9e3 || Math.abs(p(b[0].pts - m, S) - _) < 20 * g), b.forEach(function(e) {
                                            e.pts = p(e.pts - m, S);
                                        }), !n || _ < 0) {
                                            if (b = b.filter(function(e) {
                                                return e.pts >= 0;
                                            }), !b.length) return;
                                            _ = 0 === l ? 0 : r && !T ? Math.max(0, S) : b[0].pts;
                                        }
                                        if ("aac" === e.segmentCodec) for(var w = this.config.maxAudioFramesDrift, I = 0, R = _; I < b.length; I++){
                                            var C = b[I], D = C.pts, k = D - R, N = Math.abs(1e3 * k / c);
                                            if (k <= -w * g && T) 0 === I && (u.logger.warn("Audio frame @ " + (D / c).toFixed(3) + "s overlaps nextAudioPts by " + Math.round(1e3 * k / c) + " ms."), this.nextAudioPts = _ = R = D);
                                            else if (k >= w * g && N < 1e4 && T) {
                                                var L = Math.round(k / g);
                                                (R = D - L * g) < 0 && (L--, R += g), 0 === I && (this.nextAudioPts = _ = R), u.logger.warn("[mp4-remuxer]: Injecting " + L + " audio frame @ " + (R / c).toFixed(3) + "s due to " + Math.round(1e3 * k / c) + " ms gap.");
                                                for(var x = 0; x < L; x++){
                                                    var M = Math.max(R, 0), O = i.default.getSilentFrame(e.manifestCodec || e.codec, e.channelCount);
                                                    O || (u.logger.log("[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead."), O = C.unit.subarray()), b.splice(I, 0, {
                                                        unit: O,
                                                        pts: M
                                                    }), R += g, I++;
                                                }
                                            }
                                            C.pts = R, R += g;
                                        }
                                        for(var P, F = null, U = null, j = 0, B = b.length; B--;)j += b[B].unit.byteLength;
                                        for(var G = 0, H = b.length; G < H; G++){
                                            var V = b[G], K = V.unit, q = V.pts;
                                            if (null !== U) E[G - 1].duration = Math.round((q - U) / f);
                                            else {
                                                if (n && "aac" === e.segmentCodec && (q = _), F = q, !(j > 0)) return;
                                                j += A;
                                                try {
                                                    P = new Uint8Array(j);
                                                } catch (e) {
                                                    return void this.observer.emit(o.Events.ERROR, o.Events.ERROR, {
                                                        type: s1.ErrorTypes.MUX_ERROR,
                                                        details: s1.ErrorDetails.REMUX_ALLOC_ERROR,
                                                        fatal: !1,
                                                        bytes: j,
                                                        reason: "fail allocating audio mdat " + j
                                                    });
                                                }
                                                v || (new DataView(P.buffer).setUint32(0, j), P.set(a1.default.types.mdat, 4));
                                            }
                                            P.set(K, A);
                                            var Y = K.byteLength;
                                            A += Y, E.push(new y(!0, h, Y, 0)), U = q;
                                        }
                                        var W = E.length;
                                        if (W) {
                                            var z = E[E.length - 1];
                                            this.nextAudioPts = _ = U + f * z.duration;
                                            var X = v ? new Uint8Array(0) : a1.default.moof(e.sequenceNumber++, F / f, d({}, e, {
                                                samples: E
                                            }));
                                            e.samples = [];
                                            var Q = F / c, J = _ / c, Z = {
                                                data1: X,
                                                data2: P,
                                                startPTS: Q,
                                                endPTS: J,
                                                startDTS: Q,
                                                endDTS: J,
                                                type: "audio",
                                                hasAudio: !0,
                                                hasVideo: !1,
                                                nb: W
                                            };
                                            return this.isAudioContiguous = !0, console.assert(P.length, "MDAT length must not be zero"), Z;
                                        }
                                    }, t.remuxEmptyAudio = function(e, t, n, r) {
                                        var a1 = e.inputTimeScale, o = a1 / (e.samplerate ? e.samplerate : a1), s1 = this.nextAudioPts, l = (null !== s1 ? s1 : r.startDTS * a1) + this._initDTS, c = r.endDTS * a1 + this._initDTS, d = 1024 * o, f = Math.ceil((c - l) / d), h = i.default.getSilentFrame(e.manifestCodec || e.codec, e.channelCount);
                                        if (u.logger.warn("[mp4-remuxer]: remux empty Audio"), h) {
                                            for(var g = [], p = 0; p < f; p++){
                                                var m = l + p * d;
                                                g.push({
                                                    unit: h,
                                                    pts: m,
                                                    dts: m
                                                });
                                            }
                                            return e.samples = g, this.remuxAudio(e, t, n, !1);
                                        }
                                        u.logger.trace("[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec");
                                    }, e;
                                }();
                                function p(e, t) {
                                    var n;
                                    if (null === t) return e;
                                    for(n = t < e ? -8589934592 : 8589934592; Math.abs(e - t) > 4294967296;)e += n;
                                    return e;
                                }
                                function m(e, t, n, r) {
                                    var i = e.samples.length;
                                    if (i) {
                                        for(var a1 = e.inputTimeScale, o = 0; o < i; o++){
                                            var s1 = e.samples[o];
                                            s1.pts = p(s1.pts - n, t * a1) / a1, s1.dts = p(s1.dts - r, t * a1) / a1;
                                        }
                                        var u = e.samples;
                                        return e.samples = [], {
                                            samples: u
                                        };
                                    }
                                }
                                function v(e, t, n) {
                                    var r = e.samples.length;
                                    if (r) {
                                        for(var i = e.inputTimeScale, a1 = 0; a1 < r; a1++){
                                            var o = e.samples[a1];
                                            o.pts = p(o.pts - n, t * i) / i;
                                        }
                                        e.samples.sort(function(e, t) {
                                            return e.pts - t.pts;
                                        });
                                        var s1 = e.samples;
                                        return e.samples = [], {
                                            samples: s1
                                        };
                                    }
                                }
                                var y = function(e, t, n, r) {
                                    this.size = void 0, this.duration = void 0, this.cts = void 0, this.flags = void 0, this.duration = t, this.size = n, this.cts = r, this.flags = new E(e);
                                }, E = function(e) {
                                    this.isLeading = 0, this.isDependedOn = 0, this.hasRedundancy = 0, this.degradPrio = 0, this.dependsOn = 1, this.isNonSync = 1, this.dependsOn = e ? 2 : 1, this.isNonSync = e ? 0 : 1;
                                };
                            },
                            "./src/remux/passthrough-remuxer.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>l
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./src/remux/mp4-remuxer.ts"), a1 = n("./src/utils/mp4-tools.ts"), o = n("./src/loader/fragment.ts"), s1 = n("./src/utils/logger.ts");
                                function u(e, t) {
                                    var n = null == e ? void 0 : e.codec;
                                    return n && n.length > 4 ? n : "hvc1" === n || "hev1" === n ? "hvc1.1.c.L120.90" : "av01" === n ? "av01.0.04M.08" : "avc1" === n || t === o.ElementaryStreamTypes.VIDEO ? "avc1.42e01e" : "mp4a.40.5";
                                }
                                const l = function() {
                                    function e() {
                                        this.emitInitSegment = !1, this.audioCodec = void 0, this.videoCodec = void 0, this.initData = void 0, this.initPTS = void 0, this.initTracks = void 0, this.lastEndTime = null;
                                    }
                                    var t = e.prototype;
                                    return t.destroy = function() {}, t.resetTimeStamp = function(e) {
                                        this.initPTS = e, this.lastEndTime = null;
                                    }, t.resetNextTimestamp = function() {
                                        this.lastEndTime = null;
                                    }, t.resetInitSegment = function(e, t, n) {
                                        this.audioCodec = t, this.videoCodec = n, this.generateInitSegment(e), this.emitInitSegment = !0;
                                    }, t.generateInitSegment = function(e) {
                                        var t = this.audioCodec, n = this.videoCodec;
                                        if (!e || !e.byteLength) return this.initTracks = void 0, void (this.initData = void 0);
                                        var r = this.initData = (0, a1.parseInitSegment)(e);
                                        t || (t = u(r.audio, o.ElementaryStreamTypes.AUDIO)), n || (n = u(r.video, o.ElementaryStreamTypes.VIDEO));
                                        var i = {};
                                        r.audio && r.video ? i.audiovideo = {
                                            container: "video/mp4",
                                            codec: t + "," + n,
                                            initSegment: e,
                                            id: "main"
                                        } : r.audio ? i.audio = {
                                            container: "audio/mp4",
                                            codec: t,
                                            initSegment: e,
                                            id: "audio"
                                        } : r.video ? i.video = {
                                            container: "video/mp4",
                                            codec: n,
                                            initSegment: e,
                                            id: "main"
                                        } : s1.logger.warn("[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes."), this.initTracks = i;
                                    }, t.remux = function(e, t, n, o, u) {
                                        var l, c = this.initPTS, d = this.lastEndTime, f = {
                                            audio: void 0,
                                            video: void 0,
                                            text: o,
                                            id3: n,
                                            initSegment: void 0
                                        };
                                        (0, r.isFiniteNumber)(d) || (d = this.lastEndTime = u || 0);
                                        var h = t.samples;
                                        if (!h || !h.length) return f;
                                        var g = {
                                            initPTS: void 0,
                                            timescale: 1
                                        }, p = this.initData;
                                        if (p && p.length || (this.generateInitSegment(h), p = this.initData), !p || !p.length) return s1.logger.warn("[passthrough-remuxer.ts]: Failed to generate initSegment."), f;
                                        this.emitInitSegment && (g.tracks = this.initTracks, this.emitInitSegment = !1);
                                        var m = (0, a1.getStartDTS)(p, h);
                                        (0, r.isFiniteNumber)(c) || (this.initPTS = g.initPTS = c = m - u);
                                        var v = (0, a1.getDuration)(h, p), y = e ? m - c : d, E = y + v;
                                        (0, a1.offsetStartDTS)(p, h, c), v > 0 ? this.lastEndTime = E : (s1.logger.warn("Duration parsed from mp4 should be greater than zero"), this.resetNextTimestamp());
                                        var T = !!p.audio, b = !!p.video, A = "";
                                        T && (A += "audio"), b && (A += "video");
                                        var _ = {
                                            data1: h,
                                            startPTS: y,
                                            startDTS: y,
                                            endPTS: E,
                                            endDTS: E,
                                            type: A,
                                            hasAudio: T,
                                            hasVideo: b,
                                            nb: 1,
                                            dropped: 0
                                        };
                                        f.audio = "audio" === _.type ? _ : void 0, f.video = "audio" !== _.type ? _ : void 0, f.initSegment = g;
                                        var S = null != (l = this.initPTS) ? l : 0;
                                        return f.id3 = (0, i.flushTextTrackMetadataCueSamples)(n, u, S, S), o.samples.length && (f.text = (0, i.flushTextTrackUserdataCueSamples)(o, u, S)), f;
                                    }, e;
                                }();
                            },
                            "./src/task-loop.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>r
                                });
                                var r = function() {
                                    function e() {
                                        this._boundTick = void 0, this._tickTimer = null, this._tickInterval = null, this._tickCallCount = 0, this._boundTick = this.tick.bind(this);
                                    }
                                    var t = e.prototype;
                                    return t.destroy = function() {
                                        this.onHandlerDestroying(), this.onHandlerDestroyed();
                                    }, t.onHandlerDestroying = function() {
                                        this.clearNextTick(), this.clearInterval();
                                    }, t.onHandlerDestroyed = function() {}, t.hasInterval = function() {
                                        return !!this._tickInterval;
                                    }, t.hasNextTick = function() {
                                        return !!this._tickTimer;
                                    }, t.setInterval = function(e) {
                                        return !this._tickInterval && (this._tickInterval = self.setInterval(this._boundTick, e), !0);
                                    }, t.clearInterval = function() {
                                        return !!this._tickInterval && (self.clearInterval(this._tickInterval), this._tickInterval = null, !0);
                                    }, t.clearNextTick = function() {
                                        return !!this._tickTimer && (self.clearTimeout(this._tickTimer), this._tickTimer = null, !0);
                                    }, t.tick = function() {
                                        this._tickCallCount++, 1 === this._tickCallCount && (this.doTick(), this._tickCallCount > 1 && this.tickImmediate(), this._tickCallCount = 0);
                                    }, t.tickImmediate = function() {
                                        this.clearNextTick(), this._tickTimer = self.setTimeout(this._boundTick, 0);
                                    }, t.doTick = function() {}, e;
                                }();
                            },
                            "./src/types/cmcd.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    CMCDObjectType: ()=>r,
                                    CMCDStreamType: ()=>a1,
                                    CMCDStreamingFormat: ()=>i,
                                    CMCDVersion: ()=>o
                                });
                                var r, i, a1, o = 1;
                                !function(e) {
                                    e.MANIFEST = "m", e.AUDIO = "a", e.VIDEO = "v", e.MUXED = "av", e.INIT = "i", e.CAPTION = "c", e.TIMED_TEXT = "tt", e.KEY = "k", e.OTHER = "o";
                                }(r || (r = {})), function(e) {
                                    e.DASH = "d", e.HLS = "h", e.SMOOTH = "s", e.OTHER = "o";
                                }(i || (i = {})), function(e) {
                                    e.VOD = "v", e.LIVE = "l";
                                }(a1 || (a1 = {}));
                            },
                            "./src/types/demuxer.ts": (e, t, n)=>{
                                "use strict";
                                var r;
                                n.r(t), n.d(t, {
                                    MetadataSchema: ()=>r
                                }), function(e) {
                                    e.audioId3 = "org.id3", e.dateRange = "com.apple.quicktime.HLS", e.emsg = "https://aomedia.org/emsg/ID3";
                                }(r || (r = {}));
                            },
                            "./src/types/level.ts": (e, t, n)=>{
                                "use strict";
                                function r(e, t) {
                                    for(var n = 0; n < t.length; n++){
                                        var r = t[n];
                                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                                    }
                                }
                                var i;
                                function a1(e, t) {
                                    var n = e.canSkipUntil, r = e.canSkipDateRanges, a1 = e.endSN;
                                    return n && (void 0 !== t ? t - a1 : 0) < n ? r ? i.v2 : i.Yes : i.No;
                                }
                                n.r(t), n.d(t, {
                                    HlsSkip: ()=>i,
                                    HlsUrlParameters: ()=>o,
                                    Level: ()=>s1,
                                    getSkipValue: ()=>a1
                                }), function(e) {
                                    e.No = "", e.Yes = "YES", e.v2 = "v2";
                                }(i || (i = {}));
                                var o = function() {
                                    function e(e, t, n) {
                                        this.msn = void 0, this.part = void 0, this.skip = void 0, this.msn = e, this.part = t, this.skip = n;
                                    }
                                    return e.prototype.addDirectives = function(e) {
                                        var t = new self.URL(e);
                                        return void 0 !== this.msn && t.searchParams.set("_HLS_msn", this.msn.toString()), void 0 !== this.part && t.searchParams.set("_HLS_part", this.part.toString()), this.skip && t.searchParams.set("_HLS_skip", this.skip), t.toString();
                                    }, e;
                                }(), s1 = function() {
                                    function e(e) {
                                        this.attrs = void 0, this.audioCodec = void 0, this.bitrate = void 0, this.codecSet = void 0, this.height = void 0, this.id = void 0, this.name = void 0, this.videoCodec = void 0, this.width = void 0, this.unknownCodecs = void 0, this.audioGroupIds = void 0, this.details = void 0, this.fragmentError = 0, this.loadError = 0, this.loaded = void 0, this.realBitrate = 0, this.textGroupIds = void 0, this.url = void 0, this._urlId = 0, this.url = [
                                            e.url
                                        ], this.attrs = e.attrs, this.bitrate = e.bitrate, e.details && (this.details = e.details), this.id = e.id || 0, this.name = e.name, this.width = e.width || 0, this.height = e.height || 0, this.audioCodec = e.audioCodec, this.videoCodec = e.videoCodec, this.unknownCodecs = e.unknownCodecs, this.codecSet = [
                                            e.videoCodec,
                                            e.audioCodec
                                        ].filter(function(e) {
                                            return e;
                                        }).join(",").replace(/\.[^.,]+/g, "");
                                    }
                                    var t, n;
                                    return t = e, n = [
                                        {
                                            key: "maxBitrate",
                                            get: function() {
                                                return Math.max(this.realBitrate, this.bitrate);
                                            }
                                        },
                                        {
                                            key: "uri",
                                            get: function() {
                                                return this.url[this._urlId] || "";
                                            }
                                        },
                                        {
                                            key: "urlId",
                                            get: function() {
                                                return this._urlId;
                                            },
                                            set: function(e) {
                                                var t = e % this.url.length;
                                                this._urlId !== t && (this.details = void 0, this._urlId = t);
                                            }
                                        }
                                    ], r(t.prototype, n), Object.defineProperty(t, "prototype", {
                                        writable: !1
                                    }), e;
                                }();
                            },
                            "./src/types/loader.ts": (e, t, n)=>{
                                "use strict";
                                var r, i;
                                n.r(t), n.d(t, {
                                    PlaylistContextType: ()=>r,
                                    PlaylistLevelType: ()=>i
                                }), function(e) {
                                    e.MANIFEST = "manifest", e.LEVEL = "level", e.AUDIO_TRACK = "audioTrack", e.SUBTITLE_TRACK = "subtitleTrack";
                                }(r || (r = {})), function(e) {
                                    e.MAIN = "main", e.AUDIO = "audio", e.SUBTITLE = "subtitle";
                                }(i || (i = {}));
                            },
                            "./src/types/transmuxer.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    ChunkMetadata: ()=>r
                                });
                                var r = function(e, t, n, r, i, a1) {
                                    void 0 === r && (r = 0), void 0 === i && (i = -1), void 0 === a1 && (a1 = !1), this.level = void 0, this.sn = void 0, this.part = void 0, this.id = void 0, this.size = void 0, this.partial = void 0, this.transmuxing = {
                                        start: 0,
                                        executeStart: 0,
                                        executeEnd: 0,
                                        end: 0
                                    }, this.buffering = {
                                        audio: {
                                            start: 0,
                                            executeStart: 0,
                                            executeEnd: 0,
                                            end: 0
                                        },
                                        video: {
                                            start: 0,
                                            executeStart: 0,
                                            executeEnd: 0,
                                            end: 0
                                        },
                                        audiovideo: {
                                            start: 0,
                                            executeStart: 0,
                                            executeEnd: 0,
                                            end: 0
                                        }
                                    }, this.level = e, this.sn = t, this.id = n, this.size = r, this.part = i, this.partial = a1;
                                };
                            },
                            "./src/utils/attr-list.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    AttrList: ()=>a1
                                });
                                var r = /^(\d+)x(\d+)$/, i = /\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g, a1 = function() {
                                    function e(t) {
                                        for(var n in "string" == typeof t && (t = e.parseAttrList(t)), t)t.hasOwnProperty(n) && (this[n] = t[n]);
                                    }
                                    var t = e.prototype;
                                    return t.decimalInteger = function(e) {
                                        var t = parseInt(this[e], 10);
                                        return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
                                    }, t.hexadecimalInteger = function(e) {
                                        if (this[e]) {
                                            var t = (this[e] || "0x").slice(2);
                                            t = (1 & t.length ? "0" : "") + t;
                                            for(var n = new Uint8Array(t.length / 2), r = 0; r < t.length / 2; r++)n[r] = parseInt(t.slice(2 * r, 2 * r + 2), 16);
                                            return n;
                                        }
                                        return null;
                                    }, t.hexadecimalIntegerAsNumber = function(e) {
                                        var t = parseInt(this[e], 16);
                                        return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
                                    }, t.decimalFloatingPoint = function(e) {
                                        return parseFloat(this[e]);
                                    }, t.optionalFloat = function(e, t) {
                                        var n = this[e];
                                        return n ? parseFloat(n) : t;
                                    }, t.enumeratedString = function(e) {
                                        return this[e];
                                    }, t.bool = function(e) {
                                        return "YES" === this[e];
                                    }, t.decimalResolution = function(e) {
                                        var t = r.exec(this[e]);
                                        if (null !== t) return {
                                            width: parseInt(t[1], 10),
                                            height: parseInt(t[2], 10)
                                        };
                                    }, e.parseAttrList = function(e) {
                                        var t, n = {};
                                        for(i.lastIndex = 0; null !== (t = i.exec(e));){
                                            var r = t[2];
                                            0 === r.indexOf('"') && r.lastIndexOf('"') === r.length - 1 && (r = r.slice(1, -1)), n[t[1]] = r;
                                        }
                                        return n;
                                    }, e;
                                }();
                            },
                            "./src/utils/binary-search.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>r
                                });
                                const r = {
                                    search: function(e, t) {
                                        for(var n = 0, r = e.length - 1, i = null, a1 = null; n <= r;){
                                            var o = t(a1 = e[i = (n + r) / 2 | 0]);
                                            if (o > 0) n = i + 1;
                                            else {
                                                if (!(o < 0)) return a1;
                                                r = i - 1;
                                            }
                                        }
                                        return null;
                                    }
                                };
                            },
                            "./src/utils/buffer-helper.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    BufferHelper: ()=>a1
                                });
                                var r = n("./src/utils/logger.ts"), i = {
                                    length: 0,
                                    start: function() {
                                        return 0;
                                    },
                                    end: function() {
                                        return 0;
                                    }
                                }, a1 = function() {
                                    function e() {}
                                    return e.isBuffered = function(t, n) {
                                        try {
                                            if (t) {
                                                for(var r = e.getBuffered(t), i = 0; i < r.length; i++)if (n >= r.start(i) && n <= r.end(i)) return !0;
                                            }
                                        } catch (e) {}
                                        return !1;
                                    }, e.bufferInfo = function(t, n, r) {
                                        try {
                                            if (t) {
                                                var i, a1 = e.getBuffered(t), o = [];
                                                for(i = 0; i < a1.length; i++)o.push({
                                                    start: a1.start(i),
                                                    end: a1.end(i)
                                                });
                                                return this.bufferedInfo(o, n, r);
                                            }
                                        } catch (e) {}
                                        return {
                                            len: 0,
                                            start: n,
                                            end: n,
                                            nextStart: void 0
                                        };
                                    }, e.bufferedInfo = function(e, t, n) {
                                        t = Math.max(0, t), e.sort(function(e, t) {
                                            return e.start - t.start || t.end - e.end;
                                        });
                                        var r = [];
                                        if (n) for(var i = 0; i < e.length; i++){
                                            var a1 = r.length;
                                            if (a1) {
                                                var o = r[a1 - 1].end;
                                                e[i].start - o < n ? e[i].end > o && (r[a1 - 1].end = e[i].end) : r.push(e[i]);
                                            } else r.push(e[i]);
                                        }
                                        else r = e;
                                        for(var s1, u = 0, l = t, c = t, d = 0; d < r.length; d++){
                                            var f = r[d].start, h = r[d].end;
                                            if (t + n >= f && t < h) l = f, u = (c = h) - t;
                                            else if (t + n < f) {
                                                s1 = f;
                                                break;
                                            }
                                        }
                                        return {
                                            len: u,
                                            start: l || 0,
                                            end: c || 0,
                                            nextStart: s1
                                        };
                                    }, e.getBuffered = function(e) {
                                        try {
                                            return e.buffered;
                                        } catch (e) {
                                            return r.logger.log("failed to get media.buffered", e), i;
                                        }
                                    }, e;
                                }();
                            },
                            "./src/utils/cea-608-parser.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    CaptionScreen: ()=>E,
                                    Row: ()=>y,
                                    default: ()=>_
                                });
                                var r, i = n("./src/utils/logger.ts"), a1 = {
                                    42: 225,
                                    92: 233,
                                    94: 237,
                                    95: 243,
                                    96: 250,
                                    123: 231,
                                    124: 247,
                                    125: 209,
                                    126: 241,
                                    127: 9608,
                                    128: 174,
                                    129: 176,
                                    130: 189,
                                    131: 191,
                                    132: 8482,
                                    133: 162,
                                    134: 163,
                                    135: 9834,
                                    136: 224,
                                    137: 32,
                                    138: 232,
                                    139: 226,
                                    140: 234,
                                    141: 238,
                                    142: 244,
                                    143: 251,
                                    144: 193,
                                    145: 201,
                                    146: 211,
                                    147: 218,
                                    148: 220,
                                    149: 252,
                                    150: 8216,
                                    151: 161,
                                    152: 42,
                                    153: 8217,
                                    154: 9473,
                                    155: 169,
                                    156: 8480,
                                    157: 8226,
                                    158: 8220,
                                    159: 8221,
                                    160: 192,
                                    161: 194,
                                    162: 199,
                                    163: 200,
                                    164: 202,
                                    165: 203,
                                    166: 235,
                                    167: 206,
                                    168: 207,
                                    169: 239,
                                    170: 212,
                                    171: 217,
                                    172: 249,
                                    173: 219,
                                    174: 171,
                                    175: 187,
                                    176: 195,
                                    177: 227,
                                    178: 205,
                                    179: 204,
                                    180: 236,
                                    181: 210,
                                    182: 242,
                                    183: 213,
                                    184: 245,
                                    185: 123,
                                    186: 125,
                                    187: 92,
                                    188: 94,
                                    189: 95,
                                    190: 124,
                                    191: 8764,
                                    192: 196,
                                    193: 228,
                                    194: 214,
                                    195: 246,
                                    196: 223,
                                    197: 165,
                                    198: 164,
                                    199: 9475,
                                    200: 197,
                                    201: 229,
                                    202: 216,
                                    203: 248,
                                    204: 9487,
                                    205: 9491,
                                    206: 9495,
                                    207: 9499
                                }, o = function(e) {
                                    var t = e;
                                    return a1.hasOwnProperty(e) && (t = a1[e]), String.fromCharCode(t);
                                }, s1 = 15, u = 100, l = {
                                    17: 1,
                                    18: 3,
                                    21: 5,
                                    22: 7,
                                    23: 9,
                                    16: 11,
                                    19: 12,
                                    20: 14
                                }, c = {
                                    17: 2,
                                    18: 4,
                                    21: 6,
                                    22: 8,
                                    23: 10,
                                    19: 13,
                                    20: 15
                                }, d = {
                                    25: 1,
                                    26: 3,
                                    29: 5,
                                    30: 7,
                                    31: 9,
                                    24: 11,
                                    27: 12,
                                    28: 14
                                }, f = {
                                    25: 2,
                                    26: 4,
                                    29: 6,
                                    30: 8,
                                    31: 10,
                                    27: 13,
                                    28: 15
                                }, h = [
                                    "white",
                                    "green",
                                    "blue",
                                    "cyan",
                                    "red",
                                    "yellow",
                                    "magenta",
                                    "black",
                                    "transparent"
                                ];
                                !function(e) {
                                    e[e.ERROR = 0] = "ERROR", e[e.TEXT = 1] = "TEXT", e[e.WARNING = 2] = "WARNING", e[e.INFO = 2] = "INFO", e[e.DEBUG = 3] = "DEBUG", e[e.DATA = 3] = "DATA";
                                }(r || (r = {}));
                                var g = function() {
                                    function e() {
                                        this.time = null, this.verboseLevel = r.ERROR;
                                    }
                                    return e.prototype.log = function(e, t) {
                                        this.verboseLevel >= e && i.logger.log(this.time + " [" + e + "] " + t);
                                    }, e;
                                }(), p = function(e) {
                                    for(var t = [], n = 0; n < e.length; n++)t.push(e[n].toString(16));
                                    return t;
                                }, m = function() {
                                    function e(e, t, n, r, i) {
                                        this.foreground = void 0, this.underline = void 0, this.italics = void 0, this.background = void 0, this.flash = void 0, this.foreground = e || "white", this.underline = t || !1, this.italics = n || !1, this.background = r || "black", this.flash = i || !1;
                                    }
                                    var t = e.prototype;
                                    return t.reset = function() {
                                        this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
                                    }, t.setStyles = function(e) {
                                        for(var t = [
                                            "foreground",
                                            "underline",
                                            "italics",
                                            "background",
                                            "flash"
                                        ], n = 0; n < t.length; n++){
                                            var r = t[n];
                                            e.hasOwnProperty(r) && (this[r] = e[r]);
                                        }
                                    }, t.isDefault = function() {
                                        return "white" === this.foreground && !this.underline && !this.italics && "black" === this.background && !this.flash;
                                    }, t.equals = function(e) {
                                        return this.foreground === e.foreground && this.underline === e.underline && this.italics === e.italics && this.background === e.background && this.flash === e.flash;
                                    }, t.copy = function(e) {
                                        this.foreground = e.foreground, this.underline = e.underline, this.italics = e.italics, this.background = e.background, this.flash = e.flash;
                                    }, t.toString = function() {
                                        return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
                                    }, e;
                                }(), v = function() {
                                    function e(e, t, n, r, i, a1) {
                                        this.uchar = void 0, this.penState = void 0, this.uchar = e || " ", this.penState = new m(t, n, r, i, a1);
                                    }
                                    var t = e.prototype;
                                    return t.reset = function() {
                                        this.uchar = " ", this.penState.reset();
                                    }, t.setChar = function(e, t) {
                                        this.uchar = e, this.penState.copy(t);
                                    }, t.setPenState = function(e) {
                                        this.penState.copy(e);
                                    }, t.equals = function(e) {
                                        return this.uchar === e.uchar && this.penState.equals(e.penState);
                                    }, t.copy = function(e) {
                                        this.uchar = e.uchar, this.penState.copy(e.penState);
                                    }, t.isEmpty = function() {
                                        return " " === this.uchar && this.penState.isDefault();
                                    }, e;
                                }(), y = function() {
                                    function e(e) {
                                        this.chars = void 0, this.pos = void 0, this.currPenState = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chars = [];
                                        for(var t = 0; t < u; t++)this.chars.push(new v);
                                        this.logger = e, this.pos = 0, this.currPenState = new m;
                                    }
                                    var t = e.prototype;
                                    return t.equals = function(e) {
                                        for(var t = !0, n = 0; n < u; n++)if (!this.chars[n].equals(e.chars[n])) {
                                            t = !1;
                                            break;
                                        }
                                        return t;
                                    }, t.copy = function(e) {
                                        for(var t = 0; t < u; t++)this.chars[t].copy(e.chars[t]);
                                    }, t.isEmpty = function() {
                                        for(var e = !0, t = 0; t < u; t++)if (!this.chars[t].isEmpty()) {
                                            e = !1;
                                            break;
                                        }
                                        return e;
                                    }, t.setCursor = function(e) {
                                        this.pos !== e && (this.pos = e), this.pos < 0 ? (this.logger.log(r.DEBUG, "Negative cursor position " + this.pos), this.pos = 0) : this.pos > u && (this.logger.log(r.DEBUG, "Too large cursor position " + this.pos), this.pos = u);
                                    }, t.moveCursor = function(e) {
                                        var t = this.pos + e;
                                        if (e > 1) for(var n = this.pos + 1; n < t + 1; n++)this.chars[n].setPenState(this.currPenState);
                                        this.setCursor(t);
                                    }, t.backSpace = function() {
                                        this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
                                    }, t.insertChar = function(e) {
                                        e >= 144 && this.backSpace();
                                        var t = o(e);
                                        this.pos >= u ? this.logger.log(r.ERROR, "Cannot insert " + e.toString(16) + " (" + t + ") at position " + this.pos + ". Skipping it!") : (this.chars[this.pos].setChar(t, this.currPenState), this.moveCursor(1));
                                    }, t.clearFromPos = function(e) {
                                        var t;
                                        for(t = e; t < u; t++)this.chars[t].reset();
                                    }, t.clear = function() {
                                        this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
                                    }, t.clearToEndOfRow = function() {
                                        this.clearFromPos(this.pos);
                                    }, t.getTextString = function() {
                                        for(var e = [], t = !0, n = 0; n < u; n++){
                                            var r = this.chars[n].uchar;
                                            " " !== r && (t = !1), e.push(r);
                                        }
                                        return t ? "" : e.join("");
                                    }, t.setPenStyles = function(e) {
                                        this.currPenState.setStyles(e), this.chars[this.pos].setPenState(this.currPenState);
                                    }, e;
                                }(), E = function() {
                                    function e(e) {
                                        this.rows = void 0, this.currRow = void 0, this.nrRollUpRows = void 0, this.lastOutputScreen = void 0, this.logger = void 0, this.rows = [];
                                        for(var t = 0; t < s1; t++)this.rows.push(new y(e));
                                        this.logger = e, this.currRow = 14, this.nrRollUpRows = null, this.lastOutputScreen = null, this.reset();
                                    }
                                    var t = e.prototype;
                                    return t.reset = function() {
                                        for(var e = 0; e < s1; e++)this.rows[e].clear();
                                        this.currRow = 14;
                                    }, t.equals = function(e) {
                                        for(var t = !0, n = 0; n < s1; n++)if (!this.rows[n].equals(e.rows[n])) {
                                            t = !1;
                                            break;
                                        }
                                        return t;
                                    }, t.copy = function(e) {
                                        for(var t = 0; t < s1; t++)this.rows[t].copy(e.rows[t]);
                                    }, t.isEmpty = function() {
                                        for(var e = !0, t = 0; t < s1; t++)if (!this.rows[t].isEmpty()) {
                                            e = !1;
                                            break;
                                        }
                                        return e;
                                    }, t.backSpace = function() {
                                        this.rows[this.currRow].backSpace();
                                    }, t.clearToEndOfRow = function() {
                                        this.rows[this.currRow].clearToEndOfRow();
                                    }, t.insertChar = function(e) {
                                        this.rows[this.currRow].insertChar(e);
                                    }, t.setPen = function(e) {
                                        this.rows[this.currRow].setPenStyles(e);
                                    }, t.moveCursor = function(e) {
                                        this.rows[this.currRow].moveCursor(e);
                                    }, t.setCursor = function(e) {
                                        this.logger.log(r.INFO, "setCursor: " + e), this.rows[this.currRow].setCursor(e);
                                    }, t.setPAC = function(e) {
                                        this.logger.log(r.INFO, "pacData = " + JSON.stringify(e));
                                        var t = e.row - 1;
                                        if (this.nrRollUpRows && t < this.nrRollUpRows - 1 && (t = this.nrRollUpRows - 1), this.nrRollUpRows && this.currRow !== t) {
                                            for(var n = 0; n < s1; n++)this.rows[n].clear();
                                            var i = this.currRow + 1 - this.nrRollUpRows, a1 = this.lastOutputScreen;
                                            if (a1) {
                                                var o = a1.rows[i].cueStartTime, u = this.logger.time;
                                                if (o && null !== u && o < u) for(var l = 0; l < this.nrRollUpRows; l++)this.rows[t - this.nrRollUpRows + l + 1].copy(a1.rows[i + l]);
                                            }
                                        }
                                        this.currRow = t;
                                        var c = this.rows[this.currRow];
                                        if (null !== e.indent) {
                                            var d = e.indent, f = Math.max(d - 1, 0);
                                            c.setCursor(e.indent), e.color = c.chars[f].penState.foreground;
                                        }
                                        var h = {
                                            foreground: e.color,
                                            underline: e.underline,
                                            italics: e.italics,
                                            background: "black",
                                            flash: !1
                                        };
                                        this.setPen(h);
                                    }, t.setBkgData = function(e) {
                                        this.logger.log(r.INFO, "bkgData = " + JSON.stringify(e)), this.backSpace(), this.setPen(e), this.insertChar(32);
                                    }, t.setRollUpRows = function(e) {
                                        this.nrRollUpRows = e;
                                    }, t.rollUp = function() {
                                        if (null !== this.nrRollUpRows) {
                                            this.logger.log(r.TEXT, this.getDisplayText());
                                            var e = this.currRow + 1 - this.nrRollUpRows, t = this.rows.splice(e, 1)[0];
                                            t.clear(), this.rows.splice(this.currRow, 0, t), this.logger.log(r.INFO, "Rolling up");
                                        } else this.logger.log(r.DEBUG, "roll_up but nrRollUpRows not set yet");
                                    }, t.getDisplayText = function(e) {
                                        e = e || !1;
                                        for(var t = [], n = "", r = -1, i = 0; i < s1; i++){
                                            var a1 = this.rows[i].getTextString();
                                            a1 && (r = i + 1, e ? t.push("Row " + r + ": '" + a1 + "'") : t.push(a1.trim()));
                                        }
                                        return t.length > 0 && (n = e ? "[" + t.join(" | ") + "]" : t.join("\n")), n;
                                    }, t.getTextAndFormat = function() {
                                        return this.rows;
                                    }, e;
                                }(), T = function() {
                                    function e(e, t, n) {
                                        this.chNr = void 0, this.outputFilter = void 0, this.mode = void 0, this.verbose = void 0, this.displayedMemory = void 0, this.nonDisplayedMemory = void 0, this.lastOutputScreen = void 0, this.currRollUpRow = void 0, this.writeScreen = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chNr = e, this.outputFilter = t, this.mode = null, this.verbose = 0, this.displayedMemory = new E(n), this.nonDisplayedMemory = new E(n), this.lastOutputScreen = new E(n), this.currRollUpRow = this.displayedMemory.rows[14], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.logger = n;
                                    }
                                    var t = e.prototype;
                                    return t.reset = function() {
                                        this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.outputFilter.reset(), this.currRollUpRow = this.displayedMemory.rows[14], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
                                    }, t.getHandler = function() {
                                        return this.outputFilter;
                                    }, t.setHandler = function(e) {
                                        this.outputFilter = e;
                                    }, t.setPAC = function(e) {
                                        this.writeScreen.setPAC(e);
                                    }, t.setBkgData = function(e) {
                                        this.writeScreen.setBkgData(e);
                                    }, t.setMode = function(e) {
                                        e !== this.mode && (this.mode = e, this.logger.log(r.INFO, "MODE=" + e), "MODE_POP-ON" === this.mode ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), "MODE_ROLL-UP" !== this.mode && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = e);
                                    }, t.insertChars = function(e) {
                                        for(var t = 0; t < e.length; t++)this.writeScreen.insertChar(e[t]);
                                        var n = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
                                        this.logger.log(r.INFO, n + ": " + this.writeScreen.getDisplayText(!0)), "MODE_PAINT-ON" !== this.mode && "MODE_ROLL-UP" !== this.mode || (this.logger.log(r.TEXT, "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
                                    }, t.ccRCL = function() {
                                        this.logger.log(r.INFO, "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
                                    }, t.ccBS = function() {
                                        this.logger.log(r.INFO, "BS - BackSpace"), "MODE_TEXT" !== this.mode && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
                                    }, t.ccAOF = function() {}, t.ccAON = function() {}, t.ccDER = function() {
                                        this.logger.log(r.INFO, "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
                                    }, t.ccRU = function(e) {
                                        this.logger.log(r.INFO, "RU(" + e + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(e);
                                    }, t.ccFON = function() {
                                        this.logger.log(r.INFO, "FON - Flash On"), this.writeScreen.setPen({
                                            flash: !0
                                        });
                                    }, t.ccRDC = function() {
                                        this.logger.log(r.INFO, "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
                                    }, t.ccTR = function() {
                                        this.logger.log(r.INFO, "TR"), this.setMode("MODE_TEXT");
                                    }, t.ccRTD = function() {
                                        this.logger.log(r.INFO, "RTD"), this.setMode("MODE_TEXT");
                                    }, t.ccEDM = function() {
                                        this.logger.log(r.INFO, "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate(!0);
                                    }, t.ccCR = function() {
                                        this.logger.log(r.INFO, "CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate(!0);
                                    }, t.ccENM = function() {
                                        this.logger.log(r.INFO, "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
                                    }, t.ccEOC = function() {
                                        if (this.logger.log(r.INFO, "EOC - End Of Caption"), "MODE_POP-ON" === this.mode) {
                                            var e = this.displayedMemory;
                                            this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = e, this.writeScreen = this.nonDisplayedMemory, this.logger.log(r.TEXT, "DISP: " + this.displayedMemory.getDisplayText());
                                        }
                                        this.outputDataUpdate(!0);
                                    }, t.ccTO = function(e) {
                                        this.logger.log(r.INFO, "TO(" + e + ") - Tab Offset"), this.writeScreen.moveCursor(e);
                                    }, t.ccMIDROW = function(e) {
                                        var t = {
                                            flash: !1
                                        };
                                        if (t.underline = e % 2 == 1, t.italics = e >= 46, t.italics) t.foreground = "white";
                                        else {
                                            var n = Math.floor(e / 2) - 16;
                                            t.foreground = [
                                                "white",
                                                "green",
                                                "blue",
                                                "cyan",
                                                "red",
                                                "yellow",
                                                "magenta"
                                            ][n];
                                        }
                                        this.logger.log(r.INFO, "MIDROW: " + JSON.stringify(t)), this.writeScreen.setPen(t);
                                    }, t.outputDataUpdate = function(e) {
                                        void 0 === e && (e = !1);
                                        var t = this.logger.time;
                                        null !== t && this.outputFilter && (null !== this.cueStartTime || this.displayedMemory.isEmpty() ? this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen), e && this.outputFilter.dispatchCue && this.outputFilter.dispatchCue(), this.cueStartTime = this.displayedMemory.isEmpty() ? null : t) : this.cueStartTime = t, this.lastOutputScreen.copy(this.displayedMemory));
                                    }, t.cueSplitAtTime = function(e) {
                                        this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, e, this.displayedMemory), this.cueStartTime = e));
                                    }, e;
                                }();
                                function b(e, t, n) {
                                    n.a = e, n.b = t;
                                }
                                function A(e, t, n) {
                                    return n.a === e && n.b === t;
                                }
                                const _ = function() {
                                    function e(e, t, n) {
                                        this.channels = void 0, this.currentChannel = 0, this.cmdHistory = void 0, this.logger = void 0;
                                        var r = new g;
                                        this.channels = [
                                            null,
                                            new T(e, t, r),
                                            new T(e + 1, n, r)
                                        ], this.cmdHistory = {
                                            a: null,
                                            b: null
                                        }, this.logger = r;
                                    }
                                    var t = e.prototype;
                                    return t.getHandler = function(e) {
                                        return this.channels[e].getHandler();
                                    }, t.setHandler = function(e, t) {
                                        this.channels[e].setHandler(t);
                                    }, t.addData = function(e, t) {
                                        var n, i, a1, o = !1;
                                        this.logger.time = e;
                                        for(var s1 = 0; s1 < t.length; s1 += 2)if (i = 127 & t[s1], a1 = 127 & t[s1 + 1], 0 !== i || 0 !== a1) {
                                            if (this.logger.log(r.DATA, "[" + p([
                                                t[s1],
                                                t[s1 + 1]
                                            ]) + "] -> (" + p([
                                                i,
                                                a1
                                            ]) + ")"), (n = this.parseCmd(i, a1)) || (n = this.parseMidrow(i, a1)), n || (n = this.parsePAC(i, a1)), n || (n = this.parseBackgroundAttributes(i, a1)), !n && (o = this.parseChars(i, a1))) {
                                                var u = this.currentChannel;
                                                u && u > 0 ? this.channels[u].insertChars(o) : this.logger.log(r.WARNING, "No channel found yet. TEXT-MODE?");
                                            }
                                            n || o || this.logger.log(r.WARNING, "Couldn't parse cleaned data " + p([
                                                i,
                                                a1
                                            ]) + " orig: " + p([
                                                t[s1],
                                                t[s1 + 1]
                                            ]));
                                        }
                                    }, t.parseCmd = function(e, t) {
                                        var n = this.cmdHistory;
                                        if (!((20 === e || 28 === e || 21 === e || 29 === e) && t >= 32 && t <= 47 || (23 === e || 31 === e) && t >= 33 && t <= 35)) return !1;
                                        if (A(e, t, n)) return b(null, null, n), this.logger.log(r.DEBUG, "Repeated command (" + p([
                                            e,
                                            t
                                        ]) + ") is dropped"), !0;
                                        var i = 20 === e || 21 === e || 23 === e ? 1 : 2, a1 = this.channels[i];
                                        return 20 === e || 21 === e || 28 === e || 29 === e ? 32 === t ? a1.ccRCL() : 33 === t ? a1.ccBS() : 34 === t ? a1.ccAOF() : 35 === t ? a1.ccAON() : 36 === t ? a1.ccDER() : 37 === t ? a1.ccRU(2) : 38 === t ? a1.ccRU(3) : 39 === t ? a1.ccRU(4) : 40 === t ? a1.ccFON() : 41 === t ? a1.ccRDC() : 42 === t ? a1.ccTR() : 43 === t ? a1.ccRTD() : 44 === t ? a1.ccEDM() : 45 === t ? a1.ccCR() : 46 === t ? a1.ccENM() : 47 === t && a1.ccEOC() : a1.ccTO(t - 32), b(e, t, n), this.currentChannel = i, !0;
                                    }, t.parseMidrow = function(e, t) {
                                        var n = 0;
                                        if ((17 === e || 25 === e) && t >= 32 && t <= 47) {
                                            if ((n = 17 === e ? 1 : 2) !== this.currentChannel) return this.logger.log(r.ERROR, "Mismatch channel in midrow parsing"), !1;
                                            var i = this.channels[n];
                                            return !!i && (i.ccMIDROW(t), this.logger.log(r.DEBUG, "MIDROW (" + p([
                                                e,
                                                t
                                            ]) + ")"), !0);
                                        }
                                        return !1;
                                    }, t.parsePAC = function(e, t) {
                                        var n, r = this.cmdHistory;
                                        if (!((e >= 17 && e <= 23 || e >= 25 && e <= 31) && t >= 64 && t <= 127 || (16 === e || 24 === e) && t >= 64 && t <= 95)) return !1;
                                        if (A(e, t, r)) return b(null, null, r), !0;
                                        var i = e <= 23 ? 1 : 2;
                                        n = t >= 64 && t <= 95 ? 1 === i ? l[e] : d[e] : 1 === i ? c[e] : f[e];
                                        var a1 = this.channels[i];
                                        return !!a1 && (a1.setPAC(this.interpretPAC(n, t)), b(e, t, r), this.currentChannel = i, !0);
                                    }, t.interpretPAC = function(e, t) {
                                        var n, r = {
                                            color: null,
                                            italics: !1,
                                            indent: null,
                                            underline: !1,
                                            row: e
                                        };
                                        return n = t > 95 ? t - 96 : t - 64, r.underline = 1 == (1 & n), n <= 13 ? r.color = [
                                            "white",
                                            "green",
                                            "blue",
                                            "cyan",
                                            "red",
                                            "yellow",
                                            "magenta",
                                            "white"
                                        ][Math.floor(n / 2)] : n <= 15 ? (r.italics = !0, r.color = "white") : r.indent = 4 * Math.floor((n - 16) / 2), r;
                                    }, t.parseChars = function(e, t) {
                                        var n, i, a1 = null, s1 = null;
                                        if (e >= 25 ? (n = 2, s1 = e - 8) : (n = 1, s1 = e), s1 >= 17 && s1 <= 19 ? (i = 17 === s1 ? t + 80 : 18 === s1 ? t + 112 : t + 144, this.logger.log(r.INFO, "Special char '" + o(i) + "' in channel " + n), a1 = [
                                            i
                                        ]) : e >= 32 && e <= 127 && (a1 = 0 === t ? [
                                            e
                                        ] : [
                                            e,
                                            t
                                        ]), a1) {
                                            var u = p(a1);
                                            this.logger.log(r.DEBUG, "Char codes =  " + u.join(",")), b(e, t, this.cmdHistory);
                                        }
                                        return a1;
                                    }, t.parseBackgroundAttributes = function(e, t) {
                                        var n;
                                        if (!((16 === e || 24 === e) && t >= 32 && t <= 47 || (23 === e || 31 === e) && t >= 45 && t <= 47)) return !1;
                                        var r = {};
                                        16 === e || 24 === e ? (n = Math.floor((t - 32) / 2), r.background = h[n], t % 2 == 1 && (r.background = r.background + "_semi")) : 45 === t ? r.background = "transparent" : (r.foreground = "black", 47 === t && (r.underline = !0));
                                        var i = e <= 23 ? 1 : 2;
                                        return this.channels[i].setBkgData(r), b(e, t, this.cmdHistory), !0;
                                    }, t.reset = function() {
                                        for(var e = 0; e < Object.keys(this.channels).length; e++){
                                            var t = this.channels[e];
                                            t && t.reset();
                                        }
                                        this.cmdHistory = {
                                            a: null,
                                            b: null
                                        };
                                    }, t.cueSplitAtTime = function(e) {
                                        for(var t = 0; t < this.channels.length; t++){
                                            var n = this.channels[t];
                                            n && n.cueSplitAtTime(e);
                                        }
                                    }, e;
                                }();
                            },
                            "./src/utils/codecs.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    isCodecSupportedInMp4: ()=>a1,
                                    isCodecType: ()=>i
                                });
                                var r = {
                                    audio: {
                                        a3ds: !0,
                                        "ac-3": !0,
                                        "ac-4": !0,
                                        alac: !0,
                                        alaw: !0,
                                        dra1: !0,
                                        "dts+": !0,
                                        "dts-": !0,
                                        dtsc: !0,
                                        dtse: !0,
                                        dtsh: !0,
                                        "ec-3": !0,
                                        enca: !0,
                                        g719: !0,
                                        g726: !0,
                                        m4ae: !0,
                                        mha1: !0,
                                        mha2: !0,
                                        mhm1: !0,
                                        mhm2: !0,
                                        mlpa: !0,
                                        mp4a: !0,
                                        "raw ": !0,
                                        Opus: !0,
                                        opus: !0,
                                        samr: !0,
                                        sawb: !0,
                                        sawp: !0,
                                        sevc: !0,
                                        sqcp: !0,
                                        ssmv: !0,
                                        twos: !0,
                                        ulaw: !0
                                    },
                                    video: {
                                        avc1: !0,
                                        avc2: !0,
                                        avc3: !0,
                                        avc4: !0,
                                        avcp: !0,
                                        av01: !0,
                                        drac: !0,
                                        dva1: !0,
                                        dvav: !0,
                                        dvh1: !0,
                                        dvhe: !0,
                                        encv: !0,
                                        hev1: !0,
                                        hvc1: !0,
                                        mjp2: !0,
                                        mp4v: !0,
                                        mvc1: !0,
                                        mvc2: !0,
                                        mvc3: !0,
                                        mvc4: !0,
                                        resv: !0,
                                        rv60: !0,
                                        s263: !0,
                                        svc1: !0,
                                        svc2: !0,
                                        "vc-1": !0,
                                        vp08: !0,
                                        vp09: !0
                                    },
                                    text: {
                                        stpp: !0,
                                        wvtt: !0
                                    }
                                };
                                function i(e, t) {
                                    var n = r[t];
                                    return !!n && !0 === n[e.slice(0, 4)];
                                }
                                function a1(e, t) {
                                    return MediaSource.isTypeSupported((t || "video") + '/mp4;codecs="' + e + '"');
                                }
                            },
                            "./src/utils/cues.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>s1
                                });
                                var r = n("./src/utils/vttparser.ts"), i = n("./src/utils/webvtt-parser.ts"), a1 = n("./src/utils/texttrack-utils.ts"), o = /\s/;
                                const s1 = {
                                    newCue: function(e, t, n, s1) {
                                        for(var u, l, c, d, f, h = [], g = self.VTTCue || self.TextTrackCue, p = 0; p < s1.rows.length; p++)if (c = !0, d = 0, f = "", !(u = s1.rows[p]).isEmpty()) {
                                            for(var m = 0; m < u.chars.length; m++)o.test(u.chars[m].uchar) && c ? d++ : (f += u.chars[m].uchar, c = !1);
                                            u.cueStartTime = t, t === n && (n += 1e-4), d >= 16 ? d-- : d++;
                                            var v = (0, r.fixLineBreaks)(f.trim()), y = (0, i.generateCueId)(t, n, v);
                                            e && e.cues && e.cues.getCueById(y) || ((l = new g(t, n, v)).id = y, l.line = p + 1, l.align = "left", l.position = 10 + Math.min(80, 10 * Math.floor(8 * d / 32)), h.push(l));
                                        }
                                        return e && h.length && (h.sort(function(e, t) {
                                            return "auto" === e.line || "auto" === t.line ? 0 : e.line > 8 && t.line > 8 ? t.line - e.line : e.line - t.line;
                                        }), h.forEach(function(t) {
                                            return (0, a1.addCueToTrack)(e, t);
                                        })), h;
                                    }
                                };
                            },
                            "./src/utils/discontinuities.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    adjustSlidingStart: ()=>c,
                                    alignMediaPlaylistByPDT: ()=>h,
                                    alignPDT: ()=>f,
                                    alignStream: ()=>d,
                                    findDiscontinuousReferenceFrag: ()=>u,
                                    findFirstFragWithCC: ()=>o,
                                    shouldAlignOnDiscontinuities: ()=>s1
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./src/utils/logger.ts"), a1 = n("./src/controller/level-helper.ts");
                                function o(e, t) {
                                    for(var n = null, r = 0, i = e.length; r < i; r++){
                                        var a1 = e[r];
                                        if (a1 && a1.cc === t) {
                                            n = a1;
                                            break;
                                        }
                                    }
                                    return n;
                                }
                                function s1(e, t, n) {
                                    return !(!t.details || !(n.endCC > n.startCC || e && e.cc < n.startCC));
                                }
                                function u(e, t, n) {
                                    void 0 === n && (n = 0);
                                    var r = e.fragments, a1 = t.fragments;
                                    if (a1.length && r.length) {
                                        var s1 = o(r, a1[0].cc);
                                        if (s1 && (!s1 || s1.startPTS)) return s1;
                                        i.logger.log("No frag in previous level to align on");
                                    } else i.logger.log("No fragments to align");
                                }
                                function l(e, t) {
                                    if (e) {
                                        var n = e.start + t;
                                        e.start = e.startPTS = n, e.endPTS = n + e.duration;
                                    }
                                }
                                function c(e, t) {
                                    for(var n = t.fragments, r = 0, i = n.length; r < i; r++)l(n[r], e);
                                    t.fragmentHint && l(t.fragmentHint, e), t.alignedSliding = !0;
                                }
                                function d(e, t, n) {
                                    t && (function(e, t, n) {
                                        if (s1(e, n, t)) {
                                            var a1 = u(n.details, t);
                                            a1 && (0, r.isFiniteNumber)(a1.start) && (i.logger.log("Adjusting PTS using last level due to CC increase within current level " + t.url), c(a1.start, t));
                                        }
                                    }(e, n, t), !n.alignedSliding && t.details && f(n, t.details), n.alignedSliding || !t.details || n.skippedSegments || (0, a1.adjustSliding)(t.details, n));
                                }
                                function f(e, t) {
                                    if (t.fragments.length && e.hasProgramDateTime && t.hasProgramDateTime) {
                                        var n = t.fragments[0].programDateTime, a1 = e.fragments[0].programDateTime, o = (a1 - n) / 1e3 + t.fragments[0].start;
                                        o && (0, r.isFiniteNumber)(o) && (i.logger.log("Adjusting PTS using programDateTime delta " + (a1 - n) + "ms, sliding:" + o.toFixed(3) + " " + e.url + " "), c(o, e));
                                    }
                                }
                                function h(e, t) {
                                    if (e.hasProgramDateTime && t.hasProgramDateTime) {
                                        var n = e.fragments, r = t.fragments;
                                        if (n.length && r.length) {
                                            var i = r[Math.round(r.length / 2) - 1], a1 = o(n, i.cc) || n[Math.round(n.length / 2) - 1], s1 = i.programDateTime, u = a1.programDateTime;
                                            null !== s1 && null !== u && c((u - s1) / 1e3 - (a1.start - i.start), e);
                                        }
                                    }
                                }
                            },
                            "./src/utils/ewma-bandwidth-estimator.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>i
                                });
                                var r = n("./src/utils/ewma.ts");
                                const i = function() {
                                    function e(e, t, n) {
                                        this.defaultEstimate_ = void 0, this.minWeight_ = void 0, this.minDelayMs_ = void 0, this.slow_ = void 0, this.fast_ = void 0, this.defaultEstimate_ = n, this.minWeight_ = .001, this.minDelayMs_ = 50, this.slow_ = new r.default(e), this.fast_ = new r.default(t);
                                    }
                                    var t = e.prototype;
                                    return t.update = function(e, t) {
                                        var n = this.slow_, i = this.fast_;
                                        this.slow_.halfLife !== e && (this.slow_ = new r.default(e, n.getEstimate(), n.getTotalWeight())), this.fast_.halfLife !== t && (this.fast_ = new r.default(t, i.getEstimate(), i.getTotalWeight()));
                                    }, t.sample = function(e, t) {
                                        var n = (e = Math.max(e, this.minDelayMs_)) / 1e3, r = 8 * t / n;
                                        this.fast_.sample(n, r), this.slow_.sample(n, r);
                                    }, t.canEstimate = function() {
                                        var e = this.fast_;
                                        return e && e.getTotalWeight() >= this.minWeight_;
                                    }, t.getEstimate = function() {
                                        return this.canEstimate() ? Math.min(this.fast_.getEstimate(), this.slow_.getEstimate()) : this.defaultEstimate_;
                                    }, t.destroy = function() {}, e;
                                }();
                            },
                            "./src/utils/ewma.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>r
                                });
                                const r = function() {
                                    function e(e, t, n) {
                                        void 0 === t && (t = 0), void 0 === n && (n = 0), this.halfLife = void 0, this.alpha_ = void 0, this.estimate_ = void 0, this.totalWeight_ = void 0, this.halfLife = e, this.alpha_ = e ? Math.exp(Math.log(.5) / e) : 0, this.estimate_ = t, this.totalWeight_ = n;
                                    }
                                    var t = e.prototype;
                                    return t.sample = function(e, t) {
                                        var n = Math.pow(this.alpha_, e);
                                        this.estimate_ = t * (1 - n) + n * this.estimate_, this.totalWeight_ += e;
                                    }, t.getTotalWeight = function() {
                                        return this.totalWeight_;
                                    }, t.getEstimate = function() {
                                        if (this.alpha_) {
                                            var e = 1 - Math.pow(this.alpha_, this.totalWeight_);
                                            if (e) return this.estimate_ / e;
                                        }
                                        return this.estimate_;
                                    }, e;
                                }();
                            },
                            "./src/utils/fetch-loader.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>m,
                                    fetchSupported: ()=>f
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./src/loader/load-stats.ts"), a1 = n("./src/demux/chunk-cache.ts");
                                function o(e) {
                                    var t = "function" == typeof Map ? new Map : void 0;
                                    return o = function(e) {
                                        if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
                                        var n;
                                        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                                        if (void 0 !== t) {
                                            if (t.has(e)) return t.get(e);
                                            t.set(e, r);
                                        }
                                        function r() {
                                            return s1(e, arguments, c(this).constructor);
                                        }
                                        return r.prototype = Object.create(e.prototype, {
                                            constructor: {
                                                value: r,
                                                enumerable: !1,
                                                writable: !0,
                                                configurable: !0
                                            }
                                        }), l(r, e);
                                    }, o(e);
                                }
                                function s1(e, t, n) {
                                    return s1 = u() ? Reflect.construct.bind() : function(e, t, n) {
                                        var r = [
                                            null
                                        ];
                                        r.push.apply(r, t);
                                        var i = new (Function.bind.apply(e, r));
                                        return n && l(i, n.prototype), i;
                                    }, s1.apply(null, arguments);
                                }
                                function u() {
                                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                    if (Reflect.construct.sham) return !1;
                                    if ("function" == typeof Proxy) return !0;
                                    try {
                                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                }
                                function l(e, t) {
                                    return l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                                        return e.__proto__ = t, e;
                                    }, l(e, t);
                                }
                                function c(e) {
                                    return c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                                        return e.__proto__ || Object.getPrototypeOf(e);
                                    }, c(e);
                                }
                                function d() {
                                    return d = Object.assign ? Object.assign.bind() : function(e) {
                                        for(var t = 1; t < arguments.length; t++){
                                            var n = arguments[t];
                                            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                                        }
                                        return e;
                                    }, d.apply(this, arguments);
                                }
                                function f() {
                                    if (self.fetch && self.AbortController && self.ReadableStream && self.Request) try {
                                        return new self.ReadableStream({}), !0;
                                    } catch (e) {}
                                    return !1;
                                }
                                var h = function() {
                                    function e(e) {
                                        this.fetchSetup = void 0, this.requestTimeout = void 0, this.request = void 0, this.response = void 0, this.controller = void 0, this.context = void 0, this.config = null, this.callbacks = null, this.stats = void 0, this.loader = null, this.fetchSetup = e.fetchSetup || g, this.controller = new self.AbortController, this.stats = new i.LoadStats;
                                    }
                                    var t = e.prototype;
                                    return t.destroy = function() {
                                        this.loader = this.callbacks = null, this.abortInternal();
                                    }, t.abortInternal = function() {
                                        var e = this.response;
                                        e && e.ok || (this.stats.aborted = !0, this.controller.abort());
                                    }, t.abort = function() {
                                        var e;
                                        this.abortInternal(), null !== (e = this.callbacks) && void 0 !== e && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.response);
                                    }, t.load = function(e, t, n) {
                                        var i = this, a1 = this.stats;
                                        if (a1.loading.start) throw new Error("Loader can only be used once.");
                                        a1.loading.start = self.performance.now();
                                        var o = function(e, t) {
                                            var n = {
                                                method: "GET",
                                                mode: "cors",
                                                credentials: "same-origin",
                                                signal: t,
                                                headers: new self.Headers(d({}, e.headers))
                                            };
                                            return e.rangeEnd && n.headers.set("Range", "bytes=" + e.rangeStart + "-" + String(e.rangeEnd - 1)), n;
                                        }(e, this.controller.signal), s1 = n.onProgress, u = "arraybuffer" === e.responseType, l = u ? "byteLength" : "length";
                                        this.context = e, this.config = t, this.callbacks = n, this.request = this.fetchSetup(e, o), self.clearTimeout(this.requestTimeout), this.requestTimeout = self.setTimeout(function() {
                                            i.abortInternal(), n.onTimeout(a1, e, i.response);
                                        }, t.timeout), self.fetch(this.request).then(function(n) {
                                            if (i.response = i.loader = n, !n.ok) {
                                                var o = n.status, l = n.statusText;
                                                throw new p(l || "fetch, bad network response", o, n);
                                            }
                                            return a1.loading.first = Math.max(self.performance.now(), a1.loading.start), a1.total = parseInt(n.headers.get("Content-Length") || "0"), s1 && (0, r.isFiniteNumber)(t.highWaterMark) ? i.loadProgressively(n, a1, e, t.highWaterMark, s1) : u ? n.arrayBuffer() : n.text();
                                        }).then(function(o) {
                                            var u = i.response;
                                            self.clearTimeout(i.requestTimeout), a1.loading.end = Math.max(self.performance.now(), a1.loading.first), a1.loaded = a1.total = o[l];
                                            var c = {
                                                url: u.url,
                                                data: o
                                            };
                                            s1 && !(0, r.isFiniteNumber)(t.highWaterMark) && s1(a1, e, o, u), n.onSuccess(c, a1, e, u);
                                        }).catch(function(t) {
                                            if (self.clearTimeout(i.requestTimeout), !a1.aborted) {
                                                var r = t && t.code || 0, o = t ? t.message : null;
                                                n.onError({
                                                    code: r,
                                                    text: o
                                                }, e, t ? t.details : null);
                                            }
                                        });
                                    }, t.getCacheAge = function() {
                                        var e = null;
                                        if (this.response) {
                                            var t = this.response.headers.get("age");
                                            e = t ? parseFloat(t) : null;
                                        }
                                        return e;
                                    }, t.loadProgressively = function(e, t, n, r, i) {
                                        void 0 === r && (r = 0);
                                        var o = new a1.default, s1 = e.body.getReader();
                                        return function a1() {
                                            return s1.read().then(function(s1) {
                                                if (s1.done) return o.dataLength && i(t, n, o.flush(), e), Promise.resolve(new ArrayBuffer(0));
                                                var u = s1.value, l = u.length;
                                                return t.loaded += l, l < r || o.dataLength ? (o.push(u), o.dataLength >= r && i(t, n, o.flush(), e)) : i(t, n, u, e), a1();
                                            }).catch(function() {
                                                return Promise.reject();
                                            });
                                        }();
                                    }, e;
                                }();
                                function g(e, t) {
                                    return new self.Request(e.url, t);
                                }
                                var p = function(e) {
                                    var t, n;
                                    function r(t, n, r) {
                                        var i;
                                        return (i = e.call(this, t) || this).code = void 0, i.details = void 0, i.code = n, i.details = r, i;
                                    }
                                    return n = e, (t = r).prototype = Object.create(n.prototype), t.prototype.constructor = t, l(t, n), r;
                                }(o(Error));
                                const m = h;
                            },
                            "./src/utils/imsc1-ttml-parser.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    IMSC1_CODEC: ()=>c,
                                    parseIMSC1: ()=>g
                                });
                                var r = n("./src/utils/mp4-tools.ts"), i = n("./src/utils/vttparser.ts"), a1 = n("./src/utils/vttcue.ts"), o = n("./src/demux/id3.ts"), s1 = n("./src/utils/timescale-conversion.ts"), u = n("./src/utils/webvtt-parser.ts");
                                function l() {
                                    return l = Object.assign ? Object.assign.bind() : function(e) {
                                        for(var t = 1; t < arguments.length; t++){
                                            var n = arguments[t];
                                            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                                        }
                                        return e;
                                    }, l.apply(this, arguments);
                                }
                                var c = "stpp.ttml.im1t", d = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/, f = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/, h = {
                                    left: "start",
                                    center: "center",
                                    right: "end",
                                    start: "start",
                                    end: "end"
                                };
                                function g(e, t, n, i, c) {
                                    var d = (0, r.findBox)(new Uint8Array(e), [
                                        "mdat"
                                    ]);
                                    if (0 !== d.length) {
                                        var f = d.map(function(e) {
                                            return (0, o.utf8ArrayToStr)(e);
                                        }), g = (0, s1.toTimescaleFromScale)(t, 1, n);
                                        try {
                                            f.forEach(function(e) {
                                                return i(function(e, t) {
                                                    var n = (new DOMParser).parseFromString(e, "text/xml").getElementsByTagName("tt")[0];
                                                    if (!n) throw new Error("Invalid ttml");
                                                    var r = {
                                                        frameRate: 30,
                                                        subFrameRate: 1,
                                                        frameRateMultiplier: 0,
                                                        tickRate: 0
                                                    }, i = Object.keys(r).reduce(function(e, t) {
                                                        return e[t] = n.getAttribute("ttp:" + t) || r[t], e;
                                                    }, {}), o = "preserve" !== n.getAttribute("xml:space"), s1 = m(p(n, "styling", "style")), c = m(p(n, "layout", "region")), d = p(n, "body", "[begin]");
                                                    return [].map.call(d, function(e) {
                                                        var n = v(e, o);
                                                        if (!n || !e.hasAttribute("begin")) return null;
                                                        var r = T(e.getAttribute("begin"), i), d = T(e.getAttribute("dur"), i), f = T(e.getAttribute("end"), i);
                                                        if (null === r) throw E(e);
                                                        if (null === f) {
                                                            if (null === d) throw E(e);
                                                            f = r + d;
                                                        }
                                                        var g = new a1.default(r - t, f - t, n);
                                                        g.id = (0, u.generateCueId)(g.startTime, g.endTime, g.text);
                                                        var p = c[e.getAttribute("region")], m = s1[e.getAttribute("style")];
                                                        g.position = 10, g.size = 80;
                                                        var b = function(e, t, n) {
                                                            var r = "http://www.w3.org/ns/ttml#styling", i = null, a1 = null != e && e.hasAttribute("style") ? e.getAttribute("style") : null;
                                                            return a1 && n.hasOwnProperty(a1) && (i = n[a1]), [
                                                                "displayAlign",
                                                                "textAlign",
                                                                "color",
                                                                "backgroundColor",
                                                                "fontSize",
                                                                "fontFamily"
                                                            ].reduce(function(n, a1) {
                                                                var o = y(t, r, a1) || y(e, r, a1) || y(i, r, a1);
                                                                return o && (n[a1] = o), n;
                                                            }, {});
                                                        }(p, m, s1), A = b.textAlign;
                                                        if (A) {
                                                            var _ = h[A];
                                                            _ && (g.lineAlign = _), g.align = A;
                                                        }
                                                        return l(g, b), g;
                                                    }).filter(function(e) {
                                                        return null !== e;
                                                    });
                                                }(e, g));
                                            });
                                        } catch (e) {
                                            c(e);
                                        }
                                    } else c(new Error("Could not parse IMSC1 mdat"));
                                }
                                function p(e, t, n) {
                                    var r = e.getElementsByTagName(t)[0];
                                    return r ? [].slice.call(r.querySelectorAll(n)) : [];
                                }
                                function m(e) {
                                    return e.reduce(function(e, t) {
                                        var n = t.getAttribute("xml:id");
                                        return n && (e[n] = t), e;
                                    }, {});
                                }
                                function v(e, t) {
                                    return [].slice.call(e.childNodes).reduce(function(e, n, r) {
                                        var i;
                                        return "br" === n.nodeName && r ? e + "\n" : null !== (i = n.childNodes) && void 0 !== i && i.length ? v(n, t) : t ? e + n.textContent.trim().replace(/\s+/g, " ") : e + n.textContent;
                                    }, "");
                                }
                                function y(e, t, n) {
                                    return e && e.hasAttributeNS(t, n) ? e.getAttributeNS(t, n) : null;
                                }
                                function E(e) {
                                    return new Error("Could not parse ttml timestamp " + e);
                                }
                                function T(e, t) {
                                    if (!e) return null;
                                    var n = (0, i.parseTimeStamp)(e);
                                    return null === n && (d.test(e) ? n = function(e, t) {
                                        var n = d.exec(e), r = (0 | n[4]) + (0 | n[5]) / t.subFrameRate;
                                        return 3600 * (0 | n[1]) + 60 * (0 | n[2]) + (0 | n[3]) + r / t.frameRate;
                                    }(e, t) : f.test(e) && (n = function(e, t) {
                                        var n = f.exec(e), r = Number(n[1]);
                                        switch(n[2]){
                                            case "h":
                                                return 3600 * r;
                                            case "m":
                                                return 60 * r;
                                            case "ms":
                                                return 1e3 * r;
                                            case "f":
                                                return r / t.frameRate;
                                            case "t":
                                                return r / t.tickRate;
                                        }
                                        return r;
                                    }(e, t))), n;
                                }
                            },
                            "./src/utils/logger.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    enableLogs: ()=>s1,
                                    logger: ()=>u
                                });
                                var r = function() {}, i = {
                                    trace: r,
                                    debug: r,
                                    log: r,
                                    warn: r,
                                    info: r,
                                    error: r
                                }, a1 = i;
                                function o(e) {
                                    var t = self.console[e];
                                    return t ? t.bind(self.console, "[" + e + "] >") : r;
                                }
                                function s1(e, t) {
                                    if (self.console && !0 === e || "object" == typeof e) {
                                        !function(e) {
                                            for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
                                            n.forEach(function(t) {
                                                a1[t] = e[t] ? e[t].bind(e) : o(t);
                                            });
                                        }(e, "debug", "log", "info", "warn", "error");
                                        try {
                                            a1.log('Debug logs enabled for "' + t + '"');
                                        } catch (e) {
                                            a1 = i;
                                        }
                                    } else a1 = i;
                                }
                                var u = i;
                            },
                            "./src/utils/mediakeys-helper.ts": (e, t, n)=>{
                                "use strict";
                                var r;
                                n.r(t), n.d(t, {
                                    KeySystems: ()=>r,
                                    requestMediaKeySystemAccess: ()=>i
                                }), function(e) {
                                    e.WIDEVINE = "com.widevine.alpha", e.PLAYREADY = "com.microsoft.playready";
                                }(r || (r = {}));
                                var i = "undefined" != typeof self && self.navigator && self.navigator.requestMediaKeySystemAccess ? self.navigator.requestMediaKeySystemAccess.bind(self.navigator) : null;
                            },
                            "./src/utils/mediasource-helper.ts": (e, t, n)=>{
                                "use strict";
                                function r() {
                                    return self.MediaSource || self.WebKitMediaSource;
                                }
                                n.r(t), n.d(t, {
                                    getMediaSource: ()=>r
                                });
                            },
                            "./src/utils/mp4-tools.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    RemuxerTrackIdConfig: ()=>u,
                                    appendUint8Array: ()=>A,
                                    bin2str: ()=>l,
                                    computeRawDurationFromSamples: ()=>E,
                                    discardEPB: ()=>I,
                                    findBox: ()=>g,
                                    getDuration: ()=>y,
                                    getStartDTS: ()=>v,
                                    offsetStartDTS: ()=>T,
                                    parseEmsg: ()=>R,
                                    parseInitSegment: ()=>m,
                                    parseSEIMessageFromNALu: ()=>w,
                                    parseSamples: ()=>_,
                                    parseSegmentIndex: ()=>p,
                                    readSint32: ()=>f,
                                    readUint16: ()=>c,
                                    readUint32: ()=>d,
                                    segmentValidRange: ()=>b,
                                    writeUint32: ()=>h
                                });
                                var r = n("./src/utils/typed-array.ts"), i = n("./src/loader/fragment.ts"), a1 = n("./src/demux/id3.ts"), o = Math.pow(2, 32) - 1, s1 = [].push, u = {
                                    video: 1,
                                    audio: 2,
                                    id3: 3,
                                    text: 4
                                };
                                function l(e) {
                                    return String.fromCharCode.apply(null, e);
                                }
                                function c(e, t) {
                                    var n = e[t] << 8 | e[t + 1];
                                    return n < 0 ? 65536 + n : n;
                                }
                                function d(e, t) {
                                    var n = f(e, t);
                                    return n < 0 ? 4294967296 + n : n;
                                }
                                function f(e, t) {
                                    return e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3];
                                }
                                function h(e, t, n) {
                                    e[t] = n >> 24, e[t + 1] = n >> 16 & 255, e[t + 2] = n >> 8 & 255, e[t + 3] = 255 & n;
                                }
                                function g(e, t) {
                                    var n = [];
                                    if (!t.length) return n;
                                    for(var r = e.byteLength, i = 0; i < r;){
                                        var a1 = d(e, i), o = a1 > 1 ? i + a1 : r;
                                        if (l(e.subarray(i + 4, i + 8)) === t[0]) {
                                            if (1 === t.length) n.push(e.subarray(i + 8, o));
                                            else {
                                                var u = g(e.subarray(i + 8, o), t.slice(1));
                                                u.length && s1.apply(n, u);
                                            }
                                        }
                                        i = o;
                                    }
                                    return n;
                                }
                                function p(e) {
                                    var t = [], n = e[0], r = 8, i = d(e, r);
                                    r += 4, r += 0 === n ? 8 : 16, r += 2;
                                    var a1 = e.length + 0, o = c(e, r);
                                    r += 2;
                                    for(var s1 = 0; s1 < o; s1++){
                                        var u = r, l = d(e, u);
                                        u += 4;
                                        var f = 2147483647 & l;
                                        if (1 == (2147483648 & l) >>> 31) return console.warn("SIDX has hierarchical references (not supported)"), null;
                                        var h = d(e, u);
                                        u += 4, t.push({
                                            referenceSize: f,
                                            subsegmentDuration: h,
                                            info: {
                                                duration: h / i,
                                                start: a1,
                                                end: a1 + f - 1
                                            }
                                        }), a1 += f, r = u += 4;
                                    }
                                    return {
                                        earliestPresentationTime: 0,
                                        timescale: i,
                                        version: n,
                                        referencesCount: o,
                                        references: t
                                    };
                                }
                                function m(e) {
                                    for(var t = [], n = g(e, [
                                        "moov",
                                        "trak"
                                    ]), r = 0; r < n.length; r++){
                                        var a1 = n[r], o = g(a1, [
                                            "tkhd"
                                        ])[0];
                                        if (o) {
                                            var s1 = o[0], u = 0 === s1 ? 12 : 20, c = d(o, u), f = g(a1, [
                                                "mdia",
                                                "mdhd"
                                            ])[0];
                                            if (f) {
                                                var h = d(f, u = 0 === (s1 = f[0]) ? 12 : 20), p = g(a1, [
                                                    "mdia",
                                                    "hdlr"
                                                ])[0];
                                                if (p) {
                                                    var m = l(p.subarray(8, 12)), v = {
                                                        soun: i.ElementaryStreamTypes.AUDIO,
                                                        vide: i.ElementaryStreamTypes.VIDEO
                                                    }[m];
                                                    if (v) {
                                                        var y = g(a1, [
                                                            "mdia",
                                                            "minf",
                                                            "stbl",
                                                            "stsd"
                                                        ])[0], E = void 0;
                                                        y && (E = l(y.subarray(12, 16))), t[c] = {
                                                            timescale: h,
                                                            type: v
                                                        }, t[v] = {
                                                            timescale: h,
                                                            id: c,
                                                            codec: E
                                                        };
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    return g(e, [
                                        "moov",
                                        "mvex",
                                        "trex"
                                    ]).forEach(function(e) {
                                        var n = d(e, 4), r = t[n];
                                        r && (r.default = {
                                            duration: d(e, 12),
                                            flags: d(e, 20)
                                        });
                                    }), t;
                                }
                                function v(e, t) {
                                    return g(t, [
                                        "moof",
                                        "traf"
                                    ]).reduce(function(t, n) {
                                        var r = g(n, [
                                            "tfdt"
                                        ])[0], i = r[0], a1 = g(n, [
                                            "tfhd"
                                        ]).reduce(function(t, n) {
                                            var a1 = d(n, 4), o = e[a1];
                                            if (o) {
                                                var s1 = d(r, 4);
                                                1 === i && (s1 *= Math.pow(2, 32), s1 += d(r, 8));
                                                var u = s1 / (o.timescale || 9e4);
                                                if (isFinite(u) && (null === t || u < t)) return u;
                                            }
                                            return t;
                                        }, null);
                                        return null !== a1 && isFinite(a1) && (null === t || a1 < t) ? a1 : t;
                                    }, null) || 0;
                                }
                                function y(e, t) {
                                    for(var n = 0, r = 0, a1 = 0, o = g(e, [
                                        "moof",
                                        "traf"
                                    ]), s1 = 0; s1 < o.length; s1++){
                                        var u = o[s1], l = g(u, [
                                            "tfhd"
                                        ])[0], c = t[d(l, 4)];
                                        if (c) {
                                            var f = c.default, h = d(l, 0) | (null == f ? void 0 : f.flags), m = null == f ? void 0 : f.duration;
                                            8 & h && (m = d(l, 2 & h ? 12 : 8));
                                            for(var v = c.timescale || 9e4, y = g(u, [
                                                "trun"
                                            ]), T = 0; T < y.length; T++)!(n = E(y[T])) && m && (n = m * d(y[T], 4)), c.type === i.ElementaryStreamTypes.VIDEO ? r += n / v : c.type === i.ElementaryStreamTypes.AUDIO && (a1 += n / v);
                                        }
                                    }
                                    if (0 === r && 0 === a1) {
                                        for(var b = 0, A = g(e, [
                                            "sidx"
                                        ]), _ = 0; _ < A.length; _++){
                                            var S = p(A[_]);
                                            null != S && S.references && (b += S.references.reduce(function(e, t) {
                                                return e + t.info.duration || 0;
                                            }, 0));
                                        }
                                        return b;
                                    }
                                    return r || a1;
                                }
                                function E(e) {
                                    var t = d(e, 0), n = 8;
                                    1 & t && (n += 4), 4 & t && (n += 4);
                                    for(var r = 0, i = d(e, 4), a1 = 0; a1 < i; a1++)256 & t && (r += d(e, n), n += 4), 512 & t && (n += 4), 1024 & t && (n += 4), 2048 & t && (n += 4);
                                    return r;
                                }
                                function T(e, t, n) {
                                    g(t, [
                                        "moof",
                                        "traf"
                                    ]).forEach(function(t) {
                                        g(t, [
                                            "tfhd"
                                        ]).forEach(function(r) {
                                            var i = d(r, 4), a1 = e[i];
                                            if (a1) {
                                                var s1 = a1.timescale || 9e4;
                                                g(t, [
                                                    "tfdt"
                                                ]).forEach(function(e) {
                                                    var t = e[0], r = d(e, 4);
                                                    if (0 === t) r -= n * s1, h(e, 4, r = Math.max(r, 0));
                                                    else {
                                                        r *= Math.pow(2, 32), r += d(e, 8), r -= n * s1, r = Math.max(r, 0);
                                                        var i = Math.floor(r / (o + 1)), a1 = Math.floor(r % (o + 1));
                                                        h(e, 4, i), h(e, 8, a1);
                                                    }
                                                });
                                            }
                                        });
                                    });
                                }
                                function b(e) {
                                    var t = {
                                        valid: null,
                                        remainder: null
                                    }, n = g(e, [
                                        "moof"
                                    ]);
                                    if (!n) return t;
                                    if (n.length < 2) return t.remainder = e, t;
                                    var i = n[n.length - 1];
                                    return t.valid = (0, r.sliceUint8)(e, 0, i.byteOffset - 8), t.remainder = (0, r.sliceUint8)(e, i.byteOffset - 8), t;
                                }
                                function A(e, t) {
                                    var n = new Uint8Array(e.length + t.length);
                                    return n.set(e), n.set(t, e.length), n;
                                }
                                function _(e, t) {
                                    var n = [], r = t.samples, a1 = t.timescale, o = t.id, s1 = !1;
                                    return g(r, [
                                        "moof"
                                    ]).map(function(u) {
                                        var l = u.byteOffset - 8;
                                        g(u, [
                                            "traf"
                                        ]).map(function(u) {
                                            var c = g(u, [
                                                "tfdt"
                                            ]).map(function(e) {
                                                var t = e[0], n = d(e, 4);
                                                return 1 === t && (n *= Math.pow(2, 32), n += d(e, 8)), n / a1;
                                            })[0];
                                            return void 0 !== c && (e = c), g(u, [
                                                "tfhd"
                                            ]).map(function(c) {
                                                var h = d(c, 4), p = 16777215 & d(c, 0), m = 0, v = 0 != (16 & p), y = 0, E = 0 != (32 & p), T = 8;
                                                h === o && (0 != (1 & p) && (T += 8), 0 != (2 & p) && (T += 4), 0 != (8 & p) && (m = d(c, T), T += 4), v && (y = d(c, T), T += 4), E && (T += 4), "video" === t.type && (s1 = function(e) {
                                                    if (!e) return !1;
                                                    var t = e.indexOf("."), n = t < 0 ? e : e.substring(0, t);
                                                    return "hvc1" === n || "hev1" === n || "dvh1" === n || "dvhe" === n;
                                                }(t.codec)), g(u, [
                                                    "trun"
                                                ]).map(function(o) {
                                                    var u = o[0], c = 16777215 & d(o, 0), h = 0 != (1 & c), g = 0, p = 0 != (4 & c), v = 0 != (256 & c), E = 0, T = 0 != (512 & c), b = 0, A = 0 != (1024 & c), _ = 0 != (2048 & c), I = 0, R = d(o, 4), C = 8;
                                                    h && (g = d(o, C), C += 4), p && (C += 4);
                                                    for(var D = g + l, k = 0; k < R; k++){
                                                        if (v ? (E = d(o, C), C += 4) : E = m, T ? (b = d(o, C), C += 4) : b = y, A && (C += 4), _ && (I = 0 === u ? d(o, C) : f(o, C), C += 4), t.type === i.ElementaryStreamTypes.VIDEO) for(var N = 0; N < b;){
                                                            var L = d(r, D);
                                                            S(s1, r[D += 4]) && w(r.subarray(D, D + L), s1 ? 2 : 1, e + I / a1, n), D += L, N += L + 4;
                                                        }
                                                        e += E / a1;
                                                    }
                                                }));
                                            });
                                        });
                                    }), n;
                                }
                                function S(e, t) {
                                    if (e) {
                                        var n = t >> 1 & 63;
                                        return 39 === n || 40 === n;
                                    }
                                    return 6 == (31 & t);
                                }
                                function w(e, t, n, r) {
                                    var i = I(e), o = 0;
                                    o += t;
                                    for(var s1 = 0, u = 0, l = !1, f = 0; o < i.length;){
                                        s1 = 0;
                                        do {
                                            if (o >= i.length) break;
                                            s1 += f = i[o++];
                                        }while (255 === f);
                                        u = 0;
                                        do {
                                            if (o >= i.length) break;
                                            u += f = i[o++];
                                        }while (255 === f);
                                        var h = i.length - o;
                                        if (!l && 4 === s1 && o < i.length) {
                                            if (l = !0, 181 === i[o++]) {
                                                var g = c(i, o);
                                                if (o += 2, 49 === g) {
                                                    var p = d(i, o);
                                                    if (o += 4, 1195456820 === p) {
                                                        var m = i[o++];
                                                        if (3 === m) {
                                                            var v = i[o++], y = 64 & v, E = y ? 2 + 3 * (31 & v) : 0, T = new Uint8Array(E);
                                                            if (y) {
                                                                T[0] = v;
                                                                for(var b = 1; b < E; b++)T[b] = i[o++];
                                                            }
                                                            r.push({
                                                                type: m,
                                                                payloadType: s1,
                                                                pts: n,
                                                                bytes: T
                                                            });
                                                        }
                                                    }
                                                }
                                            }
                                        } else if (5 === s1 && u < h) {
                                            if (l = !0, u > 16) {
                                                for(var A = [], _ = 0; _ < 16; _++){
                                                    var S = i[o++].toString(16);
                                                    A.push(1 == S.length ? "0" + S : S), 3 !== _ && 5 !== _ && 7 !== _ && 9 !== _ || A.push("-");
                                                }
                                                for(var w = u - 16, R = new Uint8Array(w), C = 0; C < w; C++)R[C] = i[o++];
                                                r.push({
                                                    payloadType: s1,
                                                    pts: n,
                                                    uuid: A.join(""),
                                                    userData: (0, a1.utf8ArrayToStr)(R),
                                                    userDataBytes: R
                                                });
                                            }
                                        } else if (u < h) o += u;
                                        else if (u > h) break;
                                    }
                                }
                                function I(e) {
                                    for(var t = e.byteLength, n = [], r = 1; r < t - 2;)0 === e[r] && 0 === e[r + 1] && 3 === e[r + 2] ? (n.push(r + 2), r += 2) : r++;
                                    if (0 === n.length) return e;
                                    var i = t - n.length, a1 = new Uint8Array(i), o = 0;
                                    for(r = 0; r < i; o++, r++)o === n[0] && (o++, n.shift()), a1[r] = e[o];
                                    return a1;
                                }
                                function R(e) {
                                    var t = e[0], n = "", r = "", i = 0, a1 = 0, o = 0, s1 = 0, u = 0, c = 0;
                                    if (0 === t) {
                                        for(; "\0" !== l(e.subarray(c, c + 1));)n += l(e.subarray(c, c + 1)), c += 1;
                                        for(n += l(e.subarray(c, c + 1)), c += 1; "\0" !== l(e.subarray(c, c + 1));)r += l(e.subarray(c, c + 1)), c += 1;
                                        r += l(e.subarray(c, c + 1)), c += 1, i = d(e, 12), a1 = d(e, 16), s1 = d(e, 20), u = d(e, 24), c = 28;
                                    } else if (1 === t) {
                                        i = d(e, c += 4);
                                        var f = d(e, c += 4), h = d(e, c += 4);
                                        for(c += 4, o = Math.pow(2, 32) * f + h, Number.isSafeInteger(o) || (o = Number.MAX_SAFE_INTEGER, console.warn("Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box")), s1 = d(e, c), u = d(e, c += 4), c += 4; "\0" !== l(e.subarray(c, c + 1));)n += l(e.subarray(c, c + 1)), c += 1;
                                        for(n += l(e.subarray(c, c + 1)), c += 1; "\0" !== l(e.subarray(c, c + 1));)r += l(e.subarray(c, c + 1)), c += 1;
                                        r += l(e.subarray(c, c + 1)), c += 1;
                                    }
                                    return {
                                        schemeIdUri: n,
                                        value: r,
                                        timeScale: i,
                                        presentationTime: o,
                                        presentationTimeDelta: a1,
                                        eventDuration: s1,
                                        id: u,
                                        payload: e.subarray(c, e.byteLength)
                                    };
                                }
                            },
                            "./src/utils/output-filter.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>r
                                });
                                var r = function() {
                                    function e(e, t) {
                                        this.timelineController = void 0, this.cueRanges = [], this.trackName = void 0, this.startTime = null, this.endTime = null, this.screen = null, this.timelineController = e, this.trackName = t;
                                    }
                                    var t = e.prototype;
                                    return t.dispatchCue = function() {
                                        null !== this.startTime && (this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges), this.startTime = null);
                                    }, t.newCue = function(e, t, n) {
                                        (null === this.startTime || this.startTime > e) && (this.startTime = e), this.endTime = t, this.screen = n, this.timelineController.createCaptionsTrack(this.trackName);
                                    }, t.reset = function() {
                                        this.cueRanges = [], this.startTime = null;
                                    }, e;
                                }();
                            },
                            "./src/utils/texttrack-utils.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    addCueToTrack: ()=>a1,
                                    clearCurrentCues: ()=>o,
                                    getCuesInRange: ()=>u,
                                    removeCuesInRange: ()=>s1,
                                    sendAddTrackEvent: ()=>i
                                });
                                var r = n("./src/utils/logger.ts");
                                function i(e, t) {
                                    var n;
                                    try {
                                        n = new Event("addtrack");
                                    } catch (e) {
                                        (n = document.createEvent("Event")).initEvent("addtrack", !1, !1);
                                    }
                                    n.track = e, t.dispatchEvent(n);
                                }
                                function a1(e, t) {
                                    var n = e.mode;
                                    if ("disabled" === n && (e.mode = "hidden"), e.cues && !e.cues.getCueById(t.id)) try {
                                        if (e.addCue(t), !e.cues.getCueById(t.id)) throw new Error("addCue is failed for: " + t);
                                    } catch (n) {
                                        r.logger.debug("[texttrack-utils]: " + n);
                                        var i = new self.TextTrackCue(t.startTime, t.endTime, t.text);
                                        i.id = t.id, e.addCue(i);
                                    }
                                    "disabled" === n && (e.mode = n);
                                }
                                function o(e) {
                                    var t = e.mode;
                                    if ("disabled" === t && (e.mode = "hidden"), e.cues) for(var n = e.cues.length; n--;)e.removeCue(e.cues[n]);
                                    "disabled" === t && (e.mode = t);
                                }
                                function s1(e, t, n, r) {
                                    var i = e.mode;
                                    if ("disabled" === i && (e.mode = "hidden"), e.cues && e.cues.length > 0) for(var a1 = u(e.cues, t, n), o = 0; o < a1.length; o++)r && !r(a1[o]) || e.removeCue(a1[o]);
                                    "disabled" === i && (e.mode = i);
                                }
                                function u(e, t, n) {
                                    var r = [], i = function(e, t) {
                                        if (t < e[0].startTime) return 0;
                                        var n = e.length - 1;
                                        if (t > e[n].endTime) return -1;
                                        for(var r = 0, i = n; r <= i;){
                                            var a1 = Math.floor((i + r) / 2);
                                            if (t < e[a1].startTime) i = a1 - 1;
                                            else {
                                                if (!(t > e[a1].startTime && r < n)) return a1;
                                                r = a1 + 1;
                                            }
                                        }
                                        return e[r].startTime - t < t - e[i].startTime ? r : i;
                                    }(e, t);
                                    if (i > -1) for(var a1 = i, o = e.length; a1 < o; a1++){
                                        var s1 = e[a1];
                                        if (s1.startTime >= t && s1.endTime <= n) r.push(s1);
                                        else if (s1.startTime > n) return r;
                                    }
                                    return r;
                                }
                            },
                            "./src/utils/time-ranges.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>r
                                });
                                const r = {
                                    toString: function(e) {
                                        for(var t = "", n = e.length, r = 0; r < n; r++)t += "[" + e.start(r).toFixed(3) + "," + e.end(r).toFixed(3) + "]";
                                        return t;
                                    }
                                };
                            },
                            "./src/utils/timescale-conversion.ts": (e, t, n)=>{
                                "use strict";
                                function r(e, t, n, r) {
                                    void 0 === n && (n = 1), void 0 === r && (r = !1);
                                    var i = e * t * n;
                                    return r ? Math.round(i) : i;
                                }
                                function i(e, t, n, i) {
                                    return void 0 === n && (n = 1), void 0 === i && (i = !1), r(e, t, 1 / n, i);
                                }
                                function a1(e, t) {
                                    return void 0 === t && (t = !1), r(e, 1e3, 1 / 9e4, t);
                                }
                                function o(e, t) {
                                    return void 0 === t && (t = 1), r(e, 9e4, 1 / t);
                                }
                                n.r(t), n.d(t, {
                                    toMpegTsClockFromTimescale: ()=>o,
                                    toMsFromMpegTsClock: ()=>a1,
                                    toTimescaleFromBase: ()=>r,
                                    toTimescaleFromScale: ()=>i
                                });
                            },
                            "./src/utils/typed-array.ts": (e, t, n)=>{
                                "use strict";
                                function r(e, t, n) {
                                    return Uint8Array.prototype.slice ? e.slice(t, n) : new Uint8Array(Array.prototype.slice.call(e, t, n));
                                }
                                n.r(t), n.d(t, {
                                    sliceUint8: ()=>r
                                });
                            },
                            "./src/utils/vttcue.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>r
                                });
                                const r = function() {
                                    if ("undefined" != typeof self && self.VTTCue) return self.VTTCue;
                                    var e = [
                                        "",
                                        "lr",
                                        "rl"
                                    ], t = [
                                        "start",
                                        "middle",
                                        "end",
                                        "left",
                                        "right"
                                    ];
                                    function n(e, t) {
                                        if ("string" != typeof t) return !1;
                                        if (!Array.isArray(e)) return !1;
                                        var n = t.toLowerCase();
                                        return !!~e.indexOf(n) && n;
                                    }
                                    function r(e) {
                                        return n(t, e);
                                    }
                                    function i(e) {
                                        for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
                                        for(var i = 1; i < arguments.length; i++){
                                            var a1 = arguments[i];
                                            for(var o in a1)e[o] = a1[o];
                                        }
                                        return e;
                                    }
                                    function a1(t, a1, o) {
                                        var s1 = this, u = {
                                            enumerable: !0
                                        };
                                        s1.hasBeenReset = !1;
                                        var l = "", c = !1, d = t, f = a1, h = o, g = null, p = "", m = !0, v = "auto", y = "start", E = 50, T = "middle", b = 50, A = "middle";
                                        Object.defineProperty(s1, "id", i({}, u, {
                                            get: function() {
                                                return l;
                                            },
                                            set: function(e) {
                                                l = "" + e;
                                            }
                                        })), Object.defineProperty(s1, "pauseOnExit", i({}, u, {
                                            get: function() {
                                                return c;
                                            },
                                            set: function(e) {
                                                c = !!e;
                                            }
                                        })), Object.defineProperty(s1, "startTime", i({}, u, {
                                            get: function() {
                                                return d;
                                            },
                                            set: function(e) {
                                                if ("number" != typeof e) throw new TypeError("Start time must be set to a number.");
                                                d = e, this.hasBeenReset = !0;
                                            }
                                        })), Object.defineProperty(s1, "endTime", i({}, u, {
                                            get: function() {
                                                return f;
                                            },
                                            set: function(e) {
                                                if ("number" != typeof e) throw new TypeError("End time must be set to a number.");
                                                f = e, this.hasBeenReset = !0;
                                            }
                                        })), Object.defineProperty(s1, "text", i({}, u, {
                                            get: function() {
                                                return h;
                                            },
                                            set: function(e) {
                                                h = "" + e, this.hasBeenReset = !0;
                                            }
                                        })), Object.defineProperty(s1, "region", i({}, u, {
                                            get: function() {
                                                return g;
                                            },
                                            set: function(e) {
                                                g = e, this.hasBeenReset = !0;
                                            }
                                        })), Object.defineProperty(s1, "vertical", i({}, u, {
                                            get: function() {
                                                return p;
                                            },
                                            set: function(t) {
                                                var r = function(t) {
                                                    return n(e, t);
                                                }(t);
                                                if (!1 === r) throw new SyntaxError("An invalid or illegal string was specified.");
                                                p = r, this.hasBeenReset = !0;
                                            }
                                        })), Object.defineProperty(s1, "snapToLines", i({}, u, {
                                            get: function() {
                                                return m;
                                            },
                                            set: function(e) {
                                                m = !!e, this.hasBeenReset = !0;
                                            }
                                        })), Object.defineProperty(s1, "line", i({}, u, {
                                            get: function() {
                                                return v;
                                            },
                                            set: function(e) {
                                                if ("number" != typeof e && "auto" !== e) throw new SyntaxError("An invalid number or illegal string was specified.");
                                                v = e, this.hasBeenReset = !0;
                                            }
                                        })), Object.defineProperty(s1, "lineAlign", i({}, u, {
                                            get: function() {
                                                return y;
                                            },
                                            set: function(e) {
                                                var t = r(e);
                                                if (!t) throw new SyntaxError("An invalid or illegal string was specified.");
                                                y = t, this.hasBeenReset = !0;
                                            }
                                        })), Object.defineProperty(s1, "position", i({}, u, {
                                            get: function() {
                                                return E;
                                            },
                                            set: function(e) {
                                                if (e < 0 || e > 100) throw new Error("Position must be between 0 and 100.");
                                                E = e, this.hasBeenReset = !0;
                                            }
                                        })), Object.defineProperty(s1, "positionAlign", i({}, u, {
                                            get: function() {
                                                return T;
                                            },
                                            set: function(e) {
                                                var t = r(e);
                                                if (!t) throw new SyntaxError("An invalid or illegal string was specified.");
                                                T = t, this.hasBeenReset = !0;
                                            }
                                        })), Object.defineProperty(s1, "size", i({}, u, {
                                            get: function() {
                                                return b;
                                            },
                                            set: function(e) {
                                                if (e < 0 || e > 100) throw new Error("Size must be between 0 and 100.");
                                                b = e, this.hasBeenReset = !0;
                                            }
                                        })), Object.defineProperty(s1, "align", i({}, u, {
                                            get: function() {
                                                return A;
                                            },
                                            set: function(e) {
                                                var t = r(e);
                                                if (!t) throw new SyntaxError("An invalid or illegal string was specified.");
                                                A = t, this.hasBeenReset = !0;
                                            }
                                        })), s1.displayState = void 0;
                                    }
                                    return a1.prototype.getCueAsHTML = function() {
                                        return self.WebVTT.convertCueToDOMTree(self, this.text);
                                    }, a1;
                                }();
                            },
                            "./src/utils/vttparser.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    VTTParser: ()=>f,
                                    fixLineBreaks: ()=>d,
                                    parseTimeStamp: ()=>a1
                                });
                                var r = n("./src/utils/vttcue.ts"), i = function() {
                                    function e() {}
                                    return e.prototype.decode = function(e, t) {
                                        if (!e) return "";
                                        if ("string" != typeof e) throw new Error("Error - expected string data.");
                                        return decodeURIComponent(encodeURIComponent(e));
                                    }, e;
                                }();
                                function a1(e) {
                                    function t(e, t, n, r) {
                                        return 3600 * (0 | e) + 60 * (0 | t) + (0 | n) + parseFloat(r || 0);
                                    }
                                    var n = e.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
                                    return n ? parseFloat(n[2]) > 59 ? t(n[2], n[3], 0, n[4]) : t(n[1], n[2], n[3], n[4]) : null;
                                }
                                var o = function() {
                                    function e() {
                                        this.values = Object.create(null);
                                    }
                                    var t = e.prototype;
                                    return t.set = function(e, t) {
                                        this.get(e) || "" === t || (this.values[e] = t);
                                    }, t.get = function(e, t, n) {
                                        return n ? this.has(e) ? this.values[e] : t[n] : this.has(e) ? this.values[e] : t;
                                    }, t.has = function(e) {
                                        return e in this.values;
                                    }, t.alt = function(e, t, n) {
                                        for(var r = 0; r < n.length; ++r)if (t === n[r]) {
                                            this.set(e, t);
                                            break;
                                        }
                                    }, t.integer = function(e, t) {
                                        /^-?\d+$/.test(t) && this.set(e, parseInt(t, 10));
                                    }, t.percent = function(e, t) {
                                        if (/^([\d]{1,3})(\.[\d]*)?%$/.test(t)) {
                                            var n = parseFloat(t);
                                            if (n >= 0 && n <= 100) return this.set(e, n), !0;
                                        }
                                        return !1;
                                    }, e;
                                }();
                                function s1(e, t, n, r) {
                                    var i = r ? e.split(r) : [
                                        e
                                    ];
                                    for(var a1 in i)if ("string" == typeof i[a1]) {
                                        var o = i[a1].split(n);
                                        2 === o.length && t(o[0], o[1]);
                                    }
                                }
                                var u = new r.default(0, 0, ""), l = "middle" === u.align ? "middle" : "center";
                                function c(e, t, n) {
                                    var r = e;
                                    function i() {
                                        var t = a1(e);
                                        if (null === t) throw new Error("Malformed timestamp: " + r);
                                        return e = e.replace(/^[^\sa-zA-Z-]+/, ""), t;
                                    }
                                    function c() {
                                        e = e.replace(/^\s+/, "");
                                    }
                                    if (c(), t.startTime = i(), c(), "--\x3e" !== e.slice(0, 3)) throw new Error("Malformed time stamp (time stamps must be separated by '--\x3e'): " + r);
                                    e = e.slice(3), c(), t.endTime = i(), c(), function(e, t) {
                                        var r = new o;
                                        s1(e, function(e, t) {
                                            var i;
                                            switch(e){
                                                case "region":
                                                    for(var a1 = n.length - 1; a1 >= 0; a1--)if (n[a1].id === t) {
                                                        r.set(e, n[a1].region);
                                                        break;
                                                    }
                                                    break;
                                                case "vertical":
                                                    r.alt(e, t, [
                                                        "rl",
                                                        "lr"
                                                    ]);
                                                    break;
                                                case "line":
                                                    i = t.split(","), r.integer(e, i[0]), r.percent(e, i[0]) && r.set("snapToLines", !1), r.alt(e, i[0], [
                                                        "auto"
                                                    ]), 2 === i.length && r.alt("lineAlign", i[1], [
                                                        "start",
                                                        l,
                                                        "end"
                                                    ]);
                                                    break;
                                                case "position":
                                                    i = t.split(","), r.percent(e, i[0]), 2 === i.length && r.alt("positionAlign", i[1], [
                                                        "start",
                                                        l,
                                                        "end",
                                                        "line-left",
                                                        "line-right",
                                                        "auto"
                                                    ]);
                                                    break;
                                                case "size":
                                                    r.percent(e, t);
                                                    break;
                                                case "align":
                                                    r.alt(e, t, [
                                                        "start",
                                                        l,
                                                        "end",
                                                        "left",
                                                        "right"
                                                    ]);
                                            }
                                        }, /:/, /\s/), t.region = r.get("region", null), t.vertical = r.get("vertical", "");
                                        var i = r.get("line", "auto");
                                        "auto" === i && -1 === u.line && (i = -1), t.line = i, t.lineAlign = r.get("lineAlign", "start"), t.snapToLines = r.get("snapToLines", !0), t.size = r.get("size", 100), t.align = r.get("align", l);
                                        var a1 = r.get("position", "auto");
                                        "auto" === a1 && 50 === u.position && (a1 = "start" === t.align || "left" === t.align ? 0 : "end" === t.align || "right" === t.align ? 100 : 50), t.position = a1;
                                    }(e, t);
                                }
                                function d(e) {
                                    return e.replace(/<br(?: \/)?>/gi, "\n");
                                }
                                var f = function() {
                                    function e() {
                                        this.state = "INITIAL", this.buffer = "", this.decoder = new i, this.regionList = [], this.cue = null, this.oncue = void 0, this.onparsingerror = void 0, this.onflush = void 0;
                                    }
                                    var t = e.prototype;
                                    return t.parse = function(e) {
                                        var t = this;
                                        function n() {
                                            var e = t.buffer, n = 0;
                                            for(e = d(e); n < e.length && "\r" !== e[n] && "\n" !== e[n];)++n;
                                            var r = e.slice(0, n);
                                            return "\r" === e[n] && ++n, "\n" === e[n] && ++n, t.buffer = e.slice(n), r;
                                        }
                                        e && (t.buffer += t.decoder.decode(e, {
                                            stream: !0
                                        }));
                                        try {
                                            var i = "";
                                            if ("INITIAL" === t.state) {
                                                if (!/\r\n|\n/.test(t.buffer)) return this;
                                                var a1 = (i = n()).match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
                                                if (!a1 || !a1[0]) throw new Error("Malformed WebVTT signature.");
                                                t.state = "HEADER";
                                            }
                                            for(var o = !1; t.buffer;){
                                                if (!/\r\n|\n/.test(t.buffer)) return this;
                                                switch(o ? o = !1 : i = n(), t.state){
                                                    case "HEADER":
                                                        /:/.test(i) ? s1(i, function(e, t) {}, /:/) : i || (t.state = "ID");
                                                        continue;
                                                    case "NOTE":
                                                        i || (t.state = "ID");
                                                        continue;
                                                    case "ID":
                                                        if (/^NOTE($|[ \t])/.test(i)) {
                                                            t.state = "NOTE";
                                                            break;
                                                        }
                                                        if (!i) continue;
                                                        if (t.cue = new r.default(0, 0, ""), t.state = "CUE", -1 === i.indexOf("--\x3e")) {
                                                            t.cue.id = i;
                                                            continue;
                                                        }
                                                    case "CUE":
                                                        if (!t.cue) {
                                                            t.state = "BADCUE";
                                                            continue;
                                                        }
                                                        try {
                                                            c(i, t.cue, t.regionList);
                                                        } catch (e) {
                                                            t.cue = null, t.state = "BADCUE";
                                                            continue;
                                                        }
                                                        t.state = "CUETEXT";
                                                        continue;
                                                    case "CUETEXT":
                                                        var u = -1 !== i.indexOf("--\x3e");
                                                        if (!i || u && (o = !0)) {
                                                            t.oncue && t.cue && t.oncue(t.cue), t.cue = null, t.state = "ID";
                                                            continue;
                                                        }
                                                        if (null === t.cue) continue;
                                                        t.cue.text && (t.cue.text += "\n"), t.cue.text += i;
                                                        continue;
                                                    case "BADCUE":
                                                        i || (t.state = "ID");
                                                }
                                            }
                                        } catch (e) {
                                            "CUETEXT" === t.state && t.cue && t.oncue && t.oncue(t.cue), t.cue = null, t.state = "INITIAL" === t.state ? "BADWEBVTT" : "BADCUE";
                                        }
                                        return this;
                                    }, t.flush = function() {
                                        var e = this;
                                        try {
                                            if ((e.cue || "HEADER" === e.state) && (e.buffer += "\n\n", e.parse()), "INITIAL" === e.state || "BADWEBVTT" === e.state) throw new Error("Malformed WebVTT signature.");
                                        } catch (t) {
                                            e.onparsingerror && e.onparsingerror(t);
                                        }
                                        return e.onflush && e.onflush(), this;
                                    }, e;
                                }();
                            },
                            "./src/utils/webvtt-parser.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    generateCueId: ()=>d,
                                    parseWebVTT: ()=>f
                                });
                                var r = n("./src/polyfills/number.ts"), i = n("./src/utils/vttparser.ts"), a1 = n("./src/demux/id3.ts"), o = n("./src/utils/timescale-conversion.ts"), s1 = n("./src/remux/mp4-remuxer.ts"), u = /\r\n|\n\r|\n|\r/g, l = function(e, t, n) {
                                    return void 0 === n && (n = 0), e.slice(n, n + t.length) === t;
                                }, c = function(e) {
                                    for(var t = 5381, n = e.length; n;)t = 33 * t ^ e.charCodeAt(--n);
                                    return (t >>> 0).toString();
                                };
                                function d(e, t, n) {
                                    return c(e.toString()) + c(t.toString()) + c(n);
                                }
                                function f(e, t, n, c, f, h, g, p) {
                                    var m, v = new i.VTTParser, y = (0, a1.utf8ArrayToStr)(new Uint8Array(e)).trim().replace(u, "\n").split("\n"), E = [], T = (0, o.toMpegTsClockFromTimescale)(t, n), b = "00:00.000", A = 0, _ = 0, S = !0;
                                    v.oncue = function(e) {
                                        var t = c[f], n = c.ccOffset, r = (A - T) / 9e4;
                                        null != t && t.new && (void 0 !== _ ? n = c.ccOffset = t.start : function(e, t, n) {
                                            var r = e[t], i = e[r.prevCC];
                                            if (!i || !i.new && r.new) return e.ccOffset = e.presentationOffset = r.start, void (r.new = !1);
                                            for(; null !== (a1 = i) && void 0 !== a1 && a1.new;){
                                                var a1;
                                                e.ccOffset += r.start - i.start, r.new = !1, i = e[(r = i).prevCC];
                                            }
                                            e.presentationOffset = n;
                                        }(c, f, r)), r && (n = r - c.presentationOffset);
                                        var i = e.endTime - e.startTime, a1 = (0, s1.normalizePts)(9e4 * (e.startTime + n - _), 9e4 * h) / 9e4;
                                        e.startTime = Math.max(a1, 0), e.endTime = Math.max(a1 + i, 0);
                                        var o = e.text.trim();
                                        e.text = decodeURIComponent(encodeURIComponent(o)), e.id || (e.id = d(e.startTime, e.endTime, o)), e.endTime > 0 && E.push(e);
                                    }, v.onparsingerror = function(e) {
                                        m = e;
                                    }, v.onflush = function() {
                                        m ? p(m) : g(E);
                                    }, y.forEach(function(e) {
                                        if (S) {
                                            if (l(e, "X-TIMESTAMP-MAP=")) {
                                                S = !1, e.slice(16).split(",").forEach(function(e) {
                                                    l(e, "LOCAL:") ? b = e.slice(6) : l(e, "MPEGTS:") && (A = parseInt(e.slice(7)));
                                                });
                                                try {
                                                    _ = function(e) {
                                                        var t = parseInt(e.slice(-3)), n = parseInt(e.slice(-6, -4)), i = parseInt(e.slice(-9, -7)), a1 = e.length > 9 ? parseInt(e.substring(0, e.indexOf(":"))) : 0;
                                                        if (!((0, r.isFiniteNumber)(t) && (0, r.isFiniteNumber)(n) && (0, r.isFiniteNumber)(i) && (0, r.isFiniteNumber)(a1))) throw Error("Malformed X-TIMESTAMP-MAP: Local:" + e);
                                                        return t += 1e3 * n, (t += 6e4 * i) + 36e5 * a1;
                                                    }(b) / 1e3;
                                                } catch (e) {
                                                    m = e;
                                                }
                                                return;
                                            }
                                            "" === e && (S = !1);
                                        }
                                        v.parse(e + "\n");
                                    }), v.flush();
                                }
                            },
                            "./src/utils/xhr-loader.ts": (e, t, n)=>{
                                "use strict";
                                n.r(t), n.d(t, {
                                    default: ()=>o
                                });
                                var r = n("./src/utils/logger.ts"), i = n("./src/loader/load-stats.ts"), a1 = /^age:\s*[\d.]+\s*$/m;
                                const o = function() {
                                    function e(e) {
                                        this.xhrSetup = void 0, this.requestTimeout = void 0, this.retryTimeout = void 0, this.retryDelay = void 0, this.config = null, this.callbacks = null, this.context = void 0, this.loader = null, this.stats = void 0, this.xhrSetup = e ? e.xhrSetup : null, this.stats = new i.LoadStats, this.retryDelay = 0;
                                    }
                                    var t = e.prototype;
                                    return t.destroy = function() {
                                        this.callbacks = null, this.abortInternal(), this.loader = null, this.config = null;
                                    }, t.abortInternal = function() {
                                        var e = this.loader;
                                        self.clearTimeout(this.requestTimeout), self.clearTimeout(this.retryTimeout), e && (e.onreadystatechange = null, e.onprogress = null, 4 !== e.readyState && (this.stats.aborted = !0, e.abort()));
                                    }, t.abort = function() {
                                        var e;
                                        this.abortInternal(), null !== (e = this.callbacks) && void 0 !== e && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.loader);
                                    }, t.load = function(e, t, n) {
                                        if (this.stats.loading.start) throw new Error("Loader can only be used once.");
                                        this.stats.loading.start = self.performance.now(), this.context = e, this.config = t, this.callbacks = n, this.retryDelay = t.retryDelay, this.loadInternal();
                                    }, t.loadInternal = function() {
                                        var e = this.config, t = this.context;
                                        if (e) {
                                            var n = this.loader = new self.XMLHttpRequest, r = this.stats;
                                            r.loading.first = 0, r.loaded = 0;
                                            var i = this.xhrSetup;
                                            try {
                                                if (i) try {
                                                    i(n, t.url);
                                                } catch (e) {
                                                    n.open("GET", t.url, !0), i(n, t.url);
                                                }
                                                n.readyState || n.open("GET", t.url, !0);
                                                var a1 = this.context.headers;
                                                if (a1) for(var o in a1)n.setRequestHeader(o, a1[o]);
                                            } catch (e) {
                                                return void this.callbacks.onError({
                                                    code: n.status,
                                                    text: e.message
                                                }, t, n);
                                            }
                                            t.rangeEnd && n.setRequestHeader("Range", "bytes=" + t.rangeStart + "-" + (t.rangeEnd - 1)), n.onreadystatechange = this.readystatechange.bind(this), n.onprogress = this.loadprogress.bind(this), n.responseType = t.responseType, self.clearTimeout(this.requestTimeout), this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), e.timeout), n.send();
                                        }
                                    }, t.readystatechange = function() {
                                        var e = this.context, t = this.loader, n = this.stats;
                                        if (e && t) {
                                            var i = t.readyState, a1 = this.config;
                                            if (!n.aborted && i >= 2) {
                                                if (self.clearTimeout(this.requestTimeout), 0 === n.loading.first && (n.loading.first = Math.max(self.performance.now(), n.loading.start)), 4 === i) {
                                                    t.onreadystatechange = null, t.onprogress = null;
                                                    var o = t.status, s1 = "arraybuffer" === t.responseType;
                                                    if (o >= 200 && o < 300 && (s1 && t.response || null !== t.responseText)) {
                                                        var u, l;
                                                        if (n.loading.end = Math.max(self.performance.now(), n.loading.first), l = s1 ? (u = t.response).byteLength : (u = t.responseText).length, n.loaded = n.total = l, !this.callbacks) return;
                                                        var c = this.callbacks.onProgress;
                                                        if (c && c(n, e, u, t), !this.callbacks) return;
                                                        var d = {
                                                            url: t.responseURL,
                                                            data: u
                                                        };
                                                        this.callbacks.onSuccess(d, n, e, t);
                                                    } else n.retry >= a1.maxRetry || o >= 400 && o < 499 ? (r.logger.error(o + " while loading " + e.url), this.callbacks.onError({
                                                        code: o,
                                                        text: t.statusText
                                                    }, e, t)) : (r.logger.warn(o + " while loading " + e.url + ", retrying in " + this.retryDelay + "..."), this.abortInternal(), this.loader = null, self.clearTimeout(this.retryTimeout), this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay), this.retryDelay = Math.min(2 * this.retryDelay, a1.maxRetryDelay), n.retry++);
                                                } else self.clearTimeout(this.requestTimeout), this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), a1.timeout);
                                            }
                                        }
                                    }, t.loadtimeout = function() {
                                        r.logger.warn("timeout while loading " + this.context.url);
                                        var e = this.callbacks;
                                        e && (this.abortInternal(), e.onTimeout(this.stats, this.context, this.loader));
                                    }, t.loadprogress = function(e) {
                                        var t = this.stats;
                                        t.loaded = e.loaded, e.lengthComputable && (t.total = e.total);
                                    }, t.getCacheAge = function() {
                                        var e = null;
                                        if (this.loader && a1.test(this.loader.getAllResponseHeaders())) {
                                            var t = this.loader.getResponseHeader("age");
                                            e = t ? parseFloat(t) : null;
                                        }
                                        return e;
                                    }, e;
                                }();
                            },
                            "./node_modules/eventemitter3/index.js": (e)=>{
                                "use strict";
                                var t = Object.prototype.hasOwnProperty, n = "~";
                                function r() {}
                                function i(e, t, n) {
                                    this.fn = e, this.context = t, this.once = n || !1;
                                }
                                function a1(e, t, r, a1, o) {
                                    if ("function" != typeof r) throw new TypeError("The listener must be a function");
                                    var s1 = new i(r, a1 || e, o), u = n ? n + t : t;
                                    return e._events[u] ? e._events[u].fn ? e._events[u] = [
                                        e._events[u],
                                        s1
                                    ] : e._events[u].push(s1) : (e._events[u] = s1, e._eventsCount++), e;
                                }
                                function o(e, t) {
                                    0 == --e._eventsCount ? e._events = new r : delete e._events[t];
                                }
                                function s1() {
                                    this._events = new r, this._eventsCount = 0;
                                }
                                Object.create && (r.prototype = Object.create(null), (new r).__proto__ || (n = !1)), s1.prototype.eventNames = function() {
                                    var e, r, i = [];
                                    if (0 === this._eventsCount) return i;
                                    for(r in e = this._events)t.call(e, r) && i.push(n ? r.slice(1) : r);
                                    return Object.getOwnPropertySymbols ? i.concat(Object.getOwnPropertySymbols(e)) : i;
                                }, s1.prototype.listeners = function(e) {
                                    var t = n ? n + e : e, r = this._events[t];
                                    if (!r) return [];
                                    if (r.fn) return [
                                        r.fn
                                    ];
                                    for(var i = 0, a1 = r.length, o = new Array(a1); i < a1; i++)o[i] = r[i].fn;
                                    return o;
                                }, s1.prototype.listenerCount = function(e) {
                                    var t = n ? n + e : e, r = this._events[t];
                                    return r ? r.fn ? 1 : r.length : 0;
                                }, s1.prototype.emit = function(e, t, r, i, a1, o) {
                                    var s1 = n ? n + e : e;
                                    if (!this._events[s1]) return !1;
                                    var u, l, c = this._events[s1], d = arguments.length;
                                    if (c.fn) {
                                        switch(c.once && this.removeListener(e, c.fn, void 0, !0), d){
                                            case 1:
                                                return c.fn.call(c.context), !0;
                                            case 2:
                                                return c.fn.call(c.context, t), !0;
                                            case 3:
                                                return c.fn.call(c.context, t, r), !0;
                                            case 4:
                                                return c.fn.call(c.context, t, r, i), !0;
                                            case 5:
                                                return c.fn.call(c.context, t, r, i, a1), !0;
                                            case 6:
                                                return c.fn.call(c.context, t, r, i, a1, o), !0;
                                        }
                                        for(l = 1, u = new Array(d - 1); l < d; l++)u[l - 1] = arguments[l];
                                        c.fn.apply(c.context, u);
                                    } else {
                                        var f, h = c.length;
                                        for(l = 0; l < h; l++)switch(c[l].once && this.removeListener(e, c[l].fn, void 0, !0), d){
                                            case 1:
                                                c[l].fn.call(c[l].context);
                                                break;
                                            case 2:
                                                c[l].fn.call(c[l].context, t);
                                                break;
                                            case 3:
                                                c[l].fn.call(c[l].context, t, r);
                                                break;
                                            case 4:
                                                c[l].fn.call(c[l].context, t, r, i);
                                                break;
                                            default:
                                                if (!u) for(f = 1, u = new Array(d - 1); f < d; f++)u[f - 1] = arguments[f];
                                                c[l].fn.apply(c[l].context, u);
                                        }
                                    }
                                    return !0;
                                }, s1.prototype.on = function(e, t, n) {
                                    return a1(this, e, t, n, !1);
                                }, s1.prototype.once = function(e, t, n) {
                                    return a1(this, e, t, n, !0);
                                }, s1.prototype.removeListener = function(e, t, r, i) {
                                    var a1 = n ? n + e : e;
                                    if (!this._events[a1]) return this;
                                    if (!t) return o(this, a1), this;
                                    var s1 = this._events[a1];
                                    if (s1.fn) s1.fn !== t || i && !s1.once || r && s1.context !== r || o(this, a1);
                                    else {
                                        for(var u = 0, l = [], c = s1.length; u < c; u++)(s1[u].fn !== t || i && !s1[u].once || r && s1[u].context !== r) && l.push(s1[u]);
                                        l.length ? this._events[a1] = 1 === l.length ? l[0] : l : o(this, a1);
                                    }
                                    return this;
                                }, s1.prototype.removeAllListeners = function(e) {
                                    var t;
                                    return e ? (t = n ? n + e : e, this._events[t] && o(this, t)) : (this._events = new r, this._eventsCount = 0), this;
                                }, s1.prototype.off = s1.prototype.removeListener, s1.prototype.addListener = s1.prototype.on, s1.prefixed = n, s1.EventEmitter = s1, e.exports = s1;
                            },
                            "./node_modules/url-toolkit/src/url-toolkit.js": function(e) {
                                var t, n, r, i, a1;
                                t = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/, n = /^(?=([^\/?#]*))\1([^]*)$/, r = /(?:\/|^)\.(?=\/)/g, i = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, a1 = {
                                    buildAbsoluteURL: function(e, t, r) {
                                        if (r = r || {}, e = e.trim(), !(t = t.trim())) {
                                            if (!r.alwaysNormalize) return e;
                                            var i = a1.parseURL(e);
                                            if (!i) throw new Error("Error trying to parse base URL.");
                                            return i.path = a1.normalizePath(i.path), a1.buildURLFromParts(i);
                                        }
                                        var o = a1.parseURL(t);
                                        if (!o) throw new Error("Error trying to parse relative URL.");
                                        if (o.scheme) return r.alwaysNormalize ? (o.path = a1.normalizePath(o.path), a1.buildURLFromParts(o)) : t;
                                        var s1 = a1.parseURL(e);
                                        if (!s1) throw new Error("Error trying to parse base URL.");
                                        if (!s1.netLoc && s1.path && "/" !== s1.path[0]) {
                                            var u = n.exec(s1.path);
                                            s1.netLoc = u[1], s1.path = u[2];
                                        }
                                        s1.netLoc && !s1.path && (s1.path = "/");
                                        var l = {
                                            scheme: s1.scheme,
                                            netLoc: o.netLoc,
                                            path: null,
                                            params: o.params,
                                            query: o.query,
                                            fragment: o.fragment
                                        };
                                        if (!o.netLoc && (l.netLoc = s1.netLoc, "/" !== o.path[0])) {
                                            if (o.path) {
                                                var c = s1.path, d = c.substring(0, c.lastIndexOf("/") + 1) + o.path;
                                                l.path = a1.normalizePath(d);
                                            } else l.path = s1.path, o.params || (l.params = s1.params, o.query || (l.query = s1.query));
                                        }
                                        return null === l.path && (l.path = r.alwaysNormalize ? a1.normalizePath(o.path) : o.path), a1.buildURLFromParts(l);
                                    },
                                    parseURL: function(e) {
                                        var n = t.exec(e);
                                        return n ? {
                                            scheme: n[1] || "",
                                            netLoc: n[2] || "",
                                            path: n[3] || "",
                                            params: n[4] || "",
                                            query: n[5] || "",
                                            fragment: n[6] || ""
                                        } : null;
                                    },
                                    normalizePath: function(e) {
                                        for(e = e.split("").reverse().join("").replace(r, ""); e.length !== (e = e.replace(i, "")).length;);
                                        return e.split("").reverse().join("");
                                    },
                                    buildURLFromParts: function(e) {
                                        return e.scheme + e.netLoc + e.path + e.params + e.query + e.fragment;
                                    }
                                }, e.exports = a1;
                            }
                        }, t = {};
                        function n(r) {
                            var i = t[r];
                            if (void 0 !== i) return i.exports;
                            var a1 = t[r] = {
                                exports: {}
                            };
                            return e[r].call(a1.exports, a1, a1.exports, n), a1.exports;
                        }
                        n.m = e, n.n = (e)=>{
                            var t = e && e.__esModule ? ()=>e.default : ()=>e;
                            return n.d(t, {
                                a: t
                            }), t;
                        }, n.d = (e, t)=>{
                            for(var r in t)n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
                                enumerable: !0,
                                get: t[r]
                            });
                        }, n.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), n.r = (e)=>{
                            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                                value: "Module"
                            }), Object.defineProperty(e, "__esModule", {
                                value: !0
                            });
                        };
                        var r = n("./src/hls.ts");
                        return r.default;
                    })(), e.exports = t());
            },
            118: (e)=>{
                e.exports = function(e) {
                    return {
                        all: e = e || new Map,
                        on: function(t, n) {
                            var r = e.get(t);
                            r ? r.push(n) : e.set(t, [
                                n
                            ]);
                        },
                        off: function(t, n) {
                            var r = e.get(t);
                            r && (n ? r.splice(r.indexOf(n) >>> 0, 1) : e.set(t, []));
                        },
                        emit: function(t, n) {
                            var r = e.get(t);
                            r && r.slice().map(function(e) {
                                e(n);
                            }), (r = e.get("*")) && r.slice().map(function(e) {
                                e(t, n);
                            });
                        }
                    };
                };
            },
            686: (e, t, n)=>{
                !function() {
                    var e = "undefined" != typeof window ? window : n.g, r = {};
                    for(var i in (function(e, t, n) {
                        var r;
                        function i(e) {
                            var t = 0;
                            return function() {
                                return t < e.length ? {
                                    done: !1,
                                    value: e[t++]
                                } : {
                                    done: !0
                                };
                            };
                        }
                        var a1 = "function" == typeof Object.defineProperties ? Object.defineProperty : function(e, t, n) {
                            return e == Array.prototype || e == Object.prototype || (e[t] = n.value), e;
                        }, o = function(n) {
                            n = [
                                "object" == typeof globalThis && globalThis,
                                n,
                                "object" == typeof e && e,
                                "object" == typeof self && self,
                                "object" == typeof t && t
                            ];
                            for(var r = 0; r < n.length; ++r){
                                var i = n[r];
                                if (i && i.Math == Math) return i;
                            }
                            throw Error("Cannot find global object");
                        }(this);
                        function s1(e, t) {
                            if (t) e: {
                                for(var n = o, r = e.split("."), i = 0; i < r.length - 1; i++){
                                    var s1 = r[i];
                                    if (!(s1 in n)) break e;
                                    n = n[s1];
                                }
                                (s1 = t(i = n[r = r[r.length - 1]])) != i && null != s1 && a1(n, r, {
                                    configurable: !0,
                                    writable: !0,
                                    value: s1
                                });
                            }
                        }
                        function u(e) {
                            return (e = {
                                next: e
                            })[Symbol.iterator] = function() {
                                return this;
                            }, e;
                        }
                        function l(e) {
                            var t = "undefined" != typeof Symbol && Symbol.iterator && e[Symbol.iterator];
                            return t ? t.call(e) : {
                                next: i(e)
                            };
                        }
                        function c(e) {
                            if (!(e instanceof Array)) {
                                e = l(e);
                                for(var t, n = []; !(t = e.next()).done;)n.push(t.value);
                                e = n;
                            }
                            return e;
                        }
                        s1("Symbol", function(e) {
                            function t(e, t) {
                                this.g = e, a1(this, "description", {
                                    configurable: !0,
                                    writable: !0,
                                    value: t
                                });
                            }
                            if (e) return e;
                            t.prototype.toString = function() {
                                return this.g;
                            };
                            var n = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", r = 0;
                            return function e(i) {
                                if (this instanceof e) throw new TypeError("Symbol is not a constructor");
                                return new t(n + (i || "") + "_" + r++, i);
                            };
                        }), s1("Symbol.iterator", function(e) {
                            if (e) return e;
                            e = Symbol("Symbol.iterator");
                            for(var t = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), n = 0; n < t.length; n++){
                                var r = o[t[n]];
                                "function" == typeof r && "function" != typeof r.prototype[e] && a1(r.prototype, e, {
                                    configurable: !0,
                                    writable: !0,
                                    value: function() {
                                        return u(i(this));
                                    }
                                });
                            }
                            return e;
                        });
                        var d, f = "function" == typeof Object.create ? Object.create : function(e) {
                            function t() {}
                            return t.prototype = e, new t;
                        };
                        if ("function" == typeof Object.setPrototypeOf) d = Object.setPrototypeOf;
                        else {
                            var h;
                            e: {
                                var g = {};
                                try {
                                    g.__proto__ = {
                                        a: !0
                                    }, h = g.a;
                                    break e;
                                } catch (e) {}
                                h = !1;
                            }
                            d = h ? function(e, t) {
                                if (e.__proto__ = t, e.__proto__ !== t) throw new TypeError(e + " is not extensible");
                                return e;
                            } : null;
                        }
                        var p = d;
                        function m(e, t) {
                            if (e.prototype = f(t.prototype), e.prototype.constructor = e, p) p(e, t);
                            else for(var n in t)if ("prototype" != n) {
                                if (Object.defineProperties) {
                                    var r = Object.getOwnPropertyDescriptor(t, n);
                                    r && Object.defineProperty(e, n, r);
                                } else e[n] = t[n];
                            }
                            e.yh = t.prototype;
                        }
                        function v() {
                            this.o = !1, this.l = null, this.h = void 0, this.g = 1, this.j = this.m = 0, this.u = this.i = null;
                        }
                        function y(e) {
                            if (e.o) throw new TypeError("Generator is already running");
                            e.o = !0;
                        }
                        function E(e, t) {
                            e.i = {
                                Ce: t,
                                Je: !0
                            }, e.g = e.m || e.j;
                        }
                        function T(e, t, n) {
                            return e.g = n, {
                                value: t
                            };
                        }
                        function b(e) {
                            e.g = 0;
                        }
                        function A(e, t, n) {
                            e.m = t, null != n && (e.j = n);
                        }
                        function _(e) {
                            e.m = 0, e.j = 2;
                        }
                        function S(e, t) {
                            e.g = t, e.m = 0;
                        }
                        function w(e) {
                            e.m = 0;
                            var t = e.i.Ce;
                            return e.i = null, t;
                        }
                        function I(e) {
                            e.u = [
                                e.i
                            ], e.m = 0, e.j = 0;
                        }
                        function R(e, t) {
                            var n = e.u.splice(0)[0];
                            (n = e.i = e.i || n) ? n.Je ? e.g = e.m || e.j : null != n.A && e.j < n.A ? (e.g = n.A, e.i = null) : e.g = e.j : e.g = t;
                        }
                        function C(e) {
                            this.g = new v, this.h = e;
                        }
                        function D(e, t, n, r) {
                            try {
                                var i = t.call(e.g.l, n);
                                if (!(i instanceof Object)) throw new TypeError("Iterator result " + i + " is not an object");
                                if (!i.done) return e.g.o = !1, i;
                                var a1 = i.value;
                            } catch (t) {
                                return e.g.l = null, E(e.g, t), k(e);
                            }
                            return e.g.l = null, r.call(e.g, a1), k(e);
                        }
                        function k(e) {
                            for(; e.g.g;)try {
                                var t = e.h(e.g);
                                if (t) return e.g.o = !1, {
                                    value: t.value,
                                    done: !1
                                };
                            } catch (t) {
                                e.g.h = void 0, E(e.g, t);
                            }
                            if (e.g.o = !1, e.g.i) {
                                if (t = e.g.i, e.g.i = null, t.Je) throw t.Ce;
                                return {
                                    value: t.return,
                                    done: !0
                                };
                            }
                            return {
                                value: void 0,
                                done: !0
                            };
                        }
                        function N(e) {
                            this.next = function(t) {
                                return y(e.g), e.g.l ? t = D(e, e.g.l.next, t, e.g.s) : (e.g.s(t), t = k(e)), t;
                            }, this.throw = function(t) {
                                return y(e.g), e.g.l ? t = D(e, e.g.l.throw, t, e.g.s) : (E(e.g, t), t = k(e)), t;
                            }, this.return = function(t) {
                                return function(e, t) {
                                    y(e.g);
                                    var n = e.g.l;
                                    return n ? D(e, "return" in n ? n.return : function(e) {
                                        return {
                                            value: e,
                                            done: !0
                                        };
                                    }, t, e.g.return) : (e.g.return(t), k(e));
                                }(e, t);
                            }, this[Symbol.iterator] = function() {
                                return this;
                            };
                        }
                        function L(e) {
                            return function(e) {
                                function t(t) {
                                    return e.next(t);
                                }
                                function n(t) {
                                    return e.throw(t);
                                }
                                return new Promise(function(r, i) {
                                    !function e(a1) {
                                        a1.done ? r(a1.value) : Promise.resolve(a1.value).then(t, n).then(e, i);
                                    }(e.next());
                                });
                            }(new N(new C(e)));
                        }
                        function x() {
                            for(var e = Number(this), t = [], n = e; n < arguments.length; n++)t[n - e] = arguments[n];
                            return t;
                        }
                        function M(e, t) {
                            return Object.prototype.hasOwnProperty.call(e, t);
                        }
                        function O(e, t, n) {
                            e instanceof String && (e = String(e));
                            for(var r = e.length, i = 0; i < r; i++){
                                var a1 = e[i];
                                if (t.call(n, a1, i, e)) return {
                                    He: i,
                                    v: a1
                                };
                            }
                            return {
                                He: -1,
                                v: void 0
                            };
                        }
                        function P(e, t, n) {
                            if (null == e) throw new TypeError("The 'this' value for String.prototype." + n + " must not be null or undefined");
                            if (t instanceof RegExp) throw new TypeError("First argument to String.prototype." + n + " must not be a regular expression");
                            return e + "";
                        }
                        function F(e, t) {
                            e instanceof String && (e += "");
                            var n = 0, r = !1, i = {
                                next: function() {
                                    if (!r && n < e.length) {
                                        var i = n++;
                                        return {
                                            value: t(i, e[i]),
                                            done: !1
                                        };
                                    }
                                    return r = !0, {
                                        done: !0,
                                        value: void 0
                                    };
                                }
                            };
                            return i[Symbol.iterator] = function() {
                                return i;
                            }, i;
                        }
                        v.prototype.s = function(e) {
                            this.h = e;
                        }, v.prototype.return = function(e) {
                            this.i = {
                                return: e
                            }, this.g = this.j;
                        }, v.prototype.A = function(e) {
                            this.g = e;
                        }, s1("Promise", function(e) {
                            function t(e) {
                                this.h = 0, this.i = void 0, this.g = [], this.o = !1;
                                var t = this.j();
                                try {
                                    e(t.resolve, t.reject);
                                } catch (e) {
                                    t.reject(e);
                                }
                            }
                            function n() {
                                this.g = null;
                            }
                            function r(e) {
                                return e instanceof t ? e : new t(function(t) {
                                    t(e);
                                });
                            }
                            if (e) return e;
                            n.prototype.h = function(e) {
                                if (null == this.g) {
                                    this.g = [];
                                    var t = this;
                                    this.i(function() {
                                        t.l();
                                    });
                                }
                                this.g.push(e);
                            };
                            var i = o.setTimeout;
                            n.prototype.i = function(e) {
                                i(e, 0);
                            }, n.prototype.l = function() {
                                for(; this.g && this.g.length;){
                                    var e = this.g;
                                    this.g = [];
                                    for(var t = 0; t < e.length; ++t){
                                        var n = e[t];
                                        e[t] = null;
                                        try {
                                            n();
                                        } catch (e) {
                                            this.j(e);
                                        }
                                    }
                                }
                                this.g = null;
                            }, n.prototype.j = function(e) {
                                this.i(function() {
                                    throw e;
                                });
                            }, t.prototype.j = function() {
                                function e(e) {
                                    return function(r) {
                                        n || (n = !0, e.call(t, r));
                                    };
                                }
                                var t = this, n = !1;
                                return {
                                    resolve: e(this.F),
                                    reject: e(this.l)
                                };
                            }, t.prototype.F = function(e) {
                                if (e === this) this.l(new TypeError("A Promise cannot resolve to itself"));
                                else if (e instanceof t) this.H(e);
                                else {
                                    e: switch(typeof e){
                                        case "object":
                                            var n = null != e;
                                            break e;
                                        case "function":
                                            n = !0;
                                            break e;
                                        default:
                                            n = !1;
                                    }
                                    n ? this.D(e) : this.m(e);
                                }
                            }, t.prototype.D = function(e) {
                                var t = void 0;
                                try {
                                    t = e.then;
                                } catch (e) {
                                    return void this.l(e);
                                }
                                "function" == typeof t ? this.K(t, e) : this.m(e);
                            }, t.prototype.l = function(e) {
                                this.s(2, e);
                            }, t.prototype.m = function(e) {
                                this.s(1, e);
                            }, t.prototype.s = function(e, t) {
                                if (0 != this.h) throw Error("Cannot settle(" + e + ", " + t + "): Promise already settled in state" + this.h);
                                this.h = e, this.i = t, 2 === this.h && this.G(), this.u();
                            }, t.prototype.G = function() {
                                var e = this;
                                i(function() {
                                    if (e.B()) {
                                        var t = o.console;
                                        void 0 !== t && t.error(e.i);
                                    }
                                }, 1);
                            }, t.prototype.B = function() {
                                if (this.o) return !1;
                                var e = o.CustomEvent, t = o.Event, n = o.dispatchEvent;
                                return void 0 === n || ("function" == typeof e ? e = new e("unhandledrejection", {
                                    cancelable: !0
                                }) : "function" == typeof t ? e = new t("unhandledrejection", {
                                    cancelable: !0
                                }) : (e = o.document.createEvent("CustomEvent")).initCustomEvent("unhandledrejection", !1, !0, e), e.promise = this, e.reason = this.i, n(e));
                            }, t.prototype.u = function() {
                                if (null != this.g) {
                                    for(var e = 0; e < this.g.length; ++e)a1.h(this.g[e]);
                                    this.g = null;
                                }
                            };
                            var a1 = new n;
                            return t.prototype.H = function(e) {
                                var t = this.j();
                                e.Kc(t.resolve, t.reject);
                            }, t.prototype.K = function(e, t) {
                                var n = this.j();
                                try {
                                    e.call(t, n.resolve, n.reject);
                                } catch (e) {
                                    n.reject(e);
                                }
                            }, t.prototype.then = function(e, n) {
                                function r(e, t) {
                                    return "function" == typeof e ? function(t) {
                                        try {
                                            i(e(t));
                                        } catch (e) {
                                            a1(e);
                                        }
                                    } : t;
                                }
                                var i, a1, o = new t(function(e, t) {
                                    i = e, a1 = t;
                                });
                                return this.Kc(r(e, i), r(n, a1)), o;
                            }, t.prototype.catch = function(e) {
                                return this.then(void 0, e);
                            }, t.prototype.Kc = function(e, t) {
                                function n() {
                                    switch(r.h){
                                        case 1:
                                            e(r.i);
                                            break;
                                        case 2:
                                            t(r.i);
                                            break;
                                        default:
                                            throw Error("Unexpected state: " + r.h);
                                    }
                                }
                                var r = this;
                                null == this.g ? a1.h(n) : this.g.push(n), this.o = !0;
                            }, t.resolve = r, t.reject = function(e) {
                                return new t(function(t, n) {
                                    n(e);
                                });
                            }, t.race = function(e) {
                                return new t(function(t, n) {
                                    for(var i = l(e), a1 = i.next(); !a1.done; a1 = i.next())r(a1.value).Kc(t, n);
                                });
                            }, t.all = function(e) {
                                var n = l(e), i = n.next();
                                return i.done ? r([]) : new t(function(e, t) {
                                    function a1(t) {
                                        return function(n) {
                                            o[t] = n, 0 == --s1 && e(o);
                                        };
                                    }
                                    var o = [], s1 = 0;
                                    do o.push(void 0), s1++, r(i.value).Kc(a1(o.length - 1), t), i = n.next();
                                    while (!i.done);
                                });
                            }, t;
                        }), s1("WeakMap", function(e) {
                            function t(e) {
                                if (this.g = (u += Math.random() + 1).toString(), e) {
                                    e = l(e);
                                    for(var t; !(t = e.next()).done;)t = t.value, this.set(t[0], t[1]);
                                }
                            }
                            function n() {}
                            function r(e) {
                                var t = typeof e;
                                return "object" === t && null !== e || "function" === t;
                            }
                            function i(e) {
                                if (!M(e, s1)) {
                                    var t = new n;
                                    a1(e, s1, {
                                        value: t
                                    });
                                }
                            }
                            function o(e) {
                                var t = Object[e];
                                t && (Object[e] = function(e) {
                                    return e instanceof n ? e : (Object.isExtensible(e) && i(e), t(e));
                                });
                            }
                            if (function() {
                                if (!e || !Object.seal) return !1;
                                try {
                                    var t = Object.seal({}), n = Object.seal({}), r = new e([
                                        [
                                            t,
                                            2
                                        ],
                                        [
                                            n,
                                            3
                                        ]
                                    ]);
                                    return 2 == r.get(t) && 3 == r.get(n) && (r.delete(t), r.set(n, 4), !r.has(t) && 4 == r.get(n));
                                } catch (e) {
                                    return !1;
                                }
                            }()) return e;
                            var s1 = "$jscomp_hidden_" + Math.random();
                            o("freeze"), o("preventExtensions"), o("seal");
                            var u = 0;
                            return t.prototype.set = function(e, t) {
                                if (!r(e)) throw Error("Invalid WeakMap key");
                                if (i(e), !M(e, s1)) throw Error("WeakMap key fail: " + e);
                                return e[s1][this.g] = t, this;
                            }, t.prototype.get = function(e) {
                                return r(e) && M(e, s1) ? e[s1][this.g] : void 0;
                            }, t.prototype.has = function(e) {
                                return r(e) && M(e, s1) && M(e[s1], this.g);
                            }, t.prototype.delete = function(e) {
                                return !!(r(e) && M(e, s1) && M(e[s1], this.g)) && delete e[s1][this.g];
                            }, t;
                        }), s1("Map", function(e) {
                            function t() {
                                var e = {};
                                return e.Qa = e.next = e.head = e;
                            }
                            function n(e, t) {
                                var n = e.g;
                                return u(function() {
                                    if (n) {
                                        for(; n.head != e.g;)n = n.Qa;
                                        for(; n.next != n.head;)return n = n.next, {
                                            done: !1,
                                            value: t(n)
                                        };
                                        n = null;
                                    }
                                    return {
                                        done: !0,
                                        value: void 0
                                    };
                                });
                            }
                            function r(e, t) {
                                var n = t && typeof t;
                                "object" == n || "function" == n ? a1.has(t) ? n = a1.get(t) : (n = "" + ++o, a1.set(t, n)) : n = "p_" + t;
                                var r = e.h[n];
                                if (r && M(e.h, n)) for(var i = 0; i < r.length; i++){
                                    var s1 = r[i];
                                    if (t != t && s1.key != s1.key || t === s1.key) return {
                                        id: n,
                                        list: r,
                                        index: i,
                                        fa: s1
                                    };
                                }
                                return {
                                    id: n,
                                    list: r,
                                    index: -1,
                                    fa: void 0
                                };
                            }
                            function i(e) {
                                if (this.h = {}, this.g = t(), this.size = 0, e) {
                                    e = l(e);
                                    for(var n; !(n = e.next()).done;)n = n.value, this.set(n[0], n[1]);
                                }
                            }
                            if (function() {
                                if (!e || "function" != typeof e || !e.prototype.entries || "function" != typeof Object.seal) return !1;
                                try {
                                    var t = Object.seal({
                                        x: 4
                                    }), n = new e(l([
                                        [
                                            t,
                                            "s"
                                        ]
                                    ]));
                                    if ("s" != n.get(t) || 1 != n.size || n.get({
                                        x: 4
                                    }) || n.set({
                                        x: 4
                                    }, "t") != n || 2 != n.size) return !1;
                                    var r = n.entries(), i = r.next();
                                    return !i.done && i.value[0] == t && "s" == i.value[1] && !((i = r.next()).done || 4 != i.value[0].x || "t" != i.value[1] || !r.next().done);
                                } catch (e) {
                                    return !1;
                                }
                            }()) return e;
                            var a1 = new WeakMap;
                            i.prototype.set = function(e, t) {
                                var n = r(this, e = 0 === e ? 0 : e);
                                return n.list || (n.list = this.h[n.id] = []), n.fa ? n.fa.value = t : (n.fa = {
                                    next: this.g,
                                    Qa: this.g.Qa,
                                    head: this.g,
                                    key: e,
                                    value: t
                                }, n.list.push(n.fa), this.g.Qa.next = n.fa, this.g.Qa = n.fa, this.size++), this;
                            }, i.prototype.delete = function(e) {
                                return !(!(e = r(this, e)).fa || !e.list || (e.list.splice(e.index, 1), e.list.length || delete this.h[e.id], e.fa.Qa.next = e.fa.next, e.fa.next.Qa = e.fa.Qa, e.fa.head = null, this.size--, 0));
                            }, i.prototype.clear = function() {
                                this.h = {}, this.g = this.g.Qa = t(), this.size = 0;
                            }, i.prototype.has = function(e) {
                                return !!r(this, e).fa;
                            }, i.prototype.get = function(e) {
                                return (e = r(this, e).fa) && e.value;
                            }, i.prototype.entries = function() {
                                return n(this, function(e) {
                                    return [
                                        e.key,
                                        e.value
                                    ];
                                });
                            }, i.prototype.keys = function() {
                                return n(this, function(e) {
                                    return e.key;
                                });
                            }, i.prototype.values = function() {
                                return n(this, function(e) {
                                    return e.value;
                                });
                            }, i.prototype.forEach = function(e, t) {
                                for(var n, r = this.entries(); !(n = r.next()).done;)n = n.value, e.call(t, n[1], n[0], this);
                            }, i.prototype[Symbol.iterator] = i.prototype.entries;
                            var o = 0;
                            return i;
                        }), s1("Set", function(e) {
                            function t(e) {
                                if (this.g = new Map, e) {
                                    e = l(e);
                                    for(var t; !(t = e.next()).done;)this.add(t.value);
                                }
                                this.size = this.g.size;
                            }
                            return function() {
                                if (!e || "function" != typeof e || !e.prototype.entries || "function" != typeof Object.seal) return !1;
                                try {
                                    var t = Object.seal({
                                        x: 4
                                    }), n = new e(l([
                                        t
                                    ]));
                                    if (!n.has(t) || 1 != n.size || n.add(t) != n || 1 != n.size || n.add({
                                        x: 4
                                    }) != n || 2 != n.size) return !1;
                                    var r = n.entries(), i = r.next();
                                    return !i.done && i.value[0] == t && i.value[1] == t && !(i = r.next()).done && i.value[0] != t && 4 == i.value[0].x && i.value[1] == i.value[0] && r.next().done;
                                } catch (e) {
                                    return !1;
                                }
                            }() ? e : (t.prototype.add = function(e) {
                                return e = 0 === e ? 0 : e, this.g.set(e, e), this.size = this.g.size, this;
                            }, t.prototype.delete = function(e) {
                                return e = this.g.delete(e), this.size = this.g.size, e;
                            }, t.prototype.clear = function() {
                                this.g.clear(), this.size = 0;
                            }, t.prototype.has = function(e) {
                                return this.g.has(e);
                            }, t.prototype.entries = function() {
                                return this.g.entries();
                            }, t.prototype.values = function() {
                                return this.g.values();
                            }, t.prototype.keys = t.prototype.values, t.prototype[Symbol.iterator] = t.prototype.values, t.prototype.forEach = function(e, t) {
                                var n = this;
                                this.g.forEach(function(r) {
                                    return e.call(t, r, r, n);
                                });
                            }, t);
                        }), s1("Array.prototype.findIndex", function(e) {
                            return e || function(e, t) {
                                return O(this, e, t).He;
                            };
                        }), s1("Object.is", function(e) {
                            return e || function(e, t) {
                                return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
                            };
                        }), s1("Array.prototype.includes", function(e) {
                            return e || function(e, t) {
                                var n = this;
                                n instanceof String && (n = String(n));
                                var r = n.length, i = t || 0;
                                for(0 > i && (i = Math.max(i + r, 0)); i < r; i++){
                                    var a1 = n[i];
                                    if (a1 === e || Object.is(a1, e)) return !0;
                                }
                                return !1;
                            };
                        }), s1("String.prototype.includes", function(e) {
                            return e || function(e, t) {
                                return -1 !== P(this, e, "includes").indexOf(e, t || 0);
                            };
                        }), s1("Array.prototype.find", function(e) {
                            return e || function(e, t) {
                                return O(this, e, t).v;
                            };
                        }), s1("String.prototype.startsWith", function(e) {
                            return e || function(e, t) {
                                for(var n = P(this, e, "startsWith"), r = n.length, i = e.length, a1 = Math.max(0, Math.min(0 | t, n.length)), o = 0; o < i && a1 < r;)if (n[a1++] != e[o++]) return !1;
                                return o >= i;
                            };
                        }), s1("Array.prototype.keys", function(e) {
                            return e || function() {
                                return F(this, function(e) {
                                    return e;
                                });
                            };
                        });
                        var U = "function" == typeof Object.assign ? Object.assign : function(e, t) {
                            for(var n = 1; n < arguments.length; n++){
                                var r = arguments[n];
                                if (r) for(var i in r)M(r, i) && (e[i] = r[i]);
                            }
                            return e;
                        };
                        s1("Object.assign", function(e) {
                            return e || U;
                        }), s1("Array.from", function(e) {
                            return e || function(e, t, n) {
                                t = null != t ? t : function(e) {
                                    return e;
                                };
                                var r = [], i = "undefined" != typeof Symbol && Symbol.iterator && e[Symbol.iterator];
                                if ("function" == typeof i) {
                                    e = i.call(e);
                                    for(var a1 = 0; !(i = e.next()).done;)r.push(t.call(n, i.value, a1++));
                                } else for(i = e.length, a1 = 0; a1 < i; a1++)r.push(t.call(n, e[a1], a1));
                                return r;
                            };
                        }), s1("Array.prototype.values", function(e) {
                            return e || function() {
                                return F(this, function(e, t) {
                                    return t;
                                });
                            };
                        }), s1("Promise.prototype.finally", function(e) {
                            return e || function(e) {
                                return this.then(function(t) {
                                    return Promise.resolve(e()).then(function() {
                                        return t;
                                    });
                                }, function(t) {
                                    return Promise.resolve(e()).then(function() {
                                        throw t;
                                    });
                                });
                            };
                        }), s1("Array.prototype.entries", function(e) {
                            return e || function() {
                                return F(this, function(e, t) {
                                    return [
                                        e,
                                        t
                                    ];
                                });
                            };
                        }), s1("String.prototype.repeat", function(e) {
                            return e || function(e) {
                                var t = P(this, null, "repeat");
                                if (0 > e || 1342177279 < e) throw new RangeError("Invalid count value");
                                e |= 0;
                                for(var n = ""; e;)1 & e && (n += t), (e >>>= 1) && (t += t);
                                return n;
                            };
                        }), s1("Number.isNaN", function(e) {
                            return e || function(e) {
                                return "number" == typeof e && isNaN(e);
                            };
                        }), s1("Object.values", function(e) {
                            return e || function(e) {
                                var t, n = [];
                                for(t in e)M(e, t) && n.push(e[t]);
                                return n;
                            };
                        }), s1("Math.log2", function(e) {
                            return e || function(e) {
                                return Math.log(e) / Math.LN2;
                            };
                        }), s1("Math.trunc", function(e) {
                            return e || function(e) {
                                if (e = Number(e), isNaN(e) || 1 / 0 === e || -1 / 0 === e || 0 === e) return e;
                                var t = Math.floor(Math.abs(e));
                                return 0 > e ? -t : t;
                            };
                        }), s1("Object.entries", function(e) {
                            return e || function(e) {
                                var t, n = [];
                                for(t in e)M(e, t) && n.push([
                                    t,
                                    e[t]
                                ]);
                                return n;
                            };
                        });
                        var j = this || self;
                        function B(e, t) {
                            var n, r = e.split("."), i = j;
                            r[0] in i || void 0 === i.execScript || i.execScript("var " + r[0]);
                            for(; r.length && (n = r.shift());)r.length || void 0 === t ? i = i[n] && i[n] !== Object.prototype[n] ? i[n] : i[n] = {} : i[n] = t;
                        }
                        function G(e) {
                            this.g = Math.exp(Math.log(.5) / e), this.i = this.h = 0;
                        }
                        function H(e) {
                            return e.h / (1 - Math.pow(e.g, e.i));
                        }
                        function V() {
                            this.h = new G(2), this.j = new G(5), this.g = 0, this.i = 128e3, this.l = 16e3;
                        }
                        function K() {}
                        function q() {}
                        function Y() {}
                        function W(e) {
                            var t = x.apply(1, arguments);
                            X.has(e) || (X.add(e), Y.apply(K, c(t)));
                        }
                        function z() {}
                        G.prototype.sample = function(e, t) {
                            var n = Math.pow(this.g, e);
                            n = t * (1 - n) + n * this.h, isNaN(n) || (this.h = n, this.i += e);
                        }, V.prototype.configure = function(e) {
                            this.i = e.minTotalBytes, this.l = e.minBytes, this.h.g = Math.exp(Math.log(.5) / e.fastHalfLife), this.j.g = Math.exp(Math.log(.5) / e.slowHalfLife);
                        }, V.prototype.sample = function(e, t) {
                            if (!(t < this.l)) {
                                var n = 8e3 * t / e, r = e / 1e3;
                                this.g += t, this.h.sample(r, n), this.j.sample(r, n);
                            }
                        }, V.prototype.getBandwidthEstimate = function(e) {
                            return this.g < this.i ? e : Math.min(H(this.h), H(this.j));
                        };
                        var X = new Set;
                        if (e.console && e.console.log.bind) {
                            var Q = {}, J = (Q[1] = console.error.bind(console), Q[2] = console.warn.bind(console), Q[3] = console.info.bind(console), Q[4] = console.log.bind(console), Q[5] = console.debug.bind(console), Q[6] = console.debug.bind(console), Q);
                            Y = J[2], q = J[1];
                        }
                        function Z(e, t) {
                            return !("number" != typeof e || "number" != typeof t || !isNaN(e) || !isNaN(t)) || e === t;
                        }
                        function $(e, t) {
                            var n = e.indexOf(t);
                            -1 < n && e.splice(n, 1);
                        }
                        function ee(e, t, n) {
                            if (n || (n = Z), e.length != t.length) return !1;
                            t = t.slice();
                            for(var r = {}, i = (e = l(e)).next(); !i.done; r = {
                                nd: r.nd
                            }, i = e.next()){
                                if (r.nd = i.value, -1 == (i = t.findIndex(function(e) {
                                    return function(t) {
                                        return n(e.nd, t);
                                    };
                                }(r)))) return !1;
                                t[i] = t[t.length - 1], t.pop();
                            }
                            return 0 == t.length;
                        }
                        function te(e, t, n) {
                            if (n || (n = Z), e.length != t.length) return !1;
                            for(var r = 0; r < e.length; r++)if (!n(e[r], t[r])) return !1;
                            return !0;
                        }
                        function ne(e, t, n) {
                            this.startTime = e, this.direction = le, this.endTime = t, this.payload = n, this.region = new Ee, this.position = null, this.positionAlign = ie, this.size = 0, this.textAlign = ae, this.writingMode = ce, this.lineInterpretation = de, this.line = null, this.lineHeight = "", this.lineAlign = fe, this.displayAlign = se, this.fontSize = this.textStrokeWidth = this.textStrokeColor = this.textShadow = this.border = this.backgroundImage = this.backgroundColor = this.color = "", this.fontWeight = me, this.fontStyle = ve, this.linePadding = this.letterSpacing = this.fontFamily = "", this.opacity = 1, this.textDecoration = [], this.wrapLine = !0, this.id = "", this.nestedCues = [], this.lineBreak = this.isContainer = !1, this.cellResolution = {
                                columns: 32,
                                rows: 15
                            };
                        }
                        function re(e, t) {
                            if (e.startTime != t.startTime || e.endTime != t.endTime || e.payload != t.payload) return !1;
                            for(var n in e)if ("startTime" != n && "endTime" != n && "payload" != n) {
                                if ("nestedCues" == n) {
                                    if (!te(e.nestedCues, t.nestedCues, re)) return !1;
                                } else if ("region" == n || "cellResolution" == n) {
                                    for(var r in e[n])if (e[n][r] != t[n][r]) return !1;
                                } else if (Array.isArray(e[n])) {
                                    if (!te(e[n], t[n])) return !1;
                                } else if (e[n] != t[n]) return !1;
                            }
                            return !0;
                        }
                        ne.prototype.clone = function() {
                            var e, t = new ne(0, 0, "");
                            for(e in this)t[e] = this[e], t[e] && t[e].constructor == Array && (t[e] = t[e].slice());
                            return t;
                        }, B("shaka.text.Cue", ne);
                        var ie = "auto";
                        ne.positionAlign = {
                            LEFT: "line-left",
                            RIGHT: "line-right",
                            CENTER: "center",
                            AUTO: ie
                        };
                        var ae = "center", oe = {
                            LEFT: "left",
                            RIGHT: "right",
                            CENTER: ae,
                            START: "start",
                            END: "end"
                        };
                        ne.textAlign = oe;
                        var se = "after", ue = {
                            BEFORE: "before",
                            CENTER: "center",
                            AFTER: se
                        };
                        ne.displayAlign = ue;
                        var le = "ltr";
                        ne.direction = {
                            HORIZONTAL_LEFT_TO_RIGHT: le,
                            HORIZONTAL_RIGHT_TO_LEFT: "rtl"
                        };
                        var ce = "horizontal-tb";
                        ne.writingMode = {
                            HORIZONTAL_TOP_TO_BOTTOM: ce,
                            VERTICAL_LEFT_TO_RIGHT: "vertical-lr",
                            VERTICAL_RIGHT_TO_LEFT: "vertical-rl"
                        };
                        var de = 0;
                        ne.lineInterpretation = {
                            LINE_NUMBER: de,
                            PERCENTAGE: 1
                        };
                        var fe = "start", he = {
                            CENTER: "center",
                            START: fe,
                            END: "end"
                        };
                        ne.lineAlign = he;
                        var ge = {
                            white: "#FFF",
                            lime: "#0F0",
                            cyan: "#0FF",
                            red: "#F00",
                            yellow: "#FF0",
                            magenta: "#F0F",
                            blue: "#00F",
                            black: "#000"
                        };
                        ne.defaultTextColor = ge;
                        var pe = {
                            bg_white: "#FFF",
                            bg_lime: "#0F0",
                            bg_cyan: "#0FF",
                            bg_red: "#F00",
                            bg_yellow: "#FF0",
                            bg_magenta: "#F0F",
                            bg_blue: "#00F",
                            bg_black: "#000"
                        };
                        ne.defaultTextBackgroundColor = pe;
                        var me = 400;
                        ne.fontWeight = {
                            NORMAL: me,
                            BOLD: 700
                        };
                        var ve = "normal", ye = {
                            NORMAL: ve,
                            ITALIC: "italic",
                            OBLIQUE: "oblique"
                        };
                        function Ee() {
                            this.id = "", this.regionAnchorY = this.regionAnchorX = this.viewportAnchorY = this.viewportAnchorX = 0, this.height = this.width = 100, this.viewportAnchorUnits = this.widthUnits = this.heightUnits = Te, this.scroll = be;
                        }
                        ne.fontStyle = ye, ne.textDecoration = {
                            UNDERLINE: "underline",
                            LINE_THROUGH: "lineThrough",
                            OVERLINE: "overline"
                        }, B("shaka.text.CueRegion", Ee);
                        var Te = 1;
                        Ee.units = {
                            PX: 0,
                            PERCENTAGE: Te,
                            LINES: 2
                        };
                        var be = "";
                        function Ae() {}
                        function _e(e, t) {
                            if (!e && !t) return !0;
                            if (!e || !t || e.byteLength != t.byteLength) return !1;
                            if (Se(e) == Se(t) && (e.byteOffset || 0) == (t.byteOffset || 0)) return !0;
                            for(var n = Ie(e), r = Ie(t), i = 0; i < e.byteLength; i++)if (n[i] != r[i]) return !1;
                            return !0;
                        }
                        function Se(e) {
                            return e instanceof ArrayBuffer ? e : e.buffer;
                        }
                        function we(e) {
                            return e instanceof ArrayBuffer ? e : 0 == e.byteOffset && e.byteLength == e.buffer.byteLength ? e.buffer : new Uint8Array(e).buffer;
                        }
                        function Ie(e, t, n) {
                            return Ce(e, void 0 === t ? 0 : t, n = void 0 === n ? 1 / 0 : n, Uint8Array);
                        }
                        function Re(e, t, n) {
                            return Ce(e, void 0 === t ? 0 : t, n = void 0 === n ? 1 / 0 : n, DataView);
                        }
                        function Ce(e, t, n, r) {
                            var i = (e.byteOffset || 0) + e.byteLength;
                            return t = Math.max(0, Math.min((e.byteOffset || 0) + t, i)), new r(Se(e), t, Math.min(t + Math.max(n, 0), i) - t);
                        }
                        function De(e, t, n) {
                            var r = x.apply(3, arguments);
                            this.severity = e, this.category = t, this.code = n, this.data = r, this.handled = !1;
                        }
                        Ee.scrollMode = {
                            NONE: be,
                            UP: "up"
                        }, B("shaka.util.BufferUtils", Ae), Ae.toDataView = Re, Ae.toUint8 = Ie, Ae.toArrayBuffer = we, Ae.equal = _e, De.prototype.toString = function() {
                            return "shaka.util.Error " + JSON.stringify(this, null, "  ");
                        }, B("shaka.util.Error", De), De.Severity = {
                            RECOVERABLE: 1,
                            CRITICAL: 2
                        }, De.Category = {
                            NETWORK: 1,
                            TEXT: 2,
                            MEDIA: 3,
                            MANIFEST: 4,
                            STREAMING: 5,
                            DRM: 6,
                            PLAYER: 7,
                            CAST: 8,
                            STORAGE: 9,
                            ADS: 10
                        }, De.Code = {
                            UNSUPPORTED_SCHEME: 1e3,
                            BAD_HTTP_STATUS: 1001,
                            HTTP_ERROR: 1002,
                            TIMEOUT: 1003,
                            MALFORMED_DATA_URI: 1004,
                            REQUEST_FILTER_ERROR: 1006,
                            RESPONSE_FILTER_ERROR: 1007,
                            MALFORMED_TEST_URI: 1008,
                            UNEXPECTED_TEST_REQUEST: 1009,
                            ATTEMPTS_EXHAUSTED: 1010,
                            SEGMENT_MISSING: 1011,
                            INVALID_TEXT_HEADER: 2e3,
                            INVALID_TEXT_CUE: 2001,
                            UNABLE_TO_DETECT_ENCODING: 2003,
                            BAD_ENCODING: 2004,
                            INVALID_XML: 2005,
                            INVALID_MP4_TTML: 2007,
                            INVALID_MP4_VTT: 2008,
                            UNABLE_TO_EXTRACT_CUE_START_TIME: 2009,
                            INVALID_MP4_CEA: 2010,
                            TEXT_COULD_NOT_GUESS_MIME_TYPE: 2011,
                            CANNOT_ADD_EXTERNAL_TEXT_TO_SRC_EQUALS: 2012,
                            TEXT_ONLY_WEBVTT_SRC_EQUALS: 2013,
                            MISSING_TEXT_PLUGIN: 2014,
                            CHAPTERS_TRACK_FAILED: 2015,
                            CANNOT_ADD_EXTERNAL_THUMBNAILS_TO_SRC_EQUALS: 2016,
                            UNSUPPORTED_EXTERNAL_THUMBNAILS_URI: 2017,
                            BUFFER_READ_OUT_OF_BOUNDS: 3e3,
                            JS_INTEGER_OVERFLOW: 3001,
                            EBML_OVERFLOW: 3002,
                            EBML_BAD_FLOATING_POINT_SIZE: 3003,
                            MP4_SIDX_WRONG_BOX_TYPE: 3004,
                            MP4_SIDX_INVALID_TIMESCALE: 3005,
                            MP4_SIDX_TYPE_NOT_SUPPORTED: 3006,
                            WEBM_CUES_ELEMENT_MISSING: 3007,
                            WEBM_EBML_HEADER_ELEMENT_MISSING: 3008,
                            WEBM_SEGMENT_ELEMENT_MISSING: 3009,
                            WEBM_INFO_ELEMENT_MISSING: 3010,
                            WEBM_DURATION_ELEMENT_MISSING: 3011,
                            WEBM_CUE_TRACK_POSITIONS_ELEMENT_MISSING: 3012,
                            WEBM_CUE_TIME_ELEMENT_MISSING: 3013,
                            MEDIA_SOURCE_OPERATION_FAILED: 3014,
                            MEDIA_SOURCE_OPERATION_THREW: 3015,
                            VIDEO_ERROR: 3016,
                            QUOTA_EXCEEDED_ERROR: 3017,
                            TRANSMUXING_FAILED: 3018,
                            CONTENT_TRANSFORMATION_FAILED: 3019,
                            UNABLE_TO_GUESS_MANIFEST_TYPE: 4e3,
                            DASH_INVALID_XML: 4001,
                            DASH_NO_SEGMENT_INFO: 4002,
                            DASH_EMPTY_ADAPTATION_SET: 4003,
                            DASH_EMPTY_PERIOD: 4004,
                            DASH_WEBM_MISSING_INIT: 4005,
                            DASH_UNSUPPORTED_CONTAINER: 4006,
                            DASH_PSSH_BAD_ENCODING: 4007,
                            DASH_NO_COMMON_KEY_SYSTEM: 4008,
                            DASH_MULTIPLE_KEY_IDS_NOT_SUPPORTED: 4009,
                            DASH_CONFLICTING_KEY_IDS: 4010,
                            RESTRICTIONS_CANNOT_BE_MET: 4012,
                            HLS_PLAYLIST_HEADER_MISSING: 4015,
                            INVALID_HLS_TAG: 4016,
                            HLS_INVALID_PLAYLIST_HIERARCHY: 4017,
                            DASH_DUPLICATE_REPRESENTATION_ID: 4018,
                            HLS_MULTIPLE_MEDIA_INIT_SECTIONS_FOUND: 4020,
                            HLS_REQUIRED_ATTRIBUTE_MISSING: 4023,
                            HLS_REQUIRED_TAG_MISSING: 4024,
                            HLS_COULD_NOT_GUESS_CODECS: 4025,
                            HLS_KEYFORMATS_NOT_SUPPORTED: 4026,
                            DASH_UNSUPPORTED_XLINK_ACTUATE: 4027,
                            DASH_XLINK_DEPTH_LIMIT: 4028,
                            CONTENT_UNSUPPORTED_BY_BROWSER: 4032,
                            CANNOT_ADD_EXTERNAL_TEXT_TO_LIVE_STREAM: 4033,
                            NO_VARIANTS: 4036,
                            PERIOD_FLATTENING_FAILED: 4037,
                            INCONSISTENT_DRM_ACROSS_PERIODS: 4038,
                            HLS_VARIABLE_NOT_FOUND: 4039,
                            HLS_MSE_ENCRYPTED_MP2T_NOT_SUPPORTED: 4040,
                            HLS_MSE_ENCRYPTED_LEGACY_APPLE_MEDIA_KEYS_NOT_SUPPORTED: 4041,
                            NO_WEB_CRYPTO_API: 4042,
                            HLS_AES_128_INVALID_IV_LENGTH: 4043,
                            HLS_AES_128_INVALID_KEY_LENGTH: 4044,
                            CANNOT_ADD_EXTERNAL_THUMBNAILS_TO_LIVE_STREAM: 4045,
                            STREAMING_ENGINE_STARTUP_INVALID_STATE: 5006,
                            NO_RECOGNIZED_KEY_SYSTEMS: 6e3,
                            REQUESTED_KEY_SYSTEM_CONFIG_UNAVAILABLE: 6001,
                            FAILED_TO_CREATE_CDM: 6002,
                            FAILED_TO_ATTACH_TO_VIDEO: 6003,
                            INVALID_SERVER_CERTIFICATE: 6004,
                            FAILED_TO_CREATE_SESSION: 6005,
                            FAILED_TO_GENERATE_LICENSE_REQUEST: 6006,
                            LICENSE_REQUEST_FAILED: 6007,
                            LICENSE_RESPONSE_REJECTED: 6008,
                            ENCRYPTED_CONTENT_WITHOUT_DRM_INFO: 6010,
                            NO_LICENSE_SERVER_GIVEN: 6012,
                            OFFLINE_SESSION_REMOVED: 6013,
                            EXPIRED: 6014,
                            SERVER_CERTIFICATE_REQUIRED: 6015,
                            INIT_DATA_TRANSFORM_ERROR: 6016,
                            SERVER_CERTIFICATE_REQUEST_FAILED: 6017,
                            LOAD_INTERRUPTED: 7e3,
                            OPERATION_ABORTED: 7001,
                            NO_VIDEO_ELEMENT: 7002,
                            OBJECT_DESTROYED: 7003,
                            CONTENT_NOT_LOADED: 7004,
                            CAST_API_UNAVAILABLE: 8e3,
                            NO_CAST_RECEIVERS: 8001,
                            ALREADY_CASTING: 8002,
                            UNEXPECTED_CAST_ERROR: 8003,
                            CAST_CANCELED_BY_USER: 8004,
                            CAST_CONNECTION_TIMED_OUT: 8005,
                            CAST_RECEIVER_APP_UNAVAILABLE: 8006,
                            STORAGE_NOT_SUPPORTED: 9e3,
                            INDEXED_DB_ERROR: 9001,
                            DEPRECATED_OPERATION_ABORTED: 9002,
                            REQUESTED_ITEM_NOT_FOUND: 9003,
                            MALFORMED_OFFLINE_URI: 9004,
                            CANNOT_STORE_LIVE_OFFLINE: 9005,
                            NO_INIT_DATA_FOR_OFFLINE: 9007,
                            LOCAL_PLAYER_INSTANCE_REQUIRED: 9008,
                            NEW_KEY_OPERATION_NOT_SUPPORTED: 9011,
                            KEY_NOT_FOUND: 9012,
                            MISSING_STORAGE_CELL: 9013,
                            STORAGE_LIMIT_REACHED: 9014,
                            DOWNLOAD_SIZE_CALLBACK_ERROR: 9015,
                            MODIFY_OPERATION_NOT_SUPPORTED: 9016,
                            INDEXED_DB_INIT_TIMED_OUT: 9017,
                            CS_IMA_SDK_MISSING: 1e4,
                            CS_AD_MANAGER_NOT_INITIALIZED: 10001,
                            SS_IMA_SDK_MISSING: 10002,
                            SS_AD_MANAGER_NOT_INITIALIZED: 10003,
                            CURRENT_DAI_REQUEST_NOT_FINISHED: 10004
                        };
                        var ke = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#(.*))?$");
                        function Ne(e) {
                            var t;
                            e instanceof Ne ? (Le(this, e.Da), this.pb = e.pb, this.Fa = e.Fa, xe(this, e.Jb), this.qa = e.qa, Me(this, e.g.clone()), this.gb = e.gb) : e && (t = String(e).match(ke)) ? (Le(this, t[1] || "", !0), this.pb = Oe(t[2] || ""), this.Fa = Oe(t[3] || "", !0), xe(this, t[4]), this.qa = Oe(t[5] || "", !0), Me(this, t[6] || "", !0), this.gb = Oe(t[7] || "")) : this.g = new Ve(null);
                        }
                        function Le(e, t, n) {
                            e.Da = n ? Oe(t, !0) : t, e.Da && (e.Da = e.Da.replace(/:$/, ""));
                        }
                        function xe(e, t) {
                            if (t) {
                                if (t = Number(t), isNaN(t) || 0 > t) throw Error("Bad port number " + t);
                                e.Jb = t;
                            } else e.Jb = null;
                        }
                        function Me(e, t, n) {
                            t instanceof Ve ? e.g = t : (n || (t = Pe(t, Ge)), e.g = new Ve(t));
                        }
                        function Oe(e, t) {
                            return e ? t ? decodeURI(e) : decodeURIComponent(e) : "";
                        }
                        function Pe(e, t, n) {
                            return null != e ? (e = encodeURI(e).replace(t, Fe), n && (e = e.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), e) : null;
                        }
                        function Fe(e) {
                            return "%" + ((e = e.charCodeAt(0)) >> 4 & 15).toString(16) + (15 & e).toString(16);
                        }
                        (r = Ne.prototype).Da = "", r.pb = "", r.Fa = "", r.Jb = null, r.qa = "", r.gb = "", r.toString = function() {
                            var e = [], t = this.Da;
                            if (t && e.push(Pe(t, Ue, !0), ":"), t = this.Fa) {
                                e.push("//");
                                var n = this.pb;
                                n && e.push(Pe(n, Ue, !0), "@"), e.push(encodeURIComponent(t).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), null != (t = this.Jb) && e.push(":", String(t));
                            }
                            return (t = this.qa) && (this.Fa && "/" != t.charAt(0) && e.push("/"), e.push(Pe(t, "/" == t.charAt(0) ? Be : je, !0))), (t = this.g.toString()) && e.push("?", t), (t = this.gb) && e.push("#", Pe(t, He)), e.join("");
                        }, r.resolve = function(e) {
                            var t = this.clone();
                            "data" === t.Da && (t = new Ne);
                            var n = !!e.Da;
                            n ? Le(t, e.Da) : n = !!e.pb, n ? t.pb = e.pb : n = !!e.Fa, n ? t.Fa = e.Fa : n = null != e.Jb;
                            var r = e.qa;
                            if (n) xe(t, e.Jb);
                            else if (n = !!e.qa) {
                                if ("/" != r.charAt(0)) {
                                    if (this.Fa && !this.qa) r = "/" + r;
                                    else {
                                        var i = t.qa.lastIndexOf("/");
                                        -1 != i && (r = t.qa.substr(0, i + 1) + r);
                                    }
                                }
                                if (".." == r || "." == r) r = "";
                                else if (-1 != r.indexOf("./") || -1 != r.indexOf("/.")) {
                                    i = 0 == r.lastIndexOf("/", 0), r = r.split("/");
                                    for(var a1 = [], o = 0; o < r.length;){
                                        var s1 = r[o++];
                                        "." == s1 ? i && o == r.length && a1.push("") : ".." == s1 ? ((1 < a1.length || 1 == a1.length && "" != a1[0]) && a1.pop(), i && o == r.length && a1.push("")) : (a1.push(s1), i = !0);
                                    }
                                    r = a1.join("/");
                                }
                            }
                            return n ? t.qa = r : n = "" !== e.g.toString(), n ? Me(t, e.g.clone()) : n = !!e.gb, n && (t.gb = e.gb), t;
                        }, r.clone = function() {
                            return new Ne(this);
                        };
                        var Ue = /[#\/\?@]/g, je = /[#\?:]/g, Be = /[#\?]/g, Ge = /[#\?@]/g, He = /#/g;
                        function Ve(e) {
                            this.g = e || null;
                        }
                        function Ke(e) {
                            if (!e.ma && (e.ma = {}, e.Nc = 0, e.g)) for(var t = e.g.split("&"), n = 0; n < t.length; n++){
                                var r = t[n].indexOf("="), i = null;
                                if (0 <= r) {
                                    var a1 = t[n].substring(0, r);
                                    i = t[n].substring(r + 1);
                                } else a1 = t[n];
                                a1 = decodeURIComponent(a1.replace(/\+/g, " ")), i = i || "", e.add(a1, decodeURIComponent(i.replace(/\+/g, " ")));
                            }
                        }
                        function qe(e, t) {
                            return e.concat(t);
                        }
                        function Ye() {}
                        function We(e) {
                            return null != e;
                        }
                        function ze(e, t) {
                            if (0 == t.length) return e;
                            var n = t.map(function(e) {
                                return new Ne(e);
                            });
                            return e.map(function(e) {
                                return new Ne(e);
                            }).map(function(e) {
                                return n.map(function(t) {
                                    return e.resolve(t);
                                });
                            }).reduce(qe, []).map(function(e) {
                                return e.toString();
                            });
                        }
                        function Xe(e, t) {
                            return {
                                keySystem: e,
                                licenseServerUri: "",
                                distinctiveIdentifierRequired: !1,
                                persistentStateRequired: !1,
                                audioRobustness: "",
                                videoRobustness: "",
                                serverCertificate: null,
                                serverCertificateUri: "",
                                sessionType: "",
                                initData: t || [],
                                keyIds: new Set
                            };
                        }
                        function Qe(e, t) {
                            if (1 == t.length) return t[0];
                            var n = Je(e, t);
                            if (null != n) return n;
                            throw new De(2, 4, 4025, t);
                        }
                        function Je(e, t) {
                            for(var n = l(et[e]), r = n.next(); !r.done; r = n.next()){
                                r = r.value;
                                for(var i = l(t), a1 = i.next(); !a1.done; a1 = i.next())if (a1 = a1.value, r.test(a1.trim())) return a1.trim();
                            }
                            return e == Ze ? "" : null;
                        }
                        (r = Ve.prototype).ma = null, r.Nc = null, r.add = function(e, t) {
                            Ke(this), this.g = null;
                            var n = this.ma.hasOwnProperty(e) && this.ma[e];
                            return n || (this.ma[e] = n = []), n.push(t), this.Nc++, this;
                        }, r.set = function(e, t) {
                            return Ke(this), this.g = null, this.ma.hasOwnProperty(e) ? this.ma[e] = [
                                t
                            ] : this.add(e, t), this;
                        }, r.toString = function() {
                            if (this.g) return this.g;
                            if (!this.ma) return "";
                            var e, t = [];
                            for(e in this.ma)for(var n = encodeURIComponent(e), r = this.ma[e], i = 0; i < r.length; i++){
                                var a1 = n;
                                "" !== r[i] && (a1 += "=" + encodeURIComponent(r[i])), t.push(a1);
                            }
                            return this.g = t.join("&");
                        }, r.clone = function() {
                            var e = new Ve;
                            if (e.g = this.g, this.ma) {
                                var t, n = {};
                                for(t in this.ma)n[t] = this.ma[t].concat();
                                e.ma = n, e.Nc = this.Nc;
                            }
                            return e;
                        };
                        var Ze = "text", $e = {
                            ua: "video",
                            Gc: "audio",
                            Z: Ze,
                            Vb: "image",
                            Fg: "application"
                        }, et = {
                            audio: [
                                /^vorbis$/,
                                /^opus$/,
                                /^flac$/,
                                /^mp4a/,
                                /^[ae]c-3$/,
                                /^ac-4$/,
                                /^dts[cx]$/,
                                /^[du]dts$/
                            ],
                            video: [
                                /^avc/,
                                /^hev/,
                                /^hvc/,
                                /^vp0?[89]/,
                                /^av01/,
                                /^dvhe/
                            ],
                            text: [
                                /^vtt$/,
                                /^wvtt/,
                                /^stpp/
                            ]
                        };
                        function tt() {
                            var e, t, n = new Promise(function(n, r) {
                                e = n, t = r;
                            });
                            return n.resolve = e, n.reject = t, n;
                        }
                        function nt(e) {
                            this.h = e, this.g = void 0;
                        }
                        function rt(e) {
                            this.h = e, this.g = null;
                        }
                        function it(e) {
                            this.h = e, this.g = null;
                        }
                        function at() {
                            return !(!e.MediaSource || !MediaSource.isTypeSupported);
                        }
                        function ot(e) {
                            return "" != gt().canPlayType(e);
                        }
                        function st() {
                            return ht("Xbox One");
                        }
                        function ut() {
                            return ht("Tizen");
                        }
                        function lt() {
                            return ht("Web0S") && ht("Chrome/38.0.2125.122 Safari/537.36");
                        }
                        function ct() {
                            return !!navigator.vendor && navigator.vendor.includes("Apple") && !ut() && !ht("PC=EOS") && !ht("VirginMedia") && !dt() && !ht("AFT");
                        }
                        function dt() {
                            return ht("PlayStation 4");
                        }
                        function ft() {
                            if (!ct()) return null;
                            var e = navigator.userAgent.match(/Version\/(\d+)/);
                            return e || (e = navigator.userAgent.match(/OS (\d+)(?:_\d+)?/)) ? parseInt(e[1], 10) : null;
                        }
                        function ht(e) {
                            return (navigator.userAgent || "").includes(e);
                        }
                        function gt() {
                            return mt || (pt || (pt = new it(function() {
                                mt = null;
                            })), (mt = document.getElementsByTagName("video")[0] || document.getElementsByTagName("audio")[0]) || (mt = document.createElement("video")), pt.O(1), mt);
                        }
                        tt.prototype.resolve = function() {}, tt.prototype.reject = function() {}, nt.prototype.value = function() {
                            return null == this.g && (this.g = this.h()), this.g;
                        }, rt.prototype.O = function(t) {
                            var n = this;
                            this.stop();
                            var r = !0, i = null;
                            return this.g = function() {
                                e.clearTimeout(i), r = !1;
                            }, i = e.setTimeout(function() {
                                r && n.h();
                            }, 1e3 * t), this;
                        }, rt.prototype.stop = function() {
                            this.g && (this.g(), this.g = null);
                        }, it.prototype.Lb = function() {
                            return this.stop(), this.h(), this;
                        }, it.prototype.O = function(e) {
                            var t = this;
                            return this.stop(), this.g = new rt(function() {
                                t.h();
                            }).O(e), this;
                        }, it.prototype.Ba = function(e) {
                            var t = this;
                            return this.stop(), this.g = new rt(function() {
                                t.g.O(e), t.h();
                            }).O(e), this;
                        }, it.prototype.stop = function() {
                            this.g && (this.g.stop(), this.g = null);
                        }, B("shaka.util.Timer", it), it.prototype.stop = it.prototype.stop, it.prototype.tickEvery = it.prototype.Ba, it.prototype.tickAfter = it.prototype.O, it.prototype.tickNow = it.prototype.Lb;
                        var pt = null, mt = null;
                        function vt() {}
                        function yt(t) {
                            if (!t) return "";
                            if (239 == (t = Ie(t))[0] && 187 == t[1] && 191 == t[2] && (t = t.subarray(3)), e.TextDecoder && !dt()) return (t = (new TextDecoder).decode(t)).includes("\uFFFD") && q('Decoded string contains an "unknown character" codepoint.  That probably means the UTF8 encoding was incorrect!'), t;
                            for(var n = "", r = 0; r < t.length; ++r){
                                var i = 65533;
                                if (0 == (128 & t[r]) ? i = t[r] : t.length >= r + 2 && 192 == (224 & t[r]) && 128 == (192 & t[r + 1]) ? (i = (31 & t[r]) << 6 | 63 & t[r + 1], r += 1) : t.length >= r + 3 && 224 == (240 & t[r]) && 128 == (192 & t[r + 1]) && 128 == (192 & t[r + 2]) ? (i = (15 & t[r]) << 12 | (63 & t[r + 1]) << 6 | 63 & t[r + 2], r += 2) : t.length >= r + 4 && 240 == (241 & t[r]) && 128 == (192 & t[r + 1]) && 128 == (192 & t[r + 2]) && 128 == (192 & t[r + 3]) && (i = (7 & t[r]) << 18 | (63 & t[r + 1]) << 12 | (63 & t[r + 2]) << 6 | 63 & t[r + 3], r += 3), 65535 >= i) n += String.fromCharCode(i);
                                else {
                                    var a1 = 1023 & (i -= 65536);
                                    n += String.fromCharCode(55296 + (i >> 10)), n += String.fromCharCode(56320 + a1);
                                }
                            }
                            return n;
                        }
                        function Et(e, t, n) {
                            if (!e) return "";
                            if (!n && 0 != e.byteLength % 2) throw new De(2, 2, 2004);
                            n = Math.floor(e.byteLength / 2);
                            var r = new Uint16Array(n);
                            e = Re(e);
                            for(var i = 0; i < n; i++)r[i] = e.getUint16(2 * i, t);
                            return _t.value()(r);
                        }
                        function Tt(e) {
                            function t(e) {
                                return n.byteLength <= e || 32 <= n[e] && 126 >= n[e];
                            }
                            if (!e) return "";
                            var n = Ie(e);
                            if (239 == n[0] && 187 == n[1] && 191 == n[2]) return yt(n);
                            if (254 == n[0] && 255 == n[1]) return Et(n.subarray(2), !1);
                            if (255 == n[0] && 254 == n[1]) return Et(n.subarray(2), !0);
                            if (0 == n[0] && 0 == n[2]) return Et(e, !1);
                            if (0 == n[1] && 0 == n[3]) return Et(e, !0);
                            if (t(0) && t(1) && t(2) && t(3)) return yt(e);
                            throw new De(2, 2, 2003);
                        }
                        function bt(t) {
                            if (e.TextEncoder && !dt()) {
                                var n = new TextEncoder;
                                return we(n.encode(t));
                            }
                            t = encodeURIComponent(t), t = unescape(t), n = new Uint8Array(t.length);
                            for(var r = 0; r < t.length; r++)n[r] = t[r].charCodeAt(0);
                            return we(n);
                        }
                        function At(e, t) {
                            for(var n = new ArrayBuffer(2 * e.length), r = new DataView(n), i = 0; i < e.length; ++i)r.setUint16(2 * i, e.charCodeAt(i), t);
                            return n;
                        }
                        B("shaka.util.StringUtils", vt), vt.resetFromCharCode = function() {
                            _t.g = void 0;
                        }, vt.toUTF16 = At, vt.toUTF8 = bt, vt.fromBytesAutoDetect = Tt, vt.fromUTF16 = Et, vt.fromUTF8 = yt;
                        var _t = new nt(function() {
                            function e(e) {
                                try {
                                    var t = new Uint8Array(e);
                                    return 0 < String.fromCharCode.apply(null, t).length;
                                } catch (e) {
                                    return !1;
                                }
                            }
                            for(var t = {
                                Va: 65536
                            }; 0 < t.Va; (t = {
                                Va: t.Va
                            }).Va /= 2)if (e(t.Va)) return function(e) {
                                return function(t) {
                                    for(var n = "", r = 0; r < t.length; r += e.Va)n += String.fromCharCode.apply(null, t.subarray(r, r + e.Va));
                                    return n;
                                };
                            }(t);
                            return null;
                        });
                        function St() {}
                        function wt(e) {
                            return e = Ie(e), e = _t.value()(e), btoa(e);
                        }
                        function It(e, t) {
                            t = null == t || t;
                            var n = wt(e).replace(/\+/g, "-").replace(/\//g, "_");
                            return t ? n : n.replace(/[=]*$/, "");
                        }
                        function Rt(t) {
                            t = e.atob(t.replace(/-/g, "+").replace(/_/g, "/"));
                            for(var n = new Uint8Array(t.length), r = 0; r < t.length; ++r)n[r] = t.charCodeAt(r);
                            return n;
                        }
                        function Ct(t) {
                            for(var n = t.length / 2, r = new Uint8Array(n), i = 0; i < n; i++)r[i] = e.parseInt(t.substr(2 * i, 2), 16);
                            return r;
                        }
                        function Dt(e) {
                            var t = Ie(e);
                            e = "";
                            for(var n = (t = l(t)).next(); !n.done; n = t.next())1 == (n = (n = n.value).toString(16)).length && (n = "0" + n), e += n;
                            return e;
                        }
                        function kt() {
                            for(var e = x.apply(0, arguments), t = 0, n = l(e), r = n.next(); !r.done; r = n.next())t += r.value.byteLength;
                            for(t = new Uint8Array(t), n = 0, r = (e = l(e)).next(); !r.done; r = e.next())r = r.value, t.set(Ie(r), n), n += r.byteLength;
                            return t;
                        }
                        function Nt() {}
                        B("shaka.util.Uint8ArrayUtils", St), St.concat = kt, St.toHex = Dt, St.fromHex = Ct, St.fromBase64 = Rt, St.toBase64 = It, St.toStandardBase64 = wt, B("shaka.dependencies", Nt), Nt.has = function(e) {
                            return xt.has(e);
                        }, Nt.add = function(e, t) {
                            if (!Lt[e]) throw Error(e + " is not supported");
                            xt.set(e, function() {
                                return t;
                            });
                        };
                        var Lt = {
                            muxjs: "muxjs"
                        };
                        Nt.Allowed = Lt;
                        var xt = new Map([
                            [
                                "muxjs",
                                function() {
                                    return e.muxjs;
                                }
                            ]
                        ]);
                        function Mt(e) {
                            var t = this;
                            this.o = e, this.m = xt.get("muxjs")(), this.g = new this.m.mp4.Transmuxer({
                                keepOriginalTimestamps: !0
                            }), this.h = null, this.l = [], this.i = [], this.j = !1, this.g.on("data", function(e) {
                                t.i = e.captions, t.l.push(kt(e.initSegment, e.data));
                            }), this.g.on("done", function() {
                                var e = {
                                    data: kt.apply(St, c(t.l)),
                                    captions: t.i
                                };
                                t.h.resolve(e), t.j = !1;
                            });
                        }
                        function Ot(e, t) {
                            var n = Pt(e), r = "audio/aac" == e.toLowerCase().split(";")[0];
                            return !(!xt.get("muxjs")() || !n && !r) && (r ? MediaSource.isTypeSupported('audio/mp4; codecs="mp4a.40.2"') : t ? MediaSource.isTypeSupported(Ut(t, e)) : (n = Ut("audio", e), r = Ut("video", e), MediaSource.isTypeSupported(n) || MediaSource.isTypeSupported(r)));
                        }
                        function Pt(e) {
                            return "mp2t" == e.toLowerCase().split(";")[0].split("/")[1];
                        }
                        function Ft(e, t) {
                            return "audio/aac" == t.toLowerCase().split(";")[0] ? 'audio/mp4; codecs="mp4a.40.2"' : Pt(t) ? Ut(e, t) : t;
                        }
                        function Ut(e, t) {
                            var n = t.replace(/mp2t/i, "mp4");
                            "audio" == e && (n = n.replace("video", "audio"));
                            var r = /avc1\.(66|77|100)\.(\d+)/.exec(n);
                            if (r) {
                                var i = "avc1.", a1 = r[1], o = Number(r[2]);
                                i = ("66" == a1 ? i + "4200" : "77" == a1 ? i + "4d00" : i + "6400") + (o >> 4).toString(16), i += (15 & o).toString(16), n = n.replace(r[0], i);
                            }
                            return n;
                        }
                        function jt() {}
                        function Bt(e, t) {
                            var n = e;
                            return t && (n += '; codecs="' + t + '"'), n;
                        }
                        function Gt(e, t, n) {
                            return Ot(e = Bt(e, t), n) ? Ft(n, e) : "audio" == n ? e.replace("video", "audio") : e;
                        }
                        function Ht(e) {
                            var t = Kt(e);
                            switch(e = t[0], t = t[1].toLowerCase(), !0){
                                case "mp4a" === e && "69" === t:
                                case "mp4a" === e && "6b" === t:
                                    return "mp3";
                                case "mp4a" === e && "66" === t:
                                case "mp4a" === e && "67" === t:
                                case "mp4a" === e && "68" === t:
                                case "mp4a" === e && "40.2" === t:
                                case "mp4a" === e && "40.02" === t:
                                case "mp4a" === e && "40.5" === t:
                                case "mp4a" === e && "40.05" === t:
                                case "mp4a" === e && "40.29" === t:
                                case "mp4a" === e && "40.42" === t:
                                    return "aac";
                                case "mp4a" === e && "a5" === t:
                                    return "ac-3";
                                case "mp4a" === e && "a6" === t:
                                    return "ec-3";
                                case "mp4a" === e && "b2" === t:
                                    return "dtsx";
                                case "mp4a" === e && "a9" === t:
                                    return "dtsc";
                                case "avc1" === e:
                                case "avc3" === e:
                                    return "avc";
                                case "hvc1" === e:
                                case "hev1" === e:
                                    return "hevc";
                                case "dvh1" === e:
                                case "dvhe" === e:
                                    return "dovi";
                            }
                            return e;
                        }
                        function Vt(e) {
                            return (e = e.split(/ *; */)).shift(), (e = e.find(function(e) {
                                return e.startsWith("codecs=");
                            })) ? e.split("=")[1].replace(/^"|"$/g, "") : "";
                        }
                        function Kt(e) {
                            var t = (e = e.split("."))[0];
                            return e.shift(), [
                                t,
                                e.join(".")
                            ];
                        }
                        function qt(e) {
                            this.j = null, this.i = e, this.u = !1, this.l = this.s = 0, this.m = 1 / 0, this.h = this.g = null, this.B = "", this.o = new Map;
                        }
                        function Yt(e) {
                            return !(!Qt[e] && "application/cea-608" != e && "application/cea-708" != e);
                        }
                        function Wt(e, t, n) {
                            if (e.B = t, t = e.o.get(t)) for(var r = l(t.keys()), i = r.next(); !i.done; i = r.next())(i = t.get(i.value).filter(function(e) {
                                return e.endTime <= n;
                            })) && e.i.append(i);
                        }
                        function zt(e, t, n) {
                            t.startTime += n, t.endTime += n;
                            for(var r = (t = l(t.nestedCues)).next(); !r.done; r = t.next())zt(e, r.value, n);
                        }
                        function Xt(e, t, n, r, i) {
                            for(var a1 = n + " " + r, o = new Map, s1 = (t = l(t)).next(); !s1.done; s1 = t.next()){
                                var u = s1.value;
                                s1 = u.stream, u = u.cue, o.has(s1) || o.set(s1, new Map), o.get(s1).has(a1) || o.get(s1).set(a1, []), zt(e, u, i), u.startTime >= e.l && u.startTime < e.m && (o.get(s1).get(a1).push(u), s1 == e.B && e.i.append([
                                    u
                                ]));
                            }
                            for(a1 = (i = l(o.keys())).next(); !a1.done; a1 = i.next())for(a1 = a1.value, e.o.has(a1) || e.o.set(a1, new Map), s1 = (t = l(o.get(a1).keys())).next(); !s1.done; s1 = t.next())s1 = s1.value, u = o.get(a1).get(s1), e.o.get(a1).set(s1, u);
                            e.g = null == e.g ? Math.max(n, e.l) : Math.min(e.g, Math.max(n, e.l)), e.h = Math.max(e.h, Math.min(r, e.m));
                        }
                        Mt.prototype.destroy = function() {
                            return this.g.dispose(), this.g = null, Promise.resolve();
                        }, B("shaka.util.MimeUtils", jt), jt.getFullType = Bt, (new Map).set("codecs", "codecs").set("frameRate", "framerate").set("bandwidth", "bitrate").set("width", "width").set("height", "height").set("channelsCount", "channels"), qt.prototype.destroy = function() {
                            return this.i = this.j = null, this.o.clear(), Promise.resolve();
                        }, qt.prototype.remove = function(e, t) {
                            var n = this;
                            return L(function(r) {
                                if (1 == r.g) return T(r, Promise.resolve(), 2);
                                !n.i || !n.i.remove(e, t) || null == n.g || t <= n.g || e >= n.h || (e <= n.g && t >= n.h ? n.g = n.h = null : e <= n.g && t < n.h ? n.g = t : e > n.g && t >= n.h && (n.h = e)), b(r);
                            });
                        }, B("shaka.text.TextEngine", qt), qt.prototype.destroy = qt.prototype.destroy, qt.findParser = function(e) {
                            return Qt[e];
                        }, qt.unregisterParser = function(e) {
                            delete Qt[e];
                        }, qt.registerParser = function(e, t) {
                            Qt[e] = t;
                        };
                        var Qt = {};
                        function Jt() {}
                        function Zt(e, t) {
                            return e = tn(e), t = tn(t), e.split("-")[0] == t.split("-")[0];
                        }
                        function $t(e, t) {
                            e = tn(e), t = tn(t);
                            var n = e.split("-"), r = t.split("-");
                            return n[0] == r[0] && 1 == n.length && 2 == r.length;
                        }
                        function en(e, t) {
                            e = tn(e), t = tn(t);
                            var n = e.split("-"), r = t.split("-");
                            return 2 == n.length && 2 == r.length && n[0] == r[0];
                        }
                        function tn(e) {
                            var t = e.split("-");
                            return e = t[0] || "", t = t[1] || "", e = e.toLowerCase(), e = sn.get(e) || e, (t = t.toUpperCase()) ? e + "-" + t : e;
                        }
                        function nn(e, t) {
                            return e = tn(e), (t = tn(t)) == e ? 4 : $t(t, e) ? 3 : en(t, e) ? 2 : $t(e, t) ? 1 : 0;
                        }
                        function rn(e) {
                            var t = e.indexOf("-");
                            return e = (e = 0 <= t ? e.substring(0, t) : e).toLowerCase(), sn.get(e) || e;
                        }
                        function an(e) {
                            return e.language ? tn(e.language) : e.audio && e.audio.language ? tn(e.audio.language) : e.video && e.video.language ? tn(e.video.language) : "und";
                        }
                        function on(e, t) {
                            for(var n = tn(e), r = new Set, i = l(t), a1 = i.next(); !a1.done; a1 = i.next())r.add(tn(a1.value));
                            for(a1 = (i = l(r)).next(); !a1.done; a1 = i.next())if ((a1 = a1.value) == n) return a1;
                            for(a1 = (i = l(r)).next(); !a1.done; a1 = i.next())if ($t(a1 = a1.value, n)) return a1;
                            for(a1 = (i = l(r)).next(); !a1.done; a1 = i.next())if (en(a1 = a1.value, n)) return a1;
                            for(a1 = (r = l(r)).next(); !a1.done; a1 = r.next())if ($t(n, a1 = a1.value)) return a1;
                            return null;
                        }
                        B("shaka.util.LanguageUtils", Jt), Jt.findClosestLocale = on, Jt.getLocaleForVariant = an, Jt.getLocaleForText = function(e) {
                            return tn(e.language || "und");
                        }, Jt.getBase = rn, Jt.relatedness = nn, Jt.areSiblings = function(e, t) {
                            var n = rn(e), r = rn(t);
                            return e != n && t != r && n == r;
                        }, Jt.normalize = tn, Jt.isSiblingOf = en, Jt.isParentOf = $t, Jt.areLanguageCompatible = Zt, Jt.areLocaleCompatible = function(e, t) {
                            return (e = tn(e)) == tn(t);
                        };
                        var sn = new Map([
                            [
                                "aar",
                                "aa"
                            ],
                            [
                                "abk",
                                "ab"
                            ],
                            [
                                "afr",
                                "af"
                            ],
                            [
                                "aka",
                                "ak"
                            ],
                            [
                                "alb",
                                "sq"
                            ],
                            [
                                "amh",
                                "am"
                            ],
                            [
                                "ara",
                                "ar"
                            ],
                            [
                                "arg",
                                "an"
                            ],
                            [
                                "arm",
                                "hy"
                            ],
                            [
                                "asm",
                                "as"
                            ],
                            [
                                "ava",
                                "av"
                            ],
                            [
                                "ave",
                                "ae"
                            ],
                            [
                                "aym",
                                "ay"
                            ],
                            [
                                "aze",
                                "az"
                            ],
                            [
                                "bak",
                                "ba"
                            ],
                            [
                                "bam",
                                "bm"
                            ],
                            [
                                "baq",
                                "eu"
                            ],
                            [
                                "bel",
                                "be"
                            ],
                            [
                                "ben",
                                "bn"
                            ],
                            [
                                "bih",
                                "bh"
                            ],
                            [
                                "bis",
                                "bi"
                            ],
                            [
                                "bod",
                                "bo"
                            ],
                            [
                                "bos",
                                "bs"
                            ],
                            [
                                "bre",
                                "br"
                            ],
                            [
                                "bul",
                                "bg"
                            ],
                            [
                                "bur",
                                "my"
                            ],
                            [
                                "cat",
                                "ca"
                            ],
                            [
                                "ces",
                                "cs"
                            ],
                            [
                                "cha",
                                "ch"
                            ],
                            [
                                "che",
                                "ce"
                            ],
                            [
                                "chi",
                                "zh"
                            ],
                            [
                                "chu",
                                "cu"
                            ],
                            [
                                "chv",
                                "cv"
                            ],
                            [
                                "cor",
                                "kw"
                            ],
                            [
                                "cos",
                                "co"
                            ],
                            [
                                "cre",
                                "cr"
                            ],
                            [
                                "cym",
                                "cy"
                            ],
                            [
                                "cze",
                                "cs"
                            ],
                            [
                                "dan",
                                "da"
                            ],
                            [
                                "deu",
                                "de"
                            ],
                            [
                                "div",
                                "dv"
                            ],
                            [
                                "dut",
                                "nl"
                            ],
                            [
                                "dzo",
                                "dz"
                            ],
                            [
                                "ell",
                                "el"
                            ],
                            [
                                "eng",
                                "en"
                            ],
                            [
                                "epo",
                                "eo"
                            ],
                            [
                                "est",
                                "et"
                            ],
                            [
                                "eus",
                                "eu"
                            ],
                            [
                                "ewe",
                                "ee"
                            ],
                            [
                                "fao",
                                "fo"
                            ],
                            [
                                "fas",
                                "fa"
                            ],
                            [
                                "fij",
                                "fj"
                            ],
                            [
                                "fin",
                                "fi"
                            ],
                            [
                                "fra",
                                "fr"
                            ],
                            [
                                "fre",
                                "fr"
                            ],
                            [
                                "fry",
                                "fy"
                            ],
                            [
                                "ful",
                                "ff"
                            ],
                            [
                                "geo",
                                "ka"
                            ],
                            [
                                "ger",
                                "de"
                            ],
                            [
                                "gla",
                                "gd"
                            ],
                            [
                                "gle",
                                "ga"
                            ],
                            [
                                "glg",
                                "gl"
                            ],
                            [
                                "glv",
                                "gv"
                            ],
                            [
                                "gre",
                                "el"
                            ],
                            [
                                "grn",
                                "gn"
                            ],
                            [
                                "guj",
                                "gu"
                            ],
                            [
                                "hat",
                                "ht"
                            ],
                            [
                                "hau",
                                "ha"
                            ],
                            [
                                "heb",
                                "he"
                            ],
                            [
                                "her",
                                "hz"
                            ],
                            [
                                "hin",
                                "hi"
                            ],
                            [
                                "hmo",
                                "ho"
                            ],
                            [
                                "hrv",
                                "hr"
                            ],
                            [
                                "hun",
                                "hu"
                            ],
                            [
                                "hye",
                                "hy"
                            ],
                            [
                                "ibo",
                                "ig"
                            ],
                            [
                                "ice",
                                "is"
                            ],
                            [
                                "ido",
                                "io"
                            ],
                            [
                                "iii",
                                "ii"
                            ],
                            [
                                "iku",
                                "iu"
                            ],
                            [
                                "ile",
                                "ie"
                            ],
                            [
                                "ina",
                                "ia"
                            ],
                            [
                                "ind",
                                "id"
                            ],
                            [
                                "ipk",
                                "ik"
                            ],
                            [
                                "isl",
                                "is"
                            ],
                            [
                                "ita",
                                "it"
                            ],
                            [
                                "jav",
                                "jv"
                            ],
                            [
                                "jpn",
                                "ja"
                            ],
                            [
                                "kal",
                                "kl"
                            ],
                            [
                                "kan",
                                "kn"
                            ],
                            [
                                "kas",
                                "ks"
                            ],
                            [
                                "kat",
                                "ka"
                            ],
                            [
                                "kau",
                                "kr"
                            ],
                            [
                                "kaz",
                                "kk"
                            ],
                            [
                                "khm",
                                "km"
                            ],
                            [
                                "kik",
                                "ki"
                            ],
                            [
                                "kin",
                                "rw"
                            ],
                            [
                                "kir",
                                "ky"
                            ],
                            [
                                "kom",
                                "kv"
                            ],
                            [
                                "kon",
                                "kg"
                            ],
                            [
                                "kor",
                                "ko"
                            ],
                            [
                                "kua",
                                "kj"
                            ],
                            [
                                "kur",
                                "ku"
                            ],
                            [
                                "lao",
                                "lo"
                            ],
                            [
                                "lat",
                                "la"
                            ],
                            [
                                "lav",
                                "lv"
                            ],
                            [
                                "lim",
                                "li"
                            ],
                            [
                                "lin",
                                "ln"
                            ],
                            [
                                "lit",
                                "lt"
                            ],
                            [
                                "ltz",
                                "lb"
                            ],
                            [
                                "lub",
                                "lu"
                            ],
                            [
                                "lug",
                                "lg"
                            ],
                            [
                                "mac",
                                "mk"
                            ],
                            [
                                "mah",
                                "mh"
                            ],
                            [
                                "mal",
                                "ml"
                            ],
                            [
                                "mao",
                                "mi"
                            ],
                            [
                                "mar",
                                "mr"
                            ],
                            [
                                "may",
                                "ms"
                            ],
                            [
                                "mkd",
                                "mk"
                            ],
                            [
                                "mlg",
                                "mg"
                            ],
                            [
                                "mlt",
                                "mt"
                            ],
                            [
                                "mon",
                                "mn"
                            ],
                            [
                                "mri",
                                "mi"
                            ],
                            [
                                "msa",
                                "ms"
                            ],
                            [
                                "mya",
                                "my"
                            ],
                            [
                                "nau",
                                "na"
                            ],
                            [
                                "nav",
                                "nv"
                            ],
                            [
                                "nbl",
                                "nr"
                            ],
                            [
                                "nde",
                                "nd"
                            ],
                            [
                                "ndo",
                                "ng"
                            ],
                            [
                                "nep",
                                "ne"
                            ],
                            [
                                "nld",
                                "nl"
                            ],
                            [
                                "nno",
                                "nn"
                            ],
                            [
                                "nob",
                                "nb"
                            ],
                            [
                                "nor",
                                "no"
                            ],
                            [
                                "nya",
                                "ny"
                            ],
                            [
                                "oci",
                                "oc"
                            ],
                            [
                                "oji",
                                "oj"
                            ],
                            [
                                "ori",
                                "or"
                            ],
                            [
                                "orm",
                                "om"
                            ],
                            [
                                "oss",
                                "os"
                            ],
                            [
                                "pan",
                                "pa"
                            ],
                            [
                                "per",
                                "fa"
                            ],
                            [
                                "pli",
                                "pi"
                            ],
                            [
                                "pol",
                                "pl"
                            ],
                            [
                                "por",
                                "pt"
                            ],
                            [
                                "pus",
                                "ps"
                            ],
                            [
                                "que",
                                "qu"
                            ],
                            [
                                "roh",
                                "rm"
                            ],
                            [
                                "ron",
                                "ro"
                            ],
                            [
                                "rum",
                                "ro"
                            ],
                            [
                                "run",
                                "rn"
                            ],
                            [
                                "rus",
                                "ru"
                            ],
                            [
                                "sag",
                                "sg"
                            ],
                            [
                                "san",
                                "sa"
                            ],
                            [
                                "sin",
                                "si"
                            ],
                            [
                                "slk",
                                "sk"
                            ],
                            [
                                "slo",
                                "sk"
                            ],
                            [
                                "slv",
                                "sl"
                            ],
                            [
                                "sme",
                                "se"
                            ],
                            [
                                "smo",
                                "sm"
                            ],
                            [
                                "sna",
                                "sn"
                            ],
                            [
                                "snd",
                                "sd"
                            ],
                            [
                                "som",
                                "so"
                            ],
                            [
                                "sot",
                                "st"
                            ],
                            [
                                "spa",
                                "es"
                            ],
                            [
                                "sqi",
                                "sq"
                            ],
                            [
                                "srd",
                                "sc"
                            ],
                            [
                                "srp",
                                "sr"
                            ],
                            [
                                "ssw",
                                "ss"
                            ],
                            [
                                "sun",
                                "su"
                            ],
                            [
                                "swa",
                                "sw"
                            ],
                            [
                                "swe",
                                "sv"
                            ],
                            [
                                "tah",
                                "ty"
                            ],
                            [
                                "tam",
                                "ta"
                            ],
                            [
                                "tat",
                                "tt"
                            ],
                            [
                                "tel",
                                "te"
                            ],
                            [
                                "tgk",
                                "tg"
                            ],
                            [
                                "tgl",
                                "tl"
                            ],
                            [
                                "tha",
                                "th"
                            ],
                            [
                                "tib",
                                "bo"
                            ],
                            [
                                "tir",
                                "ti"
                            ],
                            [
                                "ton",
                                "to"
                            ],
                            [
                                "tsn",
                                "tn"
                            ],
                            [
                                "tso",
                                "ts"
                            ],
                            [
                                "tuk",
                                "tk"
                            ],
                            [
                                "tur",
                                "tr"
                            ],
                            [
                                "twi",
                                "tw"
                            ],
                            [
                                "uig",
                                "ug"
                            ],
                            [
                                "ukr",
                                "uk"
                            ],
                            [
                                "urd",
                                "ur"
                            ],
                            [
                                "uzb",
                                "uz"
                            ],
                            [
                                "ven",
                                "ve"
                            ],
                            [
                                "vie",
                                "vi"
                            ],
                            [
                                "vol",
                                "vo"
                            ],
                            [
                                "wel",
                                "cy"
                            ],
                            [
                                "wln",
                                "wa"
                            ],
                            [
                                "wol",
                                "wo"
                            ],
                            [
                                "xho",
                                "xh"
                            ],
                            [
                                "yid",
                                "yi"
                            ],
                            [
                                "yor",
                                "yo"
                            ],
                            [
                                "zha",
                                "za"
                            ],
                            [
                                "zho",
                                "zh"
                            ],
                            [
                                "zul",
                                "zu"
                            ]
                        ]);
                        function un() {
                            this.g = {};
                        }
                        function ln(e, t) {
                            for(var n in e.g)t(n, e.g[n]);
                        }
                        function cn(e, t, n, r, i) {
                            var a1 = e.variants;
                            (t.length || n.length) && (a1 = function(e, t, n) {
                                for(var r = {}, i = (t = l(t)).next(); !i.done; r = {
                                    yd: r.yd
                                }, i = t.next())if (r.yd = i.value, i = e.filter(function(e) {
                                    return function(t) {
                                        return t.video && t.video.codecs.startsWith(e.yd);
                                    };
                                }(r)), i.length) {
                                    e = i;
                                    break;
                                }
                                for(r = {}, t = (n = l(n)).next(); !t.done; r = {
                                    kd: r.kd
                                }, t = n.next())if (r.kd = t.value, t = e.filter(function(e) {
                                    return function(t) {
                                        return t.audio && t.audio.codecs.startsWith(e.kd);
                                    };
                                }(r)), t.length) {
                                    e = t;
                                    break;
                                }
                                return e;
                            }(a1, t, n)), t = function(e) {
                                for(var t = new un, n = (e = l(e)).next(); !n.done; n = e.next()){
                                    var r = fn(n = n.value);
                                    t.push(r, n);
                                }
                                return t;
                            }(a1 = kn(a1, r)), t = function(e) {
                                var t = 0, n = new Map, r = e.size();
                                return ln(e, function(e, i) {
                                    for(var a1 = l(i), o = a1.next(); !o.done; o = a1.next()){
                                        var s1 = (o = o.value).video;
                                        if (s1 && s1.width && s1.height) {
                                            s1 = s1.width * s1.height * (s1.frameRate || 1), n.has(s1) || n.set(s1, new un);
                                            var u = n.get(s1);
                                            u.push(e, o), u.size() === r && (t = Math.max(t, s1));
                                        }
                                    }
                                }), t ? n.get(t) : e;
                            }(t);
                            var o = function(e, t) {
                                for(var n = l(t), r = n.next(); !r.done; r = n.next())if ((r = r.value) == Pn || r == Fn) {
                                    if (1 == (e = dn(e, r)).size()) return e.keys()[0];
                                } else if (r == Un) break;
                                return function(e) {
                                    var t = "", n = 1 / 0;
                                    return ln(e, function(e, r) {
                                        for(var i = 0, a1 = 0, o = l(r), s1 = o.next(); !s1.done; s1 = o.next())i += s1.value.bandwidth || 0, ++a1;
                                        (i /= a1) < n && (t = e, n = i);
                                    }), t;
                                }(e);
                            }(t, i);
                            e.variants = e.variants.filter(function(e) {
                                return fn(e) == o;
                            });
                        }
                        function dn(e, t) {
                            var n = 0, r = new un;
                            return ln(e, function(e, i) {
                                for(var a1 = 0, o = 0, s1 = l(i), u = s1.next(); !u.done; u = s1.next())(u = u.value).decodingInfos.length && (a1 += u.decodingInfos[0][t] ? 1 : 0, o++);
                                (a1 /= o) > n ? (r.g = {}, r.push(e, i), n = a1) : a1 == n && r.push(e, i);
                            }), r;
                        }
                        function fn(e) {
                            var t = "";
                            e.video && (t = Ht(e.video.codecs));
                            var n = "";
                            return e.audio && (n = Ht(e.audio.codecs)), t + "-" + n;
                        }
                        function hn(e, t, n) {
                            function r(e, t, n) {
                                return e >= t && e <= n;
                            }
                            var i = e.video;
                            if (0 != e.disabledUntilTime) {
                                if (e.disabledUntilTime > Date.now() / 1e3) return !1;
                                e.disabledUntilTime = 0;
                            }
                            return !(i && i.width && i.height && (!r(i.width, t.minWidth, Math.min(t.maxWidth, n.width)) || !r(i.height, t.minHeight, Math.min(t.maxHeight, n.height)) || !r(i.width * i.height, t.minPixels, t.maxPixels)) || e && e.video && e.video.frameRate && !r(e.video.frameRate, t.minFrameRate, t.maxFrameRate) || !r(e.bandwidth, t.minBandwidth, t.maxBandwidth));
                        }
                        function gn(e, t, n) {
                            for(var r = !1, i = (e = l(e)).next(); !i.done; i = e.next()){
                                var a1 = (i = i.value).allowedByApplication;
                                i.allowedByApplication = hn(i, t, n), a1 != i.allowedByApplication && (r = !0);
                            }
                            return r;
                        }
                        function pn(e, t) {
                            return L(function(n) {
                                if (1 == n.g) return T(n, mn(e.variants, t, !1), 2);
                                e.variants = e.variants.filter(function(e) {
                                    var t = e.video;
                                    if (t) {
                                        var n = En(t.codecs);
                                        if (t.codecs.includes(",")) {
                                            var r = t.codecs.split(",");
                                            if (n = Qe("video", r), r = Qe("audio", r), r = Gt(t.mimeType, r, "audio"), !MediaSource.isTypeSupported(r)) return !1;
                                        }
                                        if (n = Gt(t.mimeType, n, "video"), !MediaSource.isTypeSupported(n)) return !1;
                                    }
                                    return !((n = e.audio) && (r = yn(n.codecs), n = Gt(n.mimeType, r, "audio"), !MediaSource.isTypeSupported(n))) && (st() && t && (t.width && 1920 < t.width || t.height && 1080 < t.height) && (t.codecs.includes("avc1.") || t.codecs.includes("avc3.")) ? (xn(e), !1) : ((t = e.decodingInfos.some(function(e) {
                                        return e.supported;
                                    })) || xn(e), t));
                                }), b(n);
                            });
                        }
                        function mn(e, t, n) {
                            var r, i, a1, o, s1, u, c, d, f, h;
                            return L(function(g) {
                                if (e.some(function(e) {
                                    return e.decodingInfos.length;
                                })) return g.return();
                                for(r = navigator.mediaCapabilities, i = [], a1 = function(e, t) {
                                    var n;
                                    return L(function(i) {
                                        return 1 == i.g ? (A(i, 2), T(i, r.decodingInfo(t), 4)) : 2 != i.g ? (n = i.h, e.decodingInfos.push(n), S(i, 0)) : (w(i), JSON.stringify(t), void b(i));
                                    });
                                }, o = l(e), s1 = o.next(); !s1.done; s1 = o.next())for(u = s1.value, c = vn(u, t, n), d = l(c), f = d.next(); !f.done; f = d.next())h = f.value, i.push(a1(u, h));
                                return T(g, Promise.all(i), 0);
                            });
                        }
                        function vn(e, t, n) {
                            var r = e.audio, i = e.video;
                            if (n = {
                                type: n ? "file" : "media-source"
                            }, i) {
                                var a1 = i.codecs;
                                if (i.codecs.includes(",")) {
                                    var o = i.codecs.split(",");
                                    a1 = En(a1 = Qe("video", o)), o = Qe("audio", o), o = Gt(i.mimeType, o, "audio"), n.audio = {
                                        contentType: o,
                                        channels: 2,
                                        bitrate: e.bandwidth || 1,
                                        samplerate: 1,
                                        spatialRendering: !1
                                    };
                                }
                                if (a1 = En(a1), a1 = Gt(i.mimeType, a1, "video"), n.video = {
                                    contentType: a1,
                                    width: i.width || 64,
                                    height: i.height || 64,
                                    bitrate: i.bandwidth || e.bandwidth || 1,
                                    framerate: i.frameRate || 1
                                }, i.hdr) switch(i.hdr){
                                    case "SDR":
                                        n.video.transferFunction = "srgb";
                                        break;
                                    case "PQ":
                                        n.video.transferFunction = "pq";
                                        break;
                                    case "HLG":
                                        n.video.transferFunction = "hlg";
                                }
                            }
                            if (r && (a1 = yn(r.codecs), a1 = Gt(r.mimeType, a1, "audio"), n.audio = {
                                contentType: a1,
                                channels: r.channelsCount || 2,
                                bitrate: r.bandwidth || e.bandwidth || 1,
                                samplerate: r.audioSamplingRate || 1,
                                spatialRendering: r.spatialAudio
                            }), !(o = (e.video ? e.video.drmInfos : []).concat(e.audio ? e.audio.drmInfos : [])).length) return [
                                n
                            ];
                            e = [], a1 = new Map;
                            for(var s1 = (o = l(o)).next(); !s1.done; s1 = o.next()){
                                var u = s1.value;
                                a1.get(u.keySystem) || a1.set(u.keySystem, []), a1.get(u.keySystem).push(u);
                            }
                            o = t ? "required" : "optional", t = t ? [
                                "persistent-license"
                            ] : [
                                "temporary"
                            ];
                            for(var c = (u = l(a1.keys())).next(); !c.done; c = u.next()){
                                var d = c.value;
                                c = Object.assign({}, n);
                                var f = a1.get(d);
                                for(d = {
                                    keySystem: d,
                                    initDataType: "cenc",
                                    persistentState: o,
                                    distinctiveIdentifier: "optional",
                                    sessionTypes: t
                                }, s1 = (f = l(f)).next(); !s1.done; s1 = f.next()){
                                    if ((s1 = s1.value).initData && s1.initData.length) {
                                        for(var h = new Set, g = l(s1.initData), p = g.next(); !p.done; p = g.next())h.add(p.value.initDataType);
                                        d.initDataType = s1.initData[0].initDataType;
                                    }
                                    s1.distinctiveIdentifierRequired && (d.distinctiveIdentifier = "required"), s1.persistentStateRequired && (d.persistentState = "required"), s1.sessionType && (d.sessionTypes = [
                                        s1.sessionType
                                    ]), r && (d.audio ? d.audio.robustness = d.audio.robustness || s1.audioRobustness : d.audio = {
                                        robustness: s1.audioRobustness
                                    }), i && (d.video ? d.video.robustness = d.video.robustness || s1.videoRobustness : d.video = {
                                        robustness: s1.videoRobustness
                                    });
                                }
                                c.keySystemConfiguration = d, e.push(c);
                            }
                            return e;
                        }
                        function yn(e) {
                            return ut() && "ac-3" == e.toLowerCase() ? "ec-3" : e;
                        }
                        function En(e) {
                            return "vp9" == e ? "vp09.00.41.08" : e;
                        }
                        function Tn(e, t) {
                            t.variants = t.variants.filter(function(t) {
                                var n = t.audio;
                                return t = t.video, !(n && e && e.audio && !bn(n, e.audio) || t && e && e.video && !bn(t, e.video));
                            });
                        }
                        function bn(e, t) {
                            return e.mimeType == t.mimeType && e.codecs.split(".")[0] == t.codecs.split(".")[0];
                        }
                        function An(e) {
                            var t = e.audio, n = e.video, r = t ? t.mimeType : null, i = n ? n.mimeType : null, a1 = t ? t.codecs : null, o = n ? n.codecs : null, s1 = [];
                            o && s1.push(o), a1 && s1.push(a1);
                            var u = [];
                            n && u.push(n.mimeType), t && u.push(t.mimeType), u = u[0] || null;
                            var c = [];
                            t && c.push(t.kind), n && c.push(n.kind), c = c[0] || null;
                            var d = new Set;
                            if (t) for(var f = l(t.roles), h = f.next(); !h.done; h = f.next())d.add(h.value);
                            if (n) for(h = (f = l(n.roles)).next(); !h.done; h = f.next())d.add(h.value);
                            return e = {
                                id: e.id,
                                active: !1,
                                type: "variant",
                                bandwidth: e.bandwidth,
                                language: e.language,
                                label: null,
                                kind: c,
                                width: null,
                                height: null,
                                frameRate: null,
                                pixelAspectRatio: null,
                                hdr: null,
                                mimeType: u,
                                audioMimeType: r,
                                videoMimeType: i,
                                codecs: s1.join(", "),
                                audioCodec: a1,
                                videoCodec: o,
                                primary: e.primary,
                                roles: Array.from(d),
                                audioRoles: null,
                                forced: !1,
                                videoId: null,
                                audioId: null,
                                channelsCount: null,
                                audioSamplingRate: null,
                                spatialAudio: !1,
                                tilesLayout: null,
                                audioBandwidth: null,
                                videoBandwidth: null,
                                originalVideoId: null,
                                originalAudioId: null,
                                originalTextId: null,
                                originalImageId: null
                            }, n && (e.videoId = n.id, e.originalVideoId = n.originalId, e.width = n.width || null, e.height = n.height || null, e.frameRate = n.frameRate || null, e.pixelAspectRatio = n.pixelAspectRatio || null, e.videoBandwidth = n.bandwidth || null), t && (e.audioId = t.id, e.originalAudioId = t.originalId, e.channelsCount = t.channelsCount, e.audioSamplingRate = t.audioSamplingRate, e.audioBandwidth = t.bandwidth || null, e.spatialAudio = t.spatialAudio, e.label = t.label, e.audioRoles = t.roles), e;
                        }
                        function _n(e) {
                            return {
                                id: e.id,
                                active: !1,
                                type: Ze,
                                bandwidth: 0,
                                language: e.language,
                                label: e.label,
                                kind: e.kind || null,
                                width: null,
                                height: null,
                                frameRate: null,
                                pixelAspectRatio: null,
                                hdr: null,
                                mimeType: e.mimeType,
                                audioMimeType: null,
                                videoMimeType: null,
                                codecs: e.codecs || null,
                                audioCodec: null,
                                videoCodec: null,
                                primary: e.primary,
                                roles: e.roles,
                                audioRoles: null,
                                forced: e.forced,
                                videoId: null,
                                audioId: null,
                                channelsCount: null,
                                audioSamplingRate: null,
                                spatialAudio: !1,
                                tilesLayout: null,
                                audioBandwidth: null,
                                videoBandwidth: null,
                                originalVideoId: null,
                                originalAudioId: null,
                                originalTextId: e.originalId,
                                originalImageId: null
                            };
                        }
                        function Sn(e) {
                            var t = e.width || null, n = e.height || null, r = null;
                            e.segmentIndex && (r = e.segmentIndex.get(0));
                            var i = e.tilesLayout;
                            return r && (i = r.tilesLayout || i), i && null != t && (t /= Number(i.split("x")[0])), i && null != n && (n /= Number(i.split("x")[1])), {
                                id: e.id,
                                active: !1,
                                type: "image",
                                bandwidth: e.bandwidth || 0,
                                language: "",
                                label: null,
                                kind: null,
                                width: t,
                                height: n,
                                frameRate: null,
                                pixelAspectRatio: null,
                                hdr: null,
                                mimeType: e.mimeType,
                                audioMimeType: null,
                                videoMimeType: null,
                                codecs: null,
                                audioCodec: null,
                                videoCodec: null,
                                primary: !1,
                                roles: [],
                                audioRoles: null,
                                forced: !1,
                                videoId: null,
                                audioId: null,
                                channelsCount: null,
                                audioSamplingRate: null,
                                spatialAudio: !1,
                                tilesLayout: i || null,
                                audioBandwidth: null,
                                videoBandwidth: null,
                                originalVideoId: null,
                                originalAudioId: null,
                                originalTextId: null,
                                originalImageId: e.originalId
                            };
                        }
                        function wn(e) {
                            return e.__shaka_id || (e.__shaka_id = On++), e.__shaka_id;
                        }
                        function In(e) {
                            var t = Cn(e);
                            return t.active = "disabled" != e.mode, t.type = "text", t.originalTextId = e.id, "captions" == e.kind && (t.mimeType = "application/cea-608"), e.kind && (t.roles = [
                                e.kind
                            ]), "forced" == e.kind && (t.forced = !0), t;
                        }
                        function Rn(e) {
                            var t = Cn(e);
                            return t.active = e.enabled, t.type = "variant", t.originalAudioId = e.id, "main" == e.kind && (t.primary = !0), e.kind && (t.roles = [
                                e.kind
                            ], t.audioRoles = [
                                e.kind
                            ], t.label = e.label), t;
                        }
                        function Cn(e) {
                            return {
                                id: wn(e),
                                active: !1,
                                type: "",
                                bandwidth: 0,
                                language: tn(e.language),
                                label: e.label,
                                kind: e.kind,
                                width: null,
                                height: null,
                                frameRate: null,
                                pixelAspectRatio: null,
                                hdr: null,
                                mimeType: null,
                                audioMimeType: null,
                                videoMimeType: null,
                                codecs: null,
                                audioCodec: null,
                                videoCodec: null,
                                primary: !1,
                                roles: [],
                                forced: !1,
                                audioRoles: null,
                                videoId: null,
                                audioId: null,
                                channelsCount: null,
                                audioSamplingRate: null,
                                spatialAudio: !1,
                                tilesLayout: null,
                                audioBandwidth: null,
                                videoBandwidth: null,
                                originalVideoId: null,
                                originalAudioId: null,
                                originalTextId: null,
                                originalImageId: null
                            };
                        }
                        function Dn(e) {
                            return e.allowedByApplication && e.allowedByKeySystem;
                        }
                        function kn(e, t) {
                            for(var n = e.filter(function(e) {
                                return e.audio && e.audio.channelsCount;
                            }), r = new Map, i = (n = l(n)).next(); !i.done; i = n.next()){
                                var a1 = (i = i.value).audio.channelsCount;
                                r.has(a1) || r.set(a1, []), r.get(a1).push(i);
                            }
                            return 0 == (n = Array.from(r.keys())).length ? e : (i = n.filter(function(e) {
                                return e <= t;
                            })).length ? r.get(Math.max.apply(Math, c(i))) : r.get(Math.min.apply(Math, c(n)));
                        }
                        function Nn(e, t, n, r) {
                            var i = e, a1 = e.filter(function(e) {
                                return e.primary;
                            });
                            a1.length && (i = a1);
                            var o = i.length ? i[0].language : "";
                            if (i = i.filter(function(e) {
                                return e.language == o;
                            }), t) {
                                var s1 = on(tn(t), e.map(function(e) {
                                    return e.language;
                                }));
                                s1 && (i = e.filter(function(e) {
                                    return tn(e.language) == s1;
                                }));
                            }
                            if (i = i.filter(function(e) {
                                return e.forced == r;
                            }), n) {
                                if ((e = Ln(i, n)).length) return e;
                            } else if (e = i.filter(function(e) {
                                return 0 == e.roles.length;
                            }), e.length) return e;
                            return e = i.map(function(e) {
                                return e.roles;
                            }).reduce(qe, []), e.length ? Ln(i, e[0]) : i;
                        }
                        function Ln(e, t) {
                            return e.filter(function(e) {
                                return e.roles.includes(t);
                            });
                        }
                        function xn(e) {
                            var t = [];
                            return e.audio && t.push(Mn(e.audio)), e.video && t.push(Mn(e.video)), t.join(", ");
                        }
                        function Mn(e) {
                            return "audio" == e.type ? "type=audio codecs=" + e.codecs + " bandwidth=" + e.bandwidth + " channelsCount=" + e.channelsCount + " audioSamplingRate=" + e.audioSamplingRate : "video" == e.type ? "type=video codecs=" + e.codecs + " bandwidth=" + e.bandwidth + " frameRate=" + e.frameRate + " width=" + e.width + " height=" + e.height : "unexpected stream type";
                        }
                        (r = un.prototype).push = function(e, t) {
                            this.g.hasOwnProperty(e) ? this.g[e].push(t) : this.g[e] = [
                                t
                            ];
                        }, r.get = function(e) {
                            return (e = this.g[e]) ? e.slice() : null;
                        }, r.remove = function(e, t) {
                            e in this.g && (this.g[e] = this.g[e].filter(function(e) {
                                return e != t;
                            }), 0 == this.g[e].length && delete this.g[e]);
                        }, r.size = function() {
                            return Object.keys(this.g).length;
                        }, r.keys = function() {
                            return Object.keys(this.g);
                        };
                        var On = 0, Pn = "smooth", Fn = "powerEfficient", Un = "bandwidth", jn = (new Map).set("image/svg+xml", !0).set("image/png", !0).set("image/jpeg", !0).set("image/jpg", !0), Bn = (new Map).set("image/webp", "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA").set("image/avif", "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=");
                        function Gn() {
                            var e = this;
                            this.l = null, this.o = !1, this.i = new V, navigator.connection && navigator.connection.addEventListener("change", function() {
                                if (e.g.useNetworkInformation && e.o) {
                                    e.i = new V, e.g && e.i.configure(e.g.advanced);
                                    var t = e.chooseVariant();
                                    t && e.l(t);
                                }
                            }), this.m = [], this.u = 1, this.B = !1, this.h = this.j = this.g = this.s = null, this.D = new it(function() {
                                if (e.g.restrictToElementSize) {
                                    var t = e.chooseVariant();
                                    t && e.l(t);
                                }
                            });
                        }
                        function Hn(e) {
                            var t = e.g.defaultBandwidthEstimate;
                            return navigator.connection && navigator.connection.downlink && e.g.useNetworkInformation && (t = 1e6 * navigator.connection.downlink), t;
                        }
                        function Vn(e, t, n, r) {
                            return e && (t = t.filter(function(t) {
                                return hn(t, e, {
                                    width: r,
                                    height: n
                                });
                            })), t.sort(function(e, t) {
                                return e.bandwidth - t.bandwidth;
                            });
                        }
                        (r = Gn.prototype).stop = function() {
                            this.l = null, this.o = !1, this.m = [], this.u = 1, this.j = this.s = null, this.h && (this.h.disconnect(), this.h = null), this.D.stop();
                        }, r.init = function(e) {
                            this.l = e;
                        }, r.chooseVariant = function() {
                            var t = 1 / 0, n = 1 / 0;
                            this.g.restrictToScreenSize && (n = this.g.ignoreDevicePixelRatio ? 1 : e.devicePixelRatio, t = e.screen.height * n, n *= e.screen.width), this.h && this.g.restrictToElementSize && (n = this.g.ignoreDevicePixelRatio ? 1 : e.devicePixelRatio, t = this.j.clientWidth * n, n *= this.j.clientHeight), t = Vn(this.g.restrictions, this.m, t, n), n = this.i.getBandwidthEstimate(Hn(this)), this.m.length && !t.length && (t = [
                                (t = Vn(null, this.m, 1 / 0, 1 / 0))[0]
                            ]);
                            for(var r = t[0] || null, i = 0; i < t.length; i++){
                                for(var a1 = t[i], o = isNaN(this.u) ? 1 : Math.abs(this.u), s1 = o * a1.bandwidth / this.g.bandwidthDowngradeTarget, u = {
                                    bandwidth: 1 / 0
                                }, l = i + 1; l < t.length; l++)if (a1.bandwidth != t[l].bandwidth) {
                                    u = t[l];
                                    break;
                                }
                                o = o * u.bandwidth / this.g.bandwidthUpgradeTarget, n >= s1 && n <= o && r.bandwidth != a1.bandwidth && (r = a1);
                            }
                            return this.s = Date.now(), r;
                        }, r.enable = function() {
                            this.o = !0;
                        }, r.disable = function() {
                            this.o = !1;
                        }, r.segmentDownloaded = function(e, t) {
                            if (this.i.sample(e, t), null != this.s && this.o) e: {
                                if (this.B) {
                                    if (Date.now() - this.s < 1e3 * this.g.switchInterval) break e;
                                } else {
                                    var n = this.i;
                                    if (!(n.g >= n.i)) break e;
                                    this.B = !0;
                                }
                                n = this.chooseVariant(), this.i.getBandwidthEstimate(Hn(this)), n && this.l(n);
                            }
                        }, r.getBandwidthEstimate = function() {
                            return this.i.getBandwidthEstimate(Hn(this));
                        }, r.setVariants = function(e) {
                            this.m = e;
                        }, r.playbackRateChanged = function(e) {
                            this.u = e;
                        }, r.setMediaElement = function(t) {
                            var n = this;
                            this.j = t, this.h && (this.h.disconnect(), this.h = null), this.j && "ResizeObserver" in e && (this.h = new ResizeObserver(function() {
                                n.D.O(Kn);
                            }), this.h.observe(this.j));
                        }, r.configure = function(e) {
                            this.g = e, this.i && this.g && this.i.configure(this.g.advanced);
                        }, B("shaka.abr.SimpleAbrManager", Gn), Gn.prototype.configure = Gn.prototype.configure, Gn.prototype.setMediaElement = Gn.prototype.setMediaElement, Gn.prototype.playbackRateChanged = Gn.prototype.playbackRateChanged, Gn.prototype.setVariants = Gn.prototype.setVariants, Gn.prototype.getBandwidthEstimate = Gn.prototype.getBandwidthEstimate, Gn.prototype.segmentDownloaded = Gn.prototype.segmentDownloaded, Gn.prototype.disable = Gn.prototype.disable, Gn.prototype.enable = Gn.prototype.enable, Gn.prototype.chooseVariant = Gn.prototype.chooseVariant, Gn.prototype.init = Gn.prototype.init, Gn.prototype.stop = Gn.prototype.stop;
                        var Kn = 1;
                        function qn(e, t) {
                            this.g = e, this.h = t;
                        }
                        function Yn(e, t) {
                            var n = new qn(5, 0), r = Xn, i = r.g, a1 = n.h - i.h;
                            (0 < (n.g - i.g || a1) ? r.i : r.h)(r.g, n, e, t);
                        }
                        function Wn(e, t, n, r) {
                            Y([
                                n,
                                "has been deprecated and will be removed in",
                                t,
                                ". We are currently at version",
                                e,
                                ". Additional information:",
                                r
                            ].join(" "));
                        }
                        function zn(e, t, n, r) {
                            q([
                                n,
                                "has been deprecated and has been removed in",
                                t,
                                ". We are now at version",
                                e,
                                ". Additional information:",
                                r
                            ].join(""));
                        }
                        qn.prototype.toString = function() {
                            return "v" + this.g + "." + this.h;
                        };
                        var Xn = null;
                        function Qn(e, t) {
                            this.h = e, this.g = new Set([
                                e
                            ]);
                            for(var n = l(t = t || []), r = n.next(); !r.done; r = n.next())this.add(r.value);
                        }
                        function Jn(e, t) {
                            var n;
                            if (!(n = !!e.audio != !!t.audio || !!e.video != !!t.video || e.language != t.language) && (n = e.audio && t.audio)) {
                                n = e.audio;
                                var r = t.audio;
                                n = !((!(!n.channelsCount || !r.channelsCount || 2 < n.channelsCount || 2 < r.channelsCount) || n.channelsCount == r.channelsCount) && Zn(n, r) && $n(n.roles, r.roles));
                            }
                            return !n && (n = e.video && t.video) && (n = !(Zn(n = e.video, r = t.video) && $n(n.roles, r.roles))), !n;
                        }
                        function Zn(e, t) {
                            if (e.mimeType != t.mimeType) return !1;
                            var n = e.codecs.split(",").map(function(e) {
                                return Kt(e)[0];
                            }), r = t.codecs.split(",").map(function(e) {
                                return Kt(e)[0];
                            });
                            if (n.length != r.length) return !1;
                            n.sort(), r.sort();
                            for(var i = 0; i < n.length; i++)if (n[i] != r[i]) return !1;
                            return !0;
                        }
                        function $n(e, t) {
                            var n = new Set(e), r = new Set(t);
                            if (n.delete("main"), r.delete("main"), n.size != r.size) return !1;
                            for(var i = (n = l(n)).next(); !i.done; i = n.next())if (!r.has(i.value)) return !1;
                            return !0;
                        }
                        function er(e) {
                            this.g = e, this.h = new tr(e.language, "", e.audio && e.audio.channelsCount ? e.audio.channelsCount : 0, "");
                        }
                        function tr(e, t, n, r) {
                            this.i = e, this.j = t, this.g = n, this.h = void 0 === r ? "" : r;
                        }
                        function nr() {
                            this.g = ar, this.h = (new Map).set(ar, 2).set(ir, 1);
                        }
                        function rr(e, t, n) {
                            e.h.set(ar, n).set(ir, t);
                        }
                        B("shaka.config.AutoShowText", {
                            NEVER: 0,
                            ALWAYS: 1,
                            IF_PREFERRED_TEXT_LANGUAGE: 2,
                            IF_SUBTITLES_MAY_BE_NEEDED: 3
                        }), Qn.prototype.add = function(e) {
                            return !!Jn(this.h, e) && (this.g.add(e), !0);
                        }, Qn.prototype.values = function() {
                            return this.g.values();
                        }, er.prototype.create = function(e) {
                            var t = this, n = e.filter(function(e) {
                                return Jn(t.g, e);
                            });
                            return n.length ? new Qn(n[0], n) : this.h.create(e);
                        }, tr.prototype.create = function(e) {
                            var t = [];
                            t = function(e, t) {
                                var n = on(tn(t), e.map(function(e) {
                                    return an(e);
                                }));
                                return n ? e.filter(function(e) {
                                    return n == an(e);
                                }) : [];
                            }(e, this.i);
                            var n = e.filter(function(e) {
                                return e.primary;
                            });
                            for(e = function(e, t) {
                                return e.filter(function(e) {
                                    return !!e.audio && (t ? e.audio.roles.includes(t) : 0 == e.audio.roles.length);
                                });
                            }(t = t.length ? t : n.length ? n : e, this.j), e.length && (t = e), this.g && (e = kn(t, this.g)).length && (t = e), this.h && (e = function(e, t) {
                                return e.filter(function(e) {
                                    return !!e.audio && e.audio.label.toLowerCase() == t.toLowerCase();
                                });
                            }(t, this.h), e.length && (t = e)), e = new Qn(t[0]), n = (t = l(t)).next(); !n.done; n = t.next())n = n.value, Jn(e.h, n) && e.add(n);
                            return e;
                        };
                        var ir = 0, ar = 1;
                        function or(e, t) {
                            var n = 2, r = 1e3, i = 2, a1 = .5;
                            this.l = null == e.maxAttempts ? n : e.maxAttempts, this.j = null == e.baseDelay ? r : e.baseDelay, this.o = null == e.fuzzFactor ? a1 : e.fuzzFactor, this.m = null == e.backoffFactor ? i : e.backoffFactor, this.g = 0, this.h = this.j, (this.i = void 0 !== t && t) && (this.g = 1);
                        }
                        function sr(e) {
                            var t, n;
                            return L(function(r) {
                                if (1 == r.g) {
                                    if (e.g >= e.l) {
                                        if (!e.i) throw new De(2, 7, 1010);
                                        e.g = 1, e.h = e.j;
                                    }
                                    return t = e.g, e.g++, 0 == t ? r.return() : (n = e.h * (1 + (2 * Math.random() - 1) * e.o), T(r, new Promise(function(e) {
                                        new it(e).O(n / 1e3);
                                    }), 2));
                                }
                                e.h *= e.m, b(r);
                            });
                        }
                        function ur(e, t) {
                            this.promise = e, this.i = t, this.g = !1;
                        }
                        function lr(e) {
                            return new ur(Promise.reject(e), function() {
                                return Promise.resolve();
                            });
                        }
                        function cr() {
                            var e = Promise.reject(new De(2, 7, 7001));
                            return e.catch(function() {}), new ur(e, function() {
                                return Promise.resolve();
                            });
                        }
                        function dr(e) {
                            return new ur(Promise.resolve(e), function() {
                                return Promise.resolve();
                            });
                        }
                        function fr(e) {
                            return new ur(e, function() {
                                return e.catch(function() {});
                            });
                        }
                        function hr(e) {
                            return new ur(Promise.all(e.map(function(e) {
                                return e.promise;
                            })), function() {
                                return Promise.all(e.map(function(e) {
                                    return e.abort();
                                }));
                            });
                        }
                        function gr(t, n) {
                            if (n) {
                                if (n instanceof Map) for(var r = l(n.keys()), i = r.next(); !i.done; i = r.next())i = i.value, Object.defineProperty(this, i, {
                                    value: n.get(i),
                                    writable: !0,
                                    enumerable: !0
                                });
                                else for(r in n)Object.defineProperty(this, r, {
                                    value: n[r],
                                    writable: !0,
                                    enumerable: !0
                                });
                            }
                            this.defaultPrevented = this.cancelable = this.bubbles = !1, this.timeStamp = e.performance && e.performance.now ? e.performance.now() : Date.now(), this.type = t, this.isTrusted = !1, this.target = this.currentTarget = null, this.g = !1;
                        }
                        function pr(e) {
                            var t, n = new gr(e.type);
                            for(t in e)Object.defineProperty(n, t, {
                                value: e[t],
                                writable: !0,
                                enumerable: !0
                            });
                            return n;
                        }
                        ur.prototype.abort = function() {
                            return this.g = !0, this.i();
                        }, ur.prototype.finally = function(e) {
                            return this.promise.then(function() {
                                return e(!0);
                            }, function() {
                                return e(!1);
                            }), this;
                        }, ur.prototype.Y = function(e, t) {
                            function n(n) {
                                return function(s1) {
                                    if (i.g && n) a1.reject(o);
                                    else {
                                        var u = n ? e : t;
                                        u ? r = function(e, t, n) {
                                            try {
                                                var r = e(t);
                                                return r && r.promise && r.abort ? (n.resolve(r.promise), function() {
                                                    return r.abort();
                                                }) : (n.resolve(r), function() {
                                                    return Promise.resolve(r).then(function() {}, function() {});
                                                });
                                            } catch (e) {
                                                return n.reject(e), function() {
                                                    return Promise.resolve();
                                                };
                                            }
                                        }(u, s1, a1) : (n ? a1.resolve : a1.reject)(s1);
                                    }
                                };
                            }
                            function r() {
                                return a1.reject(o), i.abort();
                            }
                            var i = this, a1 = new tt, o = new De(2, 7, 7001);
                            return this.promise.then(n(!0), n(!1)), new ur(a1, function() {
                                return r();
                            });
                        }, B("shaka.util.AbortableOperation", ur), ur.prototype.chain = ur.prototype.Y, ur.prototype.finally = ur.prototype.finally, ur.all = hr, ur.prototype.abort = ur.prototype.abort, ur.notAbortable = fr, ur.completed = dr, ur.aborted = cr, ur.failed = lr, gr.prototype.preventDefault = function() {
                            this.cancelable && (this.defaultPrevented = !0);
                        }, gr.prototype.stopImmediatePropagation = function() {
                            this.g = !0;
                        }, gr.prototype.stopPropagation = function() {}, B("shaka.util.FakeEvent", gr);
                        var mr = {
                            Hg: "abrstatuschanged",
                            Ig: "adaptation",
                            Jg: "buffering",
                            Lg: "downloadfailed",
                            Mg: "downloadheadersreceived",
                            Ng: "drmsessionupdate",
                            Pg: "emsg",
                            bh: "prft",
                            Error: "error",
                            Qg: "expirationupdated",
                            Rg: "gapjumped",
                            Ug: "loaded",
                            Vg: "loading",
                            Xg: "manifestparsed",
                            Yg: "mediaqualitychanged",
                            Metadata: "metadata",
                            $g: "onstatechange",
                            ah: "onstateidle",
                            dh: "ratechange",
                            fh: "segmentappended",
                            gh: "sessiondata",
                            hh: "stalldetected",
                            ih: "streaming",
                            jh: "textchanged",
                            kh: "texttrackvisibility",
                            lh: "timelineregionadded",
                            mh: "timelineregionenter",
                            nh: "timelineregionexit",
                            oh: "trackschanged",
                            qh: "unloading",
                            rh: "variantchanged"
                        };
                        function vr() {
                            this.da = new un, this.Vc = this;
                        }
                        function yr(e) {
                            var t = new Set;
                            return function e(n) {
                                switch(typeof n){
                                    case "undefined":
                                    case "boolean":
                                    case "number":
                                    case "string":
                                    case "symbol":
                                    case "function":
                                        return n;
                                    default:
                                        if (!n || n.buffer && n.buffer.constructor == ArrayBuffer) return n;
                                        if (t.has(n)) return null;
                                        var r = n.constructor == Array;
                                        if (n.constructor != Object && !r) return null;
                                        t.add(n);
                                        var i, a1 = r ? [] : {};
                                        for(i in n)a1[i] = e(n[i]);
                                        return r && (a1.length = n.length), a1;
                                }
                            }(e);
                        }
                        function Er(e) {
                            var t, n = {};
                            for(t in e)n[t] = e[t];
                            return n;
                        }
                        function Tr() {
                            this.g = [];
                        }
                        function br(e, t) {
                            e.g.push(t.finally(function() {
                                $(e.g, t);
                            }));
                        }
                        function Ar(e, t, n) {
                            vr.call(this), this.i = !1, this.m = new Tr, this.g = new Set, this.h = new Set, this.l = e || null, this.j = t || null, this.s = n || null, this.o = !1;
                        }
                        function _r(e, t, n, r) {
                            n = n || Dr;
                            var i = kr[e];
                            (!i || n >= i.priority) && (kr[e] = {
                                priority: n,
                                ig: t,
                                jg: void 0 !== r && r
                            });
                        }
                        function Sr(e, t, n) {
                            return {
                                uris: e,
                                method: "GET",
                                body: null,
                                headers: {},
                                allowCrossSiteCredentials: !1,
                                retryParameters: t,
                                licenseRequestType: null,
                                sessionId: null,
                                drmInfo: null,
                                initData: null,
                                initDataType: null,
                                streamDataCallback: void 0 === n ? null : n
                            };
                        }
                        function wr(e, t, n, r, i, a1, o) {
                            e.o && (n.uris[i] = n.uris[i].replace("http://", "https://"));
                            var s1 = new Ne(n.uris[i]), u = s1.Da, l = !1;
                            u || (Le(s1, u = (u = location.protocol).slice(0, -1)), n.uris[i] = s1.toString()), u = u.toLowerCase();
                            var c = (u = kr[u]) ? u.ig : null;
                            if (!c) return lr(new De(2, 1, 1e3, s1));
                            var d, f = u.jg, h = null, g = null, p = !1, m = !1;
                            return fr(sr(r)).Y(function() {
                                if (e.i) return cr();
                                d = Date.now();
                                var r = c(n.uris[i], n, t, function(n, r, i) {
                                    h && h.stop(), g && g.O(s1 / 1e3), e.l && t == Cr && (e.l(n, r), l = !0, o.g = i);
                                }, function(r) {
                                    e.j && e.j(r, n, t), m = !0;
                                });
                                if (!f) return r;
                                var a1 = n.retryParameters.connectionTimeout;
                                a1 && (h = new it(function() {
                                    p = !0, r.abort();
                                })).O(a1 / 1e3);
                                var s1 = n.retryParameters.stallTimeout;
                                return s1 && (g = new it(function() {
                                    p = !0, r.abort();
                                })), r;
                            }).Y(function(r) {
                                h && h.stop(), g && g.stop(), null == r.timeMs && (r.timeMs = Date.now() - d);
                                var i = {
                                    response: r,
                                    Xf: l
                                };
                                return !m && e.j && e.j(r.headers, n, t), i;
                            }, function(s1) {
                                if (h && h.stop(), g && g.stop(), e.s) {
                                    var u = null, l = 0;
                                    s1 instanceof De && (u = s1, 1001 == s1.code && (l = s1.data[1])), e.s(n, u, l, p);
                                }
                                if (e.i) return cr();
                                if (p && (s1 = new De(1, 1, 1003, n.uris[i], t)), s1 instanceof De) {
                                    if (7001 == s1.code) throw s1;
                                    if (1010 == s1.code) throw a1;
                                    if (1 == s1.severity) return u = new gr("retry", u = (new Map).set("error", s1)), e.dispatchEvent(u), i = (i + 1) % n.uris.length, wr(e, t, n, r, i, s1, o);
                                }
                                throw s1;
                            });
                        }
                        function Ir() {
                            this.g = 0;
                        }
                        function Rr(e, t, n) {
                            ur.call(this, e, t), this.h = n;
                        }
                        vr.prototype.addEventListener = function(e, t) {
                            this.da && this.da.push(e, t);
                        }, vr.prototype.removeEventListener = function(e, t) {
                            this.da && this.da.remove(e, t);
                        }, vr.prototype.dispatchEvent = function(e) {
                            if (!this.da) return !0;
                            var t = this.da.get(e.type) || [], n = this.da.get("All");
                            for(n && (t = t.concat(n)), n = (t = l(t)).next(); !n.done; n = t.next()){
                                n = n.value, e.target = this.Vc, e.currentTarget = this.Vc;
                                try {
                                    n.handleEvent ? n.handleEvent(e) : n.call(this, e);
                                } catch (e) {}
                                if (e.g) break;
                            }
                            return e.defaultPrevented;
                        }, vr.prototype.release = function() {
                            this.da = null;
                        }, Tr.prototype.destroy = function() {
                            for(var e = [], t = l(this.g), n = t.next(); !n.done; n = t.next())(n = n.value).promise.catch(function() {}), e.push(n.abort());
                            return this.g = [], Promise.all(e);
                        }, m(Ar, vr), (r = Ar.prototype).ie = function(e) {
                            this.o = e;
                        }, r.kg = function(e) {
                            this.g.add(e);
                        }, r.Ag = function(e) {
                            this.g.delete(e);
                        }, r.qf = function() {
                            this.g.clear();
                        }, r.lg = function(e) {
                            this.h.add(e);
                        }, r.Bg = function(e) {
                            this.h.delete(e);
                        }, r.rf = function() {
                            this.h.clear();
                        }, r.destroy = function() {
                            return this.i = !0, this.g.clear(), this.h.clear(), vr.prototype.release.call(this), this.m.destroy();
                        }, r.request = function(e, t) {
                            var n = this, r = new Ir;
                            if (this.i) {
                                var i = Promise.reject(new De(2, 7, 7001));
                                return i.catch(function() {}), new Rr(i, function() {
                                    return Promise.resolve();
                                }, r);
                            }
                            t.method = t.method || "GET", t.headers = t.headers || {}, t.retryParameters = t.retryParameters ? yr(t.retryParameters) : {
                                maxAttempts: 2,
                                baseDelay: 1e3,
                                backoffFactor: 2,
                                fuzzFactor: .5,
                                timeout: 3e4,
                                stallTimeout: 5e3,
                                connectionTimeout: 1e4
                            }, t.uris = yr(t.uris), i = function(e, t, n) {
                                for(var r = dr(void 0), i = {}, a1 = (e = l(e.g)).next(); !a1.done; i = {
                                    td: i.td
                                }, a1 = e.next())i.td = a1.value, r = r.Y(function(e) {
                                    return function() {
                                        return n.body && (n.body = we(n.body)), e.td(t, n);
                                    };
                                }(i));
                                return r.Y(void 0, function(e) {
                                    if (e instanceof De && 7001 == e.code) throw e;
                                    throw new De(2, 1, 1006, e);
                                });
                            }(this, e, t);
                            var a1 = i.Y(function() {
                                return wr(n, e, t, new or(t.retryParameters, !1), 0, null, r);
                            }), o = a1.Y(function(t) {
                                return function(e, t, n) {
                                    for(var r = dr(void 0), i = {}, a1 = (e = l(e.h)).next(); !a1.done; i = {
                                        ud: i.ud
                                    }, a1 = e.next())i.ud = a1.value, r = r.Y(function(e) {
                                        return function() {
                                            var r = n.response;
                                            return r.data && (r.data = we(r.data)), e.ud(t, r);
                                        };
                                    }(i));
                                    return r.Y(function() {
                                        return n;
                                    }, function(e) {
                                        var t = 2;
                                        if (e instanceof De) {
                                            if (7001 == e.code) throw e;
                                            t = e.severity;
                                        }
                                        throw new De(t, 1, 1007, e);
                                    });
                                }(n, e, t);
                            }), s1 = Date.now(), u = 0;
                            i.promise.then(function() {
                                u = Date.now() - s1;
                            }, function() {});
                            var c = 0;
                            a1.promise.then(function() {
                                c = Date.now();
                            }, function() {});
                            var d = o.Y(function(t) {
                                var r = Date.now() - c, i = t.response;
                                return i.timeMs += u, i.timeMs += r, t.Xf || !n.l || i.fromCache || e != Cr || n.l(i.timeMs, i.data.byteLength), i;
                            }, function(e) {
                                throw e && (e.severity = 2), e;
                            });
                            return i = new Rr(d.promise, function() {
                                return d.abort();
                            }, r), br(this.m, i), i;
                        }, B("shaka.net.NetworkingEngine", Ar), Ar.prototype.request = Ar.prototype.request, Ar.prototype.destroy = Ar.prototype.destroy, Ar.makeRequest = Sr, Ar.defaultRetryParameters = function() {
                            return {
                                maxAttempts: 2,
                                baseDelay: 1e3,
                                backoffFactor: 2,
                                fuzzFactor: .5,
                                timeout: 3e4,
                                stallTimeout: 5e3,
                                connectionTimeout: 1e4
                            };
                        }, Ar.prototype.clearAllResponseFilters = Ar.prototype.rf, Ar.prototype.unregisterResponseFilter = Ar.prototype.Bg, Ar.prototype.registerResponseFilter = Ar.prototype.lg, Ar.prototype.clearAllRequestFilters = Ar.prototype.qf, Ar.prototype.unregisterRequestFilter = Ar.prototype.Ag, Ar.prototype.registerRequestFilter = Ar.prototype.kg, Ar.unregisterScheme = function(e) {
                            delete kr[e];
                        }, Ar.registerScheme = _r, Ar.prototype.setForceHTTPS = Ar.prototype.ie, Ar.NumBytesRemainingClass = Ir, m(Rr, ur), Ar.PendingRequest = Rr;
                        var Cr = 1;
                        Ar.RequestType = {
                            MANIFEST: 0,
                            SEGMENT: Cr,
                            LICENSE: 2,
                            APP: 3,
                            TIMING: 4,
                            SERVER_CERTIFICATE: 5,
                            KEY: 6
                        };
                        var Dr = 3;
                        Ar.PluginPriority = {
                            FALLBACK: 1,
                            PREFERRED: 2,
                            APPLICATION: Dr
                        };
                        var kr = {};
                        function Nr(e) {
                            this.g = !1, this.h = new tt, this.i = e;
                        }
                        function Lr(e, t) {
                            if (e.g) {
                                if (t instanceof De && 7003 == t.code) throw t;
                                throw new De(2, 7, 7003, t);
                            }
                        }
                        function xr() {
                            this.g = new un;
                        }
                        function Mr(e, t, n, r) {
                            this.target = e, this.type = t, this.listener = n, this.g = function(e, t) {
                                if (null == t) return !1;
                                if ("boolean" == typeof t) return t;
                                var n = new Set([
                                    "passive",
                                    "capture"
                                ]);
                                return Object.keys(t).filter(function(e) {
                                    return !n.has(e);
                                }), function(e) {
                                    var t = Or;
                                    if (null == t) {
                                        t = !1;
                                        try {
                                            var n = {}, r = {
                                                get: function() {
                                                    return t = !0, !1;
                                                }
                                            };
                                            Object.defineProperty(n, "passive", r), Object.defineProperty(n, "capture", r), r = function() {}, e.addEventListener("test", r, n), e.removeEventListener("test", r, n);
                                        } catch (e) {
                                            t = !1;
                                        }
                                        Or = t;
                                    }
                                    return t || !1;
                                }(e) ? t : t.capture || !1;
                            }(e, r), this.target.addEventListener(t, n, this.g);
                        }
                        Nr.prototype.destroy = function() {
                            var e = this;
                            return this.g ? this.h : (this.g = !0, this.i().then(function() {
                                e.h.resolve();
                            }, function() {
                                e.h.resolve();
                            }));
                        }, (r = xr.prototype).release = function() {
                            this.nb(), this.g = null;
                        }, r.C = function(e, t, n, r) {
                            this.g && (e = new Mr(e, t, n, r), this.g.push(t, e));
                        }, r.na = function(e, t, n, r) {
                            var i = this;
                            this.C(e, t, function r(a1) {
                                i.yc(e, t, r), n(a1);
                            }, r);
                        }, r.yc = function(e, t, n) {
                            if (this.g) for(var r = this.g.get(t) || [], i = (r = l(r)).next(); !i.done; i = r.next())(i = i.value).target != e || n != i.listener && n || (i.yc(), this.g.remove(t, i));
                        }, r.nb = function() {
                            if (this.g) {
                                var e, t = this.g, n = [];
                                for(e in t.g)n.push.apply(n, c(t.g[e]));
                                for(n = (t = l(n)).next(); !n.done; n = t.next())n.value.yc();
                                this.g.g = {};
                            }
                        }, B("shaka.util.EventManager", xr), xr.prototype.removeAll = xr.prototype.nb, xr.prototype.unlisten = xr.prototype.yc, xr.prototype.listenOnce = xr.prototype.na, xr.prototype.listen = xr.prototype.C, xr.prototype.release = xr.prototype.release, Mr.prototype.yc = function() {
                            this.target.removeEventListener(this.type, this.listener, this.g), this.listener = this.target = null, this.g = !1;
                        };
                        var Or = void 0;
                        function Pr(e, t) {
                            for(var n = [], r = l(e), i = r.next(); !i.done; i = r.next())n.push(t(i.value));
                            return n;
                        }
                        function Fr(e) {
                            for(var t = new Map, n = l(Object.keys(e)), r = n.next(); !r.done; r = n.next())r = r.value, t.set(r, e[r]);
                            return t;
                        }
                        function Ur(e) {
                            var t = {};
                            return e.forEach(function(e, n) {
                                t[n] = e;
                            }), t;
                        }
                        function jr(e, t) {
                            if (!e && !t) return !0;
                            if (e && !t || t && !e) return !1;
                            if (e.size != t.size) return !1;
                            for(var n = l(e), r = n.next(); !r.done; r = n.next()){
                                var i = l(r.value);
                                if (r = i.next().value, i = i.next().value, !t.has(r)) return !1;
                                if ((r = t.get(r)) != i || null == r) return !1;
                            }
                            return !0;
                        }
                        function Br(e, t) {
                            this.S = Re(e), this.h = t == Hr, this.g = 0;
                        }
                        function Gr() {
                            return new De(2, 3, 3e3);
                        }
                        (r = Br.prototype).la = function() {
                            return this.g < this.S.byteLength;
                        }, r.$ = function() {
                            return this.g;
                        }, r.Ff = function() {
                            return this.S.byteLength;
                        }, r.Ra = function() {
                            try {
                                var e = this.S.getUint8(this.g);
                                return this.g += 1, e;
                            } catch (e) {
                                throw Gr();
                            }
                        }, r.Zd = function() {
                            try {
                                var e = this.S.getUint16(this.g, this.h);
                                return this.g += 2, e;
                            } catch (e) {
                                throw Gr();
                            }
                        }, r.L = function() {
                            try {
                                var e = this.S.getUint32(this.g, this.h);
                                return this.g += 4, e;
                            } catch (e) {
                                throw Gr();
                            }
                        }, r.Oe = function() {
                            try {
                                var e = this.S.getInt32(this.g, this.h);
                                return this.g += 4, e;
                            } catch (e) {
                                throw Gr();
                            }
                        }, r.ab = function() {
                            try {
                                if (this.h) var e = this.S.getUint32(this.g, !0), t = this.S.getUint32(this.g + 4, !0);
                                else t = this.S.getUint32(this.g, !1), e = this.S.getUint32(this.g + 4, !1);
                            } catch (e) {
                                throw Gr();
                            }
                            if (2097151 < t) throw new De(2, 3, 3001);
                            return this.g += 8, t * Math.pow(2, 32) + e;
                        }, r.$a = function(e) {
                            if (this.g + e > this.S.byteLength) throw Gr();
                            var t = Ie(this.S, this.g, e);
                            return this.g += e, t;
                        }, r.skip = function(e) {
                            if (this.g + e > this.S.byteLength) throw Gr();
                            this.g += e;
                        }, r.rg = function(e) {
                            if (this.g < e) throw Gr();
                            this.g -= e;
                        }, r.seek = function(e) {
                            if (0 > e || e > this.S.byteLength) throw Gr();
                            this.g = e;
                        }, r.rc = function() {
                            for(var e = this.g; this.la() && 0 != this.S.getUint8(this.g);)this.g += 1;
                            return e = Ie(this.S, e, this.g - e), this.g += 1, yt(e);
                        }, B("shaka.util.DataViewReader", Br), Br.prototype.readTerminatedString = Br.prototype.rc, Br.prototype.seek = Br.prototype.seek, Br.prototype.rewind = Br.prototype.rg, Br.prototype.skip = Br.prototype.skip, Br.prototype.readBytes = Br.prototype.$a, Br.prototype.readUint64 = Br.prototype.ab, Br.prototype.readInt32 = Br.prototype.Oe, Br.prototype.readUint32 = Br.prototype.L, Br.prototype.readUint16 = Br.prototype.Zd, Br.prototype.readUint8 = Br.prototype.Ra, Br.prototype.getLength = Br.prototype.Ff, Br.prototype.getPosition = Br.prototype.$, Br.prototype.hasMoreData = Br.prototype.la;
                        var Hr = 1;
                        function Vr() {
                            this.i = [], this.h = [], this.g = !1;
                        }
                        function Kr(e) {
                            for(var t = Xr(e); e.reader.la() && !e.parser.g;)e.parser.ed(e.start + t, e.reader, e.partialOkay);
                        }
                        function qr(e) {
                            for(var t = Xr(e), n = e.reader.L(), r = 0; r < n && (e.parser.ed(e.start + t, e.reader, e.partialOkay), !e.parser.g); r++);
                        }
                        function Yr(e) {
                            return function(t) {
                                e(t.reader.$a(t.reader.S.byteLength - t.reader.$()));
                            };
                        }
                        function Wr(e) {
                            for(var t = 0, n = (e = l(e)).next(); !n.done; n = e.next())t = t << 8 | n.value.charCodeAt(0);
                            return t;
                        }
                        function zr(e) {
                            return String.fromCharCode(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, 255 & e);
                        }
                        function Xr(e) {
                            return 8 + (e.has64BitSize ? 8 : 0) + (null != e.flags ? 4 : 0);
                        }
                        Br.Endianness = {
                            BIG_ENDIAN: 0,
                            LITTLE_ENDIAN: Hr
                        }, (r = Vr.prototype).box = function(e, t) {
                            var n = Wr(e);
                            return this.i[n] = Qr, this.h[n] = t, this;
                        }, r.T = function(e, t) {
                            var n = Wr(e);
                            return this.i[n] = Jr, this.h[n] = t, this;
                        }, r.stop = function() {
                            this.g = !0;
                        }, r.parse = function(e, t, n) {
                            for(e = new Br(e, 0), this.g = !1; e.la() && !this.g;)this.ed(0, e, t, n);
                        }, r.ed = function(e, t, n, r) {
                            var i = t.$();
                            if (r && i + 8 > t.S.byteLength) this.g = !0;
                            else {
                                var a1 = t.L(), o = t.L(), s1 = !1;
                                switch(a1){
                                    case 0:
                                        a1 = t.S.byteLength - i;
                                        break;
                                    case 1:
                                        if (r && t.$() + 8 > t.S.byteLength) return void (this.g = !0);
                                        a1 = t.ab(), s1 = !0;
                                }
                                var u = this.h[o];
                                if (u) {
                                    var l = null, c = null;
                                    if (this.i[o] == Jr) {
                                        if (r && t.$() + 4 > t.S.byteLength) return void (this.g = !0);
                                        l = (c = t.L()) >>> 24, c &= 16777215;
                                    }
                                    o = i + a1, n && o > t.S.byteLength && (o = t.S.byteLength), r && o > t.S.byteLength ? this.g = !0 : (r = o - t.$(), u({
                                        parser: this,
                                        partialOkay: n || !1,
                                        version: l,
                                        flags: c,
                                        reader: t = new Br(t = 0 < r ? t.$a(r) : new Uint8Array(0), 0),
                                        size: a1,
                                        start: i + e,
                                        has64BitSize: s1
                                    }));
                                } else t.skip(Math.min(i + a1 - t.$(), t.S.byteLength - t.$()));
                            }
                        }, B("shaka.util.Mp4Parser", Vr), Vr.headerSize = Xr, Vr.typeToString = zr, Vr.allData = Yr, Vr.sampleDescription = qr, Vr.children = Kr, Vr.prototype.parseNext = Vr.prototype.ed, Vr.prototype.parse = Vr.prototype.parse, Vr.prototype.stop = Vr.prototype.stop, Vr.prototype.fullBox = Vr.prototype.T, Vr.prototype.box = Vr.prototype.box;
                        var Qr = 0, Jr = 1;
                        function Zr(e) {
                            var t = this;
                            this.g = [], this.h = [], this.data = [], (new Vr).box("moov", Kr).box("moof", Kr).T("pssh", function(e) {
                                if (!(1 < e.version)) {
                                    var n = Ie(e.reader.S, -12, e.size);
                                    if (t.data.push(n), t.g.push(Dt(e.reader.$a(16))), 0 < e.version) {
                                        n = e.reader.L();
                                        for(var r = 0; r < n; r++){
                                            var i = Dt(e.reader.$a(16));
                                            t.h.push(i);
                                        }
                                    }
                                }
                            }).parse(e);
                        }
                        function $r(e, t, n, r) {
                            var i = e.length, a1 = t.length + 16 + i;
                            0 < r && (a1 += 4 + 16 * n.size);
                            var o = new Uint8Array(a1), s1 = Re(o), u = 0;
                            if (s1.setUint32(u, a1), u += 4, s1.setUint32(u, 1886614376), u += 4, 1 > r ? s1.setUint32(u, 0) : s1.setUint32(u, 16777216), u += 4, o.set(t, u), u += t.length, 0 < r) for(s1.setUint32(u, n.size), u += 4, n = (t = l(n)).next(); !n.done; n = t.next())n = Ct(n.value), o.set(n, u), u += n.length;
                            return s1.setUint32(u, i), o.set(e, u + 4), o;
                        }
                        function ei(e, t) {
                            var n = ni(e, t);
                            return 1 != n.length ? null : n[0];
                        }
                        function ti(e, t, n) {
                            return 1 != (e = ri(e, t, n)).length ? null : e[0];
                        }
                        function ni(e, t) {
                            for(var n = [], r = l(e.childNodes), i = r.next(); !i.done; i = r.next())(i = i.value) instanceof Element && i.tagName == t && n.push(i);
                            return n;
                        }
                        function ri(e, t, n) {
                            for(var r = [], i = (e = l(e.childNodes)).next(); !i.done; i = e.next())(i = i.value) instanceof Element && i.localName == n && i.namespaceURI == t && r.push(i);
                            return r;
                        }
                        function ii(e, t, n) {
                            return e.hasAttributeNS(t, n) ? e.getAttributeNS(t, n) : null;
                        }
                        function ai(e, t, n) {
                            for(var r = (t = l(t)).next(); !r.done; r = t.next())if (r = r.value, e.hasAttributeNS(r, n)) return e.getAttributeNS(r, n);
                            return null;
                        }
                        function oi(e) {
                            return Array.from(e.childNodes).every(si) ? e.textContent.trim() : null;
                        }
                        function si(e) {
                            return e.nodeType == Node.TEXT_NODE || e.nodeType == Node.CDATA_SECTION_NODE;
                        }
                        function ui(e, t, n, r) {
                            r = void 0 === r ? null : r;
                            var i = null;
                            return null != (e = e.getAttribute(t)) && (i = n(e)), null == i ? r : i;
                        }
                        function li(e) {
                            return e ? (/^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/.test(e) && (e += "Z"), e = Date.parse(e), isNaN(e) ? null : e / 1e3) : null;
                        }
                        function ci(e) {
                            return e && (e = RegExp("^P(?:([0-9]*)Y)?(?:([0-9]*)M)?(?:([0-9]*)D)?(?:T(?:([0-9]*)H)?(?:([0-9]*)M)?(?:([0-9.]*)S)?)?$").exec(e)) ? (e = 31536e3 * Number(e[1] || null) + 2592e3 * Number(e[2] || null) + 86400 * Number(e[3] || null) + 3600 * Number(e[4] || null) + 60 * Number(e[5] || null) + Number(e[6] || null), isFinite(e) ? e : null) : null;
                        }
                        function di(e) {
                            var t = /([0-9]+)-([0-9]+)/.exec(e);
                            return t ? (e = Number(t[1]), isFinite(e) ? (t = Number(t[2]), isFinite(t) ? {
                                start: e,
                                end: t
                            } : null) : null) : null;
                        }
                        function fi(e) {
                            return 0 == (e = Number(e)) % 1 ? e : null;
                        }
                        function hi(e) {
                            return 0 == (e = Number(e)) % 1 && 0 < e ? e : null;
                        }
                        function gi(e) {
                            return 0 == (e = Number(e)) % 1 && 0 <= e ? e : null;
                        }
                        function pi(e) {
                            return e = Number(e), isNaN(e) ? null : e;
                        }
                        function mi(e) {
                            var t, n = (t = e.match(/^(\d+)\/(\d+)$/)) ? Number(t[1]) / Number(t[2]) : Number(e);
                            return isNaN(n) ? null : n;
                        }
                        function vi(e, t) {
                            var n = new DOMParser, r = Ei.value()(e), i = null;
                            try {
                                i = n.parseFromString(r, "text/xml");
                            } catch (e) {
                                return null;
                            }
                            if (!(n = i.documentElement) || n.getElementsByTagName("parsererror").length || n.tagName != t) return null;
                            for(i = document.createNodeIterator(i, NodeFilter.SHOW_ALL); r = i.nextNode();)if (r instanceof HTMLElement || r instanceof SVGElement) return null;
                            return n;
                        }
                        function yi(e, t) {
                            try {
                                return vi(yt(e), t);
                            } catch (e) {
                                return null;
                            }
                        }
                        var Ei = new nt(function() {
                            if ("undefined" != typeof trustedTypes) {
                                var e = trustedTypes.createPolicy("shaka-player#xml", {
                                    createHTML: function(e) {
                                        return e;
                                    }
                                });
                                return function(t) {
                                    return e.createHTML(t);
                                };
                            }
                            return function(e) {
                                return e;
                            };
                        });
                        function Ti(e, t) {
                            var n = this;
                            t = void 0 === t ? 1 : t, this.D = e, this.G = new Set, this.l = this.u = null, this.ea = this.X = !1, this.H = 0, this.g = null, this.s = new xr, this.i = new Map, this.B = [], this.o = new tt, this.h = null, this.m = function(t) {
                                n.o.reject(t), e.onError(t);
                            }, this.ha = new Map, this.ca = new Map, this.P = new it(function() {
                                return function(e) {
                                    var t = e.ha, n = e.ca;
                                    n.clear(), t.forEach(function(e, t) {
                                        return n.set(t, e);
                                    }), (t = Array.from(n.values())).length && t.every(function(e) {
                                        return "expired" == e;
                                    }) && e.m(new De(2, 6, 6014)), e.D.cd(Ur(n));
                                }(n);
                            }), this.M = !1, this.K = [], this.N = !1, this.da = new it(function() {
                                !function(e) {
                                    e.i.forEach(function(t, n) {
                                        var r = t.Ud, i = n.expiration;
                                        isNaN(i) && (i = 1 / 0), i != r && (e.D.onExpirationUpdated(n.sessionId, i), t.Ud = i);
                                    });
                                }(n);
                            }).Ba(t), this.o.catch(function() {}), this.j = new Nr(function() {
                                return function(e) {
                                    return L(function(t) {
                                        switch(t.g){
                                            case 1:
                                                return e.s.release(), e.s = null, e.o.reject(), e.da.stop(), e.da = null, e.P.stop(), e.P = null, T(t, xi(e), 2);
                                            case 2:
                                                if (!e.l) {
                                                    t.A(3);
                                                    break;
                                                }
                                                return A(t, 4), T(t, e.l.setMediaKeys(null), 6);
                                            case 6:
                                                S(t, 5);
                                                break;
                                            case 4:
                                                w(t);
                                            case 5:
                                                e.l = null;
                                            case 3:
                                                e.g = null, e.G.clear(), e.u = null, e.B = [], e.h = null, e.m = function() {}, e.D = null, e.W = !1, e.F = null, b(t);
                                        }
                                    });
                                }(n);
                            }), this.W = !1, this.F = null;
                        }
                        function bi(e, t, n) {
                            return e.B = n, e.M = 0 < n.length, Ai(e, t);
                        }
                        function Ai(t, n) {
                            var r, i, a1, o, s1, u, c, d, f, h, g, p;
                            return L(function(m) {
                                if (1 == m.g) {
                                    if (r = function(t) {
                                        if (0 == (t = Fr(t.h.clearKeys)).size) return null;
                                        var n = [], r = [];
                                        t.forEach(function(e, t) {
                                            var i = t;
                                            22 != i.length && (i = It(Ct(t), !1));
                                            var a1 = e;
                                            22 != a1.length && (a1 = It(Ct(e), !1)), i = {
                                                kty: "oct",
                                                kid: i,
                                                k: a1
                                            }, n.push(i), r.push(i.kid);
                                        }), t = JSON.stringify({
                                            keys: n
                                        });
                                        var i = JSON.stringify({
                                            kids: r
                                        });
                                        return i = [
                                            {
                                                initData: Ie(bt(i)),
                                                initDataType: "keyids"
                                            }
                                        ], {
                                            keySystem: "org.w3.clearkey",
                                            licenseServerUri: "data:application/json;base64," + e.btoa(t),
                                            distinctiveIdentifierRequired: !1,
                                            persistentStateRequired: !1,
                                            audioRobustness: "",
                                            videoRobustness: "",
                                            serverCertificate: null,
                                            serverCertificateUri: "",
                                            sessionType: "",
                                            initData: i,
                                            keyIds: new Set(r)
                                        };
                                    }(t)) for(i = l(n), a1 = i.next(); !a1.done; a1 = i.next())(o = a1.value).video && (o.video.drmInfos = [
                                        r
                                    ]), o.audio && (o.audio.drmInfos = [
                                        r
                                    ]);
                                    for((s1 = n.some(function(e) {
                                        return !!(e.video && e.video.drmInfos.length || e.audio && e.audio.drmInfos.length);
                                    })) || (u = Fr(t.h.servers), function(e, t) {
                                        var n = [];
                                        t.forEach(function(e, t) {
                                            n.push({
                                                keySystem: t,
                                                licenseServerUri: e,
                                                distinctiveIdentifierRequired: !1,
                                                persistentStateRequired: !1,
                                                audioRobustness: "",
                                                videoRobustness: "",
                                                serverCertificate: null,
                                                serverCertificateUri: "",
                                                initData: [],
                                                keyIds: new Set
                                            });
                                        });
                                        for(var r = l(e), i = r.next(); !i.done; i = r.next())(i = i.value).video && (i.video.drmInfos = n), i.audio && (i.audio.drmInfos = n);
                                    }(n, u)), c = l(n), a1 = c.next(); !a1.done; a1 = c.next())for(d = a1.value, f = Oi(d), h = l(f), g = h.next(); !g.done; g = h.next())Ui(g.value, Fr(t.h.servers), Fr(t.h.advanced || {}), t.h.keySystemsMapping);
                                    return T(m, mn(n, t.M, t.W), 2);
                                }
                                return s1 || Object.keys(t.h.servers).length ? (p = Di(t, void 0, n), m.return(s1 ? p : p.catch(function() {}))) : (t.X = !0, m.return(Promise.resolve()));
                            });
                        }
                        function _i(e) {
                            var t;
                            return L(function(n) {
                                switch(n.g){
                                    case 1:
                                        if (e.l.mediaKeys) return n.return();
                                        if (!e.F) {
                                            n.A(2);
                                            break;
                                        }
                                        return T(n, e.F, 3);
                                    case 3:
                                        return Lr(e.j), n.return();
                                    case 2:
                                        return A(n, 4), e.F = e.l.setMediaKeys(e.u), T(n, e.F, 6);
                                    case 6:
                                        S(n, 5);
                                        break;
                                    case 4:
                                        t = w(n), e.m(new De(2, 6, 6003, t.message));
                                    case 5:
                                        Lr(e.j), b(n);
                                }
                            });
                        }
                        function Si(e) {
                            var t, n;
                            return L(function(r) {
                                switch(r.g){
                                    case 1:
                                        if (!e.u || !e.g) return r.return();
                                        if (!e.g.serverCertificateUri || e.g.serverCertificate && e.g.serverCertificate.length) {
                                            r.A(2);
                                            break;
                                        }
                                        return t = Sr([
                                            e.g.serverCertificateUri
                                        ], e.h.retryParameters), A(r, 3), T(r, e.D.lb.request(5, t).promise, 5);
                                    case 5:
                                        n = r.h, e.g.serverCertificate = Ie(n.data), S(r, 4);
                                        break;
                                    case 3:
                                        throw new De(2, 6, 6017, w(r));
                                    case 4:
                                        if (e.j.g) return r.return();
                                    case 2:
                                        return e.g.serverCertificate && e.g.serverCertificate.length ? (A(r, 6), T(r, e.u.setServerCertificate(e.g.serverCertificate), 8)) : r.return();
                                    case 8:
                                        S(r, 0);
                                        break;
                                    case 6:
                                        throw new De(2, 6, 6004, w(r).message);
                                }
                            });
                        }
                        function wi(e) {
                            for(var t = (e.g ? e.g.initData : []) || [], n = l(t), r = n.next(); !r.done; r = n.next())Ii(e, (r = r.value).initDataType, r.initData);
                            for(r = (n = l(e.B)).next(); !r.done; r = n.next())ki(e, r.value);
                            return t.length || e.B.length || e.o.resolve(), e.o;
                        }
                        function Ii(e, t, n) {
                            if (n.length) {
                                for(var r = e.i.values(), i = (r = l(r)).next(); !i.done; i = r.next())if (_e(n, i.value.initData) && !ht("Tizen 2")) return;
                                0 < e.i.size && Pi(e) && (e.o.resolve(), e.o = new tt, e.o.catch(function() {})), function(e, t, n, r) {
                                    try {
                                        var i = e.u.createSession(r);
                                    } catch (t) {
                                        return void e.m(new De(2, 6, 6005, t.message));
                                    }
                                    e.s.C(i, "message", function(t) {
                                        e.l && e.h.delayLicenseRequestUntilPlayed && e.l.paused && !e.N ? e.K.push(t) : Ni(e, t);
                                    }), e.s.C(i, "keystatuseschange", function(t) {
                                        return Li(e, t);
                                    }), e.i.set(i, {
                                        initData: n,
                                        initDataType: t,
                                        loaded: !1,
                                        Ud: 1 / 0,
                                        Ja: null,
                                        type: r
                                    });
                                    try {
                                        n = e.h.initDataTransform(n, t, e.g);
                                    } catch (n) {
                                        return t = n, n instanceof De || (t = new De(2, 6, 6016, n)), void e.m(t);
                                    }
                                    e.h.logLicenseExchange && It(n), i.generateRequest(t, n).catch(function(t) {
                                        if (!e.j.g) {
                                            e.i.delete(i);
                                            var n = t.errorCode;
                                            if (n && n.systemCode) {
                                                var r = n.systemCode;
                                                0 > r && (r += Math.pow(2, 32)), r = "0x" + r.toString(16);
                                            }
                                            e.m(new De(2, 6, 6006, t.message, t, r));
                                        }
                                    });
                                }(e, t, n, e.g.sessionType);
                            }
                        }
                        function Ri(e) {
                            return !!e && !!e.match(/^com\.(microsoft|chromecast)\.playready/);
                        }
                        function Ci(e) {
                            return e = Pr(e = e.i.keys(), function(e) {
                                return e.sessionId;
                            }), Array.from(e);
                        }
                        function Di(e, t, n) {
                            var r, i, a1, o, s1, u, c, d, f, h, g, p, m;
                            return L(function(v) {
                                switch(v.g){
                                    case 1:
                                        if (r = new Map, n.length) {
                                            i = function(e, t, n) {
                                                for(var r = l(t), i = r.next(); !i.done; i = r.next()){
                                                    var a1 = l(Oi(i.value));
                                                    for(i = a1.next(); !i.done; i = a1.next())i = i.value, n.has(i.keySystem) || n.set(i.keySystem, []), n.get(i.keySystem).push(i);
                                                }
                                                if (1 == n.size && n.has("")) throw new De(2, 6, 6e3);
                                                for(r = {}, i = (e = l(e.h.preferredKeySystems)).next(); !i.done; r = {
                                                    rd: r.rd
                                                }, i = e.next())for(r.rd = i.value, i = (a1 = l(t)).next(); !i.done; i = a1.next())if (i = i.value.decodingInfos.find(function(e) {
                                                    return function(t) {
                                                        return t.supported && null != t.keySystemAccess && t.keySystemAccess.keySystem == e.rd;
                                                    };
                                                }(r))) return i.keySystemAccess;
                                                for(i = (e = l([
                                                    !0,
                                                    !1
                                                ])).next(); !i.done; i = e.next())for(r = i.value, i = (a1 = l(t)).next(); !i.done; i = a1.next()){
                                                    var o = l(i.value.decodingInfos);
                                                    for(i = o.next(); !i.done; i = o.next()){
                                                        var s1 = i.value;
                                                        if (s1.supported && s1.keySystemAccess) {
                                                            var u = l(i = n.get(s1.keySystemAccess.keySystem));
                                                            for(i = u.next(); !i.done; i = u.next())if (!!i.value.licenseServerUri == r) return s1.keySystemAccess;
                                                        }
                                                    }
                                                }
                                                return null;
                                            }(e, n, r), v.A(2);
                                            break;
                                        }
                                        return T(v, function(e, t) {
                                            var n, r, i, a1, o, s1, u, c, d, f, h, g, p, m, v;
                                            return L(function(y) {
                                                switch(y.g){
                                                    case 1:
                                                        if (1 == t.size && t.has("")) throw new De(2, 6, 6e3);
                                                        for(r = l(t.values()), i = r.next(); !i.done; i = r.next())0 == (a1 = i.value).audioCapabilities.length && delete a1.audioCapabilities, 0 == a1.videoCapabilities.length && delete a1.videoCapabilities;
                                                        o = l(e.h.preferredKeySystems), s1 = o.next();
                                                    case 2:
                                                        if (s1.done) {
                                                            y.A(4);
                                                            break;
                                                        }
                                                        if (u = s1.value, !t.has(u)) {
                                                            y.A(3);
                                                            break;
                                                        }
                                                        return c = t.get(u), A(y, 6), T(y, navigator.requestMediaKeySystemAccess(u, [
                                                            c
                                                        ]), 8);
                                                    case 8:
                                                        return n = y.h, y.return(n);
                                                    case 6:
                                                        w(y);
                                                    case 7:
                                                        Lr(e.j);
                                                    case 3:
                                                        s1 = o.next(), y.A(2);
                                                        break;
                                                    case 4:
                                                        d = l([
                                                            !0,
                                                            !1
                                                        ]), f = d.next();
                                                    case 9:
                                                        if (f.done) {
                                                            y.A(11);
                                                            break;
                                                        }
                                                        h = f.value, g = l(t.keys()), s1 = g.next();
                                                    case 12:
                                                        if (s1.done) {
                                                            f = d.next(), y.A(9);
                                                            break;
                                                        }
                                                        if (p = s1.value, m = t.get(p), v = m.drmInfos.some(function(e) {
                                                            return !!e.licenseServerUri;
                                                        }), v != h) {
                                                            y.A(13);
                                                            break;
                                                        }
                                                        return A(y, 15), T(y, navigator.requestMediaKeySystemAccess(p, [
                                                            m
                                                        ]), 17);
                                                    case 17:
                                                        return n = y.h, y.return(n);
                                                    case 15:
                                                        w(y);
                                                    case 16:
                                                        Lr(e.j);
                                                    case 13:
                                                        s1 = g.next(), y.A(12);
                                                        break;
                                                    case 11:
                                                        return y.return(n);
                                                }
                                            });
                                        }(e, t), 3);
                                    case 3:
                                        i = v.h;
                                    case 2:
                                        if (!(a1 = i)) throw new De(2, 6, 6001);
                                        for(Lr(e.j), A(v, 4), e.G.clear(), o = a1.getConfiguration(), s1 = o.audioCapabilities || [], u = o.videoCapabilities || [], c = l(s1), d = c.next(); !d.done; d = c.next())f = d.value, e.G.add(f.contentType.toLowerCase());
                                        for(h = l(u), d = h.next(); !d.done; d = h.next())g = d.value, e.G.add(g.contentType.toLowerCase());
                                        if (n.length) {
                                            var y = a1.keySystem, E = r.get(a1.keySystem), b = [], _ = [], I = [], R = [], C = new Set;
                                            Fi(E, b, I, _, R, C);
                                            var D = e.M ? "persistent-license" : "temporary";
                                            for(y = {
                                                keySystem: y,
                                                licenseServerUri: b[0],
                                                distinctiveIdentifierRequired: E[0].distinctiveIdentifierRequired,
                                                persistentStateRequired: E[0].persistentStateRequired,
                                                sessionType: E[0].sessionType || D,
                                                audioRobustness: E[0].audioRobustness || "",
                                                videoRobustness: E[0].videoRobustness || "",
                                                serverCertificate: I[0],
                                                serverCertificateUri: _[0],
                                                initData: R,
                                                keyIds: C
                                            }, b = (E = l(E)).next(); !b.done; b = E.next())(b = b.value).distinctiveIdentifierRequired && (y.distinctiveIdentifierRequired = b.distinctiveIdentifierRequired), b.persistentStateRequired && (y.persistentStateRequired = b.persistentStateRequired);
                                            E = y;
                                        } else E = a1.keySystem, y = t.get(a1.keySystem), b = [], _ = [], I = [], R = [], C = new Set, Fi(y.drmInfos, b, I, _, R, C), E = {
                                            keySystem: E,
                                            licenseServerUri: b[0],
                                            distinctiveIdentifierRequired: "required" == y.distinctiveIdentifier,
                                            persistentStateRequired: "required" == y.persistentState,
                                            sessionType: y.sessionTypes[0] || "temporary",
                                            audioRobustness: (y.audioCapabilities ? y.audioCapabilities[0].robustness : "") || "",
                                            videoRobustness: (y.videoCapabilities ? y.videoCapabilities[0].robustness : "") || "",
                                            serverCertificate: I[0],
                                            serverCertificateUri: _[0],
                                            initData: R,
                                            keyIds: C
                                        };
                                        if (e.g = E, !e.g.licenseServerUri) throw new De(2, 6, 6012, e.g.keySystem);
                                        return T(v, a1.createMediaKeys(), 6);
                                    case 6:
                                        return p = v.h, Lr(e.j), e.u = p, e.X = !0, T(v, Si(e), 7);
                                    case 7:
                                        Lr(e.j), S(v, 0);
                                        break;
                                    case 4:
                                        if (m = w(v), Lr(e.j, m), e.g = null, e.G.clear(), m instanceof De) throw m;
                                        throw new De(2, 6, 6002, m.message);
                                }
                            });
                        }
                        function ki(e, t) {
                            var n, r, i, a1, o;
                            return L(function(s1) {
                                switch(s1.g){
                                    case 1:
                                        try {
                                            n = e.u.createSession("persistent-license");
                                        } catch (t) {
                                            return r = new De(2, 6, 6005, t.message), e.m(r), s1.return(Promise.reject(r));
                                        }
                                        return e.s.C(n, "message", function(t) {
                                            e.l && e.h.delayLicenseRequestUntilPlayed && e.l.paused && !e.N ? e.K.push(t) : Ni(e, t);
                                        }), e.s.C(n, "keystatuseschange", function(t) {
                                            return Li(e, t);
                                        }), i = {
                                            initData: null,
                                            initDataType: null,
                                            loaded: !1,
                                            Ud: 1 / 0,
                                            Ja: null,
                                            type: "persistent-license"
                                        }, e.i.set(n, i), A(s1, 2), T(s1, n.load(t), 4);
                                    case 4:
                                        return a1 = s1.h, Lr(e.j), a1 ? (i.loaded = !0, Pi(e) && e.o.resolve(), s1.return(n)) : (e.i.delete(n), e.m(new De(2, 6, 6013)), s1.return(Promise.resolve()));
                                    case 2:
                                        o = w(s1), Lr(e.j, o), e.i.delete(n), e.m(new De(2, 6, 6005, o.message));
                                    case 3:
                                        return s1.return(Promise.resolve());
                                }
                            });
                        }
                        function Ni(e, t) {
                            var n, r, i, a1, o, s1, u, c, d, f, h, g;
                            L(function(p) {
                                switch(p.g){
                                    case 1:
                                        return n = t.target, e.h.logLicenseExchange && It(t.message), r = e.i.get(n), i = e.g.licenseServerUri, a1 = e.h.advanced[e.g.keySystem], "individualization-request" == t.messageType && a1 && a1.individualizationServer && (i = a1.individualizationServer), (o = Sr([
                                            i
                                        ], e.h.retryParameters)).body = t.message, o.method = "POST", o.licenseRequestType = t.messageType, o.sessionId = n.sessionId, o.drmInfo = e.g, r && (o.initData = r.initData, o.initDataType = r.initDataType), Ri(e.g.keySystem) && function(e) {
                                            var t = Et(e.body, !0, !0);
                                            if (t.includes("PlayReadyKeyMessage")) {
                                                for(var n = l((t = vi(t, "PlayReadyKeyMessage")).getElementsByTagName("HttpHeader")), r = n.next(); !r.done; r = n.next())r = r.value, e.headers[r.getElementsByTagName("name")[0].textContent] = r.getElementsByTagName("value")[0].textContent;
                                                e.body = Rt(t.getElementsByTagName("Challenge")[0].textContent);
                                            } else e.headers["Content-Type"] = "text/xml; charset=utf-8";
                                        }(o), s1 = Date.now(), A(p, 2), T(p, e.D.lb.request(2, o).promise, 4);
                                    case 4:
                                        u = p.h, S(p, 3);
                                        break;
                                    case 2:
                                        return c = w(p), d = new De(2, 6, 6007, c), e.m(d), r && r.Ja && r.Ja.reject(d), p.return();
                                    case 3:
                                        return e.j.g ? p.return() : (e.H += (Date.now() - s1) / 1e3, e.h.logLicenseExchange && It(u.data), A(p, 5), T(p, n.update(u.data), 7));
                                    case 7:
                                        S(p, 6);
                                        break;
                                    case 5:
                                        return f = w(p), h = new De(2, 6, 6008, f.message), e.m(h), r && r.Ja && r.Ja.reject(h), p.return();
                                    case 6:
                                        if (e.j.g) return p.return();
                                        g = new gr("drmsessionupdate"), e.D.onEvent(g), r && (r.Ja && r.Ja.resolve(), new it(function() {
                                            r.loaded = !0, Pi(e) && e.o.resolve();
                                        }).O(Bi)), b(p);
                                }
                            });
                        }
                        function Li(e, t) {
                            var n = t.target, r = e.i.get(n), i = !1;
                            n.keyStatuses.forEach(function(t, n) {
                                if ("string" == typeof n) {
                                    var a1 = n;
                                    n = t, t = a1;
                                }
                                if (Ri(e.g.keySystem) && 16 == n.byteLength && (navigator.userAgent.match(/Edge?\//) || dt())) {
                                    var o = (a1 = Re(n)).getUint32(0, !0), s1 = a1.getUint16(4, !0), u = a1.getUint16(6, !0);
                                    a1.setUint32(0, o, !1), a1.setUint16(4, s1, !1), a1.setUint16(6, u, !1);
                                }
                                "status-pending" != t && (r.loaded = !0), "expired" == t && (i = !0), a1 = Dt(n).slice(0, 32), e.ha.set(a1, t);
                            });
                            var a1 = n.expiration - Date.now();
                            (0 > a1 || i && 1e3 > a1) && r && !r.Ja && (e.i.delete(n), n.close().catch(function() {})), Pi(e) && (e.o.resolve(), e.P.O(Gi));
                        }
                        function xi(e) {
                            var t;
                            return L(function(n) {
                                return t = Array.from(e.i.entries()), e.i.clear(), T(n, Promise.all(t.map(function(t) {
                                    var n = (t = l(t)).next().value, r = t.next().value;
                                    return L(function(t) {
                                        return 1 == t.g ? (A(t, 2), e.ea || e.B.includes(n.sessionId) || "persistent-license" !== r.type ? T(t, function(e) {
                                            var t;
                                            return L(function(n) {
                                                return 1 == n.g ? (t = new Promise(function(e, t) {
                                                    new it(t).O(ji);
                                                }), A(n, 2), T(n, Promise.race([
                                                    Promise.all([
                                                        e.close(),
                                                        e.closed
                                                    ]),
                                                    t
                                                ]), 4)) : 2 != n.g ? S(n, 0) : (w(n), void b(n));
                                            });
                                        }(n), 5) : T(t, n.remove(), 5)) : 2 != t.g ? S(t, 0) : (w(t), void b(t));
                                    });
                                })), 0);
                            });
                        }
                        function Mi(e, t) {
                            if (!e.length) return t;
                            if (!t.length) return e;
                            for(var n = [], r = l(e), i = r.next(); !i.done; i = r.next()){
                                i = i.value;
                                for(var a1 = {}, o = l(t), s1 = o.next(); !s1.done; a1 = {
                                    Ca: a1.Ca
                                }, s1 = o.next())if (s1 = s1.value, i.keySystem == s1.keySystem) {
                                    a1.Ca = [], a1.Ca = a1.Ca.concat(i.initData || []), a1.Ca = a1.Ca.concat(s1.initData || []), a1.Ca = a1.Ca.filter(function(e) {
                                        return function(t, n) {
                                            return void 0 === t.keyId || n === e.Ca.findIndex(function(e) {
                                                return e.keyId === t.keyId;
                                            });
                                        };
                                    }(a1)), o = i.keyIds && s1.keyIds ? new Set([].concat(c(i.keyIds), c(s1.keyIds))) : i.keyIds || s1.keyIds, n.push({
                                        keySystem: i.keySystem,
                                        licenseServerUri: i.licenseServerUri || s1.licenseServerUri,
                                        distinctiveIdentifierRequired: i.distinctiveIdentifierRequired || s1.distinctiveIdentifierRequired,
                                        persistentStateRequired: i.persistentStateRequired || s1.persistentStateRequired,
                                        videoRobustness: i.videoRobustness || s1.videoRobustness,
                                        audioRobustness: i.audioRobustness || s1.audioRobustness,
                                        serverCertificate: i.serverCertificate || s1.serverCertificate,
                                        serverCertificateUri: i.serverCertificateUri || s1.serverCertificateUri,
                                        initData: a1.Ca,
                                        keyIds: o
                                    });
                                    break;
                                }
                            }
                            return n;
                        }
                        function Oi(e) {
                            return (e.video ? e.video.drmInfos : []).concat(e.audio ? e.audio.drmInfos : []);
                        }
                        function Pi(e) {
                            return function(e, t) {
                                for(var n = l(e), r = n.next(); !r.done; r = n.next())if (!t(r.value)) return !1;
                                return !0;
                            }(e = e.i.values(), function(e) {
                                return e.loaded;
                            });
                        }
                        function Fi(e, t, n, r, i, a1) {
                            for(var o = {}, s1 = (e = l(e)).next(); !s1.done; o = {
                                pa: o.pa
                            }, s1 = e.next()){
                                if (o.pa = s1.value, t.includes(o.pa.licenseServerUri) || t.push(o.pa.licenseServerUri), r.includes(o.pa.serverCertificateUri) || r.push(o.pa.serverCertificateUri), o.pa.serverCertificate && (n.some(function(e) {
                                    return function(t) {
                                        return _e(t, e.pa.serverCertificate);
                                    };
                                }(o)) || n.push(o.pa.serverCertificate)), o.pa.initData) {
                                    s1 = {};
                                    for(var u = l(o.pa.initData), c = u.next(); !c.done; s1 = {
                                        Cc: s1.Cc
                                    }, c = u.next())s1.Cc = c.value, i.some(function(e) {
                                        return function(t) {
                                            var n = e.Cc;
                                            return !(!t.keyId || t.keyId != n.keyId) || t.initDataType == n.initDataType && _e(t.initData, n.initData);
                                        };
                                    }(s1)) || i.push(s1.Cc);
                                }
                                if (o.pa.keyIds) for(u = (s1 = l(o.pa.keyIds)).next(); !u.done; u = s1.next())a1.add(u.value);
                            }
                        }
                        function Ui(t, n, r, i) {
                            var a1 = t.keySystem;
                            !a1 || "org.w3.clearkey" == a1 && t.licenseServerUri || (n.size && (n = n.get(a1) || "", t.licenseServerUri = n), t.keyIds || (t.keyIds = new Set), (r = r.get(a1)) && (t.distinctiveIdentifierRequired || (t.distinctiveIdentifierRequired = r.distinctiveIdentifierRequired), t.persistentStateRequired || (t.persistentStateRequired = r.persistentStateRequired), t.videoRobustness || (t.videoRobustness = r.videoRobustness), t.audioRobustness || (t.audioRobustness = r.audioRobustness), t.serverCertificate || (t.serverCertificate = r.serverCertificate), r.sessionType && (t.sessionType = r.sessionType), t.serverCertificateUri || (t.serverCertificateUri = r.serverCertificateUri)), i[a1] && (t.keySystem = i[a1]), e.cast && e.cast.__platform__ && "com.microsoft.playready" == a1 && (t.keySystem = "com.chromecast.playready"));
                        }
                        (r = Ti.prototype).destroy = function() {
                            return this.j.destroy();
                        }, r.configure = function(e) {
                            this.h = e;
                        }, r.Yb = function(e) {
                            var t, n = this;
                            return L(function(r) {
                                if (1 == r.g) return n.u ? (n.l = e, n.s.na(n.l, "play", function() {
                                    for(var e = l(n.K), t = e.next(); !t.done; t = e.next())Ni(n, t.value);
                                    n.N = !0, n.K = [];
                                }), "webkitCurrentPlaybackTargetIsWireless" in n.l && n.s.C(n.l, "webkitcurrentplaybacktargetiswirelesschanged", function() {
                                    return xi(n);
                                }), (t = n.g.initData.find(function(e) {
                                    return 0 < e.initData.length;
                                })) || "com.apple.fps" !== n.g.keySystem || n.B.length ? T(r, _i(n), 2) : r.A(2)) : (n.s.na(e, "encrypted", function() {
                                    n.m(new De(2, 6, 6010));
                                }), r.return());
                                wi(n), t || n.B.length || n.h.parseInbandPsshEnabled || n.s.C(n.l, "encrypted", function(e) {
                                    return function(e, t) {
                                        return L(function(n) {
                                            if (1 == n.g) return T(n, _i(e), 2);
                                            Ii(e, t.initDataType, Ie(t.initData)), b(n);
                                        });
                                    }(n, e);
                                }), b(r);
                            });
                        }, r.hc = function() {
                            for(var e = 1 / 0, t = this.i.keys(), n = (t = l(t)).next(); !n.done; n = t.next())n = n.value, isNaN(n.expiration) || (e = Math.min(e, n.expiration));
                            return e;
                        }, r.Qc = function() {
                            return Ur(this.ca);
                        };
                        var ji = 1, Bi = 5, Gi = .5, Hi = new nt(function() {
                            return we(new Uint8Array([
                                0
                            ]));
                        });
                        function Vi() {}
                        function Ki(e, t, n, r) {
                            var i, a1, o, s1;
                            return L(function(u) {
                                if (1 == u.g) return r && (i = Wi[r.toLowerCase()]) ? u.return(i) : (a1 = Yi(e)) && (o = zi[a1]) ? u.return(o) : r ? u.A(2) : T(u, qi(e, t, n), 3);
                                if (2 != u.g && (r = u.h) && (s1 = Wi[r])) return u.return(s1);
                                throw new De(2, 4, 4e3, e);
                            });
                        }
                        function qi(e, t, n) {
                            var r, i, a1;
                            return L(function(o) {
                                return 1 == o.g ? ((r = Sr([
                                    e
                                ], n)).method = "HEAD", T(o, t.request(0, r).promise, 2)) : (i = o.h, a1 = i.headers["content-type"], o.return(a1 ? a1.toLowerCase().split(";").shift() : ""));
                            });
                        }
                        function Yi(e) {
                            return 1 == (e = new Ne(e).qa.split("/").pop().split(".")).length ? "" : e.pop().toLowerCase();
                        }
                        B("shaka.media.ManifestParser", Vi), Vi.unregisterParserByMime = function(e) {
                            delete Wi[e];
                        }, Vi.registerParserByMime = function(e, t) {
                            Wi[e] = t;
                        }, Vi.registerParserByExtension = function(e, t) {
                            zi[e] = t;
                        };
                        var Wi = {}, zi = {};
                        function Xi(e, t, n, r, i) {
                            var a1 = Ji.value(), o = e.subarray(n.start, n.start + n.size), s1 = Re(o), u = new Uint8Array(n.size + a1.byteLength);
                            for(u.set(o, 0), (o = Re(u)).setUint32(4, i), u.set(a1, n.size), i = s1.getUint32(4), o.setUint32(n.size + 16, i), Qi(u, 0, u.byteLength), i = new Uint8Array(e.byteLength + u.byteLength), n = st() ? n.start : n.start + n.size, a1 = e.subarray(n), i.set(e.subarray(0, n)), i.set(u, n), i.set(a1, n + u.byteLength), r = (e = l(r)).next(); !r.done; r = e.next())Qi(i, (r = r.value).start, r.size + u.byteLength);
                            return u = Re(i, t.start), t = Xr(t), e = u.getUint32(t), u.setUint32(t, e + 1), i;
                        }
                        function Qi(e, t, n) {
                            0 != (t = (e = Re(e, t)).getUint32(0)) && (1 == t ? (e.setUint32(8, n >> 32), e.setUint32(12, 4294967295 & n)) : e.setUint32(0, n));
                        }
                        var Ji = new nt(function() {
                            return new Uint8Array([
                                0,
                                0,
                                0,
                                80,
                                115,
                                105,
                                110,
                                102,
                                0,
                                0,
                                0,
                                12,
                                102,
                                114,
                                109,
                                97,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                20,
                                115,
                                99,
                                104,
                                109,
                                0,
                                0,
                                0,
                                0,
                                99,
                                101,
                                110,
                                99,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                0,
                                40,
                                115,
                                99,
                                104,
                                105,
                                0,
                                0,
                                0,
                                32,
                                116,
                                101,
                                110,
                                99,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                1,
                                8,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ]);
                        });
                        function Zi(e, t, n, r, i) {
                            if (r >= i) return null;
                            for(var a1 = -1, o = -1, s1 = 0; s1 < n.length; s1++)if (n[s1].some(function(e) {
                                return null != e && "" != e.g.trim();
                            })) {
                                a1 = s1;
                                break;
                            }
                            for(s1 = n.length - 1; 0 <= s1; s1--)if (n[s1].some(function(e) {
                                return null != e && "" != e.g.trim();
                            })) {
                                o = s1;
                                break;
                            }
                            if (-1 === a1 || -1 === o) return null;
                            for(var u = s1 = !1, l = "white", c = "black", d = $i(r, i, s1, u, l, c); a1 <= o; a1++){
                                for(var f = n[a1], h = -1, g = -1, p = 0; p < f.length; p++)if (null != f[p] && "" !== f[p].g.trim()) {
                                    h = p;
                                    break;
                                }
                                for(p = f.length - 1; 0 <= p; p--)if (null != f[p] && "" !== f[p].g.trim()) {
                                    g = p;
                                    break;
                                }
                                if (-1 === h || -1 === g) f = ea(r, i), e.nestedCues.push(f);
                                else {
                                    for(; h <= g; h++)if (p = f[h]) {
                                        var m = p.l, v = p.i, y = p.j, E = p.h;
                                        m == s1 && v == u && y == l && E == c || (d.payload && e.nestedCues.push(d), d = $i(r, i, m, v, y, E), s1 = m, u = v, l = y, c = E), d.payload += p.g;
                                    } else d.payload += " ";
                                    d.payload && e.nestedCues.push(d), a1 !== o && (d = ea(r, i), e.nestedCues.push(d)), d = $i(r, i, s1, u, l, c);
                                }
                            }
                            return e.nestedCues.length ? {
                                cue: e,
                                stream: t
                            } : null;
                        }
                        function $i(e, t, n, r, i, a1) {
                            return e = new ne(e, t, ""), n && e.textDecoration.push("underline"), r && (e.fontStyle = "italic"), e.color = i, e.backgroundColor = a1, e;
                        }
                        function ea(e, t) {
                            var n = new ne(e, t, "");
                            return n.lineBreak = !0, n;
                        }
                        function ta(e, t, n, r, i) {
                            this.g = e, this.l = t, this.i = n, this.h = r, this.j = i;
                        }
                        function na(e, t) {
                            this.i = [], this.g = 1, this.h = 0, this.u = e, this.s = t, this.j = this.m = !1, this.l = "white", this.o = "black", ia(this);
                        }
                        function ra(e, t, n) {
                            return Zi(new ne(t, n, ""), "CC" + (e.u << 1 | e.s + 1), e.i, t, n);
                        }
                        function ia(e) {
                            sa(e, 0, 15), e.g = 1;
                        }
                        function aa(e, t, n) {
                            if (!(32 > n || 127 < n)) {
                                var r = "";
                                switch(t){
                                    case ua:
                                        r = fa.has(n) ? fa.get(n) : String.fromCharCode(n);
                                        break;
                                    case la:
                                        r = ha.get(n);
                                        break;
                                    case ca:
                                        e.i[e.g].pop(), r = ga.get(n);
                                        break;
                                    case da:
                                        e.i[e.g].pop(), r = pa.get(n);
                                }
                                r && e.i[e.g].push(new ta(r, e.m, e.j, e.o, e.l));
                            }
                        }
                        function oa(e, t, n, r) {
                            if (!(0 > n || 0 > t)) {
                                if (t >= n) for(--r; 0 <= r; r--)e.i[t + r] = e.i[n + r].map(function(e) {
                                    return e;
                                });
                                else for(var i = 0; i < r; i++)e.i[t + i] = e.i[n + i].map(function(e) {
                                    return e;
                                });
                            }
                        }
                        function sa(e, t, n) {
                            for(var r = 0; r <= n; r++)e.i[t + r] = [];
                        }
                        var ua = 0, la = 1, ca = 2, da = 3, fa = new Map([
                            [
                                39,
                                "\u2019"
                            ],
                            [
                                42,
                                "\xe1"
                            ],
                            [
                                92,
                                "\xe9"
                            ],
                            [
                                92,
                                "\xe9"
                            ],
                            [
                                94,
                                "\xed"
                            ],
                            [
                                95,
                                "\xf3"
                            ],
                            [
                                96,
                                "\xfa"
                            ],
                            [
                                123,
                                "\xe7"
                            ],
                            [
                                124,
                                "\xf7"
                            ],
                            [
                                125,
                                "\xd1"
                            ],
                            [
                                126,
                                "\xf1"
                            ],
                            [
                                127,
                                "\u2588"
                            ]
                        ]), ha = new Map([
                            [
                                48,
                                "\xae"
                            ],
                            [
                                49,
                                "\xb0"
                            ],
                            [
                                50,
                                "\xbd"
                            ],
                            [
                                51,
                                "\xbf"
                            ],
                            [
                                52,
                                "\u2122"
                            ],
                            [
                                53,
                                "\xa2"
                            ],
                            [
                                54,
                                "\xa3"
                            ],
                            [
                                55,
                                "\u266A"
                            ],
                            [
                                56,
                                "\xe0"
                            ],
                            [
                                57,
                                "\u2800"
                            ],
                            [
                                58,
                                "\xe8"
                            ],
                            [
                                59,
                                "\xe2"
                            ],
                            [
                                60,
                                "\xea"
                            ],
                            [
                                61,
                                "\xee"
                            ],
                            [
                                62,
                                "\xf4"
                            ],
                            [
                                63,
                                "\xfb"
                            ]
                        ]), ga = new Map([
                            [
                                32,
                                "\xc1"
                            ],
                            [
                                33,
                                "\xc9"
                            ],
                            [
                                34,
                                "\xd3"
                            ],
                            [
                                35,
                                "\xda"
                            ],
                            [
                                36,
                                "\xdc"
                            ],
                            [
                                37,
                                "\xfc"
                            ],
                            [
                                38,
                                "\u2018"
                            ],
                            [
                                39,
                                "\xa1"
                            ],
                            [
                                40,
                                "*"
                            ],
                            [
                                41,
                                "'"
                            ],
                            [
                                42,
                                "\u2500"
                            ],
                            [
                                43,
                                "\xa9"
                            ],
                            [
                                44,
                                "\u2120"
                            ],
                            [
                                45,
                                "\xb7"
                            ],
                            [
                                46,
                                "\u201C"
                            ],
                            [
                                47,
                                "\u201D"
                            ],
                            [
                                48,
                                "\xc0"
                            ],
                            [
                                49,
                                "\xc2"
                            ],
                            [
                                50,
                                "\xc7"
                            ],
                            [
                                51,
                                "\xc8"
                            ],
                            [
                                52,
                                "\xca"
                            ],
                            [
                                53,
                                "\xcb"
                            ],
                            [
                                54,
                                "\xeb"
                            ],
                            [
                                55,
                                "\xce"
                            ],
                            [
                                56,
                                "\xcf"
                            ],
                            [
                                57,
                                "\xef"
                            ],
                            [
                                58,
                                "\xd4"
                            ],
                            [
                                59,
                                "\xd9"
                            ],
                            [
                                60,
                                "\xf9"
                            ],
                            [
                                61,
                                "\xdb"
                            ],
                            [
                                62,
                                "\xab"
                            ],
                            [
                                63,
                                "\xbb"
                            ]
                        ]), pa = new Map([
                            [
                                32,
                                "\xc3"
                            ],
                            [
                                33,
                                "\xe3"
                            ],
                            [
                                34,
                                "\xcd"
                            ],
                            [
                                35,
                                "\xcc"
                            ],
                            [
                                36,
                                "\xec"
                            ],
                            [
                                37,
                                "\xd2"
                            ],
                            [
                                38,
                                "\xf2"
                            ],
                            [
                                39,
                                "\xd5"
                            ],
                            [
                                40,
                                "\xf5"
                            ],
                            [
                                41,
                                "{"
                            ],
                            [
                                42,
                                "}"
                            ],
                            [
                                43,
                                "\\"
                            ],
                            [
                                44,
                                "^"
                            ],
                            [
                                45,
                                "_"
                            ],
                            [
                                46,
                                "|"
                            ],
                            [
                                47,
                                "~"
                            ],
                            [
                                48,
                                "\xc4"
                            ],
                            [
                                49,
                                "\xe4"
                            ],
                            [
                                50,
                                "\xd6"
                            ],
                            [
                                51,
                                "\xf6"
                            ],
                            [
                                52,
                                "\xdf"
                            ],
                            [
                                53,
                                "\xa5"
                            ],
                            [
                                54,
                                "\xa4"
                            ],
                            [
                                55,
                                "\u2502"
                            ],
                            [
                                56,
                                "\xc5"
                            ],
                            [
                                57,
                                "\xe5"
                            ],
                            [
                                58,
                                "\xd8"
                            ],
                            [
                                59,
                                "\xf8"
                            ],
                            [
                                60,
                                "\u250C"
                            ],
                            [
                                61,
                                "\u2510"
                            ],
                            [
                                62,
                                "\u2514"
                            ],
                            [
                                63,
                                "\u2518"
                            ]
                        ]);
                        function ma(e, t) {
                            this.h = Ta, this.o = new na(e, t), this.i = new na(e, t), this.l = new na(e, t), this.g = this.i, this.j = 0, this.m = null;
                        }
                        function va(e, t, n) {
                            e.g = e.i;
                            var r = e.g, i = null;
                            return e.h !== Aa && e.h !== _a && (i = ra(r, e.j, n), (n = e.i).g = 0 < n.h ? n.h : 0, sa(n, 0, 15), (n = e.l).g = 0 < n.h ? n.h : 0, sa(n, 0, 15), r.g = 15), e.h = Aa, r.h = t, i;
                        }
                        function ya(e) {
                            e.h = ba, e.g = e.l, e.g.h = 0;
                        }
                        function Ea(e) {
                            W("Cea608DataChannel", "CEA-608 text mode entered, but is unsupported"), e.g = e.o, e.h = _a;
                        }
                        var Ta = 0, ba = 1, Aa = 3, _a = 4, Sa = "black green blue cyan red yellow magenta black".split(" "), wa = "white green blue cyan red yellow magenta white_italics".split(" ");
                        function Ia() {
                            this.l = !1, this.B = this.F = 0, this.D = Ma, this.i = [], this.g = this.h = this.j = 0, this.u = this.o = !1, this.s = "white", this.m = "black", Ra(this);
                        }
                        function Ra(e) {
                            e.i = [];
                            for(var t = 0; 15 > t; t++)e.i.push(Ca());
                        }
                        function Ca() {
                            for(var e = [], t = 0; 42 > t; t++)e.push(null);
                            return e;
                        }
                        function Da(e, t) {
                            ka(e) && (e.i[e.h][e.g] = new ta(t, e.u, e.o, e.m, e.s), e.g++);
                        }
                        function ka(e) {
                            var t = e.g < e.B && 0 <= e.g;
                            return e.h < e.F && 0 <= e.h && t;
                        }
                        function Na(e, t, n) {
                            var r = new ne(e.j, t, "");
                            return r.textAlign = e.D === La ? "left" : e.D === xa ? "right" : ae, (n = Zi(r, "svc" + n, e.i, e.j, t)) && (e.j = t), n;
                        }
                        Ia.prototype.isVisible = function() {
                            return this.l;
                        };
                        var La = 0, xa = 1, Ma = 2;
                        function Oa() {
                            this.i = [], this.h = null, this.g = 0;
                        }
                        function Pa(e, t) {
                            3 === t.type ? (e.g = 2 * (63 & t.value) - 1, e.h = []) : e.h && (0 < e.g && (e.h.push(t), e.g--), 0 === e.g && (e.i.push(new Fa(e.h)), e.h = null, e.g = 0));
                        }
                        function Fa(e) {
                            this.g = 0, this.h = e;
                        }
                        function Ua(e) {
                            if (!e.la()) throw new De(2, 2, 3e3);
                            return e.h[e.g++];
                        }
                        function ja(e) {
                            this.i = e, this.h = [
                                null,
                                null,
                                null,
                                null,
                                null,
                                null,
                                null,
                                null
                            ], this.g = null;
                        }
                        function Ba(e, t, n, r) {
                            if (128 <= n && 135 >= n) r = 7 & n, e.h[r] && (e.g = e.h[r]);
                            else {
                                if (136 === n) {
                                    n = Ua(t).value, t = null;
                                    for(var i = (n = l(Ga(e, n))).next(); !i.done; i = n.next())(i = e.h[i.value]).isVisible() && (t = Na(i, r, e.i)), Ra(i);
                                    return t;
                                }
                                if (137 === n) for(n = (t = l(Ga(e, t = Ua(t).value))).next(); !n.done; n = t.next())(n = e.h[n.value]).isVisible() || (n.j = r), n.l = !0;
                                else {
                                    if (138 === n) {
                                        for(n = Ua(t).value, t = null, i = (n = l(Ga(e, n))).next(); !i.done; i = n.next())(i = e.h[i.value]).isVisible() && (t = Na(i, r, e.i)), i.l = !1;
                                        return t;
                                    }
                                    if (139 === n) {
                                        for(n = Ua(t).value, t = null, i = (n = l(Ga(e, n))).next(); !i.done; i = n.next())(i = e.h[i.value]).isVisible() ? t = Na(i, r, e.i) : i.j = r, i.l = !i.l;
                                        return t;
                                    }
                                    if (140 === n) return Ha(e, t = Ua(t).value, r);
                                    if (143 === n) return r = Ha(e, 255, r), Va(e), r;
                                    if (144 === n) t.skip(1), r = Ua(t).value, e.g && (e.g.o = 0 < (128 & r), e.g.u = 0 < (64 & r));
                                    else if (145 === n) r = Ua(t).value, n = Ua(t).value, t.skip(1), e.g && (t = Ka((48 & n) >> 4, (12 & n) >> 2, 3 & n), e.g.s = Ka((48 & r) >> 4, (12 & r) >> 2, 3 & r), e.g.m = t);
                                    else if (146 === n) r = Ua(t).value, t = Ua(t).value, e.g && ((e = e.g).h = 15 & r, e.g = 63 & t);
                                    else if (151 === n) t.skip(1), t.skip(1), r = Ua(t).value, t.skip(1), e.g && (e.g.D = 3 & r);
                                    else if (152 <= n && 159 >= n) {
                                        if (n = (15 & n) - 8, !(i = null !== e.h[n])) {
                                            var a1 = new Ia;
                                            a1.j = r, e.h[n] = a1;
                                        }
                                        r = Ua(t).value, Ua(t), Ua(t), a1 = Ua(t).value;
                                        var o = Ua(t).value;
                                        t = Ua(t).value, i && 0 == (7 & t) || ((t = e.h[n]).h = 0, t.g = 0, t.u = !1, t.o = !1, t.s = "white", t.m = "black"), (t = e.h[n]).l = 0 < (32 & r), t.F = 1 + (15 & a1), t.B = 1 + (63 & o), e.g = e.h[n];
                                    }
                                }
                            }
                            return null;
                        }
                        function Ga(e, t) {
                            for(var n = [], r = 0; 8 > r; r++)1 == (1 & t) && e.h[r] && n.push(r), t >>= 1;
                            return n;
                        }
                        function Ha(e, t, n) {
                            for(var r = null, i = (t = l(Ga(e, t))).next(); !i.done; i = t.next()){
                                i = i.value;
                                var a1 = e.h[i];
                                a1.isVisible() && (r = Na(a1, n, e.i)), e.h[i] = null;
                            }
                            return r;
                        }
                        function Va(e) {
                            e.g = null, e.h = [
                                null,
                                null,
                                null,
                                null,
                                null,
                                null,
                                null,
                                null
                            ];
                        }
                        function Ka(e, t, n) {
                            var r = {
                                0: 0,
                                1: 0,
                                2: 1,
                                3: 1
                            };
                            return Ya[(e = r[e]) << 2 | (t = r[t]) << 1 | (n = r[n])];
                        }
                        Fa.prototype.la = function() {
                            return this.g < this.h.length;
                        }, Fa.prototype.$ = function() {
                            return this.g;
                        }, Fa.prototype.skip = function(e) {
                            if (this.g + e > this.h.length) throw new De(2, 2, 3e3);
                            this.g += e;
                        };
                        var qa = new Map([
                            [
                                32,
                                " "
                            ],
                            [
                                33,
                                "\xa0"
                            ],
                            [
                                37,
                                "\u2026"
                            ],
                            [
                                42,
                                "\u0160"
                            ],
                            [
                                44,
                                "\u0152"
                            ],
                            [
                                48,
                                "\u2588"
                            ],
                            [
                                49,
                                "\u2018"
                            ],
                            [
                                50,
                                "\u2019"
                            ],
                            [
                                51,
                                "\u201C"
                            ],
                            [
                                52,
                                "\u201D"
                            ],
                            [
                                53,
                                "\u2022"
                            ],
                            [
                                57,
                                "\u2122"
                            ],
                            [
                                58,
                                "\u0161"
                            ],
                            [
                                60,
                                "\u0153"
                            ],
                            [
                                61,
                                "\u2120"
                            ],
                            [
                                63,
                                "\u0178"
                            ],
                            [
                                118,
                                "\u215B"
                            ],
                            [
                                119,
                                "\u215C"
                            ],
                            [
                                120,
                                "\u215D"
                            ],
                            [
                                121,
                                "\u215E"
                            ],
                            [
                                122,
                                "\u2502"
                            ],
                            [
                                123,
                                "\u2510"
                            ],
                            [
                                124,
                                "\u2514"
                            ],
                            [
                                125,
                                "\u2500"
                            ],
                            [
                                126,
                                "\u2518"
                            ],
                            [
                                127,
                                "\u250C"
                            ]
                        ]), Ya = "black blue green cyan red magenta yellow white".split(" ");
                        function Wa() {
                            this.h = [], this.g = [], this.i = new Oa, this.l = 0, this.s = new Map([
                                [
                                    "CC1",
                                    new ma(0, 0)
                                ],
                                [
                                    "CC2",
                                    new ma(0, 1)
                                ],
                                [
                                    "CC3",
                                    new ma(1, 0)
                                ],
                                [
                                    "CC4",
                                    new ma(1, 1)
                                ]
                            ]), this.o = this.m = 0, this.j = new Map, za(this);
                        }
                        function za(e) {
                            e.m = 0, e.o = 0;
                            for(var t = (e = l(e.s.values())).next(); !t.done; t = e.next())(t = t.value).h = 2, t.g = t.i, t.m = null, ia(t.i), ia(t.l), ia(t.o);
                        }
                        function Xa(e, t) {
                            var n = t.type;
                            if (16 == (112 & t.wa)) {
                                var r = t.wa >> 3 & 1;
                                0 === n ? e.m = r : e.o = r;
                            }
                            if (n = e.s.get("CC" + (n << 1 | (n ? e.o : e.m) + 1)), 255 === t.wa && 255 === t.La || !t.wa && !t.La || !Ja(t.wa) || !Ja(t.La)) return 45 <= ++e.l && za(e), null;
                            if (e.l = 0, t.wa &= 127, t.La &= 127, !t.wa && !t.La) return null;
                            if (r = null, 16 == (112 & t.wa)) e: {
                                var i = t.wa;
                                if (r = t.La, n.m === (i << 8 | r)) n.m = null;
                                else if (n.m = i << 8 | r, 16 == (240 & i) && 64 == (192 & r)) {
                                    i = [
                                        11,
                                        11,
                                        1,
                                        2,
                                        3,
                                        4,
                                        12,
                                        13,
                                        14,
                                        15,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ][(7 & i) << 1 | r >> 5 & 1];
                                    var a1 = (30 & r) >> 1, o = "white", s1 = !1;
                                    if (7 > a1 ? o = wa[a1] : 7 === a1 && (s1 = !0), r = 1 == (1 & r), n.h !== _a) {
                                        if (a1 = n.g, n.h === Aa && i !== a1.g) {
                                            var u = 1 + i - a1.h;
                                            oa(a1, u, 1 + a1.g - a1.h, a1.h), sa(a1, 0, u - 1), sa(a1, i + 1, 15 - i);
                                        }
                                        a1.g = i, n.g.m = r, n.g.j = s1, n.g.l = o, n.g.o = "black";
                                    }
                                } else if (17 == (247 & i) && 32 == (240 & r)) n.g.m = !1, n.g.j = !1, n.g.l = "white", aa(n.g, ua, 32), o = !1, "white_italics" === (i = wa[(14 & r) >> 1]) && (i = "white", o = !0), n.g.m = 1 == (1 & r), n.g.j = o, n.g.l = i;
                                else if (16 == (247 & i) && 32 == (240 & r) || 23 == (247 & i) && 45 == (255 & r)) o = "black", 0 == (7 & i) && (o = Sa[(14 & r) >> 1]), n.g.o = o;
                                else if (17 == (247 & i) && 48 == (240 & r)) aa(n.g, la, r);
                                else if (18 == (246 & i) && 32 == (224 & r)) aa(n.g, 1 & i ? da : ca, r);
                                else if (20 == (246 & i) && 32 == (240 & r)) {
                                    switch(r = t.pts, i = null, t.La){
                                        case 32:
                                            ya(n);
                                            break;
                                        case 33:
                                            (n = n.g).i[n.g].pop();
                                            break;
                                        case 37:
                                            i = va(n, 2, r);
                                            break;
                                        case 38:
                                            i = va(n, 3, r);
                                            break;
                                        case 39:
                                            i = va(n, 4, r);
                                            break;
                                        case 40:
                                            aa(n.g, ua, 32);
                                            break;
                                        case 41:
                                            n.h = 2, n.g = n.i, n.g.h = 0, n.j = r;
                                            break;
                                        case 42:
                                            ia(n.o), Ea(n);
                                            break;
                                        case 43:
                                            Ea(n);
                                            break;
                                        case 44:
                                            i = n.i, o = null, n.h !== _a && (o = ra(i, n.j, r)), sa(i, 0, 15), i = o;
                                            break;
                                        case 45:
                                            i = n.g, n.h !== Aa ? i = null : (o = ra(i, n.j, r), oa(i, (s1 = i.g - i.h + 1) - 1, s1, i.h), sa(i, 0, s1 - 1), sa(i, i.g, 15 - i.g), n.j = r, i = o);
                                            break;
                                        case 46:
                                            sa(n.l, 0, 15);
                                            break;
                                        case 47:
                                            i = null, n.h !== _a && (i = ra(n.i, n.j, r)), o = n.l, n.l = n.i, n.i = o, ya(n), n.j = r;
                                    }
                                    r = i;
                                    break e;
                                }
                                r = null;
                            }
                            else i = t.La, aa(n.g, ua, t.wa), aa(n.g, ua, i);
                            return r;
                        }
                        function Qa(e, t) {
                            var n = [];
                            try {
                                for(; t.la();){
                                    var r = Ua(t).value, i = (224 & r) >> 5, a1 = 31 & r;
                                    if (7 === i && 0 != a1 && (i = 63 & Ua(t).value), 0 != i) {
                                        e.j.has(i) || e.j.set(i, new ja(i));
                                        for(var o = e.j.get(i), s1 = t.$(); t.$() - s1 < a1;){
                                            var u = Ua(i = t), l = u.value, c = u.pts;
                                            if (16 === l && (l = l << 16 | Ua(i).value), 0 <= l && 31 >= l) {
                                                var d = c;
                                                if (o.g) {
                                                    var f = o.g;
                                                    switch(i = null, l){
                                                        case 8:
                                                            !ka(f) || 0 >= f.g && 0 >= f.h || (0 >= f.g ? (f.g = f.B - 1, f.h--) : f.g--, f.i[f.h][f.g] = null);
                                                            break;
                                                        case 13:
                                                            if (f.isVisible() && (i = Na(f, d, o.i)), f.h + 1 >= f.F) {
                                                                d = f;
                                                                for(var h = 0, g = 1; 15 > g; g++, h++)d.i[h] = d.i[g];
                                                                for(g = 0; 1 > g; g++, h++)d.i[h] = Ca();
                                                            } else f.h++;
                                                            f.g = 0;
                                                            break;
                                                        case 14:
                                                            f.isVisible() && (i = Na(f, d, o.i)), f.i[f.h] = Ca(), f.g = 0;
                                                            break;
                                                        case 12:
                                                            f.isVisible() && (i = Na(f, d, o.i)), Ra(f), (d = f).h = 0, d.g = 0;
                                                    }
                                                    var p = i;
                                                } else p = null;
                                            } else if (128 <= l && 159 >= l) p = Ba(o, i, l, c);
                                            else {
                                                if (4096 <= l && 4127 >= l) 8 <= (d = 255 & l) && 15 >= d ? i.skip(1) : 16 <= d && 23 >= d ? i.skip(2) : 24 <= d && 31 >= d && i.skip(3);
                                                else if (4224 <= l && 4255 >= l) 128 <= (d = 255 & l) && 135 >= d ? i.skip(4) : 136 <= d && 143 >= d && i.skip(5);
                                                else if (32 <= l && 127 >= l) i = l, o.g && Da(o.g, 127 === i ? "\u266A" : String.fromCharCode(i));
                                                else if (160 <= l && 255 >= l) o.g && Da(o.g, String.fromCharCode(l));
                                                else if (4128 <= l && 4223 >= l) {
                                                    if (i = 255 & l, o.g) {
                                                        if (qa.has(i)) {
                                                            var m = qa.get(i);
                                                            Da(o.g, m);
                                                        } else Da(o.g, "_");
                                                    }
                                                } else 4256 <= l && 4351 >= l && o.g && Da(o.g, 160 != (255 & l) ? "_" : "[CC]");
                                                p = null;
                                            }
                                            (i = p) && n.push(i);
                                        }
                                    }
                                }
                            } catch (e) {
                                if (!(e instanceof De && 3e3 === e.code)) throw e;
                                W("CEA708_INVALID_DATA", "Buffer read out of bounds / invalid CEA-708 Data.");
                            }
                            return n;
                        }
                        function Ja(e) {
                            for(var t = 0; e;)t ^= 1 & e, e >>= 1;
                            return 1 === t;
                        }
                        function Za() {}
                        function $a(e, t) {
                            var n = null, r = null, i = null, a1 = e.L();
                            return 1 & t && (i = e.ab()), 2 & t && e.skip(4), 8 & t && (n = e.L()), 16 & t && (r = e.L()), {
                                trackId: a1,
                                Ae: n,
                                wf: r,
                                sh: i
                            };
                        }
                        function eo(e, t) {
                            return {
                                ue: 1 == t ? e.ab() : e.L()
                            };
                        }
                        function to(e, t) {
                            return 1 == t ? (e.skip(8), e.skip(8)) : (e.skip(4), e.skip(4)), {
                                timescale: e.L()
                            };
                        }
                        function no(e, t, n) {
                            var r = e.L(), i = [], a1 = null;
                            1 & n && (a1 = e.L()), 4 & n && e.skip(4);
                            for(var o = 0; o < r; o++){
                                var s1 = {
                                    de: null,
                                    sampleSize: null,
                                    fd: null
                                };
                                256 & n && (s1.de = e.L()), 512 & n && (s1.sampleSize = e.L()), 1024 & n && e.skip(4), 2048 & n && (s1.fd = 0 == t ? e.L() : e.Oe()), i.push(s1);
                            }
                            return {
                                xh: r,
                                Qe: i,
                                vf: a1
                            };
                        }
                        function ro() {
                            this.j = new Map, this.i = this.h = 0, this.g = io;
                        }
                        Za.prototype.init = function() {}, Za.prototype.parse = function() {
                            return [];
                        }, ro.prototype.init = function(e) {
                            function t(e) {
                                return function() {
                                    n.g = e;
                                };
                            }
                            var n = this, r = [], i = [];
                            if ((new Vr).box("moov", Kr).box("mvex", Kr).T("trex", function(e) {
                                var t = e.reader;
                                t.skip(4), t.skip(4), e = t.L(), t = t.L(), n.h = e, n.i = t;
                            }).box("trak", Kr).T("tkhd", function(e) {
                                var t = e.reader;
                                1 == e.version ? (t.skip(8), t.skip(8)) : (t.skip(4), t.skip(4)), e = t.L(), r.push(e);
                            }).box("mdia", Kr).T("mdhd", function(e) {
                                e = to(e.reader, e.version), i.push(e.timescale);
                            }).box("minf", Kr).box("stbl", Kr).T("stsd", qr).box("avc1", t(ao)).box("avc3", t(ao)).box("hev1", t(oo)).box("hvc1", t(oo)).box("dvh1", t(oo)).box("dvhe", t(oo)).parse(e, !0), !r.length || !i.length || r.length != i.length) throw new De(2, 2, 2010);
                            this.g == io && Y("Unable to determine bitstream format for CEA parsing!"), r.forEach(function(e, t) {
                                n.j.set(e, i[t]);
                            });
                        }, ro.prototype.parse = function(e) {
                            var t = this;
                            if (this.g == io) return [];
                            var n = [], r = this.h, i = this.i, a1 = [], o = null, s1 = null, u = null, d = 9e4;
                            return (new Vr).box("moof", function(e) {
                                o = e.start, Kr(e);
                            }).box("traf", Kr).T("trun", function(e) {
                                e = no(e.reader, e.version, e.flags), a1 = e.Qe, s1 = e.vf;
                            }).T("tfhd", function(e) {
                                e = $a(e.reader, e.flags), r = e.Ae || t.h, i = e.wf || t.i, e = e.trackId, t.j.has(e) && (d = t.j.get(e));
                            }).T("tfdt", function(e) {
                                u = eo(e.reader, e.version).ue;
                            }).box("mdat", function(e) {
                                if (null === u) throw new De(2, 2, 2010);
                                e: {
                                    var f = e.reader, h = u, g = d, p = r, m = i, v = a1, y = 0, E = m;
                                    for(v.length && (E = v[0].sampleSize || m), f.skip((o || 0) + (s1 || 0) - e.start - 8); f.la();){
                                        e = f.L();
                                        var T = f.Ra();
                                        switch(t.g){
                                            case ao:
                                                T = 6 == (T &= 31);
                                                break;
                                            case oo:
                                                T = 39 == (T = T >> 1 & 63) || 40 == T;
                                                break;
                                            default:
                                                break e;
                                        }
                                        if (T) {
                                            T = 0, v.length > y && (T = v[y].fd || 0), T = (h + T) / g;
                                            for(var b, A = [], _ = f.$a(e - 1), S = b = 0; S < _.length;)2 == b && 3 == _[S] ? (b = 0, (_ = [].concat(c(_))).splice(S, 1), _ = new Uint8Array(_)) : 0 == _[S] ? b++ : b = 0, S++;
                                            for(b = _, S = 0; S < b.length;){
                                                for(_ = 0; 255 == b[S];)_ += 255, S++;
                                                _ += b[S++];
                                                for(var w = 0; 255 == b[S];)w += 255, S++;
                                                w += b[S++], 4 == _ && A.push(b.subarray(S, S + w)), S += w;
                                            }
                                            for(b = (A = l(A)).next(); !b.done; b = A.next())n.push({
                                                hg: b.value,
                                                pts: T
                                            });
                                        } else try {
                                            f.skip(e - 1);
                                        } catch (e) {
                                            break;
                                        }
                                        0 == (E -= e + 4) && (h = v.length > y ? h + (v[y].de || p) : h + p, y++, E = v.length > y && v[y].sampleSize || m);
                                    }
                                }
                            }).parse(e, !1), n;
                        };
                        var io = 0, ao = 1, oo = 2;
                        function so(e) {
                            this.h = new Za, e.includes("video/mp4") && (this.h = new ro), this.g = new Wa;
                        }
                        function uo(e, t, n, r, i) {
                            this.xa = e, this.Aa = t, this.ka = n, this.Od = void 0 === r ? null : r, this.timescale = i;
                        }
                        function lo(e, t, n, r, i, a1, o, s1, u, l, c, d, f, h, g) {
                            l = void 0 === l ? [] : l, h = void 0 === h ? co : h, this.startTime = e, this.j = this.endTime = t, this.s = n, this.Aa = r, this.ka = i, this.h = a1, this.timestampOffset = o, this.appendWindowStart = s1, this.appendWindowEnd = u, this.i = l, this.tilesLayout = void 0 === c ? "" : c, this.o = void 0 === d ? null : d, this.g = void 0 === f ? null : f, this.status = h, this.l = void 0 === g ? null : g, this.m = null;
                        }
                        so.prototype.init = function(e) {
                            this.h.init(e);
                        }, uo.prototype.kc = function() {
                            return this.Aa;
                        }, uo.prototype.fc = function() {
                            return this.ka;
                        }, B("shaka.media.InitSegmentReference", uo), uo.prototype.getEndByte = uo.prototype.fc, uo.prototype.getStartByte = uo.prototype.kc, (r = lo.prototype).xa = function() {
                            return this.s();
                        }, r.getStartTime = function() {
                            return this.startTime;
                        }, r.Df = function() {
                            return this.endTime;
                        }, r.kc = function() {
                            return this.Aa;
                        }, r.fc = function() {
                            return this.ka;
                        }, r.Uf = function() {
                            return this.tilesLayout;
                        }, r.Tf = function() {
                            return this.o;
                        }, r.Db = function() {
                            return this.status;
                        }, r.ag = function() {
                            this.status = fo;
                        }, r.Xe = function(e) {
                            this.m = e;
                        }, r.Rf = function() {
                            return this.m;
                        }, B("shaka.media.SegmentReference", lo), lo.prototype.getThumbnailSprite = lo.prototype.Rf, lo.prototype.setThumbnailSprite = lo.prototype.Xe, lo.prototype.markAsUnavailable = lo.prototype.ag, lo.prototype.getStatus = lo.prototype.Db, lo.prototype.getTileDuration = lo.prototype.Tf, lo.prototype.getTilesLayout = lo.prototype.Uf, lo.prototype.getEndByte = lo.prototype.fc, lo.prototype.getStartByte = lo.prototype.kc, lo.prototype.getEndTime = lo.prototype.Df, lo.prototype.getStartTime = lo.prototype.getStartTime, lo.prototype.getUris = lo.prototype.xa;
                        var co = 0, fo = 1;
                        function ho(e) {
                            return !e || 1 == e.length && 1e-6 > e.end(0) - e.start(0) ? null : 1 == e.length && 0 > e.start(0) ? 0 : e.length ? e.start(0) : null;
                        }
                        function go(e) {
                            return !e || 1 == e.length && 1e-6 > e.end(0) - e.start(0) ? null : e.length ? e.end(e.length - 1) : null;
                        }
                        function po(e, t) {
                            return !(!e || !e.length || 1 == e.length && 1e-6 > e.end(0) - e.start(0) || t > e.end(e.length - 1)) && t >= e.start(0);
                        }
                        function mo(e, t) {
                            if (!e || !e.length || 1 == e.length && 1e-6 > e.end(0) - e.start(0)) return 0;
                            for(var n = 0, r = l(vo(e)), i = r.next(); !i.done; i = r.next()){
                                var a1 = i.value;
                                i = a1.start, (a1 = a1.end) > t && (n += a1 - Math.max(i, t));
                            }
                            return n;
                        }
                        function vo(e) {
                            if (!e) return [];
                            for(var t = [], n = 0; n < e.length; n++)t.push({
                                start: e.start(n),
                                end: e.end(n)
                            });
                            return t;
                        }
                        function yo() {}
                        function Eo(e, t) {
                            var n = (127 & e[t]) << 21;
                            return n |= (127 & e[t + 1]) << 14, (n |= (127 & e[t + 2]) << 7) | 127 & e[t + 3];
                        }
                        function To(e) {
                            var t = {
                                key: e.type,
                                description: "",
                                data: ""
                            };
                            if ("TXXX" === e.type) {
                                if (2 > e.size || 3 !== e.data[0]) return null;
                                var n = e.data.subarray(1).indexOf(0);
                                if (-1 === n) return null;
                                var r = yt(Ie(e.data, 1, n));
                                return e = yt(Ie(e.data, 2 + n)).replace(/\0*$/, ""), t.description = r, t.data = e, t;
                            }
                            return "WXXX" === e.type ? 2 > e.size || 3 !== e.data[0] || -1 === (n = e.data.subarray(1).indexOf(0)) ? null : (r = yt(Ie(e.data, 1, n)), e = yt(Ie(e.data, 2 + n)).replace(/\0*$/, ""), t.description = r, t.data = e, t) : "PRIV" === e.type ? 2 > e.size || -1 === (r = e.data.indexOf(0)) ? null : (r = yt(Ie(e.data, 0, r)), e = we(e.data.subarray(r.length + 1)), t.description = r, t.data = e, t) : "T" === e.type[0] ? 2 > e.size || 3 !== e.data[0] ? null : (e = yt(e.data.subarray(1)).replace(/\0*$/, ""), t.data = e, t) : "W" === e.type[0] ? (e = yt(e.data).replace(/\0*$/, ""), t.data = e, t) : e.data ? (t.data = we(e.data), t) : null;
                        }
                        function bo(e) {
                            for(var t = 0, n = []; t + 10 <= e.length && 73 === e[t] && 68 === e[t + 1] && 51 === e[t + 2] && 255 > e[t + 3] && 255 > e[t + 4] && 128 > e[t + 6] && 128 > e[t + 7] && 128 > e[t + 8] && 128 > e[t + 9];){
                                var r = Eo(e, t + 6);
                                for(e[t + 5] >> 6 & 1 && (t += 10), r = (t += 10) + r; t + 10 < r;){
                                    var i = e.subarray(t), a1 = Eo(i, 4);
                                    (a1 = To(i = {
                                        type: String.fromCharCode(i[0], i[1], i[2], i[3]),
                                        size: a1,
                                        data: i.subarray(10, 10 + a1)
                                    })) && n.push(a1), t += i.size + 10;
                                }
                                t + 10 <= e.length && 51 === e[t] && 68 === e[t + 1] && 73 === e[t + 2] && 255 > e[t + 3] && 255 > e[t + 4] && 128 > e[t + 6] && 128 > e[t + 7] && 128 > e[t + 8] && 128 > e[t + 9] && (t += 10);
                            }
                            return n;
                        }
                        function Ao() {
                            this.o = null, this.s = !1, this.l = this.m = null, this.B = [], this.g = this.h = null, this.u = [], this.j = null, this.i = [];
                        }
                        function _o(e) {
                            if (1 != (e[0] << 16 | e[1] << 8 | e[2])) return null;
                            var t = {
                                data: new Uint8Array(0),
                                wh: 6 + (e[4] << 8 | e[5]),
                                pts: null,
                                dts: null
                            }, n = e[7];
                            return 192 & n && (t.pts = 536870912 * (14 & e[9]) + 4194304 * (255 & e[10]) + 16384 * (254 & e[11]) + 128 * (255 & e[12]) + (254 & e[13]) / 2, t.dts = t.pts, 64 & n && (t.dts = 536870912 * (14 & e[14]) + 4194304 * (255 & e[15]) + 16384 * (254 & e[16]) + 128 * (255 & e[17]) + (254 & e[18]) / 2)), t.data = e.subarray(9 + e[8]), t;
                        }
                        function So(e) {
                            for(var t = Math.min(1e3, e.length - 564), n = 0; n < t;){
                                if (71 === e[n] && 71 === e[n + 188] && 71 === e[n + 376]) return n;
                                n++;
                            }
                            return -1;
                        }
                        function wo(e, t, n) {
                            this.g = null, this.i = -1, this.j = e, this.h = t, this.l = n, "undefined" == typeof libDPIModule && Y("Could not Find LCEVC Library dependencies on this page"), "undefined" == typeof LcevcDil ? Y("Could not Find LCEVC Library on this page") : LcevcDil.SupportObject.SupportStatus || Y(LcevcDil.SupportObject.SupportError), "undefined" != typeof LcevcDil && "undefined" != typeof libDPIModule && this.h instanceof HTMLCanvasElement && LcevcDil.SupportObject.SupportStatus && !this.g && LcevcDil.SupportObject.webGLSupport(this.h) && (this.h.classList.remove("shaka-hidden"), this.g = new LcevcDil.LcevcDil(this.j, this.h, this.l));
                        }
                        function Io(e, t) {
                            var n = Ro;
                            switch(t.mimeType){
                                case "video/webm":
                                    n = Co;
                                    break;
                                case "video/mp4":
                                    n = Do;
                            }
                            e.g && (e.i = t.id, e.g.setLevelSwitching(t.id, !0), e.g.setContainerFormat(n));
                        }
                        lo.Status = {
                            Gg: co,
                            ph: fo,
                            Wg: 2
                        }, B("shaka.util.Id3Utils", yo), yo.getID3Frames = bo, Ao.prototype.parse = function(e) {
                            if (564 > e.length) return this;
                            for(var t = Math.max(0, So(e)), n = e.length - (e.length + t) % 188, r = !1, i = t; i < n; i += 188)if (71 === e[i]) {
                                var a1 = !!(64 & e[i + 1]), o = ((31 & e[i + 1]) << 8) + e[i + 2];
                                if (1 < (48 & e[i + 3]) >> 4) {
                                    var s1 = i + 5 + e[i + 4];
                                    if (s1 === i + 188) continue;
                                } else s1 = i + 4;
                                switch(o){
                                    case 0:
                                        a1 && (s1 += e[s1] + 1), this.o = (31 & e[s1 + 10]) << 8 | e[s1 + 11];
                                        break;
                                    case 17:
                                    case 8191:
                                        break;
                                    case this.o:
                                        a1 && (s1 += e[s1] + 1), o = {
                                            audio: -1,
                                            video: -1,
                                            Fd: -1,
                                            audioCodec: "",
                                            videoCodec: ""
                                        };
                                        var u = s1 + 3 + ((15 & (a1 = e)[s1 + 1]) << 8 | a1[s1 + 2]) - 4;
                                        for(s1 += 12 + ((15 & a1[s1 + 10]) << 8 | a1[s1 + 11]); s1 < u;){
                                            var l = (31 & a1[s1 + 1]) << 8 | a1[s1 + 2];
                                            switch(a1[s1]){
                                                case 15:
                                                    -1 === o.audio && (o.audio = l, o.audioCodec = "aac");
                                                    break;
                                                case 21:
                                                    -1 === o.Fd && (o.Fd = l);
                                                    break;
                                                case 27:
                                                    -1 === o.video && (o.video = l, o.videoCodec = "avc");
                                                    break;
                                                case 3:
                                                case 4:
                                                    -1 === o.audio && (o.audio = l, o.audioCodec = "mp3");
                                                    break;
                                                case 36:
                                                    -1 === o.video && (o.video = l, o.videoCodec = "hvc");
                                            }
                                            s1 += 5 + ((15 & a1[s1 + 3]) << 8 | a1[s1 + 4]);
                                        }
                                        a1 = o, null == this.l && (this.l = a1.video), null == this.g && (this.g = a1.audio), null == this.j && (this.j = a1.Fd), r && !this.s && (r = !1, i = t - 188), this.s = !0;
                                        break;
                                    case this.l:
                                        a1 = e.subarray(s1, i + 188), null == this.m && (s1 = _o(a1)) && null != s1.pts && (this.m = s1.pts / 9e4), this.B.push(a1);
                                        break;
                                    case this.g:
                                        a1 = e.subarray(s1, i + 188), null == this.h && (s1 = _o(a1)) && null != s1.pts && (this.h = s1.pts / 9e4), this.u.push(a1);
                                        break;
                                    case this.j:
                                        this.i.push(e.subarray(s1, i + 188));
                                        break;
                                    default:
                                        r = !0;
                                }
                            }
                            return this;
                        }, Ao.prototype.getStartTime = function() {
                            return {
                                audio: this.h,
                                video: this.m
                            };
                        }, B("shaka.util.TsParser", Ao), wo.prototype.release = function() {
                            this.g && (this.g.close(), this.g = null);
                        }, B("shaka.lcevc.Dil", wo), wo.prototype.release = wo.prototype.release;
                        var Ro = 0, Co = 1, Do = 2;
                        function ko(e, t, n, r) {
                            var i = this;
                            this.j = e, this.F = null, this.m = t, this.h = {}, this.M = {}, this.P = {}, this.g = null, this.H = !1, this.W = n || function() {}, this.D = r || null, this.i = {}, this.u = new xr, this.o = {}, this.s = null, this.K = new tt, this.l = function(e, t) {
                                var n = new MediaSource;
                                return e.u.na(n, "sourceopen", function() {
                                    URL.revokeObjectURL(e.N), t.resolve();
                                }), e.N = Yo(n), e.j.src = e.N, n;
                            }(this, this.K), this.G = new Nr(function() {
                                return function(e) {
                                    var t, n, r, i, a1, o, s1;
                                    return L(function(u) {
                                        if (1 == u.g) {
                                            for(n in t = [], e.i)for(r = e.i[n], i = r[0], e.i[n] = r.slice(0, 1), i && t.push(i.p.catch(Ye)), a1 = l(r.slice(1)), o = a1.next(); !o.done; o = a1.next())o.value.p.reject(new De(2, 7, 7003, void 0));
                                            for(s1 in e.g && t.push(e.g.destroy()), e.m && t.push(e.m.destroy()), e.o)t.push(e.o[s1].destroy());
                                            return T(u, Promise.all(t), 2);
                                        }
                                        e.u && (e.u.release(), e.u = null), e.j && (e.j.removeAttribute("src"), e.j.load(), e.j = null), e.F = null, e.l = null, e.g = null, e.m = null, e.h = {}, e.o = {}, e.s = null, e.i = {}, e.D = null, b(u);
                                    });
                                }(i);
                            }), this.N = "", this.B = !1, this.X = new tt;
                        }
                        function No(e, t, n) {
                            e.g || (e.g = new qt(e.m));
                            var r = e.g;
                            e = e.H, "application/cea-608" != t && "application/cea-708" != t && (r.j = (0, Qt[t])(), r.j.setSequenceMode ? r.j.setSequenceMode(n) : Y('Text parsers should have a "setSequenceMode" method!'), r.u = e);
                        }
                        function Lo(e) {
                            return !e.l || "ended" == e.l.readyState;
                        }
                        function xo(e, t) {
                            return t == Ze ? e.g.g : ho(Oo(e, t));
                        }
                        function Mo(e, t) {
                            return t == Ze ? e.g.h : go(Oo(e, t));
                        }
                        function Oo(e, t) {
                            try {
                                return e.h[t].buffered;
                            } catch (e) {
                                return null;
                            }
                        }
                        function Po(e, t, n, r, i, a1, o) {
                            var s1, u, d, f, h, g, p, m, v, y, E, A, _, S, w, I, R, C, D, k;
                            return a1 = void 0 !== a1 && a1, o = void 0 !== o && o, L(function(N) {
                                switch(N.g){
                                    case 1:
                                        if (t != (s1 = $e).Z) {
                                            N.A(2);
                                            break;
                                        }
                                        if (!e.B) {
                                            N.A(3);
                                            break;
                                        }
                                        return T(N, e.X, 4);
                                    case 4:
                                        u = N.h, e.g.s = u;
                                    case 3:
                                        return T(N, function(e, t, n, r) {
                                            var i, a1, o, s1;
                                            return L(function(u) {
                                                return 1 == u.g ? T(u, Promise.resolve(), 2) : e.j && e.i ? null == n || null == r ? (e.j.parseInit(Ie(t)), u.return()) : (i = e.u ? n : e.s, a1 = {
                                                    periodStart: e.s,
                                                    segmentStart: n,
                                                    segmentEnd: r,
                                                    vttOffset: i
                                                }, o = e.j.parseMedia(Ie(t), a1), s1 = o.filter(function(t) {
                                                    return t.startTime >= e.l && t.startTime < e.m;
                                                }), e.i.append(s1), null == e.g && (e.g = Math.max(n, e.l)), e.h = Math.min(r, e.m), void b(u)) : u.return();
                                            });
                                        }(e.g, n, r ? r.startTime : null, r ? r.endTime : null), 5);
                                    case 5:
                                        return N.return();
                                    case 2:
                                        if (d = Ie(n), f = e.M[t], e.o[t] && (f = e.o[t].o), 0 > So(d) ? zo.includes(f) && (p = bo(d)).length && r && (m = {
                                            cueTime: r.startTime,
                                            data: d,
                                            frames: p,
                                            dts: r.startTime,
                                            pts: r.startTime
                                        }, e.W([
                                            m
                                        ], 0, r.endTime)) : (h = function(e) {
                                            for(var t = [], n = new Uint8Array(0), r = e.i.length - 1; 0 <= r; r--){
                                                var i = _o(n = kt(e.i[r], n));
                                                i && (t.unshift({
                                                    cueTime: i.pts ? i.pts / 9e4 : null,
                                                    data: i.data,
                                                    frames: bo(i.data),
                                                    dts: i.dts,
                                                    pts: i.pts
                                                }), n = new Uint8Array(0));
                                            }
                                            return t;
                                        }((new Ao).parse(d)), h.length && (g = e.h[t].timestampOffset, e.W(h, g, r ? r.endTime : null))), !e.o[t]) {
                                            i && t == s1.ua && (e.g || No(e, "text/vtt", e.B), e.s || (e.s = new so(f)), r ? (v = function(e, t) {
                                                for(var n = e.h.parse(t), r = (n = l(n)).next(); !r.done; r = n.next()){
                                                    var i = r.value, a1 = Ie(i.hg);
                                                    if (0 < a1.length && (r = e.g, i = i.pts, 181 === (a1 = new Br(a1, 0)).Ra() && 49 === a1.Zd() && 1195456820 === a1.L() && 3 === a1.Ra())) {
                                                        var o = a1.Ra();
                                                        if (0 != (64 & o)) {
                                                            o &= 31, a1.skip(1);
                                                            for(var s1 = 0; s1 < o; s1++){
                                                                var u = a1.Ra(), d = (4 & u) >> 2, f = a1.Ra(), h = a1.Ra();
                                                                d && (0 == (u &= 3) || 1 === u ? r.h.push({
                                                                    pts: i,
                                                                    type: u,
                                                                    wa: f,
                                                                    La: h,
                                                                    order: r.h.length
                                                                }) : (r.g.push({
                                                                    pts: i,
                                                                    type: u,
                                                                    value: f,
                                                                    order: r.g.length
                                                                }), r.g.push({
                                                                    pts: i,
                                                                    type: 2,
                                                                    value: h,
                                                                    order: r.g.length
                                                                })));
                                                            }
                                                        }
                                                    }
                                                }
                                                return function(e) {
                                                    function t(e, t) {
                                                        return e.pts - t.pts || e.order - t.order;
                                                    }
                                                    var n = [];
                                                    e.h.sort(t), e.g.sort(t);
                                                    for(var r = l(e.h), i = r.next(); !i.done; i = r.next())(i = Xa(e, i.value)) && n.push(i);
                                                    for(i = (r = l(e.g)).next(); !i.done; i = r.next())Pa(e.i, i.value);
                                                    for(i = (r = l(e.i.i)).next(); !i.done; i = r.next())i = Qa(e, i.value), n.push.apply(n, c(i));
                                                    return e.i.i = [], e.h = [], e.g = [], n;
                                                }(e.g);
                                            }(e.s, n)).length && (y = e.h[s1.ua].timestampOffset, Xt(e.g, v, r.startTime, r.endTime, y)) : e.s.init(n)), N.A(6);
                                            break;
                                        }
                                        return a1 && e.o[t].g.resetCaptions(), T(N, function(e, t) {
                                            e.j = !0, e.h = new tt, e.l = [], e.i = [];
                                            var n = Ie(t);
                                            return e.g.push(n), e.g.flush(), e.j && e.h.reject(new De(2, 3, 3018)), e.h;
                                        }(e.o[t], n), 7);
                                    case 7:
                                        E = N.h, e.g || No(e, "text/vtt", e.B), E.captions && E.captions.length && (A = e.h[s1.ua].timestampOffset, _ = function(e) {
                                            for(var t = [], n = (e = l(e)).next(); !n.done; n = e.next())n = n.value, t.push({
                                                stream: n.stream,
                                                cue: new ne(n.startTime, n.endTime, n.text)
                                            });
                                            return t;
                                        }(E.captions), Xt(e.g, _, r ? r.startTime : null, r ? r.endTime : null, A)), n = E.data;
                                    case 6:
                                        if (n = function(e, t, n, r) {
                                            var i = e.P[r];
                                            return null == n && i && (ut() || st()) && "mp4" == e.M[r].split(";")[0].split("/")[1] && (t = function(e) {
                                                function t() {
                                                    i = !0;
                                                }
                                                function n(e) {
                                                    a1.push(e), Kr(e);
                                                }
                                                e = Ie(e);
                                                var r, i = !1, a1 = [], o = [];
                                                if ((new Vr).box("moov", n).box("trak", n).box("mdia", n).box("minf", n).box("stbl", n).T("stsd", function(e) {
                                                    r = e, a1.push(e), qr(e);
                                                }).T("encv", t).T("enca", t).T("avc1", function(e) {
                                                    o.push({
                                                        box: e,
                                                        pc: 1701733238
                                                    });
                                                }).T("avc3", function(e) {
                                                    o.push({
                                                        box: e,
                                                        pc: 1701733238
                                                    });
                                                }).T("ac-3", function(e) {
                                                    o.push({
                                                        box: e,
                                                        pc: 1701733217
                                                    });
                                                }).T("ec-3", function(e) {
                                                    o.push({
                                                        box: e,
                                                        pc: 1701733217
                                                    });
                                                }).T("mp4a", function(e) {
                                                    o.push({
                                                        box: e,
                                                        pc: 1701733217
                                                    });
                                                }).parse(e), i) return e;
                                                if (0 == o.length || !r) throw Dt(e), new De(2, 3, 3019);
                                                o.reverse();
                                                for(var s1 = l(o), u = s1.next(); !u.done; u = s1.next())u = u.value, e = Xi(e, r, u.box, a1, u.pc);
                                                return e;
                                            }(t)), t;
                                        }(e, n, r ? r.startTime : null, t), S = e.h[t], w = Wo, !e.B || S.mode == w || !r) {
                                            N.A(8);
                                            break;
                                        }
                                        if (t != s1.ua && s1.ua in e.h) {
                                            N.A(9);
                                            break;
                                        }
                                        return I = [
                                            S.appendWindowStart,
                                            S.appendWindowEnd
                                        ], S.appendWindowStart = 0, S.appendWindowEnd = 1 / 0, R = S.timestampOffset, S.timestampOffset = 0, T(N, Ho(e, t, function() {
                                            return Uo(e, t, n);
                                        }), 10);
                                    case 10:
                                        return T(N, Ho(e, t, function() {
                                            return Bo(e, t);
                                        }), 11);
                                    case 11:
                                        return S.timestampOffset = R, S.appendWindowStart = I[0], S.appendWindowEnd = I[1], C = ho(Oo(e, t)), D = (r.startTime || 0) - (C || 0), e.X.resolve(D), T(N, Ho(e, t, function() {
                                            return jo(e, t, 0, e.l.duration);
                                        }), 12);
                                    case 12:
                                        if (t != s1.ua) {
                                            N.A(9);
                                            break;
                                        }
                                        return T(N, Ho(e, t, function() {
                                            e.j.currentTime -= .001, Go(e, t);
                                        }), 9);
                                    case 9:
                                        S.mode = w;
                                    case 8:
                                        return r && e.B && t != s1.Z && (a1 || o) && (k = r.startTime, Ho(e, t, function() {
                                            return Bo(e, t);
                                        }), Ho(e, t, function() {
                                            var n = k;
                                            0 > n && (n += .001), e.h[t].timestampOffset = n, Go(e, t);
                                        })), T(N, Ho(e, t, function() {
                                            Uo(e, t, n);
                                        }), 15);
                                    case 15:
                                        b(N);
                                }
                            });
                        }
                        function Fo(e, t) {
                            return L(function(n) {
                                return t == $e.Z ? e.g ? T(n, e.g.remove(0, 1 / 0), 0) : n.return() : T(n, Ho(e, t, function() {
                                    return jo(e, t, 0, e.l.duration);
                                }), 0);
                            });
                        }
                        function Uo(e, t, n) {
                            if ("video" == t && e.D) {
                                var r = e.D;
                                r.g && r.g.appendBuffer(n, "video", r.i);
                            }
                            e.h[t].appendBuffer(n);
                        }
                        function jo(e, t, n, r) {
                            r <= n ? Go(e, t) : e.h[t].remove(n, r);
                        }
                        function Bo(e, t) {
                            var n = e.h[t].appendWindowStart, r = e.h[t].appendWindowEnd;
                            e.h[t].abort(), e.h[t].appendWindowStart = n, e.h[t].appendWindowEnd = r, Go(e, t);
                        }
                        function Go(e, t) {
                            var n = e.i[t][0];
                            n && (n.p.resolve(), Ko(e, t));
                        }
                        function Ho(e, t, n) {
                            return Lr(e.G), n = {
                                start: n,
                                p: new tt
                            }, e.i[t].push(n), 1 == e.i[t].length && qo(e, t), n.p;
                        }
                        function Vo(e, t) {
                            var n, r, i, a1, o;
                            return L(function(s1) {
                                switch(s1.g){
                                    case 1:
                                        for(i in Lr(e.G), n = [], r = {}, e.h)r.Tb = new tt, a1 = {
                                            start: function(e) {
                                                return function() {
                                                    return e.Tb.resolve();
                                                };
                                            }(r),
                                            p: r.Tb
                                        }, e.i[i].push(a1), n.push(r.Tb), 1 == e.i[i].length && a1.start(), r = {
                                            Tb: r.Tb
                                        };
                                        return A(s1, 2), T(s1, Promise.all(n), 4);
                                    case 4:
                                        S(s1, 3);
                                        break;
                                    case 2:
                                        throw w(s1);
                                    case 3:
                                        try {
                                            t();
                                        } catch (e) {
                                            throw new De(2, 3, 3015, e);
                                        } finally{
                                            for(o in e.h)Ko(e, o);
                                        }
                                        b(s1);
                                }
                            });
                        }
                        function Ko(e, t) {
                            e.i[t].shift(), qo(e, t);
                        }
                        function qo(e, t) {
                            var n = e.i[t][0];
                            if (n) try {
                                n.start();
                            } catch (r) {
                                "QuotaExceededError" == r.name ? n.p.reject(new De(2, 3, 3017, t)) : n.p.reject(new De(2, 3, 3015, r)), Ko(e, t);
                            }
                        }
                        (r = ko.prototype).destroy = function() {
                            return this.G.destroy();
                        }, r.init = function(e, t, n) {
                            n = void 0 !== n && n;
                            var r, i, a1, o, s1, u, c, d, f = this;
                            return L(function(h) {
                                if (1 == h.g) return r = $e, T(h, f.K, 2);
                                for(f.B = n, i = {}, a1 = l(e.keys()), o = a1.next(); !o.done; i = {
                                    oa: i.oa
                                }, o = a1.next())i.oa = o.value, s1 = e.get(i.oa), u = Bt(s1.mimeType, s1.codecs), i.oa == r.Z ? No(f, u, n) : (!t && MediaSource.isTypeSupported(u) || !Ot(u, i.oa) || (f.o[i.oa] = new Mt(u), u = Ft(i.oa, u)), c = u + f.F.sourceBufferExtraFeatures, d = f.l.addSourceBuffer(c), f.u.C(d, "error", function(e) {
                                    return function() {
                                        f.i[e.oa][0].p.reject(new De(2, 3, 3014, f.j.error ? f.j.error.code : 0));
                                    };
                                }(i)), f.u.C(d, "updateend", function(e) {
                                    return function() {
                                        return Go(f, e.oa);
                                    };
                                }(i)), f.h[i.oa] = d, f.M[i.oa] = u, f.i[i.oa] = [], f.P[i.oa] = !!s1.drmInfos.length);
                                b(h);
                            });
                        }, r.configure = function(e) {
                            this.F = e;
                        }, r.Ma = function() {
                            var e = {
                                total: vo(this.j.buffered),
                                audio: vo(Oo(this, "audio")),
                                video: vo(Oo(this, "video")),
                                text: []
                            };
                            if (this.g) {
                                var t = this.g.g, n = this.g.h;
                                null != t && null != n && e.text.push({
                                    start: t,
                                    end: n
                                });
                            }
                            return e;
                        }, r.remove = function(e, t, n) {
                            var r = this;
                            return L(function(i) {
                                return T(i, e == $e.Z ? r.g.remove(t, n) : Ho(r, e, function() {
                                    return jo(r, e, t, n);
                                }), 0);
                            });
                        }, r.flush = function(e) {
                            var t = this;
                            return L(function(n) {
                                return e == $e.Z ? n.return() : T(n, Ho(t, e, function() {
                                    t.j.currentTime -= .001, Go(t, e);
                                }), 0);
                            });
                        }, r.endOfStream = function(e) {
                            var t = this;
                            return L(function(n) {
                                return T(n, Vo(t, function() {
                                    Lo(t) || (e ? t.l.endOfStream(e) : t.l.endOfStream());
                                }), 0);
                            });
                        }, r.Ia = function(e) {
                            var t = this;
                            return L(function(n) {
                                return T(n, Vo(t, function() {
                                    if (e < t.l.duration) for(var n in t.h){
                                        var r = {
                                            start: function() {},
                                            p: new tt
                                        };
                                        t.i[n].unshift(r);
                                    }
                                    t.l.duration = e;
                                }), 0);
                            });
                        }, r.getDuration = function() {
                            return this.l.duration;
                        };
                        var Yo = e.URL.createObjectURL, Wo = "sequence", zo = [
                            "audio/aac",
                            "audio/ac3",
                            "audio/ec3",
                            "audio/mpeg"
                        ];
                        function Xo(e, t, n) {
                            this.i = e, this.m = t, this.o = this.j = 1 / 0, this.g = 1, this.h = this.l = null, this.s = 0, this.u = !0, this.B = 0, this.D = void 0 === n || n, this.F = 0, this.G = !1;
                        }
                        function Qo(e, t, n) {
                            this.l = n, this.j = e, this.s = Zo(e), this.g = e.g.currentTime, this.m = Date.now() / 1e3, this.h = !1, this.o = 0, this.u = t, this.i = function() {};
                        }
                        function Jo(e) {
                            this.g = e;
                        }
                        function Zo(e) {
                            if (e.g.paused || 0 == e.g.playbackRate || 0 == e.g.buffered.length) var t = !1;
                            else e: {
                                t = e.g.currentTime;
                                for(var n = (e = l(vo(e.g.buffered))).next(); !n.done; n = e.next())if (!(t < (n = n.value).start - .1 || t > n.end - .5)) {
                                    t = !0;
                                    break e;
                                }
                                t = !1;
                            }
                            return t;
                        }
                        function $o(e, t, n, r, i) {
                            var a1 = this;
                            this.o = i, this.g = e, this.s = t, this.D = n, this.i = new xr, this.m = !1, this.B = e.readyState, this.u = 0, this.h = r, this.l = !1, this.i.C(e, "waiting", function() {
                                return es(a1);
                            }), this.j = new it(function() {
                                es(a1);
                            }).Ba(.25);
                        }
                        function es(e) {
                            if (0 != e.g.readyState) {
                                if (e.g.seeking) {
                                    if (!e.m) return;
                                } else e.m = !1;
                                if (!e.g.paused || 0 == e.g.currentTime && (e.g.autoplay || 0 != e.g.currentTime)) {
                                    var t;
                                    if (e.g.readyState != e.B && (e.B = e.g.readyState), !(t = !e.h)) {
                                        var n = (t = e.h).j, r = Zo(n), i = n.g.currentTime, a1 = Date.now() / 1e3;
                                        t.g == i && t.s == r || (t.m = a1, t.g = i, t.s = r, t.h = !1), (r = (i = a1 - t.m) >= t.u && r && !t.h) && (t.i(t.g, i), t.h = !0, t.g = n.g.currentTime, t.o++, t.l(new gr("stalldetected"))), t = !r;
                                    }
                                    t && (t = e.g.currentTime, r = function(e, t, n) {
                                        return !e || !e.length || 1 == e.length && 1e-6 > e.end(0) - e.start(0) ? null : 0 <= (e = vo(e).findIndex(function(e, r, i) {
                                            return e.start > t && (0 == r || i[r - 1].end - t <= n);
                                        })) ? e : null;
                                    }(n = e.g.buffered, t, e.D.gapDetectionThreshold), null == r || 0 == r && !e.l || (i = n.start(r)) >= e.s.Na() || .001 > i - t || (0 != r && n.end(r - 1), e.g.currentTime = i, e.u++, e.o(new gr("gapjumped"))));
                                }
                            }
                        }
                        function ts(e, t, n, r) {
                            t == HTMLMediaElement.HAVE_NOTHING || e.readyState >= t ? r() : (t = ns.value().get(t), n.na(e, t, r));
                        }
                        (r = Xo.prototype).getDuration = function() {
                            return this.j;
                        }, r.Jf = function() {
                            return this.g;
                        }, r.We = function(e) {
                            this.i = e;
                        }, r.Ia = function(e) {
                            this.j = e;
                        }, r.Of = function() {
                            return this.i;
                        }, r.Ue = function(e) {
                            this.s = e;
                        }, r.xc = function(e) {
                            this.u = e;
                        }, r.le = function(e) {
                            this.o = e;
                        }, r.Ve = function(e) {
                            this.m = e;
                        }, r.Cf = function() {
                            return this.m;
                        }, r.Hb = function(e) {
                            if (0 != e.length) {
                                for(var t = e[0].startTime, n = e[0].endTime, r = (e = l(e)).next(); !r.done; r = e.next())r = r.value, t = Math.min(t, r.startTime), n = Math.max(n, r.endTime), this.g = Math.max(this.g, r.endTime - r.startTime);
                                this.Sd(t), this.h = Math.max(this.h, n), null != this.i && this.D && !this.G && (this.i = (Date.now() + this.s) / 1e3 - this.h - this.g);
                            }
                        }, r.Md = function() {
                            this.G = !0;
                        }, r.Sd = function(e) {
                            this.l = null == this.l ? e : Math.min(this.l, e);
                        }, r.Rd = function(e) {
                            this.g = Math.max(this.g, e);
                        }, r.offset = function(e) {
                            null != this.l && (this.l += e), null != this.h && (this.h += e);
                        }, r.U = function() {
                            return 1 / 0 == this.j && !this.u;
                        }, r.kb = function() {
                            return 1 / 0 != this.j && !this.u;
                        }, r.Oa = function() {
                            return Math.max(this.B, this.hb() - this.o);
                        }, r.Ye = function(e) {
                            this.B = e;
                        }, r.hb = function() {
                            return this.U() || this.kb() ? Math.min(Math.max(0, (Date.now() + this.s) / 1e3 - this.g - this.i) + this.F, this.j) : this.h ? Math.min(this.h, this.j) : this.j;
                        }, r.jc = function(e) {
                            var t = Math.max(this.l, this.B);
                            return 1 / 0 == this.o ? Math.ceil(1e3 * t) / 1e3 : Math.max(t, Math.min(this.hb() - this.o + e, this.Na()));
                        }, r.Cb = function() {
                            return this.jc(0);
                        }, r.Na = function() {
                            return Math.max(0, this.hb() - (this.U() || this.kb() ? this.m : 0));
                        }, r.cf = function() {
                            return !(null == this.i || null != this.h && this.D);
                        }, r.Te = function(e) {
                            this.F = e;
                        }, B("shaka.media.PresentationTimeline", Xo), Xo.prototype.setAvailabilityTimeOffset = Xo.prototype.Te, Xo.prototype.usingPresentationStartTime = Xo.prototype.cf, Xo.prototype.getSeekRangeEnd = Xo.prototype.Na, Xo.prototype.getSeekRangeStart = Xo.prototype.Cb, Xo.prototype.getSafeSeekRangeStart = Xo.prototype.jc, Xo.prototype.getSegmentAvailabilityEnd = Xo.prototype.hb, Xo.prototype.setUserSeekStart = Xo.prototype.Ye, Xo.prototype.getSegmentAvailabilityStart = Xo.prototype.Oa, Xo.prototype.isInProgress = Xo.prototype.kb, Xo.prototype.isLive = Xo.prototype.U, Xo.prototype.offset = Xo.prototype.offset, Xo.prototype.notifyMaxSegmentDuration = Xo.prototype.Rd, Xo.prototype.notifyMinSegmentStartTime = Xo.prototype.Sd, Xo.prototype.lockStartTime = Xo.prototype.Md, Xo.prototype.notifySegments = Xo.prototype.Hb, Xo.prototype.getDelay = Xo.prototype.Cf, Xo.prototype.setDelay = Xo.prototype.Ve, Xo.prototype.setSegmentAvailabilityDuration = Xo.prototype.le, Xo.prototype.setStatic = Xo.prototype.xc, Xo.prototype.setClockOffset = Xo.prototype.Ue, Xo.prototype.getPresentationStartTime = Xo.prototype.Of, Xo.prototype.setDuration = Xo.prototype.Ia, Xo.prototype.setPresentationStartTime = Xo.prototype.We, Xo.prototype.getMaxSegmentDuration = Xo.prototype.Jf, Xo.prototype.getDuration = Xo.prototype.getDuration, Qo.prototype.release = function() {
                            this.l = this.j = null, this.i = function() {};
                        }, $o.prototype.release = function() {
                            this.i && (this.i.release(), this.i = null), null != this.j && (this.j.stop(), this.j = null), this.h && (this.h.release(), this.h = null), this.g = this.s = this.o = null;
                        }, $o.prototype.Vd = function() {
                            this.l = !0, es(this);
                        };
                        var ns = new nt(function() {
                            return new Map([
                                [
                                    HTMLMediaElement.HAVE_METADATA,
                                    "loadedmetadata"
                                ],
                                [
                                    HTMLMediaElement.HAVE_CURRENT_DATA,
                                    "loadeddata"
                                ],
                                [
                                    HTMLMediaElement.HAVE_FUTURE_DATA,
                                    "canplay"
                                ],
                                [
                                    HTMLMediaElement.HAVE_ENOUGH_DATA,
                                    "canplaythrough"
                                ]
                            ]);
                        });
                        function rs(e, t, n) {
                            var r = this;
                            this.g = e, this.l = t, this.j = n, this.m = !1, this.h = new xr, this.i = new us(e), ts(this.g, HTMLMediaElement.HAVE_METADATA, this.h, function() {
                                os(r, r.j);
                            });
                        }
                        function is(e) {
                            return e.m ? e.g.currentTime : e.j;
                        }
                        function as(e, t) {
                            0 < e.g.readyState ? ls(e.i, t) : ts(e.g, HTMLMediaElement.HAVE_METADATA, e.h, function() {
                                os(e, e.j);
                            });
                        }
                        function os(e, t) {
                            .001 > Math.abs(e.g.currentTime - t) ? ss(e) : (e.h.na(e.g, "seeking", function() {
                                ss(e);
                            }), ls(e.i, 0 == e.g.currentTime ? t : e.g.currentTime));
                        }
                        function ss(e) {
                            e.m = !0, e.h.C(e.g, "seeking", function() {
                                return e.l();
                            });
                        }
                        function us(e) {
                            var t = this;
                            this.h = e, this.m = 10, this.l = this.j = this.i = 0, this.g = new it(function() {
                                0 >= t.i || t.h.currentTime != t.j ? t.g.stop() : (t.h.currentTime = t.l, t.i--);
                            });
                        }
                        function ls(e, t) {
                            e.j = e.h.currentTime, e.l = t, e.i = e.m, e.h.currentTime = t, e.g.Ba(.1);
                        }
                        function cs(e) {
                            this.g = e, this.j = !1, this.h = null, this.i = new xr;
                        }
                        function ds(e, t, n, r, i, a1) {
                            var o = this;
                            this.i = e, this.g = t.presentationTimeline, this.B = t.minBufferTime || 0, this.l = n, this.u = i, this.s = null, this.o = function(e, t, n) {
                                if (!t.stallEnabled) return null;
                                var r = t.stallSkip;
                                return function(e, t) {
                                    e.i = t;
                                }(t = new Qo(new Jo(e), t.stallThreshold, n), function() {
                                    r ? e.currentTime += r : (e.pause(), e.play());
                                }), t;
                            }(e, n, a1), this.j = new $o(e, t.presentationTimeline, n, this.o, a1), this.h = new rs(e, function() {
                                var e = o.j;
                                e.m = !0, e.l = !1;
                                var t = is(o.h);
                                return e = hs(o, t), .001 < Math.abs(e - t) && (t = Date.now() / 1e3, !o.s || o.s < t - 1) ? (o.s = t, as(o.h, e), e = void 0) : (o.u(), e = void 0), e;
                            }, function(e, t) {
                                return null == t ? t = 1 / 0 > e.g.getDuration() ? e.g.Cb() : e.g.Na() : 0 > t && (t = e.g.Na() + t), fs(e, gs(e, t));
                            }(this, r)), this.m = new it(function() {
                                if (0 != o.i.readyState && !o.i.paused) {
                                    var e = is(o.h), t = o.g.Cb(), n = o.g.Na();
                                    3 > n - t && (t = n - 3), e < t && (e = hs(o, e), o.i.currentTime = e);
                                }
                            });
                        }
                        function fs(e, t) {
                            var n = e.g.getDuration();
                            return t >= n ? n - e.l.durationBackoff : t;
                        }
                        function hs(e, t) {
                            var n = Math.max(e.B, e.l.rebufferingGoal), r = e.l.safeSeekOffset, i = e.g.Cb(), a1 = e.g.Na(), o = e.g.getDuration();
                            3 > a1 - i && (i = a1 - 3);
                            var s1 = e.g.jc(n), u = e.g.jc(r);
                            return n = e.g.jc(n + r), t >= o ? fs(e, t) : t > a1 ? a1 : t < i ? po(e.i.buffered, u) ? u : n : t >= s1 || po(e.i.buffered, t) ? t : n;
                        }
                        function gs(e, t) {
                            var n = e.g.Cb();
                            return t < n || t > (n = e.g.Na()) ? n : t;
                        }
                        function ps(e) {
                            this.g = e, this.h = null, this.i = 0, this.j = !1;
                        }
                        function ms(e, t) {
                            for(var n = l(e.g), r = n.next(); !r.done; r = n.next())t(r.value);
                        }
                        function vs(e, t, n) {
                            return new ps([
                                new lo(e, e + t, function() {
                                    return n;
                                }, 0, null, null, e, e, e + t)
                            ]);
                        }
                        function ys(e, t, n) {
                            this.i = e, this.g = t, this.h = n;
                        }
                        function Es() {
                            ps.call(this, []), this.l = [];
                        }
                        function Ts(e) {
                            var t = this;
                            this.g = e, this.j = !1, this.i = this.g.Tc(), this.h = new it(function() {
                                t.g.Le(.25 * t.i);
                            });
                        }
                        function bs(e) {
                            e.h.stop();
                            var t = e.j ? 0 : e.i;
                            if (0 <= t) try {
                                return void (e.g.Tc() != t && e.g.ke(t));
                            } catch (e) {}
                            e.h.Ba(.25), 0 != e.g.Tc() && e.g.ke(0);
                        }
                        function As(e) {
                            var t = this;
                            this.h = e, this.g = new Set, this.i = new it(function() {
                                _s(t, !1);
                            }).Ba(.25);
                        }
                        function _s(e, t) {
                            for(var n = l(e.g), r = n.next(); !r.done; r = n.next())r.value.j(e.h.currentTime, t);
                        }
                        function Ss(e) {
                            vr.call(this), this.g = new Map, this.h = e;
                        }
                        function ws(e) {
                            vr.call(this);
                            var t = this;
                            this.g = new Set, this.i = e, this.h = new it(function() {
                                for(var e = t.i(), n = l(t.g), r = n.next(); !r.done; r = n.next())(r = r.value).endTime < e.start && (t.g.delete(r), r = new gr("regionremove", new Map([
                                    [
                                        "region",
                                        r
                                    ]
                                ])), t.dispatchEvent(r));
                            }).Ba(2);
                        }
                        function Is(e) {
                            vr.call(this);
                            var t = this;
                            this.i = e, this.g = new Map, this.l = [
                                {
                                    rb: null,
                                    qb: Ds,
                                    jb: function(e, n) {
                                        return Rs(t, "enter", e, n);
                                    }
                                },
                                {
                                    rb: Cs,
                                    qb: Ds,
                                    jb: function(e, n) {
                                        return Rs(t, "enter", e, n);
                                    }
                                },
                                {
                                    rb: ks,
                                    qb: Ds,
                                    jb: function(e, n) {
                                        return Rs(t, "enter", e, n);
                                    }
                                },
                                {
                                    rb: Ds,
                                    qb: Cs,
                                    jb: function(e, n) {
                                        return Rs(t, "exit", e, n);
                                    }
                                },
                                {
                                    rb: Ds,
                                    qb: ks,
                                    jb: function(e, n) {
                                        return Rs(t, "exit", e, n);
                                    }
                                },
                                {
                                    rb: Cs,
                                    qb: ks,
                                    jb: function(e, n) {
                                        return Rs(t, "skip", e, n);
                                    }
                                },
                                {
                                    rb: ks,
                                    qb: Cs,
                                    jb: function(e, n) {
                                        return Rs(t, "skip", e, n);
                                    }
                                }
                            ], this.h = new xr, this.h.C(this.i, "regionremove", function(e) {
                                t.g.delete(e.region);
                            });
                        }
                        function Rs(e, t, n, r) {
                            t = new gr(t, new Map([
                                [
                                    "region",
                                    n
                                ],
                                [
                                    "seeking",
                                    r
                                ]
                            ])), e.dispatchEvent(t);
                        }
                        rs.prototype.release = function() {
                            this.h && (this.h.release(), this.h = null), null != this.i && (this.i.release(), this.i = null), this.l = function() {}, this.g = null;
                        }, us.prototype.release = function() {
                            this.g && (this.g.stop(), this.g = null), this.h = null;
                        }, (r = cs.prototype).zd = function() {
                            var e = this;
                            ts(this.g, HTMLMediaElement.HAVE_CURRENT_DATA, this.i, function() {
                                null == e.h || 0 == e.h ? e.j = !0 : (e.i.na(e.g, "seeking", function() {
                                    e.j = !0;
                                }), e.g.currentTime = Math.max(0, e.g.currentTime + e.h));
                            });
                        }, r.release = function() {
                            this.i && (this.i.release(), this.i = null), this.g = null;
                        }, r.Bd = function(e) {
                            this.h = this.j ? this.h : e;
                        }, r.Hc = function() {
                            return (this.j ? this.g.currentTime : this.h) || 0;
                        }, r.se = function() {
                            return 0;
                        }, r.re = function() {
                            return 0;
                        }, r.Me = function() {}, (r = ds.prototype).zd = function() {
                            this.m.Ba(.25);
                        }, r.release = function() {
                            this.h && (this.h.release(), this.h = null), this.j && (this.j.release(), this.j = null), this.m && (this.m.stop(), this.m = null), this.i = this.h = this.g = this.l = null, this.u = function() {};
                        }, r.Bd = function(e) {
                            as(this.h, e);
                        }, r.Hc = function() {
                            var e = is(this.h);
                            return 0 < this.i.readyState && !this.i.paused ? gs(this, e) : e;
                        }, r.se = function() {
                            return this.o ? this.o.o : 0;
                        }, r.re = function() {
                            return this.j.u;
                        }, r.Me = function() {
                            this.j.Vd();
                        }, (r = ps.prototype).release = function() {
                            this.j || (this.g = [], this.h && this.h.stop(), this.h = null);
                        }, r.bg = function() {
                            this.j = !0;
                        }, r.find = function(e) {
                            for(var t = this.g.length - 1, n = t; 0 <= n; --n){
                                var r = this.g[n], i = n < t ? this.g[n + 1].startTime : r.endTime;
                                if (e >= r.startTime && e < i) return n + this.i;
                            }
                            return this.g.length && e < this.g[0].startTime ? this.i : null;
                        }, r.get = function(e) {
                            return 0 == this.g.length || 0 > (e -= this.i) || e >= this.g.length ? null : this.g[e];
                        }, r.offset = function(e) {
                            if (!this.j) for(var t = l(this.g), n = t.next(); !n.done; n = t.next()){
                                (n = n.value).startTime += e, n.endTime += e, n.j += e;
                                for(var r = (n = l(n.i)).next(); !r.done; r = n.next())(r = r.value).startTime += e, r.endTime += e, r.j += e;
                            }
                        }, r.oc = function(e) {
                            !this.j && e.length && (this.g = this.g.filter(function(t) {
                                return t.startTime < e[0].startTime;
                            }), this.g.push.apply(this.g, c(e)));
                        }, r.Gb = function(e, t) {
                            var n = this;
                            e = e.filter(function(e) {
                                return e.endTime > t && (0 == n.g.length || e.endTime > n.g[0].startTime);
                            }), this.oc(e), this.fb(t);
                        }, r.fb = function(e) {
                            if (!this.j) {
                                var t = this.g.length;
                                this.g = this.g.filter(function(t) {
                                    return t.endTime > e;
                                }), this.i += t - this.g.length;
                            }
                        }, r.Ya = function(e, t, n) {
                            if (n = void 0 !== n && n, !this.j) {
                                for(; this.g.length && this.g[this.g.length - 1].startTime >= t;)this.g.pop();
                                for(; this.g.length && this.g[0].endTime <= e;)this.g.shift(), n || this.i++;
                                0 != this.g.length && (e = this.g[this.g.length - 1], this.g[this.g.length - 1] = new lo(e.startTime, t, e.s, e.Aa, e.ka, e.h, e.timestampOffset, e.appendWindowStart, e.appendWindowEnd, e.i, e.tilesLayout, e.o, e.g, e.status, e.l));
                            }
                        }, r.gd = function(e, t) {
                            var n = this;
                            this.j || (this.h && this.h.stop(), this.h = new it(function() {
                                var e = t();
                                e ? n.g.push.apply(n.g, c(e)) : (n.h.stop(), n.h = null);
                            }), this.h.Ba(e));
                        }, ps.prototype[Symbol.iterator] = function() {
                            return this.Bb(0);
                        }, ps.prototype.Bb = function(e) {
                            var t = this.find(e);
                            if (null == t) return null;
                            t--;
                            var n = this.get(t + 1), r = -1;
                            if (n && 0 < n.i.length) for(var i = n.i.length - 1; 0 <= i; --i){
                                var a1 = n.i[i];
                                if (e >= a1.startTime && e < a1.endTime) {
                                    t++, r = i - 1;
                                    break;
                                }
                            }
                            return new ys(this, t, r);
                        }, B("shaka.media.SegmentIndex", ps), ps.forSingleSegment = vs, ps.prototype.getIteratorForTime = ps.prototype.Bb, ps.prototype.updateEvery = ps.prototype.gd, ps.prototype.fit = ps.prototype.Ya, ps.prototype.evict = ps.prototype.fb, ps.prototype.mergeAndEvict = ps.prototype.Gb, ps.prototype.offset = ps.prototype.offset, ps.prototype.get = ps.prototype.get, ps.prototype.find = ps.prototype.find, ps.prototype.markImmutable = ps.prototype.bg, ps.prototype.release = ps.prototype.release, ys.prototype.uf = function() {
                            return this.g;
                        }, ys.prototype.current = function() {
                            var e = this.i.get(this.g);
                            return e && 0 < e.i.length && e.xa().length && this.h >= e.i.length && (this.g++, this.h = 0, e = this.i.get(this.g)), e && 0 < e.i.length ? e.i[this.h] : e;
                        }, ys.prototype.next = function() {
                            var e = this.i.get(this.g);
                            return e && 0 < e.i.length ? (this.h++, e.xa().length && this.h == e.i.length && (this.g++, this.h = 0)) : (this.g++, this.h = 0), {
                                value: e = this.current(),
                                done: !e
                            };
                        }, B("shaka.media.SegmentIterator", ys), ys.prototype.next = ys.prototype.next, ys.prototype.current = ys.prototype.current, ys.prototype.currentPosition = ys.prototype.uf, m(Es, ps), (r = Es.prototype).clone = function() {
                            var e = new Es;
                            return e.l = this.l.slice(), e;
                        }, r.release = function() {
                            for(var e = l(this.l), t = e.next(); !t.done; t = e.next())t.value.release();
                            this.l = [];
                        }, r.find = function(e) {
                            for(var t = 0, n = l(this.l), r = n.next(); !r.done; r = n.next()){
                                var i = (r = r.value).find(e);
                                if (null != i) return i + t;
                                t += r.i + r.g.length;
                            }
                            return null;
                        }, r.get = function(e) {
                            for(var t = 0, n = l(this.l), r = n.next(); !r.done; r = n.next()){
                                var i = (r = r.value).get(e - t);
                                if (i) return i;
                                t += r.i + r.g.length;
                            }
                            return null;
                        }, r.offset = function() {}, r.oc = function() {}, r.fb = function() {}, r.Gb = function() {}, r.Ya = function() {}, r.gd = function() {}, B("shaka.media.MetaSegmentIndex", Es), Es.prototype.updateEvery = Es.prototype.gd, Es.prototype.fit = Es.prototype.Ya, Es.prototype.mergeAndEvict = Es.prototype.Gb, Es.prototype.evict = Es.prototype.fb, Es.prototype.merge = Es.prototype.oc, Es.prototype.offset = Es.prototype.offset, Es.prototype.get = Es.prototype.get, Es.prototype.find = Es.prototype.find, Es.prototype.release = Es.prototype.release, Ts.prototype.release = function() {
                            this.h && (this.h.stop(), this.h = null), this.g = null;
                        }, Ts.prototype.set = function(e) {
                            this.i = e, bs(this);
                        }, Ts.prototype.Pc = function() {
                            return this.g.Pc();
                        }, As.prototype.release = function() {
                            this.i.stop();
                            for(var e = l(this.g), t = e.next(); !t.done; t = e.next())t.value.release();
                            this.g.clear();
                        }, m(Ss, vr), Ss.prototype.release = function() {
                            this.g.clear(), vr.prototype.release.call(this);
                        }, Ss.prototype.j = function(e) {
                            for(var t = l(this.g.values()), n = t.next(); !n.done; n = t.next()){
                                e: {
                                    for(var r = (n = n.value).qc, i = r.length - 1; 0 <= i; i--){
                                        var a1 = r[i];
                                        if (a1.position <= e) {
                                            r = a1.Od;
                                            break e;
                                        }
                                    }
                                    r = null;
                                }
                                if ((i = r) && (i = !((i = n.ye) === r || i && r && i.bandwidth == r.bandwidth && i.audioSamplingRate == r.audioSamplingRate && i.codecs == r.codecs && i.contentType == r.contentType && i.frameRate == r.frameRate && i.height == r.height && i.mimeType == r.mimeType && i.channelsCount == r.channelsCount && i.pixelAspectRatio == r.pixelAspectRatio && i.width == r.width)), i) e: {
                                    if (i = e, a1 = r.contentType, (a1 = this.h()[a1]) && 0 < a1.length) {
                                        var o = a1[a1.length - 1].end;
                                        if (i >= a1[0].start && i < o) {
                                            i = !0;
                                            break e;
                                        }
                                    }
                                    i = !1;
                                }
                                i && (n.ye = r, JSON.stringify(r), n = new gr("qualitychange", new Map([
                                    [
                                        "quality",
                                        r
                                    ],
                                    [
                                        "position",
                                        e
                                    ]
                                ])), this.dispatchEvent(n));
                            }
                        }, m(ws, vr), ws.prototype.release = function() {
                            this.g.clear(), this.h.stop(), vr.prototype.release.call(this);
                        }, m(Is, vr), Is.prototype.release = function() {
                            this.i = null, this.g.clear(), this.h.release(), this.h = null, vr.prototype.release.call(this);
                        }, Is.prototype.j = function(e, t) {
                            for(var n = l(this.i.g), r = n.next(); !r.done; r = n.next()){
                                r = r.value;
                                var i = this.g.get(r), a1 = e < r.startTime ? Cs : e > r.endTime ? ks : Ds;
                                this.g.set(r, a1);
                                for(var o = l(this.l), s1 = o.next(); !s1.done; s1 = o.next())(s1 = s1.value).rb == i && s1.qb == a1 && s1.jb(r, t);
                            }
                        };
                        var Cs = 1, Ds = 2, ks = 3;
                        function Ns(e, t, n, r, i) {
                            return e = Sr(e, r, i), 0 == t && null == n || (e.headers.Range = n ? "bytes=" + t + "-" + n : "bytes=" + t + "-"), e;
                        }
                        function Ls(e, t) {
                            var n = this;
                            this.g = t, this.m = e, this.i = null, this.u = 1, this.o = this.l = null, this.D = !1, this.j = new Map, this.B = !1, this.F = null, this.s = !1, this.h = new Nr(function() {
                                return function(e) {
                                    var t, n, r, i;
                                    return L(function(a1) {
                                        if (1 == a1.g) {
                                            for(t = [], n = l(e.j.values()), r = n.next(); !r.done; r = n.next())Ks(i = r.value), t.push(qs(i));
                                            return T(a1, Promise.all(t), 2);
                                        }
                                        e.j.clear(), e.g = null, e.m = null, e.i = null, b(a1);
                                    });
                                }(n);
                            });
                        }
                        function xs(e, t) {
                            var n = e.j.get("video");
                            if (n) {
                                var r = n.stream;
                                if (r) {
                                    if (t) {
                                        var i = r.trickModeVideo;
                                        i && !n.ob && (Ps(e, i, !1, 0, !1), n.ob = r);
                                    } else (r = n.ob) && (n.ob = null, Ps(e, r, !0, 0, !1));
                                }
                            }
                        }
                        function Ms(e, t, n, r, i, a1) {
                            n = void 0 !== n && n, r = void 0 === r ? 0 : r, i = void 0 !== i && i, a1 = void 0 !== a1 && a1, e.l = t, e.B && (t.video && Ps(e, t.video, n, r, i, a1), t.audio && Ps(e, t.audio, n, r, i, a1));
                        }
                        function Os(e, t) {
                            e.o = t, e.B && Ps(e, t, !0, 0, !1);
                        }
                        function Ps(e, t, n, r, i, a1) {
                            var o = e.j.get(t.type);
                            o || t.type != Ze ? o && (o.ob && (t.trickModeVideo ? (o.ob = t, t = t.trickModeVideo) : o.ob = null), o.stream != t || i) && (t.type == Ze && No(e.g.R, Bt(t.mimeType, t.codecs), e.m.sequenceMode), o.stream.closeSegmentIndex && o.stream.closeSegmentIndex(), o.stream = t, o.ba = null, o.te = !!a1, n && (o.ac ? o.jd = !0 : o.Ha ? (o.cb = !0, o.Mc = r, o.jd = !0) : (Ks(o), Hs(e, o, !0, r).catch(function(t) {
                                e.g && e.g.onError(t);
                            }))), (function(e, t) {
                                var n, r;
                                return L(function(i) {
                                    if (1 == i.g) return t.sa ? (n = t.stream, r = t.sa, n.segmentIndex ? i.A(2) : T(i, n.createSegmentIndex(), 2)) : i.return();
                                    if (t.sa != r || t.stream != n) return i.return();
                                    var a1 = e.g.Sc(), o = Mo(e.g.R, t.type), s1 = t.stream.segmentIndex.find(t.ya ? t.ya.endTime : a1), u = null == s1 ? null : t.stream.segmentIndex.get(s1);
                                    s1 = u && u.ka ? u.ka - u.Aa : null, u && !s1 && (s1 = (u.endTime - u.getStartTime()) * (t.stream.bandwidth || 0) / 8), s1 ? ((u = u.h) && (s1 += (u.ka ? u.ka - u.Aa : null) || 0), a1 = 8 * s1 / (u = e.g.getBandwidthEstimate()) < (o || 0) - a1 - Math.max(e.m.minBufferTime || 0, e.i.rebufferingGoal) || t.sa.h.g > s1) : a1 = !1, a1 && t.sa.abort(), b(i);
                                });
                            })(e, o).catch(function(t) {
                                e.g && e.g.onError(t);
                            })) : function(e, t) {
                                var n, r, i, a1;
                                L(function(o) {
                                    switch(o.g){
                                        case 1:
                                            return n = $e, A(o, 2), T(o, Fo(e.g.R, n.Z), 4);
                                        case 4:
                                            S(o, 3);
                                            break;
                                        case 2:
                                            r = w(o), e.g && e.g.onError(r);
                                        case 3:
                                            i = Bt(t.mimeType, t.codecs), No(e.g.R, i, e.m.sequenceMode), (e.g.R.m.isTextVisible() || e.i.alwaysStreamText) && (a1 = Us(t), e.j.set(n.Z, a1), Vs(e, a1, 0)), b(o);
                                    }
                                });
                            }(e, t);
                        }
                        function Fs(e, t) {
                            t.ac || t.cb || (t.Ha ? (t.cb = !0, t.Mc = 0) : null == xo(e.g.R, t.type) ? null == t.Ta && Vs(e, t, 0) : (Ks(t), Hs(e, t, !1, 0).catch(function(t) {
                                e.g && e.g.onError(t);
                            })));
                        }
                        function Us(e) {
                            return {
                                stream: e,
                                type: e.type,
                                ba: null,
                                ya: null,
                                Zc: null,
                                Kd: null,
                                Jd: null,
                                Id: null,
                                ob: null,
                                endOfStream: !1,
                                Ha: !1,
                                Ta: null,
                                cb: !1,
                                Mc: 0,
                                jd: !1,
                                ac: !1,
                                uc: !0,
                                ae: !1,
                                mc: !1,
                                sa: null
                            };
                        }
                        function js(e, t, n, r, i, a1) {
                            var o, s1, u, l, c, d;
                            return L(function(f) {
                                switch(f.g){
                                    case 1:
                                        return o = r.closedCaptions && 0 < r.closedCaptions.size, u = null != r.emsgSchemeIdUris && 0 < r.emsgSchemeIdUris.length || e.i.dispatchAllEmsgBoxes, l = e.i.parsePrftBox && !e.D, (u || l) && (s1 = new Vr), u && s1.T("emsg", function(t) {
                                            var n = r.emsgSchemeIdUris;
                                            if (0 === t.version) var a1 = t.reader.rc(), o = t.reader.rc(), s1 = t.reader.L(), u = t.reader.L(), l = t.reader.L(), c = t.reader.L(), d = i.startTime + u / s1;
                                            else s1 = t.reader.L(), u = (d = t.reader.ab() / s1 + i.timestampOffset) - i.startTime, l = t.reader.L(), c = t.reader.L(), a1 = t.reader.rc(), o = t.reader.rc();
                                            t = t.reader.$a(t.reader.S.byteLength - t.reader.$()), (n && n.includes(a1) || e.i.dispatchAllEmsgBoxes) && ("urn:mpeg:dash:event:2012" == a1 ? e.g.fg() : "https://aomedia.org/emsg/ID3" == a1 ? (n = bo(t)).length && i && e.g.gg([
                                                {
                                                    cueTime: i.startTime,
                                                    data: t,
                                                    frames: n,
                                                    dts: i.startTime,
                                                    pts: i.startTime
                                                }
                                            ], 0, i.endTime) : (n = new gr("emsg", n = (new Map).set("detail", {
                                                startTime: d,
                                                endTime: d + l / s1,
                                                schemeIdUri: a1,
                                                value: o,
                                                timescale: s1,
                                                presentationTimeDelta: u,
                                                eventDuration: l,
                                                id: c,
                                                messageData: t
                                            })), e.g.onEvent(n)));
                                        }), l && s1.T("prft", function(t) {
                                            e: {
                                                if (!e.D && i.h.timescale) {
                                                    t.reader.L();
                                                    var n = t.reader.L();
                                                    if (n = 1e3 * n + t.reader.L() / Math.pow(2, 32) * 1e3, 0 === t.version) var r = t.reader.L();
                                                    else try {
                                                        r = t.reader.ab();
                                                    } catch (t) {
                                                        e.D = !0, r = void 0;
                                                        break e;
                                                    }
                                                    t = new Date(new Date(Date.UTC(1900, 0, 1, 0, 0, 0)).getTime() + n).getTime(), r = new gr("prft", r = (new Map).set("detail", {
                                                        wallClockTime: t,
                                                        programStartDate: new Date(t - r / i.h.timescale * 1e3)
                                                    })), e.g.onEvent(r), e.D = !0;
                                                }
                                                r = void 0;
                                            }
                                            return r;
                                        }), (u || l) && s1.parse(a1), T(f, function(e, t, n) {
                                            var r, i, a1;
                                            return L(function(o) {
                                                if (1 == o.g) return r = Math.max(e.i.bufferBehind, e.m.presentationTimeline.g), null == (i = xo(e.g.R, t.type)) || .01 >= (a1 = n - i - r) ? o.return() : T(o, e.g.R.remove(t.type, i, i + a1), 2);
                                                Lr(e.h), b(o);
                                            });
                                        }(e, t, n), 2);
                                    case 2:
                                        return Lr(e.h), c = t.uc, t.uc = !1, d = t.te, t.te = !1, T(f, e.g.ve(t.type, a1), 3);
                                    case 3:
                                        return T(f, Po(e.g.R, t.type, a1, i, o, c, d), 4);
                                    case 4:
                                        Lr(e.h), b(f);
                                }
                            });
                        }
                        function Bs(e) {
                            return e && e.type == Ze && ("application/cea-608" == e.stream.mimeType || "application/cea-708" == e.stream.mimeType);
                        }
                        function Gs(e, t, n, r) {
                            var i, a1, o, s1, u;
                            return L(function(l) {
                                return 1 == l.g ? (i = Cr, a1 = Ns(n.xa(), n.Aa, n.ka, e.i.retryParameters, r), o = t.stream, e.g.modifySegmentRequest(a1, {
                                    type: o.type,
                                    init: n instanceof uo,
                                    duration: n.endTime - n.startTime,
                                    mimeType: o.mimeType,
                                    codecs: o.codecs,
                                    bandwidth: o.bandwidth
                                }), s1 = e.g.lb.request(i, a1), t.sa = s1, T(l, s1.promise, 2)) : (u = l.h, t.sa = null, l.return(u.data));
                            });
                        }
                        function Hs(e, t, n, r) {
                            var i, a1;
                            return L(function(o) {
                                return 1 == o.g ? (t.cb = !1, t.jd = !1, t.Mc = 0, t.ac = !0, t.ya = null, t.Zc = null, t.ba = null, r ? (i = e.g.Sc(), a1 = e.g.R.getDuration(), T(o, e.g.R.remove(t.type, i + r, a1), 3)) : T(o, Fo(e.g.R, t.type), 4)) : 3 != o.g ? (Lr(e.h), n ? T(o, e.g.R.flush(t.type), 3) : o.A(3)) : (Lr(e.h), t.ac = !1, t.endOfStream = !1, Vs(e, t, 0), void b(o));
                            });
                        }
                        function Vs(t, n, r) {
                            var i = n.type;
                            (i != Ze || t.j.has(i)) && (n.Ta = new rt(function() {
                                var r;
                                return L(function(i) {
                                    return 1 == i.g ? (A(i, 2), T(i, function(t, n) {
                                        var r, i, a1, o, s1;
                                        return L(function(u) {
                                            switch(u.g){
                                                case 1:
                                                    if (Lr(t.h), n.Ha || null == n.Ta || n.ac) return u.return();
                                                    if (n.Ta = null, !n.cb) {
                                                        u.A(2);
                                                        break;
                                                    }
                                                    return T(u, Hs(t, n, n.jd, n.Mc), 3);
                                                case 3:
                                                    return u.return();
                                                case 2:
                                                    if (n.stream.segmentIndex) {
                                                        u.A(4);
                                                        break;
                                                    }
                                                    return r = n.stream, T(u, n.stream.createSegmentIndex(), 5);
                                                case 5:
                                                    if (r != n.stream) return r.closeSegmentIndex && r.closeSegmentIndex(), null == n.Ta && Vs(t, n, 0), u.return();
                                                case 4:
                                                    A(u, 6), i = function(t, n) {
                                                        if (Bs(n)) return function(e, t) {
                                                            var n = Mo(e, "video") || 0;
                                                            Wt(e.g, t, n);
                                                        }(t.g.R, n.stream.originalId || ""), null;
                                                        n.type == Ze && function(e) {
                                                            e.g && Wt(e.g, "", 0);
                                                        }(t.g.R);
                                                        var r = t.g.Sc(), i = n.ya ? n.ya.endTime : r, a1 = function(e, t, n) {
                                                            return t == Ze ? null == (e = e.g).h || e.h < n ? 0 : e.h - Math.max(n, e.g) : mo(e = Oo(e, t), n);
                                                        }(t.g.R, n.type, r), o = Math.max(t.m.minBufferTime || 0, t.i.rebufferingGoal, t.i.bufferingGoal) * t.u, s1 = t.m.presentationTimeline.getDuration() - i, u = Mo(t.g.R, n.type);
                                                        if (1e-6 > s1 && u) return n.endOfStream = !0, "video" == n.type && (r = t.j.get(Ze)) && Bs(r) && (r.endOfStream = !0), null;
                                                        if (n.endOfStream = !1, a1 >= o) return t.i.updateIntervalSeconds / 2;
                                                        if (a1 = function(e, t, n, r) {
                                                            if (t.ba) return t.ba.current();
                                                            if (t.ya || r) return t.ba = t.stream.segmentIndex.Bb(t.ya ? t.ya.endTime : r), t.ba && t.ba.next().value;
                                                            e = e.i.inaccurateManifestTolerance, r = Math.max(n - e, 0);
                                                            var i = null;
                                                            return e && (t.ba = t.stream.segmentIndex.Bb(r), i = t.ba && t.ba.next().value), i || (t.ba = t.stream.segmentIndex.Bb(n), i = t.ba && t.ba.next().value), i;
                                                        }(t, n, r, u), !a1) return t.i.updateIntervalSeconds;
                                                        for(o = 1 / 0, u = (s1 = l(s1 = Array.from(t.j.values()))).next(); !u.done; u = s1.next())Bs(u = u.value) || u.ba && !u.ba.current() || (o = Math.min(o, u.ya ? u.ya.endTime : r));
                                                        return i >= o + t.m.presentationTimeline.g ? t.i.updateIntervalSeconds : ((function(t, n, r, i) {
                                                            var a1, o, s1, u, l, c, d, f, h, g, p, m, v, y;
                                                            return L(function(E) {
                                                                switch(E.g){
                                                                    case 1:
                                                                        if (a1 = $e, o = n.stream, s1 = n.ba, n.Ha = !0, A(E, 2), 2 == i.Db()) throw new De(1, 1, 1011);
                                                                        return T(E, function(e, t, n) {
                                                                            var r, i, a1, o, s1, u, l;
                                                                            return L(function(c) {
                                                                                return r = [], i = Math.max(0, n.appendWindowStart - .1), a1 = n.appendWindowEnd + .01, (o = n.timestampOffset) == t.Kd && i == t.Jd && a1 == t.Id || (s1 = function() {
                                                                                    var n;
                                                                                    return L(function(r) {
                                                                                        if (1 == r.g) return A(r, 2), t.Jd = i, t.Id = a1, t.Kd = o, T(r, function(e, t, n, r, i, a1) {
                                                                                            return L(function(o) {
                                                                                                return t == $e.Z ? (a1 || (e.g.s = n), function(e, t, n) {
                                                                                                    e.l = t, e.m = n;
                                                                                                }(e.g, r, i), o.return()) : T(o, Promise.all([
                                                                                                    Ho(e, t, function() {
                                                                                                        return Bo(e, t);
                                                                                                    }),
                                                                                                    a1 ? Promise.resolve() : Ho(e, t, function() {
                                                                                                        var r = n;
                                                                                                        0 > r && (r += .001), e.h[t].timestampOffset = r, Go(e, t);
                                                                                                    }),
                                                                                                    Ho(e, t, function() {
                                                                                                        e.h[t].appendWindowStart = 0, e.h[t].appendWindowEnd = i, e.h[t].appendWindowStart = r, Go(e, t);
                                                                                                    })
                                                                                                ]), 0);
                                                                                            });
                                                                                        }(e.g.R, t.type, o, i, a1, e.m.sequenceMode), 4);
                                                                                        if (2 != r.g) return S(r, 0);
                                                                                        throw n = w(r), t.Jd = null, t.Id = null, t.Kd = null, n;
                                                                                    });
                                                                                }, r.push(s1())), !function(e, t) {
                                                                                    return e && t ? e.kc() == t.kc() && e.fc() == t.fc() && te(e.xa(), t.xa()) : e == t;
                                                                                }(n.h, t.Zc) && (t.Zc = n.h) && (u = Gs(e, t, n.h), l = function() {
                                                                                    var r, i, a1;
                                                                                    return L(function(o) {
                                                                                        switch(o.g){
                                                                                            case 1:
                                                                                                return A(o, 2), T(o, u, 4);
                                                                                            case 4:
                                                                                                return r = o.h, Lr(e.h), (new Vr).box("moov", Kr).box("trak", Kr).box("mdia", Kr).T("mdhd", function(e) {
                                                                                                    e = to(e.reader || 0, e.version || 0), n.h.timescale = e.timescale;
                                                                                                }).parse(r), i = t.stream.closedCaptions && 0 < t.stream.closedCaptions.size, T(o, e.g.ve(t.type, r), 5);
                                                                                            case 5:
                                                                                                return T(o, Po(e.g.R, t.type, r, null, i), 6);
                                                                                            case 6:
                                                                                                S(o, 0);
                                                                                                break;
                                                                                            case 2:
                                                                                                throw a1 = w(o), t.Zc = null, a1;
                                                                                        }
                                                                                    });
                                                                                }, e.g.eg(n.startTime, n.h), r.push(l())), T(c, Promise.all(r), 0);
                                                                            });
                                                                        }(t, n, i), 4);
                                                                    case 4:
                                                                        return Lr(t.h), t.s ? E.return() : (u = "video/mp4" == o.mimeType || "audio/mp4" == o.mimeType, l = e.ReadableStream, t.i.lowLatencyMode && l && u && !i.l ? (d = new Uint8Array(0), h = f = !1, g = function(e) {
                                                                            var a1, s1, u;
                                                                            return L(function(l) {
                                                                                return f ? l.return() : (h = !0, Lr(t.h), t.s ? l.return() : (d = function(e, t) {
                                                                                    var n = new Uint8Array(e.length + t.length);
                                                                                    return n.set(e), n.set(t, e.length), n;
                                                                                }(d, e), a1 = !1, s1 = 0, (new Vr).box("mdat", function(e) {
                                                                                    s1 = e.size + e.start, a1 = !0;
                                                                                }).parse(d, !1, !0), a1 ? (u = d.subarray(0, s1), d = d.subarray(s1), T(l, js(t, n, r, o, i, u), 0)) : l.A(0)));
                                                                            });
                                                                        }, T(E, Gs(t, n, i, g), 11)) : T(E, Gs(t, n, i), 7));
                                                                    case 7:
                                                                        if (c = E.h, Lr(t.h), t.s) return E.return();
                                                                        if (!i.l) {
                                                                            E.A(8);
                                                                            break;
                                                                        }
                                                                        return T(E, function(t, n, r) {
                                                                            var i, a1, o, s1;
                                                                            return L(function(u) {
                                                                                if (1 == u.g) return (i = n.l).cryptoKey ? u.A(2) : T(u, i.fetchKey(), 3);
                                                                                if (!(a1 = i.iv)) for(a1 = Ie(new ArrayBuffer(16)), o = i.firstMediaSequenceNumber + r.g, s1 = a1.byteLength - 1; 0 <= s1; s1--)a1[s1] = 255 & o, o >>= 8;
                                                                                return u.return(e.crypto.subtle.decrypt({
                                                                                    name: "AES-CBC",
                                                                                    iv: a1
                                                                                }, i.cryptoKey, t));
                                                                            });
                                                                        }(c, i, s1), 9);
                                                                    case 9:
                                                                        c = E.h;
                                                                    case 8:
                                                                        return Lr(t.h), n.cb ? (n.Ha = !1, Vs(t, n, 0), E.return()) : T(E, js(t, n, r, o, i, c), 6);
                                                                    case 11:
                                                                        if (p = E.h, h) {
                                                                            E.A(6);
                                                                            break;
                                                                        }
                                                                        return f = !0, Lr(t.h), t.s ? E.return() : n.cb ? (n.Ha = !1, Vs(t, n, 0), E.return()) : T(E, js(t, n, r, o, i, p), 6);
                                                                    case 6:
                                                                        if (Lr(t.h), t.s) return E.return();
                                                                        n.ya = i, s1.next(), n.Ha = !1, n.ae = !1, m = t.g.R.Ma(), v = m[n.type], JSON.stringify(v), n.cb || t.g.Vd(i.startTime, i.endTime, n.type), Vs(t, n, 0), S(E, 0);
                                                                        break;
                                                                    case 2:
                                                                        if (y = w(E), Lr(t.h, y), t.s) return E.return();
                                                                        if (n.Ha = !1, 7001 == y.code) n.Ha = !1, n.Ta = null, Vs(t, n, 0), E.A(0);
                                                                        else if (n.type == a1.Z && t.i.ignoreTextStreamFailures) t.j.delete(a1.Z), E.A(0);
                                                                        else {
                                                                            if (3017 != y.code) return n.mc = !0, y.severity = 2, T(E, Ys(t, y), 0);
                                                                            (function(e, t, n) {
                                                                                if (!Array.from(e.j.values()).some(function(e) {
                                                                                    return e != t && e.ae;
                                                                                })) {
                                                                                    var r = Math.round(100 * e.u);
                                                                                    if (20 < r) e.u -= .2;
                                                                                    else {
                                                                                        if (!(4 < r)) return t.mc = !0, e.s = !0, void e.g.onError(n);
                                                                                        e.u -= .04;
                                                                                    }
                                                                                    t.ae = !0;
                                                                                }
                                                                                Vs(e, t, 4);
                                                                            })(t, n, y), E.A(0);
                                                                        }
                                                                }
                                                            });
                                                        })(t, n, r, a1).catch(function() {}), null);
                                                    }(t, n), null != i && (Vs(t, n, i), n.mc = !1), S(u, 7);
                                                    break;
                                                case 6:
                                                    return a1 = w(u), T(u, Ys(t, a1), 8);
                                                case 8:
                                                    return u.return();
                                                case 7:
                                                    if (o = Array.from(t.j.values()), !t.B || !o.every(function(e) {
                                                        return e.endOfStream;
                                                    })) {
                                                        u.A(0);
                                                        break;
                                                    }
                                                    return T(u, t.g.R.endOfStream(), 10);
                                                case 10:
                                                    Lr(t.h), 0 != (s1 = t.g.R.getDuration()) && s1 < t.m.presentationTimeline.getDuration() && t.m.presentationTimeline.Ia(s1), b(u);
                                            }
                                        });
                                    }(t, n), 4)) : 2 != i.g ? S(i, 0) : (r = w(i), t.g && t.g.onError(r), void b(i));
                                });
                            }).O(r));
                        }
                        function Ks(e) {
                            null != e.Ta && (e.Ta.stop(), e.Ta = null);
                        }
                        function qs(e) {
                            return L(function(t) {
                                return e.sa ? T(t, e.sa.abort(), 0) : t.A(0);
                            });
                        }
                        function Ys(e, t) {
                            return L(function(n) {
                                if (1 == n.g) return T(n, sr(e.F), 2);
                                Lr(e.h), e.g.onError(t), t.handled || e.i.failureCallback(t), b(n);
                            });
                        }
                        function Ws(e, t) {
                            var n = {
                                J: null,
                                mimeType: null,
                                startTime: null,
                                me: NaN,
                                uri: null
                            }, r = this;
                            this.j = t, this.i = e, this.l = n, this.o = null, this.m = [], this.h = this.g = null, this.u = Promise.resolve().then(function() {
                                return function(e) {
                                    return L(function(t) {
                                        if (e.s.g) t = t.A(0);
                                        else {
                                            if (0 == e.m.length || e.g && !e.g.ib) var n = !1;
                                            else {
                                                e.g && (e.g.Ga.mb(), e.g = null);
                                                var r = (n = e.m.shift()).create(e.l);
                                                r ? (n.Ga.Ib(), e.g = {
                                                    node: r.node,
                                                    payload: r.payload,
                                                    ib: r.ib,
                                                    Ga: n.Ga
                                                }) : n.Ga.dd(), n = !0;
                                            }
                                            n ? n = Promise.resolve() : e.g ? n = function(e) {
                                                var t, n;
                                                return L(function(r) {
                                                    switch(r.g){
                                                        case 1:
                                                            return e.i = e.j.Lf(e.i, e.l, e.g.node, e.g.payload), A(r, 2), e.h = e.j.xf(e.i, e.l, e.g.payload), T(r, e.h.promise, 4);
                                                        case 4:
                                                            e.h = null, e.i == e.g.node && (e.g.Ga.bd(), e.g = null), S(r, 0);
                                                            break;
                                                        case 2:
                                                            return 7001 == (t = w(r)).code ? e.g.Ga.mb() : e.g.Ga.onError(t), e.g = null, e.h = null, n = e, T(r, e.j.handleError(e.l, t), 5);
                                                        case 5:
                                                            n.i = r.h, b(r);
                                                    }
                                                });
                                            }(e) : (e.j.dg(e.i), e.o = new tt, n = e.o), t = T(t, n, 1);
                                        }
                                        return t;
                                    });
                                }(r);
                            }), this.s = new Nr(function() {
                                return function(e) {
                                    var t, n;
                                    return L(function(r) {
                                        if (1 == r.g) return e.h && e.h.abort(), Xs(e), T(r, e.u, 2);
                                        for(e.g && e.g.Ga.mb(), t = l(e.m), n = t.next(); !n.done; n = t.next())n.value.Ga.mb();
                                        e.g = null, e.m = [], e.j = null, b(r);
                                    });
                                }(r);
                            });
                        }
                        function zs(e, t) {
                            var n = {
                                Ib: function() {},
                                bd: function() {},
                                mb: function() {},
                                onError: function() {},
                                dd: function() {},
                                vh: function() {}
                            };
                            return e.m.push({
                                create: t,
                                Ga: n
                            }), e.h && e.h.abort(), Xs(e), n;
                        }
                        function Xs(e) {
                            e.o && (e.o.resolve(), e.o = null);
                        }
                        function Qs(e) {
                            this.g = null;
                            for(var t = l(Array.from(e.textTracks)), n = t.next(); !n.done; n = t.next())(n = n.value).mode = "disabled", "Shaka Player TextTrack" == n.label && (this.g = n);
                            this.g || (this.g = e.addTextTrack("subtitles", "Shaka Player TextTrack")), this.g.mode = "hidden";
                        }
                        function Js(e) {
                            if (e.startTime >= e.endTime) return null;
                            var t = new VTTCue(e.startTime, e.endTime, e.payload);
                            t.lineAlign = e.lineAlign, t.positionAlign = e.positionAlign, e.size && (t.size = e.size);
                            try {
                                t.align = e.textAlign;
                            } catch (e) {}
                            return "center" == e.textAlign && "center" != t.align && (t.align = "middle"), "vertical-lr" == e.writingMode ? t.vertical = "lr" : "vertical-rl" == e.writingMode && (t.vertical = "rl"), 1 == e.lineInterpretation && (t.snapToLines = !1), null != e.line && (t.line = e.line), null != e.position && (t.position = e.position), t;
                        }
                        function Zs(e, t) {
                            var n = e.mode;
                            e.mode = "showing" == n ? "showing" : "hidden";
                            for(var r = l(Array.from(e.cues)), i = r.next(); !i.done; i = r.next())(i = i.value) && t(i) && e.removeCue(i);
                            e.mode = n;
                        }
                        function $s() {}
                        function eu(e) {
                            for(; e.firstChild;)e.removeChild(e.firstChild);
                        }
                        function tu(t, n) {
                            var r = this;
                            this.j = !1, this.i = [], this.B = t, this.m = n, this.g = document.createElement("div"), this.g.classList.add("shaka-text-container"), this.g.style.textAlign = "center", this.g.style.display = "flex", this.g.style.flexDirection = "column", this.g.style.alignItems = "center", this.g.style.justifyContent = "flex-end", this.m.appendChild(this.g), this.u = new it(function() {
                                ru(r);
                            }).Ba(.25), this.h = new Map, this.s = new xr, this.s.C(document, "fullscreenchange", function() {
                                ru(r, !0);
                            }), this.l = null, "ResizeObserver" in e && (this.l = new ResizeObserver(function() {
                                ru(r, !0);
                            }), this.l.observe(this.g)), this.o = new Map;
                        }
                        function nu(e, t, n, r, i) {
                            for(var a1 = !1, o = [], s1 = [], u = (t = l(t)).next(); !u.done; u = t.next()){
                                u = u.value, i.push(u);
                                var c = e.h.get(u), d = u.startTime <= r && u.endTime > r, f = c ? c.df : null;
                                c && (o.push(c.Cd), c.sc && o.push(c.sc), d || (a1 = !0, e.h.delete(u), c = null)), d && (s1.push(u), c || (iu(e, u, i), f = (c = e.h.get(u)).df, a1 = !0)), 0 < u.nestedCues.length && f && nu(e, u.nestedCues, f, r, i), i.pop();
                            }
                            if (a1) {
                                for(i = (r = l(o)).next(); !i.done; i = r.next())(i = i.value).parentElement && i.parentElement.removeChild(i);
                                for(s1.sort(function(e, t) {
                                    return e.startTime != t.startTime ? e.startTime - t.startTime : e.endTime - t.endTime;
                                }), u = (s1 = l(s1)).next(); !u.done; u = s1.next())(r = e.h.get(u.value)).sc ? (n.appendChild(r.sc), r.sc.appendChild(r.Cd)) : n.appendChild(r.Cd);
                            }
                        }
                        function ru(e, t) {
                            if (e.g) {
                                var n = e.B.currentTime;
                                if (!e.j || void 0 !== t && t) {
                                    for(var r = l(e.o.values()), i = r.next(); !i.done; i = r.next())eu(i.value);
                                    eu(e.g), e.h.clear(), e.o.clear();
                                }
                                if (e.j) {
                                    r = new Map;
                                    for(var a1 = (i = l(e.h.keys())).next(); !a1.done; a1 = i.next())a1 = a1.value, r.set(a1, e.h.get(a1));
                                    nu(e, e.i, e.g, n, []);
                                }
                            }
                        }
                        function iu(e, t, n) {
                            var r = 1 < n.length, i = r ? "span" : "div";
                            t.lineBreak && (i = "br"), r = !r && 0 < t.nestedCues.length;
                            var a1 = document.createElement(i);
                            if ("br" != i && function(e, t, n, r, i) {
                                var a1 = t.style, o = 0 == n.nestedCues.length, s1 = 1 < r.length;
                                a1.whiteSpace = "pre-wrap";
                                var u = n.payload.replace(/\s+$/g, function(e) {
                                    return "\xa0".repeat(e.length);
                                });
                                if (a1.webkitTextStrokeColor = n.textStrokeColor, a1.webkitTextStrokeWidth = n.textStrokeWidth, a1.color = n.color, a1.direction = n.direction, a1.opacity = n.opacity, a1.paddingLeft = au(n.linePadding, n, e.m), a1.paddingRight = au(n.linePadding, n, e.m), a1.textShadow = n.textShadow, n.backgroundImage) a1.backgroundImage = "url('" + n.backgroundImage + "')", a1.backgroundRepeat = "no-repeat", a1.backgroundSize = "contain", a1.backgroundPosition = "center", a1.width = "100%", a1.height = "100%";
                                else {
                                    if (n.nestedCues.length) var l = t;
                                    else l = document.createElement("span"), t.appendChild(l);
                                    n.border && (l.style.border = n.border), i || ((t = function(e, t) {
                                        for(var n = e.length - 1; 0 <= n; n--){
                                            var r = e[n].backgroundColor;
                                            if (r || 0 === r) return r;
                                        }
                                        return null;
                                    }(r)) ? l.style.backgroundColor = t : u && (l.style.backgroundColor = "rgba(0, 0, 0, 0.8)")), u && (l.textContent = u);
                                }
                                s1 && !r[r.length - 1].isContainer ? a1.display = "inline" : (a1.display = "flex", a1.flexDirection = "column", a1.alignItems = "center", a1.justifyContent = "before" == n.displayAlign ? "flex-start" : "center" == n.displayAlign ? "center" : "flex-end"), o || (a1.margin = "0"), a1.fontFamily = n.fontFamily, a1.fontWeight = n.fontWeight.toString(), a1.fontStyle = n.fontStyle, a1.letterSpacing = n.letterSpacing, a1.fontSize = au(n.fontSize, n, e.m), null != n.line && 1 == n.lineInterpretation && (a1.position = "absolute", a1.left = "0", a1.top = "0", n.writingMode == ce ? (a1.width = "100%", n.lineAlign == fe ? a1.top = n.line + "%" : "end" == n.lineAlign && (a1.bottom = 100 - n.line + "%")) : "vertical-lr" == n.writingMode ? (a1.height = "100%", n.lineAlign == fe ? a1.left = n.line + "%" : "end" == n.lineAlign && (a1.right = 100 - n.line + "%")) : (a1.height = "100%", n.lineAlign == fe ? a1.right = n.line + "%" : "end" == n.lineAlign && (a1.left = 100 - n.line + "%"))), a1.lineHeight = n.lineHeight, null != n.position && (n.writingMode == ce ? a1.paddingLeft = n.position : a1.paddingTop = n.position), "line-left" == n.positionAlign ? a1.cssFloat = "left" : "line-right" == n.positionAlign && (a1.cssFloat = "right"), a1.textAlign = n.textAlign, a1.textDecoration = n.textDecoration.join(" "), a1.writingMode = n.writingMode, "writingMode" in document.documentElement.style && a1.writingMode == n.writingMode || (a1.webkitWritingMode = n.writingMode), n.size && (n.writingMode == ce ? a1.width = n.size + "%" : a1.height = n.size + "%");
                            }(e, a1, t, n, r), n = null, t.region && t.region.id) {
                                if (n = t.region, e.o.has(n.id)) n = e.o.get(n.id);
                                else {
                                    i = document.createElement("span");
                                    var o = n.heightUnits == Te ? "%" : "px", s1 = n.widthUnits == Te ? "%" : "px", u = n.viewportAnchorUnits == Te ? "%" : "px";
                                    i.id = "shaka-text-region---" + n.id, i.classList.add("shaka-text-region"), i.style.height = n.height + o, i.style.width = n.width + s1, i.style.position = "absolute", i.style.top = n.viewportAnchorY + u, i.style.left = n.viewportAnchorX + u, i.style.display = "flex", i.style.flexDirection = "column", i.style.alignItems = "center", i.style.justifyContent = "before" == t.displayAlign ? "flex-start" : "center" == t.displayAlign ? "center" : "flex-end", e.o.set(n.id, i), n = i;
                                }
                            }
                            i = a1, r && ((i = document.createElement("span")).classList.add("shaka-text-wrapper"), i.style.backgroundColor = t.backgroundColor, a1.appendChild(i)), e.h.set(t, {
                                Cd: a1,
                                df: i,
                                sc: n
                            });
                        }
                        function au(e, t, n) {
                            var r = (r = new RegExp(/(\d*\.?\d+)([a-z]+|%+)/).exec(e)) ? {
                                value: Number(r[1]),
                                unit: r[2]
                            } : null;
                            if (!r) return e;
                            var i = r.value;
                            switch(r.unit){
                                case "%":
                                    return i / 100 * n.clientHeight / t.cellResolution.rows + "px";
                                case "c":
                                    return n.clientHeight * i / t.cellResolution.rows + "px";
                                default:
                                    return e;
                            }
                        }
                        function ou(e, t) {
                            this.h = e, this.g = t, this.j = "", this.o = void 0, this.i = !1, this.m = !0, this.l = !1;
                        }
                        function su(e, t, n) {
                            try {
                                if (e.g.enabled) {
                                    var r = {
                                        d: 1e3 * n.duration,
                                        st: e.h.U() ? Eu : yu
                                    };
                                    r.ot = function(e) {
                                        var t = e.type;
                                        return e.init ? pu : "video" == t ? e.codecs.includes(",") ? gu : hu : "audio" == t ? fu : "text" == t ? "application/mp4" === e.mimeType ? vu : mu : void 0;
                                    }(n);
                                    var i = r.ot === hu || r.ot === fu || r.ot === gu || r.ot === vu;
                                    i && (r.bl = function(e, t) {
                                        var n = e.h.Ma()[t];
                                        if (!n.length) return NaN;
                                        var r = e.h.getCurrentTime();
                                        return (n = n.find(function(e) {
                                            return e.start <= r && e.end >= r;
                                        })) ? 1e3 * (n.end - r) : NaN;
                                    }(e, n.type)), n.bandwidth && (r.br = n.bandwidth / 1e3), i && r.ot !== vu && (r.tb = function(e, t) {
                                        var n = e.h.Pa();
                                        if (!n.length) return NaN;
                                        for(var r = n[0], i = (n = l(n)).next(); !i.done; i = n.next())"variant" === (i = i.value).type && i.bandwidth > r.bandwidth && (r = i);
                                        switch(t){
                                            case hu:
                                                return r.videoBandwidth || NaN;
                                            case fu:
                                                return r.audioBandwidth || NaN;
                                            default:
                                                return r.bandwidth;
                                        }
                                    }(e, r.ot) / 1e3), lu(e, t, r);
                                }
                            } catch (e) {
                                W("CMCD_SEGMENT_ERROR", "Could not generate segment CMCD data.", e);
                            }
                        }
                        function uu(t) {
                            return t.j || (t.j = t.g.sessionId || e.crypto.randomUUID()), {
                                v: 1,
                                sf: t.o,
                                sid: t.j,
                                cid: t.g.contentId,
                                mtp: t.h.getBandwidthEstimate() / 1e3
                            };
                        }
                        function lu(e, t, n) {
                            n = void 0 === n ? {} : n;
                            var r = void 0 === r ? e.g.useHeaders : r;
                            if (e.g.enabled) {
                                Object.assign(n, uu(e)), n.pr = e.h.Rc();
                                var i = n.ot === hu || n.ot === gu;
                                if (e.l && i && (n.bs = !0, n.su = !0, e.l = !1), null == n.su && (n.su = e.m), r) e = function(e) {
                                    for(var t = Object.keys(e), n = {}, r = [
                                        "Object",
                                        "Request",
                                        "Session",
                                        "Status"
                                    ], i = [
                                        {},
                                        {},
                                        {},
                                        {}
                                    ], a1 = {
                                        br: 0,
                                        d: 0,
                                        ot: 0,
                                        tb: 0,
                                        bl: 1,
                                        dl: 1,
                                        mtp: 1,
                                        nor: 1,
                                        nrr: 1,
                                        su: 1,
                                        cid: 2,
                                        pr: 2,
                                        sf: 2,
                                        sid: 2,
                                        st: 2,
                                        v: 2,
                                        bs: 3,
                                        rtp: 3
                                    }, o = (t = l(t)).next(); !o.done; o = t.next())i[null != a1[o = o.value] ? a1[o] : 1][o] = e[o];
                                    for(e = 0; e < i.length; e++)(a1 = cu(i[e])) && (n["CMCD-" + r[e]] = a1);
                                    return n;
                                }(n), Object.keys(e).length && Object.assign(t.headers, e);
                                else {
                                    var a1 = cu(n);
                                    a1 && (t.uris = t.uris.map(function(e) {
                                        return du(e, a1);
                                    }));
                                }
                            }
                        }
                        function cu(e) {
                            function t(e) {
                                return 100 * n(e / 100);
                            }
                            function n(e) {
                                return Math.round(e);
                            }
                            for(var r = [], i = {
                                br: n,
                                d: n,
                                bl: t,
                                dl: t,
                                mtp: t,
                                nor: function(e) {
                                    return encodeURIComponent(e);
                                },
                                rtp: t,
                                tb: n
                            }, a1 = Object.keys(e || {}).sort(), o = (a1 = l(a1)).next(); !o.done; o = a1.next()){
                                var s1 = e[o = o.value];
                                if (!(d = s1, Number.isNaN(d) || null == d || "" === d || !1 === d || "v" === o && 1 === s1 || "pr" == o && 1 === s1)) {
                                    var u, c = i[o];
                                    c && (s1 = c(s1)), u = "string" == (c = typeof s1) && "ot" !== o && "sf" !== o && "st" !== o ? o + "=" + JSON.stringify(s1) : "boolean" === c ? o : "symbol" === c ? o + "=" + s1.description : o + "=" + s1, r.push(u);
                                }
                            }
                            var d;
                            return r.join(",");
                        }
                        function du(e, t) {
                            if (!t || e.includes("offline:")) return e;
                            var n = new Ne(e);
                            return n.g.set("CMCD", t), n.toString();
                        }
                        (r = Ls.prototype).destroy = function() {
                            return this.h.destroy();
                        }, r.configure = function(e) {
                            this.i = e, this.F = new or({
                                maxAttempts: Math.max(e.retryParameters.maxAttempts, 2),
                                baseDelay: e.retryParameters.baseDelay,
                                backoffFactor: e.retryParameters.backoffFactor,
                                fuzzFactor: e.retryParameters.fuzzFactor,
                                timeout: 0,
                                stallTimeout: 0,
                                connectionTimeout: 0
                            }, !0);
                        }, r.start = function() {
                            var e = this;
                            return L(function(t) {
                                if (1 == t.g) return T(t, function(e) {
                                    var t, n, r, i, a1, o, s1, u, c, d;
                                    return L(function(f) {
                                        if (1 == f.g) {
                                            if (t = $e, !e.l) throw new De(2, 5, 5006);
                                            return n = new Map, r = new Set, e.l.audio && (n.set(t.Gc, e.l.audio), r.add(e.l.audio)), e.l.video && (n.set(t.ua, e.l.video), r.add(e.l.video)), e.o && (n.set(t.Z, e.o), r.add(e.o)), i = e.g.R, a1 = e.i.forceTransmux, T(f, i.init(n, a1, e.m.sequenceMode), 2);
                                        }
                                        for(Lr(e.h), e.updateDuration(), o = l(n.keys()), s1 = o.next(); !s1.done; s1 = o.next())u = s1.value, c = n.get(u), e.j.has(u) || (d = Us(c), e.j.set(u, d), Vs(e, d, 0));
                                        b(f);
                                    });
                                }(e), 2);
                                Lr(e.h), e.B = !0, b(t);
                            });
                        }, r.uc = function() {
                            for(var e = this.g.Sc(), t = l(this.j.keys()), n = t.next(); !n.done; n = t.next()){
                                var r = n.value;
                                (n = this.j.get(r)).ba = null;
                                var i = this.g.R;
                                if (!(i = r == Ze ? null != (i = i.g).g && null != i.h && e >= i.g && e < i.h : po(i = Oo(i, r), e))) {
                                    if ((null != Mo(this.g.R, r) || n.Ha) && Fs(this, n), n.sa && (n.sa.abort(), n.sa = null), r === Ze && (r = this.g.R).s) for((r = r.s.g).l = 0, r.h = [], r.g = [], (i = r.i).i = [], i.h = [], i.g = 0, za(r), i = (r = l(r.j.values())).next(); !i.done; i = r.next())Va(i.value);
                                    n.uc = !0;
                                }
                            }
                        }, r.updateDuration = function() {
                            var e = this.m.presentationTimeline.getDuration();
                            1 / 0 > e ? this.g.R.Ia(e) : this.g.R.Ia(Math.pow(2, 32));
                        }, Ws.prototype.destroy = function() {
                            return this.s.destroy();
                        }, (r = Qs.prototype).remove = function(e, t) {
                            return !!this.g && (Zs(this.g, function(n) {
                                return n.startTime < t && n.endTime > e;
                            }), !0);
                        }, r.append = function(e) {
                            function t(e) {
                                var n = [], r = 700 <= e.fontWeight, i = "italic" == e.fontStyle, a1 = e.textDecoration.includes("underline");
                                return r && n.push("b"), i && n.push("i"), a1 && n.push("u"), r = n.reduce(function(e, t) {
                                    return e + "<" + t + ">";
                                }, ""), n = n.reduceRight(function(e, t) {
                                    return e + "</" + t + ">";
                                }, ""), e.lineBreak ? "\n" : e.nestedCues.length ? e.nestedCues.map(t).join("") : r + e.payload + n;
                            }
                            var n = function e(n, r) {
                                for(var i = l(n), a1 = i.next(); !a1.done; a1 = i.next())if ((a1 = a1.value).isContainer) e(a1.nestedCues, r);
                                else {
                                    var o = a1.clone();
                                    o.nestedCues = [], o.payload = t(a1), r.push(o);
                                }
                                return r;
                            }(e, []), r = [];
                            e = this.g.cues ? Array.from(this.g.cues) : [];
                            for(var i = {}, a1 = (n = l(n)).next(); !a1.done; i = {
                                sb: i.sb
                            }, a1 = n.next())i.sb = a1.value, e.some(function(e) {
                                return function(t) {
                                    return t.startTime == e.sb.startTime && t.endTime == e.sb.endTime && t.text == e.sb.payload;
                                };
                            }(i)) || (a1 = Js(i.sb)) && r.push(a1);
                            for(e = r.slice().sort(function(e, t) {
                                return e.startTime != t.startTime ? e.startTime - t.startTime : e.endTime != t.endTime ? e.endTime - t.startTime : "line" in VTTCue.prototype ? r.indexOf(t) - r.indexOf(e) : r.indexOf(e) - r.indexOf(t);
                            }), i = (e = l(e)).next(); !i.done; i = e.next())this.g.addCue(i.value);
                        }, r.destroy = function() {
                            return this.g && (Zs(this.g, function() {
                                return !0;
                            }), this.g.mode = "disabled"), this.g = null, Promise.resolve();
                        }, r.isTextVisible = function() {
                            return "showing" == this.g.mode;
                        }, r.setTextVisibility = function(e) {
                            this.g.mode = e ? "showing" : "hidden";
                        }, B("shaka.text.SimpleTextDisplayer", Qs), Qs.prototype.setTextVisibility = Qs.prototype.setTextVisibility, Qs.prototype.isTextVisible = Qs.prototype.isTextVisible, Qs.prototype.destroy = Qs.prototype.destroy, Qs.prototype.append = Qs.prototype.append, Qs.prototype.remove = Qs.prototype.remove, B("shaka.util.Dom", $s), $s.removeAllChildren = eu, (r = tu.prototype).append = function(e) {
                            for(var t = [].concat(c(this.i)), n = {}, r = (e = l(e)).next(); !r.done; n = {
                                Bc: n.Bc
                            }, r = e.next())n.Bc = r.value, t.some(function(e) {
                                return function(t) {
                                    return re(t, e.Bc);
                                };
                            }(n)) || this.i.push(n.Bc);
                            ru(this);
                        }, r.destroy = function() {
                            this.m.removeChild(this.g), this.g = null, this.j = !1, this.i = [], this.u && this.u.stop(), this.h.clear(), this.s && (this.s.release(), this.s = null), this.l && (this.l.disconnect(), this.l = null);
                        }, r.remove = function(e, t) {
                            if (!this.g) return !1;
                            var n = this.i.length;
                            return this.i = this.i.filter(function(n) {
                                return n.startTime < e || n.endTime >= t;
                            }), ru(this, n > this.i.length), !0;
                        }, r.isTextVisible = function() {
                            return this.j;
                        }, r.setTextVisibility = function(e) {
                            this.j = e;
                        }, B("shaka.text.UITextDisplayer", tu), tu.prototype.setTextVisibility = tu.prototype.setTextVisibility, tu.prototype.isTextVisible = tu.prototype.isTextVisible, tu.prototype.remove = tu.prototype.remove, tu.prototype.destroy = tu.prototype.destroy, tu.prototype.append = tu.prototype.append, B("shaka.text.WebVttGenerator", function() {});
                        var fu = "a", hu = "v", gu = "av", pu = "i", mu = "c", vu = "tt", yu = "v", Eu = "l";
                        function Tu() {}
                        function bu(e, t, n, r, i) {
                            var a1, o = i in r, s1 = !0;
                            for(a1 in t){
                                var u = i + "." + a1, l = o ? r[i] : n[a1];
                                o || a1 in n ? void 0 === t[a1] ? void 0 === l || o ? delete e[a1] : e[a1] = yr(l) : l.constructor == Object && t[a1] && t[a1].constructor == Object ? (e[a1] || (e[a1] = yr(l)), u = bu(e[a1], t[a1], l, r, u), s1 = s1 && u) : typeof t[a1] != typeof l || null == t[a1] || "function" != typeof t[a1] && t[a1].constructor != l.constructor ? (q("Invalid config, wrong type for " + u), s1 = !1) : ("function" == typeof n[a1] && n[a1].length != t[a1].length && Y("Unexpected number of arguments for " + u), e[a1] = t[a1]) : (q("Invalid config, unrecognized key " + u), s1 = !1);
                            }
                            return s1;
                        }
                        function Au(e, t) {
                            for(var n = {}, r = n, i = 0, a1 = 0; !(0 > (i = e.indexOf(".", i)));)0 != i && "\\" == e[i - 1] || (r[a1 = e.substring(a1, i).replace(/\\\./g, ".")] = {}, r = r[a1], a1 = i + 1), i += 1;
                            return r[e.substring(a1).replace(/\\\./g, ".")] = t, n;
                        }
                        function _u(e, t) {
                            return e && t;
                        }
                        function Su() {}
                        function wu() {
                            var e = 1 / 0;
                            navigator.connection && navigator.connection.saveData && (e = 360);
                            var t = {
                                retryParameters: {
                                    maxAttempts: 2,
                                    baseDelay: 1e3,
                                    backoffFactor: 2,
                                    fuzzFactor: .5,
                                    timeout: 3e4,
                                    stallTimeout: 5e3,
                                    connectionTimeout: 1e4
                                },
                                servers: {},
                                clearKeys: {},
                                advanced: {},
                                delayLicenseRequestUntilPlayed: !1,
                                initDataTransform: function(e, t, n) {
                                    return _u([
                                        e,
                                        t,
                                        n
                                    ], e);
                                },
                                logLicenseExchange: !1,
                                updateExpirationTime: 1,
                                preferredKeySystems: [],
                                keySystemsMapping: {},
                                parseInbandPsshEnabled: st()
                            }, n = {
                                retryParameters: {
                                    maxAttempts: 2,
                                    baseDelay: 1e3,
                                    backoffFactor: 2,
                                    fuzzFactor: .5,
                                    timeout: 3e4,
                                    stallTimeout: 5e3,
                                    connectionTimeout: 1e4
                                },
                                availabilityWindowOverride: NaN,
                                disableAudio: !1,
                                disableVideo: !1,
                                disableText: !1,
                                disableThumbnails: !1,
                                defaultPresentationDelay: 0,
                                segmentRelativeVttTiming: !1,
                                dash: {
                                    clockSyncUri: "",
                                    ignoreDrmInfo: !1,
                                    disableXlinkProcessing: !1,
                                    xlinkFailGracefully: !1,
                                    ignoreMinBufferTime: !1,
                                    autoCorrectDrift: !0,
                                    initialSegmentLimit: 1e3,
                                    ignoreSuggestedPresentationDelay: !1,
                                    ignoreEmptyAdaptationSet: !1,
                                    ignoreMaxSegmentDuration: !1,
                                    keySystemsByURI: {
                                        "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
                                        "urn:uuid:e2719d58-a985-b3c9-781a-b030af78d30e": "org.w3.clearkey",
                                        "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
                                        "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
                                        "urn:uuid:79f0049a-4098-8642-ab92-e65be0885f95": "com.microsoft.playready",
                                        "urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb": "com.adobe.primetime"
                                    },
                                    manifestPreprocessor: function(e) {
                                        return _u([
                                            e
                                        ], e);
                                    },
                                    sequenceMode: !1
                                },
                                hls: {
                                    ignoreTextStreamFailures: !1,
                                    ignoreImageStreamFailures: !1,
                                    defaultAudioCodec: "mp4a.40.2",
                                    defaultVideoCodec: "avc1.42E01E",
                                    ignoreManifestProgramDateTime: !1,
                                    mediaPlaylistFullMimeType: 'video/mp2t; codecs="avc1.42E01E, mp4a.40.2"',
                                    useSafariBehaviorForLive: !0,
                                    liveSegmentsDelay: 3
                                }
                            }, r = {
                                retryParameters: {
                                    maxAttempts: 2,
                                    baseDelay: 1e3,
                                    backoffFactor: 2,
                                    fuzzFactor: .5,
                                    timeout: 3e4,
                                    stallTimeout: 5e3,
                                    connectionTimeout: 1e4
                                },
                                failureCallback: function(e) {
                                    return _u([
                                        e
                                    ], void 0);
                                },
                                rebufferingGoal: 2,
                                bufferingGoal: 10,
                                bufferBehind: 30,
                                ignoreTextStreamFailures: !1,
                                alwaysStreamText: !1,
                                startAtSegmentBoundary: !1,
                                gapDetectionThreshold: .5,
                                durationBackoff: 1,
                                forceTransmux: !1,
                                safeSeekOffset: 5,
                                stallEnabled: !0,
                                stallThreshold: 1,
                                stallSkip: .1,
                                useNativeHlsOnSafari: !0,
                                inaccurateManifestTolerance: 2,
                                lowLatencyMode: !1,
                                autoLowLatencyMode: !1,
                                forceHTTPS: !1,
                                preferNativeHls: !1,
                                updateIntervalSeconds: 1,
                                dispatchAllEmsgBoxes: !1,
                                observeQualityChanges: !1,
                                maxDisabledTime: 30,
                                parsePrftBox: !1
                            };
                            (ht("Web0S") || ut() || ht("CrKey")) && (r.stallSkip = 0);
                            var i = {
                                trackSelectionCallback: function(e) {
                                    return L(function(t) {
                                        return t.return(e);
                                    });
                                },
                                downloadSizeCallback: function(e) {
                                    var t;
                                    return L(function(n) {
                                        return 1 == n.g ? navigator.storage && navigator.storage.estimate ? T(n, navigator.storage.estimate(), 3) : n.return(!0) : (t = n.h, n.return(t.usage + e < .95 * t.quota));
                                    });
                                },
                                progressCallback: function(e, t) {
                                    return _u([
                                        e,
                                        t
                                    ], void 0);
                                },
                                usePersistentLicense: !0,
                                numberOfParallelDownloads: 5
                            }, a1 = {
                                drm: t,
                                manifest: n,
                                streaming: r,
                                mediaSource: {
                                    sourceBufferExtraFeatures: ""
                                },
                                offline: i,
                                abrFactory: function() {
                                    return new Gn;
                                },
                                abr: {
                                    enabled: !0,
                                    useNetworkInformation: !0,
                                    defaultBandwidthEstimate: 1e6,
                                    switchInterval: 8,
                                    bandwidthUpgradeTarget: .85,
                                    bandwidthDowngradeTarget: .95,
                                    restrictions: {
                                        minWidth: 0,
                                        maxWidth: 1 / 0,
                                        minHeight: 0,
                                        maxHeight: e,
                                        minPixels: 0,
                                        maxPixels: 1 / 0,
                                        minFrameRate: 0,
                                        maxFrameRate: 1 / 0,
                                        minBandwidth: 0,
                                        maxBandwidth: 1 / 0
                                    },
                                    advanced: {
                                        minTotalBytes: 128e3,
                                        minBytes: 16e3,
                                        fastHalfLife: 2,
                                        slowHalfLife: 5
                                    },
                                    restrictToElementSize: !1,
                                    restrictToScreenSize: !1,
                                    ignoreDevicePixelRatio: !1
                                },
                                autoShowText: 3,
                                preferredAudioLanguage: "",
                                preferredTextLanguage: "",
                                preferredVariantRole: "",
                                preferredTextRole: "",
                                preferredAudioChannelCount: 2,
                                preferredVideoCodecs: [],
                                preferredAudioCodecs: [],
                                preferForcedSubs: !1,
                                preferredDecodingAttributes: [],
                                restrictions: {
                                    minWidth: 0,
                                    maxWidth: 1 / 0,
                                    minHeight: 0,
                                    maxHeight: 1 / 0,
                                    minPixels: 0,
                                    maxPixels: 1 / 0,
                                    minFrameRate: 0,
                                    maxFrameRate: 1 / 0,
                                    minBandwidth: 0,
                                    maxBandwidth: 1 / 0
                                },
                                playRangeStart: 0,
                                playRangeEnd: 1 / 0,
                                textDisplayFactory: function() {
                                    return null;
                                },
                                cmcd: {
                                    enabled: !1,
                                    sessionId: "",
                                    contentId: "",
                                    useHeaders: !1
                                },
                                lcevc: {
                                    enabled: !1,
                                    dynamicPerformanceScaling: !0,
                                    logLevel: 0,
                                    drawLogo: !1
                                }
                            };
                            return i.trackSelectionCallback = function(e) {
                                return L(function(t) {
                                    return t.return(function(e, t) {
                                        var n = e.filter(function(e) {
                                            return "variant" == e.type;
                                        }), r = [], i = on(t, n.map(function(e) {
                                            return e.language;
                                        }));
                                        i && (r = n.filter(function(e) {
                                            return tn(e.language) == i;
                                        })), 0 == r.length && (r = n.filter(function(e) {
                                            return e.primary;
                                        })), 0 == r.length && (n.map(function(e) {
                                            return e.language;
                                        }), r = n);
                                        var a1 = r.filter(function(e) {
                                            return e.height && 480 >= e.height;
                                        });
                                        if (a1.length && (a1.sort(function(e, t) {
                                            return t.height - e.height;
                                        }), r = a1.filter(function(e) {
                                            return e.height == a1[0].height;
                                        })), n = [], r.length) {
                                            var o = Math.floor(r.length / 2);
                                            r.sort(function(e, t) {
                                                return e.bandwidth - t.bandwidth;
                                            }), n.push(r[o]);
                                        }
                                        for(o = (r = l(e)).next(); !o.done; o = r.next())(o = o.value).type != Ze && "image" != o.type || n.push(o);
                                        return n;
                                    }(e, a1.preferredAudioLanguage));
                                });
                            }, a1;
                        }
                        function Iu(e, t, n) {
                            var r = {
                                ".drm.keySystemsMapping": "",
                                ".drm.servers": "",
                                ".drm.clearKeys": "",
                                ".drm.advanced": {
                                    distinctiveIdentifierRequired: !1,
                                    persistentStateRequired: !1,
                                    videoRobustness: "",
                                    audioRobustness: "",
                                    sessionType: "",
                                    serverCertificate: new Uint8Array(0),
                                    serverCertificateUri: "",
                                    individualizationServer: ""
                                }
                            };
                            return bu(e, t, n || wu(), r, "");
                        }
                        function Ru() {
                            this.g = null, this.h = [];
                        }
                        function Cu(e, t) {
                            if (null == e.g) e.g = {
                                timestamp: Date.now() / 1e3,
                                state: t,
                                duration: 0
                            };
                            else {
                                var n = Date.now() / 1e3;
                                e.g.duration = n - e.g.timestamp, e.g.state != t && (e.h.push(e.g), e.g = {
                                    timestamp: n,
                                    state: t,
                                    duration: 0
                                });
                            }
                        }
                        function Du(e, t) {
                            var n = 0;
                            e.g && e.g.state == t && (n += e.g.duration);
                            for(var r = l(e.h), i = r.next(); !i.done; i = r.next())n += (i = i.value).state == t ? i.duration : 0;
                            return n;
                        }
                        function ku() {
                            this.i = this.h = null, this.g = [];
                        }
                        function Nu(e, t, n) {
                            e.i != t && (e.i = t, e.g.push({
                                timestamp: Date.now() / 1e3,
                                id: t.id,
                                type: "text",
                                fromAdaptation: n,
                                bandwidth: null
                            }));
                        }
                        function Lu() {
                            this.u = this.B = this.G = this.D = this.s = this.j = this.F = this.m = this.i = this.N = this.P = this.H = this.K = this.M = this.l = this.o = NaN, this.g = new Ru, this.h = new ku;
                        }
                        function xu(t, n) {
                            vr.call(this);
                            var r = this;
                            this.l = Dl, this.Oc = this.g = null, this.ha = !1, this.Wc = new xr, this.Mb = new xr, this.s = new xr, this.Wb = this.i = this.Xc = this.K = this.j = this.ta = this.M = this.bf = this.W = this.Yc = this.N = this.Uc = this.H = this.wb = this.B = this.G = this.m = this.D = null, this.cc = !1, this.Nd = this.u = null, this.Xd = 1e9, this.h = Qu(this), this.dc = {
                                width: 1 / 0,
                                height: 1 / 0
                            }, this.o = null, this.Ka = new tr(this.h.preferredAudioLanguage, this.h.preferredVariantRole, this.h.preferredAudioChannelCount), this.ub = this.h.preferredTextLanguage, this.$b = this.h.preferredTextRole, this.Zb = this.h.preferForcedSubs, this.Xb = [], this.ec = null, n && n(this), this.D = function(e) {
                                return new Ar(function(t, n) {
                                    e.u && e.u.segmentDownloaded(t, n);
                                }, function(t, n, r) {
                                    t = (new Map).set("headers", t).set("request", n).set("requestType", r), e.dispatchEvent(Ou("downloadheadersreceived", t));
                                }, function(t, n, r, i) {
                                    t = (new Map).set("request", t).set("error", n).set("httpResponseCode", r).set("aborted", i), e.dispatchEvent(Ou("downloadfailed", t));
                                });
                            }(this), this.D.ie(this.h.streaming.forceHTTPS), this.F = null, Ol && (this.F = Ol()), this.Wc.C(e, "online", function() {
                                r.be();
                            }), this.P = {
                                name: "detach"
                            }, this.X = {
                                name: "attach"
                            }, this.ea = {
                                name: "unload"
                            }, this.Yd = {
                                name: "manifest-parser"
                            }, this.Wd = {
                                name: "manifest"
                            }, this.vb = {
                                name: "media-source"
                            }, this.Qd = {
                                name: "drm-engine"
                            }, this.ca = {
                                name: "load"
                            }, this.ce = {
                                name: "src-equals-drm-engine"
                            }, this.xb = {
                                name: "src-equals"
                            };
                            var i = new Map;
                            i.set(this.X, function(e, t) {
                                return fr(function(e, t, n) {
                                    return null == t.J && (t.J = n.J, e.Mb.C(t.J, "error", function() {
                                        var t = ml(e);
                                        t && gl(e, t);
                                    })), e.g = t.J, Promise.resolve();
                                }(r, e, t));
                            }), i.set(this.P, function(e) {
                                return e.J && (r.Mb.nb(), e.J = null), r.F && r.F.release(), r.g = null, fr(e = Promise.resolve());
                            }), i.set(this.ea, function(e) {
                                return fr(Pu(r, e));
                            }), i.set(this.vb, function(e) {
                                return e = function(e, t) {
                                    var n, r, i, a1, o;
                                    return L(function(s1) {
                                        if (1 == s1.g) return n = e.h.textDisplayFactory, r = n(), e.Td = n, i = function(e, t, n, r) {
                                            return new ko(e, t, n, r);
                                        }(t.J, r, function(t, n, r) {
                                            Fu(e, t, n, r);
                                        }, e.M), i.configure(e.h.mediaSource), a1 = e.h.manifest, o = a1.segmentRelativeVttTiming, i.H = o, T(s1, i.K, 2);
                                        e.G = i, b(s1);
                                    });
                                }(r, e), fr(e);
                            }), i.set(this.Yd, function(e, t) {
                                var n = function(e, t, n) {
                                    var r, i, a1, o;
                                    return L(function(s1) {
                                        if (1 == s1.g) return t.mimeType = n.mimeType, t.uri = n.uri, r = t.uri, i = e.D, e.Wb = r, a1 = e, T(s1, Ki(r, i, e.h.manifest.retryParameters, t.mimeType), 2);
                                        a1.Xc = s1.h, e.K = e.Xc(), o = yr(e.h.manifest), n.J && "AUDIO" === n.J.nodeName && (o.disableVideo = !0), e.K.configure(o), b(s1);
                                    });
                                }(r, e, t);
                                return fr(n);
                            }), i.set(this.Wd, function(e) {
                                return function(e, t) {
                                    var n = t.uri, r = e.D;
                                    e.Yc = new ws(function() {
                                        return e.tc();
                                    }), e.Yc.addEventListener("regionadd", function(t) {
                                        t = t.region, pl(e, "timelineregionadded", t), e.F && e.F.onDashTimedMetadata(t);
                                    }), e.ta = null, e.h.streaming.observeQualityChanges && (e.ta = new Ss(function() {
                                        return e.Ma();
                                    }), e.ta.addEventListener("qualitychange", function(t) {
                                        var n = t.quality;
                                        t = t.position, n = (new Map).set("mediaQuality", {
                                            bandwidth: n.bandwidth,
                                            audioSamplingRate: n.audioSamplingRate,
                                            codecs: n.codecs,
                                            contentType: n.contentType,
                                            frameRate: n.frameRate,
                                            height: n.height,
                                            mimeType: n.mimeType,
                                            channelsCount: n.channelsCount,
                                            pixelAspectRatio: n.pixelAspectRatio,
                                            width: n.width
                                        }).set("position", t), e.dispatchEvent(Ou("mediaqualitychanged", n));
                                    }));
                                    var i = {
                                        networkingEngine: r,
                                        modifyManifestRequest: function(t, n) {
                                            var r = e.W;
                                            try {
                                                r.g.enabled && (r.o = n.format, lu(r, t, {
                                                    ot: "m",
                                                    su: !r.i
                                                }));
                                            } catch (e) {
                                                W("CMCD_MANIFEST_ERROR", "Could not generate manifest CMCD data.", e);
                                            }
                                        },
                                        modifySegmentRequest: function(t, n) {
                                            su(e.W, t, n);
                                        },
                                        filter: function(t) {
                                            return Ju(e, t);
                                        },
                                        makeTextStreamsForClosedCaptions: function(t) {
                                            return function(e, t) {
                                                for(var n = new Set, r = l(t.textStreams), i = r.next(); !i.done; i = r.next())"application/cea-608" != (i = i.value).mimeType && "application/cea-708" != i.mimeType || n.add(i.originalId);
                                                for(i = (r = l(t.variants)).next(); !i.done; i = r.next())if ((i = i.value.video) && i.closedCaptions) {
                                                    for(var a1 = l(i.closedCaptions.keys()), o = a1.next(); !o.done; o = a1.next())if (o = o.value, !n.has(o)) {
                                                        var s1 = o.startsWith("CC") ? "application/cea-608" : "application/cea-708", u = new Es;
                                                        s1 = {
                                                            id: e.Xd++,
                                                            originalId: o,
                                                            createSegmentIndex: function() {
                                                                return Promise.resolve();
                                                            },
                                                            segmentIndex: u,
                                                            mimeType: s1,
                                                            codecs: "",
                                                            kind: "caption",
                                                            encrypted: !1,
                                                            drmInfos: [],
                                                            keyIds: new Set,
                                                            language: i.closedCaptions.get(o),
                                                            label: null,
                                                            type: Ze,
                                                            primary: !1,
                                                            trickModeVideo: null,
                                                            emsgSchemeIdUris: null,
                                                            roles: i.roles,
                                                            forced: !1,
                                                            channelsCount: null,
                                                            audioSamplingRate: null,
                                                            spatialAudio: !1,
                                                            closedCaptions: null
                                                        }, t.textStreams.push(s1), n.add(o);
                                                    }
                                                }
                                            }(e, t);
                                        },
                                        onTimelineRegionAdded: function(t) {
                                            var n = e.Yc;
                                            e: {
                                                for(var r = l(n.g), i = r.next(); !i.done; i = r.next())if ((i = i.value).schemeIdUri == t.schemeIdUri && i.id == t.id && i.startTime == t.startTime && i.endTime == t.endTime) {
                                                    r = i;
                                                    break e;
                                                }
                                                r = null;
                                            }
                                            null == r && (n.g.add(t), t = new gr("regionadd", new Map([
                                                [
                                                    "region",
                                                    t
                                                ]
                                            ])), n.dispatchEvent(t));
                                        },
                                        onEvent: function(t) {
                                            return e.dispatchEvent(t);
                                        },
                                        onError: function(t) {
                                            return gl(e, t);
                                        },
                                        isLowLatencyMode: function() {
                                            return e.h.streaming.lowLatencyMode;
                                        },
                                        isAutoLowLatencyMode: function() {
                                            return e.h.streaming.autoLowLatencyMode;
                                        },
                                        enableLowLatencyMode: function() {
                                            e.configure("streaming.lowLatencyMode", !0);
                                        },
                                        updateDuration: function() {
                                            e.j && e.j.updateDuration();
                                        },
                                        newDrmInfo: function(t) {
                                            var n = e.m ? e.m.g : null;
                                            n && e.m.u && $u(e, n.keySystem, t);
                                        }
                                    }, a1 = Date.now() / 1e3;
                                    return new ur(function() {
                                        var t, r, o, s1;
                                        return L(function(u) {
                                            if (1 == u.g) return t = e, T(u, e.K.start(n, i), 2);
                                            if (t.i = u.h, r = Ou("manifestparsed"), e.dispatchEvent(r), 0 == e.i.variants.length) throw new De(2, 4, 4036);
                                            !function(e) {
                                                function t(e) {
                                                    return e.video && e.audio || e.video && e.video.codecs.includes(",");
                                                }
                                                e.variants.some(t) && (e.variants = e.variants.filter(t));
                                            }(e.i), o = Date.now() / 1e3, s1 = o - a1, e.o.F = s1, b(u);
                                        });
                                    }(), function() {
                                        return e.K.stop();
                                    });
                                }(r, e);
                            }), i.set(this.Qd, function(e) {
                                return e = function(e, t) {
                                    var n, r;
                                    return L(function(i) {
                                        return 1 == i.g ? (n = Date.now() / 1e3, r = !0, e.m = Bu(e, {
                                            lb: e.D,
                                            onError: function(t) {
                                                gl(e, t);
                                            },
                                            cd: function(t) {
                                                vl(e, t);
                                            },
                                            onExpirationUpdated: function(t, n) {
                                                yl(e, t, n);
                                            },
                                            onEvent: function(t) {
                                                e.dispatchEvent(t), "drmsessionupdate" == t.type && r && (r = !1, e.o.j = Date.now() / 1e3 - n, e.M && (t = e.M).g && t.h.classList.add("shaka-hidden"));
                                            }
                                        }), e.m.configure(e.h.drm), T(i, bi(e.m, e.i.variants, e.i.offlineSessionIds), 2)) : 3 != i.g ? T(i, e.m.Yb(t.J), 3) : T(i, Ju(e, e.i), 0);
                                    });
                                }(r, e), fr(e);
                            }), i.set(this.ca, function(e, t) {
                                return fr(function(e, t, n) {
                                    var r, i, a1, o, s1, u, c, d, f, h, g, p, m, v, y, E;
                                    return L(function(A) {
                                        switch(A.g){
                                            case 1:
                                                for(t.startTime = n.startTime, null != e.ec && (t.startTime = e.ec, e.ec = null), r = t.J, i = t.uri, e.Wb = i, e.H = new Ts({
                                                    Tc: function() {
                                                        return r.playbackRate;
                                                    },
                                                    Pc: function() {
                                                        return r.defaultPlaybackRate;
                                                    },
                                                    ke: function(e) {
                                                        r.playbackRate = e;
                                                    },
                                                    Le: function(e) {
                                                        r.currentTime += e;
                                                    }
                                                }), a1 = function() {
                                                    return nl(e);
                                                }, o = function() {
                                                    return tl(e);
                                                }, e.s.C(r, "playing", a1), e.s.C(r, "pause", a1), e.s.C(r, "ended", a1), e.s.C(r, "ratechange", o), function(e, t) {
                                                    if (t.lcevc.enabled) {
                                                        var n = e.Pa();
                                                        n && n[0] && n[0].videoMimeType == Pl.ts && (navigator.userAgent.match(/Edge?\//) || navigator.userAgent.match(/Edge\//)) && (t.streaming.forceTransmux || Y("LCEVC Warning: For MPEG-2 TS decoding the config.streaming.forceTransmux must be enabled.")), Mu(e), null == e.M && (e.M = new wo(e.g, e.bf, t.lcevc), e.G && (e.G.D = e.M));
                                                    } else Mu(e);
                                                }(e, e.h), s1 = e.h.abrFactory, e.u && e.Nd == s1 || (e.Nd = s1, e.u = s1(), "function" != typeof e.u.setMediaElement && (Yn("AbrManager", "Please use an AbrManager with setMediaElement function."), e.u.setMediaElement = function() {}), e.u.configure(e.h.abr)), e.Ka = new tr(e.h.preferredAudioLanguage, e.h.preferredVariantRole, e.h.preferredAudioChannelCount), e.ub = e.h.preferredTextLanguage, e.$b = e.h.preferredTextRole, e.Zb = e.h.preferForcedSubs, El(e.i.presentationTimeline, e.h.playRangeStart, e.h.playRangeEnd), e.u.init(function(t, n, r) {
                                                    e.j && t != e.j.l && ol(e, t, !0, void 0 !== n && n, void 0 === r ? 0 : r);
                                                }), e.u.setMediaElement(r), cn(e.i, e.h.preferredVideoCodecs, e.h.preferredAudioCodecs, e.h.preferredAudioChannelCount, e.h.preferredDecodingAttributes), e.j = function(e) {
                                                    return new Ls(e.i, {
                                                        Sc: function() {
                                                            return e.B ? e.B.Hc() : 0;
                                                        },
                                                        getBandwidthEstimate: function() {
                                                            return e.u.getBandwidthEstimate();
                                                        },
                                                        modifySegmentRequest: function(t, n) {
                                                            su(e.W, t, n);
                                                        },
                                                        R: e.G,
                                                        lb: e.D,
                                                        onError: function(t) {
                                                            return gl(e, t);
                                                        },
                                                        onEvent: function(t) {
                                                            return e.dispatchEvent(t);
                                                        },
                                                        fg: function() {
                                                            e.K && e.K.update && e.K.update();
                                                        },
                                                        Vd: function(t, n, r) {
                                                            e.B && e.B.Me(), Hu(e), t = (new Map).set("start", t).set("end", n).set("contentType", r), e.dispatchEvent(Ou("segmentappended", t));
                                                        },
                                                        eg: function(t, n) {
                                                            var r = n.Od;
                                                            r && e.ta && function(e, t, n) {
                                                                var r = function(e, t) {
                                                                    var n = e.g.get(t);
                                                                    return n || (n = {
                                                                        qc: [],
                                                                        ye: null,
                                                                        contentType: t
                                                                    }, e.g.set(t, n)), n;
                                                                }(e, t.contentType);
                                                                !function(e, t) {
                                                                    var n = e.h()[t.contentType];
                                                                    if (n && 0 < n.length) {
                                                                        var r = n[0].start, i = n[n.length - 1].end, a1 = t.qc;
                                                                        t.qc = a1.filter(function(e, t) {
                                                                            return !(e.position <= r && t + 1 < a1.length && a1[t + 1].position <= r || e.position >= i);
                                                                        });
                                                                    } else t.qc = [];
                                                                }(e, r), e = {
                                                                    Od: t,
                                                                    position: n
                                                                }, 0 <= (t = (r = r.qc).findIndex(function(e) {
                                                                    return e.position >= n;
                                                                })) ? r.splice(t, r[t].position == n ? 1 : 0, e) : r.push(e);
                                                            }(e.ta, r, t);
                                                        },
                                                        ve: function(t, n) {
                                                            var r = e.m;
                                                            if (r.h.parseInbandPsshEnabled && [
                                                                "audio",
                                                                "video"
                                                            ].includes(t)) {
                                                                for(var i = new Zr(Ie(n)), a1 = 0, o = l(i.data), s1 = o.next(); !s1.done; s1 = o.next())a1 += s1.value.length;
                                                                if (0 == a1) r = Promise.resolve();
                                                                else {
                                                                    for(a1 = new Uint8Array(a1), o = 0, s1 = (i = l(i.data)).next(); !s1.done; s1 = i.next())s1 = s1.value, a1.set(s1, o), o += s1.length;
                                                                    Ii(r, "cenc", a1), r = r.o;
                                                                }
                                                            } else r = Promise.resolve();
                                                            return r;
                                                        },
                                                        gg: function(t, n, r) {
                                                            Fu(e, t, n, r);
                                                        }
                                                    });
                                                }(e), e.j.configure(e.h.streaming), e.l = kl, r.textTracks && e.s.C(r.textTracks, "addtrack", function(t) {
                                                    t.track && "chapters" === (t = t.track).kind && ju(e, t);
                                                }), e.dispatchEvent(Ou("streaming")), u = null, (c = e.Pa().find(function(e) {
                                                    return e.active;
                                                })) || (u = il(e)), d = [], h = l([
                                                    (f = c || u).video,
                                                    f.audio
                                                ]), g = h.next(); !g.done; g = h.next())(p = g.value) && !p.segmentIndex && d.push(p.createSegmentIndex());
                                                if (!(0 < d.length)) {
                                                    A.A(2);
                                                    break;
                                                }
                                                return T(A, Promise.all(d), 2);
                                            case 2:
                                                if (e.B = function(e, t) {
                                                    return new ds(e.g, e.i, e.h.streaming, t, function() {
                                                        e.wb && _s(e.wb, !0), e.j && e.j.uc(), e.N && Hu(e);
                                                    }, function(t) {
                                                        return e.dispatchEvent(t);
                                                    });
                                                }(e, t.startTime), e.wb = function(e) {
                                                    var t = new Is(e.Yc);
                                                    t.addEventListener("enter", function(t) {
                                                        pl(e, "timelineregionenter", t.region);
                                                    }), t.addEventListener("exit", function(t) {
                                                        pl(e, "timelineregionexit", t.region);
                                                    }), t.addEventListener("skip", function(t) {
                                                        var n = t.region;
                                                        t.seeking || (pl(e, "timelineregionenter", n), pl(e, "timelineregionexit", n));
                                                    });
                                                    var n = new As(e.g);
                                                    return n.g.add(t), e.ta && n.g.add(e.ta), n;
                                                }(e), m = Math.max(e.i.minBufferTime, e.h.streaming.rebufferingGoal), Gu(e, m), c) {
                                                    A.A(4);
                                                    break;
                                                }
                                                if (ol(e, u, !0, !1, 0), !e.h.streaming.startAtSegmentBoundary) {
                                                    A.A(5);
                                                    break;
                                                }
                                                return v = e.B.Hc(), T(A, function(e, t) {
                                                    var n, r, i, a1, o;
                                                    return L(function(s1) {
                                                        return 1 == s1.g ? (n = e.audio, r = e.video, i = function(e, t) {
                                                            var n, r, i;
                                                            return L(function(a1) {
                                                                return 1 == a1.g ? e ? T(a1, e.createSegmentIndex(), 2) : a1.return(null) : (r = (n = e.segmentIndex.Bb(t)) ? n.next().value : null) ? (i = r.startTime, a1.return(i)) : a1.return(null);
                                                            });
                                                        }, T(s1, i(n, t), 2)) : 3 != s1.g ? (a1 = s1.h, T(s1, i(r, t), 3)) : null != (o = s1.h) && null != a1 ? s1.return(Math.max(o, a1)) : null != o ? s1.return(o) : null != a1 ? s1.return(a1) : s1.return(t);
                                                    });
                                                }(u, v), 6);
                                            case 6:
                                                y = A.h, e.B.Bd(y);
                                            case 5:
                                                ul(e, null, An(u));
                                            case 4:
                                                return e.B.zd(), e.Eb().find(function(e) {
                                                    return e.active;
                                                }) || ((E = Nn(e.i.textStreams, e.ub, e.$b, e.Zb)[0] || null) && Nu(e.o.h, E, !0), u && (E ? (u.audio && function(e, t, n) {
                                                    if (0 == e.h.autoShowText) return !1;
                                                    if (1 == e.h.autoShowText) return !0;
                                                    var r = tn(e.h.preferredTextLanguage);
                                                    return n = tn(n.language), 2 == e.h.autoShowText ? Zt(n, r) : 3 == e.h.autoShowText ? (e = tn(t.language), Zt(n, r) && !Zt(e, n)) : (Y("Invalid autoShowText setting!"), !1);
                                                }(e, u.audio, E) && (e.ha = !0), e.ha && e.G.m.setTextVisibility(!0), fl(e)) : e.ha = !1), E && (e.h.streaming.alwaysStreamText || e.Hd()) && Os(e.j, E)), T(A, e.j.start(), 7);
                                            case 7:
                                                e.h.abr.enabled && (e.u.enable(), hl(e)), Tn(e.j ? e.j.l : null, e.i), bl(e.i), ll(e), rl(e), e.i.variants.some(function(e) {
                                                    return e.primary;
                                                }), e.cc = !0, e.s.na(r, "loadedmetadata", function() {
                                                    e.o.m = Date.now() / 1e3 - n.me;
                                                }), b(A);
                                        }
                                    });
                                }(r, e, t));
                            }), i.set(this.ce, function(e, t) {
                                var n = function(e, t, n) {
                                    var r, i, a1, o, s1, u, l;
                                    return L(function(c) {
                                        return 1 == c.g ? (r = $e, i = Date.now() / 1e3, a1 = !0, e.m = Bu(e, {
                                            lb: e.D,
                                            onError: function(t) {
                                                gl(e, t);
                                            },
                                            cd: function(t) {
                                                vl(e, t);
                                            },
                                            onExpirationUpdated: function(t, n) {
                                                yl(e, t, n);
                                            },
                                            onEvent: function(t) {
                                                e.dispatchEvent(t), "drmsessionupdate" == t.type && a1 && (a1 = !1, e.o.j = Date.now() / 1e3 - i);
                                            }
                                        }), e.m.configure(e.h.drm), o = n.uri || "", s1 = Yi(o), "application/x-mpegurl" == (u = Pl[s1]) && ct() && (u = "application/vnd.apple.mpegurl"), u || (u = "video/mp4"), l = {
                                            id: 0,
                                            language: "und",
                                            disabledUntilTime: 0,
                                            primary: !1,
                                            audio: null,
                                            video: {
                                                id: 0,
                                                originalId: null,
                                                createSegmentIndex: function() {
                                                    return Promise.resolve();
                                                },
                                                segmentIndex: null,
                                                mimeType: n.mimeType ? n.mimeType.split(";")[0] : u,
                                                codecs: n.mimeType ? Vt(n.mimeType) : "",
                                                encrypted: !0,
                                                drmInfos: [],
                                                keyIds: new Set,
                                                language: "und",
                                                label: null,
                                                type: r.ua,
                                                primary: !1,
                                                trickModeVideo: null,
                                                emsgSchemeIdUris: null,
                                                roles: [],
                                                forced: !1,
                                                channelsCount: null,
                                                audioSamplingRate: null,
                                                spatialAudio: !1,
                                                closedCaptions: null
                                            },
                                            bandwidth: 100,
                                            allowedByApplication: !0,
                                            allowedByKeySystem: !0,
                                            decodingInfos: []
                                        }, e.m.W = !0, T(c, bi(e.m, [
                                            l
                                        ], []), 2)) : T(c, e.m.Yb(t.J), 0);
                                    });
                                }(r, e, t);
                                return fr(n);
                            }), i.set(this.xb, function(e, t) {
                                return function(e, t, n) {
                                    function r() {
                                        return nl(e);
                                    }
                                    t.uri = n.uri, t.startTime = n.startTime, e.Wb = t.uri;
                                    var i = t.J;
                                    e.B = new cs(i);
                                    var a1 = !1;
                                    e.Xb.push(function() {
                                        a1 = !0;
                                    }), null != t.startTime && e.B.Bd(t.startTime), e.H = new Ts({
                                        Tc: function() {
                                            return i.playbackRate;
                                        },
                                        Pc: function() {
                                            return i.defaultPlaybackRate;
                                        },
                                        ke: function(e) {
                                            i.playbackRate = e;
                                        },
                                        Le: function(e) {
                                            i.currentTime += e;
                                        }
                                    }), Gu(e, e.h.streaming.rebufferingGoal), e.s.C(i, "playing", r), e.s.C(i, "pause", r), e.s.C(i, "ended", r), e.s.C(i, "ratechange", function() {
                                        return tl(e);
                                    }), "none" != i.preload && e.s.na(i, "loadedmetadata", function() {
                                        e.o.m = Date.now() / 1e3 - n.me;
                                    }), i.audioTracks && (e.s.C(i.audioTracks, "addtrack", function() {
                                        return ll(e);
                                    }), e.s.C(i.audioTracks, "removetrack", function() {
                                        return ll(e);
                                    }), e.s.C(i.audioTracks, "change", function() {
                                        return ll(e);
                                    })), i.textTracks && (e.s.C(i.textTracks, "addtrack", function(t) {
                                        if (t.track) switch(t = t.track, t.kind){
                                            case "metadata":
                                                !function(e, t) {
                                                    if ("metadata" == t.kind) {
                                                        t.mode = "hidden", e.s.C(t, "cuechange", function() {
                                                            if (t.activeCues) for(var n = l(t.activeCues), r = n.next(); !r.done; r = n.next())r = r.value, Uu(e, r.startTime, r.endTime, r.type, r.value), e.F && e.F.onCueMetadataChange(r.value);
                                                        });
                                                        var n = new it(function() {
                                                            for(var t = function(e) {
                                                                return Array.from(e.g.textTracks).filter(function(e) {
                                                                    return "metadata" == e.kind;
                                                                });
                                                            }(e), n = (t = l(t)).next(); !n.done; n = t.next())n.value.mode = "hidden";
                                                        }).Lb().O(.5);
                                                        e.Xb.push(function() {
                                                            n.stop();
                                                        });
                                                    }
                                                }(e, t);
                                                break;
                                            case "chapters":
                                                ju(e, t);
                                                break;
                                            default:
                                                ll(e);
                                        }
                                    }), e.s.C(i.textTracks, "removetrack", function() {
                                        return ll(e);
                                    }), e.s.C(i.textTracks, "change", function() {
                                        return ll(e);
                                    }));
                                    var o = Yi(t.uri);
                                    i.src = function(e, t, n) {
                                        try {
                                            if (!e.g.enabled) return t;
                                            var r = uu(e);
                                            e: {
                                                switch(n){
                                                    case "video/webm":
                                                    case "video/mp4":
                                                        var i = gu;
                                                        break e;
                                                    case "application/x-mpegurl":
                                                        i = "m";
                                                        break e;
                                                }
                                                i = void 0;
                                            }
                                            return r.ot = i, r.su = !0, du(t, cu(r));
                                        } catch (e) {
                                            return W("CMCD_SRC_ERROR", "Could not generate src CMCD data.", e), t;
                                        }
                                    }(e.W, t.uri, Pl[o]), (ut() || ht("Web0S")) && i.load(), e.l = Nl, e.dispatchEvent(Ou("streaming"));
                                    var s1 = new tt;
                                    return ts(i, HTMLMediaElement.HAVE_METADATA, e.s, function() {
                                        e.B.zd(), s1.resolve();
                                    }), ts(i, HTMLMediaElement.HAVE_CURRENT_DATA, e.s, function() {
                                        return L(function(t) {
                                            return 1 == t.g ? (function(e) {
                                                var t = e.h.preferredAudioLanguage;
                                                if ("" != t) {
                                                    e.fe(t);
                                                    var n = e.h.preferredVariantRole;
                                                    "" != n && e.fe(t, n);
                                                }
                                            }(e), Ku(e).find(function(e) {
                                                return "disabled" != e.mode;
                                            }) ? t.A(2) : T(t, new Promise(function(t) {
                                                e.s.na(i.textTracks, "change", t), new it(t).O(1);
                                            }), 2)) : a1 ? t.return() : (function(e) {
                                                var t = e.h.preferredTextLanguage, n = e.h.preferForcedSubs;
                                                if ("" != t) {
                                                    e.ge(t, "", n);
                                                    var r = e.h.preferredTextRole;
                                                    "" != r && e.ge(t, r, n);
                                                }
                                            }(e), void b(t));
                                        });
                                    }), i.error ? s1.reject(ml(e)) : "none" == i.preload && (Y('With <video preload="none">, the browser will not load anything until play() is called. We are unable to measure load latency in a meaningful way, and we cannot provide track info yet. Please do not use preload="none" with Shaka Player.'), s1.resolve()), e.s.na(i, "error", function() {
                                        s1.reject(ml(e));
                                    }), new ur(s1, function() {
                                        return s1.reject(new De(2, 7, 7001)), Promise.resolve();
                                    }).Y(function() {
                                        e.cc = !0;
                                    });
                                }(r, e, t);
                            }), this.Ea = new Ws(this.P, {
                                Lf: function(e, t, n, i) {
                                    var a1 = null;
                                    return e == r.P && (a1 = n == r.P ? r.P : r.X), e == r.X && (a1 = n == r.P || t.J != i.J ? r.P : n == r.X ? r.X : n == r.vb || n == r.ca ? r.vb : n == r.xb ? r.ce : null), e == r.vb && (a1 = n == r.ca && t.J == i.J ? r.Yd : r.ea), e == r.Yd && (a1 = Il(r.ca, r.Wd, r.ea, n, t, i)), e == r.Wd && (a1 = Il(r.ca, r.Qd, r.ea, n, t, i)), e == r.Qd && (a1 = Il(r.ca, r.ca, r.ea, n, t, i)), e == r.ce && (a1 = n == r.xb && t.J == i.J ? r.xb : r.ea), e != r.ca && e != r.xb || (a1 = r.ea), e == r.ea && (a1 = i.J && t.J == i.J ? r.X : r.P), a1;
                                },
                                xf: function(e, t, n) {
                                    return r.dispatchEvent(Ou("onstatechange", (new Map).set("state", e.name))), i.get(e)(t, n);
                                },
                                handleError: function(e) {
                                    return L(function(t) {
                                        return 1 == t.g ? T(t, Pu(r, e), 2) : t.return(e.J ? r.X : r.P);
                                    });
                                },
                                dg: function(e) {
                                    r.dispatchEvent(Ou("onstateidle", (new Map).set("state", e.name)));
                                }
                            }), this.$e = new it(function() {
                                gn(r.i.variants, r.h.restrictions, r.dc) && il(r);
                            }), t && this.Yb(t, !0);
                        }
                        function Mu(e) {
                            null != e.M && (e.M.release(), e.M = null);
                        }
                        function Ou(e, t) {
                            return new gr(e, t);
                        }
                        function Pu(e, t) {
                            var n, r, i, a1, o, s1, u, c, d;
                            return L(function(f) {
                                switch(f.g){
                                    case 1:
                                        return e.l != Cl && (e.l = Dl), n = e.Xb.map(function(e) {
                                            return e();
                                        }), e.Xb = [], T(f, Promise.all(n), 2);
                                    case 2:
                                        if (e.dispatchEvent(Ou("unloading")), t.mimeType = null, t.startTime = null, t.uri = null, t.J && e.s.nb(), e.$e.stop(), e.wb && (e.wb.release(), e.wb = null), e.Uc && (e.Uc.stop(), e.Uc = null), !e.K) {
                                            f.A(3);
                                            break;
                                        }
                                        return T(f, e.K.stop(), 4);
                                    case 4:
                                        e.K = null, e.Xc = null;
                                    case 3:
                                        if (!e.u) {
                                            f.A(5);
                                            break;
                                        }
                                        return T(f, e.u.stop(), 5);
                                    case 5:
                                        if (!e.j) {
                                            f.A(7);
                                            break;
                                        }
                                        return T(f, e.j.destroy(), 8);
                                    case 8:
                                        e.j = null;
                                    case 7:
                                        if (e.H && (e.H.release(), e.H = null), e.B && (e.B.release(), e.B = null), !e.G) {
                                            f.A(9);
                                            break;
                                        }
                                        return T(f, e.G.destroy(), 10);
                                    case 10:
                                        e.G = null;
                                    case 9:
                                        if (e.F && e.F.onAssetUnload(), !t.J || !t.J.src) {
                                            f.A(11);
                                            break;
                                        }
                                        return T(f, new Promise(function(e) {
                                            return new it(e).O(.1);
                                        }), 12);
                                    case 12:
                                        for(t.J.removeAttribute("src"), t.J.load(); t.J.lastChild;)t.J.removeChild(t.J.firstChild);
                                    case 11:
                                        if (!e.m) {
                                            f.A(13);
                                            break;
                                        }
                                        return T(f, e.m.destroy(), 14);
                                    case 14:
                                        e.m = null;
                                    case 13:
                                        if (e.Wb = null, e.N = null, e.i) {
                                            for(r = l(e.i.variants), i = r.next(); !i.done; i = r.next())for(a1 = i.value, o = l([
                                                a1.audio,
                                                a1.video
                                            ]), s1 = o.next(); !s1.done; s1 = o.next())(u = s1.value) && u.segmentIndex && u.segmentIndex.release();
                                            for(c = l(e.i.textStreams), s1 = c.next(); !s1.done; s1 = c.next())(d = s1.value).segmentIndex && d.segmentIndex.release();
                                        }
                                        e.i = null, e.o = new Lu, e.Td = null, el(e), b(f);
                                }
                            });
                        }
                        function Fu(e, t, n, r) {
                            for(var i = (t = l(t)).next(); !i.done; i = t.next())if ((i = i.value).data && i.cueTime && i.frames) {
                                var a1 = i.cueTime + n, o = r;
                                o && a1 > o && (o = a1);
                                for(var s1 = l(i.frames), u = s1.next(); !u.done; u = s1.next())Uu(e, a1, o, "org.id3", u.value);
                                e.F && e.F.onHlsTimedMetadata(i, a1);
                            }
                        }
                        function Uu(e, t, n, r, i) {
                            t = (new Map).set("startTime", t).set("endTime", n).set("metadataType", r).set("payload", i), e.dispatchEvent(Ou("metadata", t));
                        }
                        function ju(e, t) {
                            if (t && "chapters" == t.kind) {
                                t.mode = "hidden";
                                var n = new it(function() {
                                    t.mode = "hidden";
                                }).Lb().O(.5);
                                e.Xb.push(function() {
                                    n.stop();
                                });
                            }
                        }
                        function Bu(e, t) {
                            return new Ti(t, e.h.drm.updateExpirationTime);
                        }
                        function Gu(e, t) {
                            e.N = new nr, e.N.g = ir, rr(e.N, t, Math.min(.5, t / 2)), el(e), e.Uc = new it(function() {
                                Hu(e);
                            }).Ba(.25);
                        }
                        function Hu(e) {
                            switch(e.l){
                                case Nl:
                                    if (e.g.ended) var t = !0;
                                    else {
                                        var n = go(e.g.buffered);
                                        t = null != n && n >= e.g.duration - 1;
                                    }
                                    break;
                                case kl:
                                    e: if (e.g.ended || Lo(e.G)) t = !0;
                                    else {
                                        if (e.i.presentationTimeline.U()) {
                                            n = e.i.presentationTimeline.hb();
                                            var r = go(e.g.buffered);
                                            if (null != r && r >= n) {
                                                t = !0;
                                                break e;
                                            }
                                        }
                                        t = !1;
                                    }
                                    break;
                                default:
                                    t = !1;
                            }
                            r = mo(e.g.buffered, e.g.currentTime);
                            var i = t, a1 = (n = e.N).h.get(n.g);
                            t = n.g, r = i || r >= a1 ? ar : ir, n.g = r, t != r && el(e);
                        }
                        function Vu(e) {
                            if (e.K) {
                                var t = yr(e.h.manifest);
                                e.g && "AUDIO" === e.g.nodeName && (t.disableVideo = !0), e.K.configure(t);
                            }
                            if (e.m && e.m.configure(e.h.drm), e.j) {
                                e.j.configure(e.h.streaming);
                                try {
                                    Zu(e, e.i);
                                } catch (t) {
                                    gl(e, t);
                                }
                                e.u && rl(e), !(t = e.j.l) || t.allowedByApplication && t.allowedByKeySystem || al(e);
                            }
                            if (e.D && e.D.ie(e.h.streaming.forceHTTPS), e.G && (e.G.configure(e.h.mediaSource), e.G.H = e.h.manifest.segmentRelativeVttTiming, t = e.h.textDisplayFactory, e.Td != t)) {
                                var n = t(), r = e.G, i = r.m;
                                r.m = n, i && (n.setTextVisibility(i.isTextVisible()), i.destroy()), r.g && (r.g.i = n), e.Td = t, e.j && (n = (t = e.j).j.get(Ze)) && Ps(t, n.stream, !0, 0, !0);
                            }
                            e.u && (e.u.configure(e.h.abr), e.h.abr.enabled ? e.u.enable() : e.u.disable(), hl(e)), e.N && (t = e.h.streaming.rebufferingGoal, e.i && (t = Math.max(t, e.i.minBufferTime)), rr(e.N, t, Math.min(.5, t / 2))), e.i && El(e.i.presentationTimeline, e.h.playRangeStart, e.h.playRangeEnd);
                        }
                        function Ku(e) {
                            return Array.from(e.g.textTracks).filter(function(e) {
                                return "metadata" != e.kind && "chapters" != e.kind && "Shaka Player TextTrack" != e.label;
                            });
                        }
                        function qu(e) {
                            return Array.from(e.g.textTracks).filter(function(e) {
                                return "chapters" == e.kind;
                            });
                        }
                        function Yu(e, t) {
                            var n, r;
                            return L(function(i) {
                                switch(i.g){
                                    case 1:
                                        return n = Yi(t), (r = Fl[n]) ? i.return(r) : (A(i, 2), T(i, qi(t, e.D, e.h.streaming.retryParameters), 4));
                                    case 4:
                                        r = i.h, S(i, 3);
                                        break;
                                    case 2:
                                        w(i);
                                    case 3:
                                        if (r) return i.return(r);
                                        throw new De(1, 2, 2011, n);
                                }
                            });
                        }
                        function Wu(e, t, n, r, i, a1, o) {
                            var s1, u, l, c;
                            return L(function(d) {
                                if (1 == d.g) return "text/vtt" != i || o.length ? T(d, zu(e, t, e.D, e.h.streaming.retryParameters), 3) : d.A(2);
                                2 != d.g && (s1 = d.h, u = Xu(e, s1, i, o), l = new Blob([
                                    u
                                ], {
                                    type: "text/vtt"
                                }), t = Yo(l), i = "text/vtt"), c = document.createElement("track");
                                var f = e.W, h = t;
                                try {
                                    if (f.g.enabled) {
                                        var g = uu(f);
                                        g.ot = mu, g.su = !0;
                                        var p = du(h, cu(g));
                                    } else p = h;
                                } catch (e) {
                                    W("CMCD_TEXT_TRACK_ERROR", "Could not generate text track CMCD data.", e), p = h;
                                }
                                return c.src = p, c.label = a1, c.kind = r, c.srclang = n, e.g.getAttribute("crossorigin") || e.g.setAttribute("crossorigin", "anonymous"), e.g.appendChild(c), d.return(c);
                            });
                        }
                        function zu(e, t, n, r) {
                            var i, a1, o;
                            return L(function(s1) {
                                if (1 == s1.g) {
                                    i = Cr, (a1 = Sr([
                                        t
                                    ], r)).method = "GET";
                                    var u = e.W;
                                    try {
                                        u.g.enabled && lu(u, a1, {
                                            ot: mu,
                                            su: !0
                                        });
                                    } catch (e) {
                                        W("CMCD_TEXT_ERROR", "Could not generate text CMCD data.", e);
                                    }
                                    return T(s1, n.request(i, a1).promise, 2);
                                }
                                return o = s1.h, s1.return(o.data);
                            });
                        }
                        function Xu(e, t, n, r) {
                            var i = Qt[n];
                            if (i) return n = i(), e = {
                                periodStart: 0,
                                segmentStart: 0,
                                segmentEnd: e.g.duration,
                                vttOffset: 0
                            }, t = Ie(t), function(e, t) {
                                function n(e) {
                                    for(var n = e, r = l(t), i = r.next(); !i.done; i = r.next())(i = i.value).end && i.start < e && (n += i.end - i.start);
                                    return (10 > (e = Math.floor(n / 3600)) ? "0" : "") + e + ":" + (10 > (r = Math.floor(n / 60 % 60)) ? "0" : "") + r + ":" + (10 > (i = Math.floor(n % 60)) ? "0" : "") + i + "." + (100 > (n = Math.floor(1e3 * n % 1e3)) ? 10 > n ? "00" : "0" : "") + n;
                                }
                                function r(e) {
                                    var t = [], n = 700 <= e.fontWeight, i = "italic" == e.fontStyle, a1 = e.textDecoration.includes("underline");
                                    return n && t.push("b"), i && t.push("i"), a1 && t.push("u"), n = t.reduce(function(e, t) {
                                        return e + "<" + t + ">";
                                    }, ""), t = t.reduceRight(function(e, t) {
                                        return e + "</" + t + ">";
                                    }, ""), e.lineBreak ? "\n" : e.nestedCues.length ? e.nestedCues.map(r).join("") : n + e.payload + t;
                                }
                                for(var i = e.map(function(e) {
                                    if (e.nestedCues.length) {
                                        var t = e.clone();
                                        return t.nestedCues = [], t.payload = r(e), t;
                                    }
                                    return e;
                                }), a1 = "WEBVTT\n\n", o = (i = l(i)).next(); !o.done; o = i.next())a1 += n((o = o.value).startTime) + " --\x3e " + n(o.endTime) + function(e) {
                                    var t = [];
                                    switch(e.textAlign){
                                        case "left":
                                            t.push("align:left");
                                            break;
                                        case "right":
                                            t.push("align:right");
                                            break;
                                        case ae:
                                            t.push("align:middle");
                                            break;
                                        case "start":
                                            t.push("align:start");
                                            break;
                                        case "end":
                                            t.push("align:end");
                                    }
                                    switch(e.writingMode){
                                        case "vertical-lr":
                                            t.push("vertical:lr");
                                            break;
                                        case "vertical-rl":
                                            t.push("vertical:rl");
                                    }
                                    return t.length ? " " + t.join(" ") : "";
                                }(o) + "\n", a1 += o.payload + "\n\n";
                                return a1;
                            }(t = n.parseMedia(t, e), r);
                            throw new De(2, 2, 2014, n);
                        }
                        function Qu(e) {
                            var t = wu();
                            return t.streaming.failureCallback = function(t) {
                                if (e.U()) {
                                    var n = null;
                                    1001 == t.code || 1002 == t.code ? n = 1 : 1003 == t.code && (n = .1), null != n && (t.severity = 1, e.be(n));
                                }
                            }, t.textDisplayFactory = function() {
                                return e.Oc ? new tu(e.g, e.Oc) : new Qs(e.g);
                            }, t;
                        }
                        function Ju(e, t) {
                            return L(function(n) {
                                if (1 == n.g) return T(n, function(e, t) {
                                    return L(function(n) {
                                        if (1 == n.g) return T(n, function(e, t) {
                                            return L(function(n) {
                                                return 1 == n.g ? T(n, pn(t, 0 < t.offlineSessionIds.length), 2) : (Tn(e, t), function(e) {
                                                    e.textStreams = e.textStreams.filter(function(e) {
                                                        return Yt(Bt(e.mimeType, e.codecs));
                                                    });
                                                }(t), T(n, function(e) {
                                                    var t, n, r, i, a1, o, s1;
                                                    return L(function(u) {
                                                        switch(u.g){
                                                            case 1:
                                                                t = [], n = l(e.imageStreams), r = n.next();
                                                            case 2:
                                                                if (r.done) {
                                                                    u.A(4);
                                                                    break;
                                                                }
                                                                if (i = r.value, a1 = i.mimeType, jn.has(a1)) {
                                                                    u.A(5);
                                                                    break;
                                                                }
                                                                if (!(o = Bn.get(a1))) {
                                                                    jn.set(a1, !1), u.A(5);
                                                                    break;
                                                                }
                                                                return T(u, function(e) {
                                                                    return new Promise(function(t) {
                                                                        var n = new Image;
                                                                        n.src = e, "decode" in n ? n.decode().then(function() {
                                                                            t(!0);
                                                                        }).catch(function() {
                                                                            t(!1);
                                                                        }) : n.onload = n.onerror = function() {
                                                                            t(2 === n.height);
                                                                        };
                                                                    });
                                                                }(o), 7);
                                                            case 7:
                                                                s1 = u.h, jn.set(a1, s1);
                                                            case 5:
                                                                jn.get(a1) && t.push(i), r = n.next(), u.A(2);
                                                                break;
                                                            case 4:
                                                                e.imageStreams = t, b(u);
                                                        }
                                                    });
                                                }(t), 0));
                                            });
                                        }(e.j ? e.j.l : null, t), 2);
                                        bl(t), b(n);
                                    });
                                }(e, t), 2);
                                Zu(e, t), b(n);
                            });
                        }
                        function Zu(e, t) {
                            if (e.l != Cl) {
                                gn(t.variants, e.h.restrictions, e.dc) && e.j && ll(e);
                                var n = e.m ? e.m.g : null;
                                if (n && e.m.u) for(var r = l(t.variants), i = r.next(); !i.done; i = r.next())i = i.value, $u(e, n.keySystem, i.video), $u(e, n.keySystem, i.audio);
                                Tl(e, t);
                            }
                        }
                        function $u(e, t, n) {
                            if (n) {
                                for(var r = (n = l(n.drmInfos)).next(); !r.done; r = n.next())if ((r = r.value).keySystem == t) for(var i = (r = l(r.initData || [])).next(); !i.done; i = r.next())i = i.value, Ii(e.m, i.initDataType, i.initData);
                            }
                        }
                        function el(e) {
                            var t = e.Gd();
                            if (e.o && e.N && e.B) {
                                var n = e.H;
                                n.j = t, bs(n), e.W && (n = e.W, t || n.i || (n.i = !0), n.i && t && (n.l = !0), n.m = t), nl(e);
                            }
                            t = (new Map).set("buffering", t), e.dispatchEvent(Ou("buffering", t));
                        }
                        function tl(e) {
                            var t = e.g.playbackRate;
                            0 != t && (e.H && e.H.set(t), t = Ou("ratechange"), e.dispatchEvent(t));
                        }
                        function nl(e) {
                            if (e.o && e.N) {
                                var t = e.o.g;
                                e.N.g == ir ? Cu(t, "buffering") : e.g.paused ? Cu(t, "paused") : e.g.ended ? Cu(t, "ended") : Cu(t, "playing");
                            }
                        }
                        function rl(e) {
                            try {
                                Tl(e, e.i);
                            } catch (t) {
                                return gl(e, t), !1;
                            }
                            var t = e.i.variants.filter(function(e) {
                                return Dn(e);
                            });
                            return t = e.Ka.create(t), e.u.setVariants(Array.from(t.values())), !0;
                        }
                        function il(e) {
                            return rl(e) ? e.u.chooseVariant() : null;
                        }
                        function al(e) {
                            var t = il(e);
                            t && ol(e, t, !0, !0, 0);
                        }
                        function ol(e, t, n, r, i) {
                            var a1 = e.j.l;
                            if (t == a1) r && Ms(e.j, t, r, i, !0);
                            else {
                                var o = e.o.h;
                                o.h != t && (o.h = t, o.g.push({
                                    timestamp: Date.now() / 1e3,
                                    id: t.id,
                                    type: "variant",
                                    fromAdaptation: n,
                                    bandwidth: t.bandwidth
                                })), Ms(e.j, t, r, i, void 0, n), r = null, a1 && (r = An(a1)), t = An(t), n ? ul(e, r, t) : cl(e, r, t);
                            }
                        }
                        function sl(e, t) {
                            var n = Array.from(e.g.audioTracks).find(function(e) {
                                return e.enabled;
                            });
                            t.enabled = !0, t.id !== n.id && (n.enabled = !1), cl(e, n = Rn(n), Rn(t));
                        }
                        function ul(e, t, n) {
                            t = (new Map).set("oldTrack", t).set("newTrack", n), e.M && Io(e.M, n), Al(e, n = Ou("adaptation", t));
                        }
                        function ll(e) {
                            Al(e, Ou("trackschanged"));
                        }
                        function cl(e, t, n) {
                            t = (new Map).set("oldTrack", t).set("newTrack", n), e.M && Io(e.M, n), Al(e, n = Ou("variantchanged", t));
                        }
                        function dl(e) {
                            Al(e, Ou("textchanged"));
                        }
                        function fl(e) {
                            Al(e, Ou("texttrackvisibility"));
                        }
                        function hl(e) {
                            Al(e, Ou("abrstatuschanged", (new Map).set("newStatus", e.h.abr.enabled)));
                        }
                        function gl(e, t) {
                            if (e.l != Cl) {
                                if (function(e, t) {
                                    if (1002 != t.code && 1011 != t.code || 1 != t.category || !navigator.onLine) return !1;
                                    var n = e.h.streaming.maxDisabledTime;
                                    if (0 == n) {
                                        if (1011 != t.code) return !1;
                                        n = 1;
                                    }
                                    for(var r = e.Pa().find(function(e) {
                                        return e.active;
                                    }), i = e.i, a1 = l(i.variants), o = a1.next(); !o.done; o = a1.next())(o = o.value).id === r.id && (o.disabledUntilTime = Date.now() / 1e3 + n);
                                    return gn(i.variants, e.h.restrictions, e.dc), !!(r = il(e)) && (i = e.Ma().video.reduce(function(e, t) {
                                        return e + t.end - t.start;
                                    }, 0), ol(e, r, !1, !0, i), e.$e.O(n), !0);
                                }(e, t)) t.handled = !0;
                                else {
                                    var n = Ou("error", (new Map).set("detail", t));
                                    e.dispatchEvent(n), n.defaultPrevented && (t.handled = !0);
                                }
                            }
                        }
                        function pl(e, t, n) {
                            n = (new Map).set("detail", {
                                schemeIdUri: n.schemeIdUri,
                                value: n.value,
                                startTime: n.startTime,
                                endTime: n.endTime,
                                id: n.id,
                                eventElement: n.eventElement
                            }), e.dispatchEvent(Ou(t, n));
                        }
                        function ml(e) {
                            if (!e.g.error) return null;
                            var t = e.g.error.code;
                            if (1 == t) return null;
                            var n = e.g.error.msExtendedCode;
                            return n && (0 > n && (n += Math.pow(2, 32)), n = n.toString(16)), new De(2, 3, 3016, t, n, e.g.error.message);
                        }
                        function vl(e, t) {
                            if (e.j) {
                                var n = Object.keys(t), r = 1 == n.length && "00" == n[0], i = !1;
                                if (n.length) for(var a1 = (n = l(e.i.variants)).next(); !a1.done; a1 = n.next()){
                                    var o = [];
                                    (a1 = a1.value).audio && o.push(a1.audio), a1.video && o.push(a1.video);
                                    for(var s1 = (o = l(o)).next(); !s1.done; s1 = o.next()){
                                        var u = s1.value;
                                        if (s1 = a1.allowedByKeySystem, u.keyIds.size) {
                                            a1.allowedByKeySystem = !0;
                                            for(var c = (u = l(u.keyIds)).next(); !c.done; c = u.next())c = c.value, c = t[r ? "00" : c], a1.allowedByKeySystem = a1.allowedByKeySystem && !!c && !xl.includes(c);
                                        }
                                        s1 != a1.allowedByKeySystem && (i = !0);
                                    }
                                }
                                i && !rl(e) || ((r = e.j.l) && !r.allowedByKeySystem && al(e), i && ll(e));
                            }
                        }
                        function yl(e, t, n) {
                            e.K && e.K.onExpirationUpdated && e.K.onExpirationUpdated(t, n), t = Ou("expirationupdated"), e.dispatchEvent(t);
                        }
                        function El(e, t, n) {
                            0 < t && (e.U() || e.Ye(t)), n < (t = e.getDuration()) && (e.U() || e.Ia(n));
                        }
                        function Tl(e, t) {
                            var n = e.m ? e.m.Qc() : {}, r = Object.keys(n);
                            r = r.length && "00" == r[0];
                            for(var i = !1, a1 = !1, o = new Set, s1 = new Set, u = l(t.variants), c = u.next(); !c.done; c = u.next()){
                                var d = [];
                                (c = c.value).audio && d.push(c.audio), c.video && d.push(c.video);
                                for(var f = (d = l(d)).next(); !f.done; f = d.next())if ((f = f.value).keyIds.size) for(var h = (f = l(f.keyIds)).next(); !h.done; h = f.next()){
                                    h = h.value;
                                    var g = n[r ? "00" : h];
                                    g ? xl.includes(g) && s1.add(g) : o.add(h);
                                }
                                c.allowedByApplication ? c.allowedByKeySystem && (i = !0) : a1 = !0;
                            }
                            if (!i) throw new De(2, 4, 4012, n = {
                                hasAppRestrictions: a1,
                                missingKeys: Array.from(o),
                                restrictedKeyStatuses: Array.from(s1)
                            });
                        }
                        function bl(e) {
                            if (!e.variants.some(Dn)) throw new De(2, 4, 4032);
                        }
                        function Al(e, t) {
                            L(function(n) {
                                if (1 == n.g) return T(n, Promise.resolve(), 2);
                                e.l != Cl && e.dispatchEvent(t), b(n);
                            });
                        }
                        function _l(e) {
                            for(var t = new Set, n = (e = l(e)).next(); !n.done; n = e.next())(n = n.value).language ? t.add(tn(n.language)) : t.add("und");
                            return t;
                        }
                        function Sl(e) {
                            for(var t = new Map, n = new Map, r = (e = l(e)).next(); !r.done; r = e.next()){
                                var i = "und", a1 = [];
                                (r = r.value).language && (i = tn(r.language)), (a1 = "variant" == r.type ? r.audioRoles : r.roles) && a1.length || (a1 = [
                                    ""
                                ]), t.has(i) || t.set(i, new Set);
                                for(var o = (a1 = l(a1)).next(); !o.done; o = a1.next())o = o.value, t.get(i).add(o), r.label && (n.has(i) || n.set(i, new Map), n.get(i).set(o, r.label));
                            }
                            var s1 = [];
                            return t.forEach(function(e, t) {
                                for(var r = l(e), i = r.next(); !i.done; i = r.next()){
                                    i = i.value;
                                    var a1 = null;
                                    n.has(t) && n.get(t).has(i) && (a1 = n.get(t).get(i)), s1.push({
                                        language: t,
                                        role: i,
                                        label: a1
                                    });
                                }
                            }), s1;
                        }
                        function wl() {
                            return new De(2, 7, 7e3);
                        }
                        function Il(e, t, n, r, i, a1) {
                            return r == e && i.J == a1.J && i.uri == a1.uri && i.mimeType == a1.mimeType ? t : n;
                        }
                        function Rl(e) {
                            return new Promise(function(t, n) {
                                e.mb = function() {
                                    return n(wl());
                                }, e.bd = function() {
                                    return t();
                                }, e.onError = function(e) {
                                    return n(e);
                                }, e.dd = function() {
                                    return n(wl());
                                };
                            });
                        }
                        B("shaka.util.CmcdManager.StreamingFormat", {
                            Kg: "d",
                            Sg: "h",
                            eh: "s",
                            Zg: "o"
                        }), B("shaka.util.ConfigUtils", Tu), Tu.convertToConfigObject = Au, Tu.mergeConfigObjects = bu, B("shaka.util.PlayerConfiguration", Su), Su.mergeConfigObjects = Iu, Su.createDefault = wu, m(xu, vr), (r = xu.prototype).destroy = function() {
                            var e, t = this;
                            return L(function(n) {
                                switch(n.g){
                                    case 1:
                                        return t.l == Cl ? n.return() : (Mu(t), t.l = Cl, e = zs(t.Ea, function() {
                                            return {
                                                node: t.P,
                                                payload: {
                                                    J: null,
                                                    mimeType: null,
                                                    startTime: null,
                                                    me: NaN,
                                                    uri: null
                                                },
                                                ib: !1
                                            };
                                        }), T(n, new Promise(function(t) {
                                            e.Ib = function() {}, e.bd = function() {
                                                t();
                                            }, e.mb = function() {
                                                t();
                                            }, e.onError = function() {
                                                t();
                                            }, e.dd = function() {
                                                t();
                                            };
                                        }), 2));
                                    case 2:
                                        return T(n, t.Ea.destroy(), 3);
                                    case 3:
                                        if (t.Wc && (t.Wc.release(), t.Wc = null), t.Mb && (t.Mb.release(), t.Mb = null), t.s && (t.s.release(), t.s = null), t.Nd = null, t.u = null, t.h = null, t.o = null, t.Oc = null, t.W = null, !t.D) {
                                            n.A(4);
                                            break;
                                        }
                                        return T(n, t.D.destroy(), 5);
                                    case 5:
                                        t.D = null;
                                    case 4:
                                        vr.prototype.release.call(t), b(n);
                                }
                            });
                        }, r.Yb = function(e, t) {
                            if (t = void 0 === t || t, this.l == Cl) return Promise.reject(wl());
                            var n = {
                                J: null,
                                mimeType: null,
                                startTime: null,
                                me: NaN,
                                uri: null
                            };
                            n.J = e, at() || (t = !1);
                            var r = t ? this.vb : this.X, i = zs(this.Ea, function() {
                                return {
                                    node: r,
                                    payload: n,
                                    ib: !1
                                };
                            });
                            return i.Ib = function() {}, Rl(i);
                        }, r.kf = function(e) {
                            this.bf = e;
                        }, r.detach = function() {
                            var e = this;
                            if (this.l == Cl) return Promise.reject(wl());
                            var t = zs(this.Ea, function() {
                                return {
                                    node: e.P,
                                    payload: {
                                        J: null,
                                        mimeType: null,
                                        startTime: null,
                                        me: NaN,
                                        uri: null
                                    },
                                    ib: !1
                                };
                            });
                            return t.Ib = function() {}, Rl(t);
                        }, r.pe = function(e) {
                            var t = this;
                            if (e = void 0 === e || e, this.l == Cl) return Promise.reject(wl());
                            this.cc = !1, at() || (e = !1), Mu(this);
                            var n = {
                                J: null,
                                mimeType: null,
                                startTime: null,
                                me: NaN,
                                uri: null
                            }, r = zs(this.Ea, function(r) {
                                var i = r.J && e ? t.vb : r.J ? t.X : t.P;
                                return n.J = r.J, {
                                    node: i,
                                    payload: n,
                                    ib: !1
                                };
                            });
                            return r.Ib = function() {}, Rl(r);
                        }, r.Eg = function(e) {
                            this.ec = e;
                        }, r.load = function(e, t, n) {
                            var r = this;
                            if (this.ec = null, this.cc = !1, this.l == Cl) return Promise.reject(wl());
                            this.dispatchEvent(Ou("loading"));
                            var i = {
                                J: null,
                                mimeType: null,
                                startTime: null,
                                me: NaN,
                                uri: null
                            };
                            i.uri = e, i.me = Date.now() / 1e3, n && (i.mimeType = n), void 0 !== t && (i.startTime = t);
                            var a1 = function(e, t) {
                                if (!at()) return !0;
                                var n = t.mimeType, r = t.uri || "";
                                if (n || (n = Yi(r), n = Pl[n]), n) {
                                    if ("" == (t.J || gt()).canPlayType(n)) return !1;
                                    if (!at() || !(n in Wi) && !(Yi(r) in zi) || e.h.streaming.preferNativeHls) return !0;
                                    if (ct()) return e.h.streaming.useNativeHlsOnSafari;
                                }
                                return !1;
                            }(this, i) ? this.xb : this.ca, o = zs(this.Ea, function(e) {
                                return null == e.J ? null : (i.J = e.J, {
                                    node: a1,
                                    payload: i,
                                    ib: !0
                                });
                            });
                            return this.o = new Lu, this.W = function(e) {
                                return new ou({
                                    getBandwidthEstimate: function() {
                                        return e.u ? e.u.getBandwidthEstimate() : NaN;
                                    },
                                    Ma: function() {
                                        return e.Ma();
                                    },
                                    getCurrentTime: function() {
                                        return e.g ? e.g.currentTime : 0;
                                    },
                                    Pa: function() {
                                        return e.Pa();
                                    },
                                    Rc: function() {
                                        return e.Rc();
                                    },
                                    U: function() {
                                        return e.U();
                                    }
                                }, e.h.cmcd);
                            }(this), o.Ib = function() {}, new Promise(function(e, t) {
                                o.dd = function() {
                                    return t(new De(2, 7, 7002));
                                }, o.bd = function() {
                                    e(), r.dispatchEvent(Ou("loaded"));
                                }, o.mb = function() {
                                    return t(wl());
                                }, o.onError = function(e) {
                                    return t(e);
                                };
                            });
                        }, r.configure = function(e, t) {
                            2 == arguments.length && "string" == typeof e && (e = Au(e, t)), e.streaming && "forceTransmuxTS" in e.streaming && (Yn("streaming.forceTransmuxTS configuration", "Please Use streaming.forceTransmux instead."), e.streaming.forceTransmux = e.streaming.forceTransmuxTS, delete e.streaming.forceTransmuxTS), e.streaming && e.streaming.lowLatencyMode && (null == e.streaming.inaccurateManifestTolerance && (e.streaming.inaccurateManifestTolerance = 0), null == e.streaming.rebufferingGoal && (e.streaming.rebufferingGoal = .01));
                            var n = Iu(this.h, e, Qu(this));
                            return Vu(this), n;
                        }, r.getConfiguration = function() {
                            var e = Qu(this);
                            return Iu(e, this.h, Qu(this)), e;
                        }, r.Af = function() {
                            if (this.g) {
                                var e = this.g.buffered.length;
                                e = e ? this.g.buffered.end(e - 1) : 0;
                                var t = this.getConfiguration().streaming.bufferingGoal;
                                if (e >= (t = Math.min(this.g.currentTime + t, this.tc().end))) return 1;
                                if (!(e <= this.g.currentTime) && e < t) return (e - this.g.currentTime) / (t - this.g.currentTime);
                            }
                            return 0;
                        }, r.qg = function() {
                            for(var e in this.h)delete this.h[e];
                            Iu(this.h, Qu(this), Qu(this)), Vu(this);
                        }, r.Gf = function() {
                            return this.l;
                        }, r.Kf = function() {
                            return this.g;
                        }, r.ic = function() {
                            return this.D;
                        }, r.Ed = function() {
                            return this.Wb;
                        }, r.Ee = function() {
                            return this.F ? this.F : null;
                        }, r.U = function() {
                            return this.i ? this.i.presentationTimeline.U() : !(!this.g || !this.g.src) && 1 / 0 == this.g.duration;
                        }, r.kb = function() {
                            return !!this.i && this.i.presentationTimeline.kb();
                        }, r.Yf = function() {
                            if (this.i) {
                                var e = this.i.variants;
                                return !!e.length && !e[0].video;
                            }
                            return !(!this.g || !this.g.src) && (this.g.videoTracks ? 0 == this.g.videoTracks.length : 0 == this.g.videoHeight);
                        }, r.tc = function() {
                            if (!this.cc) return {
                                start: 0,
                                end: 0
                            };
                            if (this.i) {
                                var e = this.i.presentationTimeline;
                                return {
                                    start: e.Cb(),
                                    end: e.Na()
                                };
                            }
                            return this.g && this.g.src && (e = this.g.seekable).length ? {
                                start: e.start(0),
                                end: e.end(e.length - 1)
                            } : {
                                start: 0,
                                end: 0
                            };
                        }, r.Wf = function() {
                            this.U() && (this.g.currentTime = this.tc().end);
                        }, r.keySystem = function() {
                            var e = this.drmInfo();
                            return e ? e.keySystem : "";
                        }, r.drmInfo = function() {
                            return this.m ? this.m.g : null;
                        }, r.hc = function() {
                            return this.m ? this.m.hc() : 1 / 0;
                        }, r.Qc = function() {
                            return this.m ? this.m.Qc() : {};
                        }, r.Gd = function() {
                            return !!this.N && this.N.g == ir;
                        }, r.Rc = function() {
                            return this.g ? this.H ? this.H.i : 1 : 0;
                        }, r.zg = function(e) {
                            0 == e ? Y("A trick play rate of 0 is unsupported!") : (this.g.paused && this.g.play(), this.H.set(e), this.l == kl && (this.u.playbackRateChanged(e), xs(this.j, 1 < Math.abs(e))));
                        }, r.nf = function() {
                            var e = this.H.Pc();
                            this.l == Nl && this.H.set(e), this.l == kl && (this.H.set(e), this.u.playbackRateChanged(e), xs(this.j, !1));
                        }, r.Pa = function() {
                            if (this.i) {
                                for(var e = this.j ? this.j.l : null, t = [], n = 0, r = l(this.i.variants), i = r.next(); !i.done; i = r.next())if (Dn(i = i.value)) {
                                    var a1 = An(i);
                                    a1.active = i == e, a1.active || 1 == n || null == e || i.video != e.video || i.audio != e.audio || (a1.active = !0), a1.active && n++, t.push(a1);
                                }
                                return t;
                            }
                            return this.g && this.g.audioTracks ? Array.from(this.g.audioTracks).map(function(e) {
                                return Rn(e);
                            }) : [];
                        }, r.Eb = function() {
                            if (this.i) {
                                for(var e = this.j ? this.j.o : null, t = [], n = l(this.i.textStreams), r = n.next(); !r.done; r = n.next()){
                                    var i = _n(r = r.value);
                                    i.active = r == e, t.push(i);
                                }
                                return t;
                            }
                            return this.g && this.g.src && this.g.textTracks ? Ku(this).map(function(e) {
                                return In(e);
                            }) : [];
                        }, r.Ef = function() {
                            return this.i ? this.i.imageStreams.map(function(e) {
                                return Sn(e);
                            }) : [];
                        }, r.Sf = function(e, t) {
                            var n, r, i, a1, o, s1, u, l, c, d, f, h, g, p, m, v, y, E, b, A, _ = this;
                            return L(function(S) {
                                return 1 == S.g ? _.i ? (n = _.i.imageStreams.find(function(t) {
                                    return t.id == e;
                                })) ? n.segmentIndex ? S.A(3) : T(S, n.createSegmentIndex(), 3) : S.return(null) : S.A(2) : 2 != S.g ? null == (r = n.segmentIndex.find(t)) ? S.return(null) : (i = n.segmentIndex.get(r), a1 = i.tilesLayout || n.tilesLayout, (o = /(\d+)x(\d+)/.exec(a1)) ? (s1 = n.width || 0, u = n.height || 0, l = parseInt(o[1], 10), c = parseInt(o[2], 10), d = s1 / l, f = u / c, h = l * c, g = i.j - i.startTime, p = i.o || g / h, m = i.startTime, y = v = 0, 1 < h && (E = Math.floor((t - i.startTime) / p), m = i.startTime + E * p, v = E % l * d, y = Math.floor(E / l) * f), b = !1, (A = i.m) && (b = !0, f = A.height, v = A.positionX, y = A.positionY, d = A.width), S.return({
                                    imageHeight: u,
                                    imageWidth: s1,
                                    height: f,
                                    positionX: v,
                                    positionY: y,
                                    startTime: m,
                                    duration: p,
                                    uris: i.xa(),
                                    width: d,
                                    sprite: b
                                })) : S.return(null)) : S.return(null);
                            });
                        }, r.Re = function(e) {
                            if (this.i && this.j) {
                                var t = this.i.textStreams.find(function(t) {
                                    return t.id == e.id;
                                });
                                t && t != this.j.o && (Nu(this.o.h, t, !1), Os(this.j, t), dl(this), this.ub = t.language);
                            } else if (this.g && this.g.src && this.g.textTracks) {
                                for(var n = (t = l(t = Ku(this))).next(); !n.done; n = t.next())wn(n = n.value) == e.id ? n.mode = this.ha ? "showing" : "hidden" : n.mode = "disabled";
                                dl(this);
                            }
                        }, r.Se = function(e, t, n) {
                            if (t = void 0 !== t && t, n = void 0 === n ? 0 : n, this.i && this.j) {
                                this.h.abr.enabled && Y("Changing tracks while abr manager is enabled will likely result in the selected track being overriden. Consider disabling abr before calling selectVariantTrack().");
                                var r = this.i.variants.find(function(t) {
                                    return t.id == e.id;
                                });
                                r && Dn(r) && (ol(this, r, !1, t, n), this.Ka = new er(r), rl(this));
                            } else if (this.g && this.g.audioTracks) {
                                for(n = (t = l(t = Array.from(this.g.audioTracks))).next(); !n.done; n = t.next())if (wn(n = n.value) == e.id) {
                                    sl(this, n);
                                    break;
                                }
                            }
                        }, r.zf = function() {
                            return Sl(this.Pa());
                        }, r.Qf = function() {
                            return Sl(this.Eb());
                        }, r.yf = function() {
                            return Array.from(_l(this.Pa()));
                        }, r.Pf = function() {
                            return Array.from(_l(this.Eb()));
                        }, r.fe = function(e, t, n) {
                            if (n = void 0 === n ? 0 : n, this.i && this.B) {
                                this.Ka = new tr(e, t || "", n, ""), t = function(e, t) {
                                    return e.video || t.video ? e.video && t.video ? Math.abs((e.video.height || 0) - (t.video.height || 0)) + Math.abs((e.video.width || 0) - (t.video.width || 0)) : 1 / 0 : 0;
                                }, e = this.j.l;
                                var r = this.Ka.create(this.i.variants);
                                n = null;
                                for(var i = (r = l(r.values())).next(); !i.done; i = r.next())i = i.value, (!n || t(n, e) > t(i, e)) && (n = i);
                                n ? (t = An(n), this.Se(t, !0)) : al(this);
                            } else if (this.g && this.g.audioTracks) {
                                i = Array.from(this.g.audioTracks), e = tn(e), r = n = null;
                                for(var a1 = (i = l(i)).next(); !a1.done; a1 = i.next()){
                                    var o = Rn(a1 = a1.value);
                                    tn(o.language) == e && (n = a1, t ? o.roles.includes(t) && (r = a1) : 0 == o.roles.length && (r = a1));
                                }
                                r ? sl(this, r) : n && sl(this, n);
                            }
                        }, r.ge = function(e, t, n) {
                            if (n = void 0 !== n && n, this.i && this.B) this.ub = e, this.$b = t || "", this.Zb = n, (e = Nn(this.i.textStreams, this.ub, this.$b, this.Zb)[0] || null) && e != this.j.o && (Nu(this.o.h, e, !1), this.h.streaming.alwaysStreamText || this.Hd()) && (Os(this.j, e), dl(this));
                            else {
                                var r = tn(e);
                                (e = this.Eb().find(function(e) {
                                    return tn(e.language) == r && (!t || e.roles.includes(t)) && e.forced == n;
                                })) && this.Re(e);
                            }
                        }, r.sg = function(e) {
                            if (this.i && this.B) {
                                for(var t = null, n = l(this.i.variants), r = n.next(); !r.done; r = n.next())if ((r = r.value).audio.label == e) {
                                    t = r;
                                    break;
                                }
                                null != t && (this.Ka = new tr(t.language, "", 0, e), al(this));
                            }
                        }, r.Hd = function() {
                            var e = this.ha;
                            return this.G ? this.G.m.isTextVisible() : this.g && this.g.src && this.g.textTracks ? Ku(this).some(function(e) {
                                return "showing" == e.mode;
                            }) : e;
                        }, r.Fe = function() {
                            return this.g && this.g.src && this.g.textTracks ? qu(this).map(function(e) {
                                return In(e);
                            }) : [];
                        }, r.Bf = function(e) {
                            var t = tn(e), n = qu(this).filter(function(e) {
                                return tn(e.language) == t;
                            });
                            if (!n || !n.length) return [];
                            e = [];
                            for(var r = (n = l(n)).next(); !r.done; r = n.next())if ((r = r.value) && r.cues) for(var i = (r = l(r.cues)).next(); !i.done; i = r.next()){
                                var a1 = (i = i.value).id;
                                a1 && "" != a1 || (a1 = i.startTime + "-" + i.endTime + "-" + i.text), e.push({
                                    id: a1,
                                    title: i.text,
                                    startTime: i.startTime,
                                    endTime: i.endTime
                                });
                            }
                            return e;
                        }, r.xg = function(e) {
                            if (e = !!e, this.ha != e) {
                                if (this.ha = e, this.l == kl) this.G.m.setTextVisibility(e), this.h.streaming.alwaysStreamText || (e ? this.j.o || 0 < (e = Nn(this.i.textStreams, this.ub, this.$b, this.Zb)).length && (Os(this.j, e[0]), dl(this)) : function(e) {
                                    var t = e.j.get(Ze);
                                    t && (Ks(t), qs(t).catch(function() {}), e.j.delete(Ze)), e.o = null;
                                }(this.j));
                                else if (this.g && this.g.src && this.g.textTracks) for(var t = Ku(this), n = (t = l(t)).next(); !n.done; n = t.next())"disabled" != (n = n.value).mode && (n.mode = e ? "showing" : "hidden");
                                fl(this);
                            }
                        }, r.Nf = function() {
                            if (!this.U()) return null;
                            var e = this.Ea.l, t = 0;
                            if (this.B) t = this.B.Hc();
                            else if (e) {
                                if (null == e.startTime) return new Date;
                                t = e.startTime;
                            }
                            return this.i ? new Date(1e3 * (this.i.presentationTimeline.i + t)) : this.g && this.g.getStartDate ? (e = this.g.getStartDate(), isNaN(e.getTime()) ? null : new Date(e.getTime() + 1e3 * t)) : null;
                        }, r.Ge = function() {
                            if (!this.U()) return null;
                            if (this.i) return new Date(1e3 * this.i.presentationTimeline.i);
                            if (this.g && this.g.getStartDate) {
                                var e = this.g.getStartDate();
                                return isNaN(e.getTime()) ? null : e;
                            }
                            return null;
                        }, r.Ma = function() {
                            if (this.l == kl) return this.G.Ma();
                            var e = {
                                total: [],
                                audio: [],
                                video: [],
                                text: []
                            };
                            return this.l == Nl && (e.total = vo(this.g.buffered)), e;
                        }, r.getStats = function() {
                            if (this.l != kl && this.l != Nl) return {
                                width: NaN,
                                height: NaN,
                                streamBandwidth: NaN,
                                decodedFrames: NaN,
                                droppedFrames: NaN,
                                corruptedFrames: NaN,
                                stallsDetected: NaN,
                                gapsJumped: NaN,
                                estimatedBandwidth: NaN,
                                completionPercent: NaN,
                                loadLatency: NaN,
                                manifestTimeSeconds: NaN,
                                drmTimeSeconds: NaN,
                                playTime: NaN,
                                pauseTime: NaN,
                                bufferingTime: NaN,
                                licenseTime: NaN,
                                liveLatency: NaN,
                                maxSegmentDuration: NaN,
                                switchHistory: [],
                                stateHistory: []
                            };
                            nl(this);
                            var e = this.g, t = e.currentTime / e.duration;
                            if (!isNaN(t)) {
                                var n = this.o;
                                t = Math.round(100 * t), n.i = isNaN(n.i) ? t : Math.max(n.i, t);
                            }
                            if (this.B && (this.o.N = this.B.re(), this.o.P = this.B.se()), e.getVideoPlaybackQuality) {
                                n = e.getVideoPlaybackQuality(), t = this.o;
                                var r = Number(n.totalVideoFrames);
                                t.M = Number(n.droppedVideoFrames), t.K = r, this.o.H = Number(n.corruptedVideoFrames);
                            }
                            n = this.m && (n = this.m).H ? n.H : NaN, this.o.s = n, this.l == kl && ((n = this.j.l) && (this.o.B = (this.H ? this.H.i : 1) * n.bandwidth), n && n.video && (t = this.o, r = n.video.height || NaN, t.o = n.video.width || NaN, t.l = r), this.U() && (n = this.Ge().valueOf() + 1e3 * this.tc().end, this.o.D = (Date.now() - n) / 1e3), this.i && this.i.presentationTimeline && (this.o.G = this.i.presentationTimeline.g), n = this.u.getBandwidthEstimate(), this.o.u = n), this.l == Nl && (n = this.o, t = e.videoHeight || NaN, n.o = e.videoWidth || NaN, n.l = t);
                            var i = this.o;
                            e = i.o, n = i.l, t = i.B, r = i.K;
                            for(var a1 = i.M, o = i.H, s1 = i.P, u = i.N, c = i.u, d = i.i, f = i.m, h = i.F, g = i.j, p = Du(i.g, "playing"), m = Du(i.g, "paused"), v = Du(i.g, "buffering"), y = i.s, E = i.D, T = i.G, b = function(e) {
                                function t(e) {
                                    return {
                                        timestamp: e.timestamp,
                                        state: e.state,
                                        duration: e.duration
                                    };
                                }
                                for(var n = [], r = l(e.h), i = r.next(); !i.done; i = r.next())n.push(t(i.value));
                                return e.g && n.push(t(e.g)), n;
                            }(i.g), A = [], _ = (i = l(i.h.g)).next(); !_.done; _ = i.next())_ = _.value, A.push({
                                timestamp: _.timestamp,
                                id: _.id,
                                type: _.type,
                                fromAdaptation: _.fromAdaptation,
                                bandwidth: _.bandwidth
                            });
                            return {
                                width: e,
                                height: n,
                                streamBandwidth: t,
                                decodedFrames: r,
                                droppedFrames: a1,
                                corruptedFrames: o,
                                stallsDetected: s1,
                                gapsJumped: u,
                                estimatedBandwidth: c,
                                completionPercent: d,
                                loadLatency: f,
                                manifestTimeSeconds: h,
                                drmTimeSeconds: g,
                                playTime: p,
                                pauseTime: m,
                                bufferingTime: v,
                                licenseTime: y,
                                liveLatency: E,
                                maxSegmentDuration: T,
                                stateHistory: b,
                                switchHistory: A
                            };
                        }, r.gf = function(e, t, n, r, i, a1, o) {
                            o = void 0 !== o && o;
                            var s1, u, l, c, d, f, h, g, p, m = this;
                            return L(function(v) {
                                switch(v.g){
                                    case 1:
                                        if (m.l != kl && m.l != Nl) throw new De(1, 7, 7004);
                                        if (r) {
                                            v.A(2);
                                            break;
                                        }
                                        return T(v, Yu(m, e), 3);
                                    case 3:
                                        r = v.h;
                                    case 2:
                                        if (s1 = [], m.F) try {
                                            s1 = m.F.getServerSideCuePoints();
                                        } catch (e) {}
                                        if (m.l != Nl) {
                                            v.A(4);
                                            break;
                                        }
                                        return o && (n = "forced"), T(v, Wu(m, e, t, n, r, a1 || "", s1), 5);
                                    case 5:
                                        if (u = m.Eb(), l = u.find(function(e) {
                                            return e.language == t && e.label == (a1 || "") && e.kind == n;
                                        })) return ll(m), v.return(l);
                                        throw new De(1, 2, 2012);
                                    case 4:
                                        if (c = $e, 1 / 0 == (d = m.i.presentationTimeline.getDuration())) throw new De(1, 4, 4033);
                                        if (!s1.length) {
                                            v.A(6);
                                            break;
                                        }
                                        return T(v, zu(m, e, m.D, m.h.streaming.retryParameters), 7);
                                    case 7:
                                        f = v.h, h = Xu(m, f, r, s1), g = new Blob([
                                            h
                                        ], {
                                            type: "text/vtt"
                                        }), e = Yo(g), r = "text/vtt";
                                    case 6:
                                        if (p = {
                                            id: m.Xd++,
                                            originalId: null,
                                            createSegmentIndex: function() {
                                                return Promise.resolve();
                                            },
                                            segmentIndex: vs(0, d, [
                                                e
                                            ]),
                                            mimeType: r || "",
                                            codecs: i || "",
                                            kind: n,
                                            encrypted: !1,
                                            drmInfos: [],
                                            keyIds: new Set,
                                            language: t,
                                            label: a1 || null,
                                            type: c.Z,
                                            primary: !1,
                                            trickModeVideo: null,
                                            emsgSchemeIdUris: null,
                                            roles: [],
                                            forced: !!o,
                                            channelsCount: null,
                                            audioSamplingRate: null,
                                            spatialAudio: !1,
                                            closedCaptions: null
                                        }, !Yt(Bt(p.mimeType, p.codecs))) throw new De(2, 2, 2014, r);
                                        return m.i.textStreams.push(p), ll(m), v.return(_n(p));
                                }
                            });
                        }, r.hf = function(e, t) {
                            var n, r, i, a1, o, s1, u, c, d, f, h, g, p, m, v, y, E = this;
                            return L(function(b) {
                                switch(b.g){
                                    case 1:
                                        if (E.l != kl && E.l != Nl) throw new De(1, 7, 7004);
                                        if (E.l == Nl) throw new De(1, 2, 2016);
                                        if (t) {
                                            b.A(2);
                                            break;
                                        }
                                        return T(b, Yu(E, e), 3);
                                    case 3:
                                        t = b.h;
                                    case 2:
                                        if ("text/vtt" != t) throw new De(1, 2, 2017, e);
                                        if (n = $e, 1 / 0 == (r = E.i.presentationTimeline.getDuration())) throw new De(1, 4, 4045);
                                        return T(b, zu(E, e, E.D, E.h.streaming.retryParameters), 4);
                                    case 4:
                                        if (i = b.h, !(a1 = Qt[t])) throw new De(2, 2, 2014, t);
                                        for(o = a1(), s1 = {
                                            periodStart: 0,
                                            segmentStart: 0,
                                            segmentEnd: r,
                                            vttOffset: 0
                                        }, u = Ie(i), c = o.parseMedia(u, s1), d = [], f = {}, h = l(c), g = h.next(); !g.done; f = {
                                            Qb: f.Qb
                                        }, g = h.next())p = g.value, f.Qb = ze([
                                            e
                                        ], [
                                            p.payload
                                        ])[0], m = new lo(p.startTime, p.endTime, function(e) {
                                            return function() {
                                                return [
                                                    e.Qb
                                                ];
                                            };
                                        }(f), 0, null, null, 0, 0, 1 / 0), f.Qb.includes("#xywh") && 4 === (v = f.Qb.split("#xywh=")[1].split(",")).length && m.Xe({
                                            height: parseInt(v[3], 10),
                                            positionX: parseInt(v[0], 10),
                                            positionY: parseInt(v[1], 10),
                                            width: parseInt(v[2], 10)
                                        }), d.push(m);
                                        return y = {
                                            id: E.Xd++,
                                            originalId: null,
                                            createSegmentIndex: function() {
                                                return Promise.resolve();
                                            },
                                            segmentIndex: new ps(d),
                                            mimeType: t || "",
                                            codecs: "",
                                            kind: "",
                                            encrypted: !1,
                                            drmInfos: [],
                                            keyIds: new Set,
                                            language: "und",
                                            label: null,
                                            type: n.Vb,
                                            primary: !1,
                                            trickModeVideo: null,
                                            emsgSchemeIdUris: null,
                                            roles: [],
                                            forced: !1,
                                            channelsCount: null,
                                            audioSamplingRate: null,
                                            spatialAudio: !1,
                                            closedCaptions: null,
                                            tilesLayout: "1x1"
                                        }, E.i.imageStreams.push(y), ll(E), b.return(Sn(y));
                                }
                            });
                        }, r.ff = function(e, t, n) {
                            var r, i, a1, o, s1 = this;
                            return L(function(u) {
                                switch(u.g){
                                    case 1:
                                        if (s1.l != kl && s1.l != Nl) throw new De(1, 7, 7004);
                                        if (n) {
                                            u.A(2);
                                            break;
                                        }
                                        return T(u, Yu(s1, e), 3);
                                    case 3:
                                        n = u.h;
                                    case 2:
                                        if (r = [], s1.F) try {
                                            r = s1.F.getServerSideCuePoints();
                                        } catch (e) {}
                                        return T(u, Wu(s1, e, t, "chapters", n, "", r), 4);
                                    case 4:
                                        if (i = u.h, a1 = s1.Fe(), !(o = a1.find(function(e) {
                                            return e.language == t;
                                        }))) {
                                            u.A(5);
                                            break;
                                        }
                                        return T(u, new Promise(function(e, t) {
                                            s1.s.na(i, "load", e), s1.s.na(i, "error", function() {
                                                t(new De(1, 2, 2015));
                                            });
                                        }), 6);
                                    case 6:
                                        return u.return(o);
                                    case 5:
                                        throw new De(1, 2, 2012);
                                }
                            });
                        }, r.je = function(e, t) {
                            this.dc.width = e, this.dc.height = t;
                        }, r.be = function(e) {
                            if (this.l == kl) {
                                var t = this.j;
                                if (e = void 0 === e ? .1 : e, t.h.g) t = !1;
                                else if (t.s) t = !1;
                                else {
                                    for(var n = l(t.j.values()), r = n.next(); !r.done; r = n.next())(r = r.value).mc && (r.mc = !1, Vs(t, r, e));
                                    t = !0;
                                }
                            } else t = !1;
                            return t;
                        }, r.Hf = function() {
                            return Y("Shaka Player's internal Manifest structure is NOT covered by semantic versioning compatibility guarantees.  It may change at any time!  Please consider filing a feature request for whatever you use getManifest() for."), this.i;
                        }, r.If = function() {
                            return this.Xc;
                        }, r.Ze = function(e) {
                            this.Oc = e;
                        }, B("shaka.Player", xu), xu.prototype.setVideoContainer = xu.prototype.Ze, xu.prototype.getManifestParserFactory = xu.prototype.If, xu.prototype.getManifest = xu.prototype.Hf, xu.prototype.retryStreaming = xu.prototype.be, xu.prototype.setMaxHardwareResolution = xu.prototype.je, xu.prototype.addChaptersTrack = xu.prototype.ff, xu.prototype.addThumbnailsTrack = xu.prototype.hf, xu.prototype.addTextTrackAsync = xu.prototype.gf, xu.prototype.getStats = xu.prototype.getStats, xu.prototype.getBufferedInfo = xu.prototype.Ma, xu.prototype.getPresentationStartTimeAsDate = xu.prototype.Ge, xu.prototype.getPlayheadTimeAsDate = xu.prototype.Nf, xu.prototype.setTextTrackVisibility = xu.prototype.xg, xu.prototype.getChapters = xu.prototype.Bf, xu.prototype.getChaptersTracks = xu.prototype.Fe, xu.prototype.isTextTrackVisible = xu.prototype.Hd, xu.prototype.selectVariantsByLabel = xu.prototype.sg, xu.prototype.selectTextLanguage = xu.prototype.ge, xu.prototype.selectAudioLanguage = xu.prototype.fe, xu.prototype.getTextLanguages = xu.prototype.Pf, xu.prototype.getAudioLanguages = xu.prototype.yf, xu.prototype.getTextLanguagesAndRoles = xu.prototype.Qf, xu.prototype.getAudioLanguagesAndRoles = xu.prototype.zf, xu.prototype.selectVariantTrack = xu.prototype.Se, xu.prototype.selectTextTrack = xu.prototype.Re, xu.prototype.getThumbnails = xu.prototype.Sf, xu.prototype.getImageTracks = xu.prototype.Ef, xu.prototype.getTextTracks = xu.prototype.Eb, xu.prototype.getVariantTracks = xu.prototype.Pa, xu.prototype.cancelTrickPlay = xu.prototype.nf, xu.prototype.trickPlay = xu.prototype.zg, xu.prototype.getPlaybackRate = xu.prototype.Rc, xu.prototype.isBuffering = xu.prototype.Gd, xu.prototype.getKeyStatuses = xu.prototype.Qc, xu.prototype.getExpiration = xu.prototype.hc, xu.prototype.drmInfo = xu.prototype.drmInfo, xu.prototype.keySystem = xu.prototype.keySystem, xu.prototype.goToLive = xu.prototype.Wf, xu.prototype.seekRange = xu.prototype.tc, xu.prototype.isAudioOnly = xu.prototype.Yf, xu.prototype.isInProgress = xu.prototype.kb, xu.prototype.isLive = xu.prototype.U, xu.prototype.getAdManager = xu.prototype.Ee, xu.prototype.getAssetUri = xu.prototype.Ed, xu.prototype.getNetworkingEngine = xu.prototype.ic, xu.prototype.getMediaElement = xu.prototype.Kf, xu.prototype.getLoadMode = xu.prototype.Gf, xu.prototype.resetConfiguration = xu.prototype.qg, xu.prototype.getBufferFullness = xu.prototype.Af, xu.prototype.getConfiguration = xu.prototype.getConfiguration, xu.prototype.configure = xu.prototype.configure, xu.prototype.load = xu.prototype.load, xu.prototype.updateStartTime = xu.prototype.Eg, xu.prototype.unload = xu.prototype.pe, xu.prototype.detach = xu.prototype.detach, xu.prototype.attachCanvas = xu.prototype.kf, xu.prototype.attach = xu.prototype.Yb, xu.probeSupport = function(e) {
                            var t, n, r, i, a1;
                            return e = void 0 === e || e, L(function(o) {
                                if (1 == o.g) return t = {}, e ? T(o, function() {
                                    var e, t, n, r, i, a1;
                                    return L(function(o) {
                                        return 1 == o.g ? (e = "org.w3.clearkey com.widevine.alpha com.microsoft.playready com.microsoft.playready.recommendation com.apple.fps.1_0 com.apple.fps com.adobe.primetime".split(" "), n = [
                                            {
                                                videoCapabilities: t = [
                                                    {
                                                        contentType: 'video/mp4; codecs="avc1.42E01E"'
                                                    },
                                                    {
                                                        contentType: 'video/webm; codecs="vp8"'
                                                    }
                                                ],
                                                persistentState: "required",
                                                sessionTypes: [
                                                    "persistent-license"
                                                ]
                                            },
                                            {
                                                initDataTypes: [
                                                    "cenc"
                                                ],
                                                videoCapabilities: t
                                            }
                                        ], r = new Map, i = function(e) {
                                            var t, i, a1;
                                            return L(function(o) {
                                                switch(o.g){
                                                    case 1:
                                                        if (A(o, 2), "org.w3.clearkey" === e && ft()) throw Error("Unsupported keySystem");
                                                        return T(o, navigator.requestMediaKeySystemAccess(e, n), 4);
                                                    case 4:
                                                        return t = o.h, a1 = !!(i = t.getConfiguration().sessionTypes) && i.includes("persistent-license"), ht("Tizen 3") && (a1 = !1), r.set(e, {
                                                            persistentState: a1
                                                        }), T(o, t.createMediaKeys(), 5);
                                                    case 5:
                                                        S(o, 0);
                                                        break;
                                                    case 2:
                                                        w(o), r.set(e, null), b(o);
                                                }
                                            });
                                        }, a1 = e.map(function(e) {
                                            return i(e);
                                        }), T(o, Promise.all(a1), 2)) : o.return(Ur(r));
                                    });
                                }(), 3) : o.A(2);
                                2 != o.g && (t = o.h);
                                var s1 = {};
                                if (at()) {
                                    for(var u in Wi)s1[u] = !0;
                                    for(var d in zi)s1[d] = !0;
                                }
                                u = {
                                    mpd: "application/dash+xml",
                                    m3u8: "application/x-mpegurl",
                                    ism: "application/vnd.ms-sstr+xml"
                                };
                                for(var f = (d = l([
                                    "application/dash+xml",
                                    "application/x-mpegurl",
                                    "application/vnd.apple.mpegurl",
                                    "application/vnd.ms-sstr+xml"
                                ])).next(); !f.done; f = d.next())s1[f = f.value] = at() ? !!Wi[f] : ot(f);
                                for(var h in u)s1[h] = at() ? !!zi[h] : ot(u[h]);
                                for(n = s1, s1 = {}, u = (h = l(h = 'video/mp4; codecs="avc1.42E01E",video/mp4; codecs="avc3.42E01E",video/mp4; codecs="hev1.1.6.L93.90",video/mp4; codecs="hvc1.1.6.L93.90",video/mp4; codecs="hev1.2.4.L153.B0"; eotf="smpte2084",video/mp4; codecs="hvc1.2.4.L153.B0"; eotf="smpte2084",video/mp4; codecs="vp9",video/mp4; codecs="vp09.00.10.08",video/mp4; codecs="av01.0.01M.08",audio/mp4; codecs="mp4a.40.2",audio/mp4; codecs="ac-3",audio/mp4; codecs="ec-3",audio/mp4; codecs="opus",audio/mp4; codecs="flac",video/webm; codecs="vp8",video/webm; codecs="vp9",video/webm; codecs="vp09.00.10.08",audio/webm; codecs="vorbis",audio/webm; codecs="opus",video/mp2t; codecs="avc1.42E01E",video/mp2t; codecs="avc3.42E01E",video/mp2t; codecs="hvc1.1.6.L93.90",video/mp2t; codecs="mp4a.40.2",video/mp2t; codecs="ac-3",video/mp2t; codecs="ec-3",text/vtt,application/mp4; codecs="wvtt",application/ttml+xml,application/mp4; codecs="stpp"'.split(",").concat(c(zo)))).next(); !u.done; u = h.next())s1[u = u.value] = at() ? !!Yt(u) || MediaSource.isTypeSupported(u) || Ot(u) : ot(u), s1[d = u.split(";")[0]] = s1[d] || s1[u];
                                for(a1 in r = {
                                    manifest: n,
                                    media: s1,
                                    drm: t
                                }, i = Ml)r[a1] = i[a1]();
                                return o.return(r);
                            });
                        }, xu.isBrowserSupported = function() {
                            if (e.Promise || Y("A Promise implementation or polyfill is required"), !(e.Promise && e.Uint8Array && Array.prototype.forEach) || ht("Trident/")) return !1;
                            var t = ft();
                            return !(t && 13 > t || !(e.MediaKeys && e.navigator && e.navigator.requestMediaKeySystemAccess && e.MediaKeySystemAccess && e.MediaKeySystemAccess.prototype.getConfiguration)) && (!!at() || ot("application/x-mpegurl"));
                        }, xu.setAdManagerFactory = function(e) {
                            Ol = e;
                        }, xu.registerSupportPlugin = function(e, t) {
                            Ml[e] = t;
                        }, xu.prototype.destroy = xu.prototype.destroy;
                        var Cl = 0, Dl = 1, kl = 2, Nl = 3;
                        xu.LoadMode = {
                            DESTROYED: Cl,
                            NOT_LOADED: Dl,
                            MEDIA_SOURCE: kl,
                            SRC_EQUALS: Nl
                        }, xu.version = "v4.3.0";
                        var Ll = [
                            "4",
                            "3"
                        ];
                        Xn = new function(e) {
                            this.g = e, this.i = Wn, this.h = zn;
                        }(new qn(Number(Ll[0]), Number(Ll[1])));
                        var xl = [
                            "output-restricted",
                            "internal-error"
                        ], Ml = {}, Ol = null, Pl = {
                            mp4: "video/mp4",
                            m4v: "video/mp4",
                            m4a: "audio/mp4",
                            webm: "video/webm",
                            weba: "audio/webm",
                            mkv: "video/webm",
                            ts: "video/mp2t",
                            ogv: "video/ogg",
                            ogg: "audio/ogg",
                            mpg: "video/mpeg",
                            mpeg: "video/mpeg",
                            m3u8: "application/x-mpegurl",
                            mpd: "application/dash+xml",
                            mp3: "audio/mpeg",
                            aac: "audio/aac",
                            flac: "audio/flac",
                            wav: "audio/wav"
                        }, Fl = {
                            sbv: "text/x-subviewer",
                            srt: "text/srt",
                            vtt: "text/vtt",
                            webvtt: "text/vtt",
                            ttml: "application/ttml+xml",
                            lrc: "application/x-subtitle-lrc",
                            ssa: "text/x-ssa",
                            ass: "text/x-ssa"
                        };
                        function Ul() {
                            this.h = [], this.j = this.i = this.g = 0;
                        }
                        function jl(e, t, n) {
                            var r = this;
                            this.h = e, this.g = t, this.m = n, this.i = !1, this.l = this.g.getVolume(), this.j = new xr, this.j.C(this.g, google.ima.AdEvent.Type.PAUSED, function() {
                                r.i = !0;
                            }), this.j.C(this.g, google.ima.AdEvent.Type.RESUMED, function() {
                                r.i = !1;
                            });
                        }
                        function Bl(t, n, r, i) {
                            var a1 = this;
                            this.o = t, this.i = n, this.s = null, this.u = NaN, this.l = i, this.j = null, this.h = new xr, google.ima.settings.setLocale(r), (t = new google.ima.AdDisplayContainer(this.o, this.i)).initialize(), this.m = new google.ima.AdsLoader(t), this.m.getSettings().setPlayerType("shaka-player"), this.m.getSettings().setPlayerVersion("v4.3.0"), this.g = null, this.h.na(this.m, google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, function(t) {
                                !function(t, n) {
                                    t.l(new gr("ads-loaded", (new Map).set("loadTime", Date.now() / 1e3 - t.u))), t.g = n.getAdsManager(t.i), t.l(new gr("ima-ad-manager-loaded", (new Map).set("imaAdManager", t.g)));
                                    var r = t.g.getCuePoints();
                                    if (r.length) {
                                        for(var i = [], a1 = (r = l(r)).next(); !a1.done; a1 = r.next())i.push({
                                            start: a1.value,
                                            end: null
                                        });
                                        t.l(new gr("ad-cue-points-changed", (new Map).set("cuepoints", i)));
                                    }
                                    !function(e) {
                                        function t(t, n) {
                                            var r = (new Map).set("originalEvent", t);
                                            e.l(new gr(n, r));
                                        }
                                        e.h.C(e.g, google.ima.AdErrorEvent.Type.AD_ERROR, function(t) {
                                            Gl(e, t);
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, function(t) {
                                            Vl(e, t);
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.STARTED, function(t) {
                                            Vl(e, t);
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.FIRST_QUARTILE, function(e) {
                                            t(e, "ad-first-quartile");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.MIDPOINT, function(e) {
                                            t(e, "ad-midpoint");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.THIRD_QUARTILE, function(e) {
                                            t(e, "ad-third-quartile");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.COMPLETE, function(e) {
                                            t(e, "ad-complete");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, function(t) {
                                            Kl(e, t);
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.ALL_ADS_COMPLETED, function(t) {
                                            Kl(e, t);
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.SKIPPED, function(e) {
                                            t(e, "ad-skipped");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.VOLUME_CHANGED, function(e) {
                                            t(e, "ad-volume-changed");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.VOLUME_MUTED, function(e) {
                                            t(e, "ad-muted");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.PAUSED, function(n) {
                                            e.j && (e.j.i = !0, t(n, "ad-paused"));
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.RESUMED, function(n) {
                                            e.j && (e.j.i = !1, t(n, "ad-resumed"));
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.SKIPPABLE_STATE_CHANGED, function(n) {
                                            e.j && t(n, "ad-skip-state-changed");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.CLICK, function(e) {
                                            t(e, "ad-clicked");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.AD_PROGRESS, function(e) {
                                            t(e, "ad-progress");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.AD_BUFFERING, function(e) {
                                            t(e, "ad-buffering");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.IMPRESSION, function(e) {
                                            t(e, "ad-impression");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.DURATION_CHANGE, function(e) {
                                            t(e, "ad-duration-changed");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.USER_CLOSE, function(e) {
                                            t(e, "ad-closed");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.LOADED, function(e) {
                                            t(e, "ad-loaded");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.ALL_ADS_COMPLETED, function(e) {
                                            t(e, "all-ads-completed");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.LINEAR_CHANGED, function(e) {
                                            t(e, "ad-linear-changed");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.AD_METADATA, function(e) {
                                            t(e, "ad-metadata");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.LOG, function(e) {
                                            t(e, "ad-recoverable-error");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.AD_BREAK_READY, function(e) {
                                            t(e, "ad-break-ready");
                                        }), e.h.C(e.g, google.ima.AdEvent.Type.INTERACTION, function(e) {
                                            t(e, "ad-interaction");
                                        });
                                    }(t);
                                    try {
                                        t.g.init(t.i.offsetWidth, t.i.offsetHeight, Hl(t) ? google.ima.ViewMode.FULLSCREEN : google.ima.ViewMode.NORMAL), t.h.C(t.i, "loadeddata", function() {
                                            t.g.resize(t.i.offsetWidth, t.i.offsetHeight, Hl(t) ? google.ima.ViewMode.FULLSCREEN : google.ima.ViewMode.NORMAL);
                                        }), "ResizeObserver" in e ? (t.s = new ResizeObserver(function() {
                                            t.g.resize(t.i.offsetWidth, t.i.offsetHeight, Hl(t) ? google.ima.ViewMode.FULLSCREEN : google.ima.ViewMode.NORMAL);
                                        }), t.s.observe(t.i)) : t.h.C(document, "fullscreenchange", function() {
                                            t.g.resize(t.i.offsetWidth, t.i.offsetHeight, Hl(t) ? google.ima.ViewMode.FULLSCREEN : google.ima.ViewMode.NORMAL);
                                        }), t.i.addEventListener("play", function() {
                                            t.g.start();
                                        }, {
                                            once: !0
                                        });
                                    } catch (e) {
                                        Kl(t, null);
                                    }
                                }(a1, t);
                            }), this.h.C(this.m, google.ima.AdErrorEvent.Type.AD_ERROR, function(e) {
                                Gl(a1, e);
                            }), this.i.onended = function() {
                                a1.m.contentComplete();
                            };
                        }
                        function Gl(e, t) {
                            t.getError(), Kl(e, null), e.l(new gr("ad-cue-points-changed", (new Map).set("cuepoints", [])));
                        }
                        function Hl(e) {
                            return document.fullscreenEnabled ? !!document.fullscreenElement : !!(e = e.i).webkitSupportsFullscreen && e.webkitDisplayingFullscreen;
                        }
                        function Vl(e, t) {
                            var n = t.getAd();
                            n ? (e.j = new jl(n, e.g, e.i), n = (new Map).set("ad", e.j).set("sdkAdObject", n).set("originalEvent", t), e.l(new gr("ad-started", n)), e.j.isLinear() && (e.o.setAttribute("ad-active", "true"), e.i.pause())) : Y("The IMA SDK fired a " + t.type + " event with no associated ad. Unable to play ad!");
                        }
                        function Kl(e, t) {
                            e.l(new gr("ad-stopped", (new Map).set("originalEvent", t))), e.j && e.j.isLinear() && (e.o.removeAttribute("ad-active"), e.i.play());
                        }
                        function ql(e, t) {
                            this.i = e, this.h = null, this.g = t;
                        }
                        function Yl(e, t, n, r) {
                            var i = this;
                            this.s = e, this.l = t, this.j = null, this.G = NaN, this.i = r, this.F = !1, this.u = this.m = this.o = null, this.B = "", this.D = [], this.h = new xr, (e = new google.ima.dai.api.UiSettings).setLocale(n), this.g = new google.ima.dai.api.StreamManager(this.l, this.s, e), this.i(new gr("ima-stream-manager-loaded", (new Map).set("imaStreamManager", this.g))), this.h.C(this.g, google.ima.dai.api.StreamEvent.Type.LOADED, function(e) {
                                !function(e, t) {
                                    e.i(new gr("ads-loaded", (new Map).set("loadTime", Date.now() / 1e3 - e.G)));
                                    var n = t.getStreamData().url;
                                    e.j.resolve(n), e.j = null, e.F || e.h.C(e.l, "seeked", function() {
                                        var t = e.l.currentTime;
                                        if (0 != t) {
                                            e.g.streamTimeForContentTime(t);
                                            var n = e.g.previousCuePointForStreamTime(t);
                                            n && !n.played && (e.o = t, e.l.currentTime = n.start);
                                        }
                                    });
                                }(i, e);
                            }), this.h.C(this.g, google.ima.dai.api.StreamEvent.Type.ERROR, function() {
                                i.B.length ? i.j.resolve(i.B) : i.j.reject("IMA Stream request returned an error and there was no backup asset uri provided."), i.j = null;
                            }), this.h.C(this.g, google.ima.dai.api.StreamEvent.Type.AD_BREAK_STARTED, function() {}), this.h.C(this.g, google.ima.dai.api.StreamEvent.Type.STARTED, function(e) {
                                e = e.getAd(), i.m = new ql(e, i.l), i.u && (i.m.h = i.u), i.i(new gr("ad-started", (new Map).set("ad", i.m))), i.s.setAttribute("ad-active", "true");
                            }), this.h.C(this.g, google.ima.dai.api.StreamEvent.Type.AD_BREAK_ENDED, function() {
                                i.s.removeAttribute("ad-active");
                                var e = i.l.currentTime;
                                i.o && i.o > e && (i.l.currentTime = i.o, i.o = null);
                            }), this.h.C(this.g, google.ima.dai.api.StreamEvent.Type.AD_PROGRESS, function(e) {
                                i.u = e.getStreamData().adProgressData, i.m && (i.m.h = i.u);
                            }), this.h.C(this.g, google.ima.dai.api.StreamEvent.Type.FIRST_QUARTILE, function() {
                                i.i(new gr("ad-first-quartile"));
                            }), this.h.C(this.g, google.ima.dai.api.StreamEvent.Type.MIDPOINT, function() {
                                i.i(new gr("ad-midpoint"));
                            }), this.h.C(this.g, google.ima.dai.api.StreamEvent.Type.THIRD_QUARTILE, function() {
                                i.i(new gr("ad-third-quartile"));
                            }), this.h.C(this.g, google.ima.dai.api.StreamEvent.Type.COMPLETE, function() {
                                i.i(new gr("ad-complete")), i.i(new gr("ad-stopped")), i.s.removeAttribute("ad-active"), i.m = null;
                            }), this.h.C(this.g, google.ima.dai.api.StreamEvent.Type.SKIPPED, function() {
                                i.i(new gr("ad-skipped")), i.i(new gr("ad-stopped"));
                            }), this.h.C(this.g, google.ima.dai.api.StreamEvent.Type.CUEPOINTS_CHANGED, function(e) {
                                var t = e.getStreamData();
                                e = [];
                                for(var n = (t = l(t.cuepoints)).next(); !n.done; n = t.next())n = n.value, e.push({
                                    start: n.start,
                                    end: n.end
                                });
                                i.D = e, i.i(new gr("ad-cue-points-changed", (new Map).set("cuepoints", e)));
                            });
                        }
                        function Wl() {
                            vr.call(this), this.g = this.i = null, this.h = new Ul, this.j = navigator.language;
                        }
                        function zl(e) {
                            return JSON.stringify(e, function(e, t) {
                                if ("function" != typeof t) {
                                    if (t instanceof Event || t instanceof gr) {
                                        var n = {};
                                        for(i in t){
                                            var r = t[i];
                                            r && "object" == typeof r ? "detail" == i && (n[i] = r) : i in Event || (n[i] = r);
                                        }
                                        return n;
                                    }
                                    if (t instanceof Error) {
                                        var i = new Set([
                                            "name",
                                            "message",
                                            "stack"
                                        ]);
                                        for(n in t)i.add(n);
                                        for(n = (r = l(Object.getOwnPropertyNames(t))).next(); !n.done; n = r.next())i.add(n.value);
                                        for(r = {}, n = (i = l(i)).next(); !n.done; n = i.next())r[n = n.value] = t[n];
                                        i = {
                                            __type__: "Error",
                                            contents: r
                                        };
                                    } else if (t instanceof TimeRanges) for(i = {
                                        __type__: "TimeRanges",
                                        length: t.length,
                                        start: [],
                                        end: []
                                    }, r = (n = l(vo(t))).next(); !r.done; r = n.next()){
                                        var a1 = (r = r.value).end;
                                        i.start.push(r.start), i.end.push(a1);
                                    }
                                    else i = t instanceof Uint8Array ? {
                                        __type__: "Uint8Array",
                                        entries: Array.from(t)
                                    } : "number" == typeof t ? isNaN(t) ? "NaN" : isFinite(t) ? t : 0 > t ? "-Infinity" : "Infinity" : t;
                                    return i;
                                }
                            });
                        }
                        function Xl(e) {
                            return JSON.parse(e, function(e, t) {
                                if ("NaN" == t) var n = NaN;
                                else if ("-Infinity" == t) n = -1 / 0;
                                else if ("Infinity" == t) n = 1 / 0;
                                else if (t && "object" == typeof t && "TimeRanges" == t.__type__) n = function(e) {
                                    return {
                                        length: e.length,
                                        start: function(t) {
                                            return e.start[t];
                                        },
                                        end: function(t) {
                                            return e.end[t];
                                        }
                                    };
                                }(t);
                                else if (t && "object" == typeof t && "Uint8Array" == t.__type__) n = new Uint8Array(t.entries);
                                else if (t && "object" == typeof t && "Error" == t.__type__) {
                                    n = t.contents;
                                    var r, i = Error(n.message);
                                    for(r in n)i[r] = n[r];
                                    n = i;
                                } else n = t;
                                return n;
                            });
                        }
                        (r = jl.prototype).getDuration = function() {
                            return this.h.getDuration();
                        }, r.getMinSuggestedDuration = function() {
                            return this.h.getMinSuggestedDuration();
                        }, r.getRemainingTime = function() {
                            return this.g.getRemainingTime();
                        }, r.isPaused = function() {
                            return this.i;
                        }, r.isSkippable = function() {
                            return 0 <= this.h.getSkipTimeOffset();
                        }, r.getTimeUntilSkippable = function() {
                            var e = this.h.getSkipTimeOffset();
                            return e = this.getRemainingTime() - e, Math.max(e, 0);
                        }, r.canSkipNow = function() {
                            return this.g.getAdSkippableState();
                        }, r.skip = function() {
                            return this.g.skip();
                        }, r.pause = function() {
                            return this.g.pause();
                        }, r.play = function() {
                            return this.g.resume();
                        }, r.getVolume = function() {
                            return this.g.getVolume();
                        }, r.setVolume = function(e) {
                            return this.g.setVolume(e);
                        }, r.isMuted = function() {
                            return 0 == this.g.getVolume();
                        }, r.isLinear = function() {
                            return this.h.isLinear();
                        }, r.resize = function(e, t) {
                            var n = !1, r = this.m;
                            document.fullscreenEnabled ? n = !!document.fullscreenElement : r.webkitSupportsFullscreen && (n = r.webkitDisplayingFullscreen), this.g.resize(e, t, n ? google.ima.ViewMode.FULLSCREEN : google.ima.ViewMode.NORMAL);
                        }, r.setMuted = function(e) {
                            e ? (this.l = this.getVolume(), this.setVolume(0)) : this.setVolume(this.l);
                        }, r.getSequenceLength = function() {
                            var e = this.h.getAdPodInfo();
                            return null == e ? 1 : e.getTotalAds();
                        }, r.getPositionInSequence = function() {
                            var e = this.h.getAdPodInfo();
                            return null == e ? 1 : e.getAdPosition();
                        }, r.getTitle = function() {
                            return this.h.getTitle();
                        }, r.getDescription = function() {
                            return this.h.getDescription();
                        }, r.release = function() {
                            this.g = this.h = null;
                        }, B("shaka.ads.ClientSideAd", jl), jl.prototype.release = jl.prototype.release, jl.prototype.getDescription = jl.prototype.getDescription, jl.prototype.getTitle = jl.prototype.getTitle, jl.prototype.getPositionInSequence = jl.prototype.getPositionInSequence, jl.prototype.getSequenceLength = jl.prototype.getSequenceLength, jl.prototype.setMuted = jl.prototype.setMuted, jl.prototype.resize = jl.prototype.resize, jl.prototype.isLinear = jl.prototype.isLinear, jl.prototype.isMuted = jl.prototype.isMuted, jl.prototype.setVolume = jl.prototype.setVolume, jl.prototype.getVolume = jl.prototype.getVolume, jl.prototype.play = jl.prototype.play, jl.prototype.pause = jl.prototype.pause, jl.prototype.skip = jl.prototype.skip, jl.prototype.canSkipNow = jl.prototype.canSkipNow, jl.prototype.getTimeUntilSkippable = jl.prototype.getTimeUntilSkippable, jl.prototype.isSkippable = jl.prototype.isSkippable, jl.prototype.isPaused = jl.prototype.isPaused, jl.prototype.getRemainingTime = jl.prototype.getRemainingTime, jl.prototype.getMinSuggestedDuration = jl.prototype.getMinSuggestedDuration, jl.prototype.getDuration = jl.prototype.getDuration, Bl.prototype.stop = function() {
                            this.g && this.g.stop(), this.o && eu(this.o);
                        }, Bl.prototype.release = function() {
                            this.stop(), this.s && this.s.disconnect(), this.h && this.h.release(), this.g && this.g.destroy(), this.m.destroy();
                        }, (r = ql.prototype).getDuration = function() {
                            return this.h ? this.h.duration : -1;
                        }, r.getMinSuggestedDuration = function() {
                            return this.getDuration();
                        }, r.getRemainingTime = function() {
                            return this.h ? this.h.duration - this.h.currentTime : -1;
                        }, r.isPaused = function() {
                            return this.g.paused;
                        }, r.isSkippable = function() {
                            return this.i.isSkippable();
                        }, r.getTimeUntilSkippable = function() {
                            var e = this.i.getSkipTimeOffset();
                            return e = this.getRemainingTime() - e, Math.max(e, 0);
                        }, r.canSkipNow = function() {
                            return 0 == this.getTimeUntilSkippable();
                        }, r.skip = function() {
                            this.g.currentTime += this.getRemainingTime();
                        }, r.pause = function() {
                            return this.g.pause();
                        }, r.play = function() {
                            return this.g.play();
                        }, r.getVolume = function() {
                            return this.g.volume;
                        }, r.setVolume = function(e) {
                            this.g.volume = e;
                        }, r.isMuted = function() {
                            return this.g.muted;
                        }, r.isLinear = function() {
                            return !0;
                        }, r.resize = function() {}, r.setMuted = function(e) {
                            this.g.muted = e;
                        }, r.getSequenceLength = function() {
                            var e = this.i.getAdPodInfo();
                            return null == e ? 1 : e.getTotalAds();
                        }, r.getPositionInSequence = function() {
                            var e = this.i.getAdPodInfo();
                            return null == e ? 1 : e.getAdPosition();
                        }, r.getTitle = function() {
                            return this.i.getTitle();
                        }, r.getDescription = function() {
                            return this.i.getDescription();
                        }, r.release = function() {
                            this.g = this.h = this.i = null;
                        }, B("shaka.ads.ServerSideAd", ql), ql.prototype.release = ql.prototype.release, ql.prototype.getDescription = ql.prototype.getDescription, ql.prototype.getTitle = ql.prototype.getTitle, ql.prototype.getPositionInSequence = ql.prototype.getPositionInSequence, ql.prototype.getSequenceLength = ql.prototype.getSequenceLength, ql.prototype.setMuted = ql.prototype.setMuted, ql.prototype.resize = ql.prototype.resize, ql.prototype.isLinear = ql.prototype.isLinear, ql.prototype.isMuted = ql.prototype.isMuted, ql.prototype.setVolume = ql.prototype.setVolume, ql.prototype.getVolume = ql.prototype.getVolume, ql.prototype.play = ql.prototype.play, ql.prototype.pause = ql.prototype.pause, ql.prototype.skip = ql.prototype.skip, ql.prototype.canSkipNow = ql.prototype.canSkipNow, ql.prototype.getTimeUntilSkippable = ql.prototype.getTimeUntilSkippable, ql.prototype.isSkippable = ql.prototype.isSkippable, ql.prototype.isPaused = ql.prototype.isPaused, ql.prototype.getRemainingTime = ql.prototype.getRemainingTime, ql.prototype.getMinSuggestedDuration = ql.prototype.getMinSuggestedDuration, ql.prototype.getDuration = ql.prototype.getDuration, Yl.prototype.stop = function() {
                            this.B = "", this.o = null, this.D = [];
                        }, Yl.prototype.release = function() {
                            this.stop(), this.h && this.h.release();
                        }, Yl.prototype.onCueMetadataChange = function(e) {
                            if (e.key && e.data) {
                                var t = {};
                                t[e.key] = e.data, this.g.onTimedMetadata(t);
                            }
                        }, m(Wl, vr), (r = Wl.prototype).setLocale = function(e) {
                            this.j = e;
                        }, r.initClientSide = function(t, n) {
                            var r = this;
                            if (!e.google || !google.ima || !google.ima.AdsLoader) throw new De(2, 10, 1e4);
                            this.i && this.i.release(), this.i = new Bl(t, n, this.j, function(e) {
                                if (e && e.type) switch(e.type){
                                    case "ads-loaded":
                                        r.h.h.push(e.loadTime);
                                        break;
                                    case "ad-started":
                                        r.h.g++;
                                        break;
                                    case "ad-complete":
                                        r.h.i++;
                                        break;
                                    case "ad-skipped":
                                        r.h.j++;
                                }
                                r.dispatchEvent(e);
                            });
                        }, r.release = function() {
                            this.i && (this.i.release(), this.i = null), this.g && (this.g.release(), this.g = null), vr.prototype.release.call(this);
                        }, r.onAssetUnload = function() {
                            this.i && this.i.stop(), this.g && this.g.stop(), this.dispatchEvent(new gr("ad-stopped")), this.h = new Ul;
                        }, r.requestClientSideAds = function(e) {
                            if (!this.i) throw new De(1, 10, 10001);
                            var t = this.i;
                            t.u = Date.now() / 1e3, t.m.requestAds(e);
                        }, r.initServerSide = function(t, n) {
                            var r = this;
                            if (!e.google || !google.ima || !google.ima.dai) throw new De(2, 10, 10002);
                            this.g && this.g.release(), this.g = new Yl(t, n, this.j, function(e) {
                                if (e && e.type) switch(e.type){
                                    case "ads-loaded":
                                        r.h.h.push(e.loadTime);
                                        break;
                                    case "ad-started":
                                        r.h.g++;
                                        break;
                                    case "ad-complete":
                                        r.h.i++;
                                        break;
                                    case "ad-skipped":
                                        r.h.j++;
                                }
                                r.dispatchEvent(e);
                            });
                        }, r.requestServerSideStream = function(e, t) {
                            if (t = void 0 === t ? "" : t, !this.g) throw new De(1, 10, 10003);
                            e.adTagParameters || (e.adTagParameters = {});
                            var n = e.adTagParameters;
                            (n.mpt || n.mpv) && Y('You have attempted to set "mpt" and/or "mpv" parameters of the ad tag. Please note that those parameters are used for Shaka adoption tracking and will be overriden.'), e.adTagParameters.mpt = "shaka-player", e.adTagParameters.mpv = "v4.3.0";
                            var r = t;
                            return (n = this.g).j ? n = Promise.reject(new De(1, 10, 10004)) : (e instanceof google.ima.dai.api.LiveStreamRequest && (n.F = !0), n.j = new tt, n.g.requestStream(e), n.B = r || "", n.G = Date.now() / 1e3, n = n.j), n;
                        }, r.replaceServerSideAdTagParameters = function(e) {
                            if (!this.g) throw new De(1, 10, 10003);
                            (e.mpt || e.mpv) && Y('You have attempted to set "mpt" and/or "mpv" parameters of the ad tag. Please note that those parameters are used for Shaka adoption tracking and will be overriden.'), e.mpt = "Shaka Player", e.mpv = "v4.3.0", this.g.g.replaceAdTagParameters(e);
                        }, r.getServerSideCuePoints = function() {
                            if (!this.g) throw new De(1, 10, 10003);
                            return this.g.D;
                        }, r.getStats = function() {
                            var e = this.h;
                            return {
                                loadTimes: e.h,
                                started: e.g,
                                playedCompletely: e.i,
                                skipped: e.j
                            };
                        }, r.onDashTimedMetadata = function(e) {
                            if (this.g && "urn:google:dai:2018" == e.schemeIdUri) {
                                var t = e.schemeIdUri, n = e.eventElement ? e.eventElement.getAttribute("messageData") : null;
                                this.g.g.processMetadata(t, n, e.startTime);
                            }
                        }, r.onHlsTimedMetadata = function(e, t) {
                            this.g && this.g.g.processMetadata("ID3", e.data, t);
                        }, r.onCueMetadataChange = function(e) {
                            this.g && this.g.onCueMetadataChange(e);
                        }, B("shaka.ads.AdManager", Wl), Wl.prototype.onCueMetadataChange = Wl.prototype.onCueMetadataChange, Wl.prototype.onHlsTimedMetadata = Wl.prototype.onHlsTimedMetadata, Wl.prototype.onDashTimedMetadata = Wl.prototype.onDashTimedMetadata, Wl.prototype.getStats = Wl.prototype.getStats, Wl.prototype.getServerSideCuePoints = Wl.prototype.getServerSideCuePoints, Wl.prototype.replaceServerSideAdTagParameters = Wl.prototype.replaceServerSideAdTagParameters, Wl.prototype.requestServerSideStream = Wl.prototype.requestServerSideStream, Wl.prototype.initServerSide = Wl.prototype.initServerSide, Wl.prototype.requestClientSideAds = Wl.prototype.requestClientSideAds, Wl.prototype.onAssetUnload = Wl.prototype.onAssetUnload, Wl.prototype.release = Wl.prototype.release, Wl.prototype.initClientSide = Wl.prototype.initClientSide, Wl.prototype.setLocale = Wl.prototype.setLocale, Wl.ADS_LOADED = "ads-loaded", Wl.AD_STARTED = "ad-started", Wl.AD_FIRST_QUARTILE = "ad-first-quartile", Wl.AD_MIDPOINT = "ad-midpoint", Wl.AD_THIRD_QUARTILE = "ad-third-quartile", Wl.AD_COMPLETE = "ad-complete", Wl.AD_STOPPED = "ad-stopped", Wl.AD_SKIPPED = "ad-skipped", Wl.AD_VOLUME_CHANGED = "ad-volume-changed", Wl.AD_MUTED = "ad-muted", Wl.AD_PAUSED = "ad-paused", Wl.AD_RESUMED = "ad-resumed", Wl.AD_SKIP_STATE_CHANGED = "ad-skip-state-changed", Wl.CUEPOINTS_CHANGED = "ad-cue-points-changed", Wl.IMA_AD_MANAGER_LOADED = "ima-ad-manager-loaded", Wl.IMA_STREAM_MANAGER_LOADED = "ima-stream-manager-loaded", Wl.AD_CLICKED = "ad-clicked", Wl.AD_PROGRESS = "ad-progress", Wl.AD_BUFFERING = "ad-buffering", Wl.AD_IMPRESSION = "ad-impression", Wl.AD_DURATION_CHANGED = "ad-duration-changed", Wl.AD_CLOSED = "ad-closed", Wl.AD_LOADED = "ad-loaded", Wl.ALL_ADS_COMPLETED = "all-ads-completed", Wl.AD_LINEAR_CHANGED = "ad-linear-changed", Wl.AD_METADATA = "ad-metadata", Wl.AD_RECOVERABLE_ERROR = "ad-recoverable-error", Wl.AD_BREAK_READY = "ad-break-ready", Wl.AD_INTERACTION = "ad-interaction", Ol = function() {
                            return new Wl;
                        };
                        var Ql = "ended play playing pause pausing ratechange seeked seeking timeupdate volumechange".split(" "), Jl = "buffered currentTime duration ended loop muted paused playbackRate seeking videoHeight videoWidth volume".split(" "), Zl = [
                            "loop",
                            "playbackRate"
                        ], $l = [
                            "pause",
                            "play"
                        ], ec = {
                            getAssetUri: 2,
                            getAudioLanguages: 4,
                            getAudioLanguagesAndRoles: 4,
                            getBufferFullness: 1,
                            getBufferedInfo: 2,
                            getExpiration: 2,
                            getKeyStatuses: 2,
                            getPlaybackRate: 2,
                            getTextLanguages: 4,
                            getTextLanguagesAndRoles: 4,
                            getImageTracks: 2,
                            getThumbnails: 2,
                            isAudioOnly: 10,
                            isBuffering: 1,
                            isInProgress: 1,
                            isLive: 10,
                            isTextTrackVisible: 1,
                            keySystem: 10,
                            seekRange: 1,
                            getLoadMode: 10
                        }, tc = {
                            getConfiguration: 4,
                            getStats: 5,
                            getTextTracks: 2,
                            getVariantTracks: 2
                        }, nc = {
                            getPlayheadTimeAsDate: 1,
                            getPresentationStartTimeAsDate: 20
                        }, rc = [
                            [
                                "getConfiguration",
                                "configure"
                            ]
                        ], ic = [
                            [
                                "isTextTrackVisible",
                                "setTextTrackVisibility"
                            ]
                        ], ac = "addChaptersTrack addTextTrackAsync addThumbnailsTrack cancelTrickPlay configure getChapters getChaptersTracks resetConfiguration retryStreaming selectAudioLanguage selectTextLanguage selectTextTrack selectVariantTrack selectVariantsByLabel setTextTrackVisibility trickPlay updateStartTime goToLive".split(" "), oc = [
                            "attach",
                            "attachCanvas",
                            "detach",
                            "load",
                            "unload"
                        ];
                        function sc(e, t, n, r, i, a1, o) {
                            var s1 = this;
                            this.G = e, this.N = o, this.j = new it(t), this.P = n, this.u = !1, this.s = r, this.F = i, this.K = a1, this.h = this.m = !1, this.M = "", this.o = null, this.B = function() {
                                return fc(s1);
                            }, this.D = function(e, t) {
                                var n = Xl(t);
                                switch(n.type){
                                    case "event":
                                        var r = n.targetName;
                                        n = pr(n.event), s1.s(r, n);
                                        break;
                                    case "update":
                                        for(var i in r = n.update)for(var a1 in n = s1.g[i] || {}, r[i])n[a1] = r[i][a1];
                                        s1.u && (s1.P(), s1.u = !1);
                                        break;
                                    case "asyncComplete":
                                        if (i = n.id, n = n.error, a1 = s1.i[i], delete s1.i[i], a1) {
                                            if (n) {
                                                for(r in i = new De(n.severity, n.category, n.code), n)i[r] = n[r];
                                                a1.reject(i);
                                            } else a1.resolve();
                                        }
                                }
                            }, this.g = {
                                video: {},
                                player: {}
                            }, this.H = 0, this.i = {}, this.l = null, Ec.add(this);
                        }
                        function uc(e, t, n) {
                            vc = n, n.addUpdateListener(e.B), n.addMessageListener("urn:x-cast:com.google.shaka.v2", e.D), fc(e), gc(e, {
                                type: "init",
                                initState: t,
                                appData: e.o
                            }), e.l.resolve();
                        }
                        function lc(e, t) {
                            var n = 8003;
                            switch(t.code){
                                case "cancel":
                                    n = 8004;
                                    break;
                                case "timeout":
                                    n = 8005;
                                    break;
                                case "receiver_unavailable":
                                    n = 8006;
                            }
                            e.l.reject(new De(2, 8, n, t));
                        }
                        function cc(e, t) {
                            var n = e.K();
                            e.l = new tt, e.u = !0, uc(e, n, t);
                        }
                        function dc(e) {
                            var t = vc;
                            t.removeUpdateListener(e.B), t.removeMessageListener("urn:x-cast:com.google.shaka.v2", e.D);
                        }
                        function fc(e) {
                            var t = !!vc && "connected" == vc.status;
                            if (e.h && !t) {
                                for(var n in e.F(), e.g)e.g[n] = {};
                                hc(e);
                            }
                            e.h = t, e.M = t ? vc.receiver.friendlyName : "", e.j.Lb();
                        }
                        function hc(e) {
                            for(var t in e.i){
                                var n = e.i[t];
                                delete e.i[t], n.reject(new De(1, 7, 7e3));
                            }
                        }
                        function gc(e, t) {
                            var n = zl(t), r = vc;
                            try {
                                r.sendMessage("urn:x-cast:com.google.shaka.v2", n, function() {}, z);
                            } catch (t) {
                                throw n = new De(2, 8, 8005, t), r = new gr("error", (new Map).set("detail", n)), e.s("player", r), e.zb(), n;
                            }
                        }
                        (r = sc.prototype).destroy = function() {
                            return Ec.delete(this), hc(this), vc && dc(this), this.j && (this.j.stop(), this.j = null), this.F = this.s = null, this.h = this.m = !1, this.D = this.B = this.l = this.i = this.g = this.o = null, Promise.resolve();
                        }, r.ra = function() {
                            return this.h;
                        }, r.$d = function() {
                            return this.M;
                        }, r.init = function() {
                            if (this.G.length) {
                                if (e.chrome && chrome.cast && chrome.cast.isAvailable) {
                                    this.m = !0, this.j.Lb();
                                    var t = new chrome.cast.SessionRequest(this.G, [], null, this.N, null);
                                    t = new chrome.cast.ApiConfig(t, function(e) {
                                        for(var t = l(Ec), n = t.next(); !n.done; n = t.next())cc(n.value, e);
                                    }, function(e) {
                                        for(var t = l(Ec), n = t.next(); !n.done; n = t.next())n = n.value, mc = "available" == e, n.j.Lb();
                                    }, "origin_scoped"), chrome.cast.initialize(t, function() {}, function() {}), mc && this.j.O(pc), (t = vc) && t.status != chrome.cast.SessionStatus.STOPPED ? cc(this, t) : vc = null;
                                } else e.__onGCastApiAvailable !== Tc && (yc = e.__onGCastApiAvailable || null, e.__onGCastApiAvailable = Tc);
                            }
                        }, r.he = function(e) {
                            this.o = e, this.h && gc(this, {
                                type: "appData",
                                appData: this.o
                            });
                        }, r.cast = function(e) {
                            var t = this;
                            return L(function(n) {
                                if (!t.m) throw new De(1, 8, 8e3);
                                if (!mc) throw new De(1, 8, 8001);
                                if (t.h) throw new De(1, 8, 8002);
                                return t.l = new tt, chrome.cast.requestSession(function(n) {
                                    return uc(t, e, n);
                                }, function(e) {
                                    return lc(t, e);
                                }), T(n, t.l, 0);
                            });
                        }, r.zb = function() {
                            if (this.h) {
                                if (hc(this), vc) {
                                    dc(this);
                                    try {
                                        vc.stop(function() {}, function() {});
                                    } catch (e) {}
                                    vc = null;
                                }
                                fc(this);
                            }
                        }, r.get = function(e, t) {
                            var n = this;
                            if ("video" == e) {
                                if ($l.includes(t)) return function() {
                                    return n.Pe.apply(n, [
                                        e,
                                        t
                                    ].concat(c(x.apply(0, arguments))));
                                };
                            } else if ("player" == e) {
                                if (nc[t] && !this.get("player", "isLive")()) return function() {};
                                if (ac.includes(t)) return function() {
                                    return n.Pe.apply(n, [
                                        e,
                                        t
                                    ].concat(c(x.apply(0, arguments))));
                                };
                                if (oc.includes(t)) return function() {
                                    return n.ng.apply(n, [
                                        e,
                                        t
                                    ].concat(c(x.apply(0, arguments))));
                                };
                                if (ec[t] || tc[t]) return function() {
                                    return n.g[e][t];
                                };
                            }
                            return this.g[e][t];
                        }, r.set = function(e, t, n) {
                            this.g[e][t] = n, gc(this, {
                                type: "set",
                                targetName: e,
                                property: t,
                                value: n
                            });
                        }, r.Pe = function(e, t) {
                            gc(this, {
                                type: "call",
                                targetName: e,
                                methodName: t,
                                args: x.apply(2, arguments)
                            });
                        }, r.ng = function(e, t) {
                            var n = x.apply(2, arguments), r = new tt, i = this.H.toString();
                            this.H++, this.i[i] = r;
                            try {
                                gc(this, {
                                    type: "asyncCall",
                                    targetName: e,
                                    methodName: t,
                                    args: n,
                                    id: i
                                });
                            } catch (e) {
                                r.reject(e);
                            }
                            return r;
                        };
                        var pc = .02, mc = !1, vc = null, yc = null, Ec = new Set;
                        function Tc(t) {
                            if (yc ? e.__onGCastApiAvailable = yc : delete e.__onGCastApiAvailable, yc = null, t) for(var n = l(Ec), r = n.next(); !r.done; r = n.next())r.value.init();
                            "function" == typeof e.__onGCastApiAvailable && e.__onGCastApiAvailable(t);
                        }
                        function bc(e, t, n, r) {
                            r = void 0 !== r && r, vr.call(this);
                            var i = this;
                            this.i = e, this.h = t, this.m = this.o = this.j = this.s = this.l = null, this.D = n, this.B = r, this.u = new Map, this.g = new sc(n, function() {
                                return Sc(i);
                            }, function() {
                                return wc(i);
                            }, function(e, t) {
                                return Cc(i, e, t);
                            }, function() {
                                return Ic(i);
                            }, function() {
                                return _c(i);
                            }, r), function(e) {
                                e.g.init(), e.m = new xr;
                                for(var t = l(Ql), n = t.next(); !n.done; n = t.next())e.m.C(e.i, n.value, function(t) {
                                    e.g.ra() || (t = pr(t), e.j.dispatchEvent(t));
                                });
                                for(var r in mr)e.m.C(e.h, mr[r], function(t) {
                                    e.g.ra() || e.o.dispatchEvent(t);
                                });
                                for(var i in e.l = {}, t = {}, e.i)t.Rb = i, Object.defineProperty(e.l, t.Rb, {
                                    configurable: !1,
                                    enumerable: !0,
                                    get: function(t) {
                                        return function() {
                                            return Rc(e, t.Rb);
                                        };
                                    }(t),
                                    set: function(t) {
                                        return function(n) {
                                            var r = t.Rb;
                                            e.g.ra() ? e.g.set("video", r, n) : e.i[r] = n;
                                        };
                                    }(t)
                                }), t = {
                                    Rb: t.Rb
                                };
                                e.s = {}, Ac(e, function(t) {
                                    Object.defineProperty(e.s, t, {
                                        configurable: !1,
                                        enumerable: !0,
                                        get: function() {
                                            return function(e, t) {
                                                if (e.u.has(t) && (t = e.u.get(t)), "addEventListener" == t) return function(t, n, r) {
                                                    return e.o.addEventListener(t, n, r);
                                                };
                                                if ("removeEventListener" == t) return function(t, n, r) {
                                                    return e.o.removeEventListener(t, n, r);
                                                };
                                                if ("getMediaElement" == t) return function() {
                                                    return e.l;
                                                };
                                                if ("getSharedConfiguration" == t) return e.g.get("player", "getConfiguration");
                                                if ("getNetworkingEngine" == t) return function() {
                                                    return e.h.ic();
                                                };
                                                if ("getDrmEngine" == t) return function() {
                                                    return e.h.m;
                                                };
                                                if ("getAdManager" == t) return function() {
                                                    return e.h.Ee();
                                                };
                                                if ("setVideoContainer" == t) return function(t) {
                                                    return e.h.Ze(t);
                                                };
                                                if (e.g.ra()) {
                                                    if ("getManifest" == t || "drmInfo" == t) return function() {
                                                        return Y(t + "() does not work while casting!"), null;
                                                    };
                                                    if ("attach" == t || "detach" == t) return function() {
                                                        return Y(t + "() does not work while casting!"), Promise.resolve();
                                                    };
                                                }
                                                return e.g.ra() && 0 == Object.keys(e.g.g.video).length && (ec[t] || tc[t]) || !e.g.ra() ? e.h[t].bind(e.h) : e.g.get("player", t);
                                            }(e, t);
                                        }
                                    });
                                }), function(e) {
                                    var t = new Map;
                                    Ac(e, function(n, r) {
                                        if (t.has(r)) {
                                            var i = t.get(r);
                                            n.length < i.length ? e.u.set(n, i) : e.u.set(i, n);
                                        } else t.set(r, n);
                                    });
                                }(e), e.j = new vr, e.j.Vc = e.l, e.o = new vr, e.o.Vc = e.s;
                            }(this);
                        }
                        function Ac(e, t) {
                            function n(e) {
                                return "constructor" != e && "function" == typeof r[e] && !i.has(e);
                            }
                            var r = e.h, i = new Set;
                            for(a1 in r)n(a1) && (i.add(a1), t(a1, r[a1]));
                            for(var a1 = Object.getPrototypeOf(r), o = Object.getPrototypeOf({}); a1 && a1 != o;){
                                for(var s1 = l(Object.getOwnPropertyNames(a1)), u = s1.next(); !u.done; u = s1.next())n(u = u.value) && (i.add(u), t(u, r[u]));
                                a1 = Object.getPrototypeOf(a1);
                            }
                        }
                        function _c(e) {
                            var t = {
                                video: {},
                                player: {},
                                playerAfterLoad: {},
                                manifest: e.h.Ed(),
                                startTime: null
                            };
                            e.i.pause();
                            for(var n = l(Zl), r = n.next(); !r.done; r = n.next())r = r.value, t.video[r] = e.i[r];
                            for(e.i.ended || (t.startTime = e.i.currentTime), r = (n = l(rc)).next(); !r.done; r = n.next()){
                                var i = r.value;
                                r = i[1], i = e.h[i[0]](), t.player[r] = i;
                            }
                            for(r = (n = l(ic)).next(); !r.done; r = n.next())r = (i = r.value)[1], i = e.h[i[0]](), t.playerAfterLoad[r] = i;
                            return t;
                        }
                        function Sc(e) {
                            var t = new gr("caststatuschanged");
                            e.dispatchEvent(t);
                        }
                        function wc(e) {
                            var t = new gr(e.l.paused ? "pause" : "play");
                            e.j.dispatchEvent(t);
                        }
                        function Ic(e) {
                            for(var t = l(rc), n = t.next(); !n.done; n = t.next()){
                                var r = n.value;
                                n = r[1], r = e.g.get("player", r[0])(), e.h[n](r);
                            }
                            var i = e.g.get("player", "getAssetUri")();
                            n = e.g.get("video", "ended"), t = Promise.resolve();
                            var a1 = e.i.autoplay;
                            r = null, n || (r = e.g.get("video", "currentTime")), i && (e.i.autoplay = !1, t = e.h.load(i, r));
                            var o = {};
                            for(r = (n = l(Zl)).next(); !r.done; r = n.next())r = r.value, o[r] = e.g.get("video", r);
                            t.then(function() {
                                if (e.i) {
                                    for(var t = l(Zl), n = t.next(); !n.done; n = t.next())n = n.value, e.i[n] = o[n];
                                    for(n = (t = l(ic)).next(); !n.done; n = t.next()){
                                        var r = n.value;
                                        n = r[1], r = e.g.get("player", r[0])(), e.h[n](r);
                                    }
                                    e.i.autoplay = a1, i && e.i.play();
                                }
                            }, function(t) {
                                t = new gr("error", t = (new Map).set("detail", t)), e.h.dispatchEvent(t);
                            });
                        }
                        function Rc(e, t) {
                            if ("addEventListener" == t) return function(t, n, r) {
                                return e.j.addEventListener(t, n, r);
                            };
                            if ("removeEventListener" == t) return function(t, n, r) {
                                return e.j.removeEventListener(t, n, r);
                            };
                            if (e.g.ra() && 0 == Object.keys(e.g.g.video).length) {
                                var n = e.i[t];
                                if ("function" != typeof n) return n;
                            }
                            return e.g.ra() ? e.g.get("video", t) : ("function" == typeof (n = e.i[t]) && (n = n.bind(e.i)), n);
                        }
                        function Cc(e, t, n) {
                            e.g.ra() && ("video" == t ? e.j.dispatchEvent(n) : "player" == t && e.o.dispatchEvent(n));
                        }
                        function Dc(e, t, n, r) {
                            vr.call(this);
                            var i = this;
                            this.g = e, this.h = t, this.j = new xr, this.H = {
                                video: e,
                                player: t
                            }, this.D = n || function() {}, this.K = r || function(e) {
                                return e;
                            }, this.i = null, this.F = !1, this.o = !0, this.m = 0, this.B = !1, this.u = !0, this.s = this.l = null, this.G = new it(function() {
                                xc(i);
                            }), function(e) {
                                var t = cast.receiver.CastReceiverManager.getInstance();
                                t.onSenderConnected = function() {
                                    return kc(e);
                                }, t.onSenderDisconnected = function() {
                                    return kc(e);
                                }, t.onSystemVolumeChanged = function() {
                                    var t = cast.receiver.CastReceiverManager.getInstance().getSystemVolume();
                                    t && Fc(e, {
                                        type: "update",
                                        update: {
                                            video: {
                                                volume: t.level,
                                                muted: t.muted
                                            }
                                        }
                                    }, e.l), Fc(e, {
                                        type: "event",
                                        targetName: "video",
                                        event: {
                                            type: "volumechange"
                                        }
                                    }, e.l);
                                }, e.s = t.getCastMessageBus("urn:x-cast:com.google.cast.media"), e.s.onMessage = function(t) {
                                    return function(e, t) {
                                        var n = Xl(t.data);
                                        switch(n.type){
                                            case "PLAY":
                                                e.g.play(), Uc(e);
                                                break;
                                            case "PAUSE":
                                                e.g.pause(), Uc(e);
                                                break;
                                            case "SEEK":
                                                var r = n.currentTime, i = n.resumeState;
                                                null != r && (e.g.currentTime = Number(r)), i && "PLAYBACK_START" == i ? (e.g.play(), Uc(e)) : i && "PLAYBACK_PAUSE" == i && (e.g.pause(), Uc(e));
                                                break;
                                            case "STOP":
                                                e.h.pe().then(function() {
                                                    e.h && Uc(e);
                                                });
                                                break;
                                            case "GET_STATUS":
                                                Oc(e, Number(n.requestId));
                                                break;
                                            case "VOLUME":
                                                r = (i = n.volume).level, i = i.muted;
                                                var a1 = e.g.volume, o = e.g.muted;
                                                null != r && (e.g.volume = Number(r)), null != i && (e.g.muted = i), a1 == e.g.volume && o == e.g.muted || Uc(e);
                                                break;
                                            case "LOAD":
                                                e.m = 0, e.B = !1, e.u = !1, r = n.media, i = n.currentTime, a1 = e.K(r.contentId), o = n.autoplay || !0, e.D(r.customData), o && (e.g.autoplay = !0), e.h.load(a1, i).then(function() {
                                                    e.h && Oc(e);
                                                }).catch(function(t) {
                                                    var r = "LOAD_FAILED";
                                                    7 == t.category && 7e3 == t.code && (r = "LOAD_CANCELLED"), Fc(e, {
                                                        requestId: Number(n.requestId),
                                                        type: r
                                                    }, e.s);
                                                });
                                                break;
                                            default:
                                                Fc(e, {
                                                    requestId: Number(n.requestId),
                                                    type: "INVALID_REQUEST",
                                                    reason: "INVALID_COMMAND"
                                                }, e.s);
                                        }
                                    }(e, t);
                                }, e.l = t.getCastMessageBus("urn:x-cast:com.google.shaka.v2"), e.l.onMessage = function(t) {
                                    return function(e, t) {
                                        var n = Xl(t.data);
                                        switch(n.type){
                                            case "init":
                                                e.m = 0, e.B = !1, e.u = !0, function(e, t, n) {
                                                    var r, i, a1, o, s1, u, l, c, d, f;
                                                    L(function(h) {
                                                        switch(h.g){
                                                            case 1:
                                                                for(r in t.player)i = t.player[r], e.h[r](i);
                                                                return e.D(n), a1 = e.g.autoplay, t.manifest ? (e.g.autoplay = !1, A(h, 5), T(h, e.h.load(t.manifest, t.startTime), 7)) : T(h, Promise.resolve(), 3);
                                                            case 7:
                                                                S(h, 3);
                                                                break;
                                                            case 5:
                                                                return o = w(h), s1 = (new Map).set("detail", o), u = new gr("error", s1), e.h && e.h.dispatchEvent(u), h.return();
                                                            case 3:
                                                                if (!e.h) return h.return();
                                                                for(l in t.video)c = t.video[l], e.g[l] = c;
                                                                for(d in t.playerAfterLoad)f = t.playerAfterLoad[d], e.h[d](f);
                                                                e.g.autoplay = a1, t.manifest && (e.g.play(), Uc(e)), b(h);
                                                        }
                                                    });
                                                }(e, n.initState, n.appData), xc(e);
                                                break;
                                            case "appData":
                                                e.D(n.appData);
                                                break;
                                            case "set":
                                                var r = n.targetName, i = n.property;
                                                if (n = n.value, "video" == r) {
                                                    var a1 = cast.receiver.CastReceiverManager.getInstance();
                                                    if ("volume" == i) {
                                                        a1.setSystemVolumeLevel(n);
                                                        break;
                                                    }
                                                    if ("muted" == i) {
                                                        a1.setSystemVolumeMuted(n);
                                                        break;
                                                    }
                                                }
                                                e.H[r][i] = n;
                                                break;
                                            case "call":
                                                (r = e.H[n.targetName])[n.methodName].apply(r, n.args);
                                                break;
                                            case "asyncCall":
                                                r = n.targetName, i = n.methodName, "player" == r && "load" == i && (e.m = 0, e.B = !1);
                                                var o = n.id, s1 = t.senderId;
                                                n = (a1 = e.H[r])[i].apply(a1, n.args), "player" == r && "load" == i && (n = n.then(function() {
                                                    e.u = !0;
                                                })), n.then(function() {
                                                    return Pc(e, s1, o, null);
                                                }, function(t) {
                                                    return Pc(e, s1, o, t);
                                                });
                                        }
                                    }(e, t);
                                }, t.start();
                                for(var n = (t = l(Ql)).next(); !n.done; n = t.next())e.j.C(e.g, n.value, function(t) {
                                    return Lc(e, "video", t);
                                });
                                for(var r in mr)e.j.C(e.h, mr[r], function(t) {
                                    return Lc(e, "player", t);
                                });
                                cast.__platform__ && cast.__platform__.canDisplayType('video/mp4; codecs="avc1.640028"; width=3840; height=2160') ? e.h.je(3840, 2160) : e.h.je(1920, 1080), e.j.C(e.g, "loadeddata", function() {
                                    e.B = !0;
                                }), e.j.C(e.h, "loading", function() {
                                    e.o = !1, Nc(e);
                                }), e.j.C(e.g, "playing", function() {
                                    e.o = !1, Nc(e);
                                }), e.j.C(e.g, "pause", function() {
                                    Nc(e);
                                }), e.j.C(e.h, "unloading", function() {
                                    e.o = !0, Nc(e);
                                }), e.j.C(e.g, "ended", function() {
                                    new it(function() {
                                        e.g && e.g.ended && (e.o = !0, Nc(e));
                                    }).O(Bc);
                                });
                            }(this);
                        }
                        function kc(e) {
                            e.m = 0, e.u = !0, e.F = 0 != cast.receiver.CastReceiverManager.getInstance().getSenders().length, Nc(e);
                        }
                        function Nc(e) {
                            var t;
                            L(function(n) {
                                return 1 == n.g ? T(n, Promise.resolve(), 2) : e.h ? (t = new gr("caststatuschanged"), e.dispatchEvent(t), Mc(e) || Uc(e), void b(n)) : n.return();
                            });
                        }
                        function Lc(e, t, n) {
                            e.h && (xc(e), Fc(e, {
                                type: "event",
                                targetName: t,
                                event: n
                            }, e.l));
                        }
                        function xc(e) {
                            e.G.O(jc);
                            for(var t = {
                                video: {},
                                player: {}
                            }, n = l(Jl), r = n.next(); !r.done; r = n.next())r = r.value, t.video[r] = e.g[r];
                            if (e.h.U()) for(var i in nc)0 == e.m % nc[i] && (t.player[i] = e.h[i]());
                            for(var a1 in ec)0 == e.m % ec[a1] && (t.player[a1] = e.h[a1]());
                            for(var o in (n = cast.receiver.CastReceiverManager.getInstance().getSystemVolume()) && (t.video.volume = n.level, t.video.muted = n.muted), Fc(e, {
                                type: "update",
                                update: t
                            }, e.l), tc)0 == e.m % tc[o] && ((t = {
                                player: {}
                            }).player[o] = e.h[o](), Fc(e, {
                                type: "update",
                                update: t
                            }, e.l));
                            e.B && (e.m += 1), Mc(e);
                        }
                        function Mc(e) {
                            return !(!e.u || !e.g.duration && !e.h.U() || (Oc(e), e.u = !1, 0));
                        }
                        function Oc(e, t) {
                            var n = {
                                contentId: e.h.Ed(),
                                streamType: e.h.U() ? "LIVE" : "BUFFERED",
                                contentType: ""
                            };
                            e.h.U() || (n.duration = e.g.duration), e.i && (n.metadata = e.i), Uc(e, void 0 === t ? 0 : t, n);
                        }
                        function Pc(e, t, n, r) {
                            e.h && Fc(e, {
                                type: "asyncComplete",
                                id: n,
                                error: r
                            }, e.l, t);
                        }
                        function Fc(e, t, n, r) {
                            e.F && (e = zl(t), r ? n.getCastChannel(r).send(e) : n.broadcast(e));
                        }
                        function Uc(e, t, n) {
                            n = void 0 === n ? null : n;
                            var r = {
                                mediaSessionId: 0,
                                playbackRate: e.g.playbackRate,
                                playerState: e.o ? Gc : e.h.Gd() ? Vc : e.g.paused ? Kc : Hc,
                                currentTime: e.g.currentTime,
                                supportedMediaCommands: 63,
                                volume: {
                                    level: e.g.volume,
                                    muted: e.g.muted
                                }
                            };
                            n && (r.media = n), Fc(e, {
                                requestId: void 0 === t ? 0 : t,
                                type: "MEDIA_STATUS",
                                status: [
                                    r
                                ]
                            }, e.s);
                        }
                        m(bc, vr), (r = bc.prototype).destroy = function(e) {
                            return e && this.g.zb(), this.m && (this.m.release(), this.m = null), e = [], this.h && (e.push(this.h.destroy()), this.h = null), this.g && (e.push(this.g.destroy()), this.g = null), this.s = this.l = this.i = null, vr.prototype.release.call(this), Promise.all(e);
                        }, r.Vf = function() {
                            return this.l;
                        }, r.Mf = function() {
                            return this.s;
                        }, r.mf = function() {
                            return this.g.m && mc;
                        }, r.ra = function() {
                            return this.g.ra();
                        }, r.$d = function() {
                            return this.g.$d();
                        }, r.cast = function() {
                            var e, t = this;
                            return L(function(n) {
                                return 1 == n.g ? (e = _c(t), T(n, t.g.cast(e), 2)) : t.h ? T(n, t.h.pe(), 0) : n.return();
                            });
                        }, r.he = function(e) {
                            this.g.he(e);
                        }, r.yg = function() {
                            !function(e) {
                                if (e.h) {
                                    var t = e.K();
                                    chrome.cast.requestSession(function(n) {
                                        return uc(e, t, n);
                                    }, function(t) {
                                        return lc(e, t);
                                    });
                                }
                            }(this.g);
                        }, r.zb = function() {
                            this.g.zb();
                        }, r.pf = function(e, t) {
                            t = void 0 !== t && t;
                            var n = this;
                            return L(function(r) {
                                if (1 == r.g) return e == n.D && t == n.B ? r.return() : (n.D = e, n.B = t, n.g.zb(), T(r, n.g.destroy(), 2));
                                n.g = null, n.g = new sc(e, function() {
                                    return Sc(n);
                                }, function() {
                                    return wc(n);
                                }, function(e, t) {
                                    return Cc(n, e, t);
                                }, function() {
                                    return Ic(n);
                                }, function() {
                                    return _c(n);
                                }, t), n.g.init(), b(r);
                            });
                        }, B("shaka.cast.CastProxy", bc), bc.prototype.changeReceiverId = bc.prototype.pf, bc.prototype.forceDisconnect = bc.prototype.zb, bc.prototype.suggestDisconnect = bc.prototype.yg, bc.prototype.setAppData = bc.prototype.he, bc.prototype.cast = bc.prototype.cast, bc.prototype.receiverName = bc.prototype.$d, bc.prototype.isCasting = bc.prototype.ra, bc.prototype.canCast = bc.prototype.mf, bc.prototype.getPlayer = bc.prototype.Mf, bc.prototype.getVideo = bc.prototype.Vf, bc.prototype.destroy = bc.prototype.destroy, m(Dc, vr), (r = Dc.prototype).isConnected = function() {
                            return this.F;
                        }, r.Zf = function() {
                            return this.o;
                        }, r.vg = function(e) {
                            this.i = e;
                        }, r.tf = function() {
                            this.i = null;
                        }, r.wg = function(e) {
                            this.i || (this.i = {
                                metadataType: cast.receiver.media.MetadataType.GENERIC
                            }), this.i.title = e;
                        }, r.ug = function(e) {
                            this.i || (this.i = {
                                metadataType: cast.receiver.media.MetadataType.GENERIC
                            }), this.i.images = [
                                {
                                    url: e
                                }
                            ];
                        }, r.tg = function(e) {
                            this.i || (this.i = {}), this.i.artist = e, this.i.metadataType = cast.receiver.media.MetadataType.MUSIC_TRACK;
                        }, r.destroy = function() {
                            var e, t = this;
                            return L(function(n) {
                                if (1 == n.g) return t.j && (t.j.release(), t.j = null), e = [], t.h && (e.push(t.h.destroy()), t.h = null), t.G && (t.G.stop(), t.G = null), t.g = null, t.H = null, t.D = null, t.F = !1, t.o = !0, t.l = null, t.s = null, vr.prototype.release.call(t), T(n, Promise.all(e), 2);
                                cast.receiver.CastReceiverManager.getInstance().stop(), b(n);
                            });
                        }, B("shaka.cast.CastReceiver", Dc), Dc.prototype.destroy = Dc.prototype.destroy, Dc.prototype.setContentArtist = Dc.prototype.tg, Dc.prototype.setContentImage = Dc.prototype.ug, Dc.prototype.setContentTitle = Dc.prototype.wg, Dc.prototype.clearContentMetadata = Dc.prototype.tf, Dc.prototype.setContentMetadata = Dc.prototype.vg, Dc.prototype.isIdle = Dc.prototype.Zf, Dc.prototype.isConnected = Dc.prototype.isConnected;
                        var jc = .5, Bc = 5, Gc = "IDLE", Hc = "PLAYING", Vc = "BUFFERING", Kc = "PAUSED";
                        function qc(e, t, n) {
                            var r = function(e) {
                                for(var t = [], n = (e = l(e)).next(); !n.done; n = e.next())(n = Wc(n.value)) && t.push(n);
                                return t;
                            }(e), i = null;
                            e = [];
                            var a1 = [], o = new Set(r.map(function(e) {
                                return e.keyId;
                            }));
                            if (o.delete(null), 1 < o.size) throw new De(2, 4, 4010);
                            if (t || (a1 = r.filter(function(e) {
                                return "urn:mpeg:dash:mp4protection:2011" != e.ee || (i = e.init || i, !1);
                            })).length && (e = function(e, t, n, r) {
                                for(var i = [], a1 = (t = l(t)).next(); !a1.done; a1 = t.next()){
                                    var o = n[(a1 = a1.value).ee];
                                    if (o) {
                                        var s1;
                                        if (s1 = ti(a1.node, "urn:microsoft:playready", "pro")) {
                                            s1 = Rt(s1.textContent);
                                            var u = new Uint8Array([
                                                154,
                                                4,
                                                240,
                                                121,
                                                152,
                                                64,
                                                66,
                                                134,
                                                171,
                                                146,
                                                230,
                                                91,
                                                224,
                                                136,
                                                95,
                                                149
                                            ]);
                                            s1 = [
                                                {
                                                    initData: $r(s1, u, new Set, 0),
                                                    initDataType: "cenc",
                                                    keyId: a1.keyId
                                                }
                                            ];
                                        } else s1 = null;
                                        if (u = null, "urn:uuid:e2719d58-a985-b3c9-781a-b030af78d30e" === a1.ee) {
                                            if (0 == (u = r).size) u = null;
                                            else {
                                                var c = new Uint8Array([
                                                    16,
                                                    119,
                                                    239,
                                                    236,
                                                    192,
                                                    178,
                                                    77,
                                                    2,
                                                    172,
                                                    227,
                                                    60,
                                                    30,
                                                    82,
                                                    226,
                                                    251,
                                                    75
                                                ]);
                                                u = [
                                                    {
                                                        initData: $r(new Uint8Array([]), c, u, 1),
                                                        initDataType: "cenc",
                                                        keyId: a1.keyId
                                                    }
                                                ];
                                            }
                                        }
                                        s1 = Xe(o, a1.init || e || s1 || u), (o = Xc.get(o)) && (s1.licenseServerUri = o(a1)), i.push(s1);
                                    }
                                }
                                return i;
                            }(i, a1, n, o), 0 == e.length && (e = [
                                Xe("", i)
                            ])), r.length && (t || !a1.length)) for(e = [], n = (t = l(Object.values(n))).next(); !n.done; n = t.next())"org.w3.clearkey" != (n = n.value) && e.push(Xe(n, i));
                            if (o = Array.from(o)[0] || null) for(n = (t = l(e)).next(); !n.done; n = t.next())for(r = (n = l(n.value.initData)).next(); !r.done; r = n.next())r.value.keyId = o;
                            return {
                                ze: o,
                                th: i,
                                drmInfos: e,
                                De: !0
                            };
                        }
                        function Yc(e) {
                            return (e = ti(e.node, "urn:microsoft:playready", "pro")) && (e = (function(e) {
                                var t = 0, n = Re(e), r = n.getUint32(t, !0);
                                if (r != e.byteLength) return [];
                                e: {
                                    for(e = t + 6, t = []; e < n.byteLength - 1;){
                                        r = n.getUint16(e, !0), e += 2;
                                        var i = n.getUint16(e, !0);
                                        if (e += 2, 0 != (1 & i) || i + e > n.byteLength) {
                                            n = [];
                                            break e;
                                        }
                                        var a1 = Ie(n, e, i);
                                        t.push({
                                            type: r,
                                            value: a1
                                        }), e += i;
                                    }
                                    n = t;
                                }
                                return n;
                            })(e = Rt(e.textContent)).filter(function(e) {
                                return e.type === zc;
                            })[0]) && (e = vi(e = Et(e.value, !0), "WRMHEADER")) ? function(e) {
                                for(var t = (e = l(e.getElementsByTagName("DATA"))).next(); !t.done; t = e.next())for(var n = (t = l(t.value.childNodes)).next(); !n.done; n = t.next())if ((n = n.value) instanceof Element && "LA_URL" == n.tagName) return n.textContent;
                                return "";
                            }(e) : "";
                        }
                        function Wc(e) {
                            var t = e.getAttribute("schemeIdUri"), n = ii(e, "urn:mpeg:cenc:2013", "default_KID"), r = ri(e, "urn:mpeg:cenc:2013", "pssh").map(oi);
                            if (!t) return null;
                            if (t = t.toLowerCase(), n && (n = n.replace(/-/g, "").toLowerCase()).includes(" ")) throw new De(2, 4, 4009);
                            var i = [];
                            try {
                                i = r.map(function(e) {
                                    return {
                                        initDataType: "cenc",
                                        initData: Rt(e),
                                        keyId: null
                                    };
                                });
                            } catch (e) {
                                throw new De(2, 4, 4007);
                            }
                            return {
                                node: e,
                                ee: t,
                                keyId: n,
                                init: 0 < i.length ? i : null
                            };
                        }
                        var zc = 1, Xc = (new Map).set("com.widevine.alpha", function(e) {
                            return (e = ti(e.node, "urn:microsoft", "laurl")) && e.getAttribute("licenseUrl") || "";
                        }).set("com.microsoft.playready", Yc).set("com.microsoft.playready.recommendation", Yc).set("com.microsoft.playready.software", Yc).set("com.microsoft.playready.hardware", Yc).set("org.w3.clearkey", function(e) {
                            return (e = ti(e.node, "http://dashif.org/guidelines/clearKey", "Laurl")) && "EME-1.0" === e.getAttribute("Lic_type") && e.textContent ? e.textContent : "";
                        });
                        function Qc(t, n, r, i, a1) {
                            var o = {
                                RepresentationID: n,
                                Number: r,
                                Bandwidth: i,
                                Time: a1
                            };
                            return t.replace(/\$(RepresentationID|Number|Bandwidth|Time)?(?:%0([0-9]+)([diouxX]))?\$/g, function(t, n, r, i) {
                                if ("$$" == t) return "$";
                                var a1 = o[n];
                                if (null == a1) return t;
                                switch("RepresentationID" == n && r && (r = void 0), "Time" == n && (a1 = Math.round(a1)), i){
                                    case void 0:
                                    case "d":
                                    case "i":
                                    case "u":
                                        t = a1.toString();
                                        break;
                                    case "o":
                                        t = a1.toString(8);
                                        break;
                                    case "x":
                                        t = a1.toString(16);
                                        break;
                                    case "X":
                                        t = a1.toString(16).toUpperCase();
                                        break;
                                    default:
                                        t = a1.toString();
                                }
                                return r = e.parseInt(r, 10) || 1, Array(Math.max(0, r - t.length) + 1).join("0") + t;
                            });
                        }
                        function Jc(e, t) {
                            var n = Zc(e, t, "timescale"), r = 1;
                            n && (r = hi(n) || 1);
                            var i = Zc(e, t, "duration");
                            n = hi(i || ""), "image" == e.I.contentType && (n = pi(i || "")), n && (n /= r);
                            var a1 = Zc(e, t, "startNumber");
                            i = Number(Zc(e, t, "presentationTimeOffset")) || 0;
                            var o = gi(a1 || "");
                            null != a1 && null != o || (o = 1);
                            var s1 = $c(e, t, "SegmentTimeline");
                            if (a1 = null, s1) {
                                a1 = r;
                                var u = e.V.duration || 1 / 0;
                                s1 = ni(s1, "S");
                                for(var l = [], c = -i, d = 0; d < s1.length; ++d){
                                    var f = s1[d], h = s1[d + 1], g = ui(f, "t", gi), p = ui(f, "d", gi);
                                    if (f = ui(f, "r", fi), null != g && (g -= i), !p) break;
                                    if (g = null != g ? g : c, 0 > (f = f || 0)) {
                                        if (h) {
                                            if (null == (h = ui(h, "t", gi))) break;
                                            if (g >= h) break;
                                            f = Math.ceil((h - g) / p) - 1;
                                        } else {
                                            if (1 / 0 == u) break;
                                            if (g / a1 >= u) break;
                                            f = Math.ceil((u * a1 - g) / p) - 1;
                                        }
                                    }
                                    for(0 < l.length && g != c && (l[l.length - 1].end = g / a1), h = 0; h <= f; ++h)c = g + p, l.push({
                                        start: g / a1,
                                        end: c / a1,
                                        Cg: g
                                    }), g = c;
                                }
                                a1 = l;
                            }
                            return {
                                timescale: r,
                                ga: n,
                                Kb: o,
                                Sa: i / r || 0,
                                qe: i,
                                timeline: a1
                            };
                        }
                        function Zc(e, t, n) {
                            return [
                                t(e.I),
                                t(e.ia),
                                t(e.aa)
                            ].filter(We).map(function(e) {
                                return e.getAttribute(n);
                            }).reduce(function(e, t) {
                                return e || t;
                            });
                        }
                        function $c(e, t, n) {
                            return [
                                t(e.I),
                                t(e.ia),
                                t(e.aa)
                            ].filter(We).map(function(e) {
                                return ei(e, n);
                            }).reduce(function(e, t) {
                                return e || t;
                            });
                        }
                        function ed(e, t, n, r, i, a1) {
                            if (a1 = void 0 === a1 ? 0 : a1, ii(e, "http://www.w3.org/1999/xlink", "href")) {
                                var o = function(e, t, n, r, i, a1) {
                                    for(var o = ii(e, "http://www.w3.org/1999/xlink", "href"), s1 = ii(e, "http://www.w3.org/1999/xlink", "actuate") || "onRequest", u = l(Array.from(e.attributes)), c = u.next(); !c.done; c = u.next())"http://www.w3.org/1999/xlink" == (c = c.value).namespaceURI && e.removeAttributeNS(c.namespaceURI, c.localName);
                                    if (5 <= a1) return lr(new De(2, 4, 4028));
                                    if ("onLoad" != s1) return lr(new De(2, 4, 4027));
                                    var d = ze([
                                        r
                                    ], [
                                        o
                                    ]);
                                    return i.request(0, Sr(d, t)).Y(function(r) {
                                        if (!(r = yi(r.data, e.tagName))) return lr(new De(2, 4, 4001, o));
                                        for(; e.childNodes.length;)e.removeChild(e.childNodes[0]);
                                        for(; r.childNodes.length;){
                                            var s1 = r.childNodes[0];
                                            r.removeChild(s1), e.appendChild(s1);
                                        }
                                        for(s1 = (r = l(Array.from(r.attributes))).next(); !s1.done; s1 = r.next())e.setAttributeNode(s1.value.cloneNode(!1));
                                        return ed(e, t, n, d[0], i, a1 + 1);
                                    });
                                }(e, t, n, r, i, a1);
                                return n && (o = o.Y(void 0, function() {
                                    return ed(e, t, n, r, i, a1);
                                })), o;
                            }
                            o = [];
                            for(var s1 = l(Array.from(e.childNodes)), u = s1.next(); !u.done; u = s1.next())(u = u.value) instanceof Element && ("urn:mpeg:dash:resolve-to-zero:2013" == ii(u, "http://www.w3.org/1999/xlink", "href") ? e.removeChild(u) : "SegmentTimeline" != u.tagName && o.push(ed(u, t, n, r, i, a1)));
                            return hr(o).Y(function() {
                                return e;
                            });
                        }
                        function td(e) {
                            this.h = Re(e), this.g = new Br(this.h, 0);
                        }
                        function nd(e) {
                            var t = rd(e);
                            if (7 < t.length) throw new De(2, 3, 3002);
                            for(var n = 0, r = (t = l(t)).next(); !r.done; r = t.next())n = 256 * n + r.value;
                            t = rd(e);
                            e: {
                                for(var i = (r = l(id)).next(); !i.done; i = r.next())if (_e(t, new Uint8Array(i.value))) {
                                    r = !0;
                                    break e;
                                }
                                r = !1;
                            }
                            if (r) t = e.h.byteLength - e.g.$();
                            else {
                                if (8 == t.length && 224 & t[1]) throw new De(2, 3, 3001);
                                for(i = r = 0; i < t.length; i++){
                                    var a1 = t[i];
                                    r = 0 == i ? a1 & (1 << 8 - t.length) - 1 : 256 * r + a1;
                                }
                                t = r;
                            }
                            return t = e.g.$() + t <= e.h.byteLength ? t : e.h.byteLength - e.g.$(), r = Re(e.h, e.g.$(), t), e.g.skip(t), new ad(n, r);
                        }
                        function rd(e) {
                            var t = e.g.$(), n = e.g.Ra();
                            if (0 == n) throw new De(2, 3, 3002);
                            return n = 8 - Math.floor(Math.log2(n)), e.g.skip(n - 1), Ie(e.h, t, n);
                        }
                        td.prototype.la = function() {
                            return this.g.la();
                        };
                        var id = [
                            [
                                255
                            ],
                            [
                                127,
                                255
                            ],
                            [
                                63,
                                255,
                                255
                            ],
                            [
                                31,
                                255,
                                255,
                                255
                            ],
                            [
                                15,
                                255,
                                255,
                                255,
                                255
                            ],
                            [
                                7,
                                255,
                                255,
                                255,
                                255,
                                255
                            ],
                            [
                                3,
                                255,
                                255,
                                255,
                                255,
                                255,
                                255
                            ],
                            [
                                1,
                                255,
                                255,
                                255,
                                255,
                                255,
                                255,
                                255
                            ]
                        ];
                        function ad(e, t) {
                            this.id = e, this.g = t;
                        }
                        function od(e) {
                            if (8 < e.g.byteLength) throw new De(2, 3, 3002);
                            if (8 == e.g.byteLength && 224 & e.g.getUint8(0)) throw new De(2, 3, 3001);
                            for(var t = 0, n = 0; n < e.g.byteLength; n++)t = 256 * t + e.g.getUint8(n);
                            return t;
                        }
                        function sd(e) {
                            var t = new td(e.g);
                            if (179 != (e = nd(t)).id) throw new De(2, 3, 3013);
                            if (e = od(e), 183 != (t = nd(t)).id) throw new De(2, 3, 3012);
                            t = new td(t.g);
                            for(var n = 0; t.la();){
                                var r = nd(t);
                                if (241 == r.id) {
                                    n = od(r);
                                    break;
                                }
                            }
                            return {
                                Dg: e,
                                mg: n
                            };
                        }
                        function ud(e, t) {
                            var n = $c(e, t, "Initialization");
                            if (!n) return null;
                            var r = e.I.va, i = n.getAttribute("sourceURL");
                            i && (r = ze(e.I.va, [
                                i
                            ])), i = 0;
                            var a1 = null;
                            return (n = ui(n, "range", di)) && (i = n.start, a1 = n.end), new uo(function() {
                                return r;
                            }, i, a1, hd(e));
                        }
                        function ld(e, t, n, r, i, a1, o) {
                            var s1, u, l, c, d, f, h, g, p, m, v, y, E, b, A;
                            return L(function(_) {
                                if (1 == _.g) return s1 = e.presentationTimeline, u = !e.Xa || !e.V.Ke, l = e.V.start, c = e.V.duration, d = e.I.mimeType.split("/")[1], h = null, g = [
                                    (f = t)(r, i, a1),
                                    "webm" == d ? f(n.xa(), n.Aa, n.ka) : null
                                ], f = null, T(_, Promise.all(g), 2);
                                if (p = _.h, m = p[0], v = p[1] || null, E = l - o, b = l, A = c ? l + c : 1 / 0, "mp4" == d) var S = function(e, t, n, r, i, a1, o) {
                                    var s1, u = (new Vr).T("sidx", function(e) {
                                        s1 = function(e, t, n, r, i, a1, o) {
                                            var s1 = [];
                                            o.reader.skip(4);
                                            var u = o.reader.L();
                                            if (0 == u) throw new De(2, 3, 3005);
                                            if (0 == o.version) var l = o.reader.L(), c = o.reader.L();
                                            else l = o.reader.ab(), c = o.reader.ab();
                                            o.reader.skip(2);
                                            var d = o.reader.Zd();
                                            for(e = e + o.size + c, c = 0; c < d; c++){
                                                var f = o.reader.L(), h = (2147483648 & f) >>> 31;
                                                f &= 2147483647;
                                                var g = o.reader.L();
                                                if (o.reader.skip(4), 1 == h) throw new De(2, 3, 3006);
                                                s1.push(new lo(l / u + n, (l + g) / u + n, function() {
                                                    return a1;
                                                }, e, e + f - 1, t, n, r, i)), l += g, e += f;
                                            }
                                            return o.parser.stop(), s1;
                                        }(t, r, i, a1, o, n, e);
                                    });
                                    if (e && u.parse(e), s1) return s1;
                                    throw new De(2, 3, 3004);
                                }(m, i, r, n, E, b, A);
                                else {
                                    if (440786851 != nd(S = new td(v)).id) throw new De(2, 3, 3008);
                                    var w = nd(S);
                                    if (408125543 != w.id) throw new De(2, 3, 3009);
                                    S = w.g.byteOffset, w = new td(w.g);
                                    for(var I = null; w.la();){
                                        var R = nd(w);
                                        if (357149030 == R.id) {
                                            I = R;
                                            break;
                                        }
                                    }
                                    if (!I) throw new De(2, 3, 3010);
                                    for(I = new td(I.g), R = 1e6, w = null; I.la();){
                                        var C = nd(I);
                                        if (2807729 == C.id) R = od(C);
                                        else if (17545 == C.id) {
                                            if (4 == C.g.byteLength) w = C.g.getFloat32(0);
                                            else {
                                                if (8 != C.g.byteLength) throw new De(2, 3, 3003);
                                                w = C.g.getFloat64(0);
                                            }
                                        }
                                    }
                                    if (null == w) throw new De(2, 3, 3011);
                                    if (w *= I = R / 1e9, 475249515 != (R = nd(new td(m))).id) throw new De(2, 3, 3007);
                                    S = function(e, t, n, r, i, a1, o, s1, u) {
                                        function l() {
                                            return i;
                                        }
                                        var c = [];
                                        e = new td(e.g);
                                        for(var d = null, f = null; e.la();){
                                            var h = nd(e);
                                            if (187 == h.id) {
                                                var g = sd(h);
                                                g && (h = n * g.Dg, g = t + g.mg, null != d && c.push(new lo(d + o, h + o, l, f, g - 1, a1, o, s1, u)), d = h, f = g);
                                            }
                                        }
                                        return null != d && c.push(new lo(d + o, r + o, l, f, null, a1, o, s1, u)), c;
                                    }(R, S, I, w, r, n, E, b, A);
                                }
                                return y = S, s1.Hb(y), h = new ps(y), u && h.Ya(b, A, !0), _.return(h);
                            });
                        }
                        function cd(e) {
                            return e.vc;
                        }
                        function dd(e) {
                            var t = $c(e, cd, "RepresentationIndex");
                            return e = di((e = Zc(e, cd, "indexRange")) || ""), t && (e = ui(t, "range", di, e)), e;
                        }
                        function fd(e, t) {
                            var n = e.I.mimeType.split("/")[1];
                            if (e.I.contentType != Ze && "mp4" != n && "webm" != n) throw new De(2, 4, 4006);
                            if ("webm" == n && !t) throw new De(2, 4, 4005);
                        }
                        function hd(e) {
                            var t = e.I;
                            return {
                                bandwidth: e.bandwidth,
                                audioSamplingRate: t.audioSamplingRate,
                                codecs: t.codecs,
                                contentType: t.contentType,
                                frameRate: t.frameRate || null,
                                height: t.height || null,
                                mimeType: t.mimeType,
                                channelsCount: t.ad,
                                pixelAspectRatio: t.pixelAspectRatio || null,
                                width: t.width || null
                            };
                        }
                        function gd(e) {
                            return e.bb;
                        }
                        function pd(e) {
                            return e.wc;
                        }
                        function md() {
                            this.l = [], this.g = [], this.h = [], this.j = [], this.i = [], this.m = new Set;
                        }
                        function vd(e) {
                            var t, n, r, i, a1, o, s1, u, c, d, f, h, g, p, m, v, y, E, b, A, _, S, w, I;
                            return L(function(R) {
                                switch(R.g){
                                    case 1:
                                        if (t = $e, 1 == e.length) return R.return(e[0]);
                                        for(n = e.map(function(e) {
                                            return e.filter(function(e) {
                                                return e.type == t.Gc;
                                            });
                                        }), r = e.map(function(e) {
                                            return e.filter(function(e) {
                                                return e.type == t.ua;
                                            });
                                        }), i = e.map(function(e) {
                                            return e.filter(function(e) {
                                                return e.type == t.Z;
                                            });
                                        }), a1 = e.map(function(e) {
                                            return e.filter(function(e) {
                                                return e.type == t.Vb;
                                            });
                                        }), o = l(i), s1 = o.next(); !s1.done; s1 = o.next())s1.value.push(Md(t.Z));
                                        for(u = l(a1), c = u.next(); !c.done; c = u.next())c.value.push(Md(t.Vb));
                                        return T(R, yd([], n, 0, _d, wd), 2);
                                    case 2:
                                        return d = R.h, T(R, yd([], r, 0, _d, wd), 3);
                                    case 3:
                                        return f = R.h, T(R, yd([], i, 0, _d, wd), 4);
                                    case 4:
                                        return h = R.h, T(R, yd([], a1, 0, _d, wd), 5);
                                    case 5:
                                        if (g = R.h, p = 0, f.length && d.length) for(E = l(d), b = E.next(); !b.done; b = E.next())for(A = b.value, _ = l(f), S = _.next(); !S.done; S = _.next())w = S.value, I = p++, w.variantIds.push(I), A.variantIds.push(I);
                                        else for(m = f.concat(d), v = l(m), y = v.next(); !y.done; y = v.next())y.value.variantIds = [
                                            p++
                                        ];
                                        return R.return(f.concat(d).concat(h).concat(g));
                                }
                            });
                        }
                        function yd(e, t, n, r, i) {
                            var a1, o, s1, u, c, d, f, h, g, p, m, v, y, E, b, A, _, S;
                            return L(function(w) {
                                switch(w.g){
                                    case 1:
                                        for(a1 = $e, o = [], s1 = 0; s1 < t.length; s1++)s1 >= n ? o.push(new Set(t[s1])) : o.push(new Set);
                                        u = l(e), c = u.next();
                                    case 2:
                                        if (c.done) {
                                            w.A(4);
                                            break;
                                        }
                                        return T(w, function(e, t, n, r, i) {
                                            return L(function(a1) {
                                                return 1 == a1.g ? (Id(t, e), e.matchedStreams ? e.segmentIndex ? T(a1, Ed(e, n), 2) : a1.A(2) : a1.return(!1)) : (bd(e, n, r, i), a1.return(!0));
                                            });
                                        }(c.value, t, n, i, o), 5);
                                    case 5:
                                        if (!w.h) throw new De(2, 4, 4037);
                                        c = u.next(), w.A(2);
                                        break;
                                    case 4:
                                        for(d = l(o), f = d.next(); !f.done; f = d.next())for(h = f.value, g = l(h), p = g.next(); !p.done; p = g.next())m = p.value, (v = Td(m, t, r, i, o)) && e.push(v);
                                        for(y = l(o), f = y.next(); !f.done; f = y.next())for(E = f.value, b = {}, A = l(E), p = A.next(); !p.done; b = {
                                            Wa: b.Wa
                                        }, p = A.next())if (b.Wa = p.value, _ = b.Wa.type == a1.Z && !b.Wa.language, S = b.Wa.type == a1.Vb && !b.Wa.tilesLayout, !_ && !S && e.some(function(e) {
                                            return function(t) {
                                                return t.mimeType == e.Wa.mimeType && Ht(t.codecs) == Ht(e.Wa.codecs);
                                            };
                                        }(b))) throw new De(2, 4, 4037);
                                        return w.return(e);
                                }
                            });
                        }
                        function Ed(e, t) {
                            var n, r, i, a1, o, s1, u;
                            return L(function(c) {
                                if (1 == c.g) {
                                    for(n = [], r = e.matchedStreams, i = l(r), a1 = i.next(); !a1.done; a1 = i.next())o = a1.value, n.push(o.createSegmentIndex()), o.trickModeVideo && !o.trickModeVideo.segmentIndex && n.push(o.trickModeVideo.createSegmentIndex());
                                    return T(c, Promise.all(n), 2);
                                }
                                if (e.segmentIndex instanceof Es) for(s1 = 0; s1 < r.length; s1++)(u = r[s1]).segmentIndex && s1 >= t && e.segmentIndex.l.push(u.segmentIndex);
                                b(c);
                            });
                        }
                        function Td(e, t, n, r, i) {
                            var a1 = n(e);
                            return Id(t, a1), a1.createSegmentIndex && (a1.createSegmentIndex = function() {
                                return L(function(e) {
                                    return a1.segmentIndex ? e.A(0) : (a1.segmentIndex = new Es, T(e, Ed(a1, 0), 0));
                                });
                            }), a1.matchedStreams ? (bd(a1, 0, r, i), a1) : null;
                        }
                        function bd(e, t, n, r) {
                            for(var i = e.matchedStreams, a1 = 0; a1 < i.length; a1++)if (a1 >= t) {
                                var o = i[a1];
                                n(e, o);
                                var s1 = !0;
                                "audio" == e.type && 0 == nn(e.language, o.language) && (s1 = !1), s1 && r[a1].delete(o);
                            }
                        }
                        function Ad(e) {
                            var t = Object.assign({}, e);
                            return t.originalId = null, t.createSegmentIndex = function() {
                                return Promise.resolve();
                            }, t.closeSegmentIndex = function() {
                                if (t.segmentIndex && (t.segmentIndex.release(), t.segmentIndex = null), t.matchedStreams) for(var e = l(t.matchedStreams), n = e.next(); !n.done; n = e.next())(n = n.value).segmentIndex && (n.segmentIndex.release(), n.segmentIndex = null);
                            }, t.segmentIndex = null, t.emsgSchemeIdUris = [], t.keyIds = new Set, t.closedCaptions = null, t.trickModeVideo = null, t;
                        }
                        function _d(e) {
                            return (e = Object.assign({}, e)).keyIds = new Set, e.segments = [], e.variantIds = [], e.closedCaptions = null, e;
                        }
                        function Sd(e, t) {
                            var n, r;
                            e.roles = Array.from(new Set(e.roles.concat(t.roles))), t.emsgSchemeIdUris && (e.emsgSchemeIdUris = Array.from(new Set(e.emsgSchemeIdUris.concat(t.emsgSchemeIdUris)))), e.keyIds = (n = e.keyIds, r = t.keyIds, new Set([].concat(c(n), c(r)))), null == e.originalId ? e.originalId = t.originalId : e.originalId += "," + (t.originalId || "");
                            var i = Mi(e.drmInfos, t.drmInfos);
                            if (t.drmInfos.length && e.drmInfos.length && !i.length) throw new De(2, 4, 4038);
                            if (e.drmInfos = i, e.encrypted = e.encrypted || t.encrypted, t.closedCaptions) {
                                e.closedCaptions || (e.closedCaptions = new Map);
                                for(var a1 = (i = l(t.closedCaptions)).next(); !a1.done; a1 = i.next()){
                                    var o = l(a1.value);
                                    a1 = o.next().value, o = o.next().value, e.closedCaptions.set(a1, o);
                                }
                            }
                            t.trickModeVideo ? (e.trickModeVideo || (e.trickModeVideo = Ad(t.trickModeVideo), e.trickModeVideo.createSegmentIndex = function() {
                                return e.trickModeVideo.segmentIndex = e.segmentIndex.clone(), Promise.resolve();
                            }), Sd(e.trickModeVideo, t.trickModeVideo)) : e.trickModeVideo && Sd(e.trickModeVideo, t);
                        }
                        function wd(e, t) {
                            e.roles = Array.from(new Set(e.roles.concat(t.roles)));
                            var n = t.keyIds;
                            if (n = new Set([].concat(c(e.keyIds), c(n))), e.keyIds = n, e.encrypted = e.encrypted && t.encrypted, e.segments.push.apply(e.segments, c(t.segments)), t.closedCaptions) {
                                e.closedCaptions || (e.closedCaptions = new Map);
                                for(var r = (n = l(t.closedCaptions)).next(); !r.done; r = n.next()){
                                    var i = l(r.value);
                                    r = i.next().value, i = i.next().value, e.closedCaptions.set(r, i);
                                }
                            }
                        }
                        function Id(e, t) {
                            for(var n = [], r = l(e), i = r.next(); !i.done; i = r.next()){
                                for(var a1 = t, o = {
                                    audio: Rd,
                                    video: Rd,
                                    text: Cd,
                                    image: Dd
                                }[a1.type], s1 = {
                                    audio: kd,
                                    video: Nd,
                                    text: Ld,
                                    image: xd
                                }[a1.type], u = null, c = (i = l(i.value)).next(); !c.done; c = i.next())!o(a1, c = c.value) || u && !s1(a1, u, c) || (u = c);
                                if (!(a1 = u)) return;
                                n.push(a1);
                            }
                            t.matchedStreams = n;
                        }
                        function Rd(e, t) {
                            var n;
                            if (!(n = t.mimeType != e.mimeType || Ht(t.codecs) != Ht(e.codecs)) && (n = e.drmInfos)) {
                                n = e.drmInfos;
                                var r = t.drmInfos;
                                n = !(!n.length || !r.length || 0 < Mi(n, r).length);
                            }
                            return !n;
                        }
                        function Cd(e, t) {
                            return !!e.language && (!t.language || 0 != nn(e.language, t.language) && t.kind == e.kind);
                        }
                        function Dd(e) {
                            return !!e.tilesLayout;
                        }
                        function kd(e, t, n) {
                            if (e.id == n.id) return !0;
                            var r = nn(e.language, t.language), i = nn(e.language, n.language);
                            return i > r || !(i < r) && (e.roles.length ? (r = t.roles.filter(function(t) {
                                return e.roles.includes(t);
                            }), (i = n.roles.filter(function(t) {
                                return e.roles.includes(t);
                            })).length > r.length || !(i.length < r.length) && n.roles.length < t.roles.length) : !((n.roles.length || !t.roles.length) && (n.roles.length && !t.roles.length || (t.primary || !n.primary) && (t.primary && !n.primary || (r = Pd(e.channelsCount, t.channelsCount, n.channelsCount)) != Ud && (r == Bd || (r = Pd(e.audioSamplingRate, t.audioSamplingRate, n.audioSamplingRate)) != Ud && (r == Bd || !e.bandwidth || Fd(e.bandwidth, t.bandwidth, n.bandwidth) != Ud))))));
                        }
                        function Nd(e, t, n) {
                            if (e.id == n.id) return !0;
                            var r = Pd(e.width * e.height, t.width * t.height, n.width * n.height);
                            if (r == Ud) return !0;
                            if (r == Bd) return !1;
                            if (e.frameRate) {
                                if ((r = Pd(e.frameRate, t.frameRate, n.frameRate)) == Ud) return !0;
                                if (r == Bd) return !1;
                            }
                            return !(!e.bandwidth || Fd(e.bandwidth, t.bandwidth, n.bandwidth) != Ud);
                        }
                        function Ld(e, t, n) {
                            if (e.id == n.id) return !0;
                            var r = nn(e.language, t.language), i = nn(e.language, n.language);
                            if (i > r) return !0;
                            if (i < r) return !1;
                            if (!t.primary && n.primary) return !0;
                            if (t.primary && !n.primary) return !1;
                            if (e.roles.length) {
                                if (r = t.roles.filter(function(t) {
                                    return e.roles.includes(t);
                                }), (i = n.roles.filter(function(t) {
                                    return e.roles.includes(t);
                                })).length > r.length) return !0;
                                if (i.length < r.length) return !1;
                            } else {
                                if (!n.roles.length && t.roles.length) return !0;
                                if (n.roles.length && !t.roles.length) return !1;
                            }
                            return n.mimeType == e.mimeType && n.codecs == e.codecs && (t.mimeType != e.mimeType || t.codecs != e.codecs);
                        }
                        function xd(e, t, n) {
                            return e.id == n.id || Pd(e.width * e.height, t.width * t.height, n.width * n.height) == Ud;
                        }
                        function Md(e) {
                            return {
                                id: 0,
                                originalId: "",
                                primary: !1,
                                type: e,
                                mimeType: "",
                                codecs: "",
                                language: "",
                                label: null,
                                width: null,
                                height: null,
                                encrypted: !1,
                                keyIds: new Set,
                                segments: [],
                                variantIds: [],
                                roles: [],
                                forced: !1,
                                channelsCount: null,
                                audioSamplingRate: null,
                                spatialAudio: !1,
                                closedCaptions: null
                            };
                        }
                        function Od(e) {
                            return {
                                id: 0,
                                originalId: "",
                                createSegmentIndex: function() {
                                    return Promise.resolve();
                                },
                                segmentIndex: new ps([]),
                                mimeType: "",
                                codecs: "",
                                encrypted: !1,
                                drmInfos: [],
                                keyIds: new Set,
                                language: "",
                                label: null,
                                type: e,
                                primary: !1,
                                trickModeVideo: null,
                                emsgSchemeIdUris: null,
                                roles: [],
                                forced: !1,
                                channelsCount: null,
                                audioSamplingRate: null,
                                spatialAudio: !1,
                                closedCaptions: null
                            };
                        }
                        function Pd(e, t, n) {
                            if (t == e && e != n) return Bd;
                            if (n == e && e != t) return Ud;
                            if (t > e) {
                                if (n <= e || n - e < t - e) return Ud;
                                if (n - e > t - e) return Bd;
                            } else {
                                if (n > e) return Bd;
                                if (e - n < e - t) return Ud;
                                if (e - n > e - t) return Bd;
                            }
                            return jd;
                        }
                        function Fd(e, t, n) {
                            return t = Math.abs(e - t), (e = Math.abs(e - n)) < t ? Ud : t < e ? Bd : jd;
                        }
                        md.prototype.release = function() {
                            for(var e = l(this.g.concat(this.h, this.j, this.i)), t = e.next(); !t.done; t = e.next())(t = t.value).segmentIndex && t.segmentIndex.release();
                            this.g = [], this.h = [], this.j = [], this.i = [], this.l = [];
                        };
                        var Ud = 1, jd = 0, Bd = -1;
                        function Gd() {
                            var e = this;
                            this.h = this.g = null, this.m = [], this.i = null, this.G = 1, this.l = {}, this.M = {}, this.j = new md, this.F = 0, this.H = new G(5), this.D = new it(function() {
                                !function(e) {
                                    var t, n;
                                    L(function(r) {
                                        switch(r.g){
                                            case 1:
                                                return t = 0, A(r, 2), T(r, Hd(e), 4);
                                            case 4:
                                                t = r.h, S(r, 3);
                                                break;
                                            case 2:
                                                n = w(r), e.h && (n.severity = 1, e.h.onError(n));
                                            case 3:
                                                if (!e.h) return r.return();
                                                Yd(e, t), b(r);
                                        }
                                    });
                                }(e);
                            }), this.o = new Tr, this.s = null, this.K = [], this.u = 1 / 0, this.B = !1;
                        }
                        function Hd(e) {
                            var t, n, r, i, a1, o, s1;
                            return L(function(u) {
                                return 1 == u.g ? (t = Sr(e.m, e.g.retryParameters), n = e.h.networkingEngine, e.h.modifyManifestRequest(t, {
                                    format: "d"
                                }), r = Date.now(), i = n.request(0, t), br(e.o, i), T(u, i.promise, 2)) : 3 != u.g ? (a1 = u.h, e.h ? (a1.uri && !e.m.includes(a1.uri) && e.m.unshift(a1.uri), T(u, function(e, t, n) {
                                    var r, i, a1, o;
                                    return L(function(s1) {
                                        if (1 == s1.g) {
                                            if (!(r = yi(t, "MPD"))) throw new De(2, 4, 4001, n);
                                            return e.g.dash.disableXlinkProcessing ? s1.return(Vd(e, r, n)) : (i = e.g.dash.xlinkFailGracefully, a1 = ed(r, e.g.retryParameters, i, n, e.h.networkingEngine), br(e.o, a1), T(s1, a1.promise, 2));
                                        }
                                        return o = s1.h, s1.return(Vd(e, o, n));
                                    });
                                }(e, a1.data, a1.uri), 3)) : u.return(0)) : (o = Date.now(), s1 = (o - r) / 1e3, e.H.sample(1, s1), u.return(s1));
                            });
                        }
                        function Vd(e, t, n) {
                            var r, i, a1, o, s1, u, c, d, f, h, g, p, m, v, y, E, _, I, R, C, D, k, N, x, M, O, P, F, U;
                            return L(function(j) {
                                switch(j.g){
                                    case 1:
                                        if ((r = e.g.dash.manifestPreprocessor) && r(t), i = [
                                            n
                                        ], 0 < (a1 = ni(t, "Location").map(oi).filter(We)).length && (o = ze(i, a1), i = e.m = o), s1 = ni(t, "BaseURL"), u = s1.map(oi), c = ze(i, u), d = 0, s1 && s1.length && (d = ui(s1[0], "availabilityTimeOffset", pi) || 0), f = e.g.dash.ignoreMinBufferTime, h = 0, f || (h = ui(t, "minBufferTime", ci) || 0), e.F = ui(t, "minimumUpdatePeriod", ci, -1), g = ui(t, "availabilityStartTime", li), p = ui(t, "timeShiftBufferDepth", ci), m = e.g.dash.ignoreSuggestedPresentationDelay, v = null, m || (v = ui(t, "suggestedPresentationDelay", ci)), y = e.g.dash.ignoreMaxSegmentDuration, E = null, y || (E = ui(t, "maxSegmentDuration", ci)), _ = t.getAttribute("type") || "static", e.i) for(I = e.i.presentationTimeline, R = l(Object.values(e.l)), C = R.next(); !C.done; C = R.next())(D = C.value).segmentIndex && D.segmentIndex.fb(I.Oa());
                                        else k = e.g.defaultPresentationDelay || 1.5 * h, I = new Xo(g, null != v ? v : k, e.g.dash.autoCorrectDrift);
                                        return I.xc("static" == _), I.U() && !isNaN(e.g.availabilityWindowOverride) && (p = e.g.availabilityWindowOverride), null == p && (p = 1 / 0), I.le(p), N = t.getAttribute("profiles") || "", x = {
                                            Xa: "static" != _,
                                            presentationTimeline: I,
                                            aa: null,
                                            V: null,
                                            ia: null,
                                            I: null,
                                            bandwidth: 0,
                                            Ie: !1,
                                            yb: d,
                                            profiles: N.split(",")
                                        }, M = function(e, t, n, r) {
                                            var i = ui(r, "mediaPresentationDuration", ci), a1 = [], o = 0;
                                            r = ni(r, "Period");
                                            for(var s1 = 0; s1 < r.length; s1++){
                                                var u = r[s1], l = r[s1 + 1], c = ui(u, "start", ci, o), d = u.id, f = ui(u, "duration", ci), h = null;
                                                if (l) {
                                                    var g = ui(l, "start", ci);
                                                    null != g && (h = g - c);
                                                } else null != i && (h = i - c);
                                                if (null == h && (h = f), !(null !== e.s && null !== d && null !== c && c < e.s) || e.K.includes(d) || s1 + 1 == r.length) {
                                                    if (null !== c && (null === e.s || c > e.s) && (e.s = c), o = Kd(e, t, n, {
                                                        start: c,
                                                        duration: h,
                                                        node: u,
                                                        Ke: null == h || !l
                                                    }), a1.push(o), t.aa.id && h && (e.M[t.aa.id] = h), null == h) {
                                                        o = null;
                                                        break;
                                                    }
                                                    o = c + h;
                                                }
                                            }
                                            return e.K = a1.map(function(e) {
                                                return e.id;
                                            }), null != i ? {
                                                periods: a1,
                                                duration: i,
                                                Be: !1
                                            } : {
                                                periods: a1,
                                                duration: o,
                                                Be: !0
                                            };
                                        }(e, x, c, t), O = M.duration, P = M.periods, "static" != _ && M.Be || I.Ia(O || 1 / 0), e.u && !e.B && e.h.isAutoLowLatencyMode() && (e.h.enableLowLatencyMode(), e.B = e.h.isLowLatencyMode()), e.B ? I.Te(e.u) : e.u && Y("Low-latency DASH live stream detected, but low-latency streaming mode is not enabled in Shaka Player. Set streaming.lowLatencyMode configuration to true, and see https://bit.ly/3clctcj for details."), I.Rd(E || 1), T(j, function(e, t, n) {
                                            var r, i, a1, o, s1, u, c, d, f, h, g, p, m, v, y, E, A, _, S, w, I, R, C, D, k, N, x, M;
                                            return L(function(L) {
                                                switch(L.g){
                                                    case 1:
                                                        if (r = $e, function(e) {
                                                            for(var t = (e = l(e)).next(); !t.done; t = e.next()){
                                                                for(var n = [], r = l((t = t.value).Jc), i = r.next(); !i.done; i = r.next()){
                                                                    i = i.value;
                                                                    for(var a1 = !1, o = l(n), s1 = o.next(); !s1.done; s1 = o.next())s1 = s1.value, i.id != s1.id && i.channelsCount == s1.channelsCount && i.language == s1.language && i.bandwidth == s1.bandwidth && i.label == s1.label && i.codecs == s1.codecs && i.mimeType == s1.mimeType && ee(i.roles, s1.roles) && i.audioSamplingRate == s1.audioSamplingRate && i.primary == s1.primary && (a1 = !0);
                                                                    a1 || n.push(i);
                                                                }
                                                                t.Jc = n;
                                                            }
                                                        }(t), function(e) {
                                                            for(var t = (e = l(e)).next(); !t.done; t = e.next()){
                                                                for(var n = [], r = l((t = t.value).hd), i = r.next(); !i.done; i = r.next()){
                                                                    i = i.value;
                                                                    for(var a1 = !1, o = l(n), s1 = o.next(); !s1.done; s1 = o.next())s1 = s1.value, i.id != s1.id && i.width == s1.width && i.frameRate == s1.frameRate && i.codecs == s1.codecs && i.mimeType == s1.mimeType && i.label == s1.label && ee(i.roles, s1.roles) && jr(i.closedCaptions, s1.closedCaptions) && i.bandwidth == s1.bandwidth && (a1 = !0);
                                                                    a1 || n.push(i);
                                                                }
                                                                t.hd = n;
                                                            }
                                                        }(t), function(e) {
                                                            for(var t = (e = l(e)).next(); !t.done; t = e.next()){
                                                                for(var n = [], r = l((t = t.value).textStreams), i = r.next(); !i.done; i = r.next()){
                                                                    i = i.value;
                                                                    for(var a1 = !1, o = l(n), s1 = o.next(); !s1.done; s1 = o.next())s1 = s1.value, i.id != s1.id && i.language == s1.language && i.label == s1.label && i.codecs == s1.codecs && i.mimeType == s1.mimeType && i.bandwidth == s1.bandwidth && ee(i.roles, s1.roles) && (a1 = !0);
                                                                    a1 || n.push(i);
                                                                }
                                                                t.textStreams = n;
                                                            }
                                                        }(t), function(e) {
                                                            for(var t = (e = l(e)).next(); !t.done; t = e.next()){
                                                                for(var n = [], r = l((t = t.value).imageStreams), i = r.next(); !i.done; i = r.next()){
                                                                    i = i.value;
                                                                    for(var a1 = !1, o = l(n), s1 = o.next(); !s1.done; s1 = o.next())s1 = s1.value, i.id != s1.id && i.width == s1.width && i.codecs == s1.codecs && i.mimeType == s1.mimeType && (a1 = !0);
                                                                    a1 || n.push(i);
                                                                }
                                                                t.imageStreams = n;
                                                            }
                                                        }(t), !n && 1 == t.length) {
                                                            i = t[0], e.g = i.Jc, e.h = i.hd, e.j = i.textStreams, e.i = i.imageStreams, L.A(2);
                                                            break;
                                                        }
                                                        for(a1 = -1, o = 0; o < t.length; o++)s1 = t[o], e.m.has(s1.id) || (e.m.add(s1.id), -1 == a1 && (a1 = o));
                                                        if (-1 == a1) return L.return();
                                                        for(u = t.map(function(e) {
                                                            return e.Jc;
                                                        }), c = t.map(function(e) {
                                                            return e.hd;
                                                        }), d = t.map(function(e) {
                                                            return e.textStreams;
                                                        }), f = t.map(function(e) {
                                                            return e.imageStreams;
                                                        }), h = l(d), g = h.next(); !g.done; g = h.next())g.value.push(Od(r.Z));
                                                        for(p = l(f), m = p.next(); !m.done; m = p.next())m.value.push(Od(r.Vb));
                                                        return T(L, yd(e.g, u, a1, Ad, Sd), 3);
                                                    case 3:
                                                        return T(L, yd(e.h, c, a1, Ad, Sd), 4);
                                                    case 4:
                                                        return T(L, yd(e.j, d, a1, Ad, Sd), 5);
                                                    case 5:
                                                        return T(L, yd(e.i, f, a1, Ad, Sd), 2);
                                                    case 2:
                                                        if (v = 0, y = [], e.h.length && e.g.length) for(I = l(e.g), R = I.next(); !R.done; R = I.next())for(C = R.value, D = l(e.h), k = D.next(); !k.done; k = D.next())N = k.value, x = Mi(C.drmInfos, N.drmInfos), C.drmInfos.length && N.drmInfos.length && !x.length || (M = v++, y.push({
                                                            id: M,
                                                            language: C.language,
                                                            primary: C.primary,
                                                            audio: C,
                                                            video: N,
                                                            bandwidth: (C.bandwidth || 0) + (N.bandwidth || 0),
                                                            drmInfos: x,
                                                            allowedByApplication: !0,
                                                            allowedByKeySystem: !0,
                                                            decodingInfos: []
                                                        }));
                                                        else for(E = e.h.concat(e.g), A = l(E), _ = A.next(); !_.done; _ = A.next())S = _.value, w = v++, y.push({
                                                            id: w,
                                                            language: S.language,
                                                            primary: S.primary,
                                                            audio: S.type == r.Gc ? S : null,
                                                            video: S.type == r.ua ? S : null,
                                                            bandwidth: S.bandwidth || 0,
                                                            drmInfos: S.drmInfos,
                                                            allowedByApplication: !0,
                                                            allowedByKeySystem: !0,
                                                            decodingInfos: []
                                                        });
                                                        e.l = y, b(L);
                                                }
                                            });
                                        }(e.j, P, x.Xa), 2);
                                    case 2:
                                        if (e.i) {
                                            e.i.variants = e.j.l, e.i.textStreams = e.j.j.slice(), e.i.imageStreams = e.j.i, e.h.filter(e.i), j.A(3);
                                            break;
                                        }
                                        if (e.i = {
                                            presentationTimeline: I,
                                            variants: e.j.l,
                                            textStreams: e.j.j.slice(),
                                            imageStreams: e.j.i,
                                            offlineSessionIds: [],
                                            minBufferTime: h || 0,
                                            sequenceMode: e.g.dash.sequenceMode
                                        }, !I.cf()) {
                                            j.A(4);
                                            break;
                                        }
                                        return F = ni(t, "UTCTiming"), T(j, function(e, t, n) {
                                            var r, i, a1, o, s1, u, c, d;
                                            return L(function(f) {
                                                switch(f.g){
                                                    case 1:
                                                        r = n.map(function(e) {
                                                            return {
                                                                scheme: e.getAttribute("schemeIdUri"),
                                                                value: e.getAttribute("value")
                                                            };
                                                        }), i = e.g.dash.clockSyncUri, !r.length && i && r.push({
                                                            scheme: "urn:mpeg:dash:utc:http-head:2014",
                                                            value: i
                                                        }), a1 = l(r), o = a1.next();
                                                    case 2:
                                                        if (o.done) {
                                                            f.A(4);
                                                            break;
                                                        }
                                                        switch(s1 = o.value, A(f, 5), u = s1.scheme, c = s1.value, u){
                                                            case "urn:mpeg:dash:utc:http-head:2014":
                                                            case "urn:mpeg:dash:utc:http-head:2012":
                                                                return f.A(7);
                                                            case "urn:mpeg:dash:utc:http-xsdate:2014":
                                                            case "urn:mpeg:dash:utc:http-iso:2014":
                                                            case "urn:mpeg:dash:utc:http-xsdate:2012":
                                                            case "urn:mpeg:dash:utc:http-iso:2012":
                                                                return f.A(8);
                                                            case "urn:mpeg:dash:utc:direct:2014":
                                                            case "urn:mpeg:dash:utc:direct:2012":
                                                                return d = Date.parse(c), f.return(isNaN(d) ? 0 : d - Date.now());
                                                            case "urn:mpeg:dash:utc:http-ntp:2014":
                                                            case "urn:mpeg:dash:utc:ntp:2014":
                                                            case "urn:mpeg:dash:utc:sntp:2014":
                                                                Y("NTP UTCTiming scheme is not supported");
                                                                break;
                                                            default:
                                                                Y("Unrecognized scheme in UTCTiming element", u);
                                                        }
                                                        f.A(9);
                                                        break;
                                                    case 7:
                                                        return T(f, zd(e, t, c, "HEAD"), 10);
                                                    case 10:
                                                        return f.return(f.h);
                                                    case 8:
                                                        return T(f, zd(e, t, c, "GET"), 11);
                                                    case 11:
                                                        return f.return(f.h);
                                                    case 9:
                                                        S(f, 3);
                                                        break;
                                                    case 5:
                                                        w(f);
                                                    case 3:
                                                        o = a1.next(), f.A(2);
                                                        break;
                                                    case 4:
                                                        return Y("A UTCTiming element should always be given in live manifests! This content may not play on clients with bad clocks!"), f.return(0);
                                                }
                                            });
                                        }(e, c, F), 5);
                                    case 5:
                                        if (U = j.h, !e.h) return j.return();
                                        I.Ue(U);
                                    case 4:
                                        I.Md();
                                    case 3:
                                        e.h.makeTextStreamsForClosedCaptions(e.i), b(j);
                                }
                            });
                        }
                        function Kd(e, t, n, r) {
                            t.aa = Wd(r.node, null, n), t.V = r, t.aa.yb = t.yb, t.aa.id || (t.aa.id = "__shaka_period_" + r.start);
                            var i = ni(r.node, "EventStream");
                            n = t.presentationTimeline.Oa();
                            for(var a1 = (i = l(i)).next(); !a1.done; a1 = i.next())Xd(e, r.start, r.duration, a1.value, n);
                            if (n = ni(r.node, "AdaptationSet").map(function(n) {
                                return function(e, t, n) {
                                    function r(e) {
                                        switch(e){
                                            case 1:
                                            case 6:
                                            case 13:
                                            case 14:
                                            case 15:
                                                return "SDR";
                                            case 16:
                                                return "PQ";
                                            case 18:
                                                return "HLG";
                                        }
                                    }
                                    t.ia = Wd(n, t.aa, null);
                                    var i, a1 = !1, o = ni(n, "Role"), s1 = o.map(function(e) {
                                        return e.getAttribute("value");
                                    }).filter(We), u = void 0, d = t.ia.contentType == Ze;
                                    d && (u = "subtitle");
                                    for(var f = (o = l(o)).next(); !f.done; f = o.next()){
                                        var h = (f = f.value).getAttribute("schemeIdUri");
                                        if (null == h || "urn:mpeg:dash:role:2011" == h) switch(f = f.getAttribute("value"), f){
                                            case "main":
                                                a1 = !0;
                                                break;
                                            case "caption":
                                            case "subtitle":
                                                u = f;
                                        }
                                    }
                                    o = null, f = !1;
                                    for(var g = (h = l(h = ni(n, "EssentialProperty"))).next(); !g.done; g = h.next()){
                                        var p = (g = g.value).getAttribute("schemeIdUri");
                                        "http://dashif.org/guidelines/trickmode" == p ? o = g.getAttribute("value") : "urn:mpeg:mpegB:cicp:TransferCharacteristics" == p ? i = r(parseInt(g.getAttribute("value"), 10)) : f = !0;
                                    }
                                    for(g = (h = l(h = ni(n, "SupplementalProperty"))).next(); !g.done; g = h.next())"urn:mpeg:mpegB:cicp:TransferCharacteristics" == (g = g.value).getAttribute("schemeIdUri") && (i = r(parseInt(g.getAttribute("value"), 10)));
                                    h = ni(n, "Accessibility");
                                    var m = new Map;
                                    for(g = (h = l(h)).next(); !g.done; g = h.next())if (g = (p = g.value).getAttribute("schemeIdUri"), p = p.getAttribute("value"), "urn:scte:dash:cc:cea-608:2015" == g) {
                                        if (g = 1, null != p) for(var v = l(p = p.split(";")), y = v.next(); !y.done; y = v.next()){
                                            var E = y.value, A = y = void 0;
                                            E.includes("=") ? (y = (E = E.split("="))[0].startsWith("CC") ? E[0] : "CC" + E[0], A = E[1] || "und") : (y = "CC" + g, 2 == p.length ? g += 2 : g++, A = E), m.set(y, tn(A));
                                        }
                                        else m.set("CC1", "und");
                                    } else if ("urn:scte:dash:cc:cea-708:2015" == g) {
                                        if (g = 1, null != p) for(y = (p = l(p.split(";"))).next(); !y.done; y = p.next())E = v = void 0, (y = y.value).includes("=") ? (v = "svc" + (y = y.split("="))[0], E = y[1].split(",")[0].split(":").pop()) : (v = "svc" + g, g++, E = y), m.set(v, tn(E));
                                        else m.set("svc1", "und");
                                    } else "urn:mpeg:dash:role:2011" == g && null != p && (s1.push(p), "captions" == p && (u = "caption"));
                                    if (f) return null;
                                    var _ = qc(f = ni(n, "ContentProtection"), e.g.dash.ignoreDrmInfo, e.g.dash.keySystemsByURI), S = tn(n.getAttribute("lang") || "und"), w = n.getAttribute("label");
                                    if ((f = ni(n, "Label")) && f.length && (f = f[0]).textContent && (w = f.textContent), n = (f = ni(n, "Representation")).map(function(n) {
                                        return (n = function(e, t, n, r, i, a1, o, s1, u, c) {
                                            if (t.I = Wd(c, t.ia, null), e.u = Math.min(e.u, t.I.yb), !function(e) {
                                                var t = e.vc ? 1 : 0;
                                                return t += e.bb ? 1 : 0, 0 == (t += e.wc ? 1 : 0) ? e.contentType == Ze || "application" == e.contentType : (1 != t && (e.vc && (e.bb = null), e.wc = null), !0);
                                            }(t.I)) return null;
                                            var d = t.V.start;
                                            t.bandwidth = ui(c, "bandwidth", hi) || 0;
                                            var f = t.I.contentType, h = f == Ze || "application" == f;
                                            f = "image" == f;
                                            try {
                                                var g = function(t, n, r) {
                                                    return function(e, t, n, r) {
                                                        var i, a1, o, s1, u;
                                                        return L(function(l) {
                                                            return 1 == l.g ? (i = Cr, a1 = Ns(t, n, r, e.g.retryParameters), o = e.h.networkingEngine, s1 = o.request(i, a1), br(e.o, s1), T(l, s1.promise, 2)) : (u = l.h, l.return(u.data));
                                                        });
                                                    }(e, t, n, r);
                                                };
                                                if (t.I.vc) var p = function(e, t) {
                                                    var n = Number(Zc(e, cd, "presentationTimeOffset")) || 0, r = Zc(e, cd, "timescale"), i = 1;
                                                    r && (i = hi(r) || 1);
                                                    var a1 = n / i || 0, o = ud(e, cd);
                                                    !function(e, t) {
                                                        if (fd(e, t), !dd(e)) throw new De(2, 4, 4002);
                                                    }(e, o);
                                                    var s1 = Er(e);
                                                    return {
                                                        Ab: function() {
                                                            var e = $c(s1, cd, "RepresentationIndex"), n = s1.I.va;
                                                            return e && (e = e.getAttribute("sourceURL")) && (n = ze(s1.I.va, [
                                                                e
                                                            ])), e = dd(s1), ld(s1, t, o, n, e.start, e.end, a1);
                                                        }
                                                    };
                                                }(t, g);
                                                else if (t.I.bb) p = function(e, t) {
                                                    var n = ud(e, gd), r = function(e) {
                                                        var t = function(e) {
                                                            return [
                                                                e.I.bb,
                                                                e.ia.bb,
                                                                e.aa.bb
                                                            ].filter(We).map(function(e) {
                                                                return ni(e, "SegmentURL");
                                                            }).reduce(function(e, t) {
                                                                return 0 < e.length ? e : t;
                                                            }).map(function(t) {
                                                                return t.getAttribute("indexRange") && !e.Ie && (e.Ie = !0), {
                                                                    cg: t.getAttribute("media"),
                                                                    start: (t = ui(t, "mediaRange", di, {
                                                                        start: 0,
                                                                        end: null
                                                                    })).start,
                                                                    end: t.end
                                                                };
                                                            });
                                                        }(e), n = (e = Jc(e, gd)).Kb;
                                                        0 == n && (n = 1);
                                                        var r = 0;
                                                        return e.ga ? r = e.ga * (n - 1) : e.timeline && 0 < e.timeline.length && (r = e.timeline[0].start), {
                                                            ga: e.ga,
                                                            startTime: r,
                                                            Kb: n,
                                                            Sa: e.Sa,
                                                            timeline: e.timeline,
                                                            Fb: t
                                                        };
                                                    }(e);
                                                    if (!r.ga && !r.timeline && 1 < r.Fb.length) throw new De(2, 4, 4002);
                                                    if (!r.ga && !e.V.duration && !r.timeline && 1 == r.Fb.length) throw new De(2, 4, 4002);
                                                    if (r.timeline && 0 == r.timeline.length) throw new De(2, 4, 4002);
                                                    var i = null, a1 = null;
                                                    e.aa.id && e.I.id && (a1 = t[e.aa.id + "," + e.I.id]) && (i = a1.segmentIndex);
                                                    var o = function(e, t, n, r, i) {
                                                        var a1 = r.Fb.length;
                                                        r.timeline && r.timeline.length != r.Fb.length && (a1 = Math.min(r.timeline.length, r.Fb.length));
                                                        for(var o = e - r.Sa, s1 = t ? e + t : 1 / 0, u = [], l = r.startTime, c = {}, d = 0; d < a1; c = {
                                                            pd: c.pd
                                                        }, d++){
                                                            var f, h = r.Fb[d];
                                                            c.pd = ze(n, [
                                                                h.cg
                                                            ]), f = null != r.ga ? l + r.ga : r.timeline ? r.timeline[d].end : l + t, u.push(new lo(e + l, e + f, function(e) {
                                                                return function() {
                                                                    return e.pd;
                                                                };
                                                            }(c), h.start, h.end, i, o, e, s1)), l = f;
                                                        }
                                                        return u;
                                                    }(e.V.start, e.V.duration, e.I.va, r, n);
                                                    return n = !i, i ? i.Gb(o, e.presentationTimeline.Oa()) : i = new ps(o), e.presentationTimeline.Hb(o), e.Xa && e.V.Ke || i.Ya(e.V.start, e.V.duration ? e.V.start + e.V.duration : 1 / 0, n), a1 && (a1.segmentIndex = i), {
                                                        Ab: function() {
                                                            return i && 0 != i.g.length || i.oc(o), Promise.resolve(i);
                                                        }
                                                    };
                                                }(t, e.l);
                                                else if (t.I.wc) p = function(e, t, n, r, i, a1) {
                                                    var o = function(e) {
                                                        var t = Zc(e, pd, "initialization");
                                                        if (!t) return null;
                                                        var n = e.I.id, r = e.bandwidth || null, i = e.I.va;
                                                        return new uo(function() {
                                                            var e = Qc(t, n, null, r, null);
                                                            return ze(i, [
                                                                e
                                                            ]);
                                                        }, 0, null, hd(e));
                                                    }(e), s1 = function(e) {
                                                        var t = Jc(e, pd), n = Zc(e, pd, "media");
                                                        return e = Zc(e, pd, "index"), {
                                                            ga: t.ga,
                                                            timescale: t.timescale,
                                                            Kb: t.Kb,
                                                            Sa: t.Sa,
                                                            qe: t.qe,
                                                            timeline: t.timeline,
                                                            Pd: n,
                                                            nc: e
                                                        };
                                                    }(e);
                                                    !function(e) {
                                                        var t = e.nc ? 1 : 0;
                                                        if (t += e.timeline ? 1 : 0, 0 == (t += e.ga ? 1 : 0)) throw new De(2, 4, 4002);
                                                        if (1 != t && (e.nc && (e.timeline = null), e.ga = null), !e.nc && !e.Pd) throw new De(2, 4, 4002);
                                                    }(s1);
                                                    var u = Er(e);
                                                    if (s1.nc) return fd(e, o), {
                                                        Ab: function() {
                                                            var e = Qc(s1.nc, u.I.id, null, u.bandwidth || null, null);
                                                            return e = ze(u.I.va, [
                                                                e
                                                            ]), ld(u, t, o, e, 0, null, s1.Sa);
                                                        }
                                                    };
                                                    if (s1.ga) return r || (e.presentationTimeline.Rd(s1.ga), e.presentationTimeline.Sd(e.V.start)), {
                                                        Ab: function() {
                                                            return function(e, t, n, r, i) {
                                                                function a1(e) {
                                                                    var n = (e - g) * h, i = n + t.Sa, a1 = n + c;
                                                                    return n = a1 + h, (a1 = new lo(a1, Math.min(n, s1()), function() {
                                                                        var t = Qc(m, y, e, v, i * p);
                                                                        return ze(E, [
                                                                            t
                                                                        ]);
                                                                    }, 0, null, r, T, c, s1())).j = n, a1;
                                                                }
                                                                function o() {
                                                                    var e = [
                                                                        Math.max(u.Oa(), c),
                                                                        Math.min(u.hb(), s1())
                                                                    ].map(function(e) {
                                                                        return e - c;
                                                                    });
                                                                    return [
                                                                        Math.ceil(e[0] / h),
                                                                        Math.ceil(e[1] / h) - 1
                                                                    ].map(function(e) {
                                                                        return e + g;
                                                                    });
                                                                }
                                                                function s1() {
                                                                    var e = null != d && i[d] || f;
                                                                    return e ? c + e : 1 / 0;
                                                                }
                                                                var u = e.presentationTimeline, c = e.V.start, d = e.aa.id, f = e.V.duration, h = t.ga, g = t.Kb, p = t.timescale, m = t.Pd, v = e.bandwidth || null, y = e.I.id, E = e.I.va, T = c - t.Sa, b = o();
                                                                e = e.Xa ? Math.max(b[0], b[1] - n + 1) : b[0], b = b[1], n = [];
                                                                for(var A = e; A <= b; ++A){
                                                                    var _ = a1(A);
                                                                    n.push(_);
                                                                }
                                                                var S = new ps(n);
                                                                if (n = u.hb() < s1(), A = u.U(), n || A) {
                                                                    var w = Math.max(e, b + 1);
                                                                    S.gd(h, function() {
                                                                        var e = u.Oa();
                                                                        S.fb(e);
                                                                        var t = l(o());
                                                                        t.next(), t = t.next().value;
                                                                        for(var n = []; w <= t;){
                                                                            var r = a1(w);
                                                                            n.push(r), w++;
                                                                        }
                                                                        return e > s1() && !n.length ? null : n;
                                                                    });
                                                                }
                                                                return Promise.resolve(S);
                                                            }(u, s1, i, o, a1);
                                                        }
                                                    };
                                                    var c = null;
                                                    r = r = null, e.aa.id && e.I.id && (r = n[r = e.aa.id + "," + e.I.id]) && (c = r.segmentIndex);
                                                    var d = function(e, t, n) {
                                                        var r = e.V.start, i = e.V.duration, a1 = r - t.Sa;
                                                        i = i ? r + i : 1 / 0;
                                                        for(var o = [], s1 = {}, u = 0; u < t.timeline.length; s1 = {
                                                            od: s1.od,
                                                            sd: s1.sd,
                                                            vd: s1.vd,
                                                            ld: s1.ld,
                                                            xd: s1.xd,
                                                            md: s1.md
                                                        }, u++){
                                                            var l = t.timeline[u], c = l.start, d = l.Cg;
                                                            l = l.end, s1.vd = u + t.Kb, s1.xd = d + t.qe, s1.sd = e.I.id, s1.ld = e.bandwidth || null, s1.od = t.Pd, s1.md = e.I.va, o.push(new lo(r + c, r + l, function(e) {
                                                                return function() {
                                                                    var t = Qc(e.od, e.sd, e.vd, e.ld || null, e.xd);
                                                                    return ze(e.md, [
                                                                        t
                                                                    ]).map(function(e) {
                                                                        return e.toString();
                                                                    });
                                                                };
                                                            }(s1), 0, null, n, a1, r, i));
                                                        }
                                                        return o;
                                                    }(u, s1, o);
                                                    n = e.V.start;
                                                    var f = e.V.duration ? e.V.start + e.V.duration : 1 / 0, h = 1 / 0 != f;
                                                    return c ? (h && new ps(d).Ya(n, f, !0), c.Gb(d, e.presentationTimeline.Oa())) : c = new ps(d), e.presentationTimeline.Hb(d), h && c.Ya(n, f), r && e.Xa && (r.segmentIndex = c), {
                                                        Ab: function() {
                                                            return c && 0 != c.g.length || c.oc(d), Promise.resolve(c);
                                                        }
                                                    };
                                                }(t, g, e.l, !!e.i, e.g.dash.initialSegmentLimit, e.M);
                                                else {
                                                    var m = t.I.va, v = t.V.duration || 0;
                                                    p = {
                                                        Ab: function() {
                                                            return Promise.resolve(vs(d, v, m));
                                                        }
                                                    };
                                                }
                                            } catch (e) {
                                                if ((h || f) && 4002 == e.code) return null;
                                                throw e;
                                            }
                                            g = function(e, t, n, r) {
                                                var i = qc(e, n, r);
                                                if (t.De) e = 1 == t.drmInfos.length && !t.drmInfos[0].keySystem, n = 0 == i.drmInfos.length, (0 == t.drmInfos.length || e && !n) && (t.drmInfos = i.drmInfos), t.De = !1;
                                                else if (0 < i.drmInfos.length && (t.drmInfos = t.drmInfos.filter(function(e) {
                                                    return i.drmInfos.some(function(t) {
                                                        return t.keySystem == e.keySystem;
                                                    });
                                                }), 0 == t.drmInfos.length)) throw new De(2, 4, 4008);
                                                return i.ze || t.ze;
                                            }(g = ni(c, "ContentProtection"), n, e.g.dash.ignoreDrmInfo, e.g.dash.keySystemsByURI), g = new Set(g ? [
                                                g
                                            ] : []);
                                            var y = !1;
                                            ni(c, "SupplementalProperty").some(function(e) {
                                                return "tag:dolby.com,2018:dash:EC3_ExtensionType:2018" == e.getAttribute("schemeIdUri") && "JOC" == e.getAttribute("value");
                                            }) && (y = !0);
                                            var E, A, _ = !1;
                                            if (h && (_ = s1.includes("forced_subtitle") || s1.includes("forced-subtitle")), f && ((c = ni(c, "EssentialProperty").find(function(e) {
                                                return [
                                                    "http://dashif.org/thumbnail_tile",
                                                    "http://dashif.org/guidelines/thumbnail_tile"
                                                ].includes(e.getAttribute("schemeIdUri"));
                                            })) && (E = c.getAttribute("value")), !E)) return null;
                                            c = t.I.codecs, t.profiles.includes("http://dashif.org/guidelines/dash-if-uhd#hevc-hdr-pq10") && (c.includes("hvc1.2.4.L153.B0") || c.includes("hev1.2.4.L153.B0")) && (A = "PQ");
                                            var S = t.I.id ? t.aa.id + "," + t.I.id : "", w = {
                                                id: e.G++,
                                                originalId: t.I.id,
                                                createSegmentIndex: function() {
                                                    var n, r;
                                                    return L(function(i) {
                                                        if (1 == i.g) return (n = S && t.Xa && e.l[S] ? e.l[S] : w).segmentIndex ? i.A(0) : (r = n, T(i, p.Ab(), 3));
                                                        r.segmentIndex = i.h, b(i);
                                                    });
                                                },
                                                closeSegmentIndex: function() {
                                                    w.segmentIndex && (w.segmentIndex.release(), w.segmentIndex = null);
                                                },
                                                segmentIndex: null,
                                                mimeType: t.I.mimeType,
                                                codecs: t.I.codecs,
                                                frameRate: t.I.frameRate,
                                                pixelAspectRatio: t.I.pixelAspectRatio,
                                                bandwidth: t.bandwidth,
                                                width: t.I.width,
                                                height: t.I.height,
                                                kind: r,
                                                encrypted: 0 < n.drmInfos.length,
                                                drmInfos: n.drmInfos,
                                                keyIds: g,
                                                language: i,
                                                label: a1,
                                                type: t.ia.contentType,
                                                primary: o,
                                                trickModeVideo: null,
                                                emsgSchemeIdUris: t.I.emsgSchemeIdUris,
                                                roles: s1,
                                                forced: _,
                                                channelsCount: t.I.ad,
                                                audioSamplingRate: t.I.audioSamplingRate,
                                                spatialAudio: y,
                                                closedCaptions: u,
                                                hdr: A,
                                                tilesLayout: E,
                                                matchedStreams: []
                                            };
                                            return S && t.Xa && !e.l[S] && (e.l[S] = w), w;
                                        }(e, t, _, u, S, w, a1, s1, m, n)) && (n.hdr = n.hdr || i), n;
                                    }).filter(function(e) {
                                        return !!e;
                                    }), 0 == n.length) {
                                        if (o = "image" == t.ia.contentType, e.g.dash.ignoreEmptyAdaptationSet || d || o) return null;
                                        throw new De(2, 4, 4003);
                                    }
                                    if (!t.ia.contentType || "application" == t.ia.contentType) for(t.ia.contentType = Qd(n[0].mimeType, n[0].codecs), h = (d = l(n)).next(); !h.done; h = d.next())h.value.type = t.ia.contentType;
                                    for(h = (d = l(n)).next(); !h.done; h = d.next())for(h = h.value, p = (g = l(_.drmInfos)).next(); !p.done; p = g.next())(p = p.value).keyIds = p.keyIds && h.keyIds ? new Set([].concat(c(p.keyIds), c(h.keyIds))) : p.keyIds || h.keyIds;
                                    return d = f.map(function(e) {
                                        return e.getAttribute("id");
                                    }).filter(We), {
                                        id: t.ia.id || "__fake__" + e.G++,
                                        contentType: t.ia.contentType,
                                        language: S,
                                        uh: a1,
                                        streams: n,
                                        drmInfos: _.drmInfos,
                                        oe: o,
                                        pg: d
                                    };
                                }(e, t, n);
                            }).filter(We), t.Xa) {
                                for(r = [], a1 = (i = l(n)).next(); !a1.done; a1 = i.next())for(var o = (a1 = l(a1.value.pg)).next(); !o.done; o = a1.next())r.push(o.value);
                                if (r.length != new Set(r).size) throw new De(2, 4, 4018);
                            }
                            for(r = n.filter(function(e) {
                                return !e.oe;
                            }), i = (n = l(n = n.filter(function(e) {
                                return e.oe;
                            }))).next(); !i.done; i = n.next()){
                                a1 = (i = i.value).oe.split(" ");
                                for(var s1 = (o = l(r)).next(); !s1.done; s1 = o.next()){
                                    var u = s1.value;
                                    if (a1.includes(u.id)) {
                                        s1 = {};
                                        for(var d = (u = l(u.streams)).next(); !d.done; s1 = {
                                            Fc: s1.Fc
                                        }, d = u.next())s1.Fc = d.value, s1.Fc.trickModeVideo = i.streams.find(function(e) {
                                            return function(t) {
                                                return Ht(e.Fc.codecs) == Ht(t.codecs);
                                            };
                                        }(s1));
                                    }
                                }
                            }
                            if (i = e.g.disableAudio ? [] : qd(r, "audio"), o = e.g.disableVideo ? [] : qd(r, "video"), a1 = e.g.disableText ? [] : qd(r, Ze), n = e.g.disableThumbnails ? [] : qd(r, "image"), !o.length && !i.length) throw new De(2, 4, 4004);
                            for(r = [], s1 = (i = l(i)).next(); !s1.done; s1 = i.next())r.push.apply(r, c(s1.value.streams));
                            for(i = [], s1 = (o = l(o)).next(); !s1.done; s1 = o.next())i.push.apply(i, c(s1.value.streams));
                            for(o = [], s1 = (a1 = l(a1)).next(); !s1.done; s1 = a1.next())o.push.apply(o, c(s1.value.streams));
                            for(a1 = [], s1 = (n = l(n)).next(); !s1.done; s1 = n.next())a1.push.apply(a1, c(s1.value.streams));
                            return {
                                id: t.aa.id,
                                Jc: r,
                                hd: i,
                                textStreams: o,
                                imageStreams: a1
                            };
                        }
                        function qd(e, t) {
                            return e.filter(function(e) {
                                return e.contentType == t;
                            });
                        }
                        function Yd(e, t) {
                            0 > e.F || e.D.O(Math.max(3, e.F - t, H(e.H)));
                        }
                        function Wd(e, t, n) {
                            t = t || {
                                contentType: "",
                                mimeType: "",
                                codecs: "",
                                emsgSchemeIdUris: [],
                                frameRate: void 0,
                                pixelAspectRatio: void 0,
                                ad: null,
                                audioSamplingRate: null,
                                yb: 0
                            }, n = n || t.va;
                            for(var r = ni(e, "BaseURL"), i = r.map(oi), a1 = e.getAttribute("contentType") || t.contentType, o = e.getAttribute("mimeType") || t.mimeType, s1 = e.getAttribute("codecs") || t.codecs, u = ui(e, "frameRate", mi) || t.frameRate, c = e.getAttribute("sar") || t.pixelAspectRatio, d = ni(e, "InbandEventStream"), f = t.emsgSchemeIdUris.slice(), h = (d = l(d)).next(); !h.done; h = d.next())h = h.value.getAttribute("schemeIdUri"), f.includes(h) || f.push(h);
                            d = function(e) {
                                for(var t = (e = l(e)).next(); !t.done; t = e.next()){
                                    var n = t.value;
                                    if ((t = n.getAttribute("schemeIdUri")) && (n = n.getAttribute("value"))) switch(t){
                                        case "urn:mpeg:dash:outputChannelPositionList:2012":
                                            return n.trim().split(/ +/).length;
                                        case "urn:mpeg:dash:23003:3:audio_channel_configuration:2011":
                                        case "urn:dts:dash:audio_channel_configuration:2012":
                                            if (!(t = parseInt(n, 10))) continue;
                                            return t;
                                        case "tag:dolby.com,2014:dash:audio_channel_configuration:2011":
                                        case "urn:dolby:dash:audio_channel_configuration:2011":
                                            if (!(t = parseInt(n, 16))) continue;
                                            for(e = 0; t;)1 & t && ++e, t >>= 1;
                                            return e;
                                        case "urn:mpeg:mpegB:cicp:ChannelConfiguration":
                                            if (t = [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4,
                                                5,
                                                6,
                                                8,
                                                2,
                                                3,
                                                4,
                                                7,
                                                8,
                                                24,
                                                8,
                                                12,
                                                10,
                                                12,
                                                14,
                                                12,
                                                14
                                            ], (n = parseInt(n, 10)) && 0 < n && n < t.length) return t[n];
                                    }
                                }
                                return null;
                            }(d = ni(e, "AudioChannelConfiguration")) || t.ad, h = ui(e, "audioSamplingRate", gi) || t.audioSamplingRate, a1 || (a1 = Qd(o, s1));
                            var g = ei(e, "SegmentBase"), p = ei(e, "SegmentTemplate"), m = g && ui(g, "availabilityTimeOffset", pi) || 0, v = p && ui(p, "availabilityTimeOffset", pi) || 0;
                            return r = r && r.length && ui(r[0], "availabilityTimeOffset", pi) || 0, r = t.yb + r + m + v, {
                                va: ze(n, i),
                                vc: g || t.vc,
                                bb: ei(e, "SegmentList") || t.bb,
                                wc: p || t.wc,
                                width: ui(e, "width", gi) || t.width,
                                height: ui(e, "height", gi) || t.height,
                                contentType: a1,
                                mimeType: o,
                                codecs: s1,
                                frameRate: u,
                                pixelAspectRatio: c,
                                emsgSchemeIdUris: f,
                                id: e.getAttribute("id"),
                                ad: d,
                                audioSamplingRate: h,
                                yb: r
                            };
                        }
                        function zd(e, t, n, r) {
                            var i, a1, o, s1, u, l;
                            return L(function(c) {
                                if (1 == c.g) return i = ze(t, [
                                    n
                                ]), (a1 = Sr(i, e.g.retryParameters)).method = r, o = e.h.networkingEngine.request(4, a1), br(e.o, o), T(c, o.promise, 2);
                                if (s1 = c.h, "HEAD" == r) {
                                    if (!s1.headers || !s1.headers.date) return c.return(0);
                                    u = s1.headers.date;
                                } else u = yt(s1.data);
                                return l = Date.parse(u), isNaN(l) ? c.return(0) : c.return(l - Date.now());
                            });
                        }
                        function Xd(e, t, n, r, i) {
                            for(var a1 = r.getAttribute("schemeIdUri") || "", o = r.getAttribute("value") || "", s1 = ui(r, "timescale", gi) || 1, u = (r = l(ni(r, "Event"))).next(); !u.done; u = r.next()){
                                var c = ui(u = u.value, "presentationTime", gi) || 0, d = ui(u, "duration", gi) || 0;
                                d = (c = c / s1 + t) + d / s1, null != n && (c = Math.min(c, t + n), d = Math.min(d, t + n)), d < i || (u = {
                                    schemeIdUri: a1,
                                    value: o,
                                    startTime: c,
                                    endTime: d,
                                    id: u.getAttribute("id") || "",
                                    eventElement: u
                                }, e.h.onTimelineRegionAdded(u));
                            }
                        }
                        function Qd(e, t) {
                            return Yt(Bt(e, t)) ? Ze : e.split("/")[0];
                        }
                        function Jd(e, t, n, r) {
                            this.h = e, this.type = t, this.g = n, this.segments = r || null;
                        }
                        function Zd(e, t, n, r) {
                            this.id = e, this.name = t, this.g = n, this.value = void 0 === r ? null : r;
                        }
                        function $d(e, t, n) {
                            return (e = e.getAttribute(t)) ? e.value : n || null;
                        }
                        function ef(e, t) {
                            var n = e.getAttribute(t);
                            if (!n) throw new De(2, 4, 4023, t);
                            return n.value;
                        }
                        function tf(e, t, n) {
                            n = void 0 === n ? [] : n, this.g = t, this.i = e, this.h = n;
                        }
                        function nf(e, t) {
                            this.name = e, this.value = t;
                        }
                        function rf(e, t) {
                            return e.filter(function(e) {
                                return e.name == t;
                            });
                        }
                        function af(e, t) {
                            return e.filter(function(e) {
                                return ef(e, "TYPE") == t;
                            });
                        }
                        function of(e, t) {
                            var n = rf(e, t);
                            return n.length ? n[0] : null;
                        }
                        function sf(e) {
                            var t = 0;
                            return t = void 0 === t ? 0 : t, (e = of(e, "EXT-X-MEDIA-SEQUENCE")) ? Number(e.value) : t;
                        }
                        function uf(e, t) {
                            return ze([
                                e
                            ], [
                                t
                            ])[0];
                        }
                        function lf(e) {
                            this.h = e, this.g = 0;
                        }
                        function cf(e) {
                            df(e, /[ \t]+/gm);
                        }
                        function df(e, t) {
                            t.lastIndex = e.g;
                            var n = t.exec(e.h);
                            return n = null == n ? null : {
                                position: n.index,
                                length: n[0].length,
                                results: n
                            }, e.g == e.h.length || null == n || n.position != e.g ? null : (e.g += n.length, n.results);
                        }
                        function ff(e) {
                            return e.g == e.h.length ? null : (e = df(e, /[^ \t\n]*/gm)) ? e[0] : null;
                        }
                        function hf() {
                            this.g = 0;
                        }
                        function gf(e, t, n) {
                            var r = (t = (t = yt(t)).replace(/\r\n|\r(?=[^\n]|$)/gm, "\n").trim()).split(/\n+/m);
                            if (!/^#EXTM3U($|[ \t\n])/m.test(r[0])) throw new De(2, 4, 4015);
                            t = 0;
                            for(var i = !0, a1 = l(r), o = a1.next(); !o.done; o = a1.next())if (o = o.value, /^#(?!EXT)/m.test(o) || i) i = !1;
                            else {
                                if (o = pf(e, o), --e.g, mf.includes(o.name)) {
                                    t = 1;
                                    break;
                                }
                                "EXT-X-STREAM-INF" == o.name && (i = !0);
                            }
                            for(a1 = [], i = !0, o = 0; o < r.length; o++){
                                var s1 = r[o], u = r[o + 1];
                                if (/^#(?!EXT)/m.test(s1) || i) i = !1;
                                else {
                                    if (s1 = pf(e, s1), vf.includes(s1.name)) {
                                        if (1 != t) throw new De(2, 4, 4017);
                                        var c = r.splice(o, r.length - o);
                                        r = n, i = [], o = [], u = [], s1 = null;
                                        for(var d = (c = l(c)).next(); !d.done; d = c.next())d = d.value, /^(#EXT)/.test(d) ? (d = pf(e, d), mf.includes(d.name) ? a1.push(d) : "EXT-X-MAP" == d.name ? s1 = d : "EXT-X-PART" == d.name ? u.push(d) : "EXT-X-PRELOAD-HINT" == d.name ? "PART" == $d(d, "TYPE") ? u.push(d) : "MAP" == $d(d, "TYPE") && (d.name = "EXT-X-MAP", s1 = d) : o.push(d)) : /^#(?!EXT)/m.test(d) || (d = uf(r, d.trim()), s1 && o.push(s1), i.push(new tf(d, o, u)), o = [], u = []);
                                        return u.length && (s1 && o.push(s1), i.push(new tf("", o, u))), new Jd(n, t, a1, i);
                                    }
                                    a1.push(s1), "EXT-X-STREAM-INF" == s1.name && (s1.g.push(new nf("URI", u)), i = !0);
                                }
                            }
                            return new Jd(n, t, a1);
                        }
                        function pf(e, t) {
                            var n = e.g++, r = t.match(/^#(EXT[^:]*)(?::(.*))?$/);
                            if (!r) throw new De(2, 4, 4016, t);
                            var i, a1 = r[1], o = r[2];
                            if (r = [], o) {
                                var s1;
                                (s1 = df(o = new lf(o), /^([^,=]+)(?:,|$)/g)) && (i = s1[1]);
                                for(var u = /([^=]+)=(?:"([^"]*)"|([^",]*))(?:,|$)/g; s1 = df(o, u);)r.push(new nf(s1[1], s1[2] || s1[3])), cf(o);
                            }
                            return new Zd(n, a1, r, i);
                        }
                        (r = Gd.prototype).configure = function(e) {
                            this.g = e;
                        }, r.start = function(e, t) {
                            var n, r = this;
                            return L(function(i) {
                                if (1 == i.g) return r.B = t.isLowLatencyMode(), r.m = [
                                    e
                                ], r.h = t, T(i, Hd(r), 2);
                                if (n = i.h, r.h && Yd(r, n), !r.h) throw new De(2, 7, 7001);
                                return i.return(r.i);
                            });
                        }, r.stop = function() {
                            for(var e = l(Object.values(this.l)), t = e.next(); !t.done; t = e.next())(t = t.value).segmentIndex && t.segmentIndex.release();
                            return this.j && this.j.release(), this.g = this.h = null, this.m = [], this.i = null, this.l = {}, this.j = null, null != this.D && (this.D.stop(), this.D = null), this.o.destroy();
                        }, r.update = function() {
                            var e, t = this;
                            return L(function(n) {
                                return 1 == n.g ? (A(n, 2), T(n, Hd(t), 4)) : 2 != n.g ? S(n, 0) : (e = w(n), t.h && e ? (t.h.onError(e), void b(n)) : n.return());
                            });
                        }, r.onExpirationUpdated = function() {}, B("shaka.dash.DashParser", Gd), zi.mpd = function() {
                            return new Gd;
                        }, Wi["application/dash+xml"] = function() {
                            return new Gd;
                        }, Wi["video/vnd.mpeg.dash.mpd"] = function() {
                            return new Gd;
                        }, Zd.prototype.toString = function() {
                            var e = "#" + this.name, t = this.g ? this.g.map(function(e) {
                                return e.name + "=" + (isNaN(Number(e.value)) ? '"' + e.value + '"' : e.value);
                            }) : [];
                            return this.value && t.unshift(this.value), 0 < t.length && (e += ":" + t.join(",")), e;
                        }, Zd.prototype.getAttribute = function(e) {
                            var t = this.g.filter(function(t) {
                                return t.name == e;
                            });
                            return t.length ? t[0] : null;
                        };
                        var mf = "EXT-X-TARGETDURATION EXT-X-MEDIA-SEQUENCE EXT-X-DISCONTINUITY-SEQUENCE EXT-X-PLAYLIST-TYPE EXT-X-I-FRAMES-ONLY EXT-X-ENDLIST EXT-X-SERVER-CONTROL EXT-X-SKIP".split(" "), vf = "EXTINF EXT-X-BYTERANGE EXT-X-DISCONTINUITY EXT-X-PROGRAM-DATE-TIME EXT-X-KEY EXT-X-DATERANGE EXT-X-MAP".split(" ");
                        function yf() {}
                        function Ef(e) {
                            try {
                                var t = Tf(e);
                                return dr({
                                    uri: e,
                                    Ne: e,
                                    data: t.data,
                                    headers: {
                                        "content-type": t.contentType
                                    }
                                });
                            } catch (e) {
                                return lr(e);
                            }
                        }
                        function Tf(t) {
                            var n = t.split(":");
                            if (2 > n.length || "data" != n[0]) throw new De(2, 1, 1004, t);
                            if (2 > (n = n.slice(1).join(":").split(",")).length) throw new De(2, 1, 1004, t);
                            var r = n[0];
                            t = e.decodeURIComponent(n.slice(1).join(",")), n = r.split(";"), r = n[0];
                            var i = !1;
                            return 1 < n.length && "base64" == n[n.length - 1] && (i = !0, n.pop()), {
                                data: i ? Rt(t) : bt(t),
                                contentType: r
                            };
                        }
                        function bf() {
                            var e = this;
                            this.g = this.i = null, this.Ea = 1, this.o = new Map, this.u = new Map, this.F = new Map, this.F.set("video", new Map), this.F.set("audio", new Map), this.F.set(Ze, new Map), this.F.set("image", new Map), this.ta = new Set, this.h = new Map, this.j = null, this.N = "", this.X = new hf, this.P = 0, this.B = -1, this.M = 1 / 0, this.Ka = !1, this.m = new it(function() {
                                !function(e) {
                                    var t, n;
                                    L(function(r) {
                                        return 1 == r.g ? e.i ? (A(r, 2), T(r, e.update(), 4)) : r.return() : 2 != r.g ? (Yf(e) && (t = e.P, e.m.O(t)), S(r, 0)) : (n = w(r), e.i ? (n.severity = 1, e.i.onError(n), e.m.O(.1), void b(r)) : r.return());
                                    });
                                }(e);
                            }), this.ha = Zf, this.D = null, this.da = 0, this.H = 1 / 0, this.W = this.ea = 0, this.G = new Tr, this.K = new Map, this.s = new Map, this.ca = new Map, this.l = !1;
                        }
                        function Af(e, t) {
                            return Yf(e) ? e.F.get(t.type) : t.$c;
                        }
                        function _f(e, t) {
                            var n, r, i, a1, o, s1, u, l, d, f, h, g, p, m, v;
                            return L(function(y) {
                                if (1 == y.g) return n = t.Ic, r = new Ne(n), e.l && t.Lc && Me(r, new Ve("_HLS_skip=YES")), T(y, qf(e, r.toString()), 2);
                                if (i = y.h, !t.stream.segmentIndex) return y.return();
                                if (1 != (a1 = gf(e.X, i.data, i.uri)).type) throw new De(2, 4, 4017);
                                var E, A;
                                o = rf(a1.g, "EXT-X-DEFINE"), s1 = If(e, o), u = t.stream, l = Af(e, t), d = Pf(a1, u.mimeType), f = d.keyIds, h = d.drmInfos, E = u.keyIds, A = f, E.size === A.size && [].concat(c(E)).every(function(e) {
                                    return A.has(e);
                                }) || (u.keyIds = f, u.drmInfos = h, e.i.newDrmInfo(u)), g = Hf(e, a1, u.type, l, s1), u.segmentIndex.Gb(g, e.j.Oa()), g.length && (p = sf(a1.g), m = l.get(p), u.segmentIndex.fb(m)), v = g[g.length - 1], of(a1.g, "EXT-X-ENDLIST") && (t.lc = !0, t.Za = v.endTime), b(y);
                            });
                        }
                        function Sf(e, t, n) {
                            t.stream.segmentIndex.offset(n), t.Za += n;
                            for(var r = (t = l(e = Af(e, t))).next(); !r.done; r = t.next()){
                                var i = l(r.value);
                                r = i.next().value, i = i.next().value, e.set(r, i + n);
                            }
                        }
                        function wf(e) {
                            if (Yf(e)) {
                                if (e.P = e.H, e.ha == eh) {
                                    var t = Nf(e);
                                    e.g.hls.useSafariBehaviorForLive && (t = e.j.m), isNaN(e.g.availabilityWindowOverride) || (t = e.g.availabilityWindowOverride), e.j.le(t);
                                }
                            } else e.j.Ia(Nf(e));
                            e.j.Md();
                        }
                        function If(e, t) {
                            for(var n = new Map, r = l(t), i = r.next(); !i.done; i = r.next()){
                                var a1 = i.value;
                                i = $d(a1, "NAME");
                                var o = $d(a1, "VALUE");
                                a1 = $d(a1, "IMPORT"), i && o && n.set(i, o), a1 && (i = e.o.get(a1)) && n.set(a1, i);
                            }
                            return n;
                        }
                        function Rf(e, t) {
                            var n = [];
                            e.g.disableVideo || n.push(e.g.hls.defaultVideoCodec), e.g.disableAudio || n.push(e.g.hls.defaultAudioCodec);
                            var r = $d(t, "CODECS", n.join(",")).split(/\s*,\s*/);
                            n = new Set;
                            for(var i = [], a1 = (r = l(r)).next(); !a1.done; a1 = r.next()){
                                var o = Kt(a1 = a1.value)[0];
                                n.has(o) || (i.push(a1), n.add(o));
                            }
                            return i;
                        }
                        function Cf(e) {
                            return tn(e = $d(e, "LANGUAGE") || "und");
                        }
                        function Df(e, t) {
                            var n = ef(t, "GROUP-ID"), r = "", i = ef(t, "TYPE").toLowerCase();
                            "subtitles" == i && (i = Ze);
                            var a1 = i;
                            if (a1 != Ze && n && e.s.has(n) && (r = e.s.get(n)), i = Vf(ef(t, "URI"), e.o), e.h.has(i)) return e.h.get(i);
                            var o = Cf(t), s1 = $d(t, "NAME"), u = "YES" == $d(t, "DEFAULT"), l = "audio" == a1 && (l = $d(t, "CHANNELS")) ? parseInt(l.split("/")[0], 10) : null, c = "audio" == a1 && !!(c = $d(t, "CHANNELS")) && c.includes("/JOC");
                            return r = kf(e, i, r, a1, o, u, s1, l, null, $d(t, "CHARACTERISTICS"), "YES" == $d(t, "FORCED"), c), e.u.has(n) ? e.u.get(n).push(r) : e.u.set(n, [
                                r
                            ]), e.h.has(i) ? e.h.get(i) : (e.h.set(i, r), r);
                        }
                        function kf(e, t, n, r, i, a1, o, s1, u, c, d, f) {
                            var h = uf(e.N, t), g = Of(e, n, r, i, a1, o, s1, u, d, f);
                            zo.includes(g.mimeType) && (g.codecs = "");
                            var p = {
                                stream: g,
                                type: r,
                                zc: t,
                                Ic: h,
                                Za: 0,
                                $c: new Map,
                                Lc: !1,
                                lc: !1,
                                Dd: -1,
                                Ld: !1
                            }, m = null, v = new AbortController;
                            return g.createSegmentIndex = function() {
                                return m || (v = new AbortController, m = new Promise(function(h) {
                                    h(function(h) {
                                        var m, v, y, E, A, _, S, w, I, R, C, D, k;
                                        return L(function(N) {
                                            if (1 == N.g) return T(N, qf(e, p.Ic), 2);
                                            if (3 != N.g) return m = N.h, h.aborted ? N.return() : (v = m.uri, y = gf(e.X, m.data, v), E = Yf(e), T(N, Mf(e, y, t, v, n, r, i, a1, o, s1, u, c, d, f), 3));
                                            if (A = N.h, h.aborted) return N.return();
                                            if (_ = A.stream, Yf(e) && !E && Uf(e), p.Ic = v, p.Za = A.Za, p.Lc = A.Lc, p.lc = A.lc, p.$c = A.$c, p.Ld = !0, g.segmentIndex = _.segmentIndex, g.encrypted = _.encrypted, g.drmInfos = _.drmInfos, g.keyIds = _.keyIds, g.kind = _.kind, g.roles = _.roles, g.mimeType = _.mimeType, g.drmInfos.length && e.i.newDrmInfo(g), r == (S = $e).ua || r == S.Gc) for(w = l(e.h.values()), I = w.next(); !I.done; I = w.next())(R = I.value).Ld || R.type != r || (R.stream.mimeType = _.mimeType);
                                            (function(e) {
                                                if (!e.D) return !1;
                                                for(var t = [], n = [], r = (e = l(e.D.variants)).next(); !r.done; r = e.next())(r = r.value).video && t.push(r.video), r.audio && n.push(r.audio);
                                                return !(0 < t.length && !t.some(function(e) {
                                                    return e.segmentIndex;
                                                }) || 0 < n.length && !n.some(function(e) {
                                                    return e.segmentIndex;
                                                }));
                                            })(e) && (e.Ka ? xf(e, [
                                                p
                                            ]) : (e.Ka = !0, C = Array.from(e.h.values()), D = C.filter(function(e) {
                                                return e.stream.segmentIndex;
                                            }), xf(e, D), wf(e), 0 < (k = e.P) && e.m.O(k))), b(N);
                                        });
                                    }(v.signal));
                                }));
                            }, g.closeSegmentIndex = function() {
                                m && !g.segmentIndex && v.abort(), g.segmentIndex && (g.segmentIndex.release(), g.segmentIndex = null), m = null;
                            }, p;
                        }
                        function Nf(e) {
                            for(var t = 1 / 0, n = (e = l(e.h.values())).next(); !n.done; n = e.next())(n = n.value).stream.segmentIndex && "text" != n.stream.type && (t = Math.min(t, n.Za));
                            return t;
                        }
                        function Lf(e, t) {
                            for(var n = [], r = l(t), i = r.next(); !i.done; i = r.next())(i = i.value).segmentIndex && ms(i.segmentIndex, function(e) {
                                n.push(e);
                            });
                            e.j.Hb(n);
                        }
                        function xf(e, t) {
                            if (!Yf(e)) for(var n = Nf(e), r = l(t), i = r.next(); !i.done; i = r.next())i.value.stream.segmentIndex.Ya(0, n);
                            for(i = (n = l(t)).next(); !i.done; i = n.next())i = i.value.stream, zo.includes(i.mimeType) && (i.codecs = "");
                            Lf(e, t.map(function(e) {
                                return e.stream;
                            })), e.g.hls.ignoreManifestProgramDateTime ? function(e, t) {
                                for(var n = -1 == e.B, r = l(t), i = r.next(); !i.done; i = r.next()){
                                    var a1 = (i = i.value).stream.segmentIndex, o = Af(e, i);
                                    if (a1 = a1.g[0] || null) for(var s1 = (o = l(o)).next(); !s1.done; s1 = o.next()){
                                        var u = (s1 = l(s1.value)).next().value;
                                        if (s1.next().value == a1.startTime) {
                                            n && (e.B = Math.max(e.B, u)), i.Dd = u;
                                            break;
                                        }
                                    }
                                }
                                if (!(0 > e.B)) for(i = (n = l(t)).next(); !i.done; i = n.next())(i = (r = i.value).stream.segmentIndex) && (i.g.splice(0, e.B - r.Dd), (i = i.g[0] || null) && Sf(e, r, -i.startTime));
                            }(e, t) : function(e, t) {
                                if (1 / 0 == e.M) for(var n = l(t), r = n.next(); !r.done; r = n.next()){
                                    var i = r.value.stream.segmentIndex.g[0] || null;
                                    null != i && null != i.g && (e.M = Math.min(e.M, i.g));
                                }
                                if (1 / 0 != (n = e.M)) for(r = (i = l(e.h.values())).next(); !r.done; r = i.next()){
                                    var a1 = (r = r.value).stream.segmentIndex;
                                    null != a1 && (null == (a1 = a1.g[0] || null).g ? q("Missing EXT-X-PROGRAM-DATE-TIME for stream", r.zc, "Expect AV sync issues!") : Sf(e, r, a1.g - n - a1.startTime));
                                }
                            }(e, t);
                        }
                        function Mf(e, t, n, r, i, a1, o, s1, u, c, d, f, h, g, p) {
                            var m, v, y, E, b, A, _, S, w, I, R, C, D, k, N, x, M, O, P;
                            return L(function(F) {
                                if (1 == F.g) {
                                    if (1 != t.type) throw new De(2, 4, 4017);
                                    m = rf(t.g, "EXT-X-DEFINE"), v = If(e, m);
                                    var U = of(t.g, "EXT-X-PLAYLIST-TYPE"), j = of(t.g, "EXT-X-ENDLIST");
                                    if (j = U && "VOD" == U.value || j, U = U && "EVENT" == U.value && !j, U = !j && !U, j) Wf(e, Zf);
                                    else {
                                        if (Wf(e, U ? eh : $f), !(j = of(t.g, "EXT-X-TARGETDURATION"))) throw new De(2, 4, 4024, "EXT-X-TARGETDURATION");
                                        j = Number(j.value), U = of(t.g, "EXT-X-PART-INF"), e.l && U ? (e.ea = Number(ef(U, "PART-TARGET")), e.H = Math.min(e.ea, e.H), U = of(t.g, "EXT-X-SERVER-CONTROL"), e.W = U ? Number(ef(U, "PART-HOLD-BACK")) : 0) : e.H = Math.min(j, e.H), e.da = Math.max(j, e.da);
                                    }
                                    return p ? F.A(2) : T(F, function(e, t, n, r, i) {
                                        var a1, o, s1, u, l, c, d, f, h, g;
                                        return L(function(p) {
                                            return 1 == p.g ? (a1 = Cr, o = Math.trunc((r.segments.length - 1) / 2), s1 = Vf(r.segments[o].i, i), u = new Ne(s1), l = u.qa.split(".").pop(), c = Qf[t], (d = c[l]) || (d = Xf[l]) || (d = Kf(t, n)) ? p.return(d) : ((f = Sr([
                                                s1
                                            ], e.g.retryParameters)).method = "HEAD", T(p, zf(e, f, a1), 2))) : (h = p.h, (g = h.headers["content-type"]) ? p.return(g.split(";")[0]) : p.return(t == Ze ? "text/vtt" : Qf[t].mp4));
                                        });
                                    }(e, a1, i, t, v), 3);
                                }
                                if (2 != F.g && (p = F.h), y = Pf(t, p), E = y.drmInfos, b = y.keyIds, A = y.encrypted, _ = y.jf, A && !E.length && !_) throw new De(2, 4, 4026);
                                if (S = Yf(e) ? e.F.get(a1) : new Map, w = Hf(e, t, a1, S, v), I = w[w.length - 1].endTime, R = new ps(w), C = a1 == Ze ? "subtitle" : void 0, D = [], f) for(k = l(f.split(",")), N = k.next(); !N.done; N = k.next())x = N.value, D.push(x);
                                return O = !!(M = of(t.g, "EXT-X-SERVER-CONTROL")) && null != M.getAttribute("CAN-SKIP-UNTIL"), (P = Of(e, i, a1, o, s1, u, c, d, h, g)).segmentIndex = R, P.encrypted = A, P.drmInfos = E, P.keyIds = b, P.kind = C, P.roles = D, P.mimeType = p, F.return({
                                    stream: P,
                                    type: a1,
                                    zc: n,
                                    Ic: r,
                                    Za: I,
                                    Lc: O,
                                    lc: !1,
                                    Dd: -1,
                                    $c: S,
                                    Ld: !1
                                });
                            });
                        }
                        function Of(e, t, n, r, i, a1, o, s1, u, l) {
                            var c = Kf(n, t) || (n == Ze ? "text/vtt" : Qf[n].mp4);
                            return {
                                id: e.Ea++,
                                originalId: a1,
                                createSegmentIndex: function() {
                                    return Promise.resolve();
                                },
                                segmentIndex: null,
                                mimeType: c,
                                codecs: t,
                                kind: void 0,
                                encrypted: !1,
                                drmInfos: [],
                                keyIds: new Set,
                                language: r,
                                label: a1,
                                type: n,
                                primary: i,
                                trickModeVideo: null,
                                emsgSchemeIdUris: null,
                                frameRate: void 0,
                                pixelAspectRatio: void 0,
                                width: void 0,
                                height: void 0,
                                bandwidth: void 0,
                                roles: [],
                                forced: u,
                                channelsCount: o,
                                audioSamplingRate: null,
                                spatialAudio: l,
                                closedCaptions: s1,
                                hdr: void 0,
                                tilesLayout: void 0
                            };
                        }
                        function Pf(e, t) {
                            var n = [];
                            if (e.segments) for(var r = l(e.segments), i = r.next(); !i.done; i = r.next())i = rf(i.value.g, "EXT-X-KEY"), n.push.apply(n, c(i));
                            i = r = !1;
                            for(var a1 = [], o = new Set, s1 = (n = l(n)).next(); !s1.done; s1 = n.next()){
                                var u = ef(s1 = s1.value, "METHOD");
                                if ("NONE" != u) {
                                    if (r = !0, "AES-128" == u) i = !0;
                                    else if (u = $d(s1, "KEYFORMAT") || "identity", s1 = (u = Jf[u]) ? u(s1, t) : null) {
                                        if (s1.keyIds) for(var d = (u = l(s1.keyIds)).next(); !d.done; d = u.next())o.add(d.value);
                                        a1.push(s1);
                                    }
                                }
                            }
                            return {
                                drmInfos: a1,
                                keyIds: o,
                                encrypted: r,
                                jf: i
                            };
                        }
                        function Ff(t, n, r) {
                            if (!e.crypto || !e.crypto.subtle) throw Y("Web Crypto API is not available to decrypt AES-128. (Web Crypto only exists in secure origins like https)"), new De(2, 4, 4042);
                            var i = 0, a1 = $d(n, "IV", "");
                            if (a1) {
                                var o = Ct(a1.substr(2));
                                if (16 != o.byteLength) throw new De(2, 4, 4043);
                            } else i = sf(r.g);
                            var s1 = Sr([
                                n = uf(r.h, ef(n, "URI"))
                            ], t.g.retryParameters), u = {
                                method: "AES-128",
                                iv: o,
                                firstMediaSequenceNumber: i,
                                fetchKey: function() {
                                    var n, r;
                                    return L(function(i) {
                                        if (1 == i.g) return T(i, zf(t, s1, 6), 2);
                                        if (3 != i.g) {
                                            if (!(n = i.h).data || 16 != n.data.byteLength) throw new De(2, 4, 4044);
                                            return r = u, T(i, e.crypto.subtle.importKey("raw", n.data, "AES-CBC", !0, [
                                                "decrypt"
                                            ]), 3);
                                        }
                                        r.cryptoKey = i.h, u.fetchKey = void 0, b(i);
                                    });
                                }
                            };
                            return u;
                        }
                        function Uf(e) {
                            var t = e.g.defaultPresentationDelay ? e.g.defaultPresentationDelay : e.W ? e.W : e.da * e.g.hls.liveSegmentsDelay;
                            e.j.We(0), e.j.Ve(t), e.j.xc(!1);
                        }
                        function jf(e, t, n, r) {
                            return (n = of(n, "EXT-X-MAP")) ? (t = [
                                r = Vf(uf(t, ef(n, "URI")), r),
                                $d(n, "BYTERANGE", "")
                            ].join("-"), e.ca.has(t) || (n = function(e, t) {
                                var n = 0, r = null, i = $d(t, "BYTERANGE");
                                return i && (n = i.split("@"), r = Number(n[0]), r = (n = Number(n[1])) + r - 1), new uo(function() {
                                    return [
                                        e
                                    ];
                                }, n, r);
                            }(r, n), e.ca.set(t, n)), e.ca.get(t)) : null;
                        }
                        function Bf(e, t, n, r, i, a1, o, s1, u) {
                            var c = r.g, d = Vf(r.i, a1), f = of(c, "EXTINF"), h = a1 = 0, g = null;
                            r.h.length && !e.l && Y("Low-latency HLS live stream detected, but low-latency streaming mode is not enabled in Shaka Player. Set streaming.lowLatencyMode configuration to true, and see https://bit.ly/3clctcj for details.");
                            var p = null;
                            if (!e.g.hls.ignoreManifestProgramDateTime) {
                                var m = of(c, "EXT-X-PROGRAM-DATE-TIME");
                                m && m.value && (p = li(m.value));
                            }
                            if (m = co, of(c, "EXT-X-GAP") && (m = 2), !f) {
                                if (0 == r.h.length) throw new De(2, 4, 4024, "EXTINF");
                                if (!e.l) return null;
                            }
                            var v = [];
                            if (e.l) for(var y = {}, E = 0; E < r.h.length; y = {
                                qd: y.qd
                            }, E++){
                                var T = r.h[E], b = 0 == E ? n : v[v.length - 1], A = 0 == E ? i : b.endTime, _ = Number($d(T, "DURATION")) || e.ea;
                                if (_) {
                                    _ = A + _;
                                    var S = 0, w = null;
                                    "EXT-X-PRELOAD-HINT" == T.name ? S = (S = $d(T, "BYTERANGE-START")) ? Number(S) : 0 : (S = (w = l(Gf(b, S = $d(T, "BYTERANGE")))).next().value, w = w.next().value), (b = $d(T, "URI")) && (y.qd = uf(o, b), b = co, "YES" == $d(T, "GAP") && (b = 2), v.push(new lo(A, _, function(e) {
                                        return function() {
                                            return [
                                                e.qd
                                            ];
                                        };
                                    }(y), S, w, t, 0, 0, 1 / 0, [], "", null, null, b)));
                                }
                            }
                            return a1 = f ? i + Number(f.value.split(",")[0]) : v[v.length - 1].endTime, (e = of(c, "EXT-X-BYTERANGE")) ? (h = (g = l(Gf(n, e.value))).next().value, g = g.next().value) : v.length && (h = v[0].Aa, g = v[v.length - 1].ka), n = "", e = null, "image" == s1 && (n = "1x1", s1 = of(c, "EXT-X-TILES")) && (n = ef(s1, "LAYOUT"), (s1 = $d(s1, "DURATION")) && (e = Number(s1))), new lo(i, a1, function() {
                                return d.length ? [
                                    d
                                ] : [];
                            }, h, g, t, 0, 0, 1 / 0, v, n, e, p, m, u);
                        }
                        function Gf(e, t) {
                            var n = 0, r = null;
                            return t && (n = t.split("@"), r = Number(n[0]), r = (n = n[1] ? Number(n[1]) : e.ka + 1) + r - 1), [
                                n,
                                r
                            ];
                        }
                        function Hf(e, t, n, r, i) {
                            var a1 = t.segments, o = void 0, s1 = sf(t.g), u = of(t.g, "EXT-X-SKIP"), c = s1 + (u = u ? Number($d(u, "SKIPPED-SEGMENTS")) : 0), d = 0;
                            Yf(e) && r.has(c) && (d = r.get(c));
                            for(var f = [], h = null, g = 0; g < a1.length; g++){
                                var p = a1[g], m = 0 == g ? d : h.endTime;
                                c = s1 + u + g;
                                for(var v = l(p.g), y = v.next(); !y.done; y = v.next())"EXT-X-KEY" == (y = y.value).name && "AES-128" == ef(y, "METHOD") && (o = Ff(e, y, t));
                                r.set(c, m), v = jf(e, t.h, p.g, i), !e.l && e.i.isAutoLowLatencyMode() && (e.i.enableLowLatencyMode(), e.l = e.i.isLowLatencyMode()), (h = p = Bf(e, v, h, p, m, i, t.h, n, o)) && (e.g.hls.ignoreManifestProgramDateTime && null != e.B && c < e.B || f.push(p));
                            }
                            if (e = f.some(function(e) {
                                return null != e.g;
                            })) {
                                for(t = {}, n = 0; n < f.length; t = {
                                    Pb: t.Pb,
                                    Ob: t.Ob,
                                    Ac: t.Ac,
                                    Ua: t.Ua,
                                    Nb: t.Nb
                                }, n++)if (t.Ua = f[n], null == t.Ua.g) for(t.Ob = 0, t.Pb = n, r = function(e) {
                                    return function() {
                                        var t = f[e.Pb];
                                        if (t) {
                                            if (null != t.g) return t.g + e.Ob;
                                            e.Ob -= t.endTime - t.startTime, e.Pb += 1;
                                        }
                                        return null;
                                    };
                                }(t), t.Nb = 0, t.Ac = n, i = function(e) {
                                    return function() {
                                        var t = f[e.Ac];
                                        if (t) {
                                            if (t != e.Ua && (e.Nb += t.endTime - t.startTime), null != t.g) return t.g + e.Nb;
                                            --e.Ac;
                                        }
                                        return null;
                                    };
                                }(t); null == t.Ua.g;)t.Ua.g = i(), null == t.Ua.g && (t.Ua.g = r());
                            }
                            if (e) for(t = (e = l(f)).next(); !t.done; t = e.next())for(t = (n = t.value).g, r = (n = l(n.i)).next(); !r.done; r = n.next())(r = r.value).g = t, t += r.endTime - r.startTime;
                            return f;
                        }
                        function Vf(e, t) {
                            var n = String(e).replace(/%7B/g, "{").replace(/%7D/g, "}"), r = n.match(/{\$\w*}/g);
                            if (r) for(var i = (r = l(r)).next(); !i.done; i = r.next()){
                                var a1 = (i = i.value).slice(2, i.length - 1), o = t.get(a1);
                                if (!o) throw new De(2, 4, 4039, a1);
                                n = n.replace(i, o);
                            }
                            return n;
                        }
                        function Kf(e, t) {
                            if (e == Ze) {
                                if ("vtt" == t || "wvtt" == t) return "text/vtt";
                                if (t && "" !== t) return "application/mp4";
                            }
                            return "image" != e || t && "jpeg" != t ? "audio" == e && "mp4a.40.34" == t ? "audio/mpeg" : null : "image/jpeg";
                        }
                        function qf(e, t) {
                            var n = Sr([
                                t
                            ], e.g.retryParameters);
                            return e.i.modifyManifestRequest(n, {
                                format: "h"
                            }), zf(e, n, 0);
                        }
                        function Yf(e) {
                            return e.ha != Zf;
                        }
                        function Wf(e, t) {
                            e.ha = t, e.j && e.j.xc(!Yf(e)), Yf(e) || e.m.stop();
                        }
                        function zf(e, t, n) {
                            if (!e.G) throw new De(2, 7, 7001);
                            return t = e.i.networkingEngine.request(n, t), br(e.G, t), t.promise;
                        }
                        B("shaka.net.DataUriPlugin", yf), yf.parse = Ef, _r("data", Ef), (r = bf.prototype).configure = function(e) {
                            this.g = e;
                        }, r.start = function(e, t) {
                            var n, r = this;
                            return L(function(i) {
                                return 1 == i.g ? (r.i = t, r.l = t.isLowLatencyMode(), T(i, qf(r, e), 2)) : 3 != i.g ? (n = i.h, r.N = n.uri, T(i, function(e, t, n) {
                                    var r, i, a1, o, s1, u, c, d, f, h, g, p, m, v, y, E, _, S, I, R, C, D, k, N, x, M, O, P, F;
                                    return L(function(U) {
                                        switch(U.g){
                                            case 1:
                                                for(var j = l(rf((r = gf(e.X, t, e.N)).g, "EXT-X-DEFINE")), B = j.next(); !B.done; B = j.next()){
                                                    var G = B.value;
                                                    B = $d(G, "NAME"), G = $d(G, "VALUE"), B && G && (e.o.has(B) || e.o.set(B, G));
                                                }
                                                if (i = [], a1 = [], o = [], 1 == r.type) return I = e.g.hls.mediaPlaylistFullMimeType, r.segments.length && (R = new Ne(r.segments[0].i), C = R.qa.split(".").pop(), (D = Xf[C]) && (I = D)), k = I.split(";")[0], N = k.split("/")[0], x = Vt(I), M = new Map, T(U, Mf(e, r, n, n, x, N, "", !0, "Media Playlist", null, M, null, !1, !1, k), 5);
                                                for(s1 = rf(r.g, "EXT-X-MEDIA"), u = rf(r.g, "EXT-X-STREAM-INF"), c = rf(r.g, "EXT-X-IMAGE-STREAM-INF"), d = rf(r.g, "EXT-X-SESSION-KEY"), B = (j = l(u)).next(); !B.done; B = j.next()){
                                                    var H = B.value;
                                                    G = $d(H, "AUDIO"), B = $d(H, "VIDEO");
                                                    var V = $d(H, "SUBTITLES");
                                                    if (H = Rf(e, H), V) {
                                                        var K = Je(Ze, H);
                                                        e.s.set(V, K), $(H, K);
                                                    }
                                                    G && ((V = Je("audio", H)) || (V = e.g.hls.defaultAudioCodec), e.s.set(G, V)), B && ((G = Je("video", H)) || (G = e.g.hls.defaultVideoCodec), e.s.set(B, G));
                                                }
                                                for(f = rf(r.g, "EXT-X-SESSION-DATA"), h = l(f), g = h.next(); !g.done; g = h.next())p = g.value, m = $d(p, "DATA-ID"), v = $d(p, "URI"), y = $d(p, "LANGUAGE"), E = $d(p, "VALUE"), _ = (new Map).set("id", m), v && _.set("uri", uf(e.N, v)), y && _.set("language", y), E && _.set("value", E), S = new gr("sessiondata", _), e.i && e.i.onEvent(S);
                                                for(function(e, t) {
                                                    t = t.filter(function(e) {
                                                        var t = $d(e, "URI") || "";
                                                        return "SUBTITLES" != $d(e, "TYPE") && "" != t;
                                                    });
                                                    for(var n = l(t), r = n.next(); !r.done; r = n.next())Df(e, r.value);
                                                }(e, s1), B = (j = l(j = af(s1, "CLOSED-CAPTIONS"))).next(); !B.done; B = j.next())B = Cf(V = B.value), G = ef(V, "GROUP-ID"), V = ef(V, "INSTREAM-ID"), e.K.get(G) || e.K.set(G, new Map), e.K.get(G).set(V, B);
                                                return i = function(e, t, n) {
                                                    var r = [], i = new Set;
                                                    if (0 < n.length) for(var a1 = (n = l(n)).next(); !a1.done; a1 = n.next()){
                                                        var o = ef(a1 = a1.value, "METHOD");
                                                        if ("NONE" != o && "AES-128" != o && (o = $d(a1, "KEYFORMAT") || "identity", a1 = (o = Jf[o]) ? o(a1, "") : null)) {
                                                            if (a1.keyIds) for(var s1 = (o = l(a1.keyIds)).next(); !s1.done; s1 = o.next())i.add(s1.value);
                                                            r.push(a1);
                                                        }
                                                    }
                                                    return t = t.map(function(t) {
                                                        var n = $d(t, "FRAME-RATE"), a1 = Number($d(t, "AVERAGE-BANDWIDTH")) || Number(ef(t, "BANDWIDTH")), o = $d(t, "RESOLUTION"), s1 = (o = l(o ? o.split("x") : [
                                                            null,
                                                            null
                                                        ])).next().value, u = o.next().value, c = $d(t, "VIDEO-RANGE");
                                                        t = function(e, t) {
                                                            var n = Rf(e, t), r = $d(t, "AUDIO"), i = $d(t, "VIDEO"), a1 = r || i;
                                                            a1 = a1 && e.u.has(a1) ? e.u.get(a1) : [], r = {
                                                                audio: r ? a1 : [],
                                                                video: i ? a1 : []
                                                            }, i = !1;
                                                            var o = ef(t, "URI"), s1 = r.audio.find(function(e) {
                                                                return e && e.zc == o;
                                                            }), u = Je("video", n), l = Je("audio", n);
                                                            return l && !u ? a1 = "audio" : !a1.length && l && u ? (a1 = "video", n = [
                                                                [
                                                                    u,
                                                                    l
                                                                ].join()
                                                            ]) : r.audio.length && s1 ? (a1 = "audio", i = !0) : a1 = r.video.length ? "audio" : "video", i || (n = function(e, t, n, r) {
                                                                var i = Vf(ef(t, "URI"), e.o);
                                                                return e.h.has(i) ? e.h.get(i) : (t = $d(t, "CLOSED-CAPTIONS"), t = "video" == r && t && "NONE" != t ? e.K.get(t) : null, r = kf(e, i, n = Qe(r, n), r, "und", !1, null, null, t, null, !1, !1), e.h.has(i) ? e.h.get(i) : (e.h.set(i, r), r));
                                                            }(e, t, n, a1), r[n.stream.type] = [
                                                                n
                                                            ]), r;
                                                        }(e, t), o = t.audio;
                                                        for(var d = l(t = t.video), f = d.next(); !f.done; f = d.next())(f = f.value.stream) && (f.width = Number(s1) || void 0, f.height = Number(u) || void 0, f.frameRate = Number(n) || void 0, f.hdr = c || void 0);
                                                        for(n = e.g.disableAudio, o.length && !n || (o = [
                                                            null
                                                        ]), n = e.g.disableVideo, t.length && !n || (t = [
                                                            null
                                                        ]), n = [], s1 = (o = l(o)).next(); !s1.done; s1 = o.next())for(s1 = s1.value, c = (u = l(t)).next(); !c.done; c = u.next()){
                                                            var h = c.value;
                                                            (c = s1 ? s1.stream : null) && (c.drmInfos = r, c.keyIds = i), (d = h ? h.stream : null) && (d.drmInfos = r, d.keyIds = i), f = s1 ? s1.stream.drmInfos : null;
                                                            var g = h ? h.stream.drmInfos : null;
                                                            h = (h ? h.zc : "") + " - " + (s1 ? s1.zc : ""), c && d && f.length && g.length && !(0 < Mi(f, g).length) || e.ta.has(h) || (c = {
                                                                id: e.Ea++,
                                                                language: c ? c.language : "und",
                                                                primary: !!c && c.primary || !!d && d.primary,
                                                                audio: c,
                                                                video: d,
                                                                bandwidth: a1,
                                                                allowedByApplication: !0,
                                                                allowedByKeySystem: !0,
                                                                decodingInfos: []
                                                            }, n.push(c), e.ta.add(h));
                                                        }
                                                        return n;
                                                    }).reduce(qe, []), t.filter(function(e) {
                                                        return null != e;
                                                    });
                                                }(e, u, d), a1 = function(e, t) {
                                                    for(var n = af(t, "SUBTITLES"), r = n.map(function(t) {
                                                        if (e.g.disableText) return null;
                                                        try {
                                                            return Df(e, t).stream;
                                                        } catch (t) {
                                                            if (e.g.hls.ignoreTextStreamFailures) return null;
                                                            throw t;
                                                        }
                                                    }), i = (n = l(n)).next(); !i.done; i = n.next()){
                                                        var a1 = ef(i.value, "GROUP-ID");
                                                        if ((i = e.s.get(a1)) && (a1 = e.u.get(a1))) for(var o = (a1 = l(a1)).next(); !o.done; o = a1.next())o.value.stream.codecs = i;
                                                    }
                                                    return r.filter(function(e) {
                                                        return e;
                                                    });
                                                }(e, s1), T(U, function(e, t) {
                                                    var n, r;
                                                    return L(function(i) {
                                                        return 1 == i.g ? (n = t.map(function(t) {
                                                            var n, r;
                                                            return L(function(i) {
                                                                if (1 == i.g) return e.g.disableThumbnails ? i.return(null) : (A(i, 2), T(i, function(e, t) {
                                                                    var n, r, i, a1, o, s1, u, l, c, d;
                                                                    return L(function(f) {
                                                                        return 1 == f.g ? (n = Vf(ef(t, "URI"), e.o), r = $d(t, "CODECS", "jpeg") || "", e.h.has(n) ? f.return(e.h.get(n)) : (i = Cf(t), a1 = $d(t, "NAME"), o = $d(t, "CHARACTERISTICS"), s1 = kf(e, n, r, "image", i, !1, a1, null, null, o, !1, !1), e.h.has(n) ? f.return(e.h.get(n)) : (u = $d(t, "RESOLUTION")) ? T(f, s1.stream.createSegmentIndex(), 3) : f.A(2))) : (2 != f.g && (l = s1.stream.segmentIndex.get(0), c = l.tilesLayout) && (s1.stream.width = Number(u.split("x")[0]) * Number(c.split("x")[0]), s1.stream.height = Number(u.split("x")[1]) * Number(c.split("x")[1])), (d = $d(t, "BANDWIDTH")) && (s1.stream.bandwidth = Number(d)), e.h.set(n, s1), f.return(s1));
                                                                    });
                                                                }(e, t), 4));
                                                                if (2 != i.g) return n = i.h, i.return(n.stream);
                                                                if (r = w(i), e.g.hls.ignoreImageStreamFailures) return i.return(null);
                                                                throw r;
                                                            });
                                                        }), T(i, Promise.all(n), 2)) : (r = i.h, i.return(r.filter(function(e) {
                                                            return e;
                                                        })));
                                                    });
                                                }(e, c), 4);
                                            case 4:
                                                o = U.h, U.A(3);
                                                break;
                                            case 5:
                                                O = U.h, e.h.set(n, O), i.push({
                                                    id: 0,
                                                    language: "und",
                                                    disabledUntilTime: 0,
                                                    primary: !0,
                                                    audio: "audio" == N ? O.stream : null,
                                                    video: "video" == N ? O.stream : null,
                                                    bandwidth: 0,
                                                    allowedByApplication: !0,
                                                    allowedByKeySystem: !0,
                                                    decodingInfos: []
                                                });
                                            case 3:
                                                if (!e.i) throw new De(2, 7, 7001);
                                                e.j = new Xo(null, 0), e.j.xc(!0), 1 == r.type && (Yf(e) && (Uf(e), P = e.P, e.m.O(P)), F = Array.from(e.h.values()), xf(e, F), wf(e)), e.D = {
                                                    presentationTimeline: e.j,
                                                    variants: i,
                                                    textStreams: a1,
                                                    imageStreams: o,
                                                    offlineSessionIds: [],
                                                    minBufferTime: 0,
                                                    sequenceMode: !0
                                                }, e.i.makeTextStreamsForClosedCaptions(e.D), b(U);
                                        }
                                    });
                                }(r, n.data, e), 3)) : i.return(r.D);
                            });
                        }, r.stop = function() {
                            this.m && (this.m.stop(), this.m = null);
                            var e = [];
                            return this.G && (e.push(this.G.destroy()), this.G = null), this.g = this.i = null, this.ta.clear(), this.D = null, this.h.clear(), this.u.clear(), this.s.clear(), this.o.clear(), Promise.all(e);
                        }, r.update = function() {
                            var e, t, n, r, i, a1, o, s1, u = this;
                            return L(function(d) {
                                if (1 == d.g) {
                                    if (!Yf(u)) return d.return();
                                    for(e = [], t = Array.from(u.h.values()), n = t.filter(function(e) {
                                        return e.stream.segmentIndex;
                                    }), r = l(n), i = r.next(); !i.done; i = r.next())a1 = i.value, e.push(_f(u, a1));
                                    return T(d, Promise.all(e), 2);
                                }
                                Lf(u, n.map(function(e) {
                                    return e.stream;
                                })), o = n.some(function(e) {
                                    return 0 == e.lc;
                                }), n.length && !o && (Wf(u, th.ef), s1 = t.map(function(e) {
                                    return e.Za;
                                }), u.j.Ia(Math.min.apply(Math, c(s1))), u.i.updateDuration()), b(d);
                            });
                        }, r.onExpirationUpdated = function() {}, B("shaka.hls.HlsParser", bf);
                        var Xf = {
                            aac: "audio/aac",
                            ac3: "audio/ac3",
                            ec3: "audio/ec3",
                            mp3: "audio/mpeg"
                        }, Qf = {
                            audio: {
                                mp4: "audio/mp4",
                                mp4a: "audio/mp4",
                                m4s: "audio/mp4",
                                m4i: "audio/mp4",
                                m4a: "audio/mp4",
                                m4f: "audio/mp4",
                                cmfa: "audio/mp4",
                                ts: "video/mp2t"
                            },
                            video: {
                                mp4: "video/mp4",
                                mp4v: "video/mp4",
                                m4s: "video/mp4",
                                m4i: "video/mp4",
                                m4v: "video/mp4",
                                m4f: "video/mp4",
                                cmfv: "video/mp4",
                                ts: "video/mp2t"
                            },
                            text: {
                                mp4: "application/mp4",
                                m4s: "application/mp4",
                                m4i: "application/mp4",
                                m4f: "application/mp4",
                                cmft: "application/mp4",
                                vtt: "text/vtt",
                                webvtt: "txt/vtt",
                                ttml: "application/ttml+xml"
                            },
                            image: {
                                jpg: "image/jpeg",
                                png: "image/png",
                                svg: "image/svg+xml",
                                webp: "image/webp",
                                avif: "image/avif"
                            }
                        }, Jf = {
                            "com.apple.streamingkeydelivery": function(t, n) {
                                if ("video/mp2t" == n) throw new De(2, 4, 4040);
                                if (e.shakaMediaKeysPolyfill) throw new De(2, 4, 4041);
                                return Xe("com.apple.fps", [
                                    {
                                        initDataType: "sinf",
                                        initData: new Uint8Array(0),
                                        keyId: null
                                    }
                                ]);
                            },
                            "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": function(e) {
                                var t = ef(e, "METHOD");
                                return [
                                    "SAMPLE-AES",
                                    "SAMPLE-AES-CTR"
                                ].includes(t) ? (t = Xe("com.widevine.alpha", [
                                    {
                                        initDataType: "cenc",
                                        initData: t = Ie((t = Tf(t = ef(e, "URI"))).data)
                                    }
                                ]), (e = $d(e, "KEYID")) && (t.keyIds = new Set([
                                    e.toLowerCase().substr(2)
                                ])), t) : null;
                            },
                            "com.microsoft.playready": function(e) {
                                var t = ef(e, "METHOD");
                                return [
                                    "SAMPLE-AES",
                                    "SAMPLE-AES-CTR"
                                ].includes(t) ? Xe("com.microsoft.playready", [
                                    {
                                        initDataType: "cenc",
                                        initData: e = $r(e = Ie((e = Tf(e = ef(e, "URI"))).data), t = new Uint8Array([
                                            154,
                                            4,
                                            240,
                                            121,
                                            152,
                                            64,
                                            66,
                                            134,
                                            171,
                                            146,
                                            230,
                                            91,
                                            224,
                                            136,
                                            95,
                                            149
                                        ]), new Set, 0)
                                    }
                                ]) : null;
                            },
                            identity: function(e) {
                                return e = ef(e, "METHOD"), [
                                    "SAMPLE-AES",
                                    "SAMPLE-AES-CTR"
                                ].includes(e) ? Xe("org.w3.clearkey", null) : null;
                            }
                        }, Zf = "VOD", $f = "EVENT", eh = "LIVE", th = {
                            ef: Zf,
                            Og: $f,
                            Tg: eh
                        };
                        function nh(e, t, n, r, i, a1) {
                            if (200 <= n && 299 >= n && 202 != n) return {
                                uri: i || r,
                                Ne: r,
                                data: t,
                                status: n,
                                headers: e,
                                fromCache: !!e["x-shaka-from-cache"]
                            };
                            i = null;
                            try {
                                i = Tt(t);
                            } catch (e) {}
                            throw new De(401 == n || 403 == n ? 2 : 1, 1, 1001, r, n, i, e, a1);
                        }
                        function rh() {}
                        function ih(e, t, n, r, i) {
                            var a1 = new ch;
                            Fr(t.headers).forEach(function(e, t) {
                                a1.append(t, e);
                            });
                            var o = new uh, s1 = {
                                we: !1,
                                af: !1
                            };
                            if (e = function(e, t, n, r, i, a1, o) {
                                var s1, u, l, c, d, f, h, g, p, m, v, y;
                                return L(function(E) {
                                    switch(E.g){
                                        case 1:
                                            return s1 = sh, u = lh, f = d = 0, h = Date.now(), A(E, 2), T(E, s1(e, n), 4);
                                        case 4:
                                            return l = E.h, a1(ah(l.headers)), g = l.clone().body.getReader(), m = (p = l.headers.get("Content-Length")) ? parseInt(p, 10) : 0, new u({
                                                start: function(e) {
                                                    !function t() {
                                                        var n, r;
                                                        return L(function(a1) {
                                                            switch(a1.g){
                                                                case 1:
                                                                    return A(a1, 2), T(a1, g.read(), 4);
                                                                case 4:
                                                                    n = a1.h, S(a1, 3);
                                                                    break;
                                                                case 2:
                                                                    return w(a1), a1.return();
                                                                case 3:
                                                                    if (n.done) {
                                                                        a1.A(5);
                                                                        break;
                                                                    }
                                                                    if (d += n.value.byteLength, !o) {
                                                                        a1.A(5);
                                                                        break;
                                                                    }
                                                                    return T(a1, o(n.value), 5);
                                                                case 5:
                                                                    (100 < (r = Date.now()) - h || n.done) && (i(r - h, d - f, m - d), f = d, h = r), n.done ? e.close() : (e.enqueue(n.value), t()), b(a1);
                                                            }
                                                        });
                                                    }();
                                                }
                                            }), T(E, l.arrayBuffer(), 5);
                                        case 5:
                                            c = E.h, S(E, 3);
                                            break;
                                        case 2:
                                            if (v = w(E), r.we) throw new De(1, 1, 7001, e, t);
                                            if (r.af) throw new De(1, 1, 1003, e, t);
                                            throw new De(1, 1, 1002, e, v, t);
                                        case 3:
                                            return y = ah(l.headers), E.return(nh(y, c, l.status, e, l.url, t));
                                    }
                                });
                            }(e, n, {
                                body: t.body || void 0,
                                headers: a1,
                                method: t.method,
                                signal: o.signal,
                                credentials: t.allowCrossSiteCredentials ? "include" : void 0
                            }, s1, r, i, t.streamDataCallback), e = new ur(e, function() {
                                return s1.we = !0, o.abort(), Promise.resolve();
                            }), t = t.retryParameters.timeout) {
                                var u = new it(function() {
                                    s1.af = !0, o.abort();
                                });
                                u.O(t / 1e3), e.finally(function() {
                                    u.stop();
                                });
                            }
                            return e;
                        }
                        function ah(e) {
                            var t = {};
                            return e.forEach(function(e, n) {
                                t[n.trim()] = e;
                            }), t;
                        }
                        function oh() {
                            if (!e.ReadableStream) return !1;
                            try {
                                new ReadableStream({});
                            } catch (e) {
                                return !1;
                            }
                            return !(!e.fetch || !e.AbortController);
                        }
                        ht("Tizen 3") || ht("Tizen 2") || lt() || (zi.m3u8 = function() {
                            return new bf;
                        }, Wi["application/x-mpegurl"] = function() {
                            return new bf;
                        }, Wi["application/vnd.apple.mpegurl"] = function() {
                            return new bf;
                        }), B("shaka.net.HttpFetchPlugin", rh), rh.isSupported = oh, rh.parse = ih;
                        var sh = e.fetch, uh = e.AbortController, lh = e.ReadableStream, ch = e.Headers;
                        function dh() {}
                        function fh(e, t, n, r, i) {
                            var a1 = new gh, o = Date.now(), s1 = 0;
                            return new ur(new Promise(function(u, l) {
                                a1.open(t.method, e, !0), a1.responseType = "arraybuffer", a1.timeout = t.retryParameters.timeout, a1.withCredentials = t.allowCrossSiteCredentials, a1.onabort = function() {
                                    l(new De(1, 1, 7001, e, n));
                                };
                                var c = !1;
                                for(var d in a1.onreadystatechange = function() {
                                    if (2 == a1.readyState && !c) {
                                        var e = hh(a1);
                                        i(e), c = !0;
                                    }
                                }, a1.onload = function() {
                                    var t = hh(a1), r = a1.response;
                                    try {
                                        var i = nh(t, r, a1.status, e, a1.responseURL, n);
                                        u(i);
                                    } catch (e) {
                                        l(e);
                                    }
                                }, a1.onerror = function(t) {
                                    l(new De(1, 1, 1002, e, t, n));
                                }, a1.ontimeout = function() {
                                    l(new De(1, 1, 1003, e, n));
                                }, a1.onprogress = function(e) {
                                    var t = Date.now();
                                    (100 < t - o || e.lengthComputable && e.loaded == e.total) && (r(t - o, e.loaded - s1, e.total - e.loaded), s1 = e.loaded, o = t);
                                }, t.headers)a1.setRequestHeader(d.toLowerCase(), t.headers[d]);
                                a1.send(t.body);
                            }), function() {
                                return a1.abort(), Promise.resolve();
                            });
                        }
                        function hh(e) {
                            var t = e.getAllResponseHeaders().trim().split("\r\n");
                            e = {};
                            for(var n = (t = l(t)).next(); !n.done; n = t.next())e[(n = n.value.split(": "))[0].toLowerCase()] = n.slice(1).join(": ");
                            return e;
                        }
                        oh() && (_r("http", ih, 2, !0), _r("https", ih, 2, !0), _r("blob", ih, 2, !0)), B("shaka.net.HttpXHRPlugin", dh), dh.parse = fh;
                        var gh = e.XMLHttpRequest;
                        function ph(e, t, n, r) {
                            this.g = e, this.i = t, this.groupId = n, this.h = r;
                        }
                        function mh(e) {
                            return e.xa().map(function(e) {
                                return "{" + encodeURI(e) + "}";
                            }).join("") + ":" + e.Aa + ":" + e.ka;
                        }
                        function vh(e, t) {
                            return Ns(e.g.xa(), e.g.Aa, e.g.ka, t.streaming.retryParameters);
                        }
                        function yh() {
                            this.h = this.j = this.i = 0, this.g = new Map, this.l = 0;
                        }
                        function Eh(e, t) {
                            e.i += t;
                            var n = e.l;
                            return e.l++, e.g.set(n, t), n;
                        }
                        function Th(e) {
                            var t = this;
                            this.o = e, this.j = new Map, this.i = new Nr(function() {
                                return bh(t).catch(function() {});
                            }), this.h = [], this.m = function() {}, this.l = function() {}, this.g = new yh;
                        }
                        function bh(e) {
                            var t = e.h.map(function(e) {
                                return e();
                            });
                            return e.h = [], Promise.all(t);
                        }
                        function Ah(e, t, n, r, i, a1) {
                            Lr(e.i);
                            var o = (e.j.get(t) || Promise.resolve()).then(function() {
                                var t, o, s1, u, l, c, d;
                                return L(function(f) {
                                    if (1 == f.g) return T(f, function(e, t) {
                                        var n, r, i, a1;
                                        return L(function(o) {
                                            return 1 == o.g ? (n = Cr, r = e.o.request(n, t), i = function() {
                                                return r.abort();
                                            }, e.h.push(i), T(o, r.promise, 2)) : (a1 = o.h, $(e.h, i), o.return(a1.data));
                                        });
                                    }(e, n), 2);
                                    if (t = f.h, e.i.g) throw new De(2, 9, 7001);
                                    if (i) for(u in o = Ie(t), (s1 = new Zr(o)).data)l = Number(u), c = s1.data[l], d = s1.g[l], e.l(c, d);
                                    e.g.close(r, t.byteLength);
                                    var h = e.g;
                                    return e.m(0 == h.i ? 0 : h.j / h.i, e.g.h), f.return(a1(t));
                                });
                            });
                            e.j.set(t, o);
                        }
                        function _h(e, t) {
                            var n = this;
                            this.i = e, this.h = e.objectStore(t), this.g = new tt, e.onabort = function(e) {
                                e.preventDefault(), n.g.reject();
                            }, e.onerror = function(e) {
                                e.preventDefault(), n.g.reject();
                            }, e.oncomplete = function() {
                                n.g.resolve();
                            };
                        }
                        function Sh(e, t) {
                            return new Promise(function(n, r) {
                                var i = e.h.openCursor();
                                i.onerror = r, i.onsuccess = function() {
                                    var e;
                                    return L(function(r) {
                                        if (1 == r.g) return null == i.result ? (n(), r.return()) : (e = i.result, T(r, t(e.key, e.value, e), 2));
                                        e.continue(), b(r);
                                    });
                                };
                            });
                        }
                        function wh(e) {
                            this.h = e, this.g = [];
                        }
                        function Ih(e, t) {
                            return Rh(e, t, "readwrite");
                        }
                        function Rh(e, t, n) {
                            var r = new _h(n = e.h.transaction([
                                t
                            ], n), t);
                            return e.g.push(r), r.promise().then(function() {
                                $(e.g, r);
                            }, function() {
                                $(e.g, r);
                            }), r;
                        }
                        function Ch(e, t, n) {
                            this.h = new wh(e), this.i = t, this.g = n;
                        }
                        function Dh(e) {
                            return Promise.reject(new De(2, 9, 9011, "Cannot add new value to " + e));
                        }
                        function kh(e, t, n, r) {
                            t = (e = Ih(e.h, t)).store();
                            for(var i = {}, a1 = (n = l(n)).next(); !a1.done; i = {
                                Dc: i.Dc
                            }, a1 = n.next())i.Dc = a1.value, t.delete(i.Dc).onsuccess = function(e) {
                                return function() {
                                    return r(e.Dc);
                                };
                            }(i);
                            return e.promise();
                        }
                        function Nh(e, t, n) {
                            var r, i, a1, o, s1, u, c;
                            return L(function(d) {
                                if (1 == d.g) {
                                    for(r = Rh(e.h, t, "readonly"), i = r.store(), a1 = {}, o = [], s1 = {}, u = l(n), c = u.next(); !c.done; s1 = {
                                        Ub: s1.Ub,
                                        Sb: s1.Sb
                                    }, c = u.next())s1.Sb = c.value, s1.Ub = i.get(s1.Sb), s1.Ub.onsuccess = function(e) {
                                        return function() {
                                            null == e.Ub.result && o.push(e.Sb), a1[e.Sb] = e.Ub.result;
                                        };
                                    }(s1);
                                    return T(d, r.promise(), 2);
                                }
                                if (o.length) throw new De(2, 9, 9012, "Could not find values for " + o);
                                return d.return(n.map(function(e) {
                                    return a1[e];
                                }));
                            });
                        }
                        function Lh(e) {
                            this.g = new wh(e);
                        }
                        function xh() {
                            this.g = new Map;
                        }
                        function Mh(e) {
                            var t = null;
                            if (e.g.forEach(function(e, n) {
                                e.getCells().forEach(function(e, r) {
                                    e.hasFixedKeySpace() || t || (t = {
                                        path: {
                                            za: n,
                                            ja: r
                                        },
                                        ja: e
                                    });
                                });
                            }), t) return t;
                            throw new De(2, 9, 9013, "Could not find a cell that supports add-operations");
                        }
                        function Oh(e, t, n) {
                            if (!(e = e.g.get(t))) throw new De(2, 9, 9013, "Could not find mechanism with name " + t);
                            if (!(t = e.getCells().get(n))) throw new De(2, 9, 9013, "Could not find cell with name " + n);
                            return t;
                        }
                        function Ph(e, t) {
                            Fh.set(e, t);
                        }
                        _r("http", fh, 1, !0), _r("https", fh, 1, !0), _r("blob", fh, 1, !0), yh.prototype.close = function(e, t) {
                            if (this.g.has(e)) {
                                var n = this.g.get(e);
                                this.g.delete(e), this.j += n, this.h += t;
                            }
                        }, Th.prototype.destroy = function() {
                            return this.i.destroy();
                        }, _h.prototype.abort = function() {
                            var e = this;
                            return L(function(t) {
                                if (1 == t.g) {
                                    try {
                                        e.i.abort();
                                    } catch (e) {}
                                    return A(t, 2), T(t, e.g, 4);
                                }
                                if (2 != t.g) return S(t, 0);
                                w(t), b(t);
                            });
                        }, _h.prototype.store = function() {
                            return this.h;
                        }, _h.prototype.promise = function() {
                            return this.g;
                        }, wh.prototype.destroy = function() {
                            return Promise.all(this.g.map(function(e) {
                                return e.abort();
                            }));
                        }, (r = Ch.prototype).destroy = function() {
                            return this.h.destroy();
                        }, r.hasFixedKeySpace = function() {
                            return !0;
                        }, r.addSegments = function() {
                            return Dh(this.i);
                        }, r.removeSegments = function(e, t) {
                            return kh(this, this.i, e, t);
                        }, r.getSegments = function(e) {
                            var t, n = this;
                            return L(function(r) {
                                return 1 == r.g ? T(r, Nh(n, n.i, e), 2) : (t = r.h, r.return(t.map(function(e) {
                                    return n.xe(e);
                                })));
                            });
                        }, r.addManifests = function() {
                            return Dh(this.g);
                        }, r.updateManifest = function() {
                            return Promise.reject(new De(2, 9, 9016, "Cannot modify values in " + this.g));
                        }, r.updateManifestExpiration = function(e, t) {
                            var n = Ih(this.h, this.g), r = n.store();
                            return r.get(e).onsuccess = function(n) {
                                (n = n.target.result) && (n.expiration = t, r.put(n, e));
                            }, n.promise();
                        }, r.removeManifests = function(e, t) {
                            return kh(this, this.g, e, t);
                        }, r.getManifests = function(e) {
                            var t, n = this;
                            return L(function(r) {
                                return 1 == r.g ? T(r, Nh(n, n.g, e), 2) : (t = r.h, r.return(Promise.all(t.map(function(e) {
                                    return n.bc(e);
                                }))));
                            });
                        }, r.getAllManifests = function() {
                            var e, t, n = this;
                            return L(function(r) {
                                return 1 == r.g ? (e = Rh(n.h, n.g, "readonly"), t = new Map, T(r, Sh(e, function(e, r) {
                                    var i;
                                    return L(function(a1) {
                                        if (1 == a1.g) return T(a1, n.bc(r), 2);
                                        i = a1.h, t.set(e, i), b(a1);
                                    });
                                }), 2)) : 3 != r.g ? T(r, e.promise(), 3) : r.return(t);
                            });
                        }, r.xe = function(e) {
                            return e;
                        }, r.bc = function(e) {
                            return Promise.resolve(e);
                        }, r.add = function(e, t) {
                            var n, r, i, a1, o, s1, u, c = this;
                            return L(function(d) {
                                if (1 == d.g) {
                                    for(n = Ih(c.h, e), r = n.store(), i = [], a1 = {}, o = l(t), s1 = o.next(); !s1.done; a1 = {
                                        Ec: a1.Ec
                                    }, s1 = o.next())u = s1.value, a1.Ec = r.add(u), a1.Ec.onsuccess = function(e) {
                                        return function() {
                                            i.push(e.Ec.result);
                                        };
                                    }(a1);
                                    return T(d, n.promise(), 2);
                                }
                                return d.return(i);
                            });
                        }, Lh.prototype.destroy = function() {
                            return this.g.destroy();
                        }, Lh.prototype.getAll = function() {
                            var e, t, n = this;
                            return L(function(r) {
                                return 1 == r.g ? (e = Rh(n.g, "session-ids", "readonly"), t = [], T(r, Sh(e, function(e, n) {
                                    t.push(n);
                                }), 2)) : 3 != r.g ? T(r, e.promise(), 3) : r.return(t);
                            });
                        }, Lh.prototype.add = function(e) {
                            for(var t = Ih(this.g, "session-ids"), n = t.store(), r = (e = l(e)).next(); !r.done; r = e.next())n.add(r.value);
                            return t.promise();
                        }, Lh.prototype.remove = function(e) {
                            var t, n = this;
                            return L(function(r) {
                                return 1 == r.g ? T(r, Sh(t = Ih(n.g, "session-ids"), function(t, n, r) {
                                    e.includes(n.sessionId) && r.delete();
                                }), 2) : T(r, t.promise(), 0);
                            });
                        }, xh.prototype.destroy = function() {
                            for(var e = [], t = l(this.g.values()), n = t.next(); !n.done; n = t.next())e.push(n.value.destroy());
                            return this.g.clear(), Promise.all(e);
                        }, xh.prototype.init = function() {
                            var e = this;
                            Fh.forEach(function(t, n) {
                                var r = t();
                                r && e.g.set(n, r);
                            });
                            for(var t = [], n = l(this.g.values()), r = n.next(); !r.done; r = n.next())t.push(r.value.init());
                            return Promise.all(t);
                        }, B("shaka.offline.StorageMuxer", xh), xh.unregister = function(e) {
                            Fh.delete(e);
                        }, xh.register = Ph, xh.prototype.destroy = xh.prototype.destroy;
                        var Fh = new Map;
                        function Uh() {
                            Ch.apply(this, arguments);
                        }
                        function jh(e, t) {
                            !function(e) {
                                var t = e.streams.filter(function(e) {
                                    return "audio" == e.contentType;
                                });
                                if (e = e.streams.filter(function(e) {
                                    return "video" == e.contentType;
                                }), !t.every(function(e) {
                                    return e.variantIds;
                                }) || !e.every(function(e) {
                                    return e.variantIds;
                                })) {
                                    for(var n = l(t), r = n.next(); !r.done; r = n.next())r.value.variantIds = [];
                                    for(r = (n = l(e)).next(); !r.done; r = n.next())r.value.variantIds = [];
                                    if (n = 0, e.length && !t.length) {
                                        var i = n++, a1 = l(e);
                                        for(r = a1.next(); !r.done; r = a1.next())r.value.variantIds.push(i);
                                    }
                                    if (!e.length && t.length) for(i = n++, r = (a1 = l(t)).next(); !r.done; r = a1.next())r.value.variantIds.push(i);
                                    if (e.length && t.length) for(r = (t = l(t)).next(); !r.done; r = t.next())for(r = r.value, a1 = (i = l(e)).next(); !a1.done; a1 = i.next()){
                                        a1 = a1.value;
                                        var o = n++;
                                        r.variantIds.push(o), a1.variantIds.push(o);
                                    }
                                }
                            }(e);
                            for(var n = l(e.streams), r = n.next(); !r.done; r = n.next());
                            return e.streams.map(function(n) {
                                return function(e, t, n) {
                                    var r = e.initSegmentUri ? Bh(e.initSegmentUri) : null, i = t + e.presentationTimeOffset, a1 = t + n;
                                    return {
                                        id: e.id,
                                        originalId: null,
                                        primary: e.primary,
                                        type: e.contentType,
                                        mimeType: e.mimeType,
                                        codecs: e.codecs,
                                        frameRate: e.frameRate,
                                        pixelAspectRatio: void 0,
                                        hdr: void 0,
                                        kind: e.kind,
                                        language: e.language,
                                        label: e.label,
                                        width: e.width,
                                        height: e.height,
                                        initSegmentKey: r,
                                        encrypted: e.encrypted,
                                        keyIds: new Set([
                                            e.keyId
                                        ]),
                                        segments: e.segments.map(function(e) {
                                            var n = Bh(e.uri);
                                            return {
                                                startTime: t + e.startTime,
                                                endTime: t + e.endTime,
                                                dataKey: n,
                                                initSegmentKey: r,
                                                appendWindowStart: t,
                                                appendWindowEnd: a1,
                                                timestampOffset: i,
                                                tilesLayout: ""
                                            };
                                        }),
                                        variantIds: e.variantIds,
                                        roles: [],
                                        forced: !1,
                                        audioSamplingRate: null,
                                        channelsCount: null,
                                        spatialAudio: !1,
                                        closedCaptions: null,
                                        tilesLayout: void 0
                                    };
                                }(n, e.startTime, t);
                            });
                        }
                        function Bh(e) {
                            var t;
                            if ((t = /^offline:[0-9]+\/[0-9]+\/([0-9]+)$/.exec(e)) || (t = /^offline:segment\/([0-9]+)$/.exec(e))) return Number(t[1]);
                            throw new De(2, 9, 9004, "Could not parse uri " + e);
                        }
                        function Gh() {
                            Ch.apply(this, arguments);
                        }
                        function Hh(e, t, n) {
                            return {
                                id: e.id,
                                originalId: e.originalId,
                                primary: e.primary,
                                type: e.contentType,
                                mimeType: e.mimeType,
                                codecs: e.codecs,
                                frameRate: e.frameRate,
                                pixelAspectRatio: e.pixelAspectRatio,
                                hdr: void 0,
                                kind: e.kind,
                                language: e.language,
                                label: e.label,
                                width: e.width,
                                height: e.height,
                                encrypted: e.encrypted,
                                keyIds: new Set([
                                    e.keyId
                                ]),
                                segments: e.segments.map(function(r) {
                                    return {
                                        startTime: t + r.startTime,
                                        endTime: t + r.endTime,
                                        initSegmentKey: e.initSegmentKey,
                                        appendWindowStart: t,
                                        appendWindowEnd: n,
                                        timestampOffset: t - e.presentationTimeOffset,
                                        dataKey: r.dataKey,
                                        tilesLayout: ""
                                    };
                                }),
                                variantIds: e.variantIds,
                                roles: [],
                                forced: !1,
                                audioSamplingRate: null,
                                channelsCount: null,
                                spatialAudio: !1,
                                closedCaptions: null,
                                tilesLayout: void 0
                            };
                        }
                        function Vh() {
                            Ch.apply(this, arguments);
                        }
                        function Kh() {
                            this.m = this.j = this.i = this.h = this.g = this.l = null;
                        }
                        function qh(e, t, n, r) {
                            this.g = e, this.i = t, this.h = n, this.l = r, this.j = [
                                "offline:",
                                e,
                                "/",
                                t,
                                "/",
                                n,
                                "/",
                                r
                            ].join("");
                        }
                        function Yh(e) {
                            if (null == (e = /^offline:([a-z]+)\/([^/]+)\/([^/]+)\/([0-9]+)$/.exec(e))) return null;
                            var t = e[1];
                            if ("manifest" != t && "segment" != t) return null;
                            var n = e[2];
                            if (!n) return null;
                            var r = e[3];
                            return r && null != t ? new qh(t, n, r, Number(e[4])) : null;
                        }
                        function Wh(e, t) {
                            this.h = e, this.g = t;
                        }
                        function zh(e, t) {
                            var n = new Xo(null, 0);
                            n.Ia(t.duration);
                            var r = t.streams.filter(function(e) {
                                return "audio" == e.type;
                            }), i = t.streams.filter(function(e) {
                                return "video" == e.type;
                            });
                            r = function(e, t, n, r) {
                                for(var i = new Set, a1 = l(t), o = a1.next(); !o.done; o = a1.next()){
                                    var s1 = l(o.value.variantIds);
                                    for(o = s1.next(); !o.done; o = s1.next())i.add(o.value);
                                }
                                for(o = (a1 = l(n)).next(); !o.done; o = a1.next())for(o = (s1 = l(o.value.variantIds)).next(); !o.done; o = s1.next())i.add(o.value);
                                for(a1 = new Map, o = (i = l(i)).next(); !o.done; o = i.next())o = o.value, a1.set(o, {
                                    id: o,
                                    language: "",
                                    disabledUntilTime: 0,
                                    primary: !1,
                                    audio: null,
                                    video: null,
                                    bandwidth: 0,
                                    allowedByApplication: !0,
                                    allowedByKeySystem: !0,
                                    decodingInfos: []
                                });
                                for(i = (t = l(t)).next(); !i.done; i = t.next())for(o = Xh(e, i = i.value, r), i = (s1 = l(i.variantIds)).next(); !i.done; i = s1.next())(i = a1.get(i.value)).language = o.language, i.primary = i.primary || o.primary, i.audio = o;
                                for(t = (n = l(n)).next(); !t.done; t = n.next())for(t = Xh(e, i = t.value, r), i = (o = l(i.variantIds)).next(); !i.done; i = o.next())(i = a1.get(i.value)).primary = i.primary || t.primary, i.video = t;
                                return a1;
                            }(e, r, i, n), i = t.streams.filter(function(e) {
                                return e.type == Ze;
                            }).map(function(t) {
                                return Xh(e, t, n);
                            });
                            var a1 = t.streams.filter(function(e) {
                                return "image" == e.type;
                            }).map(function(t) {
                                return Xh(e, t, n);
                            }), o = t.drmInfo ? [
                                t.drmInfo
                            ] : [];
                            if (t.drmInfo) for(var s1 = l(r.values()), u = s1.next(); !u.done; u = s1.next())(u = u.value).audio && u.audio.encrypted && (u.audio.drmInfos = o), u.video && u.video.encrypted && (u.video.drmInfos = o);
                            return {
                                presentationTimeline: n,
                                minBufferTime: 2,
                                offlineSessionIds: t.sessionIds,
                                variants: Array.from(r.values()),
                                textStreams: i,
                                imageStreams: a1,
                                sequenceMode: t.sequenceMode || !1
                            };
                        }
                        function Xh(e, t, n) {
                            var r = t.segments.map(function(t) {
                                return function(e, t) {
                                    var n = new qh("segment", e.h, e.g, t.dataKey);
                                    return new lo(t.startTime, t.endTime, function() {
                                        return [
                                            n.toString()
                                        ];
                                    }, 0, null, null != t.initSegmentKey ? function(e, t) {
                                        var n = new qh("segment", e.h, e.g, t);
                                        return new uo(function() {
                                            return [
                                                n.toString()
                                            ];
                                        }, 0, null);
                                    }(e, t.initSegmentKey) : null, t.timestampOffset, t.appendWindowStart, t.appendWindowEnd, [], t.tilesLayout || "");
                                }(e, t);
                            });
                            return n.Hb(r), {
                                id: t.id,
                                originalId: t.originalId,
                                createSegmentIndex: function() {
                                    return Promise.resolve();
                                },
                                segmentIndex: new ps(r),
                                mimeType: t.mimeType,
                                codecs: t.codecs,
                                width: t.width || void 0,
                                height: t.height || void 0,
                                frameRate: t.frameRate,
                                pixelAspectRatio: t.pixelAspectRatio,
                                hdr: t.hdr,
                                kind: t.kind,
                                encrypted: t.encrypted,
                                drmInfos: [],
                                keyIds: t.keyIds,
                                language: t.language,
                                label: t.label,
                                type: t.type,
                                primary: t.primary,
                                trickModeVideo: null,
                                emsgSchemeIdUris: null,
                                roles: t.roles,
                                forced: t.forced,
                                channelsCount: t.channelsCount,
                                audioSamplingRate: t.audioSamplingRate,
                                spatialAudio: t.spatialAudio,
                                closedCaptions: t.closedCaptions,
                                tilesLayout: t.tilesLayout
                            };
                        }
                        function Qh() {
                            this.g = null;
                        }
                        function Jh() {}
                        function Zh(e) {
                            var t = Yh(e);
                            return e = t && "manifest" == t.g ? dr(e = {
                                uri: e,
                                Ne: e,
                                data: new ArrayBuffer(0),
                                headers: {
                                    "content-type": "application/x-offline-manifest"
                                }
                            }) : t && "segment" == t.g ? function(e, t) {
                                var n = new xh;
                                return dr(void 0).Y(function() {
                                    return n.init();
                                }).Y(function() {
                                    return Oh(n, t.za(), t.ja());
                                }).Y(function(e) {
                                    return e.getSegments([
                                        t.key()
                                    ]);
                                }).Y(function(e) {
                                    return {
                                        uri: t,
                                        data: e[0].data,
                                        headers: {}
                                    };
                                }).finally(function() {
                                    return n.destroy();
                                });
                            }(t.key(), t) : lr(new De(2, 1, 9004, e));
                        }
                        function $h(e, t, n) {
                            var r, i, a1, o, s1, u;
                            return L(function(c) {
                                switch(c.g){
                                    case 1:
                                        r = [];
                                        for(var d = [], f = l(n), h = f.next(); !h.done; h = f.next()){
                                            h = h.value;
                                            for(var g = !1, p = l(d), m = p.next(); !m.done; m = p.next())if (eg((m = m.value).info, h)) {
                                                m.sessionIds.push(h.sessionId), g = !0;
                                                break;
                                            }
                                            g || d.push({
                                                info: h,
                                                sessionIds: [
                                                    h.sessionId
                                                ]
                                            });
                                        }
                                        i = l(d), a1 = i.next();
                                    case 2:
                                        if (a1.done) {
                                            c.A(4);
                                            break;
                                        }
                                        return o = a1.value, s1 = function(e, t, n) {
                                            var r, i;
                                            return L(function(a1) {
                                                switch(a1.g){
                                                    case 1:
                                                        return r = new Ti({
                                                            lb: t,
                                                            onError: function() {},
                                                            cd: function() {},
                                                            onExpirationUpdated: function() {},
                                                            onEvent: function() {}
                                                        }), A(a1, 2), r.configure(e), T(a1, function(e, t, n, r, i, a1) {
                                                            var o = new Map;
                                                            return (i = {
                                                                audioCapabilities: i,
                                                                videoCapabilities: a1,
                                                                distinctiveIdentifier: "optional",
                                                                persistentState: "required",
                                                                sessionTypes: [
                                                                    "persistent-license"
                                                                ],
                                                                label: t
                                                            }).drmInfos = [
                                                                {
                                                                    keySystem: t,
                                                                    licenseServerUri: n,
                                                                    distinctiveIdentifierRequired: !1,
                                                                    persistentStateRequired: !0,
                                                                    audioRobustness: "",
                                                                    videoRobustness: "",
                                                                    serverCertificate: r,
                                                                    serverCertificateUri: "",
                                                                    initData: null,
                                                                    keyIds: null
                                                                }
                                                            ], o.set(t, i), Di(e, o, []);
                                                        }(r, n.info.keySystem, n.info.licenseUri, n.info.serverCertificate, n.info.audioCapabilities, n.info.videoCapabilities), 4);
                                                    case 4:
                                                        S(a1, 3);
                                                        break;
                                                    case 2:
                                                        return w(a1), T(a1, r.destroy(), 5);
                                                    case 5:
                                                    case 9:
                                                        return a1.return([]);
                                                    case 3:
                                                        return A(a1, 6), T(a1, Si(r), 8);
                                                    case 8:
                                                        S(a1, 7);
                                                        break;
                                                    case 6:
                                                        return w(a1), T(a1, r.destroy(), 9);
                                                    case 7:
                                                        return i = [], T(a1, Promise.all(n.sessionIds.map(function(e) {
                                                            return L(function(t) {
                                                                return 1 == t.g ? (A(t, 2), T(t, function(e, t) {
                                                                    var n, r, i;
                                                                    return L(function(a1) {
                                                                        return 1 == a1.g ? T(a1, ki(e, t), 2) : 3 != a1.g ? (n = a1.h) ? (r = [], (i = e.i.get(n)) && (i.Ja = new tt, r.push(i.Ja)), r.push(n.remove()), T(a1, Promise.all(r), 3)) : a1.return() : (e.i.delete(n), void b(a1));
                                                                    });
                                                                }(r, e), 4)) : 2 != t.g ? (i.push(e), S(t, 0)) : (w(t), void b(t));
                                                            });
                                                        })), 10);
                                                    case 10:
                                                        return T(a1, r.destroy(), 11);
                                                    case 11:
                                                        return a1.return(i);
                                                }
                                            });
                                        }(e, t, o), T(c, s1, 5);
                                    case 5:
                                        u = c.h, r = r.concat(u), a1 = i.next(), c.A(2);
                                        break;
                                    case 4:
                                        return c.return(r);
                                }
                            });
                        }
                        function eg(e, t) {
                            function n(e, t) {
                                return e.robustness == t.robustness && e.contentType == t.contentType;
                            }
                            return e.keySystem == t.keySystem && e.licenseUri == t.licenseUri && ee(e.audioCapabilities, t.audioCapabilities, n) && ee(e.videoCapabilities, t.videoCapabilities, n);
                        }
                        function tg(e, t) {
                            var n = zh(new Wh(e.za(), e.ja()), t), r = t.appMetadata || {};
                            return n = ng(n), {
                                offlineUri: e.toString(),
                                originalManifestUri: t.originalManifestUri,
                                duration: t.duration,
                                size: t.size,
                                expiration: t.expiration,
                                tracks: n,
                                appMetadata: r,
                                isIncomplete: t.isIncomplete || !1
                            };
                        }
                        function ng(e) {
                            for(var t = [], n = function(e) {
                                return e.filter(function(e) {
                                    return Dn(e);
                                });
                            }(e.variants), r = (n = l(n)).next(); !r.done; r = n.next())t.push(An(r.value));
                            for(n = (e = l(e.textStreams)).next(); !n.done; n = e.next())t.push(_n(n.value));
                            return t;
                        }
                        function rg() {
                            this.g = {};
                        }
                        function ig(e, t) {
                            var n = t.audio, r = t.video;
                            if (n && !r && (e.g[n.id] = n.bandwidth || t.bandwidth), !n && r && (e.g[r.id] = r.bandwidth || t.bandwidth), n && r) {
                                var i = n.bandwidth || 393216, a1 = r.bandwidth || t.bandwidth - i;
                                0 >= a1 && (a1 = t.bandwidth), e.g[n.id] = i, e.g[r.id] = a1;
                            }
                        }
                        function ag(e, t) {
                            e.g[t.id] = t.bandwidth || 2048;
                        }
                        function og(e, t) {
                            var n = e.g[t];
                            return null == n && (n = 0), n;
                        }
                        function sg(e) {
                            var t = this;
                            if (e && e.constructor != xu) throw new De(2, 9, 9008);
                            this.g = this.h = null, e ? (this.h = e.h, this.g = e.ic()) : (this.h = wu(), this.g = new Ar), this.i = [], this.j = [];
                            var n = !e;
                            this.l = new Nr(function() {
                                var e, r, i, a1, o;
                                return L(function(s1) {
                                    switch(s1.g){
                                        case 1:
                                            return T(s1, Promise.all(t.j.map(function(e) {
                                                return bh(e);
                                            })), 2);
                                        case 2:
                                            for(e = function() {}, r = [], i = l(t.i), a1 = i.next(); !a1.done; a1 = i.next())o = a1.value, r.push(o.then(e, e));
                                            return T(s1, Promise.all(r), 3);
                                        case 3:
                                            if (!n) {
                                                s1.A(4);
                                                break;
                                            }
                                            return T(s1, t.g.destroy(), 4);
                                        case 4:
                                            t.h = null, t.g = null, b(s1);
                                    }
                                });
                            });
                        }
                        function ug() {
                            if (at()) e: {
                                for(var e = l(Fh.values()), t = e.next(); !t.done; t = e.next())if (t = (t = t.value)()) {
                                    t.destroy(), e = !0;
                                    break e;
                                }
                                e = !1;
                            }
                            else e = !1;
                            return e;
                        }
                        function lg(e) {
                            var t, n, r;
                            return L(function(i) {
                                switch(i.g){
                                    case 1:
                                        return T(i, (t = new xh).init(), 2);
                                    case 2:
                                        return T(i, Mh(t), 3);
                                    case 3:
                                        return n = i.h, r = new qh("manifest", n.path.za, n.path.ja, e), T(i, t.destroy(), 4);
                                    case 4:
                                        return T(i, (new sg).remove(r.toString()), 0);
                                }
                            });
                        }
                        function cg(e, t, n, r, i, a1) {
                            var o, s1, u, c, d, f, h, g, p, m, v;
                            return L(function(y) {
                                switch(y.g){
                                    case 1:
                                        for(o = !1, A(y, 2), s1 = !0, u = l(n.streams), c = u.next(); !c.done; c = u.next())for(d = c.value, f = l(d.segments), h = f.next(); !h.done; h = f.next())g = h.value, null != (p = g.pendingSegmentRefId ? r[g.pendingSegmentRefId] : null) && (g.dataKey = p, g.pendingSegmentRefId = void 0), null != (p = g.pendingInitSegmentRefId ? r[g.pendingInitSegmentRefId] : null) && (g.initSegmentKey = p, g.pendingInitSegmentRefId = void 0), g.pendingSegmentRefId && (s1 = !1), g.pendingInitSegmentRefId && (s1 = !1);
                                        return n.size += i, s1 && (n.isIncomplete = !1), T(y, e.updateManifest(t, n), 4);
                                    case 4:
                                        o = !0, a1(), S(y, 0);
                                        break;
                                    case 2:
                                        return m = w(y), T(y, lg(t), 5);
                                    case 5:
                                        if (o) {
                                            y.A(6);
                                            break;
                                        }
                                        return v = Object.values(r), T(y, e.removeSegments(v, function() {}), 6);
                                    case 6:
                                        throw m;
                                }
                            });
                        }
                        function dg(e) {
                            return e.variants.some(function(e) {
                                var t = e.audio && e.audio.encrypted;
                                return e.video && e.video.encrypted || t;
                            });
                        }
                        function fg(e) {
                            return e.variants.some(function(e) {
                                return (e.video ? e.video.drmInfos : []).concat(e.audio ? e.audio.drmInfos : []).some(function(e) {
                                    return e.initData && e.initData.length;
                                });
                            });
                        }
                        function hg(e, t) {
                            for(var n = [], r = l(e.streams), i = r.next(); !i.done; i = r.next())i = i.value, t && "video" == i.type ? n.push({
                                contentType: Bt(i.mimeType, i.codecs),
                                robustness: e.drmInfo.videoRobustness
                            }) : t || "audio" != i.type || n.push({
                                contentType: Bt(i.mimeType, i.codecs),
                                robustness: e.drmInfo.audioRobustness
                            });
                            return n;
                        }
                        function gg(e, t, n) {
                            return L(function(r) {
                                return T(r, function(e, t, n, r) {
                                    var i, a1, o;
                                    return L(function(s1) {
                                        return 1 == s1.g ? r.drmInfo ? (i = function(e) {
                                            var t = Array.from(e.g.keys());
                                            if (!t.length) throw new De(2, 9, 9e3, "No supported storage mechanisms found");
                                            return e.g.get(t[0]).getEmeSessionCell();
                                        }(n), a1 = r.sessionIds.map(function(e) {
                                            return {
                                                sessionId: e,
                                                keySystem: r.drmInfo.keySystem,
                                                licenseUri: r.drmInfo.licenseServerUri,
                                                serverCertificate: r.drmInfo.serverCertificate,
                                                audioCapabilities: hg(r, !1),
                                                videoCapabilities: hg(r, !0)
                                            };
                                        }), T(s1, $h(t, e, a1), 2)) : s1.return() : 3 != s1.g ? (o = s1.h, T(s1, i.remove(o), 3)) : T(s1, i.add(a1.filter(function(e) {
                                            return !o.includes(e.sessionId);
                                        })), 0);
                                    });
                                }(e.g, e.h.drm, n, t), 0);
                            });
                        }
                        function pg(e, t, n) {
                            function r() {}
                            var i = function(e) {
                                for(var t = new Set, n = (e = l(e.streams)).next(); !n.done; n = e.next())for(var r = (n = l(n.value.segments)).next(); !r.done; r = n.next())null != (r = r.value).initSegmentKey && t.add(r.initSegmentKey), t.add(r.dataKey);
                                return Array.from(t);
                            }(n);
                            return tg(t, n), Promise.all([
                                e.removeSegments(i, r),
                                e.removeManifests([
                                    t.key()
                                ], r)
                            ]);
                        }
                        function mg(e, t, n, r, i, a1) {
                            var o = {
                                id: r.id,
                                originalId: r.originalId,
                                primary: r.primary,
                                type: r.type,
                                mimeType: r.mimeType,
                                codecs: r.codecs,
                                frameRate: r.frameRate,
                                pixelAspectRatio: r.pixelAspectRatio,
                                hdr: r.hdr,
                                kind: r.kind,
                                language: r.language,
                                label: r.label,
                                width: r.width || null,
                                height: r.height || null,
                                encrypted: r.encrypted,
                                keyIds: r.keyIds,
                                segments: [],
                                variantIds: [],
                                roles: r.roles,
                                forced: r.forced,
                                channelsCount: r.channelsCount,
                                audioSamplingRate: r.audioSamplingRate,
                                spatialAudio: r.spatialAudio,
                                closedCaptions: r.closedCaptions,
                                tilesLayout: r.tilesLayout
                            }, s1 = i.offline.numberOfParallelDownloads, u = 0;
                            return function(e, t, n) {
                                if (null != (t = e.segmentIndex.find(t))) for(var r = e.segmentIndex.get(t); r;)n(r), r = e.segmentIndex.get(++t);
                            }(r, n.presentationTimeline.Oa(), function(n) {
                                var i = mh(n), l = void 0;
                                if (!a1.has(i)) {
                                    var c = n.endTime - n.startTime;
                                    c = og(t, r.id) * c, c = Eh(e.g, c), a1.set(i, new ph(n, c, u, !1));
                                }
                                n.h && (l = mh(n.h), a1.has(l) || (c = .5 * og(t, r.id), c = Eh(e.g, c), a1.set(l, new ph(n.h, c, u, !0)))), o.segments.push({
                                    pendingInitSegmentRefId: l,
                                    initSegmentKey: l ? 0 : null,
                                    startTime: n.startTime,
                                    endTime: n.endTime,
                                    appendWindowStart: n.appendWindowStart,
                                    appendWindowEnd: n.appendWindowEnd,
                                    timestampOffset: n.timestampOffset,
                                    tilesLayout: n.tilesLayout,
                                    pendingSegmentRefId: i,
                                    dataKey: 0
                                }), u = (u + 1) % s1;
                            }), o;
                        }
                        function vg(e) {
                            if (e.l.g) throw new De(2, 9, 7001);
                        }
                        function yg() {
                            if (!ug()) throw new De(2, 9, 9e3);
                        }
                        function Eg(e, t) {
                            return L(function(n) {
                                return 1 == n.g ? (e.i.push(t), _(n), T(n, t, 4)) : 2 != n.g ? n.return(n.h) : (I(n), $(e.i, t), R(n, 0));
                            });
                        }
                        function Tg(e) {
                            for(var t = new Set, n = l(e.textStreams), r = n.next(); !r.done; r = n.next())t.add(r.value);
                            for(r = (n = l(e.imageStreams)).next(); !r.done; r = n.next())t.add(r.value);
                            for(n = (e = l(e.variants)).next(); !n.done; n = e.next())(n = n.value).audio && t.add(n.audio), n.video && t.add(n.video);
                            return t;
                        }
                        m(Uh, Ch), Uh.prototype.updateManifestExpiration = function(e, t) {
                            var n, r, i, a1 = this;
                            return L(function(o) {
                                return n = Ih(a1.h, a1.g), r = n.store(), i = new tt, r.get(e).onsuccess = function(n) {
                                    (n = n.target.result) ? (n.expiration = t, r.put(n), i.resolve()) : i.reject(new De(2, 9, 9012, "Could not find values for " + e));
                                }, T(o, Promise.all([
                                    n.promise(),
                                    i
                                ]), 0);
                            });
                        }, Uh.prototype.bc = function(e) {
                            var t, n, r, i, a1, o;
                            return L(function(s1) {
                                if (1 == s1.g) {
                                    for(t = [], n = 0; n < e.periods.length; ++n)r = n == e.periods.length - 1 ? e.duration : e.periods[n + 1].startTime, i = r - e.periods[n].startTime, a1 = jh(e.periods[n], i), t.push(a1);
                                    return T(s1, vd(t), 2);
                                }
                                return o = s1.h, s1.return({
                                    creationTime: 0,
                                    originalManifestUri: e.originalManifestUri,
                                    duration: e.duration,
                                    size: e.size,
                                    expiration: null == e.expiration ? 1 / 0 : e.expiration,
                                    streams: o,
                                    sessionIds: e.sessionIds,
                                    drmInfo: e.drmInfo,
                                    appMetadata: e.appMetadata,
                                    sequenceMode: !1
                                });
                            });
                        }, Uh.prototype.xe = function(e) {
                            return {
                                data: e.data
                            };
                        }, m(Gh, Ch), Gh.prototype.bc = function(e) {
                            var t, n, r, i, a1, o;
                            return L(function(s1) {
                                if (1 == s1.g) {
                                    for(t = [], n = 0; n < e.periods.length; ++n){
                                        r = n == e.periods.length - 1 ? e.duration : e.periods[n + 1].startTime, i = r - e.periods[n].startTime;
                                        for(var u = e.periods[n], c = [], d = l(u.streams), f = d.next(); !f.done; f = d.next())0 != (f = f.value).variantIds.length && c.push(Hh(f, u.startTime, u.startTime + i));
                                        a1 = c, t.push(a1);
                                    }
                                    return T(s1, vd(t), 2);
                                }
                                return o = s1.h, s1.return({
                                    appMetadata: e.appMetadata,
                                    creationTime: 0,
                                    drmInfo: e.drmInfo,
                                    duration: e.duration,
                                    expiration: null == e.expiration ? 1 / 0 : e.expiration,
                                    originalManifestUri: e.originalManifestUri,
                                    sessionIds: e.sessionIds,
                                    size: e.size,
                                    streams: o,
                                    sequenceMode: !1
                                });
                            });
                        }, m(Vh, Ch), (r = Vh.prototype).hasFixedKeySpace = function() {
                            return !1;
                        }, r.addSegments = function(e) {
                            return this.add(this.i, e);
                        }, r.addManifests = function(e) {
                            return this.add(this.g, e);
                        }, r.updateManifest = function(e, t) {
                            return function(e, t, n) {
                                var r = (e = Ih(e.h, e.g)).store();
                                return r.get(t).onsuccess = function() {
                                    r.put(n, t);
                                }, e.promise();
                            }(this, e, t);
                        }, r.bc = function(e) {
                            return null == e.expiration && (e.expiration = 1 / 0), Promise.resolve(e);
                        }, (r = Kh.prototype).init = function() {
                            var t = this, n = new tt, r = !1, i = new it(function() {
                                r = !0, n.reject(new De(2, 9, 9017));
                            });
                            i.O(2);
                            var a1 = e.indexedDB.open("shaka_offline_db", 5);
                            return a1.onsuccess = function() {
                                if (!r) {
                                    var e = a1.result;
                                    t.l = e;
                                    var o = e.objectStoreNames;
                                    o = o.contains("manifest") && o.contains("segment") ? new Uh(e, "segment", "manifest") : null, t.g = o, o = (o = e.objectStoreNames).contains("manifest-v2") && o.contains("segment-v2") ? new Gh(e, "segment-v2", "manifest-v2") : null, t.h = o, o = (o = e.objectStoreNames).contains("manifest-v3") && o.contains("segment-v3") ? new Gh(e, "segment-v3", "manifest-v3") : null, t.i = o, o = (o = e.objectStoreNames).contains("manifest-v5") && o.contains("segment-v5") ? new Vh(e, "segment-v5", "manifest-v5") : null, t.j = o, e = e.objectStoreNames.contains("session-ids") ? new Lh(e) : null, t.m = e, i.stop(), n.resolve();
                                }
                            }, a1.onupgradeneeded = function() {
                                for(var e = a1.result, t = l([
                                    "segment-v5",
                                    "manifest-v5",
                                    "session-ids"
                                ]), n = t.next(); !n.done; n = t.next())n = n.value, e.objectStoreNames.contains(n) || e.createObjectStore(n, {
                                    autoIncrement: !0
                                });
                            }, a1.onerror = function(e) {
                                r || (n.reject(new De(2, 9, 9001, a1.error)), i.stop(), e.preventDefault());
                            }, n;
                        }, r.destroy = function() {
                            var e = this;
                            return L(function(t) {
                                switch(t.g){
                                    case 1:
                                        if (!e.g) {
                                            t.A(2);
                                            break;
                                        }
                                        return T(t, e.g.destroy(), 2);
                                    case 2:
                                        if (!e.h) {
                                            t.A(4);
                                            break;
                                        }
                                        return T(t, e.h.destroy(), 4);
                                    case 4:
                                        if (!e.i) {
                                            t.A(6);
                                            break;
                                        }
                                        return T(t, e.i.destroy(), 6);
                                    case 6:
                                        if (!e.j) {
                                            t.A(8);
                                            break;
                                        }
                                        return T(t, e.j.destroy(), 8);
                                    case 8:
                                        if (!e.m) {
                                            t.A(10);
                                            break;
                                        }
                                        return T(t, e.m.destroy(), 10);
                                    case 10:
                                        e.l && e.l.close(), b(t);
                                }
                            });
                        }, r.getCells = function() {
                            var e = new Map;
                            return this.g && e.set("v1", this.g), this.h && e.set("v2", this.h), this.i && e.set("v3", this.i), this.j && e.set("v5", this.j), e;
                        }, r.getEmeSessionCell = function() {
                            return this.m;
                        }, r.erase = function() {
                            var t = this;
                            return L(function(n) {
                                switch(n.g){
                                    case 1:
                                        if (!t.g) {
                                            n.A(2);
                                            break;
                                        }
                                        return T(n, t.g.destroy(), 2);
                                    case 2:
                                        if (!t.h) {
                                            n.A(4);
                                            break;
                                        }
                                        return T(n, t.h.destroy(), 4);
                                    case 4:
                                        if (!t.i) {
                                            n.A(6);
                                            break;
                                        }
                                        return T(n, t.i.destroy(), 6);
                                    case 6:
                                        if (!t.j) {
                                            n.A(8);
                                            break;
                                        }
                                        return T(n, t.j.destroy(), 8);
                                    case 8:
                                        return t.l && t.l.close(), T(n, function() {
                                            var t = new tt, n = e.indexedDB.deleteDatabase("shaka_offline_db");
                                            return n.onblocked = function() {}, n.onsuccess = function() {
                                                t.resolve();
                                            }, n.onerror = function(e) {
                                                t.reject(new De(2, 9, 9001, n.error)), e.preventDefault();
                                            }, t;
                                        }(), 10);
                                    case 10:
                                        return t.l = null, t.g = null, t.h = null, t.i = null, t.j = null, T(n, t.init(), 0);
                                }
                            });
                        }, Ph("idb", function() {
                            return ht("CrKey") || st() || !e.indexedDB ? null : new Kh;
                        }), qh.prototype.za = function() {
                            return this.i;
                        }, qh.prototype.ja = function() {
                            return this.h;
                        }, qh.prototype.key = function() {
                            return this.l;
                        }, qh.prototype.toString = function() {
                            return this.j;
                        }, (r = Qh.prototype).configure = function() {}, r.start = function(e, t) {
                            var n, r, i, a1, o, s1, u = this;
                            return L(function(l) {
                                switch(l.g){
                                    case 1:
                                        if (n = Yh(e), u.g = n, null == n || "manifest" != n.g) throw new De(2, 1, 9004, e);
                                        return r = new xh, _(l), T(l, r.init(), 4);
                                    case 4:
                                        return T(l, Oh(r, n.za(), n.ja()), 5);
                                    case 5:
                                        return T(l, l.h.getManifests([
                                            n.key()
                                        ]), 6);
                                    case 6:
                                        return i = l.h, a1 = i[0], o = new Wh(n.za(), n.ja()), s1 = zh(o, a1), t.makeTextStreamsForClosedCaptions(s1), l.return(s1);
                                    case 2:
                                        return I(l), T(l, r.destroy(), 7);
                                    case 7:
                                        R(l, 0);
                                }
                            });
                        }, r.stop = function() {
                            return Promise.resolve();
                        }, r.update = function() {}, r.onExpirationUpdated = function(e, t) {
                            var n, r, i, a1, o, s1, u, l = this;
                            return L(function(c) {
                                switch(c.g){
                                    case 1:
                                        return n = l.g, r = new xh, A(c, 2, 3), T(c, r.init(), 5);
                                    case 5:
                                        return T(c, Oh(r, n.za(), n.ja()), 6);
                                    case 6:
                                        return T(c, (i = c.h).getManifests([
                                            n.key()
                                        ]), 7);
                                    case 7:
                                        if (a1 = c.h, o = a1[0], s1 = o.sessionIds.includes(e), u = null == o.expiration || o.expiration > t, !s1 || !u) {
                                            c.A(3);
                                            break;
                                        }
                                        return T(c, i.updateManifestExpiration(n.key(), t), 3);
                                    case 3:
                                        return I(c), T(c, r.destroy(), 10);
                                    case 10:
                                        R(c, 0);
                                        break;
                                    case 2:
                                        w(c), c.A(3);
                                }
                            });
                        }, Wi["application/x-offline-manifest"] = function() {
                            return new Qh;
                        }, B("shaka.offline.OfflineScheme", Jh), Jh.plugin = Zh, _r("offline", Zh), (r = sg.prototype).destroy = function() {
                            return this.l.destroy();
                        }, r.configure = function(e, t) {
                            return 2 == arguments.length && "string" == typeof e && (e = Au(e, t)), Iu(this.h, e);
                        }, r.getConfiguration = function() {
                            var e = wu();
                            return Iu(e, this.h, wu()), e;
                        }, r.ic = function() {
                            return this.g;
                        }, r.store = function(e, t, n) {
                            var r = this, i = this.getConfiguration(), a1 = new Th(this.g);
                            return this.j.push(a1), t = function(e, t, n, r, i, a1) {
                                var o, s1, u, c, d, f, h, g, p, m, v, y, E;
                                return L(function(_) {
                                    switch(_.g){
                                        case 1:
                                            return yg(), s1 = o = null, u = new xh, f = d = c = null, A(_, 2, 3), T(_, r(), 5);
                                        case 5:
                                            return o = _.h, T(_, function(e, t, n, r) {
                                                var i, a1, o, s1, u;
                                                return L(function(l) {
                                                    if (1 == l.g) return i = null, a1 = e.g, o = {
                                                        networkingEngine: a1,
                                                        modifyManifestRequest: function() {},
                                                        modifySegmentRequest: function() {},
                                                        filter: function() {
                                                            return Promise.resolve();
                                                        },
                                                        makeTextStreamsForClosedCaptions: function() {},
                                                        onTimelineRegionAdded: function() {},
                                                        onEvent: function() {},
                                                        onError: function(e) {
                                                            i = e;
                                                        },
                                                        isLowLatencyMode: function() {
                                                            return !1;
                                                        },
                                                        isAutoLowLatencyMode: function() {
                                                            return !1;
                                                        },
                                                        enableLowLatencyMode: function() {},
                                                        updateDuration: function() {},
                                                        newDrmInfo: function() {}
                                                    }, n.configure(r.manifest), vg(e), T(l, n.start(t, o), 2);
                                                    if (3 != l.g) return s1 = l.h, vg(e), u = Tg(s1), T(l, Promise.all(Pr(u, function(e) {
                                                        return e.createSegmentIndex();
                                                    })), 3);
                                                    if (vg(e), i) throw i;
                                                    return l.return(s1);
                                                });
                                            }(e, t, o, i), 6);
                                        case 6:
                                            if (h = _.h, vg(e), h.presentationTimeline.U() || h.presentationTimeline.kb()) throw new De(2, 9, 9005, t);
                                            return T(_, function(e, t, n, r) {
                                                var i;
                                                return L(function(a1) {
                                                    switch(a1.g){
                                                        case 1:
                                                            return (i = new Ti({
                                                                lb: e.g,
                                                                onError: n,
                                                                cd: function() {},
                                                                onExpirationUpdated: function() {},
                                                                onEvent: function() {}
                                                            })).configure(r.drm), T(a1, function(e, t, n) {
                                                                return e.ea = !0, e.B = [], e.M = n, Ai(e, t);
                                                            }(i, t.variants, r.offline.usePersistentLicense), 2);
                                                        case 2:
                                                            return T(a1, Si(i), 3);
                                                        case 3:
                                                            return T(a1, wi(i), 4);
                                                        case 4:
                                                            return a1.return(i);
                                                    }
                                                });
                                            }(e, h, function(e) {
                                                f = f || e;
                                            }, i), 7);
                                        case 7:
                                            if (s1 = _.h, vg(e), f) throw f;
                                            return T(_, function(e, t) {
                                                var n, r, i, a1, o, s1, u, c, d, f, h, g, p, m, v, y, E, _, I, R, C, D, k, N, x, M, O, P;
                                                return L(function(L) {
                                                    switch(L.g){
                                                        case 1:
                                                            return n = {
                                                                width: 1 / 0,
                                                                height: 1 / 0
                                                            }, function(e, t, n) {
                                                                e.variants = e.variants.filter(function(e) {
                                                                    return hn(e, t, n);
                                                                });
                                                            }(e, t.restrictions, n), T(L, pn(e, t.offline.usePersistentLicense), 2);
                                                        case 2:
                                                            for(r = [], i = t.preferredAudioChannelCount, a1 = t.preferredDecodingAttributes, o = t.preferredVideoCodecs, s1 = t.preferredAudioCodecs, cn(e, o, s1, i, a1), u = l(e.variants), c = u.next(); !c.done; c = u.next())d = c.value, r.push(An(d));
                                                            for(f = l(e.textStreams), h = f.next(); !h.done; h = f.next())g = h.value, r.push(_n(g));
                                                            for(p = l(e.imageStreams), m = p.next(); !m.done; m = p.next())v = m.value, r.push(Sn(v));
                                                            return T(L, t.offline.trackSelectionCallback(r), 3);
                                                        case 3:
                                                            for(y = L.h, E = e.presentationTimeline.getDuration(), _ = 0, I = l(y), R = I.next(); !R.done; R = I.next())C = R.value, D = C.bandwidth * E / 8, _ += D;
                                                            return A(L, 4), T(L, t.offline.downloadSizeCallback(_), 6);
                                                        case 6:
                                                            if (!L.h) throw new De(2, 9, 9014);
                                                            S(L, 5);
                                                            break;
                                                        case 4:
                                                            if ((k = w(L)) instanceof De) throw k;
                                                            throw new De(2, 9, 9015);
                                                        case 5:
                                                            for(N = new Set, x = new Set, M = new Set, O = l(y), R = O.next(); !R.done; R = O.next())"variant" == (P = R.value).type && N.add(P.id), "text" == P.type && x.add(P.id), "image" == P.type && M.add(P.id);
                                                            e.variants = e.variants.filter(function(e) {
                                                                return N.has(e.id);
                                                            }), e.textStreams = e.textStreams.filter(function(e) {
                                                                return x.has(e.id);
                                                            }), e.imageStreams = e.imageStreams.filter(function(e) {
                                                                return M.has(e.id);
                                                            }), function(e) {
                                                                e.variants.map(function(e) {
                                                                    return e.video;
                                                                });
                                                                var t = new Set(e.variants.map(function(e) {
                                                                    return e.audio;
                                                                }));
                                                                e = e.textStreams;
                                                                for(var n = l(t), r = n.next(); !r.done; r = n.next())for(var i = (r = l(t)).next(); !i.done; i = r.next());
                                                                for(n = (t = l(e)).next(); !n.done; n = t.next())for(r = (n = l(e)).next(); !r.done; r = n.next());
                                                            }(e), b(L);
                                                    }
                                                });
                                            }(h, i), 8);
                                        case 8:
                                            return T(_, u.init(), 9);
                                        case 9:
                                            return vg(e), T(_, Mh(u), 10);
                                        case 10:
                                            return c = _.h, vg(e), g = function(e, t, n, r, i, a1) {
                                                var o = function(e, t, n) {
                                                    return {
                                                        offlineUri: null,
                                                        originalManifestUri: e,
                                                        duration: t.presentationTimeline.getDuration(),
                                                        size: 0,
                                                        expiration: 1 / 0,
                                                        tracks: t = ng(t),
                                                        appMetadata: n,
                                                        isIncomplete: !1
                                                    };
                                                }(n, t, r), s1 = i.offline.progressCallback;
                                                !function(e, t, n) {
                                                    e.m = function(e, t) {
                                                        o.size = t, s1(o, e);
                                                    }, e.l = n;
                                                }(a1, 0, function(t, n) {
                                                    u && i.offline.usePersistentLicense && c == n && Ii(e, "cenc", t);
                                                });
                                                var u = dg(t) && !fg(t), c = null;
                                                u && (c = bg.get(e.g.keySystem));
                                                for(var d = new rg, f = l(t.textStreams), h = f.next(); !h.done; h = f.next())d.g[h.value.id] = 52;
                                                for(h = (f = l(t.imageStreams)).next(); !h.done; h = f.next())ag(d, h.value);
                                                for(f = (h = l(t.variants)).next(); !f.done; f = h.next())ig(d, f.value);
                                                return d = function(e, t, n, r) {
                                                    for(var i = new Map, a1 = Tg(n), o = new Map, s1 = (a1 = l(a1)).next(); !s1.done; s1 = a1.next()){
                                                        var u = mg(e, t, n, s1 = s1.value, r, i);
                                                        o.set(s1.id, u);
                                                    }
                                                    for(t = (e = l(n.variants)).next(); !t.done; t = e.next())(t = t.value).audio && o.get(t.audio.id).variantIds.push(t.id), t.video && o.get(t.video.id).variantIds.push(t.id);
                                                    return {
                                                        streams: Array.from(o.values()),
                                                        ne: Array.from(i.values())
                                                    };
                                                }(a1, d, t, i), a1 = d.streams, d = d.ne, h = e.g, f = i.offline.usePersistentLicense, h && f && (h.initData = []), {
                                                    $f: {
                                                        creationTime: Date.now(),
                                                        originalManifestUri: n,
                                                        duration: t.presentationTimeline.getDuration(),
                                                        size: 0,
                                                        expiration: e.hc(),
                                                        streams: a1,
                                                        sessionIds: f ? Ci(e) : [],
                                                        drmInfo: h,
                                                        appMetadata: r,
                                                        isIncomplete: !0,
                                                        sequenceMode: t.sequenceMode
                                                    },
                                                    ne: d
                                                };
                                            }(s1, h, t, n, i, a1), p = g.$f, m = g.ne, T(_, c.ja.addManifests([
                                                p
                                            ]), 11);
                                        case 11:
                                            if (v = _.h, vg(e), d = v[0], vg(e), f) throw f;
                                            return T(_, function(e, t, n, r, i, a1, o, s1, u) {
                                                var c, d, f, h, g, p, m, v, y, E;
                                                return L(function(_) {
                                                    switch(_.g){
                                                        case 1:
                                                            if (c = {}, d = 0, f = function(t, f) {
                                                                var h, g, p, m, v, y, E;
                                                                return L(function(A) {
                                                                    if (1 == A.g) {
                                                                        for(h = {}, g = l(t), p = g.next(); !p.done; h = {
                                                                            eb: h.eb
                                                                        }, p = g.next())h.eb = p.value, m = vh(h.eb, a1), v = h.eb.i, y = h.eb.h, E = function(t) {
                                                                            return function(n) {
                                                                                var r, i, a1;
                                                                                return L(function(s1) {
                                                                                    if (1 == s1.g) return T(s1, o.addSegments([
                                                                                        {
                                                                                            data: n
                                                                                        }
                                                                                    ]), 2);
                                                                                    r = s1.h, vg(e), i = t.eb.g, a1 = mh(i), c[a1] = r[0], d += n.byteLength, b(s1);
                                                                                });
                                                                            };
                                                                        }(h), Ah(i, h.eb.groupId, m, v, y, E);
                                                                        return T(A, function(e) {
                                                                            return L(function(t) {
                                                                                return 1 == t.g ? T(t, Promise.all(e.j.values()), 2) : t.return(e.g.h);
                                                                            });
                                                                        }(i), 2);
                                                                    }
                                                                    return f ? (vg(e), function(e, t, n, r) {
                                                                        if (t.expiration = n.hc(), n = Ci(n), t.sessionIds = r.offline.usePersistentLicense ? n : [], dg(e) && r.offline.usePersistentLicense && !n.length) throw new De(2, 9, 9007);
                                                                    }(s1, r, u, a1), T(A, o.updateManifest(n, r), 0)) : A.A(0);
                                                                });
                                                            }, h = !1, A(_, 2), !dg(s1) || !h || fg(s1)) {
                                                                _.A(4);
                                                                break;
                                                            }
                                                            return T(_, f(t.filter(function(e) {
                                                                return e.h;
                                                            }), !0), 5);
                                                        case 5:
                                                            return vg(e), t = t.filter(function(e) {
                                                                return !e.h;
                                                            }), g = c, p = d, c = {}, d = 0, T(_, cg(o, n, r, g, p, function() {
                                                                return vg(e);
                                                            }), 6);
                                                        case 6:
                                                            vg(e);
                                                        case 4:
                                                            if (h) {
                                                                _.A(7);
                                                                break;
                                                            }
                                                            return T(_, f(t, !1), 8);
                                                        case 8:
                                                            return vg(e), m = c, v = d, c = {}, d = 0, T(_, cg(o, n, r, m, v, function() {
                                                                return vg(e);
                                                            }), 9);
                                                        case 9:
                                                            vg(e);
                                                        case 7:
                                                            S(_, 0);
                                                            break;
                                                        case 2:
                                                            return y = w(_), E = Object.values(c), T(_, o.removeSegments(E, function() {}), 10);
                                                        case 10:
                                                            throw y;
                                                    }
                                                });
                                            }(e, m, d, p, a1, i, c.ja, h, s1), 12);
                                        case 12:
                                            return vg(e), y = new qh("manifest", c.path.za, c.path.ja, d), _.return(tg(y, p));
                                        case 3:
                                            return I(_), T(_, u.destroy(), 13);
                                        case 13:
                                            if (!o) {
                                                _.A(14);
                                                break;
                                            }
                                            return T(_, o.stop(), 14);
                                        case 14:
                                            if (!s1) {
                                                _.A(16);
                                                break;
                                            }
                                            return T(_, s1.destroy(), 16);
                                        case 16:
                                            R(_, 0);
                                            break;
                                        case 2:
                                            if (E = w(_), null == d) {
                                                _.A(18);
                                                break;
                                            }
                                            return T(_, lg(d), 18);
                                        case 18:
                                            throw f || E;
                                    }
                                });
                            }(this, e, t || {}, function() {
                                var t;
                                return L(function(a1) {
                                    return 1 == a1.g ? T(a1, Ki(e, r.g, i.manifest.retryParameters, n || null), 2) : (t = a1.h, a1.return(t()));
                                });
                            }, i, a1), (t = new ur(t, function() {
                                return bh(a1);
                            })).finally(function() {
                                $(r.j, a1);
                            }), function(e, t) {
                                var n = t.promise;
                                return e.i.push(n), t.finally(function() {
                                    $(e.i, n);
                                });
                            }(this, t);
                        }, r.remove = function(e) {
                            return Eg(this, function(e, t) {
                                var n, r, i, a1, o, s1;
                                return L(function(u) {
                                    switch(u.g){
                                        case 1:
                                            if (yg(), null == (n = Yh(t)) || "manifest" != n.g) throw new De(2, 9, 9004, t);
                                            return r = n, i = new xh, _(u), T(u, i.init(), 4);
                                        case 4:
                                            return T(u, Oh(i, r.za(), r.ja()), 5);
                                        case 5:
                                            return T(u, (a1 = u.h).getManifests([
                                                r.key()
                                            ]), 6);
                                        case 6:
                                            return o = u.h, s1 = o[0], T(u, Promise.all([
                                                gg(e, s1, i),
                                                pg(a1, r, s1)
                                            ]), 2);
                                        case 2:
                                            return I(u), T(u, i.destroy(), 8);
                                        case 8:
                                            R(u, 0);
                                    }
                                });
                            }(this, e));
                        }, r.og = function() {
                            return Eg(this, function(e) {
                                var t, n, r, i, a1, o, s1, u, c, d;
                                return L(function(f) {
                                    switch(f.g){
                                        case 1:
                                            return yg(), t = e.g, n = e.h.drm, r = new xh, i = !1, _(f), T(f, r.init(), 4);
                                        case 4:
                                            a1 = [], function(e, t) {
                                                e.g.forEach(function(e) {
                                                    var t;
                                                    t = e.getEmeSessionCell(), a1.push(t);
                                                });
                                            }(r), o = l(a1), s1 = o.next();
                                        case 5:
                                            if (s1.done) {
                                                f.A(2);
                                                break;
                                            }
                                            return T(f, (u = s1.value).getAll(), 8);
                                        case 8:
                                            return c = f.h, T(f, $h(n, t, c), 9);
                                        case 9:
                                            return d = f.h, T(f, u.remove(d), 10);
                                        case 10:
                                            d.length != c.length && (i = !0), s1 = o.next(), f.A(5);
                                            break;
                                        case 2:
                                            return I(f), T(f, r.destroy(), 11);
                                        case 11:
                                            R(f, 3);
                                            break;
                                        case 3:
                                            return f.return(!i);
                                    }
                                });
                            }(this));
                        }, r.list = function() {
                            return Eg(this, function() {
                                var e, t, n;
                                return L(function(r) {
                                    switch(r.g){
                                        case 1:
                                            return yg(), e = [], t = new xh, _(r), T(r, t.init(), 4);
                                        case 4:
                                            return n = Promise.resolve(), function(e, t) {
                                                e.g.forEach(function(e, n) {
                                                    e.getCells().forEach(function(e, r) {
                                                        t({
                                                            za: n,
                                                            ja: r
                                                        }, e);
                                                    });
                                                });
                                            }(t, function(t, r) {
                                                n = n.then(function() {
                                                    return L(function(n) {
                                                        if (1 == n.g) return T(n, r.getAllManifests(), 2);
                                                        n.h.forEach(function(n, r) {
                                                            var i = tg(new qh("manifest", t.za, t.ja, r), n);
                                                            e.push(i);
                                                        }), b(n);
                                                    });
                                                });
                                            }), T(r, n, 2);
                                        case 2:
                                            return I(r), T(r, t.destroy(), 6);
                                        case 6:
                                            R(r, 3);
                                            break;
                                        case 3:
                                            return r.return(e);
                                    }
                                });
                            }());
                        }, B("shaka.offline.Storage", sg), sg.deleteAll = function() {
                            var e;
                            return L(function(t) {
                                return 1 == t.g ? (e = new xh, _(t), T(t, function(e) {
                                    var t, n;
                                    return L(function(r) {
                                        return 1 == r.g ? (t = Array.from(e.g.values()), (n = 0 < t.length) || Fh.forEach(function(e) {
                                            (e = e()) && t.push(e);
                                        }), T(r, Promise.all(t.map(function(e) {
                                            return e.erase();
                                        })), 2)) : n ? r.A(0) : T(r, Promise.all(t.map(function(e) {
                                            return e.destroy();
                                        })), 0);
                                    });
                                }(e), 2)) : 5 != t.g ? (I(t), T(t, e.destroy(), 5)) : R(t, 0);
                            });
                        }, sg.prototype.list = sg.prototype.list, sg.prototype.removeEmeSessions = sg.prototype.og, sg.prototype.remove = sg.prototype.remove, sg.prototype.store = sg.prototype.store, sg.prototype.getNetworkingEngine = sg.prototype.ic, sg.prototype.getConfiguration = sg.prototype.getConfiguration, sg.prototype.configure = sg.prototype.configure, sg.prototype.destroy = sg.prototype.destroy, sg.support = ug;
                        var bg = (new Map).set("org.w3.clearkey", "1077efecc0b24d02ace33c1e52e2fb4b").set("com.widevine.alpha", "edef8ba979d64acea3c827dcd51d21ed").set("com.microsoft.playready", "9a04f07998404286ab92e65be0885f95").set("com.microsoft.playready.recommendation", "9a04f07998404286ab92e65be0885f95").set("com.microsoft.playready.software", "9a04f07998404286ab92e65be0885f95").set("com.microsoft.playready.hardware", "9a04f07998404286ab92e65be0885f95").set("com.adobe.primetime", "f239e769efa348509c16a903c6932efb");
                        function Ag() {}
                        function _g(e, t) {
                            for(var n = {
                                priority: t || 0,
                                lf: e
                            }, r = 0; r < Sg.length; r++)if (Sg[r].priority < n.priority) return void Sg.splice(r, 0, n);
                            Sg.push(n);
                        }
                        Ml.offline = ug, B("shaka.polyfill", Ag), Ag.register = _g, Ag.installAll = function() {
                            for(var e = l(Sg), t = e.next(); !t.done; t = e.next()){
                                t = t.value;
                                try {
                                    t.lf();
                                } catch (e) {
                                    Y("Error installing polyfill!", e);
                                }
                            }
                        };
                        var Sg = [];
                        function wg() {}
                        function Ig() {
                            if (!Object.getOwnPropertyDescriptor(Element.prototype, "ariaHidden")) for(var e = l([
                                "ariaHidden",
                                "ariaLabel",
                                "ariaPressed",
                                "ariaSelected"
                            ]), t = e.next(); !t.done; t = e.next())Rg(t.value);
                        }
                        function Rg(e) {
                            var t = "aria-" + e.toLowerCase().replace(/^aria/, "");
                            Object.defineProperty(Element.prototype, e, {
                                get: function() {
                                    return this.getAttribute(t);
                                },
                                set: function(e) {
                                    null == e || null == e ? this.removeAttribute(t) : this.setAttribute(t, e);
                                }
                            });
                        }
                        function Cg() {}
                        function Dg() {
                            cv();
                        }
                        function kg() {}
                        function Ng() {
                            if (e.Document) {
                                var t = Element.prototype;
                                t.requestFullscreen = t.requestFullscreen || t.mozRequestFullScreen || t.msRequestFullscreen || t.webkitRequestFullscreen, (t = Document.prototype).exitFullscreen = t.exitFullscreen || t.mozCancelFullScreen || t.msExitFullscreen || t.webkitCancelFullScreen, "fullscreenElement" in document || (Object.defineProperty(document, "fullscreenElement", {
                                    get: function() {
                                        return document.mozFullScreenElement || document.msFullscreenElement || document.webkitCurrentFullScreenElement || document.webkitFullscreenElement;
                                    }
                                }), Object.defineProperty(document, "fullscreenEnabled", {
                                    get: function() {
                                        return document.mozFullScreenEnabled || document.msFullscreenEnabled || document.webkitFullscreenEnabled;
                                    }
                                })), document.addEventListener("webkitfullscreenchange", Lg), document.addEventListener("webkitfullscreenerror", Lg), document.addEventListener("mozfullscreenchange", Lg), document.addEventListener("mozfullscreenerror", Lg), document.addEventListener("MSFullscreenChange", Lg), document.addEventListener("MSFullscreenError", Lg);
                            }
                        }
                        function Lg(e) {
                            var t = e.type.replace(/^(webkit|moz|MS)/, "").toLowerCase(), n = document.createEvent("Event");
                            n.initEvent(t, e.bubbles, e.cancelable), e.target.dispatchEvent(n);
                        }
                        function xg() {}
                        function Mg() {
                            var e = !0;
                            (ct() || ht("PlayStation 5") || dt() || ht("Web0S") || ut() || ht("CrKey") || ht("PC=EOS")) && (e = !1), e && navigator.mediaCapabilities || (navigator.mediaCapabilities || (navigator.mediaCapabilities = {}), Pg = navigator.mediaCapabilities, navigator.mediaCapabilities.decodingInfo = Og);
                        }
                        function Og(e) {
                            var t, n, r, i, a1, o, s1, u, l, c;
                            return L(function(d) {
                                switch(d.g){
                                    case 1:
                                        if (t = {
                                            supported: !1,
                                            powerEfficient: !0,
                                            smooth: !0,
                                            keySystemAccess: null,
                                            configuration: e
                                        }, !e) return d.return(t);
                                        if ("media-source" == e.type) {
                                            if (!at() || e.video && (n = e.video.contentType, !MediaSource.isTypeSupported(n)) || e.audio && (r = e.audio.contentType, !MediaSource.isTypeSupported(r))) return d.return(t);
                                        } else {
                                            if ("file" != e.type) return d.return(t);
                                            if (e.video && !ot(e.video.contentType) || e.audio && !ot(e.audio.contentType)) return d.return(t);
                                        }
                                        return e.keySystemConfiguration ? (i = e.keySystemConfiguration, a1 = [], o = [], i.audio && (s1 = {
                                            robustness: i.audio.robustness || "",
                                            contentType: e.audio.contentType
                                        }, a1.push(s1)), i.video && (u = {
                                            robustness: i.video.robustness || "",
                                            contentType: e.video.contentType
                                        }, o.push(u)), l = {
                                            initDataTypes: [
                                                i.initDataType
                                            ],
                                            distinctiveIdentifier: i.distinctiveIdentifier,
                                            persistentState: i.persistentState,
                                            sessionTypes: i.sessionTypes
                                        }, a1.length && (l.audioCapabilities = a1), o.length && (l.videoCapabilities = o), A(d, 3), T(d, navigator.requestMediaKeySystemAccess(i.keySystem, [
                                            l
                                        ]), 5)) : (t.supported = !0, d.return(Promise.resolve(t)));
                                    case 5:
                                        c = d.h, S(d, 4);
                                        break;
                                    case 3:
                                        w(d);
                                    case 4:
                                        c && (t.supported = !0, t.keySystemAccess = c);
                                    case 2:
                                        return d.return(t);
                                }
                            });
                        }
                        Ag.Aria = wg, wg.install = Ig, _g(Ig), Ag.EncryptionScheme = Cg, Cg.install = Dg, _g(Dg, -2), Ag.Fullscreen = kg, kg.install = Ng, _g(Ng), Ag.MediaCapabilities = xg, xg.install = Mg;
                        var Pg = null;
                        function Fg() {}
                        function Ug() {
                            var t = ft();
                            e.MediaSource && (e.cast && cast.__platform__ && cast.__platform__.canDisplayType ? function() {
                                var e = MediaSource.isTypeSupported;
                                MediaSource.isTypeSupported = function(t) {
                                    var n = t.split(/ *; */);
                                    return n.shift(), n.some(function(e) {
                                        return e.startsWith("codecs=");
                                    }) ? cast.__platform__.canDisplayType(t) : e(t);
                                };
                            }() : t ? 12 >= t ? (jg(), function() {
                                var e = SourceBuffer.prototype.remove;
                                SourceBuffer.prototype.remove = function(t, n) {
                                    return e.call(this, t, n - .001);
                                };
                            }()) : jg() : (ht("Tizen 2") || ht("Tizen 3") || ht("Tizen 4")) && function() {
                                var e = MediaSource.isTypeSupported;
                                MediaSource.isTypeSupported = function(t) {
                                    return "opus" != Kt(t)[0] && e(t);
                                };
                            }()), e.MediaSource && MediaSource.isTypeSupported('video/webm; codecs="vp9"') && !MediaSource.isTypeSupported('video/webm; codecs="vp09.00.10.08"') && function() {
                                var e = MediaSource.isTypeSupported;
                                ht("Web0S") || (MediaSource.isTypeSupported = function(t) {
                                    var n = t.split(/ *; */), r = n.findIndex(function(e) {
                                        return e.startsWith("codecs=");
                                    });
                                    if (0 > r) return e(t);
                                    var i = n[r].replace("codecs=", "").replace(/"/g, "").split(/\s*,\s*/), a1 = i.findIndex(function(e) {
                                        return e.startsWith("vp09");
                                    });
                                    return 0 <= a1 && (i[a1] = "vp9", n[r] = 'codecs="' + i.join(",") + '"', t = n.join("; ")), e(t);
                                });
                            }();
                        }
                        function jg() {
                            var e = MediaSource.prototype.addSourceBuffer;
                            MediaSource.prototype.addSourceBuffer = function() {
                                var t = e.apply(this, x.apply(0, arguments));
                                return t.abort = function() {}, t;
                            };
                        }
                        function Bg() {}
                        function Gg() {
                            screen.orientation || null != e.orientation && function() {
                                function t() {
                                    switch(e.orientation){
                                        case -90:
                                            n.type = "landscape-secondary", n.angle = 270;
                                            break;
                                        case 0:
                                            n.type = "portrait-primary", n.angle = 0;
                                            break;
                                        case 90:
                                            n.type = "landscape-primary", n.angle = 90;
                                            break;
                                        case 180:
                                            n.type = "portrait-secondary", n.angle = 180;
                                    }
                                }
                                var n = new Hg;
                                screen.orientation = n, t(), e.addEventListener("orientationchange", function() {
                                    t();
                                    var e = new gr("change");
                                    n.dispatchEvent(e);
                                });
                            }();
                        }
                        function Hg() {
                            vr.call(this), this.type = "", this.angle = 0;
                        }
                        function Vg() {}
                        function Kg(e, t) {
                            try {
                                var n = new Wg(e, t);
                                return Promise.resolve(n);
                            } catch (e) {
                                return Promise.reject(e);
                            }
                        }
                        function qg(e) {
                            var t = this.mediaKeys;
                            return t && t != e && Xg(t, null), delete this.mediaKeys, (this.mediaKeys = e) ? Xg(e, this) : Promise.resolve();
                        }
                        function Yg(e) {
                            if (Re(e = Ie(e.initData)).getUint32(0, !0) + 4 != e.byteLength) throw new RangeError("Malformed FairPlay init data");
                            e = bt(e = Et(e.subarray(4), !0));
                            var t = new Event("encrypted");
                            t.initDataType = "skd", t.initData = we(e), this.dispatchEvent(t);
                        }
                        function Wg(e, t) {
                            if (this.keySystem = e, e.startsWith("com.apple.fps")) for(var n = l(t), r = n.next(); !r.done; r = n.next()){
                                var i = r.value;
                                if ("required" == i.persistentState) r = null;
                                else {
                                    r = {
                                        audioCapabilities: [],
                                        videoCapabilities: [],
                                        persistentState: "optional",
                                        distinctiveIdentifier: "optional",
                                        initDataTypes: i.initDataTypes,
                                        sessionTypes: [
                                            "temporary"
                                        ],
                                        label: i.label
                                    };
                                    var a1 = !1, o = !1;
                                    if (i.audioCapabilities) for(var s1 = l(i.audioCapabilities), u = s1.next(); !u.done; u = s1.next())(u = u.value).contentType && (a1 = !0, WebKitMediaKeys.isTypeSupported(this.keySystem, u.contentType.split(";")[0]) && (r.audioCapabilities.push(u), o = !0));
                                    if (i.videoCapabilities) for(u = (i = l(i.videoCapabilities)).next(); !u.done; u = i.next())(s1 = u.value).contentType && (a1 = !0, WebKitMediaKeys.isTypeSupported(this.keySystem, s1.contentType.split(";")[0]) && (r.videoCapabilities.push(s1), o = !0));
                                    a1 || (o = WebKitMediaKeys.isTypeSupported(this.keySystem, "video/mp4")), r = o ? r : null;
                                }
                                if (r) return void (this.g = r);
                            }
                            throw (n = Error("Unsupported keySystem")).name = "NotSupportedError", n.code = DOMException.NOT_SUPPORTED_ERR, n;
                        }
                        function zg(e) {
                            this.h = new WebKitMediaKeys(e), this.g = new xr;
                        }
                        function Xg(e, t) {
                            if (e.g.nb(), !t) return Promise.resolve();
                            e.g.C(t, "webkitneedkey", Yg);
                            try {
                                return ts(t, HTMLMediaElement.HAVE_METADATA, e.g, function() {
                                    t.webkitSetMediaKeys(e.h);
                                }), Promise.resolve();
                            } catch (e) {
                                return Promise.reject(e);
                            }
                        }
                        function Qg(e) {
                            vr.call(this), this.i = null, this.l = e, this.g = this.h = null, this.j = new xr, this.sessionId = "", this.expiration = NaN, this.closed = new tt, this.keyStatuses = new Zg;
                        }
                        function Jg(e, t) {
                            var n = e.keyStatuses;
                            n.size = null == t ? 0 : 1, n.g = t, n = new gr("keystatuseschange"), e.dispatchEvent(n);
                        }
                        function Zg() {
                            this.size = 0, this.g = void 0;
                        }
                        function $g() {}
                        function ep() {
                            !e.HTMLVideoElement || navigator.requestMediaKeySystemAccess && MediaKeySystemAccess.prototype.getConfiguration || (navigator.requestMediaKeySystemAccess = tp, delete HTMLMediaElement.prototype.mediaKeys, HTMLMediaElement.prototype.mediaKeys = null, HTMLMediaElement.prototype.setMediaKeys = np, e.MediaKeys = rp, e.MediaKeySystemAccess = ip, e.shakaMediaKeysPolyfill = !0);
                        }
                        function tp() {
                            return Promise.reject(Error("The key system specified is not supported."));
                        }
                        function np(e) {
                            return null == e ? Promise.resolve() : Promise.reject(Error("MediaKeys not supported."));
                        }
                        function rp() {
                            throw new TypeError("Illegal constructor.");
                        }
                        function ip() {
                            throw this.keySystem = "", new TypeError("Illegal constructor.");
                        }
                        function ap() {}
                        function op() {
                            if (!(!e.HTMLVideoElement || navigator.requestMediaKeySystemAccess && MediaKeySystemAccess.prototype.getConfiguration)) {
                                if (HTMLMediaElement.prototype.webkitGenerateKeyRequest) Ep = "webkit";
                                else if (!HTMLMediaElement.prototype.generateKeyRequest) return;
                                navigator.requestMediaKeySystemAccess = up, delete HTMLMediaElement.prototype.mediaKeys, HTMLMediaElement.prototype.mediaKeys = null, HTMLMediaElement.prototype.setMediaKeys = lp, e.MediaKeys = dp, e.MediaKeySystemAccess = cp, e.shakaMediaKeysPolyfill = !0;
                            }
                        }
                        function sp(e) {
                            return Ep ? Ep + e.charAt(0).toUpperCase() + e.slice(1) : e;
                        }
                        function up(e, t) {
                            try {
                                var n = new cp(e, t);
                                return Promise.resolve(n);
                            } catch (e) {
                                return Promise.reject(e);
                            }
                        }
                        function lp(e) {
                            var t = this.mediaKeys;
                            return t && t != e && fp(t, null), delete this.mediaKeys, (this.mediaKeys = e) && fp(e, this), Promise.resolve();
                        }
                        function cp(e, t) {
                            this.g = this.keySystem = e;
                            var n = !1;
                            "org.w3.clearkey" == e && (this.g = "webkit-org.w3.clearkey", n = !1);
                            var r = !1, i = document.getElementsByTagName("video");
                            i = i.length ? i[0] : document.createElement("video");
                            for(var a1 = l(t), o = a1.next(); !o.done; o = a1.next()){
                                var s1 = {
                                    audioCapabilities: [],
                                    videoCapabilities: [],
                                    persistentState: "optional",
                                    distinctiveIdentifier: "optional",
                                    initDataTypes: (o = o.value).initDataTypes,
                                    sessionTypes: [
                                        "temporary"
                                    ],
                                    label: o.label
                                }, u = !1;
                                if (o.audioCapabilities) for(var c = l(o.audioCapabilities), d = c.next(); !d.done; d = c.next())(d = d.value).contentType && (u = !0, i.canPlayType(d.contentType.split(";")[0], this.g) && (s1.audioCapabilities.push(d), r = !0));
                                if (o.videoCapabilities) for(d = (c = l(o.videoCapabilities)).next(); !d.done; d = c.next())(d = d.value).contentType && (u = !0, i.canPlayType(d.contentType, this.g) && (s1.videoCapabilities.push(d), r = !0));
                                if (u || (r = i.canPlayType("video/mp4", this.g) || i.canPlayType("video/webm", this.g)), "required" == o.persistentState && (n ? (s1.persistentState = "required", s1.sessionTypes = [
                                    "persistent-license"
                                ]) : r = !1), r) return void (this.h = s1);
                            }
                            throw n = "Unsupported keySystem", "org.w3.clearkey" != e && "com.widevine.alpha" != e || (n = "None of the requested configurations were supported."), (n = Error(n)).name = "NotSupportedError", n.code = DOMException.NOT_SUPPORTED_ERR, n;
                        }
                        function dp(e) {
                            this.l = e, this.h = null, this.g = new xr, this.i = [], this.j = new Map;
                        }
                        function fp(e, t) {
                            e.h = t, e.g.nb();
                            var n = Ep;
                            t && (e.g.C(t, n + "needkey", function(t) {
                                var n = new CustomEvent("encrypted");
                                n.initDataType = "cenc", n.initData = we(t.initData), e.h.dispatchEvent(n);
                            }), e.g.C(t, n + "keymessage", function(t) {
                                var n = hp(e, t.sessionId);
                                n && (t = new gr("message", t = (new Map).set("messageType", null == n.keyStatuses.Db() ? "licenserequest" : "licenserenewal").set("message", t.message)), n.h && (n.h.resolve(), n.h = null), n.dispatchEvent(t));
                            }), e.g.C(t, n + "keyadded", function(t) {
                                (t = hp(e, t.sessionId)) && (vp(t, "usable"), t.g && t.g.resolve(), t.g = null);
                            }), e.g.C(t, n + "keyerror", function(t) {
                                var n = hp(e, t.sessionId);
                                n && n.handleError(t);
                            }));
                        }
                        function hp(e, t) {
                            var n = e.j.get(t);
                            return n || ((n = e.i.shift()) ? (n.sessionId = t, e.j.set(t, n), n) : null);
                        }
                        function gp(e, t, n) {
                            vr.call(this), this.j = e, this.m = !1, this.g = this.h = null, this.i = t, this.l = n, this.sessionId = "", this.expiration = NaN, this.closed = new tt, this.keyStatuses = new yp;
                        }
                        function pp(e, t, n) {
                            if (e.m) return Promise.reject(Error("The session is already initialized."));
                            e.m = !0;
                            try {
                                if ("persistent-license" == e.l) {
                                    if (n) var r = Ie(bt("LOAD_SESSION|" + n));
                                    else {
                                        var i = bt("PERSISTENT|");
                                        r = kt(i, t);
                                    }
                                } else r = Ie(t);
                            } catch (e) {
                                return Promise.reject(e);
                            }
                            e.h = new tt;
                            var a1 = sp("generateKeyRequest");
                            try {
                                e.j[a1](e.i, r);
                            } catch (t) {
                                if ("InvalidStateError" != t.name) return e.h = null, Promise.reject(t);
                                new it(function() {
                                    try {
                                        e.j[a1](e.i, r);
                                    } catch (t) {
                                        e.h.reject(t), e.h = null;
                                    }
                                }).O(.01);
                            }
                            return e.h;
                        }
                        function mp(e, t, n) {
                            if (e.g) e.g.then(function() {
                                return mp(e, t, n);
                            }).catch(function() {
                                return mp(e, t, n);
                            });
                            else {
                                if (e.g = t, "webkit-org.w3.clearkey" == e.i) {
                                    var r = yt(n), i = JSON.parse(r);
                                    "oct" != i.keys[0].kty && (e.g.reject(Error("Response is not a valid JSON Web Key Set.")), e.g = null), r = Rt(i.keys[0].k), i = Rt(i.keys[0].kid);
                                } else r = Ie(n), i = null;
                                var a1 = sp("addKey");
                                try {
                                    e.j[a1](e.i, r, i, e.sessionId);
                                } catch (t) {
                                    e.g.reject(t), e.g = null;
                                }
                            }
                        }
                        function vp(e, t) {
                            var n = e.keyStatuses;
                            n.size = null == t ? 0 : 1, n.g = t, n = new gr("keystatuseschange"), e.dispatchEvent(n);
                        }
                        function yp() {
                            this.size = 0, this.g = void 0;
                        }
                        xg.originalMcap = Pg, _g(Mg, -1), Ag.MediaSource = Fg, Fg.install = Ug, _g(Ug), Ag.Orientation = Bg, Bg.install = Gg, m(Hg, vr), Hg.prototype.lock = function(e) {
                            function t(e) {
                                return screen.lockOrientation ? screen.lockOrientation(e) : screen.mozLockOrientation ? screen.mozLockOrientation(e) : !!screen.msLockOrientation && screen.msLockOrientation(e);
                            }
                            var n = !1;
                            switch(e){
                                case "natural":
                                    n = t("default");
                                    break;
                                case "any":
                                    n = !0, this.unlock();
                                    break;
                                default:
                                    n = t(e);
                            }
                            return n ? Promise.resolve() : ((e = Error("screen.orientation.lock() is not available on this device")).name = "NotSupportedError", e.code = DOMException.NOT_SUPPORTED_ERR, Promise.reject(e));
                        }, Hg.prototype.unlock = function() {
                            screen.unlockOrientation ? screen.unlockOrientation() : screen.mozUnlockOrientation ? screen.mozUnlockOrientation() : screen.msUnlockOrientation && screen.msUnlockOrientation();
                        }, _g(Gg), Ag.PatchedMediaKeysApple = Vg, Vg.uninstall = function() {
                            this.g && (this.g = !1, Object.defineProperty(HTMLMediaElement.prototype, "mediaKeys", this.h), HTMLMediaElement.prototype.setMediaKeys = this.i, e.MediaKeys = this.m, e.MediaKeySystemAccess = this.l, navigator.requestMediaKeySystemAccess = this.j, this.h = this.j = this.i = this.l = this.m = null, e.shakaMediaKeysPolyfill = !1);
                        }, Vg.install = function(t) {
                            e.HTMLVideoElement && e.WebKitMediaKeys && (void 0 !== t && t && (this.g = !0, this.h = Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype, "mediaKeys"), this.i = HTMLMediaElement.prototype.setMediaKeys, this.m = e.MediaKeys, this.l = e.MediaKeySystemAccess, this.j = navigator.requestMediaKeySystemAccess), delete HTMLMediaElement.prototype.mediaKeys, HTMLMediaElement.prototype.mediaKeys = null, HTMLMediaElement.prototype.setMediaKeys = qg, e.MediaKeys = zg, e.MediaKeySystemAccess = Wg, navigator.requestMediaKeySystemAccess = Kg, e.shakaMediaKeysPolyfill = !0);
                        }, Wg.prototype.createMediaKeys = function() {
                            var e = new zg(this.keySystem);
                            return Promise.resolve(e);
                        }, Wg.prototype.getConfiguration = function() {
                            return this.g;
                        }, zg.prototype.createSession = function(e) {
                            if ("temporary" != (e = e || "temporary")) throw new TypeError("Session type " + e + " is unsupported on this platform.");
                            return new Qg(this.h, e);
                        }, zg.prototype.setServerCertificate = function() {
                            return Promise.resolve(!1);
                        }, m(Qg, vr), (r = Qg.prototype).generateRequest = function(e, t) {
                            var n = this;
                            this.h = new tt;
                            try {
                                var r = this.l.createSession("video/mp4", Ie(t));
                                this.i = r, this.sessionId = r.sessionId || "", this.j.C(this.i, "webkitkeymessage", function(e) {
                                    n.h && (n.h.resolve(), n.h = null), e = new gr("message", e = (new Map).set("messageType", null == n.keyStatuses.Db() ? "license-request" : "license-renewal").set("message", we(e.message))), n.dispatchEvent(e);
                                }), this.j.C(r, "webkitkeyadded", function() {
                                    n.g && (Jg(n, "usable"), n.g.resolve(), n.g = null);
                                }), this.j.C(r, "webkitkeyerror", function() {
                                    var e = Error("EME PatchedMediaKeysApple key error");
                                    if (e.errorCode = n.i.error, null != n.h) n.h.reject(e), n.h = null;
                                    else if (null != n.g) n.g.reject(e), n.g = null;
                                    else switch(n.i.error.code){
                                        case WebKitMediaKeyError.MEDIA_KEYERR_OUTPUT:
                                        case WebKitMediaKeyError.MEDIA_KEYERR_HARDWARECHANGE:
                                            Jg(n, "output-not-allowed");
                                            break;
                                        default:
                                            Jg(n, "internal-error");
                                    }
                                }), Jg(this, "status-pending");
                            } catch (e) {
                                this.h.reject(e);
                            }
                            return this.h;
                        }, r.load = function() {
                            return Promise.reject(Error("MediaKeySession.load not yet supported"));
                        }, r.update = function(e) {
                            this.g = new tt;
                            try {
                                this.i.update(Ie(e));
                            } catch (e) {
                                this.g.reject(e);
                            }
                            return this.g;
                        }, r.close = function() {
                            try {
                                this.i.close(), this.closed.resolve(), this.j.nb();
                            } catch (e) {
                                this.closed.reject(e);
                            }
                            return this.closed;
                        }, r.remove = function() {
                            return Promise.reject(Error("MediaKeySession.remove is only applicable for persistent licenses, which are not supported on this platform"));
                        }, (r = Zg.prototype).Db = function() {
                            return this.g;
                        }, r.forEach = function(e) {
                            this.g && e(this.g, Hi.value());
                        }, r.get = function(e) {
                            if (this.has(e)) return this.g;
                        }, r.has = function(e) {
                            var t = Hi.value();
                            return !(!this.g || !_e(e, t));
                        }, r.entries = function() {}, r.keys = function() {}, r.values = function() {}, Ag.PatchedMediaKeysNop = $g, $g.install = ep, rp.prototype.createSession = function() {}, rp.prototype.setServerCertificate = function() {}, ip.prototype.getConfiguration = function() {}, ip.prototype.createMediaKeys = function() {}, _g(ep, -10), Ag.PatchedMediaKeysWebkit = ap, ap.install = op, cp.prototype.createMediaKeys = function() {
                            var e = new dp(this.g);
                            return Promise.resolve(e);
                        }, cp.prototype.getConfiguration = function() {
                            return this.h;
                        }, dp.prototype.createSession = function(e) {
                            if ("temporary" != (e = e || "temporary") && "persistent-license" != e) throw new TypeError("Session type " + e + " is unsupported on this platform.");
                            var t = this.h || document.createElement("video");
                            return t.src || (t.src = "about:blank"), e = new gp(t, this.l, e), this.i.push(e), e;
                        }, dp.prototype.setServerCertificate = function() {
                            return Promise.resolve(!1);
                        }, m(gp, vr), (r = gp.prototype).handleError = function(e) {
                            var t = Error("EME v0.1b key error"), n = e.errorCode;
                            n.systemCode = e.systemCode, t.errorCode = n, !e.sessionId && this.h ? (45 == e.systemCode && (t.message = "Unsupported session type."), this.h.reject(t), this.h = null) : e.sessionId && this.g ? (this.g.reject(t), this.g = null) : (t = e.systemCode, e.errorCode.code == MediaKeyError.MEDIA_KEYERR_OUTPUT ? vp(this, "output-restricted") : vp(this, 1 == t ? "expired" : "internal-error"));
                        }, r.generateRequest = function(e, t) {
                            return pp(this, t, null);
                        }, r.load = function(e) {
                            return "persistent-license" == this.l ? pp(this, null, e) : Promise.reject(Error("Not a persistent session."));
                        }, r.update = function(e) {
                            var t = new tt;
                            return mp(this, t, e), t;
                        }, r.close = function() {
                            if ("persistent-license" != this.l) {
                                if (!this.sessionId) return this.closed.reject(Error("The session is not callable.")), this.closed;
                                var e = sp("cancelKeyRequest");
                                try {
                                    this.j[e](this.i, this.sessionId);
                                } catch (e) {}
                            }
                            return this.closed.resolve(), this.closed;
                        }, r.remove = function() {
                            return "persistent-license" != this.l ? Promise.reject(Error("Not a persistent session.")) : this.close();
                        }, (r = yp.prototype).Db = function() {
                            return this.g;
                        }, r.forEach = function(e) {
                            this.g && e(this.g, Hi.value());
                        }, r.get = function(e) {
                            if (this.has(e)) return this.g;
                        }, r.has = function(e) {
                            var t = Hi.value();
                            return !(!this.g || !_e(e, t));
                        }, r.entries = function() {}, r.keys = function() {}, r.values = function() {};
                        var Ep = "";
                        function Tp() {}
                        function bp() {
                            if (e.HTMLVideoElement) {
                                var t = HTMLVideoElement.prototype;
                                t.requestPictureInPicture && document.exitPictureInPicture || !t.webkitSupportsPresentationMode || (document.pictureInPictureEnabled = !0, document.pictureInPictureElement = null, t.requestPictureInPicture = _p, Object.defineProperty(t, "disablePictureInPicture", {
                                    get: wp,
                                    set: Ip,
                                    enumerable: !0,
                                    configurable: !0
                                }), document.exitPictureInPicture = Sp, document.addEventListener("webkitpresentationmodechanged", Ap, !0));
                            }
                        }
                        function Ap(e) {
                            if ("picture-in-picture" == (e = e.target).webkitPresentationMode) {
                                document.pictureInPictureElement = e;
                                var t = new Event("enterpictureinpicture");
                                e.dispatchEvent(t);
                            } else document.pictureInPictureElement == e && (document.pictureInPictureElement = null), t = new Event("leavepictureinpicture"), e.dispatchEvent(t);
                        }
                        function _p() {
                            return this.webkitSupportsPresentationMode("picture-in-picture") ? (this.webkitSetPresentationMode("picture-in-picture"), document.pictureInPictureElement = this, Promise.resolve()) : Promise.reject(Error("PiP not allowed by video element"));
                        }
                        function Sp() {
                            var e = document.pictureInPictureElement;
                            return e ? (e.webkitSetPresentationMode("inline"), document.pictureInPictureElement = null, Promise.resolve()) : Promise.reject(Error("No picture in picture element found"));
                        }
                        function wp() {
                            return !!this.hasAttribute("disablePictureInPicture") || !this.webkitSupportsPresentationMode("picture-in-picture");
                        }
                        function Ip(e) {
                            e ? this.setAttribute("disablePictureInPicture", "") : this.removeAttribute("disablePictureInPicture");
                        }
                        function Rp() {}
                        function Cp() {
                            e.crypto && ("randomUUID" in e.crypto || (e.crypto.randomUUID = Dp));
                        }
                        function Dp() {
                            var e = URL.createObjectURL(new Blob), t = e.toString();
                            return URL.revokeObjectURL(e), t.substr(t.lastIndexOf("/") + 1);
                        }
                        function kp() {}
                        function Np() {
                            navigator.storage && navigator.storage.estimate || !navigator.webkitTemporaryStorage || !navigator.webkitTemporaryStorage.queryUsageAndQuota || ("storage" in navigator || (navigator.storage = {}), navigator.storage.estimate = Lp);
                        }
                        function Lp() {
                            return new Promise(function(e, t) {
                                navigator.webkitTemporaryStorage.queryUsageAndQuota(function(t, n) {
                                    e({
                                        usage: t,
                                        quota: n
                                    });
                                }, t);
                            });
                        }
                        function xp() {}
                        function Mp() {
                            var e = Symbol.prototype;
                            "description" in e || Object.defineProperty(e, "description", {
                                get: Op
                            });
                        }
                        function Op() {
                            var e = /\((.*)\)/.exec(this.toString());
                            return e ? e[1] : void 0;
                        }
                        function Pp() {}
                        function Fp() {
                            if (e.HTMLMediaElement) {
                                var t = HTMLMediaElement.prototype.play;
                                HTMLMediaElement.prototype.play = function() {
                                    var e = t.apply(this);
                                    return e && e.catch(function() {}), e;
                                };
                            }
                        }
                        function Up() {}
                        function jp() {
                            if (e.HTMLVideoElement) {
                                var t = HTMLVideoElement.prototype;
                                !t.getVideoPlaybackQuality && ("webkitDroppedFrameCount" in t || lt()) && (t.getVideoPlaybackQuality = Bp);
                            }
                        }
                        function Bp() {
                            return {
                                droppedVideoFrames: this.webkitDroppedFrameCount,
                                totalVideoFrames: this.webkitDecodedFrameCount,
                                corruptedVideoFrames: 0,
                                creationTime: NaN,
                                totalFrameDelay: 0
                            };
                        }
                        function Gp() {}
                        function Hp() {
                            if (!e.VTTCue && e.TextTrackCue) {
                                var t = null, n = TextTrackCue.length;
                                if (3 == n) t = Vp;
                                else if (6 == n) t = Kp;
                                else {
                                    try {
                                        var r = !!Vp(1, 2, "");
                                    } catch (e) {
                                        r = !1;
                                    }
                                    r && (t = Vp);
                                }
                                t && (e.VTTCue = function(e, n, r) {
                                    return t(e, n, r);
                                });
                            }
                        }
                        function Vp(t, n, r) {
                            return new e.TextTrackCue(t, n, r);
                        }
                        function Kp(t, n, r) {
                            return new e.TextTrackCue(t + "-" + n + "-" + r, t, n, r);
                        }
                        function qp() {}
                        _g(op), Ag.PiPWebkit = Tp, Tp.install = bp, _g(bp), Ag.RandomUUID = Rp, Rp.install = Cp, _g(Cp), Ag.StorageEstimate = kp, kp.install = Np, _g(Np), Ag.Symbol = xp, xp.install = Mp, _g(Mp), Ag.VideoPlayPromise = Pp, Pp.install = Fp, _g(Fp), Ag.VideoPlaybackQuality = Up, Up.install = jp, _g(jp), Ag.VTTCue = Gp, Gp.install = Hp, _g(Hp), qp.prototype.parseInit = function() {}, qp.prototype.setSequenceMode = function() {}, qp.prototype.parseMedia = function(e, t) {
                            for(var n = null, r = [], i = yt(e).split(/\r?\n/), a1 = (i = l(i)).next(); !a1.done; a1 = i.next())if ((a1 = a1.value) && !/^\s+$/.test(a1) && (a1 = Yp.exec(a1))) {
                                var o = Wp.exec(a1[1]);
                                a1 = new ne(o = 60 * parseInt(o[1], 10) + parseFloat(o[2].replace(",", ".")), t.segmentEnd ? t.segmentEnd : o + 2, a1[2]), n && (n.endTime = o, r.push(n)), n = a1;
                            }
                            return n && r.push(n), r;
                        }, B("shaka.text.LrcTextParser", qp), qp.prototype.parseMedia = qp.prototype.parseMedia, qp.prototype.setSequenceMode = qp.prototype.setSequenceMode, qp.prototype.parseInit = qp.prototype.parseInit;
                        var Yp = /^\[(\d{1,2}:\d{1,2}(?:[.,]\d{1,3})?)\](.*)/, Wp = /^(\d+):(\d{1,2}(?:[.,]\d{1,3})?)$/;
                        function zp() {}
                        function Xp(e, t, n, r, i, a1, o, s1, u, c, d) {
                            var f = e.parentNode;
                            if (e.nodeType == Node.COMMENT_NODE) return null;
                            if (e.nodeType == Node.TEXT_NODE) {
                                if (!d) return null;
                                var h = document.createElement("span");
                                h.textContent = e.textContent;
                            } else h = e;
                            for(var g = null, p = l(bm), m = p.next(); !m.done && !(g = tm(h, "backgroundImage", r, "#", m.value)[0]); m = p.next());
                            if (p = d, ("p" == e.nodeName || g) && (d = !0), s1 = "default" == (h.getAttribute("xml:space") || (s1 ? "default" : "preserve")), e = [], !(m = Array.from(h.childNodes).every(function(e) {
                                return e.nodeType == Node.TEXT_NODE;
                            }))) for(var v = l(h.childNodes), y = v.next(); !y.done; y = v.next())(y = Xp(y.value, t, n, r, i, a1, o, s1, u, h, d)) && e.push(y);
                            r = null != c, v = /\S/.test(h.textContent);
                            var E = h.hasAttribute("begin") || h.hasAttribute("end") || h.hasAttribute("dur");
                            if (!(E || v || "br" == h.tagName || 0 != e.length || r && !s1)) return null;
                            for(v = (y = rm(h, n)).start, y = y.end; f && f.nodeType == Node.ELEMENT_NODE && "tt" != f.tagName;)v = (y = nm(f, n, v, y)).start, y = y.end, f = f.parentNode;
                            if (null == v && (v = 0), v += t, y = null == y ? 1 / 0 : y + t, !E && 0 < e.length) for(v = 1 / 0, y = 0, n = (t = l(e)).next(); !n.done; n = t.next())n = n.value, v = Math.min(v, n.startTime), y = Math.max(y, n.endTime);
                            if ("br" == h.tagName) return (i = new ne(v, y, "")).lineBreak = !0, i;
                            if (t = "", m && (t = h.textContent, s1 && (t = (t = t.trim()).replace(/\s+/g, " "))), (t = new ne(v, y, t)).nestedCues = e, d || (t.isContainer = !0), u && (t.cellResolution = u), u = tm(h, "region", a1, "")[0], h.hasAttribute("region") && u && u.getAttribute("xml:id")) {
                                var T = u.getAttribute("xml:id");
                                t.region = o.filter(function(e) {
                                    return e.id == T;
                                })[0];
                            }
                            return o = u, c && r && !h.getAttribute("region") && !h.getAttribute("style") && (o = tm(c, "region", a1, "")[0]), function(e, t, n, r, i, a1, o) {
                                if ("rtl" == Jp(t, n, i, "direction", a1 = a1 || o) && (e.direction = "rtl"), "tb" == (o = Jp(t, n, i, "writingMode", a1)) || "tblr" == o ? e.writingMode = "vertical-lr" : "tbrl" == o ? e.writingMode = "vertical-rl" : "rltb" == o || "rl" == o ? e.direction = "rtl" : o && (e.direction = le), (o = Jp(t, n, i, "textAlign", !0)) ? (e.positionAlign = ym[o], e.lineAlign = vm[o], e.textAlign = oe[o.toUpperCase()]) : e.textAlign = ae, (o = Jp(t, n, i, "displayAlign", !0)) && (e.displayAlign = ue[o.toUpperCase()]), (o = Jp(t, n, i, "color", a1)) && (e.color = o), (o = Jp(t, n, i, "backgroundColor", a1)) && (e.backgroundColor = o), (o = Jp(t, n, i, "border", a1)) && (e.border = o), (o = Jp(t, n, i, "fontFamily", a1)) && (e.fontFamily = o), (o = Jp(t, n, i, "fontWeight", a1)) && "bold" == o && (e.fontWeight = 700), o = Jp(t, n, i, "wrapOption", a1), e.wrapLine = !o || "noWrap" != o, (o = Jp(t, n, i, "lineHeight", a1)) && o.match(lm) && (e.lineHeight = o), (o = Jp(t, n, i, "fontSize", a1)) && (o.match(lm) || o.match(um)) && (e.fontSize = o), (o = Jp(t, n, i, "fontStyle", a1)) && (e.fontStyle = ye[o.toUpperCase()]), r) {
                                    o = r.getAttribute("imageType") || r.getAttribute("imagetype");
                                    var s1 = r.getAttribute("encoding");
                                    r = r.textContent.trim(), "PNG" == o && "Base64" == s1 && r && (e.backgroundImage = "data:image/png;base64," + r);
                                }
                                (r = Jp(t, n, i, "textOutline", a1)) && ((r = r.split(" "))[0].match(lm) ? e.textStrokeColor = e.color : (e.textStrokeColor = r[0], r.shift()), r[0] && r[0].match(lm) ? e.textStrokeWidth = r[0] : e.textStrokeColor = ""), (r = Jp(t, n, i, "letterSpacing", a1)) && r.match(lm) && (e.letterSpacing = r), (r = Jp(t, n, i, "linePadding", a1)) && r.match(lm) && (e.linePadding = r), (a1 = Jp(t, n, i, "opacity", a1)) && (e.opacity = parseFloat(a1)), (n = Zp(n, i, "textDecoration")) && Qp(e, n), (t = $p(t, i, "textDecoration")) && Qp(e, t);
                            }(t, h, o, g, i, p, 0 == e.length), t;
                        }
                        function Qp(e, t) {
                            for(var n = l(t.split(" ")), r = n.next(); !r.done; r = n.next())switch(r.value){
                                case "underline":
                                    e.textDecoration.includes("underline") || e.textDecoration.push("underline");
                                    break;
                                case "noUnderline":
                                    e.textDecoration.includes("underline") && $(e.textDecoration, "underline");
                                    break;
                                case "lineThrough":
                                    e.textDecoration.includes("lineThrough") || e.textDecoration.push("lineThrough");
                                    break;
                                case "noLineThrough":
                                    e.textDecoration.includes("lineThrough") && $(e.textDecoration, "lineThrough");
                                    break;
                                case "overline":
                                    e.textDecoration.includes("overline") || e.textDecoration.push("overline");
                                    break;
                                case "noOverline":
                                    e.textDecoration.includes("overline") && $(e.textDecoration, "overline");
                            }
                        }
                        function Jp(e, t, n, r, i) {
                            return i = void 0 === i || i, (e = $p(e, n, r)) ? e : i ? Zp(t, n, r) : null;
                        }
                        function Zp(e, t, n) {
                            return e ? ai(e, Tm, n) || em(e, t, n) : null;
                        }
                        function $p(e, t, n) {
                            return ai(e, Tm, n) || em(e, t, n);
                        }
                        function em(e, t, n) {
                            e = tm(e, "style", t, "");
                            for(var r = null, i = 0; i < e.length; i++){
                                var a1 = ii(e[i], "urn:ebu:tt:style", n);
                                a1 || (a1 = ai(e[i], Tm, n)), a1 || (a1 = $p(e[i], t, n)), a1 && (r = a1);
                            }
                            return r;
                        }
                        function tm(e, t, n, r, i) {
                            var a1 = [];
                            if (!e || 1 > n.length) return a1;
                            var o = e;
                            for(e = null; o && !(e = i ? ii(o, i, t) : o.getAttribute(t)) && (o = o.parentNode) instanceof Element;);
                            if (t = e) {
                                for(i = (t = l(t.split(" "))).next(); !i.done; i = t.next())for(i = i.value, o = (e = l(n)).next(); !o.done; o = e.next())if (r + (o = o.value).getAttribute("xml:id") == i) {
                                    a1.push(o);
                                    break;
                                }
                            }
                            return a1;
                        }
                        function nm(e, t, n, r) {
                            return e = rm(e, t), null == n ? n = e.start : null != e.start && (n += e.start), null == r ? r = e.end : null != e.start && (r += e.start), {
                                start: n,
                                end: r
                            };
                        }
                        function rm(e, t) {
                            var n = im(e.getAttribute("begin"), t), r = im(e.getAttribute("end"), t), i = im(e.getAttribute("dur"), t);
                            return null == r && null != i && (r = n + i), {
                                start: n,
                                end: r
                            };
                        }
                        function im(e, t) {
                            var n = null;
                            if (dm.test(e)) {
                                n = dm.exec(e);
                                var r = Number(n[1]), i = Number(n[2]), a1 = Number(n[3]), o = Number(n[4]);
                                n = (a1 += (o += (Number(n[5]) || 0) / t.h) / t.frameRate) + 60 * i + 3600 * r;
                            } else if (fm.test(e)) n = am(fm, e);
                            else if (hm.test(e)) n = am(hm, e);
                            else if (gm.test(e)) n = gm.exec(e), n = Number(n[1]) / t.frameRate;
                            else if (pm.test(e)) n = pm.exec(e), n = Number(n[1]) / t.g;
                            else if (mm.test(e)) n = am(mm, e);
                            else if (e) throw new De(2, 2, 2001, "Could not parse cue time range in TTML");
                            return n;
                        }
                        function am(e, t) {
                            var n = e.exec(t);
                            return null == n || "" == n[0] ? null : (Number(n[4]) || 0) / 1e3 + (Number(n[3]) || 0) + 60 * (Number(n[2]) || 0) + 3600 * (Number(n[1]) || 0);
                        }
                        function om(e, t, n, r) {
                            this.frameRate = Number(e) || 30, this.h = Number(t) || 1, this.g = Number(r), 0 == this.g && (this.g = e ? this.frameRate * this.h : 1), n && (e = /^(\d+) (\d+)$/g.exec(n)) && (this.frameRate *= Number(e[1]) / Number(e[2]));
                        }
                        Qt["application/x-subtitle-lrc"] = function() {
                            return new qp;
                        }, zp.prototype.parseInit = function() {}, zp.prototype.setSequenceMode = function() {}, zp.prototype.parseMedia = function(e, t) {
                            var n = yt(e), r = [];
                            if ("" == n) return r;
                            var i = vi(n, "tt");
                            if (!i) throw new De(2, 2, 2005, "Failed to parse TTML.");
                            if (!(n = i.getElementsByTagName("body")[0])) return [];
                            var a1 = ai(i, Em, "frameRate"), o = ai(i, Em, "subFrameRate"), s1 = ai(i, Em, "frameRateMultiplier"), u = ai(i, Em, "tickRate"), c = ai(i, Em, "cellResolution"), d = i.getAttribute("xml:space") || "default", f = ai(i, Tm, "extent");
                            if ("default" != d && "preserve" != d) throw new De(2, 2, 2005, "Invalid xml:space value: " + d);
                            d = "default" == d, a1 = new om(a1, o, s1, u), c = c && (c = /^(\d+) (\d+)$/.exec(c)) ? {
                                columns: parseInt(c[1], 10),
                                rows: parseInt(c[2], 10)
                            } : null, o = (o = i.getElementsByTagName("metadata")[0]) ? function(e) {
                                return Array.from(e.childNodes).filter(function(e) {
                                    return e instanceof Element;
                                });
                            }(o) : [], s1 = Array.from(i.getElementsByTagName("style")), u = [];
                            for(var h = l(i = Array.from(i.getElementsByTagName("region"))), g = h.next(); !g.done; g = h.next()){
                                var p = g.value;
                                g = new Ee;
                                var m = p.getAttribute("xml:id");
                                if (m) {
                                    g.id = m;
                                    var v, y, E = null;
                                    f && (E = sm.exec(f) || cm.exec(f)), m = E ? Number(E[1]) : null, E = E ? Number(E[2]) : null, (v = Zp(p, s1, "extent")) && null != (v = (y = sm.exec(v)) || cm.exec(v)) && (g.width = Number(v[1]), g.height = Number(v[2]), y || (null != m && (g.width = 100 * g.width / m), null != E && (g.height = 100 * g.height / E)), g.widthUnits = y || null != m ? Te : 0, g.heightUnits = y || null != E ? Te : 0), (p = Zp(p, s1, "origin")) && null != (v = (y = sm.exec(p)) || cm.exec(p)) && (g.viewportAnchorX = Number(v[1]), g.viewportAnchorY = Number(v[2]), y || (null != E && (g.viewportAnchorY = 100 * g.viewportAnchorY / E), null != m && (g.viewportAnchorX = 100 * g.viewportAnchorX / m)), g.viewportAnchorUnits = y || null != m ? Te : 0);
                                } else g = null;
                                g && u.push(g);
                            }
                            if (ni(n, "p").length) throw new De(2, 2, 2001, "<p> can only be inside <div> in TTML");
                            for(h = (f = l(ni(n, "div"))).next(); !h.done; h = f.next())if (ni(h.value, "span").length) throw new De(2, 2, 2001, "<span> can only be inside <p> in TTML");
                            return (n = Xp(n, t.periodStart, a1, o, s1, i, u, d, c, null, !1)) && (n.backgroundColor || (n.backgroundColor = "transparent"), r.push(n)), r;
                        }, B("shaka.text.TtmlTextParser", zp), zp.prototype.parseMedia = zp.prototype.parseMedia, zp.prototype.setSequenceMode = zp.prototype.setSequenceMode, zp.prototype.parseInit = zp.prototype.parseInit;
                        var sm = /^(\d{1,2}(?:\.\d+)?|100(?:\.0+)?)% (\d{1,2}(?:\.\d+)?|100(?:\.0+)?)%$/, um = /^(\d{1,2}(?:\.\d+)?|100)%$/, lm = /^(\d+px|\d+em|\d*\.?\d+c)$/, cm = /^(\d+)px (\d+)px$/, dm = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/, fm = /^(?:(\d{2,}):)?(\d{2}):(\d{2})$/, hm = /^(?:(\d{2,}):)?(\d{2}):(\d{2}\.\d{2,})$/, gm = /^(\d*(?:\.\d*)?)f$/, pm = /^(\d*(?:\.\d*)?)t$/, mm = RegExp("^(?:(\\d*(?:\\.\\d*)?)h)?(?:(\\d*(?:\\.\\d*)?)m)?(?:(\\d*(?:\\.\\d*)?)s)?(?:(\\d*(?:\\.\\d*)?)ms)?$"), vm = {
                            left: fe,
                            center: "center",
                            right: "end",
                            start: fe,
                            end: "end"
                        }, ym = {
                            left: "line-left",
                            center: "center",
                            right: "line-right"
                        }, Em = [
                            "http://www.w3.org/ns/ttml#parameter",
                            "http://www.w3.org/2006/10/ttaf1#parameter"
                        ], Tm = [
                            "http://www.w3.org/ns/ttml#styling",
                            "http://www.w3.org/2006/10/ttaf1#styling"
                        ], bm = [
                            "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt",
                            "http://www.smpte-ra.org/schemas/2052-1/2013/smpte-tt"
                        ];
                        function Am() {
                            this.g = new zp;
                        }
                        function _m() {
                            this.g = !1;
                        }
                        function Sm(e) {
                            for(var t = l(Object.entries(ge)), n = t.next(); !n.done; n = t.next()){
                                var r = l(n.value);
                                n = r.next().value, r = r.next().value;
                                var i = new ne(0, 0, "");
                                i.color = r, e.set(n, i);
                            }
                            for(n = (t = l(Object.entries(pe))).next(); !n.done; n = t.next())n = (r = l(n.value)).next().value, r = r.next().value, (i = new ne(0, 0, "")).backgroundColor = r, e.set(n, i);
                        }
                        function wm(e, t, n) {
                            0 === n.size && Sm(n), e = function(e) {
                                for(var t = [], n = -1, r = "", i = 0; i < e.length; i++)if ("/" === e[i]) {
                                    var a1 = e.indexOf(">", i);
                                    if (a1 <= i) return e;
                                    a1 = e.substring(i + 1, a1);
                                    var o = t.pop();
                                    if (!a1 || !o) return e;
                                    if (o === a1) r += "/" + a1 + ">";
                                    else {
                                        if (!o.startsWith("c.") || "c" !== a1) return e;
                                        r += "/" + o + ">";
                                    }
                                    i += a1.length + 1;
                                } else "<" === e[i] ? n = i + 1 : ">" === e[i] && 0 < n && (t.push(e.substr(n, i - n)), n = -1), r += e[i];
                                return r;
                            }(e);
                            for(var r = [], i = -1, a1 = 0; a1 < e.length; a1++)"<" === e[a1] ? i = a1 + 1 : ">" === e[a1] && 0 < i && ((i = e.substr(i, a1 - i)).match(Nm) && r.push(i), i = -1);
                            for(a1 = (r = l(r)).next(); !a1.done; a1 = r.next())a1 = a1.value, e = e.replace("<" + a1 + ">", '<div time="' + a1 + '">'), e += "</div>";
                            if (a1 = vi("<span>" + e + "</span>", "span")) {
                                if (r = [], 1 == (a1 = a1.childNodes).length && ((i = a1[0]).nodeType == Node.TEXT_NODE || i.nodeType == Node.CDATA_SECTION_NODE)) return void (t.payload = e);
                                for(a1 = (e = l(a1)).next(); !a1.done; a1 = e.next())Rm(a1.value, t, r, n);
                                t.nestedCues = r;
                            } else t.payload = e;
                        }
                        function Im(e, t) {
                            return e && 0 < e.length ? e : t;
                        }
                        function Rm(e, t, n, r) {
                            var i = t.clone();
                            if (e.nodeType === Node.ELEMENT_NODE && e.nodeName) for(var a1 = l(e.nodeName.split(/[ .]+/)), o = a1.next(); !o.done; o = a1.next()){
                                if (o = o.value, r.has(o)) {
                                    var s1 = r.get(o);
                                    s1 && (i.backgroundColor = Im(s1.backgroundColor, i.backgroundColor), i.color = Im(s1.color, i.color), i.fontFamily = Im(s1.fontFamily, i.fontFamily), i.fontSize = Im(s1.fontSize, i.fontSize), i.fontWeight = s1.fontWeight, i.fontStyle = s1.fontStyle, i.opacity = s1.opacity, i.wrapLine = s1.wrapLine);
                                }
                                switch(o){
                                    case "b":
                                        i.fontWeight = 700;
                                        break;
                                    case "i":
                                        i.fontStyle = "italic";
                                        break;
                                    case "u":
                                        i.textDecoration.push("underline");
                                        break;
                                    case "div":
                                        (o = e.getAttribute("time")) && (o = Dm(new lf(o))) && (i.startTime = o);
                                }
                            }
                            if (si(e)) for(a1 = !0, r = l(e.textContent.split("\n")), e = r.next(); !e.done; e = r.next())e = e.value, a1 || ((a1 = t.clone()).lineBreak = !0, n.push(a1)), 0 < e.length && ((a1 = i.clone()).payload = e, n.push(a1)), a1 = !1;
                            else for(e = (t = l(e.childNodes)).next(); !e.done; e = t.next())Rm(e.value, i, n, r);
                        }
                        function Cm(e, t, n) {
                            var r;
                            (r = /^align:(start|middle|center|end|left|right)$/.exec(t)) ? (t = r[1], e.textAlign = "middle" == t ? ae : oe[t.toUpperCase()]) : (r = /^vertical:(lr|rl)$/.exec(t)) ? e.writingMode = "lr" == r[1] ? "vertical-lr" : "vertical-rl" : (r = /^size:([\d.]+)%$/.exec(t)) ? e.size = Number(r[1]) : (r = /^position:([\d.]+)%(?:,(line-left|line-right|center|start|end))?$/.exec(t)) ? (e.position = Number(r[1]), r[2] && (t = r[2], e.positionAlign = "line-left" == t || "start" == t ? "line-left" : "line-right" == t || "end" == t ? "line-right" : "center")) : (r = /^region:(.*)$/.exec(t)) ? (t = function(e, t) {
                                var n = e.filter(function(e) {
                                    return e.id == t;
                                });
                                return n.length ? n[0] : null;
                            }(n, r[1])) && (e.region = t) : (n = /^line:([\d.]+)%(?:,(start|end|center))?$/.exec(t)) ? (e.lineInterpretation = 1, e.line = Number(n[1]), n[2] && (e.lineAlign = he[n[2].toUpperCase()])) : (n = /^line:(-?\d+)(?:,(start|end|center))?$/.exec(t)) && (e.lineInterpretation = de, e.line = Number(n[1]), n[2] && (e.lineAlign = he[n[2].toUpperCase()]));
                        }
                        function Dm(e) {
                            if (null == (e = df(e, Nm))) return null;
                            var t = Number(e[2]), n = Number(e[3]);
                            return 59 < t || 59 < n ? null : Number(e[4]) / 1e3 + n + 60 * t + 3600 * (Number(e[1]) || 0);
                        }
                        function km(e) {
                            var t = {
                                "&amp;": "&",
                                "&lt;": "<",
                                "&gt;": ">",
                                "&quot;": '"',
                                "&#39;": "'"
                            }, n = /&(?:amp|lt|gt|quot|#(0+)?39);/g, r = RegExp(n.source);
                            return e && r.test(e) ? e.replace(n, function(e) {
                                return t[e] || "'";
                            }) : e || "";
                        }
                        Qt["application/ttml+xml"] = function() {
                            return new zp;
                        }, Am.prototype.parseInit = function(e) {
                            var t = !1;
                            if ((new Vr).box("moov", Kr).box("trak", Kr).box("mdia", Kr).box("minf", Kr).box("stbl", Kr).T("stsd", qr).box("stpp", function(e) {
                                t = !0, e.parser.stop();
                            }).parse(e), !t) throw new De(2, 2, 2007);
                        }, Am.prototype.setSequenceMode = function() {}, Am.prototype.parseMedia = function(e, t) {
                            var n = this, r = !1, i = [];
                            if ((new Vr).box("mdat", Yr(function(e) {
                                r = !0, i = i.concat(n.g.parseMedia(e, t));
                            })).parse(e, !1), !r) throw new De(2, 2, 2007);
                            return i;
                        }, B("shaka.text.Mp4TtmlParser", Am), Am.prototype.parseMedia = Am.prototype.parseMedia, Am.prototype.setSequenceMode = Am.prototype.setSequenceMode, Am.prototype.parseInit = Am.prototype.parseInit, Qt['application/mp4; codecs="stpp"'] = function() {
                            return new Am;
                        }, Qt['application/mp4; codecs="stpp.ttml"'] = function() {
                            return new Am;
                        }, Qt['application/mp4; codecs="stpp.ttml.im1t"'] = function() {
                            return new Am;
                        }, Qt['application/mp4; codecs="stpp.TTML.im1t"'] = function() {
                            return new Am;
                        }, _m.prototype.parseInit = function() {}, _m.prototype.setSequenceMode = function(e) {
                            this.g = e;
                        }, _m.prototype.parseMedia = function(e, t) {
                            var n = yt(e), r = (n = n.replace(/\r\n|\r(?=[^\n]|$)/gm, "\n")).split(/\n{2,}/m);
                            if (!/^WEBVTT($|[ \t\n])/m.test(r[0])) throw new De(2, 2, 2e3);
                            if (n = t.vttOffset, r[0].includes("X-TIMESTAMP-MAP") && this.g) {
                                var i = r[0].match(/LOCAL:((?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{3}))/m), a1 = r[0].match(/MPEGTS:(\d+)/m);
                                if (i && a1) {
                                    if (null == (n = Dm(new lf(i[1])))) throw new De(2, 2, 2e3);
                                    for(a1 = Number(a1[1]), i = t.segmentStart - t.periodStart; 95443.7176888889 <= i;)i -= 95443.7176888889, a1 += 8589934592;
                                    n = t.periodStart + a1 / 9e4 - n;
                                }
                            }
                            a1 = [];
                            for(var o = (i = l(r[0].split("\n"))).next(); !o.done; o = i.next())if (o = o.value, /^Region:/.test(o)) {
                                o = new lf(o);
                                var s1 = new Ee;
                                ff(o), cf(o);
                                for(var u = ff(o); u;){
                                    var c = s1, d = u;
                                    (u = /^id=(.*)$/.exec(d)) ? c.id = u[1] : (u = /^width=(\d{1,2}|100)%$/.exec(d)) ? c.width = Number(u[1]) : (u = /^lines=(\d+)$/.exec(d)) ? (c.height = Number(u[1]), c.heightUnits = 2) : (u = /^regionanchor=(\d{1,2}|100)%,(\d{1,2}|100)%$/.exec(d)) ? (c.regionAnchorX = Number(u[1]), c.regionAnchorY = Number(u[2])) : (u = /^viewportanchor=(\d{1,2}|100)%,(\d{1,2}|100)%$/.exec(d)) ? (c.viewportAnchorX = Number(u[1]), c.viewportAnchorY = Number(u[2])) : /^scroll=up$/.exec(d) && (c.scroll = "up"), cf(o), u = ff(o);
                                }
                                a1.push(s1);
                            }
                            for(Sm(i = new Map), o = [], s1 = (r = l(r.slice(1))).next(); !s1.done; s1 = r.next()){
                                if ((1 != (s1 = s1.value.split("\n")).length || s1[0]) && !/^NOTE($|[ \t])/.test(s1[0]) && "STYLE" == s1[0] && s1[1].includes("::cue")) {
                                    c = "global", (u = s1[1].match(/\((.*)\)/)) && (c = u.pop()), u = s1.slice(2, -1), s1[1].includes("}") && (d = /\{(.*?)\}/.exec(s1[1])) && (u = d[1].split(";")), d = new ne(0, 0, "");
                                    for(var f = !1, h = 0; h < u.length; h++){
                                        var g = /^\s*([^:]+):\s*(.*)/.exec(u[h]);
                                        if (g) {
                                            var p = g[2].trim().replace(";", "");
                                            switch(g[1].trim()){
                                                case "background-color":
                                                    f = !0, d.backgroundColor = p;
                                                    break;
                                                case "color":
                                                    f = !0, d.color = p;
                                                    break;
                                                case "font-family":
                                                    f = !0, d.fontFamily = p;
                                                    break;
                                                case "font-size":
                                                    f = !0, d.fontSize = p;
                                                    break;
                                                case "font-weight":
                                                    700 <= parseInt(p, 10) && (f = !0, d.fontWeight = 700);
                                                    break;
                                                case "font-style":
                                                    switch(p){
                                                        case "normal":
                                                            f = !0, d.fontStyle = ve;
                                                            break;
                                                        case "italic":
                                                            f = !0, d.fontStyle = "italic";
                                                            break;
                                                        case "oblique":
                                                            f = !0, d.fontStyle = "oblique";
                                                    }
                                                    break;
                                                case "opacity":
                                                    f = !0, d.opacity = parseFloat(p);
                                                    break;
                                                case "text-shadow":
                                                    f = !0, d.textShadow = p;
                                                    break;
                                                case "white-space":
                                                    f = !0, d.wrapLine = "noWrap" != p;
                                            }
                                        }
                                    }
                                    f && i.set(c, d);
                                }
                                if (h = n, 1 == s1.length && !s1[0] || /^NOTE($|[ \t])/.test(s1[0]) || "STYLE" == s1[0]) s1 = null;
                                else {
                                    if (c = null, s1[0].includes("--\x3e") || (c = s1[0], s1.splice(0, 1)), d = Dm(u = new lf(s1[0])), g = df(u, /[ \t]+--\x3e[ \t]+/g), f = Dm(u), null == d || null == g || null == f) throw new De(2, 2, 2001, "Could not parse cue time range in WebVTT");
                                    for(d += h, f += h, h = km(s1.slice(1).join("\n").trim()), i.has("global") ? ((s1 = i.get("global").clone()).startTime = d, s1.endTime = f, s1.payload = "") : s1 = new ne(d, f, ""), wm(h, s1, i), cf(u), d = ff(u); d;)Cm(s1, d, a1), cf(u), d = ff(u);
                                    null != c && (s1.id = c);
                                }
                                s1 && o.push(s1);
                            }
                            return o;
                        }, B("shaka.text.VttTextParser", _m), _m.prototype.parseMedia = _m.prototype.parseMedia, _m.prototype.setSequenceMode = _m.prototype.setSequenceMode, _m.prototype.parseInit = _m.prototype.parseInit;
                        var Nm = /(?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{2,3})/g;
                        function Lm() {
                            this.g = null;
                        }
                        function xm(e, t, n) {
                            var r, i, a1;
                            return (new Vr).box("payl", Yr(function(e) {
                                r = yt(e);
                            })).box("iden", Yr(function(e) {
                                i = yt(e);
                            })).box("sttg", Yr(function(e) {
                                a1 = yt(e);
                            })).parse(e), r ? function(e, t, n, r, i) {
                                if (wm(e, r = new ne(r, i, ""), new Map), t && (r.id = t), n) for(t = ff(e = new lf(n)); t;)Cm(r, t, []), cf(e), t = ff(e);
                                return r;
                            }(r, i, a1, t, n) : null;
                        }
                        function Mm() {}
                        function Om(e) {
                            if (null == (e = df(e, /(?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{2,3})/g))) return null;
                            var t = Number(e[2]), n = Number(e[3]);
                            return 59 < t || 59 < n ? null : Number(e[4]) / 1e3 + n + 60 * t + 3600 * (Number(e[1]) || 0);
                        }
                        function Pm() {
                            this.g = new _m;
                        }
                        function Fm(e) {
                            var t = "WEBVTT\n\n";
                            if ("" == e) return t;
                            for(var n = (e = l((e = (e = e.replace(/\r+/g, "")).trim()).split("\n\n"))).next(); !n.done; n = e.next())(n = n.value.split(/\n/))[0].match(/\d+/) && n.shift(), n[0] = n[0].replace(/,/g, "."), t += n.join("\n") + "\n\n";
                            return t;
                        }
                        function Um() {}
                        function jm(e, t) {
                            var n = t.Fontname;
                            if (n && (e.fontFamily = n), (n = t.Fontsize) && (e.fontSize = n + "px"), (n = t.PrimaryColour) && (n = Bm(n)) && (e.color = n), (n = t.BackColour) && (n = Bm(n)) && (e.backgroundColor = n), t.Bold && (e.fontWeight = 700), t.Italic && (e.fontStyle = "italic"), t.Underline && e.textDecoration.push("underline"), (n = t.Spacing) && (e.letterSpacing = n + "px"), n = t.Alignment) switch(parseInt(n, 10)){
                                case 1:
                                    e.displayAlign = se, e.textAlign = "start";
                                    break;
                                case 2:
                                    e.displayAlign = se, e.textAlign = ae;
                                    break;
                                case 3:
                                    e.displayAlign = se, e.textAlign = "end";
                                    break;
                                case 5:
                                    e.displayAlign = "before", e.textAlign = "start";
                                    break;
                                case 6:
                                    e.displayAlign = "before", e.textAlign = ae;
                                    break;
                                case 7:
                                    e.displayAlign = "before", e.textAlign = "end";
                                    break;
                                case 9:
                                    e.displayAlign = "center", e.textAlign = "start";
                                    break;
                                case 10:
                                    e.displayAlign = "center", e.textAlign = ae;
                                    break;
                                case 11:
                                    e.displayAlign = "center", e.textAlign = "end";
                            }
                            (n = t.AlphaLevel) && (e.opacity = parseFloat(n));
                        }
                        function Bm(e) {
                            return 0 <= (e = parseInt(e.replace("&H", ""), 16)) ? "rgba(" + (255 & e) + "," + (e >> 8 & 255) + "," + (e >> 16 & 255) + "," + (e >> 24 & 255 ^ 255) / 255 + ")" : null;
                        }
                        function Gm(e) {
                            return 3600 * ((e = Wm.exec(e))[1] ? parseInt(e[1].replace(":", ""), 10) : 0) + 60 * parseInt(e[2], 10) + parseFloat(e[3]);
                        }
                        Qt["text/vtt"] = function() {
                            return new _m;
                        }, Qt['text/vtt; codecs="vtt"'] = function() {
                            return new _m;
                        }, Qt['text/vtt; codecs="wvtt"'] = function() {
                            return new _m;
                        }, Lm.prototype.parseInit = function(e) {
                            var t = this, n = !1;
                            if ((new Vr).box("moov", Kr).box("trak", Kr).box("mdia", Kr).T("mdhd", function(e) {
                                e = to(e.reader, e.version), t.g = e.timescale;
                            }).box("minf", Kr).box("stbl", Kr).T("stsd", qr).box("wvtt", function() {
                                n = !0;
                            }).parse(e), !this.g) throw new De(2, 2, 2008);
                            if (!n) throw new De(2, 2, 2008);
                        }, Lm.prototype.setSequenceMode = function() {}, Lm.prototype.parseMedia = function(e, t) {
                            if (!this.g) throw new De(2, 2, 2008);
                            var n, r = 0, i = [], a1 = [], o = !1, s1 = !1, u = !1, c = null;
                            if ((new Vr).box("moof", Kr).box("traf", Kr).T("tfdt", function(e) {
                                o = !0, r = eo(e.reader, e.version).ue;
                            }).T("tfhd", function(e) {
                                c = $a(e.reader, e.flags).Ae;
                            }).T("trun", function(e) {
                                s1 = !0, i = no(e.reader, e.version, e.flags).Qe;
                            }).box("mdat", Yr(function(e) {
                                u = !0, n = e;
                            })).parse(e, !1), !u && !o && !s1) throw new De(2, 2, 2008);
                            for(var d = r, f = new Br(n, 0), h = l(i), g = h.next(); !g.done; g = h.next()){
                                var p = (g = g.value).de || c, m = g.fd ? r + g.fd : d;
                                d = m + (p || 0);
                                var v = 0;
                                do {
                                    var y = f.L();
                                    v += y;
                                    var E = null;
                                    "vttc" == zr(f.L()) ? 8 < y && (E = f.$a(y - 8)) : f.skip(y - 8), p && E && (y = xm(E, t.periodStart + m / this.g, t.periodStart + d / this.g), a1.push(y));
                                }while (g.sampleSize && v < g.sampleSize);
                            }
                            return a1.filter(We);
                        }, B("shaka.text.Mp4VttParser", Lm), Lm.prototype.parseMedia = Lm.prototype.parseMedia, Lm.prototype.setSequenceMode = Lm.prototype.setSequenceMode, Lm.prototype.parseInit = Lm.prototype.parseInit, Qt['application/mp4; codecs="wvtt"'] = function() {
                            return new Lm;
                        }, Mm.prototype.parseInit = function() {}, Mm.prototype.setSequenceMode = function() {}, Mm.prototype.parseMedia = function(e) {
                            var t = yt(e).replace(/\r+/g, "");
                            if (e = [], "" == (t = t.trim())) return e;
                            for(var n = (t = l(t.split("\n\n"))).next(); !n.done; n = t.next()){
                                var r = new lf((n = n.value.split("\n"))[0]), i = Om(r), a1 = df(r, /,/g);
                                if (r = Om(r), null == i || null == a1 || null == r) throw new De(2, 2, 2001, "Could not parse cue time range in SubViewer");
                                e.push(new ne(i, r, n.slice(1).join("\n").trim()));
                            }
                            return e;
                        }, B("shaka.text.SbvTextParser", Mm), Mm.prototype.parseMedia = Mm.prototype.parseMedia, Mm.prototype.setSequenceMode = Mm.prototype.setSequenceMode, Mm.prototype.parseInit = Mm.prototype.parseInit, Qt["text/x-subviewer"] = function() {
                            return new Mm;
                        }, Pm.prototype.parseInit = function() {}, Pm.prototype.setSequenceMode = function() {}, Pm.prototype.parseMedia = function(e, t) {
                            var n = yt(e);
                            return n = Ie(bt(n = Fm(n))), this.g.parseMedia(n, t);
                        }, B("shaka.text.SrtTextParser", Pm), Pm.srt2webvtt = Fm, Pm.prototype.parseMedia = Pm.prototype.parseMedia, Pm.prototype.setSequenceMode = Pm.prototype.setSequenceMode, Pm.prototype.parseInit = Pm.prototype.parseInit, Qt["text/srt"] = function() {
                            return new Pm;
                        }, Um.prototype.parseInit = function() {}, Um.prototype.setSequenceMode = function() {}, Um.prototype.parseMedia = function(e) {
                            for(var t = "", n = "", r = (e = l(e = yt(e).split(/\r?\n\s*\r?\n/))).next(); !r.done; r = e.next()){
                                var i = Km.exec(r.value);
                                i && (r = i[1], i = i[2], "V4 Styles" == r || "V4+ Styles" == r ? t = i : "Events" == r && (n = i));
                            }
                            e = [], r = null;
                            for(var a1 = (t = l(t.split(/\r?\n/))).next(); !a1.done; a1 = t.next())if (i = a1.value, !/^\s*;/.test(i) && (a1 = qm.exec(i))) {
                                if (i = a1[1].trim(), a1 = a1[2].trim(), "Format" == i) r = a1.split(Ym);
                                else if ("Style" == i) {
                                    i = a1.split(Ym), a1 = {};
                                    for(var o = 0; o < r.length && o < i.length; o++)a1[r[o]] = i[o];
                                    e.push(a1);
                                }
                            }
                            for(r = [], t = null, i = {}, a1 = (n = l(n.split(/\r?\n/))).next(); !a1.done; i = {
                                wd: i.wd
                            }, a1 = n.next())if (a1 = a1.value, !/^\s*;/.test(a1) && (o = qm.exec(a1))) {
                                if (a1 = o[1].trim(), o = o[2].trim(), "Format" == a1) t = o.split(Ym);
                                else if ("Dialogue" == a1) {
                                    o = o.split(Ym), a1 = {};
                                    for(var s1 = 0; s1 < t.length && s1 < o.length; s1++)a1[t[s1]] = o[s1];
                                    o = new ne(s1 = Gm(a1.Start), Gm(a1.End), o.slice(t.length - 1).join(",").replace(/\\N/g, "\n").replace(/\{[^}]+\}/g, "")), i.wd = a1.Style, (a1 = e.find(function(e) {
                                        return function(t) {
                                            return t.Name == e.wd;
                                        };
                                    }(i))) && jm(o, a1), r.push(o);
                                }
                            }
                            return r;
                        }, B("shaka.text.SsaTextParser", Um), Um.prototype.parseMedia = Um.prototype.parseMedia, Um.prototype.setSequenceMode = Um.prototype.setSequenceMode, Um.prototype.parseInit = Um.prototype.parseInit;
                        var Hm, Vm, Km = /^\s*\[([^\]]+)\]\r?\n([\s\S]*)/, qm = /^\s*([^:]+):\s*(.*)/, Ym = /\s*,\s*/, Wm = /^(\d+:)?(\d{1,2}):(\d{1,2}(?:[.]\d{1,3})?)?$/;
                        function zm() {}
                        function Xm(e, t, n) {
                            function r(e) {
                                Re(a1).setUint32(o, e.byteLength, !0), o += 4, a1.set(Ie(e), o), o += e.byteLength;
                            }
                            if (!n || !n.byteLength) throw new De(2, 6, 6015);
                            var i;
                            i = "string" == typeof t ? At(t, !0) : t, e = At(e = Tt(e), !0);
                            var a1 = new Uint8Array(12 + e.byteLength + i.byteLength + n.byteLength), o = 0;
                            return r(e), r(i), r(n), a1;
                        }
                        function Qm() {}
                        function Jm() {
                            Hm ? console.debug("EmeEncryptionSchemePolyfill: Already installed.") : navigator.requestMediaKeySystemAccess && MediaKeySystemAccess.prototype.getConfiguration ? (Hm = navigator.requestMediaKeySystemAccess, console.debug("EmeEncryptionSchemePolyfill: Waiting to detect encryptionScheme support."), navigator.requestMediaKeySystemAccess = Zm) : console.debug("EmeEncryptionSchemePolyfill: EME not found");
                        }
                        function Zm(e, t) {
                            var n, r = this;
                            return L(function(i) {
                                return 1 == i.g ? (console.assert(r == navigator, 'bad "this" for requestMediaKeySystemAccess'), T(i, Hm.call(r, e, t), 2)) : uv(n = i.h) ? (console.debug("EmeEncryptionSchemePolyfill: Native encryptionScheme support found."), navigator.requestMediaKeySystemAccess = Hm, i.return(n)) : (console.debug("EmeEncryptionSchemePolyfill: No native encryptionScheme support found. Patching encryptionScheme support."), navigator.requestMediaKeySystemAccess = $m, i.return($m.call(r, e, t)));
                            });
                        }
                        function $m(e, t) {
                            var n, r, i, a1, o, s1, u, c, d, f, h = this;
                            return L(function(g) {
                                if (1 == g.g) {
                                    for(console.assert(h == navigator, 'bad "this" for requestMediaKeySystemAccess'), n = sv(e), r = [], i = l(t), a1 = i.next(); !a1.done; a1 = i.next())o = a1.value, s1 = ev(o.videoCapabilities, n), u = ev(o.audioCapabilities, n), o.videoCapabilities && o.videoCapabilities.length && !s1.length || o.audioCapabilities && o.audioCapabilities.length && !u.length || ((c = Object.assign({}, o)).videoCapabilities = s1, c.audioCapabilities = u, r.push(c));
                                    if (!r.length) throw (d = Error("Unsupported keySystem or supportedConfigurations.")).name = "NotSupportedError", d.code = DOMException.NOT_SUPPORTED_ERR, d;
                                    return T(g, Hm.call(h, e, r), 2);
                                }
                                return f = g.h, g.return(new ov(f, n));
                            });
                        }
                        function ev(e, t) {
                            return e ? e.filter(function(e) {
                                return !e.encryptionScheme || e.encryptionScheme == t;
                            }) : e;
                        }
                        function tv() {}
                        function nv() {
                            Vm ? console.debug("McEncryptionSchemePolyfill: Already installed.") : navigator.mediaCapabilities ? (Vm = navigator.mediaCapabilities.decodingInfo, console.debug("McEncryptionSchemePolyfill: Waiting to detect encryptionScheme support."), navigator.mediaCapabilities.decodingInfo = rv) : console.debug("McEncryptionSchemePolyfill: MediaCapabilities not found");
                        }
                        function rv(e) {
                            var t, n, r, i = this;
                            return L(function(a1) {
                                switch(a1.g){
                                    case 1:
                                        return console.assert(i == navigator.mediaCapabilities, 'bad "this" for decodingInfo'), T(a1, Vm.call(i, e), 2);
                                    case 2:
                                        if (t = a1.h, !e.keySystemConfiguration) return a1.return(t);
                                        if ((n = t.keySystemAccess) && uv(n)) return console.debug("McEncryptionSchemePolyfill: Native encryptionScheme support found."), navigator.mediaCapabilities.decodingInfo = Vm, a1.return(t);
                                        if (console.debug("McEncryptionSchemePolyfill: No native encryptionScheme support found. Patching encryptionScheme support."), navigator.mediaCapabilities.decodingInfo = iv, n) {
                                            a1.A(3);
                                            break;
                                        }
                                        return r = t, T(a1, av(e), 4);
                                    case 4:
                                        return r.keySystemAccess = a1.h, a1.return(t);
                                    case 3:
                                        return a1.return(iv.call(i, e));
                                }
                            });
                        }
                        function iv(e) {
                            var t, n, r, i, a1, o, s1, u, l = this;
                            return L(function(c) {
                                switch(c.g){
                                    case 1:
                                        return console.assert(l == navigator.mediaCapabilities, 'bad "this" for decodingInfo'), t = null, e.keySystemConfiguration && (n = e.keySystemConfiguration, r = n.keySystem, i = n.audio && n.audio.encryptionScheme, a1 = n.video && n.video.encryptionScheme, t = sv(r), o = {
                                            powerEfficient: !1,
                                            smooth: !1,
                                            supported: !1,
                                            keySystemAccess: null,
                                            configuration: e
                                        }, i && i != t || a1 && a1 != t) ? c.return(o) : T(c, Vm.call(l, e), 2);
                                    case 2:
                                        if ((s1 = c.h).keySystemAccess) {
                                            s1.keySystemAccess = new ov(s1.keySystemAccess, t), c.A(3);
                                            break;
                                        }
                                        if (!e.keySystemConfiguration) {
                                            c.A(3);
                                            break;
                                        }
                                        return u = s1, T(c, av(e), 5);
                                    case 5:
                                        u.keySystemAccess = c.h;
                                    case 3:
                                        return c.return(s1);
                                }
                            });
                        }
                        function av(e) {
                            var t, n;
                            return L(function(r) {
                                if (1 == r.g) {
                                    var i = e.keySystemConfiguration, a1 = [], o = [];
                                    return i.audio && a1.push({
                                        robustness: i.audio.robustness || "",
                                        contentType: e.audio.contentType
                                    }), i.video && o.push({
                                        robustness: i.video.robustness || "",
                                        contentType: e.video.contentType
                                    }), i = {
                                        initDataTypes: i.initDataType ? [
                                            i.initDataType
                                        ] : [],
                                        distinctiveIdentifier: i.distinctiveIdentifier,
                                        persistentState: i.persistentState,
                                        sessionTypes: i.sessionTypes
                                    }, a1.length && (i.audioCapabilities = a1), o.length && (i.videoCapabilities = o), t = i, T(r, navigator.requestMediaKeySystemAccess(e.keySystemConfiguration.keySystem, [
                                        t
                                    ]), 2);
                                }
                                return n = r.h, r.return(n);
                            });
                        }
                        function ov(e, t) {
                            this.h = e, this.g = t, this.keySystem = e.keySystem;
                        }
                        function sv(e) {
                            return e.startsWith("com.widevine") || e.startsWith("com.microsoft") || e.startsWith("com.chromecast") || e.startsWith("com.adobe") || e.startsWith("org.w3") ? "cenc" : e.startsWith("com.apple") ? "cbcs-1-9" : (console.warn("EmeEncryptionSchemePolyfill: Unknown key system:", e, "Please contribute!"), null);
                        }
                        function uv(e) {
                            var t = (e = e.getConfiguration()).audioCapabilities && e.audioCapabilities[0];
                            return !(!(e = e.videoCapabilities && e.videoCapabilities[0] || t) || void 0 === e.encryptionScheme);
                        }
                        function lv() {}
                        function cv() {
                            Jm(), nv();
                        }
                        Qt["text/x-ssa"] = function() {
                            return new Um;
                        }, B("shaka.util.FairPlayUtils", zm), zm.commonFairPlayResponse = function(e, t) {
                            if (2 === e) {
                                try {
                                    var n = yt(t.data);
                                } catch (e) {
                                    return;
                                }
                                var r = !1;
                                "<ckc>" === (n = n.trim()).substr(0, 5) && "</ckc>" === n.substr(-6) && (n = n.slice(5, -6), r = !0);
                                try {
                                    var i = JSON.parse(n);
                                    i.ckc && (n = i.ckc, r = !0), i.CkcMessage && (n = i.CkcMessage, r = !0), i.License && (n = i.License, r = !0);
                                } catch (e) {}
                                r && (t.data = we(Rt(n)));
                            }
                        }, zm.conaxFairPlayRequest = function(e, t) {
                            2 === e && (t.headers["Content-Type"] = "application/octet-stream");
                        }, zm.ezdrmFairPlayRequest = function(e, t) {
                            2 === e && (t.headers["Content-Type"] = "application/octet-stream");
                        }, zm.verimatrixFairPlayRequest = function(e, t) {
                            if (2 === e) {
                                var n = Ie(t.body);
                                n = It(n), t.headers["Content-Type"] = "application/x-www-form-urlencoded", t.body = bt("spc=" + n);
                            }
                        }, zm.conaxInitDataTransform = function(t, n, r) {
                            if ("skd" !== n) return t;
                            n = r.serverCertificate, r = Tt(t).split("skd://").pop().split("?").shift(), r = e.atob(r);
                            var i = new ArrayBuffer(2 * r.length);
                            i = new Uint16Array(i);
                            for(var a1 = 0, o = r.length; a1 < o; a1++)i[a1] = r.charCodeAt(a1);
                            return Xm(t, i, n);
                        }, zm.ezdrmInitDataTransform = function(e, t, n) {
                            return "skd" !== t ? e : (t = n.serverCertificate, Xm(e, n = Tt(e).split(";").pop(), t));
                        }, zm.verimatrixInitDataTransform = function(e, t, n) {
                            return "skd" !== t ? e : (t = n.serverCertificate, Xm(e, n = Tt(e).split("skd://").pop(), t));
                        }, zm.initDataTransform = Xm, zm.defaultGetContentId = function(e) {
                            return new Ne(e = Tt(e)).Fa;
                        }, zm.isFairPlaySupported = function() {
                            var e;
                            return L(function(t) {
                                return 1 == t.g ? (e = {
                                    initDataTypes: [
                                        "cenc",
                                        "sinf",
                                        "skd"
                                    ],
                                    videoCapabilities: [
                                        {
                                            contentType: 'video/mp4; codecs="avc1.42E01E"'
                                        }
                                    ]
                                }, A(t, 2), T(t, navigator.requestMediaKeySystemAccess("com.apple.fps", [
                                    e
                                ]), 4)) : 2 != t.g ? t.return(!0) : (w(t), t.return(!1));
                            });
                        }, B("EmeEncryptionSchemePolyfill", Qm), Qm.install = Jm, B("McEncryptionSchemePolyfill", tv), tv.install = nv, ov.prototype.getConfiguration = function() {
                            var e = this.h.getConfiguration();
                            if (e.videoCapabilities) for(var t = l(e.videoCapabilities), n = t.next(); !n.done; n = t.next())n.value.encryptionScheme = this.g;
                            if (e.audioCapabilities) for(n = (t = l(e.audioCapabilities)).next(); !n.done; n = t.next())n.value.encryptionScheme = this.g;
                            return e;
                        }, ov.prototype.createMediaKeys = function() {
                            return this.h.createMediaKeys();
                        }, B("EncryptionSchemePolyfills", lv), lv.install = cv, void 0 !== n && n.exports && (n.exports = lv);
                    }).call(r, e, e, void 0), r.shaka)t[i] = r.shaka[i];
                }();
            },
            147: (e, t)=>{
                var n;
                !function() {
                    "use strict";
                    var r = {}.hasOwnProperty;
                    function i() {
                        for(var e = [], t = 0; t < arguments.length; t++){
                            var n = arguments[t];
                            if (n) {
                                var a1 = typeof n;
                                if ("string" === a1 || "number" === a1) e.push(n);
                                else if (Array.isArray(n) && n.length) {
                                    var o = i.apply(null, n);
                                    o && e.push(o);
                                } else if ("object" === a1) for(var s1 in n)r.call(n, s1) && n[s1] && e.push(s1);
                            }
                        }
                        return e.join(" ");
                    }
                    e.exports ? (i.default = i, e.exports = i) : void 0 === (n = (function() {
                        return i;
                    }).apply(t, [])) || (e.exports = n);
                }();
            },
            155: (e, t, n)=>{
                var r = n(652);
                function i(e, t, n, r) {
                    Object.defineProperty(e, t, {
                        get: n,
                        set: r,
                        enumerable: !0,
                        configurable: !0
                    });
                }
                i(e.exports, "VideoEventFilter", ()=>a1.VideoEventFilter), i(e.exports, "PlayerEvents", ()=>a1.PlayerEvents), i(e.exports, "PlayerState", ()=>a1.PlayerState);
                var a1 = {};
                i(a1, "PlayerState", ()=>s1, (e)=>s1 = e), i(a1, "PlayerEvents", ()=>u, (e)=>u = e), i(a1, "VideoEventFilter", ()=>d, (e)=>d = e);
                var o, s1, u, l = function() {
                    function e() {
                        this.emitter = (function(e) {
                            return e && e.__esModule ? e.default : e;
                        })(r)();
                    }
                    return e.prototype.addEventListener = function(e, t) {
                        this.emitter.on.apply(this, [
                            e,
                            t
                        ]);
                    }, e.prototype.removeEventListener = function(e, t) {
                        this.emitter && this.emitter.off.apply(this, [
                            e,
                            t
                        ]);
                    }, e.prototype.clear = function() {
                        this.emitter.all.clear();
                    }, e.prototype.emit = function(e, t) {
                        this.emitter && this.emitter.emit.apply(this, [
                            e,
                            t
                        ]);
                    }, e;
                }(), c = (o = function(e, t) {
                    return (o = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(e, t) {
                        e.__proto__ = t;
                    } || function(e, t) {
                        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
                    })(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function n() {
                        this.constructor = e;
                    }
                    o(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
                });
                !function(e) {
                    e.Loading = "loading", e.Playing = "playing", e.Paused = "paused", e.Buffering = "buffering", e.Seeking = "seeking", e.Ended = "ended";
                }(s1 || (s1 = {})), function(e) {
                    e.Loading = "loading", e.Loaded = "loaded", e.Play = "play", e.Resume = "resume", e.Pause = "pause", e.Seeking = "seeking", e.Seeked = "seeked", e.Buffering = "buffering", e.Buffered = "buffered", e.TimeUpdate = "timeupdate", e.Ended = "ended", e.Error = "error";
                }(u || (u = {}));
                var d = function(e) {
                    function t(t) {
                        var n = e.call(this) || this;
                        return n.videoElement = t, "string" == typeof t && (n.videoElement = document.querySelector(t)), n.state = s1.Loading, n.lastState, n.emit(u.Loading), n.setupEventListeners(), n;
                    }
                    return c(t, e), t.prototype.setupEventListeners = function() {
                        this.videoElement.addEventListener("loadeddata", this.onLoaded.bind(this)), this.videoElement.addEventListener("playing", this.onPlaying.bind(this)), this.videoElement.addEventListener("pause", this.onPause.bind(this)), this.videoElement.addEventListener("seeking", this.onSeeking.bind(this)), this.videoElement.addEventListener("seeked", this.onSeeked.bind(this)), this.videoElement.addEventListener("waiting", this.onBuffering.bind(this)), this.videoElement.addEventListener("timeupdate", this.onTimeUpdate.bind(this)), this.videoElement.addEventListener("error", this.onError.bind(this)), this.videoElement.addEventListener("ended", this.onEnded.bind(this));
                    }, t.prototype.onLoaded = function() {
                        this.state === s1.Loading && this.emit(u.Loaded);
                    }, t.prototype.onPlaying = function() {
                        this.state === s1.Ended && this.setState(s1.Loading), [
                            s1.Loading,
                            s1.Paused
                        ].includes(this.state) && (this.state === s1.Loading && this.emit(u.Play), this.state === s1.Paused && (this.lastState = s1.Paused, this.emit(u.Resume)), this.setState(s1.Playing, !0)), this.state === s1.Buffering && this.onBuffered();
                    }, t.prototype.onPause = function() {
                        var e = this;
                        this.state === s1.Playing && (clearTimeout(this.pauseDebounce), this.pauseDebounce = setTimeout(function() {
                            e.emit(u.Pause), e.setState(s1.Paused, !0);
                        }, 200));
                    }, t.prototype.onSeeking = function() {
                        [
                            s1.Loading,
                            s1.Seeking,
                            s1.Ended
                        ].includes(this.state) || (clearTimeout(this.pauseDebounce), this.setState(s1.Seeking, !0), this.emit(u.Seeking));
                    }, t.prototype.onSeeked = function() {
                        this.state === s1.Seeking && (this.setState(this.lastState, !0), this.emit(u.Seeked));
                    }, t.prototype.onBuffering = function() {
                        [
                            s1.Loading,
                            s1.Buffering,
                            s1.Seeking,
                            s1.Ended
                        ].includes(this.state) || (this.setState(s1.Buffering, !0), this.emit(u.Buffering));
                    }, t.prototype.onBuffered = function() {
                        this.state === s1.Buffering && (this.setState(this.lastState, !0), this.emit(u.Buffered));
                    }, t.prototype.onTimeUpdate = function() {
                        [
                            s1.Loading,
                            s1.Paused,
                            s1.Seeking,
                            s1.Buffering,
                            s1.Ended
                        ].includes(this.state) || this.emit(u.TimeUpdate);
                    }, t.prototype.onEnded = function() {
                        clearTimeout(this.pauseDebounce), this.state !== s1.Ended && (this.setState(s1.Ended), this.emit(u.Ended));
                    }, t.prototype.onError = function(e) {
                        this.state !== s1.Ended && (this.emit(u.Error, e), this.onEnded());
                    }, t.prototype.getState = function() {
                        return this.state;
                    }, t.prototype.setState = function(e, t) {
                        t && this.updateLastState(this.state), this.state = e;
                    }, t.prototype.updateLastState = function(e) {
                        this.lastState = e || this.state;
                    }, t;
                }(l);
            },
            665: (e, t, n)=>{
                "use strict";
                n.d(t, {
                    Z: ()=>a1
                });
                var r = n(645), i = n.n(r)()(!0);
                i.push([
                    e.id,
                    "._2aAzG{position:relative;display:flex;align-items:center}._2aAzG>*{margin-right:1em}._2aAzG>:last-child{margin-right:0}._2aAzG._3K51E ._-LGHu,._2aAzG._3K51E ._t3a1b{visibility:hidden}._2aAzG ._-LGHu{color:#fff;white-space:nowrap}._2aAzG ._t3a1b{display:flex;justify-content:center;align-items:center;width:100%;padding:.5em 0;cursor:pointer}._2aAzG ._K1UW_{position:relative;width:100%;height:.25em;background:hsla(0,0%,100%,.3)}._2aAzG ._1Xt9z{position:absolute;top:0;left:0;width:0;height:100%;background:#fff}\n._1gDwG{cursor:pointer;background:#9f1e2b;color:#fff;padding:0 .5em;border-radius:.25em;white-space:nowrap}._1gDwG._22_VN{opacity:.5}\n._3njg6{width:1.5em;height:1.5em;cursor:pointer}._3njg6 svg{width:100%;height:100%;fill:hsla(0,0%,100%,.8)}._3njg6 svg:hover{fill:#fff}\n._1AKsf{width:1.5em;height:1.5em;cursor:pointer;padding-top:-50px}._1AKsf svg{width:100%;height:100%;fill:hsla(0,0%,100%,.8)}._1AKsf svg:hover{fill:#fff}._1XK6B{height:8em;width:1.5em;left:50%;margin-left:-.75em;display:none;bottom:1.5em;position:absolute}._2Kn-2{background-color:rgba(228,227,227,.3);height:7em;cursor:pointer;border-radius:.1em;bottom:.15em;left:50%;margin-left:-.35em;border:.05em solid rgba(187,186,186,.5)}._2Kn-2,._CZcKs{width:.7em;position:absolute}._CZcKs{background-color:#fff;border-radius:.1em;border-top:.05em solid rgba(187,186,186,.7);bottom:0;pointer-events:none}._1nhbD{position:relative}._1nhbD:hover ._1XK6B{display:block}\n._13aPK{position:relative;width:1.5em;height:1.5em;cursor:pointer}._13aPK svg{width:100%;height:100%;fill:hsla(0,0%,100%,.8)}._13aPK svg:hover{fill:#fff}._16WrP{list-style:none;position:absolute;bottom:1em;left:50%;transform:translateX(-50%);padding:.5em;white-space:nowrap;background:rgba(20,20,20,.6);display:none}._16WrP._Ib345{display:block}._16WrP li{margin:0}._16WrP input{display:none;margin-right:.25em}._16WrP label span{color:hsla(0,0%,100%,.8);cursor:pointer}._16WrP :checked+span{color:#1e81a0}\n._34Jhj{width:1.5em;height:1.5em;cursor:pointer}._34Jhj svg{width:100%;height:100%;fill:hsla(0,0%,100%,.8)}._34Jhj svg:hover{fill:#fff}\n._2jAm9{top:0;width:100%;height:100%;z-index:1;opacity:1;transition:opacity .2s;outline:none;font-family:Helvetica,Arial;line-height:1.5}._2jAm9,._SS6y-{position:absolute;left:0}._SS6y-{bottom:0;width:calc(100% - 16px);box-sizing:content-box;padding:8px;background:linear-gradient(1turn,#000,transparent)}._SS6y-._1Wfm6{display:none}._1pnfN{display:flex;margin-bottom:.5em}._1pnfN>*{margin-right:.5em}._1pnfN>:last-child{margin-right:0}._3ju96{flex:1}\n._2eFId{position:absolute;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center}._2eFId svg{width:3em;height:3em}\n._4r-db{position:relative;width:1.5em;height:1.5em;cursor:pointer}._4r-db svg{width:100%;height:100%;fill:hsla(0,0%,100%,.8)}._4r-db svg:hover{fill:#fff}._1b4Xq{list-style:none;position:absolute;bottom:1em;left:50%;transform:translateX(-50%);padding:.5em;white-space:nowrap;background:rgba(20,20,20,.6);display:none}._1b4Xq._8qwvr{display:block}._1b4Xq li{margin:0}._1b4Xq input{display:none;margin-right:.25em}._1b4Xq label span{color:hsla(0,0%,100%,.8);cursor:pointer}._1b4Xq :checked+span{color:#1e81a0}\n._2XaiH{width:1.5em;height:1.5em;cursor:pointer}._2XaiH svg{width:100%;height:100%;fill:hsla(0,0%,100%,.8)}._2XaiH svg:hover{fill:#fff}\n._mM3Gy{width:1.5em;height:1.5em;cursor:pointer}\n._2lVG2{position:absolute;top:0;left:0;background:#111;color:#fff;border:1px solid #ccc;border-radius:.2rem;padding:.2rem;font-size:.8rem}._2lVG2:hover{background:#222}._2lVG2 a{color:inherit;text-decoration:none;display:flex;align-items:center;white-space:nowrap;overflow:hidden}._yCzmM{height:1rem;margin-bottom:0;margin-left:.5rem}\n._xDOFW{position:absolute;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;background:#000;pointer-events:none}._xDOFW svg{width:33%;height:33%;fill:#fff}\n._1Xl8W{position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background:#000}._1Xl8W video{display:block;width:100%;height:100%}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://../eyevinn-skin/dist/index.css"
                        ],
                        names: [],
                        mappings: "AAAA,QAAQ,iBAAiB,CAAC,YAAY,CAAC,kBAAkB,CAAC,UAAU,gBAAgB,CAAC,oBAAoB,cAAc,CAAC,8CAA8C,iBAAiB,CAAC,gBAAgB,UAAU,CAAC,kBAAkB,CAAC,gBAAgB,YAAY,CAAC,sBAAsB,CAAC,kBAAkB,CAAC,UAAU,CAAC,cAAc,CAAC,cAAc,CAAC,gBAAgB,iBAAiB,CAAC,UAAU,CAAC,YAAY,CAAC,6BAA6B,CAAC,gBAAgB,iBAAiB,CAAC,KAAK,CAAC,MAAM,CAAC,OAAO,CAAC,WAAW,CAAC,eAAe;AAChgB,QAAQ,cAAc,CAAC,kBAAkB,CAAC,UAAU,CAAC,cAAc,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,eAAe,UAAU;AACpI,QAAQ,WAAW,CAAC,YAAY,CAAC,cAAc,CAAC,YAAY,UAAU,CAAC,WAAW,CAAC,uBAAuB,CAAC,kBAAkB,SAAS;AACtI,QAAQ,WAAW,CAAC,YAAY,CAAC,cAAc,CAAC,iBAAiB,CAAC,YAAY,UAAU,CAAC,WAAW,CAAC,uBAAuB,CAAC,kBAAkB,SAAS,CAAC,QAAQ,UAAU,CAAC,WAAW,CAAC,QAAQ,CAAC,kBAAkB,CAAC,YAAY,CAAC,YAAY,CAAC,iBAAiB,CAAC,QAAQ,qCAAqC,CAAC,UAAU,CAAC,cAAc,CAAC,kBAAkB,CAAC,YAAY,CAAC,QAAQ,CAAC,kBAAkB,CAAC,uCAAuC,CAAC,gBAAgB,UAAU,CAAC,iBAAiB,CAAC,QAAQ,qBAAqB,CAAC,kBAAkB,CAAC,2CAA2C,CAAC,QAAQ,CAAC,mBAAmB,CAAC,QAAQ,iBAAiB,CAAC,sBAAsB,aAAa;AAChpB,QAAQ,iBAAiB,CAAC,WAAW,CAAC,YAAY,CAAC,cAAc,CAAC,YAAY,UAAU,CAAC,WAAW,CAAC,uBAAuB,CAAC,kBAAkB,SAAS,CAAC,QAAQ,eAAe,CAAC,iBAAiB,CAAC,UAAU,CAAC,QAAQ,CAAC,0BAA0B,CAAC,YAAY,CAAC,kBAAkB,CAAC,4BAA4B,CAAC,YAAY,CAAC,eAAe,aAAa,CAAC,WAAW,QAAQ,CAAC,cAAc,YAAY,CAAC,kBAAkB,CAAC,mBAAmB,wBAAwB,CAAC,cAAc,CAAC,sBAAsB,aAAa;AACzf,QAAQ,WAAW,CAAC,YAAY,CAAC,cAAc,CAAC,YAAY,UAAU,CAAC,WAAW,CAAC,uBAAuB,CAAC,kBAAkB,SAAS;AACtI,QAAQ,KAAK,CAAC,UAAU,CAAC,WAAW,CAAC,SAAS,CAAC,SAAS,CAAC,sBAAsB,CAAC,YAAY,CAAC,2BAA2B,CAAC,eAAe,CAAC,gBAAgB,iBAAiB,CAAC,MAAM,CAAC,QAAQ,QAAQ,CAAC,uBAAuB,CAAC,sBAAsB,CAAC,WAAW,CAAC,kDAAkD,CAAC,eAAe,YAAY,CAAC,QAAQ,YAAY,CAAC,kBAAkB,CAAC,UAAU,iBAAiB,CAAC,oBAAoB,cAAc,CAAC,QAAQ,MAAM;AAClc,QAAQ,iBAAiB,CAAC,KAAK,CAAC,MAAM,CAAC,UAAU,CAAC,WAAW,CAAC,YAAY,CAAC,sBAAsB,CAAC,kBAAkB,CAAC,YAAY,SAAS,CAAC,UAAU;AACrJ,QAAQ,iBAAiB,CAAC,WAAW,CAAC,YAAY,CAAC,cAAc,CAAC,YAAY,UAAU,CAAC,WAAW,CAAC,uBAAuB,CAAC,kBAAkB,SAAS,CAAC,QAAQ,eAAe,CAAC,iBAAiB,CAAC,UAAU,CAAC,QAAQ,CAAC,0BAA0B,CAAC,YAAY,CAAC,kBAAkB,CAAC,4BAA4B,CAAC,YAAY,CAAC,eAAe,aAAa,CAAC,WAAW,QAAQ,CAAC,cAAc,YAAY,CAAC,kBAAkB,CAAC,mBAAmB,wBAAwB,CAAC,cAAc,CAAC,sBAAsB,aAAa;AACzf,QAAQ,WAAW,CAAC,YAAY,CAAC,cAAc,CAAC,YAAY,UAAU,CAAC,WAAW,CAAC,uBAAuB,CAAC,kBAAkB,SAAS;AACtI,QAAQ,WAAW,CAAC,YAAY,CAAC,cAAc;AAC/C,QAAQ,iBAAiB,CAAC,KAAK,CAAC,MAAM,CAAC,eAAe,CAAC,UAAU,CAAC,qBAAqB,CAAC,mBAAmB,CAAC,aAAa,CAAC,eAAe,CAAC,cAAc,eAAe,CAAC,UAAU,aAAa,CAAC,oBAAoB,CAAC,YAAY,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,eAAe,CAAC,QAAQ,WAAW,CAAC,eAAe,CAAC,iBAAiB;AAC7U,QAAQ,iBAAiB,CAAC,KAAK,CAAC,MAAM,CAAC,UAAU,CAAC,WAAW,CAAC,YAAY,CAAC,sBAAsB,CAAC,kBAAkB,CAAC,eAAe,CAAC,mBAAmB,CAAC,YAAY,SAAS,CAAC,UAAU,CAAC,SAAS;AACnM,QAAQ,iBAAiB,CAAC,wBAAwB,CAAC,qBAAqB,CAAC,oBAAoB,CAAC,gBAAgB,CAAC,eAAe,CAAC,cAAc,aAAa,CAAC,UAAU,CAAC,WAAW",
                        sourcesContent: [
                            "._2aAzG{position:relative;display:flex;align-items:center}._2aAzG>*{margin-right:1em}._2aAzG>:last-child{margin-right:0}._2aAzG._3K51E ._-LGHu,._2aAzG._3K51E ._t3a1b{visibility:hidden}._2aAzG ._-LGHu{color:#fff;white-space:nowrap}._2aAzG ._t3a1b{display:flex;justify-content:center;align-items:center;width:100%;padding:.5em 0;cursor:pointer}._2aAzG ._K1UW_{position:relative;width:100%;height:.25em;background:hsla(0,0%,100%,.3)}._2aAzG ._1Xt9z{position:absolute;top:0;left:0;width:0;height:100%;background:#fff}\n._1gDwG{cursor:pointer;background:#9f1e2b;color:#fff;padding:0 .5em;border-radius:.25em;white-space:nowrap}._1gDwG._22_VN{opacity:.5}\n._3njg6{width:1.5em;height:1.5em;cursor:pointer}._3njg6 svg{width:100%;height:100%;fill:hsla(0,0%,100%,.8)}._3njg6 svg:hover{fill:#fff}\n._1AKsf{width:1.5em;height:1.5em;cursor:pointer;padding-top:-50px}._1AKsf svg{width:100%;height:100%;fill:hsla(0,0%,100%,.8)}._1AKsf svg:hover{fill:#fff}._1XK6B{height:8em;width:1.5em;left:50%;margin-left:-.75em;display:none;bottom:1.5em;position:absolute}._2Kn-2{background-color:rgba(228,227,227,.3);height:7em;cursor:pointer;border-radius:.1em;bottom:.15em;left:50%;margin-left:-.35em;border:.05em solid rgba(187,186,186,.5)}._2Kn-2,._CZcKs{width:.7em;position:absolute}._CZcKs{background-color:#fff;border-radius:.1em;border-top:.05em solid rgba(187,186,186,.7);bottom:0;pointer-events:none}._1nhbD{position:relative}._1nhbD:hover ._1XK6B{display:block}\n._13aPK{position:relative;width:1.5em;height:1.5em;cursor:pointer}._13aPK svg{width:100%;height:100%;fill:hsla(0,0%,100%,.8)}._13aPK svg:hover{fill:#fff}._16WrP{list-style:none;position:absolute;bottom:1em;left:50%;transform:translateX(-50%);padding:.5em;white-space:nowrap;background:rgba(20,20,20,.6);display:none}._16WrP._Ib345{display:block}._16WrP li{margin:0}._16WrP input{display:none;margin-right:.25em}._16WrP label span{color:hsla(0,0%,100%,.8);cursor:pointer}._16WrP :checked+span{color:#1e81a0}\n._34Jhj{width:1.5em;height:1.5em;cursor:pointer}._34Jhj svg{width:100%;height:100%;fill:hsla(0,0%,100%,.8)}._34Jhj svg:hover{fill:#fff}\n._2jAm9{top:0;width:100%;height:100%;z-index:1;opacity:1;transition:opacity .2s;outline:none;font-family:Helvetica,Arial;line-height:1.5}._2jAm9,._SS6y-{position:absolute;left:0}._SS6y-{bottom:0;width:calc(100% - 16px);box-sizing:content-box;padding:8px;background:linear-gradient(1turn,#000,transparent)}._SS6y-._1Wfm6{display:none}._1pnfN{display:flex;margin-bottom:.5em}._1pnfN>*{margin-right:.5em}._1pnfN>:last-child{margin-right:0}._3ju96{flex:1}\n._2eFId{position:absolute;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center}._2eFId svg{width:3em;height:3em}\n._4r-db{position:relative;width:1.5em;height:1.5em;cursor:pointer}._4r-db svg{width:100%;height:100%;fill:hsla(0,0%,100%,.8)}._4r-db svg:hover{fill:#fff}._1b4Xq{list-style:none;position:absolute;bottom:1em;left:50%;transform:translateX(-50%);padding:.5em;white-space:nowrap;background:rgba(20,20,20,.6);display:none}._1b4Xq._8qwvr{display:block}._1b4Xq li{margin:0}._1b4Xq input{display:none;margin-right:.25em}._1b4Xq label span{color:hsla(0,0%,100%,.8);cursor:pointer}._1b4Xq :checked+span{color:#1e81a0}\n._2XaiH{width:1.5em;height:1.5em;cursor:pointer}._2XaiH svg{width:100%;height:100%;fill:hsla(0,0%,100%,.8)}._2XaiH svg:hover{fill:#fff}\n._mM3Gy{width:1.5em;height:1.5em;cursor:pointer}\n._2lVG2{position:absolute;top:0;left:0;background:#111;color:#fff;border:1px solid #ccc;border-radius:.2rem;padding:.2rem;font-size:.8rem}._2lVG2:hover{background:#222}._2lVG2 a{color:inherit;text-decoration:none;display:flex;align-items:center;white-space:nowrap;overflow:hidden}._yCzmM{height:1rem;margin-bottom:0;margin-left:.5rem}\n._xDOFW{position:absolute;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;background:#000;pointer-events:none}._xDOFW svg{width:33%;height:33%;fill:#fff}\n._1Xl8W{position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background:#000}._1Xl8W video{display:block;width:100%;height:100%}"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const a1 = i;
            },
            645: (e)=>{
                "use strict";
                e.exports = function(e) {
                    var t = [];
                    return t.toString = function() {
                        return this.map(function(t) {
                            var n = function(e, t) {
                                var n, r, i, a1 = e[1] || "", o = e[3];
                                if (!o) return a1;
                                if (t && "function" == typeof btoa) {
                                    var s1 = (n = o, r = btoa(unescape(encodeURIComponent(JSON.stringify(n)))), i = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(r), "/*# ".concat(i, " */")), u = o.sources.map(function(e) {
                                        return "/*# sourceURL=".concat(o.sourceRoot || "").concat(e, " */");
                                    });
                                    return [
                                        a1
                                    ].concat(u).concat([
                                        s1
                                    ]).join("\n");
                                }
                                return [
                                    a1
                                ].join("\n");
                            }(t, e);
                            return t[2] ? "@media ".concat(t[2], " {").concat(n, "}") : n;
                        }).join("");
                    }, t.i = function(e, n, r) {
                        "string" == typeof e && (e = [
                            [
                                null,
                                e,
                                ""
                            ]
                        ]);
                        var i = {};
                        if (r) for(var a1 = 0; a1 < this.length; a1++){
                            var o = this[a1][0];
                            null != o && (i[o] = !0);
                        }
                        for(var s1 = 0; s1 < e.length; s1++){
                            var u = [].concat(e[s1]);
                            r && i[u[0]] || (n && (u[2] ? u[2] = "".concat(n, " and ").concat(u[2]) : u[2] = n), t.push(u));
                        }
                    }, t;
                };
            },
            652: (e, t, n)=>{
                "use strict";
                function r(e) {
                    return {
                        all: e = e || new Map,
                        on: function(t, n) {
                            var r = e.get(t);
                            r && r.push(n) || e.set(t, [
                                n
                            ]);
                        },
                        off: function(t, n) {
                            var r = e.get(t);
                            r && r.splice(r.indexOf(n) >>> 0, 1);
                        },
                        emit: function(t, n) {
                            (e.get(t) || []).slice().map(function(e) {
                                e(n);
                            }), (e.get("*") || []).slice().map(function(e) {
                                e(t, n);
                            });
                        }
                    };
                }
                n.r(t), n.d(t, {
                    default: ()=>r
                });
            }
        }, t = {};
        function n(r) {
            var i = t[r];
            if (void 0 !== i) return i.exports;
            var a1 = t[r] = {
                id: r,
                exports: {}
            };
            return e[r].call(a1.exports, a1, a1.exports, n), a1.exports;
        }
        n.n = (e)=>{
            var t = e && e.__esModule ? ()=>e.default : ()=>e;
            return n.d(t, {
                a: t
            }), t;
        }, n.d = (e, t)=>{
            for(var r in t)n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
                enumerable: !0,
                get: t[r]
            });
        }, n.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        }(), n.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), n.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var r = {};
        return (()=>{
            "use strict";
            n.d(r, {
                default: ()=>at
            });
            var e, t, i, a1, o, s1 = n(365), u = {}, l = [], c = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
            function d(e, t) {
                for(var n in t)e[n] = t[n];
                return e;
            }
            function f(e) {
                var t = e.parentNode;
                t && t.removeChild(e);
            }
            function h(e, t, n) {
                var r, i, a1, o = arguments, s1 = {};
                for(a1 in t)"key" == a1 ? r = t[a1] : "ref" == a1 ? i = t[a1] : s1[a1] = t[a1];
                if (arguments.length > 3) for(n = [
                    n
                ], a1 = 3; a1 < arguments.length; a1++)n.push(o[a1]);
                if (null != n && (s1.children = n), "function" == typeof e && null != e.defaultProps) for(a1 in e.defaultProps)void 0 === s1[a1] && (s1[a1] = e.defaultProps[a1]);
                return g(e, s1, r, i, null);
            }
            function g(t, n, r, i, a1) {
                var o = {
                    type: t,
                    props: n,
                    key: r,
                    ref: i,
                    __k: null,
                    __: null,
                    __b: 0,
                    __e: null,
                    __d: void 0,
                    __c: null,
                    constructor: void 0,
                    __v: a1
                };
                return null == a1 && (o.__v = o), null != e.vnode && e.vnode(o), o;
            }
            function p(e) {
                return e.children;
            }
            function m(e, t) {
                this.props = e, this.context = t;
            }
            function v(e, t) {
                if (null == t) return e.__ ? v(e.__, e.__.__k.indexOf(e) + 1) : null;
                for(var n; t < e.__k.length; t++)if (null != (n = e.__k[t]) && null != n.__e) return n.__e;
                return "function" == typeof e.type ? v(e) : null;
            }
            function y(e) {
                var t, n;
                if (null != (e = e.__) && null != e.__c) {
                    for(e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)if (null != (n = e.__k[t]) && null != n.__e) {
                        e.__e = e.__c.base = n.__e;
                        break;
                    }
                    return y(e);
                }
            }
            function E(n) {
                (!n.__d && (n.__d = !0) && t.push(n) && !T.__r++ || a1 !== e.debounceRendering) && ((a1 = e.debounceRendering) || i)(T);
            }
            function T() {
                for(var e; T.__r = t.length;)e = t.sort(function(e, t) {
                    return e.__v.__b - t.__v.__b;
                }), t = [], e.some(function(e) {
                    var t, n, r, i, a1, o, s1;
                    e.__d && (o = (a1 = (t = e).__v).__e, (s1 = t.__P) && (n = [], (r = d({}, a1)).__v = r, i = R(s1, a1, r, t.__n, void 0 !== s1.ownerSVGElement, null, n, null == o ? v(a1) : o), C(n, a1), i != o && y(a1)));
                });
            }
            function b(e, t, n, r, i, a1, o, s1, c, d) {
                var h, m, y, E, T, b, _, S = r && r.__k || l, w = S.length;
                for(c == u && (c = null != o ? o[0] : w ? v(r, 0) : null), n.__k = [], h = 0; h < t.length; h++)if (null != (E = n.__k[h] = null == (E = t[h]) || "boolean" == typeof E ? null : "string" == typeof E || "number" == typeof E ? g(null, E, null, null, E) : Array.isArray(E) ? g(p, {
                    children: E
                }, null, null, null) : null != E.__e || null != E.__c ? g(E.type, E.props, E.key, null, E.__v) : E)) {
                    if (E.__ = n, E.__b = n.__b + 1, null === (y = S[h]) || y && E.key == y.key && E.type === y.type) S[h] = void 0;
                    else for(m = 0; m < w; m++){
                        if ((y = S[m]) && E.key == y.key && E.type === y.type) {
                            S[m] = void 0;
                            break;
                        }
                        y = null;
                    }
                    T = R(e, E, y = y || u, i, a1, o, s1, c, d), (m = E.ref) && y.ref != m && (_ || (_ = []), y.ref && _.push(y.ref, null, E), _.push(m, E.__c || T, E)), null != T ? (null == b && (b = T), c = A(e, E, y, S, o, T, c), d || "option" != n.type ? "function" == typeof n.type && (n.__d = c) : e.value = "") : c && y.__e == c && c.parentNode != e && (c = v(y));
                }
                if (n.__e = b, null != o && "function" != typeof n.type) for(h = o.length; h--;)null != o[h] && f(o[h]);
                for(h = w; h--;)null != S[h] && N(S[h], S[h]);
                if (_) for(h = 0; h < _.length; h++)k(_[h], _[++h], _[++h]);
            }
            function A(e, t, n, r, i, a1, o) {
                var s1, u, l;
                if (void 0 !== t.__d) s1 = t.__d, t.__d = void 0;
                else if (i == n || a1 != o || null == a1.parentNode) e: if (null == o || o.parentNode !== e) e.appendChild(a1), s1 = null;
                else {
                    for(u = o, l = 0; (u = u.nextSibling) && l < r.length; l += 2)if (u == a1) break e;
                    e.insertBefore(a1, o), s1 = o;
                }
                return void 0 !== s1 ? s1 : a1.nextSibling;
            }
            function _(e, t, n) {
                "-" === t[0] ? e.setProperty(t, n) : e[t] = null == n ? "" : "number" != typeof n || c.test(t) ? n : n + "px";
            }
            function S(e, t, n, r, i) {
                var a1, o;
                if (i && "className" == t && (t = "class"), "style" === t) {
                    if ("string" == typeof n) e.style = n;
                    else {
                        if ("string" == typeof r && (e.style = r = ""), r) for(t in r)n && t in n || _(e.style, t, "");
                        if (n) for(t in n)r && n[t] === r[t] || _(e.style, t, n[t]);
                    }
                } else "o" === t[0] && "n" === t[1] ? (a1 = t !== (t = t.replace(/Capture$/, "")), (o = t.toLowerCase()) in e && (t = o), t = t.slice(2), e.l || (e.l = {}), e.l[t] = n, n ? r || e.addEventListener(t, w, a1) : e.removeEventListener(t, w, a1)) : "list" !== t && "tagName" !== t && "form" !== t && "type" !== t && "size" !== t && "download" !== t && "href" !== t && !i && t in e ? e[t] = null == n ? "" : n : "function" != typeof n && "dangerouslySetInnerHTML" !== t && (t !== (t = t.replace(/xlink:?/, "")) ? null == n || !1 === n ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), n) : null == n || !1 === n && !/^ar/.test(t) ? e.removeAttribute(t) : e.setAttribute(t, n));
            }
            function w(t) {
                this.l[t.type](e.event ? e.event(t) : t);
            }
            function I(e, t, n) {
                var r, i;
                for(r = 0; r < e.__k.length; r++)(i = e.__k[r]) && (i.__ = e, i.__e && ("function" == typeof i.type && i.__k.length > 1 && I(i, t, n), t = A(n, i, i, e.__k, null, i.__e, t), "function" == typeof e.type && (e.__d = t)));
            }
            function R(t, n, r, i, a1, o, s1, u, l) {
                var c, f, h, g, v, y, E, T, A, _, S, w = n.type;
                if (void 0 !== n.constructor) return null;
                (c = e.__b) && c(n);
                try {
                    e: if ("function" == typeof w) {
                        if (T = n.props, A = (c = w.contextType) && i[c.__c], _ = c ? A ? A.props.value : c.__ : i, r.__c ? E = (f = n.__c = r.__c).__ = f.__E : ("prototype" in w && w.prototype.render ? n.__c = f = new w(T, _) : (n.__c = f = new m(T, _), f.constructor = w, f.render = L), A && A.sub(f), f.props = T, f.state || (f.state = {}), f.context = _, f.__n = i, h = f.__d = !0, f.__h = []), null == f.__s && (f.__s = f.state), null != w.getDerivedStateFromProps && (f.__s == f.state && (f.__s = d({}, f.__s)), d(f.__s, w.getDerivedStateFromProps(T, f.__s))), g = f.props, v = f.state, h) null == w.getDerivedStateFromProps && null != f.componentWillMount && f.componentWillMount(), null != f.componentDidMount && f.__h.push(f.componentDidMount);
                        else {
                            if (null == w.getDerivedStateFromProps && T !== g && null != f.componentWillReceiveProps && f.componentWillReceiveProps(T, _), !f.__e && null != f.shouldComponentUpdate && !1 === f.shouldComponentUpdate(T, f.__s, _) || n.__v === r.__v) {
                                f.props = T, f.state = f.__s, n.__v !== r.__v && (f.__d = !1), f.__v = n, n.__e = r.__e, n.__k = r.__k, f.__h.length && s1.push(f), I(n, u, t);
                                break e;
                            }
                            null != f.componentWillUpdate && f.componentWillUpdate(T, f.__s, _), null != f.componentDidUpdate && f.__h.push(function() {
                                f.componentDidUpdate(g, v, y);
                            });
                        }
                        f.context = _, f.props = T, f.state = f.__s, (c = e.__r) && c(n), f.__d = !1, f.__v = n, f.__P = t, c = f.render(f.props, f.state, f.context), f.state = f.__s, null != f.getChildContext && (i = d(d({}, i), f.getChildContext())), h || null == f.getSnapshotBeforeUpdate || (y = f.getSnapshotBeforeUpdate(g, v)), S = null != c && c.type == p && null == c.key ? c.props.children : c, b(t, Array.isArray(S) ? S : [
                            S
                        ], n, r, i, a1, o, s1, u, l), f.base = n.__e, f.__h.length && s1.push(f), E && (f.__E = f.__ = null), f.__e = !1;
                    } else null == o && n.__v === r.__v ? (n.__k = r.__k, n.__e = r.__e) : n.__e = D(r.__e, n, r, i, a1, o, s1, l);
                    (c = e.diffed) && c(n);
                } catch (t) {
                    n.__v = null, e.__e(t, n, r);
                }
                return n.__e;
            }
            function C(t, n) {
                e.__c && e.__c(n, t), t.some(function(n) {
                    try {
                        t = n.__h, n.__h = [], t.some(function(e) {
                            e.call(n);
                        });
                    } catch (t) {
                        e.__e(t, n.__v);
                    }
                });
            }
            function D(e, t, n, r, i, a1, o, s1) {
                var c, d, f, h, g, p = n.props, m = t.props;
                if (i = "svg" === t.type || i, null != a1) {
                    for(c = 0; c < a1.length; c++)if (null != (d = a1[c]) && ((null === t.type ? 3 === d.nodeType : d.localName === t.type) || e == d)) {
                        e = d, a1[c] = null;
                        break;
                    }
                }
                if (null == e) {
                    if (null === t.type) return document.createTextNode(m);
                    e = i ? document.createElementNS("http://www.w3.org/2000/svg", t.type) : document.createElement(t.type, m.is && {
                        is: m.is
                    }), a1 = null, s1 = !1;
                }
                if (null === t.type) p !== m && e.data !== m && (e.data = m);
                else {
                    if (null != a1 && (a1 = l.slice.call(e.childNodes)), f = (p = n.props || u).dangerouslySetInnerHTML, h = m.dangerouslySetInnerHTML, !s1) {
                        if (null != a1) for(p = {}, g = 0; g < e.attributes.length; g++)p[e.attributes[g].name] = e.attributes[g].value;
                        (h || f) && (h && f && h.__html == f.__html || (e.innerHTML = h && h.__html || ""));
                    }
                    (function(e, t, n, r, i) {
                        var a1;
                        for(a1 in n)"children" === a1 || "key" === a1 || a1 in t || S(e, a1, null, n[a1], r);
                        for(a1 in t)i && "function" != typeof t[a1] || "children" === a1 || "key" === a1 || "value" === a1 || "checked" === a1 || n[a1] === t[a1] || S(e, a1, t[a1], n[a1], r);
                    })(e, m, p, i, s1), h ? t.__k = [] : (c = t.props.children, b(e, Array.isArray(c) ? c : [
                        c
                    ], t, n, r, "foreignObject" !== t.type && i, a1, o, u, s1)), s1 || ("value" in m && void 0 !== (c = m.value) && c !== e.value && S(e, "value", c, p.value, !1), "checked" in m && void 0 !== (c = m.checked) && c !== e.checked && S(e, "checked", c, p.checked, !1));
                }
                return e;
            }
            function k(t, n, r) {
                try {
                    "function" == typeof t ? t(n) : t.current = n;
                } catch (t) {
                    e.__e(t, r);
                }
            }
            function N(t, n, r) {
                var i, a1, o;
                if (e.unmount && e.unmount(t), (i = t.ref) && (i.current && i.current !== t.__e || k(i, null, n)), r || "function" == typeof t.type || (r = null != (a1 = t.__e)), t.__e = t.__d = void 0, null != (i = t.__c)) {
                    if (i.componentWillUnmount) try {
                        i.componentWillUnmount();
                    } catch (t) {
                        e.__e(t, n);
                    }
                    i.base = i.__P = null;
                }
                if (i = t.__k) for(o = 0; o < i.length; o++)i[o] && N(i[o], n, r);
                null != a1 && f(a1);
            }
            function L(e, t, n) {
                return this.constructor(e, n);
            }
            function x(t, n, r) {
                var i, a1, s1;
                e.__ && e.__(t, n), a1 = (i = r === o) ? null : r && r.__k || n.__k, t = h(p, null, [
                    t
                ]), s1 = [], R(n, (i ? n : r || n).__k = t, a1 || u, u, void 0 !== n.ownerSVGElement, r && !i ? [
                    r
                ] : a1 ? null : n.childNodes.length ? l.slice.call(n.childNodes) : null, s1, r || u, i), C(s1, t);
            }
            e = {
                __e: function(e, t) {
                    for(var n, r; t = t.__;)if ((n = t.__c) && !n.__) try {
                        if (n.constructor && null != n.constructor.getDerivedStateFromError && (r = !0, n.setState(n.constructor.getDerivedStateFromError(e))), null != n.componentDidCatch && (r = !0, n.componentDidCatch(e)), r) return E(n.__E = n);
                    } catch (t) {
                        e = t;
                    }
                    throw e;
                }
            }, m.prototype.setState = function(e, t) {
                var n;
                n = null != this.__s && this.__s !== this.state ? this.__s : this.__s = d({}, this.state), "function" == typeof e && (e = e(d({}, n), this.props)), e && d(n, e), null != e && this.__v && (t && this.__h.push(t), E(this));
            }, m.prototype.forceUpdate = function(e) {
                this.__v && (this.__e = !0, e && this.__h.push(e), E(this));
            }, m.prototype.render = p, t = [], i = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, T.__r = 0, o = u;
            var M, O, P, F = 0, U = [], j = e.__r, B = e.diffed, G = e.__c, H = e.unmount;
            function V(t, n) {
                e.__h && e.__h(O, t, F || n), F = 0;
                var r = O.__H || (O.__H = {
                    __: [],
                    __h: []
                });
                return t >= r.__.length && r.__.push({}), r.__[t];
            }
            function K(e) {
                return F = 1, function(e, t, n) {
                    var r = V(M++, 2);
                    return r.t = e, r.__c || (r.__c = O, r.__ = [
                        ee(void 0, t),
                        function(e) {
                            var t = r.t(r.__[0], e);
                            r.__[0] !== t && (r.__ = [
                                t,
                                r.__[1]
                            ], r.__c.setState({}));
                        }
                    ]), r.__;
                }(ee, e);
            }
            function q(t, n) {
                var r = V(M++, 3);
                !e.__s && $(r.__H, n) && (r.__ = t, r.__H = n, O.__H.__h.push(r));
            }
            function Y(e) {
                return F = 5, W(function() {
                    return {
                        current: e
                    };
                }, []);
            }
            function W(e, t) {
                var n = V(M++, 7);
                return $(n.__H, t) ? (n.__H = t, n.__h = e, n.__ = e()) : n.__;
            }
            function z(e, t) {
                return F = 8, W(function() {
                    return e;
                }, t);
            }
            function X() {
                U.some(function(t) {
                    if (t.__P) try {
                        t.__H.__h.forEach(J), t.__H.__h.forEach(Z), t.__H.__h = [];
                    } catch (n) {
                        return t.__H.__h = [], e.__e(n, t.__v), !0;
                    }
                }), U = [];
            }
            e.__r = function(e) {
                j && j(e), M = 0;
                var t = (O = e.__c).__H;
                t && (t.__h.forEach(J), t.__h.forEach(Z), t.__h = []);
            }, e.diffed = function(t) {
                B && B(t);
                var n = t.__c;
                n && n.__H && n.__H.__h.length && (1 !== U.push(n) && P === e.requestAnimationFrame || ((P = e.requestAnimationFrame) || function(e) {
                    var t, n = function() {
                        clearTimeout(r), Q && cancelAnimationFrame(t), setTimeout(e);
                    }, r = setTimeout(n, 100);
                    Q && (t = requestAnimationFrame(n));
                })(X));
            }, e.__c = function(t, n) {
                n.some(function(t) {
                    try {
                        t.__h.forEach(J), t.__h = t.__h.filter(function(e) {
                            return !e.__ || Z(e);
                        });
                    } catch (r) {
                        n.some(function(e) {
                            e.__h && (e.__h = []);
                        }), n = [], e.__e(r, t.__v);
                    }
                }), G && G(t, n);
            }, e.unmount = function(t) {
                H && H(t);
                var n = t.__c;
                if (n && n.__H) try {
                    n.__H.__.forEach(J);
                } catch (t) {
                    e.__e(t, n.__v);
                }
            };
            var Q = "function" == typeof requestAnimationFrame;
            function J(e) {
                "function" == typeof e.u && e.u();
            }
            function Z(e) {
                e.u = e.__();
            }
            function $(e, t) {
                return !e || t.some(function(t, n) {
                    return t !== e[n];
                });
            }
            function ee(e, t) {
                return "function" == typeof t ? t(e) : t;
            }
            var te = n(147), ne = n.n(te);
            function re(e, t) {
                return (re = Object.setPrototypeOf || function(e, t) {
                    return e.__proto__ = t, e;
                })(e, t);
            }
            function ie(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }
            var ae, oe = function() {
                function e() {
                    var e;
                    this.emitter = {
                        all: e = e || new Map,
                        on: function(t, n) {
                            var r = e.get(t);
                            r && r.push(n) || e.set(t, [
                                n
                            ]);
                        },
                        off: function(t, n) {
                            var r = e.get(t);
                            r && r.splice(r.indexOf(n) >>> 0, 1);
                        },
                        emit: function(t, n) {
                            (e.get(t) || []).slice().map(function(e) {
                                e(n);
                            }), (e.get("*") || []).slice().map(function(e) {
                                e(t, n);
                            });
                        }
                    };
                }
                var t = e.prototype;
                return t.on = function(e, t) {
                    this.emitter.on.apply(this, arguments);
                }, t.off = function(e, t) {
                    this.emitter.on.apply(this, arguments);
                }, t.emit = function(e, t) {
                    this.emitter.emit.apply(this, arguments);
                }, t.destroy = function() {
                    this.emitter.all.clear();
                }, e;
            }();
            !function(e) {
                e.AVAILABILITY_CHANGED = "airplay:availability_changed", e.TARGET_CHANGED = "airplay:target_changed";
            }(ae || (ae = {}));
            var se = function(e) {
                var t, n;
                function r(t) {
                    var n;
                    return (n = e.call(this) || this).video = t, window.WebKitPlaybackTargetAvailabilityEvent ? (t.addEventListener("webkitplaybacktargetavailabilitychanged", n.onAvailabilityChanged = n.onAvailabilityChanged.bind(ie(n))), t.addEventListener("webkitcurrentplaybacktargetiswirelesschanged", n.onTargetChanged = n.onTargetChanged.bind(ie(n)))) : n.emit(ae.AVAILABILITY_CHANGED, {
                        available: !1
                    }), n;
                }
                n = e, (t = r).prototype = Object.create(n.prototype), t.prototype.constructor = t, re(t, n);
                var i = r.prototype;
                return i.onAvailabilityChanged = function(e) {
                    this.emit(ae.AVAILABILITY_CHANGED, {
                        available: "available" === e.availability
                    });
                }, i.onTargetChanged = function(e) {
                    this.emit(ae.TARGET_CHANGED, {
                        wireless: !0
                    });
                }, i.toggleAirPlay = function() {
                    this.video.webkitShowPlaybackTargetPicker();
                }, i.destroy = function() {
                    this.video.removeEventListener("webkitplaybacktargetavailabilitychanged", this.onAvailabilityChanged);
                }, r;
            }(oe);
            function ue(e, t) {
                return (ue = Object.setPrototypeOf || function(e, t) {
                    return e.__proto__ = t, e;
                })(e, t);
            }
            var le, ce, de = function() {
                function e() {
                    var e;
                    this.emitter = {
                        all: e = e || new Map,
                        on: function(t, n) {
                            var r = e.get(t);
                            r && r.push(n) || e.set(t, [
                                n
                            ]);
                        },
                        off: function(t, n) {
                            var r = e.get(t);
                            r && r.splice(r.indexOf(n) >>> 0, 1);
                        },
                        emit: function(t, n) {
                            (e.get(t) || []).slice().map(function(e) {
                                e(n);
                            }), (e.get("*") || []).slice().map(function(e) {
                                e(t, n);
                            });
                        }
                    };
                }
                var t = e.prototype;
                return t.on = function(e, t) {
                    this.emitter.on.apply(this, arguments);
                }, t.off = function(e, t) {
                    this.emitter.on.apply(this, arguments);
                }, t.emit = function(e, t) {
                    this.emitter.emit.apply(this, arguments);
                }, t.destroy = function() {
                    this.emitter.all.clear();
                }, e;
            }();
            !function(e) {
                e.CONNECTED = "cast:connected", e.DISCONNECTED = "cast:disconnected", e.STATE_CHANGE = "cast:state_change";
            }(ce || (ce = {}));
            var fe = function(e) {
                var t, n;
                function r(t, n) {
                    var r;
                    return (r = e.call(this) || this).state = {
                        playbackState: s1.P.IDLE,
                        currentTime: 0,
                        duration: 0,
                        isLive: !1,
                        isAtLiveEdge: !1,
                        isSeekable: !0,
                        isMuted: !1,
                        audioTracks: [],
                        textTracks: [],
                        volume: 1
                    }, (function(e, t) {
                        return le || (le = new Promise(function(n, r) {
                            window.__onGCastApiAvailable = function(i) {
                                i ? (cast.framework.CastContext.getInstance().setOptions({
                                    receiverApplicationId: e || chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID,
                                    autoJoinPolicy: t || chrome.cast.AutoJoinPolicy.PAGE_SCOPED
                                }), n()) : r(new Error("[Cast] not available"));
                            };
                            var i = document.createElement("script");
                            i.src = "//www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1", document.body.appendChild(i);
                        }));
                    })(t, n).then(function() {
                        r.player = new cast.framework.RemotePlayer, r.playerController = new cast.framework.RemotePlayerController(r.player), r.setupListeners();
                    }, function(e) {
                        return console.error(e);
                    }), r;
                }
                n = e, (t = r).prototype = Object.create(n.prototype), t.prototype.constructor = t, ue(t, n);
                var i = r.prototype;
                return i.setState = function(e) {
                    this.state = Object.assign({}, this.state, e), this.emit(ce.STATE_CHANGE, {
                        state: this.state
                    });
                }, i.getPlaybackStateFromPlayerState = function(e) {
                    switch(e){
                        case chrome.cast.media.PlayerState.BUFFERING:
                            return s1.P.BUFFERING;
                        case chrome.cast.media.PlayerState.PAUSED:
                            return s1.P.PAUSED;
                        case chrome.cast.media.PlayerState.PLAYING:
                            return s1.P.PLAYING;
                        case chrome.cast.media.PlayerState.IDLE:
                            return s1.P.IDLE;
                    }
                }, i.getDuration = function() {
                    return this.player.liveSeekableRange ? this.player.liveSeekableRange.end : this.player.duration;
                }, i.setupListeners = function() {
                    var e = this;
                    cast.framework.CastContext.getInstance().addEventListener(cast.framework.CastContextEventType.SESSION_STATE_CHANGED, function(t) {
                        switch(t.sessionState){
                            case cast.framework.SessionState.SESSION_STARTED:
                            case cast.framework.SessionState.SESSION_RESUMED:
                                e.emit(ce.CONNECTED), e.setState({
                                    playbackState: s1.P.READY,
                                    isMuted: e.player.isMuted
                                });
                                break;
                            case cast.framework.SessionState.SESSION_ENDED:
                                e.emit(ce.DISCONNECTED), e.setState({
                                    playbackState: s1.P.IDLE
                                });
                        }
                    }), this.playerController.addEventListener(cast.framework.RemotePlayerEventType.ANY_CHANGE, function(t) {
                        var n = t.value;
                        switch(t.field){
                            case "currentTime":
                                e.setState({
                                    currentTime: n,
                                    isAtLiveEdge: n >= e.state.duration - 20
                                });
                                break;
                            case "duration":
                                e.setState({
                                    duration: n
                                });
                                break;
                            case "playerState":
                                var r = e.getPlaybackStateFromPlayerState(n);
                                e.setState({
                                    playbackState: r
                                }), r === s1.P.IDLE && e.stop();
                                break;
                            case "liveSeekableRange":
                                e.setState(n ? {
                                    isLive: !n.isLiveDone,
                                    duration: n.end - n.start,
                                    isSeekable: n.end - n.start > 300
                                } : {
                                    isLive: !1
                                });
                        }
                    });
                }, i.load = function(e, t) {
                    void 0 === t && (t = null);
                    var n = cast.framework.CastContext.getInstance().getCurrentSession(), r = new chrome.cast.media.MediaInfo(e, "video/mp4"), i = new chrome.cast.media.LoadRequest(r);
                    return t && (i.currentTime = t), n.loadMedia(i);
                }, i.play = function() {
                    this.playerController.playOrPause();
                }, i.pause = function() {
                    this.playerController.playOrPause();
                }, i.stop = function() {
                    this.playerController.stop();
                }, i.mute = function() {
                    this.playerController.muteOrUnmute();
                }, i.unmute = function() {
                    this.playerController.muteOrUnmute();
                }, i.setAudioTrack = function() {}, i.setTextTrack = function() {}, i.seekTo = function(e) {
                    var t = e.position, n = e.change, r = e.percentage;
                    r ? t = Math.min(r, 99.9) / 100 * this.getDuration() : n && (t = this.player.currentTime + n), this.player.currentTime = t, this.playerController.seek();
                }, r;
            }(de);
            function he(e) {
                var t, n = e.onClick;
                return h("div", {
                    class: ne()("_1gDwG", (t = {}, t._22_VN = !e.isAtLiveEdge && e.isSeekable, t)),
                    onClick: n
                }, "LIVE");
            }
            function ge(e) {
                var t;
                return h("div", {
                    class: "_-LGHu"
                }, (void 0 === (t = e.time) && (t = 0), [
                    Math.floor(t / 3600) % 24,
                    Math.floor(t / 60) % 60,
                    Math.floor(t % 60)
                ].map(function(e) {
                    return e < 10 ? "0" + e : e;
                }).filter(function(e, t) {
                    return "00" !== e || t > 0;
                }).join(":")));
            }
            function pe(e) {
                var t, n = e.currentTime, r = void 0 === n ? 0 : n, i = e.duration, a1 = void 0 === i ? 0 : i, o = e.handleSeek, s1 = e.handleSeekToLive, u = e.isLive, l = e.isAtLiveEdge, c = e.isSeekable, d = z(function(e) {
                    c && o(e.offsetX / e.currentTarget.offsetWidth * 100);
                }, [
                    o,
                    c
                ]), f = !u || !l && c ? r / a1 * 100 || 0 : 100;
                return h("div", {
                    class: ne()("_2aAzG", (t = {}, t._3K51E = !c, t))
                }, h(ge, {
                    time: r
                }), h("div", {
                    class: "_t3a1b",
                    onClick: d
                }, h("div", {
                    class: "_K1UW_"
                }, h("div", {
                    class: "_1Xt9z",
                    style: {
                        width: f + "%"
                    }
                }))), u ? h(he, {
                    onClick: s1,
                    isAtLiveEdge: l,
                    isSeekable: c
                }) : h(ge, {
                    time: a1
                }));
            }
            function me() {
                return h("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    height: "24",
                    viewBox: "0 0 24 24",
                    width: "24"
                }, h("path", {
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }), h("path", {
                    d: "M8 5v14l11-7z"
                }));
            }
            function ve() {
                return h("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    height: "24",
                    viewBox: "0 0 24 24",
                    width: "24"
                }, h("path", {
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }), h("path", {
                    d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
                }));
            }
            function ye(e) {
                return h("div", {
                    class: "_3njg6",
                    onClick: e.onClick
                }, h(e.playbackState !== s1.P.PLAYING ? me : ve, null));
            }
            function Ee() {
                return h("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    height: "24",
                    viewBox: "0 0 24 24",
                    width: "24"
                }, h("path", {
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }), h("path", {
                    d: "M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
                }));
            }
            function Te() {
                return h("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    height: "24",
                    viewBox: "0 0 24 24",
                    width: "24"
                }, h("path", {
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }), h("path", {
                    d: "M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
                }));
            }
            function be(e) {
                return h("div", {
                    class: "_1AKsf",
                    onClick: e.onClick
                }, h(e.muted ? Te : Ee, null));
            }
            function Ae(e) {
                var t = e.muted, n = e.onClick, r = e.toggleMute, i = e.value, a1 = K(-1), o = a1[0], s1 = a1[1], u = z(function(e) {
                    e.preventDefault(), s1(100 - e.offsetY / e.currentTarget.offsetHeight * 100);
                }, []), l = z(function(e) {
                    e.preventDefault(), s1(-1);
                }, []);
                return h("div", {
                    class: "_1XK6B"
                }, h("div", {
                    onMouseMove: u,
                    onMouseLeave: l,
                    onClick: function() {
                        var e = o < 5 ? 0 : o > 95 ? 100 : o;
                        (t && e > 0 || !t && 0 === e) && r(), n(e);
                    },
                    class: "_2Kn-2"
                }, h("div", {
                    class: "_CZcKs",
                    style: {
                        height: (t ? 0 : 100 * i) + "%"
                    }
                })));
            }
            function _e(e) {
                var t = e.muted, n = e.toggleMute, r = e.onSliderInput, i = e.volume, a1 = !!(/iPhone|iPod|iPad|Android/.test(navigator.userAgent) || /Macintosh/.test(navigator.userAgent) && "ontouchstart" in document.documentElement);
                return h("div", {
                    class: "_1nhbD"
                }, h(be, {
                    muted: t,
                    onClick: n
                }), !a1 && h(Ae, {
                    muted: t,
                    toggleMute: n,
                    onClick: r,
                    value: i
                }));
            }
            function Se() {
                return h("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    height: "24",
                    viewBox: "0 0 24 24",
                    width: "24"
                }, h("path", {
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }), h("path", {
                    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
                }));
            }
            function we(e) {
                var t, n = e.audioTracks, r = void 0 === n ? [] : n, i = e.onChange, a1 = K(!1), o = a1[0], s1 = a1[1], u = z(function(e) {
                    i(e.target.value);
                }, [
                    i
                ]);
                return h("div", {
                    class: "_13aPK",
                    onClick: z(function() {
                        return s1(!o);
                    }, [
                        o
                    ])
                }, h(Se, null), h("ul", {
                    class: ne()("_16WrP", (t = {}, t._Ib345 = o, t))
                }, r.map(function(e) {
                    return h("li", null, h("label", null, h("input", {
                        type: "radio",
                        name: "audioTrack",
                        value: e.id,
                        checked: e.enabled,
                        onClick: u
                    }), h("span", null, e.label)));
                })));
            }
            function Ie() {
                return h("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    height: "24",
                    viewBox: "0 0 24 24",
                    width: "24"
                }, h("path", {
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }), h("path", {
                    d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
                }));
            }
            function Re() {
                return h("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    height: "24",
                    viewBox: "0 0 24 24",
                    width: "24"
                }, h("path", {
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }), h("path", {
                    d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
                }));
            }
            function Ce(e) {
                return h("div", {
                    class: "_34Jhj",
                    onClick: e.onClick
                }, h(e.isFullscreen ? Ie : Re, null));
            }
            function De() {
                return h("div", {
                    class: "_2eFId"
                }, h("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "38",
                    height: "38",
                    viewBox: "0 0 38 38"
                }, h("defs", null, h("linearGradient", {
                    x1: "8.042%",
                    y1: "0%",
                    x2: "65.682%",
                    y2: "23.865%",
                    id: "a"
                }, h("stop", {
                    "stop-color": "#fff",
                    "stop-opacity": "0",
                    offset: "0%"
                }), h("stop", {
                    "stop-color": "#fff",
                    "stop-opacity": ".631",
                    offset: "63.146%"
                }), h("stop", {
                    "stop-color": "#fff",
                    offset: "100%"
                }))), h("g", {
                    fill: "none",
                    "fill-rule": "evenodd"
                }, h("g", {
                    transform: "translate(1 1)"
                }, h("path", {
                    d: "M36 18c0-9.94-8.06-18-18-18",
                    id: "Oval-2",
                    stroke: "url(#a)",
                    "stroke-width": "2"
                }, h("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    from: "0 18 18",
                    to: "360 18 18",
                    dur: "0.9s",
                    repeatCount: "indefinite"
                })), h("circle", {
                    fill: "#fff",
                    cx: "36",
                    cy: "18",
                    r: "1"
                }, h("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    from: "0 18 18",
                    to: "360 18 18",
                    dur: "0.9s",
                    repeatCount: "indefinite"
                }))))));
            }
            function ke() {
                return !(!document.fullscreenElement && !document.webkitFullscreenElement);
            }
            function Ne() {
                return h("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    height: "24",
                    viewBox: "0 0 24 24",
                    width: "24"
                }, h("path", {
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }), h("path", {
                    d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 12h4v2H4v-2zm10 6H4v-2h10v2zm6 0h-4v-2h4v2zm0-4H10v-2h10v2z"
                }));
            }
            function Le(e) {
                var t, n = e.textTracks, r = void 0 === n ? [] : n, i = e.onChange, a1 = K(!1), o = a1[0], s1 = a1[1], u = z(function(e) {
                    i(e.target.value), e.stopPropagation();
                }, [
                    i
                ]);
                return h("div", {
                    class: "_4r-db",
                    onClick: z(function() {
                        return s1(!o);
                    }, [
                        o
                    ])
                }, h(Ne, null), h("ul", {
                    class: ne()("_1b4Xq", (t = {}, t._8qwvr = o, t))
                }, r.map(function(e) {
                    return h("li", null, h("label", null, h("input", {
                        type: "radio",
                        name: "textTrack",
                        value: e.id,
                        checked: e.enabled,
                        onClick: u
                    }), h("span", null, e.label || e.language || "und")));
                })));
            }
            function xe() {
                return h("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    "enable-background": "new 0 0 24 24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    width: "24"
                }, h("rect", {
                    fill: "none",
                    height: "24",
                    width: "24"
                }), h("g", null, h("polygon", {
                    points: "6,22 18,22 12,16"
                }), h("path", {
                    d: "M21,3H3C1.9,3,1,3.9,1,5v12c0,1.1,0.9,2,2,2h4v-2H3V5h18v12h-4v2h4c1.1,0,2-0.9,2-2V5C23,3.9,22.1,3,21,3z"
                })));
            }
            function Me(e) {
                return h("div", {
                    class: "_2XaiH",
                    onClick: e.onClick
                }, h(xe, null));
            }
            function Oe() {
                return h("div", {
                    class: "_mM3Gy"
                }, h("google-cast-launcher", null));
            }
            function Pe() {
                return (Pe = Object.assign || function(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = arguments[t];
                        for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                    }
                    return e;
                }).apply(this, arguments);
            }
            function Fe(e) {
                return h("img", {
                    class: e.className,
                    src: "data:image/png;base64,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"
                });
            }
            function Ue(e) {
                return h("div", {
                    class: "_2lVG2",
                    style: {
                        top: e.y + "px",
                        left: e.x + "px"
                    }
                }, h("a", {
                    href: "https://www.eyevinntechnology.se/",
                    target: "_blank"
                }, h("span", null, "Powered by the Eyevinn WebPlayer"), h(Fe, {
                    className: "_yCzmM"
                })));
            }
            function je() {
                return h("div", {
                    class: "_xDOFW"
                }, h("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "48",
                    height: "48",
                    viewBox: "0 0 48 48"
                }, h("path", {
                    d: "M42 6H6c-2.21 0-4 1.79-4 4v6h4v-6h36v28H28v4h14c2.21 0 4-1.79 4-4V10c0-2.21-1.79-4-4-4zM2 36v6h6c0-3.31-2.69-6-6-6zm0-8v4c5.52 0 10 4.48 10 10h4c0-7.73-6.27-14-14-14zm0-8v4c9.94 0 18 8.06 18 18h4c0-12.15-9.85-22-22-22z"
                })));
            }
            function Be(e) {
                var t, n = e.player, r = e.castAppId, i = e.rootElement, a1 = Y(), o = function(e, t) {
                    var n, r, i, a1 = K(null), o = a1[0], u = a1[1], l = K(null), c = l[0], d = l[1], f = function(e, t) {
                        var n = K(null), r = n[0], i = n[1], a1 = K(null), o = a1[0], u = a1[1];
                        q(function() {
                            var n = function() {
                                null !== t && e.manifestType !== s1.M.EYEVINN_WEBRTC_CHANNEL && u(new fe(t));
                            };
                            return e.on(s1.a.READY, n), function() {
                                return e.off(s1.a.READY, n);
                            };
                        }, []);
                        var l = Y(null);
                        return l.current = r, q(function() {
                            o && (o.on(ce.CONNECTED, function() {
                                e.currentSrc && o.load(e.currentSrc, e.currentTime);
                            }), o.on(ce.DISCONNECTED, function() {
                                var t;
                                i(function(e) {
                                    return Pe({}, e, {
                                        isCasting: !1
                                    });
                                }), e.seekTo({
                                    position: null == (t = l.current) ? void 0 : t.currentTime
                                });
                            }), o.on(ce.STATE_CHANGE, function(e) {
                                var t = e.state;
                                i(Pe({
                                    isCasting: t.playbackState !== s1.P.IDLE
                                }, t));
                            }));
                        }, [
                            o
                        ]), [
                            o,
                            r
                        ];
                    }(e, t), h = f[0], g = f[1], p = Y(!1);
                    return p.current = null != (n = null == g ? void 0 : g.isCasting) && n, q(function() {
                        e.on(s1.a.UNREADY, function() {
                            u(null), d(null);
                        }), e.on(s1.a.READYING, function() {
                            u(!1);
                        }), e.on(s1.a.READY, function() {
                            u(!0);
                        }), e.on(s1.a.STATE_CHANGE, function(t) {
                            var n = t.state;
                            p.current && e.isPlaying && e.pause(), d(Pe({
                                isCasting: !1
                            }, n));
                        });
                    }, []), g && g.playbackState !== s1.P.IDLE ? (i = h, r = g) : (i = e, r = c), [
                        o,
                        r,
                        z(function() {
                            return i.isPlaying ? i.pause() : i.play();
                        }, [
                            i
                        ]),
                        z(function() {
                            return i.isMuted ? i.unmute() : i.mute();
                        }, [
                            i
                        ]),
                        z(function(e) {
                            return i.setAudioTrack(e);
                        }, [
                            i
                        ]),
                        z(function(e) {
                            return i.setTextTrack(e);
                        }, [
                            i
                        ]),
                        z(function(e) {
                            return i.seekTo({
                                percentage: e
                            });
                        }, [
                            i
                        ]),
                        z(function(e) {
                            return i.seekTo({
                                change: e
                            });
                        }, [
                            i
                        ]),
                        z(function() {
                            return i.seekToLive();
                        }, [
                            i
                        ]),
                        z(function(e) {
                            return i.setVolume({
                                percentage: e
                            });
                        }, [
                            i
                        ]),
                        z(function(e) {
                            return i.setVolume({
                                change: e
                            });
                        }, [
                            i
                        ])
                    ];
                }(n, r), u = o[0], l = o[1], c = o[2], d = o[3], f = o[4], g = o[5], p = o[6], m = o[7], v = o[8], y = o[9], E = o[10], T = function(e) {
                    var t = K(!1), n = t[0], r = t[1], i = W(function() {
                        return new se(e.video);
                    }, []), a1 = z(function() {
                        return i.toggleAirPlay();
                    }, []);
                    return q(function() {
                        i.on(ae.AVAILABILITY_CHANGED, function(e) {
                            return r(e.available);
                        });
                    }, []), [
                        n,
                        a1
                    ];
                }(n), b = T[0], A = T[1], _ = z(function() {
                    var e;
                    return ke() ? void (null == (e = document.exitFullscreen || document.webkitExitFullscreen) || e.call(document)) : function(e, t) {
                        var n, r = e.requestFullscreen || e.webkitRequestFullscreen ? e : t;
                        null == (n = r.requestFullscreen || r.webkitRequestFullscreen || r.webkitEnterFullscreen) || n.call(r);
                    }(i, n.video);
                }, []), S = K({
                    visible: !1,
                    x: 0,
                    y: 0
                }), w = S[0], I = S[1], R = z(function(e) {
                    e.stopPropagation(), e.preventDefault(), I(e.target === e.currentTarget ? {
                        visible: !0,
                        x: e.offsetX,
                        y: e.offsetY
                    } : {
                        visible: !1,
                        x: 0,
                        y: 0
                    });
                }, []);
                q(function() {
                    document.addEventListener("click", function() {
                        I({
                            visible: !1,
                            x: 0,
                            y: 0
                        });
                    });
                }, []), q(function() {
                    var e = a1.current;
                    if (e) {
                        var t = function(e) {
                            switch(e.code){
                                case "Space":
                                    c();
                                    break;
                                case "ArrowRight":
                                    m(5);
                                    break;
                                case "ArrowLeft":
                                    m(-5);
                                    break;
                                case "ArrowUp":
                                    E(.1), n.getVolume() > 0 ? n.isMuted && n.unmute() : n.mute();
                                    break;
                                case "ArrowDown":
                                    E(-0.1), n.getVolume() > 0 ? n.isMuted && n.unmute() : n.mute();
                            }
                        };
                        return e.addEventListener("keydown", t), function() {
                            return e.removeEventListener("keydown", t);
                        };
                    }
                }, [
                    a1.current
                ]);
                var C = Y(null), D = K(!1), k = D[0], N = D[1], L = z(function() {
                    clearTimeout(C.current), N(!0), C.current = setTimeout(function() {
                        return N(!1);
                    }, 2500);
                }, []), x = !k && (null == l ? void 0 : l.playbackState) !== s1.P.READY && (null == l ? void 0 : l.playbackState) !== s1.P.PAUSED, M = (null == l ? void 0 : l.playbackState) === s1.P.LOADING || (null == l ? void 0 : l.playbackState) === s1.P.BUFFERING || (null == l ? void 0 : l.playbackState) === s1.P.SEEKING;
                return null === u ? null : h("div", {
                    ref: a1,
                    tabIndex: 0,
                    class: ne()("_2jAm9"),
                    onMouseMove: L,
                    onContextMenu: R,
                    onPointerUp: z(function(e) {
                        x || e.currentTarget !== e.target ? N(!0) : c();
                    }, [
                        x
                    ])
                }, w.visible && h(Ue, {
                    x: w.x,
                    y: w.y
                }), (M || !u) && h(De, null), (null == l ? void 0 : l.isCasting) && h(je, null), h("div", {
                    class: ne()("_SS6y-", (t = {}, t._1Wfm6 = x, t))
                }, h("div", {
                    class: "_1pnfN"
                }, h(ye, {
                    playbackState: null == l ? void 0 : l.playbackState,
                    onClick: c
                }), (null == l ? void 0 : l.isLive) && !(null != l && l.isSeekable) && h(he, {
                    onClick: v,
                    isAtLiveEdge: null == l ? void 0 : l.isAtLiveEdge,
                    isSeekable: null == l ? void 0 : l.isSeekable
                }), h("div", {
                    class: "_3ju96"
                }), h(Oe, null), b && h(Me, {
                    onClick: A
                }), !1 === (null == l ? void 0 : l.isCasting) && (null == l ? void 0 : l.textTracks.length) > 1 && h(Le, {
                    textTracks: null == l ? void 0 : l.textTracks,
                    onChange: g
                }), !1 === (null == l ? void 0 : l.isCasting) && (null == l ? void 0 : l.audioTracks.length) > 1 && h(we, {
                    audioTracks: null == l ? void 0 : l.audioTracks,
                    onChange: f
                }), h(_e, {
                    muted: null == l ? void 0 : l.isMuted,
                    toggleMute: d,
                    onSliderInput: y,
                    volume: null == l ? void 0 : l.volume
                }), h(Ce, {
                    isFullscreen: ke(),
                    onClick: _
                })), (!(null != l && l.isLive) || (null == l ? void 0 : l.isSeekable)) && h(pe, {
                    isLive: null == l ? void 0 : l.isLive,
                    isAtLiveEdge: null == l ? void 0 : l.isAtLiveEdge,
                    isSeekable: null == l ? void 0 : l.isSeekable,
                    handleSeek: p,
                    handleSeekToLive: v,
                    currentTime: null == l ? void 0 : l.currentTime,
                    duration: null == l ? void 0 : l.duration
                })));
            }
            var Ge = n(665), He = n(155);
            function Ve(e, t, n, r) {
                Object.defineProperty(e, t, {
                    get: n,
                    set: r,
                    enumerable: !0,
                    configurable: !0
                });
            }
            var Ke, qe = {};
            Ve(qe, "PlayerAnalytics", ()=>Qe, (e)=>Qe = e), function(e) {
                e.loading = "loading", e.loaded = "loaded", e.play = "playing", e.resume = "playing", e.pause = "paused", e.seeking = "seeking", e.seeked = "seeked", e.buffering = "buffering", e.buffered = "buffered", e.ended = "stopped", e.error = "error", e.warning = "warning", e.bitratechanged = "bitrate_changed", e.heartbeat = "heartbeat", e.metadata = "metadata";
            }(Ke || (Ke = {}));
            var Ye = "0.3.1", We = {};
            Ve(We, "Reporter", ()=>Xe, (e)=>Xe = e);
            var ze = function() {
                return ze = Object.assign || function(e) {
                    for(var t, n = 1, r = arguments.length; n < r; n++)for(var i in t = arguments[n])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                    return e;
                }, ze.apply(this, arguments);
            }, Xe = function() {
                function e(e) {
                    this.isInitiated = !1, this.debug = e.debug, this.eventsinkUrl = e.eventsinkUrl, this.sessionId = e.sessionId, this.heartbeatInterval = e.heartbeatInterval || 3e4, this.debug && console.log("[AnalyticsReporter] Initiated AnalyticsReporter", e);
                }
                return e.prototype.init = function(e) {
                    return function(e, t, n, r) {
                        return new (n || (n = Promise))(function(i, a1) {
                            function o(e) {
                                try {
                                    u(r.next(e));
                                } catch (e) {
                                    a1(e);
                                }
                            }
                            function s1(e) {
                                try {
                                    u(r.throw(e));
                                } catch (e) {
                                    a1(e);
                                }
                            }
                            function u(e) {
                                var t;
                                e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                    e(t);
                                })).then(o, s1);
                            }
                            u((r = r.apply(e, t || [])).next());
                        });
                    }(this, void 0, Promise, function() {
                        var t, n, r;
                        return function(e, t) {
                            var n, r, i, a1, o = {
                                label: 0,
                                sent: function() {
                                    if (1 & i[0]) throw i[1];
                                    return i[1];
                                },
                                trys: [],
                                ops: []
                            };
                            function s1(a1) {
                                return function(s1) {
                                    return function(a1) {
                                        if (n) throw new TypeError("Generator is already executing.");
                                        for(; o;)try {
                                            if (n = 1, r && (i = 2 & a1[0] ? r.return : a1[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, a1[1])).done) return i;
                                            switch(r = 0, i && (a1 = [
                                                2 & a1[0],
                                                i.value
                                            ]), a1[0]){
                                                case 0:
                                                case 1:
                                                    i = a1;
                                                    break;
                                                case 4:
                                                    return o.label++, {
                                                        value: a1[1],
                                                        done: !1
                                                    };
                                                case 5:
                                                    o.label++, r = a1[1], a1 = [
                                                        0
                                                    ];
                                                    continue;
                                                case 7:
                                                    a1 = o.ops.pop(), o.trys.pop();
                                                    continue;
                                                default:
                                                    if (!((i = (i = o.trys).length > 0 && i[i.length - 1]) || 6 !== a1[0] && 2 !== a1[0])) {
                                                        o = 0;
                                                        continue;
                                                    }
                                                    if (3 === a1[0] && (!i || a1[1] > i[0] && a1[1] < i[3])) {
                                                        o.label = a1[1];
                                                        break;
                                                    }
                                                    if (6 === a1[0] && o.label < i[1]) {
                                                        o.label = i[1], i = a1;
                                                        break;
                                                    }
                                                    if (i && o.label < i[2]) {
                                                        o.label = i[2], o.ops.push(a1);
                                                        break;
                                                    }
                                                    i[2] && o.ops.pop(), o.trys.pop();
                                                    continue;
                                            }
                                            a1 = t.call(e, o);
                                        } catch (e) {
                                            a1 = [
                                                6,
                                                e
                                            ], r = 0;
                                        } finally{
                                            n = i = 0;
                                        }
                                        if (5 & a1[0]) throw a1[1];
                                        return {
                                            value: a1[0] ? a1[1] : void 0,
                                            done: !0
                                        };
                                    }([
                                        a1,
                                        s1
                                    ]);
                                };
                            }
                            return a1 = {
                                next: s1(0),
                                throw: s1(1),
                                return: s1(2)
                            }, "function" == typeof Symbol && (a1[Symbol.iterator] = function() {
                                return this;
                            }), a1;
                        }(this, function(i) {
                            switch(i.label){
                                case 0:
                                    return this.sessionId = e || this.sessionId, t = {
                                        event: "init",
                                        sessionId: this.sessionId,
                                        timestamp: Date.now(),
                                        playhead: -1,
                                        duration: -1
                                    }, this.debug ? (console.log("[AnalyticsReporter] Init session:", t), this.isInitiated = !0, [
                                        2,
                                        {
                                            sessionId: this.sessionId,
                                            heartbeatInterval: this.heartbeatInterval,
                                            isInitiated: this.isInitiated
                                        }
                                    ]) : [
                                        3,
                                        1
                                    ];
                                case 1:
                                    return [
                                        4,
                                        fetch("".concat(this.eventsinkUrl), {
                                            method: "POST",
                                            mode: "cors",
                                            cache: "no-cache",
                                            headers: {
                                                "Content-Type": "application/json; charset=utf-8",
                                                "X-EPAS-Event": t.event,
                                                "X-EPAS-Version": Ye
                                            },
                                            body: JSON.stringify(t)
                                        })
                                    ];
                                case 2:
                                    if (!(n = i.sent()).ok) throw new Error("[AnalyticsReporter] init failed: ".concat(n.statusText));
                                    return [
                                        4,
                                        n.json()
                                    ];
                                case 3:
                                    if (r = i.sent(), !this.sessionId && !r.sessionId) throw new Error("[AnalyticsReporter] init failed: no sessionId");
                                    return r.sessionId && (this.sessionId = r.sessionId), this.isInitiated = !0, [
                                        2,
                                        {
                                            heartbeatInterval: this.heartbeatInterval,
                                            sessionId: this.sessionId,
                                            isInitiated: this.isInitiated
                                        }
                                    ];
                            }
                        });
                    });
                }, e.prototype.send = function(e) {
                    if (!this.isInitiated) return console.warn("[AnalyticsReporter] Cannot report before initiation:", e);
                    var t = ze({
                        sessionId: this.sessionId
                    }, e);
                    this.debug ? console.log("[AnalyticsReporter] Send payload:", t) : fetch("".concat(this.eventsinkUrl), {
                        method: "POST",
                        mode: "cors",
                        cache: "no-cache",
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            "X-EPAS-Event": e.event,
                            "X-EPAS-Version": Ye
                        },
                        body: JSON.stringify(t)
                    });
                }, e;
            }(), Qe = function() {
                function e(e, t) {
                    this.debug = !1, this.debug = t, this.eventsinkUrl = e;
                }
                return e.prototype.initiateAnalyticsReporter = function(e) {
                    var t = e.sessionId, n = e.heartbeatInterval, r = void 0 === n ? 3e4 : n;
                    return function(e, t, n, r) {
                        return new (n || (n = Promise))(function(i, a1) {
                            function o(e) {
                                try {
                                    u(r.next(e));
                                } catch (e) {
                                    a1(e);
                                }
                            }
                            function s1(e) {
                                try {
                                    u(r.throw(e));
                                } catch (e) {
                                    a1(e);
                                }
                            }
                            function u(e) {
                                var t;
                                e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                    e(t);
                                })).then(o, s1);
                            }
                            u((r = r.apply(e, t || [])).next());
                        });
                    }(this, void 0, void 0, function() {
                        var e, n, i;
                        return function(e, t) {
                            var n, r, i, a1, o = {
                                label: 0,
                                sent: function() {
                                    if (1 & i[0]) throw i[1];
                                    return i[1];
                                },
                                trys: [],
                                ops: []
                            };
                            function s1(a1) {
                                return function(s1) {
                                    return function(a1) {
                                        if (n) throw new TypeError("Generator is already executing.");
                                        for(; o;)try {
                                            if (n = 1, r && (i = 2 & a1[0] ? r.return : a1[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, a1[1])).done) return i;
                                            switch(r = 0, i && (a1 = [
                                                2 & a1[0],
                                                i.value
                                            ]), a1[0]){
                                                case 0:
                                                case 1:
                                                    i = a1;
                                                    break;
                                                case 4:
                                                    return o.label++, {
                                                        value: a1[1],
                                                        done: !1
                                                    };
                                                case 5:
                                                    o.label++, r = a1[1], a1 = [
                                                        0
                                                    ];
                                                    continue;
                                                case 7:
                                                    a1 = o.ops.pop(), o.trys.pop();
                                                    continue;
                                                default:
                                                    if (!((i = (i = o.trys).length > 0 && i[i.length - 1]) || 6 !== a1[0] && 2 !== a1[0])) {
                                                        o = 0;
                                                        continue;
                                                    }
                                                    if (3 === a1[0] && (!i || a1[1] > i[0] && a1[1] < i[3])) {
                                                        o.label = a1[1];
                                                        break;
                                                    }
                                                    if (6 === a1[0] && o.label < i[1]) {
                                                        o.label = i[1], i = a1;
                                                        break;
                                                    }
                                                    if (i && o.label < i[2]) {
                                                        o.label = i[2], o.ops.push(a1);
                                                        break;
                                                    }
                                                    i[2] && o.ops.pop(), o.trys.pop();
                                                    continue;
                                            }
                                            a1 = t.call(e, o);
                                        } catch (e) {
                                            a1 = [
                                                6,
                                                e
                                            ], r = 0;
                                        } finally{
                                            n = i = 0;
                                        }
                                        if (5 & a1[0]) throw a1[1];
                                        return {
                                            value: a1[0] ? a1[1] : void 0,
                                            done: !0
                                        };
                                    }([
                                        a1,
                                        s1
                                    ]);
                                };
                            }
                            return a1 = {
                                next: s1(0),
                                throw: s1(1),
                                return: s1(2)
                            }, "function" == typeof Symbol && (a1[Symbol.iterator] = function() {
                                return this;
                            }), a1;
                        }(this, function(a1) {
                            switch(a1.label){
                                case 0:
                                    return this.analyticsReporter = new We.Reporter({
                                        sessionId: t,
                                        eventsinkUrl: this.eventsinkUrl,
                                        debug: this.debug,
                                        heartbeatInterval: r
                                    }), [
                                        4,
                                        this.analyticsReporter.init(t)
                                    ];
                                case 1:
                                    return e = a1.sent(), n = e.sessionId, i = e.isInitiated, [
                                        2,
                                        {
                                            sessionId: n,
                                            heartbeatInterval: r,
                                            isInitiated: i
                                        }
                                    ];
                            }
                        });
                    });
                }, e.prototype.init = function(e) {
                    this.analyticsReporter.send(e);
                }, e.prototype.metadata = function(e) {
                    this.analyticsReporter.send(e);
                }, e.prototype.heartbeat = function(e) {
                    this.analyticsReporter.send(e);
                }, e.prototype.loading = function(e) {
                    this.analyticsReporter.send(e);
                }, e.prototype.loaded = function(e) {
                    this.analyticsReporter.send(e);
                }, e.prototype.playing = function(e) {
                    this.analyticsReporter.send(e);
                }, e.prototype.paused = function(e) {
                    this.pause(e);
                }, e.prototype.pause = function(e) {
                    this.analyticsReporter.send(e);
                }, e.prototype.buffering = function(e) {
                    this.analyticsReporter.send(e);
                }, e.prototype.buffered = function(e) {
                    this.analyticsReporter.send(e);
                }, e.prototype.seeking = function(e) {
                    this.analyticsReporter.send(e);
                }, e.prototype.seeked = function(e) {
                    this.analyticsReporter.send(e);
                }, e.prototype.bitrateChanged = function(e) {
                    this.analyticsReporter.send(e);
                }, e.prototype.error = function(e) {
                    this.analyticsReporter.send(e);
                }, e.prototype.warning = function(e) {
                    this.analyticsReporter.send(e);
                }, e.prototype.stopped = function(e) {
                    this.analyticsReporter.send(e);
                }, e.prototype.destroy = function() {
                    this.analyticsReporter = null;
                }, e;
            }();
            Ve({}, "PlayerAnalyticsConnector", ()=>Ze, (e)=>Ze = e);
            var Je = function() {
                return Je = Object.assign || function(e) {
                    for(var t, n = 1, r = arguments.length; n < r; n++)for(var i in t = arguments[n])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                    return e;
                }, Je.apply(this, arguments);
            }, Ze = function() {
                function e(e, t) {
                    this.analyticsInitiated = !1, this.eventsinkUrl = e, this.playerAnalytics = new qe.PlayerAnalytics(this.eventsinkUrl, t);
                }
                return e.prototype.init = function(e) {
                    return function(e, t, n, r) {
                        return new (n || (n = Promise))(function(i, a1) {
                            function o(e) {
                                try {
                                    u(r.next(e));
                                } catch (e) {
                                    a1(e);
                                }
                            }
                            function s1(e) {
                                try {
                                    u(r.throw(e));
                                } catch (e) {
                                    a1(e);
                                }
                            }
                            function u(e) {
                                var t;
                                e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                    e(t);
                                })).then(o, s1);
                            }
                            u((r = r.apply(e, t || [])).next());
                        });
                    }(this, void 0, void 0, function() {
                        var t, n, r;
                        return function(e, t) {
                            var n, r, i, a1, o = {
                                label: 0,
                                sent: function() {
                                    if (1 & i[0]) throw i[1];
                                    return i[1];
                                },
                                trys: [],
                                ops: []
                            };
                            function s1(a1) {
                                return function(s1) {
                                    return function(a1) {
                                        if (n) throw new TypeError("Generator is already executing.");
                                        for(; o;)try {
                                            if (n = 1, r && (i = 2 & a1[0] ? r.return : a1[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, a1[1])).done) return i;
                                            switch(r = 0, i && (a1 = [
                                                2 & a1[0],
                                                i.value
                                            ]), a1[0]){
                                                case 0:
                                                case 1:
                                                    i = a1;
                                                    break;
                                                case 4:
                                                    return o.label++, {
                                                        value: a1[1],
                                                        done: !1
                                                    };
                                                case 5:
                                                    o.label++, r = a1[1], a1 = [
                                                        0
                                                    ];
                                                    continue;
                                                case 7:
                                                    a1 = o.ops.pop(), o.trys.pop();
                                                    continue;
                                                default:
                                                    if (!((i = (i = o.trys).length > 0 && i[i.length - 1]) || 6 !== a1[0] && 2 !== a1[0])) {
                                                        o = 0;
                                                        continue;
                                                    }
                                                    if (3 === a1[0] && (!i || a1[1] > i[0] && a1[1] < i[3])) {
                                                        o.label = a1[1];
                                                        break;
                                                    }
                                                    if (6 === a1[0] && o.label < i[1]) {
                                                        o.label = i[1], i = a1;
                                                        break;
                                                    }
                                                    if (i && o.label < i[2]) {
                                                        o.label = i[2], o.ops.push(a1);
                                                        break;
                                                    }
                                                    i[2] && o.ops.pop(), o.trys.pop();
                                                    continue;
                                            }
                                            a1 = t.call(e, o);
                                        } catch (e) {
                                            a1 = [
                                                6,
                                                e
                                            ], r = 0;
                                        } finally{
                                            n = i = 0;
                                        }
                                        if (5 & a1[0]) throw a1[1];
                                        return {
                                            value: a1[0] ? a1[1] : void 0,
                                            done: !0
                                        };
                                    }([
                                        a1,
                                        s1
                                    ]);
                                };
                            }
                            return a1 = {
                                next: s1(0),
                                throw: s1(1),
                                return: s1(2)
                            }, "function" == typeof Symbol && (a1[Symbol.iterator] = function() {
                                return this;
                            }), a1;
                        }(this, function(i) {
                            switch(i.label){
                                case 0:
                                    return this.sessionId = e.sessionId, [
                                        4,
                                        this.playerAnalytics.initiateAnalyticsReporter(Je({
                                            sessionId: this.sessionId
                                        }, e))
                                    ];
                                case 1:
                                    return t = i.sent(), n = t.heartbeatInterval, r = t.isInitiated, this.analyticsInitiated = r, this.heartbeatInterval = n, [
                                        2
                                    ];
                            }
                        });
                    });
                }, e.prototype.load = function(e) {
                    this.player = e, this.playerAnalytics.loading(Je({
                        event: Ke.loading
                    }, this.playbackState())), this.initiateVideoEventFilter();
                }, e.prototype.initiateVideoEventFilter = function() {
                    var e = this;
                    this.player && (this.videoEventFilter = new He.VideoEventFilter(this.player), this.videoEventFilter.addEventListener("*", this.videoEventListener = function(t) {
                        if (Object.keys(Ke).includes(t)) {
                            var n, r = {};
                            if (t) {
                                switch(t){
                                    case He.PlayerEvents.Loaded:
                                        n = Ke.loaded;
                                        break;
                                    case He.PlayerEvents.Loading:
                                        n = Ke.loading;
                                        break;
                                    case He.PlayerEvents.Play:
                                    case He.PlayerEvents.Resume:
                                        n = Ke.play, e.startInterval();
                                        break;
                                    case He.PlayerEvents.Pause:
                                        n = Ke.pause;
                                        break;
                                    case He.PlayerEvents.Seeking:
                                        n = Ke.seeking;
                                        break;
                                    case He.PlayerEvents.Seeked:
                                        n = Ke.seeked;
                                        break;
                                    case He.PlayerEvents.Buffering:
                                        n = Ke.buffering;
                                        break;
                                    case He.PlayerEvents.Buffered:
                                        n = Ke.buffered;
                                        break;
                                    case He.PlayerEvents.Ended:
                                        n = Ke.ended, r.reason = "ended", e.stopInterval();
                                        break;
                                    case He.PlayerEvents.Error:
                                        n = Ke.error, r.reason = "error", e.stopInterval();
                                }
                                e.analyticsInitiated ? e.playerAnalytics[n](Je(Je({
                                    event: n
                                }, e.playbackState()), Object.keys(r).length > 0 && {
                                    payload: r
                                })) : console.warn("[PlayerAnalyticsConnector] Analytics not initiated");
                            }
                        }
                    }));
                }, e.prototype.startInterval = function() {
                    var e = this;
                    this.heartbeatIntervalTimer || (this.heartbeatIntervalTimer = setInterval(function() {
                        e.playerAnalytics.heartbeat(Je({
                            event: Ke.heartbeat
                        }, e.playbackState()));
                    }, this.heartbeatInterval));
                }, e.prototype.stopInterval = function() {
                    clearInterval(this.heartbeatIntervalTimer);
                }, e.prototype.reportBitrateChange = function(e) {
                    this.analyticsInitiated ? this.playerAnalytics.bitrateChanged(Je(Je({
                        event: Ke.bitratechanged
                    }, this.playbackState()), {
                        payload: e
                    })) : console.warn("[PlayerAnalyticsConnector] Analytics not initiated");
                }, e.prototype.reportStop = function() {
                    this.analyticsInitiated ? (this.playerAnalytics.stopped(Je(Je({
                        event: Ke.ended
                    }, this.playbackState()), {
                        payload: {
                            reason: "aborted"
                        }
                    })), this.stopInterval()) : console.warn("[PlayerAnalyticsConnector] Analytics not initiated");
                }, e.prototype.reportError = function(e) {
                    this.analyticsInitiated ? (this.playerAnalytics.error(Je(Je({
                        event: Ke.error
                    }, this.playbackState()), {
                        payload: e
                    })), this.playerAnalytics.stopped(Je(Je({
                        event: Ke.ended
                    }, this.playbackState()), {
                        payload: {
                            reason: "error"
                        }
                    })), this.stopInterval()) : console.warn("[PlayerAnalyticsConnector] Analytics not initiated");
                }, e.prototype.reportMetadata = function(e) {
                    this.analyticsInitiated ? this.playerAnalytics.metadata(Je(Je({
                        event: Ke.metadata
                    }, this.playbackState()), {
                        payload: e
                    })) : console.warn("[PlayerAnalyticsConnector] Analytics not initiated");
                }, e.prototype.reportWarning = function(e) {
                    this.analyticsInitiated ? this.playerAnalytics.warning(Je(Je({
                        event: Ke.warning
                    }, this.playbackState()), {
                        payload: e
                    })) : console.warn("[PlayerAnalyticsConnector] Analytics not initiated");
                }, e.prototype.playbackState = function() {
                    var e, t, n, r, i, a1 = (null === (e = this.player) || void 0 === e ? void 0 : e.duration) && (null === (t = this.player) || void 0 === t ? void 0 : t.duration) !== 1 / 0 && (null === (n = this.player) || void 0 === n ? void 0 : n.duration) > 0 ? this.player.duration : -1, o = (null === (r = this.player) || void 0 === r ? void 0 : r.currentTime) && -1 !== a1 ? null === (i = this.player) || void 0 === i ? void 0 : i.currentTime : -1;
                    return {
                        sessionId: this.sessionId,
                        timestamp: Date.now(),
                        playhead: o,
                        duration: a1
                    };
                }, e.prototype.deinit = function() {
                    this.analyticsInitiated ? (this.stopInterval(), this.heartbeatInterval = null, this.videoEventFilter && this.videoEventFilter.removeEventListener("*", this.videoEventListener), this.videoEventFilter = null) : console.warn("[PlayerAnalyticsConnector] Analytics not initiated");
                }, e.prototype.destroy = function() {
                    this.analyticsInitiated ? (this.playerAnalytics.destroy(), this.heartbeatInterval = null, this.videoEventFilter && this.videoEventFilter.removeEventListener("*", this.videoEventListener), this.stopInterval()) : console.warn("[PlayerAnalyticsConnector] Analytics not initiated");
                }, e;
            }();
            const $e = {
                SOURCE: "source",
                STARTTIME: "starttime",
                AUTOPLAY: "autoplay",
                MUTED: "muted"
            }, et = "autoplay-visible", tt = "analytics", nt = "epas-url", rt = "disable-level-cap", it = (e)=>"" === e || !!e;
            class at extends HTMLElement {
                static get observedAttributes() {
                    return Object.values($e);
                }
                constructor(){
                    super();
                    const e = this.setupDOM(), t = this.getAttribute($e.AUTOPLAY), n = this.getAttribute(et);
                    !it(t) && it(n) && (this.observer = new IntersectionObserver(this.inViewHandler.bind(this)), this.observer.observe(this.video));
                    const r = this.getAttribute(rt);
                    this.setupPlayer(e, r), this.setupAnalytics({
                        enabled: this.getAttribute(tt),
                        epasUrl: this.getAttribute(nt)
                    }), this.setupPlayerEventListener();
                }
                setupDOM() {
                    this.attachShadow({
                        mode: "open"
                    });
                    const { shadowRoot: e } = this;
                    let t = document.createElement("style");
                    t.innerHTML = Ge.Z, e.appendChild(t);
                    const n = document.createElement("div");
                    return e.appendChild(n), this.video = document.createElement("video"), n.appendChild(this.video), n;
                }
                setupPlayer(e, t) {
                    this.player = new s1.W({
                        video: this.video,
                        disablePlayerSizeLevelCap: !!t
                    }), function(e) {
                        var t = e.root, n = e.player, r = e.castAppId;
                        t.classList.add("_1Xl8W"), x(h(Be, {
                            player: n,
                            rootElement: t,
                            castAppId: r
                        }), t);
                    }({
                        root: e,
                        player: this.player,
                        castAppId: {}
                    });
                }
                setupAnalytics({ enabled: e, epasUrl: t }) {
                    this.playerAnalytics = null, it(e) && (this.playerAnalytics = new Ze(t || "https://sink.epas.eyevinn.technology"));
                }
                setupPlayerEventListener() {
                    this.player.on(s1.a.ERROR, ({ errorData: e, fatal: t })=>{
                        console.error("player reported error", e), this.playerAnalytics && (t ? this.playerAnalytics.reportError(e) : this.playerAnalytics.reportWarning(e)), t && (this.player.destroy(), console.log("player destroyed due to error"));
                    }), this.player.on(s1.a.BITRATE_CHANGE, (e)=>{
                        this.playerAnalytics && this.playerAnalytics.reportBitrateChange({
                            bitrate: e.bitrate / 1e3,
                            width: e.width,
                            height: e.height
                        });
                    });
                }
                async initAnalytics() {
                    if (this.playerAnalytics) try {
                        await this.playerAnalytics.init({
                            sessionId: `${window.location.hostname}-${Date.now()}`
                        });
                    } catch (e) {
                        console.error(e), this.playerAnalytics.deinit(), this.playerAnalytics = null;
                    }
                }
                loadAnalytics() {
                    this.playerAnalytics && (this.playerAnalytics.load(this.video), this.player.on(s1.a.LOADED_METADATA, this.metadataReporter = ()=>{
                        this.playerAnalytics.reportMetadata({
                            live: this.player.isLive,
                            contentUrl: this.getAttribute($e.SOURCE)
                        }), this.player.off(s1.a.LOADED_METADATA, this.metadataReporter);
                    }));
                }
                async attributeChangedCallback(e) {
                    const t = this.getAttribute($e.SOURCE), n = this.getAttribute($e.STARTTIME), r = this.getAttribute($e.AUTOPLAY), i = this.getAttribute($e.MUTED);
                    e === $e.SOURCE && (it(t) ? (await this.initAnalytics(), await this.player.load(t), this.loadAnalytics(), it(n) && (this.video.currentTime = n), it(r) && (this.video.muted = it(i), this.video.autoplay = !0, this.player.play())) : console.error("Invalid source was provided to <eyevinn-video> element")), e === $e.MUTED && (this.video.muted = it(i));
                }
                connectedCallback() {
                    this.setupEventProxy();
                }
                disconnectedCallback() {
                    this.player.reset();
                }
                setupEventProxy() {
                    this.player && this.player.on("*", (e, t)=>{
                        this.dispatchEvent(new CustomEvent(e, {
                            detail: t
                        }));
                    });
                }
                inViewHandler(e) {
                    e.forEach((e)=>{
                        e.isIntersecting ? (this.video.muted = !0, this.video.autoplay = !0, this.player.play()) : this.player.isPlaying && !e.isIntersecting && this.player.pause();
                    });
                }
            }
            customElements.define("eyevinn-video", at);
        })(), r.default;
    })()); //# sourceMappingURL=web-player.component.js.map

//# sourceMappingURL=media-orchestration.d8eb5432.js.map
